/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 373);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(419);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(420)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(38);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(412);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(416);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(38);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(383);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = __webpack_require__(47);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Icon = function Icon(props) {
    var type = props.type,
        _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        spin = props.spin;

    var classString = (0, _classnames2['default'])((0, _defineProperty3['default'])({
        anticon: true,
        'anticon-spin': !!spin || type === 'loading'
    }, 'anticon-' + type, true), className);
    return React.createElement('i', (0, _extends3['default'])({}, (0, _omit2['default'])(props, ['type', 'spin']), { className: classString }));
};
exports['default'] = Icon;
module.exports = exports['default'];

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _grid = __webpack_require__(253);

exports['default'] = _grid.Row;
module.exports = exports['default'];

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(154);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(231);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(231);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(1042);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _rcNotification = __webpack_require__(272);

var _rcNotification2 = _interopRequireDefault(_rcNotification);

var _icon = __webpack_require__(6);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var defaultDuration = 3; /* global Promise */

var defaultTop = void 0;
var messageInstance = void 0;
var key = 1;
var prefixCls = 'ant-message';
var transitionName = 'move-up';
var getContainer = void 0;
var maxCount = void 0;
function getMessageInstance(callback) {
    if (messageInstance) {
        callback(messageInstance);
        return;
    }
    _rcNotification2['default'].newInstance({
        prefixCls: prefixCls,
        transitionName: transitionName,
        style: { top: defaultTop },
        getContainer: getContainer,
        maxCount: maxCount
    }, function (instance) {
        if (messageInstance) {
            callback(messageInstance);
            return;
        }
        messageInstance = instance;
        callback(instance);
    });
}
function notice(content) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDuration;
    var type = arguments[2];
    var onClose = arguments[3];

    var iconType = {
        info: 'info-circle',
        success: 'check-circle',
        error: 'cross-circle',
        warning: 'exclamation-circle',
        loading: 'loading'
    }[type];
    if (typeof duration === 'function') {
        onClose = duration;
        duration = defaultDuration;
    }
    var target = key++;
    var closePromise = new Promise(function (resolve) {
        var callback = function callback() {
            if (typeof onClose === 'function') {
                onClose();
            }
            return resolve(true);
        };
        getMessageInstance(function (instance) {
            instance.notice({
                key: target,
                duration: duration,
                style: {},
                content: React.createElement(
                    'div',
                    { className: prefixCls + '-custom-content ' + prefixCls + '-' + type },
                    React.createElement(_icon2['default'], { type: iconType }),
                    React.createElement(
                        'span',
                        null,
                        content
                    )
                ),
                onClose: callback
            });
        });
    });
    var result = function result() {
        if (messageInstance) {
            messageInstance.removeNotice(target);
        }
    };
    result.then = function (filled, rejected) {
        return closePromise.then(filled, rejected);
    };
    result.promise = closePromise;
    return result;
}
exports['default'] = {
    info: function info(content, duration, onClose) {
        return notice(content, duration, 'info', onClose);
    },
    success: function success(content, duration, onClose) {
        return notice(content, duration, 'success', onClose);
    },
    error: function error(content, duration, onClose) {
        return notice(content, duration, 'error', onClose);
    },

    // Departed usage, please use warning()
    warn: function warn(content, duration, onClose) {
        return notice(content, duration, 'warning', onClose);
    },
    warning: function warning(content, duration, onClose) {
        return notice(content, duration, 'warning', onClose);
    },
    loading: function loading(content, duration, onClose) {
        return notice(content, duration, 'loading', onClose);
    },
    config: function config(options) {
        if (options.top !== undefined) {
            defaultTop = options.top;
            messageInstance = null; // delete messageInstance for new defaultTop
        }
        if (options.duration !== undefined) {
            defaultDuration = options.duration;
        }
        if (options.prefixCls !== undefined) {
            prefixCls = options.prefixCls;
        }
        if (options.getContainer !== undefined) {
            getContainer = options.getContainer;
        }
        if (options.transitionName !== undefined) {
            transitionName = options.transitionName;
            messageInstance = null; // delete messageInstance for new transitionName
        }
        if (options.maxCount !== undefined) {
            maxCount = options.maxCount;
            messageInstance = null;
        }
    },
    destroy: function destroy() {
        if (messageInstance) {
            messageInstance.destroy();
            messageInstance = null;
        }
    }
};
module.exports = exports['default'];

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(426);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rcSelect = __webpack_require__(817);

var _rcSelect2 = _interopRequireDefault(_rcSelect);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _LocaleReceiver = __webpack_require__(71);

var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);

var _default = __webpack_require__(107);

var _default2 = _interopRequireDefault(_default);

var _warning = __webpack_require__(266);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var SelectPropTypes = {
    prefixCls: _propTypes2['default'].string,
    className: _propTypes2['default'].string,
    size: _propTypes2['default'].oneOf(['default', 'large', 'small']),
    notFoundContent: _propTypes2['default'].any,
    showSearch: _propTypes2['default'].bool,
    optionLabelProp: _propTypes2['default'].string,
    transitionName: _propTypes2['default'].string,
    choiceTransitionName: _propTypes2['default'].string,
    id: _propTypes2['default'].string
};
// => It is needless to export the declaration of below two inner components.
// export { Option, OptGroup };

var Select = function (_React$Component) {
    (0, _inherits3['default'])(Select, _React$Component);

    function Select(props) {
        (0, _classCallCheck3['default'])(this, Select);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

        _this.saveSelect = function (node) {
            _this.rcSelect = node;
        };
        _this.renderSelect = function (locale) {
            var _classNames;

            var _a = _this.props,
                prefixCls = _a.prefixCls,
                _a$className = _a.className,
                className = _a$className === undefined ? '' : _a$className,
                size = _a.size,
                mode = _a.mode,
                restProps = __rest(_a, ["prefixCls", "className", "size", "mode"]);
            var cls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', size === 'small'), _classNames), className);
            var optionLabelProp = _this.props.optionLabelProp;

            if (_this.isCombobox()) {
                // children 带 dom 结构时，无法填入输入框
                optionLabelProp = optionLabelProp || 'value';
            }
            var modeConfig = {
                multiple: mode === 'multiple',
                tags: mode === 'tags',
                combobox: _this.isCombobox()
            };
            return React.createElement(_rcSelect2['default'], (0, _extends3['default'])({}, restProps, modeConfig, { prefixCls: prefixCls, className: cls, optionLabelProp: optionLabelProp || 'children', notFoundContent: _this.getNotFoundContent(locale), ref: _this.saveSelect }));
        };
        (0, _warning2['default'])(props.mode !== 'combobox', 'The combobox mode of Select is deprecated,' + 'it will be removed in next major version,' + 'please use AutoComplete instead');
        return _this;
    }

    (0, _createClass3['default'])(Select, [{
        key: 'focus',
        value: function focus() {
            this.rcSelect.focus();
        }
    }, {
        key: 'blur',
        value: function blur() {
            this.rcSelect.blur();
        }
    }, {
        key: 'getNotFoundContent',
        value: function getNotFoundContent(locale) {
            var notFoundContent = this.props.notFoundContent;

            if (this.isCombobox()) {
                // AutoComplete don't have notFoundContent defaultly
                return notFoundContent === undefined ? null : notFoundContent;
            }
            return notFoundContent === undefined ? locale.notFoundContent : notFoundContent;
        }
    }, {
        key: 'isCombobox',
        value: function isCombobox() {
            var mode = this.props.mode;

            return mode === 'combobox' || mode === Select.SECRET_COMBOBOX_MODE_DO_NOT_USE;
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement(
                _LocaleReceiver2['default'],
                { componentName: 'Select', defaultLocale: _default2['default'].Select },
                this.renderSelect
            );
        }
    }]);
    return Select;
}(React.Component);

exports['default'] = Select;

Select.Option = _rcSelect.Option;
Select.OptGroup = _rcSelect.OptGroup;
Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
Select.defaultProps = {
    prefixCls: 'ant-select',
    showSearch: false,
    transitionName: 'slide-up',
    choiceTransitionName: 'zoom'
};
Select.propTypes = SelectPropTypes;
module.exports = exports['default'];

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(436);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(717);

__webpack_require__(20);

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(587);

__webpack_require__(22);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _button = __webpack_require__(585);

var _button2 = _interopRequireDefault(_button);

var _buttonGroup = __webpack_require__(586);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_button2['default'].Group = _buttonGroup2['default'];
exports['default'] = _button2['default'];
module.exports = exports['default'];

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(584);

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Input = __webpack_require__(271);

var _Input2 = _interopRequireDefault(_Input);

var _Group = __webpack_require__(588);

var _Group2 = _interopRequireDefault(_Group);

var _Search = __webpack_require__(589);

var _Search2 = _interopRequireDefault(_Search);

var _TextArea = __webpack_require__(590);

var _TextArea2 = _interopRequireDefault(_TextArea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Input2['default'].Group = _Group2['default'];
_Input2['default'].Search = _Search2['default'];
_Input2['default'].TextArea = _TextArea2['default'];
exports['default'] = _Input2['default'];
module.exports = exports['default'];

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return API_TECH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return API_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return API_WHOAMI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return API_UPDATE_ME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return API_UPDATE_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return API_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return API_GET_MY_JOB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_CREATE_JOB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_CREATE_JOB_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_CREATE_JOB_LINK_FOR_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return API_JOB_UPLOAD_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return API_LINKS_FOR_JOB; });
/* unused harmony export API_GET_JOB_FOR_TECH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return API_GET_MY_JOB_PAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return API_GET_MY_JOB_PAG2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return API_GET_JOB_FOR_TECH_UUID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return API_UPDATE_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return API_NEXT_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return API_GET_JOB_ASSETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return API_SEND_COMMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return API_DELETE_JOB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return API_GET_PLAN_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return API_GET_PLAN_CLOUD_PROVIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return BASE_URL; });
/*eslint-disable */var API_='https://serviziortodontici-dide.com'+'/api/v1';var API_V2='https://serviziortodontici-dide.com'+'/api/v2';var API_CLIENT='https://serviziortodontici-dide.com'+'/api/v1';var API_TECH='https://tech.serviziortodontici.3d-plan.online'+'/api/v1';/*eslint-enable */// AUTH
var API_LOGIN=API_+'/auth/login/';var API_WHOAMI=API_+'/auth/me/';var API_UPDATE_ME=API_+'/auth/me/';var API_UPDATE_PROFILE=API_+'/auth/me/profile/';var API_LOGOUT=API_+'/auth/logout/';//JOB
var API_GET_MY_JOB=API_+'/job/';var API_CREATE_JOB=API_+'/job/create/';var API_CREATE_JOB_LINK=API_+'/job/create/link/';var API_CREATE_JOB_LINK_FOR_PLAN=API_+'/job/create/link/for/plan/';var API_JOB_UPLOAD_COMPLETE=API_+'/job/update/complete/';var API_LINKS_FOR_JOB=function API_LINKS_FOR_JOB(uuid){return API_+'/job/links/for/'+uuid+'/';};//STAFF
var API_GET_JOB_FOR_TECH=API_+'/staff/job/';var API_GET_MY_JOB_PAG=API_V2+'/staff/job/';var API_GET_MY_JOB_PAG2=function API_GET_MY_JOB_PAG2(date_from,date_to){return API_V2+'/staff/job/'+'?date_from='+date_from+'&date_to='+date_to;};var API_GET_JOB_FOR_TECH_UUID=function API_GET_JOB_FOR_TECH_UUID(uuid){return API_+'/staff/job/'+uuid+'/';};var API_UPDATE_PLAN=function API_UPDATE_PLAN(uuid){return API_+'/staff/job/plan/'+uuid+'/';};var API_NEXT_STEP=function API_NEXT_STEP(uuid){return API_+'/staff/job/run/next/step/'+uuid+'/';};var API_GET_JOB_ASSETS=function API_GET_JOB_ASSETS(uuid){return API_+'/staff/job/plan/'+uuid+'/assets/';};var API_SEND_COMMENT=function API_SEND_COMMENT(uuid){return API_+'/staff/job/plan/'+uuid+'/rework/';};var API_DELETE_JOB=function API_DELETE_JOB(uuid){return API_+'/staff/job/'+uuid+'/';};//REFS
var API_GET_PLAN_TYPE=API_+'/refs/plantype/';var API_GET_PLAN_CLOUD_PROVIDER=API_+'/refs/plancloudprovider/';/* eslint-disable */var BASE_URL='https://serviziortodontici-dide.com'+'';

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = switch_api;
function switch_api(API_URL){var selectedAPIURL=localStorage.getItem('API');selectedAPIURL=selectedAPIURL==""||selectedAPIURL==null?"https://ru.api.3d-smile.com/api/v1":selectedAPIURL;return API_URL.replace("https://ru.api.3d-smile.com/api/v1",selectedAPIURL);}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(493);

__webpack_require__(494);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Form = __webpack_require__(495);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _Form2['default'];
module.exports = exports['default'];

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PanelBox=function(_React$Component){_inherits(PanelBox,_React$Component);function PanelBox(){_classCallCheck(this,PanelBox);return _possibleConstructorReturn(this,(PanelBox.__proto__||Object.getPrototypeOf(PanelBox)).apply(this,arguments));}_createClass(PanelBox,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{className:"panel-box "+this.props.className,title:this.props.title,bordered:false,bodyStyle:this.props.bodyStyle,style:{textAlign:'center'}},this.props.children);}}]);return PanelBox;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PanelBox);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return warning; });
/* harmony export (immutable) */ __webpack_exports__["d"] = format;
/* harmony export (immutable) */ __webpack_exports__["e"] = isEmptyValue;
/* unused harmony export isEmptyObject */
/* harmony export (immutable) */ __webpack_exports__["a"] = asyncMap;
/* harmony export (immutable) */ __webpack_exports__["b"] = complementError;
/* harmony export (immutable) */ __webpack_exports__["c"] = deepMerge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


var formatRegExp = /%[sdj%]/g;

var warning = function warning() {};

// don't print warning message when in production env or node runtime
if (false) {
  warning = function warning(type, errors) {
    if (typeof console !== 'undefined' && console.warn) {
      if (errors.every(function (e) {
        return typeof e === 'string';
      })) {
        console.warn(type, errors);
      }
    }
  };
}

function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var i = 1;
  var f = args[0];
  var len = args.length;
  if (typeof f === 'function') {
    return f.apply(null, args.slice(1));
  }
  if (typeof f === 'string') {
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }
      if (i >= len) {
        return x;
      }
      switch (x) {
        case '%s':
          return String(args[i++]);
        case '%d':
          return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
          break;
        default:
          return x;
      }
    });
    for (var arg = args[i]; i < len; arg = args[++i]) {
      str += ' ' + arg;
    }
    return str;
  }
  return f;
}

function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
}

function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }
  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }
  return false;
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;

  function count(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }

  arr.forEach(function (a) {
    func(a, count);
  });
}

function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;

  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index;
    index = index + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }

  next([]);
}

function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, objArr[k]);
  });
  return ret;
}

function asyncMap(objArr, option, func, callback) {
  if (option.first) {
    var flattenArr = flattenObjArr(objArr);
    return asyncSerialArray(flattenArr, func, callback);
  }
  var firstFields = option.firstFields || [];
  if (firstFields === true) {
    firstFields = Object.keys(objArr);
  }
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var next = function next(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === objArrLength) {
      callback(results);
    }
  };
  objArrKeys.forEach(function (key) {
    var arr = objArr[key];
    if (firstFields.indexOf(key) !== -1) {
      asyncSerialArray(arr, func, next);
    } else {
      asyncParallelArray(arr, func, next);
    }
  });
}

function complementError(rule) {
  return function (oe) {
    if (oe && oe.message) {
      oe.field = oe.field || rule.fullField;
      return oe;
    }
    return {
      message: oe,
      field: oe.field || rule.fullField
    };
  };
}

function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];
        if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) === 'object' && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(target[s]) === 'object') {
          target[s] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }
  return target;
}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)(module)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(924);

__webpack_require__(33);

__webpack_require__(282);

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(925);

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Upload = __webpack_require__(343);

var _Upload2 = _interopRequireDefault(_Upload);

var _Dragger = __webpack_require__(1027);

var _Dragger2 = _interopRequireDefault(_Dragger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Upload2['default'].Dragger = _Dragger2['default'];
exports['default'] = _Upload2['default'];
module.exports = exports['default'];

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _progress = __webpack_require__(1022);

var _progress2 = _interopRequireDefault(_progress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _progress2['default'];
module.exports = exports['default'];

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(548);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles__ = __webpack_require__(1048);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global process */
/* eslint prefer-template: 0 */






var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);

  function Dropzone(props, context) {
    _classCallCheck(this, Dropzone);

    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));

    _this.renderChildren = function (children, isDragActive, isDragAccept, isDragReject) {
      if (typeof children === 'function') {
        return children(_extends({}, _this.state, {
          isDragActive: isDragActive,
          isDragAccept: isDragAccept,
          isDragReject: isDragReject
        }));
      }
      return children;
    };

    _this.composeHandlers = _this.composeHandlers.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDragOver = _this.onDragOver.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
    _this.onInputElementClick = _this.onInputElementClick.bind(_this);

    _this.setRef = _this.setRef.bind(_this);
    _this.setRefs = _this.setRefs.bind(_this);

    _this.isFileDialogActive = false;

    _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };
    return _this;
  }

  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      this.dragTargets = [];

      if (preventDropOnDocument) {
        document.addEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */], false);
        document.addEventListener('drop', this.onDocumentDrop, false);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
      }
      window.addEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      if (preventDropOnDocument) {
        document.removeEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */]);
        document.removeEventListener('drop', this.onDocumentDrop);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
      }
      window.removeEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'composeHandlers',
    value: function composeHandlers(handler) {
      if (this.props.disabled) {
        return null;
      }

      return handler;
    }
  }, {
    key: 'onDocumentDrop',
    value: function onDocumentDrop(evt) {
      if (this.node && this.node.contains(evt.target)) {
        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }
      evt.preventDefault();
      this.dragTargets = [];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(evt) {
      if (this.props.onDragStart) {
        this.props.onDragStart.call(this, evt);
      }
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(evt) {
      var _this2 = this;

      evt.preventDefault();

      // Count the dropzone and any children that are entered.
      if (this.dragTargets.indexOf(evt.target) === -1) {
        this.dragTargets.push(evt.target);
      }

      evt.persist();

      Promise.resolve(this.props.getDataTransferItems(evt)).then(function (draggedFiles) {
        _this2.setState({
          isDragActive: true, // Do not rely on files for the drag state. It doesn't work in Safari.
          draggedFiles: draggedFiles
        });
      });
      if (this.props.onDragEnter) {
        this.props.onDragEnter.call(this, evt);
      }
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(evt) {
      // eslint-disable-line class-methods-use-this
      evt.preventDefault();
      evt.stopPropagation();
      try {
        // The file dialog on Chrome allows users to drag files from the dialog onto
        // the dropzone, causing the browser the crash when the file dialog is closed.
        // A drop effect of 'none' prevents the file from being dropped
        evt.dataTransfer.dropEffect = this.isFileDialogActive ? 'none' : 'copy'; // eslint-disable-line no-param-reassign
      } catch (err) {
        // continue regardless of error
      }

      if (this.props.onDragOver) {
        this.props.onDragOver.call(this, evt);
      }
      return false;
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(evt) {
      var _this3 = this;

      evt.preventDefault();

      // Only deactivate once the dropzone and all children have been left.
      this.dragTargets = this.dragTargets.filter(function (el) {
        return el !== evt.target && _this3.node.contains(el);
      });
      if (this.dragTargets.length > 0) {
        return;
      }

      // Clear dragging files state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (this.props.onDragLeave) {
        this.props.onDragLeave.call(this, evt);
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(evt) {
      var _this4 = this;

      var _props = this.props,
          onDrop = _props.onDrop,
          onDropAccepted = _props.onDropAccepted,
          onDropRejected = _props.onDropRejected,
          multiple = _props.multiple,
          disablePreview = _props.disablePreview,
          accept = _props.accept,
          getDataTransferItems = _props.getDataTransferItems;

      // Stop default browser behavior

      evt.preventDefault();

      // Persist event for later usage
      evt.persist();

      // Reset the counter along with the drag on a drop.
      this.dragTargets = [];
      this.isFileDialogActive = false;

      // Clear files value
      this.draggedFiles = null;

      // Reset drag state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      Promise.resolve(getDataTransferItems(evt)).then(function (fileList) {
        var acceptedFiles = [];
        var rejectedFiles = [];

        fileList.forEach(function (file) {
          if (!disablePreview) {
            try {
              file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
            } catch (err) {
              if (false) {
                console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
              }
            }
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* fileAccepted */])(file, accept) && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* fileMatchSize */])(file, _this4.props.maxSize, _this4.props.minSize)) {
            acceptedFiles.push(file);
          } else {
            rejectedFiles.push(file);
          }
        });

        if (!multiple && acceptedFiles.length > 1) {
          // if not in multi mode add any extra accepted files to rejected.
          // This will allow end users to easily ignore a multi file drop in "single" mode.
          rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(0)));
        }

        if (onDrop) {
          onDrop.call(_this4, acceptedFiles, rejectedFiles, evt);
        }

        if (rejectedFiles.length > 0 && onDropRejected) {
          onDropRejected.call(_this4, rejectedFiles, evt);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted.call(_this4, acceptedFiles, evt);
        }
      });
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      var _props2 = this.props,
          onClick = _props2.onClick,
          disableClick = _props2.disableClick;

      if (!disableClick) {
        evt.stopPropagation();

        if (onClick) {
          onClick.call(this, evt);
        }

        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
        // this is so react can handle state changes in the onClick prop above above
        // see: https://github.com/react-dropzone/react-dropzone/issues/450
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* isIeOrEdge */])()) {
          setTimeout(this.open.bind(this), 0);
        } else {
          this.open();
        }
      }
    }
  }, {
    key: 'onInputElementClick',
    value: function onInputElementClick(evt) {
      evt.stopPropagation();
      if (this.props.inputProps && this.props.inputProps.onClick) {
        this.props.inputProps.onClick();
      }
    }
  }, {
    key: 'onFileDialogCancel',
    value: function onFileDialogCancel() {
      var _this5 = this;

      // timeout will not recognize context of this method
      var onFileDialogCancel = this.props.onFileDialogCancel;
      // execute the timeout only if the FileDialog is opened in the browser

      if (this.isFileDialogActive) {
        setTimeout(function () {
          if (_this5.fileInputEl != null) {
            // Returns an object as FileList
            var files = _this5.fileInputEl.files;


            if (!files.length) {
              _this5.isFileDialogActive = false;
            }
          }

          if (typeof onFileDialogCancel === 'function') {
            onFileDialogCancel();
          }
        }, 300);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.node = ref;
    }
  }, {
    key: 'setRefs',
    value: function setRefs(ref) {
      this.fileInputEl = ref;
    }
    /**
     * Open system file upload dialog.
     *
     * @public
     */

  }, {
    key: 'open',
    value: function open() {
      this.isFileDialogActive = true;
      this.fileInputEl.value = null;
      this.fileInputEl.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          accept = _props3.accept,
          acceptClassName = _props3.acceptClassName,
          activeClassName = _props3.activeClassName,
          children = _props3.children,
          disabled = _props3.disabled,
          disabledClassName = _props3.disabledClassName,
          inputProps = _props3.inputProps,
          multiple = _props3.multiple,
          name = _props3.name,
          rejectClassName = _props3.rejectClassName,
          rest = _objectWithoutProperties(_props3, ['accept', 'acceptClassName', 'activeClassName', 'children', 'disabled', 'disabledClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);

      var acceptStyle = rest.acceptStyle,
          activeStyle = rest.activeStyle,
          _rest$className = rest.className,
          className = _rest$className === undefined ? '' : _rest$className,
          disabledStyle = rest.disabledStyle,
          rejectStyle = rest.rejectStyle,
          style = rest.style,
          props = _objectWithoutProperties(rest, ['acceptStyle', 'activeStyle', 'className', 'disabledStyle', 'rejectStyle', 'style']);

      var _state = this.state,
          isDragActive = _state.isDragActive,
          draggedFiles = _state.draggedFiles;

      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* allFilesAccepted */])(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
      var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;

      if (isDragActive && activeClassName) {
        className += ' ' + activeClassName;
      }
      if (isDragAccept && acceptClassName) {
        className += ' ' + acceptClassName;
      }
      if (isDragReject && rejectClassName) {
        className += ' ' + rejectClassName;
      }
      if (disabled && disabledClassName) {
        className += ' ' + disabledClassName;
      }

      if (noStyles) {
        style = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].default;
        activeStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        acceptStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        rejectStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].rejected;
        disabledStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].disabled;
      }

      var appliedStyle = _extends({ position: 'relative' }, style);
      if (activeStyle && isDragActive) {
        appliedStyle = _extends({}, appliedStyle, activeStyle);
      }
      if (acceptStyle && isDragAccept) {
        appliedStyle = _extends({}, appliedStyle, acceptStyle);
      }
      if (rejectStyle && isDragReject) {
        appliedStyle = _extends({}, appliedStyle, rejectStyle);
      }
      if (disabledStyle && disabled) {
        appliedStyle = _extends({}, appliedStyle, disabledStyle);
      }

      var inputAttributes = {
        accept: accept,
        disabled: disabled,
        type: 'file',
        style: _extends({
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          opacity: 0.00001,
          pointerEvents: 'none'
        }, inputProps.style),
        multiple: __WEBPACK_IMPORTED_MODULE_2__utils__["g" /* supportMultiple */] && multiple,
        ref: this.setRefs,
        onChange: this.onDrop,
        autoComplete: 'off'
      };

      if (name && name.length) {
        inputAttributes.name = name;
      }

      // Destructure custom props away from props used for the div element
      /* eslint-disable no-unused-vars */

      var acceptedFiles = props.acceptedFiles,
          preventDropOnDocument = props.preventDropOnDocument,
          disablePreview = props.disablePreview,
          disableClick = props.disableClick,
          onDropAccepted = props.onDropAccepted,
          onDropRejected = props.onDropRejected,
          onFileDialogCancel = props.onFileDialogCancel,
          maxSize = props.maxSize,
          minSize = props.minSize,
          getDataTransferItems = props.getDataTransferItems,
          divProps = _objectWithoutProperties(props, ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize', 'getDataTransferItems']);
      /* eslint-enable no-unused-vars */

      /* eslint-disable jsx-a11y/no-static-element-interactions */
      /* eslint-disable jsx-a11y/click-events-have-key-events */


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: className,
          style: appliedStyle
        }, divProps /* expand user provided props first so event handlers are never overridden */
        , {
          onClick: this.composeHandlers(this.onClick),
          onDragStart: this.composeHandlers(this.onDragStart),
          onDragEnter: this.composeHandlers(this.onDragEnter),
          onDragOver: this.composeHandlers(this.onDragOver),
          onDragLeave: this.composeHandlers(this.onDragLeave),
          onDrop: this.composeHandlers(this.onDrop),
          ref: this.setRef,
          'aria-disabled': disabled
        }),
        this.renderChildren(children, isDragActive, isDragAccept, isDragReject),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */
        , inputAttributes))
      );
    }
  }]);

  return Dropzone;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Dropzone);

Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),

  /**
   * Contents of the dropzone
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),

  /**
   * Disallow clicking on the dropzone container to open file dialog
   */
  disableClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable the dropzone entirely
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable preview generation
   */
  disablePreview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */
  inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Allow dropping multiple files
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * `name` attribute for the input tag
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Minimum file size (in bytes)
   */
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * className
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drag is active
   */
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be accepted
   */
  acceptClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be rejected
   */
  rejectClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when dropzone is disabled
   */
  disabledClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS styles to apply
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drag is active
   */
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be accepted
   */
  acceptStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be rejected
   */
  rejectStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when dropzone is disabled
   */
  disabledStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * getDataTransferItems handler
   * @param {Event} event
   * @returns {Array} array of File objects
   */
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDrop callback
   */
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropAccepted callback
   */
  onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropRejected callback
   */
  onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragStart callback
   */
  onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragEnter callback
   */
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragOver callback
   */
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragLeave callback
   */
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  disablePreview: false,
  disableClick: false,
  inputProps: {},
  multiple: true,
  maxSize: Infinity,
  minSize: 0,
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getDataTransferItems */]
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(392);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(402);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__required__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__whitespace__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__range__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enum__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pattern__ = __webpack_require__(556);







/* harmony default export */ __webpack_exports__["a"] = ({
  required: __WEBPACK_IMPORTED_MODULE_0__required__["a" /* default */],
  whitespace: __WEBPACK_IMPORTED_MODULE_1__whitespace__["a" /* default */],
  type: __WEBPACK_IMPORTED_MODULE_2__type__["a" /* default */],
  range: __WEBPACK_IMPORTED_MODULE_3__range__["a" /* default */],
  'enum': __WEBPACK_IMPORTED_MODULE_4__enum__["a" /* default */],
  pattern: __WEBPACK_IMPORTED_MODULE_5__pattern__["a" /* default */]
});

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 42 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = {"public_path":"view/","tech_api":"https://tech.serviziortodontici.3d-plan.online","client_api":"https://serviziortodontici-dide.com","type":"standalone"}

/***/ }),
/* 44 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(136)('wks');
var uid = __webpack_require__(103);
var Symbol = __webpack_require__(56).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = __webpack_require__(326);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Group = __webpack_require__(837);

var _Group2 = _interopRequireDefault(_Group);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Checkbox2['default'].Group = _Group2['default'];
exports['default'] = _Checkbox2['default'];
module.exports = exports['default'];

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function omit(obj, fields) {
  var shallowCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj);
  for (var i = 0; i < fields.length; i++) {
    var key = fields[i];
    delete shallowCopy[key];
  }
  return shallowCopy;
}

/* harmony default export */ __webpack_exports__["default"] = (omit);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _warning = __webpack_require__(266);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var warned = {};

exports['default'] = function (valid, message) {
    if (!valid && !warned[message]) {
        (0, _warning2['default'])(false, message);
        warned[message] = true;
    }
};

module.exports = exports['default'];

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.connect = exports.Provider = undefined;

var _Provider2 = __webpack_require__(639);

var _Provider3 = _interopRequireDefault(_Provider2);

var _connect2 = __webpack_require__(640);

var _connect3 = _interopRequireDefault(_connect2);

var _create2 = __webpack_require__(641);

var _create3 = _interopRequireDefault(_create2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Provider = _Provider3.default;
exports.connect = _connect3.default;
exports.create = _create3.default;

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AnimateChild__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util__ = __webpack_require__(269);










var defaultKey = 'rc_animate_' + Date.now();


function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                return _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else {
      if (type === 'appear') {
        if (__WEBPACK_IMPORTED_MODULE_10__util__["a" /* default */].allowAppearCallback(props)) {
          props.onAppear(key);
          props.onEnd(key, true);
        }
      } else {
        if (__WEBPACK_IMPORTED_MODULE_10__util__["a" /* default */].allowEnterCallback(props)) {
          props.onEnter(key);
          props.onEnd(key, true);
        }
      }
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_10__util__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["default"] = (Animate);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(15);

var _rcMenu = __webpack_require__(79);

var _rcMenu2 = _interopRequireDefault(_rcMenu);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _openAnimation = __webpack_require__(663);

var _openAnimation2 = _interopRequireDefault(_openAnimation);

var _warning = __webpack_require__(48);

var _warning2 = _interopRequireDefault(_warning);

var _SubMenu = __webpack_require__(665);

var _SubMenu2 = _interopRequireDefault(_SubMenu);

var _MenuItem = __webpack_require__(666);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Menu = function (_React$Component) {
    (0, _inherits3['default'])(Menu, _React$Component);

    function Menu(props) {
        (0, _classCallCheck3['default'])(this, Menu);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props));

        _this.inlineOpenKeys = [];
        _this.handleClick = function (e) {
            _this.handleOpenChange([]);
            var onClick = _this.props.onClick;

            if (onClick) {
                onClick(e);
            }
        };
        _this.handleOpenChange = function (openKeys) {
            _this.setOpenKeys(openKeys);
            var onOpenChange = _this.props.onOpenChange;

            if (onOpenChange) {
                onOpenChange(openKeys);
            }
        };
        (0, _warning2['default'])(!('onOpen' in props || 'onClose' in props), '`onOpen` and `onClose` are removed, please use `onOpenChange` instead, ' + 'see: https://u.ant.design/menu-on-open-change.');
        (0, _warning2['default'])(!('inlineCollapsed' in props && props.mode !== 'inline'), '`inlineCollapsed` should only be used when Menu\'s `mode` is inline.');
        var openKeys = void 0;
        if ('defaultOpenKeys' in props) {
            openKeys = props.defaultOpenKeys;
        } else if ('openKeys' in props) {
            openKeys = props.openKeys;
        }
        _this.state = {
            openKeys: openKeys || []
        };
        return _this;
    }

    (0, _createClass3['default'])(Menu, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                inlineCollapsed: this.getInlineCollapsed(),
                antdMenuTheme: this.props.theme
            };
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps, nextContext) {
            var prefixCls = this.props.prefixCls;

            if (this.props.mode === 'inline' && nextProps.mode !== 'inline') {
                this.switchModeFromInline = true;
            }
            if ('openKeys' in nextProps) {
                this.setState({ openKeys: nextProps.openKeys });
                return;
            }
            if (nextProps.inlineCollapsed && !this.props.inlineCollapsed || nextContext.siderCollapsed && !this.context.siderCollapsed) {
                var menuNode = (0, _reactDom.findDOMNode)(this);
                this.switchModeFromInline = !!this.state.openKeys.length && !!menuNode.querySelectorAll('.' + prefixCls + '-submenu-open').length;
                this.inlineOpenKeys = this.state.openKeys;
                this.setState({ openKeys: [] });
            }
            if (!nextProps.inlineCollapsed && this.props.inlineCollapsed || !nextContext.siderCollapsed && this.context.siderCollapsed) {
                this.setState({ openKeys: this.inlineOpenKeys });
                this.inlineOpenKeys = [];
            }
        }
    }, {
        key: 'setOpenKeys',
        value: function setOpenKeys(openKeys) {
            if (!('openKeys' in this.props)) {
                this.setState({ openKeys: openKeys });
            }
        }
    }, {
        key: 'getRealMenuMode',
        value: function getRealMenuMode() {
            var inlineCollapsed = this.getInlineCollapsed();
            if (this.switchModeFromInline && inlineCollapsed) {
                return 'inline';
            }
            var mode = this.props.mode;

            return inlineCollapsed ? 'vertical' : mode;
        }
    }, {
        key: 'getInlineCollapsed',
        value: function getInlineCollapsed() {
            var inlineCollapsed = this.props.inlineCollapsed;

            if (this.context.siderCollapsed !== undefined) {
                return this.context.siderCollapsed;
            }
            return inlineCollapsed;
        }
    }, {
        key: 'getMenuOpenAnimation',
        value: function getMenuOpenAnimation(menuMode) {
            var _this2 = this;

            var _props = this.props,
                openAnimation = _props.openAnimation,
                openTransitionName = _props.openTransitionName;

            var menuOpenAnimation = openAnimation || openTransitionName;
            if (openAnimation === undefined && openTransitionName === undefined) {
                switch (menuMode) {
                    case 'horizontal':
                        menuOpenAnimation = 'slide-up';
                        break;
                    case 'vertical':
                    case 'vertical-left':
                    case 'vertical-right':
                        // When mode switch from inline
                        // submenu should hide without animation
                        if (this.switchModeFromInline) {
                            menuOpenAnimation = '';
                            this.switchModeFromInline = false;
                        } else {
                            menuOpenAnimation = 'zoom-big';
                        }
                        break;
                    case 'inline':
                        menuOpenAnimation = (0, _extends3['default'])({}, _openAnimation2['default'], { leave: function leave(node, done) {
                                return _openAnimation2['default'].leave(node, function () {
                                    // Make sure inline menu leave animation finished before mode is switched
                                    _this2.switchModeFromInline = false;
                                    _this2.setState({});
                                    // when inlineCollapsed change false to true, all submenu will be unmounted,
                                    // so that we don't need handle animation leaving.
                                    if (_this2.getRealMenuMode() === 'vertical') {
                                        return;
                                    }
                                    done();
                                });
                            } });
                        break;
                    default:
                }
            }
            return menuOpenAnimation;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                className = _props2.className,
                theme = _props2.theme;

            var menuMode = this.getRealMenuMode();
            var menuOpenAnimation = this.getMenuOpenAnimation(menuMode);
            var menuClassName = (0, _classnames2['default'])(className, prefixCls + '-' + theme, (0, _defineProperty3['default'])({}, prefixCls + '-inline-collapsed', this.getInlineCollapsed()));
            var menuProps = {
                openKeys: this.state.openKeys,
                onOpenChange: this.handleOpenChange,
                className: menuClassName,
                mode: menuMode
            };
            if (menuMode !== 'inline') {
                // closing vertical popup submenu after click it
                menuProps.onClick = this.handleClick;
                menuProps.openTransitionName = menuOpenAnimation;
            } else {
                menuProps.openAnimation = menuOpenAnimation;
            }
            // https://github.com/ant-design/ant-design/issues/8587
            var collapsedWidth = this.context.collapsedWidth;

            if (this.getInlineCollapsed() && (collapsedWidth === 0 || collapsedWidth === '0' || collapsedWidth === '0px')) {
                return null;
            }
            return React.createElement(_rcMenu2['default'], (0, _extends3['default'])({}, this.props, menuProps));
        }
    }]);
    return Menu;
}(React.Component);

exports['default'] = Menu;

Menu.Divider = _rcMenu.Divider;
Menu.Item = _MenuItem2['default'];
Menu.SubMenu = _SubMenu2['default'];
Menu.ItemGroup = _rcMenu.ItemGroup;
Menu.defaultProps = {
    prefixCls: 'ant-menu',
    className: '',
    theme: 'light',
    focusable: false
};
Menu.childContextTypes = {
    inlineCollapsed: _propTypes2['default'].bool,
    antdMenuTheme: _propTypes2['default'].string
};
Menu.contextTypes = {
    siderCollapsed: _propTypes2['default'].bool,
    collapsedWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
};
module.exports = exports['default'];

/***/ }),
/* 52 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(712);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(348);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(63);
var IE8_DOM_DEFINE = __webpack_require__(226);
var toPrimitive = __webpack_require__(131);
var dP = Object.defineProperty;

exports.f = __webpack_require__(64) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _grid = __webpack_require__(253);

exports['default'] = _grid.Col;
module.exports = exports['default'];

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(596);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(598);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(277);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(600);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(603);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(606);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(608);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(278);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(171);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(614);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(616);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(618);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(619);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(636);

__webpack_require__(282);

/***/ }),
/* 61 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(56);
var core = __webpack_require__(44);
var ctx = __webpack_require__(130);
var hide = __webpack_require__(73);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(74);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(87)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 65 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(154);

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(541);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__propertyUtils__ = __webpack_require__(651);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

var getComputedStyleX = void 0;

// https://stackoverflow.com/a/3485654/3040605
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line
  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = value + 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box = void 0;
  var x = void 0;
  var y = void 0;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }
  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }
  var originalTransition = '';
  var originalOffset = getOffset(elem);
  if ('left' in offset || 'top' in offset) {
    originalTransition = Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["c" /* getTransitionProperty */])(elem) || '';
    Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["e" /* setTransitionProperty */])(elem, 'none');
  }
  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = presetH + 'px';
  }
  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = presetV + 'px';
  }
  // force relayout
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];
      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css(elem, originalStyle);
  // force relayout
  forceRelayout(elem);
  if ('left' in offset || 'top' in offset) {
    Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["e" /* setTransitionProperty */])(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css(elem, ret);
}

function setTransform(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["b" /* getTransformXY */])(elem);
  var resultXY = { x: originalXY.x, y: originalXY.y };
  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }
  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["d" /* setTransformXY */])(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);

    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["a" /* getTransformName */])() in document.body.style) {
    setTransform(elem, offset, option);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name = void 0;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop = void 0;
  var j = void 0;
  var i = void 0;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;
        if (prop === 'border') {
          cssProp = '' + prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement['scroll' + name],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body['scroll' + name], domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val = void 0;
  var elem = args[0];
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }
  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },

  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },

  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i = void 0;
    var ret = {};
    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },

  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
      args[_key3] = arguments[_key3];
    }

    for (var i = 0; i < args.length; i++) {
      utils.mix(ret, args[i]);
    }
    return ret;
  },

  viewportWidth: 0,
  viewportHeight: 0
};

mix(utils, domUtils);

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),
/* 70 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var LocaleReceiver = function (_React$Component) {
    (0, _inherits3['default'])(LocaleReceiver, _React$Component);

    function LocaleReceiver() {
        (0, _classCallCheck3['default'])(this, LocaleReceiver);
        return (0, _possibleConstructorReturn3['default'])(this, (LocaleReceiver.__proto__ || Object.getPrototypeOf(LocaleReceiver)).apply(this, arguments));
    }

    (0, _createClass3['default'])(LocaleReceiver, [{
        key: 'getLocale',
        value: function getLocale() {
            var _props = this.props,
                componentName = _props.componentName,
                defaultLocale = _props.defaultLocale;
            var antLocale = this.context.antLocale;

            var localeFromContext = antLocale && antLocale[componentName];
            return (0, _extends3['default'])({}, typeof defaultLocale === 'function' ? defaultLocale() : defaultLocale, localeFromContext || {});
        }
    }, {
        key: 'getLocaleCode',
        value: function getLocaleCode() {
            var antLocale = this.context.antLocale;

            var localeCode = antLocale && antLocale.locale;
            // Had use LocaleProvide but didn't set locale
            if (antLocale && antLocale.exist && !localeCode) {
                return 'en-us';
            }
            return localeCode;
        }
    }, {
        key: 'render',
        value: function render() {
            return this.props.children(this.getLocale(), this.getLocaleCode());
        }
    }]);
    return LocaleReceiver;
}(React.Component);

exports['default'] = LocaleReceiver;

LocaleReceiver.contextTypes = {
    antLocale: _propTypes2['default'].object
};
module.exports = exports['default'];

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/crowns.2e4d0bbb.svg";

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(57);
var createDesc = __webpack_require__(88);
module.exports = __webpack_require__(64) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(229);
var defined = __webpack_require__(133);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(623);

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _layout = __webpack_require__(624);

var _layout2 = _interopRequireDefault(_layout);

var _Sider = __webpack_require__(625);

var _Sider2 = _interopRequireDefault(_Sider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_layout2['default'].Sider = _Sider2['default'];
exports['default'] = _layout2['default'];
module.exports = exports['default'];

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubMenu__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuItem__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Divider__ = __webpack_require__(662);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SubMenu", function() { return __WEBPACK_IMPORTED_MODULE_1__SubMenu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Item", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuItem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuItem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItemGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Divider", function() { return __WEBPACK_IMPORTED_MODULE_4__Divider__["a"]; });








/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Menu__["a" /* default */]);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */

var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12, // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33, // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34, // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35, // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36, // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37, // also NUM_WEST
  /**
   * UP
   */
  UP: 38, // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39, // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40, // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45, // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46, // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63, // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91, // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186, // needs localization
  /**
   * DASH
   */
  DASH: 189, // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187, // needs localization
  /**
   * COMMA
   */
  COMMA: 188, // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190, // needs localization
  /**
   * SLASH
   */
  SLASH: 191, // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192, // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222, // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219, // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220, // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221, // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224, // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229
};

/*
 whether text and modified key is entered at the same time.
 */
KeyCode.isTextModifyingKeyEvent = function isTextModifyingKeyEvent(e) {
  var keyCode = e.keyCode;
  if (e.altKey && !e.ctrlKey || e.metaKey ||
  // Function keys don't generate text
  keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
    return false;
  }

  // The following keys are quite harmless, even in combination with
  // CTRL, ALT or SHIFT.
  switch (keyCode) {
    case KeyCode.ALT:
    case KeyCode.CAPS_LOCK:
    case KeyCode.CONTEXT_MENU:
    case KeyCode.CTRL:
    case KeyCode.DOWN:
    case KeyCode.END:
    case KeyCode.ESC:
    case KeyCode.HOME:
    case KeyCode.INSERT:
    case KeyCode.LEFT:
    case KeyCode.MAC_FF_META:
    case KeyCode.META:
    case KeyCode.NUMLOCK:
    case KeyCode.NUM_CENTER:
    case KeyCode.PAGE_DOWN:
    case KeyCode.PAGE_UP:
    case KeyCode.PAUSE:
    case KeyCode.PRINT_SCREEN:
    case KeyCode.RIGHT:
    case KeyCode.SHIFT:
    case KeyCode.UP:
    case KeyCode.WIN_KEY:
    case KeyCode.WIN_KEY_RIGHT:
      return false;
    default:
      return true;
  }
};

/*
 whether character is entered.
 */
KeyCode.isCharacterKey = function isCharacterKey(keyCode) {
  if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
    return true;
  }

  if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
    return true;
  }

  if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
    return true;
  }

  // Safari sends zero key code for non-latin characters.
  if (window.navigation.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
    return true;
  }

  switch (keyCode) {
    case KeyCode.SPACE:
    case KeyCode.QUESTION_MARK:
    case KeyCode.NUM_PLUS:
    case KeyCode.NUM_MINUS:
    case KeyCode.NUM_PERIOD:
    case KeyCode.NUM_DIVISION:
    case KeyCode.SEMICOLON:
    case KeyCode.DASH:
    case KeyCode.EQUALS:
    case KeyCode.COMMA:
    case KeyCode.PERIOD:
    case KeyCode.SLASH:
    case KeyCode.APOSTROPHE:
    case KeyCode.SINGLE_QUOTE:
    case KeyCode.OPEN_SQUARE_BRACKET:
    case KeyCode.BACKSLASH:
    case KeyCode.CLOSE_SQUARE_BRACKET:
      return true;
    default:
      return false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (KeyCode);

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Popup__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_ContainerRender__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rc_util_es_Portal__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_classnames__);















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.prevPopupVisible = popupVisible;

    _this.state = {
      popupVisible: popupVisible
    };
    return _this;
  }

  Trigger.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    ALL_HANDLERS.forEach(function (h) {
      _this2['fire' + h] = function (e) {
        _this2.fireEvents(h, e);
      };
    });
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var popupVisible = _ref.popupVisible;

    if (popupVisible !== undefined) {
      this.setState({
        popupVisible: popupVisible
      });
    }
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    this.prevPopupVisible = prevState.popupVisible;

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;


    this.clearDelayTimer();

    if (this.state.popupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this3 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this3.setPopupVisible(visible, point);
        _this3.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this4 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = __WEBPACK_IMPORTED_MODULE_13_classnames___default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this4.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_rc_util_es_Portal__["a" /* default */],
        {
          key: 'portal',
          getContainer: this.getContainer,
          didUpdate: this.handlePortalUpdate
        },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  alignPoint: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool // Maybe we can support user pass position in the future
};
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this5.props.mouseEnterDelay;

    _this5.fireEvents('onMouseEnter', e);
    _this5.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this5.fireEvents('onMouseMove', e);
    _this5.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this5.fireEvents('onMouseLeave', e);
    _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this5.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this5._component && _this5._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(_this5._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this5.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this5.clearDelayTimer();
    if (_this5.isFocusToShow()) {
      _this5.focusTime = Date.now();
      _this5.delaySetPopupVisible(true, _this5.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this5.fireEvents('onMouseDown', e);
    _this5.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this5.fireEvents('onTouchStart', e);
    _this5.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this5.fireEvents('onBlur', e);
    _this5.clearDelayTimer();
    if (_this5.isBlurToHide()) {
      _this5.delaySetPopupVisible(false, _this5.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this5.fireEvents('onContextMenu', e);
    _this5.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this5.isContextMenuToShow()) {
      _this5.close();
    }
  };

  this.onClick = function (event) {
    _this5.fireEvents('onClick', event);
    // focus will trigger click
    if (_this5.focusTime) {
      var preTime = void 0;
      if (_this5.preClickTime && _this5.preTouchTime) {
        preTime = Math.min(_this5.preClickTime, _this5.preTouchTime);
      } else if (_this5.preClickTime) {
        preTime = _this5.preClickTime;
      } else if (_this5.preTouchTime) {
        preTime = _this5.preTouchTime;
      }
      if (Math.abs(preTime - _this5.focusTime) < 20) {
        return;
      }
      _this5.focusTime = 0;
    }
    _this5.preClickTime = 0;
    _this5.preTouchTime = 0;
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this5.state.popupVisible;
    if (_this5.isClickToHide() && !nextVisible || nextVisible && _this5.isClickToShow()) {
      _this5.setPopupVisible(!_this5.state.popupVisible, event);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this5.props.mask && !_this5.props.maskClosable) {
      return;
    }
    var target = event.target;
    var root = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5);
    var popupNode = _this5.getPopupDomNode();
    if (!Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(popupNode, target)) {
      _this5.close();
    }
  };

  this.getRootDomNode = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this5.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(Object(__WEBPACK_IMPORTED_MODULE_10__utils__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this5.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this5.state,
        popupVisible = _state.popupVisible,
        point = _state.point;


    var align = _this5.getPopupAlign();

    var mouseProps = {};
    if (_this5.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this5.onPopupMouseEnter;
    }
    if (_this5.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this5.onPopupMouseLeave;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this5.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this5.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this5.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this5.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this5.props.alignPoint;

    if (!alignPoint || !point) return;

    _this5.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this5.prevPopupVisible !== _this5.state.popupVisible) {
      _this5.props.afterPopupVisibleChange(_this5.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this5._component = node;
  };
};

/* harmony default export */ __webpack_exports__["default"] = (Trigger);

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(305);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

exports.getTodayTime = getTodayTime;
exports.getTitleString = getTitleString;
exports.getTodayTimeStr = getTodayTimeStr;
exports.getMonthName = getMonthName;
exports.syncTime = syncTime;
exports.getTimeConfig = getTimeConfig;
exports.isTimeValidByConfig = isTimeValidByConfig;
exports.isTimeValid = isTimeValid;
exports.isAllowedDate = isAllowedDate;

var _moment = __webpack_require__(31);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var defaultDisabledTime = {
  disabledHours: function disabledHours() {
    return [];
  },
  disabledMinutes: function disabledMinutes() {
    return [];
  },
  disabledSeconds: function disabledSeconds() {
    return [];
  }
};

function getTodayTime(value) {
  var today = (0, _moment2['default'])();
  today.locale(value.locale()).utcOffset(value.utcOffset());
  return today;
}

function getTitleString(value) {
  return value.format('LL');
}

function getTodayTimeStr(value) {
  var today = getTodayTime(value);
  return getTitleString(today);
}

function getMonthName(month) {
  var locale = month.locale();
  var localeData = month.localeData();
  return localeData[locale === 'zh-cn' ? 'months' : 'monthsShort'](month);
}

function syncTime(from, to) {
  if (!_moment2['default'].isMoment(from) || !_moment2['default'].isMoment(to)) return;
  to.hour(from.hour());
  to.minute(from.minute());
  to.second(from.second());
}

function getTimeConfig(value, disabledTime) {
  var disabledTimeConfig = disabledTime ? disabledTime(value) : {};
  disabledTimeConfig = (0, _extends3['default'])({}, defaultDisabledTime, disabledTimeConfig);
  return disabledTimeConfig;
}

function isTimeValidByConfig(value, disabledTimeConfig) {
  var invalidTime = false;
  if (value) {
    var hour = value.hour();
    var minutes = value.minute();
    var seconds = value.second();
    var disabledHours = disabledTimeConfig.disabledHours();
    if (disabledHours.indexOf(hour) === -1) {
      var disabledMinutes = disabledTimeConfig.disabledMinutes(hour);
      if (disabledMinutes.indexOf(minutes) === -1) {
        var disabledSeconds = disabledTimeConfig.disabledSeconds(hour, minutes);
        invalidTime = disabledSeconds.indexOf(seconds) !== -1;
      } else {
        invalidTime = true;
      }
    } else {
      invalidTime = true;
    }
  }
  return !invalidTime;
}

function isTimeValid(value, disabledTime) {
  var disabledTimeConfig = getTimeConfig(value, disabledTime);
  return isTimeValidByConfig(value, disabledTimeConfig);
}

function isAllowedDate(value, disabledDate, disabledTime) {
  if (disabledDate) {
    if (disabledDate(value)) {
      return false;
    }
  }
  if (disabledTime) {
    if (!isTimeValid(value, disabledTime)) {
      return false;
    }
  }
  return true;
}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(948),
    getValue = __webpack_require__(953);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = interopDefault;
// https://github.com/moment/moment/issues/3650
function interopDefault(m) {
    return m["default"] || m;
}
module.exports = exports["default"];

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = noop;
/* harmony export (immutable) */ __webpack_exports__["a"] = getKeyFromChildrenIndex;
/* harmony export (immutable) */ __webpack_exports__["b"] = getMenuIdFromSubMenuEventKey;
/* harmony export (immutable) */ __webpack_exports__["c"] = loopMenuItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = loopMenuItemRecursively;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return menuAllProps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function noop() {}

function getKeyFromChildrenIndex(child, menuEventKey, index) {
  var prefix = menuEventKey || '';
  return child.key || prefix + 'item_' + index;
}

function getMenuIdFromSubMenuEventKey(eventKey) {
  return eventKey + '-menu-';
}

function loopMenuItem(children, cb) {
  var index = -1;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (c) {
    index++;
    if (c && c.type && c.type.isMenuItemGroup) {
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(c.props.children, function (c2) {
        index++;
        cb(c2, index);
      });
    } else {
      cb(c, index);
    }
  });
}

function loopMenuItemRecursively(children, keys, ret) {
  /* istanbul ignore if */
  if (!children || ret.find) {
    return;
  }
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (c) {
    if (c) {
      var construct = c.type;
      if (!construct || !(construct.isSubMenu || construct.isMenuItem || construct.isMenuItemGroup)) {
        return;
      }
      if (keys.indexOf(c.key) !== -1) {
        ret.find = true;
      } else if (c.props.children) {
        loopMenuItemRecursively(c.props.children, keys, ret);
      }
    }
  });
}

var menuAllProps = ['defaultSelectedKeys', 'selectedKeys', 'defaultOpenKeys', 'openKeys', 'mode', 'getPopupContainer', 'onSelect', 'onDeselect', 'onDestroy', 'openTransitionName', 'openAnimation', 'subMenuOpenDelay', 'subMenuCloseDelay', 'forceSubMenuRender', 'triggerSubMenuAction', 'level', 'selectable', 'multiple', 'onOpenChange', 'visible', 'focusable', 'defaultActiveFirst', 'prefixCls', 'inlineIndent', 'parentMenu', 'title', 'rootPrefixCls', 'eventKey', 'active', 'onItemHover', 'onTitleMouseEnter', 'onTitleMouseLeave', 'onTitleClick', 'popupOffset', 'isOpen', 'renderMenuItem', 'manualRef', 'subMenuKey', 'disabled', 'index', 'isSelected', 'store', 'activeKey',

// the following keys found need to be removed from test regression
'attribute', 'value', 'popupClassName', 'inlineCollapsed', 'menu', 'theme'];

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(187),
    getRawTag = __webpack_require__(735),
    objectToString = __webpack_require__(736);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = measureScrollbar;
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
/* harmony export (immutable) */ __webpack_exports__["d"] = warningOnce;
/* harmony export (immutable) */ __webpack_exports__["c"] = remove;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var scrollbarSize = void 0;

// Measure scrollbar width for padding body during modal show/hide
var scrollbarMeasure = {
  position: 'absolute',
  top: '-9999px',
  width: '50px',
  height: '50px',
  overflow: 'scroll'
};

function measureScrollbar() {
  var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'vertical';

  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return 0;
  }
  if (scrollbarSize) {
    return scrollbarSize;
  }
  var scrollDiv = document.createElement('div');
  Object.keys(scrollbarMeasure).forEach(function (scrollProp) {
    scrollDiv.style[scrollProp] = scrollbarMeasure[scrollProp];
  });
  document.body.appendChild(scrollDiv);
  var size = 0;
  if (direction === 'vertical') {
    size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  } else if (direction === 'horizontal') {
    size = scrollDiv.offsetHeight - scrollDiv.clientHeight;
  }

  document.body.removeChild(scrollDiv);
  scrollbarSize = size;
  return scrollbarSize;
}

function debounce(func, wait, immediate) {
  var timeout = void 0;
  function debounceFunc() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = this;
    // https://fb.me/react-event-pooling
    if (args[0] && args[0].persist) {
      args[0].persist();
    }
    var later = function later() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  }
  debounceFunc.cancel = function cancel() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  return debounceFunc;
}

var warned = {};
function warningOnce(condition, format, args) {
  if (!warned[format]) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(condition, format, args);
    warned[format] = !condition;
  }
}

function remove(array, item) {
  var index = array.indexOf(item);
  var front = array.slice(0, index);
  var last = array.slice(index + 1, array.length);
  return front.concat(last);
}

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Group = exports.Button = undefined;

var _radio = __webpack_require__(193);

var _radio2 = _interopRequireDefault(_radio);

var _group = __webpack_require__(838);

var _group2 = _interopRequireDefault(_group);

var _radioButton = __webpack_require__(839);

var _radioButton2 = _interopRequireDefault(_radioButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_radio2['default'].Button = _radioButton2['default'];
_radio2['default'].Group = _group2['default'];
exports.Button = _radioButton2['default'];
exports.Group = _group2['default'];
exports['default'] = _radio2['default'];

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getTodayTime;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTitleString;
/* harmony export (immutable) */ __webpack_exports__["e"] = getTodayTimeStr;
/* harmony export (immutable) */ __webpack_exports__["a"] = getMonthName;
/* harmony export (immutable) */ __webpack_exports__["g"] = syncTime;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTimeConfig;
/* unused harmony export isTimeValidByConfig */
/* unused harmony export isTimeValid */
/* harmony export (immutable) */ __webpack_exports__["f"] = isAllowedDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var defaultDisabledTime = {
  disabledHours: function disabledHours() {
    return [];
  },
  disabledMinutes: function disabledMinutes() {
    return [];
  },
  disabledSeconds: function disabledSeconds() {
    return [];
  }
};

function getTodayTime(value) {
  var today = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
  today.locale(value.locale()).utcOffset(value.utcOffset());
  return today;
}

function getTitleString(value) {
  return value.format('LL');
}

function getTodayTimeStr(value) {
  var today = getTodayTime(value);
  return getTitleString(today);
}

function getMonthName(month) {
  var locale = month.locale();
  var localeData = month.localeData();
  return localeData[locale === 'zh-cn' ? 'months' : 'monthsShort'](month);
}

function syncTime(from, to) {
  if (!__WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(from) || !__WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(to)) return;
  to.hour(from.hour());
  to.minute(from.minute());
  to.second(from.second());
}

function getTimeConfig(value, disabledTime) {
  var disabledTimeConfig = disabledTime ? disabledTime(value) : {};
  disabledTimeConfig = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultDisabledTime, disabledTimeConfig);
  return disabledTimeConfig;
}

function isTimeValidByConfig(value, disabledTimeConfig) {
  var invalidTime = false;
  if (value) {
    var hour = value.hour();
    var minutes = value.minute();
    var seconds = value.second();
    var disabledHours = disabledTimeConfig.disabledHours();
    if (disabledHours.indexOf(hour) === -1) {
      var disabledMinutes = disabledTimeConfig.disabledMinutes(hour);
      if (disabledMinutes.indexOf(minutes) === -1) {
        var disabledSeconds = disabledTimeConfig.disabledSeconds(hour, minutes);
        invalidTime = disabledSeconds.indexOf(seconds) !== -1;
      } else {
        invalidTime = true;
      }
    } else {
      invalidTime = true;
    }
  }
  return !invalidTime;
}

function isTimeValid(value, disabledTime) {
  var disabledTimeConfig = getTimeConfig(value, disabledTime);
  return isTimeValidByConfig(value, disabledTimeConfig);
}

function isAllowedDate(value, disabledDate, disabledTime) {
  if (disabledDate) {
    if (disabledDate(value)) {
      return false;
    }
  }
  if (disabledTime) {
    if (!isTimeValid(value, disabledTime)) {
      return false;
    }
  }
  return true;
}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(124),
    getRawTag = __webpack_require__(949),
    objectToString = __webpack_require__(950);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 99 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gums.fb89bc55.svg";

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/attachments.80305354.svg";

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(228);
var enumBugKeys = __webpack_require__(137);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 103 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 104 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(394)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(232)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _en_US = __webpack_require__(236);

var _en_US2 = _interopRequireDefault(_en_US);

var _en_US3 = __webpack_require__(149);

var _en_US4 = _interopRequireDefault(_en_US3);

var _en_US5 = __webpack_require__(150);

var _en_US6 = _interopRequireDefault(_en_US5);

var _en_US7 = __webpack_require__(422);

var _en_US8 = _interopRequireDefault(_en_US7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    locale: 'en',
    Pagination: _en_US2['default'],
    DatePicker: _en_US4['default'],
    TimePicker: _en_US6['default'],
    Calendar: _en_US8['default'],
    Table: {
        filterTitle: 'Filter menu',
        filterConfirm: 'OK',
        filterReset: 'Reset',
        emptyText: 'No data',
        selectAll: 'Select current page',
        selectInvert: 'Invert current page'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Cancel',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Cancel'
    },
    Transfer: {
        titles: ['', ''],
        notFoundContent: 'Not Found',
        searchPlaceholder: 'Search here',
        itemUnit: 'item',
        itemsUnit: 'items'
    },
    Select: {
        notFoundContent: 'Not Found'
    },
    Upload: {
        uploading: 'Uploading...',
        removeFile: 'Remove file',
        uploadError: 'Upload error',
        previewFile: 'Preview file'
    }
};
module.exports = exports['default'];

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export userIsLoading */
/* unused harmony export userLoggedInSuccess */
/* unused harmony export userLoggedInFailure */
/* unused harmony export userLogoutFailure */
/* unused harmony export userLogoutSuccess */
/* unused harmony export userUpdateProfileSuccess */
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeUser;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateUser;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateProfile;
/* harmony export (immutable) */ __webpack_exports__["b"] = loginUser;
/* harmony export (immutable) */ __webpack_exports__["c"] = logoutUser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__switch_api__ = __webpack_require__(25);
function userIsLoading(bool){return{type:'USER_IS_LOGGING_IN',userIsLoading:bool};}function userLoggedInSuccess(fields){return{type:'USER_LOGGED_IN_SUCCESS',fields:fields};}function userLoggedInFailure(message){return{type:'USER_LOGGED_IN_ERROR',message:message};}function userLogoutFailure(message){return{type:'USER_LOGOUT_ERROR',message:message};}function userLogoutSuccess(fields){return{type:'USER_LOGOUT_SUCCESS',fields:fields};}function userUpdateProfileSuccess(fields){return{type:'USER_UPDATE_PROFILE_SUCCESS',fields:fields};}function initializeUser(){var token=localStorage.getItem('token');return function(dispatch){dispatch(userIsLoading(true));fetch(__WEBPACK_IMPORTED_MODULE_0__config__["w" /* API_WHOAMI */],{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_WHOAMI }: "+response.statusText);dispatch(userIsLoading(false));}return response;}).then(function(response){return response.json();}).then(function(fields){return dispatch(userLoggedInSuccess(fields));}).then(function(fields){fields.username?fields.is_client?localStorage.setItem('API',__WEBPACK_IMPORTED_MODULE_0__config__["a" /* API_CLIENT */]):localStorage.setItem('API',__WEBPACK_IMPORTED_MODULE_0__config__["s" /* API_TECH */]):null;}).catch(function(e){// dispatch(userLoggedInFailure('' + e))
dispatch(userIsLoading(false));});};}function updateUser(data){var token=localStorage.getItem('token');return function(dispatch){fetch(Object(__WEBPACK_IMPORTED_MODULE_1__switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_0__config__["t" /* API_UPDATE_ME */]),{method:'PATCH',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify(data)}).then(function(response){if(!response.ok){console.error("Failed loading { API_UPDATE_ME }: "+response.statusText);}return response;}).then(function(response){return response.json();}).then(function(fields){return dispatch(userUpdateProfileSuccess(fields));}).catch(function(e){// dispatch(userLoggedInFailure('' + e))
});};}function updateProfile(data){var token=localStorage.getItem('token');console.warn(data);return function(dispatch){fetch(Object(__WEBPACK_IMPORTED_MODULE_1__switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_0__config__["v" /* API_UPDATE_PROFILE */]),{method:'PATCH',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify(data)}).then(function(response){if(!response.ok){console.error("Failed loading { API_UPDATE_ME }: "+response.statusText);}return response;}).then(function(response){return response.json();}).then(function(fields){return console.warn(fields);}).catch(function(e){// dispatch(userLoggedInFailure('' + e))
});};}function loginUser(login,password){return function(dispatch){fetch(__WEBPACK_IMPORTED_MODULE_0__config__["o" /* API_LOGIN */],{method:'POST',headers:{'Accept':'application/json','Authorization':'Basic '+btoa(login+':'+password),'Content-Type':'application/x-www-form-urlencoded'}// credentials: 'include',
}).then(function(response){if(!response.ok){console.error("Failed loading { API_LOGIN }: "+response.statusText);// throw Error(response.statusText);
}return response;}).then(function(response){return response.json();}).then(function(fields){return dispatch(fields.token?(localStorage.setItem('token',fields.token),userLoggedInSuccess(fields)):userLoggedInFailure(fields.detail));}).then(function(fields){fields.fields.user?fields.fields.user.is_client?localStorage.setItem('API',__WEBPACK_IMPORTED_MODULE_0__config__["a" /* API_CLIENT */]):localStorage.setItem('API',__WEBPACK_IMPORTED_MODULE_0__config__["s" /* API_TECH */]):null;}).catch(function(e){dispatch(userLoggedInFailure(' '));});};}function logoutUser(){var token=localStorage.getItem('token');return function(dispatch,getState){fetch(__WEBPACK_IMPORTED_MODULE_0__config__["p" /* API_LOGOUT */],{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'// send cookies for CORS requests
}).then(function(response){if(!response.ok){console.error("Failed logging out on { API_LOGOUT}");throw Error(response.statusText);}return response;})// .then((response) => response.json())
.then(function(response){return dispatch(userLogoutSuccess());}).catch(function(err){return dispatch(userLogoutFailure('logout failure: '+err));});};}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(162);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(257);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(531);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(91);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.toArray = toArray;
exports.getActiveIndex = getActiveIndex;
exports.getActiveKey = getActiveKey;
exports.setTransform = setTransform;
exports.isTransformSupported = isTransformSupported;
exports.setTransition = setTransition;
exports.getTransformPropValue = getTransformPropValue;
exports.isVertical = isVertical;
exports.getTransformByIndex = getTransformByIndex;
exports.getMarginStyle = getMarginStyle;
exports.getStyle = getStyle;
exports.setPxStyle = setPxStyle;
exports.getDataAttr = getDataAttr;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function toArray(children) {
  // allow [c,[a,b]]
  var c = [];
  _react2['default'].Children.forEach(children, function (child) {
    if (child) {
      c.push(child);
    }
  });
  return c;
}

function getActiveIndex(children, activeKey) {
  var c = toArray(children);
  for (var i = 0; i < c.length; i++) {
    if (c[i].key === activeKey) {
      return i;
    }
  }
  return -1;
}

function getActiveKey(children, index) {
  var c = toArray(children);
  return c[index].key;
}

function setTransform(style, v) {
  style.transform = v;
  style.webkitTransform = v;
  style.mozTransform = v;
}

function isTransformSupported(style) {
  return 'transform' in style || 'webkitTransform' in style || 'MozTransform' in style;
}

function setTransition(style, v) {
  style.transition = v;
  style.webkitTransition = v;
  style.MozTransition = v;
}
function getTransformPropValue(v) {
  return {
    transform: v,
    WebkitTransform: v,
    MozTransform: v
  };
}

function isVertical(tabBarPosition) {
  return tabBarPosition === 'left' || tabBarPosition === 'right';
}

function getTransformByIndex(index, tabBarPosition) {
  var translate = isVertical(tabBarPosition) ? 'translateY' : 'translateX';
  return translate + '(' + -index * 100 + '%) translateZ(0)';
}

function getMarginStyle(index, tabBarPosition) {
  var marginDirection = isVertical(tabBarPosition) ? 'marginTop' : 'marginLeft';
  return (0, _defineProperty3['default'])({}, marginDirection, -index * 100 + '%');
}

function getStyle(el, property) {
  return +getComputedStyle(el).getPropertyValue(property).replace('px', '');
}

function setPxStyle(el, value, vertical) {
  value = vertical ? '0px, ' + value + 'px, 0px' : value + 'px, 0px, 0px';
  setTransform(el.style, 'translate3d(' + value + ')');
}

function getDataAttr(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
      prev[key] = props[key];
    }
    return prev;
  }, {});
}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(711);

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(724),
    listCacheDelete = __webpack_require__(725),
    listCacheGet = __webpack_require__(726),
    listCacheHas = __webpack_require__(727),
    listCacheSet = __webpack_require__(728);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(118);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 118 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(185);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(749);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dropdown = __webpack_require__(325);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _dropdownButton = __webpack_require__(829);

var _dropdownButton2 = _interopRequireDefault(_dropdownButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_dropdown2['default'].Button = _dropdownButton2['default'];
exports['default'] = _dropdown2['default'];
module.exports = exports['default'];

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(938),
    listCacheDelete = __webpack_require__(939),
    listCacheGet = __webpack_require__(940),
    listCacheHas = __webpack_require__(941),
    listCacheSet = __webpack_require__(942);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(346);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(55);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(85);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(962);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(203);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xls.2b6bd56f.svg";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pdf.0c77f5c9.svg";

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(386);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(74);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 133 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 134 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(136)('keys');
var uid = __webpack_require__(103);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(56);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 137 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 138 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(133);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(63);
var dPs = __webpack_require__(396);
var enumBugKeys = __webpack_require__(137);
var IE_PROTO = __webpack_require__(135)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(227)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(397).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(57).f;
var has = __webpack_require__(65);
var TAG = __webpack_require__(45)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(399);
var global = __webpack_require__(56);
var hide = __webpack_require__(73);
var Iterators = __webpack_require__(76);
var TO_STRING_TAG = __webpack_require__(45)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(45);


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(56);
var core = __webpack_require__(44);
var LIBRARY = __webpack_require__(140);
var wksExt = __webpack_require__(144);
var defineProperty = __webpack_require__(57).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

exports.changeConfirmLocale = changeConfirmLocale;
exports.getConfirmLocale = getConfirmLocale;

var _default = __webpack_require__(107);

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var runtimeLocale = (0, _extends3['default'])({}, _default2['default'].Modal);
function changeConfirmLocale(newLocale) {
    if (newLocale) {
        runtimeLocale = (0, _extends3['default'])({}, runtimeLocale, newLocale);
    } else {
        runtimeLocale = (0, _extends3['default'])({}, _default2['default'].Modal);
    }
}
function getConfirmLocale() {
    return runtimeLocale;
}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _en_US = __webpack_require__(237);

var _en_US2 = _interopRequireDefault(_en_US);

var _en_US3 = __webpack_require__(150);

var _en_US4 = _interopRequireDefault(_en_US3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Merge into a locale object
var locale = {
    lang: (0, _extends3['default'])({ placeholder: 'Select date', rangePlaceholder: ['Start date', 'End date'] }, _en_US2['default']),
    timePickerLocale: (0, _extends3['default'])({}, _en_US4['default'])
};
// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
exports['default'] = locale;
module.exports = exports['default'];

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var locale = {
    placeholder: 'Select time'
};
exports['default'] = locale;
module.exports = exports['default'];

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(244);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* unused harmony reexport compose */







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(446);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(497);

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(109),
    isKey = __webpack_require__(502),
    stringToPath = __webpack_require__(506),
    toString = __webpack_require__(535);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(158),
    isObjectLike = __webpack_require__(161);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(159),
    getRawTag = __webpack_require__(504),
    objectToString = __webpack_require__(505);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(160);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(503);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(513),
    getValue = __webpack_require__(518);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 163 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(157);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = __webpack_require__(38);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.argumentContainer = argumentContainer;
exports.identity = identity;
exports.flattenArray = flattenArray;
exports.treeTraverse = treeTraverse;
exports.flattenFields = flattenFields;
exports.normalizeValidateRules = normalizeValidateRules;
exports.getValidateTriggers = getValidateTriggers;
exports.getValueFromEvent = getValueFromEvent;
exports.getErrorStrs = getErrorStrs;
exports.getParams = getParams;
exports.isEmptyObject = isEmptyObject;
exports.hasRules = hasRules;
exports.startsWith = startsWith;

var _hoistNonReactStatics = __webpack_require__(265);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'WrappedComponent';
}

function argumentContainer(Container, WrappedComponent) {
  /* eslint no-param-reassign:0 */
  Container.displayName = 'Form(' + getDisplayName(WrappedComponent) + ')';
  Container.WrappedComponent = WrappedComponent;
  return (0, _hoistNonReactStatics2['default'])(Container, WrappedComponent);
}

function identity(obj) {
  return obj;
}

function flattenArray(arr) {
  return Array.prototype.concat.apply([], arr);
}

function treeTraverse() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var tree = arguments[1];
  var isLeafNode = arguments[2];
  var errorMessage = arguments[3];
  var callback = arguments[4];

  if (isLeafNode(path, tree)) {
    callback(path, tree);
  } else if (tree === undefined || tree === null) {
    return;
  } else if (Array.isArray(tree)) {
    tree.forEach(function (subTree, index) {
      return treeTraverse(path + '[' + index + ']', subTree, isLeafNode, errorMessage, callback);
    });
  } else {
    // It's object and not a leaf node
    if ((typeof tree === 'undefined' ? 'undefined' : (0, _typeof3['default'])(tree)) !== 'object') {
      console.error(errorMessage);
      return;
    }
    Object.keys(tree).forEach(function (subTreeKey) {
      var subTree = tree[subTreeKey];
      treeTraverse('' + path + (path ? '.' : '') + subTreeKey, subTree, isLeafNode, errorMessage, callback);
    });
  }
}

function flattenFields(maybeNestedFields, isLeafNode, errorMessage) {
  var fields = {};
  treeTraverse(undefined, maybeNestedFields, isLeafNode, errorMessage, function (path, node) {
    fields[path] = node;
  });
  return fields;
}

function normalizeValidateRules(validate, rules, validateTrigger) {
  var validateRules = validate.map(function (item) {
    var newItem = (0, _extends3['default'])({}, item, {
      trigger: item.trigger || []
    });
    if (typeof newItem.trigger === 'string') {
      newItem.trigger = [newItem.trigger];
    }
    return newItem;
  });
  if (rules) {
    validateRules.push({
      trigger: validateTrigger ? [].concat(validateTrigger) : [],
      rules: rules
    });
  }
  return validateRules;
}

function getValidateTriggers(validateRules) {
  return validateRules.filter(function (item) {
    return !!item.rules && item.rules.length;
  }).map(function (item) {
    return item.trigger;
  }).reduce(function (pre, curr) {
    return pre.concat(curr);
  }, []);
}

function getValueFromEvent(e) {
  // To support custom element
  if (!e || !e.target) {
    return e;
  }
  var target = e.target;

  return target.type === 'checkbox' ? target.checked : target.value;
}

function getErrorStrs(errors) {
  if (errors) {
    return errors.map(function (e) {
      if (e && e.message) {
        return e.message;
      }
      return e;
    });
  }
  return errors;
}

function getParams(ns, opt, cb) {
  var names = ns;
  var options = opt;
  var callback = cb;
  if (cb === undefined) {
    if (typeof names === 'function') {
      callback = names;
      options = {};
      names = undefined;
    } else if (Array.isArray(names)) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      } else {
        options = options || {};
      }
    } else {
      callback = options;
      options = names || {};
      names = undefined;
    }
  }
  return {
    names: names,
    options: options,
    callback: callback
  };
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function hasRules(validate) {
  if (validate) {
    return validate.some(function (item) {
      return item.rules && item.rules.length;
    });
  }
  return false;
}

function startsWith(str, prefix) {
  return str.lastIndexOf(prefix, 0) === 0;
}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(268);
} catch (err) {
  var index = __webpack_require__(268);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(592);

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _rcNotification = __webpack_require__(272);

var _rcNotification2 = _interopRequireDefault(_rcNotification);

var _icon = __webpack_require__(6);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var notificationInstance = {};
var defaultDuration = 4.5;
var defaultTop = 24;
var defaultBottom = 24;
var defaultPlacement = 'topRight';
var defaultGetContainer = void 0;
function setNotificationConfig(options) {
    var duration = options.duration,
        placement = options.placement,
        bottom = options.bottom,
        top = options.top,
        getContainer = options.getContainer;

    if (duration !== undefined) {
        defaultDuration = duration;
    }
    if (placement !== undefined) {
        defaultPlacement = placement;
    }
    if (bottom !== undefined) {
        defaultBottom = bottom;
    }
    if (top !== undefined) {
        defaultTop = top;
    }
    if (getContainer !== undefined) {
        defaultGetContainer = getContainer;
    }
}
function getPlacementStyle(placement) {
    var style = void 0;
    switch (placement) {
        case 'topLeft':
            style = {
                left: 0,
                top: defaultTop,
                bottom: 'auto'
            };
            break;
        case 'topRight':
            style = {
                right: 0,
                top: defaultTop,
                bottom: 'auto'
            };
            break;
        case 'bottomLeft':
            style = {
                left: 0,
                top: 'auto',
                bottom: defaultBottom
            };
            break;
        default:
            style = {
                right: 0,
                top: 'auto',
                bottom: defaultBottom
            };
            break;
    }
    return style;
}
function getNotificationInstance(prefixCls, placement, callback) {
    var cacheKey = prefixCls + '-' + placement;
    if (notificationInstance[cacheKey]) {
        callback(notificationInstance[cacheKey]);
        return;
    }
    _rcNotification2['default'].newInstance({
        prefixCls: prefixCls,
        className: prefixCls + '-' + placement,
        style: getPlacementStyle(placement),
        getContainer: defaultGetContainer
    }, function (notification) {
        notificationInstance[cacheKey] = notification;
        callback(notification);
    });
}
var typeToIcon = {
    success: 'check-circle-o',
    info: 'info-circle-o',
    error: 'cross-circle-o',
    warning: 'exclamation-circle-o'
};
function notice(args) {
    var outerPrefixCls = args.prefixCls || 'ant-notification';
    var prefixCls = outerPrefixCls + '-notice';
    var duration = args.duration === undefined ? defaultDuration : args.duration;
    var iconNode = null;
    if (args.icon) {
        iconNode = React.createElement(
            'span',
            { className: prefixCls + '-icon' },
            args.icon
        );
    } else if (args.type) {
        var iconType = typeToIcon[args.type];
        iconNode = React.createElement(_icon2['default'], { className: prefixCls + '-icon ' + prefixCls + '-icon-' + args.type, type: iconType });
    }
    var autoMarginTag = !args.description && iconNode ? React.createElement('span', { className: prefixCls + '-message-single-line-auto-margin' }) : null;
    getNotificationInstance(outerPrefixCls, args.placement || defaultPlacement, function (notification) {
        notification.notice({
            content: React.createElement(
                'div',
                { className: iconNode ? prefixCls + '-with-icon' : '' },
                iconNode,
                React.createElement(
                    'div',
                    { className: prefixCls + '-message' },
                    autoMarginTag,
                    args.message
                ),
                React.createElement(
                    'div',
                    { className: prefixCls + '-description' },
                    args.description
                ),
                args.btn ? React.createElement(
                    'span',
                    { className: prefixCls + '-btn' },
                    args.btn
                ) : null
            ),
            duration: duration,
            closable: true,
            onClose: args.onClose,
            key: args.key,
            style: args.style || {},
            className: args.className
        });
    });
}
var api = {
    open: notice,
    close: function close(key) {
        Object.keys(notificationInstance).forEach(function (cacheKey) {
            return notificationInstance[cacheKey].removeNotice(key);
        });
    },

    config: setNotificationConfig,
    destroy: function destroy() {
        Object.keys(notificationInstance).forEach(function (cacheKey) {
            notificationInstance[cacheKey].destroy();
            delete notificationInstance[cacheKey];
        });
    }
};
['success', 'info', 'warning', 'error'].forEach(function (type) {
    api[type] = function (args) {
        return api.open((0, _extends3['default'])({}, args, { type: type }));
    };
});
api.warn = api.warning;
exports['default'] = api;
module.exports = exports['default'];

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(274);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(275);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(30);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(172);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(629);

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Breadcrumb = __webpack_require__(630);

var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);

var _BreadcrumbItem = __webpack_require__(281);

var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Breadcrumb2['default'].Item = _BreadcrumbItem2['default'];
exports['default'] = _Breadcrumb2['default'];
module.exports = exports['default'];

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function addEventListenerWrap(target, eventType, cb) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback);
}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(664)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(680);

__webpack_require__(681);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _typeof2 = __webpack_require__(38);

var _typeof3 = _interopRequireDefault(_typeof2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _addEventListener = __webpack_require__(181);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _omit = __webpack_require__(47);

var _omit2 = _interopRequireDefault(_omit);

var _Grid = __webpack_require__(683);

var _Grid2 = _interopRequireDefault(_Grid);

var _Meta = __webpack_require__(684);

var _Meta2 = _interopRequireDefault(_Meta);

var _tabs = __webpack_require__(685);

var _tabs2 = _interopRequireDefault(_tabs);

var _row = __webpack_require__(7);

var _row2 = _interopRequireDefault(_row);

var _col = __webpack_require__(58);

var _col2 = _interopRequireDefault(_col);

var _throttleByAnimationFrame = __webpack_require__(707);

var _warning = __webpack_require__(48);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeof3["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Card = function (_React$Component) {
    (0, _inherits3["default"])(Card, _React$Component);

    function Card() {
        (0, _classCallCheck3["default"])(this, Card);

        var _this = (0, _possibleConstructorReturn3["default"])(this, (Card.__proto__ || Object.getPrototypeOf(Card)).apply(this, arguments));

        _this.state = {
            widerPadding: false
        };
        _this.updateWiderPaddingCalled = false;
        _this.onTabChange = function (key) {
            if (_this.props.onTabChange) {
                _this.props.onTabChange(key);
            }
        };
        _this.saveRef = function (node) {
            _this.container = node;
        };
        return _this;
    }

    (0, _createClass3["default"])(Card, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.updateWiderPadding();
            this.resizeEvent = (0, _addEventListener2["default"])(window, 'resize', this.updateWiderPadding);
            if ('noHovering' in this.props) {
                (0, _warning2["default"])(!this.props.noHovering, '`noHovering` of Card is deprecated, you can remove it safely or use `hoverable` instead.');
                (0, _warning2["default"])(!!this.props.noHovering, '`noHovering={false}` of Card is deprecated, use `hoverable` instead.');
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            if (this.resizeEvent) {
                this.resizeEvent.remove();
            }
            this.updateWiderPadding.cancel();
        }
    }, {
        key: "updateWiderPadding",
        value: function updateWiderPadding() {
            var _this2 = this;

            if (!this.container) {
                return;
            }
            // 936 is a magic card width pixel number indicated by designer
            var WIDTH_BOUNDARY_PX = 936;
            if (this.container.offsetWidth >= WIDTH_BOUNDARY_PX && !this.state.widerPadding) {
                this.setState({ widerPadding: true }, function () {
                    _this2.updateWiderPaddingCalled = true; // first render without css transition
                });
            }
            if (this.container.offsetWidth < WIDTH_BOUNDARY_PX && this.state.widerPadding) {
                this.setState({ widerPadding: false }, function () {
                    _this2.updateWiderPaddingCalled = true; // first render without css transition
                });
            }
        }
    }, {
        key: "isContainGrid",
        value: function isContainGrid() {
            var containGrid = void 0;
            React.Children.forEach(this.props.children, function (element) {
                if (element && element.type && element.type === _Grid2["default"]) {
                    containGrid = true;
                }
            });
            return containGrid;
        }
    }, {
        key: "getAction",
        value: function getAction(actions) {
            if (!actions || !actions.length) {
                return null;
            }
            var actionList = actions.map(function (action, index) {
                return React.createElement(
                    "li",
                    { style: { width: 100 / actions.length + "%" }, key: "action-" + index },
                    React.createElement(
                        "span",
                        null,
                        action
                    )
                );
            });
            return actionList;
        }
        // For 2.x compatible

    }, {
        key: "getCompatibleHoverable",
        value: function getCompatibleHoverable() {
            var _props = this.props,
                noHovering = _props.noHovering,
                hoverable = _props.hoverable;

            if ('noHovering' in this.props) {
                return !noHovering || hoverable;
            }
            return !!hoverable;
        }
    }, {
        key: "render",
        value: function render() {
            var _classNames;

            var _a = this.props,
                _a$prefixCls = _a.prefixCls,
                prefixCls = _a$prefixCls === undefined ? 'ant-card' : _a$prefixCls,
                className = _a.className,
                extra = _a.extra,
                _a$headStyle = _a.headStyle,
                headStyle = _a$headStyle === undefined ? {} : _a$headStyle,
                _a$bodyStyle = _a.bodyStyle,
                bodyStyle = _a$bodyStyle === undefined ? {} : _a$bodyStyle,
                noHovering = _a.noHovering,
                hoverable = _a.hoverable,
                title = _a.title,
                loading = _a.loading,
                _a$bordered = _a.bordered,
                bordered = _a$bordered === undefined ? true : _a$bordered,
                type = _a.type,
                cover = _a.cover,
                actions = _a.actions,
                tabList = _a.tabList,
                children = _a.children,
                activeTabKey = _a.activeTabKey,
                defaultActiveTabKey = _a.defaultActiveTabKey,
                others = __rest(_a, ["prefixCls", "className", "extra", "headStyle", "bodyStyle", "noHovering", "hoverable", "title", "loading", "bordered", "type", "cover", "actions", "tabList", "children", "activeTabKey", "defaultActiveTabKey"]);
            var classString = (0, _classnames2["default"])(prefixCls, className, (_classNames = {}, (0, _defineProperty3["default"])(_classNames, prefixCls + "-loading", loading), (0, _defineProperty3["default"])(_classNames, prefixCls + "-bordered", bordered), (0, _defineProperty3["default"])(_classNames, prefixCls + "-hoverable", this.getCompatibleHoverable()), (0, _defineProperty3["default"])(_classNames, prefixCls + "-wider-padding", this.state.widerPadding), (0, _defineProperty3["default"])(_classNames, prefixCls + "-padding-transition", this.updateWiderPaddingCalled), (0, _defineProperty3["default"])(_classNames, prefixCls + "-contain-grid", this.isContainGrid()), (0, _defineProperty3["default"])(_classNames, prefixCls + "-contain-tabs", tabList && tabList.length), (0, _defineProperty3["default"])(_classNames, prefixCls + "-type-" + type, !!type), _classNames));
            var loadingBlockStyle = bodyStyle.padding === 0 || bodyStyle.padding === '0px' ? { padding: 24 } : undefined;
            var loadingBlock = React.createElement(
                "div",
                { className: prefixCls + "-loading-content", style: loadingBlockStyle },
                React.createElement(
                    _row2["default"],
                    { gutter: 8 },
                    React.createElement(
                        _col2["default"],
                        { span: 22 },
                        React.createElement("div", { className: prefixCls + "-loading-block" })
                    )
                ),
                React.createElement(
                    _row2["default"],
                    { gutter: 8 },
                    React.createElement(
                        _col2["default"],
                        { span: 8 },
                        React.createElement("div", { className: prefixCls + "-loading-block" })
                    ),
                    React.createElement(
                        _col2["default"],
                        { span: 15 },
                        React.createElement("div", { className: prefixCls + "-loading-block" })
                    )
                ),
                React.createElement(
                    _row2["default"],
                    { gutter: 8 },
                    React.createElement(
                        _col2["default"],
                        { span: 6 },
                        React.createElement("div", { className: prefixCls + "-loading-block" })
                    ),
                    React.createElement(
                        _col2["default"],
                        { span: 18 },
                        React.createElement("div", { className: prefixCls + "-loading-block" })
                    )
                ),
                React.createElement(
                    _row2["default"],
                    { gutter: 8 },
                    React.createElement(
                        _col2["default"],
                        { span: 13 },
                        React.createElement("div", { className: prefixCls + "-loading-block" })
                    ),
                    React.createElement(
                        _col2["default"],
                        { span: 9 },
                        React.createElement("div", { className: prefixCls + "-loading-block" })
                    )
                ),
                React.createElement(
                    _row2["default"],
                    { gutter: 8 },
                    React.createElement(
                        _col2["default"],
                        { span: 4 },
                        React.createElement("div", { className: prefixCls + "-loading-block" })
                    ),
                    React.createElement(
                        _col2["default"],
                        { span: 3 },
                        React.createElement("div", { className: prefixCls + "-loading-block" })
                    ),
                    React.createElement(
                        _col2["default"],
                        { span: 16 },
                        React.createElement("div", { className: prefixCls + "-loading-block" })
                    )
                ),
                React.createElement(
                    _row2["default"],
                    { gutter: 8 },
                    React.createElement(
                        _col2["default"],
                        { span: 8 },
                        React.createElement("div", { className: prefixCls + "-loading-block" })
                    ),
                    React.createElement(
                        _col2["default"],
                        { span: 6 },
                        React.createElement("div", { className: prefixCls + "-loading-block" })
                    ),
                    React.createElement(
                        _col2["default"],
                        { span: 8 },
                        React.createElement("div", { className: prefixCls + "-loading-block" })
                    )
                )
            );
            var hasActiveTabKey = activeTabKey !== undefined;
            var extraProps = (0, _defineProperty3["default"])({}, hasActiveTabKey ? 'activeKey' : 'defaultActiveKey', hasActiveTabKey ? activeTabKey : defaultActiveTabKey);
            var head = void 0;
            var tabs = tabList && tabList.length ? React.createElement(
                _tabs2["default"],
                (0, _extends3["default"])({}, extraProps, { className: prefixCls + "-head-tabs", size: "large", onChange: this.onTabChange }),
                tabList.map(function (item) {
                    return React.createElement(_tabs2["default"].TabPane, { tab: item.tab, disabled: item.disabled, key: item.key });
                })
            ) : null;
            if (title || extra || tabs) {
                head = React.createElement(
                    "div",
                    { className: prefixCls + "-head", style: headStyle },
                    React.createElement(
                        "div",
                        { className: prefixCls + "-head-wrapper" },
                        title && React.createElement(
                            "div",
                            { className: prefixCls + "-head-title" },
                            title
                        ),
                        extra && React.createElement(
                            "div",
                            { className: prefixCls + "-extra" },
                            extra
                        )
                    ),
                    tabs
                );
            }
            var coverDom = cover ? React.createElement(
                "div",
                { className: prefixCls + "-cover" },
                cover
            ) : null;
            var body = React.createElement(
                "div",
                { className: prefixCls + "-body", style: bodyStyle },
                loading ? loadingBlock : children
            );
            var actionDom = actions && actions.length ? React.createElement(
                "ul",
                { className: prefixCls + "-actions" },
                this.getAction(actions)
            ) : null;
            var divProps = (0, _omit2["default"])(others, ['onTabChange']);
            return React.createElement(
                "div",
                (0, _extends3["default"])({}, divProps, { className: classString, ref: this.saveRef }),
                head,
                coverDom,
                body,
                actionDom
            );
        }
    }]);
    return Card;
}(React.Component);

exports["default"] = Card;

Card.Grid = _Grid2["default"];
Card.Meta = _Meta2["default"];
__decorate([(0, _throttleByAnimationFrame.throttleByAnimationFrameDecorator)()], Card.prototype, "updateWiderPadding", null);
module.exports = exports["default"];

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = addEventListenerWrap;

var _addDomEventListener = __webpack_require__(286);

var _addDomEventListener2 = _interopRequireDefault(_addDomEventListener);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function addEventListenerWrap(target, eventType, cb) {
  /* eslint camelcase: 2 */
  var callback = _reactDom2['default'].unstable_batchedUpdates ? function run(e) {
    _reactDom2['default'].unstable_batchedUpdates(cb, e);
  } : cb;
  return (0, _addDomEventListener2['default'])(target, eventType, callback);
}
module.exports = exports['default'];

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toArray */
/* harmony export (immutable) */ __webpack_exports__["a"] = getActiveIndex;
/* unused harmony export getActiveKey */
/* unused harmony export setTransform */
/* unused harmony export isTransformSupported */
/* unused harmony export setTransition */
/* harmony export (immutable) */ __webpack_exports__["e"] = getTransformPropValue;
/* unused harmony export isVertical */
/* harmony export (immutable) */ __webpack_exports__["d"] = getTransformByIndex;
/* harmony export (immutable) */ __webpack_exports__["c"] = getMarginStyle;
/* unused harmony export getStyle */
/* unused harmony export setPxStyle */
/* harmony export (immutable) */ __webpack_exports__["b"] = getDataAttr;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



function toArray(children) {
  // allow [c,[a,b]]
  var c = [];
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(children, function (child) {
    if (child) {
      c.push(child);
    }
  });
  return c;
}

function getActiveIndex(children, activeKey) {
  var c = toArray(children);
  for (var i = 0; i < c.length; i++) {
    if (c[i].key === activeKey) {
      return i;
    }
  }
  return -1;
}

function getActiveKey(children, index) {
  var c = toArray(children);
  return c[index].key;
}

function setTransform(style, v) {
  style.transform = v;
  style.webkitTransform = v;
  style.mozTransform = v;
}

function isTransformSupported(style) {
  return 'transform' in style || 'webkitTransform' in style || 'MozTransform' in style;
}

function setTransition(style, v) {
  style.transition = v;
  style.webkitTransition = v;
  style.MozTransition = v;
}
function getTransformPropValue(v) {
  return {
    transform: v,
    WebkitTransform: v,
    MozTransform: v
  };
}

function isVertical(tabBarPosition) {
  return tabBarPosition === 'left' || tabBarPosition === 'right';
}

function getTransformByIndex(index, tabBarPosition) {
  var translate = isVertical(tabBarPosition) ? 'translateY' : 'translateX';
  return translate + '(' + -index * 100 + '%) translateZ(0)';
}

function getMarginStyle(index, tabBarPosition) {
  var marginDirection = isVertical(tabBarPosition) ? 'marginTop' : 'marginLeft';
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, marginDirection, -index * 100 + '%');
}

function getStyle(el, property) {
  return +getComputedStyle(el).getPropertyValue(property).replace('px', '');
}

function setPxStyle(el, value, vertical) {
  value = vertical ? '0px, ' + value + 'px, 0px' : value + 'px, 0px, 0px';
  setTransform(el.style, 'translate3d(' + value + ')');
}

function getDataAttr(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
      prev[key] = props[key];
    }
    return prev;
  }, {});
}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(713);

__webpack_require__(22);

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(714);

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(734),
    getValue = __webpack_require__(740);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(93),
    isObject = __webpack_require__(70);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(82);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(308);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(186),
    isLength = __webpack_require__(312);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(93),
    isObjectLike = __webpack_require__(83);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["t"] = toTitle;
/* harmony export (immutable) */ __webpack_exports__["j"] = getValuePropValue;
/* harmony export (immutable) */ __webpack_exports__["h"] = getPropValue;
/* unused harmony export isMultiple */
/* harmony export (immutable) */ __webpack_exports__["l"] = isCombobox;
/* harmony export (immutable) */ __webpack_exports__["m"] = isMultipleOrTags;
/* harmony export (immutable) */ __webpack_exports__["n"] = isMultipleOrTagsOrCombobox;
/* harmony export (immutable) */ __webpack_exports__["o"] = isSingleMode;
/* harmony export (immutable) */ __webpack_exports__["s"] = toArray;
/* harmony export (immutable) */ __webpack_exports__["g"] = getMapKey;
/* harmony export (immutable) */ __webpack_exports__["p"] = preventDefaultEvent;
/* harmony export (immutable) */ __webpack_exports__["e"] = findIndexInValueBySingleValue;
/* harmony export (immutable) */ __webpack_exports__["f"] = getLabelFromPropsValue;
/* harmony export (immutable) */ __webpack_exports__["i"] = getSelectKeys;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UNSELECTABLE_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UNSELECTABLE_ATTRIBUTE; });
/* harmony export (immutable) */ __webpack_exports__["d"] = findFirstMenuItem;
/* harmony export (immutable) */ __webpack_exports__["k"] = includesSeparators;
/* harmony export (immutable) */ __webpack_exports__["r"] = splitBySeparators;
/* harmony export (immutable) */ __webpack_exports__["c"] = defaultFilterFn;
/* harmony export (immutable) */ __webpack_exports__["u"] = validateOptionValue;
/* harmony export (immutable) */ __webpack_exports__["q"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toTitle(title) {
  if (typeof title === 'string') {
    return title;
  }
  return null;
}

function getValuePropValue(child) {
  if (!child) {
    return null;
  }

  var props = child.props;
  if ('value' in props) {
    return props.value;
  }
  if (child.key) {
    return child.key;
  }
  if (child.type && child.type.isSelectOptGroup && props.label) {
    return props.label;
  }
  throw new Error('Need at least a key or a value or a label (only for OptGroup) for ' + child);
}

function getPropValue(child, prop) {
  if (prop === 'value') {
    return getValuePropValue(child);
  }
  return child.props[prop];
}

function isMultiple(props) {
  return props.multiple;
}

function isCombobox(props) {
  return props.combobox;
}

function isMultipleOrTags(props) {
  return props.multiple || props.tags;
}

function isMultipleOrTagsOrCombobox(props) {
  return isMultipleOrTags(props) || isCombobox(props);
}

function isSingleMode(props) {
  return !isMultipleOrTagsOrCombobox(props);
}

function toArray(value) {
  var ret = value;
  if (value === undefined) {
    ret = [];
  } else if (!Array.isArray(value)) {
    ret = [value];
  }
  return ret;
}

function getMapKey(value) {
  return typeof value + '-' + value;
}

function preventDefaultEvent(e) {
  e.preventDefault();
}

function findIndexInValueBySingleValue(value, singleValue) {
  var index = -1;
  for (var i = 0; i < value.length; i++) {
    if (value[i] === singleValue) {
      index = i;
      break;
    }
  }
  return index;
}

function getLabelFromPropsValue(value, key) {
  var label = void 0;
  value = toArray(value);
  for (var i = 0; i < value.length; i++) {
    if (value[i].key === key) {
      label = value[i].label;
      break;
    }
  }
  return label;
}

function getSelectKeys(menuItems, value) {
  if (value === null || value === undefined) {
    return [];
  }
  var selectedKeys = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(menuItems, function (item) {
    if (item.type.isMenuItemGroup) {
      selectedKeys = selectedKeys.concat(getSelectKeys(item.props.children, value));
    } else {
      var itemValue = getValuePropValue(item);
      var itemKey = item.key;
      if (findIndexInValueBySingleValue(value, itemValue) !== -1 && itemKey) {
        selectedKeys.push(itemKey);
      }
    }
  });
  return selectedKeys;
}

var UNSELECTABLE_STYLE = {
  userSelect: 'none',
  WebkitUserSelect: 'none'
};

var UNSELECTABLE_ATTRIBUTE = {
  unselectable: 'on'
};

function findFirstMenuItem(children) {
  for (var i = 0; i < children.length; i++) {
    var child = children[i];
    if (child.type.isMenuItemGroup) {
      var found = findFirstMenuItem(child.props.children);
      if (found) {
        return found;
      }
    } else if (!child.props.disabled) {
      return child;
    }
  }
  return null;
}

function includesSeparators(string, separators) {
  for (var i = 0; i < separators.length; ++i) {
    if (string.lastIndexOf(separators[i]) > 0) {
      return true;
    }
  }
  return false;
}

function splitBySeparators(string, separators) {
  var reg = new RegExp('[' + separators.join() + ']');
  return string.split(reg).filter(function (token) {
    return token;
  });
}

function defaultFilterFn(input, child) {
  if (child.props.disabled) {
    return false;
  }
  var value = toArray(getPropValue(child, this.props.optionFilterProp)).join('');
  return value.toLowerCase().indexOf(input.toLowerCase()) > -1;
}

function validateOptionValue(value, props) {
  if (isSingleMode(props) || isMultiple(props)) {
    return;
  }
  if (typeof value !== 'string') {
    throw new Error('Invalid `value` of type `' + typeof value + '` supplied to Option, ' + 'expected `string` when `tags/combobox` is `true`.');
  }
}

function saveRef(instance, name) {
  return function (node) {
    instance[name] = node;
  };
}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _rcAnimate = __webpack_require__(50);

var _rcAnimate2 = _interopRequireDefault(_rcAnimate);

var _omit = __webpack_require__(47);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

// Render indicator
var defaultIndicator = null;
function renderIndicator(props) {
    var prefixCls = props.prefixCls,
        indicator = props.indicator;

    var dotClassName = prefixCls + '-dot';
    if (React.isValidElement(indicator)) {
        return React.cloneElement(indicator, {
            className: (0, _classnames2['default'])(indicator.props.className, dotClassName)
        });
    }
    if (React.isValidElement(defaultIndicator)) {
        return React.cloneElement(defaultIndicator, {
            className: (0, _classnames2['default'])(defaultIndicator.props.className, dotClassName)
        });
    }
    return React.createElement(
        'span',
        { className: (0, _classnames2['default'])(dotClassName, prefixCls + '-dot-spin') },
        React.createElement('i', null),
        React.createElement('i', null),
        React.createElement('i', null),
        React.createElement('i', null)
    );
}

var Spin = function (_React$Component) {
    (0, _inherits3['default'])(Spin, _React$Component);

    function Spin(props) {
        (0, _classCallCheck3['default'])(this, Spin);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Spin.__proto__ || Object.getPrototypeOf(Spin)).call(this, props));

        var spinning = props.spinning;
        _this.state = {
            spinning: spinning
        };
        return _this;
    }

    (0, _createClass3['default'])(Spin, [{
        key: 'isNestedPattern',
        value: function isNestedPattern() {
            return !!(this.props && this.props.children);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var _props = this.props,
                spinning = _props.spinning,
                delay = _props.delay;

            if (spinning && delay && !isNaN(Number(delay))) {
                this.setState({ spinning: false });
                this.delayTimeout = window.setTimeout(function () {
                    return _this2.setState({ spinning: spinning });
                }, delay);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
            }
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this3 = this;

            var currentSpinning = this.props.spinning;
            var spinning = nextProps.spinning;
            var delay = this.props.delay;

            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
            }
            if (currentSpinning && !spinning) {
                this.debounceTimeout = window.setTimeout(function () {
                    return _this3.setState({ spinning: spinning });
                }, 200);
                if (this.delayTimeout) {
                    clearTimeout(this.delayTimeout);
                }
            } else {
                if (spinning && delay && !isNaN(Number(delay))) {
                    if (this.delayTimeout) {
                        clearTimeout(this.delayTimeout);
                    }
                    this.delayTimeout = window.setTimeout(function () {
                        return _this3.setState({ spinning: spinning });
                    }, delay);
                } else {
                    this.setState({ spinning: spinning });
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                className = _a.className,
                size = _a.size,
                prefixCls = _a.prefixCls,
                tip = _a.tip,
                wrapperClassName = _a.wrapperClassName,
                restProps = __rest(_a, ["className", "size", "prefixCls", "tip", "wrapperClassName"]);var spinning = this.state.spinning;

            var spinClassName = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', size === 'small'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-spinning', spinning), (0, _defineProperty3['default'])(_classNames, prefixCls + '-show-text', !!tip), _classNames), className);
            // fix https://fb.me/react-unknown-prop
            var divProps = (0, _omit2['default'])(restProps, ['spinning', 'delay', 'indicator']);
            var spinElement = React.createElement(
                'div',
                (0, _extends3['default'])({}, divProps, { className: spinClassName }),
                renderIndicator(this.props),
                tip ? React.createElement(
                    'div',
                    { className: prefixCls + '-text' },
                    tip
                ) : null
            );
            if (this.isNestedPattern()) {
                var _classNames2;

                var animateClassName = prefixCls + '-nested-loading';
                if (wrapperClassName) {
                    animateClassName += ' ' + wrapperClassName;
                }
                var containerClassName = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-container', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-blur', spinning), _classNames2));
                return React.createElement(
                    _rcAnimate2['default'],
                    (0, _extends3['default'])({}, divProps, { component: 'div', className: animateClassName, style: null, transitionName: 'fade' }),
                    spinning && React.createElement(
                        'div',
                        { key: 'loading' },
                        spinElement
                    ),
                    React.createElement(
                        'div',
                        { className: containerClassName, key: 'container' },
                        this.props.children
                    )
                );
            }
            return spinElement;
        }
    }], [{
        key: 'setDefaultIndicator',
        value: function setDefaultIndicator(indicator) {
            defaultIndicator = indicator;
        }
    }]);
    return Spin;
}(React.Component);

Spin.defaultProps = {
    prefixCls: 'ant-spin',
    spinning: true,
    size: 'default',
    wrapperClassName: ''
};
Spin.propTypes = {
    prefixCls: _propTypes2['default'].string,
    className: _propTypes2['default'].string,
    spinning: _propTypes2['default'].bool,
    size: _propTypes2['default'].oneOf(['small', 'default', 'large']),
    wrapperClassName: _propTypes2['default'].string,
    indicator: _propTypes2['default'].node
};
exports['default'] = Spin;
module.exports = exports['default'];

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rcCheckbox = __webpack_require__(327);

var _rcCheckbox2 = _interopRequireDefault(_rcCheckbox);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _shallowequal = __webpack_require__(52);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Radio = function (_React$Component) {
    (0, _inherits3['default'])(Radio, _React$Component);

    function Radio() {
        (0, _classCallCheck3['default'])(this, Radio);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));

        _this.saveCheckbox = function (node) {
            _this.rcCheckbox = node;
        };
        return _this;
    }

    (0, _createClass3['default'])(Radio, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
            return !(0, _shallowequal2['default'])(this.props, nextProps) || !(0, _shallowequal2['default'])(this.state, nextState) || !(0, _shallowequal2['default'])(this.context.radioGroup, nextContext.radioGroup);
        }
    }, {
        key: 'focus',
        value: function focus() {
            this.rcCheckbox.focus();
        }
    }, {
        key: 'blur',
        value: function blur() {
            this.rcCheckbox.blur();
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var props = this.props,
                context = this.context;

            var prefixCls = props.prefixCls,
                className = props.className,
                children = props.children,
                style = props.style,
                restProps = __rest(props, ["prefixCls", "className", "children", "style"]);

            var radioGroup = context.radioGroup;

            var radioProps = (0, _extends3['default'])({}, restProps);
            if (radioGroup) {
                radioProps.name = radioGroup.name;
                radioProps.onChange = radioGroup.onChange;
                radioProps.checked = props.value === radioGroup.value;
                radioProps.disabled = props.disabled || radioGroup.disabled;
            }
            var wrapperClassString = (0, _classnames2['default'])(className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrapper', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrapper-checked', radioProps.checked), (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrapper-disabled', radioProps.disabled), _classNames));
            return React.createElement(
                'label',
                { className: wrapperClassString, style: style, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave },
                React.createElement(_rcCheckbox2['default'], (0, _extends3['default'])({}, radioProps, { prefixCls: prefixCls, ref: this.saveCheckbox })),
                children !== undefined ? React.createElement(
                    'span',
                    null,
                    children
                ) : null
            );
        }
    }]);
    return Radio;
}(React.Component);

exports['default'] = Radio;

Radio.defaultProps = {
    prefixCls: 'ant-radio',
    type: 'radio'
};
Radio.contextTypes = {
    radioGroup: _propTypes2['default'].any
};
module.exports = exports['default'];

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getClientJobs;
/* harmony export (immutable) */ __webpack_exports__["c"] = getJobUuid;
/* unused harmony export getTechJobs */
/* harmony export (immutable) */ __webpack_exports__["e"] = getTechJobs2;
/* harmony export (immutable) */ __webpack_exports__["d"] = getLinks;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteJob;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__switch_api__ = __webpack_require__(25);
function getClientJobs(){var token=localStorage.getItem('token');return function(dispatch){fetch(Object(__WEBPACK_IMPORTED_MODULE_1__switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_0__config__["h" /* API_GET_MY_JOB */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_MY_JOB }: "+response.statusText);}return response;}).then(function(response){return response.json();}).then(function(json){return dispatch({type:'GET_JOBS',json:json});}).catch(function(e){// dispatch(userLoggedInFailure('' + e))
});};}function getJobUuid(uuid){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_1__switch_api__["a" /* switch_api */])(Object(__WEBPACK_IMPORTED_MODULE_0__config__["g" /* API_GET_JOB_FOR_TECH_UUID */])(uuid)),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_JOB_FOR_TECH_UUID }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'GET_JOB', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}function getTechJobs(){var token=localStorage.getItem('token');return function(dispatch){fetch(Object(__WEBPACK_IMPORTED_MODULE_1__switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_0__config__["i" /* API_GET_MY_JOB_PAG */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_JOB_FOR_TECH }: "+response.statusText);}return response;}).then(function(response){return response.json();}).then(function(jobs){localStorage.setItem('techJobs',JSON.stringify(jobs));return jobs;}).then(function(json){return dispatch({type:'GET_JOBS',json:json});}).catch(function(e){// dispatch(userLoggedInFailure('' + e))
});};}function getTechJobs2(date_from,date_to){var token=localStorage.getItem('token');return function(dispatch){fetch(Object(__WEBPACK_IMPORTED_MODULE_1__switch_api__["a" /* switch_api */])(Object(__WEBPACK_IMPORTED_MODULE_0__config__["j" /* API_GET_MY_JOB_PAG2 */])(date_from,date_to)),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_JOB_FOR_TECH }: "+response.statusText);}return response;}).then(function(response){return response.json();}).then(function(jobs){localStorage.setItem('techJobs',JSON.stringify(jobs));return jobs;}).then(function(json){return dispatch({type:'GET_JOBS',json:json});}).catch(function(e){// dispatch(userLoggedInFailure('' + e))
});};}function getLinks(uuid){var token=localStorage.getItem('token');return function(dispatch){fetch(Object(__WEBPACK_IMPORTED_MODULE_1__switch_api__["a" /* switch_api */])(Object(__WEBPACK_IMPORTED_MODULE_0__config__["n" /* API_LINKS_FOR_JOB */])(uuid)),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_LINKS_FOR_JOB }: "+response.statusText);dispatch({type:'NO_LINKS'});}return response;}).then(function(response){return response.json();}).then(function(json){return dispatch({type:'GET_LINKS',json:json});}).catch(function(e){// dispatch(userLoggedInFailure('' + e))
});};}function deleteJob(uuid){var token=localStorage.getItem('token');return function(dispatch){fetch(Object(__WEBPACK_IMPORTED_MODULE_1__switch_api__["a" /* switch_api */])(Object(__WEBPACK_IMPORTED_MODULE_0__config__["e" /* API_DELETE_JOB */])(uuid)),{method:'DELETE',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed deleting { API_DELETE_JOB }: "+response.statusText);dispatch(getTechJobs());}return response;}).then(function(){return dispatch(getTechJobs());}).catch(function(e){// dispatch(userLoggedInFailure('' + e))
});};}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */

var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12, // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33, // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34, // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35, // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36, // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37, // also NUM_WEST
  /**
   * UP
   */
  UP: 38, // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39, // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40, // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45, // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46, // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63, // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91, // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186, // needs localization
  /**
   * DASH
   */
  DASH: 189, // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187, // needs localization
  /**
   * COMMA
   */
  COMMA: 188, // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190, // needs localization
  /**
   * SLASH
   */
  SLASH: 191, // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192, // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222, // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219, // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220, // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221, // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224, // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229
};

/*
 whether text and modified key is entered at the same time.
 */
KeyCode.isTextModifyingKeyEvent = function isTextModifyingKeyEvent(e) {
  var keyCode = e.keyCode;
  if (e.altKey && !e.ctrlKey || e.metaKey ||
  // Function keys don't generate text
  keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
    return false;
  }

  // The following keys are quite harmless, even in combination with
  // CTRL, ALT or SHIFT.
  switch (keyCode) {
    case KeyCode.ALT:
    case KeyCode.CAPS_LOCK:
    case KeyCode.CONTEXT_MENU:
    case KeyCode.CTRL:
    case KeyCode.DOWN:
    case KeyCode.END:
    case KeyCode.ESC:
    case KeyCode.HOME:
    case KeyCode.INSERT:
    case KeyCode.LEFT:
    case KeyCode.MAC_FF_META:
    case KeyCode.META:
    case KeyCode.NUMLOCK:
    case KeyCode.NUM_CENTER:
    case KeyCode.PAGE_DOWN:
    case KeyCode.PAGE_UP:
    case KeyCode.PAUSE:
    case KeyCode.PRINT_SCREEN:
    case KeyCode.RIGHT:
    case KeyCode.SHIFT:
    case KeyCode.UP:
    case KeyCode.WIN_KEY:
    case KeyCode.WIN_KEY_RIGHT:
      return false;
    default:
      return true;
  }
};

/*
 whether character is entered.
 */
KeyCode.isCharacterKey = function isCharacterKey(keyCode) {
  if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
    return true;
  }

  if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
    return true;
  }

  if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
    return true;
  }

  // Safari sends zero key code for non-latin characters.
  if (window.navigation.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
    return true;
  }

  switch (keyCode) {
    case KeyCode.SPACE:
    case KeyCode.QUESTION_MARK:
    case KeyCode.NUM_PLUS:
    case KeyCode.NUM_MINUS:
    case KeyCode.NUM_PERIOD:
    case KeyCode.NUM_DIVISION:
    case KeyCode.SEMICOLON:
    case KeyCode.DASH:
    case KeyCode.EQUALS:
    case KeyCode.COMMA:
    case KeyCode.PERIOD:
    case KeyCode.SLASH:
    case KeyCode.APOSTROPHE:
    case KeyCode.SINGLE_QUOTE:
    case KeyCode.OPEN_SQUARE_BRACKET:
    case KeyCode.BACKSLASH:
    case KeyCode.CLOSE_SQUARE_BRACKET:
      return true;
    default:
      return false;
  }
};

exports['default'] = KeyCode;
module.exports = exports['default'];

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _createReactClass = __webpack_require__(36);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createChainedFunction = __webpack_require__(888);

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

var _KeyCode = __webpack_require__(195);

var _KeyCode2 = _interopRequireDefault(_KeyCode);

var _placements = __webpack_require__(889);

var _placements2 = _interopRequireDefault(_placements);

var _rcTrigger = __webpack_require__(81);

var _rcTrigger2 = _interopRequireDefault(_rcTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

function refFn(field, component) {
  this[field] = component;
}

var Picker = (0, _createReactClass2['default'])({
  displayName: 'Picker',

  propTypes: {
    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].string]),
    disabled: _propTypes2['default'].bool,
    transitionName: _propTypes2['default'].string,
    onChange: _propTypes2['default'].func,
    onOpenChange: _propTypes2['default'].func,
    children: _propTypes2['default'].func,
    getCalendarContainer: _propTypes2['default'].func,
    calendar: _propTypes2['default'].element,
    style: _propTypes2['default'].object,
    open: _propTypes2['default'].bool,
    defaultOpen: _propTypes2['default'].bool,
    prefixCls: _propTypes2['default'].string,
    placement: _propTypes2['default'].any,
    value: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]),
    defaultValue: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]),
    align: _propTypes2['default'].object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      prefixCls: 'rc-calendar-picker',
      style: {},
      align: {},
      placement: 'bottomLeft',
      defaultOpen: false,
      onChange: noop,
      onOpenChange: noop
    };
  },
  getInitialState: function getInitialState() {
    var props = this.props;
    var open = void 0;
    if ('open' in props) {
      open = props.open;
    } else {
      open = props.defaultOpen;
    }
    var value = props.value || props.defaultValue;
    this.saveCalendarRef = refFn.bind(this, 'calendarInstance');
    return {
      open: open,
      value: value
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var value = nextProps.value,
        open = nextProps.open;

    if ('value' in nextProps) {
      this.setState({
        value: value
      });
    }
    if (open !== undefined) {
      this.setState({
        open: open
      });
    }
  },
  componentDidUpdate: function componentDidUpdate(_, prevState) {
    if (!prevState.open && this.state.open) {
      // setTimeout is for making sure saveCalendarRef happen before focusCalendar
      this.focusTimeout = setTimeout(this.focusCalendar, 0, this);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    clearTimeout(this.focusTimeout);
  },
  onCalendarKeyDown: function onCalendarKeyDown(event) {
    if (event.keyCode === _KeyCode2['default'].ESC) {
      event.stopPropagation();
      this.close(this.focus);
    }
  },
  onCalendarSelect: function onCalendarSelect(value) {
    var cause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var props = this.props;
    if (!('value' in props)) {
      this.setState({
        value: value
      });
    }
    if (cause.source === 'keyboard' || !props.calendar.props.timePicker && cause.source !== 'dateInput' || cause.source === 'todayButton') {
      this.close(this.focus);
    }
    props.onChange(value);
  },
  onKeyDown: function onKeyDown(event) {
    if (event.keyCode === _KeyCode2['default'].DOWN && !this.state.open) {
      this.open();
      event.preventDefault();
    }
  },
  onCalendarOk: function onCalendarOk() {
    this.close(this.focus);
  },
  onCalendarClear: function onCalendarClear() {
    this.close(this.focus);
  },
  onVisibleChange: function onVisibleChange(open) {
    this.setOpen(open);
  },
  getCalendarElement: function getCalendarElement() {
    var props = this.props;
    var state = this.state;
    var calendarProps = props.calendar.props;
    var value = state.value;

    var defaultValue = value;
    var extraProps = {
      ref: this.saveCalendarRef,
      defaultValue: defaultValue || calendarProps.defaultValue,
      selectedValue: value,
      onKeyDown: this.onCalendarKeyDown,
      onOk: (0, _createChainedFunction2['default'])(calendarProps.onOk, this.onCalendarOk),
      onSelect: (0, _createChainedFunction2['default'])(calendarProps.onSelect, this.onCalendarSelect),
      onClear: (0, _createChainedFunction2['default'])(calendarProps.onClear, this.onCalendarClear)
    };

    return _react2['default'].cloneElement(props.calendar, extraProps);
  },
  setOpen: function setOpen(open, callback) {
    var onOpenChange = this.props.onOpenChange;

    if (this.state.open !== open) {
      if (!('open' in this.props)) {
        this.setState({
          open: open
        }, callback);
      }
      onOpenChange(open);
    }
  },
  open: function open(callback) {
    this.setOpen(true, callback);
  },
  close: function close(callback) {
    this.setOpen(false, callback);
  },
  focus: function focus() {
    if (!this.state.open) {
      _reactDom2['default'].findDOMNode(this).focus();
    }
  },
  focusCalendar: function focusCalendar() {
    if (this.state.open && !!this.calendarInstance) {
      this.calendarInstance.focus();
    }
  },
  render: function render() {
    var props = this.props;
    var prefixCls = props.prefixCls,
        placement = props.placement,
        style = props.style,
        getCalendarContainer = props.getCalendarContainer,
        align = props.align,
        animation = props.animation,
        disabled = props.disabled,
        dropdownClassName = props.dropdownClassName,
        transitionName = props.transitionName,
        children = props.children;

    var state = this.state;
    return _react2['default'].createElement(
      _rcTrigger2['default'],
      {
        popup: this.getCalendarElement(),
        popupAlign: align,
        builtinPlacements: _placements2['default'],
        popupPlacement: placement,
        action: disabled && !state.open ? [] : ['click'],
        destroyPopupOnHide: true,
        getPopupContainer: getCalendarContainer,
        popupStyle: style,
        popupAnimation: animation,
        popupTransitionName: transitionName,
        popupVisible: state.open,
        onPopupVisibleChange: this.onVisibleChange,
        prefixCls: prefixCls,
        popupClassName: dropdownClassName
      },
      _react2['default'].cloneElement(children(state, props), { onKeyDown: this.onKeyDown })
    );
  }
});

exports['default'] = Picker;
module.exports = exports['default'];

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(85),
    root = __webpack_require__(55);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 198 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(954),
    mapCacheDelete = __webpack_require__(961),
    mapCacheGet = __webpack_require__(963),
    mapCacheHas = __webpack_require__(964),
    mapCacheSet = __webpack_require__(965);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 200 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(61),
    isSymbol = __webpack_require__(203);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(98),
    isObjectLike = __webpack_require__(99);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/DeepCBCT_analysis.02c86a57.svg";

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/*!
 * jquery@3.3.1 (MIT)
 *   author: JS Foundation and other contributors (https://github.com/jquery/jquery/blob/3.3.1/AUTHORS.txt)
 *   url: git+https://github.com/jquery/jquery.git
 *
 *   Copyright JS Foundation and other contributors, https://js.foundation/
 *
 *   This software consists of voluntary contributions made by many
 *   individuals. For exact contribution history, see the revision history
 *   available at https://github.com/jquery/jquery
 *
 *   The following license applies to all parts of this software except as
 *   documented below:
 *
 *   ====
 *
 *   Permission is hereby granted, free of charge, to any person obtaining
 *   a copy of this software and associated documentation files (the
 *   "Software"), to deal in the Software without restriction, including
 *   without limitation the rights to use, copy, modify, merge, publish,
 *   distribute, sublicense, and/or sell copies of the Software, and to
 *   permit persons to whom the Software is furnished to do so, subject to
 *   the following conditions:
 *
 *   The above copyright notice and this permission notice shall be
 *   included in all copies or substantial portions of the Software.
 *
 *   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 *   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 *   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 *   NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 *   LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 *   OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 *   WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 *   ====
 *
 *   All files located in the node_modules and external directories are
 *   externally maintained libraries used by this software which have their
 *   own licenses; we recommend you read them, as their terms may differ from
 *   the terms above.
 *
 *
 *
 * glkit@0.0.2065 (MIT)
 *   author: Denis Belov
 *   url: git@github.com/denis-belov/glkit
 *
 *   glkit 0.0.2065
 *
 *   The MIT License
 *
 *   Copyright © 2017-2018 Denis Belov (GLKIT developer)
 *
 *   Permission is hereby granted, free of charge, to any person obtaining a copy
 *   of this software and associated documentation files (the "Software"), to deal
 *   in the Software without restriction, including without limitation the rights
 *   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 *   copies of the Software, and to permit persons to whom the Software is
 *   furnished to do so, subject to the following conditions:
 *
 *   The above copyright notice and this permission notice shall be included in
 *   all copies or substantial portions of the Software.
 *
 *   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 *   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 *   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 *   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 *   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 *   THE SOFTWARE.
 *
 *
 * bowser@1.1.0 (MIT)
 *   author: Dustin Diaz (http://dustindiaz.com)
 *   url: git+https://github.com/ded/bowser.git
 *
 *   Copyright 2015, Dustin Diaz (the "Original Author")
 *   All rights reserved.
 *
 *   MIT License
 *
 *   Permission is hereby granted, free of charge, to any person
 *   obtaining a copy of this software and associated documentation
 *   files (the "Software"), to deal in the Software without
 *   restriction, including without limitation the rights to use,
 *   copy, modify, merge, publish, distribute, sublicense, and/or sell
 *   copies of the Software, and to permit persons to whom the
 *   Software is furnished to do so, subject to the following
 *   conditions:
 *
 *   The above copyright notice and this permission notice shall be
 *   included in all copies or substantial portions of the Software.
 *
 *   Distributions of all or part of the Software intended to be used
 *   by the recipients as they would use the unmodified Software,
 *   containing modifications that substantially alter, remove, or
 *   disable functionality of the Software, outside of the documented
 *   configuration mechanisms provided by the Software, shall be
 *   modified such that the Original Author's bug reporting email
 *   addresses and urls are either replaced with the contact information
 *   of the parties responsible for the changes, or removed entirely.
 *
 *   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 *   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 *   OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 *   NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 *   HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 *   WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 *   FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 *   OTHER DEALINGS IN THE SOFTWARE.
 *
 *
 *   Except where noted, this license applies to any and all software
 *   programs and associated documentation files created by the
 *   Original Author, when distributed with the Software.
 *
 *
 *
 */!function(t){var e={};function n(r){if(e[r])return e[r].exports;var i=e[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports;}n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r});},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0});},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==(typeof t==="undefined"?"undefined":_typeof(t))&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t){n.d(r,i,function(e){return t[e];}.bind(null,i));}return r;},n.n=function(t){var e=t&&t.__esModule?function(){return t.default;}:function(){return t;};return n.d(e,"a",e),e;},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e);},n.p="/static/",n(n.s=15);}([function(t,e,n){(function(e,n){function r(t){return function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++){n[e]=t[e];}return n;}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t);}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance");}();}t.exports={getLayers:function getLayers(t,n){try{for(var r=[],i=0;i<t.length;i++){i%2&&i!==t.length-1?n.indexOf(t[i+1])>-1?r.push(t[i],t[i],t[i]):r.push(t[i],t[i],t[i+1]):r.push(t[i]);}return r.push(r[r.length-1]),r;}catch(t){(e||function(){return 0;})(t,"getLayers");}},getTriangles:function getTriangles(t,n){try{for(var r=new Array(t.length),i=0;i<n.length;i++){r.fill(n[i],t.indexOf(n[i]));}return r;}catch(t){(e||function(){return 0;})(t,"getTriangles");}},getLayersLocks:function getLayersLocks(t){try{for(var n=[],r=0;r<t.length;r++){r%2&&r!==t.length-1?n.push(t[r],t[r],t[r]):n.push(t[r]);}return n.push(n[n.length-1]),n;}catch(t){(e||function(){return 0;})(t,"getLayersLocks");}},getTrianglesLocks:function getTrianglesLocks(t,n){try{for(var r=new Array(t.length),i=0;i<n.length;i+=2){t.indexOf(n[i])>-1&&r.fill(n[i],t.indexOf(n[i]));}return r;}catch(t){(e||function(){return 0;})(t,"getTrianglesLocks");}},hex:function hex(t,e){return new t.DataFloat3({name:"uColor",x:parseInt("0x".concat(e[0]).concat(e[1]),16)/255,y:parseInt("0x".concat(e[2]).concat(e[3]),16)/255,z:parseInt("0x".concat(e[4]).concat(e[5]),16)/255});},extArr:function extArr(t){return r(t).concat([t.slice().pop()]);},setFinalCSS:function setFinalCSS(t,e){n(e.canvas).css({position:"fixed",zIndex:0}),n(".ortho-loader").find("circle").css({"stroke-dasharray":"280, 1000"}),n(".ortho-perc").html("100%"),setTimeout(function(){n(".ortho-loader").remove(),t.clbk();},100);},prepareResponses:function prepareResponses(t){var e={};for(var n in t){e[n.split("/").slice(-1)[0]]=t[n];}return t=e;}};}).call(this,n(1),n(2));},function(t,e){t.exports=function(t,e){if("3d-plan"===window.event.TARGET){var n={};n.module=e,n.content=t;var r="";r="production"===window.event.BUILD?"en"===window.event.LANG?"https://3d-plan.dev.3d-smile.com/client_log/":"https://3d-plan.dev.3d-smile.ru/client_log/":"en"===window.event.LANG?"https://3d-plan.3d-smile.com/client_log/":"https://3d-plan.3d-smile.ru/client_log/",fetch(r,{method:"POST",credentials:"include",body:n}).then(function(){return console.log("Error data sent to server.");}).catch(function(){return console.error("Error sending error.");});}throw console.error(t),"";};},function(t,e,n){var r;/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 *//*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */!function(e,n){"use strict";"object"==(typeof t==="undefined"?"undefined":_typeof(t))&&"object"==_typeof(t.exports)?t.exports=e.document?n(e,!0):function(t){if(!t.document)throw new Error("jQuery requires a window with a document");return n(t);}:n(e);}("undefined"!=typeof window?window:this,function(n,i){"use strict";var o=[],a=n.document,s=Object.getPrototypeOf,u=o.slice,l=o.concat,c=o.push,f=o.indexOf,h={},p=h.toString,d=h.hasOwnProperty,v=d.toString,m=v.call(Object),y={},g=function g(t){return"function"==typeof t&&"number"!=typeof t.nodeType;},x=function x(t){return null!=t&&t===t.window;},b={type:!0,src:!0,noModule:!0};function w(t,e,n){var r,i=(e=e||a).createElement("script");if(i.text=t,n)for(r in b){n[r]&&(i[r]=n[r]);}e.head.appendChild(i).parentNode.removeChild(i);}function _(t){return null==t?t+"":"object"==(typeof t==="undefined"?"undefined":_typeof(t))||"function"==typeof t?h[p.call(t)]||"object":typeof t==="undefined"?"undefined":_typeof(t);}var T=function T(t,e){return new T.fn.init(t,e);},k=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;function E(t){var e=!!t&&"length"in t&&t.length,n=_(t);return!g(t)&&!x(t)&&("array"===n||0===e||"number"==typeof e&&e>0&&e-1 in t);}T.fn=T.prototype={jquery:"3.3.1",constructor:T,length:0,toArray:function toArray(){return u.call(this);},get:function get(t){return null==t?u.call(this):t<0?this[t+this.length]:this[t];},pushStack:function pushStack(t){var e=T.merge(this.constructor(),t);return e.prevObject=this,e;},each:function each(t){return T.each(this,t);},map:function map(t){return this.pushStack(T.map(this,function(e,n){return t.call(e,n,e);}));},slice:function slice(){return this.pushStack(u.apply(this,arguments));},first:function first(){return this.eq(0);},last:function last(){return this.eq(-1);},eq:function eq(t){var e=this.length,n=+t+(t<0?e:0);return this.pushStack(n>=0&&n<e?[this[n]]:[]);},end:function end(){return this.prevObject||this.constructor();},push:c,sort:o.sort,splice:o.splice},T.extend=T.fn.extend=function(){var t,e,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==(typeof a==="undefined"?"undefined":_typeof(a))||g(a)||(a={}),s===u&&(a=this,s--);s<u;s++){if(null!=(t=arguments[s]))for(e in t){n=a[e],a!==(r=t[e])&&(l&&r&&(T.isPlainObject(r)||(i=Array.isArray(r)))?(i?(i=!1,o=n&&Array.isArray(n)?n:[]):o=n&&T.isPlainObject(n)?n:{},a[e]=T.extend(l,o,r)):void 0!==r&&(a[e]=r));}}return a;},T.extend({expando:"jQuery"+("3.3.1"+Math.random()).replace(/\D/g,""),isReady:!0,error:function error(t){throw new Error(t);},noop:function noop(){},isPlainObject:function isPlainObject(t){var e,n;return!(!t||"[object Object]"!==p.call(t))&&(!(e=s(t))||"function"==typeof(n=d.call(e,"constructor")&&e.constructor)&&v.call(n)===m);},isEmptyObject:function isEmptyObject(t){var e;for(e in t){return!1;}return!0;},globalEval:function globalEval(t){w(t);},each:function each(t,e){var n,r=0;if(E(t))for(n=t.length;r<n&&!1!==e.call(t[r],r,t[r]);r++){}else for(r in t){if(!1===e.call(t[r],r,t[r]))break;}return t;},trim:function trim(t){return null==t?"":(t+"").replace(k,"");},makeArray:function makeArray(t,e){var n=e||[];return null!=t&&(E(Object(t))?T.merge(n,"string"==typeof t?[t]:t):c.call(n,t)),n;},inArray:function inArray(t,e,n){return null==e?-1:f.call(e,t,n);},merge:function merge(t,e){for(var n=+e.length,r=0,i=t.length;r<n;r++){t[i++]=e[r];}return t.length=i,t;},grep:function grep(t,e,n){for(var r=[],i=0,o=t.length,a=!n;i<o;i++){!e(t[i],i)!==a&&r.push(t[i]);}return r;},map:function map(t,e,n){var r,i,o=0,a=[];if(E(t))for(r=t.length;o<r;o++){null!=(i=e(t[o],o,n))&&a.push(i);}else for(o in t){null!=(i=e(t[o],o,n))&&a.push(i);}return l.apply([],a);},guid:1,support:y}),"function"==typeof Symbol&&(T.fn[Symbol.iterator]=o[Symbol.iterator]),T.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(t,e){h["[object "+e+"]"]=e.toLowerCase();});var O=/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */function(t){var e,n,r,i,o,a,s,u,l,c,f,h,p,d,v,m,y,g,x,b="sizzle"+1*new Date(),w=t.document,_=0,T=0,k=at(),E=at(),O=at(),S=function S(t,e){return t===e&&(f=!0),0;},A={}.hasOwnProperty,C=[],F=C.pop,M=C.push,P=C.push,D=C.slice,I=function I(t,e){for(var n=0,r=t.length;n<r;n++){if(t[n]===e)return n;}return-1;},L="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",R="[\\x20\\t\\r\\n\\f]",j="(?:\\\\.|[\\w-]|[^\0-\\xa0])+",B="\\["+R+"*("+j+")(?:"+R+"*([*^$|!~]?=)"+R+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+j+"))|)"+R+"*\\]",N=":("+j+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+B+")*)|.*)\\)|)",U=new RegExp(R+"+","g"),z=new RegExp("^"+R+"+|((?:^|[^\\\\])(?:\\\\.)*)"+R+"+$","g"),W=new RegExp("^"+R+"*,"+R+"*"),X=new RegExp("^"+R+"*([>+~]|"+R+")"+R+"*"),V=new RegExp("="+R+"*([^\\]'\"]*?)"+R+"*\\]","g"),Y=new RegExp(N),H=new RegExp("^"+j+"$"),q={ID:new RegExp("^#("+j+")"),CLASS:new RegExp("^\\.("+j+")"),TAG:new RegExp("^("+j+"|[*])"),ATTR:new RegExp("^"+B),PSEUDO:new RegExp("^"+N),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+R+"*(even|odd|(([+-]|)(\\d*)n|)"+R+"*(?:([+-]|)"+R+"*(\\d+)|))"+R+"*\\)|)","i"),bool:new RegExp("^(?:"+L+")$","i"),needsContext:new RegExp("^"+R+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+R+"*((?:-\\d)?\\d*)"+R+"*\\)|)(?=[^-]|$)","i")},G=/^(?:input|select|textarea|button)$/i,$=/^h\d$/i,Z=/^[^{]+\{\s*\[native \w/,Q=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,K=/[+~]/,J=new RegExp("\\\\([\\da-f]{1,6}"+R+"?|("+R+")|.)","ig"),tt=function tt(t,e,n){var r="0x"+e-65536;return r!=r||n?e:r<0?String.fromCharCode(r+65536):String.fromCharCode(r>>10|55296,1023&r|56320);},et=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,nt=function nt(t,e){return e?"\0"===t?"�":t.slice(0,-1)+"\\"+t.charCodeAt(t.length-1).toString(16)+" ":"\\"+t;},rt=function rt(){h();},it=gt(function(t){return!0===t.disabled&&("form"in t||"label"in t);},{dir:"parentNode",next:"legend"});try{P.apply(C=D.call(w.childNodes),w.childNodes),C[w.childNodes.length].nodeType;}catch(t){P={apply:C.length?function(t,e){M.apply(t,D.call(e));}:function(t,e){for(var n=t.length,r=0;t[n++]=e[r++];){}t.length=n-1;}};}function ot(t,e,r,i){var o,s,l,c,f,d,y,g=e&&e.ownerDocument,_=e?e.nodeType:9;if(r=r||[],"string"!=typeof t||!t||1!==_&&9!==_&&11!==_)return r;if(!i&&((e?e.ownerDocument||e:w)!==p&&h(e),e=e||p,v)){if(11!==_&&(f=Q.exec(t)))if(o=f[1]){if(9===_){if(!(l=e.getElementById(o)))return r;if(l.id===o)return r.push(l),r;}else if(g&&(l=g.getElementById(o))&&x(e,l)&&l.id===o)return r.push(l),r;}else{if(f[2])return P.apply(r,e.getElementsByTagName(t)),r;if((o=f[3])&&n.getElementsByClassName&&e.getElementsByClassName)return P.apply(r,e.getElementsByClassName(o)),r;}if(n.qsa&&!O[t+" "]&&(!m||!m.test(t))){if(1!==_)g=e,y=t;else if("object"!==e.nodeName.toLowerCase()){for((c=e.getAttribute("id"))?c=c.replace(et,nt):e.setAttribute("id",c=b),s=(d=a(t)).length;s--;){d[s]="#"+c+" "+yt(d[s]);}y=d.join(","),g=K.test(t)&&vt(e.parentNode)||e;}if(y)try{return P.apply(r,g.querySelectorAll(y)),r;}catch(t){}finally{c===b&&e.removeAttribute("id");}}}return u(t.replace(z,"$1"),e,r,i);}function at(){var t=[];return function e(n,i){return t.push(n+" ")>r.cacheLength&&delete e[t.shift()],e[n+" "]=i;};}function st(t){return t[b]=!0,t;}function ut(t){var e=p.createElement("fieldset");try{return!!t(e);}catch(t){return!1;}finally{e.parentNode&&e.parentNode.removeChild(e),e=null;}}function lt(t,e){for(var n=t.split("|"),i=n.length;i--;){r.attrHandle[n[i]]=e;}}function ct(t,e){var n=e&&t,r=n&&1===t.nodeType&&1===e.nodeType&&t.sourceIndex-e.sourceIndex;if(r)return r;if(n)for(;n=n.nextSibling;){if(n===e)return-1;}return t?1:-1;}function ft(t){return function(e){return"input"===e.nodeName.toLowerCase()&&e.type===t;};}function ht(t){return function(e){var n=e.nodeName.toLowerCase();return("input"===n||"button"===n)&&e.type===t;};}function pt(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&it(e)===t:e.disabled===t:"label"in e&&e.disabled===t;};}function dt(t){return st(function(e){return e=+e,st(function(n,r){for(var i,o=t([],n.length,e),a=o.length;a--;){n[i=o[a]]&&(n[i]=!(r[i]=n[i]));}});});}function vt(t){return t&&void 0!==t.getElementsByTagName&&t;}for(e in n=ot.support={},o=ot.isXML=function(t){var e=t&&(t.ownerDocument||t).documentElement;return!!e&&"HTML"!==e.nodeName;},h=ot.setDocument=function(t){var e,i,a=t?t.ownerDocument||t:w;return a!==p&&9===a.nodeType&&a.documentElement?(d=(p=a).documentElement,v=!o(p),w!==p&&(i=p.defaultView)&&i.top!==i&&(i.addEventListener?i.addEventListener("unload",rt,!1):i.attachEvent&&i.attachEvent("onunload",rt)),n.attributes=ut(function(t){return t.className="i",!t.getAttribute("className");}),n.getElementsByTagName=ut(function(t){return t.appendChild(p.createComment("")),!t.getElementsByTagName("*").length;}),n.getElementsByClassName=Z.test(p.getElementsByClassName),n.getById=ut(function(t){return d.appendChild(t).id=b,!p.getElementsByName||!p.getElementsByName(b).length;}),n.getById?(r.filter.ID=function(t){var e=t.replace(J,tt);return function(t){return t.getAttribute("id")===e;};},r.find.ID=function(t,e){if(void 0!==e.getElementById&&v){var n=e.getElementById(t);return n?[n]:[];}}):(r.filter.ID=function(t){var e=t.replace(J,tt);return function(t){var n=void 0!==t.getAttributeNode&&t.getAttributeNode("id");return n&&n.value===e;};},r.find.ID=function(t,e){if(void 0!==e.getElementById&&v){var n,r,i,o=e.getElementById(t);if(o){if((n=o.getAttributeNode("id"))&&n.value===t)return[o];for(i=e.getElementsByName(t),r=0;o=i[r++];){if((n=o.getAttributeNode("id"))&&n.value===t)return[o];}}return[];}}),r.find.TAG=n.getElementsByTagName?function(t,e){return void 0!==e.getElementsByTagName?e.getElementsByTagName(t):n.qsa?e.querySelectorAll(t):void 0;}:function(t,e){var n,r=[],i=0,o=e.getElementsByTagName(t);if("*"===t){for(;n=o[i++];){1===n.nodeType&&r.push(n);}return r;}return o;},r.find.CLASS=n.getElementsByClassName&&function(t,e){if(void 0!==e.getElementsByClassName&&v)return e.getElementsByClassName(t);},y=[],m=[],(n.qsa=Z.test(p.querySelectorAll))&&(ut(function(t){d.appendChild(t).innerHTML="<a id='"+b+"'></a><select id='"+b+"-\r\\' msallowcapture=''><option selected=''></option></select>",t.querySelectorAll("[msallowcapture^='']").length&&m.push("[*^$]="+R+"*(?:''|\"\")"),t.querySelectorAll("[selected]").length||m.push("\\["+R+"*(?:value|"+L+")"),t.querySelectorAll("[id~="+b+"-]").length||m.push("~="),t.querySelectorAll(":checked").length||m.push(":checked"),t.querySelectorAll("a#"+b+"+*").length||m.push(".#.+[+~]");}),ut(function(t){t.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var e=p.createElement("input");e.setAttribute("type","hidden"),t.appendChild(e).setAttribute("name","D"),t.querySelectorAll("[name=d]").length&&m.push("name"+R+"*[*^$|!~]?="),2!==t.querySelectorAll(":enabled").length&&m.push(":enabled",":disabled"),d.appendChild(t).disabled=!0,2!==t.querySelectorAll(":disabled").length&&m.push(":enabled",":disabled"),t.querySelectorAll("*,:x"),m.push(",.*:");})),(n.matchesSelector=Z.test(g=d.matches||d.webkitMatchesSelector||d.mozMatchesSelector||d.oMatchesSelector||d.msMatchesSelector))&&ut(function(t){n.disconnectedMatch=g.call(t,"*"),g.call(t,"[s!='']:x"),y.push("!=",N);}),m=m.length&&new RegExp(m.join("|")),y=y.length&&new RegExp(y.join("|")),e=Z.test(d.compareDocumentPosition),x=e||Z.test(d.contains)?function(t,e){var n=9===t.nodeType?t.documentElement:t,r=e&&e.parentNode;return t===r||!(!r||1!==r.nodeType||!(n.contains?n.contains(r):t.compareDocumentPosition&&16&t.compareDocumentPosition(r)));}:function(t,e){if(e)for(;e=e.parentNode;){if(e===t)return!0;}return!1;},S=e?function(t,e){if(t===e)return f=!0,0;var r=!t.compareDocumentPosition-!e.compareDocumentPosition;return r||(1&(r=(t.ownerDocument||t)===(e.ownerDocument||e)?t.compareDocumentPosition(e):1)||!n.sortDetached&&e.compareDocumentPosition(t)===r?t===p||t.ownerDocument===w&&x(w,t)?-1:e===p||e.ownerDocument===w&&x(w,e)?1:c?I(c,t)-I(c,e):0:4&r?-1:1);}:function(t,e){if(t===e)return f=!0,0;var n,r=0,i=t.parentNode,o=e.parentNode,a=[t],s=[e];if(!i||!o)return t===p?-1:e===p?1:i?-1:o?1:c?I(c,t)-I(c,e):0;if(i===o)return ct(t,e);for(n=t;n=n.parentNode;){a.unshift(n);}for(n=e;n=n.parentNode;){s.unshift(n);}for(;a[r]===s[r];){r++;}return r?ct(a[r],s[r]):a[r]===w?-1:s[r]===w?1:0;},p):p;},ot.matches=function(t,e){return ot(t,null,null,e);},ot.matchesSelector=function(t,e){if((t.ownerDocument||t)!==p&&h(t),e=e.replace(V,"='$1']"),n.matchesSelector&&v&&!O[e+" "]&&(!y||!y.test(e))&&(!m||!m.test(e)))try{var r=g.call(t,e);if(r||n.disconnectedMatch||t.document&&11!==t.document.nodeType)return r;}catch(t){}return ot(e,p,null,[t]).length>0;},ot.contains=function(t,e){return(t.ownerDocument||t)!==p&&h(t),x(t,e);},ot.attr=function(t,e){(t.ownerDocument||t)!==p&&h(t);var i=r.attrHandle[e.toLowerCase()],o=i&&A.call(r.attrHandle,e.toLowerCase())?i(t,e,!v):void 0;return void 0!==o?o:n.attributes||!v?t.getAttribute(e):(o=t.getAttributeNode(e))&&o.specified?o.value:null;},ot.escape=function(t){return(t+"").replace(et,nt);},ot.error=function(t){throw new Error("Syntax error, unrecognized expression: "+t);},ot.uniqueSort=function(t){var e,r=[],i=0,o=0;if(f=!n.detectDuplicates,c=!n.sortStable&&t.slice(0),t.sort(S),f){for(;e=t[o++];){e===t[o]&&(i=r.push(o));}for(;i--;){t.splice(r[i],1);}}return c=null,t;},i=ot.getText=function(t){var e,n="",r=0,o=t.nodeType;if(o){if(1===o||9===o||11===o){if("string"==typeof t.textContent)return t.textContent;for(t=t.firstChild;t;t=t.nextSibling){n+=i(t);}}else if(3===o||4===o)return t.nodeValue;}else for(;e=t[r++];){n+=i(e);}return n;},(r=ot.selectors={cacheLength:50,createPseudo:st,match:q,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function ATTR(t){return t[1]=t[1].replace(J,tt),t[3]=(t[3]||t[4]||t[5]||"").replace(J,tt),"~="===t[2]&&(t[3]=" "+t[3]+" "),t.slice(0,4);},CHILD:function CHILD(t){return t[1]=t[1].toLowerCase(),"nth"===t[1].slice(0,3)?(t[3]||ot.error(t[0]),t[4]=+(t[4]?t[5]+(t[6]||1):2*("even"===t[3]||"odd"===t[3])),t[5]=+(t[7]+t[8]||"odd"===t[3])):t[3]&&ot.error(t[0]),t;},PSEUDO:function PSEUDO(t){var e,n=!t[6]&&t[2];return q.CHILD.test(t[0])?null:(t[3]?t[2]=t[4]||t[5]||"":n&&Y.test(n)&&(e=a(n,!0))&&(e=n.indexOf(")",n.length-e)-n.length)&&(t[0]=t[0].slice(0,e),t[2]=n.slice(0,e)),t.slice(0,3));}},filter:{TAG:function TAG(t){var e=t.replace(J,tt).toLowerCase();return"*"===t?function(){return!0;}:function(t){return t.nodeName&&t.nodeName.toLowerCase()===e;};},CLASS:function CLASS(t){var e=k[t+" "];return e||(e=new RegExp("(^|"+R+")"+t+"("+R+"|$)"))&&k(t,function(t){return e.test("string"==typeof t.className&&t.className||void 0!==t.getAttribute&&t.getAttribute("class")||"");});},ATTR:function ATTR(t,e,n){return function(r){var i=ot.attr(r,t);return null==i?"!="===e:!e||(i+="","="===e?i===n:"!="===e?i!==n:"^="===e?n&&0===i.indexOf(n):"*="===e?n&&i.indexOf(n)>-1:"$="===e?n&&i.slice(-n.length)===n:"~="===e?(" "+i.replace(U," ")+" ").indexOf(n)>-1:"|="===e&&(i===n||i.slice(0,n.length+1)===n+"-"));};},CHILD:function CHILD(t,e,n,r,i){var o="nth"!==t.slice(0,3),a="last"!==t.slice(-4),s="of-type"===e;return 1===r&&0===i?function(t){return!!t.parentNode;}:function(e,n,u){var l,c,f,h,p,d,v=o!==a?"nextSibling":"previousSibling",m=e.parentNode,y=s&&e.nodeName.toLowerCase(),g=!u&&!s,x=!1;if(m){if(o){for(;v;){for(h=e;h=h[v];){if(s?h.nodeName.toLowerCase()===y:1===h.nodeType)return!1;}d=v="only"===t&&!d&&"nextSibling";}return!0;}if(d=[a?m.firstChild:m.lastChild],a&&g){for(x=(p=(l=(c=(f=(h=m)[b]||(h[b]={}))[h.uniqueID]||(f[h.uniqueID]={}))[t]||[])[0]===_&&l[1])&&l[2],h=p&&m.childNodes[p];h=++p&&h&&h[v]||(x=p=0)||d.pop();){if(1===h.nodeType&&++x&&h===e){c[t]=[_,p,x];break;}}}else if(g&&(x=p=(l=(c=(f=(h=e)[b]||(h[b]={}))[h.uniqueID]||(f[h.uniqueID]={}))[t]||[])[0]===_&&l[1]),!1===x)for(;(h=++p&&h&&h[v]||(x=p=0)||d.pop())&&((s?h.nodeName.toLowerCase()!==y:1!==h.nodeType)||!++x||(g&&((c=(f=h[b]||(h[b]={}))[h.uniqueID]||(f[h.uniqueID]={}))[t]=[_,x]),h!==e));){}return(x-=i)===r||x%r==0&&x/r>=0;}};},PSEUDO:function PSEUDO(t,e){var n,i=r.pseudos[t]||r.setFilters[t.toLowerCase()]||ot.error("unsupported pseudo: "+t);return i[b]?i(e):i.length>1?(n=[t,t,"",e],r.setFilters.hasOwnProperty(t.toLowerCase())?st(function(t,n){for(var r,o=i(t,e),a=o.length;a--;){t[r=I(t,o[a])]=!(n[r]=o[a]);}}):function(t){return i(t,0,n);}):i;}},pseudos:{not:st(function(t){var e=[],n=[],r=s(t.replace(z,"$1"));return r[b]?st(function(t,e,n,i){for(var o,a=r(t,null,i,[]),s=t.length;s--;){(o=a[s])&&(t[s]=!(e[s]=o));}}):function(t,i,o){return e[0]=t,r(e,null,o,n),e[0]=null,!n.pop();};}),has:st(function(t){return function(e){return ot(t,e).length>0;};}),contains:st(function(t){return t=t.replace(J,tt),function(e){return(e.textContent||e.innerText||i(e)).indexOf(t)>-1;};}),lang:st(function(t){return H.test(t||"")||ot.error("unsupported lang: "+t),t=t.replace(J,tt).toLowerCase(),function(e){var n;do{if(n=v?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(n=n.toLowerCase())===t||0===n.indexOf(t+"-");}while((e=e.parentNode)&&1===e.nodeType);return!1;};}),target:function target(e){var n=t.location&&t.location.hash;return n&&n.slice(1)===e.id;},root:function root(t){return t===d;},focus:function focus(t){return t===p.activeElement&&(!p.hasFocus||p.hasFocus())&&!!(t.type||t.href||~t.tabIndex);},enabled:pt(!1),disabled:pt(!0),checked:function checked(t){var e=t.nodeName.toLowerCase();return"input"===e&&!!t.checked||"option"===e&&!!t.selected;},selected:function selected(t){return t.parentNode&&t.parentNode.selectedIndex,!0===t.selected;},empty:function empty(t){for(t=t.firstChild;t;t=t.nextSibling){if(t.nodeType<6)return!1;}return!0;},parent:function parent(t){return!r.pseudos.empty(t);},header:function header(t){return $.test(t.nodeName);},input:function input(t){return G.test(t.nodeName);},button:function button(t){var e=t.nodeName.toLowerCase();return"input"===e&&"button"===t.type||"button"===e;},text:function text(t){var e;return"input"===t.nodeName.toLowerCase()&&"text"===t.type&&(null==(e=t.getAttribute("type"))||"text"===e.toLowerCase());},first:dt(function(){return[0];}),last:dt(function(t,e){return[e-1];}),eq:dt(function(t,e,n){return[n<0?n+e:n];}),even:dt(function(t,e){for(var n=0;n<e;n+=2){t.push(n);}return t;}),odd:dt(function(t,e){for(var n=1;n<e;n+=2){t.push(n);}return t;}),lt:dt(function(t,e,n){for(var r=n<0?n+e:n;--r>=0;){t.push(r);}return t;}),gt:dt(function(t,e,n){for(var r=n<0?n+e:n;++r<e;){t.push(r);}return t;})}}).pseudos.nth=r.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0}){r.pseudos[e]=ft(e);}for(e in{submit:!0,reset:!0}){r.pseudos[e]=ht(e);}function mt(){}function yt(t){for(var e=0,n=t.length,r="";e<n;e++){r+=t[e].value;}return r;}function gt(t,e,n){var r=e.dir,i=e.next,o=i||r,a=n&&"parentNode"===o,s=T++;return e.first?function(e,n,i){for(;e=e[r];){if(1===e.nodeType||a)return t(e,n,i);}return!1;}:function(e,n,u){var l,c,f,h=[_,s];if(u){for(;e=e[r];){if((1===e.nodeType||a)&&t(e,n,u))return!0;}}else for(;e=e[r];){if(1===e.nodeType||a)if(c=(f=e[b]||(e[b]={}))[e.uniqueID]||(f[e.uniqueID]={}),i&&i===e.nodeName.toLowerCase())e=e[r]||e;else{if((l=c[o])&&l[0]===_&&l[1]===s)return h[2]=l[2];if(c[o]=h,h[2]=t(e,n,u))return!0;}}return!1;};}function xt(t){return t.length>1?function(e,n,r){for(var i=t.length;i--;){if(!t[i](e,n,r))return!1;}return!0;}:t[0];}function bt(t,e,n,r,i){for(var o,a=[],s=0,u=t.length,l=null!=e;s<u;s++){(o=t[s])&&(n&&!n(o,r,i)||(a.push(o),l&&e.push(s)));}return a;}function wt(t,e,n,r,i,o){return r&&!r[b]&&(r=wt(r)),i&&!i[b]&&(i=wt(i,o)),st(function(o,a,s,u){var l,c,f,h=[],p=[],d=a.length,v=o||function(t,e,n){for(var r=0,i=e.length;r<i;r++){ot(t,e[r],n);}return n;}(e||"*",s.nodeType?[s]:s,[]),m=!t||!o&&e?v:bt(v,h,t,s,u),y=n?i||(o?t:d||r)?[]:a:m;if(n&&n(m,y,s,u),r)for(l=bt(y,p),r(l,[],s,u),c=l.length;c--;){(f=l[c])&&(y[p[c]]=!(m[p[c]]=f));}if(o){if(i||t){if(i){for(l=[],c=y.length;c--;){(f=y[c])&&l.push(m[c]=f);}i(null,y=[],l,u);}for(c=y.length;c--;){(f=y[c])&&(l=i?I(o,f):h[c])>-1&&(o[l]=!(a[l]=f));}}}else y=bt(y===a?y.splice(d,y.length):y),i?i(null,a,y,u):P.apply(a,y);});}function _t(t){for(var e,n,i,o=t.length,a=r.relative[t[0].type],s=a||r.relative[" "],u=a?1:0,c=gt(function(t){return t===e;},s,!0),f=gt(function(t){return I(e,t)>-1;},s,!0),h=[function(t,n,r){var i=!a&&(r||n!==l)||((e=n).nodeType?c(t,n,r):f(t,n,r));return e=null,i;}];u<o;u++){if(n=r.relative[t[u].type])h=[gt(xt(h),n)];else{if((n=r.filter[t[u].type].apply(null,t[u].matches))[b]){for(i=++u;i<o&&!r.relative[t[i].type];i++){}return wt(u>1&&xt(h),u>1&&yt(t.slice(0,u-1).concat({value:" "===t[u-2].type?"*":""})).replace(z,"$1"),n,u<i&&_t(t.slice(u,i)),i<o&&_t(t=t.slice(i)),i<o&&yt(t));}h.push(n);}}return xt(h);}return mt.prototype=r.filters=r.pseudos,r.setFilters=new mt(),a=ot.tokenize=function(t,e){var n,i,o,a,s,u,l,c=E[t+" "];if(c)return e?0:c.slice(0);for(s=t,u=[],l=r.preFilter;s;){for(a in n&&!(i=W.exec(s))||(i&&(s=s.slice(i[0].length)||s),u.push(o=[])),n=!1,(i=X.exec(s))&&(n=i.shift(),o.push({value:n,type:i[0].replace(z," ")}),s=s.slice(n.length)),r.filter){!(i=q[a].exec(s))||l[a]&&!(i=l[a](i))||(n=i.shift(),o.push({value:n,type:a,matches:i}),s=s.slice(n.length));}if(!n)break;}return e?s.length:s?ot.error(t):E(t,u).slice(0);},s=ot.compile=function(t,e){var n,i=[],o=[],s=O[t+" "];if(!s){for(e||(e=a(t)),n=e.length;n--;){(s=_t(e[n]))[b]?i.push(s):o.push(s);}(s=O(t,function(t,e){var n=e.length>0,i=t.length>0,o=function o(_o,a,s,u,c){var f,d,m,y=0,g="0",x=_o&&[],b=[],w=l,T=_o||i&&r.find.TAG("*",c),k=_+=null==w?1:Math.random()||.1,E=T.length;for(c&&(l=a===p||a||c);g!==E&&null!=(f=T[g]);g++){if(i&&f){for(d=0,a||f.ownerDocument===p||(h(f),s=!v);m=t[d++];){if(m(f,a||p,s)){u.push(f);break;}}c&&(_=k);}n&&((f=!m&&f)&&y--,_o&&x.push(f));}if(y+=g,n&&g!==y){for(d=0;m=e[d++];){m(x,b,a,s);}if(_o){if(y>0)for(;g--;){x[g]||b[g]||(b[g]=F.call(u));}b=bt(b);}P.apply(u,b),c&&!_o&&b.length>0&&y+e.length>1&&ot.uniqueSort(u);}return c&&(_=k,l=w),x;};return n?st(o):o;}(o,i))).selector=t;}return s;},u=ot.select=function(t,e,n,i){var o,u,l,c,f,h="function"==typeof t&&t,p=!i&&a(t=h.selector||t);if(n=n||[],1===p.length){if((u=p[0]=p[0].slice(0)).length>2&&"ID"===(l=u[0]).type&&9===e.nodeType&&v&&r.relative[u[1].type]){if(!(e=(r.find.ID(l.matches[0].replace(J,tt),e)||[])[0]))return n;h&&(e=e.parentNode),t=t.slice(u.shift().value.length);}for(o=q.needsContext.test(t)?0:u.length;o--&&(l=u[o],!r.relative[c=l.type]);){if((f=r.find[c])&&(i=f(l.matches[0].replace(J,tt),K.test(u[0].type)&&vt(e.parentNode)||e))){if(u.splice(o,1),!(t=i.length&&yt(u)))return P.apply(n,i),n;break;}}}return(h||s(t,p))(i,e,!v,n,!e||K.test(t)&&vt(e.parentNode)||e),n;},n.sortStable=b.split("").sort(S).join("")===b,n.detectDuplicates=!!f,h(),n.sortDetached=ut(function(t){return 1&t.compareDocumentPosition(p.createElement("fieldset"));}),ut(function(t){return t.innerHTML="<a href='#'></a>","#"===t.firstChild.getAttribute("href");})||lt("type|href|height|width",function(t,e,n){if(!n)return t.getAttribute(e,"type"===e.toLowerCase()?1:2);}),n.attributes&&ut(function(t){return t.innerHTML="<input/>",t.firstChild.setAttribute("value",""),""===t.firstChild.getAttribute("value");})||lt("value",function(t,e,n){if(!n&&"input"===t.nodeName.toLowerCase())return t.defaultValue;}),ut(function(t){return null==t.getAttribute("disabled");})||lt(L,function(t,e,n){var r;if(!n)return!0===t[e]?e.toLowerCase():(r=t.getAttributeNode(e))&&r.specified?r.value:null;}),ot;}(n);T.find=O,T.expr=O.selectors,T.expr[":"]=T.expr.pseudos,T.uniqueSort=T.unique=O.uniqueSort,T.text=O.getText,T.isXMLDoc=O.isXML,T.contains=O.contains,T.escapeSelector=O.escape;var S=function S(t,e,n){for(var r=[],i=void 0!==n;(t=t[e])&&9!==t.nodeType;){if(1===t.nodeType){if(i&&T(t).is(n))break;r.push(t);}}return r;},A=function A(t,e){for(var n=[];t;t=t.nextSibling){1===t.nodeType&&t!==e&&n.push(t);}return n;},C=T.expr.match.needsContext;function F(t,e){return t.nodeName&&t.nodeName.toLowerCase()===e.toLowerCase();}var M=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function P(t,e,n){return g(e)?T.grep(t,function(t,r){return!!e.call(t,r,t)!==n;}):e.nodeType?T.grep(t,function(t){return t===e!==n;}):"string"!=typeof e?T.grep(t,function(t){return f.call(e,t)>-1!==n;}):T.filter(e,t,n);}T.filter=function(t,e,n){var r=e[0];return n&&(t=":not("+t+")"),1===e.length&&1===r.nodeType?T.find.matchesSelector(r,t)?[r]:[]:T.find.matches(t,T.grep(e,function(t){return 1===t.nodeType;}));},T.fn.extend({find:function find(t){var e,n,r=this.length,i=this;if("string"!=typeof t)return this.pushStack(T(t).filter(function(){for(e=0;e<r;e++){if(T.contains(i[e],this))return!0;}}));for(n=this.pushStack([]),e=0;e<r;e++){T.find(t,i[e],n);}return r>1?T.uniqueSort(n):n;},filter:function filter(t){return this.pushStack(P(this,t||[],!1));},not:function not(t){return this.pushStack(P(this,t||[],!0));},is:function is(t){return!!P(this,"string"==typeof t&&C.test(t)?T(t):t||[],!1).length;}});var D,I=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(T.fn.init=function(t,e,n){var r,i;if(!t)return this;if(n=n||D,"string"==typeof t){if(!(r="<"===t[0]&&">"===t[t.length-1]&&t.length>=3?[null,t,null]:I.exec(t))||!r[1]&&e)return!e||e.jquery?(e||n).find(t):this.constructor(e).find(t);if(r[1]){if(e=e instanceof T?e[0]:e,T.merge(this,T.parseHTML(r[1],e&&e.nodeType?e.ownerDocument||e:a,!0)),M.test(r[1])&&T.isPlainObject(e))for(r in e){g(this[r])?this[r](e[r]):this.attr(r,e[r]);}return this;}return(i=a.getElementById(r[2]))&&(this[0]=i,this.length=1),this;}return t.nodeType?(this[0]=t,this.length=1,this):g(t)?void 0!==n.ready?n.ready(t):t(T):T.makeArray(t,this);}).prototype=T.fn,D=T(a);var L=/^(?:parents|prev(?:Until|All))/,R={children:!0,contents:!0,next:!0,prev:!0};function j(t,e){for(;(t=t[e])&&1!==t.nodeType;){}return t;}T.fn.extend({has:function has(t){var e=T(t,this),n=e.length;return this.filter(function(){for(var t=0;t<n;t++){if(T.contains(this,e[t]))return!0;}});},closest:function closest(t,e){var n,r=0,i=this.length,o=[],a="string"!=typeof t&&T(t);if(!C.test(t))for(;r<i;r++){for(n=this[r];n&&n!==e;n=n.parentNode){if(n.nodeType<11&&(a?a.index(n)>-1:1===n.nodeType&&T.find.matchesSelector(n,t))){o.push(n);break;}}}return this.pushStack(o.length>1?T.uniqueSort(o):o);},index:function index(t){return t?"string"==typeof t?f.call(T(t),this[0]):f.call(this,t.jquery?t[0]:t):this[0]&&this[0].parentNode?this.first().prevAll().length:-1;},add:function add(t,e){return this.pushStack(T.uniqueSort(T.merge(this.get(),T(t,e))));},addBack:function addBack(t){return this.add(null==t?this.prevObject:this.prevObject.filter(t));}}),T.each({parent:function parent(t){var e=t.parentNode;return e&&11!==e.nodeType?e:null;},parents:function parents(t){return S(t,"parentNode");},parentsUntil:function parentsUntil(t,e,n){return S(t,"parentNode",n);},next:function next(t){return j(t,"nextSibling");},prev:function prev(t){return j(t,"previousSibling");},nextAll:function nextAll(t){return S(t,"nextSibling");},prevAll:function prevAll(t){return S(t,"previousSibling");},nextUntil:function nextUntil(t,e,n){return S(t,"nextSibling",n);},prevUntil:function prevUntil(t,e,n){return S(t,"previousSibling",n);},siblings:function siblings(t){return A((t.parentNode||{}).firstChild,t);},children:function children(t){return A(t.firstChild);},contents:function contents(t){return F(t,"iframe")?t.contentDocument:(F(t,"template")&&(t=t.content||t),T.merge([],t.childNodes));}},function(t,e){T.fn[t]=function(n,r){var i=T.map(this,e,n);return"Until"!==t.slice(-5)&&(r=n),r&&"string"==typeof r&&(i=T.filter(r,i)),this.length>1&&(R[t]||T.uniqueSort(i),L.test(t)&&i.reverse()),this.pushStack(i);};});var B=/[^\x20\t\r\n\f]+/g;function N(t){return t;}function U(t){throw t;}function z(t,e,n,r){var i;try{t&&g(i=t.promise)?i.call(t).done(e).fail(n):t&&g(i=t.then)?i.call(t,e,n):e.apply(void 0,[t].slice(r));}catch(t){n.apply(void 0,[t]);}}T.Callbacks=function(t){t="string"==typeof t?function(t){var e={};return T.each(t.match(B)||[],function(t,n){e[n]=!0;}),e;}(t):T.extend({},t);var e,n,r,i,o=[],a=[],s=-1,u=function u(){for(i=i||t.once,r=e=!0;a.length;s=-1){for(n=a.shift();++s<o.length;){!1===o[s].apply(n[0],n[1])&&t.stopOnFalse&&(s=o.length,n=!1);}}t.memory||(n=!1),e=!1,i&&(o=n?[]:"");},l={add:function add(){return o&&(n&&!e&&(s=o.length-1,a.push(n)),function e(n){T.each(n,function(n,r){g(r)?t.unique&&l.has(r)||o.push(r):r&&r.length&&"string"!==_(r)&&e(r);});}(arguments),n&&!e&&u()),this;},remove:function remove(){return T.each(arguments,function(t,e){for(var n;(n=T.inArray(e,o,n))>-1;){o.splice(n,1),n<=s&&s--;}}),this;},has:function has(t){return t?T.inArray(t,o)>-1:o.length>0;},empty:function empty(){return o&&(o=[]),this;},disable:function disable(){return i=a=[],o=n="",this;},disabled:function disabled(){return!o;},lock:function lock(){return i=a=[],n||e||(o=n=""),this;},locked:function locked(){return!!i;},fireWith:function fireWith(t,n){return i||(n=[t,(n=n||[]).slice?n.slice():n],a.push(n),e||u()),this;},fire:function fire(){return l.fireWith(this,arguments),this;},fired:function fired(){return!!r;}};return l;},T.extend({Deferred:function Deferred(t){var e=[["notify","progress",T.Callbacks("memory"),T.Callbacks("memory"),2],["resolve","done",T.Callbacks("once memory"),T.Callbacks("once memory"),0,"resolved"],["reject","fail",T.Callbacks("once memory"),T.Callbacks("once memory"),1,"rejected"]],r="pending",i={state:function state(){return r;},always:function always(){return o.done(arguments).fail(arguments),this;},catch:function _catch(t){return i.then(null,t);},pipe:function pipe(){var t=arguments;return T.Deferred(function(n){T.each(e,function(e,r){var i=g(t[r[4]])&&t[r[4]];o[r[1]](function(){var t=i&&i.apply(this,arguments);t&&g(t.promise)?t.promise().progress(n.notify).done(n.resolve).fail(n.reject):n[r[0]+"With"](this,i?[t]:arguments);});}),t=null;}).promise();},then:function then(t,r,i){var o=0;function a(t,e,r,i){return function(){var s=this,u=arguments,l=function l(){var n,l;if(!(t<o)){if((n=r.apply(s,u))===e.promise())throw new TypeError("Thenable self-resolution");l=n&&("object"==(typeof n==="undefined"?"undefined":_typeof(n))||"function"==typeof n)&&n.then,g(l)?i?l.call(n,a(o,e,N,i),a(o,e,U,i)):(o++,l.call(n,a(o,e,N,i),a(o,e,U,i),a(o,e,N,e.notifyWith))):(r!==N&&(s=void 0,u=[n]),(i||e.resolveWith)(s,u));}},c=i?l:function(){try{l();}catch(n){T.Deferred.exceptionHook&&T.Deferred.exceptionHook(n,c.stackTrace),t+1>=o&&(r!==U&&(s=void 0,u=[n]),e.rejectWith(s,u));}};t?c():(T.Deferred.getStackHook&&(c.stackTrace=T.Deferred.getStackHook()),n.setTimeout(c));};}return T.Deferred(function(n){e[0][3].add(a(0,n,g(i)?i:N,n.notifyWith)),e[1][3].add(a(0,n,g(t)?t:N)),e[2][3].add(a(0,n,g(r)?r:U));}).promise();},promise:function promise(t){return null!=t?T.extend(t,i):i;}},o={};return T.each(e,function(t,n){var a=n[2],s=n[5];i[n[1]]=a.add,s&&a.add(function(){r=s;},e[3-t][2].disable,e[3-t][3].disable,e[0][2].lock,e[0][3].lock),a.add(n[3].fire),o[n[0]]=function(){return o[n[0]+"With"](this===o?void 0:this,arguments),this;},o[n[0]+"With"]=a.fireWith;}),i.promise(o),t&&t.call(o,o),o;},when:function when(t){var e=arguments.length,n=e,r=Array(n),i=u.call(arguments),o=T.Deferred(),a=function a(t){return function(n){r[t]=this,i[t]=arguments.length>1?u.call(arguments):n,--e||o.resolveWith(r,i);};};if(e<=1&&(z(t,o.done(a(n)).resolve,o.reject,!e),"pending"===o.state()||g(i[n]&&i[n].then)))return o.then();for(;n--;){z(i[n],a(n),o.reject);}return o.promise();}});var W=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;T.Deferred.exceptionHook=function(t,e){n.console&&n.console.warn&&t&&W.test(t.name)&&n.console.warn("jQuery.Deferred exception: "+t.message,t.stack,e);},T.readyException=function(t){n.setTimeout(function(){throw t;});};var X=T.Deferred();function V(){a.removeEventListener("DOMContentLoaded",V),n.removeEventListener("load",V),T.ready();}T.fn.ready=function(t){return X.then(t).catch(function(t){T.readyException(t);}),this;},T.extend({isReady:!1,readyWait:1,ready:function ready(t){(!0===t?--T.readyWait:T.isReady)||(T.isReady=!0,!0!==t&&--T.readyWait>0||X.resolveWith(a,[T]));}}),T.ready.then=X.then,"complete"===a.readyState||"loading"!==a.readyState&&!a.documentElement.doScroll?n.setTimeout(T.ready):(a.addEventListener("DOMContentLoaded",V),n.addEventListener("load",V));var Y=function Y(t,e,n,r,i,o,a){var s=0,u=t.length,l=null==n;if("object"===_(n))for(s in i=!0,n){Y(t,e,s,n[s],!0,o,a);}else if(void 0!==r&&(i=!0,g(r)||(a=!0),l&&(a?(e.call(t,r),e=null):(l=e,e=function e(t,_e2,n){return l.call(T(t),n);})),e))for(;s<u;s++){e(t[s],n,a?r:r.call(t[s],s,e(t[s],n)));}return i?t:l?e.call(t):u?e(t[0],n):o;},H=/^-ms-/,q=/-([a-z])/g;function G(t,e){return e.toUpperCase();}function $(t){return t.replace(H,"ms-").replace(q,G);}var Z=function Z(t){return 1===t.nodeType||9===t.nodeType||!+t.nodeType;};function Q(){this.expando=T.expando+Q.uid++;}Q.uid=1,Q.prototype={cache:function cache(t){var e=t[this.expando];return e||(e={},Z(t)&&(t.nodeType?t[this.expando]=e:Object.defineProperty(t,this.expando,{value:e,configurable:!0}))),e;},set:function set(t,e,n){var r,i=this.cache(t);if("string"==typeof e)i[$(e)]=n;else for(r in e){i[$(r)]=e[r];}return i;},get:function get(t,e){return void 0===e?this.cache(t):t[this.expando]&&t[this.expando][$(e)];},access:function access(t,e,n){return void 0===e||e&&"string"==typeof e&&void 0===n?this.get(t,e):(this.set(t,e,n),void 0!==n?n:e);},remove:function remove(t,e){var n,r=t[this.expando];if(void 0!==r){if(void 0!==e){n=(e=Array.isArray(e)?e.map($):(e=$(e))in r?[e]:e.match(B)||[]).length;for(;n--;){delete r[e[n]];}}(void 0===e||T.isEmptyObject(r))&&(t.nodeType?t[this.expando]=void 0:delete t[this.expando]);}},hasData:function hasData(t){var e=t[this.expando];return void 0!==e&&!T.isEmptyObject(e);}};var K=new Q(),J=new Q(),tt=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,et=/[A-Z]/g;function nt(t,e,n){var r;if(void 0===n&&1===t.nodeType)if(r="data-"+e.replace(et,"-$&").toLowerCase(),"string"==typeof(n=t.getAttribute(r))){try{n=function(t){return"true"===t||"false"!==t&&("null"===t?null:t===+t+""?+t:tt.test(t)?JSON.parse(t):t);}(n);}catch(t){}J.set(t,e,n);}else n=void 0;return n;}T.extend({hasData:function hasData(t){return J.hasData(t)||K.hasData(t);},data:function data(t,e,n){return J.access(t,e,n);},removeData:function removeData(t,e){J.remove(t,e);},_data:function _data(t,e,n){return K.access(t,e,n);},_removeData:function _removeData(t,e){K.remove(t,e);}}),T.fn.extend({data:function data(t,e){var n,r,i,o=this[0],a=o&&o.attributes;if(void 0===t){if(this.length&&(i=J.get(o),1===o.nodeType&&!K.get(o,"hasDataAttrs"))){for(n=a.length;n--;){a[n]&&0===(r=a[n].name).indexOf("data-")&&(r=$(r.slice(5)),nt(o,r,i[r]));}K.set(o,"hasDataAttrs",!0);}return i;}return"object"==(typeof t==="undefined"?"undefined":_typeof(t))?this.each(function(){J.set(this,t);}):Y(this,function(e){var n;if(o&&void 0===e)return void 0!==(n=J.get(o,t))?n:void 0!==(n=nt(o,t))?n:void 0;this.each(function(){J.set(this,t,e);});},null,e,arguments.length>1,null,!0);},removeData:function removeData(t){return this.each(function(){J.remove(this,t);});}}),T.extend({queue:function queue(t,e,n){var r;if(t)return e=(e||"fx")+"queue",r=K.get(t,e),n&&(!r||Array.isArray(n)?r=K.access(t,e,T.makeArray(n)):r.push(n)),r||[];},dequeue:function dequeue(t,e){e=e||"fx";var n=T.queue(t,e),r=n.length,i=n.shift(),o=T._queueHooks(t,e);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===e&&n.unshift("inprogress"),delete o.stop,i.call(t,function(){T.dequeue(t,e);},o)),!r&&o&&o.empty.fire();},_queueHooks:function _queueHooks(t,e){var n=e+"queueHooks";return K.get(t,n)||K.access(t,n,{empty:T.Callbacks("once memory").add(function(){K.remove(t,[e+"queue",n]);})});}}),T.fn.extend({queue:function queue(t,e){var n=2;return"string"!=typeof t&&(e=t,t="fx",n--),arguments.length<n?T.queue(this[0],t):void 0===e?this:this.each(function(){var n=T.queue(this,t,e);T._queueHooks(this,t),"fx"===t&&"inprogress"!==n[0]&&T.dequeue(this,t);});},dequeue:function dequeue(t){return this.each(function(){T.dequeue(this,t);});},clearQueue:function clearQueue(t){return this.queue(t||"fx",[]);},promise:function promise(t,e){var n,r=1,i=T.Deferred(),o=this,a=this.length,s=function s(){--r||i.resolveWith(o,[o]);};for("string"!=typeof t&&(e=t,t=void 0),t=t||"fx";a--;){(n=K.get(o[a],t+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));}return s(),i.promise(e);}});var rt=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,it=new RegExp("^(?:([+-])=|)("+rt+")([a-z%]*)$","i"),ot=["Top","Right","Bottom","Left"],at=function at(t,e){return"none"===(t=e||t).style.display||""===t.style.display&&T.contains(t.ownerDocument,t)&&"none"===T.css(t,"display");},st=function st(t,e,n,r){var i,o,a={};for(o in e){a[o]=t.style[o],t.style[o]=e[o];}for(o in i=n.apply(t,r||[]),e){t.style[o]=a[o];}return i;};function ut(t,e,n,r){var i,o,a=20,s=r?function(){return r.cur();}:function(){return T.css(t,e,"");},u=s(),l=n&&n[3]||(T.cssNumber[e]?"":"px"),c=(T.cssNumber[e]||"px"!==l&&+u)&&it.exec(T.css(t,e));if(c&&c[3]!==l){for(u/=2,l=l||c[3],c=+u||1;a--;){T.style(t,e,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;}c*=2,T.style(t,e,c+l),n=n||[];}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i;}var lt={};function ct(t){var e,n=t.ownerDocument,r=t.nodeName,i=lt[r];return i||(e=n.body.appendChild(n.createElement(r)),i=T.css(e,"display"),e.parentNode.removeChild(e),"none"===i&&(i="block"),lt[r]=i,i);}function ft(t,e){for(var n,r,i=[],o=0,a=t.length;o<a;o++){(r=t[o]).style&&(n=r.style.display,e?("none"===n&&(i[o]=K.get(r,"display")||null,i[o]||(r.style.display="")),""===r.style.display&&at(r)&&(i[o]=ct(r))):"none"!==n&&(i[o]="none",K.set(r,"display",n)));}for(o=0;o<a;o++){null!=i[o]&&(t[o].style.display=i[o]);}return t;}T.fn.extend({show:function show(){return ft(this,!0);},hide:function hide(){return ft(this);},toggle:function toggle(t){return"boolean"==typeof t?t?this.show():this.hide():this.each(function(){at(this)?T(this).show():T(this).hide();});}});var ht=/^(?:checkbox|radio)$/i,pt=/<([a-z][^\/\0>\x20\t\r\n\f]+)/i,dt=/^$|^module$|\/(?:java|ecma)script/i,vt={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function mt(t,e){var n;return n=void 0!==t.getElementsByTagName?t.getElementsByTagName(e||"*"):void 0!==t.querySelectorAll?t.querySelectorAll(e||"*"):[],void 0===e||e&&F(t,e)?T.merge([t],n):n;}function yt(t,e){for(var n=0,r=t.length;n<r;n++){K.set(t[n],"globalEval",!e||K.get(e[n],"globalEval"));}}vt.optgroup=vt.option,vt.tbody=vt.tfoot=vt.colgroup=vt.caption=vt.thead,vt.th=vt.td;var gt=/<|&#?\w+;/;function xt(t,e,n,r,i){for(var o,a,s,u,l,c,f=e.createDocumentFragment(),h=[],p=0,d=t.length;p<d;p++){if((o=t[p])||0===o)if("object"===_(o))T.merge(h,o.nodeType?[o]:o);else if(gt.test(o)){for(a=a||f.appendChild(e.createElement("div")),s=(pt.exec(o)||["",""])[1].toLowerCase(),u=vt[s]||vt._default,a.innerHTML=u[1]+T.htmlPrefilter(o)+u[2],c=u[0];c--;){a=a.lastChild;}T.merge(h,a.childNodes),(a=f.firstChild).textContent="";}else h.push(e.createTextNode(o));}for(f.textContent="",p=0;o=h[p++];){if(r&&T.inArray(o,r)>-1)i&&i.push(o);else if(l=T.contains(o.ownerDocument,o),a=mt(f.appendChild(o),"script"),l&&yt(a),n)for(c=0;o=a[c++];){dt.test(o.type||"")&&n.push(o);}}return f;}!function(){var t=a.createDocumentFragment().appendChild(a.createElement("div")),e=a.createElement("input");e.setAttribute("type","radio"),e.setAttribute("checked","checked"),e.setAttribute("name","t"),t.appendChild(e),y.checkClone=t.cloneNode(!0).cloneNode(!0).lastChild.checked,t.innerHTML="<textarea>x</textarea>",y.noCloneChecked=!!t.cloneNode(!0).lastChild.defaultValue;}();var bt=a.documentElement,wt=/^key/,_t=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,Tt=/^([^.]*)(?:\.(.+)|)/;function kt(){return!0;}function Et(){return!1;}function Ot(){try{return a.activeElement;}catch(t){}}function St(t,e,n,r,i,o){var a,s;if("object"==(typeof e==="undefined"?"undefined":_typeof(e))){for(s in"string"!=typeof n&&(r=r||n,n=void 0),e){St(t,s,n,r,e[s],o);}return t;}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=Et;else if(!i)return t;return 1===o&&(a=i,(i=function i(t){return T().off(t),a.apply(this,arguments);}).guid=a.guid||(a.guid=T.guid++)),t.each(function(){T.event.add(this,e,i,r,n);});}T.event={global:{},add:function add(t,e,n,r,i){var o,a,s,u,l,c,f,h,p,d,v,m=K.get(t);if(m)for(n.handler&&(n=(o=n).handler,i=o.selector),i&&T.find.matchesSelector(bt,i),n.guid||(n.guid=T.guid++),(u=m.events)||(u=m.events={}),(a=m.handle)||(a=m.handle=function(e){return void 0!==T&&T.event.triggered!==e.type?T.event.dispatch.apply(t,arguments):void 0;}),l=(e=(e||"").match(B)||[""]).length;l--;){p=v=(s=Tt.exec(e[l])||[])[1],d=(s[2]||"").split(".").sort(),p&&(f=T.event.special[p]||{},p=(i?f.delegateType:f.bindType)||p,f=T.event.special[p]||{},c=T.extend({type:p,origType:v,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&T.expr.match.needsContext.test(i),namespace:d.join(".")},o),(h=u[p])||((h=u[p]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,d,a)||t.addEventListener&&t.addEventListener(p,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?h.splice(h.delegateCount++,0,c):h.push(c),T.event.global[p]=!0);}},remove:function remove(t,e,n,r,i){var o,a,s,u,l,c,f,h,p,d,v,m=K.hasData(t)&&K.get(t);if(m&&(u=m.events)){for(l=(e=(e||"").match(B)||[""]).length;l--;){if(p=v=(s=Tt.exec(e[l])||[])[1],d=(s[2]||"").split(".").sort(),p){for(f=T.event.special[p]||{},h=u[p=(r?f.delegateType:f.bindType)||p]||[],s=s[2]&&new RegExp("(^|\\.)"+d.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=h.length;o--;){c=h[o],!i&&v!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(h.splice(o,1),c.selector&&h.delegateCount--,f.remove&&f.remove.call(t,c));}a&&!h.length&&(f.teardown&&!1!==f.teardown.call(t,d,m.handle)||T.removeEvent(t,p,m.handle),delete u[p]);}else for(p in u){T.event.remove(t,p+e[l],n,r,!0);}}T.isEmptyObject(u)&&K.remove(t,"handle events");}},dispatch:function dispatch(t){var e,n,r,i,o,a,s=T.event.fix(t),u=new Array(arguments.length),l=(K.get(this,"events")||{})[s.type]||[],c=T.event.special[s.type]||{};for(u[0]=s,e=1;e<arguments.length;e++){u[e]=arguments[e];}if(s.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,s)){for(a=T.event.handlers.call(this,s,l),e=0;(i=a[e++])&&!s.isPropagationStopped();){for(s.currentTarget=i.elem,n=0;(o=i.handlers[n++])&&!s.isImmediatePropagationStopped();){s.rnamespace&&!s.rnamespace.test(o.namespace)||(s.handleObj=o,s.data=o.data,void 0!==(r=((T.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,u))&&!1===(s.result=r)&&(s.preventDefault(),s.stopPropagation()));}}return c.postDispatch&&c.postDispatch.call(this,s),s.result;}},handlers:function handlers(t,e){var n,r,i,o,a,s=[],u=e.delegateCount,l=t.target;if(u&&l.nodeType&&!("click"===t.type&&t.button>=1))for(;l!==this;l=l.parentNode||this){if(1===l.nodeType&&("click"!==t.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++){void 0===a[i=(r=e[n]).selector+" "]&&(a[i]=r.needsContext?T(i,this).index(l)>-1:T.find(i,this,null,[l]).length),a[i]&&o.push(r);}o.length&&s.push({elem:l,handlers:o});}}return l=this,u<e.length&&s.push({elem:l,handlers:e.slice(u)}),s;},addProp:function addProp(t,e){Object.defineProperty(T.Event.prototype,t,{enumerable:!0,configurable:!0,get:g(e)?function(){if(this.originalEvent)return e(this.originalEvent);}:function(){if(this.originalEvent)return this.originalEvent[t];},set:function set(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e});}});},fix:function fix(t){return t[T.expando]?t:new T.Event(t);},special:{load:{noBubble:!0},focus:{trigger:function trigger(){if(this!==Ot()&&this.focus)return this.focus(),!1;},delegateType:"focusin"},blur:{trigger:function trigger(){if(this===Ot()&&this.blur)return this.blur(),!1;},delegateType:"focusout"},click:{trigger:function trigger(){if("checkbox"===this.type&&this.click&&F(this,"input"))return this.click(),!1;},_default:function _default(t){return F(t.target,"a");}},beforeunload:{postDispatch:function postDispatch(t){void 0!==t.result&&t.originalEvent&&(t.originalEvent.returnValue=t.result);}}}},T.removeEvent=function(t,e,n){t.removeEventListener&&t.removeEventListener(e,n);},T.Event=function(t,e){if(!(this instanceof T.Event))return new T.Event(t,e);t&&t.type?(this.originalEvent=t,this.type=t.type,this.isDefaultPrevented=t.defaultPrevented||void 0===t.defaultPrevented&&!1===t.returnValue?kt:Et,this.target=t.target&&3===t.target.nodeType?t.target.parentNode:t.target,this.currentTarget=t.currentTarget,this.relatedTarget=t.relatedTarget):this.type=t,e&&T.extend(this,e),this.timeStamp=t&&t.timeStamp||Date.now(),this[T.expando]=!0;},T.Event.prototype={constructor:T.Event,isDefaultPrevented:Et,isPropagationStopped:Et,isImmediatePropagationStopped:Et,isSimulated:!1,preventDefault:function preventDefault(){var t=this.originalEvent;this.isDefaultPrevented=kt,t&&!this.isSimulated&&t.preventDefault();},stopPropagation:function stopPropagation(){var t=this.originalEvent;this.isPropagationStopped=kt,t&&!this.isSimulated&&t.stopPropagation();},stopImmediatePropagation:function stopImmediatePropagation(){var t=this.originalEvent;this.isImmediatePropagationStopped=kt,t&&!this.isSimulated&&t.stopImmediatePropagation(),this.stopPropagation();}},T.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,char:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function which(t){var e=t.button;return null==t.which&&wt.test(t.type)?null!=t.charCode?t.charCode:t.keyCode:!t.which&&void 0!==e&&_t.test(t.type)?1&e?1:2&e?3:4&e?2:0:t.which;}},T.event.addProp),T.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(t,e){T.event.special[t]={delegateType:e,bindType:e,handle:function handle(t){var n,r=t.relatedTarget,i=t.handleObj;return r&&(r===this||T.contains(this,r))||(t.type=i.origType,n=i.handler.apply(this,arguments),t.type=e),n;}};}),T.fn.extend({on:function on(t,e,n,r){return St(this,t,e,n,r);},one:function one(t,e,n,r){return St(this,t,e,n,r,1);},off:function off(t,e,n){var r,i;if(t&&t.preventDefault&&t.handleObj)return r=t.handleObj,T(t.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==(typeof t==="undefined"?"undefined":_typeof(t))){for(i in t){this.off(i,e,t[i]);}return this;}return!1!==e&&"function"!=typeof e||(n=e,e=void 0),!1===n&&(n=Et),this.each(function(){T.event.remove(this,t,n,e);});}});var At=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,Ct=/<script|<style|<link/i,Ft=/checked\s*(?:[^=]|=\s*.checked.)/i,Mt=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function Pt(t,e){return F(t,"table")&&F(11!==e.nodeType?e:e.firstChild,"tr")&&T(t).children("tbody")[0]||t;}function Dt(t){return t.type=(null!==t.getAttribute("type"))+"/"+t.type,t;}function It(t){return"true/"===(t.type||"").slice(0,5)?t.type=t.type.slice(5):t.removeAttribute("type"),t;}function Lt(t,e){var n,r,i,o,a,s,u,l;if(1===e.nodeType){if(K.hasData(t)&&(o=K.access(t),a=K.set(e,o),l=o.events))for(i in delete a.handle,a.events={},l){for(n=0,r=l[i].length;n<r;n++){T.event.add(e,i,l[i][n]);}}J.hasData(t)&&(s=J.access(t),u=T.extend({},s),J.set(e,u));}}function Rt(t,e){var n=e.nodeName.toLowerCase();"input"===n&&ht.test(t.type)?e.checked=t.checked:"input"!==n&&"textarea"!==n||(e.defaultValue=t.defaultValue);}function jt(t,e,n,r){e=l.apply([],e);var i,o,a,s,u,c,f=0,h=t.length,p=h-1,d=e[0],v=g(d);if(v||h>1&&"string"==typeof d&&!y.checkClone&&Ft.test(d))return t.each(function(i){var o=t.eq(i);v&&(e[0]=d.call(this,i,o.html())),jt(o,e,n,r);});if(h&&(o=(i=xt(e,t[0].ownerDocument,!1,t,r)).firstChild,1===i.childNodes.length&&(i=o),o||r)){for(s=(a=T.map(mt(i,"script"),Dt)).length;f<h;f++){u=i,f!==p&&(u=T.clone(u,!0,!0),s&&T.merge(a,mt(u,"script"))),n.call(t[f],u,f);}if(s)for(c=a[a.length-1].ownerDocument,T.map(a,It),f=0;f<s;f++){u=a[f],dt.test(u.type||"")&&!K.access(u,"globalEval")&&T.contains(c,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?T._evalUrl&&T._evalUrl(u.src):w(u.textContent.replace(Mt,""),c,u));}}return t;}function Bt(t,e,n){for(var r,i=e?T.filter(e,t):t,o=0;null!=(r=i[o]);o++){n||1!==r.nodeType||T.cleanData(mt(r)),r.parentNode&&(n&&T.contains(r.ownerDocument,r)&&yt(mt(r,"script")),r.parentNode.removeChild(r));}return t;}T.extend({htmlPrefilter:function htmlPrefilter(t){return t.replace(At,"<$1></$2>");},clone:function clone(t,e,n){var r,i,o,a,s=t.cloneNode(!0),u=T.contains(t.ownerDocument,t);if(!(y.noCloneChecked||1!==t.nodeType&&11!==t.nodeType||T.isXMLDoc(t)))for(a=mt(s),r=0,i=(o=mt(t)).length;r<i;r++){Rt(o[r],a[r]);}if(e)if(n)for(o=o||mt(t),a=a||mt(s),r=0,i=o.length;r<i;r++){Lt(o[r],a[r]);}else Lt(t,s);return(a=mt(s,"script")).length>0&&yt(a,!u&&mt(t,"script")),s;},cleanData:function cleanData(t){for(var e,n,r,i=T.event.special,o=0;void 0!==(n=t[o]);o++){if(Z(n)){if(e=n[K.expando]){if(e.events)for(r in e.events){i[r]?T.event.remove(n,r):T.removeEvent(n,r,e.handle);}n[K.expando]=void 0;}n[J.expando]&&(n[J.expando]=void 0);}}}}),T.fn.extend({detach:function detach(t){return Bt(this,t,!0);},remove:function remove(t){return Bt(this,t);},text:function text(t){return Y(this,function(t){return void 0===t?T.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=t);});},null,t,arguments.length);},append:function append(){return jt(this,arguments,function(t){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Pt(this,t).appendChild(t);});},prepend:function prepend(){return jt(this,arguments,function(t){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var e=Pt(this,t);e.insertBefore(t,e.firstChild);}});},before:function before(){return jt(this,arguments,function(t){this.parentNode&&this.parentNode.insertBefore(t,this);});},after:function after(){return jt(this,arguments,function(t){this.parentNode&&this.parentNode.insertBefore(t,this.nextSibling);});},empty:function empty(){for(var t,e=0;null!=(t=this[e]);e++){1===t.nodeType&&(T.cleanData(mt(t,!1)),t.textContent="");}return this;},clone:function clone(t,e){return t=null!=t&&t,e=null==e?t:e,this.map(function(){return T.clone(this,t,e);});},html:function html(t){return Y(this,function(t){var e=this[0]||{},n=0,r=this.length;if(void 0===t&&1===e.nodeType)return e.innerHTML;if("string"==typeof t&&!Ct.test(t)&&!vt[(pt.exec(t)||["",""])[1].toLowerCase()]){t=T.htmlPrefilter(t);try{for(;n<r;n++){1===(e=this[n]||{}).nodeType&&(T.cleanData(mt(e,!1)),e.innerHTML=t);}e=0;}catch(t){}}e&&this.empty().append(t);},null,t,arguments.length);},replaceWith:function replaceWith(){var t=[];return jt(this,arguments,function(e){var n=this.parentNode;T.inArray(this,t)<0&&(T.cleanData(mt(this)),n&&n.replaceChild(e,this));},t);}}),T.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(t,e){T.fn[t]=function(t){for(var n,r=[],i=T(t),o=i.length-1,a=0;a<=o;a++){n=a===o?this:this.clone(!0),T(i[a])[e](n),c.apply(r,n.get());}return this.pushStack(r);};});var Nt=new RegExp("^("+rt+")(?!px)[a-z%]+$","i"),Ut=function Ut(t){var e=t.ownerDocument.defaultView;return e&&e.opener||(e=n),e.getComputedStyle(t);},zt=new RegExp(ot.join("|"),"i");function Wt(t,e,n){var r,i,o,a,s=t.style;return(n=n||Ut(t))&&(""!==(a=n.getPropertyValue(e)||n[e])||T.contains(t.ownerDocument,t)||(a=T.style(t,e)),!y.pixelBoxStyles()&&Nt.test(a)&&zt.test(e)&&(r=s.width,i=s.minWidth,o=s.maxWidth,s.minWidth=s.maxWidth=s.width=a,a=n.width,s.width=r,s.minWidth=i,s.maxWidth=o)),void 0!==a?a+"":a;}function Xt(t,e){return{get:function get(){if(!t())return(this.get=e).apply(this,arguments);delete this.get;}};}!function(){function t(){if(c){l.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",c.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",bt.appendChild(l).appendChild(c);var t=n.getComputedStyle(c);r="1%"!==t.top,u=12===e(t.marginLeft),c.style.right="60%",s=36===e(t.right),i=36===e(t.width),c.style.position="absolute",o=36===c.offsetWidth||"absolute",bt.removeChild(l),c=null;}}function e(t){return Math.round(parseFloat(t));}var r,i,o,s,u,l=a.createElement("div"),c=a.createElement("div");c.style&&(c.style.backgroundClip="content-box",c.cloneNode(!0).style.backgroundClip="",y.clearCloneStyle="content-box"===c.style.backgroundClip,T.extend(y,{boxSizingReliable:function boxSizingReliable(){return t(),i;},pixelBoxStyles:function pixelBoxStyles(){return t(),s;},pixelPosition:function pixelPosition(){return t(),r;},reliableMarginLeft:function reliableMarginLeft(){return t(),u;},scrollboxSize:function scrollboxSize(){return t(),o;}}));}();var Vt=/^(none|table(?!-c[ea]).+)/,Yt=/^--/,Ht={position:"absolute",visibility:"hidden",display:"block"},qt={letterSpacing:"0",fontWeight:"400"},Gt=["Webkit","Moz","ms"],$t=a.createElement("div").style;function Zt(t){var e=T.cssProps[t];return e||(e=T.cssProps[t]=function(t){if(t in $t)return t;for(var e=t[0].toUpperCase()+t.slice(1),n=Gt.length;n--;){if((t=Gt[n]+e)in $t)return t;}}(t)||t),e;}function Qt(t,e,n){var r=it.exec(e);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):e;}function Kt(t,e,n,r,i,o){var a="width"===e?1:0,s=0,u=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2){"margin"===n&&(u+=T.css(t,n+ot[a],!0,i)),r?("content"===n&&(u-=T.css(t,"padding"+ot[a],!0,i)),"margin"!==n&&(u-=T.css(t,"border"+ot[a]+"Width",!0,i))):(u+=T.css(t,"padding"+ot[a],!0,i),"padding"!==n?u+=T.css(t,"border"+ot[a]+"Width",!0,i):s+=T.css(t,"border"+ot[a]+"Width",!0,i));}return!r&&o>=0&&(u+=Math.max(0,Math.ceil(t["offset"+e[0].toUpperCase()+e.slice(1)]-o-u-s-.5))),u;}function Jt(t,e,n){var r=Ut(t),i=Wt(t,e,r),o="border-box"===T.css(t,"boxSizing",!1,r),a=o;if(Nt.test(i)){if(!n)return i;i="auto";}return a=a&&(y.boxSizingReliable()||i===t.style[e]),("auto"===i||!parseFloat(i)&&"inline"===T.css(t,"display",!1,r))&&(i=t["offset"+e[0].toUpperCase()+e.slice(1)],a=!0),(i=parseFloat(i)||0)+Kt(t,e,n||(o?"border":"content"),a,r,i)+"px";}function te(t,e,n,r,i){return new te.prototype.init(t,e,n,r,i);}T.extend({cssHooks:{opacity:{get:function get(t,e){if(e){var n=Wt(t,"opacity");return""===n?"1":n;}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function style(t,e,n,r){if(t&&3!==t.nodeType&&8!==t.nodeType&&t.style){var i,o,a,s=$(e),u=Yt.test(e),l=t.style;if(u||(e=Zt(s)),a=T.cssHooks[e]||T.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(t,!1,r))?i:l[e];"string"===(o=typeof n==="undefined"?"undefined":_typeof(n))&&(i=it.exec(n))&&i[1]&&(n=ut(t,e,i),o="number"),null!=n&&n==n&&("number"===o&&(n+=i&&i[3]||(T.cssNumber[s]?"":"px")),y.clearCloneStyle||""!==n||0!==e.indexOf("background")||(l[e]="inherit"),a&&"set"in a&&void 0===(n=a.set(t,n,r))||(u?l.setProperty(e,n):l[e]=n));}},css:function css(t,e,n,r){var i,o,a,s=$(e);return Yt.test(e)||(e=Zt(s)),(a=T.cssHooks[e]||T.cssHooks[s])&&"get"in a&&(i=a.get(t,!0,n)),void 0===i&&(i=Wt(t,e,r)),"normal"===i&&e in qt&&(i=qt[e]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i;}}),T.each(["height","width"],function(t,e){T.cssHooks[e]={get:function get(t,n,r){if(n)return!Vt.test(T.css(t,"display"))||t.getClientRects().length&&t.getBoundingClientRect().width?Jt(t,e,r):st(t,Ht,function(){return Jt(t,e,r);});},set:function set(t,n,r){var i,o=Ut(t),a="border-box"===T.css(t,"boxSizing",!1,o),s=r&&Kt(t,e,r,a,o);return a&&y.scrollboxSize()===o.position&&(s-=Math.ceil(t["offset"+e[0].toUpperCase()+e.slice(1)]-parseFloat(o[e])-Kt(t,e,"border",!1,o)-.5)),s&&(i=it.exec(n))&&"px"!==(i[3]||"px")&&(t.style[e]=n,n=T.css(t,e)),Qt(0,n,s);}};}),T.cssHooks.marginLeft=Xt(y.reliableMarginLeft,function(t,e){if(e)return(parseFloat(Wt(t,"marginLeft"))||t.getBoundingClientRect().left-st(t,{marginLeft:0},function(){return t.getBoundingClientRect().left;}))+"px";}),T.each({margin:"",padding:"",border:"Width"},function(t,e){T.cssHooks[t+e]={expand:function expand(n){for(var r=0,i={},o="string"==typeof n?n.split(" "):[n];r<4;r++){i[t+ot[r]+e]=o[r]||o[r-2]||o[0];}return i;}},"margin"!==t&&(T.cssHooks[t+e].set=Qt);}),T.fn.extend({css:function css(t,e){return Y(this,function(t,e,n){var r,i,o={},a=0;if(Array.isArray(e)){for(r=Ut(t),i=e.length;a<i;a++){o[e[a]]=T.css(t,e[a],!1,r);}return o;}return void 0!==n?T.style(t,e,n):T.css(t,e);},t,e,arguments.length>1);}}),T.Tween=te,te.prototype={constructor:te,init:function init(t,e,n,r,i,o){this.elem=t,this.prop=n,this.easing=i||T.easing._default,this.options=e,this.start=this.now=this.cur(),this.end=r,this.unit=o||(T.cssNumber[n]?"":"px");},cur:function cur(){var t=te.propHooks[this.prop];return t&&t.get?t.get(this):te.propHooks._default.get(this);},run:function run(t){var e,n=te.propHooks[this.prop];return this.options.duration?this.pos=e=T.easing[this.easing](t,this.options.duration*t,0,1,this.options.duration):this.pos=e=t,this.now=(this.end-this.start)*e+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):te.propHooks._default.set(this),this;}},te.prototype.init.prototype=te.prototype,te.propHooks={_default:{get:function get(t){var e;return 1!==t.elem.nodeType||null!=t.elem[t.prop]&&null==t.elem.style[t.prop]?t.elem[t.prop]:(e=T.css(t.elem,t.prop,""))&&"auto"!==e?e:0;},set:function set(t){T.fx.step[t.prop]?T.fx.step[t.prop](t):1!==t.elem.nodeType||null==t.elem.style[T.cssProps[t.prop]]&&!T.cssHooks[t.prop]?t.elem[t.prop]=t.now:T.style(t.elem,t.prop,t.now+t.unit);}}},te.propHooks.scrollTop=te.propHooks.scrollLeft={set:function set(t){t.elem.nodeType&&t.elem.parentNode&&(t.elem[t.prop]=t.now);}},T.easing={linear:function linear(t){return t;},swing:function swing(t){return .5-Math.cos(t*Math.PI)/2;},_default:"swing"},T.fx=te.prototype.init,T.fx.step={};var ee,ne,re=/^(?:toggle|show|hide)$/,ie=/queueHooks$/;function oe(){ne&&(!1===a.hidden&&n.requestAnimationFrame?n.requestAnimationFrame(oe):n.setTimeout(oe,T.fx.interval),T.fx.tick());}function ae(){return n.setTimeout(function(){ee=void 0;}),ee=Date.now();}function se(t,e){var n,r=0,i={height:t};for(e=e?1:0;r<4;r+=2-e){i["margin"+(n=ot[r])]=i["padding"+n]=t;}return e&&(i.opacity=i.width=t),i;}function ue(t,e,n){for(var r,i=(le.tweeners[e]||[]).concat(le.tweeners["*"]),o=0,a=i.length;o<a;o++){if(r=i[o].call(n,e,t))return r;}}function le(t,e,n){var r,i,o=0,a=le.prefilters.length,s=T.Deferred().always(function(){delete u.elem;}),u=function u(){if(i)return!1;for(var e=ee||ae(),n=Math.max(0,l.startTime+l.duration-e),r=1-(n/l.duration||0),o=0,a=l.tweens.length;o<a;o++){l.tweens[o].run(r);}return s.notifyWith(t,[l,r,n]),r<1&&a?n:(a||s.notifyWith(t,[l,1,0]),s.resolveWith(t,[l]),!1);},l=s.promise({elem:t,props:T.extend({},e),opts:T.extend(!0,{specialEasing:{},easing:T.easing._default},n),originalProperties:e,originalOptions:n,startTime:ee||ae(),duration:n.duration,tweens:[],createTween:function createTween(e,n){var r=T.Tween(t,l.opts,e,n,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(r),r;},stop:function stop(e){var n=0,r=e?l.tweens.length:0;if(i)return this;for(i=!0;n<r;n++){l.tweens[n].run(1);}return e?(s.notifyWith(t,[l,1,0]),s.resolveWith(t,[l,e])):s.rejectWith(t,[l,e]),this;}}),c=l.props;for(!function(t,e){var n,r,i,o,a;for(n in t){if(i=e[r=$(n)],o=t[n],Array.isArray(o)&&(i=o[1],o=t[n]=o[0]),n!==r&&(t[r]=o,delete t[n]),(a=T.cssHooks[r])&&("expand"in a))for(n in o=a.expand(o),delete t[r],o){(n in t)||(t[n]=o[n],e[n]=i);}else e[r]=i;}}(c,l.opts.specialEasing);o<a;o++){if(r=le.prefilters[o].call(l,t,c,l.opts))return g(r.stop)&&(T._queueHooks(l.elem,l.opts.queue).stop=r.stop.bind(r)),r;}return T.map(c,ue,l),g(l.opts.start)&&l.opts.start.call(t,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),T.fx.timer(T.extend(u,{elem:t,anim:l,queue:l.opts.queue})),l;}T.Animation=T.extend(le,{tweeners:{"*":[function(t,e){var n=this.createTween(t,e);return ut(n.elem,t,it.exec(e),n),n;}]},tweener:function tweener(t,e){g(t)?(e=t,t=["*"]):t=t.match(B);for(var n,r=0,i=t.length;r<i;r++){n=t[r],le.tweeners[n]=le.tweeners[n]||[],le.tweeners[n].unshift(e);}},prefilters:[function(t,e,n){var r,i,o,a,s,u,l,c,f="width"in e||"height"in e,h=this,p={},d=t.style,v=t.nodeType&&at(t),m=K.get(t,"fxshow");for(r in n.queue||(null==(a=T._queueHooks(t,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s();}),a.unqueued++,h.always(function(){h.always(function(){a.unqueued--,T.queue(t,"fx").length||a.empty.fire();});})),e){if(i=e[r],re.test(i)){if(delete e[r],o=o||"toggle"===i,i===(v?"hide":"show")){if("show"!==i||!m||void 0===m[r])continue;v=!0;}p[r]=m&&m[r]||T.style(t,r);}}if((u=!T.isEmptyObject(e))||!T.isEmptyObject(p))for(r in f&&1===t.nodeType&&(n.overflow=[d.overflow,d.overflowX,d.overflowY],null==(l=m&&m.display)&&(l=K.get(t,"display")),"none"===(c=T.css(t,"display"))&&(l?c=l:(ft([t],!0),l=t.style.display||l,c=T.css(t,"display"),ft([t]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===T.css(t,"float")&&(u||(h.done(function(){d.display=l;}),null==l&&(c=d.display,l="none"===c?"":c)),d.display="inline-block")),n.overflow&&(d.overflow="hidden",h.always(function(){d.overflow=n.overflow[0],d.overflowX=n.overflow[1],d.overflowY=n.overflow[2];})),u=!1,p){u||(m?"hidden"in m&&(v=m.hidden):m=K.access(t,"fxshow",{display:l}),o&&(m.hidden=!v),v&&ft([t],!0),h.done(function(){for(r in v||ft([t]),K.remove(t,"fxshow"),p){T.style(t,r,p[r]);}})),u=ue(v?m[r]:0,r,h),r in m||(m[r]=u.start,v&&(u.end=u.start,u.start=0));}}],prefilter:function prefilter(t,e){e?le.prefilters.unshift(t):le.prefilters.push(t);}}),T.speed=function(t,e,n){var r=t&&"object"==(typeof t==="undefined"?"undefined":_typeof(t))?T.extend({},t):{complete:n||!n&&e||g(t)&&t,duration:t,easing:n&&e||e&&!g(e)&&e};return T.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in T.fx.speeds?r.duration=T.fx.speeds[r.duration]:r.duration=T.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){g(r.old)&&r.old.call(this),r.queue&&T.dequeue(this,r.queue);},r;},T.fn.extend({fadeTo:function fadeTo(t,e,n,r){return this.filter(at).css("opacity",0).show().end().animate({opacity:e},t,n,r);},animate:function animate(t,e,n,r){var i=T.isEmptyObject(t),o=T.speed(e,n,r),a=function a(){var e=le(this,T.extend({},t),o);(i||K.get(this,"finish"))&&e.stop(!0);};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a);},stop:function stop(t,e,n){var r=function r(t){var e=t.stop;delete t.stop,e(n);};return"string"!=typeof t&&(n=e,e=t,t=void 0),e&&!1!==t&&this.queue(t||"fx",[]),this.each(function(){var e=!0,i=null!=t&&t+"queueHooks",o=T.timers,a=K.get(this);if(i)a[i]&&a[i].stop&&r(a[i]);else for(i in a){a[i]&&a[i].stop&&ie.test(i)&&r(a[i]);}for(i=o.length;i--;){o[i].elem!==this||null!=t&&o[i].queue!==t||(o[i].anim.stop(n),e=!1,o.splice(i,1));}!e&&n||T.dequeue(this,t);});},finish:function finish(t){return!1!==t&&(t=t||"fx"),this.each(function(){var e,n=K.get(this),r=n[t+"queue"],i=n[t+"queueHooks"],o=T.timers,a=r?r.length:0;for(n.finish=!0,T.queue(this,t,[]),i&&i.stop&&i.stop.call(this,!0),e=o.length;e--;){o[e].elem===this&&o[e].queue===t&&(o[e].anim.stop(!0),o.splice(e,1));}for(e=0;e<a;e++){r[e]&&r[e].finish&&r[e].finish.call(this);}delete n.finish;});}}),T.each(["toggle","show","hide"],function(t,e){var n=T.fn[e];T.fn[e]=function(t,r,i){return null==t||"boolean"==typeof t?n.apply(this,arguments):this.animate(se(e,!0),t,r,i);};}),T.each({slideDown:se("show"),slideUp:se("hide"),slideToggle:se("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(t,e){T.fn[t]=function(t,n,r){return this.animate(e,t,n,r);};}),T.timers=[],T.fx.tick=function(){var t,e=0,n=T.timers;for(ee=Date.now();e<n.length;e++){(t=n[e])()||n[e]!==t||n.splice(e--,1);}n.length||T.fx.stop(),ee=void 0;},T.fx.timer=function(t){T.timers.push(t),T.fx.start();},T.fx.interval=13,T.fx.start=function(){ne||(ne=!0,oe());},T.fx.stop=function(){ne=null;},T.fx.speeds={slow:600,fast:200,_default:400},T.fn.delay=function(t,e){return t=T.fx&&T.fx.speeds[t]||t,e=e||"fx",this.queue(e,function(e,r){var i=n.setTimeout(e,t);r.stop=function(){n.clearTimeout(i);};});},function(){var t=a.createElement("input"),e=a.createElement("select").appendChild(a.createElement("option"));t.type="checkbox",y.checkOn=""!==t.value,y.optSelected=e.selected,(t=a.createElement("input")).value="t",t.type="radio",y.radioValue="t"===t.value;}();var ce,fe=T.expr.attrHandle;T.fn.extend({attr:function attr(t,e){return Y(this,T.attr,t,e,arguments.length>1);},removeAttr:function removeAttr(t){return this.each(function(){T.removeAttr(this,t);});}}),T.extend({attr:function attr(t,e,n){var r,i,o=t.nodeType;if(3!==o&&8!==o&&2!==o)return void 0===t.getAttribute?T.prop(t,e,n):(1===o&&T.isXMLDoc(t)||(i=T.attrHooks[e.toLowerCase()]||(T.expr.match.bool.test(e)?ce:void 0)),void 0!==n?null===n?void T.removeAttr(t,e):i&&"set"in i&&void 0!==(r=i.set(t,n,e))?r:(t.setAttribute(e,n+""),n):i&&"get"in i&&null!==(r=i.get(t,e))?r:null==(r=T.find.attr(t,e))?void 0:r);},attrHooks:{type:{set:function set(t,e){if(!y.radioValue&&"radio"===e&&F(t,"input")){var n=t.value;return t.setAttribute("type",e),n&&(t.value=n),e;}}}},removeAttr:function removeAttr(t,e){var n,r=0,i=e&&e.match(B);if(i&&1===t.nodeType)for(;n=i[r++];){t.removeAttribute(n);}}}),ce={set:function set(t,e,n){return!1===e?T.removeAttr(t,n):t.setAttribute(n,n),n;}},T.each(T.expr.match.bool.source.match(/\w+/g),function(t,e){var n=fe[e]||T.find.attr;fe[e]=function(t,e,r){var i,o,a=e.toLowerCase();return r||(o=fe[a],fe[a]=i,i=null!=n(t,e,r)?a:null,fe[a]=o),i;};});var he=/^(?:input|select|textarea|button)$/i,pe=/^(?:a|area)$/i;function de(t){return(t.match(B)||[]).join(" ");}function ve(t){return t.getAttribute&&t.getAttribute("class")||"";}function me(t){return Array.isArray(t)?t:"string"==typeof t&&t.match(B)||[];}T.fn.extend({prop:function prop(t,e){return Y(this,T.prop,t,e,arguments.length>1);},removeProp:function removeProp(t){return this.each(function(){delete this[T.propFix[t]||t];});}}),T.extend({prop:function prop(t,e,n){var r,i,o=t.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&T.isXMLDoc(t)||(e=T.propFix[e]||e,i=T.propHooks[e]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(t,n,e))?r:t[e]=n:i&&"get"in i&&null!==(r=i.get(t,e))?r:t[e];},propHooks:{tabIndex:{get:function get(t){var e=T.find.attr(t,"tabindex");return e?parseInt(e,10):he.test(t.nodeName)||pe.test(t.nodeName)&&t.href?0:-1;}}},propFix:{for:"htmlFor",class:"className"}}),y.optSelected||(T.propHooks.selected={get:function get(t){var e=t.parentNode;return e&&e.parentNode&&e.parentNode.selectedIndex,null;},set:function set(t){var e=t.parentNode;e&&(e.selectedIndex,e.parentNode&&e.parentNode.selectedIndex);}}),T.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){T.propFix[this.toLowerCase()]=this;}),T.fn.extend({addClass:function addClass(t){var e,n,r,i,o,a,s,u=0;if(g(t))return this.each(function(e){T(this).addClass(t.call(this,e,ve(this)));});if((e=me(t)).length)for(;n=this[u++];){if(i=ve(n),r=1===n.nodeType&&" "+de(i)+" "){for(a=0;o=e[a++];){r.indexOf(" "+o+" ")<0&&(r+=o+" ");}i!==(s=de(r))&&n.setAttribute("class",s);}}return this;},removeClass:function removeClass(t){var e,n,r,i,o,a,s,u=0;if(g(t))return this.each(function(e){T(this).removeClass(t.call(this,e,ve(this)));});if(!arguments.length)return this.attr("class","");if((e=me(t)).length)for(;n=this[u++];){if(i=ve(n),r=1===n.nodeType&&" "+de(i)+" "){for(a=0;o=e[a++];){for(;r.indexOf(" "+o+" ")>-1;){r=r.replace(" "+o+" "," ");}}i!==(s=de(r))&&n.setAttribute("class",s);}}return this;},toggleClass:function toggleClass(t,e){var n=typeof t==="undefined"?"undefined":_typeof(t),r="string"===n||Array.isArray(t);return"boolean"==typeof e&&r?e?this.addClass(t):this.removeClass(t):g(t)?this.each(function(n){T(this).toggleClass(t.call(this,n,ve(this),e),e);}):this.each(function(){var e,i,o,a;if(r)for(i=0,o=T(this),a=me(t);e=a[i++];){o.hasClass(e)?o.removeClass(e):o.addClass(e);}else void 0!==t&&"boolean"!==n||((e=ve(this))&&K.set(this,"__className__",e),this.setAttribute&&this.setAttribute("class",e||!1===t?"":K.get(this,"__className__")||""));});},hasClass:function hasClass(t){var e,n,r=0;for(e=" "+t+" ";n=this[r++];){if(1===n.nodeType&&(" "+de(ve(n))+" ").indexOf(e)>-1)return!0;}return!1;}});var ye=/\r/g;T.fn.extend({val:function val(t){var e,n,r,i=this[0];return arguments.length?(r=g(t),this.each(function(n){var i;1===this.nodeType&&(null==(i=r?t.call(this,n,T(this).val()):t)?i="":"number"==typeof i?i+="":Array.isArray(i)&&(i=T.map(i,function(t){return null==t?"":t+"";})),(e=T.valHooks[this.type]||T.valHooks[this.nodeName.toLowerCase()])&&"set"in e&&void 0!==e.set(this,i,"value")||(this.value=i));})):i?(e=T.valHooks[i.type]||T.valHooks[i.nodeName.toLowerCase()])&&"get"in e&&void 0!==(n=e.get(i,"value"))?n:"string"==typeof(n=i.value)?n.replace(ye,""):null==n?"":n:void 0;}}),T.extend({valHooks:{option:{get:function get(t){var e=T.find.attr(t,"value");return null!=e?e:de(T.text(t));}},select:{get:function get(t){var e,n,r,i=t.options,o=t.selectedIndex,a="select-one"===t.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++){if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!F(n.parentNode,"optgroup"))){if(e=T(n).val(),a)return e;s.push(e);}}return s;},set:function set(t,e){for(var n,r,i=t.options,o=T.makeArray(e),a=i.length;a--;){((r=i[a]).selected=T.inArray(T.valHooks.option.get(r),o)>-1)&&(n=!0);}return n||(t.selectedIndex=-1),o;}}}}),T.each(["radio","checkbox"],function(){T.valHooks[this]={set:function set(t,e){if(Array.isArray(e))return t.checked=T.inArray(T(t).val(),e)>-1;}},y.checkOn||(T.valHooks[this].get=function(t){return null===t.getAttribute("value")?"on":t.value;});}),y.focusin="onfocusin"in n;var ge=/^(?:focusinfocus|focusoutblur)$/,xe=function xe(t){t.stopPropagation();};T.extend(T.event,{trigger:function trigger(t,e,r,i){var o,s,u,l,c,f,h,p,v=[r||a],m=d.call(t,"type")?t.type:t,y=d.call(t,"namespace")?t.namespace.split("."):[];if(s=p=u=r=r||a,3!==r.nodeType&&8!==r.nodeType&&!ge.test(m+T.event.triggered)&&(m.indexOf(".")>-1&&(m=(y=m.split(".")).shift(),y.sort()),c=m.indexOf(":")<0&&"on"+m,(t=t[T.expando]?t:new T.Event(m,"object"==(typeof t==="undefined"?"undefined":_typeof(t))&&t)).isTrigger=i?2:3,t.namespace=y.join("."),t.rnamespace=t.namespace?new RegExp("(^|\\.)"+y.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,t.result=void 0,t.target||(t.target=r),e=null==e?[t]:T.makeArray(e,[t]),h=T.event.special[m]||{},i||!h.trigger||!1!==h.trigger.apply(r,e))){if(!i&&!h.noBubble&&!x(r)){for(l=h.delegateType||m,ge.test(l+m)||(s=s.parentNode);s;s=s.parentNode){v.push(s),u=s;}u===(r.ownerDocument||a)&&v.push(u.defaultView||u.parentWindow||n);}for(o=0;(s=v[o++])&&!t.isPropagationStopped();){p=s,t.type=o>1?l:h.bindType||m,(f=(K.get(s,"events")||{})[t.type]&&K.get(s,"handle"))&&f.apply(s,e),(f=c&&s[c])&&f.apply&&Z(s)&&(t.result=f.apply(s,e),!1===t.result&&t.preventDefault());}return t.type=m,i||t.isDefaultPrevented()||h._default&&!1!==h._default.apply(v.pop(),e)||!Z(r)||c&&g(r[m])&&!x(r)&&((u=r[c])&&(r[c]=null),T.event.triggered=m,t.isPropagationStopped()&&p.addEventListener(m,xe),r[m](),t.isPropagationStopped()&&p.removeEventListener(m,xe),T.event.triggered=void 0,u&&(r[c]=u)),t.result;}},simulate:function simulate(t,e,n){var r=T.extend(new T.Event(),n,{type:t,isSimulated:!0});T.event.trigger(r,null,e);}}),T.fn.extend({trigger:function trigger(t,e){return this.each(function(){T.event.trigger(t,e,this);});},triggerHandler:function triggerHandler(t,e){var n=this[0];if(n)return T.event.trigger(t,e,n,!0);}}),y.focusin||T.each({focus:"focusin",blur:"focusout"},function(t,e){var n=function n(t){T.event.simulate(e,t.target,T.event.fix(t));};T.event.special[e]={setup:function setup(){var r=this.ownerDocument||this,i=K.access(r,e);i||r.addEventListener(t,n,!0),K.access(r,e,(i||0)+1);},teardown:function teardown(){var r=this.ownerDocument||this,i=K.access(r,e)-1;i?K.access(r,e,i):(r.removeEventListener(t,n,!0),K.remove(r,e));}};});var be=n.location,we=Date.now(),_e=/\?/;T.parseXML=function(t){var e;if(!t||"string"!=typeof t)return null;try{e=new n.DOMParser().parseFromString(t,"text/xml");}catch(t){e=void 0;}return e&&!e.getElementsByTagName("parsererror").length||T.error("Invalid XML: "+t),e;};var Te=/\[\]$/,ke=/\r?\n/g,Ee=/^(?:submit|button|image|reset|file)$/i,Oe=/^(?:input|select|textarea|keygen)/i;function Se(t,e,n,r){var i;if(Array.isArray(e))T.each(e,function(e,i){n||Te.test(t)?r(t,i):Se(t+"["+("object"==(typeof i==="undefined"?"undefined":_typeof(i))&&null!=i?e:"")+"]",i,n,r);});else if(n||"object"!==_(e))r(t,e);else for(i in e){Se(t+"["+i+"]",e[i],n,r);}}T.param=function(t,e){var n,r=[],i=function i(t,e){var n=g(e)?e():e;r[r.length]=encodeURIComponent(t)+"="+encodeURIComponent(null==n?"":n);};if(Array.isArray(t)||t.jquery&&!T.isPlainObject(t))T.each(t,function(){i(this.name,this.value);});else for(n in t){Se(n,t[n],e,i);}return r.join("&");},T.fn.extend({serialize:function serialize(){return T.param(this.serializeArray());},serializeArray:function serializeArray(){return this.map(function(){var t=T.prop(this,"elements");return t?T.makeArray(t):this;}).filter(function(){var t=this.type;return this.name&&!T(this).is(":disabled")&&Oe.test(this.nodeName)&&!Ee.test(t)&&(this.checked||!ht.test(t));}).map(function(t,e){var n=T(this).val();return null==n?null:Array.isArray(n)?T.map(n,function(t){return{name:e.name,value:t.replace(ke,"\r\n")};}):{name:e.name,value:n.replace(ke,"\r\n")};}).get();}});var Ae=/%20/g,Ce=/#.*$/,Fe=/([?&])_=[^&]*/,Me=/^(.*?):[ \t]*([^\r\n]*)$/gm,Pe=/^(?:GET|HEAD)$/,De=/^\/\//,Ie={},Le={},Re="*/".concat("*"),je=a.createElement("a");function Be(t){return function(e,n){"string"!=typeof e&&(n=e,e="*");var r,i=0,o=e.toLowerCase().match(B)||[];if(g(n))for(;r=o[i++];){"+"===r[0]?(r=r.slice(1)||"*",(t[r]=t[r]||[]).unshift(n)):(t[r]=t[r]||[]).push(n);}};}function Ne(t,e,n,r){var i={},o=t===Le;function a(s){var u;return i[s]=!0,T.each(t[s]||[],function(t,s){var l=s(e,n,r);return"string"!=typeof l||o||i[l]?o?!(u=l):void 0:(e.dataTypes.unshift(l),a(l),!1);}),u;}return a(e.dataTypes[0])||!i["*"]&&a("*");}function Ue(t,e){var n,r,i=T.ajaxSettings.flatOptions||{};for(n in e){void 0!==e[n]&&((i[n]?t:r||(r={}))[n]=e[n]);}return r&&T.extend(!0,t,r),t;}je.href=be.href,T.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:be.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(be.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Re,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":T.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function ajaxSetup(t,e){return e?Ue(Ue(t,T.ajaxSettings),e):Ue(T.ajaxSettings,t);},ajaxPrefilter:Be(Ie),ajaxTransport:Be(Le),ajax:function ajax(t,e){"object"==(typeof t==="undefined"?"undefined":_typeof(t))&&(e=t,t=void 0),e=e||{};var r,i,o,s,u,l,c,f,h,p,d=T.ajaxSetup({},e),v=d.context||d,m=d.context&&(v.nodeType||v.jquery)?T(v):T.event,y=T.Deferred(),g=T.Callbacks("once memory"),x=d.statusCode||{},b={},w={},_="canceled",k={readyState:0,getResponseHeader:function getResponseHeader(t){var e;if(c){if(!s)for(s={};e=Me.exec(o);){s[e[1].toLowerCase()]=e[2];}e=s[t.toLowerCase()];}return null==e?null:e;},getAllResponseHeaders:function getAllResponseHeaders(){return c?o:null;},setRequestHeader:function setRequestHeader(t,e){return null==c&&(t=w[t.toLowerCase()]=w[t.toLowerCase()]||t,b[t]=e),this;},overrideMimeType:function overrideMimeType(t){return null==c&&(d.mimeType=t),this;},statusCode:function statusCode(t){var e;if(t)if(c)k.always(t[k.status]);else for(e in t){x[e]=[x[e],t[e]];}return this;},abort:function abort(t){var e=t||_;return r&&r.abort(e),E(0,e),this;}};if(y.promise(k),d.url=((t||d.url||be.href)+"").replace(De,be.protocol+"//"),d.type=e.method||e.type||d.method||d.type,d.dataTypes=(d.dataType||"*").toLowerCase().match(B)||[""],null==d.crossDomain){l=a.createElement("a");try{l.href=d.url,l.href=l.href,d.crossDomain=je.protocol+"//"+je.host!=l.protocol+"//"+l.host;}catch(t){d.crossDomain=!0;}}if(d.data&&d.processData&&"string"!=typeof d.data&&(d.data=T.param(d.data,d.traditional)),Ne(Ie,d,e,k),c)return k;for(h in(f=T.event&&d.global)&&0==T.active++&&T.event.trigger("ajaxStart"),d.type=d.type.toUpperCase(),d.hasContent=!Pe.test(d.type),i=d.url.replace(Ce,""),d.hasContent?d.data&&d.processData&&0===(d.contentType||"").indexOf("application/x-www-form-urlencoded")&&(d.data=d.data.replace(Ae,"+")):(p=d.url.slice(i.length),d.data&&(d.processData||"string"==typeof d.data)&&(i+=(_e.test(i)?"&":"?")+d.data,delete d.data),!1===d.cache&&(i=i.replace(Fe,"$1"),p=(_e.test(i)?"&":"?")+"_="+we++ +p),d.url=i+p),d.ifModified&&(T.lastModified[i]&&k.setRequestHeader("If-Modified-Since",T.lastModified[i]),T.etag[i]&&k.setRequestHeader("If-None-Match",T.etag[i])),(d.data&&d.hasContent&&!1!==d.contentType||e.contentType)&&k.setRequestHeader("Content-Type",d.contentType),k.setRequestHeader("Accept",d.dataTypes[0]&&d.accepts[d.dataTypes[0]]?d.accepts[d.dataTypes[0]]+("*"!==d.dataTypes[0]?", "+Re+"; q=0.01":""):d.accepts["*"]),d.headers){k.setRequestHeader(h,d.headers[h]);}if(d.beforeSend&&(!1===d.beforeSend.call(v,k,d)||c))return k.abort();if(_="abort",g.add(d.complete),k.done(d.success),k.fail(d.error),r=Ne(Le,d,e,k)){if(k.readyState=1,f&&m.trigger("ajaxSend",[k,d]),c)return k;d.async&&d.timeout>0&&(u=n.setTimeout(function(){k.abort("timeout");},d.timeout));try{c=!1,r.send(b,E);}catch(t){if(c)throw t;E(-1,t);}}else E(-1,"No Transport");function E(t,e,a,s){var l,h,p,b,w,_=e;c||(c=!0,u&&n.clearTimeout(u),r=void 0,o=s||"",k.readyState=t>0?4:0,l=t>=200&&t<300||304===t,a&&(b=function(t,e,n){for(var r,i,o,a,s=t.contents,u=t.dataTypes;"*"===u[0];){u.shift(),void 0===r&&(r=t.mimeType||e.getResponseHeader("Content-Type"));}if(r)for(i in s){if(s[i]&&s[i].test(r)){u.unshift(i);break;}}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||t.converters[i+" "+u[0]]){o=i;break;}a||(a=i);}o=o||a;}if(o)return o!==u[0]&&u.unshift(o),n[o];}(d,k,a)),b=function(t,e,n,r){var i,o,a,s,u,l={},c=t.dataTypes.slice();if(c[1])for(a in t.converters){l[a.toLowerCase()]=t.converters[a];}for(o=c.shift();o;){if(t.responseFields[o]&&(n[t.responseFields[o]]=e),!u&&r&&t.dataFilter&&(e=t.dataFilter(e,t.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l){if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break;}}if(!0!==a)if(a&&t.throws)e=a(e);else try{e=a(e);}catch(t){return{state:"parsererror",error:a?t:"No conversion from "+u+" to "+o};}}}return{state:"success",data:e};}(d,b,k,l),l?(d.ifModified&&((w=k.getResponseHeader("Last-Modified"))&&(T.lastModified[i]=w),(w=k.getResponseHeader("etag"))&&(T.etag[i]=w)),204===t||"HEAD"===d.type?_="nocontent":304===t?_="notmodified":(_=b.state,h=b.data,l=!(p=b.error))):(p=_,!t&&_||(_="error",t<0&&(t=0))),k.status=t,k.statusText=(e||_)+"",l?y.resolveWith(v,[h,_,k]):y.rejectWith(v,[k,_,p]),k.statusCode(x),x=void 0,f&&m.trigger(l?"ajaxSuccess":"ajaxError",[k,d,l?h:p]),g.fireWith(v,[k,_]),f&&(m.trigger("ajaxComplete",[k,d]),--T.active||T.event.trigger("ajaxStop")));}return k;},getJSON:function getJSON(t,e,n){return T.get(t,e,n,"json");},getScript:function getScript(t,e){return T.get(t,void 0,e,"script");}}),T.each(["get","post"],function(t,e){T[e]=function(t,n,r,i){return g(n)&&(i=i||r,r=n,n=void 0),T.ajax(T.extend({url:t,type:e,dataType:i,data:n,success:r},T.isPlainObject(t)&&t));};}),T._evalUrl=function(t){return T.ajax({url:t,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,throws:!0});},T.fn.extend({wrapAll:function wrapAll(t){var e;return this[0]&&(g(t)&&(t=t.call(this[0])),e=T(t,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&e.insertBefore(this[0]),e.map(function(){for(var t=this;t.firstElementChild;){t=t.firstElementChild;}return t;}).append(this)),this;},wrapInner:function wrapInner(t){return g(t)?this.each(function(e){T(this).wrapInner(t.call(this,e));}):this.each(function(){var e=T(this),n=e.contents();n.length?n.wrapAll(t):e.append(t);});},wrap:function wrap(t){var e=g(t);return this.each(function(n){T(this).wrapAll(e?t.call(this,n):t);});},unwrap:function unwrap(t){return this.parent(t).not("body").each(function(){T(this).replaceWith(this.childNodes);}),this;}}),T.expr.pseudos.hidden=function(t){return!T.expr.pseudos.visible(t);},T.expr.pseudos.visible=function(t){return!!(t.offsetWidth||t.offsetHeight||t.getClientRects().length);},T.ajaxSettings.xhr=function(){try{return new n.XMLHttpRequest();}catch(t){}};var ze={0:200,1223:204},We=T.ajaxSettings.xhr();y.cors=!!We&&"withCredentials"in We,y.ajax=We=!!We,T.ajaxTransport(function(t){var _e3,r;if(y.cors||We&&!t.crossDomain)return{send:function send(i,o){var a,s=t.xhr();if(s.open(t.type,t.url,t.async,t.username,t.password),t.xhrFields)for(a in t.xhrFields){s[a]=t.xhrFields[a];}for(a in t.mimeType&&s.overrideMimeType&&s.overrideMimeType(t.mimeType),t.crossDomain||i["X-Requested-With"]||(i["X-Requested-With"]="XMLHttpRequest"),i){s.setRequestHeader(a,i[a]);}_e3=function e(t){return function(){_e3&&(_e3=r=s.onload=s.onerror=s.onabort=s.ontimeout=s.onreadystatechange=null,"abort"===t?s.abort():"error"===t?"number"!=typeof s.status?o(0,"error"):o(s.status,s.statusText):o(ze[s.status]||s.status,s.statusText,"text"!==(s.responseType||"text")||"string"!=typeof s.responseText?{binary:s.response}:{text:s.responseText},s.getAllResponseHeaders()));};},s.onload=_e3(),r=s.onerror=s.ontimeout=_e3("error"),void 0!==s.onabort?s.onabort=r:s.onreadystatechange=function(){4===s.readyState&&n.setTimeout(function(){_e3&&r();});},_e3=_e3("abort");try{s.send(t.hasContent&&t.data||null);}catch(t){if(_e3)throw t;}},abort:function abort(){_e3&&_e3();}};}),T.ajaxPrefilter(function(t){t.crossDomain&&(t.contents.script=!1);}),T.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function textScript(t){return T.globalEval(t),t;}}}),T.ajaxPrefilter("script",function(t){void 0===t.cache&&(t.cache=!1),t.crossDomain&&(t.type="GET");}),T.ajaxTransport("script",function(t){var e,_n;if(t.crossDomain)return{send:function send(r,i){e=T("<script>").prop({charset:t.scriptCharset,src:t.url}).on("load error",_n=function n(t){e.remove(),_n=null,t&&i("error"===t.type?404:200,t.type);}),a.head.appendChild(e[0]);},abort:function abort(){_n&&_n();}};});var Xe=[],Ve=/(=)\?(?=&|$)|\?\?/;T.ajaxSetup({jsonp:"callback",jsonpCallback:function jsonpCallback(){var t=Xe.pop()||T.expando+"_"+we++;return this[t]=!0,t;}}),T.ajaxPrefilter("json jsonp",function(t,e,r){var i,o,a,s=!1!==t.jsonp&&(Ve.test(t.url)?"url":"string"==typeof t.data&&0===(t.contentType||"").indexOf("application/x-www-form-urlencoded")&&Ve.test(t.data)&&"data");if(s||"jsonp"===t.dataTypes[0])return i=t.jsonpCallback=g(t.jsonpCallback)?t.jsonpCallback():t.jsonpCallback,s?t[s]=t[s].replace(Ve,"$1"+i):!1!==t.jsonp&&(t.url+=(_e.test(t.url)?"&":"?")+t.jsonp+"="+i),t.converters["script json"]=function(){return a||T.error(i+" was not called"),a[0];},t.dataTypes[0]="json",o=n[i],n[i]=function(){a=arguments;},r.always(function(){void 0===o?T(n).removeProp(i):n[i]=o,t[i]&&(t.jsonpCallback=e.jsonpCallback,Xe.push(i)),a&&g(o)&&o(a[0]),a=o=void 0;}),"script";}),y.createHTMLDocument=function(){var t=a.implementation.createHTMLDocument("").body;return t.innerHTML="<form></form><form></form>",2===t.childNodes.length;}(),T.parseHTML=function(t,e,n){return"string"!=typeof t?[]:("boolean"==typeof e&&(n=e,e=!1),e||(y.createHTMLDocument?((r=(e=a.implementation.createHTMLDocument("")).createElement("base")).href=a.location.href,e.head.appendChild(r)):e=a),i=M.exec(t),o=!n&&[],i?[e.createElement(i[1])]:(i=xt([t],e,o),o&&o.length&&T(o).remove(),T.merge([],i.childNodes)));var r,i,o;},T.fn.load=function(t,e,n){var r,i,o,a=this,s=t.indexOf(" ");return s>-1&&(r=de(t.slice(s)),t=t.slice(0,s)),g(e)?(n=e,e=void 0):e&&"object"==(typeof e==="undefined"?"undefined":_typeof(e))&&(i="POST"),a.length>0&&T.ajax({url:t,type:i||"GET",dataType:"html",data:e}).done(function(t){o=arguments,a.html(r?T("<div>").append(T.parseHTML(t)).find(r):t);}).always(n&&function(t,e){a.each(function(){n.apply(this,o||[t.responseText,e,t]);});}),this;},T.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(t,e){T.fn[e]=function(t){return this.on(e,t);};}),T.expr.pseudos.animated=function(t){return T.grep(T.timers,function(e){return t===e.elem;}).length;},T.offset={setOffset:function setOffset(t,e,n){var r,i,o,a,s,u,l=T.css(t,"position"),c=T(t),f={};"static"===l&&(t.style.position="relative"),s=c.offset(),o=T.css(t,"top"),u=T.css(t,"left"),("absolute"===l||"fixed"===l)&&(o+u).indexOf("auto")>-1?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),g(e)&&(e=e.call(t,n,T.extend({},s))),null!=e.top&&(f.top=e.top-s.top+a),null!=e.left&&(f.left=e.left-s.left+i),"using"in e?e.using.call(t,f):c.css(f);}},T.fn.extend({offset:function offset(t){if(arguments.length)return void 0===t?this:this.each(function(e){T.offset.setOffset(this,t,e);});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0;},position:function position(){if(this[0]){var t,e,n,r=this[0],i={top:0,left:0};if("fixed"===T.css(r,"position"))e=r.getBoundingClientRect();else{for(e=this.offset(),n=r.ownerDocument,t=r.offsetParent||n.documentElement;t&&(t===n.body||t===n.documentElement)&&"static"===T.css(t,"position");){t=t.parentNode;}t&&t!==r&&1===t.nodeType&&((i=T(t).offset()).top+=T.css(t,"borderTopWidth",!0),i.left+=T.css(t,"borderLeftWidth",!0));}return{top:e.top-i.top-T.css(r,"marginTop",!0),left:e.left-i.left-T.css(r,"marginLeft",!0)};}},offsetParent:function offsetParent(){return this.map(function(){for(var t=this.offsetParent;t&&"static"===T.css(t,"position");){t=t.offsetParent;}return t||bt;});}}),T.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,e){var n="pageYOffset"===e;T.fn[t]=function(r){return Y(this,function(t,r,i){var o;if(x(t)?o=t:9===t.nodeType&&(o=t.defaultView),void 0===i)return o?o[e]:t[r];o?o.scrollTo(n?o.pageXOffset:i,n?i:o.pageYOffset):t[r]=i;},t,r,arguments.length);};}),T.each(["top","left"],function(t,e){T.cssHooks[e]=Xt(y.pixelPosition,function(t,n){if(n)return n=Wt(t,e),Nt.test(n)?T(t).position()[e]+"px":n;});}),T.each({Height:"height",Width:"width"},function(t,e){T.each({padding:"inner"+t,content:e,"":"outer"+t},function(n,r){T.fn[r]=function(i,o){var a=arguments.length&&(n||"boolean"!=typeof i),s=n||(!0===i||!0===o?"margin":"border");return Y(this,function(e,n,i){var o;return x(e)?0===r.indexOf("outer")?e["inner"+t]:e.document.documentElement["client"+t]:9===e.nodeType?(o=e.documentElement,Math.max(e.body["scroll"+t],o["scroll"+t],e.body["offset"+t],o["offset"+t],o["client"+t])):void 0===i?T.css(e,n,s):T.style(e,n,i,s);},e,a?i:void 0,a);};});}),T.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(t,e){T.fn[e]=function(t,n){return arguments.length>0?this.on(e,null,t,n):this.trigger(e);};}),T.fn.extend({hover:function hover(t,e){return this.mouseenter(t).mouseleave(e||t);}}),T.fn.extend({bind:function bind(t,e,n){return this.on(t,null,e,n);},unbind:function unbind(t,e){return this.off(t,null,e);},delegate:function delegate(t,e,n,r){return this.on(e,t,n,r);},undelegate:function undelegate(t,e,n){return 1===arguments.length?this.off(t,"**"):this.off(e,t||"**",n);}}),T.proxy=function(t,e){var n,r,i;if("string"==typeof e&&(n=t[e],e=t,t=n),g(t))return r=u.call(arguments,2),(i=function i(){return t.apply(e||this,r.concat(u.call(arguments)));}).guid=t.guid=t.guid||T.guid++,i;},T.holdReady=function(t){t?T.readyWait++:T.ready(!0);},T.isArray=Array.isArray,T.parseJSON=JSON.parse,T.nodeName=F,T.isFunction=g,T.isWindow=x,T.camelCase=$,T.type=_,T.now=Date.now,T.isNumeric=function(t){var e=T.type(t);return("number"===e||"string"===e)&&!isNaN(t-parseFloat(t));},void 0===(r=function(){return T;}.apply(e,[]))||(t.exports=r);var Ye=n.jQuery,He=n.$;return T.noConflict=function(t){return n.$===T&&(n.$=He),t&&n.jQuery===T&&(n.jQuery=Ye),T;},i||(n.jQuery=n.$=T),T;});},function(t,e,n){window,t.exports=function(t){var e={};function n(r){if(e[r])return e[r].exports;var i=e[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports;}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r});},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0});},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==(typeof t==="undefined"?"undefined":_typeof(t))&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t){n.d(r,i,function(e){return t[e];}.bind(null,i));}return r;},n.n=function(t){var e=t&&t.__esModule?function(){return t.default;}:function(){return t;};return n.d(e,"a",e),e;},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e);},n.p="",n(n.s=1);}([function(t,e){var n={null:"null"};t.exports={mix:function mix(t,e,n){return t+(e-t)*n;},concatArrays:function t(e,n,r){if(n)for(var i=!0,o=n.length,a=0;a<o;a++){var s=n[a];if(s.arrays)for(var u in i=!0,s.arrays){var l=s.arrays[u];e.arrays?e.arrays[u]||(e.arrays[u]={arr:[],size:l.size||3,type:l.type}):(e.arrays={},e.arrays[u]={arr:[],size:l.size||3,type:l.type}),"IBO"===e.arrays[u].type?(e.arrays[u].arr=e.arrays[u].arr.concat(l.arr.map(function(t){return t+r;})),r+=s.verticesNumber):e.arrays[u].arr=e.arrays[u].arr.concat(l.arr),i&&"VBO"===e.arrays[u].type&&(i=!1,e.batchIndices=e.batchIndices.concat(new Array(s.verticesNumber).fill(s.batchIndex)));}r=t(e,s.children,r);}return r;},premultiplyParentMatrices:function premultiplyParentMatrices(t){var e=t.parent;return t.matrix.premultiplyArray(e.scaleMatrix.arr).premultiplyArray(e.rotationMatrix.arr).premultiplyArrayPosition(e.position).switch[n[e.parent]](e);}};},function(t,e,n){t.exports=n(2);},function(t,e,n){function r(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t;}var i=n(3),o=n(35);t.exports=function(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{},i=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(i=i.concat(Object.getOwnPropertySymbols(n).filter(function(t){return Object.getOwnPropertyDescriptor(n,t).enumerable;}))),i.forEach(function(e){r(t,e,n[e]);});}return t;}({WebGL:i,Loader:o},{version:"0.0.2065"});},function(t,e,n){function r(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}var i=n(4),o=n(5),a=n(6),s=n(7),u=n(8),l=n(9),c=n(10),f=n(11),h=n(12),p=n(13),d=n(14),v=n(15),m=n(16),y=n(17),g=n(18),x=n(19),b=n(20),w=n(21),_=n(22),T=n(23),k=n(24),E=n(25),O=n(26),S=n(27),A=n(28),C=n(29),F=n(30),M=n(31),P=n(32),D=n(33),I=n(34),L=n(0);t.exports=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,t),this.init(e);}return function(t,e,n){e&&r(t.prototype,e);}(t,[{key:"init",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{version:1,class:"WebGL".concat(t.version||"","Context"),errorCallback:null,canvas:t.canvas||document.createElement("canvas"),antialias:!0,alpha:!1,premultipliedAlpha:!1},t),this.getWebGLContext(),this.frameTime={x:0},this.globalTime={x:0},this.lastTime={x:new Date()},this.transitions=[],this.clbk=function(){return 0;},this.DataInt1=o(this),this.DataInt2=a(this),this.DataInt3=s(this),this.DataInt4=u(this),this.DataFloat1=l(this),this.DataFloat2=c(this),this.DataFloat3=f(this),this.DataFloat4=h(this),this.DataArrayInt2=p(this),this.DataArrayInt3=d(this),this.DataArrayInt4=v(this),this.DataArrayFloat2=m(this),this.DataArrayFloat3=y(this),this.DataArrayFloat4=g(this),this.Mat4=x(this),this.VBO=b(this),this.MVBO=w(this),this.IBO=_(this),this.MIBO=T(this),this.VAO=k(this),this.UBO=E(this),this.Texture2D=O(this),this.RBO=S(this),this.FBO=A(this),this.Offscreen=C(this),this.OffscreenMultisample=F(this),this.Material=M(this),this.Obj=P(this);var e=D(this);Object.assign(this,e),Object.assign(this,{math:I,utility:L}),this.xOrig=0,this.yOrig=0,this.width=0,this.height=0,this.currentMIBO=null,this.currentMVBO=null,this.objects={},this.materials={},this.currentObject=new this.Obj(),this.currentMatrix=new this.Mat4(),this.currentNormalMatrix=new this.Mat4(),Object.assign(this,i(this)),this.applyOptions(t);}},{key:"applyOptions",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{anisotropy:!0,minDpr:1,maxDpr:999,preprocessing:!1,glsl300:!1},t);var e=this.WebGLRenderingContext;this.dpr=Math.min(Math.max(window.devicePixelRatio||1,this.minDpr),this.maxDpr),this.maxTextureUnits=e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS),this.textureUnits=new Array(this.maxTextureUnits).fill(null).map(function(t,n){return e["TEXTURE".concat(n)];}),this.maxPrecision={vs:{int:this.getMaxPrecision(),float:this.getMaxPrecision("vs","float")},fs:{int:this.getMaxPrecision("fs"),float:this.getMaxPrecision("fs","float")}},this.anisotropy&&(this.anisotropy=e.getExtension("EXT_texture_filter_anisotropic")||e.getExtension("MOZ_EXT_texture_filter_anisotropic")||e.getExtension("WEBKIT_EXT_texture_filter_anisotropic"),this.maxAnisotropy=this.anisotropy?e.getParameter(this.anisotropy.MAX_TEXTURE_MAX_ANISOTROPY_EXT):0);}},{key:"getWebGLContext",value:function value(){var t={antialias:this.antialias,alpha:this.alpha,premultipliedAlpha:this.premultipliedAlpha};try{this.WebGLRenderingContext=this.canvas.getContext("webgl".concat(1===this.version?"":this.version),t);}catch(t){if(!this.errorCallback)throw new Error(t);this.errorCallback(t);}}}]),t;}();},function(t,e){t.exports=function(t){var e=t.WebGLRenderingContext,n=e.VERTEX_SHADER,r=e.FRAGMENT_SHADER,i=e.TEXTURE_2D,o=e.RENDERBUFFER,a=e.FRAMEBUFFER,s=e.BLEND,u=e.DEPTH_TEST,l=e.CULL_FACE,c=e.ARRAY_BUFFER,f=e.ELEMENT_ARRAY_BUFFER,h=e.UNIFORM_BUFFER,p={vs:n,fs:r};return{setDpr:function setDpr(){this.dpr=Math.min(Math.max(window.devicePixelRatio||1,this.minDpr),this.maxDpr);},viewport:function viewport(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0;e.viewport(t*this.dpr,n*this.dpr,r*this.dpr,i*this.dpr);},setSize:function setSize(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0;this.setDpr(),this.xOrig=t,this.yOrig=n,this.width=r,this.height=i,this.canvas.width=r*this.dpr,this.canvas.height=i*this.dpr,this.canvas.style.width="".concat(r,"px"),this.canvas.style.height="".concat(i,"px"),e.viewport(t*this.dpr,n*this.dpr,r*this.dpr,i*this.dpr);},updateTime:function updateTime(){var t=new Date();this.frameTime.x=t-this.lastTime.x,this.lastTime.x=t,this.globalTime.x+=this.frameTime.x;},updateTransitions:function updateTransitions(){for(var t=this.transitions,e=t.length,n=0;n<e;n++){t[e-n-1].updateTransitionFunction();}},getMaxPrecision:function getMaxPrecision(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"vs",n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"int",r=e.getShaderPrecisionFormat(p[t],e["MEDIUM_".concat(n.toUpperCase())]),i=e.getShaderPrecisionFormat(p[t],e["HIGH_".concat(n.toUpperCase())]),o="lowp";return i.precision+i.rangeMin+i.rangeMax?o="highp":r.precision+r.rangeMin+r.rangeMax&&(o="mediump"),o;},disableTexture2D:function disableTexture2D(){return e.bindTexture(i,null),this;},disableRBO:function disableRBO(){return e.bindRenderbuffer(o,null),this;},framebufferRenderbuffer:function framebufferRenderbuffer(t,n,r){return e.framebufferRenderbuffer(t,n,o,r.renderbuffer),this;},framebufferTexture2D:function framebufferTexture2D(t,n,r,i){return e.framebufferTexture2D(t,n,r,i.texture,0),this;},renderbufferStorage:function renderbufferStorage(t,n,r){return e.renderbufferStorage(o,t,n,r),this;},renderbufferStorageMultisample:function renderbufferStorageMultisample(t,n,r,i){return e.renderbufferStorageMultisample(o,t,n,r,i),this;},disableFBO:function disableFBO(){return e.bindFramebuffer(a,null),this;},enableBlend:function enableBlend(){return this.currentObject.enableBlend(),this;},enableBlendSeparate:function enableBlendSeparate(){return this.currentObject.enableBlendSeparate(),this;},disableBlend:function disableBlend(){return e.disable(s),this;},enableDepthTest:function enableDepthTest(){return this.currentObject.enableDepthTest(),this;},disableDepthTest:function disableDepthTest(){return e.disable(u),this;},enableCullFace:function enableCullFace(){return this.currentObject.enableCullFace(),this;},disableCullFace:function disableCullFace(){return e.disable(l),this;},enableVAO:function enableVAO(){return this.currentObject.enableVAO(),this;},disableVAO:function disableVAO(){return e.bindVertexArray(null),this;},enableBuffers:function enableBuffers(){return this.currentObject.enableBuffers(),this;},disableVBO:function disableVBO(){return e.bindBuffer(c,null),this;},disableIBO:function disableIBO(){return e.bindBuffer(f,null),this;},disableUBO:function disableUBO(){return e.bindBuffer(h,null),this;},disableMaterial:function disableMaterial(){return e.useProgram(null),this;},updateMaterialUniforms:function updateMaterialUniforms(){return this.currentObject.updateMaterialUniforms(),this;},updateAllMaterialUniforms:function updateAllMaterialUniforms(){return this.currentObject.updateAllMaterialUniforms(),this;},updateMaterialAttributes:function updateMaterialAttributes(){return this.currentObject.updateMaterialAttributes(),this;},updateMatrix:function updateMatrix(){return this.currentObject.updateMatrix(),this;}};};},function(t,e){t.exports=function(){};},function(t,e){t.exports=function(){};},function(t,e){t.exports=function(){};},function(t,e){t.exports=function(){};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}var r=function r(){};t.exports=function(t){var e=t.WebGLRenderingContext,i=t.transitions,o=t.frameTime,a=[function(t){t.x=t.transitionFrom+t.transitionFunc(t.transitionInterpolation)*(t.transitionTo-t.transitionFrom),t.transitionCurrentTime+=o.x;},function(t){t.x=t.transitionTo,t.cancelTransition();}],s=[function(t){t.x=t.transitionFrom+t.transitionFunc(t.transitionInterpolation)*(t.transitionTo-t.transitionFrom),t.transitionCurrentTime+=o.x;},function(t){t.x=t.transitionTo,t.cancelTransition(),t.transitionOnEnd();}],u=[r,function(t){var e=i[i.length-1];e.transitionIndex=t,i[t].inTransitions--,i[t]=e,i.pop();}];return function(){function l(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,l),this.class="DataFloat1",this.applyOptions(t);}return function(t,e,r){e&&n(t.prototype,e);}(l,[{key:"applyOptions",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",x:0,updated:!0,excludeMaterials:[]},t),this.inTransitions=0,this.transitionIndex=0,this.transitionFunc=null,this.transitionDuration=null,this.transitionFrom=null,this.transitionTo=null,this.transitionOnProgress=null,this.transitionOnEnd=null,this.transitionCurrentTime=null,this.transitionInterpolation=null,this.updateTransitionFunction=null,this.materials=[];}},{key:"uniform",value:function value(t){return t.uniforms||(t.uniforms=[]),t.uniforms.push(this),"uniform float ".concat(this.name,";");}},{key:"set",value:function value(t){this.x=t||this.x;}},{key:"reset",value:function value(){this.x=0;}},{key:"setWithUniforms",value:function value(t){this.x=t||this.x,this.updateUniforms();}},{key:"updateUniforms",value:function value(){for(var t=this.materials,n=t.length,r=0;r<n;r++){e.useProgram(t[r].program),this.updateUniform(t[r].uniformLocations[this.name]);}}},{key:"initVertexAttrib",value:function value(t){e.vertexAttrib1f(t,this.x);}},{key:"updateVertexAttrib",value:function value(t){e.vertexAttrib1f(t,this.x);}},{key:"initUniform",value:function value(t){e.uniform1f(t,this.x);}},{key:"updateUniform",value:function value(t){e.uniform1f(t,this.x);}},{key:"initUBOSubdata",value:function value(t){t.push(this.x);}},{key:"updateUBOSubdata",value:function value(t,e){t[e]=this.x;}},{key:"cancelTransition",value:function value(){u[this.inTransitions](this.transitionIndex);}},{key:"setTransition",value:function value(t){this.cancelTransition(),this.transitionFunc=t.func,this.transitionDuration=t.duration,this.transitionFrom=this.x,this.transitionTo=t.to,this.transitionCurrentTime=o.x,this.updateTransitionFunction=this.updateTransition,this.inTransitions++,this.transitionIndex=i.push(this)-1;}},{key:"updateTransition",value:function value(){this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration,a[2+~(1-1e-10*~~this.transitionInterpolation)](this);}},{key:"setTransitionWithUniforms",value:function value(t){this.cancelTransition(),this.transitionFunc=t.func,this.transitionDuration=t.duration,this.transitionFrom=this.x,this.transitionTo=t.to,this.transitionCurrentTime=o.x,this.updateTransitionFunction=this.updateTransitionWithUniforms,this.inTransitions++,this.transitionIndex=i.push(this)-1;}},{key:"updateTransitionWithUniforms",value:function value(){this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration,a[2+~(1-1e-10*~~this.transitionInterpolation)](this),this.updateUniforms();}},{key:"setCallbackTransition",value:function value(t){this.cancelTransition(),this.transitionFunc=t.func,this.transitionDuration=t.duration,this.transitionFrom=this.x,this.transitionTo=t.to,this.transitionCurrentTime=o.x,this.updateTransitionFunction=this.updateCallbackTransition,this.inTransitions++,this.transitionIndex=i.push(this)-1;}},{key:"updateCallbackTransition",value:function value(){this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration,a[2+~(1-1e-10*~~this.transitionInterpolation)](this),t.clbk();}},{key:"setCallbackTransitionWithUniforms",value:function value(t){this.cancelTransition(),this.transitionFunc=t.func,this.transitionDuration=t.duration,this.transitionFrom=this.x,this.transitionTo=t.to,this.transitionCurrentTime=o.x,this.updateTransitionFunction=this.updateCallbackTransitionWithUniforms,this.inTransitions++,this.transitionIndex=i.push(this)-1;}},{key:"updateCallbackTransitionWithUniforms",value:function value(){this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration,a[2+~(1-1e-10*~~this.transitionInterpolation)](this),this.updateUniforms(),t.clbk();}},{key:"setExtendedTransition",value:function value(t){this.cancelTransition(),this.transitionFunc=t.func,this.transitionDuration=t.duration,this.transitionFrom=this.x,this.transitionTo=t.to,this.transitionOnProgress=t.onProgress||r,this.transitionOnEnd=t.onEnd||r,this.transitionCurrentTime=o.x,this.updateTransitionFunction=this.updateExtendedTransition,this.inTransitions++,this.transitionIndex=i.push(this)-1;}},{key:"updateExtendedTransition",value:function value(){this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration,s[2+~(1-1e-10*~~this.transitionInterpolation)](this),this.transitionOnProgress();}},{key:"setExtendedTransitionWithUniforms",value:function value(t){this.cancelTransition(),this.transitionFunc=t.func,this.transitionDuration=t.duration,this.transitionFrom=this.x,this.transitionTo=t.to,this.transitionOnProgress=t.onProgress||r,this.transitionOnEnd=t.onEnd||r,this.transitionCurrentTime=o.x,this.updateTransitionFunction=this.updateExtendedTransitionWithUniforms,this.inTransitions++,this.transitionIndex=i.push(this)-1;}},{key:"updateExtendedTransitionWithUniforms",value:function value(){this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration,s[2+~(1-1e-10*~~this.transitionInterpolation)](this),this.updateUniforms(),this.transitionOnProgress();}}]),l;}();};},function(t,e){t.exports=function(){};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}t.exports=function(t){var e=t.WebGLRenderingContext;return function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,t),this.class="DataFloat3",this.applyOptions(e);}return function(t,e,r){e&&n(t.prototype,e);}(t,[{key:"applyOptions",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",x:0,y:0,z:0,updated:!0,excludeMaterials:[]},t),this.transitionFunc=null,this.transitionDuration=null,this.transitionFrom={},this.transitionTo=null,this.transitionOnProgress=null,this.transitionOnEnd=null,this.transitionCurrentTime=null,this.updateTransitionFunction=null,this.materials=[];}},{key:"uniform",value:function value(t){return t.uniforms||(t.uniforms=[]),t.uniforms.push(this),"uniform vec3 ".concat(this.name,";");}},{key:"set",value:function value(t,e,n){this.x=t||this.x,this.y=e||this.y,this.z=n||this.z;}},{key:"reset",value:function value(){this.x=0,this.y=0,this.z=0;}},{key:"setWithUniforms",value:function value(t,e,n){this.x=t||this.x,this.y=e||this.y,this.z=n||this.z,this.updateUniforms();}},{key:"updateUniforms",value:function value(){for(var t=this.materials,n=t.length,r=0;r<n;r++){e.useProgram(t[r].program),this.updateUniform(t[r].uniformLocations[this.name]);}}},{key:"initVertexAttrib",value:function value(t){e.vertexAttrib3f(t,this.x,this.y,this.z);}},{key:"updateVertexAttrib",value:function value(t){e.vertexAttrib3f(t,this.x,this.y,this.z);}},{key:"initUniform",value:function value(t){e.uniform3f(t,this.x,this.y,this.z);}},{key:"updateUniform",value:function value(t){e.uniform3f(t,this.x,this.y,this.z);}},{key:"initUBOSubdata",value:function value(t){t.push(this.x,this.y,this.z);}},{key:"updateUBOSubdata",value:function value(t,e){t[e]=this.x,t[e+1]=this.y,t[e+2]=this.z;}},{key:"multiplyScalar",value:function value(t){this.x*=t,this.y*=t,this.z*=t;}},{key:"applyMatrix4",value:function value(t){var e=this.x,n=this.y,r=this.z,i=t.arr,o=1/(i[3]*e+i[7]*n+i[11]*r+i[15]);this.x=(i[0]*e+i[4]*n+i[8]*r+i[12])*o,this.y=(i[1]*e+i[5]*n+i[9]*r+i[13])*o,this.z=(i[2]*e+i[6]*n+i[10]*r+i[14])*o;}},{key:"applyMatrix4Array",value:function value(t){var e=this.x,n=this.y,r=this.z,i=1/(t[3]*e+t[7]*n+t[11]*r+t[15]);this.x=(t[0]*e+t[4]*n+t[8]*r+t[12])*i,this.y=(t[1]*e+t[5]*n+t[9]*r+t[13])*i,this.z=(t[2]*e+t[6]*n+t[10]*r+t[14])*i;}},{key:"cloneApplyMatrix4",value:function value(t){var e=this.x,n=this.y,r=this.z,i=t.arr,o=1/(i[3]*e+i[7]*n+i[11]*r+i[15]);return new this.constructor({x:(i[0]*e+i[4]*n+i[8]*r+i[12])*o,y:(i[1]*e+i[5]*n+i[9]*r+i[13])*o,z:(i[2]*e+i[6]*n+i[10]*r+i[14])*o});}},{key:"cloneApplyMatrix4Array",value:function value(t){var e=this.x,n=this.y,r=this.z,i=1/(t[3]*e+t[7]*n+t[11]*r+t[15]);return new this.constructor({x:(t[0]*e+t[4]*n+t[8]*r+t[12])*i,y:(t[1]*e+t[5]*n+t[9]*r+t[13])*i,z:(t[2]*e+t[6]*n+t[10]*r+t[14])*i});}},{key:"cloneObjApplyMatrix4",value:function value(t){var e=this.x,n=this.y,r=this.z,i=t.arr,o=1/(i[3]*e+i[7]*n+i[11]*r+i[15]);return{x:(i[0]*e+i[4]*n+i[8]*r+i[12])*o,y:(i[1]*e+i[5]*n+i[9]*r+i[13])*o,z:(i[2]*e+i[6]*n+i[10]*r+i[14])*o};}},{key:"cloneObjApplyMatrix4Array",value:function value(t){var e=this.x,n=this.y,r=this.z,i=1/(t[3]*e+t[7]*n+t[11]*r+t[15]);return{x:(t[0]*e+t[4]*n+t[8]*r+t[12])*i,y:(t[1]*e+t[5]*n+t[9]*r+t[13])*i,z:(t[2]*e+t[6]*n+t[10]*r+t[14])*i};}},{key:"divideScalar",value:function value(t){this.multiplyScalar(1/t);}},{key:"length",value:function value(){var t=this.x,e=this.y,n=this.z;return Math.sqrt(t*t+e*e+n*n);}},{key:"normalize",value:function value(){this.divideScalar(this.length()||1);}},{key:"setFromMatrixColumn",value:function value(t,e){this.fromArray(t.arr,4*e);}},{key:"fromArray",value:function value(t,e){void 0===e&&(e=0),this.x=t[e],this.y=t[e+1],this.z=t[e+2];}}]),t;}();};},function(t,e){t.exports=function(t){var e=t.WebGLRenderingContext;return function t(){(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,t),this.test=e,this.class="DataFloat4";};};},function(t,e){t.exports=function(){};},function(t,e){t.exports=function(){};},function(t,e){t.exports=function(){};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}var r=function r(){};t.exports=function(t){var e=t.WebGLRenderingContext,i=t.transitions,o=t.frameTime,a=[function(t){var e=t.transitionFunc(t.transitionInterpolation),n=t.transitionFrom,r=t.transitionTo,i=t.arr;i[0]=n[0]+e*(r[0]-n[0]),i[1]=n[1]+e*(r[1]-n[1]),t.transitionCurrentTime+=o.x;},function(t){var e=t.transitionTo,n=t.arr;n[0]=e[0],n[1]=e[1],t.cancelTransition();}],s=[function(t){var e=t.transitionFunc(t.transitionInterpolation),n=t.transitionFrom,r=t.transitionTo,i=t.arr;i[0]=n[0]+e*(r[0]-n[0]),i[1]=n[1]+e*(r[1]-n[1]),t.transitionCurrentTime+=o.x;},function(t){var e=t.transitionTo,n=t.arr;n[0]=e[0],n[1]=e[1],t.cancelTransition(),t.transitionOnEnd();}],u=[r,function(t){var e=i[i.length-1];e.transitionIndex=t,i[t].inTransitions--,i[t]=e,i.pop();}];return function(){function l(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,l),this.class="DataArrayFloat2",this.applyOptions(t);}return function(t,e,r){e&&n(t.prototype,e);}(l,[{key:"applyOptions",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",arr:t.arr||new Float32Array([0,0]),updated:!0,excludeMaterials:[]},t),this.inTransitions=0,this.transitionIndex=0,this.transitionFunc=null,this.transitionDuration=null,this.transitionFrom=null,this.transitionTo=null,this.transitionOnProgress=null,this.transitionOnEnd=null,this.transitionCurrentTime=null,this.updateTransitionFunction=null,this.materials=[];}},{key:"uniform",value:function value(t){return t.uniforms||(t.uniforms=[]),t.uniforms.push(this),"uniform vec2 ".concat(this.name,";");}},{key:"set",value:function value(t,e){var n=this.arr;n[0]=t||n[0],n[1]=e||n[1];}},{key:"reset",value:function value(){var t=this.arr;t[0]=0,t[1]=0;}},{key:"setWithUniforms",value:function value(t,e){var n=this.arr;n[0]=t||n[0],n[1]=e||n[1],this.updateUniforms();}},{key:"updateUniforms",value:function value(){for(var t=this.materials,n=t.length,r=0;r<n;r++){e.useProgram(t[r].program),this.updateUniform(t[r].uniformLocations[this.name]);}}},{key:"initVertexAttrib",value:function value(t){e.vertexAttrib2fv(t,this.arr);}},{key:"updateVertexAttrib",value:function value(t){e.vertexAttrib2fv(t,this.arr);}},{key:"initUniform",value:function value(t){e.uniform2fv(t,this.arr);}},{key:"updateUniform",value:function value(t){e.uniform2fv(t,this.arr);}},{key:"initUBOSubdata",value:function value(t){var e=this.arr;t.push(e[0],e[1]);}},{key:"updateUBOSubdata",value:function value(t,e){var n=this.arr;t[e]=n[0],t[e+1]=n[1];}},{key:"cancelTransition",value:function value(){u[this.inTransitions](this.transitionIndex);}},{key:"setTransition",value:function value(e){this.cancelTransition(),this.transitionFunc=e.func,this.transitionDuration=e.duration,this.transitionFrom=this.arr.slice(),this.transitionTo=e.to,this.transitionCurrentTime=o.x,this.updateTransitionFunction=this.updateTransition,t.transitions.push(this);}},{key:"updateTransition",value:function value(){a[~~(this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration)](this);}},{key:"setCallbackTransition",value:function value(e){this.cancelTransition(),this.transitionFunc=e.func,this.transitionDuration=e.duration,this.transitionFrom=this.arr.slice(),this.transitionTo=e.to,this.transitionCurrentTime=o.x,this.updateTransitionFunction=this.updateCallbackTransition,t.transitions.push(this);}},{key:"updateCallbackTransition",value:function value(){a[~~(this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration)](this);}},{key:"setCallbackTransitionWithUniforms",value:function value(t){this.cancelTransition(),this.transitionFunc=t.func,this.transitionDuration=t.duration,this.transitionFrom=this.arr.slice(),this.transitionTo=t.to,this.transitionCurrentTime=o.x,this.updateTransitionFunction=this.updateCallbackTransitionWithUniforms,this.inTransitions++,this.transitionIndex=i.push(this)-1;}},{key:"updateCallbackTransitionWithUniforms",value:function value(){this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration,a[2+~(1-1e-10*~~this.transitionInterpolation)](this),this.updateUniforms(),t.clbk();}},{key:"setExtendedTransition",value:function value(e){this.cancelTransition(),this.transitionFunc=e.func,this.transitionDuration=e.duration,this.transitionFrom=this.arr.slice(),this.transitionTo=e.to,this.transitionOnProgress=e.onProgress||r,this.transitionOnEnd=e.onEnd||r,this.transitionCurrentTime=o.x,this.updateTransitionFunction=this.updateExtendedTransition,t.transitions.push(this);}},{key:"updateExtendedTransition",value:function value(){s[~~(this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration)](this);}}]),l;}();};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}t.exports=function(t){var e=t.WebGLRenderingContext;return function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,t),this.class="DataArrayFloat3",this.applyOptions(e);}return function(t,e,r){e&&n(t.prototype,e);}(t,[{key:"applyOptions",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",arr:t.arr||new Float32Array([0,0,0]),updated:!0,excludeMaterials:[]},t),this.transitionFunc=null,this.transitionDuration=null,this.transitionFrom=null,this.transitionTo=null,this.transitionOnProgress=null,this.transitionOnEnd=null,this.transitionCurrentTime=null,this.updateTransitionFunction=null,this.materials=[];}},{key:"set",value:function value(t,e,n){var r=this.arr;r[0]=t||r[0],r[1]=e||r[1],r[2]=n||r[2];}},{key:"reset",value:function value(){var t=this.arr;t[0]=0,t[1]=0,t[2]=0;}},{key:"setWithUniforms",value:function value(t,e,n){var r=this.arr;r[0]=t||r[0],r[1]=e||r[1],r[2]=n||r[2],this.updateUniforms();}},{key:"updateUniforms",value:function value(){for(var t=this.materials,n=t.length,r=0;r<n;r++){e.useProgram(t[r].program),this.updateUniform(t[r].uniformLocations[this.name]);}}},{key:"initVertexAttrib",value:function value(t){e.vertexAttrib3fv(t,this.arr);}},{key:"updateVertexAttrib",value:function value(t){e.vertexAttrib3fv(t,this.arr);}},{key:"initUniform",value:function value(t){e.uniform3fv(t,this.arr);}},{key:"updateUniform",value:function value(t){e.uniform3fv(t,this.arr);}},{key:"initUBOSubdata",value:function value(t){var e=this.arr;t.push(e[0],e[1],e[2]);}},{key:"updateUBOSubdata",value:function value(t,e){var n=this.arr;t[e]=n[0],t[e+1]=n[1],t[e+2]=n[2];}}]),t;}();};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}var r=function r(){return 0;};t.exports=function(t){var e=t.WebGLRenderingContext;return[r].undefined=function(e){return t.transitions.splice(e,1);},function(){function i(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,i),this.class="DataArrayFloat4",this.applyOptions(t);}return function(t,e,r){e&&n(t.prototype,e);}(i,[{key:"applyOptions",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",arr:t.arr||new Float32Array([0,0,0,1]),updated:!0,excludeMaterials:[]},t),this.transitionFunc=null,this.transitionDuration=null,this.transitionFrom=null,this.transitionTo=null,this.transitionOnProgress=null,this.transitionOnEnd=null,this.transitionCurrentTime=null,this.updateTransitionFunction=null,this.materials=[];}},{key:"set",value:function value(t,e,n,r){var i=this.arr;i[0]=t||i[0],i[1]=e||i[1],i[2]=n||i[2],i[3]=r||i[3];}},{key:"reset",value:function value(){var t=this.arr;t[0]=0,t[1]=0,t[2]=0,t[3]=1;}},{key:"setWithUniforms",value:function value(t,e,n,r){var i=this.arr;i[0]=t||i[0],i[1]=e||i[1],i[2]=n||i[2],i[3]=r||i[3],this.updateUniforms();}},{key:"updateUniforms",value:function value(){for(var t=this.materials,n=t.length,r=0;r<n;r++){e.useProgram(t[r].program),this.updateUniform(t[r].uniformLocations[this.name]);}}},{key:"initVertexAttrib",value:function value(t){e.vertexAttrib4fv(t,this.arr);}},{key:"updateVertexAttrib",value:function value(t){e.vertexAttrib4fv(t,this.arr);}},{key:"initUniform",value:function value(t){e.uniform4fv(t,this.arr);}},{key:"updateUniform",value:function value(t){e.uniform4fv(t,this.arr);}},{key:"initUBOSubdata",value:function value(t){var e=this.arr;t.push(e[0],e[1],e[2],e[3]);}},{key:"updateUBOSubdata",value:function value(t,e){var n=this.arr;t[e]=n[0],t[e+1]=n[1],t[e+2]=n[2],t[e+3]=n[3];}},{key:"setTransition",value:function value(e){this.cancelTransition(),this.transitionFunc=e.func,this.transitionDuration=e.duration,this.transitionFrom=this.arr.slice(),this.transitionTo=e.to,this.transitionCurrentTime=t.frameTime.x,this.updateTransitionFunction=this.updateTransition,t.transitions.push(this);}},{key:"setCallbackTransition",value:function value(e){this.cancelTransition(),this.transitionFunc=e.func,this.transitionDuration=e.duration,this.transitionFrom=this.arr.slice(),this.transitionTo=e.to,this.transitionCurrentTime=t.frameTime.x,this.updateTransitionFunction=this.updateCallbackTransition,t.transitions.push(this);}},{key:"setExtendedTransition",value:function value(e){this.cancelTransition(),this.transitionFunc=e.func,this.transitionDuration=e.duration,this.transitionFrom=this.arr.slice(),this.transitionTo=e.to,this.transitionOnProgress=e.onProgress||r,this.transitionOnEnd=e.onEnd||r,this.transitionCurrentTime=t.frameTime.x,this.updateTransitionFunction=this.updateExtendedTransition,t.transitions.push(this);}}]),i;}();};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}t.exports=function(t){var e=t.WebGLRenderingContext;return function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,t),this.class="Mat4",this.applyOptions(e);}return function(t,e,r){e&&n(t.prototype,e);}(t,[{key:"applyOptions",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",arr:t.arr||new Float32Array([1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1]),updated:!0,excludeMaterials:[]},t),this.transitionFunc=null,this.transitionDuration=null,this.transitionFrom=null,this.transitionTo=null,this.transitionOnProgress=null,this.transitionOnEnd=null,this.transitionCurrentTime=null,this.updateTransitionFunction=null,this.materials=[];}},{key:"uniform",value:function value(t){return t.uniforms||(t.uniforms=[]),t.uniforms.push(this),"uniform mat4 ".concat(this.name,";");}},{key:"set",value:function value(t){this.arr=t.slice();}},{key:"reset",value:function value(){var t=this.arr;t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=1,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=1,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1;}},{key:"updateUniforms",value:function value(){for(var t=this.materials,n=t.length,r=0;r<n;r++){e.useProgram(t[r].program),this.updateUniform(t[r].uniformLocations[this.name]);}}},{key:"initUniform",value:function value(t){e.uniformMatrix4fv(t,!1,this.arr);}},{key:"updateUniform",value:function value(t){e.uniformMatrix4fv(t,!1,this.arr);}},{key:"initUBOSubdata",value:function value(t){var e=this.arr;t.push(e[0],e[1],e[2],e[3],e[4],e[5],e[6],e[7],e[8],e[9],e[10],e[11],e[12],e[13],e[14],e[15]);}},{key:"updateUBOSubdata",value:function value(t,e){var n=this.arr;t[e]=n[0],t[e+1]=n[1],t[e+2]=n[2],t[e+3]=n[3],t[e+4]=n[4],t[e+5]=n[5],t[e+6]=n[6],t[e+7]=n[7],t[e+8]=n[8],t[e+9]=n[9],t[e+10]=n[10],t[e+11]=n[11],t[e+12]=n[12],t[e+13]=n[13],t[e+14]=n[14],t[e+15]=n[15];}},{key:"setRotationFromQuaternion",value:function value(t){var e=this.arr,n=t.x,r=t.y,i=t.z,o=t.w,a=n+n,s=r+r,u=i+i,l=n*a,c=n*s,f=n*u,h=r*s,p=r*u,d=i*u,v=o*a,m=o*s,y=o*u;e[0]=1-(h+d),e[1]=c+y,e[2]=f-m,e[3]=0,e[4]=c-y,e[5]=1-(l+d),e[6]=p+v,e[7]=0,e[8]=f+m,e[9]=p-v,e[10]=1-(l+h),e[11]=0,e[12]=0,e[13]=0,e[14]=0,e[15]=1;}},{key:"premultiply",value:function value(t){var e=this.arr,n=this.arr.slice();e[0]=t[0]*n[0]+t[4]*n[1]+t[8]*n[2]+t[12]*n[3],e[1]=t[1]*n[0]+t[5]*n[1]+t[9]*n[2]+t[13]*n[3],e[2]=t[2]*n[0]+t[6]*n[1]+t[10]*n[2]+t[14]*n[3],e[3]=t[3]*n[0]+t[7]*n[1]+t[11]*n[2]+t[15]*n[3],e[4]=t[0]*n[4]+t[4]*n[5]+t[8]*n[6]+t[12]*n[7],e[5]=t[1]*n[4]+t[5]*n[5]+t[9]*n[6]+t[13]*n[7],e[6]=t[2]*n[4]+t[6]*n[5]+t[10]*n[6]+t[14]*n[7],e[7]=t[3]*n[4]+t[7]*n[5]+t[11]*n[6]+t[15]*n[7],e[8]=t[0]*n[8]+t[4]*n[9]+t[8]*n[10]+t[12]*n[11],e[9]=t[1]*n[8]+t[5]*n[9]+t[9]*n[10]+t[13]*n[11],e[10]=t[2]*n[8]+t[6]*n[9]+t[10]*n[10]+t[14]*n[11],e[11]=t[3]*n[8]+t[7]*n[9]+t[11]*n[10]+t[15]*n[11],e[12]=t[0]*n[12]+t[4]*n[13]+t[8]*n[14]+t[12]*n[15],e[13]=t[1]*n[12]+t[5]*n[13]+t[9]*n[14]+t[13]*n[15],e[14]=t[2]*n[12]+t[6]*n[13]+t[10]*n[14]+t[14]*n[15],e[15]=t[3]*n[12]+t[7]*n[13]+t[11]*n[14]+t[15]*n[15];}},{key:"postmultiply",value:function value(t){var e=this.arr,n=this.arr.slice();e[0]=n[0]*t[0]+n[4]*t[1]+n[8]*t[2]+n[12]*t[3],e[1]=n[1]*t[0]+n[5]*t[1]+n[9]*t[2]+n[13]*t[3],e[2]=n[2]*t[0]+n[6]*t[1]+n[10]*t[2]+n[14]*t[3],e[3]=n[3]*t[0]+n[7]*t[1]+n[11]*t[2]+n[15]*t[3],e[4]=n[0]*t[4]+n[4]*t[5]+n[8]*t[6]+n[12]*t[7],e[5]=n[1]*t[4]+n[5]*t[5]+n[9]*t[6]+n[13]*t[7],e[6]=n[2]*t[4]+n[6]*t[5]+n[10]*t[6]+n[14]*t[7],e[7]=n[3]*t[4]+n[7]*t[5]+n[11]*t[6]+n[15]*t[7],e[8]=n[0]*t[8]+n[4]*t[9]+n[8]*t[10]+n[12]*t[11],e[9]=n[1]*t[8]+n[5]*t[9]+n[9]*t[10]+n[13]*t[11],e[10]=n[2]*t[8]+n[6]*t[9]+n[10]*t[10]+n[14]*t[11],e[11]=n[3]*t[8]+n[7]*t[9]+n[11]*t[10]+n[15]*t[11],e[12]=n[0]*t[12]+n[4]*t[13]+n[8]*t[14]+n[12]*t[15],e[13]=n[1]*t[12]+n[5]*t[13]+n[9]*t[14]+n[13]*t[15],e[14]=n[2]*t[12]+n[6]*t[13]+n[10]*t[14]+n[14]*t[15],e[15]=n[3]*t[12]+n[7]*t[13]+n[11]*t[14]+n[15]*t[15];}},{key:"premultiplyPosition",value:function value(t){var e=this.arr,n=this.arr.slice(),r=t.x,i=t.y,o=t.z;e[0]=n[0]+r*n[3],e[1]=n[1]+i*n[3],e[2]=n[2]+o*n[3],e[3]=n[3],e[4]=n[4]+r*n[7],e[5]=n[5]+i*n[7],e[6]=n[6]+o*n[7],e[7]=n[7],e[8]=n[8]+r*n[11],e[9]=n[9]+i*n[11],e[10]=n[10]+o*n[11],e[11]=n[11],e[12]=n[12]+r*n[15],e[13]=n[13]+i*n[15],e[14]=n[14]+o*n[15],e[15]=n[15];}},{key:"getInverse",value:function value(t){var e=this.arr,n=t[9]*t[14]*t[7]-t[13]*t[10]*t[7]+t[13]*t[6]*t[11]-t[5]*t[14]*t[11]-t[9]*t[6]*t[15]+t[5]*t[10]*t[15],r=t[12]*t[10]*t[7]-t[8]*t[14]*t[7]-t[12]*t[6]*t[11]+t[4]*t[14]*t[11]+t[8]*t[6]*t[15]-t[4]*t[10]*t[15],i=t[8]*t[13]*t[7]-t[12]*t[9]*t[7]+t[12]*t[5]*t[11]-t[4]*t[13]*t[11]-t[8]*t[5]*t[15]+t[4]*t[9]*t[15],o=t[12]*t[9]*t[6]-t[8]*t[13]*t[6]-t[12]*t[5]*t[10]+t[4]*t[13]*t[10]+t[8]*t[5]*t[14]-t[4]*t[9]*t[14],a=1/(t[0]*n+t[1]*r+t[2]*i+t[3]*o);e[0]=n*a,e[1]=(t[13]*t[10]*t[3]-t[9]*t[14]*t[3]-t[13]*t[2]*t[11]+t[1]*t[14]*t[11]+t[9]*t[2]*t[15]-t[1]*t[10]*t[15])*a,e[2]=(t[5]*t[14]*t[3]-t[13]*t[6]*t[3]+t[13]*t[2]*t[7]-t[1]*t[14]*t[7]-t[5]*t[2]*t[15]+t[1]*t[6]*t[15])*a,e[3]=(t[9]*t[6]*t[3]-t[5]*t[10]*t[3]-t[9]*t[2]*t[7]+t[1]*t[10]*t[7]+t[5]*t[2]*t[11]-t[1]*t[6]*t[11])*a,e[4]=r*a,e[5]=(t[8]*t[14]*t[3]-t[12]*t[10]*t[3]+t[12]*t[2]*t[11]-t[0]*t[14]*t[11]-t[8]*t[2]*t[15]+t[0]*t[10]*t[15])*a,e[6]=(t[12]*t[6]*t[3]-t[4]*t[14]*t[3]-t[12]*t[2]*t[7]+t[0]*t[14]*t[7]+t[4]*t[2]*t[15]-t[0]*t[6]*t[15])*a,e[7]=(t[4]*t[10]*t[3]-t[8]*t[6]*t[3]+t[8]*t[2]*t[7]-t[0]*t[10]*t[7]-t[4]*t[2]*t[11]+t[0]*t[6]*t[11])*a,e[8]=i*a,e[9]=(t[12]*t[9]*t[3]-t[8]*t[13]*t[3]-t[12]*t[1]*t[11]+t[0]*t[13]*t[11]+t[8]*t[1]*t[15]-t[0]*t[9]*t[15])*a,e[10]=(t[4]*t[13]*t[3]-t[12]*t[5]*t[3]+t[12]*t[1]*t[7]-t[0]*t[13]*t[7]-t[4]*t[1]*t[15]+t[0]*t[5]*t[15])*a,e[11]=(t[8]*t[5]*t[3]-t[4]*t[9]*t[3]-t[8]*t[1]*t[7]+t[0]*t[9]*t[7]+t[4]*t[1]*t[11]-t[0]*t[5]*t[11])*a,e[12]=o*a,e[13]=(t[8]*t[13]*t[2]-t[12]*t[9]*t[2]+t[12]*t[1]*t[10]-t[0]*t[13]*t[10]-t[8]*t[1]*t[14]+t[0]*t[9]*t[14])*a,e[14]=(t[12]*t[5]*t[2]-t[4]*t[13]*t[2]-t[12]*t[1]*t[6]+t[0]*t[13]*t[6]+t[4]*t[1]*t[14]-t[0]*t[5]*t[14])*a,e[15]=(t[4]*t[9]*t[2]-t[8]*t[5]*t[2]+t[8]*t[1]*t[6]-t[0]*t[9]*t[6]-t[4]*t[1]*t[10]+t[0]*t[5]*t[10])*a;}},{key:"transpose",value:function value(){var t=this.arr,e=t[1];t[1]=t[4],t[4]=e,e=t[2],t[2]=t[8],t[8]=e,e=t[6],t[6]=t[9],t[9]=e,e=t[3],t[3]=t[12],t[12]=e,e=t[7],t[7]=t[13],t[13]=e,e=t[11],t[11]=t[14],t[14]=e;}},{key:"makePerspective",value:function value(t){var e=this.arr,n=t[0],r=t[1],i=t[2],o=t[3],a=t[4],s=t[5];e[0]=2*a/(r-n),e[1]=0,e[2]=0,e[3]=0,e[4]=0,e[5]=2*a/(i-o),e[6]=0,e[7]=0,e[8]=(r+n)/(r-n),e[9]=(i+o)/(i-o),e[10]=-(s+a)/(s-a),e[11]=-1,e[12]=0,e[13]=0,e[14]=-2*s*a/(s-a),e[15]=0;}},{key:"makeOrthographic",value:function value(t){var e=this.arr,n=t[0],r=t[1],i=t[2],o=t[3],a=t[4],s=t[5],u=1/(r-n),l=1/(i-o),c=1/(s-a);e[0]=2*u,e[1]=0,e[2]=0,e[3]=0,e[4]=0,e[5]=2*l,e[6]=0,e[7]=0,e[8]=0,e[9]=0,e[10]=-2*c,e[11]=0,e[12]=-(r+n)*u,e[13]=-(i+o)*l,e[14]=-(s+a)*c,e[15]=1;}},{key:"rotate",value:function value(t,e){var n=t.x,r=void 0===n?0:n,i=t.y,o=void 0===i?0:i,a=t.z,s=void 0===a?0:a,u=Math.cos(e),l=Math.sin(e),c=r*r,f=o*o,h=s*s,p=r*o,d=r*s,v=o*s,m=1-u,y=r*l,g=o*l,x=s*l;this.premultiply([u+c*m,p*m-x,d*m+g,0,p*m+x,u+f*m,v*m-y,0,d*m-g,v*m+y,u+h*m,0,0,0,0,1]);}},{key:"rotateX",value:function value(t){var e=Math.cos(t),n=Math.sin(t);this.premultiply([1,0,0,0,0,e,-n,0,0,n,e,0,0,0,0,1]);}},{key:"rotateY",value:function value(t){var e=Math.cos(t),n=Math.sin(t);this.premultiply([e,0,n,0,0,1,0,0,-n,0,e,0,0,0,0,1]);}},{key:"rotateZ",value:function value(t){var e=Math.cos(t),n=Math.sin(t);this.premultiply([e,-n,0,0,n,e,0,0,0,0,1,0,0,0,0,1]);}},{key:"translate",value:function value(t){var e=t.x,n=void 0===e?0:e,r=t.y,i=void 0===r?0:r,o=t.z,a=void 0===o?0:o,s=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;this.premultiply([1,0,0,0,0,1,0,0,0,0,1,0,n*s,i*s,a*s,1]);}},{key:"translateX",value:function value(t){this.premultiply([1,0,0,0,0,1,0,0,0,0,1,0,t,0,0,1]);}},{key:"translateY",value:function value(t){this.premultiply([1,0,0,0,0,1,0,0,0,0,1,0,0,t,0,1]);}},{key:"translateZ",value:function value(t){this.premultiply([1,0,0,0,0,1,0,0,0,0,1,0,0,0,t,1]);}},{key:"scale",value:function value(t,e){var n=e-1,r=n*t.x,i=n*t.y,o=r*t.y,a=r*t.z,s=i*t.z;this.premultiply([1+r*t.x,o,a,0,o,1+i*t.y,s,0,a,s,1+n*t.z*t.z,0,0,0,0,1]);}},{key:"scaleXYZ",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{x:1,y:1,z:1};this.premultiply([t.x,0,0,0,0,1,t.y,0,0,0,0,t.z,0,0,0,0,1]);}},{key:"scaleX",value:function value(t){this.premultiply([t,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1]);}},{key:"scaleY",value:function value(t){this.premultiply([1,0,0,0,0,t,0,0,0,0,1,0,0,0,0,1]);}},{key:"scaleZ",value:function value(t){this.premultiply([1,0,0,0,0,1,0,0,0,0,t,0,0,0,0,1]);}}]),t;}();};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}t.exports=function(t){var e=t.WebGLRenderingContext,r=e.FLOAT,i=e.STATIC_DRAW,o=e.ARRAY_BUFFER;return function(){function a(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,a),this.class="VBO",this.init(t);}return function(t,e,r){e&&n(t.prototype,e);}(a,[{key:"init",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.buffer=e.createBuffer(),this.applyOptions(t);}},{key:"applyOptions",value:function value(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",location:0,size:3,type:r,normalized:!1,stride:0,offset:0,content:[],usage:i},n),e.bindBuffer(o,this.buffer),e.bufferData(o,this.content,this.usage),e.enableVertexAttribArray(this.location),e.vertexAttribPointer(this.location,this.size,this.type,this.normalized,this.stride,this.offset),t.disableVBO();}},{key:"enable",value:function value(){e.bindBuffer(o,this.buffer),e.vertexAttribPointer(this.location,this.size,this.type,this.normalized,this.stride,this.offset);}},{key:"delete",value:function value(){e.deleteBuffer(this.buffer);}}]),a;}();};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}t.exports=function(t){var e=t.WebGLRenderingContext,r=e.FLOAT,i=e.DYNAMIC_DRAW,o=e.ARRAY_BUFFER,a=[function(){},function(t){e.bufferData(o,t.content[(t.current=t.next)+t.index],t.usage);}];return function(){function s(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,s),this.class="MVBO",this.init(t);}return function(t,e,r){e&&n(t.prototype,e);}(s,[{key:"init",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.buffer=e.createBuffer(),this.applyOptions(t);}},{key:"applyOptions",value:function value(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",location:0,size:3,type:r,normalized:!1,stride:0,offset:0,content:[],usage:i,interpolation:new t.DataFloat1(),index:0},n),this.current=0,this.next=0,e.bindBuffer(o,this.buffer),e.bufferData(o,this.content[this.index],this.usage),e.enableVertexAttribArray(this.location),e.vertexAttribPointer(this.location,this.size,this.type,this.normalized,this.stride,this.offset),t.disableVBO();}},{key:"enable",value:function value(){t.currentMVBO=this,e.bindBuffer(o,this.buffer);var n=(this.next=this.interpolation.x)-this.current;a[2+~(1-1e-10*~~(n*n))](this),e.vertexAttribPointer(this.location,this.size,this.type,this.normalized,this.stride,this.offset);}},{key:"delete",value:function value(){e.deleteBuffer(this.buffer);}}]),s;}();};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}t.exports=function(t){var e=t.WebGLRenderingContext,r=e.STATIC_DRAW,i=e.ELEMENT_ARRAY_BUFFER;return function(){function o(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,o),this.class="IBO",this.init(t);}return function(t,e,r){e&&n(t.prototype,e);}(o,[{key:"init",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.buffer=e.createBuffer(),this.applyOptions(t);}},{key:"applyOptions",value:function value(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",content:[],usage:r},n),e.bindBuffer(i,this.buffer),e.bufferData(i,this.content,this.usage),t.disableIBO();}},{key:"enable",value:function value(){e.bindBuffer(i,this.buffer);}},{key:"delete",value:function value(){e.deleteBuffer(this.buffer);}}]),o;}();};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}t.exports=function(t){var e=t.WebGLRenderingContext,r=e.DYNAMIC_DRAW,i=e.ELEMENT_ARRAY_BUFFER,o=[function(){},function(t){e.bufferData(i,t.content[t.current=t.next],t.usage);}];return function(){function a(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,a),this.class="MIBO",this.init(t);}return function(t,e,r){e&&n(t.prototype,e);}(a,[{key:"init",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.buffer=e.createBuffer(),this.applyOptions(t);}},{key:"applyOptions",value:function value(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",content:[],usage:r,interpolation:new t.DataFloat1(),index:0},n),this.current=0,this.next=0,e.bindBuffer(i,this.buffer),e.bufferData(i,this.content[0],this.usage),e.bindBuffer(i,null);}},{key:"enable",value:function value(){t.currentMIBO=this,e.bindBuffer(i,this.buffer);var n=(this.next=this.interpolation.x)-this.current;o[2+~(1-1e-10*~~(n*n))](this);}},{key:"delete",value:function value(){e.deleteBuffer(this.buffer);}}]),a;}();};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}t.exports=function(t){var e=t.WebGLRenderingContext;return function(){function r(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,r),this.class="VAO",this.init(t);}return function(t,e,r){e&&n(t.prototype,e);}(r,[{key:"init",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.vertexArray=e.createVertexArray(),this.applyOptions(t);}},{key:"applyOptions",value:function value(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",buffers:[]},e),this.buffersByName={},this.enable(),this.handleBuffers(),t.disableVAO();}},{key:"enable",value:function value(){e.bindVertexArray(this.vertexArray);}},{key:"addBuffers",value:function value(t){this.buffers=this.buffers.concat(t);}},{key:"handleBuffers",value:function value(){for(var t=this.buffers,e=t.length,n=0;n<e;n++){t[n].bind();}}},{key:"delete",value:function value(){e.deleteVertexArray(this.vertexArray);}}]),r;}();};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}t.exports=function(t){var e=t.WebGLRenderingContext,r=e.DYNAMIC_DRAW,i=e.UNIFORM_BUFFER;return function(){function o(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,o),this.class="UBO",this.init(t);}return function(t,e,r){e&&n(t.prototype,e);}(o,[{key:"init",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.buffer=e.createBuffer(),this.applyOptions(t);}},{key:"applyOptions",value:function value(){var n=this,o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{content:[],usage:r,name:"",index:0,subData:{},material:null},o),this.updatedSubData=[];var a=[];Object.keys(this.subData).forEach(function(t){a.push(t),t.init(),!1!==t.updated&&n.updatedSubData.push(t);}),this.subData=a,this.enable(),e.bufferData(i,this.content=new Float32Array(this.content),this.usage),e.bindBufferBase(i,this.index,this.buffer),t.disableUBO();}},{key:"enable",value:function value(){e.bindBuffer(i,this.buffer);}},{key:"enableSubData",value:function value(){e.bindBuffer(i,this.buffer);for(var t=this.updatedSubData.length,n=0;n<t;n++){this.updatedSubData[n].update(this.content,this.offsets[this.updatedSubData[n].name]);}e.bufferData(i,this.content,this.usage);}},{key:"delete",value:function value(){e.deleteBuffer(this.buffer);}}]),o;}();};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}t.exports=function(t){var e=t.WebGLRenderingContext,r=e.TEXTURE_2D,i=e.RGBA,o=e.UNSIGNED_BYTE,a=e.LINEAR,s=e.NEAREST,u=e.CLAMP_TO_EDGE,l=e.TEXTURE_MAG_FILTER,c=e.TEXTURE_MIN_FILTER,f=e.TEXTURE_WRAP_S,h=e.TEXTURE_WRAP_T;return function(){function p(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,p),this.class="Texture2D",this.init(t);}return function(t,e,r){e&&n(t.prototype,e);}(p,[{key:"init",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.texture=e.createTexture(),this.applyOptions(t);}},{key:"applyOptions",value:function value(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",target:r,unit:0,image:null,internalFormat:i,format:i,width:0,height:0,level:0,border:0,type:o,mag:a,min:a,wrapS:u,wrapT:u,autosize:!0,anisotropy:!1,FBO:!1,excludeMaterials:[]},n),this.materials=[],this.image&&this.autosize&&(this.width=this.image.width,this.height=this.image.height),this.FBO&&(this.min=s,this.mag=s);var p=this.target,d=this.internalFormat,v=this.format,m=this.width,y=this.height,g=this.level,x=this.border,b=this.type,w=this.image,_=this.mag,T=this.min,k=this.wrapS,E=this.wrapT,O=this.anisotropy,S=this.FBO;e.bindTexture(this.target,this.texture),"WebGL2Context"===t.class||S?e.texImage2D(p,g,d,m,y,x,v,b,w):e.texImage2D(p,g,d,d,b,w),e.texParameteri(p,l,_),e.texParameteri(p,c,T),e.texParameteri(p,f,k),e.texParameteri(p,h,E),O&&t.anisotropy&&e.texParameterf(p,t.anisotropy.TEXTURE_MAX_ANISOTROPY_EXT,O),this.image&&e.generateMipmap(p),t.disableTexture2D();}},{key:"uniform",value:function value(t){return t.uniforms||(t.uniforms=[]),t.uniforms.push(this),"uniform sampler2D ".concat(this.name,";");}},{key:"enable",value:function value(){e.bindTexture(this.target,this.texture);}},{key:"delete",value:function value(){e.deleteTexture(this.texture);}},{key:"initUniform",value:function value(n){e.activeTexture(t.textureUnits[this.unit]),e.bindTexture(this.target,this.texture),e.uniform1i(n,this.unit);}},{key:"updateUniform",value:function value(){e.activeTexture(t.textureUnits[this.unit]),e.bindTexture(this.target,this.texture);}}]),p;}();};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}t.exports=function(t){var e=t.WebGLRenderingContext,r=e.DEPTH_COMPONENT16,i=e.RGBA8,o=e.RENDERBUFFER;return function(){function a(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,a),this.class="RBO",this.init(t);}return function(t,e,r){e&&n(t.prototype,e);}(a,[{key:"init",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.renderbuffer=e.createRenderbuffer(),t.samples?this.applyOptionsMultisample(t):this.applyOptions(t);}},{key:"applyOptions",value:function value(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",format:r,width:0,height:0},e);var n=this.format,i=this.width,o=this.height;this.enable(),t.renderbufferStorage(n,i,o),t.disableRBO();}},{key:"applyOptionsMultisample",value:function value(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",format:i,width:0,height:0,samples:1},e);var n=this.format,r=this.width,o=this.height,a=this.samples;this.enable(),t.renderbufferStorageMultisample(a,n,r,o),t.disableRBO();}},{key:"enable",value:function value(){e.bindRenderbuffer(o,this.renderbuffer);}},{key:"delete",value:function value(){e.deleteRenderbuffer(this.renderbuffer);}}]),a;}();};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}t.exports=function(t){var e=t.WebGLRenderingContext,r=e.FRAMEBUFFER,i=e.READ_FRAMEBUFFER,o=e.DRAW_FRAMEBUFFER;return function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,t),this.class="FBO",this.init(e);}return function(t,e,r){e&&n(t.prototype,e);}(t,[{key:"init",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.framebuffer=e.createFramebuffer(),this.applyOptions(t);}},{key:"applyOptions",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",width:0,height:0},t);}},{key:"enable",value:function value(){e.bindFramebuffer(r,this.framebuffer);}},{key:"read",value:function value(){e.bindFramebuffer(i,this.framebuffer);}},{key:"draw",value:function value(){e.bindFramebuffer(o,this.framebuffer);}},{key:"delete",value:function value(){e.deleteFramebuffer(this.framebuffer);}}]),t;}();};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}t.exports=function(t){var e=t.WebGLRenderingContext,r=e.COLOR_ATTACHMENT0,i=e.DEPTH_ATTACHMENT,o=e.FRAMEBUFFER,a=e.TEXTURE_2D;return function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,e),this.class="Offscreen",this.applyOptions(t);}return function(t,e,r){e&&n(t.prototype,e);}(e,[{key:"applyOptions",value:function value(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",texture:null,RBO:null,FBO:null,textureAttachment:r,renderbufferAttachment:i},e);var n=this.texture,s=this.RBO,u=this.FBO,l=this.textureAttachment,c=this.renderbufferAttachment;u.enable(),s&&t.framebufferRenderbuffer(o,c,s),n&&t.framebufferTexture2D(o,l,a,n),t.disableFBO();}},{key:"render",value:function value(e){this.FBO.enable(),e(),t.disableFBO();}}]),e;}();};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}t.exports=function(t){var e=t.WebGLRenderingContext,r=e.COLOR_ATTACHMENT0,i=e.COLOR_BUFFER_BIT,o=e.NEAREST,a=e.FRAMEBUFFER,s=e.TEXTURE_2D;return function(){function u(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,u),this.class="OffscreenMultisample",this.applyOptions(t);}return function(t,e,r){e&&n(t.prototype,e);}(u,[{key:"applyOptions",value:function value(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",texture:null,RBO:null,readFBO:null,drawFBO:null,textureAttachment:r,renderbufferAttachment:r,mask:i,filter:o},e);var n=this.texture,u=this.RBO,l=this.readFBO,c=this.drawFBO,f=this.textureAttachment,h=this.renderbufferAttachment;l.enable(),t.framebufferRenderbuffer(a,h,u),c.enable(),t.framebufferTexture2D(a,f,s,n),t.disableFBO();}},{key:"render",value:function value(n){var r=this.readFBO,i=this.drawFBO;r.enable(),n(),r.read(),i.draw(),e.blitFramebuffer(0,0,r.width,r.height,0,0,i.width,i.height,this.mask,this.filter),t.disableFBO();}}]),u;}();};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}t.exports=function(t){var e=t.WebGLRenderingContext,r=e.VERTEX_SHADER,i=e.FRAGMENT_SHADER,o=e.LINK_STATUS,a=e.COMPILE_STATUS,s=function s(t,n){var r=e.createShader(n);if(e.shaderSource(r,t),e.compileShader(r),!e.getShaderParameter(r,a)){var i="\n".concat(t.split("\n").map(function(t,e){return"".concat(e+1,":").concat(t);}).join("\n"));throw new Error("".concat(i).concat(e.getShaderInfoLog(r)));}return r;};return function(){function a(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,a),this.class="Material",this.init(t);}return function(t,e,r){e&&n(t.prototype,e);}(a,[{key:"init",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.program=e.createProgram(),this.applyOptions(t);}},{key:"applyOptions",value:function value(){var n=this,a=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};if(Object.assign(this,{name:"",VS:null,FS:null,UBO:null,uniforms:null,onBeforeLink:null},a),this.UBOLocations=null,this.uniformLocations=null,this.updatedUniforms=null,"function"==typeof this.VS&&(this.VS=this.VS()),"function"==typeof this.FS&&(this.FS=this.FS()),this.VS.split("\n").filter(function(t){return t.search(/\battribute\b|\bin\b/)>-1;}).forEach(function(t,r){var i=t.trim().split(" ").pop().replace(/[^0-9A-Za-z]/g,"");e.bindAttribLocation(n.program,r,i);}),e.attachShader(this.program,s(this.VS,r)),e.attachShader(this.program,s(this.FS,i)),(this.onBeforeLink||{}).call&&this.onBeforeLink(),this.link(),!e.getProgramParameter(this.program,o))throw new Error("".concat(o,", ").concat(e.getProgramInfoLog(this.program)));this.enable(),this.bindUBO(),this.bindUniforms(),t.disableMaterial();}},{key:"enable",value:function value(){e.useProgram(this.program);}},{key:"link",value:function value(){e.linkProgram(this.program);}},{key:"bindUBO",value:function value(){var t=this;(this.UBO||[]).length&&(this.UBOLocations||(this.UBOLocations={}),this.UBO.forEach(function(n){t.UBOLocations[n.name]=e.getUniformLocation(t.program,n.name),e.uniformBlockBinding(t.program,t.UBOLocations[n.name],n.index);}));}},{key:"bindUniforms",value:function value(){var t=this;(this.uniforms||[]).length&&(this.uniformLocations||(this.uniformLocations={}),this.uniforms.forEach(function(n){t.uniformLocations[n.name]=e.getUniformLocation(t.program,n.name),n.excludeMaterials&&n.excludeMaterials.indexOf(t.name)<0&&n.materials.push(t),n.initUniform(t.uniformLocations[n.name]),!1!==n.updated&&(t.updatedUniforms||(t.updatedUniforms=[]),t.updatedUniforms.push(n));}));}},{key:"updateUniforms",value:function value(){for(var t=this.updatedUniforms,e=t.length,n=0;n<e;n++){t[n].updateUniform(this.uniformLocations[t[n].name]);}}},{key:"updateAllUniforms",value:function value(){for(var t=this.uniforms,e=t.length,n=0;n<e;n++){t[n].updateUniform(this.uniformLocations[t[n].name]);}}},{key:"delete",value:function value(){e.deleteProgram(this.program);}}]),a;}();};},function(t,e,n){function r(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}var i=n(0),o=i.concatArrays,a=i.premultiplyParentMatrices,s=function s(){};t.exports=function(t){var e=t.WebGLRenderingContext,n=e.LESS,i=e.BACK,u=e.DEPTH_TEST,l=e.BLEND,c=e.CULL_FACE,f=new t.DataFloat4();return function(){function h(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,h),this.class="Object",this.applyOptions(t);}return function(t,e,n){e&&r(t.prototype,e);}(h,[{key:"applyOptions",value:function value(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",material:null,VAO:null,buffers:null,arrays:null,blend:null,children:null,camera:null,draw:null,depthTest:n,cullFace:i,batchIndex:0,verticesNumber:0,enable:s,disable:s,enableChain:s,disableChain:s,mode:s},e),this.quaternion=new t.DataFloat4(),this.rotation=new t.DataFloat3(),this.position=new t.DataFloat3(),this.matrix=new t.Mat4(),this.normalMatrix=new t.Mat4(),this.scaleMatrix=new t.Mat4(),this.rotationMatrix=new t.Mat4(),this.parent=null,this.batchIndices=[],this.draw||(this.draw=this.drawSingle),this.bindChain(),t.objects[this.name]=this;}},{key:"addBuffers",value:function value(t){this.buffers=this.buffers.concat(t);}},{key:"bindChain",value:function value(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;this.parent=e,this.updateMatrix=this["updateMatrix".concat(this.parent?"Parent":"").concat(this.children?"Children":"")],this.children&&this.children.forEach(function(e){return e.bindChain(t);});}},{key:"batch",value:function value(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.batchIndices=this.batchIndices.concat(new Array(this.verticesNumber).fill(this.batchIndex)),o(this,this.children,this.verticesNumber);var n=e.VAO?this.VAO=new t.VAO():this;for(var r in this.arrays){var i=null;"VBO"===this.arrays[r].type?i=new t.VBO({name:r,content:new Float32Array(this.arrays[r].arr),size:this.arrays[r].size||3}):"IBO"===this.arrays[r].type&&(i=new t.IBO({content:new window.Uint16Array(this.arrays[r].arr)})),n.buffers.push(i);}!1!==e.indexVBO&&n.buffers.push(new t.VBO({name:e.indexAttrName||"modelIndex",content:new Float32Array(this.batchIndices),size:1}));}},{key:"enableBlend",value:function value(){var t=this.blend,n=t.func;e.enable(l),e.blendEquation(t.equation),e.blendFunc(n.sfactor,n.dfactor);}},{key:"enableBlendSeparate",value:function value(){var t=this.blend,n=t.equationSeparate,r=t.funcSeparate;e.enable(l),e.blendEquationSeparate(n.modeRGB,n.modeAlpha),e.blendFuncSeparate(r.srcRGB,r.dstRGB,r.srcAlpha,r.dstAlpha);}},{key:"enableDepthTest",value:function value(){e.enable(u),e.depthFunc(this.depthTest);}},{key:"enableCullFace",value:function value(){e.enable(c),e.cullFace(this.cullFace);}},{key:"enableVAO",value:function value(){this.VAO.enable();}},{key:"enableBuffers",value:function value(){for(var t=this.buffers,e=t.length,n=0;n<e;n++){t[n].enable();}}},{key:"updateMaterialUniforms",value:function value(){this.material.updateUniforms();}},{key:"updateAllMaterialUniforms",value:function value(){t.currentObject=this,t.currentMatrix.arr=this.matrix.arr,t.currentNormalMatrix.arr=this.normalMatrix.arr,this.material.updateAllUniforms();}},{key:"updateMaterialAttributes",value:function value(){this.material.updateAttributes();}},{key:"updateAllMaterialAttributes",value:function value(){t.currentObject=this,t.currentMatrix.arr=this.matrix.arr,t.currentNormalMatrix.arr=this.normalMatrix.arr,this.material.updateAllAttributes();}},{key:"drawSingle",value:function value(){t.currentObject=this,t.currentMatrix.arr=this.matrix.arr,t.currentNormalMatrix.arr=this.normalMatrix.arr,e.useProgram(this.material.program),this.enable(),this.mode(),this.disable();}},{key:"updateSingle",value:function value(){t.currentObject=this,t.currentMatrix.arr=this.matrix.arr,t.currentNormalMatrix.arr=this.normalMatrix.arr,e.useProgram(this.material.program),this.enable(),this.disable();}},{key:"drawChain",value:function value(){var n=this.children,r=n.length;t.currentObject=this,t.currentMatrix.arr=this.matrix.arr,t.currentNormalMatrix.arr=this.normalMatrix.arr,e.useProgram(this.material.program),this.enableChain(),this.enable(),this.mode(),this.disable();for(var i=0;i<r;i++){n[i].draw();}this.disableChain();}},{key:"updateChain",value:function value(){var n=this.children,r=n.length;t.currentObject=this,t.currentMatrix.arr=this.matrix.arr,t.currentNormalMatrix.arr=this.normalMatrix.arr,e.useProgram(this.material.program),this.enableChain(),this.enable(),this.disable();for(var i=0;i<r;i++){n[i].update();}this.disableChain();}},{key:"scale",value:function value(t,e){this.scaleMatrix.scale(t,e);}},{key:"scaleXYZ",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{x:1,y:1,z:1};this.scaleMatrix.scaleXYZ(t);}},{key:"scaleX",value:function value(t){this.scaleMatrix.scaleX(t);}},{key:"scaleY",value:function value(t){this.scaleMatrix.scaleY(t);}},{key:"scaleZ",value:function value(t){this.scaleMatrix.scaleZ(t);}},{key:"setRotation",value:function value(t,e){var n=this.quaternion;n.setQuaternionRotation(t,e),this.rotationMatrix.setRotationFromQuaternion(n);}},{key:"setRotationX",value:function value(t){var e=this.quaternion;e.setQuaternionRotationX(t),this.rotationMatrix.setRotationFromQuaternion(e);}},{key:"setRotationY",value:function value(t){var e=this.quaternion;e.setQuaternionRotationY(t),this.rotationMatrix.setRotationFromQuaternion(e);}},{key:"setRotationZ",value:function value(t){var e=this.quaternion;e.setQuaternionRotationZ(t),this.rotationMatrix.setRotationFromQuaternion(e);}},{key:"rotate",value:function value(t,e){var n=this.quaternion;f.setQuaternionRotation(t,e),n.multiplyQuaternion(f),this.rotationMatrix.setRotationFromQuaternion(n);}},{key:"rotateX",value:function value(t){var e=this.quaternion;f.setQuaternionRotationX(t),e.multiplyQuaternion(f),this.rotationMatrix.setRotationFromQuaternion(e);}},{key:"rotateY",value:function value(t){var e=this.quaternion;f.setQuaternionRotationY(t),e.multiplyQuaternion(f),this.rotationMatrix.setRotationFromQuaternion(e);}},{key:"rotateZ",value:function value(t){var e=this.quaternion;f.setQuaternionRotationZ(t),e.multiplyQuaternion(f),this.rotationMatrix.setRotationFromQuaternion(e);}},{key:"updateNormalMatrix",value:function value(){var t=this.normalMatrix;t.getInverse(this.matrix.arr),t.transpose();}},{key:"updateMatrix",value:function value(){var t=this.matrix;t.reset(),t.premultiply(this.scaleMatrix.arr),t.premultiply(this.rotationMatrix.arr),t.premultiplyPosition(this.position);}},{key:"updateMatrixParent",value:function value(){var t=this.matrix;t.reset(),t.premultiply(this.scaleMatrix.arr),t.premultiply(this.rotationMatrix.arr),t.premultiplyPosition(this.position),a(this);}},{key:"updateMatrixChildren",value:function value(){var t=this.matrix,e=this.children,n=e.length;t.reset(),t.premultiply(this.scaleMatrix.arr),t.premultiply(this.rotationMatrix.arr),t.premultiplyPosition(this.position);for(var r=0;r<n;r++){e[r].updateMatrix();}}},{key:"updateMatrixParentChildren",value:function value(){var t=this.matrix,e=this.children,n=e.length;t.reset(),t.premultiply(this.scaleMatrix.arr),t.premultiply(this.rotationMatrix.arr),t.premultiplyPosition(this.position),a(this);for(var r=0;r<n;r++){e[r].updateMatrix();}}}]),h;}();};},function(t,e){function n(t){return(n="function"==typeof Symbol&&"symbol"==_typeof(Symbol.iterator)?function(t){return typeof t==="undefined"?"undefined":_typeof(t);}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t==="undefined"?"undefined":_typeof(t);})(t);}function r(t,e){return!e||"object"!==n(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t;}(t):e;}function i(t){return(i=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t);})(t);}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&function(t,e){(Object.setPrototypeOf||function(t,e){return t.__proto__=e,t;})(t,e);}(t,e);}function a(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");}function s(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}function u(t,e,n){return e&&s(t.prototype,e),n&&s(t,n),t;}t.exports=function(t){var e=function(){function e(){a(this,e),this.class="Camera",this.matrix=new t.Mat4(),this.viewMatrix=new t.Mat4({name:"viewMatrix"}),this.projectionMatrix=new t.Mat4({name:"projectionMatrix"}),this.position=new t.DataFloat3({name:"cameraPosition"}),this.fov=0,this.aspect=0,this.near=0,this.far=0,this.zoom=0,this.left=0,this.right=0,this.top=0,this.bottom=0,this.near=0;}return u(e,[{key:"updateProjectionMatrixPerspective",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{fov:45,aspect:window.innerWidth/window.innerHeight,near:1,far:1e3,zoom:1},t);var e=this.fov,n=this.aspect,r=this.near,i=this.far,o=this.zoom,a=r*Math.tan(.008726646*e)/(o||1),s=2*a,u=n*s,l=-.5*u;this.projectionMatrix.makePerspective([l,l+u,a,a-s,r,i]);}},{key:"updateProjectionMatrixOrthographic",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{left:window.innerWidth/-2,right:window.innerWidth/2,top:window.innerHeight/2,bottom:window.innerHeight/-2,near:1,far:1e3,zoom:1},t);var e=this.left,n=this.right,r=this.top,i=this.bottom,o=this.near,a=this.far,s=this.zoom,u=(n-e)/(2*(s||1)),l=(r-i)/(2*(s||1)),c=(n+e)/2,f=(r+i)/2,h=c-u,p=c+u,d=f+l,v=f-l;this.projectionMatrix.makeOrthographic([h,p,d,v,o,a]);}},{key:"updateViewMatrix",value:function value(){this.viewMatrix.getInverse(this.matrix.arr);}}]),e;}();return{Camera:e,PerspectiveCamera:function(t){function n(){var t,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return a(this,n),(t=r(this,i(n).call(this))).class="PerspectiveCamera",t.updateProjectionMatrix(e),t;}return o(n,e),u(n,[{key:"updateProjectionMatrix",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this.updateProjectionMatrixPerspective(t),this;}}]),n;}(),OrthographicCamera:function(t){function n(){var t,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return a(this,n),(t=r(this,i(n).call(this))).class="OrthographicCamera",t.updateProjectionMatrix(e),t;}return o(n,e),u(n,[{key:"updateProjectionMatrix",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this.updateProjectionMatrixOrthographic(t),this;}}]),n;}(),Orbit:function(){function e(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};a(this,e),this.class="Orbit",Object.assign(this,{camera:new t.PerspectiveCamera(),rotation:new t.DataArrayFloat2({name:"orbitRotation"}),translation:new t.DataFloat3({name:"orbitTranslation"})},n);}return u(e,[{key:"update",value:function value(){var t=this.camera,e=t.position,n=t.matrix,r=this.rotation.arr,i=this.translation;n.reset(),n.rotateX(r[0]),n.rotateY(r[1]),e.x=i.x,e.y=i.y,e.z=i.z,e.applyMatrix4Array(n.arr),e.updateUniforms(),n.translate(e),t.viewMatrix.getInverse(n.arr),t.viewMatrix.updateUniforms();}}]),e;}()};};},function(t,e){t.exports={Linear:function Linear(t){return t;},BezierCubicCurve:function BezierCubicCurve(t,e,n,r){var i=2*Math.PI/3,o=3*t,a=3*n,s=o-a+1,u=(a-2*o)/s,l=u*u,c=o/s*3,f=c*u*3-2*l*u,h=(c-l)/9,p=h*h*h,d=Math.sqrt(-h),v=-d*h,m=2*d,y=u/3,g=[function(t,e){return e;},function(t,e){return-t-e;}],x=[function(t){return t;},function(t,e){return g[1+~~(m*e-y)](t,e);}],b=[function(t){var e=Math.acos(t/v)/3,n=Math.cos(e),r=Math.cos(e+i);return m*x[~~(m*n-y)](n,r);},function(t,e){var n=Math.sqrt(e);return Math.cbrt(t+n)+Math.cbrt(t-n);}];return b[2]=b[1],function(t){var n=(f+27*t/s)/54,i=p+n*n,o=b[Math.floor(i)+1](n,i)-y,a=1-o,u=o*o;return 3*o*a*a*e+3*u*a*r+u*o;};},GaussCurve:function GaussCurve(t,e){return 1/(t*Math.sqrt(2*Math.PI))*Math.exp(-e*e/2/t/t);},TriangleSquare:function TriangleSquare(t,e,n){var r=Math.sqrt(2*(n.x-e.x)+2*(n.y-e.y)+2*(n.z-e.z)),i=Math.sqrt(2*(n.x-t.x)+2*(n.y-t.y)+2*(n.z-t.z)),o=Math.sqrt(2*(e.x-t.x)+2*(e.x-t.x)+2*(e.x-t.x)),a=(r+i+o)/2;return Math.sqrt(a*(a-r)*(a-i)*(a-o));},inTriangle2D:function inTriangle2D(t,e,n,r){var i=(t.x-r.x)*(e.y-t.y)>(e.x-t.x)*(t.y-r.y),o=(e.x-r.x)*(n.y-e.y)>(n.x-e.x)*(e.y-r.y),a=(n.x-r.x)*(t.y-n.y)>(t.x-n.x)*(n.y-r.y);return i===o&&o===a;}};},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}t.exports=function(){function t(){(function(t,e){if(!function(t,e){return null!=e&&"undefined"!=typeof Symbol&&e[Symbol.hasInstance]?e[Symbol.hasInstance](t):t instanceof e;}(t,e))throw new TypeError("Cannot call a class as a function");})(this,t),Object.assign(this,{content:{},length:null,current:null,loaded:null,progress:null,rejectOnError:!1});}return function(t,e,r){e&&n(t.prototype,e);}(t,[{key:"getXhr",value:function value(t,e,n,r,i){var o=this,a=new XMLHttpRequest();return a.lastLoaded=0,a.image=null,a.lengthComputable=!0,a.loaded=0,a.open("GET",e,!0),"image"===t?(a.responseType="arraybuffer",a.image=new Image()):"document"===t?(a.responseType=t,a.overrideMimeType("text/xml")):a.responseType=t,a.setRequestHeader("X-Requested-With","XMLHttpRequest"),a.setRequestHeader("Content-type","text"),a.onprogress=function(t){return o.onprogress(a,t);},a.onload=function(){200===a.status?"image"===t?(a.image.onload=function(){return o.onload(a,n,r);},a.image.src=window.URL.createObjectURL(new Blob([a.response]))):o.onload(a,n,r):o.rejectOnError?i(a):o.onloadBroken(a,n,r);},a.onerror=function(t){return i(t);},a;}},{key:"load",value:function value(t){var e=this;return new Promise(function(n,r){if(t&&t.sources)for(var i in Object.assign(e,{length:Object.keys(t.sources).length,current:0,loaded:0,progress:function progress(){return 0;},rejectOnError:!1},t),t.sources){var o=t.sources[i];e.content[i]=e.getXhr(o.type||"text",o.source||o,i,n,r),e.content[i].send();}else r(new Error("GLKIT Loader: no sources."));});}},{key:"onprogress",value:function value(t,e){t.lengthComputable=e.lengthComputable,t.lengthComputable&&(this.loaded+=e.loaded/e.total-t.lastLoaded,t.lastLoaded=e.loaded/e.total,t.loaded=t.lastLoaded,this.progress());}},{key:"onload",value:function value(t,e,n){this.loaded+=t.lengthComputable?1-t.loaded:1,this.progress();var r=this.content[e];this.content[e]=r.image||r.response||r.responseText,++this.current===this.length&&(this.loaded=this.length,this.progress(),n(this.content));}},{key:"onloadBroken",value:function value(t,e,n){this.loaded++,this.progress(),this.content[e]=null,++this.current===this.length&&(this.loaded=this.length,this.progress(),n(this.content));}}]),t;}();}]);},function(t,e,n){(function(e){function n(t){return function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++){n[e]=t[e];}return n;}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t);}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance");}();}t.exports={getDrawFunc2Attr:function getDrawFunc2Attr(t,r,i,o,a,s,u,l,c){try{var f=t.program,h=r.vertices.map(function(t){return new Float32Array(t);}),p=new a.MVBO({content:h,name:"aStartPosition",interpolation:i,location:0}),d=new a.MVBO({content:h,name:"aEndPosition",interpolation:i,index:1,location:1}),v=null;if(n(p.content).concat(n(d.content)).filter(function(t){return t.length/3>65536;}).length){if(o){var m=new a.MIBO({content:r.triangles.map(function(t){return new Uint32Array(t);}),interpolation:i}),y=m.content.map(function(t){return t.length;});v=function v(){s.useProgram(f),p.enable(),d.enable(),m.enable(),s.drawElements(u,y[m.current],c,0);};}else{for(var g=r.triangles.map(function(t){return Array.prototype.slice.call(new Uint32Array(t));}),x=[],b=[],w=g.length,_=[],T=[],k=0;k<w;k++){T[k]=[],_[k]=[];var E=g[k],O=g[k].length;x[k]=[],b[k]=[];for(var S=0,A={},C=0;C<O;C+=3){if(E[C]>65535||E[C+1]>65535||E[C+2]>65535)for(var F=0;F<3;F++){x[k].push(E[C+F]),A[E[C+F]]||(A[E[C+F]]=S++,_[k].push(h[k][3*E[C+F]],h[k][3*E[C+F]+1],h[k][3*E[C+F]+2])),T[k].push(A[E[C+F]]);}else b[k].push(E[C],E[C+1],E[C+2]);}}var M=new a.MIBO({content:T.map(function(t){return new Uint16Array(t);}),interpolation:i}),P=new a.MIBO({content:b.map(function(t){return new Uint16Array(t);}),interpolation:i}),D=_.map(function(t){return new Float32Array(t);}),I=new a.MVBO({content:D,name:"aStartPosition",interpolation:i,location:0}),L=new a.MVBO({content:D,name:"aEndPosition",interpolation:i,index:1,location:1}),R=M.content.map(function(t){return t.length;}),j=P.content.map(function(t){return t.length;});v=function v(){s.useProgram(f),I.enable(),L.enable(),M.enable(),s.drawElements(u,R[M.current],l,0),p.enable(),d.enable(),P.enable(),s.drawElements(u,j[P.current],l,0);};}}else{var B=new a.MIBO({content:r.triangles.map(function(t){return new Uint16Array(t);}),interpolation:i}),N=B.content.map(function(t){return t.length;});v=function v(){s.useProgram(f),p.enable(),d.enable(),B.enable(),s.drawElements(u,N[B.current],l,0);};}return v;}catch(t){(e||function(){return 0;})(t,"getDrawFunc2Attr");}},getDrawFunc4Attr:function getDrawFunc4Attr(t,r,i,o,a,s,u,l,c,f,h){try{var p=t.program,d=r.vertices.map(function(t){return new Float32Array(t);}),v=new u.MVBO({content:d,name:"aStartPosition",interpolation:i,location:0}),m=new u.MVBO({content:d,name:"aEndPosition",interpolation:i,index:1,location:1}),y=o.map(function(t){return new Float32Array(t);}),g=new u.MVBO({content:y,name:"aStartColor",interpolation:a,location:2}),x=new u.MVBO({content:y,name:"aEndColor",interpolation:a,index:1,location:3}),b=null;if(n(v.content).concat(n(m.content)).filter(function(t){return t.length/3>65536;}).length){if(s){var w=new u.MIBO({content:r.triangles.map(function(t){return new Uint32Array(t);}),interpolation:i}),_=w.content.map(function(t){return t.length;});b=function b(){l.useProgram(p),v.enable(),m.enable(),g.enable(),x.enable(),w.enable(),l.drawElements(c,_[w.current],h,0);};}else{for(var T=r.triangles.map(function(t){return Array.prototype.slice.call(new Uint32Array(t));}),k=[],E=[],O=T.length,S=[],A=[],C=[],F=0;F<O;F++){C[F]=[],S[F]=[],A[F]=[];var M=T[F],P=T[F].length;k[F]=[],E[F]=[];for(var D=0,I={},L=0;L<P;L+=3){if(M[L]>65535||M[L+1]>65535||M[L+2]>65535)for(var R=0;R<3;R++){k[F].push(M[L+R]),I[M[L+R]]||(I[M[L+R]]=D++,S[F].push(d[F][3*M[L+R]],d[F][3*M[L+R]+1],d[F][3*M[L+R]+2]),A[F].push(y[F][3*M[L+R]],y[F][3*M[L+R]+1],y[F][3*M[L+R]+2])),C[F].push(I[M[L+R]]);}else E[F].push(M[L],M[L+1],M[L+2]);}}var j=new u.MIBO({content:C.map(function(t){return new Uint16Array(t);}),interpolation:i}),B=new u.MIBO({content:E.map(function(t){return new Uint16Array(t);}),interpolation:i}),N=S.map(function(t){return new Float32Array(t);}),U=A.map(function(t){return new Float32Array(t);}),z=new u.MVBO({content:N,name:"aStartPosition",interpolation:i,location:0}),W=new u.MVBO({content:N,name:"aEndPosition",interpolation:i,index:1,location:1}),X=new u.MVBO({content:U,name:"aStartColor",interpolation:i,location:2}),V=new u.MVBO({content:U,name:"aEndColor",interpolation:i,index:1,location:3}),Y=j.content.map(function(t){return t.length;}),H=B.content.map(function(t){return t.length;});b=function b(){l.useProgram(p),z.enable(),W.enable(),X.enable(),V.enable(),j.enable(),l.drawElements(c,Y[j.current],f,0),v.enable(),m.enable(),g.enable(),x.enable(),B.enable(),l.drawElements(c,H[B.current],f,0);};}}else{var q=new u.MIBO({content:r.triangles.map(function(t){return new Uint16Array(t);}),interpolation:i}),G=q.content.map(function(t){return t.length;});b=function b(){l.useProgram(p),v.enable(),m.enable(),g.enable(),x.enable(),q.enable(),l.drawElements(c,G[q.current],f,0);};}return b;}catch(t){(e||function(){return 0;})(t,"getDrawFunc4Attr");}},getDrawFunc2AttrSingle:function getDrawFunc2AttrSingle(t,n,r,i,o,a,s,u){try{var l=t.program,c=new Float32Array(n.vertices),f=new i.VBO({content:c,name:"position",location:0}),h=null;if(f.content.length/3>65536){if(r){var p=new i.IBO({content:new Uint32Array(n.triangles)}),d=p.content.length;h=function h(){o.useProgram(l),f.enable(),p.enable(),o.drawElements(a,d,u,0);};}else{for(var v=[],m=[],y=[],g=[],x=Array.prototype.slice.call(new Uint32Array(n.triangles)),b=x.length,w=0,_={},T=0;T<b;T+=3){if(x[T]>65535||x[T+1]>65535||x[T+2]>65535)for(var k=0;k<3;k++){v.push(x[T+k]),_[x[T+k]]||(_[x[T+k]]=w++,y.push(c[3*x[T+k]],c[3*x[T+k]+1],c[3*x[T+k]+2])),g.push(_[x[T+k]]);}else m.push(x[T],x[T+1],x[T+2]);}var E=new i.IBO({content:new Uint16Array(g)}),O=new i.IBO({content:new Uint16Array(m)}),S=new Float32Array(y),A=new i.VBO({content:S,name:"position",location:0}),C=E.content.length,F=O.content.length;h=function h(){o.useProgram(l),A.enable(),E.enable(),o.drawElements(a,C,s,0),f.enable(),O.enable(),o.drawElements(a,F,s,0);};}}else{var M=new i.IBO({content:new Uint16Array(n.triangles)}),P=M.content.length;h=function h(){o.useProgram(l),f.enable(),M.enable(),o.drawElements(a,P,s,0);};}return h;}catch(t){(e||function(){return 0;})(t,"getDrawFunc2AttrSingle");}},getDrawFunc4AttrSingle:function getDrawFunc4AttrSingle(t,n,r,i,o,a,s,u,l){try{var c=t.program,f=new Float32Array(n.vertices),h=new Float32Array(r),p=new o.VBO({content:f,name:"position",location:0}),d=new o.VBO({content:h,name:"color",location:1}),v=null;if(p.content.length/3>65536){if(i){var m=new o.IBO({content:new Uint32Array(n.triangles)}),y=m.content.length;v=function v(){a.useProgram(c),p.enable(),d.enable(),m.enable(),a.drawElements(s,y,l,0);};}else{for(var g=[],x=[],b=[],w=[],_=[],T=Array.prototype.slice.call(new Uint32Array(n.triangles)),k=T.length,E=0,O={},S=0;S<k;S+=3){if(T[S]>65535||T[S+1]>65535||T[S+2]>65535)for(var A=0;A<3;A++){g.push(T[S+A]),O[T[S+A]]||(O[T[S+A]]=E++,b.push(f[3*T[S+A]],f[3*T[S+A]+1],f[3*T[S+A]+2]),w.push(h[3*T[S+A]],h[3*T[S+A]+1],h[3*T[S+A]+2])),_.push(O[T[S+A]]);}else x.push(T[S],T[S+1],T[S+2]);}var C=new o.IBO({content:new Uint16Array(_)}),F=new o.IBO({content:new Uint16Array(x)}),M=new Float32Array(b),P=new Float32Array(w),D=new o.VBO({content:M,name:"position",location:0}),I=new o.VBO({content:P,name:"color",location:1}),L=C.content.length,R=F.content.length;v=function v(){a.useProgram(c),D.enable(),I.enable(),C.enable(),a.drawElements(s,L,u,0),p.enable(),d.enable(),F.enable(),a.drawElements(s,R,u,0);};}}else{var j=new o.IBO({content:new Uint16Array(n.triangles)}),B=j.content.length;v=function v(){a.useProgram(c),p.enable(),d.enable(),j.enable(),a.drawElements(s,B,u,0);};}return v;}catch(t){(e||function(){return 0;})(t,"getDrawFunc4AttrSingle");}}};}).call(this,n(1));},function(t,e){t.exports=function(t){throw document.getElementsByClassName("ortho-nowebgl")[0].getElementsByTagName("span")[0].style.display="table-cell",new Error(t);};},function(t,e,n){(function(e){t.exports=function(){var t=e(".ortho-loader").find("circle"),n=e(".ortho-perc");return function(){var e=this.loaded/this.length;t.css({"stroke-dasharray":"".concat(280*e,", 1000")}),n.html("".concat(Math.floor(100*e),"%"));};};}).call(this,n(2));},function(t,e,n){(function(e){t.exports=function(t,n){try{var r=new t.Orbit({camera:new t.Camera(),rotation:new t.DataArrayFloat2({name:"orbitRotation"}),translation:new t.DataFloat3({name:"orbitTranslation",z:750})});return r.startX=0,r.currentX=0,r.endX=0,r.currentY=0,r.endY=0,r.startY=0,{orbit:r,updateProjectionMatrix:[function(){return r.camera.updateProjectionMatrixPerspective({fov:10,aspect:n.offsetWidth/n.offsetHeight,near:1,far:2e3});},function(){return r.camera.updateProjectionMatrixOrthographic({left:.5*-n.offsetWidth,right:.5*n.offsetWidth,top:.5*n.offsetHeight,bottom:.5*-n.offsetHeight,near:1,far:2e3,zoom:6});}]};}catch(t){(e||function(){return 0;})(t,"cameras");}};}).call(this,n(1));},function(t,e){t.exports={ROTATION_MATRIX_X:"mat4 rotationMatrixX(float a) {\n      float c = cos(a);\n      float s = sin(a);\n      return mat4(1., 0., 0., 0., 0., c, -s, 0., 0., s, c, 0., 0., 0., 0., 1.);\n    }",ROTATION_MATRIX_Y:"mat4 rotationMatrixY(float a) {\n      float c = cos(a);\n      float s = sin(a);\n      return mat4(c, 0., s, 0., 0., 1., 0., 0., -s, 0., c, 0., 0., 0., 0., 1.);\n    }"};},function(t,e){t.exports=function(t,e,n,r){for(var i=e.LINES,o=[],a=[],s=0;s<=100;s++){o.push(-50,s-50,-100,50,s-50,-100,s-50,-50,-100,s-50,50,-100),s%5==0?a.push(0,.522/1.2,.541/1.2,0,.522/1.2,.541/1.2,0,.522/1.2,.541/1.2,0,.522/1.2,.541/1.2):a.push(0,.6525,.67625,0,.6525,.67625,0,.6525,.67625,0,.6525,.67625);}var u=o.length/3,l=new t.Material({VS:function VS(){return"\n        precision ".concat(t.maxPrecision.vs.float," float;\n        ").concat(n.uniform(this),"\n        ").concat(r.uniform(this),"\n        attribute vec3 position;\n        attribute vec3 color;\n        varying vec3 vColor;\n        void main() {\n          vColor = color;\n          gl_Position = projectionMatrix * vec4(position, zoom);\n        }\n      ");},FS:"\n      precision ".concat(t.maxPrecision.fs.float," float;\n      varying vec3 vColor;\n      void main() {\n        gl_FragColor = vec4(vColor, 1.);\n      }\n      ")}).program,c=new t.VBO({name:"position",content:new Float32Array(o),location:0}),f=new t.VBO({name:"color",content:new Float32Array(a),location:1});return new t.Obj({draw:function draw(){e.useProgram(l),c.enable(),f.enable(),e.drawArrays(i,0,u);}});};},function(t,e,n){(function(e,n){function r(t,e){return function(t){if(Array.isArray(t))return t;}(t)||function(t,e){var n=[],r=!0,i=!1,o=void 0;try{for(var a,s=t[Symbol.iterator]();!(r=(a=s.next()).done)&&(n.push(a.value),!e||n.length!==e);r=!0){}}catch(t){i=!0,o=t;}finally{try{r||null==s.return||s.return();}finally{if(i)throw o;}}return n;}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}();}t.exports=function(t,i,o,a,s,u,l,c,f,h,p,d,v,m,y){try{var g=function g(t){return e("a.ortho-nav-mobile-icon.-".concat(t,", a.ortho-nav-cell.-").concat(t));},x=e("a.ortho-nav-mobile-icon.-menu"),b=g("both"),w=g("upper"),_=g("lower"),T=g("occlusion"),k=e("a.ortho-nav-cell.-both, a.ortho-nav-cell.-upper, a.ortho-nav-cell.-lower, a.ortho-nav-cell.-occlusion"),E=g("separations"),O=g("locks"),S=g("grid"),A=g("pdf"),C=e(".ortho-subnav-cell.-en"),F=e(".ortho-subnav-cell.-ru"),M=g("plan_bone"),P=g("back"),D=g("transp"),I=g("transp_back"),L=e(".ortho-nav-mobile"),R=e(".ortho-subnav"),j=e("a.ortho-nav-mobile-icon.-info"),B=e(".ortho-info"),N=0,U=.5*Math.PI,z=2*Math.PI,W={};window.__GET_ORBIT_ROTATION__=function(){var t=r(d.rotation.arr,2),e=t[0],n=t[1];W.currentY=d.currentY,W.currentX=d.currentX,W.endY=d.endY,W.endX=d.endX,W.startY=d.startY,W.startX=d.startX,console.log("__SET_ORBIT_ROTATION__(".concat(e,", ").concat(n,", 1000)"));},window.__SET_ORBIT_ROTATION__=function(t,e,n){d.currentY=W.currentY,d.currentX=W.currentX,d.endY=W.endY,d.endX=W.endX,d.startY=W.startY,d.startX=W.startX,d.rotation.setCallbackTransitionWithUniforms({func:o,to:[t,e],duration:n});};var X={func:o,to:[0,0],duration:1e3},V={func:o,to:0,duration:1e3},Y={func:o,to:U,duration:1e3},H=null;H="main"===window.__VIEWER_TYPE__||"ply"===window.__VIEWER_TYPE__?function(t,n,r,o,u,l){k.removeClass("-active"),t.addClass("-active"),e(".ortho-occl").hide(),N=n,a.x=r,s.x=o,a.updateUniforms(),s.updateUniforms(),"ply"===window.__VIEWER_TYPE__&&(p.x=u),i.setCallbackTransitionWithUniforms(l);}:function(t,e,n,r,o,u){k.removeClass("-active"),t.addClass("-active"),N=e,a.x=n,s.x=r,a.updateUniforms(),s.updateUniforms(),"ply"===window.__VIEWER_TYPE__&&(p.x=o),i.setCallbackTransitionWithUniforms(u);};var q=[function(){var t=d.rotation.arr;if(0!==t[0]||0!==t[1])d.currentY=0,d.currentX=0,d.endY=0,d.endX=0,d.startY=0,d.startX=0,t[0]-=Math.round(t[0]/z)*z,t[1]-=Math.round(t[1]/z)*z,d.rotation.setCallbackTransitionWithUniforms(X);else{var e=d.translation.y,n=d.translation.x;G.x=0,G.setExtendedTransition({func:o,to:1,duration:500,onProgress:function onProgress(){var t=o(G.transitionInterpolation);d.translation.y=e+t*(0-e),d.translation.x=n+t*(0-n),c.clbk();},onEnd:function onEnd(){d.translation.y=0,d.translation.x=0,c.clbk();}});}},function(){return H(b,0,1,1,0,V);}];x.on("click",function(){return L.toggleClass("-visible");}),window.__VIEW_BOTH__=function(){return q[N]();},b.on("click",window.__VIEW_BOTH__);var G=new c.DataFloat1();if(window.__VIEW_BOTH_2__=function(){window.__VIEW_BOTH__();var t=d.translation.y,e=d.translation.x;G.x=0,G.setExtendedTransition({func:o,to:1,duration:500,onProgress:function onProgress(){var n=o(G.transitionInterpolation);d.translation.y=t+n*(0-t),d.translation.x=e+n*(0-e),c.clbk();},onEnd:function onEnd(){d.translation.y=0,d.translation.x=0,c.clbk();}});},b.on("dblclick",window.__VIEW_BOTH_2__),window.__VIEW_UPPER__=function(){return H(w,1,1,0,0,V);},w.on("click",window.__VIEW_UPPER__),window.__VIEW_LOWER__=function(){return H(_,1,0,1,0,V);},_.on("click",window.__VIEW_LOWER__),("main"===window.__VIEWER_TYPE__||"ply"===window.__VIEWER_TYPE__)&&Boolean(m&&y)?(window.__OCCLUSION__=function(){H(T,1,1,1,1,Y),e(".ortho-occl").show();},T.on("click",window.__OCCLUSION__)):T.remove(),"main"===window.__VIEWER_TYPE__||"ply"===window.__VIEWER_TYPE__)window.__VIEW_IPR__=function(){E.toggleClass("-active"),h.x=1-h.x,c.clbk();},E.on("click",window.__VIEW_IPR__),window.__VIEW_ATTACHMENTS__=function(){O.toggleClass("-active"),f.x=1-f.x,c.clbk();},O.on("click",window.__VIEW_ATTACHMENTS__);else{var $=e(O[1]).parent();$.next().remove(),$.remove(),O.remove(),E.remove();}if(window.__VIEW_GRID__=function(){S.toggleClass("-active"),u[l.x=1-l.x](),d.camera.projectionMatrix.updateUniforms(),c.clbk();},S.on("click",window.__VIEW_GRID__),"main"===window.__VIEWER_TYPE__||"ply"===window.__VIEWER_TYPE__?(R.on("click",function(){return R.hide();}),C.on("click",function(){return window.open(t.pdf.en);}),F.on("click",function(){return window.open(t.pdf.ru);}),A.on("click",function(){R.toggle(),A.toggleClass("-active");})):(R.remove(),C.remove(),F.remove(),A.remove()),"main"===window.__VIEWER_TYPE__||window.__VIEWER_TYPE__,M.remove(),window.__VIEWER_TYPE__,P.remove(),"roots"===window.__VIEWER_TYPE__||"deepct"===window.__VIEWER_TYPE__){var Z={.6:1,1:.6};I.hide(),window.__VIEW_TRANSPARENT_ON__=function(){D.hide(),I.show(),e(".ortho-dist").show(),v.x=Z[v.x],v.updateUniforms(),c.clbk();},D.on("click",window.__VIEW_TRANSPARENT_ON__),window.__VIEW_TRANSPARENT_OFF__=function(){I.hide(),D.show(),e(".ortho-dist").hide(),v.x=Z[v.x],v.updateUniforms(),c.clbk();},I.on("click",window.__VIEW_TRANSPARENT_OFF__);}else D.remove(),I.remove();B.on("click",function(t){"a"!==t.target.tagName.toLowerCase()?B.removeClass("-visible"):window.location=t.target.href;}),j.on("click",function(){return B.addClass("-visible");}),"deepct"===window.__VIEWER_TYPE__&&e(".ortho-controls").remove(),"main"!==window.__VIEWER_TYPE__?e(".ortho-occl").remove():(e(".ortho-occl").hide(),e(".ortho-occl-ru").remove()),"roots"!==window.__VIEWER_TYPE__&&"deepct"!==window.__VIEWER_TYPE__?e(".ortho-dist").remove():(e(".ortho-dist").hide(),e(".ortho-dist-ru").remove()),Boolean(m)||e(".ortho-controls-current.-up").remove(),Boolean(y)||e(".ortho-controls-current.-down").remove();}catch(t){(n||function(){return 0;})(t,"modes");}};}).call(this,n(2),n(1));},function(t,e,n){(function(e,r){var i=n(14),o=i.mobile||i.tablet,a=[],s=!1;t.exports=function(t,n,i,u,l,c,f){try{var h=f?f.controls:null,p=u.math.BezierCubicCurve(.25,1,1,1),d=0,v=0,m=0,y=0,g=0,x=0,b=0,w=0,_=0,T=0,k=0;t.mousePrevTransX=0,t.mousePrevTransY=0,t.mouseTransX=0,t.mouseTransY=0;var E=0,O=function O(){i.x<.25?i.x=.25:i.x>1.5&&(i.x=1.5),f&&(i.x<.5?h.hide():h.show()),i.updateUniforms(),u.clbk();};window.addEventListener("wheel",function(t){"img"!==t.target.tagName.toLowerCase()&&t.target.className.search("non_scrollable")<0&&(i.x+=.1*Math.sign(t.deltaY||t.detail||t.wheelDelta),O());},!1),window.addEventListener("keydown",function(t){38!==t.keyCode&&40!==t.keyCode||(i.x+=.1*(t.keyCode-39),O());},!1);var S=[];window.__GET_ORBIT_TRANSLATION__=function(){return console.log("__SET_ORBIT_TRANSLATION__(".concat(t.translation.x,", ").concat(t.translation.y,")"));},window.__SET_ORBIT_TRANSLATION__=function(e,n){t.translation.x=e,t.translation.y=n,u.clbk();};var A=[function(e){t.currentX=e.clientY-t.startX,t.currentY=e.clientX-t.startY,S[0]=.0025*(t.endX+t.currentX),S[1]=.0025*(t.endY+t.currentY),t.rotation.setCallbackTransitionWithUniforms({func:p,to:S,duration:300});},function(e){t.mouseTransX=.005*(e.clientY-t.mousePrevTransX),t.mouseTransY=.005*(e.clientX-t.mousePrevTransY),t.mousePrevTransX=e.clientY,t.mousePrevTransY=e.clientX,t.translation.y+=26.76*t.mouseTransX,t.translation.x-=26.76*t.mouseTransY,u.clbk();}];t.mousemove=function(t){A[E](t);};var C=[function(n){E=0,t.startX=n.clientY,t.startY=n.clientX,t.currentX=n.clientY-t.startX,t.currentY=n.clientX-t.startY,S[0]=.0025*(t.endX+t.currentX),S[1]=.0025*(t.endY+t.currentY),t.rotation[0]=S[0],t.rotation[1]=S[1],e(window).on("mousemove",t.mousemove);},function(n){E=0,t.startX=n.clientY,t.startY=n.clientX,t.currentX=n.clientY-t.startX,t.currentY=n.clientX-t.startY,S[0]=.0025*(t.endX+t.currentX),S[1]=.0025*(t.endY+t.currentY),t.rotation[0]=S[0],t.rotation[1]=S[1],e(window).on("mousemove",t.mousemove);},function(n){E=1,t.mousePrevTransX=n.clientY,t.mousePrevTransY=n.clientX,e(window).on("mousemove",t.mousemove);},function(n){E=1,t.mousePrevTransX=n.clientY,t.mousePrevTransY=n.clientX,e(window).on("mousemove",t.mousemove);}];t.mousedown=function(t){t.target===n.canvas?(s=!0,C[t[t.which?"which":"button"]](t)):s=!1;},e(window).on("mousedown",t.mousedown);var F=[function(e){t.endY+=t.currentY,t.endX+=t.currentX;},function(){}];t.mouseup=function(){s&&F[E](),e(window).off("mousemove",t.mousemove);},e(window).on("mouseup",t.mouseup);var M=[function(){},function(e){var n=e.touches;n[0].clientY<window.innerHeight-80&&(y=.005*(n[0].clientY-v),g=.005*(n[0].clientX-m),v=n[0].clientY,m=n[0].clientX,t.rotation.arr[0]+=y,t.rotation.arr[1]+=g,t.rotation.updateUniforms(),u.clbk());},function(t){var e=t.touches;if(e[0].clientY<window.innerHeight-80&&e[1].clientY<window.innerHeight-80){var n=e[1].clientX-e[0].clientX;n*=n;var r=e[1].clientY-e[0].clientY;r*=r,b=Math.sqrt(n+r),i.x-=.001*(b-x),x=b,O();}},function(e){var n=e.touches;n[0].clientY<window.innerHeight-80&&n[1].clientY<window.innerHeight-80&&n[2].clientY<window.innerHeight-80&&(T=.005*(n[1].clientY-w),k=.005*(n[1].clientX-_),w=n[1].clientY,_=n[1].clientX,t.translation.y+=20*T,t.translation.x-=20*k,u.clbk());}];t.touchmove=function(t){t.preventDefault(),(f&&!f.isMoving||!f)&&M[d](t);};var P=[function(){},function(t){var e=t.touches;v=e[0].clientY,m=e[0].clientX;},function(t){var e=t.touches,n=(a=[[e[0].clientX,e[0].clientY],[e[1].clientX,e[1].clientY]])[1][0]-a[0][0];n*=n;var r=a[1][1]-a[0][1];r*=r,b=x=Math.sqrt(n+r);},function(t){var e=t.touches;w=e[1].clientY,_=e[1].clientX;}];if(t.touchstart=function(t){t.preventDefault(),d=t.touches.length,P[d](t);},t.touchend=function(t){t.preventDefault(),d=0,f&&(f.isMoving=!1);},e(n.canvas).on("touchstart",t.touchstart).on("touchend",t.touchend).on("touchmove",t.touchmove),e(window).on("contextmenu",function(t){t.preventDefault();}),o){var D=!1;document.body.offsetWidth>document.body.offsetHeight&&h?h.hide():h&&h.show(),e(window).on("resize",function(){D&&(D=!1,document.body.offsetWidth>document.body.offsetHeight&&h?h.hide():i.x>=.5&&h&&h.show(),u.setSize(0,0,document.body.offsetWidth,document.body.offsetHeight),l[c.x](),t.camera.projectionMatrix.updateUniforms(),f&&(f.left=f.currStep/f.steps*f.parent.offsetWidth,f.style.left="".concat(f.left,"px"),f.mouseupX=Math.round(f.left/f.parent.offsetWidth*f.steps)*f.parent.offsetWidth/f.steps),u.clbk());}),e(window).on("orientationchange",function(){D=!0;});}else window.addEventListener("resize",function(){u.setSize(0,0,document.body.offsetWidth,document.body.offsetHeight),l[c.x](),t.camera.projectionMatrix.updateUniforms(),f&&(f.left=f.currStep/f.steps*f.parent.offsetWidth,f.style.left="".concat(f.left,"px"),f.mouseupX=Math.round(f.left/f.parent.offsetWidth*f.steps)*f.parent.offsetWidth/f.steps),u.clbk();},!1);}catch(t){(r||function(){return 0;})(t,"orbit");}};}).call(this,n(2),n(1));},function(t,e,n){(function(e,r){var i=n(14);t.exports=function(t,n,o,a,s,u,l,c){try{var f=Object({"Plan ID":"Plan ID ","Upper jaw":"Upper jaw","Lower jaw":"Lower jaw","Total steps":"Total steps","IPR before step":"IPR before step",Step:"Step",Approve:"Approve",Publish:"Publish",Rework:"Rework",Aligner:"Aligner","Are you sure?":"Are you sure?","Initial condition":"Initial condition",Correction:"Correction",profile:"Profile (not smiling)",full_face_with_smile:"Full face (smiling)",full_face_without_smile:"Full face (not smiling)",occlusal_view_upper:"Upper occlusal",occlusal_view_lower:"Lower occlusal",lateral_view_right:"Right view",front_view:"Front view",lateral_view_left:"Left view","Extra photos":"Extra photos"}),h=document.getElementsByClassName("ortho-info-inner")[0];h.innerHTML='<div class="non_scrollable ortho-info-row -head">'.concat(f["Plan ID"]).concat(t.case,"</div>");var p=document.createElement("div");if(p.className="non_scrollable ortho-info-block",p.innerHTML="",Boolean(l))if("deepct"!==window.__VIEWER_TYPE__&&(p.innerHTML+='\n        <div class="non_scrollable ortho-info-row">'.concat(f["Upper jaw"],':</div>\n        <div class="non_scrollable ortho-info-row">').concat(f["Total steps"],": ").concat(parseInt(o[o.length-1])+1,"</div>\n        ")),"ply"===window.__VIEWER_TYPE__){if(n.upper.separations){p.innerHTML+='<div class="non_scrollable ortho-info-row">'.concat(f["IPR before step"],":</div>");for(var d=0;d<a.length;d++){p.innerHTML+='<div class="non_scrollable ortho-info-row -stage '.concat(a[d],' -blue">').concat(f.Step,": ").concat(parseInt(a[d])+1,"</div>");}}}else if("main"===window.__VIEWER_TYPE__){var v=[];for(var m in n.dict.upper){n.dict.upper[m].separation&&v.push(n.dict.upper[m].model[0].from);}if(v.length){p.innerHTML+='<div class="non_scrollable ortho-info-row">'.concat(f["IPR before step"],":</div>");for(var y=0;y<v.length;y++){p.innerHTML+='<div class="non_scrollable ortho-info-row -stage '.concat(v[y],' -blue">').concat(f.Step,": ").concat(parseInt(v[y])+1,"</div>");}}}if(Boolean(c))if("deepct"!==window.__VIEWER_TYPE__&&(p.innerHTML+='\n        <div class="non_scrollable ortho-info-row">'.concat(f["Lower jaw"],':</div>\n        <div class="non_scrollable ortho-info-row">').concat(f["Total steps"],": ").concat(parseInt(s[s.length-1])+1,"</div>\n        ")),"ply"===window.__VIEWER_TYPE__){if(n.lower.separations){p.innerHTML+='<div class="non_scrollable ortho-info-row">'.concat(f["IPR before step"],":</div>");for(var g=0;g<u.length;g++){p.innerHTML+='<div class="non_scrollable ortho-info-row -stage '.concat(u[g],' -blue">').concat(f.Step,": ").concat(parseInt(u[g])+1,"</div>");}}}else if("main"===window.__VIEWER_TYPE__){var x=[];for(var b in n.dict.lower){n.dict.lower[b].separation&&x.push(n.dict.lower[b].model[0].from);}if(x.length){p.innerHTML+='<div class="non_scrollable ortho-info-row">'.concat(f["IPR before step"],":</div>");for(var w=0;w<x.length;w++){p.innerHTML+='<div class="non_scrollable ortho-info-row -stage '.concat(x[w],' -blue">').concat(f.Step,": ").concat(parseInt(x[w])+1,"</div>");}}}h.appendChild(p),h.innerHTML+='\n        <div class="non_scrollable ortho-info-block -bottom">\n          <a class="non_scrollable ortho-publish-button">'.concat(f.Publish,'</a>\n          <a class="non_scrollable ortho-rework-button" href="/">').concat(f.Rework,"</a>\n        </div>\n        "),!i.mobile&&i.tablet,window.__VIEWER_TYPE__;for(var _=document.getElementsByClassName("-stage"),T=0;T<_.length;T++){_[T].stage=_[T].className.split(" ")[2];}e(".ortho-info-row.-stage.0").addClass("-red"),e(".ortho-publish-button").on("click",function(e){e.preventDefault(),e.stopPropagation(),window.confirm(f["Are you sure?"])&&t.nextStep&&t.nextStep();}),e(".ortho-rework-button").on("click",function(t){t.preventDefault(),t.stopPropagation(),e(".ortho-comment").toggle(),E[0].focus();});var k=e(".ortho-comment-btn"),E=e(".ortho-comment-inner-textarea");k.on("click",function(){var n=E.val();t.comment(n,function(){e(".ortho-comment").hide(),E.val(""),k.attr("disabled",!0),window.location="/";});}),E.on("input",function(){var t=Boolean(E.val());k.attr("disabled",!t),k.css({cursor:t?"pointer":"default"});}),e(".ortho-comment-cancel").on("click",function(){e(".ortho-comment").hide(),E.val(""),k.attr("disabled",!0);});var O=e(e(".ortho-controls-current")[0]),S=e(e(".ortho-controls-current")[1]);O.html("".concat(f.Aligner," 1")),S.html("".concat(f.Aligner," 1"));var A=[37,38,39,40];e(window).on("keydown keyup",function(t){A.indexOf(t.keyCode)>-1&&t.preventDefault();});}catch(t){(r||function(){return 0;})(t,"info");}};}).call(this,n(2),n(1));},function(t,e,n){(function(e,n){function r(t){return function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++){n[e]=t[e];}return n;}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t);}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance");}();}t.exports=function(t,i,o,a,s,u,l,c,f,h,p,d,v,m,y,g,x,b,w,_){try{var T=e(".ortho-controls-actions-item"),k=e(e(".ortho-controls-current")[0]),E=e(e(".ortho-controls-current")[1]),O=e(".ortho-controls-slider")[0];O.parent=e(".ortho-controls-inner")[0],O.controls=e(".ortho-controls-inner").find(".ortho-controls-actions-inner"),O.line=e(".ortho-controls-line"),O.steps=Math.max(t.slice().pop()||0,i.slice().pop()||0);var S,A,C,F,M=function M(t){for(var e=[],n=0;n<=t.length;n+=2){var r=parseInt(t[n]),i=parseInt(t[n+1]),o=void 0;if(i-r){o=1/(i-r);for(var a=0;a<i-r;a++){e.push(n+o*a);}}else t[n]===t[n+1]&&t[n+1]===t[n+2]&&t[n+2]===t[n+3]||e.push(n);}return e;};if(O.upperLayers=M(t),O.lowerLayers=M(i),O.upperMax=O.upperLayers.length,O.lowerMax=O.lowerLayers.length,t[0]+t[1]+t[2]===0&&t.length<5&&(O.upperMax=1),i[0]+i[1]+i[2]===0&&i.length<5&&(O.lowerMax=1),O.upperLayersLocks=M(o),O.lowerLayersLocks=M(a),"main"===window.__VIEWER_TYPE__&&(O.layersColors=M(_||[])),O.upperLayers.length>O.lowerLayers.length)(S=O.lowerLayers).push.apply(S,r(new Array(O.upperLayers.length-O.lowerLayers.length).fill(O.lowerLayers[O.lowerLayers.length-1])));else(A=O.upperLayers).push.apply(A,r(new Array(O.lowerLayers.length-O.upperLayers.length).fill(O.upperLayers[O.upperLayers.length-1])));if(O.upperLayersLocks.length>O.lowerLayersLocks.length)(C=O.lowerLayersLocks).push.apply(C,r(new Array(O.upperLayersLocks.length-O.lowerLayersLocks.length).fill(O.lowerLayersLocks[O.lowerLayersLocks.length-1])));else(F=O.upperLayersLocks).push.apply(F,r(new Array(O.lowerLayersLocks.length-O.upperLayersLocks.length).fill(O.upperLayersLocks[O.upperLayersLocks.length-1])));O.interval=null,O.paused=!0,O.currStep=0,O.mousedownX=0,O.mouseupX=0,O.left=0,O.touchDown=[],O.isMoving=!1;var P=new s.DataFloat1();O.catcherEven=[0],O.switchEven=[function(t){return t-1;}],O.switchEven.undefined=function(t){return t;},O.catcherOdd=[0,1],O.switchOdd=[function(t){return t;},function(t){return t+1;}],O.switchOdd.undefined=function(t){return t;},O.setTLBack=function(t,e){return t.x=e[O.currStep+1],t.x=O.switchEven[O.catcherEven[t.x%2]](t.x),t.x;},O.setTLForw=function(t,e){t.x=e[O.currStep-1];var n=e[O.currStep];return n=O.switchEven[O.catcherEven[n%2]](n),[t.x,n];},O.moveBack=null,"main"===window.__VIEWER_TYPE__?O.moveBack=function(){var t=O.setTLBack(u[0],O.upperLayers),e=O.setTLBack(u[1],O.lowerLayers),n=O.setTLBack(l[0],O.upperLayersLocks),r=O.setTLBack(l[1],O.lowerLayersLocks),i=O.setTLBack(w,O.layersColors);P.x=0,P.setExtendedTransition({func:s.math.Linear,to:1,duration:250,onProgress:function onProgress(){u[0].x=s.utility.mix(t,O.upperLayers[O.currStep],P.x),u[1].x=s.utility.mix(e,O.lowerLayers[O.currStep],P.x),l[0].x=s.utility.mix(n,O.upperLayersLocks[O.currStep],P.x),l[1].x=s.utility.mix(r,O.lowerLayersLocks[O.currStep],P.x),w.x=s.utility.mix(i,O.layersColors[O.currStep],P.x),f.x=~~u[0].x,h.x=~~u[1].x,p.x=u[0].x-f.x,d.x=u[1].x-h.x,p.updateUniforms(),d.updateUniforms(),v.x=~~l[0].x,m.x=~~l[1].x,y.x=l[0].x-v.x,g.x=l[1].x-m.x,y.updateUniforms(),g.updateUniforms(),x.x=~~w.x,b.x=w.x-x.x,b.updateUniforms(),s.clbk();}});}:"ply"!==window.__VIEWER_TYPE__&&"roots"!==window.__VIEWER_TYPE__||(O.moveBack=function(){var t=O.setTLBack(u[0],O.upperLayers),e=O.setTLBack(u[1],O.lowerLayers),n=O.setTLBack(l[0],O.upperLayersLocks),r=O.setTLBack(l[1],O.lowerLayersLocks);P.x=0,P.setExtendedTransition({func:s.math.Linear,to:1,duration:250,onProgress:function onProgress(){u[0].x=s.utility.mix(t,O.upperLayers[O.currStep],P.x),u[1].x=s.utility.mix(e,O.lowerLayers[O.currStep],P.x),l[0].x=s.utility.mix(n,O.upperLayersLocks[O.currStep],P.x),l[1].x=s.utility.mix(r,O.lowerLayersLocks[O.currStep],P.x),f.x=~~u[0].x,h.x=~~u[1].x,p.x=u[0].x-f.x,d.x=u[1].x-h.x,p.updateUniforms(),d.updateUniforms(),v.x=~~l[0].x,m.x=~~l[1].x,y.x=l[0].x-v.x,g.x=l[1].x-m.x,y.updateUniforms(),g.updateUniforms(),s.clbk();}});}),O.moveForward=null,"main"===window.__VIEWER_TYPE__?O.moveForward=function(){var t=O.setTLForw(u[0],O.upperLayers),e=O.setTLForw(u[1],O.lowerLayers),n=O.setTLForw(l[0],O.upperLayersLocks),r=O.setTLForw(l[1],O.lowerLayersLocks),i=O.setTLForw(w,O.layersColors);P.x=0,P.setExtendedTransition({func:s.math.Linear,to:1,duration:250,onProgress:function onProgress(){u[0].x=s.utility.mix(t[0],t[1],P.x),u[0].x=O.switchOdd[O.catcherOdd[u[0].x%2]](u[0].x),u[1].x=s.utility.mix(e[0],e[1],P.x),u[1].x=O.switchOdd[O.catcherOdd[u[1].x%2]](u[1].x),l[0].x=s.utility.mix(n[0],n[1],P.x),l[0].x=O.switchOdd[O.catcherOdd[l[0].x%2]](l[0].x),l[1].x=s.utility.mix(r[0],r[1],P.x),l[1].x=O.switchOdd[O.catcherOdd[l[1].x%2]](l[1].x),w.x=s.utility.mix(i[0],i[1],P.x),w.x=O.switchOdd[O.catcherOdd[w.x%2]](w.x),f.x=~~u[0].x,h.x=~~u[1].x,p.x=u[0].x-f.x,d.x=u[1].x-h.x,p.updateUniforms(),d.updateUniforms(),v.x=~~l[0].x,m.x=~~l[1].x,y.x=l[0].x-v.x,g.x=l[1].x-m.x,y.updateUniforms(),g.updateUniforms(),x.x=~~w.x,b.x=w.x-x.x,b.updateUniforms(),s.clbk();}});}:"ply"!==window.__VIEWER_TYPE__&&"roots"!==window.__VIEWER_TYPE__||(O.moveForward=function(){var t=O.setTLForw(u[0],O.upperLayers),e=O.setTLForw(u[1],O.lowerLayers),n=O.setTLForw(l[0],O.upperLayersLocks),r=O.setTLForw(l[1],O.lowerLayersLocks);P.x=0,P.setExtendedTransition({func:s.math.Linear,to:1,duration:250,onProgress:function onProgress(){u[0].x=s.utility.mix(t[0],t[1],P.x),u[0].x=O.switchOdd[O.catcherOdd[u[0].x%2]](u[0].x),u[1].x=s.utility.mix(e[0],e[1],P.x),u[1].x=O.switchOdd[O.catcherOdd[u[1].x%2]](u[1].x),l[0].x=s.utility.mix(n[0],n[1],P.x),l[0].x=O.switchOdd[O.catcherOdd[l[0].x%2]](l[0].x),l[1].x=s.utility.mix(r[0],r[1],P.x),l[1].x=O.switchOdd[O.catcherOdd[l[1].x%2]](l[1].x),f.x=~~u[0].x,h.x=~~u[1].x,p.x=u[0].x-f.x,d.x=u[1].x-h.x,p.updateUniforms(),d.updateUniforms(),v.x=~~l[0].x,m.x=~~l[1].x,y.x=l[0].x-v.x,g.x=l[1].x-m.x,y.updateUniforms(),g.updateUniforms(),s.clbk();}});}),O.moveSide={"-1":function _(){return O.moveBack();},1:function _(){return O.moveForward();}},O.move=null;return"main"===window.__VIEWER_TYPE__||"ply"===window.__VIEWER_TYPE__?O.move=function(t){var n=O.currStep<t?1:-1;O.currStep=t,O.style.left="".concat(O.currStep/O.steps*O.parent.offsetWidth,"px"),O.moveSide[n](),c.x=O.currStep,c.updateUniforms(),k.html("".concat("Aligner"," ").concat((O.currStep>O.upperMax-1?O.upperMax-1:O.currStep)+1)),E.html("".concat("Aligner"," ").concat((O.currStep>O.lowerMax-1?O.lowerMax-1:O.currStep)+1)),e(".ortho-info-row.-stage").removeClass("-red"),e(".ortho-info-row.-stage.".concat(O.currStep)).addClass("-red");}:O.move=function(t){var e=O.currStep<t?1:-1;O.currStep=t,O.style.left="".concat(O.currStep/O.steps*O.parent.offsetWidth,"px"),O.moveSide[e](),k.html("".concat("Aligner"," ").concat((O.currStep>O.upperMax-1?O.upperMax-1:O.currStep)+1)),E.html("".concat("Aligner"," ").concat((O.currStep>O.lowerMax-1?O.lowerMax-1:O.currStep)+1));},O.line.on("click",function(t){t.preventDefault(),O.paused=!0,clearInterval(O.interval);var e=O.parent.offsetWidth/O.steps,n=Math.round(t.offsetX/e);O.left=n*e,O.mouseupX=O.left,O.currStep!==n&&O.move(n);}),O.mousemove=function(t){O.paused=!0,clearInterval(O.interval),O.left=O.mouseupX+(t.touches?t.touches[0]:t).clientX-O.mousedownX,O.left<0?O.left=0:window.innerWidth<768&&O.left>window.innerWidth-80?O.left=window.innerWidth-80:window.innerWidth>=768&&O.left>window.innerWidth-200&&(O.left=window.innerWidth-200);var e=Math.round(O.left/O.parent.offsetWidth*O.steps);O.currStep!=e&&O.move(e);},O.keyDownPlayForward=function(){O.left=O.mouseupX+1/O.steps*O.parent.offsetWidth,O.move(O.currStep+1),O.mouseupX=O.left;},O.keyDownPlayBack=function(){O.left=O.mouseupX-1/O.steps*O.parent.offsetWidth,O.move(O.currStep-1),O.mouseupX=O.left;},e(O).on("mousedown touchstart",function(t){O.paused=!0,clearInterval(O.interval),t.touches?(O.mousedownX=t.touches[0].clientX,e(O).on("touchmove",O.mousemove)):(O.mousedownX=t.clientX,e(window).on("mousemove",O.mousemove));}).on("touchend",function(t){O.mouseupX=O.left,e(O).off("touchmove",O.mousemove);}),e(window).on("mouseup",function(t){O.mouseupX=O.left,e(window).off("mousemove",O.mousemove);}).on("keydown",function(t){39==t.keyCode&&O.currStep+1<=O.steps?(O.paused=!0,clearInterval(O.interval),O.keyDownPlayForward()):37==t.keyCode&&O.currStep-1>=0?(O.paused=!0,clearInterval(O.interval),O.keyDownPlayBack()):32==t.keyCode&&(O.paused?(O.paused=!1,O.interval=setInterval(function(){O.currStep+1<=O.steps?O.keyDownPlayForward():(O.paused=!0,clearInterval(O.interval));},250)):(O.paused=!0,clearInterval(O.interval)));}),e(T[0]).on("click",function(){O.currStep&&(O.paused=!0,clearInterval(O.interval),O.left=0,O.move(0),O.mouseupX=0);}),e(T[1]).on("click",function(){O.paused||(O.paused=!0,clearInterval(O.interval));}),e(T[2]).on("click",function(){O.paused&&(O.paused=!1,O.interval=setInterval(function(){O.currStep+1<=O.steps?O.keyDownPlayForward():(O.paused=!0,clearInterval(O.interval));},250));}),e(T[3]).on("click",function(){O.steps-O.currStep&&(O.paused=!0,clearInterval(O.interval),O.left=O.parent.offsetWidth,O.move(O.steps),O.mouseupX=O.parent.offsetWidth);}),window.__SLIDER_FIRST__=function(){O.currStep&&(O.paused=!0,clearInterval(O.interval),O.left=0,O.move(0),O.mouseupX=0);},window.__SLIDER_PAUSE__=function(){O.paused||(O.paused=!0,clearInterval(O.interval));},window.__SLIDER_PLAY__=function(){O.paused&&(O.paused=!1,O.interval=setInterval(function(){O.currStep+1<=O.steps?O.keyDownPlayForward():(O.paused=!0,clearInterval(O.interval));},250));},window.__SLIDER_LAST__=function(){O.steps-O.currStep&&(O.paused=!0,clearInterval(O.interval),O.left=O.parent.offsetWidth,O.move(O.steps),O.mouseupX=O.parent.offsetWidth);},window.__GO_TO__=function(t){return O.move(t);},O;}catch(t){(n||function(){return 0;})(t,"slider");}};}).call(this,n(2),n(1));},function(t,e,n){var r,i;/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */!function(o,a){void 0!==t&&t.exports?t.exports=a():void 0===(i="function"==typeof(r=a)?r.call(e,n,e,t):r)||(t.exports=i);}(0,function(){var t=!0;function e(e){function n(t){var n=e.match(t);return n&&n.length>1&&n[1]||"";}var r,i=n(/(ipod|iphone|ipad)/i).toLowerCase(),o=!/like android/i.test(e)&&/android/i.test(e),a=/nexus\s*[0-6]\s*/i.test(e),s=!a&&/nexus\s*[0-9]+/i.test(e),u=/CrOS/.test(e),l=/silk/i.test(e),c=/sailfish/i.test(e),f=/tizen/i.test(e),h=/(web|hpw)os/i.test(e),p=/windows phone/i.test(e),d=!p&&/windows/i.test(e),v=!i&&!l&&/macintosh/i.test(e),m=!o&&!c&&!f&&!h&&/linux/i.test(e),y=n(/edge\/(\d+(\.\d+)?)/i),g=n(/version\/(\d+(\.\d+)?)/i),x=/tablet/i.test(e),b=!x&&/[^-]mobi/i.test(e);/opera|opr/i.test(e)?r={name:"Opera",opera:t,version:g||n(/(?:opera|opr)[\s\/](\d+(\.\d+)?)/i)}:/yabrowser/i.test(e)?r={name:"Yandex Browser",yandexbrowser:t,version:g||n(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)}:/ucbrowser/i.test(e)?r={name:"UC Browser",ucbrowser:t,version:n(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)}:p?(r={name:"Windows Phone",windowsphone:t},y?(r.msedge=t,r.version=y):(r.msie=t,r.version=n(/iemobile\/(\d+(\.\d+)?)/i))):/msie|trident/i.test(e)?r={name:"Internet Explorer",msie:t,version:n(/(?:msie |rv:)(\d+(\.\d+)?)/i)}:u?r={name:"Chrome",chromeos:t,chromeBook:t,chrome:t,version:n(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)}:/chrome.+? edge/i.test(e)?r={name:"Microsoft Edge",msedge:t,version:y}:/vivaldi/i.test(e)?r={name:"Vivaldi",vivaldi:t,version:n(/vivaldi\/(\d+(\.\d+)?)/i)||g}:/chrome|crios|crmo/i.test(e)?r={name:"Chrome",chrome:t,version:n(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)}:i?(r={name:"iphone"==i?"iPhone":"ipad"==i?"iPad":"iPod"},g&&(r.version=g)):c?r={name:"Sailfish",sailfish:t,version:n(/sailfish\s?browser\/(\d+(\.\d+)?)/i)}:/seamonkey\//i.test(e)?r={name:"SeaMonkey",seamonkey:t,version:n(/seamonkey\/(\d+(\.\d+)?)/i)}:/firefox|iceweasel/i.test(e)?(r={name:"Firefox",firefox:t,version:n(/(?:firefox|iceweasel)[ \/](\d+(\.\d+)?)/i)},/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(e)&&(r.firefoxos=t)):l?r={name:"Amazon Silk",silk:t,version:n(/silk\/(\d+(\.\d+)?)/i)}:o?r={name:"Android",version:g}:/phantom/i.test(e)?r={name:"PhantomJS",phantom:t,version:n(/phantomjs\/(\d+(\.\d+)?)/i)}:/blackberry|\bbb\d+/i.test(e)||/rim\stablet/i.test(e)?r={name:"BlackBerry",blackberry:t,version:g||n(/blackberry[\d]+\/(\d+(\.\d+)?)/i)}:h?(r={name:"WebOS",webos:t,version:g||n(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)},/touchpad\//i.test(e)&&(r.touchpad=t)):r=/bada/i.test(e)?{name:"Bada",bada:t,version:n(/dolfin\/(\d+(\.\d+)?)/i)}:f?{name:"Tizen",tizen:t,version:n(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i)||g}:/qupzilla/i.test(e)?{name:"QupZilla",qupzilla:t,version:n(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i)||g}:/safari/i.test(e)?{name:"Safari",safari:t,version:g}:/googlebot/i.test(e)?{name:"Googlebot",googlebot:t,version:n(/googlebot\/(\d+(\.\d+))/i)||g}:{name:n(/^(.*)\/(.*) /),version:function(t){var n=e.match(t);return n&&n.length>1&&n[2]||"";}(/^(.*)\/(.*) /)},!r.msedge&&/(apple)?webkit/i.test(e)?(r.name=r.name||"Webkit",r.webkit=t,!r.version&&g&&(r.version=g)):!r.opera&&/gecko\//i.test(e)&&(r.name=r.name||"Gecko",r.gecko=t,r.version=r.version||n(/gecko\/(\d+(\.\d+)?)/i)),r.msedge||!o&&!r.silk?i?(r[i]=t,r.ios=t):d?r.windows=t:v?r.mac=t:m&&(r.linux=t):r.android=t;var w="";r.windowsphone?w=n(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i):i?w=(w=n(/os (\d+([_\s]\d+)*) like mac os x/i)).replace(/[_\s]/g,"."):o?w=n(/android[ \/-](\d+(\.\d+)*)/i):r.webos?w=n(/(?:web|hpw)os\/(\d+(\.\d+)*)/i):r.blackberry?w=n(/rim\stablet\sos\s(\d+(\.\d+)*)/i):r.bada?w=n(/bada\/(\d+(\.\d+)*)/i):r.tizen&&(w=n(/tizen[\/\s](\d+(\.\d+)*)/i)),w&&(r.osversion=w);var _=w.split(".")[0];return x||s||"ipad"==i||o&&(3==_||4==_&&!b)||r.silk?r.tablet=t:(b||"iphone"==i||"ipod"==i||o||a||r.blackberry||r.webos||r.bada)&&(r.mobile=t),r.msedge||r.msie&&r.version>=10||r.yandexbrowser&&r.version>=15||r.vivaldi&&r.version>=1||r.chrome&&r.version>=20||r.firefox&&r.version>=20||r.safari&&r.version>=6||r.opera&&r.version>=10||r.ios&&r.osversion&&r.osversion.split(".")[0]>=6||r.blackberry&&r.version>=10.1?r.a=t:r.msie&&r.version<10||r.chrome&&r.version<20||r.firefox&&r.version<20||r.safari&&r.version<6||r.opera&&r.version<10||r.ios&&r.osversion&&r.osversion.split(".")[0]<6?r.c=t:r.x=t,r;}var n=e("undefined"!=typeof navigator?navigator.userAgent:"");return n.test=function(t){for(var e=0;e<t.length;++e){var r=t[e];if("string"==typeof r&&r in n)return!0;}return!1;},n._detect=e,n;});},function(t,e,n){"use strict";n.r(e);n(16);window.ortho=null;var r={main:n(18),roots:n(25),deepct:n(26)};window.ortho=function(t){window.__VIEWER_TYPE__=t.type,r[t.type](t);};},function(t,e,n){},,function(t,e,n){(function(e,n,r,i,o,a,s,u,l,c,f,h,p,d,v,m,y,g,x,b,w,_,T,k,E,O,S,A){t.exports=function(t){var C=new e({errorCallback:n,alpha:!0}),F=r(".ortho-gl-container")[0];r(".ortho-nowebgl").hide();t.source_stage_folder;var M=new i();M.load({sources:{list:t.json["case.json"]}}).then(function(e){var n=JSON.parse(e.list);n.files=Object.values(t.json);var r={},i=n.files.length;for(1;i--;){n.files[i].split&&(r[n.files[i]]={source:n.files[i],type:"arraybuffer"});}r.logo={source:"".concat(t.base_url,"/static/media/cup_logo.png"),type:"image"},M.load({sources:r,progress:o()}).then(function(e){try{var r=C.WebGLRenderingContext,i=r.TRIANGLES,o=r.UNSIGNED_SHORT,M=r.UNSIGNED_INT,P=r.COLOR_BUFFER_BIT,D=r.getExtension("OES_element_index_uint");e=a(e),C.setSize(0,0,F.offsetWidth,F.offsetHeight),r.clearColor(1,1,1,1),r.clear(P),r.enable(r.DEPTH_TEST),r.depthFunc(r.LESS),r.getExtension("OES_standard_derivatives")||r.getExtension("MOZ_OES_standard_derivatives")||r.getExtension("WEBKIT_OES_standard_derivatives");var I=C.math.BezierCubicCurve(.25,0,0,1),L=[],R=[],j=[new C.DataFloat1(),new C.DataFloat1()],B=[new C.DataFloat1(),new C.DataFloat1()],N=new C.DataFloat1(),U=n.dict,z=new C.DataFloat1({name:"visUpper",x:1}),W=new C.DataFloat1({name:"visLower",x:1}),X=new C.DataFloat1({name:"rot"}),V=new C.DataFloat1({name:"zoom",x:1}),Y=new C.DataFloat1({name:"uIndex"}),H={x:0},q={x:1},G={x:1},$=n.upper.keys.map(function(t,e,n){return e%2!=0&&n[e-1]===t&&n[e+1]?t+1:t;}),Z=n.lower.keys.map(function(t,e,n){return e%2!=0&&n[e-1]===t&&n[e+1]?t+1:t;}),Q=n.upper.separations,K=n.lower.separations,J=n.upper.locksKeys.map(function(t,e,n){return e%2!=0&&n[e-1]===t&&n[e+1]?t+1:t;}),tt=n.lower.locksKeys.map(function(t,e,n){return e%2!=0&&n[e-1]===t&&n[e+1]?t+1:t;}),et=s(C,F),nt=et.orbit,rt=et.updateProjectionMatrix;rt[H.x]();var it=new C.DataFloat1(),ot=new C.DataFloat1(),at=new C.DataFloat1({name:"interp"}),st=new C.DataFloat1({name:"interp"}),ut=new C.DataFloat1(),lt=new C.DataFloat1(),ct=new C.DataFloat1({name:"interp"}),ft=new C.DataFloat1({name:"interp"}),ht=new C.DataFloat1(),pt=new C.DataFloat1({name:"interpColors"}),dt=nt.camera,vt=dt.projectionMatrix,mt=dt.viewMatrix,yt=dt.position,gt=function gt(t,e,n,r,i,o){var a=i.minZ;return new C.Material({VS:function VS(){return"\n                  precision ".concat(C.maxPrecision.vs.float," float;\n                  ").concat(vt.uniform(this),"\n                  ").concat(mt.uniform(this),"\n                  ").concat(n.uniform(this),"\n                  ").concat(o?o.uniform(this):"","\n                  ").concat(X.uniform(this),"\n                  ").concat(V.uniform(this),"\n                  ").concat(yt.uniform(this),"\n                  ").concat(e.uniform(this),"\n                  attribute vec3 aStartPosition;\n                  attribute vec3 aEndPosition;\n                  ").concat(r?"\n                    attribute vec3 aStartColor;\n                    attribute vec3 aEndColor;\n                  ":"","\n                  varying vec4 vPosition;\n                  varying vec4 vCol;\n                  varying vec3 lightDir;\n                  ").concat(u,"\n                  void main() {\n                    vec3 vPosXYZ = mix(aStartPosition, aEndPosition, interp);\n                    vCol = vec4(").concat(r?"mix(vec3(1.), mix(aStartColor, aEndColor, ".concat(o?"interpColors":"interp","), rot), "):"","1.);\n                    vPosXYZ.z -= ").concat((a-3).toString().split(".")[0],".;\n                    vPosition = rotationMatrixX(").concat(t," rot) * vec4(vPosXYZ, zoom);\n                    vPosition.z += ").concat((a-3).toString().split(".")[0],".;\n                    lightDir = normalize(cameraPosition - vPosXYZ);\n                    gl_Position = projectionMatrix * viewMatrix * vPosition * ").concat(e.name,";\n                  }\n                ");},FS:"\n                #extension GL_OES_standard_derivatives: enable\n                precision ".concat(C.maxPrecision.fs.float," float;\n                varying vec4 vPosition;\n                varying vec4 vCol;\n                varying vec3 lightDir;\n                void main() {\n                  float diffuse = dot(normalize(cross(dFdx(vPosition.xyz), dFdy(vPosition.xyz))), lightDir) + .125;\n                  gl_FragColor = vCol * diffuse;\n                  gl_FragColor.w = 1.0;\n                }\n                ")});},xt=new C.Texture2D({name:"LOGO",image:e.logo,max:r.LINEAR,min:r.LINEAR_MIPMAP_LINEAR,anisotropy:16,unit:0}),bt=function bt(t,e,n,r,i){var o=i.minZ,a=i.avZ;return new C.Material({VS:function VS(){return"\n                  precision ".concat(C.maxPrecision.vs.float," float;\n                  ").concat(vt.uniform(this),"\n                  ").concat(mt.uniform(this),"\n                  ").concat(r.uniform(this),"\n                  ").concat(X.uniform(this),"\n                  ").concat(V.uniform(this),"\n                  ").concat(yt.uniform(this),"\n                  ").concat(n.uniform(this),"\n                  attribute vec3 aStartPosition;\n                  attribute vec3 aEndPosition;\n                  varying vec4 vPosition;\n                  varying vec3 lightDir;\n                  varying float absPosY;\n                  varying vec2 texCoords;\n                  ").concat(u,"\n                  void main() {\n                    vec3 vPosXYZ = mix(aStartPosition, aEndPosition, interp);\n                    absPosY = abs(vPosXYZ.y);\n                    vPosXYZ.y = absPosY > 20. ? ").concat(e," 20. : vPosXYZ.y;\n                    texCoords = vPosXYZ.xz;\n                    texCoords.y -= ").concat((a-3).toString().split(".")[0],".;\n                    vPosXYZ.z -= ").concat((o-3).toString().split(".")[0],".;\n                    vPosition = rotationMatrixX(").concat(e," rot) * vec4(vPosXYZ, zoom);\n                    vPosition.z +=  ").concat((o-3).toString().split(".")[0],".;\n                    lightDir = normalize(cameraPosition - vPosXYZ);\n                    gl_Position = projectionMatrix * viewMatrix * vPosition * ").concat(n.name,";\n                  }\n                ");},FS:function FS(){return"\n                  #extension GL_OES_standard_derivatives: enable\n                  precision ".concat(C.maxPrecision.fs.float," float;\n                  ").concat(l(C,t).uniform(this),"\n                  ").concat(xt.uniform(this),"\n                  varying vec4 vPosition;\n                  varying vec3 lightDir;\n                  varying float absPosY;\n                  varying vec2 texCoords;\n                  void main() {\n                    float diffuse = dot(normalize(cross(dFdx(vPosition.xyz), dFdy(vPosition.xyz))), lightDir) + .125;\n                    vec4 texel = texture2D(LOGO, (texCoords * 0.05 + 0.5) * (sign(vPosition.y) + 1.0) * 0.5);\n                    gl_FragColor = vec4(absPosY > 19.99 ? texel.xyz : uColor, 1.0) * diffuse;\n                    gl_FragColor.w = 1.0;\n                  }\n                ");}});},wt=function wt(t,e,n,a){return new C.Obj({draw:c(e,t,n,t.colors,a,D,C,r,i,o,M)});},_t=function _t(t,e,n){return new C.Obj({draw:f(e,t,n,D,C,r,i,o,M)});},Tt=h(C,r,nt.camera.projectionMatrix,V),kt=0,Et=0;if(e["upper_gums_k_0.b"])for(var Ot=new Float32Array(e["upper_gums_k_0.b"]),St=2;St<Ot.length;St+=3){!(Ot[St]<kt)||(kt=Math.round(Ot[St])),!(Ot[St]>Et)||(Et=Math.round(Ot[St]));}if(e["lower_gums_k_0.b"])for(var At=new Float32Array(e["lower_gums_k_0.b"]),Ct=2;Ct<At.length;Ct+=3){!(At[Ct]<kt)||(kt=Math.round(At[Ct])),!(At[Ct]>Et)||(Et=Math.round(At[Ct]));}var Ft=.5*(Et+kt),Mt=p($,Q),Pt=p(Z,K),Dt=d(Mt,Q),It=d(Pt,K),Lt=null,Rt=v(J),jt=v(tt),Bt=m(Rt,J),Nt=m(jt,tt),Ut=y(Mt),zt=y(Dt),Wt=y(Pt),Xt=y(It),Vt=y(Rt),Yt=y(Bt),Ht=y(jt),qt=y(Nt);0===n.upper.keys[0]&&0===n.upper.keys[1]&&1===n.upper.keys[2]&&0===n.upper.separations[0]&&1===n.upper.separations[1]&&(Ut[0]=0,Ut[1]=0,Ut[2]=1,Ut[3]=1),0===n.lower.keys[0]&&0===n.lower.keys[1]&&1===n.lower.keys[2]&&0===n.lower.separations[0]&&1===n.lower.separations[1]&&(Wt[0]=0,Wt[1]=0,Wt[2]=1,Wt[3]=1),n.upper.teethIs&&L.push(wt({triangles:zt.map(function(t){return e["upper_teeth_t_".concat(t,".b")];}),vertices:Ut.map(function(t){return e["upper_teeth_k_".concat(t,".b")];}),colors:y(p(function(){var t=$.slice();return t.pop(),t.push(Math.max($.slice().pop(),Z.slice().pop())),t;}(),Q)).map(function(t){return e["upper_teeth_c_".concat(t,".b")];})},gt("",z,at,e["upper_teeth_c_0.b"],{minZ:kt},function(){var t=null;if($.slice().pop()<Z.slice().pop()){var e=$.slice();e.pop(),e.push(Z.slice().pop()),Lt=p(e,Q),t=pt;}return t;}()),it,$.slice().pop()>=Z.slice().pop()?it:ht)),n.lower.teethIs&&L.push(wt({triangles:Xt.map(function(t){return e["lower_teeth_t_".concat(t,".b")];}),vertices:Wt.map(function(t){return e["lower_teeth_k_".concat(t,".b")];}),colors:y(p(function(){var t=Z.slice();return t.pop(),t.push(Math.max($.slice().pop(),Z.slice().pop())),t;}(),K)).map(function(t){return e["lower_teeth_c_".concat(t,".b")];})},gt("-",W,st,e["lower_teeth_c_0.b"],{minZ:kt},function(){var t=null;if($.slice().pop()>=Z.slice().pop()){var e=Z.slice();e.pop(),e.push($.slice().pop()),Lt=p(e,K),t=pt;}return t;}()),ot,$.slice().pop()<Z.slice().pop()?ot:ht)),n.upper.gumsIs&&L.push(_t({triangles:zt.map(function(t){return e["upper_gums_t_".concat(t,".b")];}),vertices:Ut.map(function(t){return e["upper_gums_k_".concat(t,".b")];})},bt("ff9c8e","",z,at,{minZ:kt,avZ:Ft}),it)),n.lower.gumsIs&&L.push(_t({triangles:Xt.map(function(t){return e["lower_gums_t_".concat(t,".b")];}),vertices:Wt.map(function(t){return e["lower_gums_k_".concat(t,".b")];})},bt("ff9c8e","-",W,st,{minZ:kt,avZ:Ft}),ot)),n.upper.locksIs&&R.push(_t({triangles:Yt.map(function(t){return e["upper_locks_t_".concat(t,".b")];}),vertices:Vt.map(function(t){return e["upper_locks_k_".concat(t,".b")];})},bt("82d9d4","",z,ct,{minZ:kt,avZ:Ft}),ut)),n.lower.locksIs&&R.push(_t({triangles:qt.map(function(t){return e["lower_locks_t_".concat(t,".b")];}),vertices:Ht.map(function(t){return e["lower_locks_k_".concat(t,".b")];})},bt("82d9d4","-",W,ft,{minZ:kt,avZ:Ft}),lt));var Gt=[],$t=[];g(C,r,nt.camera.projectionMatrix,nt.camera.viewMatrix,W,Y,V,z,nt.rotation,U,Gt,u,x),b(C,r,nt.camera.projectionMatrix,nt.camera.viewMatrix,z,W,Y,V,U,Gt),w(C,r,nt.camera.projectionMatrix,nt.camera.viewMatrix,W,Y,V,z,nt.rotation,U,Gt,$t,u,x),_(C,r,nt.camera.projectionMatrix,nt.camera.viewMatrix,W,Y,V,z,nt.rotation,U,Gt,$t,u,x);var Zt=T(Mt,Pt,Rt,jt,C,j,B,Y,it,ot,at,st,ut,lt,ct,ft,ht,pt,N,Lt);k(t,X,I,z,W,rt,H,C,G,q,!1,nt,!1,e["upper_teeth_t_0.b"],e["lower_teeth_t_0.b"]),E(nt,r,V,C,rt,H,Zt),O(t,n,Mt,Q,Pt,K,e["upper_teeth_t_0.b"],e["lower_teeth_t_0.b"]);var Qt=function Qt(){},Kt=R.length,Jt=L.length,te=[Qt,function(){Tt.draw();}],ee=[Qt,function(){for(var t=0;t<Kt;t++){R[t].draw();}}],ne=[Qt,function(){for(var t=Gt.length,e=0;e<t;e++){Gt[e].draw();}}],re=0;!function t(){re=0,C.updateTime(),C.updateTransitions(),requestAnimationFrame(t);}();var ie=[function(){re=1,nt.update(),r.activeTexture(r.TEXTURE0);for(var t=0;t<Jt;t++){L[t].draw();}r.activeTexture(r.TEXTURE1),ne[q.x*(1-~~X.x)](),ee[G.x](),te[H.x](),r.finish();},Qt];F.appendChild(C.canvas),C.clbk=function(){ie[re]();},C.clbk(),S(C,r);}catch(t){(A||function(){return 0;})(t,"main");}}).catch();}).catch();};}).call(this,n(3).WebGL,n(5),n(2),n(3).Loader,n(6),n(0).prepareResponses,n(7),n(8).ROTATION_MATRIX_X,n(0).hex,n(4).getDrawFunc4Attr,n(4).getDrawFunc2Attr,n(9),n(0).getLayers,n(0).getTriangles,n(0).getLayersLocks,n(0).getTrianglesLocks,n(0).extArr,n(19),n(8).ROTATION_MATRIX_Y,n(20),n(22),n(23),n(13),n(10),n(11),n(12),n(0).setFinalCSS,n(1));},function(t,e,n){(function(e){t.exports=function(t,n,r,i,o,a,s,u,l,c,f,h,p){try{var d=n.TRIANGLES,v=n.UNSIGNED_SHORT,m=-1,y=[],g=[],x=[],b=[],w=[],_="main"===window.__VIEWER_TYPE__?function(e,n,r,i){m++;var o=e.centroid[e.separation[n].a],a=e.centroid[e.separation[n].b],s=.1*(parseInt(e.separation[n].a[1])+parseInt(e.separation[n].b[1])),u=[.5*(o[0]+a[0]),.5*(o[1]+a[1]),.5*(o[2]+a[2])],l=new t.DataFloat3({x:o[0]-a[0],y:o[1]-a[1],z:o[2]-a[2]});l.normalize();var c,f,h=[l.z,0,l.x],p=new t.DataFloat3({x:u[0]-h[0]*s,y:u[1],z:u[2]+h[2]*s}),d=new t.DataFloat3({x:u[0]+h[0]*s,y:u[1],z:u[2]-h[2]*s}),v=p;p.length(new t.DataFloat3())<d.length(new t.DataFloat3())&&(v=d);for(var _=[],T=[],k=0,E=0;E<=32;E++){T=[],c=E/32;for(var O=0;O<=32;O++){f=O/32,y.push(v.x-2.2*Math.cos(0+6.3*f)*Math.sin(0+6.3*c),v.y+2.2*Math.cos(0+6.3*c),v.z+2.2*Math.sin(0+6.3*f)*Math.sin(0+6.3*c)),w.push(i),x.push(e.model[0].from),b.push(v.x,v.y,v.z),T.push(k++);}_.push(T);}for(var S=0;S<32;S++){for(var A=0;A<32;A++){var C=_[S][A+1],F=_[S][A],M=_[S+1][A],P=_[S+1][A+1];0!==S&&g.push(1089*m+C,1089*m+F,1089*m+P),(31!==S||Math.PI>6.3)&&g.push(1089*m+F,1089*m+M,1089*m+P);}}}:function(e,n,r,i){m++;var o=e.centroid[e.separation[n].a],a=e.centroid[e.separation[n].b],s=.1*(parseInt(e.separation[n].a[1])+parseInt(e.separation[n].b[1])),u=[.5*(o[0]+a[0]),.5*(o[1]+a[1]),.5*(o[2]+a[2])],l=new t.DataFloat3({x:o[0]-a[0],y:o[1]-a[1],z:o[2]-a[2]});l.normalize();var c,f,h=[l.z,0,l.x],p=new t.DataFloat3({x:u[0]-h[0]*s,y:u[1],z:u[2]+h[2]*s}),d=new t.DataFloat3({x:u[0]+h[0]*s,y:u[1],z:u[2]-h[2]*s}),v=p;p.length(new t.DataFloat3())<d.length(new t.DataFloat3())&&(v=d);for(var _=[],T=[],k=0,E=0;E<=32;E++){T=[],c=E/32;for(var O=0;O<=32;O++){f=O/32,y.push(v.x-2.2*Math.cos(0+6.3*f)*Math.sin(0+6.3*c),v.y+2.2*Math.cos(0+6.3*c),v.z+2.2*Math.sin(0+6.3*f)*Math.sin(0+6.3*c)),w.push(i),x.push(e.model[0]-1),b.push(v.x,v.y,v.z),T.push(k++);}_.push(T);}for(var S=0;S<32;S++){for(var A=0;A<32;A++){var C=_[S][A+1],F=_[S][A],M=_[S+1][A],P=_[S+1][A+1];0!==S&&g.push(1089*m+C,1089*m+F,1089*m+P),(31!==S||Math.PI>6.3)&&g.push(1089*m+F,1089*m+M,1089*m+P);}}};for(var T in c.upper){if(c.upper[T].separation&&Object.keys(c.upper[T].separation).length)for(var k in c.upper[T].separation){_(c.upper[T],k,1,1);}}for(var E in c.lower){if(c.lower[E].separation&&Object.keys(c.lower[E].separation).length)for(var O in c.lower[E].separation){_(c.lower[E],O,-1,0);}}var S=g.length,A=new t.Material({VS:function VS(){return"\n          precision ".concat(t.maxPrecision.vs.float," float;\n          ").concat(r.uniform(this),"\n          ").concat(i.uniform(this),"\n          ").concat(s.uniform(this),"\n          ").concat(a.uniform(this),"\n          ").concat(u.uniform(this),"\n          ").concat(o.uniform(this),"\n          attribute vec3 position;\n          attribute float index;\n          attribute float location;\n          void main() {\n            gl_Position = projectionMatrix * viewMatrix * vec4(position, zoom) * (1. - abs(uIndex - index)) * float((location > .5 && visUpper > .5) || (location < .5 && visLower > .5));\n          }\n        ");},FS:"\n        precision ".concat(t.maxPrecision.fs.float," float;\n        void main() {\n          gl_FragColor.y = .522;\n          gl_FragColor.z = .541;\n          gl_FragColor.w = 1.0;\n        }\n        ")});if(y.length){var C=A.program,F=new t.VBO({content:new Float32Array(y),name:"position",location:0}),M=new t.VBO({content:new Float32Array(x),name:"index",size:1,location:1}),P=new t.VBO({content:new Float32Array(w),name:"location",size:1,location:2}),D=new t.IBO({content:new Uint16Array(g)}),I=new t.Obj({draw:function draw(){n.useProgram(C),F.enable(),M.enable(),P.enable(),D.enable(),n.drawElements(d,S,v,0);}});f.push(I);}}catch(t){(e||function(){return 0;})(t,"spheres");}};}).call(this,n(1));},function(t,e,n){(function(e,n){t.exports=function(t,r,i,o,a,s,u,l,c,f){try{var h=r.LINES,p=[],d=[],v=[],m=function m(n,r,i,o,a,s){var u=n.centroid[n.separation[o].a],l=n.centroid[n.separation[o].b],c=[.5*(u[0]+l[0]),.5*(u[1]+l[1]),.5*(u[2]+l[2])],f=new t.DataFloat3({x:u[0]-l[0],y:u[1]-l[1],z:u[2]-l[2]});f.normalize();var h=[f.z,0,f.x],p=new t.DataFloat3({x:c[0]-30*h[0],y:c[1]+20*a,z:c[2]+30*h[2]}),d=new t.DataFloat3({x:c[0]+30*h[0],y:c[1]+20*a,z:c[2]-30*h[2]}),m=new t.DataFloat3({x:c[0],y:c[1],z:c[2]}),y=new t.DataFloat3({x:p.x,y:p.y,z:p.z});p.length(new t.DataFloat3())<d.length(new t.DataFloat3())&&(y=new t.DataFloat3({x:d.x,y:d.y,z:d.z}));for(var g=new t.DataFloat3({x:.5*(m.x+y.x),y:m.y,z:.5*(m.z+y.z)}),x=new e(m,g,g,y).getPoints(41),b=0;b<x.length;b++){r.push(x[b].x,x[b].y,x[b].z),i.push("main"===window.__VIEWER_TYPE__?n.model[0].from:n.model[0]-1),v.push(s);}};for(var y in c.upper){if(c.upper[y].separation&&Object.keys(c.upper[y].separation).length)for(var g in c.upper[y].separation){m(c.upper[y],p,d,g,1,1);}}for(var x in c.lower){if(c.lower[x].separation&&Object.keys(c.lower[x].separation).length)for(var b in c.lower[x].separation){m(c.lower[x],p,d,b,-1,0);}}var w=new t.Material({VS:function VS(){return"\n          precision ".concat(t.maxPrecision.vs.float," float;\n          ").concat(i.uniform(this),"\n          ").concat(o.uniform(this),"\n          ").concat(l.uniform(this),"\n          ").concat(u.uniform(this),"\n          ").concat(a.uniform(this),"\n          ").concat(s.uniform(this),"\n          attribute vec3 position;\n          attribute float index;\n          attribute float location;\n          void main() {\n            gl_Position = projectionMatrix * viewMatrix * vec4(position, zoom) * (1. - (abs(uIndex - index))) * float((location > .5 && visUpper > .5) || (location < .5 && visLower > .5));\n          }\n        ");},FS:"\n        precision ".concat(t.maxPrecision.fs.float," float;\n        void main() {\n          gl_FragColor.y = .522;\n          gl_FragColor.z = .541;\n          gl_FragColor.w = 1.0;\n        }\n        ")});if(p.length){var _=w.program,T=p.length/3,k=new t.VBO({content:new Float32Array(p),name:"position",location:0}),E=new t.VBO({content:new Float32Array(d),name:"index",size:1,location:1}),O=new t.VBO({content:new Float32Array(v),name:"location",size:1,location:2}),S=new t.Obj({draw:function draw(){r.useProgram(_),k.enable(),E.enable(),O.enable(),r.drawArrays(h,0,T);}});f.push(S);}}catch(t){(n||function(){return 0;})(t,"info");}};}).call(this,n(21),n(1));},function(t,e){var n=function n(t,e,_n2,r,i){return function(t,e){var n=1-t;return n*n*n*e;}(t,e)+function(t,e){var n=1-t;return 3*n*n*t*e;}(t,_n2)+function(t,e){return 3*(1-t)*t*t*e;}(t,r)+function(t,e){return t*t*t*e;}(t,i);},r=function r(t,e,n,_r){this.v0=t,this.v1=e,this.v2=n,this.v3=_r;};r.prototype.getPoint=function(t){var e=this.v0,r=this.v1,i=this.v2,o=this.v3;return{x:n(t,e.x,r.x,i.x,o.x),y:n(t,e.y,r.y,i.y,o.y),z:n(t,e.z,r.z,i.z,o.z)};},r.prototype.getPoints=function(t){for(var e=[],n=0;n<=t;n++){e.push(this.getPoint(n/t));}return e;},t.exports=r;},function(t,e,n){(function(e){t.exports=function(t,n,r,i,o,a,s,u,l,c,f,h,p,d){try{var v=n.TRIANGLES,m=n.UNSIGNED_SHORT,y=-1,g=[],x=[],b=[],w=[],_=[],T="main"===window.__VIEWER_TYPE__?function(e,n,r,i){y++;var o=e.centroid[e.separation[n].a],a=e.centroid[e.separation[n].b],s=[.5*(o[0]+a[0]),.5*(o[1]+a[1]),.5*(o[2]+a[2])],u=new t.DataFloat3({x:o[0]-a[0],y:o[1]-a[1],z:o[2]-a[2]});u.normalize();var l=[u.z,0,u.x],c=new t.DataFloat3({x:s[0]-30*l[0],y:s[1]+20*r,z:s[2]+30*l[2]}),f=new t.DataFloat3({x:s[0]+30*l[0],y:s[1]+20*r,z:s[2]-30*l[2]}),p=c;c.length(new t.DataFloat3())<f.length(new t.DataFloat3())&&(p=f);var d=parseFloat(e.separation[n].size.slice(1,e.separation[n].size.length-3));h.push(2*d),g.push(p.x,p.y,p.z),x.push(i),w.push(e.model[0].from),_.push(p.x,p.y,p.z);for(var v=0;v<32;v++){var m=v/32*6.3,T=.8*Math.cos(m),k=.8*Math.sin(m);g.push(T+p.x,k+p.y,p.z),x.push(i),v&&b.push(33*y,v+33*y,v+1+33*y),w.push(e.model[0].from),_.push(p.x,p.y,p.z);}b.push(33*y,32+33*y,1+33*y);}:function(e,n,r,i){y++;var o=e.centroid[e.separation[n].a],a=e.centroid[e.separation[n].b],s=[.5*(o[0]+a[0]),.5*(o[1]+a[1]),.5*(o[2]+a[2])],u=new t.DataFloat3({x:o[0]-a[0],y:o[1]-a[1],z:o[2]-a[2]});u.normalize();var l=[u.z,0,u.x],c=new t.DataFloat3({x:s[0]-30*l[0],y:s[1]+20*r,z:s[2]+30*l[2]}),f=new t.DataFloat3({x:s[0]+30*l[0],y:s[1]+20*r,z:s[2]-30*l[2]}),p=c;c.length(new t.DataFloat3())<f.length(new t.DataFloat3())&&(p=f);var d=parseFloat(e.separation[n].size.slice(1,e.separation[n].size.length-3));h.push(2*d),g.push(p.x,p.y,p.z),x.push(i),w.push(e.model[0]-1),_.push(p.x,p.y,p.z);for(var v=0;v<32;v++){var m=v/32*6.3,T=.8*Math.cos(m),k=.8*Math.sin(m);g.push(T+p.x,k+p.y,p.z),x.push(i),v&&b.push(33*y,v+33*y,v+1+33*y),w.push(e.model[0]-1),_.push(p.x,p.y,p.z);}b.push(33*y,32+33*y,1+33*y);};for(var k in c.upper){if(c.upper[k].separation&&Object.keys(c.upper[k].separation).length)for(var E in c.upper[k].separation){T(c.upper[k],E,1,1);}}for(var O in c.lower){if(c.lower[O].separation&&Object.keys(c.lower[O].separation).length)for(var S in c.lower[O].separation){T(c.lower[O],S,-1,0);}}var A=Math.pow(2,Math.ceil(Math.log(h.length)/Math.log(2)));if(A>h.length)for(var C=h.length-1;C<A-1;C++){h.push(0);}var F=32*(y+1)*3,M=new t.Material({VS:function VS(){return"\n          precision ".concat(t.maxPrecision.vs.float," float;\n          ").concat(r.uniform(this),"\n          ").concat(i.uniform(this),"\n          ").concat(l.uniform(this),"\n          ").concat(s.uniform(this),"\n          ").concat(a.uniform(this),"\n          ").concat(u.uniform(this),"\n          ").concat(o.uniform(this),"\n          attribute vec3 position;\n          attribute vec3 origin;\n          attribute float index;\n          attribute float location;\n          ").concat(p,"\n          ").concat(d,"\n          void main() {\n            mat4 rot = rotationMatrixY(orbitRotation.y) * rotationMatrixX(orbitRotation.x);\n            vec4 pos = rot * vec4(position - origin, 1.);\n            pos.xyz += origin;\n            pos.w *= zoom;\n            gl_Position = projectionMatrix * viewMatrix * pos * (1. - abs(uIndex - index)) * float((location > .5 && visUpper > .5) || (location < .5 && visLower > .5));\n          }\n        ");},FS:"\n        precision ".concat(t.maxPrecision.fs.float," float;\n        void main() {\n          gl_FragColor.y = .522;\n          gl_FragColor.z = .541;\n          gl_FragColor.w = 1.0;\n        }\n        ")});if(g.length){var P=M.program,D=new t.VBO({content:new Float32Array(g),name:"position",location:0}),I=new t.VBO({content:new Float32Array(_),name:"origin",location:1}),L=new t.VBO({content:new Float32Array(w),name:"index",size:1,location:2}),R=new t.VBO({content:new Float32Array(x),name:"location",size:1,location:3}),j=new t.IBO({content:new Uint16Array(b)}),B=new t.Obj({draw:function draw(){n.useProgram(P),D.enable(),I.enable(),L.enable(),R.enable(),j.enable(),n.drawElements(v,F,m,0);}});f.push(B);}}catch(t){(e||function(){return 0;})(t,"circles");}};}).call(this,n(1));},function(t,e,n){(function(e,n){t.exports=function(t,r,i,o,a,s,u,l,c,f,h,p,d,v){try{var m=r.TRIANGLES,y=r.UNSIGNED_SHORT;p.length&&e(p,function(e){!function(){var n=-1,g=[],x=[],b=[],w=[],_=[],T=[],k=[],E="main"===window.__VIEWER_TYPE__?function(e,r,i,o){n++,_.push(n,n,n,n);var a=e.centroid[e.separation[r].a],s=e.centroid[e.separation[r].b],u=[.5*(a[0]+s[0]),.5*(a[1]+s[1]),.5*(a[2]+s[2])],l=new t.DataFloat3({x:a[0]-s[0],y:a[1]-s[1],z:a[2]-s[2]});l.normalize();var c=[l.z,0,l.x],f=new t.DataFloat3({x:u[0]-30*c[0],y:u[1]+20*i,z:u[2]+30*c[2]}),h=new t.DataFloat3({x:u[0]+30*c[0],y:u[1]+20*i,z:u[2]-30*c[2]}),p=f;f.length(new t.DataFloat3())<h.length(new t.DataFloat3())&&(p=h),b.push(e.model[0].from,e.model[0].from,e.model[0].from,e.model[0].from),w.push(p.x,p.y,p.z,p.x,p.y,p.z,p.x,p.y,p.z,p.x,p.y,p.z),k.push(0,1,0,0,1,0,1,1),g.push(p.x-3.2,p.y-1.6,p.z,p.x-3.2,p.y+1.6,p.z,p.x+3.2,p.y+1.6,p.z,p.x+3.2,p.y-1.6,p.z),x.push(0+4*n,1+4*n,2+4*n,0+4*n,3+4*n,2+4*n),T.push(o,o,o,o);}:function(e,r,i,o){n++,_.push(n,n,n,n);var a=e.centroid[e.separation[r].a],s=e.centroid[e.separation[r].b],u=[.5*(a[0]+s[0]),.5*(a[1]+s[1]),.5*(a[2]+s[2])],l=new t.DataFloat3({x:a[0]-s[0],y:a[1]-s[1],z:a[2]-s[2]});l.normalize();var c=[l.z,0,l.x],f=new t.DataFloat3({x:u[0]-30*c[0],y:u[1]+20*i,z:u[2]+30*c[2]}),h=new t.DataFloat3({x:u[0]+30*c[0],y:u[1]+20*i,z:u[2]-30*c[2]}),p=f;f.length(new t.DataFloat3())<h.length(new t.DataFloat3())&&(p=h),b.push(e.model[0]-1,e.model[0]-1,e.model[0]-1,e.model[0]-1),w.push(p.x,p.y,p.z,p.x,p.y,p.z,p.x,p.y,p.z,p.x,p.y,p.z),k.push(0,1,0,0,1,0,1,1),g.push(p.x-3.2,p.y-1.6,p.z,p.x-3.2,p.y+1.6,p.z,p.x+3.2,p.y+1.6,p.z,p.x+3.2,p.y-1.6,p.z),x.push(0+4*n,1+4*n,2+4*n,0+4*n,3+4*n,2+4*n),T.push(o,o,o,o);};for(var O in f.upper){if(f.upper[O].separation&&Object.keys(f.upper[O].separation).length)for(var S in f.upper[O].separation){E(f.upper[O],S,1,1);}}for(var A in f.lower){if(f.lower[A].separation&&Object.keys(f.lower[A].separation).length)for(var C in f.lower[A].separation){E(f.lower[A],C,-1,0);}}var F=6*(n+1),M=new t.Material({VS:function VS(){return"\n                precision ".concat(t.maxPrecision.vs.float," float;\n                ").concat(i.uniform(this),"\n                ").concat(o.uniform(this),"\n                ").concat(c.uniform(this),"\n                ").concat(u.uniform(this),"\n                ").concat(s.uniform(this),"\n                ").concat(l.uniform(this),"\n                ").concat(a.uniform(this),"\n                attribute vec3 position;\n                attribute vec3 origin;\n                attribute float index;\n                attribute vec2 uv;\n                attribute float tIndex;\n                attribute float location;\n                varying vec2 vUv;\n                ").concat(d,"\n                ").concat(v,"\n                void main() {\n                  vUv = vec2(uv.x, uv.y / ").concat(p.length,". + tIndex / ").concat(p.length,".);\n                  mat4 rot = rotationMatrixY(orbitRotation.y) * rotationMatrixX(orbitRotation.x);\n                  vec4 pos = rot * vec4(position - origin, zoom);\n                  pos.xyz += origin + (rot * vec4(- 4., 2.6, 0., 1.)).xyz;\n                  gl_Position = projectionMatrix * viewMatrix * pos * (1. - abs(uIndex - index)) * float((location > .5 && visUpper > .5) || (location < .5 && visLower > .5));\n                }\n              ");},FS:function FS(){return"\n                precision ".concat(t.maxPrecision.fs.float," float;\n                ").concat(new t.Texture2D({name:"LABEL",image:e,min:r.LINEAR_MIPMAP_LINEAR,unit:1}).uniform(this),"\n                varying vec2 vUv;\n                void main() {\n                  gl_FragColor = texture2D(LABEL, vUv);\n                  gl_FragColor.w = 1.0;\n                }\n              ");}});if(g.length){var P=M.program,D=new t.VBO({content:new Float32Array(g),name:"position",location:0}),I=new t.VBO({content:new Float32Array(w),name:"origin",location:1}),L=new t.VBO({content:new Float32Array(b),name:"index",size:1,location:2}),R=new t.VBO({content:new Float32Array(k),name:"uv",size:2,location:3}),j=new t.VBO({content:new Float32Array(_),name:"tIndex",size:1,location:4}),B=new t.VBO({content:new Float32Array(T),name:"location",size:1,location:5}),N=new t.IBO({content:new Uint16Array(x)}),U=new t.Obj({draw:function draw(){r.useProgram(P),D.enable(),I.enable(),L.enable(),R.enable(),j.enable(),B.enable(),N.enable(),r.drawElements(m,F,y,0);}});h.push(U);}}();t.clbk();});}catch(t){(n||function(){return 0;})(t,"quads");}};}).call(this,n(24),n(1));},function(t,e){t.exports=function(t,e){var n='\n    <svg xmlns="http://www.w3.org/2000/svg" width="128" height="'.concat(64*t.length,'">\n      ').concat(t.map(function(t,e){return'\n          <rect x="0" y="'.concat(64*e,'" width="128" height="64" fill="white" stroke="#00858a"/>\n          <text fill="black"\n                text-anchor="middle"\n                x="64"\n                y="').concat(64*(e+1),'"\n                font-family="Open Sans, sans-serif"\n                font-size="50"\n                transform="translate(0,-14)">\n            ').concat(t,"\n          </text>\n          ");}).join(""),"\n    </svg>\n    "),r=window.URL||window.webkitURL||window,i=new Blob([n],{type:"image/svg+xml"}),o=r.createObjectURL(i),a=new Image();a.crossOrigin="Anonymous",a.onload=function(){return e(a);},a.src=o;};},function(t,e,n){(function(e,n,r,i,o,a,s,u,l,c,f,h,p,d,v,m,y,g,x){t.exports=function(t){var b=new e({errorCallback:n,alpha:!0}),w=r(".ortho-gl-container")[0];r(".ortho-nowebgl").hide();t.source_stage_folder;var _=new i();_.load({sources:{list:t.json["case_roots.json"]}}).then(function(e){var n=JSON.parse(e.list);n.files=Object.values(t.json);var r={},i=n.files.length;for(1;i--;){r[n.files[i]]={source:n.files[i],type:"arraybuffer"};}_.load({sources:r,progress:o()}).then(function(e){try{var r=b.WebGLRenderingContext,i=r.TRIANGLES,o=r.UNSIGNED_SHORT,_=r.UNSIGNED_INT,T=r.COLOR_BUFFER_BIT,k=r.BLEND,E=r.getExtension("OES_element_index_uint");e=a(e),b.setSize(0,0,w.offsetWidth,w.offsetHeight),r.clearColor(1,1,1,1),r.clear(T),r.enable(r.DEPTH_TEST),r.depthFunc(r.LESS),r.enable(k),r.enable(r.CULL_FACE),r.cullFace(r.BACK),r.blendFunc(r.SRC_ALPHA,r.ONE_MINUS_SRC_ALPHA),r.getExtension("OES_standard_derivatives")||r.getExtension("MOZ_OES_standard_derivatives")||r.getExtension("WEBKIT_OES_standard_derivatives");var O=b.math.BezierCubicCurve(.25,0,0,1),S=[],A=new b.DataFloat1({x:.6,name:"rootsMode"}),C=[new b.DataFloat1(),new b.DataFloat1()],F=[new b.DataFloat1(),new b.DataFloat1()],M=new b.DataFloat1({name:"visUpper",x:1}),P=new b.DataFloat1({name:"visLower",x:1}),D=new b.DataFloat1({name:"rot"}),I=new b.DataFloat1({name:"zoom",x:1}),L=new b.DataFloat1({name:"uIndex"}),R={x:0},j=n.upper.keys.map(function(t,e,n){return e%2!=0&&n[e-1]===t&&n[e+1]?t+1:t;}),B=n.lower.keys.map(function(t,e,n){return e%2!=0&&n[e-1]===t&&n[e+1]?t+1:t;}),N=n.upper.separationsRoots,U=n.lower.separationsRoots,z=n.upper.separationsJaw,W=n.lower.separationsJaw,X=s(b,w),V=X.orbit,Y=X.updateProjectionMatrix;Y[R.x]();var H=new b.DataFloat1(),q=new b.DataFloat1(),G=new b.DataFloat1({name:"interp"}),$=new b.DataFloat1({name:"interp"}),Z=new b.DataFloat1(),Q=new b.DataFloat1(),K=new b.DataFloat1({name:"interp"}),J=new b.DataFloat1({name:"interp"}),tt=V.camera,et=tt.projectionMatrix,nt=tt.viewMatrix,rt=tt.position,it=function it(t,e,n){return new b.Material({VS:function VS(){return"\n                  precision ".concat(b.maxPrecision.vs.float," float;\n                  ").concat(et.uniform(this),"\n                  ").concat(nt.uniform(this),"\n                  ").concat(e.uniform(this),"\n                  ").concat(I.uniform(this),"\n                  ").concat(t.uniform(this),"\n                  ").concat(rt.uniform(this),"\n                  attribute vec3 aStartPosition;\n                  attribute vec3 aEndPosition;\n                  varying vec4 vPosition;\n                  varying vec3 lightDir;\n                  ").concat(n?"\n                  attribute vec3 aStartColor;\n                  attribute vec3 aEndColor;\n                  varying vec3 vColor;\n                  ":"","\n                  void main() {\n                    vPosition = vec4(mix(aStartPosition, aEndPosition, interp), zoom);\n                    lightDir = normalize(cameraPosition - vPosition.xyz);\n                    gl_Position = projectionMatrix * viewMatrix * vPosition * ").concat(t.name,";\n                    ").concat(n?"vColor = mix(aStartColor, aEndColor, interp);":"","\n                  }\n                ");},FS:function FS(){return"\n                  #extension GL_OES_standard_derivatives: enable\n                  precision ".concat(b.maxPrecision.fs.float," float;\n                  varying vec4 vPosition;\n                  varying vec3 lightDir;\n                  ").concat(n?A.uniform(this):"","\n                  ").concat(n?"varying vec3 vColor;":"","\n                  void main() {\n                    float diffuse = dot(normalize(cross(dFdx(vPosition.xyz), dFdy(vPosition.xyz))), lightDir) + .125;\n                    ").concat(n?"vec3 col = mix(vec3(.506, .51, .447), vColor, (rootsMode - .6) * 2.5) * diffuse;":"","\n                    gl_FragColor = vec4(").concat(n?"col, rootsMode":"vec3(diffuse), 1.0",");\n                  }\n                ");}});},ot=function ot(t,e,n){return new b.Obj({draw:u(e,t,n,t.colors,n,E,b,r,i,o,_)});},at=function at(t,e,n){return new b.Obj({draw:l(e,t,n,E,b,r,i,o,_)});},st=c(b,r,V.camera.projectionMatrix,I),ut=f(j,N),lt=f(B,U),ct=h(ut,N),ft=h(lt,U),ht=f(j,z),pt=f(B,W),dt=h(ht,z),vt=h(pt,W),mt=p(ut),yt=p(lt),gt=p(ct),xt=p(ft),bt=p(ht),wt=p(pt),_t=p(dt),Tt=p(vt);S.push(at({triangles:gt.map(function(t){return e["upper_roots_teeth_t_".concat(t,".b")];}),vertices:mt.map(function(t){return e["upper_roots_teeth_k_".concat(t,".b")];})},it(M,G,!1),H)),S.push(at({triangles:xt.map(function(t){return e["lower_roots_teeth_t_".concat(t,".b")];}),vertices:yt.map(function(t){return e["lower_roots_teeth_k_".concat(t,".b")];})},it(P,$,!1),q)),S.push(ot({triangles:_t.map(function(t){return e["upper_roots_jaw_t_".concat(t,".b")];}),vertices:bt.map(function(t){return e["upper_roots_jaw_k_".concat(t,".b")];}),colors:bt.map(function(t){return e["upper_roots_jaw_c_".concat(t,".b")];})},it(M,K,!0),Z)),S.push(ot({triangles:Tt.map(function(t){return e["lower_roots_jaw_t_".concat(t,".b")];}),vertices:wt.map(function(t){return e["lower_roots_jaw_k_".concat(t,".b")];}),colors:wt.map(function(t){return e["lower_roots_jaw_c_".concat(t,".b")];})},it(P,J,!0),Q));var kt=d(ut,lt,ht,pt,b,C,F,L,H,q,G,$,Z,Q,K,J);v(t,D,O,M,P,Y,R,b,!1,!1,!1,V,A,e["upper_roots_teeth_t_0.b"],e["lower_roots_teeth_t_0.b"]),m(V,r,I,b,Y,R,kt),y(t,n,ut,!1,lt,!1,e["upper_roots_teeth_t_0.b"],e["lower_roots_teeth_t_0.b"]);var Et=function Et(){},Ot=S.length,St=[Et,function(){st.draw();}],At=0;!function t(){At=0,b.updateTime(),b.updateTransitions(),requestAnimationFrame(t);}();var Ct=[function(){At=1,V.update();for(var t=0;t<Ot;t++){S[t].draw();}St[R.x](),r.finish();},Et];w.appendChild(b.canvas),b.clbk=function(){Ct[At]();},b.clbk(),g(b,r);}catch(t){(x||function(){return 0;})(t,"roots");}}).catch();}).catch();};}).call(this,n(3).WebGL,n(5),n(2),n(3).Loader,n(6),n(0).prepareResponses,n(7),n(4).getDrawFunc4Attr,n(4).getDrawFunc2Attr,n(9),n(0).getLayers,n(0).getTriangles,n(0).extArr,n(13),n(10),n(11),n(12),n(0).setFinalCSS,n(1));},function(t,e,n){(function(e,n,r,i,o,a,s,u,l,c,f,h,p,d,v,m,y){t.exports=function(t){var g=new e({errorCallback:n,alpha:!0}),x=r(".ortho-gl-container")[0];r(".ortho-nowebgl").hide();t.source_stage_folder;var b=new i(),w={};w.files=Object.values(t.json);var _={},T=w.files.length;for(1;T--;){_[w.files[T]]={source:w.files[T],type:"arraybuffer"};}b.load({sources:_,progress:o()}).then(function(e){try{var n=g.WebGLRenderingContext,r=n.TRIANGLES,i=n.UNSIGNED_SHORT,o=n.UNSIGNED_INT,b=n.COLOR_BUFFER_BIT,_=n.BLEND,T=n.getExtension("OES_element_index_uint");e=a(e),g.setSize(0,0,x.offsetWidth,x.offsetHeight),n.clearColor(1,1,1,1),n.clear(b),n.enable(n.DEPTH_TEST),n.depthFunc(n.LESS),n.enable(_),n.enable(n.CULL_FACE),n.cullFace(n.BACK),n.blendFunc(n.SRC_ALPHA,n.ONE_MINUS_SRC_ALPHA),n.getExtension("OES_standard_derivatives")||n.getExtension("MOZ_OES_standard_derivatives")||n.getExtension("WEBKIT_OES_standard_derivatives");var k=g.math.BezierCubicCurve(.25,0,0,1),E=[],O=new g.DataFloat1({x:.6,name:"rootsMode"}),S=new g.DataFloat1({name:"visUpper",x:1}),A=new g.DataFloat1({name:"visLower",x:1}),C=new g.DataFloat1({name:"rot"}),F=new g.DataFloat1({name:"zoom",x:1}),M={x:0},P=s(g,x),D=P.orbit,I=P.updateProjectionMatrix;I[M.x]();var L=D.camera,R=L.projectionMatrix,j=L.viewMatrix,B=L.position,N=function N(t,e){return new g.Material({VS:function VS(){return"\n              precision ".concat(g.maxPrecision.vs.float," float;\n              ").concat(R.uniform(this),"\n              ").concat(j.uniform(this),"\n              ").concat(F.uniform(this),"\n              ").concat(e.uniform(this),"\n              ").concat(B.uniform(this),"\n              attribute vec3 position;\n              attribute vec3 color;\n              varying vec4 vPosition;\n              varying vec3 vColor;\n              varying vec3 lightDir;\n              ").concat(u,"\n              void main() {\n                vColor = color;\n                vPosition = vec4(position, zoom);\n                lightDir = normalize(cameraPosition - vPosition.xyz);\n                gl_Position = projectionMatrix * viewMatrix * vPosition * ").concat(e.name,";\n              }\n            ");},FS:function FS(){return"\n              #extension GL_OES_standard_derivatives: enable\n              precision ".concat(g.maxPrecision.fs.float," float;\n              ").concat(O.uniform(this),"\n              varying vec4 vPosition;\n              varying vec3 vColor;\n              varying vec3 lightDir;\n              void main() {\n                float diffuse = dot(normalize(cross(dFdx(vPosition.xyz), dFdy(vPosition.xyz))), lightDir) + .125;\n                vec3 col = mix(vec3(.506, .51, .447), vColor, (rootsMode - .6) * 2.5) * diffuse;\n                gl_FragColor = vec4(col, rootsMode);\n              }\n            ");}});},U=function U(t,e,n,r){return new g.Material({VS:function VS(){return"\n              precision ".concat(g.maxPrecision.vs.float," float;\n              ").concat(R.uniform(this),"\n              ").concat(j.uniform(this),"\n              ").concat(F.uniform(this),"\n              ").concat(n.uniform(this),"\n              ").concat(B.uniform(this),"\n              ").concat(r?O.uniform(this):"","\n              attribute vec3 position;\n              varying vec4 vPosition;\n              varying vec3 lightDir;\n              ").concat(u,"\n              void main() {\n                vPosition = vec4(position, zoom ").concat(r?"* (1. - (rootsMode - .6) * 2.5)":"",");\n                lightDir = normalize(cameraPosition - vPosition.xyz);\n                gl_Position = projectionMatrix * viewMatrix * vPosition * ").concat(n.name,";\n              }\n            ");},FS:function FS(){return"\n              #extension GL_OES_standard_derivatives: enable\n              precision ".concat(g.maxPrecision.fs.float," float;\n              ").concat(l(g,t).uniform(this),"\n              varying vec4 vPosition;\n              varying vec3 lightDir;\n              void main() {\n                float diffuse = dot(normalize(cross(dFdx(vPosition.xyz), dFdy(vPosition.xyz))), lightDir) + .125;\n                gl_FragColor = vec4(vec3(uColor * diffuse), ").concat(r?".6":"1.",");\n              }\n            ");}});},z=function z(t,e){return new g.Obj({draw:c(e,t,t.colors,T,g,n,r,i,o)});},W=function W(t,e){return new g.Obj({draw:f(e,t,T,g,n,r,i,o)});},X=h(g,n,D.camera.projectionMatrix,F);E.push(W({triangles:e["upper_deepct_teeth_t.b"],vertices:e["upper_deepct_teeth_k.b"]},U("ffffff",0,S))),E.push(W({triangles:e["lower_deepct_teeth_t.b"],vertices:e["lower_deepct_teeth_k.b"]},U("ffffff",0,A))),E.push(W({triangles:e["upper_deepct_gums_t.b"],vertices:e["upper_deepct_gums_k.b"]},U("ff9c8e",0,S,!0))),E.push(W({triangles:e["lower_deepct_gums_t.b"],vertices:e["lower_deepct_gums_k.b"]},U("ff9c8e",0,A,!0))),E.push(z({triangles:e["upper_deepct_jaw_t.b"],vertices:e["upper_deepct_jaw_k.b"],colors:e["upper_deepct_jaw_c.b"]},N(0,S))),E.push(z({triangles:e["lower_deepct_jaw_t.b"],vertices:e["lower_deepct_jaw_k.b"],colors:e["lower_deepct_jaw_c.b"]},N(0,A))),p(t,C,k,S,A,I,M,g,!1,!1,!1,D,O,e["upper_deepct_teeth_t.b"],e["lower_deepct_teeth_t.b"]),d(D,n,F,g,I,M,!1),v(t,w,!1,!1,!1,!1,e["upper_deepct_teeth_t.b"],e["lower_deepct_teeth_t.b"]);var V=function V(){},Y=E.length,H=[V,function(){X.draw();}],q=0;!function t(){q=0,g.updateTime(),g.updateTransitions(),requestAnimationFrame(t);}();var G=[function(){q=1,D.update();for(var t=0;t<Y;t++){E[t].draw();}H[M.x](),n.finish();},V];x.appendChild(g.canvas),g.clbk=function(){G[q]();},g.clbk(),m(g,n);}catch(t){(y||function(){return 0;})(t,"deepct");}}).catch();};}).call(this,n(3).WebGL,n(5),n(2),n(3).Loader,n(6),n(0).prepareResponses,n(7),n(8).ROTATION_MATRIX_X,n(0).hex,n(4).getDrawFunc4AttrSingle,n(4).getDrawFunc2AttrSingle,n(9),n(10),n(11),n(12),n(0).setFinalCSS,n(1));}]);

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/both.3ad378a2.svg";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/upper.bda21440.svg";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lower.d96a836b.svg";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/occlusion.5d1d114a.svg";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/menu.645834d6.svg";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/locks.34882276.svg";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/separations.8a359284.svg";

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mm-grid.f792e9b2.svg";

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pdf.1fdbf463.svg";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/transp.cd59adfb.svg";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/m_i.58bdc384.svg";

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/en.90386a52.svg";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ru.793fe37d.svg";

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/first.acd71b1e.svg";

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pause.d0dd8195.svg";

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/play.d2df9e7f.svg";

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/last.139c6b32.svg";

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1086)
var ieee754 = __webpack_require__(1087)
var isArray = __webpack_require__(1088)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(376);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(64) && !__webpack_require__(87)(function () {
  return Object.defineProperty(__webpack_require__(227)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(74);
var document = __webpack_require__(56).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(65);
var toIObject = __webpack_require__(75);
var arrayIndexOf = __webpack_require__(388)(false);
var IE_PROTO = __webpack_require__(135)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(132);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(134);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(390), __esModule: true };

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(140);
var $export = __webpack_require__(62);
var redefine = __webpack_require__(233);
var hide = __webpack_require__(73);
var has = __webpack_require__(65);
var Iterators = __webpack_require__(76);
var $iterCreate = __webpack_require__(395);
var setToStringTag = __webpack_require__(142);
var getPrototypeOf = __webpack_require__(398);
var ITERATOR = __webpack_require__(45)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(73);


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(228);
var hiddenKeys = __webpack_require__(137).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(104);
var createDesc = __webpack_require__(88);
var toIObject = __webpack_require__(75);
var toPrimitive = __webpack_require__(131);
var has = __webpack_require__(65);
var IE8_DOM_DEFINE = __webpack_require__(226);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(64) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  // Options.jsx
  items_per_page: '/ page',
  jump_to: 'Goto',
  jump_to_confirm: 'confirm',
  page: '',

  // Pagination.jsx
  prev_page: 'Previous Page',
  next_page: 'Next Page',
  prev_5: 'Previous 5 Pages',
  next_5: 'Next 5 Pages',
  prev_3: 'Previous 3 Pages',
  next_3: 'Next 3 Pages'
};
module.exports = exports['default'];

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  today: 'Today',
  now: 'Now',
  backToToday: 'Back to today',
  ok: 'Ok',
  clear: 'Clear',
  month: 'Month',
  year: 'Year',
  timeSelect: 'select time',
  dateSelect: 'select date',
  weekSelect: 'Choose a week',
  monthSelect: 'Choose a month',
  yearSelect: 'Choose a year',
  decadeSelect: 'Choose a decade',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Previous month (PageUp)',
  nextMonth: 'Next month (PageDown)',
  previousYear: 'Last year (Control + left)',
  nextYear: 'Next year (Control + right)',
  previousDecade: 'Last decade',
  nextDecade: 'Next decade',
  previousCentury: 'Last century',
  nextCentury: 'Next century'
};
module.exports = exports['default'];

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.updateIntl = exports.UPDATE = exports.Provider = exports.IntlProvider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.intlReducer = intlReducer;

var _IntlProvider2 = __webpack_require__(239);

var _IntlProvider3 = _interopRequireDefault(_IntlProvider2);

var _Provider2 = __webpack_require__(476);

var _Provider3 = _interopRequireDefault(_Provider2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.IntlProvider = _IntlProvider3.default;
exports.Provider = _Provider3.default;
var UPDATE = exports.UPDATE = '@@intl/UPDATE';

var updateIntl = exports.updateIntl = function updateIntl(_ref) {
  var locale = _ref.locale,
      formats = _ref.formats,
      messages = _ref.messages;
  return {
    type: UPDATE,
    payload: { locale: locale, formats: formats, messages: messages }
  };
};

var initialState = exports.initialState = {
  locale: 'en',
  messages: {}
};

function intlReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  if (action.type !== UPDATE) {
    return state;
  }

  return _extends({}, state, action.payload);
}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(17);

var _reactIntl = __webpack_require__(248);

function defaultSelector(state) {
  return state.intl;
}

var mapStateToProps = function mapStateToProps(state, _ref) {
  var _ref$intlSelector = _ref.intlSelector,
      intlSelector = _ref$intlSelector === undefined ? defaultSelector : _ref$intlSelector;
  return intlSelector(state);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { pure: false })(_reactIntl.IntlProvider);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(240);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(440);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(247);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(151);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLocaleData", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intlShape", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectIntl", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineMessages", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntlProvider", function() { return IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedDate", function() { return FormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedTime", function() { return FormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedRelative", function() { return FormattedRelative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedNumber", function() { return FormattedNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedPlural", function() { return FormattedPlural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedMessage", function() { return FormattedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedHTMLMessage", function() { return FormattedHTMLMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_intl_format_cache__);
/*
 * Copyright 2017, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */









// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? 'wrappedInstance' : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return InjectIntl;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 // months to year
};

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
}

function getNamedFormat(formats, type, name) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  if (false) {
    console.error('[React Intl] No ' + type + ' format named: ' + name);
  }
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var defaults$$1 = format && getNamedFormat(formats, 'date', format);
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting date.\n' + e);
    }
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var defaults$$1 = format && getNamedFormat(formats, 'time', format);
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting time.\n' + e);
    }
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting relative time.\n' + e);
    }
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var defaults$$1 = format && getNamedFormat(formats, 'number', format);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting number.\n' + e);
    }
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting plural.\n' + e);
    }
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // `id` is a required field of a Message Descriptor.

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      if (false) {
        console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
      }
    }
  } else {
    if (false) {
      // This prevents warnings from littering the console in development
      // when no `messages` are passed into the <IntlProvider> for the
      // default locale, and a default message is in the source.
      if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
        console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
      }
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      if (false) {
        console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
      }
    }
  }

  if (!formattedMessage) {
    if (false) {
      console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
    }
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {}
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.DateTimeFormat),
      getNumberFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.NumberFormat),
      getMessageFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats;


        if (false) {
          console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
        }

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatMessage = _context$intl.formatMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(458)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(465);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _ru_RU = __webpack_require__(485);

var _ru_RU2 = _interopRequireDefault(_ru_RU);

var _ru_RU3 = __webpack_require__(252);

var _ru_RU4 = _interopRequireDefault(_ru_RU3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Created by Andrey Gayvoronsky on 13/04/16.
 */
var locale = {
  lang: (0, _extends3['default'])({ placeholder: 'Выберите дату', rangePlaceholder: ['Начальная дата', 'Конечная дата'] }, _ru_RU2['default']),
  timePickerLocale: (0, _extends3['default'])({}, _ru_RU4['default'])
};
// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
exports['default'] = locale;
module.exports = exports['default'];

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by Andrey Gayvoronsky on 13/04/16.
 */
var locale = {
  placeholder: 'Выберите время'
};
exports['default'] = locale;
module.exports = exports['default'];

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Col = exports.Row = undefined;

var _row = __webpack_require__(254);

var _row2 = _interopRequireDefault(_row);

var _col = __webpack_require__(256);

var _col2 = _interopRequireDefault(_col);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.Row = _row2['default'];
exports.Col = _col2['default'];

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(5);

var _extends5 = _interopRequireDefault(_extends4);

var _typeof2 = __webpack_require__(38);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
// matchMedia polyfill for
// https://github.com/WickyNilliams/enquire.js/issues/82
var enquire = void 0;
if (typeof window !== 'undefined') {
    var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
        return {
            media: mediaQuery,
            matches: false,
            addListener: function addListener() {},
            removeListener: function removeListener() {}
        };
    };
    window.matchMedia = window.matchMedia || matchMediaPolyfill;
    enquire = __webpack_require__(489);
}

var responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
var responsiveMap = {
    xs: '(max-width: 575px)',
    sm: '(min-width: 576px)',
    md: '(min-width: 768px)',
    lg: '(min-width: 992px)',
    xl: '(min-width: 1200px)',
    xxl: '(min-width: 1600px)'
};

var Row = function (_React$Component) {
    (0, _inherits3['default'])(Row, _React$Component);

    function Row() {
        (0, _classCallCheck3['default'])(this, Row);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));

        _this.state = {
            screens: {}
        };
        return _this;
    }

    (0, _createClass3['default'])(Row, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            Object.keys(responsiveMap).map(function (screen) {
                return enquire.register(responsiveMap[screen], {
                    match: function match() {
                        if ((0, _typeof3['default'])(_this2.props.gutter) !== 'object') {
                            return;
                        }
                        _this2.setState(function (prevState) {
                            return {
                                screens: (0, _extends5['default'])({}, prevState.screens, (0, _defineProperty3['default'])({}, screen, true))
                            };
                        });
                    },
                    unmatch: function unmatch() {
                        if ((0, _typeof3['default'])(_this2.props.gutter) !== 'object') {
                            return;
                        }
                        _this2.setState(function (prevState) {
                            return {
                                screens: (0, _extends5['default'])({}, prevState.screens, (0, _defineProperty3['default'])({}, screen, false))
                            };
                        });
                    },
                    // Keep a empty destory to avoid triggering unmatch when unregister
                    destroy: function destroy() {}
                });
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            Object.keys(responsiveMap).map(function (screen) {
                return enquire.unregister(responsiveMap[screen]);
            });
        }
    }, {
        key: 'getGutter',
        value: function getGutter() {
            var gutter = this.props.gutter;

            if ((typeof gutter === 'undefined' ? 'undefined' : (0, _typeof3['default'])(gutter)) === 'object') {
                for (var i = 0; i <= responsiveArray.length; i++) {
                    var breakpoint = responsiveArray[i];
                    if (this.state.screens[breakpoint] && gutter[breakpoint] !== undefined) {
                        return gutter[breakpoint];
                    }
                }
            }
            return gutter;
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                type = _a.type,
                justify = _a.justify,
                align = _a.align,
                className = _a.className,
                style = _a.style,
                children = _a.children,
                _a$prefixCls = _a.prefixCls,
                prefixCls = _a$prefixCls === undefined ? 'ant-row' : _a$prefixCls,
                others = __rest(_a, ["type", "justify", "align", "className", "style", "children", "prefixCls"]);
            var gutter = this.getGutter();
            var classes = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls, !type), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + type, type), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + type + '-' + justify, type && justify), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + type + '-' + align, type && align), _classNames), className);
            var rowStyle = gutter > 0 ? (0, _extends5['default'])({ marginLeft: gutter / -2, marginRight: gutter / -2 }, style) : style;
            var cols = _react.Children.map(children, function (col) {
                if (!col) {
                    return null;
                }
                if (col.props && gutter > 0) {
                    return (0, _react.cloneElement)(col, {
                        style: (0, _extends5['default'])({ paddingLeft: gutter / 2, paddingRight: gutter / 2 }, col.props.style)
                    });
                }
                return col;
            });
            var otherProps = (0, _extends5['default'])({}, others);
            delete otherProps.gutter;
            return React.createElement(
                'div',
                (0, _extends5['default'])({}, otherProps, { className: classes, style: rowStyle }),
                cols
            );
        }
    }]);
    return Row;
}(React.Component);

exports['default'] = Row;

Row.defaultProps = {
    gutter: 0
};
Row.propTypes = {
    type: _propTypes2['default'].string,
    align: _propTypes2['default'].string,
    justify: _propTypes2['default'].string,
    className: _propTypes2['default'].string,
    children: _propTypes2['default'].node,
    gutter: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].number]),
    prefixCls: _propTypes2['default'].string
};
module.exports = exports['default'];

/***/ }),
/* 255 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(5);

var _extends4 = _interopRequireDefault(_extends3);

var _typeof2 = __webpack_require__(38);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var stringOrNumber = _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]);
var objectOrNumber = _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].number]);

var Col = function (_React$Component) {
    (0, _inherits3['default'])(Col, _React$Component);

    function Col() {
        (0, _classCallCheck3['default'])(this, Col);
        return (0, _possibleConstructorReturn3['default'])(this, (Col.__proto__ || Object.getPrototypeOf(Col)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Col, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var props = this.props;

            var span = props.span,
                order = props.order,
                offset = props.offset,
                push = props.push,
                pull = props.pull,
                className = props.className,
                children = props.children,
                _props$prefixCls = props.prefixCls,
                prefixCls = _props$prefixCls === undefined ? 'ant-col' : _props$prefixCls,
                others = __rest(props, ["span", "order", "offset", "push", "pull", "className", "children", "prefixCls"]);

            var sizeClassObj = {};
            ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].forEach(function (size) {
                var _extends2;

                var sizeProps = {};
                if (typeof props[size] === 'number') {
                    sizeProps.span = props[size];
                } else if ((0, _typeof3['default'])(props[size]) === 'object') {
                    sizeProps = props[size] || {};
                }
                delete others[size];
                sizeClassObj = (0, _extends4['default'])({}, sizeClassObj, (_extends2 = {}, (0, _defineProperty3['default'])(_extends2, prefixCls + '-' + size + '-' + sizeProps.span, sizeProps.span !== undefined), (0, _defineProperty3['default'])(_extends2, prefixCls + '-' + size + '-order-' + sizeProps.order, sizeProps.order || sizeProps.order === 0), (0, _defineProperty3['default'])(_extends2, prefixCls + '-' + size + '-offset-' + sizeProps.offset, sizeProps.offset || sizeProps.offset === 0), (0, _defineProperty3['default'])(_extends2, prefixCls + '-' + size + '-push-' + sizeProps.push, sizeProps.push || sizeProps.push === 0), (0, _defineProperty3['default'])(_extends2, prefixCls + '-' + size + '-pull-' + sizeProps.pull, sizeProps.pull || sizeProps.pull === 0), _extends2));
            });
            var classes = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + span, span !== undefined), (0, _defineProperty3['default'])(_classNames, prefixCls + '-order-' + order, order), (0, _defineProperty3['default'])(_classNames, prefixCls + '-offset-' + offset, offset), (0, _defineProperty3['default'])(_classNames, prefixCls + '-push-' + push, push), (0, _defineProperty3['default'])(_classNames, prefixCls + '-pull-' + pull, pull), _classNames), className, sizeClassObj);
            return React.createElement(
                'div',
                (0, _extends4['default'])({}, others, { className: classes }),
                children
            );
        }
    }]);
    return Col;
}(React.Component);

exports['default'] = Col;

Col.propTypes = {
    span: stringOrNumber,
    order: stringOrNumber,
    offset: stringOrNumber,
    push: stringOrNumber,
    pull: stringOrNumber,
    className: _propTypes2['default'].string,
    children: _propTypes2['default'].node,
    xs: objectOrNumber,
    sm: objectOrNumber,
    md: objectOrNumber,
    lg: objectOrNumber,
    xl: objectOrNumber,
    xxl: objectOrNumber
};
module.exports = exports['default'];

/***/ }),
/* 257 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 258 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(39);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _typeof2 = __webpack_require__(38);

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(68);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(36);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _asyncValidator = __webpack_require__(549);

var _asyncValidator2 = _interopRequireDefault(_asyncValidator);

var _warning = __webpack_require__(30);

var _warning2 = _interopRequireDefault(_warning);

var _get = __webpack_require__(571);

var _get2 = _interopRequireDefault(_get);

var _set = __webpack_require__(263);

var _set2 = _interopRequireDefault(_set);

var _createFieldsStore = __webpack_require__(577);

var _createFieldsStore2 = _interopRequireDefault(_createFieldsStore);

var _utils = __webpack_require__(165);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DEFAULT_TRIGGER = 'onChange';

function createBaseForm() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mixins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var validateMessages = option.validateMessages,
      onFieldsChange = option.onFieldsChange,
      onValuesChange = option.onValuesChange,
      _option$mapProps = option.mapProps,
      mapProps = _option$mapProps === undefined ? _utils.identity : _option$mapProps,
      mapPropsToFields = option.mapPropsToFields,
      fieldNameProp = option.fieldNameProp,
      fieldMetaProp = option.fieldMetaProp,
      fieldDataProp = option.fieldDataProp,
      _option$formPropName = option.formPropName,
      formPropName = _option$formPropName === undefined ? 'form' : _option$formPropName,
      withRef = option.withRef;


  return function decorate(WrappedComponent) {
    var Form = (0, _createReactClass2['default'])({
      displayName: 'Form',

      mixins: mixins,

      getInitialState: function getInitialState() {
        var _this = this;

        var fields = mapPropsToFields && mapPropsToFields(this.props);
        this.fieldsStore = (0, _createFieldsStore2['default'])(fields || {});

        this.instances = {};
        this.cachedBind = {};
        this.clearedFieldMetaCache = {};
        // HACK: https://github.com/ant-design/ant-design/issues/6406
        ['getFieldsValue', 'getFieldValue', 'setFieldsInitialValue', 'getFieldsError', 'getFieldError', 'isFieldValidating', 'isFieldsValidating', 'isFieldsTouched', 'isFieldTouched'].forEach(function (key) {
          return _this[key] = function () {
            var _fieldsStore;

            if (false) {
              (0, _warning2['default'])(false, 'you should not use `ref` on enhanced form, please use `wrappedComponentRef`. ' + 'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140');
            }
            return (_fieldsStore = _this.fieldsStore)[key].apply(_fieldsStore, arguments);
          };
        });

        return {
          submitting: false
        };
      },
      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (mapPropsToFields) {
          this.fieldsStore.updateFields(mapPropsToFields(nextProps));
        }
      },
      onCollectCommon: function onCollectCommon(name, action, args) {
        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if (fieldMeta[action]) {
          fieldMeta[action].apply(fieldMeta, (0, _toConsumableArray3['default'])(args));
        } else if (fieldMeta.originalProps && fieldMeta.originalProps[action]) {
          var _fieldMeta$originalPr;

          (_fieldMeta$originalPr = fieldMeta.originalProps)[action].apply(_fieldMeta$originalPr, (0, _toConsumableArray3['default'])(args));
        }
        var value = fieldMeta.getValueFromEvent ? fieldMeta.getValueFromEvent.apply(fieldMeta, (0, _toConsumableArray3['default'])(args)) : _utils.getValueFromEvent.apply(undefined, (0, _toConsumableArray3['default'])(args));
        if (onValuesChange && value !== this.fieldsStore.getFieldValue(name)) {
          var valuesAll = this.fieldsStore.getAllValues();
          var valuesAllSet = {};
          valuesAll[name] = value;
          Object.keys(valuesAll).forEach(function (key) {
            return (0, _set2['default'])(valuesAllSet, key, valuesAll[key]);
          });
          onValuesChange(this.props, (0, _set2['default'])({}, name, value), valuesAllSet);
        }
        var field = this.fieldsStore.getField(name);
        return { name: name, field: (0, _extends3['default'])({}, field, { value: value, touched: true }), fieldMeta: fieldMeta };
      },
      onCollect: function onCollect(name_, action) {
        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }

        var _onCollectCommon = this.onCollectCommon(name_, action, args),
            name = _onCollectCommon.name,
            field = _onCollectCommon.field,
            fieldMeta = _onCollectCommon.fieldMeta;

        var validate = fieldMeta.validate;

        var newField = (0, _extends3['default'])({}, field, {
          dirty: (0, _utils.hasRules)(validate)
        });
        this.setFields((0, _defineProperty3['default'])({}, name, newField));
      },
      onCollectValidate: function onCollectValidate(name_, action) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        var _onCollectCommon2 = this.onCollectCommon(name_, action, args),
            field = _onCollectCommon2.field,
            fieldMeta = _onCollectCommon2.fieldMeta;

        var newField = (0, _extends3['default'])({}, field, {
          dirty: true
        });
        this.validateFieldsInternal([newField], {
          action: action,
          options: {
            firstFields: !!fieldMeta.validateFirst
          }
        });
      },
      getCacheBind: function getCacheBind(name, action, fn) {
        if (!this.cachedBind[name]) {
          this.cachedBind[name] = {};
        }
        var cache = this.cachedBind[name];
        if (!cache[action]) {
          cache[action] = fn.bind(this, name, action);
        }
        return cache[action];
      },
      recoverClearedField: function recoverClearedField(name) {
        if (this.clearedFieldMetaCache[name]) {
          this.fieldsStore.setFields((0, _defineProperty3['default'])({}, name, this.clearedFieldMetaCache[name].field));
          this.fieldsStore.setFieldMeta(name, this.clearedFieldMetaCache[name].meta);
          delete this.clearedFieldMetaCache[name];
        }
      },
      getFieldDecorator: function getFieldDecorator(name, fieldOption) {
        var _this2 = this;

        var props = this.getFieldProps(name, fieldOption);
        return function (fieldElem) {
          var fieldMeta = _this2.fieldsStore.getFieldMeta(name);
          var originalProps = fieldElem.props;
          if (false) {
            var valuePropName = fieldMeta.valuePropName;
            (0, _warning2['default'])(!(valuePropName in originalProps), '`getFieldDecorator` will override `' + valuePropName + '`, ' + ('so please don\'t set `' + valuePropName + '` directly ') + 'and use `setFieldsValue` to set it.');
            var defaultValuePropName = 'default' + valuePropName[0].toUpperCase() + valuePropName.slice(1);
            (0, _warning2['default'])(!(defaultValuePropName in originalProps), '`' + defaultValuePropName + '` is invalid ' + ('for `getFieldDecorator` will set `' + valuePropName + '`,') + ' please use `option.initialValue` instead.');
          }
          fieldMeta.originalProps = originalProps;
          fieldMeta.ref = fieldElem.ref;
          return _react2['default'].cloneElement(fieldElem, (0, _extends3['default'])({}, props, _this2.fieldsStore.getFieldValuePropValue(fieldMeta)));
        };
      },
      getFieldProps: function getFieldProps(name) {
        var _this3 = this;

        var usersFieldOption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!name) {
          throw new Error('Must call `getFieldProps` with valid name string!');
        }
        if (false) {
          (0, _warning2['default'])(this.fieldsStore.isValidNestedFieldName(name), 'One field name cannot be part of another, e.g. `a` and `a.b`.');
          (0, _warning2['default'])(!('exclusive' in usersFieldOption), '`option.exclusive` of `getFieldProps`|`getFieldDecorator` had been remove.');
        }

        delete this.clearedFieldMetaCache[name];

        var fieldOption = (0, _extends3['default'])({
          name: name,
          trigger: DEFAULT_TRIGGER,
          valuePropName: 'value',
          validate: []
        }, usersFieldOption);

        var rules = fieldOption.rules,
            trigger = fieldOption.trigger,
            _fieldOption$validate = fieldOption.validateTrigger,
            validateTrigger = _fieldOption$validate === undefined ? trigger : _fieldOption$validate,
            validate = fieldOption.validate;


        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if ('initialValue' in fieldOption) {
          fieldMeta.initialValue = fieldOption.initialValue;
        }

        var inputProps = (0, _extends3['default'])({}, this.fieldsStore.getFieldValuePropValue(fieldOption), {
          ref: this.getCacheBind(name, name + '__ref', this.saveRef)
        });
        if (fieldNameProp) {
          inputProps[fieldNameProp] = name;
        }

        var validateRules = (0, _utils.normalizeValidateRules)(validate, rules, validateTrigger);
        var validateTriggers = (0, _utils.getValidateTriggers)(validateRules);
        validateTriggers.forEach(function (action) {
          if (inputProps[action]) return;
          inputProps[action] = _this3.getCacheBind(name, action, _this3.onCollectValidate);
        });

        // make sure that the value will be collect
        if (trigger && validateTriggers.indexOf(trigger) === -1) {
          inputProps[trigger] = this.getCacheBind(name, trigger, this.onCollect);
        }

        var meta = (0, _extends3['default'])({}, fieldMeta, fieldOption, {
          validate: validateRules
        });
        this.fieldsStore.setFieldMeta(name, meta);
        if (fieldMetaProp) {
          inputProps[fieldMetaProp] = meta;
        }

        if (fieldDataProp) {
          inputProps[fieldDataProp] = this.fieldsStore.getField(name);
        }

        return inputProps;
      },
      getFieldInstance: function getFieldInstance(name) {
        return this.instances[name];
      },
      getRules: function getRules(fieldMeta, action) {
        var actionRules = fieldMeta.validate.filter(function (item) {
          return !action || item.trigger.indexOf(action) >= 0;
        }).map(function (item) {
          return item.rules;
        });
        return (0, _utils.flattenArray)(actionRules);
      },
      setFields: function setFields(maybeNestedFields, callback) {
        var _this4 = this;

        var fields = this.fieldsStore.flattenRegisteredFields(maybeNestedFields);
        this.fieldsStore.setFields(fields);
        if (onFieldsChange) {
          var changedFields = Object.keys(fields).reduce(function (acc, name) {
            return (0, _set2['default'])(acc, name, _this4.fieldsStore.getField(name));
          }, {});
          onFieldsChange(this.props, changedFields, this.fieldsStore.getNestedAllFields());
        }
        this.forceUpdate(callback);
      },
      resetFields: function resetFields(ns) {
        var _this5 = this;

        var newFields = this.fieldsStore.resetFields(ns);
        if (Object.keys(newFields).length > 0) {
          this.setFields(newFields);
        }
        if (ns) {
          var names = Array.isArray(ns) ? ns : [ns];
          names.forEach(function (name) {
            return delete _this5.clearedFieldMetaCache[name];
          });
        } else {
          this.clearedFieldMetaCache = {};
        }
      },
      setFieldsValue: function setFieldsValue(changedValues, callback) {
        var fieldsMeta = this.fieldsStore.fieldsMeta;

        var values = this.fieldsStore.flattenRegisteredFields(changedValues);
        var newFields = Object.keys(values).reduce(function (acc, name) {
          var isRegistered = fieldsMeta[name];
          if (false) {
            (0, _warning2['default'])(isRegistered, 'Cannot use `setFieldsValue` until ' + 'you use `getFieldDecorator` or `getFieldProps` to register it.');
          }
          if (isRegistered) {
            var value = values[name];
            acc[name] = {
              value: value
            };
          }
          return acc;
        }, {});
        this.setFields(newFields, callback);
        if (onValuesChange) {
          var allValues = this.fieldsStore.getAllValues();
          onValuesChange(this.props, changedValues, allValues);
        }
      },
      saveRef: function saveRef(name, _, component) {
        if (!component) {
          // after destroy, delete data
          this.clearedFieldMetaCache[name] = {
            field: this.fieldsStore.getField(name),
            meta: this.fieldsStore.getFieldMeta(name)
          };
          this.fieldsStore.clearField(name);
          delete this.instances[name];
          delete this.cachedBind[name];
          return;
        }
        this.recoverClearedField(name);
        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if (fieldMeta) {
          var ref = fieldMeta.ref;
          if (ref) {
            if (typeof ref === 'string') {
              throw new Error('can not set ref string for ' + name);
            }
            ref(component);
          }
        }
        this.instances[name] = component;
      },
      validateFieldsInternal: function validateFieldsInternal(fields, _ref, callback) {
        var _this6 = this;

        var fieldNames = _ref.fieldNames,
            action = _ref.action,
            _ref$options = _ref.options,
            options = _ref$options === undefined ? {} : _ref$options;

        var allRules = {};
        var allValues = {};
        var allFields = {};
        var alreadyErrors = {};
        fields.forEach(function (field) {
          var name = field.name;
          if (options.force !== true && field.dirty === false) {
            if (field.errors) {
              (0, _set2['default'])(alreadyErrors, name, { errors: field.errors });
            }
            return;
          }
          var fieldMeta = _this6.fieldsStore.getFieldMeta(name);
          var newField = (0, _extends3['default'])({}, field);
          newField.errors = undefined;
          newField.validating = true;
          newField.dirty = true;
          allRules[name] = _this6.getRules(fieldMeta, action);
          allValues[name] = newField.value;
          allFields[name] = newField;
        });
        this.setFields(allFields);
        // in case normalize
        Object.keys(allValues).forEach(function (f) {
          allValues[f] = _this6.fieldsStore.getFieldValue(f);
        });
        if (callback && (0, _utils.isEmptyObject)(allFields)) {
          callback((0, _utils.isEmptyObject)(alreadyErrors) ? null : alreadyErrors, this.fieldsStore.getFieldsValue(fieldNames));
          return;
        }
        var validator = new _asyncValidator2['default'](allRules);
        if (validateMessages) {
          validator.messages(validateMessages);
        }
        validator.validate(allValues, options, function (errors) {
          var errorsGroup = (0, _extends3['default'])({}, alreadyErrors);
          if (errors && errors.length) {
            errors.forEach(function (e) {
              var fieldName = e.field;
              var field = (0, _get2['default'])(errorsGroup, fieldName);
              if ((typeof field === 'undefined' ? 'undefined' : (0, _typeof3['default'])(field)) !== 'object' || Array.isArray(field)) {
                (0, _set2['default'])(errorsGroup, fieldName, { errors: [] });
              }
              var fieldErrors = (0, _get2['default'])(errorsGroup, fieldName.concat('.errors'));
              fieldErrors.push(e);
            });
          }
          var expired = [];
          var nowAllFields = {};
          Object.keys(allRules).forEach(function (name) {
            var fieldErrors = (0, _get2['default'])(errorsGroup, name);
            var nowField = _this6.fieldsStore.getField(name);
            // avoid concurrency problems
            if (nowField.value !== allValues[name]) {
              expired.push({
                name: name
              });
            } else {
              nowField.errors = fieldErrors && fieldErrors.errors;
              nowField.value = allValues[name];
              nowField.validating = false;
              nowField.dirty = false;
              nowAllFields[name] = nowField;
            }
          });
          _this6.setFields(nowAllFields);
          if (callback) {
            if (expired.length) {
              expired.forEach(function (_ref2) {
                var name = _ref2.name;

                var fieldErrors = [{
                  message: name + ' need to revalidate',
                  field: name
                }];
                (0, _set2['default'])(errorsGroup, name, {
                  expired: true,
                  errors: fieldErrors
                });
              });
            }

            callback((0, _utils.isEmptyObject)(errorsGroup) ? null : errorsGroup, _this6.fieldsStore.getFieldsValue(fieldNames));
          }
        });
      },
      validateFields: function validateFields(ns, opt, cb) {
        var _this7 = this;

        var _getParams = (0, _utils.getParams)(ns, opt, cb),
            names = _getParams.names,
            callback = _getParams.callback,
            options = _getParams.options;

        var fieldNames = names ? this.fieldsStore.getValidFieldsFullName(names) : this.fieldsStore.getValidFieldsName();
        var fields = fieldNames.filter(function (name) {
          var fieldMeta = _this7.fieldsStore.getFieldMeta(name);
          return (0, _utils.hasRules)(fieldMeta.validate);
        }).map(function (name) {
          var field = _this7.fieldsStore.getField(name);
          field.value = _this7.fieldsStore.getFieldValue(name);
          return field;
        });
        if (!fields.length) {
          if (callback) {
            callback(null, this.fieldsStore.getFieldsValue(fieldNames));
          }
          return;
        }
        if (!('firstFields' in options)) {
          options.firstFields = fieldNames.filter(function (name) {
            var fieldMeta = _this7.fieldsStore.getFieldMeta(name);
            return !!fieldMeta.validateFirst;
          });
        }
        this.validateFieldsInternal(fields, {
          fieldNames: fieldNames,
          options: options
        }, callback);
      },
      isSubmitting: function isSubmitting() {
        if (false) {
          (0, _warning2['default'])(false, '`isSubmitting` is deprecated. ' + 'Actually, it\'s more convenient to handle submitting status by yourself.');
        }
        return this.state.submitting;
      },
      submit: function submit(callback) {
        var _this8 = this;

        if (false) {
          (0, _warning2['default'])(false, '`submit` is deprecated.' + 'Actually, it\'s more convenient to handle submitting status by yourself.');
        }
        var fn = function fn() {
          _this8.setState({
            submitting: false
          });
        };
        this.setState({
          submitting: true
        });
        callback(fn);
      },
      render: function render() {
        var _props = this.props,
            wrappedComponentRef = _props.wrappedComponentRef,
            restProps = (0, _objectWithoutProperties3['default'])(_props, ['wrappedComponentRef']);

        var formProps = (0, _defineProperty3['default'])({}, formPropName, this.getForm());
        if (withRef) {
          if (false) {
            (0, _warning2['default'])(false, '`withRef` is deprecated, please use `wrappedComponentRef` instead. ' + 'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140');
          }
          formProps.ref = 'wrappedComponent';
        } else if (wrappedComponentRef) {
          formProps.ref = wrappedComponentRef;
        }
        var props = mapProps.call(this, (0, _extends3['default'])({}, formProps, restProps));
        return _react2['default'].createElement(WrappedComponent, props);
      }
    });

    return (0, _utils.argumentContainer)(Form, WrappedComponent);
  };
}

exports['default'] = createBaseForm;
module.exports = exports['default'];

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(261);
var ITERATOR = __webpack_require__(45)('iterator');
var Iterators = __webpack_require__(76);
module.exports = __webpack_require__(44).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(132);
var TAG = __webpack_require__(45)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(29);


/**
 *  Rule for validating required fields.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || __WEBPACK_IMPORTED_MODULE_0__util__["e" /* isEmptyValue */](value, type || rule.type))) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.required, rule.fullField));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (required);

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(573);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

exports.isFormField = isFormField;
exports["default"] = createFormField;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Field = function Field(fields) {
  (0, _classCallCheck3["default"])(this, Field);

  (0, _extends3["default"])(this, fields);
};

function isFormField(obj) {
  return obj instanceof Field;
}

function createFormField(field) {
  if (isFormField(field)) {
    return field;
  }
  return new Field(field);
}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule warning
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isCssAnimationSupported", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["default"] = (cssAnimation);

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FIELD_META_PROP = exports.FIELD_META_PROP = 'data-__meta';
var FIELD_DATA_PROP = exports.FIELD_DATA_PROP = 'data-__field';

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = __webpack_require__(47);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function fixControlledValue(value) {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    return value;
}

var Input = function (_React$Component) {
    (0, _inherits3['default'])(Input, _React$Component);

    function Input() {
        (0, _classCallCheck3['default'])(this, Input);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));

        _this.handleKeyDown = function (e) {
            var _this$props = _this.props,
                onPressEnter = _this$props.onPressEnter,
                onKeyDown = _this$props.onKeyDown;

            if (e.keyCode === 13 && onPressEnter) {
                onPressEnter(e);
            }
            if (onKeyDown) {
                onKeyDown(e);
            }
        };
        _this.saveInput = function (node) {
            _this.input = node;
        };
        return _this;
    }

    (0, _createClass3['default'])(Input, [{
        key: 'focus',
        value: function focus() {
            this.input.focus();
        }
    }, {
        key: 'blur',
        value: function blur() {
            this.input.blur();
        }
    }, {
        key: 'getInputClassName',
        value: function getInputClassName() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                size = _props.size,
                disabled = _props.disabled;

            return (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', size === 'small'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), _classNames));
        }
    }, {
        key: 'renderLabeledInput',
        value: function renderLabeledInput(children) {
            var _classNames3;

            var props = this.props;
            // Not wrap when there is not addons
            if (!props.addonBefore && !props.addonAfter) {
                return children;
            }
            var wrapperClassName = props.prefixCls + '-group';
            var addonClassName = wrapperClassName + '-addon';
            var addonBefore = props.addonBefore ? React.createElement(
                'span',
                { className: addonClassName },
                props.addonBefore
            ) : null;
            var addonAfter = props.addonAfter ? React.createElement(
                'span',
                { className: addonClassName },
                props.addonAfter
            ) : null;
            var className = (0, _classnames2['default'])(props.prefixCls + '-wrapper', (0, _defineProperty3['default'])({}, wrapperClassName, addonBefore || addonAfter));
            var groupClassName = (0, _classnames2['default'])(props.prefixCls + '-group-wrapper', (_classNames3 = {}, (0, _defineProperty3['default'])(_classNames3, props.prefixCls + '-group-wrapper-sm', props.size === 'small'), (0, _defineProperty3['default'])(_classNames3, props.prefixCls + '-group-wrapper-lg', props.size === 'large'), _classNames3));
            // Need another wrapper for changing display:table to display:inline-block
            // and put style prop in wrapper
            return React.createElement(
                'span',
                { className: groupClassName, style: props.style },
                React.createElement(
                    'span',
                    { className: className },
                    addonBefore,
                    React.cloneElement(children, { style: null }),
                    addonAfter
                )
            );
        }
    }, {
        key: 'renderLabeledIcon',
        value: function renderLabeledIcon(children) {
            var _classNames4;

            var props = this.props;

            if (!('prefix' in props || 'suffix' in props)) {
                return children;
            }
            var prefix = props.prefix ? React.createElement(
                'span',
                { className: props.prefixCls + '-prefix' },
                props.prefix
            ) : null;
            var suffix = props.suffix ? React.createElement(
                'span',
                { className: props.prefixCls + '-suffix' },
                props.suffix
            ) : null;
            var affixWrapperCls = (0, _classnames2['default'])(props.className, props.prefixCls + '-affix-wrapper', (_classNames4 = {}, (0, _defineProperty3['default'])(_classNames4, props.prefixCls + '-affix-wrapper-sm', props.size === 'small'), (0, _defineProperty3['default'])(_classNames4, props.prefixCls + '-affix-wrapper-lg', props.size === 'large'), _classNames4));
            return React.createElement(
                'span',
                { className: affixWrapperCls, style: props.style },
                prefix,
                React.cloneElement(children, { style: null, className: this.getInputClassName() }),
                suffix
            );
        }
    }, {
        key: 'renderInput',
        value: function renderInput() {
            var _props2 = this.props,
                value = _props2.value,
                className = _props2.className;
            // Fix https://fb.me/react-unknown-prop

            var otherProps = (0, _omit2['default'])(this.props, ['prefixCls', 'onPressEnter', 'addonBefore', 'addonAfter', 'prefix', 'suffix']);
            if ('value' in this.props) {
                otherProps.value = fixControlledValue(value);
                // Input elements must be either controlled or uncontrolled,
                // specify either the value prop, or the defaultValue prop, but not both.
                delete otherProps.defaultValue;
            }
            return this.renderLabeledIcon(React.createElement('input', (0, _extends3['default'])({}, otherProps, { className: (0, _classnames2['default'])(this.getInputClassName(), className), onKeyDown: this.handleKeyDown, ref: this.saveInput })));
        }
    }, {
        key: 'render',
        value: function render() {
            return this.renderLabeledInput(this.renderInput());
        }
    }]);
    return Input;
}(React.Component);

exports['default'] = Input;

Input.defaultProps = {
    prefixCls: 'ant-input',
    type: 'text',
    disabled: false
};
Input.propTypes = {
    type: _propTypes2['default'].string,
    id: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
    size: _propTypes2['default'].oneOf(['small', 'default', 'large']),
    maxLength: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
    disabled: _propTypes2['default'].bool,
    value: _propTypes2['default'].any,
    defaultValue: _propTypes2['default'].any,
    className: _propTypes2['default'].string,
    addonBefore: _propTypes2['default'].node,
    addonAfter: _propTypes2['default'].node,
    prefixCls: _propTypes2['default'].string,
    autosize: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].object]),
    onPressEnter: _propTypes2['default'].func,
    onKeyDown: _propTypes2['default'].func,
    onKeyUp: _propTypes2['default'].func,
    onFocus: _propTypes2['default'].func,
    onBlur: _propTypes2['default'].func,
    prefix: _propTypes2['default'].node,
    suffix: _propTypes2['default'].node
};
module.exports = exports['default'];

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Notification__ = __webpack_require__(593);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Notification__["a" /* default */]);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createChainedFunction;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);
  if (args.length === 1) {
    return args[0];
  }

  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(279);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(173);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var BreadcrumbItem = function (_React$Component) {
    (0, _inherits3['default'])(BreadcrumbItem, _React$Component);

    function BreadcrumbItem() {
        (0, _classCallCheck3['default'])(this, BreadcrumbItem);
        return (0, _possibleConstructorReturn3['default'])(this, (BreadcrumbItem.__proto__ || Object.getPrototypeOf(BreadcrumbItem)).apply(this, arguments));
    }

    (0, _createClass3['default'])(BreadcrumbItem, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                prefixCls = _a.prefixCls,
                separator = _a.separator,
                children = _a.children,
                restProps = __rest(_a, ["prefixCls", "separator", "children"]);
            var link = void 0;
            if ('href' in this.props) {
                link = React.createElement(
                    'a',
                    (0, _extends3['default'])({ className: prefixCls + '-link' }, restProps),
                    children
                );
            } else {
                link = React.createElement(
                    'span',
                    (0, _extends3['default'])({ className: prefixCls + '-link' }, restProps),
                    children
                );
            }
            if (children) {
                return React.createElement(
                    'span',
                    null,
                    link,
                    React.createElement(
                        'span',
                        { className: prefixCls + '-separator' },
                        separator
                    )
                );
            }
            return null;
        }
    }]);
    return BreadcrumbItem;
}(React.Component);

exports['default'] = BreadcrumbItem;

BreadcrumbItem.__ANT_BREADCRUMB_ITEM = true;
BreadcrumbItem.defaultProps = {
    prefixCls: 'ant-breadcrumb',
    separator: '/'
};
BreadcrumbItem.propTypes = {
    prefixCls: _propTypes2['default'].string,
    separator: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].element]),
    href: _propTypes2['default'].string
};
module.exports = exports['default'];

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(637);

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeShape = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storeShape = exports.storeShape = _propTypes2.default.shape({
  subscribe: _propTypes2.default.func.isRequired,
  setState: _propTypes2.default.func.isRequired,
  getState: _propTypes2.default.func.isRequired
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getActiveKey;
/* unused harmony export saveRef */
/* unused harmony export SubPopupMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_createChainedFunction__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DOMWrap__ = __webpack_require__(642);














function allDisabled(arr) {
  if (!arr.length) {
    return true;
  }
  return arr.every(function (c) {
    return !!c.props.disabled;
  });
}

function updateActiveKey(store, menuId, activeKey) {
  var _extends2;

  var state = store.getState();
  store.setState({
    activeKey: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.activeKey, (_extends2 = {}, _extends2[menuId] = activeKey, _extends2))
  });
}

function getActiveKey(props, originalActiveKey) {
  var activeKey = originalActiveKey;
  var children = props.children,
      eventKey = props.eventKey;

  if (activeKey) {
    var found = void 0;
    Object(__WEBPACK_IMPORTED_MODULE_11__util__["c" /* loopMenuItem */])(children, function (c, i) {
      if (c && !c.props.disabled && activeKey === Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* getKeyFromChildrenIndex */])(c, eventKey, i)) {
        found = true;
      }
    });
    if (found) {
      return activeKey;
    }
  }
  activeKey = null;
  if (props.defaultActiveFirst) {
    Object(__WEBPACK_IMPORTED_MODULE_11__util__["c" /* loopMenuItem */])(children, function (c, i) {
      if (!activeKey && c && !c.props.disabled) {
        activeKey = Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* getKeyFromChildrenIndex */])(c, eventKey, i);
      }
    });
    return activeKey;
  }
  return activeKey;
}

function saveRef(c) {
  if (c) {
    var index = this.instanceArray.indexOf(c);
    if (index !== -1) {
      // update component if it's already inside instanceArray
      this.instanceArray[index] = c;
    } else {
      // add component if it's not in instanceArray yet;
      this.instanceArray.push(c);
    }
  }
}

var SubPopupMenu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SubPopupMenu, _React$Component);

  function SubPopupMenu(props) {
    var _extends3;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SubPopupMenu);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    props.store.setState({
      activeKey: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props.store.getState().activeKey, (_extends3 = {}, _extends3[props.eventKey] = getActiveKey(props, props.activeKey), _extends3))
    });
    return _this;
  }

  SubPopupMenu.prototype.componentWillMount = function componentWillMount() {
    this.instanceArray = [];
  };

  SubPopupMenu.prototype.componentDidMount = function componentDidMount() {
    // invoke customized ref to expose component to mixin
    if (this.props.manualRef) {
      this.props.manualRef(this);
    }
  };

  SubPopupMenu.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var originalActiveKey = 'activeKey' in nextProps ? nextProps.activeKey : this.getStore().getState().activeKey[this.getEventKey()];
    var activeKey = getActiveKey(nextProps, originalActiveKey);
    if (activeKey !== originalActiveKey) {
      updateActiveKey(this.getStore(), this.getEventKey(), activeKey);
    }
  };

  SubPopupMenu.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.visible || nextProps.visible;
  };

  // all keyboard events callbacks run from here at first


  SubPopupMenu.prototype.render = function render() {
    var _this2 = this;

    var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

    this.instanceArray = [];
    var className = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(props.prefixCls, props.className, props.prefixCls + '-' + props.mode);
    var domProps = {
      className: className,
      // role could be 'select' and by default set to menu
      role: props.role || 'menu'
    };
    if (props.id) {
      domProps.id = props.id;
    }
    if (props.focusable) {
      domProps.tabIndex = '0';
      domProps.onKeyDown = this.onKeyDown;
    }
    var prefixCls = props.prefixCls,
        eventKey = props.eventKey,
        visible = props.visible;

    __WEBPACK_IMPORTED_MODULE_11__util__["e" /* menuAllProps */].forEach(function (key) {
      return delete props[key];
    });

    // Otherwise, the propagated click event will trigger another onClick
    delete props.onClick;
    return (
      // ESLint is not smart enough to know that the type of `children` was checked.
      /* eslint-disable */
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12__DOMWrap__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, {
          tag: 'ul',
          hiddenClassName: prefixCls + '-hidden',
          visible: visible
        }, domProps),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(props.children, function (c, i) {
          return _this2.renderMenuItem(c, i, eventKey || '0-menu-');
        })
      )
      /*eslint-enable */

    );
  };

  return SubPopupMenu;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

SubPopupMenu.propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onOpenChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  openTransitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  openAnimation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  openKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  parentMenu: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  store: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    getState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    setState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }),

  // adding in refactor
  focusable: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  defaultActiveFirst: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  defaultSelectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  defaultOpenKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  level: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
  triggerSubMenuAction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['click', 'hover']),
  inlineIndent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  manualRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
SubPopupMenu.defaultProps = {
  prefixCls: 'rc-menu',
  className: '',
  mode: 'vertical',
  level: 1,
  inlineIndent: 24,
  visible: true,
  focusable: true,
  style: {},
  manualRef: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */]
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onKeyDown = function (e, callback) {
    var keyCode = e.keyCode;
    var handled = void 0;
    _this3.getFlatInstanceArray().forEach(function (obj) {
      if (obj && obj.props.active && obj.onKeyDown) {
        handled = obj.onKeyDown(e);
      }
    });
    if (handled) {
      return 1;
    }
    var activeItem = null;
    if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].UP || keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].DOWN) {
      activeItem = _this3.step(keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].UP ? -1 : 1);
    }
    if (activeItem) {
      e.preventDefault();
      updateActiveKey(_this3.getStore(), _this3.getEventKey(), activeItem.props.eventKey);

      if (typeof callback === 'function') {
        callback(activeItem);
      }

      return 1;
    }
  };

  this.onItemHover = function (e) {
    var key = e.key,
        hover = e.hover;

    updateActiveKey(_this3.getStore(), _this3.getEventKey(), hover ? key : null);
  };

  this.onDeselect = function (selectInfo) {
    _this3.props.onDeselect(selectInfo);
  };

  this.onSelect = function (selectInfo) {
    _this3.props.onSelect(selectInfo);
  };

  this.onClick = function (e) {
    _this3.props.onClick(e);
  };

  this.onOpenChange = function (e) {
    _this3.props.onOpenChange(e);
  };

  this.onDestroy = function (key) {
    /* istanbul ignore next */
    _this3.props.onDestroy(key);
  };

  this.getFlatInstanceArray = function () {
    return _this3.instanceArray;
  };

  this.getStore = function () {
    return _this3.props.store;
  };

  this.getEventKey = function () {
    // when eventKey not available ,it's menu and return menu id '0-menu-'
    return _this3.props.eventKey || '0-menu-';
  };

  this.getOpenTransitionName = function () {
    return _this3.props.openTransitionName;
  };

  this.step = function (direction) {
    var children = _this3.getFlatInstanceArray();
    var activeKey = _this3.getStore().getState().activeKey[_this3.getEventKey()];
    var len = children.length;
    if (!len) {
      return null;
    }
    if (direction < 0) {
      children = children.concat().reverse();
    }
    // find current activeIndex
    var activeIndex = -1;
    children.every(function (c, ci) {
      if (c && c.props.eventKey === activeKey) {
        activeIndex = ci;
        return false;
      }
      return true;
    });
    if (!_this3.props.defaultActiveFirst && activeIndex !== -1 && allDisabled(children.slice(activeIndex, len - 1))) {
      return undefined;
    }
    var start = (activeIndex + 1) % len;
    var i = start;

    do {
      var child = children[i];
      if (!child || child.props.disabled) {
        i = (i + 1) % len;
      } else {
        return child;
      }
    } while (i !== start);

    return null;
  };

  this.renderCommonMenuItem = function (child, i, extraProps) {
    var state = _this3.getStore().getState();
    var props = _this3.props;
    var key = Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* getKeyFromChildrenIndex */])(child, props.eventKey, i);
    var childProps = child.props;
    var isActive = key === state.activeKey;
    var newChildProps = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
      mode: props.mode,
      level: props.level,
      inlineIndent: props.inlineIndent,
      renderMenuItem: _this3.renderMenuItem,
      rootPrefixCls: props.prefixCls,
      index: i,
      parentMenu: props.parentMenu,
      // customized ref function, need to be invoked manually in child's componentDidMount
      manualRef: childProps.disabled ? undefined : Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_createChainedFunction__["a" /* default */])(child.ref, saveRef.bind(_this3)),
      eventKey: key,
      active: !childProps.disabled && isActive,
      multiple: props.multiple,
      onClick: function onClick(e) {
        (childProps.onClick || __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */])(e);
        _this3.onClick(e);
      },
      onItemHover: _this3.onItemHover,
      openTransitionName: _this3.getOpenTransitionName(),
      openAnimation: props.openAnimation,
      subMenuOpenDelay: props.subMenuOpenDelay,
      subMenuCloseDelay: props.subMenuCloseDelay,
      forceSubMenuRender: props.forceSubMenuRender,
      onOpenChange: _this3.onOpenChange,
      onDeselect: _this3.onDeselect,
      onSelect: _this3.onSelect
    }, extraProps);
    if (props.mode === 'inline') {
      newChildProps.triggerSubMenuAction = 'click';
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, newChildProps);
  };

  this.renderMenuItem = function (c, i, subMenuKey) {
    /* istanbul ignore if */
    if (!c) {
      return null;
    }
    var state = _this3.getStore().getState();
    var extraProps = {
      openKeys: state.openKeys,
      selectedKeys: state.selectedKeys,
      triggerSubMenuAction: _this3.props.triggerSubMenuAction,
      subMenuKey: subMenuKey
    };
    return _this3.renderCommonMenuItem(c, i, extraProps);
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_mini_store__["connect"])()(SubPopupMenu));

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = addEventListener;

var _EventObject = __webpack_require__(644);

var _EventObject2 = _interopRequireDefault(_EventObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function addEventListener(target, eventType, callback) {
  function wrapCallback(e) {
    var ne = new _EventObject2["default"](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    target.addEventListener(eventType, wrapCallback, false);
    return {
      remove: function remove() {
        target.removeEventListener(eventType, wrapCallback, false);
      }
    };
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}
module.exports = exports['default'];

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getVisibleRectForElement__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adjustForViewport__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getRegion__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getElFuturePos__ = __webpack_require__(654);
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */







// http://yiminghe.iteye.com/blog/1124720

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n = void 0;
  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }
  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}

/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  // 当前节点可以被放置的显示区域
  var visibleRect = Object(__WEBPACK_IMPORTED_MODULE_1__getVisibleRectForElement__["a" /* default */])(source);
  // 当前节点所占的区域, left/top/width/height
  var elRegion = Object(__WEBPACK_IMPORTED_MODULE_3__getRegion__["a" /* default */])(source);
  // 将 offset 转换成数值，支持百分比
  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion);
  // 当前节点将要被放置的位置
  var elFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, points, offset, targetOffset);
  // 当前节点将要所处的区域
  var newElRegion = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].merge(elRegion, elFuturePos);

  // 如果可视区域不能完全放置当前节点时允许调整
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/ig, {
          l: 'r',
          r: 'l'
        });
        // 偏移量也反下
        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/ig, {
          t: 'b',
          b: 't'
        });
        // 偏移量也反下
        var _newOffset = flipOffset(offset, 1);
        var _newTargetOffset = flipOffset(targetOffset, 1);
        var _newElFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    }

    // 如果失败，重新计算当前节点将要被放置的位置
    if (fail) {
      elFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, points, offset, targetOffset);
      __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数
    if (isStillFailX || isStillFailY) {
      points = align.points;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    }
    // 2. 只有指定了可以调整当前方向才调整
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;

    // 确实要调整，甚至可能会调整高度宽度
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = Object(__WEBPACK_IMPORTED_MODULE_2__adjustForViewport__["a" /* default */])(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }

  // need judge to in case set fixed with in css on height auto element
  if (newElRegion.width !== elRegion.width) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(source, 'width', __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(source, 'height', __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].height(source) + newElRegion.height - elRegion.height);
  }

  // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>
  __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });

  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}

/* harmony default export */ __webpack_exports__["a"] = (doAlign);
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isAncestorFixed__ = __webpack_require__(652);




/**
 * 获得元素的显示部分的区域
 */
function getVisibleRectForElement(element) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = Object(__WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */])(element);
  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;

  // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.
  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
    // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(el, 'overflow') !== 'visible') {
      var pos = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(el);
      // add border
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right,
      // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = Object(__WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */])(el);
  }

  // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601
  var originalPosition = null;
  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(element, 'position');
    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win);
  var scrollY = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win);
  var viewportWidth = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
  var viewportHeight = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;

  // Reset element position after calculate the visible area
  if (element.style) {
    element.style.position = originalPosition;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__isAncestorFixed__["a" /* default */])(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);

    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

/* harmony default export */ __webpack_exports__["a"] = (getVisibleRectForElement);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(69);


/**
 * 得到会导致元素显示不全的祖先元素
 */

function getOffsetParent(element) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) || element.nodeType === 9) {
    return null;
  }
  // ie 这个也不是完全可行
  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法
  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var body = doc.body;
  var parent = void 0;
  var positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : element.parentNode;
  }

  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
    positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(parent, 'position');
    if (positionStyle !== 'static') {
      return parent;
    }
  }
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (getOffsetParent);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(69);


function getRegion(node) {
  var offset = void 0;
  var w = void 0;
  var h = void 0;
  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(node) && node.nodeType !== 9) {
    offset = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(node);
    w = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].outerWidth(node);
    h = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].outerHeight(node);
  } else {
    var win = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindow(node);
    offset = {
      left: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win),
      top: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win)
    };
    w = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
    h = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);
  }
  offset.width = w;
  offset.height = h;
  return offset;
}

/* harmony default export */ __webpack_exports__["a"] = (getRegion);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var ContainerRender = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ContainerRender, _React$Component);

  function ContainerRender() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ContainerRender);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ContainerRender.__proto__ || Object.getPrototypeOf(ContainerRender)).call.apply(_ref, [this].concat(args))), _this), _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(_this.container);
        _this.container.parentNode.removeChild(_this.container);
        _this.container = null;
      }
    }, _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ContainerRender, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};
/* harmony default export */ __webpack_exports__["a"] = (ContainerRender);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var Portal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Portal, _React$Component);

  function Portal() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Portal);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: 'createContainer',
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: 'removeContainer',
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.createPortal(this.props.children, this._container);
      }
      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _rcTooltip = __webpack_require__(667);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _placements = __webpack_require__(671);

var _placements2 = _interopRequireDefault(_placements);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var splitObject = function splitObject(obj, keys) {
    var picked = {};
    var omitted = (0, _extends3['default'])({}, obj);
    keys.forEach(function (key) {
        if (obj && key in obj) {
            picked[key] = obj[key];
            delete omitted[key];
        }
    });
    return { picked: picked, omitted: omitted };
};

var Tooltip = function (_React$Component) {
    (0, _inherits3['default'])(Tooltip, _React$Component);

    function Tooltip(props) {
        (0, _classCallCheck3['default'])(this, Tooltip);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

        _this.onVisibleChange = function (visible) {
            var onVisibleChange = _this.props.onVisibleChange;

            if (!('visible' in _this.props)) {
                _this.setState({ visible: _this.isNoTitle() ? false : visible });
            }
            if (onVisibleChange && !_this.isNoTitle()) {
                onVisibleChange(visible);
            }
        };
        // 动态设置动画点
        _this.onPopupAlign = function (domNode, align) {
            var placements = _this.getPlacements();
            // 当前返回的位置
            var placement = Object.keys(placements).filter(function (key) {
                return placements[key].points[0] === align.points[0] && placements[key].points[1] === align.points[1];
            })[0];
            if (!placement) {
                return;
            }
            // 根据当前坐标设置动画点
            var rect = domNode.getBoundingClientRect();
            var transformOrigin = {
                top: '50%',
                left: '50%'
            };
            if (placement.indexOf('top') >= 0 || placement.indexOf('Bottom') >= 0) {
                transformOrigin.top = rect.height - align.offset[1] + 'px';
            } else if (placement.indexOf('Top') >= 0 || placement.indexOf('bottom') >= 0) {
                transformOrigin.top = -align.offset[1] + 'px';
            }
            if (placement.indexOf('left') >= 0 || placement.indexOf('Right') >= 0) {
                transformOrigin.left = rect.width - align.offset[0] + 'px';
            } else if (placement.indexOf('right') >= 0 || placement.indexOf('Left') >= 0) {
                transformOrigin.left = -align.offset[0] + 'px';
            }
            domNode.style.transformOrigin = transformOrigin.left + ' ' + transformOrigin.top;
        };
        _this.saveTooltip = function (node) {
            _this.tooltip = node;
        };
        _this.state = {
            visible: !!props.visible || !!props.defaultVisible
        };
        return _this;
    }

    (0, _createClass3['default'])(Tooltip, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('visible' in nextProps) {
                this.setState({ visible: nextProps.visible });
            }
        }
    }, {
        key: 'getPopupDomNode',
        value: function getPopupDomNode() {
            return this.tooltip.getPopupDomNode();
        }
    }, {
        key: 'getPlacements',
        value: function getPlacements() {
            var _props = this.props,
                builtinPlacements = _props.builtinPlacements,
                arrowPointAtCenter = _props.arrowPointAtCenter,
                autoAdjustOverflow = _props.autoAdjustOverflow;

            return builtinPlacements || (0, _placements2['default'])({
                arrowPointAtCenter: arrowPointAtCenter,
                verticalArrowShift: 8,
                autoAdjustOverflow: autoAdjustOverflow
            });
        }
    }, {
        key: 'isHoverTrigger',
        value: function isHoverTrigger() {
            var trigger = this.props.trigger;

            if (!trigger || trigger === 'hover') {
                return true;
            }
            if (Array.isArray(trigger)) {
                return trigger.indexOf('hover') >= 0;
            }
            return false;
        }
        // Fix Tooltip won't hide at disabled button
        // mouse events don't trigger at disabled button in Chrome
        // https://github.com/react-component/tooltip/issues/18

    }, {
        key: 'getDisabledCompatibleChildren',
        value: function getDisabledCompatibleChildren(element) {
            if ((element.type.__ANT_BUTTON || element.type === 'button') && element.props.disabled && this.isHoverTrigger()) {
                // Pick some layout related style properties up to span
                // Prevent layout bugs like https://github.com/ant-design/ant-design/issues/5254
                var _splitObject = splitObject(element.props.style, ['position', 'left', 'right', 'top', 'bottom', 'float', 'display', 'zIndex']),
                    picked = _splitObject.picked,
                    omitted = _splitObject.omitted;

                var spanStyle = (0, _extends3['default'])({ display: 'inline-block' }, picked, { cursor: 'not-allowed' });
                var buttonStyle = (0, _extends3['default'])({}, omitted, { pointerEvents: 'none' });
                var child = (0, _react.cloneElement)(element, {
                    style: buttonStyle,
                    className: null
                });
                return React.createElement(
                    'span',
                    { style: spanStyle, className: element.props.className },
                    child
                );
            }
            return element;
        }
    }, {
        key: 'isNoTitle',
        value: function isNoTitle() {
            var _props2 = this.props,
                title = _props2.title,
                overlay = _props2.overlay;

            return !title && !overlay; // overlay for old version compatibility
        }
    }, {
        key: 'render',
        value: function render() {
            var props = this.props,
                state = this.state;
            var prefixCls = props.prefixCls,
                title = props.title,
                overlay = props.overlay,
                openClassName = props.openClassName,
                getPopupContainer = props.getPopupContainer,
                getTooltipContainer = props.getTooltipContainer;

            var children = props.children;
            var visible = state.visible;
            // Hide tooltip when there is no title
            if (!('visible' in props) && this.isNoTitle()) {
                visible = false;
            }
            var child = this.getDisabledCompatibleChildren(React.isValidElement(children) ? children : React.createElement(
                'span',
                null,
                children
            ));
            var childProps = child.props;
            var childCls = (0, _classnames2['default'])(childProps.className, (0, _defineProperty3['default'])({}, openClassName || prefixCls + '-open', true));
            return React.createElement(
                _rcTooltip2['default'],
                (0, _extends3['default'])({}, this.props, { getTooltipContainer: getPopupContainer || getTooltipContainer, ref: this.saveTooltip, builtinPlacements: this.getPlacements(), overlay: overlay || title || '', visible: visible, onVisibleChange: this.onVisibleChange, onPopupAlign: this.onPopupAlign }),
                visible ? (0, _react.cloneElement)(child, { className: childCls }) : child
            );
        }
    }]);
    return Tooltip;
}(React.Component);

exports['default'] = Tooltip;

Tooltip.defaultProps = {
    prefixCls: 'ant-tooltip',
    placement: 'top',
    transitionName: 'zoom-big-fast',
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    arrowPointAtCenter: false,
    autoAdjustOverflow: true
};
module.exports = exports['default'];

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(182);












var TabPane = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(TabPane, _React$Component);

  function TabPane() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, TabPane);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TabPane.__proto__ || Object.getPrototypeOf(TabPane)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(TabPane, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          destroyInactiveTabPane = _props.destroyInactiveTabPane,
          active = _props.active,
          forceRender = _props.forceRender,
          rootPrefixCls = _props.rootPrefixCls,
          style = _props.style,
          children = _props.children,
          placeholder = _props.placeholder,
          restProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'destroyInactiveTabPane', 'active', 'forceRender', 'rootPrefixCls', 'style', 'children', 'placeholder']);

      this._isActived = this._isActived || active;
      var prefixCls = rootPrefixCls + '-tabpane';
      var cls = __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-inactive', !active), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-active', active), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, className, className), _classnames));
      var isRender = destroyInactiveTabPane ? active : this._isActived;
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          style: style,
          role: 'tabpanel',
          'aria-hidden': active ? 'false' : 'true',
          className: cls
        }, Object(__WEBPACK_IMPORTED_MODULE_10__utils__["b" /* getDataAttr */])(restProps)),
        isRender || forceRender ? children : placeholder
      );
    }
  }]);

  return TabPane;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (TabPane);


TabPane.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  destroyInactiveTabPane: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  placeholder: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node
};

TabPane.defaultProps = {
  placeholder: null
};

/***/ }),
/* 298 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(697);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(299);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(710);

__webpack_require__(115);

__webpack_require__(53);

__webpack_require__(183);

__webpack_require__(184);

__webpack_require__(715);

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Table = __webpack_require__(718);

var _Table2 = _interopRequireDefault(_Table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _Table2['default'];
module.exports = exports['default'];

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(185),
    root = __webpack_require__(82);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(741),
    mapCacheDelete = __webpack_require__(748),
    mapCacheGet = __webpack_require__(750),
    mapCacheHas = __webpack_require__(751),
    mapCacheSet = __webpack_require__(752);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(188),
    eq = __webpack_require__(118);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(185);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(763);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 310 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(764),
    isObjectLike = __webpack_require__(83);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 312 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(82),
    stubFalse = __webpack_require__(766);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)(module)))

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(768),
    baseUnary = __webpack_require__(769),
    nodeUtil = __webpack_require__(770);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 315 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  return key == '__proto__'
    ? undefined
    : object[key];
}

module.exports = safeGet;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(774),
    baseKeysIn = __webpack_require__(776),
    isArrayLike = __webpack_require__(189);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 317 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 318 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ColGroup__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TableHeader__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TableRow__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ExpandableRow__ = __webpack_require__(804);














var BaseTable = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BaseTable, _React$Component);

  function BaseTable() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, BaseTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = BaseTable.__proto__ || Object.getPrototypeOf(BaseTable)).call.apply(_ref, [this].concat(args))), _this), _this.handleRowHover = function (isHover, key) {
      _this.props.store.setState({
        currentHoverKey: isHover ? key : null
      });
    }, _this.renderRows = function (renderData, indent) {
      var rows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var ancestorKeys = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var table = _this.context.table;
      var columnManager = table.columnManager,
          components = table.components;
      var _table$props = table.props,
          prefixCls = _table$props.prefixCls,
          childrenColumnName = _table$props.childrenColumnName,
          rowClassName = _table$props.rowClassName,
          rowRef = _table$props.rowRef,
          onRowClick = _table$props.onRowClick,
          onRowDoubleClick = _table$props.onRowDoubleClick,
          onRowContextMenu = _table$props.onRowContextMenu,
          onRowMouseEnter = _table$props.onRowMouseEnter,
          onRowMouseLeave = _table$props.onRowMouseLeave,
          onRow = _table$props.onRow;
      var _this$props = _this.props,
          getRowKey = _this$props.getRowKey,
          fixed = _this$props.fixed,
          expander = _this$props.expander,
          isAnyColumnsFixed = _this$props.isAnyColumnsFixed;

      var _loop = function _loop(i) {
        var record = renderData[i];
        var key = getRowKey(record, i);
        var className = typeof rowClassName === 'string' ? rowClassName : rowClassName(record, i, indent);

        var onHoverProps = {};
        if (columnManager.isAnyColumnsFixed()) {
          onHoverProps.onHover = _this.handleRowHover;
        }

        var leafColumns = void 0;
        if (fixed === 'left') {
          leafColumns = columnManager.leftLeafColumns();
        } else if (fixed === 'right') {
          leafColumns = columnManager.rightLeafColumns();
        } else {
          leafColumns = _this.getColumns(columnManager.leafColumns());
        }

        var rowPrefixCls = prefixCls + '-row';
        var rowIndex = rows.filter(function (row) {
          return !row.props.expandedRow;
        }).length;

        var row = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__ExpandableRow__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, expander.props, {
            fixed: fixed,
            index: rowIndex,
            prefixCls: rowPrefixCls,
            record: record,
            key: key,
            rowKey: key,
            onRowClick: onRowClick,
            needIndentSpaced: expander.needIndentSpaced,
            onExpandedChange: expander.handleExpandChange
          }),
          function (expandableRow) {
            return (// eslint-disable-line
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__TableRow__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                fixed: fixed,
                indent: indent,
                className: className,
                record: record,
                index: rowIndex,
                prefixCls: rowPrefixCls,
                childrenColumnName: childrenColumnName,
                columns: leafColumns,
                onRow: onRow,
                onRowDoubleClick: onRowDoubleClick,
                onRowContextMenu: onRowContextMenu,
                onRowMouseEnter: onRowMouseEnter,
                onRowMouseLeave: onRowMouseLeave
              }, onHoverProps, {
                rowKey: key,
                ancestorKeys: ancestorKeys,
                ref: rowRef(record, i, indent),
                components: components,
                isAnyColumnsFixed: isAnyColumnsFixed
              }, expandableRow))
            );
          }
        );

        rows.push(row);

        expander.renderRows(_this.renderRows, rows, record, i, indent, fixed, key, ancestorKeys);
      };

      for (var i = 0; i < renderData.length; i++) {
        _loop(i);
      }
      return rows;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(BaseTable, [{
    key: 'getColumns',
    value: function getColumns(cols) {
      var _props = this.props,
          _props$columns = _props.columns,
          columns = _props$columns === undefined ? [] : _props$columns,
          fixed = _props.fixed;
      var table = this.context.table;
      var prefixCls = table.props.prefixCls;

      return (cols || columns).map(function (column) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, column, {
          className: !!column.fixed && !fixed ? __WEBPACK_IMPORTED_MODULE_8_classnames___default()(prefixCls + '-fixed-columns-in-body', column.className) : column.className
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var table = this.context.table;
      var components = table.components;
      var _table$props2 = table.props,
          prefixCls = _table$props2.prefixCls,
          scroll = _table$props2.scroll,
          data = _table$props2.data,
          getBodyWrapper = _table$props2.getBodyWrapper;
      var _props2 = this.props,
          expander = _props2.expander,
          tableClassName = _props2.tableClassName,
          hasHead = _props2.hasHead,
          hasBody = _props2.hasBody,
          fixed = _props2.fixed;

      var tableStyle = {};

      if (!fixed && scroll.x) {
        // not set width, then use content fixed width
        if (scroll.x === true) {
          tableStyle.tableLayout = 'fixed';
        } else {
          tableStyle.width = scroll.x;
        }
      }

      var Table = hasBody ? components.table : 'table';
      var BodyWrapper = components.body.wrapper;

      var body = void 0;
      if (hasBody) {
        body = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          BodyWrapper,
          { className: prefixCls + '-tbody' },
          this.renderRows(data, 0)
        );
        if (getBodyWrapper) {
          body = getBodyWrapper(body);
        }
      }

      var columns = this.getColumns();

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        Table,
        { className: tableClassName, style: tableStyle, key: 'table' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ColGroup__["a" /* default */], { columns: columns, fixed: fixed }),
        hasHead && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TableHeader__["a" /* default */], { expander: expander, columns: columns, fixed: fixed }),
        body
      );
    }
  }]);

  return BaseTable;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

BaseTable.propTypes = {
  fixed: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  columns: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array.isRequired,
  tableClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  hasHead: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired,
  hasBody: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired,
  store: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  expander: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  getRowKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  isAnyColumnsFixed: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
BaseTable.contextTypes = {
  table: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_mini_store__["connect"])()(BaseTable));

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mini_store__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_lifecycles_compat__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TableCell__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(95);














var TableRow = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TableRow, _React$Component);

  function TableRow(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TableRow);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props));

    _this.onRowClick = function (event) {
      var _this$props = _this.props,
          record = _this$props.record,
          index = _this$props.index,
          onRowClick = _this$props.onRowClick;

      if (onRowClick) {
        onRowClick(record, index, event);
      }
    };

    _this.onRowDoubleClick = function (event) {
      var _this$props2 = _this.props,
          record = _this$props2.record,
          index = _this$props2.index,
          onRowDoubleClick = _this$props2.onRowDoubleClick;

      if (onRowDoubleClick) {
        onRowDoubleClick(record, index, event);
      }
    };

    _this.onContextMenu = function (event) {
      var _this$props3 = _this.props,
          record = _this$props3.record,
          index = _this$props3.index,
          onRowContextMenu = _this$props3.onRowContextMenu;

      if (onRowContextMenu) {
        onRowContextMenu(record, index, event);
      }
    };

    _this.onMouseEnter = function (event) {
      var _this$props4 = _this.props,
          record = _this$props4.record,
          index = _this$props4.index,
          onRowMouseEnter = _this$props4.onRowMouseEnter,
          onHover = _this$props4.onHover,
          rowKey = _this$props4.rowKey;

      onHover(true, rowKey);
      if (onRowMouseEnter) {
        onRowMouseEnter(record, index, event);
      }
    };

    _this.onMouseLeave = function (event) {
      var _this$props5 = _this.props,
          record = _this$props5.record,
          index = _this$props5.index,
          onRowMouseLeave = _this$props5.onRowMouseLeave,
          onHover = _this$props5.onHover,
          rowKey = _this$props5.rowKey;

      onHover(false, rowKey);
      if (onRowMouseLeave) {
        onRowMouseLeave(record, index, event);
      }
    };

    _this.shouldRender = props.visible;

    _this.state = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TableRow, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.shouldRender) {
        this.saveRowRef();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !!(this.props.visible || nextProps.visible);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.state.shouldRender && !this.rowRef) {
        this.saveRowRef();
      }
    }
  }, {
    key: 'setExpanedRowHeight',
    value: function setExpanedRowHeight() {
      var _props = this.props,
          store = _props.store,
          rowKey = _props.rowKey;

      var _store$getState = store.getState(),
          expandedRowsHeight = _store$getState.expandedRowsHeight;

      var height = this.rowRef.getBoundingClientRect().height;
      expandedRowsHeight = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, expandedRowsHeight, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, rowKey, height));
      store.setState({ expandedRowsHeight: expandedRowsHeight });
    }
  }, {
    key: 'setRowHeight',
    value: function setRowHeight() {
      var _props2 = this.props,
          store = _props2.store,
          rowKey = _props2.rowKey;

      var _store$getState2 = store.getState(),
          fixedColumnsBodyRowsHeight = _store$getState2.fixedColumnsBodyRowsHeight;

      var height = this.rowRef.getBoundingClientRect().height;
      store.setState({
        fixedColumnsBodyRowsHeight: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, fixedColumnsBodyRowsHeight, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, rowKey, height))
      });
    }
  }, {
    key: 'getStyle',
    value: function getStyle() {
      var _props3 = this.props,
          height = _props3.height,
          visible = _props3.visible;


      if (height && height !== this.style.height) {
        this.style = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.style, { height: height });
      }

      if (!visible && !this.style.display) {
        this.style = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.style, { display: 'none' });
      }

      return this.style;
    }
  }, {
    key: 'saveRowRef',
    value: function saveRowRef() {
      this.rowRef = __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this);

      var _props4 = this.props,
          isAnyColumnsFixed = _props4.isAnyColumnsFixed,
          fixed = _props4.fixed,
          expandedRow = _props4.expandedRow,
          ancestorKeys = _props4.ancestorKeys;


      if (!isAnyColumnsFixed) {
        return;
      }

      if (!fixed && expandedRow) {
        this.setExpanedRowHeight();
      }

      if (!fixed && ancestorKeys.length >= 0) {
        this.setRowHeight();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state.shouldRender) {
        return null;
      }

      var _props5 = this.props,
          prefixCls = _props5.prefixCls,
          columns = _props5.columns,
          record = _props5.record,
          rowKey = _props5.rowKey,
          index = _props5.index,
          onRow = _props5.onRow,
          indent = _props5.indent,
          indentSize = _props5.indentSize,
          hovered = _props5.hovered,
          height = _props5.height,
          visible = _props5.visible,
          components = _props5.components,
          hasExpandIcon = _props5.hasExpandIcon,
          renderExpandIcon = _props5.renderExpandIcon,
          renderExpandIconCell = _props5.renderExpandIconCell;


      var BodyRow = components.body.row;
      var BodyCell = components.body.cell;

      var className = this.props.className;


      if (hovered) {
        className += ' ' + prefixCls + '-hover';
      }

      var cells = [];

      renderExpandIconCell(cells);

      for (var i = 0; i < columns.length; i++) {
        var column = columns[i];

        Object(__WEBPACK_IMPORTED_MODULE_12__utils__["d" /* warningOnce */])(column.onCellClick === undefined, 'column[onCellClick] is deprecated, please use column[onCell] instead.');

        cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__TableCell__["a" /* default */], {
          prefixCls: prefixCls,
          record: record,
          indentSize: indentSize,
          indent: indent,
          index: index,
          column: column,
          key: column.key || column.dataIndex,
          expandIcon: hasExpandIcon(i) && renderExpandIcon(),
          component: BodyCell
        }));
      }

      var rowClassName = (prefixCls + ' ' + className + ' ' + prefixCls + '-level-' + indent).trim();

      var rowProps = onRow(record, index);
      var customStyle = rowProps ? rowProps.style : {};
      var style = { height: height };

      if (!visible) {
        style.display = 'none';
      }

      style = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, style, customStyle);

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        BodyRow,
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          onClick: this.onRowClick,
          onDoubleClick: this.onRowDoubleClick,
          onMouseEnter: this.onMouseEnter,
          onMouseLeave: this.onMouseLeave,
          onContextMenu: this.onContextMenu,
          className: rowClassName
        }, rowProps, {
          style: style,
          'data-row-key': rowKey
        }),
        cells
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (prevState.visible || !prevState.visible && nextProps.visible) {
        return {
          shouldRender: true,
          visible: nextProps.visible
        };
      }
      return {
        visible: nextProps.visible
      };
    }
  }]);

  return TableRow;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

TableRow.propTypes = {
  onRow: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onRowClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onRowDoubleClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onRowContextMenu: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onRowMouseEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onRowMouseLeave: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  record: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  onHover: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  columns: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array,
  height: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  index: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  rowKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]).isRequired,
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  indent: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  indentSize: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  hasExpandIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  hovered: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool.isRequired,
  visible: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool.isRequired,
  store: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired,
  fixed: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool]),
  renderExpandIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  renderExpandIconCell: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  components: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  expandedRow: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  isAnyColumnsFixed: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  ancestorKeys: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array.isRequired
};
TableRow.defaultProps = {
  onRow: function onRow() {},
  onHover: function onHover() {},
  hasExpandIcon: function hasExpandIcon() {},
  renderExpandIcon: function renderExpandIcon() {},
  renderExpandIconCell: function renderExpandIconCell() {}
};


function getRowHeight(state, props) {
  var expandedRowsHeight = state.expandedRowsHeight,
      fixedColumnsBodyRowsHeight = state.fixedColumnsBodyRowsHeight;
  var fixed = props.fixed,
      rowKey = props.rowKey;


  if (!fixed) {
    return null;
  }

  if (expandedRowsHeight[rowKey]) {
    return expandedRowsHeight[rowKey];
  }

  if (fixedColumnsBodyRowsHeight[rowKey]) {
    return fixedColumnsBodyRowsHeight[rowKey];
  }

  return null;
}

Object(__WEBPACK_IMPORTED_MODULE_10_react_lifecycles_compat__["polyfill"])(TableRow);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_mini_store__["connect"])(function (state, props) {
  var currentHoverKey = state.currentHoverKey,
      expandedRowKeys = state.expandedRowKeys;
  var rowKey = props.rowKey,
      ancestorKeys = props.ancestorKeys;

  var visible = ancestorKeys.length === 0 || ancestorKeys.every(function (k) {
    return ~expandedRowKeys.indexOf(k);
  });

  return {
    visible: visible,
    hovered: currentHoverKey === rowKey,
    height: getRowHeight(state, props)
  };
})(TableRow));

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ZERO: 48,
  NINE: 57,

  NUMPAD_ZERO: 96,
  NUMPAD_NINE: 105,

  BACKSPACE: 8,
  DELETE: 46,
  ENTER: 13,

  ARROW_UP: 38,
  ARROW_DOWN: 40
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArray(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (c) {
    ret.push(c);
  });
  return ret;
}

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Option = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Option, _React$Component);

  function Option() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Option);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number])
};
Option.isSelectOption = true;
/* harmony default export */ __webpack_exports__["a"] = (Option);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectPropTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function valueType(props, propName, componentName) {
  var basicType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number]);

  var labelInValueShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    key: basicType.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node
  });
  if (props.labelInValue) {
    var validate = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(labelInValueShape), labelInValueShape]);
    var error = validate.apply(undefined, arguments);
    if (error) {
      return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`, ' + ('when you set `labelInValue` to `true`, `' + propName + '` should in ') + 'shape of `{ key: string | number, label?: ReactNode }`.');
    }
  } else if ((props.mode === 'multiple' || props.mode === 'tags' || props.multiple || props.tags) && props[propName] === '') {
    return new Error('Invalid prop `' + propName + '` of type `string` supplied to `' + componentName + '`, ' + 'expected `array` when `multiple` or `tags` is `true`.');
  } else {
    var _validate = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(basicType), basicType]);
    return _validate.apply(undefined, arguments);
  }
}

var SelectPropTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  defaultActiveFirstOption: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  filterOption: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
  showSearch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  allowClear: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  showArrow: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  tags: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  prefixCls: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  optionLabelProp: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  optionFilterProp: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  animation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  choiceTransitionName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onSearch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPopupScroll: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onInputKeyDown: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  placeholder: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
  onDeselect: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  labelInValue: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  value: valueType,
  defaultValue: valueType,
  dropdownStyle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  maxTagTextLength: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  maxTagCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  maxTagPlaceholder: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
  tokenSeparators: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string),
  getInputElement: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  showAction: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string)
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _rcDropdown = __webpack_require__(826);

var _rcDropdown2 = _interopRequireDefault(_rcDropdown);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(48);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Dropdown = function (_React$Component) {
    (0, _inherits3['default'])(Dropdown, _React$Component);

    function Dropdown() {
        (0, _classCallCheck3['default'])(this, Dropdown);
        return (0, _possibleConstructorReturn3['default'])(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Dropdown, [{
        key: 'getTransitionName',
        value: function getTransitionName() {
            var _props = this.props,
                _props$placement = _props.placement,
                placement = _props$placement === undefined ? '' : _props$placement,
                transitionName = _props.transitionName;

            if (transitionName !== undefined) {
                return transitionName;
            }
            if (placement.indexOf('top') >= 0) {
                return 'slide-down';
            }
            return 'slide-up';
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var overlay = this.props.overlay;

            if (overlay) {
                var overlayProps = overlay.props;
                (0, _warning2['default'])(!overlayProps.mode || overlayProps.mode === 'vertical', 'mode="' + overlayProps.mode + '" is not supported for Dropdown\'s Menu.');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                children = _props2.children,
                prefixCls = _props2.prefixCls,
                overlayElements = _props2.overlay,
                trigger = _props2.trigger,
                disabled = _props2.disabled;

            var child = React.Children.only(children);
            var overlay = React.Children.only(overlayElements);
            var dropdownTrigger = React.cloneElement(child, {
                className: (0, _classnames2['default'])(child.props.className, prefixCls + '-trigger'),
                disabled: disabled
            });
            // menu cannot be selectable in dropdown defaultly
            // menu should be focusable in dropdown defaultly
            var _overlay$props = overlay.props,
                _overlay$props$select = _overlay$props.selectable,
                selectable = _overlay$props$select === undefined ? false : _overlay$props$select,
                _overlay$props$focusa = _overlay$props.focusable,
                focusable = _overlay$props$focusa === undefined ? true : _overlay$props$focusa;

            var fixedModeOverlay = typeof overlay.type === 'string' ? overlay : React.cloneElement(overlay, {
                mode: 'vertical',
                selectable: selectable,
                focusable: focusable
            });
            var triggerActions = disabled ? [] : trigger;
            var alignPoint = void 0;
            if (triggerActions && triggerActions.indexOf('contextMenu') !== -1) {
                alignPoint = true;
            }
            return React.createElement(
                _rcDropdown2['default'],
                (0, _extends3['default'])({ alignPoint: alignPoint }, this.props, { transitionName: this.getTransitionName(), trigger: triggerActions, overlay: fixedModeOverlay }),
                dropdownTrigger
            );
        }
    }]);
    return Dropdown;
}(React.Component);

exports['default'] = Dropdown;

Dropdown.defaultProps = {
    prefixCls: 'ant-dropdown',
    mouseEnterDelay: 0.15,
    mouseLeaveDelay: 0.1,
    placement: 'bottomLeft'
};
module.exports = exports['default'];

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _rcCheckbox = __webpack_require__(327);

var _rcCheckbox2 = _interopRequireDefault(_rcCheckbox);

var _shallowequal = __webpack_require__(52);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Checkbox = function (_React$Component) {
    (0, _inherits3['default'])(Checkbox, _React$Component);

    function Checkbox() {
        (0, _classCallCheck3['default'])(this, Checkbox);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));

        _this.saveCheckbox = function (node) {
            _this.rcCheckbox = node;
        };
        return _this;
    }

    (0, _createClass3['default'])(Checkbox, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
            return !(0, _shallowequal2['default'])(this.props, nextProps) || !(0, _shallowequal2['default'])(this.state, nextState) || !(0, _shallowequal2['default'])(this.context.checkboxGroup, nextContext.checkboxGroup);
        }
    }, {
        key: 'focus',
        value: function focus() {
            this.rcCheckbox.focus();
        }
    }, {
        key: 'blur',
        value: function blur() {
            this.rcCheckbox.blur();
        }
    }, {
        key: 'render',
        value: function render() {
            var props = this.props,
                context = this.context;

            var prefixCls = props.prefixCls,
                className = props.className,
                children = props.children,
                indeterminate = props.indeterminate,
                style = props.style,
                onMouseEnter = props.onMouseEnter,
                onMouseLeave = props.onMouseLeave,
                restProps = __rest(props, ["prefixCls", "className", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave"]);

            var checkboxGroup = context.checkboxGroup;

            var checkboxProps = (0, _extends3['default'])({}, restProps);
            if (checkboxGroup) {
                checkboxProps.onChange = function () {
                    return checkboxGroup.toggleOption({ label: children, value: props.value });
                };
                checkboxProps.checked = checkboxGroup.value.indexOf(props.value) !== -1;
                checkboxProps.disabled = props.disabled || checkboxGroup.disabled;
            }
            var classString = (0, _classnames2['default'])(className, (0, _defineProperty3['default'])({}, prefixCls + '-wrapper', true));
            var checkboxClass = (0, _classnames2['default'])((0, _defineProperty3['default'])({}, prefixCls + '-indeterminate', indeterminate));
            return React.createElement(
                'label',
                { className: classString, style: style, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
                React.createElement(_rcCheckbox2['default'], (0, _extends3['default'])({}, checkboxProps, { prefixCls: prefixCls, className: checkboxClass, ref: this.saveCheckbox })),
                children !== undefined ? React.createElement(
                    'span',
                    null,
                    children
                ) : null
            );
        }
    }]);
    return Checkbox;
}(React.Component);

exports['default'] = Checkbox;

Checkbox.defaultProps = {
    prefixCls: 'ant-checkbox',
    indeterminate: false
};
Checkbox.contextTypes = {
    checkboxGroup: _propTypes2['default'].any
};
module.exports = exports['default'];

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Checkbox__ = __webpack_require__(830);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Checkbox__["a" /* default */]);

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(848);

__webpack_require__(22);

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _Modal = __webpack_require__(330);

var _Modal2 = _interopRequireDefault(_Modal);

var _confirm = __webpack_require__(853);

var _confirm2 = _interopRequireDefault(_confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Modal2['default'].info = function (props) {
    var config = (0, _extends3['default'])({ type: 'info', iconType: 'info-circle', okCancel: false }, props);
    return (0, _confirm2['default'])(config);
};
_Modal2['default'].success = function (props) {
    var config = (0, _extends3['default'])({ type: 'success', iconType: 'check-circle', okCancel: false }, props);
    return (0, _confirm2['default'])(config);
};
_Modal2['default'].error = function (props) {
    var config = (0, _extends3['default'])({ type: 'error', iconType: 'cross-circle', okCancel: false }, props);
    return (0, _confirm2['default'])(config);
};
_Modal2['default'].warning = _Modal2['default'].warn = function (props) {
    var config = (0, _extends3['default'])({ type: 'warning', iconType: 'exclamation-circle', okCancel: false }, props);
    return (0, _confirm2['default'])(config);
};
_Modal2['default'].confirm = function (props) {
    var config = (0, _extends3['default'])({ type: 'confirm', okCancel: true }, props);
    return (0, _confirm2['default'])(config);
};
exports['default'] = _Modal2['default'];
module.exports = exports['default'];

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _rcDialog = __webpack_require__(849);

var _rcDialog2 = _interopRequireDefault(_rcDialog);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _addEventListener = __webpack_require__(181);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _button = __webpack_require__(21);

var _button2 = _interopRequireDefault(_button);

var _LocaleReceiver = __webpack_require__(71);

var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);

var _locale = __webpack_require__(148);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var mousePosition = void 0;
var mousePositionEventBinded = void 0;

var Modal = function (_React$Component) {
    (0, _inherits3['default'])(Modal, _React$Component);

    function Modal() {
        (0, _classCallCheck3['default'])(this, Modal);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));

        _this.handleCancel = function (e) {
            var onCancel = _this.props.onCancel;
            if (onCancel) {
                onCancel(e);
            }
        };
        _this.handleOk = function (e) {
            var onOk = _this.props.onOk;
            if (onOk) {
                onOk(e);
            }
        };
        _this.renderFooter = function (locale) {
            var _this$props = _this.props,
                okText = _this$props.okText,
                okType = _this$props.okType,
                cancelText = _this$props.cancelText,
                confirmLoading = _this$props.confirmLoading;

            return React.createElement(
                'div',
                null,
                React.createElement(
                    _button2['default'],
                    (0, _extends3['default'])({ onClick: _this.handleCancel }, _this.props.cancelButtonProps),
                    cancelText || locale.cancelText
                ),
                React.createElement(
                    _button2['default'],
                    (0, _extends3['default'])({ type: okType, loading: confirmLoading, onClick: _this.handleOk }, _this.props.okButtonProps),
                    okText || locale.okText
                )
            );
        };
        return _this;
    }

    (0, _createClass3['default'])(Modal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (mousePositionEventBinded) {
                return;
            }
            // 只有点击事件支持从鼠标位置动画展开
            (0, _addEventListener2['default'])(document.documentElement, 'click', function (e) {
                mousePosition = {
                    x: e.pageX,
                    y: e.pageY
                };
                // 100ms 内发生过点击事件，则从点击位置动画展示
                // 否则直接 zoom 展示
                // 这样可以兼容非点击方式展开
                setTimeout(function () {
                    return mousePosition = null;
                }, 100);
            });
            mousePositionEventBinded = true;
        }
    }, {
        key: 'render',
        value: function render() {
            var _a = this.props,
                footer = _a.footer,
                visible = _a.visible,
                wrapClassName = _a.wrapClassName,
                centered = _a.centered,
                prefixCls = _a.prefixCls,
                restProps = __rest(_a, ["footer", "visible", "wrapClassName", "centered", "prefixCls"]);
            var defaultFooter = React.createElement(
                _LocaleReceiver2['default'],
                { componentName: 'Modal', defaultLocale: (0, _locale.getConfirmLocale)() },
                this.renderFooter
            );
            return React.createElement(_rcDialog2['default'], (0, _extends3['default'])({}, restProps, { prefixCls: prefixCls, wrapClassName: (0, _classnames2['default'])((0, _defineProperty3['default'])({}, prefixCls + '-centered', !!centered), wrapClassName), footer: footer === undefined ? defaultFooter : footer, visible: visible, mousePosition: mousePosition, onClose: this.handleCancel }));
        }
    }]);
    return Modal;
}(React.Component);

exports['default'] = Modal;

Modal.defaultProps = {
    prefixCls: 'ant-modal',
    width: 520,
    transitionName: 'zoom',
    maskTransitionName: 'fade',
    confirmLoading: false,
    visible: false,
    okType: 'primary',
    okButtonDisabled: false,
    cancelButtonDisabled: false
};
Modal.propTypes = {
    prefixCls: _propTypes2['default'].string,
    onOk: _propTypes2['default'].func,
    onCancel: _propTypes2['default'].func,
    okText: _propTypes2['default'].node,
    cancelText: _propTypes2['default'].node,
    centered: _propTypes2['default'].bool,
    width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
    confirmLoading: _propTypes2['default'].bool,
    visible: _propTypes2['default'].bool,
    align: _propTypes2['default'].object,
    footer: _propTypes2['default'].node,
    title: _propTypes2['default'].node,
    closable: _propTypes2['default'].bool
};
module.exports = exports['default'];

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Calendar__ = __webpack_require__(863);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Calendar__["a" /* default */]);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapSelf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function mirror(o) {
  return o;
}

function mapSelf(children) {
  // return ReactFragment
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, mirror);
}

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(36);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _KeyCode = __webpack_require__(195);

var _KeyCode2 = _interopRequireDefault(_KeyCode);

var _CalendarHeader = __webpack_require__(335);

var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);

var _CalendarFooter = __webpack_require__(885);

var _CalendarFooter2 = _interopRequireDefault(_CalendarFooter);

var _CalendarMixin = __webpack_require__(886);

var _CalendarMixin2 = _interopRequireDefault(_CalendarMixin);

var _CommonMixin = __webpack_require__(340);

var _CommonMixin2 = _interopRequireDefault(_CommonMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MonthCalendar = (0, _createReactClass2['default'])({
  displayName: 'MonthCalendar',

  propTypes: {
    monthCellRender: _propTypes2['default'].func,
    dateCellRender: _propTypes2['default'].func
  },
  mixins: [_CommonMixin2['default'], _CalendarMixin2['default']],

  getInitialState: function getInitialState() {
    return { mode: 'month' };
  },
  onKeyDown: function onKeyDown(event) {
    var keyCode = event.keyCode;
    var ctrlKey = event.ctrlKey || event.metaKey;
    var stateValue = this.state.value;
    var disabledDate = this.props.disabledDate;

    var value = stateValue;
    switch (keyCode) {
      case _KeyCode2['default'].DOWN:
        value = stateValue.clone();
        value.add(3, 'months');
        break;
      case _KeyCode2['default'].UP:
        value = stateValue.clone();
        value.add(-3, 'months');
        break;
      case _KeyCode2['default'].LEFT:
        value = stateValue.clone();
        if (ctrlKey) {
          value.add(-1, 'years');
        } else {
          value.add(-1, 'months');
        }
        break;
      case _KeyCode2['default'].RIGHT:
        value = stateValue.clone();
        if (ctrlKey) {
          value.add(1, 'years');
        } else {
          value.add(1, 'months');
        }
        break;
      case _KeyCode2['default'].ENTER:
        if (!disabledDate || !disabledDate(stateValue)) {
          this.onSelect(stateValue);
        }
        event.preventDefault();
        return 1;
      default:
        return undefined;
    }
    if (value !== stateValue) {
      this.setValue(value);
      event.preventDefault();
      return 1;
    }
  },
  handlePanelChange: function handlePanelChange(_, mode) {
    if (mode !== 'date') {
      this.setState({ mode: mode });
    }
  },
  render: function render() {
    var props = this.props,
        state = this.state;
    var mode = state.mode,
        value = state.value;

    var children = _react2['default'].createElement(
      'div',
      { className: props.prefixCls + '-month-calendar-content' },
      _react2['default'].createElement(
        'div',
        { className: props.prefixCls + '-month-header-wrap' },
        _react2['default'].createElement(_CalendarHeader2['default'], {
          prefixCls: props.prefixCls,
          mode: mode,
          value: value,
          locale: props.locale,
          disabledMonth: props.disabledDate,
          monthCellRender: props.monthCellRender,
          monthCellContentRender: props.monthCellContentRender,
          onMonthSelect: this.onSelect,
          onValueChange: this.setValue,
          onPanelChange: this.handlePanelChange
        })
      ),
      _react2['default'].createElement(_CalendarFooter2['default'], {
        prefixCls: props.prefixCls,
        renderFooter: props.renderFooter
      })
    );
    return this.renderRoot({
      className: props.prefixCls + '-month-calendar',
      children: children
    });
  }
});

exports['default'] = MonthCalendar;
module.exports = exports['default'];

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(36);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mapSelf = __webpack_require__(336);

var _mapSelf2 = _interopRequireDefault(_mapSelf);

var _MonthPanel = __webpack_require__(881);

var _MonthPanel2 = _interopRequireDefault(_MonthPanel);

var _YearPanel = __webpack_require__(883);

var _YearPanel2 = _interopRequireDefault(_YearPanel);

var _DecadePanel = __webpack_require__(884);

var _DecadePanel2 = _interopRequireDefault(_DecadePanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function goMonth(direction) {
  var next = this.props.value.clone();
  next.add(direction, 'months');
  this.props.onValueChange(next);
}

function goYear(direction) {
  var next = this.props.value.clone();
  next.add(direction, 'years');
  this.props.onValueChange(next);
}

function showIf(condition, el) {
  return condition ? el : null;
}

var CalendarHeader = (0, _createReactClass2['default'])({
  displayName: 'CalendarHeader',

  propTypes: {
    prefixCls: _propTypes2['default'].string,
    value: _propTypes2['default'].object,
    onValueChange: _propTypes2['default'].func,
    showTimePicker: _propTypes2['default'].bool,
    onPanelChange: _propTypes2['default'].func,
    locale: _propTypes2['default'].object,
    enablePrev: _propTypes2['default'].any,
    enableNext: _propTypes2['default'].any,
    disabledMonth: _propTypes2['default'].func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      enableNext: 1,
      enablePrev: 1,
      onPanelChange: function onPanelChange() {},
      onValueChange: function onValueChange() {}
    };
  },
  getInitialState: function getInitialState() {
    this.nextMonth = goMonth.bind(this, 1);
    this.previousMonth = goMonth.bind(this, -1);
    this.nextYear = goYear.bind(this, 1);
    this.previousYear = goYear.bind(this, -1);
    return { yearPanelReferer: null };
  },
  onMonthSelect: function onMonthSelect(value) {
    this.props.onPanelChange(value, 'date');
    if (this.props.onMonthSelect) {
      this.props.onMonthSelect(value);
    } else {
      this.props.onValueChange(value);
    }
  },
  onYearSelect: function onYearSelect(value) {
    var referer = this.state.yearPanelReferer;
    this.setState({ yearPanelReferer: null });
    this.props.onPanelChange(value, referer);
    this.props.onValueChange(value);
  },
  onDecadeSelect: function onDecadeSelect(value) {
    this.props.onPanelChange(value, 'year');
    this.props.onValueChange(value);
  },
  monthYearElement: function monthYearElement(showTimePicker) {
    var _this = this;

    var props = this.props;
    var prefixCls = props.prefixCls;
    var locale = props.locale;
    var value = props.value;
    var localeData = value.localeData();
    var monthBeforeYear = locale.monthBeforeYear;
    var selectClassName = prefixCls + '-' + (monthBeforeYear ? 'my-select' : 'ym-select');
    var year = _react2['default'].createElement(
      'a',
      {
        className: prefixCls + '-year-select',
        role: 'button',
        onClick: showTimePicker ? null : function () {
          return _this.showYearPanel('date');
        },
        title: locale.yearSelect
      },
      value.format(locale.yearFormat)
    );
    var month = _react2['default'].createElement(
      'a',
      {
        className: prefixCls + '-month-select',
        role: 'button',
        onClick: showTimePicker ? null : this.showMonthPanel,
        title: locale.monthSelect
      },
      locale.monthFormat ? value.format(locale.monthFormat) : localeData.monthsShort(value)
    );
    var day = void 0;
    if (showTimePicker) {
      day = _react2['default'].createElement(
        'a',
        {
          className: prefixCls + '-day-select',
          role: 'button'
        },
        value.format(locale.dayFormat)
      );
    }
    var my = [];
    if (monthBeforeYear) {
      my = [month, day, year];
    } else {
      my = [year, month, day];
    }
    return _react2['default'].createElement(
      'span',
      { className: selectClassName },
      (0, _mapSelf2['default'])(my)
    );
  },
  showMonthPanel: function showMonthPanel() {
    // null means that users' interaction doesn't change value
    this.props.onPanelChange(null, 'month');
  },
  showYearPanel: function showYearPanel(referer) {
    this.setState({ yearPanelReferer: referer });
    this.props.onPanelChange(null, 'year');
  },
  showDecadePanel: function showDecadePanel() {
    this.props.onPanelChange(null, 'decade');
  },
  render: function render() {
    var _this2 = this;

    var props = this.props;
    var prefixCls = props.prefixCls,
        locale = props.locale,
        mode = props.mode,
        value = props.value,
        showTimePicker = props.showTimePicker,
        enableNext = props.enableNext,
        enablePrev = props.enablePrev,
        disabledMonth = props.disabledMonth;


    var panel = null;
    if (mode === 'month') {
      panel = _react2['default'].createElement(_MonthPanel2['default'], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onMonthSelect,
        onYearPanelShow: function onYearPanelShow() {
          return _this2.showYearPanel('month');
        },
        disabledDate: disabledMonth,
        cellRender: props.monthCellRender,
        contentRender: props.monthCellContentRender
      });
    }
    if (mode === 'year') {
      panel = _react2['default'].createElement(_YearPanel2['default'], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onYearSelect,
        onDecadePanelShow: this.showDecadePanel
      });
    }
    if (mode === 'decade') {
      panel = _react2['default'].createElement(_DecadePanel2['default'], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onDecadeSelect
      });
    }

    return _react2['default'].createElement(
      'div',
      { className: prefixCls + '-header' },
      _react2['default'].createElement(
        'div',
        { style: { position: 'relative' } },
        showIf(enablePrev && !showTimePicker, _react2['default'].createElement('a', {
          className: prefixCls + '-prev-year-btn',
          role: 'button',
          onClick: this.previousYear,
          title: locale.previousYear
        })),
        showIf(enablePrev && !showTimePicker, _react2['default'].createElement('a', {
          className: prefixCls + '-prev-month-btn',
          role: 'button',
          onClick: this.previousMonth,
          title: locale.previousMonth
        })),
        this.monthYearElement(showTimePicker),
        showIf(enableNext && !showTimePicker, _react2['default'].createElement('a', {
          className: prefixCls + '-next-month-btn',
          onClick: this.nextMonth,
          title: locale.nextMonth
        })),
        showIf(enableNext && !showTimePicker, _react2['default'].createElement('a', {
          className: prefixCls + '-next-year-btn',
          onClick: this.nextYear,
          title: locale.nextYear
        }))
      ),
      panel
    );
  }
});

exports['default'] = CalendarHeader;
module.exports = exports['default'];

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = mapSelf;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function mirror(o) {
  return o;
}

function mapSelf(children) {
  // return ReactFragment
  return _react2['default'].Children.map(children, mirror);
}
module.exports = exports['default'];

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = TodayButton;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _util = __webpack_require__(84);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function TodayButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      value = _ref.value,
      timePicker = _ref.timePicker,
      disabled = _ref.disabled,
      disabledDate = _ref.disabledDate,
      onToday = _ref.onToday,
      text = _ref.text;

  var localeNow = (!text && timePicker ? locale.now : text) || locale.today;
  var disabledToday = disabledDate && !(0, _util.isAllowedDate)((0, _util.getTodayTime)(value), disabledDate);
  var isDisabled = disabledToday || disabled;
  var disabledTodayClass = isDisabled ? prefixCls + '-today-btn-disabled' : '';
  return _react2['default'].createElement(
    'a',
    {
      className: prefixCls + '-today-btn ' + disabledTodayClass,
      role: 'button',
      onClick: isDisabled ? null : onToday,
      title: (0, _util.getTodayTimeStr)(value)
    },
    localeNow
  );
}
module.exports = exports['default'];

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = OkButton;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function OkButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      okDisabled = _ref.okDisabled,
      onOk = _ref.onOk;

  var className = prefixCls + "-ok-btn";
  if (okDisabled) {
    className += " " + prefixCls + "-ok-btn-disabled";
  }
  return _react2["default"].createElement(
    "a",
    {
      className: className,
      role: "button",
      onClick: okDisabled ? null : onOk
    },
    locale.ok
  );
}
module.exports = exports['default'];

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = TimePickerButton;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(11);

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function TimePickerButton(_ref) {
  var _classnames;

  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      showTimePicker = _ref.showTimePicker,
      onOpenTimePicker = _ref.onOpenTimePicker,
      onCloseTimePicker = _ref.onCloseTimePicker,
      timePickerDisabled = _ref.timePickerDisabled;

  var className = (0, _classnames3['default'])((_classnames = {}, _classnames[prefixCls + '-time-picker-btn'] = true, _classnames[prefixCls + '-time-picker-btn-disabled'] = timePickerDisabled, _classnames));
  var onClick = null;
  if (!timePickerDisabled) {
    onClick = showTimePicker ? onCloseTimePicker : onOpenTimePicker;
  }
  return _react2['default'].createElement(
    'a',
    {
      className: className,
      role: 'button',
      onClick: onClick
    },
    showTimePicker ? locale.dateSelect : locale.timeSelect
  );
}
module.exports = exports['default'];

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _en_US = __webpack_require__(237);

var _en_US2 = _interopRequireDefault(_en_US);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

exports['default'] = {
  propTypes: {
    className: _propTypes2['default'].string,
    locale: _propTypes2['default'].object,
    style: _propTypes2['default'].object,
    visible: _propTypes2['default'].bool,
    onSelect: _propTypes2['default'].func,
    prefixCls: _propTypes2['default'].string,
    onChange: _propTypes2['default'].func,
    onOk: _propTypes2['default'].func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      locale: _en_US2['default'],
      style: {},
      visible: true,
      prefixCls: 'rc-calendar',
      className: '',
      onSelect: noop,
      onChange: noop,
      onClear: noop,
      renderFooter: function renderFooter() {
        return null;
      },
      renderSidebar: function renderSidebar() {
        return null;
      }
    };
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
    return this.props.visible || nextProps.visible;
  },
  getFormat: function getFormat() {
    var format = this.props.format;
    var _props = this.props,
        locale = _props.locale,
        timePicker = _props.timePicker;

    if (!format) {
      if (timePicker) {
        format = locale.dateTimeFormat;
      } else {
        format = locale.dateFormat;
      }
    }
    return format;
  },
  focus: function focus() {
    if (this.rootInstance) {
      this.rootInstance.focus();
    }
  },
  saveRoot: function saveRoot(root) {
    this.rootInstance = root;
  }
};
module.exports = exports['default'];

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Header = __webpack_require__(892);

var _Header2 = _interopRequireDefault(_Header);

var _Combobox = __webpack_require__(893);

var _Combobox2 = _interopRequireDefault(_Combobox);

var _moment = __webpack_require__(31);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

function generateOptions(length, disabledOptions, hideDisabledOptions) {
  var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  var arr = [];
  for (var value = 0; value < length; value += step) {
    if (!disabledOptions || disabledOptions.indexOf(value) < 0 || !hideDisabledOptions) {
      arr.push(value);
    }
  }
  return arr;
}

var Panel = function (_Component) {
  (0, _inherits3['default'])(Panel, _Component);

  function Panel(props) {
    (0, _classCallCheck3['default'])(this, Panel);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).call(this, props));

    _this.onChange = function (newValue) {
      _this.setState({ value: newValue });
      _this.props.onChange(newValue);
    };

    _this.onCurrentSelectPanelChange = function (currentSelectPanel) {
      _this.setState({ currentSelectPanel: currentSelectPanel });
    };

    _this.disabledHours = function () {
      var _this$props = _this.props,
          use12Hours = _this$props.use12Hours,
          disabledHours = _this$props.disabledHours;

      var disabledOptions = disabledHours();
      if (use12Hours && Array.isArray(disabledOptions)) {
        if (_this.isAM()) {
          disabledOptions = disabledOptions.filter(function (h) {
            return h < 12;
          }).map(function (h) {
            return h === 0 ? 12 : h;
          });
        } else {
          disabledOptions = disabledOptions.map(function (h) {
            return h === 12 ? 12 : h - 12;
          });
        }
      }
      return disabledOptions;
    };

    _this.state = {
      value: props.value,
      selectionRange: []
    };
    return _this;
  }

  (0, _createClass3['default'])(Panel, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value;
      if (value) {
        this.setState({
          value: value
        });
      }
    }
  }, {
    key: 'close',


    // https://github.com/ant-design/ant-design/issues/5829
    value: function close() {
      this.props.onEsc();
    }
  }, {
    key: 'isAM',
    value: function isAM() {
      var value = this.state.value || this.props.defaultOpenValue;
      return value.hour() >= 0 && value.hour() < 12;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          className = _props.className,
          placeholder = _props.placeholder,
          disabledMinutes = _props.disabledMinutes,
          disabledSeconds = _props.disabledSeconds,
          hideDisabledOptions = _props.hideDisabledOptions,
          allowEmpty = _props.allowEmpty,
          showHour = _props.showHour,
          showMinute = _props.showMinute,
          showSecond = _props.showSecond,
          format = _props.format,
          defaultOpenValue = _props.defaultOpenValue,
          clearText = _props.clearText,
          onEsc = _props.onEsc,
          addon = _props.addon,
          use12Hours = _props.use12Hours,
          onClear = _props.onClear,
          focusOnOpen = _props.focusOnOpen,
          onKeyDown = _props.onKeyDown,
          hourStep = _props.hourStep,
          minuteStep = _props.minuteStep,
          secondStep = _props.secondStep,
          inputReadOnly = _props.inputReadOnly;
      var _state = this.state,
          value = _state.value,
          currentSelectPanel = _state.currentSelectPanel;

      var disabledHourOptions = this.disabledHours();
      var disabledMinuteOptions = disabledMinutes(value ? value.hour() : null);
      var disabledSecondOptions = disabledSeconds(value ? value.hour() : null, value ? value.minute() : null);
      var hourOptions = generateOptions(24, disabledHourOptions, hideDisabledOptions, hourStep);
      var minuteOptions = generateOptions(60, disabledMinuteOptions, hideDisabledOptions, minuteStep);
      var secondOptions = generateOptions(60, disabledSecondOptions, hideDisabledOptions, secondStep);

      return _react2['default'].createElement(
        'div',
        { className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-inner', true), (0, _defineProperty3['default'])(_classNames, className, !!className), _classNames)) },
        _react2['default'].createElement(_Header2['default'], {
          clearText: clearText,
          prefixCls: prefixCls,
          defaultOpenValue: defaultOpenValue,
          value: value,
          currentSelectPanel: currentSelectPanel,
          onEsc: onEsc,
          format: format,
          placeholder: placeholder,
          hourOptions: hourOptions,
          minuteOptions: minuteOptions,
          secondOptions: secondOptions,
          disabledHours: this.disabledHours,
          disabledMinutes: disabledMinutes,
          disabledSeconds: disabledSeconds,
          onChange: this.onChange,
          onClear: onClear,
          allowEmpty: allowEmpty,
          focusOnOpen: focusOnOpen,
          onKeyDown: onKeyDown,
          inputReadOnly: inputReadOnly
        }),
        _react2['default'].createElement(_Combobox2['default'], {
          prefixCls: prefixCls,
          value: value,
          defaultOpenValue: defaultOpenValue,
          format: format,
          onChange: this.onChange,
          showHour: showHour,
          showMinute: showMinute,
          showSecond: showSecond,
          hourOptions: hourOptions,
          minuteOptions: minuteOptions,
          secondOptions: secondOptions,
          disabledHours: this.disabledHours,
          disabledMinutes: disabledMinutes,
          disabledSeconds: disabledSeconds,
          onCurrentSelectPanelChange: this.onCurrentSelectPanelChange,
          use12Hours: use12Hours,
          isAM: this.isAM()
        }),
        addon(this)
      );
    }
  }]);
  return Panel;
}(_react.Component);

Panel.propTypes = {
  clearText: _propTypes2['default'].string,
  prefixCls: _propTypes2['default'].string,
  className: _propTypes2['default'].string,
  defaultOpenValue: _propTypes2['default'].object,
  value: _propTypes2['default'].object,
  placeholder: _propTypes2['default'].string,
  format: _propTypes2['default'].string,
  inputReadOnly: _propTypes2['default'].bool,
  disabledHours: _propTypes2['default'].func,
  disabledMinutes: _propTypes2['default'].func,
  disabledSeconds: _propTypes2['default'].func,
  hideDisabledOptions: _propTypes2['default'].bool,
  onChange: _propTypes2['default'].func,
  onEsc: _propTypes2['default'].func,
  allowEmpty: _propTypes2['default'].bool,
  showHour: _propTypes2['default'].bool,
  showMinute: _propTypes2['default'].bool,
  showSecond: _propTypes2['default'].bool,
  onClear: _propTypes2['default'].func,
  use12Hours: _propTypes2['default'].bool,
  hourStep: _propTypes2['default'].number,
  minuteStep: _propTypes2['default'].number,
  secondStep: _propTypes2['default'].number,
  addon: _propTypes2['default'].func,
  focusOnOpen: _propTypes2['default'].bool,
  onKeyDown: _propTypes2['default'].func
};
Panel.defaultProps = {
  prefixCls: 'rc-time-picker-panel',
  onChange: noop,
  onClear: noop,
  disabledHours: noop,
  disabledMinutes: noop,
  disabledSeconds: noop,
  defaultOpenValue: (0, _moment2['default'])(),
  use12Hours: false,
  addon: noop,
  onKeyDown: noop,
  inputReadOnly: false
};
exports['default'] = Panel;
module.exports = exports['default'];

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7
};
module.exports = exports['default'];

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _rcUpload = __webpack_require__(926);

var _rcUpload2 = _interopRequireDefault(_rcUpload);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _uniqBy = __webpack_require__(934);

var _uniqBy2 = _interopRequireDefault(_uniqBy);

var _LocaleReceiver = __webpack_require__(71);

var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);

var _default = __webpack_require__(107);

var _default2 = _interopRequireDefault(_default);

var _UploadList = __webpack_require__(1021);

var _UploadList2 = _interopRequireDefault(_UploadList);

var _utils = __webpack_require__(1026);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Upload = function (_React$Component) {
    (0, _inherits3['default'])(Upload, _React$Component);

    function Upload(props) {
        (0, _classCallCheck3['default'])(this, Upload);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Upload.__proto__ || Object.getPrototypeOf(Upload)).call(this, props));

        _this.onStart = function (file) {
            var targetItem = void 0;
            var nextFileList = _this.state.fileList.concat();
            targetItem = (0, _utils.fileToObject)(file);
            targetItem.status = 'uploading';
            nextFileList.push(targetItem);
            _this.onChange({
                file: targetItem,
                fileList: nextFileList
            });
            // fix ie progress
            if (!window.FormData) {
                _this.autoUpdateProgress(0, targetItem);
            }
        };
        _this.onSuccess = function (response, file) {
            _this.clearProgressTimer();
            try {
                if (typeof response === 'string') {
                    response = JSON.parse(response);
                }
            } catch (e) {/* do nothing */
            }
            var fileList = _this.state.fileList;
            var targetItem = (0, _utils.getFileItem)(file, fileList);
            // removed
            if (!targetItem) {
                return;
            }
            targetItem.status = 'done';
            targetItem.response = response;
            _this.onChange({
                file: (0, _extends3['default'])({}, targetItem),
                fileList: fileList
            });
        };
        _this.onProgress = function (e, file) {
            var fileList = _this.state.fileList;
            var targetItem = (0, _utils.getFileItem)(file, fileList);
            // removed
            if (!targetItem) {
                return;
            }
            targetItem.percent = e.percent;
            _this.onChange({
                event: e,
                file: (0, _extends3['default'])({}, targetItem),
                fileList: _this.state.fileList
            });
        };
        _this.onError = function (error, response, file) {
            _this.clearProgressTimer();
            var fileList = _this.state.fileList;
            var targetItem = (0, _utils.getFileItem)(file, fileList);
            // removed
            if (!targetItem) {
                return;
            }
            targetItem.error = error;
            targetItem.response = response;
            targetItem.status = 'error';
            _this.onChange({
                file: (0, _extends3['default'])({}, targetItem),
                fileList: fileList
            });
        };
        _this.handleManualRemove = function (file) {
            _this.upload.abort(file);
            file.status = 'removed'; // eslint-disable-line
            _this.handleRemove(file);
        };
        _this.onChange = function (info) {
            if (!('fileList' in _this.props)) {
                _this.setState({ fileList: info.fileList });
            }
            var onChange = _this.props.onChange;

            if (onChange) {
                onChange(info);
            }
        };
        _this.onFileDrop = function (e) {
            _this.setState({
                dragState: e.type
            });
        };
        _this.beforeUpload = function (file, fileList) {
            if (!_this.props.beforeUpload) {
                return true;
            }
            var result = _this.props.beforeUpload(file, fileList);
            if (result === false) {
                _this.onChange({
                    file: file,
                    fileList: (0, _uniqBy2['default'])(_this.state.fileList.concat(fileList.map(_utils.fileToObject)), function (item) {
                        return item.uid;
                    })
                });
                return false;
            } else if (result && result.then) {
                return result;
            }
            return true;
        };
        _this.saveUpload = function (node) {
            _this.upload = node;
        };
        _this.renderUploadList = function (locale) {
            var _this$props = _this.props,
                showUploadList = _this$props.showUploadList,
                listType = _this$props.listType,
                onPreview = _this$props.onPreview;
            var showRemoveIcon = showUploadList.showRemoveIcon,
                showPreviewIcon = showUploadList.showPreviewIcon;

            return React.createElement(_UploadList2['default'], { listType: listType, items: _this.state.fileList, onPreview: onPreview, onRemove: _this.handleManualRemove, showRemoveIcon: showRemoveIcon, showPreviewIcon: showPreviewIcon, locale: (0, _extends3['default'])({}, locale, _this.props.locale) });
        };
        _this.state = {
            fileList: props.fileList || props.defaultFileList || [],
            dragState: 'drop'
        };
        return _this;
    }

    (0, _createClass3['default'])(Upload, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearProgressTimer();
        }
    }, {
        key: 'autoUpdateProgress',
        value: function autoUpdateProgress(_, file) {
            var _this2 = this;

            var getPercent = (0, _utils.genPercentAdd)();
            var curPercent = 0;
            this.clearProgressTimer();
            this.progressTimer = setInterval(function () {
                curPercent = getPercent(curPercent);
                _this2.onProgress({
                    percent: curPercent * 100
                }, file);
            }, 200);
        }
    }, {
        key: 'handleRemove',
        value: function handleRemove(file) {
            var _this3 = this;

            var onRemove = this.props.onRemove;

            Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then(function (ret) {
                // Prevent removing file
                if (ret === false) {
                    return;
                }
                var removedFileList = (0, _utils.removeFileItem)(file, _this3.state.fileList);
                if (removedFileList) {
                    _this3.onChange({
                        file: file,
                        fileList: removedFileList
                    });
                }
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('fileList' in nextProps) {
                this.setState({
                    fileList: nextProps.fileList || []
                });
            }
        }
    }, {
        key: 'clearProgressTimer',
        value: function clearProgressTimer() {
            clearInterval(this.progressTimer);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames2;

            var _props = this.props,
                _props$prefixCls = _props.prefixCls,
                prefixCls = _props$prefixCls === undefined ? '' : _props$prefixCls,
                className = _props.className,
                showUploadList = _props.showUploadList,
                listType = _props.listType,
                type = _props.type,
                disabled = _props.disabled,
                children = _props.children;

            var rcUploadProps = (0, _extends3['default'])({ onStart: this.onStart, onError: this.onError, onProgress: this.onProgress, onSuccess: this.onSuccess }, this.props, { beforeUpload: this.beforeUpload });
            delete rcUploadProps.className;
            var uploadList = showUploadList ? React.createElement(
                _LocaleReceiver2['default'],
                { componentName: 'Upload', defaultLocale: _default2['default'].Upload },
                this.renderUploadList
            ) : null;
            if (type === 'drag') {
                var _classNames;

                var dragCls = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-drag', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-drag-uploading', this.state.fileList.some(function (file) {
                    return file.status === 'uploading';
                })), (0, _defineProperty3['default'])(_classNames, prefixCls + '-drag-hover', this.state.dragState === 'dragover'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), _classNames));
                return React.createElement(
                    'span',
                    { className: className },
                    React.createElement(
                        'div',
                        { className: dragCls, onDrop: this.onFileDrop, onDragOver: this.onFileDrop, onDragLeave: this.onFileDrop },
                        React.createElement(
                            _rcUpload2['default'],
                            (0, _extends3['default'])({}, rcUploadProps, { ref: this.saveUpload, className: prefixCls + '-btn' }),
                            React.createElement(
                                'div',
                                { className: prefixCls + '-drag-container' },
                                children
                            )
                        )
                    ),
                    uploadList
                );
            }
            var uploadButtonCls = (0, _classnames2['default'])(prefixCls, (_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-select', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-select-' + listType, true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-disabled', disabled), _classNames2));
            var uploadButton = React.createElement(
                'div',
                { className: uploadButtonCls, style: { display: children ? '' : 'none' } },
                React.createElement(_rcUpload2['default'], (0, _extends3['default'])({}, rcUploadProps, { ref: this.saveUpload }))
            );
            if (listType === 'picture-card') {
                return React.createElement(
                    'span',
                    { className: className },
                    uploadList,
                    uploadButton
                );
            }
            return React.createElement(
                'span',
                { className: className },
                uploadButton,
                uploadList
            );
        }
    }]);
    return Upload;
}(React.Component);

exports['default'] = Upload;

Upload.defaultProps = {
    prefixCls: 'ant-upload',
    type: 'select',
    multiple: false,
    action: '',
    data: {},
    accept: '',
    beforeUpload: _utils.T,
    showUploadList: true,
    listType: 'text',
    className: '',
    disabled: false,
    supportServerRender: true
};
module.exports = exports['default'];

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uid;
var now = +new Date();
var index = 0;

function uid() {
  return "rc-upload-" + now + "-" + ++index;
}

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(122),
    stackClear = __webpack_require__(943),
    stackDelete = __webpack_require__(944),
    stackGet = __webpack_require__(945),
    stackHas = __webpack_require__(946),
    stackSet = __webpack_require__(947);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 346 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(98),
    isObject = __webpack_require__(198);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 349 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(966),
    isObjectLike = __webpack_require__(99);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(352),
    arraySome = __webpack_require__(969),
    cacheHas = __webpack_require__(353);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(199),
    setCacheAdd = __webpack_require__(967),
    setCacheHas = __webpack_require__(968);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 353 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(980),
    baseKeys = __webpack_require__(987),
    isArrayLike = __webpack_require__(991);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(982),
    isObjectLike = __webpack_require__(99);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(55),
    stubFalse = __webpack_require__(983);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)(module)))

/***/ }),
/* 357 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(984),
    baseUnary = __webpack_require__(985),
    nodeUtil = __webpack_require__(986);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(85),
    root = __webpack_require__(55);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(198);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 361 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(363),
    toKey = __webpack_require__(127);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(61),
    isKey = __webpack_require__(202),
    stringToPath = __webpack_require__(999),
    toString = __webpack_require__(1002);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);



var enhancer = function enhancer(WrappedComponent) {
  return function (_WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Progress, _WrappedComponent);

    function Progress() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Progress);

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _WrappedComponent.apply(this, arguments));
    }

    Progress.prototype.componentDidUpdate = function componentDidUpdate() {
      if (!this.path) {
        return;
      }
      var pathStyle = this.path.style;
      pathStyle.transitionDuration = '.3s, .3s, .3s, .06s';
      var now = Date.now();
      if (this.prevTimeStamp && now - this.prevTimeStamp < 100) {
        pathStyle.transitionDuration = '0s, 0s';
      }
      this.prevTimeStamp = Date.now();
    };

    Progress.prototype.render = function render() {
      return _WrappedComponent.prototype.render.call(this);
    };

    return Progress;
  }(WrappedComponent);
};

/* harmony default export */ __webpack_exports__["a"] = (enhancer);

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return propTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var defaultProps = {
  className: '',
  percent: 0,
  prefixCls: 'rc-progress',
  strokeColor: '#2db7f5',
  strokeLinecap: 'round',
  strokeWidth: 1,
  style: {},
  trailColor: '#D9D9D9',
  trailWidth: 1
};

var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  percent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
  prefixCls: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  strokeColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  strokeLinecap: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['butt', 'round', 'square']),
  strokeWidth: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  trailColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  trailWidth: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string])
};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/roots.eae696b8.svg";

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bone.fbfe4c77.svg";

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/joint.dcdc32ff.svg";

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/plan_bone.01d59eda.svg";

/***/ }),
/* 370 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/* cpexcel.js (C) 2013-present SheetJS -- http://sheetjs.com */
/*jshint -W100 */
var cptable = {version:"1.14.0"};
cptable[437] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[620] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàąçêëèïîćÄĄĘęłôöĆûùŚÖÜ¢Ł¥śƒŹŻóÓńŃźż¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[737] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[850] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[852] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[857] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[861] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[865] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[866] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[874] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[895] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ČüéďäĎŤčěĚĹÍľǪÄÁÉžŽôöÓůÚýÖÜŠĽÝŘťáíóúňŇŮÔšřŕŔ¼§«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[932] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ��������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[129] = "����������������������������������������������������������������　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×�÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓�����������∈∋⊆⊇⊂⊃∪∩��������∧∨￢⇒⇔∀∃�����������∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬�������Å‰♯♭♪†‡¶����◯���".split("");
for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
D[130] = "�������������������������������������������������������������������������������０１２３４５６７８９�������ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ�������ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ����ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん��������������".split("");
for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
D[131] = "����������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミ�ムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ��������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�����������������������������������������".split("");
for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
D[132] = "����������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмн�опрстуфхцчшщъыьэюя�������������─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂�����������������������������������������������������������������".split("");
for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
D[135] = "����������������������������������������������������������������①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡��������㍻�〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪���������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
D[136] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭���".split("");
for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
D[137] = "����������������������������������������������������������������院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円�園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改���".split("");
for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
D[138] = "����������������������������������������������������������������魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫�橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄���".split("");
for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
D[139] = "����������������������������������������������������������������機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救�朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈���".split("");
for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
D[140] = "����������������������������������������������������������������掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨�劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向���".split("");
for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
D[141] = "����������������������������������������������������������������后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降�項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷���".split("");
for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
D[142] = "����������������������������������������������������������������察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止�死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周���".split("");
for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
D[143] = "����������������������������������������������������������������宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳�準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾���".split("");
for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
D[144] = "����������������������������������������������������������������拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨�逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線���".split("");
for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
D[145] = "����������������������������������������������������������������繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻�操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只���".split("");
for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
D[146] = "����������������������������������������������������������������叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄�逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓���".split("");
for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
D[147] = "����������������������������������������������������������������邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬�凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入���".split("");
for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
D[148] = "����������������������������������������������������������������如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅�楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美���".split("");
for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
D[149] = "����������������������������������������������������������������鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷�斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋���".split("");
for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
D[150] = "����������������������������������������������������������������法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆�摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒���".split("");
for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
D[151] = "����������������������������������������������������������������諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲�沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯���".split("");
for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
D[152] = "����������������������������������������������������������������蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕��������������������������������������������弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲���".split("");
for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
D[153] = "����������������������������������������������������������������僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭�凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨���".split("");
for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
D[154] = "����������������������������������������������������������������咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸�噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩���".split("");
for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
D[155] = "����������������������������������������������������������������奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀�它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏���".split("");
for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
D[156] = "����������������������������������������������������������������廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠�怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛���".split("");
for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
D[157] = "����������������������������������������������������������������戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫�捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼���".split("");
for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
D[158] = "����������������������������������������������������������������曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎�梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣���".split("");
for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
D[159] = "����������������������������������������������������������������檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯�麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌���".split("");
for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
D[224] = "����������������������������������������������������������������漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝�烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱���".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "����������������������������������������������������������������瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿�痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬���".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "����������������������������������������������������������������磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰�窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆���".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "����������������������������������������������������������������紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷�縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋���".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "����������������������������������������������������������������隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤�艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈���".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "����������������������������������������������������������������蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬�蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞���".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "����������������������������������������������������������������襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧�諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊���".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "����������������������������������������������������������������蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜�轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮���".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "����������������������������������������������������������������錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙�閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰���".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "����������������������������������������������������������������顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃�騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈���".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "����������������������������������������������������������������鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯�黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙�������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[237] = "����������������������������������������������������������������纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏�塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱���".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "����������������������������������������������������������������犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙�蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑��ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂���".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[250] = "����������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊�兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯���".split("");
for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
D[251] = "����������������������������������������������������������������涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神�祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙���".split("");
for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
D[252] = "����������������������������������������������������������������髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑������������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
return {"enc": e, "dec": d }; })();
cptable[936] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[129] = "����������������������������������������������������������������丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪乫乬乭乮乯乲乴乵乶乷乸乹乺乻乼乽乿亀亁亂亃亄亅亇亊�亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂伃伄伅伆伇伈伋伌伒伓伔伕伖伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾伿佀佁佂佄佅佇佈佉佊佋佌佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢�".split("");
for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
D[130] = "����������������������������������������������������������������侤侫侭侰侱侲侳侴侶侷侸侹侺侻侼侽侾俀俁係俆俇俈俉俋俌俍俒俓俔俕俖俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿倀倁倂倃倄倅倆倇倈倉倊�個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯倰倱倲倳倴倵倶倷倸倹倻倽倿偀偁偂偄偅偆偉偊偋偍偐偑偒偓偔偖偗偘偙偛偝偞偟偠偡偢偣偤偦偧偨偩偪偫偭偮偯偰偱偲偳側偵偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎傏傐傑傒傓傔傕傖傗傘備傚傛傜傝傞傟傠傡傢傤傦傪傫傭傮傯傰傱傳傴債傶傷傸傹傼�".split("");
for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
D[131] = "����������������������������������������������������������������傽傾傿僀僁僂僃僄僅僆僇僈僉僊僋僌働僎僐僑僒僓僔僕僗僘僙僛僜僝僞僟僠僡僢僣僤僥僨僩僪僫僯僰僱僲僴僶僷僸價僺僼僽僾僿儀儁儂儃億儅儈�儉儊儌儍儎儏儐儑儓儔儕儖儗儘儙儚儛儜儝儞償儠儢儣儤儥儦儧儨儩優儫儬儭儮儯儰儱儲儳儴儵儶儷儸儹儺儻儼儽儾兂兇兊兌兎兏児兒兓兗兘兙兛兝兞兟兠兡兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦冧冨冩冪冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒凓凔凕凖凗�".split("");
for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
D[132] = "����������������������������������������������������������������凘凙凚凜凞凟凢凣凥処凧凨凩凪凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄剅剆則剈剉剋剎剏剒剓剕剗剘�剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳剴創剶剷剸剹剺剻剼剾劀劃劄劅劆劇劉劊劋劌劍劎劏劑劒劔劕劖劗劘劙劚劜劤劥劦劧劮劯劰労劵劶劷劸効劺劻劼劽勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務勚勛勜勝勞勠勡勢勣勥勦勧勨勩勪勫勬勭勮勯勱勲勳勴勵勶勷勸勻勼勽匁匂匃匄匇匉匊匋匌匎�".split("");
for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
D[133] = "����������������������������������������������������������������匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯匰匱匲匳匴匵匶匷匸匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏�厐厑厒厓厔厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯厰厱厲厳厴厵厷厸厹厺厼厽厾叀參叄叅叆叇収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝呞呟呠呡呣呥呧呩呪呫呬呭呮呯呰呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡�".split("");
for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
D[134] = "����������������������������������������������������������������咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠員哢哣哤哫哬哯哰哱哴哵哶哷哸哹哻哾唀唂唃唄唅唈唊唋唌唍唎唒唓唕唖唗唘唙唚唜唝唞唟唡唥唦�唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋啌啍啎問啑啒啓啔啗啘啙啚啛啝啞啟啠啢啣啨啩啫啯啰啱啲啳啴啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠喡喢喣喤喥喦喨喩喪喫喬喭單喯喰喲喴営喸喺喼喿嗀嗁嗂嗃嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗嗘嗙嗚嗛嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸嗹嗺嗻嗼嗿嘂嘃嘄嘅�".split("");
for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
D[135] = "����������������������������������������������������������������嘆嘇嘊嘋嘍嘐嘑嘒嘓嘔嘕嘖嘗嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀噁噂噃噄噅噆噇噈噉噊噋噏噐噑噒噓噕噖噚噛噝噞噟噠噡�噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽噾噿嚀嚁嚂嚃嚄嚇嚈嚉嚊嚋嚌嚍嚐嚑嚒嚔嚕嚖嚗嚘嚙嚚嚛嚜嚝嚞嚟嚠嚡嚢嚤嚥嚦嚧嚨嚩嚪嚫嚬嚭嚮嚰嚱嚲嚳嚴嚵嚶嚸嚹嚺嚻嚽嚾嚿囀囁囂囃囄囅囆囇囈囉囋囌囍囎囏囐囑囒囓囕囖囘囙囜団囥囦囧囨囩囪囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國圌圍圎圏圐圑�".split("");
for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
D[136] = "����������������������������������������������������������������園圓圔圕圖圗團圙圚圛圝圞圠圡圢圤圥圦圧圫圱圲圴圵圶圷圸圼圽圿坁坃坄坅坆坈坉坋坒坓坔坕坖坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀�垁垇垈垉垊垍垎垏垐垑垔垕垖垗垘垙垚垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹垺垻垼垽垾垿埀埁埄埅埆埇埈埉埊埌埍埐埑埓埖埗埛埜埞埡埢埣埥埦埧埨埩埪埫埬埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥堦堧堨堩堫堬堭堮堯報堲堳場堶堷堸堹堺堻堼堽�".split("");
for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
D[137] = "����������������������������������������������������������������堾堿塀塁塂塃塅塆塇塈塉塊塋塎塏塐塒塓塕塖塗塙塚塛塜塝塟塠塡塢塣塤塦塧塨塩塪塭塮塯塰塱塲塳塴塵塶塷塸塹塺塻塼塽塿墂墄墆墇墈墊墋墌�墍墎墏墐墑墔墕墖増墘墛墜墝墠墡墢墣墤墥墦墧墪墫墬墭墮墯墰墱墲墳墴墵墶墷墸墹墺墻墽墾墿壀壂壃壄壆壇壈壉壊壋壌壍壎壏壐壒壓壔壖壗壘壙壚壛壜壝壞壟壠壡壢壣壥壦壧壨壩壪壭壯壱売壴壵壷壸壺壻壼壽壾壿夀夁夃夅夆夈変夊夋夌夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻�".split("");
for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
D[138] = "����������������������������������������������������������������夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛奜奝奞奟奡奣奤奦奧奨奩奪奫奬奭奮奯奰奱奲奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦�妧妬妭妰妱妳妴妵妶妷妸妺妼妽妿姀姁姂姃姄姅姇姈姉姌姍姎姏姕姖姙姛姞姟姠姡姢姤姦姧姩姪姫姭姮姯姰姱姲姳姴姵姶姷姸姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪娫娬娭娮娯娰娳娵娷娸娹娺娻娽娾娿婁婂婃婄婅婇婈婋婌婍婎婏婐婑婒婓婔婖婗婘婙婛婜婝婞婟婠�".split("");
for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
D[139] = "����������������������������������������������������������������婡婣婤婥婦婨婩婫婬婭婮婯婰婱婲婳婸婹婻婼婽婾媀媁媂媃媄媅媆媇媈媉媊媋媌媍媎媏媐媑媓媔媕媖媗媘媙媜媝媞媟媠媡媢媣媤媥媦媧媨媩媫媬�媭媮媯媰媱媴媶媷媹媺媻媼媽媿嫀嫃嫄嫅嫆嫇嫈嫊嫋嫍嫎嫏嫐嫑嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬嫭嫮嫯嫰嫲嫳嫴嫵嫶嫷嫸嫹嫺嫻嫼嫽嫾嫿嬀嬁嬂嬃嬄嬅嬆嬇嬈嬊嬋嬌嬍嬎嬏嬐嬑嬒嬓嬔嬕嬘嬙嬚嬛嬜嬝嬞嬟嬠嬡嬢嬣嬤嬥嬦嬧嬨嬩嬪嬫嬬嬭嬮嬯嬰嬱嬳嬵嬶嬸嬹嬺嬻嬼嬽嬾嬿孁孂孃孄孅孆孇�".split("");
for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
D[140] = "����������������������������������������������������������������孈孉孊孋孌孍孎孏孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏�寑寔寕寖寗寘寙寚寛寜寠寢寣實寧審寪寫寬寭寯寱寲寳寴寵寶寷寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧屨屩屪屫屬屭屰屲屳屴屵屶屷屸屻屼屽屾岀岃岄岅岆岇岉岊岋岎岏岒岓岕岝岞岟岠岡岤岥岦岧岨�".split("");
for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
D[141] = "����������������������������������������������������������������岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅峆峇峈峉峊峌峍峎峏峐峑峓峔峕峖峗峘峚峛峜峝峞峟峠峢峣峧峩峫峬峮峯峱峲峳峴峵島峷峸峹峺峼峽峾峿崀�崁崄崅崈崉崊崋崌崍崏崐崑崒崓崕崗崘崙崚崜崝崟崠崡崢崣崥崨崪崫崬崯崰崱崲崳崵崶崷崸崹崺崻崼崿嵀嵁嵂嵃嵄嵅嵆嵈嵉嵍嵎嵏嵐嵑嵒嵓嵔嵕嵖嵗嵙嵚嵜嵞嵟嵠嵡嵢嵣嵤嵥嵦嵧嵨嵪嵭嵮嵰嵱嵲嵳嵵嵶嵷嵸嵹嵺嵻嵼嵽嵾嵿嶀嶁嶃嶄嶅嶆嶇嶈嶉嶊嶋嶌嶍嶎嶏嶐嶑嶒嶓嶔嶕嶖嶗嶘嶚嶛嶜嶞嶟嶠�".split("");
for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
D[142] = "����������������������������������������������������������������嶡嶢嶣嶤嶥嶦嶧嶨嶩嶪嶫嶬嶭嶮嶯嶰嶱嶲嶳嶴嶵嶶嶸嶹嶺嶻嶼嶽嶾嶿巀巁巂巃巄巆巇巈巉巊巋巌巎巏巐巑巒巓巔巕巖巗巘巙巚巜巟巠巣巤巪巬巭�巰巵巶巸巹巺巻巼巿帀帄帇帉帊帋帍帎帒帓帗帞帟帠帡帢帣帤帥帨帩帪師帬帯帰帲帳帴帵帶帹帺帾帿幀幁幃幆幇幈幉幊幋幍幎幏幐幑幒幓幖幗幘幙幚幜幝幟幠幣幤幥幦幧幨幩幪幫幬幭幮幯幰幱幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨庩庪庫庬庮庯庰庱庲庴庺庻庼庽庿廀廁廂廃廄廅�".split("");
for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
D[143] = "����������������������������������������������������������������廆廇廈廋廌廍廎廏廐廔廕廗廘廙廚廜廝廞廟廠廡廢廣廤廥廦廧廩廫廬廭廮廯廰廱廲廳廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤�弨弫弬弮弰弲弳弴張弶強弸弻弽弾弿彁彂彃彄彅彆彇彈彉彊彋彌彍彎彏彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢徣徤徥徦徧復徫徬徯徰徱徲徳徴徶徸徹徺徻徾徿忀忁忂忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇�".split("");
for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
D[144] = "����������������������������������������������������������������怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰怱怲怳怴怶怷怸怹怺怽怾恀恄恅恆恇恈恉恊恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀�悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽悾悿惀惁惂惃惄惇惈惉惌惍惎惏惐惒惓惔惖惗惙惛惞惡惢惣惤惥惪惱惲惵惷惸惻惼惽惾惿愂愃愄愅愇愊愋愌愐愑愒愓愔愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬愭愮愯愰愱愲愳愴愵愶愷愸愹愺愻愼愽愾慀慁慂慃慄慅慆�".split("");
for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
D[145] = "����������������������������������������������������������������慇慉態慍慏慐慒慓慔慖慗慘慙慚慛慜慞慟慠慡慣慤慥慦慩慪慫慬慭慮慯慱慲慳慴慶慸慹慺慻慼慽慾慿憀憁憂憃憄憅憆憇憈憉憊憌憍憏憐憑憒憓憕�憖憗憘憙憚憛憜憞憟憠憡憢憣憤憥憦憪憫憭憮憯憰憱憲憳憴憵憶憸憹憺憻憼憽憿懀懁懃懄懅懆懇應懌懍懎懏懐懓懕懖懗懘懙懚懛懜懝懞懟懠懡懢懣懤懥懧懨懩懪懫懬懭懮懯懰懱懲懳懴懶懷懸懹懺懻懼懽懾戀戁戂戃戄戅戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸戹戺戻戼扂扄扅扆扊�".split("");
for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
D[146] = "����������������������������������������������������������������扏扐払扖扗扙扚扜扝扞扟扠扡扢扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋抌抍抎抏抐抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁�拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳挴挵挶挷挸挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖捗捘捙捚捛捜捝捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙掚掛掜掝掞掟採掤掦掫掯掱掲掵掶掹掻掽掿揀�".split("");
for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
D[147] = "����������������������������������������������������������������揁揂揃揅揇揈揊揋揌揑揓揔揕揗揘揙揚換揜揝揟揢揤揥揦揧揨揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆搇搈搉搊損搎搑搒搕搖搗搘搙搚搝搟搢搣搤�搥搧搨搩搫搮搯搰搱搲搳搵搶搷搸搹搻搼搾摀摂摃摉摋摌摍摎摏摐摑摓摕摖摗摙摚摛摜摝摟摠摡摢摣摤摥摦摨摪摫摬摮摯摰摱摲摳摴摵摶摷摻摼摽摾摿撀撁撃撆撈撉撊撋撌撍撎撏撐撓撔撗撘撚撛撜撝撟撠撡撢撣撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆擇擈擉擊擋擌擏擑擓擔擕擖擙據�".split("");
for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
D[148] = "����������������������������������������������������������������擛擜擝擟擠擡擣擥擧擨擩擪擫擬擭擮擯擰擱擲擳擴擵擶擷擸擹擺擻擼擽擾擿攁攂攃攄攅攆攇攈攊攋攌攍攎攏攐攑攓攔攕攖攗攙攚攛攜攝攞攟攠攡�攢攣攤攦攧攨攩攪攬攭攰攱攲攳攷攺攼攽敀敁敂敃敄敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數敹敺敻敼敽敾敿斀斁斂斃斄斅斆斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱斲斳斴斵斶斷斸斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘旙旚旛旜旝旞旟旡旣旤旪旫�".split("");
for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
D[149] = "����������������������������������������������������������������旲旳旴旵旸旹旻旼旽旾旿昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷昸昹昺昻昽昿晀時晄晅晆晇晈晉晊晍晎晐晑晘�晙晛晜晝晞晠晢晣晥晧晩晪晫晬晭晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘暙暚暛暜暞暟暠暡暢暣暤暥暦暩暪暫暬暭暯暰暱暲暳暵暶暷暸暺暻暼暽暿曀曁曂曃曄曅曆曇曈曉曊曋曌曍曎曏曐曑曒曓曔曕曖曗曘曚曞曟曠曡曢曣曤曥曧曨曪曫曬曭曮曯曱曵曶書曺曻曽朁朂會�".split("");
for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
D[150] = "����������������������������������������������������������������朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠朡朢朣朤朥朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗杘杙杚杛杝杢杣杤杦杧杫杬杮東杴杶�杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹枺枻枼枽枾枿柀柂柅柆柇柈柉柊柋柌柍柎柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵柶柷柸柹柺査柼柾栁栂栃栄栆栍栐栒栔栕栘栙栚栛栜栞栟栠栢栣栤栥栦栧栨栫栬栭栮栯栰栱栴栵栶栺栻栿桇桋桍桏桒桖桗桘桙桚桛�".split("");
for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
D[151] = "����������������������������������������������������������������桜桝桞桟桪桬桭桮桯桰桱桲桳桵桸桹桺桻桼桽桾桿梀梂梄梇梈梉梊梋梌梍梎梐梑梒梔梕梖梘梙梚梛梜條梞梟梠梡梣梤梥梩梪梫梬梮梱梲梴梶梷梸�梹梺梻梼梽梾梿棁棃棄棅棆棇棈棊棌棎棏棐棑棓棔棖棗棙棛棜棝棞棟棡棢棤棥棦棧棨棩棪棫棬棭棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆椇椈椉椊椌椏椑椓椔椕椖椗椘椙椚椛検椝椞椡椢椣椥椦椧椨椩椪椫椬椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃楄楅楆楇楈楉楊楋楌楍楎楏楐楑楒楓楕楖楘楙楛楜楟�".split("");
for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
D[152] = "����������������������������������������������������������������楡楢楤楥楧楨楩楪楬業楯楰楲楳楴極楶楺楻楽楾楿榁榃榅榊榋榌榎榏榐榑榒榓榖榗榙榚榝榞榟榠榡榢榣榤榥榦榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽�榾榿槀槂槃槄槅槆槇槈槉構槍槏槑槒槓槕槖槗様槙槚槜槝槞槡槢槣槤槥槦槧槨槩槪槫槬槮槯槰槱槳槴槵槶槷槸槹槺槻槼槾樀樁樂樃樄樅樆樇樈樉樋樌樍樎樏樐樑樒樓樔樕樖標樚樛樜樝樞樠樢樣樤樥樦樧権樫樬樭樮樰樲樳樴樶樷樸樹樺樻樼樿橀橁橂橃橅橆橈橉橊橋橌橍橎橏橑橒橓橔橕橖橗橚�".split("");
for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
D[153] = "����������������������������������������������������������������橜橝橞機橠橢橣橤橦橧橨橩橪橫橬橭橮橯橰橲橳橴橵橶橷橸橺橻橽橾橿檁檂檃檅檆檇檈檉檊檋檌檍檏檒檓檔檕檖檘檙檚檛檜檝檞檟檡檢檣檤檥檦�檧檨檪檭檮檯檰檱檲檳檴檵檶檷檸檹檺檻檼檽檾檿櫀櫁櫂櫃櫄櫅櫆櫇櫈櫉櫊櫋櫌櫍櫎櫏櫐櫑櫒櫓櫔櫕櫖櫗櫘櫙櫚櫛櫜櫝櫞櫟櫠櫡櫢櫣櫤櫥櫦櫧櫨櫩櫪櫫櫬櫭櫮櫯櫰櫱櫲櫳櫴櫵櫶櫷櫸櫹櫺櫻櫼櫽櫾櫿欀欁欂欃欄欅欆欇欈欉權欋欌欍欎欏欐欑欒欓欔欕欖欗欘欙欚欛欜欝欞欟欥欦欨欩欪欫欬欭欮�".split("");
for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
D[154] = "����������������������������������������������������������������欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍歎歏歐歑歒歓歔歕歖歗歘歚歛歜歝歞歟歠歡歨歩歫歬歭歮歯歰歱歲歳歴歵歶歷歸歺歽歾歿殀殅殈�殌殎殏殐殑殔殕殗殘殙殜殝殞殟殠殢殣殤殥殦殧殨殩殫殬殭殮殯殰殱殲殶殸殹殺殻殼殽殾毀毃毄毆毇毈毉毊毌毎毐毑毘毚毜毝毞毟毠毢毣毤毥毦毧毨毩毬毭毮毰毱毲毴毶毷毸毺毻毼毾毿氀氁氂氃氄氈氉氊氋氌氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋汌汍汎汏汑汒汓汖汘�".split("");
for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
D[155] = "����������������������������������������������������������������汙汚汢汣汥汦汧汫汬汭汮汯汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘�泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟洠洡洢洣洤洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽浾浿涀涁涃涄涆涇涊涋涍涏涐涒涖涗涘涙涚涜涢涥涬涭涰涱涳涴涶涷涹涺涻涼涽涾淁淂淃淈淉淊�".split("");
for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
D[156] = "����������������������������������������������������������������淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽淾淿渀渁渂渃渄渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵�渶渷渹渻渼渽渾渿湀湁湂湅湆湇湈湉湊湋湌湏湐湑湒湕湗湙湚湜湝湞湠湡湢湣湤湥湦湧湨湩湪湬湭湯湰湱湲湳湴湵湶湷湸湹湺湻湼湽満溁溂溄溇溈溊溋溌溍溎溑溒溓溔溕準溗溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪滫滬滭滮滯�".split("");
for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
D[157] = "����������������������������������������������������������������滰滱滲滳滵滶滷滸滺滻滼滽滾滿漀漁漃漄漅漇漈漊漋漌漍漎漐漑漒漖漗漘漙漚漛漜漝漞漟漡漢漣漥漦漧漨漬漮漰漲漴漵漷漸漹漺漻漼漽漿潀潁潂�潃潄潅潈潉潊潌潎潏潐潑潒潓潔潕潖潗潙潚潛潝潟潠潡潣潤潥潧潨潩潪潫潬潯潰潱潳潵潶潷潹潻潽潾潿澀澁澂澃澅澆澇澊澋澏澐澑澒澓澔澕澖澗澘澙澚澛澝澞澟澠澢澣澤澥澦澨澩澪澫澬澭澮澯澰澱澲澴澵澷澸澺澻澼澽澾澿濁濃濄濅濆濇濈濊濋濌濍濎濏濐濓濔濕濖濗濘濙濚濛濜濝濟濢濣濤濥�".split("");
for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
D[158] = "����������������������������������������������������������������濦濧濨濩濪濫濬濭濰濱濲濳濴濵濶濷濸濹濺濻濼濽濾濿瀀瀁瀂瀃瀄瀅瀆瀇瀈瀉瀊瀋瀌瀍瀎瀏瀐瀒瀓瀔瀕瀖瀗瀘瀙瀜瀝瀞瀟瀠瀡瀢瀤瀥瀦瀧瀨瀩瀪�瀫瀬瀭瀮瀯瀰瀱瀲瀳瀴瀶瀷瀸瀺瀻瀼瀽瀾瀿灀灁灂灃灄灅灆灇灈灉灊灋灍灎灐灑灒灓灔灕灖灗灘灙灚灛灜灝灟灠灡灢灣灤灥灦灧灨灩灪灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞炟炠炡炢炣炤炥炦炧炨炩炪炰炲炴炵炶為炾炿烄烅烆烇烉烋烌烍烎烏烐烑烒烓烔烕烖烗烚�".split("");
for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
D[159] = "����������������������������������������������������������������烜烝烞烠烡烢烣烥烪烮烰烱烲烳烴烵烶烸烺烻烼烾烿焀焁焂焃焄焅焆焇焈焋焌焍焎焏焑焒焔焗焛焜焝焞焟焠無焢焣焤焥焧焨焩焪焫焬焭焮焲焳焴�焵焷焸焹焺焻焼焽焾焿煀煁煂煃煄煆煇煈煉煋煍煏煐煑煒煓煔煕煖煗煘煙煚煛煝煟煠煡煢煣煥煩煪煫煬煭煯煰煱煴煵煶煷煹煻煼煾煿熀熁熂熃熅熆熇熈熉熋熌熍熎熐熑熒熓熕熖熗熚熛熜熝熞熡熢熣熤熥熦熧熩熪熫熭熮熯熰熱熲熴熶熷熸熺熻熼熽熾熿燀燁燂燄燅燆燇燈燉燊燋燌燍燏燐燑燒燓�".split("");
for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
D[160] = "����������������������������������������������������������������燖燗燘燙燚燛燜燝燞營燡燢燣燤燦燨燩燪燫燬燭燯燰燱燲燳燴燵燶燷燸燺燻燼燽燾燿爀爁爂爃爄爅爇爈爉爊爋爌爍爎爏爐爑爒爓爔爕爖爗爘爙爚�爛爜爞爟爠爡爢爣爤爥爦爧爩爫爭爮爯爲爳爴爺爼爾牀牁牂牃牄牅牆牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅犆犇犈犉犌犎犐犑犓犔犕犖犗犘犙犚犛犜犝犞犠犡犢犣犤犥犦犧犨犩犪犫犮犱犲犳犵犺犻犼犽犾犿狀狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛�".split("");
for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
D[162] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������︵︶︹︺︿﹀︽︾﹁﹂﹃﹄��︻︼︷︸︱�︳︴����������".split("");
for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
D[168] = "����������������������������������������������������������������ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇�█▉▊▋▌▍▎▏▓▔▕▼▽◢◣◤◥☉⊕〒〝〞�����������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ�ńň�ɡ����ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
D[169] = "����������������������������������������������������������������〡〢〣〤〥〦〧〨〩㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤�℡㈱�‐���ー゛゜ヽヾ〆ゝゞ﹉﹊﹋﹌﹍﹎﹏﹐﹑﹒﹔﹕﹖﹗﹙﹚﹛﹜﹝﹞﹟﹠﹡�﹢﹣﹤﹥﹦﹨﹩﹪﹫�������������〇�������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
D[170] = "����������������������������������������������������������������狜狝狟狢狣狤狥狦狧狪狫狵狶狹狽狾狿猀猂猄猅猆猇猈猉猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀獁獂獃獄獅獆獇獈�獉獊獋獌獎獏獑獓獔獕獖獘獙獚獛獜獝獞獟獡獢獣獤獥獦獧獨獩獪獫獮獰獱�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
D[171] = "����������������������������������������������������������������獲獳獴獵獶獷獸獹獺獻獼獽獿玀玁玂玃玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣玤玥玦玧玨玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃珄珅珆珇�珋珌珎珒珓珔珕珖珗珘珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳珴珵珶珷�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
D[172] = "����������������������������������������������������������������珸珹珺珻珼珽現珿琀琁琂琄琇琈琋琌琍琎琑琒琓琔琕琖琗琘琙琜琝琞琟琠琡琣琤琧琩琫琭琯琱琲琷琸琹琺琻琽琾琿瑀瑂瑃瑄瑅瑆瑇瑈瑉瑊瑋瑌瑍�瑎瑏瑐瑑瑒瑓瑔瑖瑘瑝瑠瑡瑢瑣瑤瑥瑦瑧瑨瑩瑪瑫瑬瑮瑯瑱瑲瑳瑴瑵瑸瑹瑺�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
D[173] = "����������������������������������������������������������������瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑璒璓璔璕璖璗璘璙璚璛璝璟璠璡璢璣璤璥璦璪璫璬璭璮璯環璱璲璳璴璵璶璷璸璹璻璼璽璾璿瓀瓁瓂瓃瓄瓅瓆瓇�瓈瓉瓊瓋瓌瓍瓎瓏瓐瓑瓓瓔瓕瓖瓗瓘瓙瓚瓛瓝瓟瓡瓥瓧瓨瓩瓪瓫瓬瓭瓰瓱瓲�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
D[174] = "����������������������������������������������������������������瓳瓵瓸瓹瓺瓻瓼瓽瓾甀甁甂甃甅甆甇甈甉甊甋甌甎甐甒甔甕甖甗甛甝甞甠甡產産甤甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘�畝畞畟畠畡畢畣畤畧畨畩畫畬畭畮畯異畱畳畵當畷畺畻畼畽畾疀疁疂疄疅疇�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
D[175] = "����������������������������������������������������������������疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦疧疨疩疪疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇�瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
D[176] = "����������������������������������������������������������������癅癆癇癈癉癊癋癎癏癐癑癒癓癕癗癘癙癚癛癝癟癠癡癢癤癥癦癧癨癩癪癬癭癮癰癱癲癳癴癵癶癷癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛�皜皝皞皟皠皡皢皣皥皦皧皨皩皪皫皬皭皯皰皳皵皶皷皸皹皺皻皼皽皾盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
D[177] = "����������������������������������������������������������������盄盇盉盋盌盓盕盙盚盜盝盞盠盡盢監盤盦盧盨盩盪盫盬盭盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎眏眐眑眒眓眔眕眖眗眘眛眜眝眞眡眣眤眥眧眪眫�眬眮眰眱眲眳眴眹眻眽眾眿睂睄睅睆睈睉睊睋睌睍睎睏睒睓睔睕睖睗睘睙睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
D[178] = "����������������������������������������������������������������睝睞睟睠睤睧睩睪睭睮睯睰睱睲睳睴睵睶睷睸睺睻睼瞁瞂瞃瞆瞇瞈瞉瞊瞋瞏瞐瞓瞔瞕瞖瞗瞘瞙瞚瞛瞜瞝瞞瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶瞷瞸瞹瞺�瞼瞾矀矁矂矃矄矅矆矇矈矉矊矋矌矎矏矐矑矒矓矔矕矖矘矙矚矝矞矟矠矡矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
D[179] = "����������������������������������������������������������������矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃砄砅砆砇砈砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚�硛硜硞硟硠硡硢硣硤硥硦硧硨硩硯硰硱硲硳硴硵硶硸硹硺硻硽硾硿碀碁碂碃场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
D[180] = "����������������������������������������������������������������碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨碩碪碫碬碭碮碯碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚磛磜磝磞磟磠磡磢磣�磤磥磦磧磩磪磫磭磮磯磰磱磳磵磶磸磹磻磼磽磾磿礀礂礃礄礆礇礈礉礊礋礌础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
D[181] = "����������������������������������������������������������������礍礎礏礐礑礒礔礕礖礗礘礙礚礛礜礝礟礠礡礢礣礥礦礧礨礩礪礫礬礭礮礯礰礱礲礳礵礶礷礸礹礽礿祂祃祄祅祇祊祋祌祍祎祏祐祑祒祔祕祘祙祡祣�祤祦祩祪祫祬祮祰祱祲祳祴祵祶祹祻祼祽祾祿禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
D[182] = "����������������������������������������������������������������禓禔禕禖禗禘禙禛禜禝禞禟禠禡禢禣禤禥禦禨禩禪禫禬禭禮禯禰禱禲禴禵禶禷禸禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙秚秛秜秝秞秠秡秢秥秨秪�秬秮秱秲秳秴秵秶秷秹秺秼秾秿稁稄稅稇稈稉稊稌稏稐稑稒稓稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
D[183] = "����������������������������������������������������������������稝稟稡稢稤稥稦稧稨稩稪稫稬稭種稯稰稱稲稴稵稶稸稺稾穀穁穂穃穄穅穇穈穉穊穋穌積穎穏穐穒穓穔穕穖穘穙穚穛穜穝穞穟穠穡穢穣穤穥穦穧穨�穩穪穫穬穭穮穯穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
D[184] = "����������������������������������������������������������������窣窤窧窩窪窫窮窯窰窱窲窴窵窶窷窸窹窺窻窼窽窾竀竁竂竃竄竅竆竇竈竉竊竌竍竎竏竐竑竒竓竔竕竗竘竚竛竜竝竡竢竤竧竨竩竪竫竬竮竰竱竲竳�竴竵競竷竸竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
D[185] = "����������������������������������������������������������������笯笰笲笴笵笶笷笹笻笽笿筀筁筂筃筄筆筈筊筍筎筓筕筗筙筜筞筟筡筣筤筥筦筧筨筩筪筫筬筭筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆箇箈箉箊箋箌箎箏�箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹箺箻箼箽箾箿節篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
D[186] = "����������������������������������������������������������������篅篈築篊篋篍篎篏篐篒篔篕篖篗篘篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲篳篴篵篶篸篹篺篻篽篿簀簁簂簃簄簅簆簈簉簊簍簎簐簑簒簓簔簕簗簘簙�簚簛簜簝簞簠簡簢簣簤簥簨簩簫簬簭簮簯簰簱簲簳簴簵簶簷簹簺簻簼簽簾籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
D[187] = "����������������������������������������������������������������籃籄籅籆籇籈籉籊籋籌籎籏籐籑籒籓籔籕籖籗籘籙籚籛籜籝籞籟籠籡籢籣籤籥籦籧籨籩籪籫籬籭籮籯籰籱籲籵籶籷籸籹籺籾籿粀粁粂粃粄粅粆粇�粈粊粋粌粍粎粏粐粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴粵粶粷粸粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
D[188] = "����������������������������������������������������������������粿糀糂糃糄糆糉糋糎糏糐糑糒糓糔糘糚糛糝糞糡糢糣糤糥糦糧糩糪糫糬糭糮糰糱糲糳糴糵糶糷糹糺糼糽糾糿紀紁紂紃約紅紆紇紈紉紋紌納紎紏紐�紑紒紓純紕紖紗紘紙級紛紜紝紞紟紡紣紤紥紦紨紩紪紬紭紮細紱紲紳紴紵紶肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
D[189] = "����������������������������������������������������������������紷紸紹紺紻紼紽紾紿絀絁終絃組絅絆絇絈絉絊絋経絍絎絏結絑絒絓絔絕絖絗絘絙絚絛絜絝絞絟絠絡絢絣絤絥給絧絨絩絪絫絬絭絯絰統絲絳絴絵絶�絸絹絺絻絼絽絾絿綀綁綂綃綄綅綆綇綈綉綊綋綌綍綎綏綐綑綒經綔綕綖綗綘健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
D[190] = "����������������������������������������������������������������継続綛綜綝綞綟綠綡綢綣綤綥綧綨綩綪綫綬維綯綰綱網綳綴綵綶綷綸綹綺綻綼綽綾綿緀緁緂緃緄緅緆緇緈緉緊緋緌緍緎総緐緑緒緓緔緕緖緗緘緙�線緛緜緝緞緟締緡緢緣緤緥緦緧編緩緪緫緬緭緮緯緰緱緲緳練緵緶緷緸緹緺尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
D[191] = "����������������������������������������������������������������緻緼緽緾緿縀縁縂縃縄縅縆縇縈縉縊縋縌縍縎縏縐縑縒縓縔縕縖縗縘縙縚縛縜縝縞縟縠縡縢縣縤縥縦縧縨縩縪縫縬縭縮縯縰縱縲縳縴縵縶縷縸縹�縺縼總績縿繀繂繃繄繅繆繈繉繊繋繌繍繎繏繐繑繒繓織繕繖繗繘繙繚繛繜繝俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
D[192] = "����������������������������������������������������������������繞繟繠繡繢繣繤繥繦繧繨繩繪繫繬繭繮繯繰繱繲繳繴繵繶繷繸繹繺繻繼繽繾繿纀纁纃纄纅纆纇纈纉纊纋續纍纎纏纐纑纒纓纔纕纖纗纘纙纚纜纝纞�纮纴纻纼绖绤绬绹缊缐缞缷缹缻缼缽缾缿罀罁罃罆罇罈罉罊罋罌罍罎罏罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
D[193] = "����������������������������������������������������������������罖罙罛罜罝罞罠罣罤罥罦罧罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂羃羄羅羆羇羈羉羋羍羏羐羑羒羓羕羖羗羘羙羛羜羠羢羣羥羦羨義羪羫羬羭羮羱�羳羴羵羶羷羺羻羾翀翂翃翄翆翇翈翉翋翍翏翐翑習翓翖翗翙翚翛翜翝翞翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
D[194] = "����������������������������������������������������������������翤翧翨翪翫翬翭翯翲翴翵翶翷翸翹翺翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫耬耭耮耯耰耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗�聙聛聜聝聞聟聠聡聢聣聤聥聦聧聨聫聬聭聮聯聰聲聳聴聵聶職聸聹聺聻聼聽隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
D[195] = "����������������������������������������������������������������聾肁肂肅肈肊肍肎肏肐肑肒肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇胈胉胊胋胏胐胑胒胓胔胕胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋�脌脕脗脙脛脜脝脟脠脡脢脣脤脥脦脧脨脩脪脫脭脮脰脳脴脵脷脹脺脻脼脽脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
D[196] = "����������������������������������������������������������������腀腁腂腃腄腅腇腉腍腎腏腒腖腗腘腛腜腝腞腟腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃膄膅膆膇膉膋膌膍膎膐膒膓膔膕膖膗膙膚膞膟膠膡膢膤膥�膧膩膫膬膭膮膯膰膱膲膴膵膶膷膸膹膼膽膾膿臄臅臇臈臉臋臍臎臏臐臑臒臓摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
D[197] = "����������������������������������������������������������������臔臕臖臗臘臙臚臛臜臝臞臟臠臡臢臤臥臦臨臩臫臮臯臰臱臲臵臶臷臸臹臺臽臿舃與興舉舊舋舎舏舑舓舕舖舗舘舙舚舝舠舤舥舦舧舩舮舲舺舼舽舿�艀艁艂艃艅艆艈艊艌艍艎艐艑艒艓艔艕艖艗艙艛艜艝艞艠艡艢艣艤艥艦艧艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
D[198] = "����������������������������������������������������������������艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸�苺苼苽苾苿茀茊茋茍茐茒茓茖茘茙茝茞茟茠茡茢茣茤茥茦茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
D[199] = "����������������������������������������������������������������茾茿荁荂荄荅荈荊荋荌荍荎荓荕荖荗荘荙荝荢荰荱荲荳荴荵荶荹荺荾荿莀莁莂莃莄莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡莢莣莤莥莦莧莬莭莮�莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
D[200] = "����������������������������������������������������������������菮華菳菴菵菶菷菺菻菼菾菿萀萂萅萇萈萉萊萐萒萓萔萕萖萗萙萚萛萞萟萠萡萢萣萩萪萫萬萭萮萯萰萲萳萴萵萶萷萹萺萻萾萿葀葁葂葃葄葅葇葈葉�葊葋葌葍葎葏葐葒葓葔葕葖葘葝葞葟葠葢葤葥葦葧葨葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
D[201] = "����������������������������������������������������������������葽葾葿蒀蒁蒃蒄蒅蒆蒊蒍蒏蒐蒑蒒蒓蒔蒕蒖蒘蒚蒛蒝蒞蒟蒠蒢蒣蒤蒥蒦蒧蒨蒩蒪蒫蒬蒭蒮蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗�蓘蓙蓚蓛蓜蓞蓡蓢蓤蓧蓨蓩蓪蓫蓭蓮蓯蓱蓲蓳蓴蓵蓶蓷蓸蓹蓺蓻蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
D[202] = "����������������������������������������������������������������蔃蔄蔅蔆蔇蔈蔉蔊蔋蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢蔣蔤蔥蔦蔧蔨蔩蔪蔭蔮蔯蔰蔱蔲蔳蔴蔵蔶蔾蔿蕀蕁蕂蕄蕅蕆蕇蕋蕌蕍蕎蕏蕐蕑蕒蕓蕔蕕�蕗蕘蕚蕛蕜蕝蕟蕠蕡蕢蕣蕥蕦蕧蕩蕪蕫蕬蕭蕮蕯蕰蕱蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
D[203] = "����������������������������������������������������������������薂薃薆薈薉薊薋薌薍薎薐薑薒薓薔薕薖薗薘薙薚薝薞薟薠薡薢薣薥薦薧薩薫薬薭薱薲薳薴薵薶薸薺薻薼薽薾薿藀藂藃藄藅藆藇藈藊藋藌藍藎藑藒�藔藖藗藘藙藚藛藝藞藟藠藡藢藣藥藦藧藨藪藫藬藭藮藯藰藱藲藳藴藵藶藷藸恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
D[204] = "����������������������������������������������������������������藹藺藼藽藾蘀蘁蘂蘃蘄蘆蘇蘈蘉蘊蘋蘌蘍蘎蘏蘐蘒蘓蘔蘕蘗蘘蘙蘚蘛蘜蘝蘞蘟蘠蘡蘢蘣蘤蘥蘦蘨蘪蘫蘬蘭蘮蘯蘰蘱蘲蘳蘴蘵蘶蘷蘹蘺蘻蘽蘾蘿虀�虁虂虃虄虅虆虇虈虉虊虋虌虒虓處虖虗虘虙虛虜虝號虠虡虣虤虥虦虧虨虩虪獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
D[205] = "����������������������������������������������������������������虭虯虰虲虳虴虵虶虷虸蚃蚄蚅蚆蚇蚈蚉蚎蚏蚐蚑蚒蚔蚖蚗蚘蚙蚚蚛蚞蚟蚠蚡蚢蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻蚼蚽蚾蚿蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜�蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
D[206] = "����������������������������������������������������������������蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀蝁蝂蝃蝄蝅蝆蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚蝛蝜蝝蝞蝟蝡蝢蝦蝧蝨蝩蝪蝫蝬蝭蝯蝱蝲蝳蝵�蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎螏螐螑螒螔螕螖螘螙螚螛螜螝螞螠螡螢螣螤巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
D[207] = "����������������������������������������������������������������螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁蟂蟃蟄蟅蟇蟈蟉蟌蟍蟎蟏蟐蟔蟕蟖蟗蟘蟙蟚蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯蟰蟱蟲蟳蟴蟵蟶蟷蟸�蟺蟻蟼蟽蟿蠀蠁蠂蠄蠅蠆蠇蠈蠉蠋蠌蠍蠎蠏蠐蠑蠒蠔蠗蠘蠙蠚蠜蠝蠞蠟蠠蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
D[208] = "����������������������������������������������������������������蠤蠥蠦蠧蠨蠩蠪蠫蠬蠭蠮蠯蠰蠱蠳蠴蠵蠶蠷蠸蠺蠻蠽蠾蠿衁衂衃衆衇衈衉衊衋衎衏衐衑衒術衕衖衘衚衛衜衝衞衟衠衦衧衪衭衯衱衳衴衵衶衸衹衺�衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗袘袙袚袛袝袞袟袠袡袣袥袦袧袨袩袪小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
D[209] = "����������������������������������������������������������������袬袮袯袰袲袳袴袵袶袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚裛補裝裞裠裡裦裧裩裪裫裬裭裮裯裲裵裶裷裺裻製裿褀褁褃褄褅褆複褈�褉褋褌褍褎褏褑褔褕褖褗褘褜褝褞褟褠褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
D[210] = "����������������������������������������������������������������褸褹褺褻褼褽褾褿襀襂襃襅襆襇襈襉襊襋襌襍襎襏襐襑襒襓襔襕襖襗襘襙襚襛襜襝襠襡襢襣襤襥襧襨襩襪襫襬襭襮襯襰襱襲襳襴襵襶襷襸襹襺襼�襽襾覀覂覄覅覇覈覉覊見覌覍覎規覐覑覒覓覔覕視覗覘覙覚覛覜覝覞覟覠覡摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
D[211] = "����������������������������������������������������������������覢覣覤覥覦覧覨覩親覫覬覭覮覯覰覱覲観覴覵覶覷覸覹覺覻覼覽覾覿觀觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴觵觶觷觸觹觺�觻觼觽觾觿訁訂訃訄訅訆計訉訊訋訌訍討訏訐訑訒訓訔訕訖託記訙訚訛訜訝印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
D[212] = "����������������������������������������������������������������訞訟訠訡訢訣訤訥訦訧訨訩訪訫訬設訮訯訰許訲訳訴訵訶訷訸訹診註証訽訿詀詁詂詃詄詅詆詇詉詊詋詌詍詎詏詐詑詒詓詔評詖詗詘詙詚詛詜詝詞�詟詠詡詢詣詤詥試詧詨詩詪詫詬詭詮詯詰話該詳詴詵詶詷詸詺詻詼詽詾詿誀浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
D[213] = "����������������������������������������������������������������誁誂誃誄誅誆誇誈誋誌認誎誏誐誑誒誔誕誖誗誘誙誚誛誜誝語誟誠誡誢誣誤誥誦誧誨誩說誫説読誮誯誰誱課誳誴誵誶誷誸誹誺誻誼誽誾調諀諁諂�諃諄諅諆談諈諉諊請諌諍諎諏諐諑諒諓諔諕論諗諘諙諚諛諜諝諞諟諠諡諢諣铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
D[214] = "����������������������������������������������������������������諤諥諦諧諨諩諪諫諬諭諮諯諰諱諲諳諴諵諶諷諸諹諺諻諼諽諾諿謀謁謂謃謄謅謆謈謉謊謋謌謍謎謏謐謑謒謓謔謕謖謗謘謙謚講謜謝謞謟謠謡謢謣�謤謥謧謨謩謪謫謬謭謮謯謰謱謲謳謴謵謶謷謸謹謺謻謼謽謾謿譀譁譂譃譄譅帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
D[215] = "����������������������������������������������������������������譆譇譈證譊譋譌譍譎譏譐譑譒譓譔譕譖譗識譙譚譛譜譝譞譟譠譡譢譣譤譥譧譨譩譪譫譭譮譯議譱譲譳譴譵譶護譸譹譺譻譼譽譾譿讀讁讂讃讄讅讆�讇讈讉變讋讌讍讎讏讐讑讒讓讔讕讖讗讘讙讚讛讜讝讞讟讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
D[216] = "����������������������������������������������������������������谸谹谺谻谼谽谾谿豀豂豃豄豅豈豊豋豍豎豏豐豑豒豓豔豖豗豘豙豛豜豝豞豟豠豣豤豥豦豧豨豩豬豭豮豯豰豱豲豴豵豶豷豻豼豽豾豿貀貁貃貄貆貇�貈貋貍貎貏貐貑貒貓貕貖貗貙貚貛貜貝貞貟負財貢貣貤貥貦貧貨販貪貫責貭亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
D[217] = "����������������������������������������������������������������貮貯貰貱貲貳貴貵貶買貸貹貺費貼貽貾貿賀賁賂賃賄賅賆資賈賉賊賋賌賍賎賏賐賑賒賓賔賕賖賗賘賙賚賛賜賝賞賟賠賡賢賣賤賥賦賧賨賩質賫賬�賭賮賯賰賱賲賳賴賵賶賷賸賹賺賻購賽賾賿贀贁贂贃贄贅贆贇贈贉贊贋贌贍佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
D[218] = "����������������������������������������������������������������贎贏贐贑贒贓贔贕贖贗贘贙贚贛贜贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸赹赺赻赼赽赾赿趀趂趃趆趇趈趉趌趍趎趏趐趒趓趕趖趗趘趙趚趛趜趝趞趠趡�趢趤趥趦趧趨趩趪趫趬趭趮趯趰趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
D[219] = "����������������������������������������������������������������跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾跿踀踁踂踃踄踆踇踈踋踍踎踐踑踒踓踕踖踗踘踙踚踛踜踠踡踤踥踦踧踨踫踭踰踲踳踴踶踷踸踻踼踾�踿蹃蹅蹆蹌蹍蹎蹏蹐蹓蹔蹕蹖蹗蹘蹚蹛蹜蹝蹞蹟蹠蹡蹢蹣蹤蹥蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
D[220] = "����������������������������������������������������������������蹳蹵蹷蹸蹹蹺蹻蹽蹾躀躂躃躄躆躈躉躊躋躌躍躎躑躒躓躕躖躗躘躙躚躛躝躟躠躡躢躣躤躥躦躧躨躩躪躭躮躰躱躳躴躵躶躷躸躹躻躼躽躾躿軀軁軂�軃軄軅軆軇軈軉車軋軌軍軏軐軑軒軓軔軕軖軗軘軙軚軛軜軝軞軟軠軡転軣軤堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
D[221] = "����������������������������������������������������������������軥軦軧軨軩軪軫軬軭軮軯軰軱軲軳軴軵軶軷軸軹軺軻軼軽軾軿輀輁輂較輄輅輆輇輈載輊輋輌輍輎輏輐輑輒輓輔輕輖輗輘輙輚輛輜輝輞輟輠輡輢輣�輤輥輦輧輨輩輪輫輬輭輮輯輰輱輲輳輴輵輶輷輸輹輺輻輼輽輾輿轀轁轂轃轄荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
D[222] = "����������������������������������������������������������������轅轆轇轈轉轊轋轌轍轎轏轐轑轒轓轔轕轖轗轘轙轚轛轜轝轞轟轠轡轢轣轤轥轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆�迉迊迋迌迍迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
D[223] = "����������������������������������������������������������������這逜連逤逥逧逨逩逪逫逬逰週進逳逴逷逹逺逽逿遀遃遅遆遈遉遊運遌過達違遖遙遚遜遝遞遟遠遡遤遦遧適遪遫遬遯遰遱遲遳遶遷選遹遺遻遼遾邁�還邅邆邇邉邊邌邍邎邏邐邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
D[224] = "����������������������������������������������������������������郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅鄆鄇鄈鄉鄊鄋鄌鄍鄎鄏鄐鄑鄒鄓鄔鄕鄖鄗鄘鄚鄛鄜�鄝鄟鄠鄡鄤鄥鄦鄧鄨鄩鄪鄫鄬鄭鄮鄰鄲鄳鄴鄵鄶鄷鄸鄺鄻鄼鄽鄾鄿酀酁酂酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "����������������������������������������������������������������酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀醁醂醃醄醆醈醊醎醏醓醔醕醖醗醘醙醜醝醞醟醠醡醤醥醦醧醨醩醫醬醰醱醲醳醶醷醸醹醻�醼醽醾醿釀釁釂釃釄釅釆釈釋釐釒釓釔釕釖釗釘釙釚釛針釞釟釠釡釢釣釤釥帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "����������������������������������������������������������������釦釧釨釩釪釫釬釭釮釯釰釱釲釳釴釵釶釷釸釹釺釻釼釽釾釿鈀鈁鈂鈃鈄鈅鈆鈇鈈鈉鈊鈋鈌鈍鈎鈏鈐鈑鈒鈓鈔鈕鈖鈗鈘鈙鈚鈛鈜鈝鈞鈟鈠鈡鈢鈣鈤�鈥鈦鈧鈨鈩鈪鈫鈬鈭鈮鈯鈰鈱鈲鈳鈴鈵鈶鈷鈸鈹鈺鈻鈼鈽鈾鈿鉀鉁鉂鉃鉄鉅狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "����������������������������������������������������������������鉆鉇鉈鉉鉊鉋鉌鉍鉎鉏鉐鉑鉒鉓鉔鉕鉖鉗鉘鉙鉚鉛鉜鉝鉞鉟鉠鉡鉢鉣鉤鉥鉦鉧鉨鉩鉪鉫鉬鉭鉮鉯鉰鉱鉲鉳鉵鉶鉷鉸鉹鉺鉻鉼鉽鉾鉿銀銁銂銃銄銅�銆銇銈銉銊銋銌銍銏銐銑銒銓銔銕銖銗銘銙銚銛銜銝銞銟銠銡銢銣銤銥銦銧恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "����������������������������������������������������������������銨銩銪銫銬銭銯銰銱銲銳銴銵銶銷銸銹銺銻銼銽銾銿鋀鋁鋂鋃鋄鋅鋆鋇鋉鋊鋋鋌鋍鋎鋏鋐鋑鋒鋓鋔鋕鋖鋗鋘鋙鋚鋛鋜鋝鋞鋟鋠鋡鋢鋣鋤鋥鋦鋧鋨�鋩鋪鋫鋬鋭鋮鋯鋰鋱鋲鋳鋴鋵鋶鋷鋸鋹鋺鋻鋼鋽鋾鋿錀錁錂錃錄錅錆錇錈錉洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "����������������������������������������������������������������錊錋錌錍錎錏錐錑錒錓錔錕錖錗錘錙錚錛錜錝錞錟錠錡錢錣錤錥錦錧錨錩錪錫錬錭錮錯錰錱録錳錴錵錶錷錸錹錺錻錼錽錿鍀鍁鍂鍃鍄鍅鍆鍇鍈鍉�鍊鍋鍌鍍鍎鍏鍐鍑鍒鍓鍔鍕鍖鍗鍘鍙鍚鍛鍜鍝鍞鍟鍠鍡鍢鍣鍤鍥鍦鍧鍨鍩鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "����������������������������������������������������������������鍬鍭鍮鍯鍰鍱鍲鍳鍴鍵鍶鍷鍸鍹鍺鍻鍼鍽鍾鍿鎀鎁鎂鎃鎄鎅鎆鎇鎈鎉鎊鎋鎌鎍鎎鎐鎑鎒鎓鎔鎕鎖鎗鎘鎙鎚鎛鎜鎝鎞鎟鎠鎡鎢鎣鎤鎥鎦鎧鎨鎩鎪鎫�鎬鎭鎮鎯鎰鎱鎲鎳鎴鎵鎶鎷鎸鎹鎺鎻鎼鎽鎾鎿鏀鏁鏂鏃鏄鏅鏆鏇鏈鏉鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "����������������������������������������������������������������鏎鏏鏐鏑鏒鏓鏔鏕鏗鏘鏙鏚鏛鏜鏝鏞鏟鏠鏡鏢鏣鏤鏥鏦鏧鏨鏩鏪鏫鏬鏭鏮鏯鏰鏱鏲鏳鏴鏵鏶鏷鏸鏹鏺鏻鏼鏽鏾鏿鐀鐁鐂鐃鐄鐅鐆鐇鐈鐉鐊鐋鐌鐍�鐎鐏鐐鐑鐒鐓鐔鐕鐖鐗鐘鐙鐚鐛鐜鐝鐞鐟鐠鐡鐢鐣鐤鐥鐦鐧鐨鐩鐪鐫鐬鐭鐮纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "����������������������������������������������������������������鐯鐰鐱鐲鐳鐴鐵鐶鐷鐸鐹鐺鐻鐼鐽鐿鑀鑁鑂鑃鑄鑅鑆鑇鑈鑉鑊鑋鑌鑍鑎鑏鑐鑑鑒鑓鑔鑕鑖鑗鑘鑙鑚鑛鑜鑝鑞鑟鑠鑡鑢鑣鑤鑥鑦鑧鑨鑩鑪鑬鑭鑮鑯�鑰鑱鑲鑳鑴鑵鑶鑷鑸鑹鑺鑻鑼鑽鑾鑿钀钁钂钃钄钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "����������������������������������������������������������������锧锳锽镃镈镋镕镚镠镮镴镵長镸镹镺镻镼镽镾門閁閂閃閄閅閆閇閈閉閊開閌閍閎閏閐閑閒間閔閕閖閗閘閙閚閛閜閝閞閟閠閡関閣閤閥閦閧閨閩閪�閫閬閭閮閯閰閱閲閳閴閵閶閷閸閹閺閻閼閽閾閿闀闁闂闃闄闅闆闇闈闉闊闋椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "����������������������������������������������������������������闌闍闎闏闐闑闒闓闔闕闖闗闘闙闚闛關闝闞闟闠闡闢闣闤闥闦闧闬闿阇阓阘阛阞阠阣阤阥阦阧阨阩阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗�陘陙陚陜陝陞陠陣陥陦陫陭陮陯陰陱陳陸陹険陻陼陽陾陿隀隁隂隃隄隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[235] = "����������������������������������������������������������������隌階隑隒隓隕隖隚際隝隞隟隠隡隢隣隤隥隦隨隩險隫隬隭隮隯隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖雗雘雙雚雛雜雝雞雟雡離難雤雥雦雧雫�雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗霘霙霚霛霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
D[236] = "����������������������������������������������������������������霡霢霣霤霥霦霧霨霩霫霬霮霯霱霳霴霵霶霷霺霻霼霽霿靀靁靂靃靄靅靆靇靈靉靊靋靌靍靎靏靐靑靔靕靗靘靚靜靝靟靣靤靦靧靨靪靫靬靭靮靯靰靱�靲靵靷靸靹靺靻靽靾靿鞀鞁鞂鞃鞄鞆鞇鞈鞉鞊鞌鞎鞏鞐鞓鞕鞖鞗鞙鞚鞛鞜鞝臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
D[237] = "����������������������������������������������������������������鞞鞟鞡鞢鞤鞥鞦鞧鞨鞩鞪鞬鞮鞰鞱鞳鞵鞶鞷鞸鞹鞺鞻鞼鞽鞾鞿韀韁韂韃韄韅韆韇韈韉韊韋韌韍韎韏韐韑韒韓韔韕韖韗韘韙韚韛韜韝韞韟韠韡韢韣�韤韥韨韮韯韰韱韲韴韷韸韹韺韻韼韽韾響頀頁頂頃頄項順頇須頉頊頋頌頍頎怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "����������������������������������������������������������������頏預頑頒頓頔頕頖頗領頙頚頛頜頝頞頟頠頡頢頣頤頥頦頧頨頩頪頫頬頭頮頯頰頱頲頳頴頵頶頷頸頹頺頻頼頽頾頿顀顁顂顃顄顅顆顇顈顉顊顋題額�顎顏顐顑顒顓顔顕顖顗願顙顚顛顜顝類顟顠顡顢顣顤顥顦顧顨顩顪顫顬顭顮睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[239] = "����������������������������������������������������������������顯顰顱顲顳顴颋颎颒颕颙颣風颩颪颫颬颭颮颯颰颱颲颳颴颵颶颷颸颹颺颻颼颽颾颿飀飁飂飃飄飅飆飇飈飉飊飋飌飍飏飐飔飖飗飛飜飝飠飡飢飣飤�飥飦飩飪飫飬飭飮飯飰飱飲飳飴飵飶飷飸飹飺飻飼飽飾飿餀餁餂餃餄餅餆餇铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
D[240] = "����������������������������������������������������������������餈餉養餋餌餎餏餑餒餓餔餕餖餗餘餙餚餛餜餝餞餟餠餡餢餣餤餥餦餧館餩餪餫餬餭餯餰餱餲餳餴餵餶餷餸餹餺餻餼餽餾餿饀饁饂饃饄饅饆饇饈饉�饊饋饌饍饎饏饐饑饒饓饖饗饘饙饚饛饜饝饞饟饠饡饢饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
D[241] = "����������������������������������������������������������������馌馎馚馛馜馝馞馟馠馡馢馣馤馦馧馩馪馫馬馭馮馯馰馱馲馳馴馵馶馷馸馹馺馻馼馽馾馿駀駁駂駃駄駅駆駇駈駉駊駋駌駍駎駏駐駑駒駓駔駕駖駗駘�駙駚駛駜駝駞駟駠駡駢駣駤駥駦駧駨駩駪駫駬駭駮駯駰駱駲駳駴駵駶駷駸駹瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
D[242] = "����������������������������������������������������������������駺駻駼駽駾駿騀騁騂騃騄騅騆騇騈騉騊騋騌騍騎騏騐騑騒験騔騕騖騗騘騙騚騛騜騝騞騟騠騡騢騣騤騥騦騧騨騩騪騫騬騭騮騯騰騱騲騳騴騵騶騷騸�騹騺騻騼騽騾騿驀驁驂驃驄驅驆驇驈驉驊驋驌驍驎驏驐驑驒驓驔驕驖驗驘驙颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
D[243] = "����������������������������������������������������������������驚驛驜驝驞驟驠驡驢驣驤驥驦驧驨驩驪驫驲骃骉骍骎骔骕骙骦骩骪骫骬骭骮骯骲骳骴骵骹骻骽骾骿髃髄髆髇髈髉髊髍髎髏髐髒體髕髖髗髙髚髛髜�髝髞髠髢髣髤髥髧髨髩髪髬髮髰髱髲髳髴髵髶髷髸髺髼髽髾髿鬀鬁鬂鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
D[244] = "����������������������������������������������������������������鬇鬉鬊鬋鬌鬍鬎鬐鬑鬒鬔鬕鬖鬗鬘鬙鬚鬛鬜鬝鬞鬠鬡鬢鬤鬥鬦鬧鬨鬩鬪鬫鬬鬭鬮鬰鬱鬳鬴鬵鬶鬷鬸鬹鬺鬽鬾鬿魀魆魊魋魌魎魐魒魓魕魖魗魘魙魚�魛魜魝魞魟魠魡魢魣魤魥魦魧魨魩魪魫魬魭魮魯魰魱魲魳魴魵魶魷魸魹魺魻簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
D[245] = "����������������������������������������������������������������魼魽魾魿鮀鮁鮂鮃鮄鮅鮆鮇鮈鮉鮊鮋鮌鮍鮎鮏鮐鮑鮒鮓鮔鮕鮖鮗鮘鮙鮚鮛鮜鮝鮞鮟鮠鮡鮢鮣鮤鮥鮦鮧鮨鮩鮪鮫鮬鮭鮮鮯鮰鮱鮲鮳鮴鮵鮶鮷鮸鮹鮺�鮻鮼鮽鮾鮿鯀鯁鯂鯃鯄鯅鯆鯇鯈鯉鯊鯋鯌鯍鯎鯏鯐鯑鯒鯓鯔鯕鯖鯗鯘鯙鯚鯛酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
D[246] = "����������������������������������������������������������������鯜鯝鯞鯟鯠鯡鯢鯣鯤鯥鯦鯧鯨鯩鯪鯫鯬鯭鯮鯯鯰鯱鯲鯳鯴鯵鯶鯷鯸鯹鯺鯻鯼鯽鯾鯿鰀鰁鰂鰃鰄鰅鰆鰇鰈鰉鰊鰋鰌鰍鰎鰏鰐鰑鰒鰓鰔鰕鰖鰗鰘鰙鰚�鰛鰜鰝鰞鰟鰠鰡鰢鰣鰤鰥鰦鰧鰨鰩鰪鰫鰬鰭鰮鰯鰰鰱鰲鰳鰴鰵鰶鰷鰸鰹鰺鰻觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
D[247] = "����������������������������������������������������������������鰼鰽鰾鰿鱀鱁鱂鱃鱄鱅鱆鱇鱈鱉鱊鱋鱌鱍鱎鱏鱐鱑鱒鱓鱔鱕鱖鱗鱘鱙鱚鱛鱜鱝鱞鱟鱠鱡鱢鱣鱤鱥鱦鱧鱨鱩鱪鱫鱬鱭鱮鱯鱰鱱鱲鱳鱴鱵鱶鱷鱸鱹鱺�鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾鲿鳀鳁鳂鳈鳉鳑鳒鳚鳛鳠鳡鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
D[248] = "����������������������������������������������������������������鳣鳤鳥鳦鳧鳨鳩鳪鳫鳬鳭鳮鳯鳰鳱鳲鳳鳴鳵鳶鳷鳸鳹鳺鳻鳼鳽鳾鳿鴀鴁鴂鴃鴄鴅鴆鴇鴈鴉鴊鴋鴌鴍鴎鴏鴐鴑鴒鴓鴔鴕鴖鴗鴘鴙鴚鴛鴜鴝鴞鴟鴠鴡�鴢鴣鴤鴥鴦鴧鴨鴩鴪鴫鴬鴭鴮鴯鴰鴱鴲鴳鴴鴵鴶鴷鴸鴹鴺鴻鴼鴽鴾鴿鵀鵁鵂�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
D[249] = "����������������������������������������������������������������鵃鵄鵅鵆鵇鵈鵉鵊鵋鵌鵍鵎鵏鵐鵑鵒鵓鵔鵕鵖鵗鵘鵙鵚鵛鵜鵝鵞鵟鵠鵡鵢鵣鵤鵥鵦鵧鵨鵩鵪鵫鵬鵭鵮鵯鵰鵱鵲鵳鵴鵵鵶鵷鵸鵹鵺鵻鵼鵽鵾鵿鶀鶁�鶂鶃鶄鶅鶆鶇鶈鶉鶊鶋鶌鶍鶎鶏鶐鶑鶒鶓鶔鶕鶖鶗鶘鶙鶚鶛鶜鶝鶞鶟鶠鶡鶢�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
D[250] = "����������������������������������������������������������������鶣鶤鶥鶦鶧鶨鶩鶪鶫鶬鶭鶮鶯鶰鶱鶲鶳鶴鶵鶶鶷鶸鶹鶺鶻鶼鶽鶾鶿鷀鷁鷂鷃鷄鷅鷆鷇鷈鷉鷊鷋鷌鷍鷎鷏鷐鷑鷒鷓鷔鷕鷖鷗鷘鷙鷚鷛鷜鷝鷞鷟鷠鷡�鷢鷣鷤鷥鷦鷧鷨鷩鷪鷫鷬鷭鷮鷯鷰鷱鷲鷳鷴鷵鷶鷷鷸鷹鷺鷻鷼鷽鷾鷿鸀鸁鸂�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
D[251] = "����������������������������������������������������������������鸃鸄鸅鸆鸇鸈鸉鸊鸋鸌鸍鸎鸏鸐鸑鸒鸓鸔鸕鸖鸗鸘鸙鸚鸛鸜鸝鸞鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴鹵鹶鹷鹸鹹鹺鹻鹼鹽麀�麁麃麄麅麆麉麊麌麍麎麏麐麑麔麕麖麗麘麙麚麛麜麞麠麡麢麣麤麥麧麨麩麪�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
D[252] = "����������������������������������������������������������������麫麬麭麮麯麰麱麲麳麵麶麷麹麺麼麿黀黁黂黃黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰黱黲黳黴黵黶黷黸黺黽黿鼀鼁鼂鼃鼄鼅�鼆鼇鼈鼉鼊鼌鼏鼑鼒鼔鼕鼖鼘鼚鼛鼜鼝鼞鼟鼡鼣鼤鼥鼦鼧鼨鼩鼪鼫鼭鼮鼰鼱�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
D[253] = "����������������������������������������������������������������鼲鼳鼴鼵鼶鼸鼺鼼鼿齀齁齂齃齅齆齇齈齉齊齋齌齍齎齏齒齓齔齕齖齗齘齙齚齛齜齝齞齟齠齡齢齣齤齥齦齧齨齩齪齫齬齭齮齯齰齱齲齳齴齵齶齷齸�齹齺齻齼齽齾龁龂龍龎龏龐龑龒龓龔龕龖龗龘龜龝龞龡龢龣龤龥郎凉秊裏隣�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
D[254] = "����������������������������������������������������������������兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩��������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[254].length; ++j) if(D[254][j].charCodeAt(0) !== 0xFFFD) { e[D[254][j]] = 65024 + j; d[65024 + j] = D[254][j];}
return {"enc": e, "dec": d }; })();
cptable[949] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[129] = "�����������������������������������������������������������������갂갃갅갆갋갌갍갎갏갘갞갟갡갢갣갥갦갧갨갩갪갫갮갲갳갴������갵갶갷갺갻갽갾갿걁걂걃걄걅걆걇걈걉걊걌걎걏걐걑걒걓걕������걖걗걙걚걛걝걞걟걠걡걢걣걤걥걦걧걨걩걪걫걬걭걮걯걲걳걵걶걹걻걼걽걾걿겂겇겈겍겎겏겑겒겓겕겖겗겘겙겚겛겞겢겣겤겥겦겧겫겭겮겱겲겳겴겵겶겷겺겾겿곀곂곃곅곆곇곉곊곋곍곎곏곐곑곒곓곔곖곘곙곚곛곜곝곞곟곢곣곥곦곩곫곭곮곲곴곷곸곹곺곻곾곿괁괂괃괅괇괈괉괊괋괎괐괒괓�".split("");
for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
D[130] = "�����������������������������������������������������������������괔괕괖괗괙괚괛괝괞괟괡괢괣괤괥괦괧괨괪괫괮괯괰괱괲괳������괶괷괹괺괻괽괾괿굀굁굂굃굆굈굊굋굌굍굎굏굑굒굓굕굖굗������굙굚굛굜굝굞굟굠굢굤굥굦굧굨굩굪굫굮굯굱굲굷굸굹굺굾궀궃궄궅궆궇궊궋궍궎궏궑궒궓궔궕궖궗궘궙궚궛궞궟궠궡궢궣궥궦궧궨궩궪궫궬궭궮궯궰궱궲궳궴궵궶궸궹궺궻궼궽궾궿귂귃귅귆귇귉귊귋귌귍귎귏귒귔귕귖귗귘귙귚귛귝귞귟귡귢귣귥귦귧귨귩귪귫귬귭귮귯귰귱귲귳귴귵귶귷�".split("");
for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
D[131] = "�����������������������������������������������������������������귺귻귽귾긂긃긄긅긆긇긊긌긎긏긐긑긒긓긕긖긗긘긙긚긛긜������긝긞긟긠긡긢긣긤긥긦긧긨긩긪긫긬긭긮긯긲긳긵긶긹긻긼������긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗깘깙깚깛깞깢깣깤깦깧깪깫깭깮깯깱깲깳깴깵깶깷깺깾깿꺀꺁꺂꺃꺆꺇꺈꺉꺊꺋꺍꺎꺏꺐꺑꺒꺓꺔꺕꺖꺗꺘꺙꺚꺛꺜꺝꺞꺟꺠꺡꺢꺣꺤꺥꺦꺧꺨꺩꺪꺫꺬꺭꺮꺯꺰꺱꺲꺳꺴꺵꺶꺷꺸꺹꺺꺻꺿껁껂껃껅껆껇껈껉껊껋껎껒껓껔껕껖껗껚껛껝껞껟껠껡껢껣껤껥�".split("");
for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
D[132] = "�����������������������������������������������������������������껦껧껩껪껬껮껯껰껱껲껳껵껶껷껹껺껻껽껾껿꼀꼁꼂꼃꼄꼅������꼆꼉꼊꼋꼌꼎꼏꼑꼒꼓꼔꼕꼖꼗꼘꼙꼚꼛꼜꼝꼞꼟꼠꼡꼢꼣������꼤꼥꼦꼧꼨꼩꼪꼫꼮꼯꼱꼳꼵꼶꼷꼸꼹꼺꼻꼾꽀꽄꽅꽆꽇꽊꽋꽌꽍꽎꽏꽑꽒꽓꽔꽕꽖꽗꽘꽙꽚꽛꽞꽟꽠꽡꽢꽣꽦꽧꽨꽩꽪꽫꽬꽭꽮꽯꽰꽱꽲꽳꽴꽵꽶꽷꽸꽺꽻꽼꽽꽾꽿꾁꾂꾃꾅꾆꾇꾉꾊꾋꾌꾍꾎꾏꾒꾓꾔꾖꾗꾘꾙꾚꾛꾝꾞꾟꾠꾡꾢꾣꾤꾥꾦꾧꾨꾩꾪꾫꾬꾭꾮꾯꾰꾱꾲꾳꾴꾵꾶꾷꾺꾻꾽꾾�".split("");
for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
D[133] = "�����������������������������������������������������������������꾿꿁꿂꿃꿄꿅꿆꿊꿌꿏꿐꿑꿒꿓꿕꿖꿗꿘꿙꿚꿛꿝꿞꿟꿠꿡������꿢꿣꿤꿥꿦꿧꿪꿫꿬꿭꿮꿯꿲꿳꿵꿶꿷꿹꿺꿻꿼꿽꿾꿿뀂뀃������뀅뀆뀇뀈뀉뀊뀋뀍뀎뀏뀑뀒뀓뀕뀖뀗뀘뀙뀚뀛뀞뀟뀠뀡뀢뀣뀤뀥뀦뀧뀩뀪뀫뀬뀭뀮뀯뀰뀱뀲뀳뀴뀵뀶뀷뀸뀹뀺뀻뀼뀽뀾뀿끀끁끂끃끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞끟끠끡끢끣끤끥끦끧끨끩끪끫끬끭끮끯끰끱끲끳끴끵끶끷끸끹끺끻끾끿낁낂낃낅낆낇낈낉낊낋낎낐낒낓낔낕낖낗낛낝낞낣낤�".split("");
for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
D[134] = "�����������������������������������������������������������������낥낦낧낪낰낲낶낷낹낺낻낽낾낿냀냁냂냃냆냊냋냌냍냎냏냒������냓냕냖냗냙냚냛냜냝냞냟냡냢냣냤냦냧냨냩냪냫냬냭냮냯냰������냱냲냳냴냵냶냷냸냹냺냻냼냽냾냿넀넁넂넃넄넅넆넇넊넍넎넏넑넔넕넖넗넚넞넟넠넡넢넦넧넩넪넫넭넮넯넰넱넲넳넶넺넻넼넽넾넿녂녃녅녆녇녉녊녋녌녍녎녏녒녓녖녗녙녚녛녝녞녟녡녢녣녤녥녦녧녨녩녪녫녬녭녮녯녰녱녲녳녴녵녶녷녺녻녽녾녿놁놃놄놅놆놇놊놌놎놏놐놑놕놖놗놙놚놛놝�".split("");
for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
D[135] = "�����������������������������������������������������������������놞놟놠놡놢놣놤놥놦놧놩놪놫놬놭놮놯놰놱놲놳놴놵놶놷놸������놹놺놻놼놽놾놿뇀뇁뇂뇃뇄뇅뇆뇇뇈뇉뇊뇋뇍뇎뇏뇑뇒뇓뇕������뇖뇗뇘뇙뇚뇛뇞뇠뇡뇢뇣뇤뇥뇦뇧뇪뇫뇭뇮뇯뇱뇲뇳뇴뇵뇶뇷뇸뇺뇼뇾뇿눀눁눂눃눆눇눉눊눍눎눏눐눑눒눓눖눘눚눛눜눝눞눟눡눢눣눤눥눦눧눨눩눪눫눬눭눮눯눰눱눲눳눵눶눷눸눹눺눻눽눾눿뉀뉁뉂뉃뉄뉅뉆뉇뉈뉉뉊뉋뉌뉍뉎뉏뉐뉑뉒뉓뉔뉕뉖뉗뉙뉚뉛뉝뉞뉟뉡뉢뉣뉤뉥뉦뉧뉪뉫뉬뉭뉮�".split("");
for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
D[136] = "�����������������������������������������������������������������뉯뉰뉱뉲뉳뉶뉷뉸뉹뉺뉻뉽뉾뉿늀늁늂늃늆늇늈늊늋늌늍늎������늏늒늓늕늖늗늛늜늝늞늟늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷������늸늹늺늻늼늽늾늿닀닁닂닃닄닅닆닇닊닋닍닎닏닑닓닔닕닖닗닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉댊댋댌댍댎댏댒댖댗댘댙댚댛댝댞댟댠댡댢댣댤댥댦댧댨댩댪댫댬댭댮댯댰댱댲댳댴댵댶댷댸댹댺댻댼댽댾댿덀덁덂덃덄덅덆덇덈덉덊덋덌덍덎덏덐덑덒덓덗덙덚덝덠덡덢덣�".split("");
for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
D[137] = "�����������������������������������������������������������������덦덨덪덬덭덯덲덳덵덶덷덹덺덻덼덽덾덿뎂뎆뎇뎈뎉뎊뎋뎍������뎎뎏뎑뎒뎓뎕뎖뎗뎘뎙뎚뎛뎜뎝뎞뎟뎢뎣뎤뎥뎦뎧뎩뎪뎫뎭������뎮뎯뎰뎱뎲뎳뎴뎵뎶뎷뎸뎹뎺뎻뎼뎽뎾뎿돀돁돂돃돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩돪돫돬돭돮돯돰돱돲돳돴돵돶돷돸돹돺돻돽돾돿됀됁됂됃됄됅됆됇됈됉됊됋됌됍됎됏됑됒됓됔됕됖됗됙됚됛됝됞됟됡됢됣됤됥됦됧됪됬됭됮됯됰됱됲됳됵됶됷됸됹됺됻됼됽됾됿둀둁둂둃둄�".split("");
for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
D[138] = "�����������������������������������������������������������������둅둆둇둈둉둊둋둌둍둎둏둒둓둕둖둗둙둚둛둜둝둞둟둢둤둦������둧둨둩둪둫둭둮둯둰둱둲둳둴둵둶둷둸둹둺둻둼둽둾둿뒁뒂������뒃뒄뒅뒆뒇뒉뒊뒋뒌뒍뒎뒏뒐뒑뒒뒓뒔뒕뒖뒗뒘뒙뒚뒛뒜뒞뒟뒠뒡뒢뒣뒥뒦뒧뒩뒪뒫뒭뒮뒯뒰뒱뒲뒳뒴뒶뒸뒺뒻뒼뒽뒾뒿듁듂듃듅듆듇듉듊듋듌듍듎듏듑듒듓듔듖듗듘듙듚듛듞듟듡듢듥듧듨듩듪듫듮듰듲듳듴듵듶듷듹듺듻듼듽듾듿딀딁딂딃딄딅딆딇딈딉딊딋딌딍딎딏딐딑딒딓딖딗딙딚딝�".split("");
for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
D[139] = "�����������������������������������������������������������������딞딟딠딡딢딣딦딫딬딭딮딯딲딳딵딶딷딹딺딻딼딽딾딿땂땆������땇땈땉땊땎땏땑땒땓땕땖땗땘땙땚땛땞땢땣땤땥땦땧땨땩땪������땫땬땭땮땯땰땱땲땳땴땵땶땷땸땹땺땻땼땽땾땿떀떁떂떃떄떅떆떇떈떉떊떋떌떍떎떏떐떑떒떓떔떕떖떗떘떙떚떛떜떝떞떟떢떣떥떦떧떩떬떭떮떯떲떶떷떸떹떺떾떿뗁뗂뗃뗅뗆뗇뗈뗉뗊뗋뗎뗒뗓뗔뗕뗖뗗뗙뗚뗛뗜뗝뗞뗟뗠뗡뗢뗣뗤뗥뗦뗧뗨뗩뗪뗫뗭뗮뗯뗰뗱뗲뗳뗴뗵뗶뗷뗸뗹뗺뗻뗼뗽뗾뗿�".split("");
for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
D[140] = "�����������������������������������������������������������������똀똁똂똃똄똅똆똇똈똉똊똋똌똍똎똏똒똓똕똖똗똙똚똛똜똝������똞똟똠똡똢똣똤똦똧똨똩똪똫똭똮똯똰똱똲똳똵똶똷똸똹똺������똻똼똽똾똿뙀뙁뙂뙃뙄뙅뙆뙇뙉뙊뙋뙌뙍뙎뙏뙐뙑뙒뙓뙔뙕뙖뙗뙘뙙뙚뙛뙜뙝뙞뙟뙠뙡뙢뙣뙥뙦뙧뙩뙪뙫뙬뙭뙮뙯뙰뙱뙲뙳뙴뙵뙶뙷뙸뙹뙺뙻뙼뙽뙾뙿뚀뚁뚂뚃뚄뚅뚆뚇뚈뚉뚊뚋뚌뚍뚎뚏뚐뚑뚒뚓뚔뚕뚖뚗뚘뚙뚚뚛뚞뚟뚡뚢뚣뚥뚦뚧뚨뚩뚪뚭뚮뚯뚰뚲뚳뚴뚵뚶뚷뚸뚹뚺뚻뚼뚽뚾뚿뛀뛁뛂�".split("");
for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
D[141] = "�����������������������������������������������������������������뛃뛄뛅뛆뛇뛈뛉뛊뛋뛌뛍뛎뛏뛐뛑뛒뛓뛕뛖뛗뛘뛙뛚뛛뛜뛝������뛞뛟뛠뛡뛢뛣뛤뛥뛦뛧뛨뛩뛪뛫뛬뛭뛮뛯뛱뛲뛳뛵뛶뛷뛹뛺������뛻뛼뛽뛾뛿뜂뜃뜄뜆뜇뜈뜉뜊뜋뜌뜍뜎뜏뜐뜑뜒뜓뜔뜕뜖뜗뜘뜙뜚뜛뜜뜝뜞뜟뜠뜡뜢뜣뜤뜥뜦뜧뜪뜫뜭뜮뜱뜲뜳뜴뜵뜶뜷뜺뜼뜽뜾뜿띀띁띂띃띅띆띇띉띊띋띍띎띏띐띑띒띓띖띗띘띙띚띛띜띝띞띟띡띢띣띥띦띧띩띪띫띬띭띮띯띲띴띶띷띸띹띺띻띾띿랁랂랃랅랆랇랈랉랊랋랎랓랔랕랚랛랝랞�".split("");
for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
D[142] = "�����������������������������������������������������������������랟랡랢랣랤랥랦랧랪랮랯랰랱랲랳랶랷랹랺랻랼랽랾랿럀럁������럂럃럄럅럆럈럊럋럌럍럎럏럐럑럒럓럔럕럖럗럘럙럚럛럜럝������럞럟럠럡럢럣럤럥럦럧럨럩럪럫럮럯럱럲럳럵럶럷럸럹럺럻럾렂렃렄렅렆렊렋렍렎렏렑렒렓렔렕렖렗렚렜렞렟렠렡렢렣렦렧렩렪렫렭렮렯렰렱렲렳렶렺렻렼렽렾렿롁롂롃롅롆롇롈롉롊롋롌롍롎롏롐롒롔롕롖롗롘롙롚롛롞롟롡롢롣롥롦롧롨롩롪롫롮롰롲롳롴롵롶롷롹롺롻롽롾롿뢀뢁뢂뢃뢄�".split("");
for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
D[143] = "�����������������������������������������������������������������뢅뢆뢇뢈뢉뢊뢋뢌뢎뢏뢐뢑뢒뢓뢔뢕뢖뢗뢘뢙뢚뢛뢜뢝뢞뢟������뢠뢡뢢뢣뢤뢥뢦뢧뢩뢪뢫뢬뢭뢮뢯뢱뢲뢳뢵뢶뢷뢹뢺뢻뢼뢽������뢾뢿룂룄룆룇룈룉룊룋룍룎룏룑룒룓룕룖룗룘룙룚룛룜룞룠룢룣룤룥룦룧룪룫룭룮룯룱룲룳룴룵룶룷룺룼룾룿뤀뤁뤂뤃뤅뤆뤇뤈뤉뤊뤋뤌뤍뤎뤏뤐뤑뤒뤓뤔뤕뤖뤗뤙뤚뤛뤜뤝뤞뤟뤡뤢뤣뤤뤥뤦뤧뤨뤩뤪뤫뤬뤭뤮뤯뤰뤱뤲뤳뤴뤵뤶뤷뤸뤹뤺뤻뤾뤿륁륂륃륅륆륇륈륉륊륋륍륎륐륒륓륔륕륖륗�".split("");
for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
D[144] = "�����������������������������������������������������������������륚륛륝륞륟륡륢륣륤륥륦륧륪륬륮륯륰륱륲륳륶륷륹륺륻륽������륾륿릀릁릂릃릆릈릋릌릏릐릑릒릓릔릕릖릗릘릙릚릛릜릝릞������릟릠릡릢릣릤릥릦릧릨릩릪릫릮릯릱릲릳릵릶릷릸릹릺릻릾맀맂맃맄맅맆맇맊맋맍맓맔맕맖맗맚맜맟맠맢맦맧맩맪맫맭맮맯맰맱맲맳맶맻맼맽맾맿먂먃먄먅먆먇먉먊먋먌먍먎먏먐먑먒먓먔먖먗먘먙먚먛먜먝먞먟먠먡먢먣먤먥먦먧먨먩먪먫먬먭먮먯먰먱먲먳먴먵먶먷먺먻먽먾먿멁멃멄멅멆�".split("");
for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
D[145] = "�����������������������������������������������������������������멇멊멌멏멐멑멒멖멗멙멚멛멝멞멟멠멡멢멣멦멪멫멬멭멮멯������멲멳멵멶멷멹멺멻멼멽멾멿몀몁몂몆몈몉몊몋몍몎몏몐몑몒������몓몔몕몖몗몘몙몚몛몜몝몞몟몠몡몢몣몤몥몦몧몪몭몮몯몱몳몴몵몶몷몺몼몾몿뫀뫁뫂뫃뫅뫆뫇뫉뫊뫋뫌뫍뫎뫏뫐뫑뫒뫓뫔뫕뫖뫗뫚뫛뫜뫝뫞뫟뫠뫡뫢뫣뫤뫥뫦뫧뫨뫩뫪뫫뫬뫭뫮뫯뫰뫱뫲뫳뫴뫵뫶뫷뫸뫹뫺뫻뫽뫾뫿묁묂묃묅묆묇묈묉묊묋묌묎묐묒묓묔묕묖묗묙묚묛묝묞묟묡묢묣묤묥묦묧�".split("");
for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
D[146] = "�����������������������������������������������������������������묨묪묬묭묮묯묰묱묲묳묷묹묺묿뭀뭁뭂뭃뭆뭈뭊뭋뭌뭎뭑뭒������뭓뭕뭖뭗뭙뭚뭛뭜뭝뭞뭟뭠뭢뭤뭥뭦뭧뭨뭩뭪뭫뭭뭮뭯뭰뭱������뭲뭳뭴뭵뭶뭷뭸뭹뭺뭻뭼뭽뭾뭿뮀뮁뮂뮃뮄뮅뮆뮇뮉뮊뮋뮍뮎뮏뮑뮒뮓뮔뮕뮖뮗뮘뮙뮚뮛뮜뮝뮞뮟뮠뮡뮢뮣뮥뮦뮧뮩뮪뮫뮭뮮뮯뮰뮱뮲뮳뮵뮶뮸뮹뮺뮻뮼뮽뮾뮿믁믂믃믅믆믇믉믊믋믌믍믎믏믑믒믔믕믖믗믘믙믚믛믜믝믞믟믠믡믢믣믤믥믦믧믨믩믪믫믬믭믮믯믰믱믲믳믴믵믶믷믺믻믽믾밁�".split("");
for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
D[147] = "�����������������������������������������������������������������밃밄밅밆밇밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵������밶밷밹밺밻밼밽밾밿뱂뱆뱇뱈뱊뱋뱎뱏뱑뱒뱓뱔뱕뱖뱗뱘뱙������뱚뱛뱜뱞뱟뱠뱡뱢뱣뱤뱥뱦뱧뱨뱩뱪뱫뱬뱭뱮뱯뱰뱱뱲뱳뱴뱵뱶뱷뱸뱹뱺뱻뱼뱽뱾뱿벀벁벂벃벆벇벉벊벍벏벐벑벒벓벖벘벛벜벝벞벟벢벣벥벦벩벪벫벬벭벮벯벲벶벷벸벹벺벻벾벿볁볂볃볅볆볇볈볉볊볋볌볎볒볓볔볖볗볙볚볛볝볞볟볠볡볢볣볤볥볦볧볨볩볪볫볬볭볮볯볰볱볲볳볷볹볺볻볽�".split("");
for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
D[148] = "�����������������������������������������������������������������볾볿봀봁봂봃봆봈봊봋봌봍봎봏봑봒봓봕봖봗봘봙봚봛봜봝������봞봟봠봡봢봣봥봦봧봨봩봪봫봭봮봯봰봱봲봳봴봵봶봷봸봹������봺봻봼봽봾봿뵁뵂뵃뵄뵅뵆뵇뵊뵋뵍뵎뵏뵑뵒뵓뵔뵕뵖뵗뵚뵛뵜뵝뵞뵟뵠뵡뵢뵣뵥뵦뵧뵩뵪뵫뵬뵭뵮뵯뵰뵱뵲뵳뵴뵵뵶뵷뵸뵹뵺뵻뵼뵽뵾뵿붂붃붅붆붋붌붍붎붏붒붔붖붗붘붛붝붞붟붠붡붢붣붥붦붧붨붩붪붫붬붭붮붯붱붲붳붴붵붶붷붹붺붻붼붽붾붿뷀뷁뷂뷃뷄뷅뷆뷇뷈뷉뷊뷋뷌뷍뷎뷏뷐뷑�".split("");
for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
D[149] = "�����������������������������������������������������������������뷒뷓뷖뷗뷙뷚뷛뷝뷞뷟뷠뷡뷢뷣뷤뷥뷦뷧뷨뷪뷫뷬뷭뷮뷯뷱������뷲뷳뷵뷶뷷뷹뷺뷻뷼뷽뷾뷿븁븂븄븆븇븈븉븊븋븎븏븑븒븓������븕븖븗븘븙븚븛븞븠븡븢븣븤븥븦븧븨븩븪븫븬븭븮븯븰븱븲븳븴븵븶븷븸븹븺븻븼븽븾븿빀빁빂빃빆빇빉빊빋빍빏빐빑빒빓빖빘빜빝빞빟빢빣빥빦빧빩빫빬빭빮빯빲빶빷빸빹빺빾빿뺁뺂뺃뺅뺆뺇뺈뺉뺊뺋뺎뺒뺓뺔뺕뺖뺗뺚뺛뺜뺝뺞뺟뺠뺡뺢뺣뺤뺥뺦뺧뺩뺪뺫뺬뺭뺮뺯뺰뺱뺲뺳뺴뺵뺶뺷�".split("");
for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
D[150] = "�����������������������������������������������������������������뺸뺹뺺뺻뺼뺽뺾뺿뻀뻁뻂뻃뻄뻅뻆뻇뻈뻉뻊뻋뻌뻍뻎뻏뻒뻓������뻕뻖뻙뻚뻛뻜뻝뻞뻟뻡뻢뻦뻧뻨뻩뻪뻫뻭뻮뻯뻰뻱뻲뻳뻴뻵������뻶뻷뻸뻹뻺뻻뻼뻽뻾뻿뼀뼂뼃뼄뼅뼆뼇뼊뼋뼌뼍뼎뼏뼐뼑뼒뼓뼔뼕뼖뼗뼚뼞뼟뼠뼡뼢뼣뼤뼥뼦뼧뼨뼩뼪뼫뼬뼭뼮뼯뼰뼱뼲뼳뼴뼵뼶뼷뼸뼹뼺뼻뼼뼽뼾뼿뽂뽃뽅뽆뽇뽉뽊뽋뽌뽍뽎뽏뽒뽓뽔뽖뽗뽘뽙뽚뽛뽜뽝뽞뽟뽠뽡뽢뽣뽤뽥뽦뽧뽨뽩뽪뽫뽬뽭뽮뽯뽰뽱뽲뽳뽴뽵뽶뽷뽸뽹뽺뽻뽼뽽뽾뽿뾀뾁뾂�".split("");
for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
D[151] = "�����������������������������������������������������������������뾃뾄뾅뾆뾇뾈뾉뾊뾋뾌뾍뾎뾏뾐뾑뾒뾓뾕뾖뾗뾘뾙뾚뾛뾜뾝������뾞뾟뾠뾡뾢뾣뾤뾥뾦뾧뾨뾩뾪뾫뾬뾭뾮뾯뾱뾲뾳뾴뾵뾶뾷뾸������뾹뾺뾻뾼뾽뾾뾿뿀뿁뿂뿃뿄뿆뿇뿈뿉뿊뿋뿎뿏뿑뿒뿓뿕뿖뿗뿘뿙뿚뿛뿝뿞뿠뿢뿣뿤뿥뿦뿧뿨뿩뿪뿫뿬뿭뿮뿯뿰뿱뿲뿳뿴뿵뿶뿷뿸뿹뿺뿻뿼뿽뿾뿿쀀쀁쀂쀃쀄쀅쀆쀇쀈쀉쀊쀋쀌쀍쀎쀏쀐쀑쀒쀓쀔쀕쀖쀗쀘쀙쀚쀛쀜쀝쀞쀟쀠쀡쀢쀣쀤쀥쀦쀧쀨쀩쀪쀫쀬쀭쀮쀯쀰쀱쀲쀳쀴쀵쀶쀷쀸쀹쀺쀻쀽쀾쀿�".split("");
for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
D[152] = "�����������������������������������������������������������������쁀쁁쁂쁃쁄쁅쁆쁇쁈쁉쁊쁋쁌쁍쁎쁏쁐쁒쁓쁔쁕쁖쁗쁙쁚쁛������쁝쁞쁟쁡쁢쁣쁤쁥쁦쁧쁪쁫쁬쁭쁮쁯쁰쁱쁲쁳쁴쁵쁶쁷쁸쁹������쁺쁻쁼쁽쁾쁿삀삁삂삃삄삅삆삇삈삉삊삋삌삍삎삏삒삓삕삖삗삙삚삛삜삝삞삟삢삤삦삧삨삩삪삫삮삱삲삷삸삹삺삻삾샂샃샄샆샇샊샋샍샎샏샑샒샓샔샕샖샗샚샞샟샠샡샢샣샦샧샩샪샫샭샮샯샰샱샲샳샶샸샺샻샼샽샾샿섁섂섃섅섆섇섉섊섋섌섍섎섏섑섒섓섔섖섗섘섙섚섛섡섢섥섨섩섪섫섮�".split("");
for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
D[153] = "�����������������������������������������������������������������섲섳섴섵섷섺섻섽섾섿셁셂셃셄셅셆셇셊셎셏셐셑셒셓셖셗������셙셚셛셝셞셟셠셡셢셣셦셪셫셬셭셮셯셱셲셳셵셶셷셹셺셻������셼셽셾셿솀솁솂솃솄솆솇솈솉솊솋솏솑솒솓솕솗솘솙솚솛솞솠솢솣솤솦솧솪솫솭솮솯솱솲솳솴솵솶솷솸솹솺솻솼솾솿쇀쇁쇂쇃쇅쇆쇇쇉쇊쇋쇍쇎쇏쇐쇑쇒쇓쇕쇖쇙쇚쇛쇜쇝쇞쇟쇡쇢쇣쇥쇦쇧쇩쇪쇫쇬쇭쇮쇯쇲쇴쇵쇶쇷쇸쇹쇺쇻쇾쇿숁숂숃숅숆숇숈숉숊숋숎숐숒숓숔숕숖숗숚숛숝숞숡숢숣�".split("");
for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
D[154] = "�����������������������������������������������������������������숤숥숦숧숪숬숮숰숳숵숶숷숸숹숺숻숼숽숾숿쉀쉁쉂쉃쉄쉅������쉆쉇쉉쉊쉋쉌쉍쉎쉏쉒쉓쉕쉖쉗쉙쉚쉛쉜쉝쉞쉟쉡쉢쉣쉤쉦������쉧쉨쉩쉪쉫쉮쉯쉱쉲쉳쉵쉶쉷쉸쉹쉺쉻쉾슀슂슃슄슅슆슇슊슋슌슍슎슏슑슒슓슔슕슖슗슙슚슜슞슟슠슡슢슣슦슧슩슪슫슮슯슰슱슲슳슶슸슺슻슼슽슾슿싀싁싂싃싄싅싆싇싈싉싊싋싌싍싎싏싐싑싒싓싔싕싖싗싘싙싚싛싞싟싡싢싥싦싧싨싩싪싮싰싲싳싴싵싷싺싽싾싿쌁쌂쌃쌄쌅쌆쌇쌊쌋쌎쌏�".split("");
for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
D[155] = "�����������������������������������������������������������������쌐쌑쌒쌖쌗쌙쌚쌛쌝쌞쌟쌠쌡쌢쌣쌦쌧쌪쌫쌬쌭쌮쌯쌰쌱쌲������쌳쌴쌵쌶쌷쌸쌹쌺쌻쌼쌽쌾쌿썀썁썂썃썄썆썇썈썉썊썋썌썍������썎썏썐썑썒썓썔썕썖썗썘썙썚썛썜썝썞썟썠썡썢썣썤썥썦썧썪썫썭썮썯썱썳썴썵썶썷썺썻썾썿쎀쎁쎂쎃쎅쎆쎇쎉쎊쎋쎍쎎쎏쎐쎑쎒쎓쎔쎕쎖쎗쎘쎙쎚쎛쎜쎝쎞쎟쎠쎡쎢쎣쎤쎥쎦쎧쎨쎩쎪쎫쎬쎭쎮쎯쎰쎱쎲쎳쎴쎵쎶쎷쎸쎹쎺쎻쎼쎽쎾쎿쏁쏂쏃쏄쏅쏆쏇쏈쏉쏊쏋쏌쏍쏎쏏쏐쏑쏒쏓쏔쏕쏖쏗쏚�".split("");
for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
D[156] = "�����������������������������������������������������������������쏛쏝쏞쏡쏣쏤쏥쏦쏧쏪쏫쏬쏮쏯쏰쏱쏲쏳쏶쏷쏹쏺쏻쏼쏽쏾������쏿쐀쐁쐂쐃쐄쐅쐆쐇쐉쐊쐋쐌쐍쐎쐏쐑쐒쐓쐔쐕쐖쐗쐘쐙쐚������쐛쐜쐝쐞쐟쐠쐡쐢쐣쐥쐦쐧쐨쐩쐪쐫쐭쐮쐯쐱쐲쐳쐵쐶쐷쐸쐹쐺쐻쐾쐿쑀쑁쑂쑃쑄쑅쑆쑇쑉쑊쑋쑌쑍쑎쑏쑐쑑쑒쑓쑔쑕쑖쑗쑘쑙쑚쑛쑜쑝쑞쑟쑠쑡쑢쑣쑦쑧쑩쑪쑫쑭쑮쑯쑰쑱쑲쑳쑶쑷쑸쑺쑻쑼쑽쑾쑿쒁쒂쒃쒄쒅쒆쒇쒈쒉쒊쒋쒌쒍쒎쒏쒐쒑쒒쒓쒕쒖쒗쒘쒙쒚쒛쒝쒞쒟쒠쒡쒢쒣쒤쒥쒦쒧쒨쒩�".split("");
for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
D[157] = "�����������������������������������������������������������������쒪쒫쒬쒭쒮쒯쒰쒱쒲쒳쒴쒵쒶쒷쒹쒺쒻쒽쒾쒿쓀쓁쓂쓃쓄쓅������쓆쓇쓈쓉쓊쓋쓌쓍쓎쓏쓐쓑쓒쓓쓔쓕쓖쓗쓘쓙쓚쓛쓜쓝쓞쓟������쓠쓡쓢쓣쓤쓥쓦쓧쓨쓪쓫쓬쓭쓮쓯쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂씃씄씅씆씇씈씉씊씋씍씎씏씑씒씓씕씖씗씘씙씚씛씝씞씟씠씡씢씣씤씥씦씧씪씫씭씮씯씱씲씳씴씵씶씷씺씼씾씿앀앁앂앃앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩앪앫앬앭앮앯앲앶앷앸앹앺앻앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔�".split("");
for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
D[158] = "�����������������������������������������������������������������얖얙얚얛얝얞얟얡얢얣얤얥얦얧얨얪얫얬얭얮얯얰얱얲얳얶������얷얺얿엀엁엂엃엋엍엏엒엓엕엖엗엙엚엛엜엝엞엟엢엤엦엧������엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑옒옓옔옕옖옗옚옝옞옟옠옡옢옣옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉왊왋왌왍왎왏왒왖왗왘왙왚왛왞왟왡왢왣왤왥왦왧왨왩왪왫왭왮왰왲왳왴왵왶왷왺왻왽왾왿욁욂욃욄욅욆욇욊욌욎욏욐욑욒욓욖욗욙욚욛욝욞욟욠욡욢욣욦�".split("");
for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
D[159] = "�����������������������������������������������������������������욨욪욫욬욭욮욯욲욳욵욶욷욻욼욽욾욿웂웄웆웇웈웉웊웋웎������웏웑웒웓웕웖웗웘웙웚웛웞웟웢웣웤웥웦웧웪웫웭웮웯웱웲������웳웴웵웶웷웺웻웼웾웿윀윁윂윃윆윇윉윊윋윍윎윏윐윑윒윓윖윘윚윛윜윝윞윟윢윣윥윦윧윩윪윫윬윭윮윯윲윴윶윸윹윺윻윾윿읁읂읃읅읆읇읈읉읋읎읐읙읚읛읝읞읟읡읢읣읤읥읦읧읩읪읬읭읮읯읰읱읲읳읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛잜잝잞잟잢잧잨잩잪잫잮잯잱잲잳잵잶잷�".split("");
for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
D[160] = "�����������������������������������������������������������������잸잹잺잻잾쟂쟃쟄쟅쟆쟇쟊쟋쟍쟏쟑쟒쟓쟔쟕쟖쟗쟙쟚쟛쟜������쟞쟟쟠쟡쟢쟣쟥쟦쟧쟩쟪쟫쟭쟮쟯쟰쟱쟲쟳쟴쟵쟶쟷쟸쟹쟺������쟻쟼쟽쟾쟿젂젃젅젆젇젉젋젌젍젎젏젒젔젗젘젙젚젛젞젟젡젢젣젥젦젧젨젩젪젫젮젰젲젳젴젵젶젷젹젺젻젽젾젿졁졂졃졄졅졆졇졊졋졎졏졐졑졒졓졕졖졗졘졙졚졛졜졝졞졟졠졡졢졣졤졥졦졧졨졩졪졫졬졭졮졯졲졳졵졶졷졹졻졼졽졾졿좂좄좈좉좊좎좏좐좑좒좓좕좖좗좘좙좚좛좜좞좠좢좣좤�".split("");
for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
D[161] = "�����������������������������������������������������������������좥좦좧좩좪좫좬좭좮좯좰좱좲좳좴좵좶좷좸좹좺좻좾좿죀죁������죂죃죅죆죇죉죊죋죍죎죏죐죑죒죓죖죘죚죛죜죝죞죟죢죣죥������죦죧죨죩죪죫죬죭죮죯죰죱죲죳죴죶죷죸죹죺죻죾죿줁줂줃줇줈줉줊줋줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈〉《》「」『』【】±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢�".split("");
for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
D[162] = "�����������������������������������������������������������������줐줒줓줔줕줖줗줙줚줛줜줝줞줟줠줡줢줣줤줥줦줧줨줩줪줫������줭줮줯줰줱줲줳줵줶줷줸줹줺줻줼줽줾줿쥀쥁쥂쥃쥄쥅쥆쥇������쥈쥉쥊쥋쥌쥍쥎쥏쥒쥓쥕쥖쥗쥙쥚쥛쥜쥝쥞쥟쥢쥤쥥쥦쥧쥨쥩쥪쥫쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®������������������������".split("");
for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
D[163] = "�����������������������������������������������������������������쥱쥲쥳쥵쥶쥷쥸쥹쥺쥻쥽쥾쥿즀즁즂즃즄즅즆즇즊즋즍즎즏������즑즒즓즔즕즖즗즚즜즞즟즠즡즢즣즤즥즦즧즨즩즪즫즬즭즮������즯즰즱즲즳즴즵즶즷즸즹즺즻즼즽즾즿짂짃짅짆짉짋짌짍짎짏짒짔짗짘짛！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［￦］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
D[164] = "�����������������������������������������������������������������짞짟짡짣짥짦짨짩짪짫짮짲짳짴짵짶짷짺짻짽짾짿쨁쨂쨃쨄������쨅쨆쨇쨊쨎쨏쨐쨑쨒쨓쨕쨖쨗쨙쨚쨛쨜쨝쨞쨟쨠쨡쨢쨣쨤쨥������쨦쨧쨨쨪쨫쨬쨭쨮쨯쨰쨱쨲쨳쨴쨵쨶쨷쨸쨹쨺쨻쨼쨽쨾쨿쩀쩁쩂쩃쩄쩅쩆ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅤㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ�".split("");
for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
D[165] = "�����������������������������������������������������������������쩇쩈쩉쩊쩋쩎쩏쩑쩒쩓쩕쩖쩗쩘쩙쩚쩛쩞쩢쩣쩤쩥쩦쩧쩩쩪������쩫쩬쩭쩮쩯쩰쩱쩲쩳쩴쩵쩶쩷쩸쩹쩺쩻쩼쩾쩿쪀쪁쪂쪃쪅쪆������쪇쪈쪉쪊쪋쪌쪍쪎쪏쪐쪑쪒쪓쪔쪕쪖쪗쪙쪚쪛쪜쪝쪞쪟쪠쪡쪢쪣쪤쪥쪦쪧ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ�����ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������".split("");
for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
D[166] = "�����������������������������������������������������������������쪨쪩쪪쪫쪬쪭쪮쪯쪰쪱쪲쪳쪴쪵쪶쪷쪸쪹쪺쪻쪾쪿쫁쫂쫃쫅������쫆쫇쫈쫉쫊쫋쫎쫐쫒쫔쫕쫖쫗쫚쫛쫜쫝쫞쫟쫡쫢쫣쫤쫥쫦쫧������쫨쫩쫪쫫쫭쫮쫯쫰쫱쫲쫳쫵쫶쫷쫸쫹쫺쫻쫼쫽쫾쫿쬀쬁쬂쬃쬄쬅쬆쬇쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊���������������������������".split("");
for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
D[167] = "�����������������������������������������������������������������쬋쬌쬍쬎쬏쬑쬒쬓쬕쬖쬗쬙쬚쬛쬜쬝쬞쬟쬢쬣쬤쬥쬦쬧쬨쬩������쬪쬫쬬쬭쬮쬯쬰쬱쬲쬳쬴쬵쬶쬷쬸쬹쬺쬻쬼쬽쬾쬿쭀쭂쭃쭄������쭅쭆쭇쭊쭋쭍쭎쭏쭑쭒쭓쭔쭕쭖쭗쭚쭛쭜쭞쭟쭠쭡쭢쭣쭥쭦쭧쭨쭩쭪쭫쭬㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙㎚㎛㎜㎝㎞㎟㎠㎡㎢㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰㎱㎲㎳㎴㎵㎶㎷㎸㎹㎀㎁㎂㎃㎄㎺㎻㎼㎽㎾㎿㎐㎑㎒㎓㎔Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆����������������".split("");
for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
D[168] = "�����������������������������������������������������������������쭭쭮쭯쭰쭱쭲쭳쭴쭵쭶쭷쭺쭻쭼쭽쭾쭿쮀쮁쮂쮃쮄쮅쮆쮇쮈������쮉쮊쮋쮌쮍쮎쮏쮐쮑쮒쮓쮔쮕쮖쮗쮘쮙쮚쮛쮝쮞쮟쮠쮡쮢쮣������쮤쮥쮦쮧쮨쮩쮪쮫쮬쮭쮮쮯쮰쮱쮲쮳쮴쮵쮶쮷쮹쮺쮻쮼쮽쮾쮿쯀쯁쯂쯃쯄ÆÐªĦ�Ĳ�ĿŁØŒºÞŦŊ�㉠㉡㉢㉣㉤㉥㉦㉧㉨㉩㉪㉫㉬㉭㉮㉯㉰㉱㉲㉳㉴㉵㉶㉷㉸㉹㉺㉻ⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮½⅓⅔¼¾⅛⅜⅝⅞�".split("");
for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
D[169] = "�����������������������������������������������������������������쯅쯆쯇쯈쯉쯊쯋쯌쯍쯎쯏쯐쯑쯒쯓쯕쯖쯗쯘쯙쯚쯛쯜쯝쯞쯟������쯠쯡쯢쯣쯥쯦쯨쯪쯫쯬쯭쯮쯯쯰쯱쯲쯳쯴쯵쯶쯷쯸쯹쯺쯻쯼������쯽쯾쯿찀찁찂찃찄찅찆찇찈찉찊찋찎찏찑찒찓찕찖찗찘찙찚찛찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀㈁㈂㈃㈄㈅㈆㈇㈈㈉㈊㈋㈌㈍㈎㈏㈐㈑㈒㈓㈔㈕㈖㈗㈘㈙㈚㈛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂¹²³⁴ⁿ₁₂₃₄�".split("");
for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
D[170] = "�����������������������������������������������������������������찥찦찪찫찭찯찱찲찳찴찵찶찷찺찿챀챁챂챃챆챇챉챊챋챍챎������챏챐챑챒챓챖챚챛챜챝챞챟챡챢챣챥챧챩챪챫챬챭챮챯챱챲������챳챴챶챷챸챹챺챻챼챽챾챿첀첁첂첃첄첅첆첇첈첉첊첋첌첍첎첏첐첑첒첓ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
D[171] = "�����������������������������������������������������������������첔첕첖첗첚첛첝첞첟첡첢첣첤첥첦첧첪첮첯첰첱첲첳첶첷첹������첺첻첽첾첿쳀쳁쳂쳃쳆쳈쳊쳋쳌쳍쳎쳏쳑쳒쳓쳕쳖쳗쳘쳙쳚������쳛쳜쳝쳞쳟쳠쳡쳢쳣쳥쳦쳧쳨쳩쳪쳫쳭쳮쳯쳱쳲쳳쳴쳵쳶쳷쳸쳹쳺쳻쳼쳽ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
D[172] = "�����������������������������������������������������������������쳾쳿촀촂촃촄촅촆촇촊촋촍촎촏촑촒촓촔촕촖촗촚촜촞촟촠������촡촢촣촥촦촧촩촪촫촭촮촯촰촱촲촳촴촵촶촷촸촺촻촼촽촾������촿쵀쵁쵂쵃쵄쵅쵆쵇쵈쵉쵊쵋쵌쵍쵎쵏쵐쵑쵒쵓쵔쵕쵖쵗쵘쵙쵚쵛쵝쵞쵟АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
D[173] = "�����������������������������������������������������������������쵡쵢쵣쵥쵦쵧쵨쵩쵪쵫쵮쵰쵲쵳쵴쵵쵶쵷쵹쵺쵻쵼쵽쵾쵿춀������춁춂춃춄춅춆춇춉춊춋춌춍춎춏춐춑춒춓춖춗춙춚춛춝춞춟������춠춡춢춣춦춨춪춫춬춭춮춯춱춲춳춴춵춶춷춸춹춺춻춼춽춾춿췀췁췂췃췅�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
D[174] = "�����������������������������������������������������������������췆췇췈췉췊췋췍췎췏췑췒췓췔췕췖췗췘췙췚췛췜췝췞췟췠췡������췢췣췤췥췦췧췩췪췫췭췮췯췱췲췳췴췵췶췷췺췼췾췿츀츁츂������츃츅츆츇츉츊츋츍츎츏츐츑츒츓츕츖츗츘츚츛츜츝츞츟츢츣츥츦츧츩츪츫�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
D[175] = "�����������������������������������������������������������������츬츭츮츯츲츴츶츷츸츹츺츻츼츽츾츿칀칁칂칃칄칅칆칇칈칉������칊칋칌칍칎칏칐칑칒칓칔칕칖칗칚칛칝칞칢칣칤칥칦칧칪칬������칮칯칰칱칲칳칶칷칹칺칻칽칾칿캀캁캂캃캆캈캊캋캌캍캎캏캒캓캕캖캗캙�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
D[176] = "�����������������������������������������������������������������캚캛캜캝캞캟캢캦캧캨캩캪캫캮캯캰캱캲캳캴캵캶캷캸캹캺������캻캼캽캾캿컀컂컃컄컅컆컇컈컉컊컋컌컍컎컏컐컑컒컓컔컕������컖컗컘컙컚컛컜컝컞컟컠컡컢컣컦컧컩컪컭컮컯컰컱컲컳컶컺컻컼컽컾컿가각간갇갈갉갊감갑값갓갔강갖갗같갚갛개객갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆�".split("");
for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
D[177] = "�����������������������������������������������������������������켂켃켅켆켇켉켊켋켌켍켎켏켒켔켖켗켘켙켚켛켝켞켟켡켢켣������켥켦켧켨켩켪켫켮켲켳켴켵켶켷켹켺켻켼켽켾켿콀콁콂콃콄������콅콆콇콈콉콊콋콌콍콎콏콐콑콒콓콖콗콙콚콛콝콞콟콠콡콢콣콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸�".split("");
for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
D[178] = "�����������������������������������������������������������������콭콮콯콲콳콵콶콷콹콺콻콼콽콾콿쾁쾂쾃쾄쾆쾇쾈쾉쾊쾋쾍������쾎쾏쾐쾑쾒쾓쾔쾕쾖쾗쾘쾙쾚쾛쾜쾝쾞쾟쾠쾢쾣쾤쾥쾦쾧쾩������쾪쾫쾬쾭쾮쾯쾱쾲쾳쾴쾵쾶쾷쾸쾹쾺쾻쾼쾽쾾쾿쿀쿁쿂쿃쿅쿆쿇쿈쿉쿊쿋깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙�".split("");
for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
D[179] = "�����������������������������������������������������������������쿌쿍쿎쿏쿐쿑쿒쿓쿔쿕쿖쿗쿘쿙쿚쿛쿜쿝쿞쿟쿢쿣쿥쿦쿧쿩������쿪쿫쿬쿭쿮쿯쿲쿴쿶쿷쿸쿹쿺쿻쿽쿾쿿퀁퀂퀃퀅퀆퀇퀈퀉퀊������퀋퀌퀍퀎퀏퀐퀒퀓퀔퀕퀖퀗퀙퀚퀛퀜퀝퀞퀟퀠퀡퀢퀣퀤퀥퀦퀧퀨퀩퀪퀫퀬끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫났낭낮낯낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝�".split("");
for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
D[180] = "�����������������������������������������������������������������퀮퀯퀰퀱퀲퀳퀶퀷퀹퀺퀻퀽퀾퀿큀큁큂큃큆큈큊큋큌큍큎큏������큑큒큓큕큖큗큙큚큛큜큝큞큟큡큢큣큤큥큦큧큨큩큪큫큮큯������큱큲큳큵큶큷큸큹큺큻큾큿킀킂킃킄킅킆킇킈킉킊킋킌킍킎킏킐킑킒킓킔뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫달닭닮닯닳담답닷닸당닺닻닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥�".split("");
for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
D[181] = "�����������������������������������������������������������������킕킖킗킘킙킚킛킜킝킞킟킠킡킢킣킦킧킩킪킫킭킮킯킰킱킲������킳킶킸킺킻킼킽킾킿탂탃탅탆탇탊탋탌탍탎탏탒탖탗탘탙탚������탛탞탟탡탢탣탥탦탧탨탩탪탫탮탲탳탴탵탶탷탹탺탻탼탽탾탿턀턁턂턃턄덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸�".split("");
for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
D[182] = "�����������������������������������������������������������������턅턆턇턈턉턊턋턌턎턏턐턑턒턓턔턕턖턗턘턙턚턛턜턝턞턟������턠턡턢턣턤턥턦턧턨턩턪턫턬턭턮턯턲턳턵턶턷턹턻턼턽턾������턿텂텆텇텈텉텊텋텎텏텑텒텓텕텖텗텘텙텚텛텞텠텢텣텤텥텦텧텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗�".split("");
for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
D[183] = "�����������������������������������������������������������������텮텯텰텱텲텳텴텵텶텷텸텹텺텻텽텾텿톀톁톂톃톅톆톇톉톊������톋톌톍톎톏톐톑톒톓톔톕톖톗톘톙톚톛톜톝톞톟톢톣톥톦톧������톩톪톫톬톭톮톯톲톴톶톷톸톹톻톽톾톿퇁퇂퇃퇄퇅퇆퇇퇈퇉퇊퇋퇌퇍퇎퇏래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩�".split("");
for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
D[184] = "�����������������������������������������������������������������퇐퇑퇒퇓퇔퇕퇖퇗퇙퇚퇛퇜퇝퇞퇟퇠퇡퇢퇣퇤퇥퇦퇧퇨퇩퇪������퇫퇬퇭퇮퇯퇰퇱퇲퇳퇵퇶퇷퇹퇺퇻퇼퇽퇾퇿툀툁툂툃툄툅툆������툈툊툋툌툍툎툏툑툒툓툔툕툖툗툘툙툚툛툜툝툞툟툠툡툢툣툤툥툦툧툨툩륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많맏말맑맒맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼�".split("");
for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
D[185] = "�����������������������������������������������������������������툪툫툮툯툱툲툳툵툶툷툸툹툺툻툾퉀퉂퉃퉄퉅퉆퉇퉉퉊퉋퉌������퉍퉎퉏퉐퉑퉒퉓퉔퉕퉖퉗퉘퉙퉚퉛퉝퉞퉟퉠퉡퉢퉣퉥퉦퉧퉨������퉩퉪퉫퉬퉭퉮퉯퉰퉱퉲퉳퉴퉵퉶퉷퉸퉹퉺퉻퉼퉽퉾퉿튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바박밖밗반받발밝밞밟밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗�".split("");
for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
D[186] = "�����������������������������������������������������������������튍튎튏튒튓튔튖튗튘튙튚튛튝튞튟튡튢튣튥튦튧튨튩튪튫튭������튮튯튰튲튳튴튵튶튷튺튻튽튾틁틃틄틅틆틇틊틌틍틎틏틐틑������틒틓틕틖틗틙틚틛틝틞틟틠틡틢틣틦틧틨틩틪틫틬틭틮틯틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤�".split("");
for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
D[187] = "�����������������������������������������������������������������틻틼틽틾틿팂팄팆팇팈팉팊팋팏팑팒팓팕팗팘팙팚팛팞팢팣������팤팦팧팪팫팭팮팯팱팲팳팴팵팶팷팺팾팿퍀퍁퍂퍃퍆퍇퍈퍉������퍊퍋퍌퍍퍎퍏퍐퍑퍒퍓퍔퍕퍖퍗퍘퍙퍚퍛퍜퍝퍞퍟퍠퍡퍢퍣퍤퍥퍦퍧퍨퍩빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤�".split("");
for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
D[188] = "�����������������������������������������������������������������퍪퍫퍬퍭퍮퍯퍰퍱퍲퍳퍴퍵퍶퍷퍸퍹퍺퍻퍾퍿펁펂펃펅펆펇������펈펉펊펋펎펒펓펔펕펖펗펚펛펝펞펟펡펢펣펤펥펦펧펪펬펮������펯펰펱펲펳펵펶펷펹펺펻펽펾펿폀폁폂폃폆폇폊폋폌폍폎폏폑폒폓폔폕폖샥샨샬샴샵샷샹섀섄섈섐섕서석섞섟선섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭�".split("");
for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
D[189] = "�����������������������������������������������������������������폗폙폚폛폜폝폞폟폠폢폤폥폦폧폨폩폪폫폮폯폱폲폳폵폶폷������폸폹폺폻폾퐀퐂퐃퐄퐅퐆퐇퐉퐊퐋퐌퐍퐎퐏퐐퐑퐒퐓퐔퐕퐖������퐗퐘퐙퐚퐛퐜퐞퐟퐠퐡퐢퐣퐤퐥퐦퐧퐨퐩퐪퐫퐬퐭퐮퐯퐰퐱퐲퐳퐴퐵퐶퐷숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰�".split("");
for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
D[190] = "�����������������������������������������������������������������퐸퐹퐺퐻퐼퐽퐾퐿푁푂푃푅푆푇푈푉푊푋푌푍푎푏푐푑푒푓������푔푕푖푗푘푙푚푛푝푞푟푡푢푣푥푦푧푨푩푪푫푬푮푰푱푲������푳푴푵푶푷푺푻푽푾풁풃풄풅풆풇풊풌풎풏풐풑풒풓풕풖풗풘풙풚풛풜풝쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄업없엇었엉엊엌엎�".split("");
for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
D[191] = "�����������������������������������������������������������������풞풟풠풡풢풣풤풥풦풧풨풪풫풬풭풮풯풰풱풲풳풴풵풶풷풸������풹풺풻풼풽풾풿퓀퓁퓂퓃퓄퓅퓆퓇퓈퓉퓊퓋퓍퓎퓏퓑퓒퓓퓕������퓖퓗퓘퓙퓚퓛퓝퓞퓠퓡퓢퓣퓤퓥퓦퓧퓩퓪퓫퓭퓮퓯퓱퓲퓳퓴퓵퓶퓷퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염엽엾엿였영옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨�".split("");
for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
D[192] = "�����������������������������������������������������������������퓾퓿픀픁픂픃픅픆픇픉픊픋픍픎픏픐픑픒픓픖픘픙픚픛픜픝������픞픟픠픡픢픣픤픥픦픧픨픩픪픫픬픭픮픯픰픱픲픳픴픵픶픷������픸픹픺픻픾픿핁핂핃핅핆핇핈핉핊핋핎핐핒핓핔핕핖핗핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응읒읓읔읕읖읗의읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊�".split("");
for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
D[193] = "�����������������������������������������������������������������핤핦핧핪핬핮핯핰핱핲핳핶핷핹핺핻핽핾핿햀햁햂햃햆햊햋������햌햍햎햏햑햒햓햔햕햖햗햘햙햚햛햜햝햞햟햠햡햢햣햤햦햧������햨햩햪햫햬햭햮햯햰햱햲햳햴햵햶햷햸햹햺햻햼햽햾햿헀헁헂헃헄헅헆헇점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓�".split("");
for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
D[194] = "�����������������������������������������������������������������헊헋헍헎헏헑헓헔헕헖헗헚헜헞헟헠헡헢헣헦헧헩헪헫헭헮������헯헰헱헲헳헶헸헺헻헼헽헾헿혂혃혅혆혇혉혊혋혌혍혎혏혒������혖혗혘혙혚혛혝혞혟혡혢혣혥혦혧혨혩혪혫혬혮혯혰혱혲혳혴혵혶혷혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻�".split("");
for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
D[195] = "�����������������������������������������������������������������혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝홞홟홠홡������홢홣홤홥홦홨홪홫홬홭홮홯홲홳홵홶홷홸홹홺홻홼홽홾홿횀������횁횂횄횆횇횈횉횊횋횎횏횑횒횓횕횖횗횘횙횚횛횜횞횠횢횣횤횥횦횧횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층�".split("");
for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
D[196] = "�����������������������������������������������������������������횫횭횮횯횱횲횳횴횵횶횷횸횺횼횽횾횿훀훁훂훃훆훇훉훊훋������훍훎훏훐훒훓훕훖훘훚훛훜훝훞훟훡훢훣훥훦훧훩훪훫훬훭������훮훯훱훲훳훴훶훷훸훹훺훻훾훿휁휂휃휅휆휇휈휉휊휋휌휍휎휏휐휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼�".split("");
for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
D[197] = "�����������������������������������������������������������������휕휖휗휚휛휝휞휟휡휢휣휤휥휦휧휪휬휮휯휰휱휲휳휶휷휹������휺휻휽휾휿흀흁흂흃흅흆흈흊흋흌흍흎흏흒흓흕흚흛흜흝흞������흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵흶흷흸흹흺흻흾흿힀힂힃힄힅힆힇힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜�".split("");
for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
D[198] = "�����������������������������������������������������������������힍힎힏힑힒힓힔힕힖힗힚힜힞힟힠힡힢힣������������������������������������������������������������������������������퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁�".split("");
for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠�".split("");
for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝�".split("");
for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕�".split("");
for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢�".split("");
for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械�".split("");
for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜�".split("");
for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾�".split("");
for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴�".split("");
for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣�".split("");
for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩羅蘿螺裸邏那樂洛烙珞落諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉�".split("");
for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������納臘蠟衲囊娘廊朗浪狼郎乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧老蘆虜路露駑魯鷺碌祿綠菉錄鹿論壟弄濃籠聾膿農惱牢磊腦賂雷尿壘屢樓淚漏累縷陋嫩訥杻紐勒肋凜凌稜綾能菱陵尼泥匿溺多茶�".split("");
for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃�".split("");
for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅�".split("");
for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣�".split("");
for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼�".split("");
for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬�".split("");
for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅�".split("");
for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文�".split("");
for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑�".split("");
for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖�".split("");
for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦�".split("");
for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥�".split("");
for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索�".split("");
for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署�".split("");
for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬�".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁�".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧�".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁�".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額�".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬�".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒�".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳�".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療�".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓�".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜�".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼�".split("");
for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄�".split("");
for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長�".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱�".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖�".split("");
for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫�".split("");
for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只�".split("");
for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯�".split("");
for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策�".split("");
for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢�".split("");
for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃�".split("");
for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託�".split("");
for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑�".split("");
for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
D[248] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃�".split("");
for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
D[249] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航�".split("");
for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
D[250] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型�".split("");
for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
D[251] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵�".split("");
for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
D[252] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆�".split("");
for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
D[253] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰�".split("");
for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
return {"enc": e, "dec": d }; })();
cptable[950] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[161] = "����������������������������������������������������������������　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚����������������������������������﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢﹣﹤﹥﹦～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／�".split("");
for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
D[162] = "����������������������������������������������������������������＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁▂▃▄▅▆▇█▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭����������������������������������╮╰╯═╞╪╡◢◣◥◤╱╲╳０１２３４５６７８９ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ〡〢〣〤〥〦〧〨〩十卄卅ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖ�".split("");
for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
D[163] = "����������������������������������������������������������������ｗｘｙｚΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏ����������������������������������ㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ˙ˉˊˇˋ���������������������������������€������������������������������".split("");
for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
D[164] = "����������������������������������������������������������������一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才����������������������������������丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙�".split("");
for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
D[165] = "����������������������������������������������������������������世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外����������������������������������央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全�".split("");
for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
D[166] = "����������������������������������������������������������������共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年����������������������������������式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣�".split("");
for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
D[167] = "����������������������������������������������������������������作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍����������������������������������均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠�".split("");
for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
D[168] = "����������������������������������������������������������������杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒����������������������������������芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵�".split("");
for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
D[169] = "����������������������������������������������������������������咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居����������������������������������屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊�".split("");
for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
D[170] = "����������������������������������������������������������������昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠����������������������������������炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附�".split("");
for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
D[171] = "����������������������������������������������������������������陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品����������������������������������哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷�".split("");
for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
D[172] = "����������������������������������������������������������������拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗����������������������������������活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄�".split("");
for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
D[173] = "����������������������������������������������������������������耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥����������������������������������迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪�".split("");
for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
D[174] = "����������������������������������������������������������������哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙����������������������������������恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓�".split("");
for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
D[175] = "����������������������������������������������������������������浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷����������������������������������砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃�".split("");
for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
D[176] = "����������������������������������������������������������������虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡����������������������������������陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀�".split("");
for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
D[177] = "����������������������������������������������������������������娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽����������������������������������情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺�".split("");
for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
D[178] = "����������������������������������������������������������������毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶����������������������������������瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼�".split("");
for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
D[179] = "����������������������������������������������������������������莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途����������������������������������部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠�".split("");
for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
D[180] = "����������������������������������������������������������������婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍����������������������������������插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋�".split("");
for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
D[181] = "����������������������������������������������������������������溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘����������������������������������窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁�".split("");
for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
D[182] = "����������������������������������������������������������������詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑����������������������������������間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼�".split("");
for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
D[183] = "����������������������������������������������������������������媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業����������������������������������楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督�".split("");
for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
D[184] = "����������������������������������������������������������������睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫����������������������������������腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊�".split("");
for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
D[185] = "����������������������������������������������������������������辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴����������������������������������飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇�".split("");
for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
D[186] = "����������������������������������������������������������������愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢����������������������������������滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬�".split("");
for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
D[187] = "����������������������������������������������������������������罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤����������������������������������說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜�".split("");
for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
D[188] = "����������������������������������������������������������������劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂����������������������������������慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃�".split("");
for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
D[189] = "����������������������������������������������������������������瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯����������������������������������翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞�".split("");
for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
D[190] = "����������������������������������������������������������������輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉����������������������������������鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡�".split("");
for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
D[191] = "����������������������������������������������������������������濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊����������������������������������縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚�".split("");
for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
D[192] = "����������������������������������������������������������������錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇����������������������������������嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬�".split("");
for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
D[193] = "����������������������������������������������������������������瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪����������������������������������薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁�".split("");
for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
D[194] = "����������������������������������������������������������������駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘����������������������������������癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦�".split("");
for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
D[195] = "����������������������������������������������������������������鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸����������������������������������獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類�".split("");
for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
D[196] = "����������������������������������������������������������������願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼����������������������������������纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴�".split("");
for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
D[197] = "����������������������������������������������������������������護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬����������������������������������禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒�".split("");
for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
D[198] = "����������������������������������������������������������������讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲���������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
D[201] = "����������������������������������������������������������������乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕����������������������������������氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋�".split("");
for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
D[202] = "����������������������������������������������������������������汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘����������������������������������吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇�".split("");
for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
D[203] = "����������������������������������������������������������������杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓����������������������������������芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢�".split("");
for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
D[204] = "����������������������������������������������������������������坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋����������������������������������怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲�".split("");
for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
D[205] = "����������������������������������������������������������������泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺����������������������������������矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏�".split("");
for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
D[206] = "����������������������������������������������������������������哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛����������������������������������峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺�".split("");
for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
D[207] = "����������������������������������������������������������������柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂����������������������������������洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀�".split("");
for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
D[208] = "����������������������������������������������������������������穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪����������������������������������苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱�".split("");
for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
D[209] = "����������������������������������������������������������������唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧����������������������������������恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤�".split("");
for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
D[210] = "����������������������������������������������������������������毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸����������������������������������牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐�".split("");
for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
D[211] = "����������������������������������������������������������������笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢����������������������������������荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐�".split("");
for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
D[212] = "����������������������������������������������������������������酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅����������������������������������唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏�".split("");
for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
D[213] = "����������������������������������������������������������������崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟����������������������������������捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉�".split("");
for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
D[214] = "����������������������������������������������������������������淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏����������������������������������痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟�".split("");
for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
D[215] = "����������������������������������������������������������������耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷����������������������������������蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪�".split("");
for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
D[216] = "����������������������������������������������������������������釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷����������������������������������堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔�".split("");
for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
D[217] = "����������������������������������������������������������������惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒����������������������������������晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞�".split("");
for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
D[218] = "����������������������������������������������������������������湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖����������������������������������琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥�".split("");
for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
D[219] = "����������������������������������������������������������������罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳����������������������������������菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺�".split("");
for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
D[220] = "����������������������������������������������������������������軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈����������������������������������隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆�".split("");
for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
D[221] = "����������������������������������������������������������������媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤����������������������������������搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼�".split("");
for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
D[222] = "����������������������������������������������������������������毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓����������������������������������煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓�".split("");
for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
D[223] = "����������������������������������������������������������������稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯����������������������������������腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤�".split("");
for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
D[224] = "����������������������������������������������������������������觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿����������������������������������遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠�".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "����������������������������������������������������������������凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠����������������������������������寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉�".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "����������������������������������������������������������������榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊����������������������������������漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓�".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "����������������������������������������������������������������禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞����������������������������������耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻�".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "����������������������������������������������������������������裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍����������������������������������銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘�".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "����������������������������������������������������������������噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉����������������������������������憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒�".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "����������������������������������������������������������������澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙����������������������������������獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟�".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "����������������������������������������������������������������膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢����������������������������������蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧�".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "����������������������������������������������������������������踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓����������������������������������銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮�".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "����������������������������������������������������������������噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺����������������������������������憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸�".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "����������������������������������������������������������������澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙����������������������������������瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘�".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[235] = "����������������������������������������������������������������蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠����������������������������������諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌�".split("");
for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
D[236] = "����������������������������������������������������������������錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕����������������������������������魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎�".split("");
for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
D[237] = "����������������������������������������������������������������檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶����������������������������������瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞�".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "����������������������������������������������������������������蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞����������������������������������謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜�".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[239] = "����������������������������������������������������������������鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰����������������������������������鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶�".split("");
for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
D[240] = "����������������������������������������������������������������璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒����������������������������������臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧�".split("");
for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
D[241] = "����������������������������������������������������������������蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪����������������������������������鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰�".split("");
for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
D[242] = "����������������������������������������������������������������徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛����������������������������������礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕�".split("");
for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
D[243] = "����������������������������������������������������������������譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦����������������������������������鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲�".split("");
for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
D[244] = "����������������������������������������������������������������嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩����������������������������������禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿�".split("");
for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
D[245] = "����������������������������������������������������������������鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛����������������������������������鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥�".split("");
for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
D[246] = "����������������������������������������������������������������蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺����������������������������������騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚�".split("");
for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
D[247] = "����������������������������������������������������������������糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊����������������������������������驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾�".split("");
for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
D[248] = "����������������������������������������������������������������讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏����������������������������������齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚�".split("");
for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
D[249] = "����������������������������������������������������������������纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊����������������������������������龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓�".split("");
for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
return {"enc": e, "dec": d }; })();
cptable[1250] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1251] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1252] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1253] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1254] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1255] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1256] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1257] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1258] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10000] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10006] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10007] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10008] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。・ˉˇ¨〃々―～�…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
D[162] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������������������������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω���������������������������������������".split("");
for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
D[168] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüê����������ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
D[169] = "��������������������������������������������������������������������������������������������������������������������������������������������������������������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
D[176] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
D[177] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
D[178] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
D[179] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
D[180] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
D[181] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
D[182] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
D[183] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
D[184] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
D[185] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
D[186] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
D[187] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
D[188] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
D[189] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
D[190] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
D[191] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
D[192] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
D[193] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
D[194] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
D[195] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
D[196] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
D[197] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
D[198] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
D[201] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
return {"enc": e, "dec": d }; })();
cptable[10029] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10079] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10081] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
// eslint-disable-next-line no-undef
if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = cptable;
/* cputils.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* vim: set ft=javascript: */
/*jshint newcap: false */
(function(root, factory) {
  /*jshint ignore:start */
  /*eslint-disable */
  "use strict";
  if(typeof cptable === "undefined") {
    if(true){
      var cpt = cptable;
      if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = factory(cpt);
      else root.cptable = factory(cpt);
    } else throw new Error("cptable not found");
  } else cptable = factory(cptable);
  /*eslint-enable */
  /*jshint ignore:end */
}(this, function(cpt){
  "use strict";
  /*global module, Buffer */
  var magic = {
    "1200":"utf16le",
    "1201":"utf16be",
    "12000":"utf32le",
    "12001":"utf32be",
    "16969":"utf64le",
    "20127":"ascii",
    "65000":"utf7",
    "65001":"utf8"
  };

  var sbcs_cache = [874,1250,1251,1252,1253,1254,1255,1256,10000];
  var dbcs_cache = [932,936,949,950];
  var magic_cache = [65001];
  var magic_decode = {};
  var magic_encode = {};
  var cpdcache = {};
  var cpecache = {};

  var sfcc = function sfcc(x) { return String.fromCharCode(x); };
  var cca = function cca(x) { return x.charCodeAt(0); };

  var has_buf = (typeof Buffer !== 'undefined');
  var Buffer_from = function(){};
  if(has_buf) {
    var nbfs = !Buffer.from;
    if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
    Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
    // $FlowIgnore
    if(!Buffer.allocUnsafe) Buffer.allocUnsafe = function(n) { return new Buffer(n); };

    var mdl = 1024, mdb = Buffer.allocUnsafe(mdl);
    var make_EE = function make_EE(E){
      var EE = Buffer.allocUnsafe(65536);
      for(var i = 0; i < 65536;++i) EE[i] = 0;
      var keys = Object.keys(E), len = keys.length;
      for(var ee = 0, e = keys[ee]; ee < len; ++ee) {
        if(!(e = keys[ee])) continue;
        EE[e.charCodeAt(0)] = E[e];
      }
      return EE;
    };
    var sbcs_encode = function make_sbcs_encode(cp) {
      var EE = make_EE(cpt[cp].enc);
      return function sbcs_e(data, ofmt) {
        var len = data.length;
        var out, i=0, j=0, D=0, w=0;
        if(typeof data === 'string') {
          out = Buffer.allocUnsafe(len);
          for(i = 0; i < len; ++i) out[i] = EE[data.charCodeAt(i)];
        } else if(Buffer.isBuffer(data)) {
          out = Buffer.allocUnsafe(2*len);
          j = 0;
          for(i = 0; i < len; ++i) {
            D = data[i];
            if(D < 128) out[j++] = EE[D];
            else if(D < 224) { out[j++] = EE[((D&31)<<6)+(data[i+1]&63)]; ++i; }
            else if(D < 240) { out[j++] = EE[((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63)]; i+=2; }
            else {
              w = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3;
              if(w < 65536) out[j++] = EE[w];
              else { w -= 65536; out[j++] = EE[0xD800 + ((w>>10)&1023)]; out[j++] = EE[0xDC00 + (w&1023)]; }
            }
          }
          out = out.slice(0,j);
        } else {
          out = Buffer.allocUnsafe(len);
          for(i = 0; i < len; ++i) out[i] = EE[data[i].charCodeAt(0)];
        }
        if(!ofmt || ofmt === 'buf') return out;
        if(ofmt !== 'arr') return out.toString('binary');
        return [].slice.call(out);
      };
    };
    var sbcs_decode = function make_sbcs_decode(cp) {
      var D = cpt[cp].dec;
      var DD = Buffer.allocUnsafe(131072), d=0, c="";
      for(d=0;d<D.length;++d) {
        if(!(c=D[d])) continue;
        var w = c.charCodeAt(0);
        DD[2*d] = w&255; DD[2*d+1] = w>>8;
      }
      return function sbcs_d(data) {
        var len = data.length, i=0, j=0;
        if(2 * len > mdl) { mdl = 2 * len; mdb = Buffer.allocUnsafe(mdl); }
        if(Buffer.isBuffer(data)) {
          for(i = 0; i < len; i++) {
            j = 2*data[i];
            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
          }
        } else if(typeof data === "string") {
          for(i = 0; i < len; i++) {
            j = 2*data.charCodeAt(i);
            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
          }
        } else {
          for(i = 0; i < len; i++) {
            j = 2*data[i];
            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
          }
        }
        return mdb.slice(0, 2 * len).toString('ucs2');
      };
    };
    var dbcs_encode = function make_dbcs_encode(cp) {
      var E = cpt[cp].enc;
      var EE = Buffer.allocUnsafe(131072);
      for(var i = 0; i < 131072; ++i) EE[i] = 0;
      var keys = Object.keys(E);
      for(var ee = 0, e = keys[ee]; ee < keys.length; ++ee) {
        if(!(e = keys[ee])) continue;
        var f = e.charCodeAt(0);
        EE[2*f] = E[e] & 255; EE[2*f+1] = E[e]>>8;
      }
      return function dbcs_e(data, ofmt) {
        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, jj=0, k=0, D=0;
        if(typeof data === 'string') {
          for(i = k = 0; i < len; ++i) {
            j = data.charCodeAt(i)*2;
            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
          }
          out = out.slice(0,k);
        } else if(Buffer.isBuffer(data)) {
          for(i = k = 0; i < len; ++i) {
            D = data[i];
            if(D < 128) j = D;
            else if(D < 224) { j = ((D&31)<<6)+(data[i+1]&63); ++i; }
            else if(D < 240) { j = ((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63); i+=2; }
            else { j = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3; }
            if(j<65536) { j*=2; out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j]; }
            else { jj = j-65536;
              j=2*(0xD800 + ((jj>>10)&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
              j=2*(0xDC00 + (jj&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
            }
          }
          out = out.slice(0,k);
        } else {
          for(i = k = 0; i < len; i++) {
            j = data[i].charCodeAt(0)*2;
            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
          }
        }
        if(!ofmt || ofmt === 'buf') return out;
        if(ofmt !== 'arr') return out.toString('binary');
        return [].slice.call(out);
      };
    };
    var dbcs_decode = function make_dbcs_decode(cp) {
      var D = cpt[cp].dec;
      var DD = Buffer.allocUnsafe(131072), d=0, c, w=0, j=0, i=0;
      for(i = 0; i < 65536; ++i) { DD[2*i] = 0xFF; DD[2*i+1] = 0xFD;}
      for(d = 0; d < D.length; ++d) {
        if(!(c=D[d])) continue;
        w = c.charCodeAt(0);
        j = 2*d;
        DD[j] = w&255; DD[j+1] = w>>8;
      }
      return function dbcs_d(data) {
        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, k=0;
        if(Buffer.isBuffer(data)) {
          for(i = 0; i < len; i++) {
            j = 2*data[i];
            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
            out[k++] = DD[j]; out[k++] = DD[j+1];
          }
        } else if(typeof data === "string") {
          for(i = 0; i < len; i++) {
            j = 2*data.charCodeAt(i);
            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data.charCodeAt(i)<<8)+data.charCodeAt(i+1)); ++i; }
            out[k++] = DD[j]; out[k++] = DD[j+1];
          }
        } else {
          for(i = 0; i < len; i++) {
            j = 2*data[i];
            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
            out[k++] = DD[j]; out[k++] = DD[j+1];
          }
        }
        return out.slice(0,k).toString('ucs2');
      };
    };
    magic_decode[65001] = function utf8_d(data) {
      if(typeof data === "string") return utf8_d(data.split("").map(cca));
      var len = data.length, w = 0, ww = 0;
      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
      var i = 0;
      if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
      for(var j = 1, k = 0, D = 0; i < len; i+=j) {
        j = 1; D = data[i];
        if(D < 128) w = D;
        else if(D < 224) { w=(D&31)*64+(data[i+1]&63); j=2; }
        else if(D < 240) { w=((D&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
        else { w=(D&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
        if(w < 65536) { mdb[k++] = w&255; mdb[k++] = w>>8; }
        else {
          w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
          mdb[k++] = ww&255; mdb[k++] = ww>>>8; mdb[k++] = w&255; mdb[k++] = (w>>>8)&255;
        }
      }
      return mdb.slice(0,k).toString('ucs2');
    };
    magic_encode[65001] = function utf8_e(data, ofmt) {
      if(has_buf && Buffer.isBuffer(data)) {
        if(!ofmt || ofmt === 'buf') return data;
        if(ofmt !== 'arr') return data.toString('binary');
        return [].slice.call(data);
      }
      var len = data.length, w = 0, ww = 0, j = 0;
      var direct = typeof data === "string";
      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
      for(var i = 0; i < len; ++i) {
        w = direct ? data.charCodeAt(i) : data[i].charCodeAt(0);
        if(w <= 0x007F) mdb[j++] = w;
        else if(w <= 0x07FF) {
          mdb[j++] = 192 + (w >> 6);
          mdb[j++] = 128 + (w&63);
        } else if(w >= 0xD800 && w <= 0xDFFF) {
          w -= 0xD800; ++i;
          ww = (direct ? data.charCodeAt(i) : data[i].charCodeAt(0)) - 0xDC00 + (w << 10);
          mdb[j++] = 240 + ((ww>>>18) & 0x07);
          mdb[j++] = 144 + ((ww>>>12) & 0x3F);
          mdb[j++] = 128 + ((ww>>>6) & 0x3F);
          mdb[j++] = 128 + (ww & 0x3F);
        } else {
          mdb[j++] = 224 + (w >> 12);
          mdb[j++] = 128 + ((w >> 6)&63);
          mdb[j++] = 128 + (w&63);
        }
      }
      if(!ofmt || ofmt === 'buf') return mdb.slice(0,j);
      if(ofmt !== 'arr') return mdb.slice(0,j).toString('binary');
      return [].slice.call(mdb, 0, j);
    };
  }

  var encache = function encache() {
    if(has_buf) {
      if(cpdcache[sbcs_cache[0]]) return;
      var i=0, s=0;
      for(i = 0; i < sbcs_cache.length; ++i) {
        s = sbcs_cache[i];
        if(cpt[s]) {
          cpdcache[s] = sbcs_decode(s);
          cpecache[s] = sbcs_encode(s);
        }
      }
      for(i = 0; i < dbcs_cache.length; ++i) {
        s = dbcs_cache[i];
        if(cpt[s]) {
          cpdcache[s] = dbcs_decode(s);
          cpecache[s] = dbcs_encode(s);
        }
      }
      for(i = 0; i < magic_cache.length; ++i) {
        s = magic_cache[i];
        if(magic_decode[s]) cpdcache[s] = magic_decode[s];
        if(magic_encode[s]) cpecache[s] = magic_encode[s];
      }
    }
  };
  var null_enc = function(data, ofmt) { void ofmt; return ""; };
  var cp_decache = function cp_decache(cp) { delete cpdcache[cp]; delete cpecache[cp]; };
  var decache = function decache() {
    if(has_buf) {
      if(!cpdcache[sbcs_cache[0]]) return;
      sbcs_cache.forEach(cp_decache);
      dbcs_cache.forEach(cp_decache);
      magic_cache.forEach(cp_decache);
    }
    last_enc = null_enc; last_cp = 0;
  };
  var cache = {
    encache: encache,
    decache: decache,
    sbcs: sbcs_cache,
    dbcs: dbcs_cache
  };

  encache();

  var BM = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var SetD = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";
  var last_enc = null_enc, last_cp = 0;
  var encode = function encode(cp, data, ofmt) {
    if(cp === last_cp && last_enc) { return last_enc(data, ofmt); }
    if(cpecache[cp]) { last_enc = cpecache[last_cp=cp]; return last_enc(data, ofmt); }
    if(has_buf && Buffer.isBuffer(data)) data = data.toString('utf8');
    var len = data.length;
    var out = has_buf ? Buffer.allocUnsafe(4*len) : [], w=0, i=0, j = 0, ww=0;
    var C = cpt[cp], E, M = "";
    var isstr = typeof data === 'string';
    if(C && (E=C.enc)) for(i = 0; i < len; ++i, ++j) {
      w = E[isstr? data.charAt(i) : data[i]];
      if(w > 255) {
        out[j] = w>>8;
        out[++j] = w&255;
      } else out[j] = w&255;
    }
    else if((M=magic[cp])) switch(M) {
      case "utf8":
        if(has_buf && isstr) { out = Buffer_from(data, M); j = out.length; break; }
        for(i = 0; i < len; ++i, ++j) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if(w <= 0x007F) out[j] = w;
          else if(w <= 0x07FF) {
            out[j]   = 192 + (w >> 6);
            out[++j] = 128 + (w&63);
          } else if(w >= 0xD800 && w <= 0xDFFF) {
            w -= 0xD800;
            ww = (isstr ? data.charCodeAt(++i) : data[++i].charCodeAt(0)) - 0xDC00 + (w << 10);
            out[j]   = 240 + ((ww>>>18) & 0x07);
            out[++j] = 144 + ((ww>>>12) & 0x3F);
            out[++j] = 128 + ((ww>>>6) & 0x3F);
            out[++j] = 128 + (ww & 0x3F);
          } else {
            out[j]   = 224 + (w >> 12);
            out[++j] = 128 + ((w >> 6)&63);
            out[++j] = 128 + (w&63);
          }
        }
        break;
      case "ascii":
        if(has_buf && typeof data === "string") { out = Buffer_from(data, M); j = out.length; break; }
        for(i = 0; i < len; ++i, ++j) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if(w <= 0x007F) out[j] = w;
          else throw new Error("bad ascii " + w);
        }
        break;
      case "utf16le":
        if(has_buf && typeof data === "string") { out = Buffer_from(data, M); j = out.length; break; }
        for(i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          out[j++] = w&255;
          out[j++] = w>>8;
        }
        break;
      case "utf16be":
        for(i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          out[j++] = w>>8;
          out[j++] = w&255;
        }
        break;
      case "utf32le":
        for(i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
          out[j++] = w&255; w >>= 8;
          out[j++] = w&255; w >>= 8;
          out[j++] = w&255; w >>= 8;
          out[j++] = w&255;
        }
        break;
      case "utf32be":
        for(i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
          out[j+3] = w&255; w >>= 8;
          out[j+2] = w&255; w >>= 8;
          out[j+1] = w&255; w >>= 8;
          out[j] = w&255;
          j+=4;
        }
        break;
      case "utf7":
        for(i = 0; i < len; i++) {
          var c = isstr ? data.charAt(i) : data[i].charAt(0);
          if(c === "+") { out[j++] = 0x2b; out[j++] = 0x2d; continue; }
          if(SetD.indexOf(c) > -1) { out[j++] = c.charCodeAt(0); continue; }
          var tt = encode(1201, c);
          out[j++] = 0x2b;
          out[j++] = BM.charCodeAt(tt[0]>>2);
          out[j++] = BM.charCodeAt(((tt[0]&0x03)<<4) + ((tt[1]||0)>>4));
          out[j++] = BM.charCodeAt(((tt[1]&0x0F)<<2) + ((tt[2]||0)>>6));
          out[j++] = 0x2d;
        }
        break;
      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
    }
    else throw new Error("Unrecognized CP: " + cp);
    out = out.slice(0,j);
    if(!has_buf) return (ofmt == 'str') ? (out).map(sfcc).join("") : out;
    if(!ofmt || ofmt === 'buf') return out;
    if(ofmt !== 'arr') return out.toString('binary');
    return [].slice.call(out);
  };
  var decode = function decode(cp, data) {
    var F; if((F=cpdcache[cp])) return F(data);
    if(typeof data === "string") return decode(cp, data.split("").map(cca));
    var len = data.length, out = new Array(len), s="", w=0, i=0, j=1, k=0, ww=0;
    var C = cpt[cp], D, M="";
    if(C && (D=C.dec)) {
      for(i = 0; i < len; i+=j) {
        j = 2;
        s = D[(data[i]<<8)+ data[i+1]];
        if(!s) {
          j = 1;
          s = D[data[i]];
        }
        if(!s) throw new Error('Unrecognized code: ' + data[i] + ' ' + data[i+j-1] + ' ' + i + ' ' + j + ' ' + D[data[i]]);
        out[k++] = s;
      }
    }
    else if((M=magic[cp])) switch(M) {
      case "utf8":
        if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
        for(; i < len; i+=j) {
          j = 1;
          if(data[i] < 128) w = data[i];
          else if(data[i] < 224) { w=(data[i]&31)*64+(data[i+1]&63); j=2; }
          else if(data[i] < 240) { w=((data[i]&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
          else { w=(data[i]&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
          if(w < 65536) { out[k++] = String.fromCharCode(w); }
          else {
            w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
            out[k++] = String.fromCharCode(ww); out[k++] = String.fromCharCode(w);
          }
        }
        break;
      case "ascii":
        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
        for(i = 0; i < len; i++) out[i] = String.fromCharCode(data[i]);
        k = len; break;
      case "utf16le":
        if(len >= 2 && data[0] == 0xFF) if(data[1] == 0xFE) i = 2;
        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
        j = 2;
        for(; i+1 < len; i+=j) {
          out[k++] = String.fromCharCode((data[i+1]<<8) + data[i]);
        }
        break;
      case "utf16be":
        if(len >= 2 && data[0] == 0xFE) if(data[1] == 0xFF) i = 2;
        j = 2;
        for(; i+1 < len; i+=j) {
          out[k++] = String.fromCharCode((data[i]<<8) + data[i+1]);
        }
        break;
      case "utf32le":
        if(len >= 4 && data[0] == 0xFF) if(data[1] == 0xFE && data[2] === 0 && data[3] === 0) i = 4;
        j = 4;
        for(; i < len; i+=j) {
          w = (data[i+3]<<24) + (data[i+2]<<16) + (data[i+1]<<8) + (data[i]);
          if(w > 0xFFFF) {
            w -= 0x10000;
            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
          }
          else out[k++] = String.fromCharCode(w);
        }
        break;
      case "utf32be":
        if(len >= 4 && data[3] == 0xFF) if(data[2] == 0xFE && data[1] === 0 && data[0] === 0) i = 4;
        j = 4;
        for(; i < len; i+=j) {
          w = (data[i]<<24) + (data[i+1]<<16) + (data[i+2]<<8) + (data[i+3]);
          if(w > 0xFFFF) {
            w -= 0x10000;
            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
          }
          else out[k++] = String.fromCharCode(w);
        }
        break;
      case "utf7":
        if(len >= 4 && data[0] == 0x2B && data[1] == 0x2F && data[2] == 0x76) {
          if(len >= 5 && data[3] == 0x38 && data[4] == 0x2D) i = 5;
          else if(data[3] == 0x38 || data[3] == 0x39 || data[3] == 0x2B || data[3] == 0x2F) i = 4;
        }
        for(; i < len; i+=j) {
          if(data[i] !== 0x2b) { j=1; out[k++] = String.fromCharCode(data[i]); continue; }
          j=1;
          if(data[i+1] === 0x2d) { j = 2; out[k++] = "+"; continue; }
          // eslint-disable-next-line no-useless-escape
          while(String.fromCharCode(data[i+j]).match(/[A-Za-z0-9+\/]/)) j++;
          var dash = 0;
          if(data[i+j] === 0x2d) { ++j; dash=1; }
          var tt = [];
          var o64 = "";
          var c1=0, c2=0, c3=0;
          var e1=0, e2=0, e3=0, e4=0;
          for(var l = 1; l < j - dash;) {
            e1 = BM.indexOf(String.fromCharCode(data[i+l++]));
            e2 = BM.indexOf(String.fromCharCode(data[i+l++]));
            c1 = e1 << 2 | e2 >> 4;
            tt.push(c1);
            e3 = BM.indexOf(String.fromCharCode(data[i+l++]));
            if(e3 === -1) break;
            c2 = (e2 & 15) << 4 | e3 >> 2;
            tt.push(c2);
            e4 = BM.indexOf(String.fromCharCode(data[i+l++]));
            if(e4 === -1) break;
            c3 = (e3 & 3) << 6 | e4;
            if(e4 < 64) tt.push(c3);
          }
          o64 = decode(1201, tt);
          for(l = 0; l < o64.length; ++l) out[k++] = o64.charAt(l);
        }
        break;
      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
    }
    else throw new Error("Unrecognized CP: " + cp);
    return out.slice(0,k).join("");
  };
  var hascp = function hascp(cp) { return !!(cpt[cp] || magic[cp]); };
  cpt.utils = { decode: decode, encode: encode, hascp: hascp, magic: magic, cache:cache };
  return cpt;
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(224).Buffer))

/***/ }),
/* 372 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(374);
module.exports = __webpack_require__(379);


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(375).enable();
  window.Promise = __webpack_require__(377);
}

// fetch() polyfill for making API calls.
__webpack_require__(378);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(86);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(225);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(225);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 378 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_locale_provider_style__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_locale_provider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_locale_provider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_locale_provider__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_locale_provider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_locale_provider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_free_css_fontawesome_css__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_free_css_fontawesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_free_css_fontawesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_css_solid_css__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_css_solid_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_css_solid_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_auth__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl_redux__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_intl_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__configureStore__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_locale_provider_ru_RU__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_locale_provider_ru_RU___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_locale_provider_ru_RU__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__welcome__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Login__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Layout__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Viewer_main_jsx__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Viewer_roots_jsx__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Viewer_deepct_jsx__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_ViewerV4_plan_standart_jsx__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_intl__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_intl_locale_data_en__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_intl_locale_data_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_intl_locale_data_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_intl_locale_data_ru__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_intl_locale_data_ru___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_intl_locale_data_ru__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__locale_ru_js__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__locale_en_js__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_router_dom__ = __webpack_require__(59);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// import registerServiceWorker from './registerServiceWorker';
Object(__WEBPACK_IMPORTED_MODULE_18_react_intl__["addLocaleData"])([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_19_react_intl_locale_data_en___default.a),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_20_react_intl_locale_data_ru___default.a)));var store=Object(__WEBPACK_IMPORTED_MODULE_9__configureStore__["a" /* default */])({intl:{locale:'en',messages:__WEBPACK_IMPORTED_MODULE_22__locale_en_js__["a" /* default */]}});var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));}_createClass(App,[{key:"render",value:function render(){var WelcomeWithRouter=Object(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["f" /* withRouter */])(__WEBPACK_IMPORTED_MODULE_11__welcome__["a" /* default */]);return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_locale_provider___default.a,{locale:__WEBPACK_IMPORTED_MODULE_10_antd_lib_locale_provider_ru_RU___default.a},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl_redux__["Provider"],{store:store},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{style:{width:'100%',height:'100%'}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["d" /* Route */],{path:"/",render:function render(_ref){var location=_ref.location;if(!store.getState().user.username){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_auth__["a" /* initializeUser */])());return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(WelcomeWithRouter,{to:location.pathname});}else{return null;}}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["d" /* Route */],{path:"/login",component:__WEBPACK_IMPORTED_MODULE_12__views_Login__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["d" /* Route */],{path:"/case/control/plan-standart/:uuid",component:__WEBPACK_IMPORTED_MODULE_14__views_Viewer_main_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["d" /* Route */],{path:"/case/control/plan-roots/:uuid",component:__WEBPACK_IMPORTED_MODULE_15__views_Viewer_roots_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["d" /* Route */],{path:"/case/control/plan-deep-ct/:uuid",component:__WEBPACK_IMPORTED_MODULE_16__views_Viewer_deepct_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["d" /* Route */],{path:"/case/control/plan-standard-orthostudio/:uuid",component:__WEBPACK_IMPORTED_MODULE_17__views_ViewerV4_plan_standart_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["d" /* Route */],{path:"/case/control/plan-standard-3shape-1c/:uuid",component:__WEBPACK_IMPORTED_MODULE_17__views_ViewerV4_plan_standart_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["d" /* Route */],{path:"/case/control/plan-standard-3shape-color/:uuid",component:__WEBPACK_IMPORTED_MODULE_17__views_ViewerV4_plan_standart_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["d" /* Route */],{path:"/case/control/plan-standard-archform-1c/:uuid",component:__WEBPACK_IMPORTED_MODULE_17__views_ViewerV4_plan_standart_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["d" /* Route */],{path:"/case/control/plan-standard-onyxceph/:uuid",component:__WEBPACK_IMPORTED_MODULE_17__views_ViewerV4_plan_standart_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["d" /* Route */],{path:"/case/control/plan-standard-orthostudio-v5/:uuid",component:__WEBPACK_IMPORTED_MODULE_17__views_ViewerV4_plan_standart_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["d" /* Route */],{path:"/case/control/plan-standard-suresmile-sou/:uuid",component:__WEBPACK_IMPORTED_MODULE_17__views_ViewerV4_plan_standart_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["d" /* Route */],{path:"/case/control/plan-standard-nemo/:uuid",component:__WEBPACK_IMPORTED_MODULE_17__views_ViewerV4_plan_standart_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["d" /* Route */],{path:"/case/control/teeth-alignment-modelling/:uuid",component:__WEBPACK_IMPORTED_MODULE_14__views_Viewer_main_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["d" /* Route */],{path:"/",component:__WEBPACK_IMPORTED_MODULE_13__views_Layout__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["c" /* Redirect */],{to:"/login"}))))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(App,{user:store.getState()}),document.getElementById('root'));// registerServiceWorker();

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(381);

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(31);

var moment = _interopRequireWildcard(_moment);

var _interopDefault = __webpack_require__(89);

var _interopDefault2 = _interopRequireDefault(_interopDefault);

var _locale = __webpack_require__(148);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function setMomentLocale(locale) {
    if (locale && locale.locale) {
        (0, _interopDefault2['default'])(moment).locale(locale.locale);
    } else {
        (0, _interopDefault2['default'])(moment).locale('en');
    }
}

var LocaleProvider = function (_React$Component) {
    (0, _inherits3['default'])(LocaleProvider, _React$Component);

    function LocaleProvider(props) {
        (0, _classCallCheck3['default'])(this, LocaleProvider);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (LocaleProvider.__proto__ || Object.getPrototypeOf(LocaleProvider)).call(this, props));

        setMomentLocale(props.locale);
        (0, _locale.changeConfirmLocale)(props.locale && props.locale.Modal);
        return _this;
    }

    (0, _createClass3['default'])(LocaleProvider, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                antLocale: (0, _extends3['default'])({}, this.props.locale, { exist: true })
            };
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var locale = this.props.locale;

            var nextLocale = nextProps.locale;
            if (locale !== nextLocale) {
                setMomentLocale(nextProps.locale);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var locale = this.props.locale;

            (0, _locale.changeConfirmLocale)(locale && locale.Modal);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (0, _locale.changeConfirmLocale)();
        }
    }, {
        key: 'render',
        value: function render() {
            return React.Children.only(this.props.children);
        }
    }]);
    return LocaleProvider;
}(React.Component);

exports['default'] = LocaleProvider;

LocaleProvider.propTypes = {
    locale: _propTypes2['default'].object
};
LocaleProvider.defaultProps = {
    locale: {}
};
LocaleProvider.childContextTypes = {
    antLocale: _propTypes2['default'].object
};
module.exports = exports['default'];

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(384), __esModule: true };

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(385);
module.exports = __webpack_require__(44).Object.assign;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(62);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(387) });


/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(102);
var gOPS = __webpack_require__(138);
var pIE = __webpack_require__(104);
var toObject = __webpack_require__(139);
var IObject = __webpack_require__(229);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(87)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(75);
var toLength = __webpack_require__(230);
var toAbsoluteIndex = __webpack_require__(389);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(134);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(391);
var $Object = __webpack_require__(44).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(62);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(64), 'Object', { defineProperty: __webpack_require__(57).f });


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(393), __esModule: true };

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105);
__webpack_require__(143);
module.exports = __webpack_require__(144).f('iterator');


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(134);
var defined = __webpack_require__(133);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(141);
var descriptor = __webpack_require__(88);
var setToStringTag = __webpack_require__(142);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(73)(IteratorPrototype, __webpack_require__(45)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(57);
var anObject = __webpack_require__(63);
var getKeys = __webpack_require__(102);

module.exports = __webpack_require__(64) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(56).document;
module.exports = document && document.documentElement;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(65);
var toObject = __webpack_require__(139);
var IE_PROTO = __webpack_require__(135)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(400);
var step = __webpack_require__(401);
var Iterators = __webpack_require__(76);
var toIObject = __webpack_require__(75);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(232)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(403), __esModule: true };

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(404);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
module.exports = __webpack_require__(44).Symbol;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(56);
var has = __webpack_require__(65);
var DESCRIPTORS = __webpack_require__(64);
var $export = __webpack_require__(62);
var redefine = __webpack_require__(233);
var META = __webpack_require__(405).KEY;
var $fails = __webpack_require__(87);
var shared = __webpack_require__(136);
var setToStringTag = __webpack_require__(142);
var uid = __webpack_require__(103);
var wks = __webpack_require__(45);
var wksExt = __webpack_require__(144);
var wksDefine = __webpack_require__(145);
var enumKeys = __webpack_require__(406);
var isArray = __webpack_require__(407);
var anObject = __webpack_require__(63);
var isObject = __webpack_require__(74);
var toIObject = __webpack_require__(75);
var toPrimitive = __webpack_require__(131);
var createDesc = __webpack_require__(88);
var _create = __webpack_require__(141);
var gOPNExt = __webpack_require__(408);
var $GOPD = __webpack_require__(235);
var $DP = __webpack_require__(57);
var $keys = __webpack_require__(102);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(234).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(104).f = $propertyIsEnumerable;
  __webpack_require__(138).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(140)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(73)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(103)('meta');
var isObject = __webpack_require__(74);
var has = __webpack_require__(65);
var setDesc = __webpack_require__(57).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(87)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(102);
var gOPS = __webpack_require__(138);
var pIE = __webpack_require__(104);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(132);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(75);
var gOPN = __webpack_require__(234).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 409 */
/***/ (function(module, exports) {



/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(145)('asyncIterator');


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(145)('observable');


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(413), __esModule: true };

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(414);
module.exports = __webpack_require__(44).Object.setPrototypeOf;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(62);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(415).set });


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(74);
var anObject = __webpack_require__(63);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(130)(Function.call, __webpack_require__(235).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(417), __esModule: true };

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(418);
var $Object = __webpack_require__(44).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(62);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(141) });


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.1
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(86),n=__webpack_require__(106),p=__webpack_require__(146),q=__webpack_require__(147),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.1",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(147);
var invariant = __webpack_require__(106);
var ReactPropTypesSecret = __webpack_require__(421);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _en_US = __webpack_require__(149);

var _en_US2 = _interopRequireDefault(_en_US);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _en_US2['default'];
module.exports = exports['default'];

/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.1
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(106),ba=__webpack_require__(0),m=__webpack_require__(427),p=__webpack_require__(86),v=__webpack_require__(147),da=__webpack_require__(428),ea=__webpack_require__(429),fa=__webpack_require__(430),ha=__webpack_require__(146);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ba?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,fc="function"===typeof Symbol&&Symbol.for,gc=fc?Symbol.for("react.element"):60103,hc=fc?Symbol.for("react.portal"):60106,ic=fc?Symbol.for("react.fragment"):60107,jc=fc?Symbol.for("react.strict_mode"):60108,kc=fc?Symbol.for("react.profiler"):60114,lc=fc?Symbol.for("react.provider"):60109,mc=fc?Symbol.for("react.context"):60110,pc=fc?Symbol.for("react.async_mode"):60111,qc=fc?Symbol.for("react.forward_ref"):60112,rc=fc?Symbol.for("react.timeout"):
60113,sc="function"===typeof Symbol&&Symbol.iterator;function tc(a){if(null===a||"undefined"===typeof a)return null;a=sc&&a[sc]||a["@@iterator"];return"function"===typeof a?a:null}
function uc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case pc:return"AsyncMode";case mc:return"Context.Consumer";case ic:return"ReactFragment";case hc:return"ReactPortal";case kc:return"Profiler("+a.pendingProps.id+")";case lc:return"Context.Provider";case jc:return"StrictMode";case rc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case qc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=uc(a);var f=null;c&&(f=uc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc={},zc={};function Ac(a){if(zc.hasOwnProperty(a))return!0;if(xc.hasOwnProperty(a))return!1;if(wc.test(a))return zc[a]=!0;xc[a]=!0;return!1}
function Bc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Cc(a,b,c,d){if(null===b||"undefined"===typeof b||Bc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function I(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var J={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var Dc=/[\-:]([a-z])/g;function Ec(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Dc,
Ec);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Dc,Ec);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Dc,Ec);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);
function Fc(a,b,c,d){var e=J.hasOwnProperty(b)?J[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Cc(b,c,e,d)&&(c=null),d||null===e?Ac(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Gc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Hc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Ic(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Jc(a,b){b=b.checked;null!=b&&Fc(a,"checked",b,!1)}
function Kc(a,b){Jc(a,b);var c=Ic(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Lc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Lc(a,b.type,Ic(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Mc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){b=""+a._wrapperState.initialValue;var d=a.value;c||b===d||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==c&&(a.name=c)}function Lc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Ic(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Nc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Oc(a,b,c){a=H.getPooled(Nc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Pc=null,Qc=null;function Rc(a){Ia(a,!1)}function Sc(a){var b=Oa(a);if(dc(b))return a}
function Tc(a,b){if("change"===a)return b}var Uc=!1;m.canUseDOM&&(Uc=$b("input")&&(!document.documentMode||9<document.documentMode));function Vc(){Pc&&(Pc.detachEvent("onpropertychange",Wc),Qc=Pc=null)}function Wc(a){"value"===a.propertyName&&Sc(Qc)&&(a=Oc(Qc,a,Zb(a)),Wb(Rc,a))}function Xc(a,b,c){"focus"===a?(Vc(),Pc=b,Qc=c,Pc.attachEvent("onpropertychange",Wc)):"blur"===a&&Vc()}function Yc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Sc(Qc)}
function Zc(a,b){if("click"===a)return Sc(b)}function $c(a,b){if("input"===a||"change"===a)return Sc(b)}
var ad={eventTypes:Nc,_isInputEventSupported:Uc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Tc:Yb(e)?Uc?f=$c:(f=Yc,g=Xc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Zc);if(f&&(f=f(a,b)))return Oc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Lc(e,"number",e.value)}},bd=H.extend({view:null,detail:null}),cd={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}
var fd=bd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),gd=fd.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),hd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},id={eventTypes:hd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=fd,h=hd.mouseLeave,k=hd.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=gd,h=hd.pointerLeave,k=hd.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function jd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function kd(a){2!==jd(a)?A("188"):void 0}
function ld(a){var b=a.alternate;if(!b)return b=jd(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return kd(e),a;if(g===d)return kd(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function md(a){a=ld(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function nd(a){a=ld(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var od=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),pd=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),qd=bd.extend({relatedTarget:null});
function rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var sd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},td={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ud=bd.extend({key:function(a){if(a.key){var b=sd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?td[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===
a.type?rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),vd=fd.extend({dataTransfer:null}),wd=bd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed}),xd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),yd=fd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),zd=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Ad={},Bd={};function Cd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Ad[a]=b;Bd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Cd(a,!0)});zd.forEach(function(a){Cd(a,!1)});
var Dd={eventTypes:Ad,isInteractiveTopLevelEventType:function(a){a=Bd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Bd[a];if(!e)return null;switch(a){case "keypress":if(0===rd(c))return null;case "keydown":case "keyup":a=ud;break;case "blur":case "focus":a=qd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=fd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=wd;break;case fb:case gb:case hb:a=od;break;case ib:a=xd;break;case "scroll":a=bd;break;case "wheel":a=yd;break;case "copy":case "cut":case "paste":a=pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=gd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Ed=Dd.isInteractiveTopLevelEventType,
Fd=[];function Gd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Hd=!0;function Id(a){Hd=!!a}function K(a,b){if(!b)return null;var c=(Ed(a)?Kd:Ld).bind(null,a);b.addEventListener(a,c,!1)}
function Md(a,b){if(!b)return null;var c=(Ed(a)?Kd:Ld).bind(null,a);b.addEventListener(a,c,!0)}function Kd(a,b){Tb(Ld,a,b)}function Ld(a,b){if(Hd){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===jd(c)||(c=null);if(Fd.length){var d=Fd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Gd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Fd.length&&Fd.push(a)}}}
var Nd={get _enabled(){return Hd},setEnabled:Id,isEnabled:function(){return Hd},trapBubbledEvent:K,trapCapturedEvent:Md,dispatchEvent:Ld},Od={},Pd=0,Qd="_reactListenersID"+(""+Math.random()).slice(2);function Rd(a){Object.prototype.hasOwnProperty.call(a,Qd)||(a[Qd]=Pd++,Od[a[Qd]]={});return Od[a[Qd]]}function Sd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Td(a,b){var c=Sd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Sd(c)}}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Vd=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
function ae(a,b){if($d||null==Xd||Xd!==da())return null;var c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Zd&&ea(Zd,c)?null:(Zd=c,a=H.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Ya(a),a)}
var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Rd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
case "keydown":case "keyup":return ae(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Dd,EnterLeaveEventPlugin:id,ChangeEventPlugin:ad,SelectEventPlugin:be,BeforeInputEventPlugin:Ib});
var ce="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,de=Date,ee=setTimeout,fe=clearTimeout,ge=void 0;if("object"===typeof performance&&"function"===typeof performance.now){var he=performance;ge=function(){return he.now()}}else ge=function(){return de.now()};var ie=void 0,je=void 0;
if(m.canUseDOM){var ke="function"===typeof ce?ce:function(){A("276")},L=null,le=null,me=-1,ne=!1,oe=!1,pe=0,qe=33,re=33,se={didTimeout:!1,timeRemaining:function(){var a=pe-ge();return 0<a?a:0}},ue=function(a,b){var c=a.scheduledCallback,d=!1;try{c(b),d=!0}finally{je(a),d||(ne=!0,window.postMessage(te,"*"))}},te="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===te&&(ne=!1,null!==L)){if(null!==L){var b=ge();if(!(-1===
me||me>b)){a=-1;for(var c=[],d=L;null!==d;){var e=d.timeoutTime;-1!==e&&e<=b?c.push(d):-1!==e&&(-1===a||e<a)&&(a=e);d=d.next}if(0<c.length)for(se.didTimeout=!0,b=0,d=c.length;b<d;b++)ue(c[b],se);me=a}}for(a=ge();0<pe-a&&null!==L;)a=L,se.didTimeout=!1,ue(a,se),a=ge();null===L||oe||(oe=!0,ke(ve))}},!1);var ve=function(a){oe=!1;var b=a-pe+re;b<re&&qe<re?(8>b&&(b=8),re=b<qe?qe:b):qe=b;pe=a+re;ne||(ne=!0,window.postMessage(te,"*"))};ie=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=ge()+
b.timeout);if(-1===me||-1!==c&&c<me)me=c;a={scheduledCallback:a,timeoutTime:c,prev:null,next:null};null===L?L=a:(b=a.prev=le,null!==b&&(b.next=a));le=a;oe||(oe=!0,ke(ve));return a};je=function(a){if(null!==a.prev||L===a){var b=a.next,c=a.prev;a.next=null;a.prev=null;null!==b?null!==c?(c.next=b,b.prev=c):(b.prev=null,L=b):null!==c?(c.next=null,le=c):le=L=null}}}else{var we=new Map;ie=function(a){var b={scheduledCallback:a,timeoutTime:0,next:null,prev:null},c=ee(function(){a({timeRemaining:function(){return Infinity},
didTimeout:!1})});we.set(a,c);return b};je=function(a){var b=we.get(a.scheduledCallback);we.delete(a);fe(b)}}function xe(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function ye(a,b){a=p({children:void 0},b);if(b=xe(b.children))a.children=b;return a}
function ze(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ae(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Be(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function De(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function He(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Ie=void 0,Je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Fe.svg||"innerHTML"in a)a.innerHTML=b;else{Ie=Ie||document.createElement("div");Ie.innerHTML="<svg>"+b+"</svg>";for(b=Ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Me=["Webkit","ms","Moz","O"];Object.keys(Le).forEach(function(a){Me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Le[b]=Le[a]})});
function Ne(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Le.hasOwnProperty(e)&&Le[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Oe=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Pe(a,b,c){b&&(Oe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Qe(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Re=v.thatReturns("");
function Se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Rd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Md("scroll",a);break;case "focus":case "blur":Md("focus",a);Md("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Md(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&K(e,a)}c[e]=!0}}}
function Te(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Fe.html&&(d=Ge(a));d===Fe.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Ue(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function Ve(a,b,c,d){var e=Qe(b,c);switch(b){case "iframe":case "object":K("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)K(jb[f],a);f=c;break;case "source":K("error",a);f=c;break;case "img":case "image":case "link":K("error",a);K("load",a);f=c;break;case "form":K("reset",a);K("submit",a);f=c;break;case "details":K("toggle",a);f=c;break;case "input":Hc(a,c);f=Gc(a,c);K("invalid",a);Se(d,"onChange");break;case "option":f=ye(a,c);break;case "select":Ae(a,c);f=p({},c,{value:void 0});
K("invalid",a);Se(d,"onChange");break;case "textarea":Ce(a,c);f=Be(a,c);K("invalid",a);Se(d,"onChange");break;default:f=c}Pe(b,f,Re);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Ne(a,k,Re):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Je(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Ke(a,k):"number"===typeof k&&Ke(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Se(d,
h):null!=k&&Fc(a,h,k,e))}switch(b){case "input":cc(a);Mc(a,c,!1);break;case "textarea":cc(a);Ee(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?ze(a,!!c.multiple,b,!1):null!=c.defaultValue&&ze(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function We(a,b,c,d,e){var f=null;switch(b){case "input":c=Gc(a,c);d=Gc(a,d);f=[];break;case "option":c=ye(a,c);d=ye(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=Be(a,c);d=Be(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Pe(b,d,Re);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Se(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Xe(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Jc(a,e);Qe(c,d);d=Qe(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Ne(a,h,Re):"dangerouslySetInnerHTML"===g?Je(a,h):"children"===g?Ke(a,h):Fc(a,g,h,d)}switch(c){case "input":Kc(a,e);break;case "textarea":De(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ze(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
ze(a,!!e.multiple,e.defaultValue,!0):ze(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ye(a,b,c,d,e){switch(b){case "iframe":case "object":K("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)K(jb[d],a);break;case "source":K("error",a);break;case "img":case "image":case "link":K("error",a);K("load",a);break;case "form":K("reset",a);K("submit",a);break;case "details":K("toggle",a);break;case "input":Hc(a,c);K("invalid",a);Se(e,"onChange");break;case "select":Ae(a,c);K("invalid",a);Se(e,"onChange");break;case "textarea":Ce(a,c),K("invalid",a),Se(e,"onChange")}Pe(b,
c,Re);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Se(e,f)}switch(b){case "input":cc(a);Mc(a,c,!0);break;case "textarea":cc(a);Ee(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function Ze(a,b){return a.nodeValue!==b}
var $e={createElement:Te,createTextNode:Ue,setInitialProperties:Ve,diffProperties:We,updateProperties:Xe,diffHydratedProperties:Ye,diffHydratedText:Ze,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Kc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Kc(d,e)}}}break;case "textarea":De(a,c);break;case "select":b=c.value,null!=b&&ze(a,!!c.multiple,b,!1)}}},af=null,bf=null;function cf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function df(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var ef=ge,ff=ie,gf=je;function hf(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function jf(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var kf=[],lf=-1;function mf(a){return{current:a}}
function M(a){0>lf||(a.current=kf[lf],kf[lf]=null,lf--)}function N(a,b){lf++;kf[lf]=a.current;a.current=b}var nf=mf(ha),O=mf(!1),of=ha;function pf(a){return qf(a)?of:nf.current}
function rf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function qf(a){return 2===a.tag&&null!=a.type.childContextTypes}function sf(a){qf(a)&&(M(O,a),M(nf,a))}function tf(a){M(O,a);M(nf,a)}
function uf(a,b,c){nf.current!==ha?A("168"):void 0;N(nf,b,a);N(O,c,a)}function vf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",uc(a)||"Unknown",e);return p({},b,c)}function wf(a){if(!qf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;of=nf.current;N(nf,b,a);N(O,O.current,a);return!0}
function xf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=vf(a,of);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(nf,a);N(nf,d,a)}else M(O,a);N(O,b,a)}
function yf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function zf(a,b,c){var d=a.alternate;null===d?(d=new yf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Af(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case ic:return Bf(a.children,b,c,e);case pc:f=11;b|=3;break;case jc:f=11;b|=2;break;case kc:return d=new yf(15,a,e,b|4),d.type=kc,d.expirationTime=c,d;case rc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case lc:f=13;break a;case mc:f=12;break a;case qc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new yf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Bf(a,b,c,d){a=new yf(10,a,d,b);a.expirationTime=c;return a}function Cf(a,b,c){a=new yf(6,a,null,b);a.expirationTime=c;return a}function Df(a,b,c){b=new yf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Ef(a,b,c){b=new yf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Ff=null,Gf=null;function Hf(a){return function(b){try{return a(b)}catch(c){}}}
function If(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ff=Hf(function(a){return b.onCommitFiberRoot(c,a)});Gf=Hf(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Jf(a){"function"===typeof Ff&&Ff(a)}function Kf(a){"function"===typeof Gf&&Gf(a)}var Lf=!1;
function Mf(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Nf(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Of(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Pf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Qf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=Mf(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=Mf(a.memoizedState),f=d.updateQueue=Mf(d.memoizedState)):e=a.updateQueue=Nf(f):null===f&&(f=d.updateQueue=Nf(e));null===f||e===f?Pf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Pf(e,b,c),Pf(f,b,c)):(Pf(e,b,c),f.lastUpdate=b)}
function Rf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=Mf(a.memoizedState):Sf(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Sf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Nf(b));return b}
function Tf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Lf=!0}return d}
function Uf(a,b,c,d,e){Lf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Sf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Tf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Tf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Vf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Wf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Vf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Vf(b,c)),a=a.nextEffect}
function Xf(a,b){return{value:a,source:b,stack:vc(b)}}var Yf=mf(null),Zf=mf(null),$f=mf(0);function ag(a){var b=a.type._context;N($f,b._changedBits,a);N(Zf,b._currentValue,a);N(Yf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function bg(a){var b=$f.current,c=Zf.current;M(Yf,a);M(Zf,a);M($f,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var cg={},dg=mf(cg),eg=mf(cg),fg=mf(cg);function gg(a){a===cg?A("174"):void 0;return a}
function ig(a,b){N(fg,b,a);N(eg,a,a);N(dg,cg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:He(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=He(b,c)}M(dg,a);N(dg,b,a)}function jg(a){M(dg,a);M(eg,a);M(fg,a)}function kg(a){eg.current===a&&(M(dg,a),M(eg,a))}function lg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var pg={isMounted:function(a){return(a=a._reactInternalFiber)?2===jd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=mg();d=ng(d,a);var e=Of(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Qf(a,e,d);og(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=mg();d=ng(d,a);var e=Of(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Qf(a,e,d);og(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=mg();c=ng(c,a);var d=Of(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Qf(a,d,c);og(a,c)}};function qg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function rg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&pg.enqueueReplaceState(b,b.state,null)}
function sg(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=pf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=rf(a,f);f=a.updateQueue;null!==f&&(Uf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(lg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&pg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Uf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var tg=Array.isArray;
function ug(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function vg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function wg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=zf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Cf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=ug(a,b,c),d.return=a,d;d=Af(c,a.mode,d);d.ref=ug(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Df(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=Bf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Cf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case gc:return c=Af(b,a.mode,c),c.ref=ug(a,null,b),c.return=a,c;case hc:return b=Df(b,a.mode,c),b.return=a,b}if(tg(b)||tc(b))return b=Bf(b,a.mode,c,null),b.return=
a,b;vg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case gc:return c.key===e?c.type===ic?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case hc:return c.key===e?n(a,b,c,d):null}if(tg(c)||tc(c))return null!==e?null:r(a,b,c,d,null);vg(a,c)}return null}function nc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case gc:return a=a.get(null===d.key?c:d.key)||null,d.type===ic?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case hc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(tg(d)||tc(d))return a=a.get(c)||null,r(b,a,d,e,null);vg(b,d)}return null}function Jd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=nc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var u=tc(h);"function"!==typeof u?A("150"):void 0;h=u.call(h);null==h?A("151"):void 0;for(var t=u=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===t?u=r:t.sibling=r;t=r;n=y}if(l.done)return c(e,n),u;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===t?u=l:t.sibling=l,t=l);return u}for(n=d(e,n);!l.done;x++,l=h.next())l=nc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
t?u=l:t.sibling=l,t=l);a&&n.forEach(function(a){return b(e,a)});return u}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ic&&null===f.key;k&&(f=f.props.children);var n="object"===typeof f&&null!==f;if(n)switch(f.$$typeof){case gc:a:{n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===ic:k.type===f.type){c(a,k.sibling);d=e(k,f.type===ic?f.props.children:f.props,h);d.ref=ug(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===ic?(d=Bf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=Af(f,a.mode,h),h.ref=ug(a,d,f),h.return=a,a=h)}return g(a);case hc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Df(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=Cf(f,a.mode,h),d.return=a,a=d),g(a);if(tg(f))return Jd(a,d,f,h);if(tc(f))return E(a,d,f,h);n&&vg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var xg=wg(!0),yg=wg(!1),zg=null,Ag=null,Bg=!1;function Cg(a,b){var c=new yf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Dg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Eg(a){if(Bg){var b=Ag;if(b){var c=b;if(!Dg(a,b)){b=hf(c);if(!b||!Dg(a,b)){a.effectTag|=2;Bg=!1;zg=a;return}Cg(zg,c)}zg=a;Ag=jf(b)}else a.effectTag|=2,Bg=!1,zg=a}}
function Fg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;zg=a}function Gg(a){if(a!==zg)return!1;if(!Bg)return Fg(a),Bg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!df(b,a.memoizedProps))for(b=Ag;b;)Cg(a,b),b=hf(b);Fg(a);Ag=zg?hf(a.stateNode):null;return!0}function Hg(){Ag=zg=null;Bg=!1}function Q(a,b,c){Ig(a,b,c,b.expirationTime)}function Ig(a,b,c,d){b.child=null===a?yg(b,null,c,d):xg(b,a.child,c,d)}
function Jg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Kg(a,b,c,d,e){Jg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&xf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Ig(a,b,null,e),b.child=null);Ig(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&xf(b,!0);return b.child}
function Lg(a){var b=a.stateNode;b.pendingContext?uf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&uf(a,b.context,!1);ig(a,b.containerInfo)}
function Mg(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Qg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,ag(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b)}else Mg(b,d,h,c)}b.stateNode=h;ag(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=zf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=zf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Rg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Lg(b);break;case 2:wf(b);break;case 4:ig(b,b.stateNode.containerInfo);break;case 13:ag(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=pf(b);f=rf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&lg(b,f,e),e=wf(b),d.updater=pg,b.stateNode=d,d._reactInternalFiber=b,sg(b,c),a=Kg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=pf(b),d=rf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=wf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=pf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?rf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=pg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);sg(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=pf(b);g=rf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&rg(b,d,f,g);Lf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Uf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Lf?("function"===typeof r&&(lg(b,r,f),n=b.memoizedState),(k=Lf||qg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=pf(b),g=rf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&rg(b,d,k,g),Lf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Uf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Lf?("function"===typeof r&&(lg(b,r,k),w=b.memoizedState),(r=Lf||qg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Kg(a,b,d,e,c);case 3:Lg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Uf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Hg(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)Ag=jf(b.stateNode.containerInfo),zg=b,d=Bg=!0;d?(b.effectTag|=2,b.child=yg(b,null,e,c)):(Hg(),Q(a,b,e));a=b.child}else Hg(),a=R(a,b);return a;case 5:a:{gg(fg.current);e=gg(dg.current);d=He(e,
b.type);e!==d&&(N(eg,b,b),N(dg,d,b));null===a&&Eg(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;df(e,d)?k=null:f&&df(e,f)&&(b.effectTag|=16);Jg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Eg(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return ig(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=xg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Qg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Mg(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Sg(a){a.effectTag|=4}var Tg=void 0,Ug=void 0,Vg=void 0;Tg=function(){};Ug=function(a,b,c){(b.updateQueue=c)&&Sg(b)};Vg=function(a,b,c,d){c!==d&&Sg(b)};
function Wg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return sf(b),null;case 3:jg(b);tf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Gg(b),b.effectTag&=-3;Tg(b);return null;case 5:kg(b);d=gg(fg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=gg(dg.current);g=We(g,e,f,c,d);Ug(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=gg(dg.current);if(Gg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ye(c,e,f,a,d),b.updateQueue=d,null!==d&&Sg(b);else{a=Te(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}Ve(a,e,c,d);cf(e,c)&&Sg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Vg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=gg(fg.current);gg(dg.current);Gg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,Ze(d,c)&&Sg(b)):(d=Ue(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return jg(b),Tg(b),null;case 13:return bg(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Xg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&uc(c);b=b.value;null!==a&&2===a.tag&&uc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Yg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Zg(a,c)}else b.current=null}
function $g(a){"function"===typeof Kf&&Kf(a);switch(a.tag){case 2:Yg(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Zg(a,c)}break;case 5:Yg(a);break;case 4:ah(a)}}function bh(a){return 5===a.tag||3===a.tag||4===a.tag}
function ch(a){a:{for(var b=a.return;null!==b;){if(bh(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||bh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function ah(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if($g(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:$g(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function dh(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Xe(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function eh(a,b,c){c=Of(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){fh(d);Xg(a,b)};return c}
function gh(a,b,c){c=Of(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===hh?hh=new Set([this]):hh.add(this);var c=b.value,d=b.stack;Xg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function ih(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Xf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=eh(a,d,f);Rf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===hh||!hh.has(c))){a.effectTag|=1024;d=gh(a,b,f);Rf(a,d,f);return}}a=a.return}while(null!==a)}
function jh(a){switch(a.tag){case 2:sf(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return jg(a),tf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return kg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return jg(a),null;case 13:return bg(a),null;default:return null}}var kh=ef(),lh=2,mh=kh,nh=0,oh=0,ph=!1,S=null,qh=null,T=0,rh=-1,sh=!1,U=null,th=!1,uh=!1,hh=null;
function vh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:sf(b);break;case 3:jg(b);tf(b);break;case 5:kg(b);break;case 4:jg(b);break;case 13:bg(b)}a=a.return}qh=null;T=0;rh=-1;sh=!1;S=null;uh=!1}
function wh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Wg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{uh=!0;break}}else{a=jh(a,sh,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function xh(a){var b=Rg(a.alternate,a,T);null===b&&(b=wh(a));ec.current=null;return b}
function yh(a,b,c){ph?A("243"):void 0;ph=!0;if(b!==T||a!==qh||null===S)vh(),qh=a,T=b,rh=-1,S=zf(qh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;sh=!c||T<=lh;do{try{if(c)for(;null!==S&&!zh();)S=xh(S);else for(;null!==S;)S=xh(S)}catch(f){if(null===S)d=!0,fh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;fh(f);break}ih(a,e,c,f,sh,T,mh);S=wh(c)}}break}while(1);ph=!1;if(d)return null;if(null===S){if(uh)return a.pendingCommitExpirationTime=b,a.current.alternate;sh?A("262"):
void 0;0<=rh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&Ah(a,b)},rh);Bh(a.current.expirationTime)}return null}
function Zg(a,b){var c;a:{ph&&!th?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===hh||!hh.has(d))){a=Xf(b,a);a=gh(c,a,1);Qf(c,a,1);og(c,1);c=void 0;break a}break;case 3:a=Xf(b,a);a=eh(c,a,1);Qf(c,a,1);og(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Xf(b,a),c=eh(a,c,1),Qf(a,c,1),og(a,1));c=void 0}return c}
function Ch(){var a=2+25*(((mg()-2+500)/25|0)+1);a<=nh&&(a=nh+1);return nh=a}function ng(a,b){a=0!==oh?oh:ph?th?1:T:b.mode&1?Dh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;Dh&&(0===Eh||a>Eh)&&(Eh=a);return a}
function og(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!ph&&0!==T&&b<T&&vh();var d=c.current.expirationTime;ph&&!th&&qh===c||Ah(c,d);Fh>Gh&&A("185")}else break;a=a.return}}function mg(){mh=ef()-kh;return lh=(mh/10|0)+2}
function Hh(a){var b=oh;oh=2+25*(((mg()-2+500)/25|0)+1);try{return a()}finally{oh=b}}function Ih(a,b,c,d,e){var f=oh;oh=1;try{return a(b,c,d,e)}finally{oh=f}}var Jh=null,V=null,Kh=0,Lh=void 0,W=!1,X=null,Y=0,Eh=0,Mh=!1,Nh=!1,Oh=null,Ph=null,Z=!1,Qh=!1,Dh=!1,Rh=null,Gh=1E3,Fh=0,Sh=1;function Th(a){if(0!==Kh){if(a>Kh)return;null!==Lh&&gf(Lh)}var b=ef()-kh;Kh=a;Lh=ff(Uh,{timeout:10*(a-2)-b})}
function Ah(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Jh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Jh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Qh&&(X=a,Y=1,Vh(a,1,!1)):1===b?Wh():Th(b))}
function Xh(){var a=0,b=null;if(null!==V)for(var c=V,d=Jh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Jh=V=d.nextScheduledRoot=null;break}else if(d===Jh)Jh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Jh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Fh++:Fh=0;X=b;Y=a}function Uh(a){Yh(0,!0,a)}function Wh(){Yh(1,!1,null)}function Yh(a,b,c){Ph=c;Xh();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Mh||mg()>=Y);)mg(),Vh(X,Y,!Mh),Xh();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Vh(X,Y,!1),Xh();null!==Ph&&(Kh=0,Lh=null);0!==Y&&Th(Y);Ph=null;Mh=!1;Zh()}function $h(a,b){W?A("253"):void 0;X=a;Y=b;Vh(a,b,!1);Wh();Zh()}
function Zh(){Fh=0;if(null!==Rh){var a=Rh;Rh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Nh||(Nh=!0,Oh=d)}}}if(Nh)throw a=Oh,Oh=null,Nh=!1,a;}function Vh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?ai(a,c,b):(c=yh(a,b,!0),null!==c&&(zh()?a.finishedWork=c:ai(a,c,b)))):(c=a.finishedWork,null!==c?ai(a,c,b):(c=yh(a,b,!1),null!==c&&ai(a,c,b)));W=!1}
function ai(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Rh?Rh=[d]:Rh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;th=ph=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;mg();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;af=Hd;var f=da();if(Ud(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,nc=0,Jd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++nc===k&&(w=r);t===n&&++Jd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;bf={focusedElem:f,selectionRange:g};Id(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var mi=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=mi}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,Zg(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Ke(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:ch(U);U.effectTag&=-3;break;case 6:ch(U);U.effectTag&=-3;dh(U.alternate,
U);break;case 4:dh(U.alternate,U);break;case 8:D=U,ah(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,Zg(U,y),null!==U&&(U=U.nextEffect))}l=bf;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){null!==u&&Ud(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Td(q,l),D=Td(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}bf=null;Id(af);af=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var hg=U.effectTag;if(hg&36){var oc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ca=l.stateNode;if(l.effectTag&4)if(null===oc)ca.props=l.memoizedProps,ca.state=l.memoizedState,ca.componentDidMount();else{var wi=oc.memoizedProps,xi=oc.memoizedState;ca.props=l.memoizedProps;
ca.state=l.memoizedState;ca.componentDidUpdate(wi,xi,ca.__reactInternalSnapshotBeforeUpdate)}var Ng=l.updateQueue;null!==Ng&&(ca.props=l.memoizedProps,ca.state=l.memoizedState,Wf(l,Ng,ca,u));break;case 3:var Og=l.updateQueue;if(null!==Og){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Wf(l,Og,y,u)}break;case 5:var yi=l.stateNode;null===oc&&l.effectTag&4&&cf(l.type,l.memoizedProps)&&yi.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;
default:A("163")}}if(hg&128){l=void 0;var yc=U.ref;if(null!==yc){var Pg=U.stateNode;switch(U.tag){case 5:l=Pg;break;default:l=Pg}"function"===typeof yc?yc(l):yc.current=l}}var zi=U.nextEffect;U.nextEffect=null;U=zi}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,Zg(U,q),null!==U&&(U=U.nextEffect))}ph=th=!1;"function"===typeof Jf&&Jf(b.stateNode);b=c.current.expirationTime;0===b&&(hh=null);a.remainingExpirationTime=b}function zh(){return null===Ph||Ph.timeRemaining()>Sh?!1:Mh=!0}
function fh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Nh||(Nh=!0,Oh=a)}function Bh(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function bi(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Wh()}}function ci(a,b){if(Z&&!Qh){Qh=!0;try{return a(b)}finally{Qh=!1}}return a(b)}function di(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Ih(a,b)}finally{Z=c,Wh()}}
function ei(a,b,c){if(Dh)return a(b,c);Z||W||0===Eh||(Yh(Eh,!1,null),Eh=0);var d=Dh,e=Z;Z=Dh=!0;try{return a(b,c)}finally{Dh=d,(Z=e)||W||Wh()}}function fi(a){var b=Z;Z=!0;try{Ih(a)}finally{(Z=b)||W||Yh(1,!1,null)}}
function gi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===jd(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(qf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=qf(c)?vf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Of(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Qf(f,e,d);og(f,d);return d}
function hi(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=md(b);return null===a?null:a.stateNode}function ii(a,b,c,d){var e=b.current,f=mg();e=ng(f,e);return gi(a,b,c,e,d)}function ji(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function ki(a){var b=a.findFiberByHostInstance;return If(p({},a,{findHostInstanceByFiber:function(a){a=md(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var li={updateContainerAtExpirationTime:gi,createContainer:function(a,b,c){return Ef(a,b,c)},updateContainer:ii,flushRoot:$h,requestWork:Ah,computeUniqueAsyncExpiration:Ch,batchedUpdates:bi,unbatchedUpdates:ci,deferredUpdates:Hh,syncUpdates:Ih,interactiveUpdates:ei,flushInteractiveUpdates:function(){W||0===Eh||(Yh(Eh,!1,null),Eh=0)},flushControlled:fi,flushSync:di,getPublicRootInstance:ji,findHostInstance:hi,findHostInstanceWithNoPortals:function(a){a=nd(a);return null===a?null:a.stateNode},injectIntoDevTools:ki};
function ni(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:hc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent($e);function oi(a){this._expirationTime=Ch();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}
oi.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new pi;gi(a,b,null,c,d._onCommit);return d};oi.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
oi.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;$h(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};oi.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function pi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}pi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
pi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function qi(a,b,c){this._internalRoot=Ef(a,b,c)}qi.prototype.render=function(a,b){var c=this._internalRoot,d=new pi;b=void 0===b?null:b;null!==b&&d.then(b);ii(a,c,null,d._onCommit);return d};
qi.prototype.unmount=function(a){var b=this._internalRoot,c=new pi;a=void 0===a?null:a;null!==a&&c.then(a);ii(null,b,null,c._onCommit);return c};qi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new pi;c=void 0===c?null:c;null!==c&&e.then(c);ii(b,d,a,e._onCommit);return e};
qi.prototype.createBatch=function(){var a=new oi(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function ri(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=li.batchedUpdates;Tb=li.interactiveUpdates;Ub=li.flushInteractiveUpdates;
function si(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new qi(a,!1,b)}
function ti(a,b,c,d,e){ri(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ji(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=si(c,d);if("function"===typeof e){var h=e;e=function(){var a=ji(f._internalRoot);h.call(a)}}ci(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ji(f._internalRoot)}
function ui(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ri(b)?void 0:A("200");return ni(a,b,null,c)}
var vi={createPortal:ui,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:hi(a)},hydrate:function(a,b,c){return ti(null,a,b,!0,c)},render:function(a,b,c){return ti(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return ti(a,b,c,!1,d)},unmountComponentAtNode:function(a){ri(a)?void 0:A("40");return a._reactRootContainer?(ci(function(){ti(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return ui.apply(void 0,
arguments)},unstable_batchedUpdates:bi,unstable_deferredUpdates:Hh,unstable_interactiveUpdates:ei,flushSync:di,unstable_flushControlled:fi,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Nd},unstable_createRoot:function(a,b){return new qi(a,!0,null!=b&&!0===b.hydrate)}};ki({findFiberByHostInstance:Na,bundleType:0,version:"16.4.1",rendererPackageName:"react-dom"});
var Ai={default:vi},Bi=Ai&&vi||Ai;module.exports=Bi.default?Bi.default:Bi;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(431);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(432);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(151);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(455);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(246);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(443);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(441);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(42)))

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(243);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(445);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(448);


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(449);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42), __webpack_require__(66)(module)))

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(244);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(245);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(246);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(247);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(456);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(151);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(459), src$en$$ = __webpack_require__(464);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(250), src$es5$$ = __webpack_require__(460), src$compiler$$ = __webpack_require__(461), intl$messageformat$parser$$ = __webpack_require__(462);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(250);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(463)['default'];
exports['default'] = exports;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 465 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(467)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(472);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(468), src$en$$ = __webpack_require__(471);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var intl$messageformat$$ = __webpack_require__(249), src$diff$$ = __webpack_require__(469), src$es5$$ = __webpack_require__(470);
exports["default"] = RelativeFormat;

// -----------------------------------------------------------------------------

var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];

// -- RelativeFormat -----------------------------------------------------------

function RelativeFormat(locales, options) {
    options = options || {};

    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (src$es5$$.isArray(locales)) {
        locales = locales.concat();
    }

    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
    src$es5$$.defineProperty(this, '_options', {value: {
        style: this._resolveStyle(options.style),
        units: this._isValidUnits(options.units) && options.units
    }});

    src$es5$$.defineProperty(this, '_locales', {value: locales});
    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlRelativeFormat is missing a ' +
            '`locale` property value'
        );
    }

    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;

    // Add data to IntlMessageFormat.
    intl$messageformat$$["default"].__addLocaleData(data);
}});

// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,

    value: {
        second: 45, 'second-short': 45,  // seconds to minute
        minute: 45, 'minute-short': 45, // minutes to hour
        hour  : 22, 'hour-short': 22, // hours to day
        day   : 26, 'day-short': 26, // days to month
        month : 11, 'month-short': 11 // months to year
    }
});

RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style : this._options.style,
        units : this._options.units
    };
};

RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales        = this._locales;
    var resolvedLocale = this._locale;

    var field        = this._fields[units];
    var relativeTime = field.relativeTime;
    var future       = '';
    var past         = '';
    var i;

    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }

    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }

    var message = '{when, select, future {{0, plural, ' + future + '}}' +
                                 'past {{0, plural, ' + past + '}}}';

    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl$messageformat$$["default"](message, locales);
};

RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;

    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }

    return messages[units];
};

RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];

    if (field.relative) {
        return field.relative[diff];
    }
};

RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale
    );
};

RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();

    if (date === undefined) {
        date = now;
    }

    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError(
            'The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    if (!isFinite(date)) {
        throw new RangeError(
            'The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    var diffReport  = src$diff$$["default"](now, date);
    var units       = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];

    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }

    return this._getMessage(units).format({
        '0' : Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};

RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }

    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error(
                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion
            );
        }
    }

    throw new Error(
        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"'
    );
};

RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);

    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }

    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }

    throw new Error(
        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"'
    );
};

RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function(field) {
        return field.indexOf('-short') < 1;
    });

    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];

        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }

    return units;
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var round = Math.round;

function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}

exports["default"] = function (from, to) {
    // Convert to ms timestamps.
    from = +from;
    to   = +to;

    var millisecond = round(to - from),
        second      = round(millisecond / 1000),
        minute      = round(second / 60),
        hour        = round(minute / 60),
        day         = round(hour / 24),
        week        = round(day / 7);

    var rawYears = daysToYears(day),
        month    = round(rawYears * 12),
        year     = round(rawYears);

    return {
        millisecond    : millisecond,
        second         : second,
        'second-short' : second,
        minute         : minute,
        'minute-short' : minute,
        hour           : hour,
        'hour-short'   : hour,
        day            : day,
        'day-short'    : day,
        week           : week,
        'week-short'   : week,
        month          : month,
        'month-short'  : month,
        year           : year,
        'year-short'   : year
    };
};

//# sourceMappingURL=diff.js.map

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License



var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }

    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }

    return -1;
};

var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

var dateNow = Date.now || function () {
    return new Date().getTime();
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"year-short":{"displayName":"yr.","relative":{"0":"this yr.","1":"next yr.","-1":"last yr."},"relativeTime":{"future":{"one":"in {0} yr.","other":"in {0} yr."},"past":{"one":"{0} yr. ago","other":"{0} yr. ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"month-short":{"displayName":"mo.","relative":{"0":"this mo.","1":"next mo.","-1":"last mo."},"relativeTime":{"future":{"one":"in {0} mo.","other":"in {0} mo."},"past":{"one":"{0} mo. ago","other":"{0} mo. ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"day-short":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"hour-short":{"displayName":"hr.","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hr.","other":"in {0} hr."},"past":{"one":"{0} hr. ago","other":"{0} hr. ago"}}},"minute":{"displayName":"minute","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"minute-short":{"displayName":"min.","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} min.","other":"in {0} min."},"past":{"one":"{0} min. ago","other":"{0} min. ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}},"second-short":{"displayName":"sec.","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} sec.","other":"in {0} sec."},"past":{"one":"{0} sec. ago","other":"{0} sec. ago"}}}}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 472 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(474)['default'];
exports['default'] = exports;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jshint esnext: true */


var src$es5$$ = __webpack_require__(475);
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args    = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format  = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') { return; }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys  = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key  = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i]  = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill



var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(17);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IntlProvider = __webpack_require__(239);

var _IntlProvider2 = _interopRequireDefault(_IntlProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Provider = function Provider(_ref) {
  var store = _ref.store,
      children = _ref.children;
  return _react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(
      _IntlProvider2.default,
      null,
      children
    )
  );
};

Provider.propTypes =  false ? {
  children: _propTypes2.default.element.isRequired
} : {};

exports.default = Provider;

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configureStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_logger__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers__ = __webpack_require__(480);
function configureStore(initialState){return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* createStore */])(__WEBPACK_IMPORTED_MODULE_3__reducers__["a" /* default */],initialState,Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_2_redux_thunk___default.a,__WEBPACK_IMPORTED_MODULE_1_redux_logger___default.a));}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl_redux__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_intl_redux__);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({intl:__WEBPACK_IMPORTED_MODULE_3_react_intl_redux__["intlReducer"],user:__WEBPACK_IMPORTED_MODULE_1__login__["a" /* user */],jobs:__WEBPACK_IMPORTED_MODULE_2__common__["b" /* jobs */],links:__WEBPACK_IMPORTED_MODULE_2__common__["c" /* links */],userIsLoading:__WEBPACK_IMPORTED_MODULE_1__login__["b" /* userIsLoading */],errorMessage:__WEBPACK_IMPORTED_MODULE_2__common__["a" /* errorMessage */]}));

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = user;
/* harmony export (immutable) */ __webpack_exports__["b"] = userIsLoading;
function user(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case'USER_LOGGED_IN_SUCCESS':if(action.fields.user){return action.fields.user;}else if(action.fields.username){return action.fields;}else{return state;}case'USER_UPDATE_PROFILE_SUCCESS':return action.fields;case'USER_LOGOUT_SUCCESS':return Object.assign({},{});default:return state;}}function userIsLoading(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case'USER_IS_LOGGING_IN':return action.userIsLoading;default:return state;}}

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = errorMessage;
/* harmony export (immutable) */ __webpack_exports__["b"] = jobs;
/* harmony export (immutable) */ __webpack_exports__["c"] = links;
function errorMessage(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var action=arguments[1];switch(action.type){case'USER_LOGGED_IN_ERROR':return action.message;case'ERASE_ERROR':return'';default:return state;}}function jobs(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case'GET_JOBS':return action.json;case'ERASE_JOBS':return'';default:return state;}}function links(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case'GET_LINKS':return action.json;case'NO_LINKS':return[];case'ERASE_LINKS':return'';default:return state;}}

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ru_RU = __webpack_require__(484);

var _ru_RU2 = _interopRequireDefault(_ru_RU);

var _ru_RU3 = __webpack_require__(251);

var _ru_RU4 = _interopRequireDefault(_ru_RU3);

var _ru_RU5 = __webpack_require__(252);

var _ru_RU6 = _interopRequireDefault(_ru_RU5);

var _ru_RU7 = __webpack_require__(486);

var _ru_RU8 = _interopRequireDefault(_ru_RU7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    locale: 'ru',
    Pagination: _ru_RU2['default'],
    DatePicker: _ru_RU4['default'],
    TimePicker: _ru_RU6['default'],
    Calendar: _ru_RU8['default'],
    Table: {
        filterTitle: 'Фильтр',
        filterConfirm: 'OK',
        filterReset: 'Сбросить',
        emptyText: 'Нет данных',
        selectAll: 'Выбрать всё',
        selectInvert: 'Инвертировать выбор'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Отмена',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Отмена'
    },
    Transfer: {
        notFoundContent: 'Ничего не найдено',
        searchPlaceholder: 'Введите название для поиска',
        itemUnit: 'элем.',
        itemsUnit: 'элем.'
    },
    Select: {
        notFoundContent: 'Ничего не найдено'
    },
    Upload: {
        uploading: 'Закачиваю...',
        removeFile: 'Удалить файл',
        uploadError: 'Ошибка при закачке',
        previewFile: 'Предпросмотр файла'
    }
};
module.exports = exports['default'];

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  // Options.jsx
  items_per_page: '/странице',
  jump_to: 'Перейти',
  jump_to_confirm: 'подтвердить',
  page: '',

  // Pagination.jsx
  prev_page: 'Назад',
  next_page: 'Вперед',
  prev_5: 'Предыдущие 5',
  next_5: 'Следующие 5',
  prev_3: 'Предыдущие 3',
  next_3: 'Следующие 3'
};
module.exports = exports['default'];

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  today: 'Сегодня',
  now: 'Сейчас',
  backToToday: 'Текущая дата',
  ok: 'Ok',
  clear: 'Очистить',
  month: 'Месяц',
  year: 'Год',
  timeSelect: 'Выбрать время',
  dateSelect: 'Выбрать дату',
  monthSelect: 'Выбрать месяц',
  yearSelect: 'Выбрать год',
  decadeSelect: 'Выбрать десятилетие',
  yearFormat: 'YYYY',
  dateFormat: 'D-M-YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'D-M-YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Предыдущий месяц (PageUp)',
  nextMonth: 'Следующий месяц (PageDown)',
  previousYear: 'Предыдущий год (Control + left)',
  nextYear: 'Следующий год (Control + right)',
  previousDecade: 'Предыдущее десятилетие',
  nextDecade: 'Следущее десятилетие',
  previousCentury: 'Предыдущий век',
  nextCentury: 'Следующий век'
};
module.exports = exports['default'];

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ru_RU = __webpack_require__(251);

var _ru_RU2 = _interopRequireDefault(_ru_RU);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _ru_RU2['default'];
module.exports = exports['default'];

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{user:state.user,errorMessage:state.errorMessage};};var Welcome=function(_Component){_inherits(Welcome,_Component);function Welcome(){_classCallCheck(this,Welcome);return _possibleConstructorReturn(this,(Welcome.__proto__||Object.getPrototypeOf(Welcome)).apply(this,arguments));}_createClass(Welcome,[{key:'render',value:function render(){return null;}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.props.user.account_id){this.props.history.replace(prevProps.to);}}}]);return Welcome;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Welcome));

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_notification_style__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_notification__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__index_less__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions_auth__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_router_dom__ = __webpack_require__(59);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormItem=__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item;var mapStateToProps=function mapStateToProps(state){return{user:state.user,errorMessage:state.errorMessage};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{tryLogin:function tryLogin(login,password){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_auth__["b" /* loginUser */])(login,password));},eraseError:function eraseError(){return dispatch({type:'ERASE_ERROR'});}};};var Login=function(_React$Component){_inherits(Login,_React$Component);function Login(props){_classCallCheck(this,Login);var _this=_possibleConstructorReturn(this,(Login.__proto__||Object.getPrototypeOf(Login)).call(this,props));_this.state={login:null,password:null,loading:false};_this.setAuthData=_this.setAuthData.bind(_this);_this.tryToLoggin=_this.tryToLoggin.bind(_this);return _this;}_createClass(Login,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.user&&nextProps.user!==this.props.user&&nextProps.user.account_id){this.setState({loading:false});__WEBPACK_IMPORTED_MODULE_13_antd_lib_notification___default.a.success({message:"Login as "+nextProps.user.first_name,duration:2});}if(nextProps.errorMessage){this.setState({loading:false});__WEBPACK_IMPORTED_MODULE_13_antd_lib_notification___default.a.error({message:"Login error "+nextProps.errorMessage,duration:2});}}},{key:"tryToLoggin",value:function tryToLoggin(e){e.preventDefault();this.props.tryLogin(this.state.login,this.state.password);this.setState({loading:true});this.props.eraseError();}},{key:"setAuthData",value:function setAuthData(fieldName,value){var stateObject={};stateObject[fieldName]=value;this.setState(stateObject);}},{key:"render",value:function render(){var _this2=this;if(this.props.user.username){return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_router_dom__["c" /* Redirect */],{to:"/"});}else{return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{className:"login-row",type:"flex",justify:"space-around",align:"middle"},__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,null,__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{layout:"horizontal",className:"login-form",id:"login-form"},__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"logo"}),__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(FormItem,null,__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:"user",style:{fontSize:13}}),placeholder:"Login",id:"login-input-field",onChange:function onChange(e){return _this2.setAuthData('login',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(FormItem,null,__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:"lock",style:{fontSize:13}}),type:"password",placeholder:"Password",id:"password-input-field",onChange:function onChange(e){return _this2.setAuthData('password',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"login-button-block"},__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{// className="btn-login"
type:"primary",size:"large",icon:"poweroff",id:"login-button",loading:this.state.loading,htmlType:"submit",onClick:function onClick(e){return _this2.tryToLoggin(e);}},"Login")),__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("p",null))));}}}]);return Login;}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Login));

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(490);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(491);
var Util = __webpack_require__(255);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(492);
var each = __webpack_require__(255).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 492 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(154);

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _createDOMForm = __webpack_require__(496);

var _createDOMForm2 = _interopRequireDefault(_createDOMForm);

var _createFormField = __webpack_require__(264);

var _createFormField2 = _interopRequireDefault(_createFormField);

var _omit = __webpack_require__(47);

var _omit2 = _interopRequireDefault(_omit);

var _warning = __webpack_require__(48);

var _warning2 = _interopRequireDefault(_warning);

var _FormItem = __webpack_require__(579);

var _FormItem2 = _interopRequireDefault(_FormItem);

var _constants = __webpack_require__(270);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Form = function (_React$Component) {
    (0, _inherits3['default'])(Form, _React$Component);

    function Form(props) {
        (0, _classCallCheck3['default'])(this, Form);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

        (0, _warning2['default'])(!props.form, 'It is unnecessary to pass `form` to `Form` after antd@1.7.0.');
        return _this;
    }

    (0, _createClass3['default'])(Form, [{
        key: 'getChildContext',
        value: function getChildContext() {
            var layout = this.props.layout;

            return {
                vertical: layout === 'vertical'
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                hideRequiredMark = _props.hideRequiredMark,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                layout = _props.layout;

            var formClassName = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-horizontal', layout === 'horizontal'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-vertical', layout === 'vertical'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-inline', layout === 'inline'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-hide-required-mark', hideRequiredMark), _classNames), className);
            var formProps = (0, _omit2['default'])(this.props, ['prefixCls', 'className', 'layout', 'form', 'hideRequiredMark']);
            return React.createElement('form', (0, _extends3['default'])({}, formProps, { className: formClassName }));
        }
    }]);
    return Form;
}(React.Component);

exports['default'] = Form;

Form.defaultProps = {
    prefixCls: 'ant-form',
    layout: 'horizontal',
    hideRequiredMark: false,
    onSubmit: function onSubmit(e) {
        e.preventDefault();
    }
};
Form.propTypes = {
    prefixCls: _propTypes2['default'].string,
    layout: _propTypes2['default'].oneOf(['horizontal', 'inline', 'vertical']),
    children: _propTypes2['default'].any,
    onSubmit: _propTypes2['default'].func,
    hideRequiredMark: _propTypes2['default'].bool
};
Form.childContextTypes = {
    vertical: _propTypes2['default'].bool
};
Form.Item = _FormItem2['default'];
Form.createFormField = _createFormField2['default'];
Form.create = function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return (0, _createDOMForm2['default'])((0, _extends3['default'])({ fieldNameProp: 'id' }, options, { fieldMetaProp: _constants.FIELD_META_PROP, fieldDataProp: _constants.FIELD_DATA_PROP }));
};
module.exports = exports['default'];

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _domScrollIntoView = __webpack_require__(155);

var _domScrollIntoView2 = _interopRequireDefault(_domScrollIntoView);

var _has = __webpack_require__(499);

var _has2 = _interopRequireDefault(_has);

var _createBaseForm = __webpack_require__(259);

var _createBaseForm2 = _interopRequireDefault(_createBaseForm);

var _createForm = __webpack_require__(578);

var _utils = __webpack_require__(165);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function computedStyle(el, prop) {
  var getComputedStyle = window.getComputedStyle;
  var style =
  // If we have getComputedStyle
  getComputedStyle ?
  // Query it
  // TODO: From CSS-Query notes, we might need (node, null) for FF
  getComputedStyle(el) :

  // Otherwise, we are in IE and use currentStyle
  el.currentStyle;
  if (style) {
    return style[
    // Switch to camelCase for CSSOM
    // DEV: Grabbed from jQuery
    // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
    // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
    prop.replace(/-(\w)/gi, function (word, letter) {
      return letter.toUpperCase();
    })];
  }
  return undefined;
}

function getScrollableContainer(n) {
  var node = n;
  var nodeName = void 0;
  /* eslint no-cond-assign:0 */
  while ((nodeName = node.nodeName.toLowerCase()) !== 'body') {
    var overflowY = computedStyle(node, 'overflowY');
    // https://stackoverflow.com/a/36900407/3040605
    if (node !== n && (overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) {
      return node;
    }
    node = node.parentNode;
  }
  return nodeName === 'body' ? node.ownerDocument : node;
}

var mixin = {
  getForm: function getForm() {
    return (0, _extends3['default'])({}, _createForm.mixin.getForm.call(this), {
      validateFieldsAndScroll: this.validateFieldsAndScroll
    });
  },
  validateFieldsAndScroll: function validateFieldsAndScroll(ns, opt, cb) {
    var _this = this;

    var _getParams = (0, _utils.getParams)(ns, opt, cb),
        names = _getParams.names,
        callback = _getParams.callback,
        options = _getParams.options;

    var newCb = function newCb(error, values) {
      if (error) {
        var validNames = _this.fieldsStore.getValidFieldsName();
        var firstNode = void 0;
        var firstTop = void 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = validNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var name = _step.value;

            if ((0, _has2['default'])(error, name)) {
              var instance = _this.getFieldInstance(name);
              if (instance) {
                var node = _reactDom2['default'].findDOMNode(instance);
                var top = node.getBoundingClientRect().top;
                if (node.type !== 'hidden' && (firstTop === undefined || firstTop > top)) {
                  firstTop = top;
                  firstNode = node;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator['return']) {
              _iterator['return']();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (firstNode) {
          var c = options.container || getScrollableContainer(firstNode);
          (0, _domScrollIntoView2['default'])(firstNode, c, (0, _extends3['default'])({
            onlyScrollIfNeeded: true
          }, options.scroll));
        }
      }

      if (typeof callback === 'function') {
        callback(error, values);
      }
    };

    return this.validateFields(names, options, newCb);
  }
};

function createDOMForm(option) {
  return (0, _createBaseForm2['default'])((0, _extends3['default'])({}, option), [mixin]);
}

exports['default'] = createDOMForm;
module.exports = exports['default'];

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(498);

function scrollIntoView(elem, container, config) {
  config = config || {};
  // document 归一化到 window
  if (container.nodeType === 9) {
    container = util.getWindow(container);
  }

  var allowHorizontalScroll = config.allowHorizontalScroll;
  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
  var alignWithTop = config.alignWithTop;
  var alignWithLeft = config.alignWithLeft;
  var offsetTop = config.offsetTop || 0;
  var offsetLeft = config.offsetLeft || 0;
  var offsetBottom = config.offsetBottom || 0;
  var offsetRight = config.offsetRight || 0;

  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;

  var isWin = util.isWindow(container);
  var elemOffset = util.offset(elem);
  var eh = util.outerHeight(elem);
  var ew = util.outerWidth(elem);
  var containerOffset = undefined;
  var ch = undefined;
  var cw = undefined;
  var containerScroll = undefined;
  var diffTop = undefined;
  var diffBottom = undefined;
  var win = undefined;
  var winScroll = undefined;
  var ww = undefined;
  var wh = undefined;

  if (isWin) {
    win = container;
    wh = util.height(win);
    ww = util.width(win);
    winScroll = {
      left: util.scrollLeft(win),
      top: util.scrollTop(win)
    };
    // elem 相对 container 可视视窗的距离
    diffTop = {
      left: elemOffset.left - winScroll.left - offsetLeft,
      top: elemOffset.top - winScroll.top - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (winScroll.left + ww) + offsetRight,
      top: elemOffset.top + eh - (winScroll.top + wh) + offsetBottom
    };
    containerScroll = winScroll;
  } else {
    containerOffset = util.offset(container);
    ch = container.clientHeight;
    cw = container.clientWidth;
    containerScroll = {
      left: container.scrollLeft,
      top: container.scrollTop
    };
    // elem 相对 container 可视视窗的距离
    // 注意边框, offset 是边框到根节点
    diffTop = {
      left: elemOffset.left - (containerOffset.left + (parseFloat(util.css(container, 'borderLeftWidth')) || 0)) - offsetLeft,
      top: elemOffset.top - (containerOffset.top + (parseFloat(util.css(container, 'borderTopWidth')) || 0)) - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (containerOffset.left + cw + (parseFloat(util.css(container, 'borderRightWidth')) || 0)) + offsetRight,
      top: elemOffset.top + eh - (containerOffset.top + ch + (parseFloat(util.css(container, 'borderBottomWidth')) || 0)) + offsetBottom
    };
  }

  if (diffTop.top < 0 || diffBottom.top > 0) {
    // 强制向上
    if (alignWithTop === true) {
      util.scrollTop(container, containerScroll.top + diffTop.top);
    } else if (alignWithTop === false) {
      util.scrollTop(container, containerScroll.top + diffBottom.top);
    } else {
      // 自动调整
      if (diffTop.top < 0) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  } else {
    if (!onlyScrollIfNeeded) {
      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
      if (alignWithTop) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  }

  if (allowHorizontalScroll) {
    if (diffTop.left < 0 || diffBottom.left > 0) {
      // 强制向上
      if (alignWithLeft === true) {
        util.scrollLeft(container, containerScroll.left + diffTop.left);
      } else if (alignWithLeft === false) {
        util.scrollLeft(container, containerScroll.left + diffBottom.left);
      } else {
        // 自动调整
        if (diffTop.left < 0) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    } else {
      if (!onlyScrollIfNeeded) {
        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
        if (alignWithLeft) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    }
  }
}

module.exports = scrollIntoView;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

function getClientPosition(elem) {
  var box = undefined;
  var x = undefined;
  var y = undefined;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
function _getComputedStyle(elem, name, computedStyle_) {
  var val = '';
  var d = elem.ownerDocument;
  var computedStyle = computedStyle_ || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

var getComputedStyleX = undefined;
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name = undefined;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop = undefined;
  var j = undefined;
  var i = undefined;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = undefined;
        if (prop === 'border') {
          cssProp = prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj != null && obj == obj.window;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement['scroll' + name],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body['scroll' + name], domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, extra) {
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue == null || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue == null || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  }
  if (borderBoxValueOrIsBorderBox) {
    var padding = extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle);
    return val + (extra === BORDER_INDEX ? 0 : padding);
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay(elem) {
  var val = undefined;
  var args = arguments;
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

function css(el, name, v) {
  var value = v;
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value += 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, val) {
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

// 设置 elem 相对 elem.ownerDocument 的坐标
function setOffset(elem, offset) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var old = getOffset(elem);
  var ret = {};
  var current = undefined;
  var key = undefined;

  for (key in offset) {
    if (offset.hasOwnProperty(key)) {
      current = parseFloat(css(elem, key)) || 0;
      ret[key] = current + offset[key] - old[key];
    }
  }
  css(elem, ret);
}

module.exports = _extends({
  getWindow: function getWindow(node) {
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  offset: function offset(el, value) {
    if (typeof value !== 'undefined') {
      setOffset(el, value);
    } else {
      return getOffset(el);
    }
  },

  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var ret = {};
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  scrollLeft: function scrollLeft(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollLeft(w);
      }
      window.scrollTo(v, getScrollTop(w));
    } else {
      if (v === undefined) {
        return w.scrollLeft;
      }
      w.scrollLeft = v;
    }
  },
  scrollTop: function scrollTop(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollTop(w);
      }
      window.scrollTo(getScrollLeft(w), v);
    } else {
      if (v === undefined) {
        return w.scrollTop;
      }
      w.scrollTop = v;
    }
  },

  viewportWidth: 0,
  viewportHeight: 0
}, domUtils);

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(500),
    hasPath = __webpack_require__(501);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 500 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(156),
    isArguments = __webpack_require__(538),
    isArray = __webpack_require__(109),
    isIndex = __webpack_require__(258),
    isLength = __webpack_require__(540),
    toKey = __webpack_require__(164);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(109),
    isSymbol = __webpack_require__(157);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(159);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 505 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(507);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(508);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(509);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(510),
    mapCacheDelete = __webpack_require__(530),
    mapCacheGet = __webpack_require__(532),
    mapCacheHas = __webpack_require__(533),
    mapCacheSet = __webpack_require__(534);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(511),
    ListCache = __webpack_require__(523),
    Map = __webpack_require__(529);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(512),
    hashDelete = __webpack_require__(519),
    hashGet = __webpack_require__(520),
    hashHas = __webpack_require__(521),
    hashSet = __webpack_require__(522);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(110);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(514),
    isMasked = __webpack_require__(515),
    isObject = __webpack_require__(163),
    toSource = __webpack_require__(517);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(158),
    isObject = __webpack_require__(163);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(516);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(160);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 517 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 518 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 519 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(110);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(110);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(110);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(524),
    listCacheDelete = __webpack_require__(525),
    listCacheGet = __webpack_require__(526),
    listCacheHas = __webpack_require__(527),
    listCacheSet = __webpack_require__(528);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 524 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(111);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(111);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(111);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(111);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(162),
    root = __webpack_require__(160);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(112);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 531 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(112);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(112);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(112);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(536);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(159),
    arrayMap = __webpack_require__(537),
    isArray = __webpack_require__(109),
    isSymbol = __webpack_require__(157);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 537 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(539),
    isObjectLike = __webpack_require__(161);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(158),
    isObjectLike = __webpack_require__(161);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 540 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(542), __esModule: true };

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105);
__webpack_require__(543);
module.exports = __webpack_require__(44).Array.from;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(130);
var $export = __webpack_require__(62);
var toObject = __webpack_require__(139);
var call = __webpack_require__(544);
var isArrayIter = __webpack_require__(545);
var toLength = __webpack_require__(230);
var createProperty = __webpack_require__(546);
var getIterFn = __webpack_require__(260);

$export($export.S + $export.F * !__webpack_require__(547)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(63);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(76);
var ITERATOR = __webpack_require__(45)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(57);
var createDesc = __webpack_require__(88);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(45)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(86);

var emptyObject = __webpack_require__(146);
var _invariant = __webpack_require__(106);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validator___ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__messages__ = __webpack_require__(570);






/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */
function Schema(descriptor) {
  this.rules = null;
  this._messages = __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* messages */];
  this.define(descriptor);
}

Schema.prototype = {
  messages: function messages(_messages) {
    if (_messages) {
      this._messages = Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* deepMerge */])(Object(__WEBPACK_IMPORTED_MODULE_4__messages__["b" /* newMessages */])(), _messages);
    }
    return this._messages;
  },
  define: function define(rules) {
    if (!rules) {
      throw new Error('Cannot configure a schema with no rules');
    }
    if ((typeof rules === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(rules)) !== 'object' || Array.isArray(rules)) {
      throw new Error('Rules must be an object');
    }
    this.rules = {};
    var z = void 0;
    var item = void 0;
    for (z in rules) {
      if (rules.hasOwnProperty(z)) {
        item = rules[z];
        this.rules[z] = Array.isArray(item) ? item : [item];
      }
    }
  },
  validate: function validate(source_) {
    var _this = this;

    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var oc = arguments[2];

    var source = source_;
    var options = o;
    var callback = oc;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback();
      }
      return;
    }
    function complete(results) {
      var i = void 0;
      var field = void 0;
      var errors = [];
      var fields = {};

      function add(e) {
        if (Array.isArray(e)) {
          errors = errors.concat.apply(errors, e);
        } else {
          errors.push(e);
        }
      }

      for (i = 0; i < results.length; i++) {
        add(results[i]);
      }
      if (!errors.length) {
        errors = null;
        fields = null;
      } else {
        for (i = 0; i < errors.length; i++) {
          field = errors[i].field;
          fields[field] = fields[field] || [];
          fields[field].push(errors[i]);
        }
      }
      callback(errors, fields);
    }

    if (options.messages) {
      var messages = this.messages();
      if (messages === __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* messages */]) {
        messages = Object(__WEBPACK_IMPORTED_MODULE_4__messages__["b" /* newMessages */])();
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* deepMerge */])(messages, options.messages);
      options.messages = messages;
    } else {
      options.messages = this.messages();
    }
    var arr = void 0;
    var value = void 0;
    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function (z) {
      arr = _this.rules[z];
      value = source[z];
      arr.forEach(function (r) {
        var rule = r;
        if (typeof rule.transform === 'function') {
          if (source === source_) {
            source = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, source);
          }
          value = source[z] = rule.transform(value);
        }
        if (typeof rule === 'function') {
          rule = {
            validator: rule
          };
        } else {
          rule = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rule);
        }
        rule.validator = _this.getValidationMethod(rule);
        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this.getType(rule);
        if (!rule.validator) {
          return;
        }
        series[z] = series[z] || [];
        series[z].push({
          rule: rule,
          value: value,
          source: source,
          field: z
        });
      });
    });
    var errorFields = {};
    Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* asyncMap */])(series, options, function (data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === 'object' || rule.type === 'array') && (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(rule.fields) === 'object' || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(rule.defaultField) === 'object');
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;
      function addFullfield(key, schema) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, schema, {
          fullField: rule.fullField + '.' + key
        });
      }

      function cb() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var errors = e;
        if (!Array.isArray(errors)) {
          errors = [errors];
        }
        if (errors.length) {
          Object(__WEBPACK_IMPORTED_MODULE_2__util__["f" /* warning */])('async-validator:', errors);
        }
        if (errors.length && rule.message) {
          errors = [].concat(rule.message);
        }

        errors = errors.map(Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* complementError */])(rule));

        if (options.first && errors.length) {
          errorFields[rule.field] = 1;
          return doIt(errors);
        }
        if (!deep) {
          doIt(errors);
        } else {
          // if rule is required but the target object
          // does not exist fail at the rule level and don't
          // go deeper
          if (rule.required && !data.value) {
            if (rule.message) {
              errors = [].concat(rule.message).map(Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* complementError */])(rule));
            } else if (options.error) {
              errors = [options.error(rule, Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* format */])(options.messages.required, rule.field))];
            } else {
              errors = [];
            }
            return doIt(errors);
          }

          var fieldsSchema = {};
          if (rule.defaultField) {
            for (var k in data.value) {
              if (data.value.hasOwnProperty(k)) {
                fieldsSchema[k] = rule.defaultField;
              }
            }
          }
          fieldsSchema = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, fieldsSchema, data.rule.fields);
          for (var f in fieldsSchema) {
            if (fieldsSchema.hasOwnProperty(f)) {
              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
            }
          }
          var schema = new Schema(fieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function (errs) {
            doIt(errs && errs.length ? errors.concat(errs) : errs);
          });
        }
      }

      var res = rule.validator(rule, data.value, cb, data.source, options);
      if (res && res.then) {
        res.then(function () {
          return cb();
        }, function (e) {
          return cb(e);
        });
      }
    }, function (results) {
      complete(results);
    });
  },
  getType: function getType(rule) {
    if (rule.type === undefined && rule.pattern instanceof RegExp) {
      rule.type = 'pattern';
    }
    if (typeof rule.validator !== 'function' && rule.type && !__WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */].hasOwnProperty(rule.type)) {
      throw new Error(Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* format */])('Unknown rule type %s', rule.type));
    }
    return rule.type || 'string';
  },
  getValidationMethod: function getValidationMethod(rule) {
    if (typeof rule.validator === 'function') {
      return rule.validator;
    }
    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf('message');
    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }
    if (keys.length === 1 && keys[0] === 'required') {
      return __WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */].required;
    }
    return __WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */][this.getType(rule)] || false;
  }
};

Schema.register = function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }
  __WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */][type] = validator;
};

Schema.messages = __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* messages */];

/* harmony default export */ __webpack_exports__["default"] = (Schema);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__string__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__method__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__boolean__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__regexp__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__integer__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__float__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__array__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__object__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__enum__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pattern__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__date__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__required__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__type__ = __webpack_require__(569);















/* harmony default export */ __webpack_exports__["a"] = ({
  string: __WEBPACK_IMPORTED_MODULE_0__string__["a" /* default */],
  method: __WEBPACK_IMPORTED_MODULE_1__method__["a" /* default */],
  number: __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */],
  boolean: __WEBPACK_IMPORTED_MODULE_3__boolean__["a" /* default */],
  regexp: __WEBPACK_IMPORTED_MODULE_4__regexp__["a" /* default */],
  integer: __WEBPACK_IMPORTED_MODULE_5__integer__["a" /* default */],
  float: __WEBPACK_IMPORTED_MODULE_6__float__["a" /* default */],
  array: __WEBPACK_IMPORTED_MODULE_7__array__["a" /* default */],
  object: __WEBPACK_IMPORTED_MODULE_8__object__["a" /* default */],
  'enum': __WEBPACK_IMPORTED_MODULE_9__enum__["a" /* default */],
  pattern: __WEBPACK_IMPORTED_MODULE_10__pattern__["a" /* default */],
  date: __WEBPACK_IMPORTED_MODULE_11__date__["a" /* default */],
  url: __WEBPACK_IMPORTED_MODULE_13__type__["a" /* default */],
  hex: __WEBPACK_IMPORTED_MODULE_13__type__["a" /* default */],
  email: __WEBPACK_IMPORTED_MODULE_13__type__["a" /* default */],
  required: __WEBPACK_IMPORTED_MODULE_12__required__["a" /* default */]
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(29);



/**
 *  Performs validation for string types.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string') && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options, 'string');
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string')) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (string);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(29);


/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.whitespace, rule.fullField));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (whitespace);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__required__ = __webpack_require__(262);




/* eslint max-len:0 */

var pattern = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};

var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  float: function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === 'number';
  },
  object: function object(value) {
    return (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object' && !types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
  },
  url: function url(value) {
    return typeof value === 'string' && !!value.match(pattern.url);
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(pattern.hex);
  }
};

/**
 *  Rule for validating the type of a value.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    Object(__WEBPACK_IMPORTED_MODULE_2__required__["a" /* default */])(rule, value, source, errors, options);
    return;
  }
  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* format */](options.messages.types[ruleType], rule.fullField, rule.type));
    }
    // straight typeof check
  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) !== rule.type) {
    errors.push(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* format */](options.messages.types[ruleType], rule.fullField, rule.type));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (type);

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(29);


/**
 *  Rule for validating minimum and maximum allowed values.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number';
  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);
  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  }
  // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (range);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(29);

var ENUM = 'enum';

/**
 *  Rule for validating a value exists in an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (enumerable);

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(29);


/**
 *  Rule for validating a regular expression pattern.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (pattern);

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(29);



/**
 *  Validates a function.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (method);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(29);



/**
 *  Validates a number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (number);

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rule___ = __webpack_require__(40);



/**
 *  Validates a boolean.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_1__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_1__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (boolean);

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(29);



/**
 *  Validates the regular expression type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value)) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (regexp);

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(29);



/**
 *  Validates a number is an integer.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (integer);

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(29);



/**
 *  Validates a number is a floating point number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (floatFn);

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(29);


/**
 *  Validates an array.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'array') && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options, 'array');
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'array')) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (array);

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(29);



/**
 *  Validates an object.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (object);

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(29);


var ENUM = 'enum';

/**
 *  Validates an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */][ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (enumerable);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(29);



/**
 *  Validates a regular expression pattern.
 *
 *  Performs validation when a rule only contains
 *  a pattern property but is not declared as a string type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string') && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string')) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (pattern);

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(29);



function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  // console.log('validate on %s value', value);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value)) {
      var dateObject = void 0;

      if (typeof value === 'number') {
        dateObject = new Date(value);
      } else {
        dateObject = value;
      }

      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, dateObject, source, errors, options);
      if (dateObject) {
        __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (date);

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rule___ = __webpack_require__(40);



function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value);
  __WEBPACK_IMPORTED_MODULE_1__rule___["a" /* default */].required(rule, value, source, errors, options, type);
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (required);

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(29);



function type(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, ruleType) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options, ruleType);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, ruleType)) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (type);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = newMessages;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messages; });
function newMessages() {
  return {
    'default': 'Validation error on field %s',
    required: '%s is required',
    'enum': '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      boolean: '%s is not a %s',
      integer: '%s is not an %s',
      float: '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}

var messages = newMessages();

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(572);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(156),
    toKey = __webpack_require__(164);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(574),
    castPath = __webpack_require__(156),
    isIndex = __webpack_require__(258),
    isObject = __webpack_require__(163),
    toKey = __webpack_require__(164);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(575),
    eq = __webpack_require__(257);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(576);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(162);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

exports['default'] = createFieldsStore;

var _set = __webpack_require__(263);

var _set2 = _interopRequireDefault(_set);

var _createFormField = __webpack_require__(264);

var _createFormField2 = _interopRequireDefault(_createFormField);

var _utils = __webpack_require__(165);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function partOf(a, b) {
  return b.indexOf(a) === 0 && ['.', '['].indexOf(b[a.length]) !== -1;
}

var FieldsStore = function () {
  function FieldsStore(fields) {
    (0, _classCallCheck3['default'])(this, FieldsStore);

    _initialiseProps.call(this);

    this.fields = this.flattenFields(fields);
    this.fieldsMeta = {};
  }

  (0, _createClass3['default'])(FieldsStore, [{
    key: 'updateFields',
    value: function updateFields(fields) {
      this.fields = this.flattenFields(fields);
    }
  }, {
    key: 'flattenFields',
    value: function flattenFields(fields) {
      return (0, _utils.flattenFields)(fields, function (_, node) {
        return (0, _createFormField.isFormField)(node);
      }, 'You must wrap field data with `createFormField`.');
    }
  }, {
    key: 'flattenRegisteredFields',
    value: function flattenRegisteredFields(fields) {
      var validFieldsName = this.getAllFieldsName();
      return (0, _utils.flattenFields)(fields, function (path) {
        return validFieldsName.indexOf(path) >= 0;
      }, 'You cannot set field before registering it.');
    }
  }, {
    key: 'setFields',
    value: function setFields(fields) {
      var _this = this;

      var fieldsMeta = this.fieldsMeta;
      var nowFields = (0, _extends3['default'])({}, this.fields, fields);
      var nowValues = {};
      Object.keys(fieldsMeta).forEach(function (f) {
        return nowValues[f] = _this.getValueFromFields(f, nowFields);
      });
      Object.keys(nowValues).forEach(function (f) {
        var value = nowValues[f];
        var fieldMeta = _this.getFieldMeta(f);
        if (fieldMeta && fieldMeta.normalize) {
          var nowValue = fieldMeta.normalize(value, _this.getValueFromFields(f, _this.fields), nowValues);
          if (nowValue !== value) {
            nowFields[f] = (0, _extends3['default'])({}, nowFields[f], {
              value: nowValue
            });
          }
        }
      });
      this.fields = nowFields;
    }
  }, {
    key: 'resetFields',
    value: function resetFields(ns) {
      var fields = this.fields;

      var names = ns ? this.getValidFieldsFullName(ns) : this.getAllFieldsName();
      return names.reduce(function (acc, name) {
        var field = fields[name];
        if (field && 'value' in field) {
          acc[name] = {};
        }
        return acc;
      }, {});
    }
  }, {
    key: 'setFieldMeta',
    value: function setFieldMeta(name, meta) {
      this.fieldsMeta[name] = meta;
    }
  }, {
    key: 'getFieldMeta',
    value: function getFieldMeta(name) {
      this.fieldsMeta[name] = this.fieldsMeta[name] || {};
      return this.fieldsMeta[name];
    }
  }, {
    key: 'getValueFromFields',
    value: function getValueFromFields(name, fields) {
      var field = fields[name];
      if (field && 'value' in field) {
        return field.value;
      }
      var fieldMeta = this.getFieldMeta(name);
      return fieldMeta && fieldMeta.initialValue;
    }
  }, {
    key: 'getValidFieldsName',
    value: function getValidFieldsName() {
      var _this2 = this;

      var fieldsMeta = this.fieldsMeta;

      return fieldsMeta ? Object.keys(fieldsMeta).filter(function (name) {
        return !_this2.getFieldMeta(name).hidden;
      }) : [];
    }
  }, {
    key: 'getAllFieldsName',
    value: function getAllFieldsName() {
      var fieldsMeta = this.fieldsMeta;

      return fieldsMeta ? Object.keys(fieldsMeta) : [];
    }
  }, {
    key: 'getValidFieldsFullName',
    value: function getValidFieldsFullName(maybePartialName) {
      var maybePartialNames = Array.isArray(maybePartialName) ? maybePartialName : [maybePartialName];
      return this.getValidFieldsName().filter(function (fullName) {
        return maybePartialNames.some(function (partialName) {
          return fullName === partialName || (0, _utils.startsWith)(fullName, partialName) && ['.', '['].indexOf(fullName[partialName.length]) >= 0;
        });
      });
    }
  }, {
    key: 'getFieldValuePropValue',
    value: function getFieldValuePropValue(fieldMeta) {
      var name = fieldMeta.name,
          getValueProps = fieldMeta.getValueProps,
          valuePropName = fieldMeta.valuePropName;

      var field = this.getField(name);
      var fieldValue = 'value' in field ? field.value : fieldMeta.initialValue;
      if (getValueProps) {
        return getValueProps(fieldValue);
      }
      return (0, _defineProperty3['default'])({}, valuePropName, fieldValue);
    }
  }, {
    key: 'getField',
    value: function getField(name) {
      return (0, _extends3['default'])({}, this.fields[name], {
        name: name
      });
    }
  }, {
    key: 'getNotCollectedFields',
    value: function getNotCollectedFields() {
      var _this3 = this;

      return this.getValidFieldsName().filter(function (name) {
        return !_this3.fields[name];
      }).map(function (name) {
        return {
          name: name,
          dirty: false,
          value: _this3.getFieldMeta(name).initialValue
        };
      }).reduce(function (acc, field) {
        return (0, _set2['default'])(acc, field.name, (0, _createFormField2['default'])(field));
      }, {});
    }
  }, {
    key: 'getNestedAllFields',
    value: function getNestedAllFields() {
      var _this4 = this;

      return Object.keys(this.fields).reduce(function (acc, name) {
        return (0, _set2['default'])(acc, name, (0, _createFormField2['default'])(_this4.fields[name]));
      }, this.getNotCollectedFields());
    }
  }, {
    key: 'getFieldMember',
    value: function getFieldMember(name, member) {
      return this.getField(name)[member];
    }
  }, {
    key: 'getNestedFields',
    value: function getNestedFields(names, getter) {
      var fields = names || this.getValidFieldsName();
      return fields.reduce(function (acc, f) {
        return (0, _set2['default'])(acc, f, getter(f));
      }, {});
    }
  }, {
    key: 'getNestedField',
    value: function getNestedField(name, getter) {
      var fullNames = this.getValidFieldsFullName(name);
      if (fullNames.length === 0 || // Not registered
      fullNames.length === 1 && fullNames[0] === name // Name already is full name.
      ) {
          return getter(name);
        }
      var isArrayValue = fullNames[0][name.length] === '[';
      var suffixNameStartIndex = isArrayValue ? name.length : name.length + 1;
      return fullNames.reduce(function (acc, fullName) {
        return (0, _set2['default'])(acc, fullName.slice(suffixNameStartIndex), getter(fullName));
      }, isArrayValue ? [] : {});
    }
  }, {
    key: 'isValidNestedFieldName',


    // @private
    // BG: `a` and `a.b` cannot be use in the same form
    value: function isValidNestedFieldName(name) {
      var names = this.getAllFieldsName();
      return names.every(function (n) {
        return !partOf(n, name) && !partOf(name, n);
      });
    }
  }, {
    key: 'clearField',
    value: function clearField(name) {
      delete this.fields[name];
      delete this.fieldsMeta[name];
    }
  }]);
  return FieldsStore;
}();

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.setFieldsInitialValue = function (initialValues) {
    var flattenedInitialValues = _this5.flattenRegisteredFields(initialValues);
    var fieldsMeta = _this5.fieldsMeta;
    Object.keys(flattenedInitialValues).forEach(function (name) {
      if (fieldsMeta[name]) {
        _this5.setFieldMeta(name, (0, _extends3['default'])({}, _this5.getFieldMeta(name), {
          initialValue: flattenedInitialValues[name]
        }));
      }
    });
  };

  this.getAllValues = function () {
    var fieldsMeta = _this5.fieldsMeta,
        fields = _this5.fields;

    return Object.keys(fieldsMeta).reduce(function (acc, name) {
      return (0, _set2['default'])(acc, name, _this5.getValueFromFields(name, fields));
    }, {});
  };

  this.getFieldsValue = function (names) {
    return _this5.getNestedFields(names, _this5.getFieldValue);
  };

  this.getFieldValue = function (name) {
    var fields = _this5.fields;

    return _this5.getNestedField(name, function (fullName) {
      return _this5.getValueFromFields(fullName, fields);
    });
  };

  this.getFieldsError = function (names) {
    return _this5.getNestedFields(names, _this5.getFieldError);
  };

  this.getFieldError = function (name) {
    return _this5.getNestedField(name, function (fullName) {
      return (0, _utils.getErrorStrs)(_this5.getFieldMember(fullName, 'errors'));
    });
  };

  this.isFieldValidating = function (name) {
    return _this5.getFieldMember(name, 'validating');
  };

  this.isFieldsValidating = function (ns) {
    var names = ns || _this5.getValidFieldsName();
    return names.some(function (n) {
      return _this5.isFieldValidating(n);
    });
  };

  this.isFieldTouched = function (name) {
    return _this5.getFieldMember(name, 'touched');
  };

  this.isFieldsTouched = function (ns) {
    var names = ns || _this5.getValidFieldsName();
    return names.some(function (n) {
      return _this5.isFieldTouched(n);
    });
  };
};

function createFieldsStore(fields) {
  return new FieldsStore(fields);
}
module.exports = exports['default'];

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mixin = undefined;

var _createBaseForm = __webpack_require__(259);

var _createBaseForm2 = _interopRequireDefault(_createBaseForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mixin = exports.mixin = {
  getForm: function getForm() {
    return {
      getFieldsValue: this.fieldsStore.getFieldsValue,
      getFieldValue: this.fieldsStore.getFieldValue,
      getFieldInstance: this.getFieldInstance,
      setFieldsValue: this.setFieldsValue,
      setFields: this.setFields,
      setFieldsInitialValue: this.fieldsStore.setFieldsInitialValue,
      getFieldDecorator: this.getFieldDecorator,
      getFieldProps: this.getFieldProps,
      getFieldsError: this.fieldsStore.getFieldsError,
      getFieldError: this.fieldsStore.getFieldError,
      isFieldValidating: this.fieldsStore.isFieldValidating,
      isFieldsValidating: this.fieldsStore.isFieldsValidating,
      isFieldsTouched: this.fieldsStore.isFieldsTouched,
      isFieldTouched: this.fieldsStore.isFieldTouched,
      isSubmitting: this.isSubmitting,
      submit: this.submit,
      validateFields: this.validateFields,
      resetFields: this.resetFields
    };
  }
};

function createForm(options) {
  return (0, _createBaseForm2['default'])(options, [mixin]);
}

exports['default'] = createForm;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(15);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _intersperse = __webpack_require__(580);

var _intersperse2 = _interopRequireDefault(_intersperse);

var _rcAnimate = __webpack_require__(50);

var _rcAnimate2 = _interopRequireDefault(_rcAnimate);

var _row = __webpack_require__(254);

var _row2 = _interopRequireDefault(_row);

var _col = __webpack_require__(256);

var _col2 = _interopRequireDefault(_col);

var _warning = __webpack_require__(48);

var _warning2 = _interopRequireDefault(_warning);

var _constants = __webpack_require__(270);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var FormItem = function (_React$Component) {
    (0, _inherits3['default'])(FormItem, _React$Component);

    function FormItem() {
        (0, _classCallCheck3['default'])(this, FormItem);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (FormItem.__proto__ || Object.getPrototypeOf(FormItem)).apply(this, arguments));

        _this.helpShow = false;
        _this.onHelpAnimEnd = function (_key, helpShow) {
            _this.helpShow = helpShow;
            if (!helpShow) {
                _this.setState({});
            }
        };
        // Resolve duplicated ids bug between different forms
        // https://github.com/ant-design/ant-design/issues/7351
        _this.onLabelClick = function (e) {
            var label = _this.props.label;

            var id = _this.props.id || _this.getId();
            if (!id) {
                return;
            }
            var controls = document.querySelectorAll('[id="' + id + '"]');
            if (controls.length !== 1) {
                // Only prevent in default situation
                // Avoid preventing event in `label={<a href="xx">link</a>}``
                if (typeof label === 'string') {
                    e.preventDefault();
                }
                var formItemNode = ReactDOM.findDOMNode(_this);
                var control = formItemNode.querySelector('[id="' + id + '"]');
                if (control && control.focus) {
                    control.focus();
                }
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(FormItem, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _warning2['default'])(this.getControls(this.props.children, true).length <= 1, '`Form.Item` cannot generate `validateStatus` and `help` automatically, ' + 'while there are more than one `getFieldDecorator` in it.');
        }
    }, {
        key: 'getHelpMessage',
        value: function getHelpMessage() {
            var help = this.props.help;

            if (help === undefined && this.getOnlyControl()) {
                var errors = this.getField().errors;
                if (errors) {
                    return (0, _intersperse2['default'])(errors.map(function (e, index) {
                        return React.isValidElement(e.message) ? React.cloneElement(e.message, { key: index }) : e.message;
                    }), ' ');
                }
                return '';
            }
            return help;
        }
    }, {
        key: 'getControls',
        value: function getControls(children, recursively) {
            var controls = [];
            var childrenArray = React.Children.toArray(children);
            for (var i = 0; i < childrenArray.length; i++) {
                if (!recursively && controls.length > 0) {
                    break;
                }
                var child = childrenArray[i];
                if (child.type && (child.type === FormItem || child.type.displayName === 'FormItem')) {
                    continue;
                }
                if (!child.props) {
                    continue;
                }
                if (_constants.FIELD_META_PROP in child.props) {
                    // And means FIELD_DATA_PROP in child.props, too.
                    controls.push(child);
                } else if (child.props.children) {
                    controls = controls.concat(this.getControls(child.props.children, recursively));
                }
            }
            return controls;
        }
    }, {
        key: 'getOnlyControl',
        value: function getOnlyControl() {
            var child = this.getControls(this.props.children, false)[0];
            return child !== undefined ? child : null;
        }
    }, {
        key: 'getChildProp',
        value: function getChildProp(prop) {
            var child = this.getOnlyControl();
            return child && child.props && child.props[prop];
        }
    }, {
        key: 'getId',
        value: function getId() {
            return this.getChildProp('id');
        }
    }, {
        key: 'getMeta',
        value: function getMeta() {
            return this.getChildProp(_constants.FIELD_META_PROP);
        }
    }, {
        key: 'getField',
        value: function getField() {
            return this.getChildProp(_constants.FIELD_DATA_PROP);
        }
    }, {
        key: 'renderHelp',
        value: function renderHelp() {
            var prefixCls = this.props.prefixCls;
            var help = this.getHelpMessage();
            var children = help ? React.createElement(
                'div',
                { className: prefixCls + '-explain', key: 'help' },
                help
            ) : null;
            if (children) {
                this.helpShow = !!children;
            }
            return React.createElement(
                _rcAnimate2['default'],
                { transitionName: 'show-help', component: '', transitionAppear: true, key: 'help', onEnd: this.onHelpAnimEnd },
                children
            );
        }
    }, {
        key: 'renderExtra',
        value: function renderExtra() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                extra = _props.extra;

            return extra ? React.createElement(
                'div',
                { className: prefixCls + '-extra' },
                extra
            ) : null;
        }
    }, {
        key: 'getValidateStatus',
        value: function getValidateStatus() {
            var onlyControl = this.getOnlyControl();
            if (!onlyControl) {
                return '';
            }
            var field = this.getField();
            if (field.validating) {
                return 'validating';
            }
            if (field.errors) {
                return 'error';
            }
            var fieldValue = 'value' in field ? field.value : this.getMeta().initialValue;
            if (fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
                return 'success';
            }
            return '';
        }
    }, {
        key: 'renderValidateWrapper',
        value: function renderValidateWrapper(c1, c2, c3) {
            var props = this.props;
            var onlyControl = this.getOnlyControl;
            var validateStatus = props.validateStatus === undefined && onlyControl ? this.getValidateStatus() : props.validateStatus;
            var classes = this.props.prefixCls + '-item-control';
            if (validateStatus) {
                classes = (0, _classnames2['default'])(this.props.prefixCls + '-item-control', {
                    'has-feedback': props.hasFeedback || validateStatus === 'validating',
                    'has-success': validateStatus === 'success',
                    'has-warning': validateStatus === 'warning',
                    'has-error': validateStatus === 'error',
                    'is-validating': validateStatus === 'validating'
                });
            }
            return React.createElement(
                'div',
                { className: classes },
                React.createElement(
                    'span',
                    { className: this.props.prefixCls + '-item-children' },
                    c1
                ),
                c2,
                c3
            );
        }
    }, {
        key: 'renderWrapper',
        value: function renderWrapper(children) {
            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                wrapperCol = _props2.wrapperCol;

            var className = (0, _classnames2['default'])(prefixCls + '-item-control-wrapper', wrapperCol && wrapperCol.className);
            return React.createElement(
                _col2['default'],
                (0, _extends3['default'])({}, wrapperCol, { className: className, key: 'wrapper' }),
                children
            );
        }
    }, {
        key: 'isRequired',
        value: function isRequired() {
            var required = this.props.required;

            if (required !== undefined) {
                return required;
            }
            if (this.getOnlyControl()) {
                var meta = this.getMeta() || {};
                var validate = meta.validate || [];
                return validate.filter(function (item) {
                    return !!item.rules;
                }).some(function (item) {
                    return item.rules.some(function (rule) {
                        return rule.required;
                    });
                });
            }
            return false;
        }
    }, {
        key: 'renderLabel',
        value: function renderLabel() {
            var _props3 = this.props,
                prefixCls = _props3.prefixCls,
                label = _props3.label,
                labelCol = _props3.labelCol,
                colon = _props3.colon,
                id = _props3.id;

            var context = this.context;
            var required = this.isRequired();
            var labelColClassName = (0, _classnames2['default'])(prefixCls + '-item-label', labelCol && labelCol.className);
            var labelClassName = (0, _classnames2['default'])((0, _defineProperty3['default'])({}, prefixCls + '-item-required', required));
            var labelChildren = label;
            // Keep label is original where there should have no colon
            var haveColon = colon && !context.vertical;
            // Remove duplicated user input colon
            if (haveColon && typeof label === 'string' && label.trim() !== '') {
                labelChildren = label.replace(/[：|:]\s*$/, '');
            }
            return label ? React.createElement(
                _col2['default'],
                (0, _extends3['default'])({}, labelCol, { className: labelColClassName, key: 'label' }),
                React.createElement(
                    'label',
                    { htmlFor: id || this.getId(), className: labelClassName, title: typeof label === 'string' ? label : '', onClick: this.onLabelClick },
                    labelChildren
                )
            ) : null;
        }
    }, {
        key: 'renderChildren',
        value: function renderChildren() {
            var children = this.props.children;

            return [this.renderLabel(), this.renderWrapper(this.renderValidateWrapper(children, this.renderHelp(), this.renderExtra()))];
        }
    }, {
        key: 'renderFormItem',
        value: function renderFormItem(children) {
            var _itemClassName;

            var props = this.props;
            var prefixCls = props.prefixCls;
            var style = props.style;
            var itemClassName = (_itemClassName = {}, (0, _defineProperty3['default'])(_itemClassName, prefixCls + '-item', true), (0, _defineProperty3['default'])(_itemClassName, prefixCls + '-item-with-help', this.helpShow), (0, _defineProperty3['default'])(_itemClassName, prefixCls + '-item-no-colon', !props.colon), (0, _defineProperty3['default'])(_itemClassName, '' + props.className, !!props.className), _itemClassName);
            return React.createElement(
                _row2['default'],
                { className: (0, _classnames2['default'])(itemClassName), style: style },
                children
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var children = this.renderChildren();
            return this.renderFormItem(children);
        }
    }]);
    return FormItem;
}(React.Component);

exports['default'] = FormItem;

FormItem.defaultProps = {
    hasFeedback: false,
    prefixCls: 'ant-form',
    colon: true
};
FormItem.propTypes = {
    prefixCls: _propTypes2['default'].string,
    label: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].node]),
    labelCol: _propTypes2['default'].object,
    help: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].bool]),
    validateStatus: _propTypes2['default'].oneOf(['', 'success', 'warning', 'error', 'validating']),
    hasFeedback: _propTypes2['default'].bool,
    wrapperCol: _propTypes2['default'].object,
    className: _propTypes2['default'].string,
    id: _propTypes2['default'].string,
    children: _propTypes2['default'].node,
    colon: _propTypes2['default'].bool
};
FormItem.contextTypes = {
    vertical: _propTypes2['default'].bool
};
module.exports = exports['default'];

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports = intersperse;

function intersperse(arr, obj) {
	if (!arr.length) return [];
	if (arr.length === 1) return arr.slice(0);

	var items = [arr[0]];
	for (var i = 1, len = arr.length; i < len; ++i) {
		items.push(obj, arr[i]);
	}

	return items;
}

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && nextChildrenPending.hasOwnProperty(child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_css_animation__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(269);











var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_9__util__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_9__util__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_9__util__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_8_css_animation__["isCssAnimationSupported"] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_8_css_animation__["default"])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete EVENT_NAME_MAP.transitionend.transition;
  }

  for (var baseEventName in EVENT_NAME_MAP) {
    if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
      var baseEvents = EVENT_NAME_MAP[baseEventName];
      for (var styleName in baseEvents) {
        if (styleName in style) {
          endEvents.push(baseEvents[styleName]);
          break;
        }
      }
    }
  }
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },


  endEvents: endEvents,

  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(15);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = __webpack_require__(6);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function isString(str) {
    return typeof str === 'string';
}
// Insert one space between two chinese characters automatically.
function insertSpace(child, needInserted) {
    // Check the child if is undefined or null.
    if (child == null) {
        return;
    }
    var SPACE = needInserted ? ' ' : '';
    // strictNullChecks oops.
    if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
        return React.cloneElement(child, {}, child.props.children.split('').join(SPACE));
    }
    if (typeof child === 'string') {
        if (isTwoCNChar(child)) {
            child = child.split('').join(SPACE);
        }
        return React.createElement(
            'span',
            null,
            child
        );
    }
    return child;
}

var Button = function (_React$Component) {
    (0, _inherits3['default'])(Button, _React$Component);

    function Button(props) {
        (0, _classCallCheck3['default'])(this, Button);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

        _this.handleClick = function (e) {
            // Add click effect
            _this.setState({ clicked: true });
            clearTimeout(_this.timeout);
            _this.timeout = window.setTimeout(function () {
                return _this.setState({ clicked: false });
            }, 500);
            var onClick = _this.props.onClick;
            if (onClick) {
                onClick(e);
            }
        };
        _this.state = {
            loading: props.loading,
            clicked: false,
            hasTwoCNChar: false
        };
        return _this;
    }

    (0, _createClass3['default'])(Button, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fixTwoCNChar();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var currentLoading = this.props.loading;
            var loading = nextProps.loading;
            if (currentLoading) {
                clearTimeout(this.delayTimeout);
            }
            if (typeof loading !== 'boolean' && loading && loading.delay) {
                this.delayTimeout = window.setTimeout(function () {
                    return _this2.setState({ loading: loading });
                }, loading.delay);
            } else {
                this.setState({ loading: loading });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.fixTwoCNChar();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
            }
        }
    }, {
        key: 'fixTwoCNChar',
        value: function fixTwoCNChar() {
            // Fix for HOC usage like <FormatMessage />
            var node = (0, _reactDom.findDOMNode)(this);
            var buttonText = node.textContent || node.innerText;
            if (this.isNeedInserted() && isTwoCNChar(buttonText)) {
                if (!this.state.hasTwoCNChar) {
                    this.setState({
                        hasTwoCNChar: true
                    });
                }
            } else if (this.state.hasTwoCNChar) {
                this.setState({
                    hasTwoCNChar: false
                });
            }
        }
    }, {
        key: 'isNeedInserted',
        value: function isNeedInserted() {
            var _props = this.props,
                icon = _props.icon,
                children = _props.children;

            return React.Children.count(children) === 1 && !icon;
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames,
                _this3 = this;

            var _a = this.props,
                type = _a.type,
                shape = _a.shape,
                size = _a.size,
                className = _a.className,
                children = _a.children,
                icon = _a.icon,
                prefixCls = _a.prefixCls,
                ghost = _a.ghost,
                _loadingProp = _a.loading,
                block = _a.block,
                rest = __rest(_a, ["type", "shape", "size", "className", "children", "icon", "prefixCls", "ghost", "loading", "block"]);var _state = this.state,
                loading = _state.loading,
                clicked = _state.clicked,
                hasTwoCNChar = _state.hasTwoCNChar;
            // large => lg
            // small => sm

            var sizeCls = '';
            switch (size) {
                case 'large':
                    sizeCls = 'lg';
                    break;
                case 'small':
                    sizeCls = 'sm';
                default:
                    break;
            }
            var classes = (0, _classnames2['default'])(prefixCls, className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + type, type), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + shape, shape), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + sizeCls, sizeCls), (0, _defineProperty3['default'])(_classNames, prefixCls + '-icon-only', !children && icon), (0, _defineProperty3['default'])(_classNames, prefixCls + '-loading', loading), (0, _defineProperty3['default'])(_classNames, prefixCls + '-clicked', clicked), (0, _defineProperty3['default'])(_classNames, prefixCls + '-background-ghost', ghost), (0, _defineProperty3['default'])(_classNames, prefixCls + '-two-chinese-chars', hasTwoCNChar), (0, _defineProperty3['default'])(_classNames, prefixCls + '-block', block), _classNames));
            var iconType = loading ? 'loading' : icon;
            var iconNode = iconType ? React.createElement(_icon2['default'], { type: iconType }) : null;
            var kids = children || children === 0 ? React.Children.map(children, function (child) {
                return insertSpace(child, _this3.isNeedInserted());
            }) : null;
            if ('href' in rest) {
                return React.createElement(
                    'a',
                    (0, _extends3['default'])({}, rest, { className: classes, onClick: this.handleClick }),
                    iconNode,
                    kids
                );
            } else {
                // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
                var htmlType = rest.htmlType,
                    otherProps = __rest(rest, ["htmlType"]);
                return React.createElement(
                    'button',
                    (0, _extends3['default'])({}, otherProps, { type: htmlType || 'button', className: classes, onClick: this.handleClick }),
                    iconNode,
                    kids
                );
            }
        }
    }]);
    return Button;
}(React.Component);

exports['default'] = Button;

Button.__ANT_BUTTON = true;
Button.defaultProps = {
    prefixCls: 'ant-btn',
    loading: false,
    ghost: false,
    block: false
};
Button.propTypes = {
    type: _propTypes2['default'].string,
    shape: _propTypes2['default'].oneOf(['circle', 'circle-outline']),
    size: _propTypes2['default'].oneOf(['large', 'default', 'small']),
    htmlType: _propTypes2['default'].oneOf(['submit', 'button', 'reset']),
    onClick: _propTypes2['default'].func,
    loading: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].object]),
    className: _propTypes2['default'].string,
    icon: _propTypes2['default'].string,
    block: _propTypes2['default'].bool
};
module.exports = exports['default'];

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var ButtonGroup = function ButtonGroup(props) {
    var _props$prefixCls = props.prefixCls,
        prefixCls = _props$prefixCls === undefined ? 'ant-btn-group' : _props$prefixCls,
        size = props.size,
        className = props.className,
        others = __rest(props, ["prefixCls", "size", "className"]);
    // large => lg
    // small => sm


    var sizeCls = '';
    switch (size) {
        case 'large':
            sizeCls = 'lg';
            break;
        case 'small':
            sizeCls = 'sm';
        default:
            break;
    }
    var classes = (0, _classnames2['default'])(prefixCls, (0, _defineProperty3['default'])({}, prefixCls + '-' + sizeCls, sizeCls), className);
    return React.createElement('div', (0, _extends3['default'])({}, others, { className: classes }));
};
exports['default'] = ButtonGroup;
module.exports = exports['default'];

/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Group = function Group(props) {
    var _classNames;

    var _props$prefixCls = props.prefixCls,
        prefixCls = _props$prefixCls === undefined ? 'ant-input-group' : _props$prefixCls,
        _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className;

    var cls = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', props.size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', props.size === 'small'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-compact', props.compact), _classNames), className);
    return React.createElement(
        'span',
        { className: cls, style: props.style, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave, onFocus: props.onFocus, onBlur: props.onBlur },
        props.children
    );
};
exports['default'] = Group;
module.exports = exports['default'];

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Input = __webpack_require__(271);

var _Input2 = _interopRequireDefault(_Input);

var _icon = __webpack_require__(6);

var _icon2 = _interopRequireDefault(_icon);

var _button = __webpack_require__(21);

var _button2 = _interopRequireDefault(_button);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Search = function (_React$Component) {
    (0, _inherits3['default'])(Search, _React$Component);

    function Search() {
        (0, _classCallCheck3['default'])(this, Search);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));

        _this.onSearch = function (e) {
            var onSearch = _this.props.onSearch;

            if (onSearch) {
                onSearch(_this.input.input.value, e);
            }
            _this.input.focus();
        };
        _this.saveInput = function (node) {
            _this.input = node;
        };
        return _this;
    }

    (0, _createClass3['default'])(Search, [{
        key: 'focus',
        value: function focus() {
            this.input.focus();
        }
    }, {
        key: 'blur',
        value: function blur() {
            this.input.blur();
        }
    }, {
        key: 'getButtonOrIcon',
        value: function getButtonOrIcon() {
            var _props = this.props,
                enterButton = _props.enterButton,
                prefixCls = _props.prefixCls,
                size = _props.size,
                disabled = _props.disabled;

            var enterButtonAsElement = enterButton;
            var node = void 0;
            if (!enterButton) {
                node = React.createElement(_icon2['default'], { className: prefixCls + '-icon', type: 'search', key: 'searchIcon' });
            } else if (enterButtonAsElement.type === _button2['default'] || enterButtonAsElement.type === 'button') {
                node = React.cloneElement(enterButtonAsElement, enterButtonAsElement.type === _button2['default'] ? {
                    className: prefixCls + '-button',
                    size: size
                } : {});
            } else {
                node = React.createElement(
                    _button2['default'],
                    { className: prefixCls + '-button', type: 'primary', size: size, disabled: disabled, key: 'enterButton' },
                    enterButton === true ? React.createElement(_icon2['default'], { type: 'search' }) : enterButton
                );
            }
            return React.cloneElement(node, {
                onClick: this.onSearch
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                className = _a.className,
                prefixCls = _a.prefixCls,
                inputPrefixCls = _a.inputPrefixCls,
                size = _a.size,
                suffix = _a.suffix,
                enterButton = _a.enterButton,
                others = __rest(_a, ["className", "prefixCls", "inputPrefixCls", "size", "suffix", "enterButton"]);
            delete others.onSearch;
            var buttonOrIcon = this.getButtonOrIcon();
            var searchSuffix = suffix ? [suffix, buttonOrIcon] : buttonOrIcon;
            var inputClassName = (0, _classnames2['default'])(prefixCls, className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-enter-button', !!enterButton), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + size, !!size), _classNames));
            return React.createElement(_Input2['default'], (0, _extends3['default'])({ onPressEnter: this.onSearch }, others, { size: size, className: inputClassName, prefixCls: inputPrefixCls, suffix: searchSuffix, ref: this.saveInput }));
        }
    }]);
    return Search;
}(React.Component);

exports['default'] = Search;

Search.defaultProps = {
    inputPrefixCls: 'ant-input',
    prefixCls: 'ant-input-search',
    enterButton: false
};
module.exports = exports['default'];

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _omit = __webpack_require__(47);

var _omit2 = _interopRequireDefault(_omit);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _calculateNodeHeight = __webpack_require__(591);

var _calculateNodeHeight2 = _interopRequireDefault(_calculateNodeHeight);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function onNextFrame(cb) {
    if (window.requestAnimationFrame) {
        return window.requestAnimationFrame(cb);
    }
    return window.setTimeout(cb, 1);
}
function clearNextFrameAction(nextFrameId) {
    if (window.cancelAnimationFrame) {
        window.cancelAnimationFrame(nextFrameId);
    } else {
        window.clearTimeout(nextFrameId);
    }
}

var TextArea = function (_React$Component) {
    (0, _inherits3['default'])(TextArea, _React$Component);

    function TextArea() {
        (0, _classCallCheck3['default'])(this, TextArea);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).apply(this, arguments));

        _this.state = {
            textareaStyles: {}
        };
        _this.resizeTextarea = function () {
            var autosize = _this.props.autosize;

            if (!autosize || !_this.textAreaRef) {
                return;
            }
            var minRows = autosize ? autosize.minRows : null;
            var maxRows = autosize ? autosize.maxRows : null;
            var textareaStyles = (0, _calculateNodeHeight2['default'])(_this.textAreaRef, false, minRows, maxRows);
            _this.setState({ textareaStyles: textareaStyles });
        };
        _this.handleTextareaChange = function (e) {
            if (!('value' in _this.props)) {
                _this.resizeTextarea();
            }
            var onChange = _this.props.onChange;

            if (onChange) {
                onChange(e);
            }
        };
        _this.handleKeyDown = function (e) {
            var _this$props = _this.props,
                onPressEnter = _this$props.onPressEnter,
                onKeyDown = _this$props.onKeyDown;

            if (e.keyCode === 13 && onPressEnter) {
                onPressEnter(e);
            }
            if (onKeyDown) {
                onKeyDown(e);
            }
        };
        _this.saveTextAreaRef = function (textArea) {
            _this.textAreaRef = textArea;
        };
        return _this;
    }

    (0, _createClass3['default'])(TextArea, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.resizeTextarea();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // Re-render with the new content then recalculate the height as required.
            if (this.props.value !== nextProps.value) {
                if (this.nextFrameActionId) {
                    clearNextFrameAction(this.nextFrameActionId);
                }
                this.nextFrameActionId = onNextFrame(this.resizeTextarea);
            }
        }
    }, {
        key: 'focus',
        value: function focus() {
            this.textAreaRef.focus();
        }
    }, {
        key: 'blur',
        value: function blur() {
            this.textAreaRef.blur();
        }
    }, {
        key: 'getTextAreaClassName',
        value: function getTextAreaClassName() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                disabled = _props.disabled;

            return (0, _classnames2['default'])(prefixCls, className, (0, _defineProperty3['default'])({}, prefixCls + '-disabled', disabled));
        }
    }, {
        key: 'render',
        value: function render() {
            var props = this.props;
            var otherProps = (0, _omit2['default'])(props, ['prefixCls', 'onPressEnter', 'autosize']);
            var style = (0, _extends3['default'])({}, props.style, this.state.textareaStyles);
            // Fix https://github.com/ant-design/ant-design/issues/6776
            // Make sure it could be reset when using form.getFieldDecorator
            if ('value' in otherProps) {
                otherProps.value = otherProps.value || '';
            }
            return React.createElement('textarea', (0, _extends3['default'])({}, otherProps, { className: this.getTextAreaClassName(), style: style, onKeyDown: this.handleKeyDown, onChange: this.handleTextareaChange, ref: this.saveTextAreaRef }));
        }
    }]);
    return TextArea;
}(React.Component);

exports['default'] = TextArea;

TextArea.defaultProps = {
    prefixCls: 'ant-input'
};
module.exports = exports['default'];

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = calculateNodeHeight;
// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */
var HIDDEN_TEXTAREA_STYLE = '\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';
var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
var computedStyleCache = {};
var hiddenTextarea = void 0;
function calculateNodeStyling(node) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
    if (useCache && computedStyleCache[nodeRef]) {
        return computedStyleCache[nodeRef];
    }
    var style = window.getComputedStyle(node);
    var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
    var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
    var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
    var sizingStyle = SIZING_STYLE.map(function (name) {
        return name + ':' + style.getPropertyValue(name);
    }).join(';');
    var nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing
    };
    if (useCache && nodeRef) {
        computedStyleCache[nodeRef] = nodeInfo;
    }
    return nodeInfo;
}
function calculateNodeHeight(uiTextNode) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    if (!hiddenTextarea) {
        hiddenTextarea = document.createElement('textarea');
        document.body.appendChild(hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute('wrap')) {
        hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
    } else {
        hiddenTextarea.removeAttribute('wrap');
    }
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox

    var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
        paddingSize = _calculateNodeStyling.paddingSize,
        borderSize = _calculateNodeStyling.borderSize,
        boxSizing = _calculateNodeStyling.boxSizing,
        sizingStyle = _calculateNodeStyling.sizingStyle;
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content


    hiddenTextarea.setAttribute('style', sizingStyle + ';' + HIDDEN_TEXTAREA_STYLE);
    hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
    var minHeight = Number.MIN_SAFE_INTEGER;
    var maxHeight = Number.MAX_SAFE_INTEGER;
    var height = hiddenTextarea.scrollHeight;
    var overflowY = void 0;
    if (boxSizing === 'border-box') {
        // border-box: add border, since height = content + padding + border
        height = height + borderSize;
    } else if (boxSizing === 'content-box') {
        // remove padding, since height = content
        height = height - paddingSize;
    }
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        hiddenTextarea.value = ' ';
        var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === 'border-box') {
                minHeight = minHeight + paddingSize + borderSize;
            }
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === 'border-box') {
                maxHeight = maxHeight + paddingSize + borderSize;
            }
            overflowY = height > maxHeight ? '' : 'hidden';
            height = Math.min(maxHeight, height);
        }
    }
    // Remove scroll bar flash when autosize without maxRows
    if (!maxRows) {
        overflowY = 'hidden';
    }
    return { height: height, minHeight: minHeight, maxHeight: maxHeight, overflowY: overflowY };
}
module.exports = exports['default'];

/***/ }),
/* 592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_animate__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_createChainedFunction__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Notice__ = __webpack_require__(594);















var seed = 0;
var now = Date.now();

function getUuid() {
  return 'rcNotification_' + now + '_' + seed++;
}

var Notification = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Notification, _Component);

  function Notification() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Notification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Notification.__proto__ || Object.getPrototypeOf(Notification)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      notices: []
    }, _this.add = function (notice) {
      var key = notice.key = notice.key || getUuid();
      var maxCount = _this.props.maxCount;

      _this.setState(function (previousState) {
        var notices = previousState.notices;
        var noticeIndex = notices.map(function (v) {
          return v.key;
        }).indexOf(key);
        var updatedNotices = notices.concat();
        if (noticeIndex !== -1) {
          updatedNotices.splice(noticeIndex, 1, notice);
        } else {
          if (maxCount && notices.length >= maxCount) {
                                                notice.updateKey = updatedNotices[0].updateKey || updatedNotices[0].key;
            updatedNotices.shift();
          }
          updatedNotices.push(notice);
        }
        return {
          notices: updatedNotices
        };
      });
    }, _this.remove = function (key) {
      _this.setState(function (previousState) {
        return {
          notices: previousState.notices.filter(function (notice) {
            return notice.key !== key;
          })
        };
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Notification, [{
    key: 'getTransitionName',
    value: function getTransitionName() {
      var props = this.props;
      var transitionName = props.transitionName;
      if (!transitionName && props.animation) {
        transitionName = props.prefixCls + '-' + props.animation;
      }
      return transitionName;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _className;

      var props = this.props;
      var notices = this.state.notices;

      var noticeNodes = notices.map(function (notice, index) {
        var update = Boolean(index === notices.length - 1 && notice.updateKey);
        var key = notice.updateKey ? notice.updateKey : notice.key;
        var onClose = Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_createChainedFunction__["a" /* default */])(_this2.remove.bind(_this2, notice.key), notice.onClose);
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__Notice__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
            prefixCls: props.prefixCls
          }, notice, {
            key: key,
            update: update,
            onClose: onClose,
            closeIcon: props.closeIcon
          }),
          notice.content
        );
      });
      var className = (_className = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_className, props.prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_className, props.className, !!props.className), _className);
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()(className), style: props.style },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_rc_animate__["default"],
          { transitionName: this.getTransitionName() },
          noticeNodes
        )
      );
    }
  }]);

  return Notification;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Notification.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  animation: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object]),
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  maxCount: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  closeIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node
};
Notification.defaultProps = {
  prefixCls: 'rc-notification',
  animation: 'fade',
  style: {
    top: 65,
    left: '50%'
  }
};


Notification.newInstance = function newNotificationInstance(properties, callback) {
  var _ref2 = properties || {},
      getContainer = _ref2.getContainer,
      props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['getContainer']);

  var div = document.createElement('div');
  if (getContainer) {
    var root = getContainer();
    root.appendChild(div);
  } else {
    document.body.appendChild(div);
  }
  var called = false;
  function ref(notification) {
    if (called) {
      return;
    }
    called = true;
    callback({
      notice: function notice(noticeProps) {
        notification.add(noticeProps);
      },
      removeNotice: function removeNotice(key) {
        notification.remove(key);
      },

      component: notification,
      destroy: function destroy() {
        __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.unmountComponentAtNode(div);
        div.parentNode.removeChild(div);
      }
    });
  }
  __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Notification, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, props, { ref: ref })), div);
};

/* harmony default export */ __webpack_exports__["a"] = (Notification);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);









var Notice = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Notice, _Component);

  function Notice() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Notice);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Notice.__proto__ || Object.getPrototypeOf(Notice)).call.apply(_ref, [this].concat(args))), _this), _this.close = function () {
      _this.clearCloseTimer();
      _this.props.onClose();
    }, _this.startCloseTimer = function () {
      if (_this.props.duration) {
        _this.closeTimer = setTimeout(function () {
          _this.close();
        }, _this.props.duration * 1000);
      }
    }, _this.clearCloseTimer = function () {
      if (_this.closeTimer) {
        clearTimeout(_this.closeTimer);
        _this.closeTimer = null;
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Notice, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startCloseTimer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.duration !== prevProps.duration || this.props.update) {
        this.restartCloseTimer();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearCloseTimer();
    }
  }, {
    key: 'restartCloseTimer',
    value: function restartCloseTimer() {
      this.clearCloseTimer();
      this.startCloseTimer();
    }
  }, {
    key: 'render',
    value: function render() {
      var _className;

      var props = this.props;
      var componentClass = props.prefixCls + '-notice';
      var className = (_className = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, '' + componentClass, 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, componentClass + '-closable', props.closable), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, props.className, !!props.className), _className);
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className), style: props.style, onMouseEnter: this.clearCloseTimer,
          onMouseLeave: this.startCloseTimer
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: componentClass + '-content' },
          props.children
        ),
        props.closable ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'a',
          { tabIndex: '0', onClick: this.close, className: componentClass + '-close' },
          props.closeIcon || __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: componentClass + '-close-x' })
        ) : null
      );
    }
  }]);

  return Notice;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Notice.propTypes = {
  duration: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  onClose: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  update: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  closeIcon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Notice.defaultProps = {
  onEnd: function onEnd() {},
  onClose: function onClose() {},

  duration: 1.5,
  style: {
    right: '50%'
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Notice);

/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(171);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(30);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(41);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(169);

var _PathUtils = __webpack_require__(90);

var _createTransitionManager = __webpack_require__(170);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(276);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(171);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(30);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(41);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(169);

var _PathUtils = __webpack_require__(90);

var _createTransitionManager = __webpack_require__(170);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(276);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(601);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(172);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(30);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(90);

var _LocationUtils = __webpack_require__(169);

var _createTransitionManager = __webpack_require__(170);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(277);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(605)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(607);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(609);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(610);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(611);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(612);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(613);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(91);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(280);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(280);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(174);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(615);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(172);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(617);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(173);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(173);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(620);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(279);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_notification_style__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_notification__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_less__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_NavPath__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Header__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Sidebar__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Footer__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__routes__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__User__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Loading__ = __webpack_require__(1072);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Loading from '../../components/Loading'
// import CaseUpload from '../Cases/caseUpload'
var Content=__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a.Content;var mapStateToProps=function mapStateToProps(state){return{user:state.user,errorMessage:state.errorMessage};};var App=function(_React$Component){_inherits(App,_React$Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.state={needToLogout:false,isLoading:true};_this.needToLogoutHandler=_this.needToLogoutHandler.bind(_this);return _this;}_createClass(App,[{key:'componentWillMount',value:function componentWillMount(){__WEBPACK_IMPORTED_MODULE_3_antd_lib_notification___default.a.destroy();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.user.username){this.setState({isLoading:false});}}},{key:'needToLogoutHandler',value:function needToLogoutHandler(data){this.setState({needToLogout:data});}},{key:'render',value:function render(){var _this2=this;var UserRoutes=__WEBPACK_IMPORTED_MODULE_12__routes__["a" /* Routes */];var username=this.props.user.username;if(!username){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Loading__["a" /* default */],{needToLogout:this.state.needToLogout});}else{return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,{className:'ant-layout-has-sider'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Sidebar__["a" /* default */],{accountType:UserRoutes,isLoading:this.state.isLoading}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Header__["a" /* default */],{needToLogoutHandler:function needToLogoutHandler(data){return _this2.needToLogoutHandler(data);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Content,{style:{margin:'0 16px'}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_NavPath__["a" /* default */],null),UserRoutes&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{style:{minHeight:360}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["e" /* Switch */],null,UserRoutes.map(function(route,index){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["d" /* Route */],{key:index,path:route.path,component:route.component,exactly:route.exactly});}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["d" /* Route */],{path:'/profile',component:__WEBPACK_IMPORTED_MODULE_13__User__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Redirect */],{to:'/home'})))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Footer__["a" /* default */],null)));}}}]);return App;}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps)(App));

/***/ }),
/* 623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(68);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

function generator(props) {
    return function (BasicComponent) {
        return function (_React$Component) {
            (0, _inherits3['default'])(Adapter, _React$Component);

            function Adapter() {
                (0, _classCallCheck3['default'])(this, Adapter);
                return (0, _possibleConstructorReturn3['default'])(this, (Adapter.__proto__ || Object.getPrototypeOf(Adapter)).apply(this, arguments));
            }

            (0, _createClass3['default'])(Adapter, [{
                key: 'render',
                value: function render() {
                    var prefixCls = props.prefixCls;

                    return React.createElement(BasicComponent, (0, _extends3['default'])({ prefixCls: prefixCls }, this.props));
                }
            }]);
            return Adapter;
        }(React.Component);
    };
}

var Basic = function (_React$Component2) {
    (0, _inherits3['default'])(Basic, _React$Component2);

    function Basic() {
        (0, _classCallCheck3['default'])(this, Basic);
        return (0, _possibleConstructorReturn3['default'])(this, (Basic.__proto__ || Object.getPrototypeOf(Basic)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Basic, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                children = _a.children,
                others = __rest(_a, ["prefixCls", "className", "children"]);
            var divCls = (0, _classnames2['default'])(className, prefixCls);
            return React.createElement(
                'div',
                (0, _extends3['default'])({ className: divCls }, others),
                children
            );
        }
    }]);
    return Basic;
}(React.Component);

var BasicLayout = function (_React$Component3) {
    (0, _inherits3['default'])(BasicLayout, _React$Component3);

    function BasicLayout() {
        (0, _classCallCheck3['default'])(this, BasicLayout);

        var _this3 = (0, _possibleConstructorReturn3['default'])(this, (BasicLayout.__proto__ || Object.getPrototypeOf(BasicLayout)).apply(this, arguments));

        _this3.state = { siders: [] };
        return _this3;
    }

    (0, _createClass3['default'])(BasicLayout, [{
        key: 'getChildContext',
        value: function getChildContext() {
            var _this4 = this;

            return {
                siderHook: {
                    addSider: function addSider(id) {
                        _this4.setState({
                            siders: [].concat((0, _toConsumableArray3['default'])(_this4.state.siders), [id])
                        });
                    },
                    removeSider: function removeSider(id) {
                        _this4.setState({
                            siders: _this4.state.siders.filter(function (currentId) {
                                return currentId !== id;
                            })
                        });
                    }
                }
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                children = _a.children,
                hasSider = _a.hasSider,
                others = __rest(_a, ["prefixCls", "className", "children", "hasSider"]);
            var divCls = (0, _classnames2['default'])(className, prefixCls, (0, _defineProperty3['default'])({}, prefixCls + '-has-sider', hasSider || this.state.siders.length > 0));
            return React.createElement(
                'div',
                (0, _extends3['default'])({ className: divCls }, others),
                children
            );
        }
    }]);
    return BasicLayout;
}(React.Component);

BasicLayout.childContextTypes = {
    siderHook: _propTypes2['default'].object
};
var Layout = generator({
    prefixCls: 'ant-layout'
})(BasicLayout);
var Header = generator({
    prefixCls: 'ant-layout-header'
})(Basic);
var Footer = generator({
    prefixCls: 'ant-layout-footer'
})(Basic);
var Content = generator({
    prefixCls: 'ant-layout-content'
})(Basic);
Layout.Header = Header;
Layout.Footer = Footer;
Layout.Content = Content;
exports['default'] = Layout;
module.exports = exports['default'];

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = __webpack_require__(47);

var _omit2 = _interopRequireDefault(_omit);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _icon = __webpack_require__(6);

var _icon2 = _interopRequireDefault(_icon);

var _isNumeric = __webpack_require__(626);

var _isNumeric2 = _interopRequireDefault(_isNumeric);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
// matchMedia polyfill for
// https://github.com/WickyNilliams/enquire.js/issues/82
if (typeof window !== 'undefined') {
    var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
        return {
            media: mediaQuery,
            matches: false,
            addListener: function addListener() {},
            removeListener: function removeListener() {}
        };
    };
    window.matchMedia = window.matchMedia || matchMediaPolyfill;
}

var dimensionMap = {
    xs: '480px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1600px'
};
var generateId = function () {
    var i = 0;
    return function () {
        var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        i += 1;
        return '' + prefix + i;
    };
}();

var Sider = function (_React$Component) {
    (0, _inherits3['default'])(Sider, _React$Component);

    function Sider(props) {
        (0, _classCallCheck3['default'])(this, Sider);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Sider.__proto__ || Object.getPrototypeOf(Sider)).call(this, props));

        _this.responsiveHandler = function (mql) {
            _this.setState({ below: mql.matches });
            var onBreakpoint = _this.props.onBreakpoint;

            if (onBreakpoint) {
                onBreakpoint(mql.matches);
            }
            if (_this.state.collapsed !== mql.matches) {
                _this.setCollapsed(mql.matches, 'responsive');
            }
        };
        _this.setCollapsed = function (collapsed, type) {
            if (!('collapsed' in _this.props)) {
                _this.setState({
                    collapsed: collapsed
                });
            }
            var onCollapse = _this.props.onCollapse;

            if (onCollapse) {
                onCollapse(collapsed, type);
            }
        };
        _this.toggle = function () {
            var collapsed = !_this.state.collapsed;
            _this.setCollapsed(collapsed, 'clickTrigger');
        };
        _this.belowShowChange = function () {
            _this.setState({ belowShow: !_this.state.belowShow });
        };
        _this.uniqueId = generateId('ant-sider-');
        var matchMedia = void 0;
        if (typeof window !== 'undefined') {
            matchMedia = window.matchMedia;
        }
        if (matchMedia && props.breakpoint && props.breakpoint in dimensionMap) {
            _this.mql = matchMedia('(max-width: ' + dimensionMap[props.breakpoint] + ')');
        }
        var collapsed = void 0;
        if ('collapsed' in props) {
            collapsed = props.collapsed;
        } else {
            collapsed = props.defaultCollapsed;
        }
        _this.state = {
            collapsed: collapsed,
            below: false
        };
        return _this;
    }

    (0, _createClass3['default'])(Sider, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                siderCollapsed: this.state.collapsed,
                collapsedWidth: this.props.collapsedWidth
            };
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('collapsed' in nextProps) {
                this.setState({
                    collapsed: nextProps.collapsed
                });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.mql) {
                this.mql.addListener(this.responsiveHandler);
                this.responsiveHandler(this.mql);
            }
            if (this.context.siderHook) {
                this.context.siderHook.addSider(this.uniqueId);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.mql) {
                this.mql.removeListener(this.responsiveHandler);
            }
            if (this.context.siderHook) {
                this.context.siderHook.removeSider(this.uniqueId);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                theme = _a.theme,
                collapsible = _a.collapsible,
                reverseArrow = _a.reverseArrow,
                trigger = _a.trigger,
                style = _a.style,
                width = _a.width,
                collapsedWidth = _a.collapsedWidth,
                others = __rest(_a, ["prefixCls", "className", "theme", "collapsible", "reverseArrow", "trigger", "style", "width", "collapsedWidth"]);
            var divProps = (0, _omit2['default'])(others, ['collapsed', 'defaultCollapsed', 'onCollapse', 'breakpoint', 'onBreakpoint']);
            var rawWidth = this.state.collapsed ? collapsedWidth : width;
            // use "px" as fallback unit for width
            var siderWidth = (0, _isNumeric2['default'])(rawWidth) ? rawWidth + 'px' : String(rawWidth);
            // special trigger when collapsedWidth == 0
            var zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? React.createElement(
                'span',
                { onClick: this.toggle, className: prefixCls + '-zero-width-trigger' },
                React.createElement(_icon2['default'], { type: 'bars' })
            ) : null;
            var iconObj = {
                'expanded': reverseArrow ? React.createElement(_icon2['default'], { type: 'right' }) : React.createElement(_icon2['default'], { type: 'left' }),
                'collapsed': reverseArrow ? React.createElement(_icon2['default'], { type: 'left' }) : React.createElement(_icon2['default'], { type: 'right' })
            };
            var status = this.state.collapsed ? 'collapsed' : 'expanded';
            var defaultTrigger = iconObj[status];
            var triggerDom = trigger !== null ? zeroWidthTrigger || React.createElement(
                'div',
                { className: prefixCls + '-trigger', onClick: this.toggle, style: { width: siderWidth } },
                trigger || defaultTrigger
            ) : null;
            var divStyle = (0, _extends3['default'])({}, style, { flex: '0 0 ' + siderWidth, maxWidth: siderWidth, minWidth: siderWidth, width: siderWidth });
            var siderCls = (0, _classnames2['default'])(className, prefixCls, prefixCls + '-' + theme, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-collapsed', !!this.state.collapsed), (0, _defineProperty3['default'])(_classNames, prefixCls + '-has-trigger', collapsible && trigger !== null && !zeroWidthTrigger), (0, _defineProperty3['default'])(_classNames, prefixCls + '-below', !!this.state.below), (0, _defineProperty3['default'])(_classNames, prefixCls + '-zero-width', parseFloat(siderWidth) === 0), _classNames));
            return React.createElement(
                'div',
                (0, _extends3['default'])({ className: siderCls }, divProps, { style: divStyle }),
                React.createElement(
                    'div',
                    { className: prefixCls + '-children' },
                    this.props.children
                ),
                collapsible || this.state.below && zeroWidthTrigger ? triggerDom : null
            );
        }
    }]);
    return Sider;
}(React.Component);

exports['default'] = Sider;

Sider.__ANT_LAYOUT_SIDER = true;
Sider.defaultProps = {
    prefixCls: 'ant-layout-sider',
    collapsible: false,
    defaultCollapsed: false,
    reverseArrow: false,
    width: 200,
    collapsedWidth: 80,
    style: {},
    theme: 'dark'
};
Sider.childContextTypes = {
    siderCollapsed: _propTypes2['default'].bool,
    collapsedWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
};
Sider.contextTypes = {
    siderHook: _propTypes2['default'].object
};
module.exports = exports['default'];

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var isNumeric = function isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
};
exports["default"] = isNumeric;
module.exports = exports["default"];

/***/ }),
/* 627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_breadcrumb_style__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_breadcrumb__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_less__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__index_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultProps={data:[]};var propTypes={data:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array};var NavPath=function(_React$Component){_inherits(NavPath,_React$Component);function NavPath(){_classCallCheck(this,NavPath);return _possibleConstructorReturn(this,(NavPath.__proto__||Object.getPrototypeOf(NavPath)).apply(this,arguments));}_createClass(NavPath,[{key:'render',value:function render(){var data=this.props.data;var bread=data.map(function(item){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_breadcrumb___default.a.Item,{key:'bc-'+item.key},item.name);});return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_breadcrumb___default.a,{style:{margin:'12px 0'}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_breadcrumb___default.a.Item,{key:'bc-0'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'home'})),bread);}}]);return NavPath;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);NavPath.propTypes=propTypes;NavPath.defaultProps=defaultProps;/* harmony default export */ __webpack_exports__["a"] = (NavPath);

/***/ }),
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(48);

var _warning2 = _interopRequireDefault(_warning);

var _BreadcrumbItem = __webpack_require__(281);

var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getBreadcrumbName(route, params) {
    if (!route.breadcrumbName) {
        return null;
    }
    var paramsKeys = Object.keys(params).join('|');
    var name = route.breadcrumbName.replace(new RegExp(':(' + paramsKeys + ')', 'g'), function (replacement, key) {
        return params[key] || replacement;
    });
    return name;
}
function defaultItemRender(route, params, routes, paths) {
    var isLastItem = routes.indexOf(route) === routes.length - 1;
    var name = getBreadcrumbName(route, params);
    return isLastItem ? React.createElement(
        'span',
        null,
        name
    ) : React.createElement(
        'a',
        { href: '#/' + paths.join('/') },
        name
    );
}

var Breadcrumb = function (_React$Component) {
    (0, _inherits3['default'])(Breadcrumb, _React$Component);

    function Breadcrumb() {
        (0, _classCallCheck3['default'])(this, Breadcrumb);
        return (0, _possibleConstructorReturn3['default'])(this, (Breadcrumb.__proto__ || Object.getPrototypeOf(Breadcrumb)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Breadcrumb, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var props = this.props;
            (0, _warning2['default'])(!('linkRender' in props || 'nameRender' in props), '`linkRender` and `nameRender` are removed, please use `itemRender` instead, ' + 'see: https://u.ant.design/item-render.');
        }
    }, {
        key: 'render',
        value: function render() {
            var crumbs = void 0;
            var _props = this.props,
                separator = _props.separator,
                prefixCls = _props.prefixCls,
                style = _props.style,
                className = _props.className,
                routes = _props.routes,
                _props$params = _props.params,
                params = _props$params === undefined ? {} : _props$params,
                children = _props.children,
                _props$itemRender = _props.itemRender,
                itemRender = _props$itemRender === undefined ? defaultItemRender : _props$itemRender;

            if (routes && routes.length > 0) {
                var paths = [];
                crumbs = routes.map(function (route) {
                    route.path = route.path || '';
                    var path = route.path.replace(/^\//, '');
                    Object.keys(params).forEach(function (key) {
                        path = path.replace(':' + key, params[key]);
                    });
                    if (path) {
                        paths.push(path);
                    }
                    return React.createElement(
                        _BreadcrumbItem2['default'],
                        { separator: separator, key: route.breadcrumbName || path },
                        itemRender(route, params, routes, paths)
                    );
                });
            } else if (children) {
                crumbs = React.Children.map(children, function (element, index) {
                    if (!element) {
                        return element;
                    }
                    (0, _warning2['default'])(element.type && element.type.__ANT_BREADCRUMB_ITEM, 'Breadcrumb only accepts Breadcrumb.Item as it\'s children');
                    return (0, _react.cloneElement)(element, {
                        separator: separator,
                        key: index
                    });
                });
            }
            return React.createElement(
                'div',
                { className: (0, _classnames2['default'])(className, prefixCls), style: style },
                crumbs
            );
        }
    }]);
    return Breadcrumb;
}(React.Component);

exports['default'] = Breadcrumb;

Breadcrumb.defaultProps = {
    prefixCls: 'ant-breadcrumb',
    separator: '/'
};
Breadcrumb.propTypes = {
    prefixCls: _propTypes2['default'].string,
    separator: _propTypes2['default'].node,
    routes: _propTypes2['default'].array,
    params: _propTypes2['default'].object,
    linkRender: _propTypes2['default'].func,
    nameRender: _propTypes2['default'].func
};
module.exports = exports['default'];

/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_avatar_style__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_avatar_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_avatar_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_avatar__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_menu_style__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_menu_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_menu_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_menu__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_layout_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_layout__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_auth__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__index_less__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__index_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header=__WEBPACK_IMPORTED_MODULE_11_antd_lib_layout___default.a.Header;var mapStateToProps=function mapStateToProps(state){return{user:state.user,userIsLoading:state.userIsLoading,errorMessage:state.errorMessage};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{tryLogout:function tryLogout(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_auth__["c" /* logoutUser */])());}};};var commonHeader=function(_React$Component){_inherits(commonHeader,_React$Component);function commonHeader(props){_classCallCheck(this,commonHeader);var _this=_possibleConstructorReturn(this,(commonHeader.__proto__||Object.getPrototypeOf(commonHeader)).call(this,props));_this.state={needToLogout:false};_this.accountMenu=_this.accountMenu.bind(_this);_this.menuSelectHandler=_this.menuSelectHandler.bind(_this);return _this;}_createClass(commonHeader,[{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(!nextProps.user.username){this.setState({needToLogout:true});}}},{key:'menuSelectHandler',value:function menuSelectHandler(data){this.props.tryLogout();this.props.needToLogoutHandler(true);}},{key:'accountMenu',value:function accountMenu(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_menu___default.a,{onSelect:function onSelect(e){return _this2.menuSelectHandler(e);}});}},{key:'render',value:function render(){var _this3=this;var username=this.props.user.username;if(this.state.needToLogout){this.props.needToLogoutHandler(true);return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_router_dom__["c" /* Redirect */],{to:'/login'});}else{return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(Header,{style:{background:'#fff',padding:0}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'end',align:'middle'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{xs:2,sm:2,md:1},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_router_dom__["b" /* Link */],{to:'/profile'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_avatar___default.a,{style:{verticalAlign:'middle'}},username)))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{xs:4,sm:3,md:2},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,{ghost:true,type:'primary',size:'small',onClick:function onClick(e){return _this3.menuSelectHandler(e);}},'Logout')))));}}}]);return commonHeader;}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(commonHeader));

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(634);

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(15);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _icon = __webpack_require__(6);

var _icon2 = _interopRequireDefault(_icon);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Avatar = function (_React$Component) {
    (0, _inherits3['default'])(Avatar, _React$Component);

    function Avatar(props) {
        (0, _classCallCheck3['default'])(this, Avatar);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).call(this, props));

        _this.setScale = function () {
            var childrenNode = _this.avatarChildren;
            if (childrenNode) {
                var childrenWidth = childrenNode.offsetWidth;
                var avatarNode = ReactDOM.findDOMNode(_this);
                var avatarWidth = avatarNode.getBoundingClientRect().width;
                // add 4px gap for each side to get better performance
                if (avatarWidth - 8 < childrenWidth) {
                    _this.setState({
                        scale: (avatarWidth - 8) / childrenWidth
                    });
                } else {
                    _this.setState({
                        scale: 1
                    });
                }
            }
        };
        _this.handleImgLoadError = function () {
            var onError = _this.props.onError;

            var errorFlag = onError ? onError() : undefined;
            if (errorFlag !== false) {
                _this.setState({ isImgExist: false });
            }
        };
        _this.state = {
            scale: 1,
            isImgExist: true
        };
        return _this;
    }

    (0, _createClass3['default'])(Avatar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setScale();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (prevProps.children !== this.props.children || prevState.scale !== this.state.scale && this.state.scale === 1 || prevState.isImgExist !== this.state.isImgExist) {
                this.setScale();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames,
                _classNames2,
                _this2 = this;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                shape = _a.shape,
                size = _a.size,
                src = _a.src,
                icon = _a.icon,
                className = _a.className,
                alt = _a.alt,
                others = __rest(_a, ["prefixCls", "shape", "size", "src", "icon", "className", "alt"]);var _state = this.state,
                isImgExist = _state.isImgExist,
                scale = _state.scale;

            var sizeCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', size === 'small'), _classNames));
            var classString = (0, _classnames2['default'])(prefixCls, className, sizeCls, (_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-' + shape, shape), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-image', src && isImgExist), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-icon', icon), _classNames2));
            var sizeStyle = typeof size === 'number' ? {
                width: size,
                height: size,
                lineHeight: size + 'px',
                fontSize: icon ? size / 2 : 18
            } : {};
            var children = this.props.children;
            if (src && isImgExist) {
                children = React.createElement('img', { src: src, onError: this.handleImgLoadError, alt: alt });
            } else if (icon) {
                children = React.createElement(_icon2['default'], { type: icon });
            } else {
                var childrenNode = this.avatarChildren;
                if (childrenNode || scale !== 1) {
                    var childrenStyle = {
                        msTransform: 'scale(' + scale + ')',
                        WebkitTransform: 'scale(' + scale + ')',
                        transform: 'scale(' + scale + ')',
                        position: 'absolute',
                        display: 'inline-block',
                        left: 'calc(50% - ' + Math.round(childrenNode.offsetWidth / 2) + 'px)'
                    };
                    var sizeChildrenStyle = typeof size === 'number' ? {
                        lineHeight: size + 'px'
                    } : {};
                    children = React.createElement(
                        'span',
                        { className: prefixCls + '-string', ref: function ref(span) {
                                return _this2.avatarChildren = span;
                            }, style: (0, _extends3['default'])({}, sizeChildrenStyle, childrenStyle) },
                        children
                    );
                } else {
                    children = React.createElement(
                        'span',
                        { className: prefixCls + '-string', ref: function ref(span) {
                                return _this2.avatarChildren = span;
                            } },
                        children
                    );
                }
            }
            return React.createElement(
                'span',
                (0, _extends3['default'])({}, others, { style: (0, _extends3['default'])({}, sizeStyle, others.style), className: classString }),
                children
            );
        }
    }]);
    return Avatar;
}(React.Component);

exports['default'] = Avatar;

Avatar.defaultProps = {
    prefixCls: 'ant-avatar',
    shape: 'circle',
    size: 'default'
};
module.exports = exports['default'];

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SubPopupMenu__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(92);











var Menu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Menu, _React$Component);

  function Menu(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Menu);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    _this.isRootMenu = true;

    var selectedKeys = props.defaultSelectedKeys;
    var openKeys = props.defaultOpenKeys;
    if ('selectedKeys' in props) {
      selectedKeys = props.selectedKeys || [];
    }
    if ('openKeys' in props) {
      openKeys = props.openKeys || [];
    }

    _this.store = Object(__WEBPACK_IMPORTED_MODULE_7_mini_store__["create"])({
      selectedKeys: selectedKeys,
      openKeys: openKeys,
      activeKey: { '0-menu-': Object(__WEBPACK_IMPORTED_MODULE_8__SubPopupMenu__["b" /* getActiveKey */])(props, props.activeKey) }
    });
    return _this;
  }

  Menu.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('selectedKeys' in nextProps) {
      this.store.setState({
        selectedKeys: nextProps.selectedKeys || []
      });
    }
    if ('openKeys' in nextProps) {
      this.store.setState({
        openKeys: nextProps.openKeys || []
      });
    }
  };

  // onKeyDown needs to be exposed as a instance method
  // e.g., in rc-select, we need to navigate menu item while
  // current active item is rc-select input box rather than the menu itself


  Menu.prototype.render = function render() {
    var _this2 = this;

    var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

    props.className += ' ' + props.prefixCls + '-root';
    props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      onClick: this.onClick,
      onOpenChange: this.onOpenChange,
      onDeselect: this.onDeselect,
      onSelect: this.onSelect,
      openTransitionName: this.getOpenTransitionName(),
      parentMenu: this
    });
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_mini_store__["Provider"],
      { store: this.store },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__SubPopupMenu__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { ref: function ref(c) {
            return _this2.innerMenu = c;
          } }),
        this.props.children
      )
    );
  };

  return Menu;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Menu.propTypes = {
  defaultSelectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  defaultActiveFirst: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  defaultOpenKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  openKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  openTransitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  openAnimation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  subMenuOpenDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  subMenuCloseDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  forceSubMenuRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  triggerSubMenuAction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  level: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  selectable: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
Menu.defaultProps = {
  selectable: true,
  onClick: __WEBPACK_IMPORTED_MODULE_9__util__["f" /* noop */],
  onSelect: __WEBPACK_IMPORTED_MODULE_9__util__["f" /* noop */],
  onOpenChange: __WEBPACK_IMPORTED_MODULE_9__util__["f" /* noop */],
  onDeselect: __WEBPACK_IMPORTED_MODULE_9__util__["f" /* noop */],
  defaultSelectedKeys: [],
  defaultOpenKeys: [],
  subMenuOpenDelay: 0.1,
  subMenuCloseDelay: 0.1,
  triggerSubMenuAction: 'hover',
  prefixCls: 'rc-menu',
  className: '',
  mode: 'vertical',
  style: {}
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onSelect = function (selectInfo) {
    var props = _this3.props;
    if (props.selectable) {
      // root menu
      var selectedKeys = _this3.store.getState().selectedKeys;
      var selectedKey = selectInfo.key;
      if (props.multiple) {
        selectedKeys = selectedKeys.concat([selectedKey]);
      } else {
        selectedKeys = [selectedKey];
      }
      if (!('selectedKeys' in props)) {
        _this3.store.setState({
          selectedKeys: selectedKeys
        });
      }
      props.onSelect(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, selectInfo, {
        selectedKeys: selectedKeys
      }));
    }
  };

  this.onClick = function (e) {
    _this3.props.onClick(e);
  };

  this.onKeyDown = function (e, callback) {
    _this3.innerMenu.getWrappedInstance().onKeyDown(e, callback);
  };

  this.onOpenChange = function (event) {
    var props = _this3.props;
    var openKeys = _this3.store.getState().openKeys.concat();
    var changed = false;
    var processSingle = function processSingle(e) {
      var oneChanged = false;
      if (e.open) {
        oneChanged = openKeys.indexOf(e.key) === -1;
        if (oneChanged) {
          openKeys.push(e.key);
        }
      } else {
        var index = openKeys.indexOf(e.key);
        oneChanged = index !== -1;
        if (oneChanged) {
          openKeys.splice(index, 1);
        }
      }
      changed = changed || oneChanged;
    };
    if (Array.isArray(event)) {
      // batch change call
      event.forEach(processSingle);
    } else {
      processSingle(event);
    }
    if (changed) {
      if (!('openKeys' in _this3.props)) {
        _this3.store.setState({ openKeys: openKeys });
      }
      props.onOpenChange(openKeys);
    }
  };

  this.onDeselect = function (selectInfo) {
    var props = _this3.props;
    if (props.selectable) {
      var selectedKeys = _this3.store.getState().selectedKeys.concat();
      var selectedKey = selectInfo.key;
      var index = selectedKeys.indexOf(selectedKey);
      if (index !== -1) {
        selectedKeys.splice(index, 1);
      }
      if (!('selectedKeys' in props)) {
        _this3.store.setState({
          selectedKeys: selectedKeys
        });
      }
      props.onDeselect(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, selectInfo, {
        selectedKeys: selectedKeys
      }));
    }
  };

  this.getOpenTransitionName = function () {
    var props = _this3.props;
    var transitionName = props.openTransitionName;
    var animationName = props.openAnimation;
    if (!transitionName && typeof animationName === 'string') {
      transitionName = props.prefixCls + '-open-' + animationName;
    }
    return transitionName;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(283);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  function Provider() {
    _classCallCheck(this, Provider);

    return _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
  }

  _createClass(Provider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        miniStore: this.props.store
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);

  return Provider;
}(_react.Component);

Provider.propTypes = {
  store: _PropTypes.storeShape.isRequired
};
Provider.childContextTypes = {
  miniStore: _PropTypes.storeShape.isRequired
};
exports.default = Provider;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = connect;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _shallowequal = __webpack_require__(52);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _hoistNonReactStatics = __webpack_require__(265);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _PropTypes = __webpack_require__(283);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function isStateless(Component) {
  return !Component.prototype.render;
}

var defaultMapStateToProps = function defaultMapStateToProps() {
  return {};
};

function connect(mapStateToProps) {
  var shouldSubscribe = !!mapStateToProps;
  var finnalMapStateToProps = mapStateToProps || defaultMapStateToProps;

  return function wrapWithConnect(WrappedComponent) {
    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, (Connect.__proto__ || Object.getPrototypeOf(Connect)).call(this, props, context));

        _this.handleChange = function () {
          if (!_this.unsubscribe) {
            return;
          }

          var nextState = finnalMapStateToProps(_this.store.getState(), _this.props);
          if (!(0, _shallowequal2.default)(_this.nextState, nextState)) {
            _this.nextState = nextState;
            _this.setState({ subscribed: nextState });
          }
        };

        _this.store = context.miniStore;
        _this.state = { subscribed: finnalMapStateToProps(_this.store.getState(), props) };
        return _this;
      }

      _createClass(Connect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.trySubscribe();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.tryUnsubscribe();
        }
      }, {
        key: 'trySubscribe',
        value: function trySubscribe() {
          if (shouldSubscribe) {
            this.unsubscribe = this.store.subscribe(this.handleChange);
            this.handleChange();
          }
        }
      }, {
        key: 'tryUnsubscribe',
        value: function tryUnsubscribe() {
          if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
          }
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          return this.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var props = _extends({}, this.props, this.state.subscribed, {
            store: this.store
          });

          if (!isStateless(WrappedComponent)) {
            props = _extends({}, props, {
              ref: function ref(c) {
                return _this2.wrappedInstance = c;
              }
            });
          }

          return _react2.default.createElement(WrappedComponent, props);
        }
      }]);

      return Connect;
    }(_react.Component);

    Connect.displayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
    Connect.contextTypes = {
      miniStore: _PropTypes.storeShape.isRequired
    };


    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
  };
}

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = create;
function create(initialState) {
  var state = initialState;
  var listeners = [];

  function setState(partial) {
    state = _extends({}, state, partial);
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }
  }

  function getState() {
    return state;
  }

  function subscribe(listener) {
    listeners.push(listener);

    return function unsubscribe() {
      var index = listeners.indexOf(listener);
      listeners.splice(index, 1);
    };
  }

  return {
    setState: setState,
    getState: getState,
    subscribe: subscribe
  };
}

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var DOMWrap = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DOMWrap, _React$Component);

  function DOMWrap() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DOMWrap);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DOMWrap.prototype.render = function render() {
    var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props);
    if (!props.visible) {
      props.className += ' ' + props.hiddenClassName;
    }
    var Tag = props.tag;
    delete props.tag;
    delete props.hiddenClassName;
    delete props.visible;
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, props);
  };

  return DOMWrap;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

DOMWrap.propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
DOMWrap.defaultProps = {
  tag: 'div',
  className: ''
};
/* harmony default export */ __webpack_exports__["a"] = (DOMWrap);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SubMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SubPopupMenu__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__placements__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rc_animate__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util__ = __webpack_require__(92);
















var guid = 0;

var popupPlacementMap = {
  horizontal: 'bottomLeft',
  vertical: 'rightTop',
  'vertical-left': 'rightTop',
  'vertical-right': 'leftTop'
};

var updateDefaultActiveFirst = function updateDefaultActiveFirst(store, eventKey, defaultActiveFirst) {
  var _extends2;

  var menuId = Object(__WEBPACK_IMPORTED_MODULE_14__util__["b" /* getMenuIdFromSubMenuEventKey */])(eventKey);
  var state = store.getState();
  store.setState({
    defaultActiveFirst: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.defaultActiveFirst, (_extends2 = {}, _extends2[menuId] = defaultActiveFirst, _extends2))
  });
};

var SubMenu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SubMenu, _React$Component);

  function SubMenu(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SubMenu);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var store = props.store;
    var eventKey = props.eventKey;
    var defaultActiveFirst = store.getState().defaultActiveFirst;

    _this.isRootMenu = false;

    var value = false;

    if (defaultActiveFirst) {
      value = defaultActiveFirst[eventKey];
    }

    updateDefaultActiveFirst(store, eventKey, value);
    return _this;
  }

  SubMenu.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate();
  };

  SubMenu.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var _props = this.props,
        mode = _props.mode,
        parentMenu = _props.parentMenu,
        manualRef = _props.manualRef;

    // invoke customized ref to expose component to mixin

    if (manualRef) {
      manualRef(this);
    }

    if (mode !== 'horizontal' || !parentMenu.isRootMenu || !this.props.isOpen) {
      return;
    }

    this.minWidthTimeout = setTimeout(function () {
      return _this2.adjustWidth();
    }, 0);
  };

  SubMenu.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        onDestroy = _props2.onDestroy,
        eventKey = _props2.eventKey;

    if (onDestroy) {
      onDestroy(eventKey);
    }

    /* istanbul ignore if */
    if (this.minWidthTimeout) {
      clearTimeout(this.minWidthTimeout);
    }

    /* istanbul ignore if */
    if (this.mouseenterTimeout) {
      clearTimeout(this.mouseenterTimeout);
    }
  };

  SubMenu.prototype.renderChildren = function renderChildren(children) {
    var props = this.props;
    var baseProps = {
      mode: props.mode === 'horizontal' ? 'vertical' : props.mode,
      visible: this.props.isOpen,
      level: props.level + 1,
      inlineIndent: props.inlineIndent,
      focusable: false,
      onClick: this.onSubMenuClick,
      onSelect: this.onSelect,
      onDeselect: this.onDeselect,
      onDestroy: this.onDestroy,
      selectedKeys: props.selectedKeys,
      eventKey: props.eventKey + '-menu-',
      openKeys: props.openKeys,
      openTransitionName: props.openTransitionName,
      openAnimation: props.openAnimation,
      onOpenChange: this.onOpenChange,
      subMenuOpenDelay: props.subMenuOpenDelay,
      parentMenu: this,
      subMenuCloseDelay: props.subMenuCloseDelay,
      forceSubMenuRender: props.forceSubMenuRender,
      triggerSubMenuAction: props.triggerSubMenuAction,
      defaultActiveFirst: props.store.getState().defaultActiveFirst[Object(__WEBPACK_IMPORTED_MODULE_14__util__["b" /* getMenuIdFromSubMenuEventKey */])(props.eventKey)],
      multiple: props.multiple,
      prefixCls: props.rootPrefixCls,
      id: this._menuId,
      manualRef: this.saveMenuInstance
    };

    var haveRendered = this.haveRendered;
    this.haveRendered = true;

    this.haveOpened = this.haveOpened || baseProps.visible || baseProps.forceSubMenuRender;
    // never rendered not planning to, don't render
    if (!this.haveOpened) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null);
    }

    // don't show transition on first rendering (no animation for opened menu)
    // show appear transition if it's not visible (not sure why)
    // show appear transition if it's not inline mode
    var transitionAppear = haveRendered || !baseProps.visible || !baseProps.mode === 'inline';

    baseProps.className = ' ' + baseProps.prefixCls + '-sub';
    var animProps = {};

    if (baseProps.openTransitionName) {
      animProps.transitionName = baseProps.openTransitionName;
    } else if (typeof baseProps.openAnimation === 'object') {
      animProps.animation = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, baseProps.openAnimation);
      if (!transitionAppear) {
        delete animProps.animation.appear;
      }
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13_rc_animate__["default"],
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, animProps, {
        showProp: 'visible',
        component: '',
        transitionAppear: transitionAppear
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__SubPopupMenu__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, baseProps, { id: this._menuId }),
        children
      )
    );
  };

  SubMenu.prototype.render = function render() {
    var _classNames;

    var props = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.props);
    var isOpen = props.isOpen;
    var prefixCls = this.getPrefixCls();
    var isInlineMode = props.mode === 'inline';
    var className = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(prefixCls, prefixCls + '-' + props.mode, (_classNames = {}, _classNames[props.className] = !!props.className, _classNames[this.getOpenClassName()] = isOpen, _classNames[this.getActiveClassName()] = props.active || isOpen && !isInlineMode, _classNames[this.getDisabledClassName()] = props.disabled, _classNames[this.getSelectedClassName()] = this.isChildrenSelected(), _classNames));

    if (!this._menuId) {
      if (props.eventKey) {
        this._menuId = props.eventKey + '$Menu';
      } else {
        this._menuId = '$__$' + ++guid + '$Menu';
      }
    }

    var mouseEvents = {};
    var titleClickEvents = {};
    var titleMouseEvents = {};
    if (!props.disabled) {
      mouseEvents = {
        onMouseLeave: this.onMouseLeave,
        onMouseEnter: this.onMouseEnter
      };

      // only works in title, not outer li
      titleClickEvents = {
        onClick: this.onTitleClick
      };
      titleMouseEvents = {
        onMouseEnter: this.onTitleMouseEnter,
        onMouseLeave: this.onTitleMouseLeave
      };
    }

    var style = {};
    if (isInlineMode) {
      style.paddingLeft = props.inlineIndent * props.level;
    }

    var ariaOwns = {};
    // only set aria-owns when menu is open
    // otherwise it would be an invalid aria-owns value
    // since corresponding node cannot be found
    if (this.props.isOpen) {
      ariaOwns = {
        'aria-owns': this._menuId
      };
    }

    var title = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
        ref: this.saveSubMenuTitle,
        style: style,
        className: prefixCls + '-title'
      }, titleMouseEvents, titleClickEvents, {
        'aria-expanded': isOpen
      }, ariaOwns, {
        'aria-haspopup': 'true',
        title: typeof props.title === 'string' ? props.title : undefined
      }),
      props.title,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('i', { className: prefixCls + '-arrow' })
    );
    var children = this.renderChildren(props.children);

    var getPopupContainer = props.parentMenu.isRootMenu ? props.parentMenu.props.getPopupContainer : function (triggerNode) {
      return triggerNode.parentNode;
    };
    var popupPlacement = popupPlacementMap[props.mode];
    var popupAlign = props.popupOffset ? { offset: props.popupOffset } : {};
    var popupClassName = props.mode === 'inline' ? '' : props.popupClassName;
    var disabled = props.disabled,
        triggerSubMenuAction = props.triggerSubMenuAction,
        subMenuOpenDelay = props.subMenuOpenDelay,
        forceSubMenuRender = props.forceSubMenuRender,
        subMenuCloseDelay = props.subMenuCloseDelay;

    __WEBPACK_IMPORTED_MODULE_14__util__["e" /* menuAllProps */].forEach(function (key) {
      return delete props[key];
    });
    // Set onClick to null, to ignore propagated onClick event
    delete props.onClick;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'li',
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, props, mouseEvents, {
        className: className,
        role: 'menuitem'
      }),
      isInlineMode && title,
      isInlineMode && children,
      !isInlineMode && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["default"],
        {
          prefixCls: prefixCls,
          popupClassName: prefixCls + '-popup ' + popupClassName,
          getPopupContainer: getPopupContainer,
          builtinPlacements: __WEBPACK_IMPORTED_MODULE_12__placements__["a" /* default */],
          popupPlacement: popupPlacement,
          popupVisible: isOpen,
          popupAlign: popupAlign,
          popup: children,
          action: disabled ? [] : [triggerSubMenuAction],
          mouseEnterDelay: subMenuOpenDelay,
          mouseLeaveDelay: subMenuCloseDelay,
          onPopupVisibleChange: this.onPopupVisibleChange,
          forceRender: forceSubMenuRender
        },
        title
      )
    );
  };

  return SubMenu;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

SubMenu.propTypes = {
  parentMenu: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  openKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onOpenChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, // TODO: remove
  onItemHover: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  triggerSubMenuAction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTitleMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTitleMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTitleClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  popupOffset: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  isOpen: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  store: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
  manualRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
SubMenu.defaultProps = {
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
  onTitleMouseEnter: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
  onTitleMouseLeave: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
  onTitleClick: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
  manualRef: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
  mode: 'vertical',
  title: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onDestroy = function (key) {
    _this3.props.onDestroy(key);
  };

  this.onKeyDown = function (e) {
    var keyCode = e.keyCode;
    var menu = _this3.menuInstance;
    var _props3 = _this3.props,
        isOpen = _props3.isOpen,
        store = _props3.store;


    if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].ENTER) {
      _this3.onTitleClick(e);
      updateDefaultActiveFirst(store, _this3.props.eventKey, true);
      return true;
    }

    if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].RIGHT) {
      if (isOpen) {
        menu.onKeyDown(e);
      } else {
        _this3.triggerOpenChange(true);
        // need to update current menu's defaultActiveFirst value
        updateDefaultActiveFirst(store, _this3.props.eventKey, true);
      }
      return true;
    }
    if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].LEFT) {
      var handled = void 0;
      if (isOpen) {
        handled = menu.onKeyDown(e);
      } else {
        return undefined;
      }
      if (!handled) {
        _this3.triggerOpenChange(false);
        handled = true;
      }
      return handled;
    }

    if (isOpen && (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].UP || keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].DOWN)) {
      return menu.onKeyDown(e);
    }
  };

  this.onOpenChange = function (e) {
    _this3.props.onOpenChange(e);
  };

  this.onPopupVisibleChange = function (visible) {
    _this3.triggerOpenChange(visible, visible ? 'mouseenter' : 'mouseleave');
  };

  this.onMouseEnter = function (e) {
    var _props4 = _this3.props,
        key = _props4.eventKey,
        onMouseEnter = _props4.onMouseEnter,
        store = _props4.store;

    updateDefaultActiveFirst(store, _this3.props.eventKey, false);
    onMouseEnter({
      key: key,
      domEvent: e
    });
  };

  this.onMouseLeave = function (e) {
    var _props5 = _this3.props,
        parentMenu = _props5.parentMenu,
        eventKey = _props5.eventKey,
        onMouseLeave = _props5.onMouseLeave;

    parentMenu.subMenuInstance = _this3;
    onMouseLeave({
      key: eventKey,
      domEvent: e
    });
  };

  this.onTitleMouseEnter = function (domEvent) {
    var _props6 = _this3.props,
        key = _props6.eventKey,
        onItemHover = _props6.onItemHover,
        onTitleMouseEnter = _props6.onTitleMouseEnter;

    onItemHover({
      key: key,
      hover: true
    });
    onTitleMouseEnter({
      key: key,
      domEvent: domEvent
    });
  };

  this.onTitleMouseLeave = function (e) {
    var _props7 = _this3.props,
        parentMenu = _props7.parentMenu,
        eventKey = _props7.eventKey,
        onItemHover = _props7.onItemHover,
        onTitleMouseLeave = _props7.onTitleMouseLeave;

    parentMenu.subMenuInstance = _this3;
    onItemHover({
      key: eventKey,
      hover: false
    });
    onTitleMouseLeave({
      key: eventKey,
      domEvent: e
    });
  };

  this.onTitleClick = function (e) {
    var props = _this3.props;

    props.onTitleClick({
      key: props.eventKey,
      domEvent: e
    });
    if (props.triggerSubMenuAction === 'hover') {
      return;
    }
    _this3.triggerOpenChange(!props.isOpen, 'click');
    updateDefaultActiveFirst(props.store, _this3.props.eventKey, false);
  };

  this.onSubMenuClick = function (info) {
    _this3.props.onClick(_this3.addKeyPath(info));
  };

  this.onSelect = function (info) {
    _this3.props.onSelect(info);
  };

  this.onDeselect = function (info) {
    _this3.props.onDeselect(info);
  };

  this.getPrefixCls = function () {
    return _this3.props.rootPrefixCls + '-submenu';
  };

  this.getActiveClassName = function () {
    return _this3.getPrefixCls() + '-active';
  };

  this.getDisabledClassName = function () {
    return _this3.getPrefixCls() + '-disabled';
  };

  this.getSelectedClassName = function () {
    return _this3.getPrefixCls() + '-selected';
  };

  this.getOpenClassName = function () {
    return _this3.props.rootPrefixCls + '-submenu-open';
  };

  this.saveMenuInstance = function (c) {
    // children menu instance
    _this3.menuInstance = c;
  };

  this.addKeyPath = function (info) {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, info, {
      keyPath: (info.keyPath || []).concat(_this3.props.eventKey)
    });
  };

  this.triggerOpenChange = function (open, type) {
    var key = _this3.props.eventKey;
    var openChange = function openChange() {
      _this3.onOpenChange({
        key: key,
        item: _this3,
        trigger: type,
        open: open
      });
    };
    if (type === 'mouseenter') {
      // make sure mouseenter happen after other menu item's mouseleave
      _this3.mouseenterTimeout = setTimeout(function () {
        openChange();
      }, 0);
    } else {
      openChange();
    }
  };

  this.isChildrenSelected = function () {
    var ret = { find: false };
    Object(__WEBPACK_IMPORTED_MODULE_14__util__["d" /* loopMenuItemRecursively */])(_this3.props.children, _this3.props.selectedKeys, ret);
    return ret.find;
  };

  this.isOpen = function () {
    return _this3.props.openKeys.indexOf(_this3.props.eventKey) !== -1;
  };

  this.adjustWidth = function () {
    /* istanbul ignore if */
    if (!_this3.subMenuTitle || !_this3.menuInstance) {
      return;
    }
    var popupMenu = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(_this3.menuInstance);
    if (popupMenu.offsetWidth >= _this3.subMenuTitle.offsetWidth) {
      return;
    }

    /* istanbul ignore next */
    popupMenu.style.minWidth = _this3.subMenuTitle.offsetWidth + 'px';
  };

  this.saveSubMenuTitle = function (subMenuTitle) {
    _this3.subMenuTitle = subMenuTitle;
  };
};

var connected = Object(__WEBPACK_IMPORTED_MODULE_10_mini_store__["connect"])(function (_ref, _ref2) {
  var openKeys = _ref.openKeys,
      activeKey = _ref.activeKey,
      selectedKeys = _ref.selectedKeys;
  var eventKey = _ref2.eventKey,
      subMenuKey = _ref2.subMenuKey;
  return {
    isOpen: openKeys.indexOf(eventKey) > -1,
    active: activeKey[subMenuKey] === eventKey,
    selectedKeys: selectedKeys
  };
})(SubMenu);

connected.isSubMenu = true;

/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EventBaseObject = __webpack_require__(645);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(86);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = void 0;
    var deltaY = void 0;
    var delta = void 0;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = void 0;
    var doc = void 0;
    var body = void 0;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2["default"].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = void 0;
  var l = void 0;
  var prop = void 0;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2["default"].prototype;

(0, _objectAssign2["default"])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },
  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports["default"] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */

function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },
  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },
  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },
  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports['default'];

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(292);













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  point: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(648);
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_align__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(657);











function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        if (element) {
          result = Object(__WEBPACK_IMPORTED_MODULE_6_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = Object(__WEBPACK_IMPORTED_MODULE_6_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Align.prototype.componentDidMount = function componentDidMount() {
    var props = this.props;
    // if parent ref not attached .... use document.getElementById
    this.forceAlign();
    if (!props.disabled && props.monitorWindowResize) {
      this.startMonitorWindowResize();
    }
  };

  Align.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var reAlign = false;
    var props = this.props;

    if (!props.disabled) {
      var source = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var sourceRect = source ? source.getBoundingClientRect() : null;

      if (prevProps.disabled) {
        reAlign = true;
      } else {
        var lastElement = getElement(prevProps.target);
        var currentElement = getElement(props.target);
        var lastPoint = getPoint(prevProps.target);
        var currentPoint = getPoint(props.target);

        if (Object(__WEBPACK_IMPORTED_MODULE_8__util__["c" /* isWindow */])(lastElement) && Object(__WEBPACK_IMPORTED_MODULE_8__util__["c" /* isWindow */])(currentElement)) {
          // Skip if is window
          reAlign = false;
        } else if (lastElement !== currentElement || // Element change
        lastElement && !currentElement && currentPoint || // Change from element to point
        lastPoint && currentPoint && currentElement || // Change from point to element
        currentPoint && !Object(__WEBPACK_IMPORTED_MODULE_8__util__["b" /* isSamePoint */])(lastPoint, currentPoint)) {
          reAlign = true;
        }

        // If source element size changed
        var preRect = this.sourceRect || {};
        if (!reAlign && source && (preRect.width !== sourceRect.width || preRect.height !== sourceRect.height)) {
          reAlign = true;
        }
      }

      this.sourceRect = sourceRect;
    }

    if (reAlign) {
      this.forceAlign();
    }

    if (props.monitorWindowResize && !props.disabled) {
      this.startMonitorWindowResize();
    } else {
      this.stopMonitorWindowResize();
    }
  };

  Align.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stopMonitorWindowResize();
  };

  Align.prototype.startMonitorWindowResize = function startMonitorWindowResize() {
    if (!this.resizeHandler) {
      this.bufferMonitor = Object(__WEBPACK_IMPORTED_MODULE_8__util__["a" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
      this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
    }
  };

  Align.prototype.stopMonitorWindowResize = function stopMonitorWindowResize() {
    if (this.resizeHandler) {
      this.bufferMonitor.clear();
      this.resizeHandler.remove();
      this.resizeHandler = null;
    }
  };

  Align.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        childrenProps = _props.childrenProps,
        children = _props.children;

    var child = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(children);
    if (childrenProps) {
      var newProps = {};
      var propList = Object.keys(childrenProps);
      propList.forEach(function (prop) {
        newProps[prop] = _this2.props[childrenProps[prop]];
      });

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, newProps);
    }
    return child;
  };

  return Align;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__align_alignElement__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__align_alignPoint__ = __webpack_require__(656);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__align_alignElement__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__align_alignPoint__["a"]; });





/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__align_alignElement__["a" /* default */]);

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__align__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getRegion__ = __webpack_require__(290);





function isOutOfVisibleRect(target) {
  var visibleRect = Object(__WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__["a" /* default */])(target);
  var targetRegion = Object(__WEBPACK_IMPORTED_MODULE_3__getRegion__["a" /* default */])(target);

  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = Object(__WEBPACK_IMPORTED_MODULE_3__getRegion__["a" /* default */])(target);

  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target);

  return Object(__WEBPACK_IMPORTED_MODULE_0__align__["a" /* default */])(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */];

alignElement.__getVisibleRectForElement = __WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (alignElement);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransformName;
/* harmony export (immutable) */ __webpack_exports__["e"] = setTransitionProperty;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTransitionProperty;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTransformXY;
/* harmony export (immutable) */ __webpack_exports__["d"] = setTransformXY;
var vendorPrefix = void 0;

var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }
  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }
  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? getVendorPrefix() + 'TransitionProperty' : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? getVendorPrefix() + 'Transform' : 'transform';
}

function setTransitionProperty(node, value) {
  var name = getTransitionName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}

function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return { x: parseFloat(matrix[12] || matrix[4], 0), y: parseFloat(matrix[13] || matrix[5], 0) };
  }
  return {
    x: 0,
    y: 0
  };
}

var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;

function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var arr = void 0;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, 'matrix(' + arr.join(',') + ')');
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, 'matrix3d(' + arr.join(',') + ')');
    }
  } else {
    setTransform(node, 'translateX(' + xy.x + 'px) translateY(' + xy.y + 'px) translateZ(0)');
  }
}

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAncestorFixed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(69);


function isAncestorFixed(element) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
    var positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(parent, 'position');
    if (positionStyle === 'fixed') {
      return true;
    }
  }
  return false;
}

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(69);


function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }

  // Left edge inside and right edge outside viewport, try to resize it.
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }

  // Right edge outside viewport, try to move it.
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }

  // Top edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }

  // Top edge inside and bottom edge outside viewport, try to resize it.
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }

  // Bottom edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].mix(pos, size);
}

/* harmony default export */ __webpack_exports__["a"] = (adjustForViewport);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAlignOffset__ = __webpack_require__(655);


function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = Object(__WEBPACK_IMPORTED_MODULE_0__getAlignOffset__["a" /* default */])(refNodeRegion, points[1]);
  var p2 = Object(__WEBPACK_IMPORTED_MODULE_0__getAlignOffset__["a" /* default */])(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];

  return {
    left: elRegion.left - diff[0] + offset[0] - targetOffset[0],
    top: elRegion.top - diff[1] + offset[1] - targetOffset[1]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getElFuturePos);

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */

function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;

  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getAlignOffset);

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__align__ = __webpack_require__(287);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX = void 0;
  var pageY = void 0;

  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(el);
  var win = doc.defaultView || doc.parentWindow;

  var scrollX = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win);
  var scrollY = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win);
  var viewportWidth = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
  var viewportHeight = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };

  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;

  // Provide default target point
  var points = [align.points[0], 'cc'];

  return Object(__WEBPACK_IMPORTED_MODULE_1__align__["a" /* default */])(el, tgtRegion, _extends({}, align, { points: points }), pointInView);
}

/* harmony default export */ __webpack_exports__["a"] = (alignPoint);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["c"] = isWindow;
function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(291);







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placements */
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 7]
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0]
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0]
  }
};

/* harmony default export */ __webpack_exports__["a"] = (placements);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MenuItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(92);













/* eslint react/no-is-mounted:0 */

var MenuItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(MenuItem, _React$Component);

  function MenuItem(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MenuItem);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.onKeyDown = function (e) {
      var keyCode = e.keyCode;
      if (keyCode === __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].ENTER) {
        _this.onClick(e);
        return true;
      }
    };

    _this.onMouseLeave = function (e) {
      var _this$props = _this.props,
          eventKey = _this$props.eventKey,
          onItemHover = _this$props.onItemHover,
          onMouseLeave = _this$props.onMouseLeave;

      onItemHover({
        key: eventKey,
        hover: false
      });
      onMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onMouseEnter = function (e) {
      var _this$props2 = _this.props,
          eventKey = _this$props2.eventKey,
          onItemHover = _this$props2.onItemHover,
          onMouseEnter = _this$props2.onMouseEnter;

      onItemHover({
        key: eventKey,
        hover: true
      });
      onMouseEnter({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onClick = function (e) {
      var _this$props3 = _this.props,
          eventKey = _this$props3.eventKey,
          multiple = _this$props3.multiple,
          onClick = _this$props3.onClick,
          onSelect = _this$props3.onSelect,
          onDeselect = _this$props3.onDeselect,
          isSelected = _this$props3.isSelected;

      var info = {
        key: eventKey,
        keyPath: [eventKey],
        item: _this,
        domEvent: e
      };
      onClick(info);
      if (multiple) {
        if (isSelected) {
          onDeselect(info);
        } else {
          onSelect(info);
        }
      } else if (!isSelected) {
        onSelect(info);
      }
    };

    return _this;
  }

  MenuItem.prototype.componentDidMount = function componentDidMount() {
    // invoke customized ref to expose component to mixin
    this.callRef();
  };

  MenuItem.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.props.active) {
      __WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view___default()(__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this), __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.props.parentMenu), {
        onlyScrollIfNeeded: true
      });
    }
    this.callRef();
  };

  MenuItem.prototype.componentWillUnmount = function componentWillUnmount() {
    var props = this.props;
    if (props.onDestroy) {
      props.onDestroy(props.eventKey);
    }
  };

  MenuItem.prototype.getPrefixCls = function getPrefixCls() {
    return this.props.rootPrefixCls + '-item';
  };

  MenuItem.prototype.getActiveClassName = function getActiveClassName() {
    return this.getPrefixCls() + '-active';
  };

  MenuItem.prototype.getSelectedClassName = function getSelectedClassName() {
    return this.getPrefixCls() + '-selected';
  };

  MenuItem.prototype.getDisabledClassName = function getDisabledClassName() {
    return this.getPrefixCls() + '-disabled';
  };

  MenuItem.prototype.callRef = function callRef() {
    if (this.props.manualRef) {
      this.props.manualRef(this);
    }
  };

  MenuItem.prototype.render = function render() {
    var _classNames;

    var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props);
    var className = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(this.getPrefixCls(), props.className, (_classNames = {}, _classNames[this.getActiveClassName()] = !props.disabled && props.active, _classNames[this.getSelectedClassName()] = props.isSelected, _classNames[this.getDisabledClassName()] = props.disabled, _classNames));
    var attrs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props.attribute, {
      title: props.title,
      className: className,
      // set to menuitem by default
      role: 'menuitem',
      'aria-disabled': props.disabled
    });

    if (props.role === 'option') {
      // overwrite to option
      attrs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, attrs, {
        role: 'option',
        'aria-selected': props.isSelected
      });
    } else if (props.role === null) {
      // sometimes we want to specify role inside <li/> element
      // <li><a role='menuitem'>Link</a></li> would be a good example
      delete attrs.role;
    }
    // In case that onClick/onMouseLeave/onMouseEnter is passed down from owner
    var mouseEvent = {
      onClick: props.disabled ? null : this.onClick,
      onMouseLeave: props.disabled ? null : this.onMouseLeave,
      onMouseEnter: props.disabled ? null : this.onMouseEnter
    };
    var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props.style);
    if (props.mode === 'inline') {
      style.paddingLeft = props.inlineIndent * props.level;
    }
    __WEBPACK_IMPORTED_MODULE_11__util__["e" /* menuAllProps */].forEach(function (key) {
      return delete props[key];
    });
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'li',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, attrs, mouseEvent, {
        style: style
      }),
      props.children
    );
  };

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MenuItem.propTypes = {
  attribute: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onItemHover: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  parentMenu: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  isSelected: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  manualRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
MenuItem.defaultProps = {
  onSelect: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */],
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */],
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */],
  manualRef: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */]
};
MenuItem.isMenuItem = true;

var connected = Object(__WEBPACK_IMPORTED_MODULE_10_mini_store__["connect"])(function (_ref, _ref2) {
  var activeKey = _ref.activeKey,
      selectedKeys = _ref.selectedKeys;
  var eventKey = _ref2.eventKey,
      subMenuKey = _ref2.subMenuKey;
  return {
    active: activeKey[subMenuKey] === eventKey,
    isSelected: selectedKeys.indexOf(eventKey) !== -1
  };
})(MenuItem);

/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(92);









var MenuItemGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MenuItemGroup, _React$Component);

  function MenuItemGroup() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MenuItemGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderInnerMenuItem = function (item) {
      var _this$props = _this.props,
          renderMenuItem = _this$props.renderMenuItem,
          index = _this$props.index;

      return renderMenuItem(item, index, _this.props.subMenuKey);
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  MenuItemGroup.prototype.render = function render() {
    var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        rootPrefixCls = props.rootPrefixCls;

    var titleClassName = rootPrefixCls + '-item-group-title';
    var listClassName = rootPrefixCls + '-item-group-list';
    var title = props.title,
        children = props.children;

    __WEBPACK_IMPORTED_MODULE_7__util__["e" /* menuAllProps */].forEach(function (key) {
      return delete props[key];
    });

    // Set onClick to null, to ignore propagated onClick event
    delete props.onClick;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'li',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: className + ' ' + rootPrefixCls + '-item-group' }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        {
          className: titleClassName,
          title: typeof title === 'string' ? title : undefined
        },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'ul',
        { className: listClassName },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(children, this.renderInnerMenuItem)
      )
    );
  };

  return MenuItemGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

MenuItemGroup.propTypes = {
  renderMenuItem: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  index: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  subMenuKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
MenuItemGroup.defaultProps = {
  disabled: true
};


MenuItemGroup.isMenuItemGroup = true;

/* harmony default export */ __webpack_exports__["a"] = (MenuItemGroup);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Divider = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Divider, _React$Component);

  function Divider() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Divider);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Divider.prototype.render = function render() {
    var _props = this.props,
        _props$className = _props.className,
        className = _props$className === undefined ? '' : _props$className,
        rootPrefixCls = _props.rootPrefixCls;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li', { className: className + ' ' + rootPrefixCls + '-item-divider' });
  };

  return Divider;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Divider.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
};
Divider.defaultProps = {
  // To fix keyboard UX.
  disabled: true
};
/* harmony default export */ __webpack_exports__["a"] = (Divider);

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cssAnimation = __webpack_require__(267);

var _cssAnimation2 = _interopRequireDefault(_cssAnimation);

var _raf = __webpack_require__(178);

var _raf2 = _interopRequireDefault(_raf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function animate(node, show, done) {
    var height = void 0;
    var requestAnimationFrameId = void 0;
    return (0, _cssAnimation2['default'])(node, 'ant-motion-collapse', {
        start: function start() {
            if (!show) {
                node.style.height = node.offsetHeight + 'px';
                node.style.opacity = '1';
            } else {
                height = node.offsetHeight;
                node.style.height = '0px';
                node.style.opacity = '0';
            }
        },
        active: function active() {
            if (requestAnimationFrameId) {
                _raf2['default'].cancel(requestAnimationFrameId);
            }
            requestAnimationFrameId = (0, _raf2['default'])(function () {
                node.style.height = (show ? height : 0) + 'px';
                node.style.opacity = show ? '1' : '0';
            });
        },
        end: function end() {
            if (requestAnimationFrameId) {
                _raf2['default'].cancel(requestAnimationFrameId);
            }
            node.style.height = '';
            node.style.opacity = '';
            done();
        }
    });
}
var animation = {
    enter: function enter(node, done) {
        return animate(node, true, done);
    },
    leave: function leave(node, done) {
        return animate(node, false, done);
    },
    appear: function appear(node, done) {
        return animate(node, true, done);
    }
};
exports['default'] = animation;
module.exports = exports['default'];

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(295)))

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rcMenu = __webpack_require__(79);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SubMenu = function (_React$Component) {
    (0, _inherits3['default'])(SubMenu, _React$Component);

    function SubMenu() {
        (0, _classCallCheck3['default'])(this, SubMenu);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (SubMenu.__proto__ || Object.getPrototypeOf(SubMenu)).apply(this, arguments));

        _this.onKeyDown = function (e) {
            _this.subMenu.onKeyDown(e);
        };
        _this.saveSubMenu = function (subMenu) {
            _this.subMenu = subMenu;
        };
        return _this;
    }

    (0, _createClass3['default'])(SubMenu, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                rootPrefixCls = _props.rootPrefixCls,
                className = _props.className;

            var theme = this.context.antdMenuTheme;
            return React.createElement(_rcMenu.SubMenu, (0, _extends3['default'])({}, this.props, { ref: this.saveSubMenu, popupClassName: (0, _classnames2['default'])(rootPrefixCls + '-' + theme, className) }));
        }
    }]);
    return SubMenu;
}(React.Component);

SubMenu.contextTypes = {
    antdMenuTheme: _propTypes2['default'].string
};
// fix issue:https://github.com/ant-design/ant-design/issues/8666
SubMenu.isSubMenu = 1;
exports['default'] = SubMenu;
module.exports = exports['default'];

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _rcMenu = __webpack_require__(79);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _tooltip = __webpack_require__(296);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MenuItem = function (_React$Component) {
    (0, _inherits3['default'])(MenuItem, _React$Component);

    function MenuItem() {
        (0, _classCallCheck3['default'])(this, MenuItem);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).apply(this, arguments));

        _this.onKeyDown = function (e) {
            _this.menuItem.onKeyDown(e);
        };
        _this.saveMenuItem = function (menuItem) {
            _this.menuItem = menuItem;
        };
        return _this;
    }

    (0, _createClass3['default'])(MenuItem, [{
        key: 'render',
        value: function render() {
            var inlineCollapsed = this.context.inlineCollapsed;

            var props = this.props;
            return React.createElement(
                _tooltip2['default'],
                { title: inlineCollapsed && props.level === 1 ? props.children : '', placement: 'right', overlayClassName: props.rootPrefixCls + '-inline-collapsed-tooltip' },
                React.createElement(_rcMenu.Item, (0, _extends3['default'])({}, props, { ref: this.saveMenuItem }))
            );
        }
    }]);
    return MenuItem;
}(React.Component);

MenuItem.contextTypes = {
    inlineCollapsed: _propTypes2['default'].bool
};
MenuItem.isMenuItem = 1;
exports['default'] = MenuItem;
module.exports = exports['default'];

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(668);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__placements__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Content__ = __webpack_require__(670);











var Tooltip = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _Component);

  function Tooltip() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
      var _this$props = _this.props,
          arrowContent = _this$props.arrowContent,
          overlay = _this$props.overlay,
          prefixCls = _this$props.prefixCls,
          id = _this$props.id;

      return [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-arrow', key: 'arrow' },
        arrowContent
      ), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Content__["a" /* default */], {
        key: 'content',
        trigger: _this.trigger,
        prefixCls: prefixCls,
        id: id,
        overlay: overlay
      })];
    }, _this.saveTrigger = function (node) {
      _this.trigger = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Tooltip.prototype.render = function render() {
    var _props = this.props,
        overlayClassName = _props.overlayClassName,
        trigger = _props.trigger,
        mouseEnterDelay = _props.mouseEnterDelay,
        mouseLeaveDelay = _props.mouseLeaveDelay,
        overlayStyle = _props.overlayStyle,
        prefixCls = _props.prefixCls,
        children = _props.children,
        onVisibleChange = _props.onVisibleChange,
        afterVisibleChange = _props.afterVisibleChange,
        transitionName = _props.transitionName,
        animation = _props.animation,
        placement = _props.placement,
        align = _props.align,
        destroyTooltipOnHide = _props.destroyTooltipOnHide,
        defaultVisible = _props.defaultVisible,
        getTooltipContainer = _props.getTooltipContainer,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);

    var extraProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps);
    if ('visible' in this.props) {
      extraProps.popupVisible = this.props.visible;
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["default"],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        popupClassName: overlayClassName,
        ref: this.saveTrigger,
        prefixCls: prefixCls,
        popup: this.getPopupElement,
        action: trigger,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_8__placements__["a" /* placements */],
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
      }, extraProps),
      children
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Tooltip.propTypes = {
  trigger: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  placement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  afterVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  overlay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]).isRequired,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  getTooltipContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  destroyTooltipOnHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  arrowContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
Tooltip.defaultProps = {
  prefixCls: 'rc-tooltip',
  mouseEnterDelay: 0,
  destroyTooltipOnHide: false,
  mouseLeaveDelay: 0.1,
  align: {},
  placement: 'right',
  trigger: ['hover'],
  arrowContent: null
};


/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Content = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Content, _React$Component);

  function Content() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Content);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Content.prototype.componentDidUpdate = function componentDidUpdate() {
    var trigger = this.props.trigger;

    if (trigger) {
      trigger.forcePopupAlign();
    }
  };

  Content.prototype.render = function render() {
    var _props = this.props,
        overlay = _props.overlay,
        prefixCls = _props.prefixCls,
        id = _props.id;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-inner', id: id },
      typeof overlay === 'function' ? overlay() : overlay
    );
  };

  return Content;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Content.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  overlay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]).isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  trigger: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

exports.getOverflowOptions = getOverflowOptions;
exports['default'] = getPlacements;

var _placements = __webpack_require__(672);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var autoAdjustOverflowEnabled = {
    adjustX: 1,
    adjustY: 1
};
var autoAdjustOverflowDisabled = {
    adjustX: 0,
    adjustY: 0
};
var targetOffset = [0, 0];
function getOverflowOptions(autoAdjustOverflow) {
    if (typeof autoAdjustOverflow === 'boolean') {
        return autoAdjustOverflow ? autoAdjustOverflowEnabled : autoAdjustOverflowDisabled;
    }
    return (0, _extends3['default'])({}, autoAdjustOverflowDisabled, autoAdjustOverflow);
}
function getPlacements() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$arrowWidth = config.arrowWidth,
        arrowWidth = _config$arrowWidth === undefined ? 5 : _config$arrowWidth,
        _config$horizontalArr = config.horizontalArrowShift,
        horizontalArrowShift = _config$horizontalArr === undefined ? 16 : _config$horizontalArr,
        _config$verticalArrow = config.verticalArrowShift,
        verticalArrowShift = _config$verticalArrow === undefined ? 12 : _config$verticalArrow,
        _config$autoAdjustOve = config.autoAdjustOverflow,
        autoAdjustOverflow = _config$autoAdjustOve === undefined ? true : _config$autoAdjustOve;

    var placementMap = {
        left: {
            points: ['cr', 'cl'],
            offset: [-4, 0]
        },
        right: {
            points: ['cl', 'cr'],
            offset: [4, 0]
        },
        top: {
            points: ['bc', 'tc'],
            offset: [0, -4]
        },
        bottom: {
            points: ['tc', 'bc'],
            offset: [0, 4]
        },
        topLeft: {
            points: ['bl', 'tc'],
            offset: [-(horizontalArrowShift + arrowWidth), -4]
        },
        leftTop: {
            points: ['tr', 'cl'],
            offset: [-4, -(verticalArrowShift + arrowWidth)]
        },
        topRight: {
            points: ['br', 'tc'],
            offset: [horizontalArrowShift + arrowWidth, -4]
        },
        rightTop: {
            points: ['tl', 'cr'],
            offset: [4, -(verticalArrowShift + arrowWidth)]
        },
        bottomRight: {
            points: ['tr', 'bc'],
            offset: [horizontalArrowShift + arrowWidth, 4]
        },
        rightBottom: {
            points: ['bl', 'cr'],
            offset: [4, verticalArrowShift + arrowWidth]
        },
        bottomLeft: {
            points: ['tl', 'bc'],
            offset: [-(horizontalArrowShift + arrowWidth), 4]
        },
        leftBottom: {
            points: ['br', 'cl'],
            offset: [-4, verticalArrowShift + arrowWidth]
        }
    };
    Object.keys(placementMap).forEach(function (key) {
        placementMap[key] = config.arrowPointAtCenter ? (0, _extends3['default'])({}, placementMap[key], { overflow: getOverflowOptions(autoAdjustOverflow), targetOffset: targetOffset }) : (0, _extends3['default'])({}, _placements.placements[key], { overflow: getOverflowOptions(autoAdjustOverflow) });
    });
    return placementMap;
}

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = exports.placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

exports['default'] = placements;

/***/ }),
/* 673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_menu_style__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_menu_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_menu_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_menu__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_less__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(59);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubMenu=__WEBPACK_IMPORTED_MODULE_3_antd_lib_menu___default.a.SubMenu;var Sider=__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Sider;var Sidebar=function(_React$Component){_inherits(Sidebar,_React$Component);function Sidebar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Sidebar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Sidebar.__proto__||Object.getPrototypeOf(Sidebar)).call.apply(_ref,[this].concat(args))),_this),_this.state={account_type:[],openKey:"sub1",activeKey:"menu101",collapsed:false,mode:'inline'},_this.toggle=function(){_this.setState({collapsed:!_this.state.collapsed,mode:!_this.state.collapsed?'vertical':'inline'});},_this.menuClickHandle=function(item){_this.setState({activeKey:item.key});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Sidebar,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){nextProps.accountType&&nextProps.accountType.length?this.setState({account_type:nextProps.accountType}):null;}},{key:'render',value:function render(){if(this.state.account_type){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Sider,{trigger:null,collapsible:true,collapsed:this.state.collapsed,onCollapse:this.onCollapse},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'ant-layout-logo'}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_menu___default.a,{mode:this.state.mode,theme:'dark'// selectedKeys={[activeKey]}
,selectable:false,defaultOpenKeys:['main'],onClick:this.menuClickHandle},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(SubMenu,{key:'main',title:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span',{className:'nav-text'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'database'}),'Menu'))},this.props.accountType.slice(0,1).map(function(menu,index){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_menu___default.a.Item,{key:index},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Link */],{to:menu.path},menu.menuTitle));}))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'sider-trigger'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{className:'trigger',type:this.state.collapsed?'menu-unfold':'menu-fold',onClick:this.toggle})));}else{return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',null,'loading...');}}}]);return Sidebar;}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Sidebar);

/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Footer=__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a.Footer;var commonFooter=function(_React$Component){_inherits(commonFooter,_React$Component);function commonFooter(){_classCallCheck(this,commonFooter);return _possibleConstructorReturn(this,(commonFooter.__proto__||Object.getPrototypeOf(commonFooter)).apply(this,arguments));}_createClass(commonFooter,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Footer,{style:{textAlign:'center'}},'3D Smile \xA9 2017');}}]);return commonFooter;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (commonFooter);

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Home__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Cases__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Cases_caseUploadCT__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Cases_caseUploadCTAlign__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Cases_caseUploadCTv2__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Cases_caseUploadCTv2Auto__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Cases_caseUploadPlanStandart__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Cases_caseUploadPlanRoots__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Cases_caseUploadPlanDeepCT__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Cases_caseUploadPlanStandartOrthostudio__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Cases_caseUploadPlanStandart3shape1c__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Cases_caseUploadPlanStandart3shapeColor__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Cases_caseUploadPlanStandartArchform1c__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Cases_caseUploadPlanStandartOnyxceph__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Cases_caseUploadPlanStandartSureSmileSOU__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Cases_caseUploadPlanStandartOrthoStudioV5__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_Cases_caseUploadPlanStandartNemo__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_Cases_caseUploadTeethAlignmentModelling__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_Cases_planUpdateForm__ = __webpack_require__(1068);
var Routes=[{'path':'/home','component':__WEBPACK_IMPORTED_MODULE_4__views_Cases__["a" /* default */],'exactly':true,'menuTitle':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'home'}),'Home'),'menuGroup':'main'},{'path':'/case/upload/ct','component':__WEBPACK_IMPORTED_MODULE_5__views_Cases_caseUploadCT__["a" /* default */],'exactly':true,'menuTitle':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'folder-add'}),'Case'),'menuGroup':'main'},{'path':'/case/upload/ct-align','component':__WEBPACK_IMPORTED_MODULE_6__views_Cases_caseUploadCTAlign__["a" /* default */],'exactly':true,'menuTitle':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'folder-add'}),'Case'),'menuGroup':'main'},{'path':'/case/upload/ct-v2','component':__WEBPACK_IMPORTED_MODULE_7__views_Cases_caseUploadCTv2__["a" /* default */],'exactly':true,'menuTitle':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'folder-add'}),'Case'),'menuGroup':'main'},{'path':'/case/upload/ct-v2-auto','component':__WEBPACK_IMPORTED_MODULE_8__views_Cases_caseUploadCTv2Auto__["a" /* default */],'exactly':true,'menuTitle':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'folder-add'}),'Case'),'menuGroup':'main'},{'path':'/case/upload/plan-standart','component':__WEBPACK_IMPORTED_MODULE_9__views_Cases_caseUploadPlanStandart__["a" /* default */],'exactly':true,'menuTitle':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'folder-add'}),'Case'),'menuGroup':'main'},{'path':'/case/upload/plan-roots','component':__WEBPACK_IMPORTED_MODULE_10__views_Cases_caseUploadPlanRoots__["a" /* default */],'exactly':true,'menuTitle':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'folder-add'}),'Case'),'menuGroup':'main'},{'path':'/case/upload/plan-deep-ct','component':__WEBPACK_IMPORTED_MODULE_11__views_Cases_caseUploadPlanDeepCT__["a" /* default */],'exactly':true,'menuTitle':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'folder-add'}),'Case'),'menuGroup':'main'},{'path':'/case/upload/plan-standard-orthostudio','component':__WEBPACK_IMPORTED_MODULE_12__views_Cases_caseUploadPlanStandartOrthostudio__["a" /* default */],'exactly':true,'menuTitle':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'folder-add'}),'Case'),'menuGroup':'main'},{'path':'/case/upload/plan-standard-3shape-1c','component':__WEBPACK_IMPORTED_MODULE_13__views_Cases_caseUploadPlanStandart3shape1c__["a" /* default */],'exactly':true,'menuTitle':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'folder-add'}),'Case'),'menuGroup':'main'},{'path':'/case/upload/plan-standard-3shape-color','component':__WEBPACK_IMPORTED_MODULE_14__views_Cases_caseUploadPlanStandart3shapeColor__["a" /* default */],'exactly':true,'menuTitle':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'folder-add'}),'Case'),'menuGroup':'main'},{'path':'/case/upload/plan-standard-archform-1c','component':__WEBPACK_IMPORTED_MODULE_15__views_Cases_caseUploadPlanStandartArchform1c__["a" /* default */],'exactly':true,'menuTitle':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'folder-add'}),'Case'),'menuGroup':'main'},{'path':'/case/upload/plan-standard-onyxceph','component':__WEBPACK_IMPORTED_MODULE_16__views_Cases_caseUploadPlanStandartOnyxceph__["a" /* default */],'exactly':true,'menuTitle':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'folder-add'}),'Case'),'menuGroup':'main'},{'path':'/case/plan-update-form/:uuid','component':__WEBPACK_IMPORTED_MODULE_21__views_Cases_planUpdateForm__["a" /* default */],'exactly':true,'menuTitle':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'folder-add'}),'Case'),'menuGroup':'main'},{'path':'/case/upload/plan-standard-orthostudio-v5','component':__WEBPACK_IMPORTED_MODULE_18__views_Cases_caseUploadPlanStandartOrthoStudioV5__["a" /* default */],'exactly':true,'menuTitle':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'folder-add'}),'Case'),'menuGroup':'main'},{'path':'/case/upload/plan-standard-suresmile-sou','component':__WEBPACK_IMPORTED_MODULE_17__views_Cases_caseUploadPlanStandartSureSmileSOU__["a" /* default */],'exactly':true,'menuTitle':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'folder-add'}),'Case'),'menuGroup':'main'},{'path':'/case/upload/plan-standard-nemo','component':__WEBPACK_IMPORTED_MODULE_19__views_Cases_caseUploadPlanStandartNemo__["a" /* default */],'exactly':true,'menuTitle':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'folder-add'}),'Case'),'menuGroup':'main'},{'path':'/case/upload/teeth-alignment-modelling','component':__WEBPACK_IMPORTED_MODULE_20__views_Cases_caseUploadTeethAlignmentModelling__["a" /* default */],'exactly':true,'menuTitle':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'folder-add'}),'Case'),'menuGroup':'main'}];

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormItem=__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item;var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var Home=function(_React$Component){_inherits(Home,_React$Component);function Home(props){_classCallCheck(this,Home);var _this=_possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).call(this,props));_this.state={};return _this;}_createClass(Home,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_PanelBox__["a" /* default */],{title:'\u0413\u043B\u0430\u0432\u043D\u0430\u044F'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a,null,'Content'));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps)(Home));

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(682);

/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

exports['default'] = function (props) {
    var _props$prefixCls = props.prefixCls,
        prefixCls = _props$prefixCls === undefined ? 'ant-card' : _props$prefixCls,
        className = props.className,
        others = __rest(props, ["prefixCls", "className"]);

    var classString = (0, _classnames2['default'])(prefixCls + '-grid', className);
    return React.createElement('div', (0, _extends3['default'])({}, others, { className: classString }));
};

module.exports = exports['default'];

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

exports['default'] = function (props) {
    var _props$prefixCls = props.prefixCls,
        prefixCls = _props$prefixCls === undefined ? 'ant-card' : _props$prefixCls,
        className = props.className,
        avatar = props.avatar,
        title = props.title,
        description = props.description,
        others = __rest(props, ["prefixCls", "className", "avatar", "title", "description"]);

    var classString = (0, _classnames2['default'])(prefixCls + '-meta', className);
    var avatarDom = avatar ? React.createElement(
        'div',
        { className: prefixCls + '-meta-avatar' },
        avatar
    ) : null;
    var titleDom = title ? React.createElement(
        'div',
        { className: prefixCls + '-meta-title' },
        title
    ) : null;
    var descriptionDom = description ? React.createElement(
        'div',
        { className: prefixCls + '-meta-description' },
        description
    ) : null;
    var MetaDetail = titleDom || descriptionDom ? React.createElement(
        'div',
        { className: prefixCls + '-meta-detail' },
        titleDom,
        descriptionDom
    ) : null;
    return React.createElement(
        'div',
        (0, _extends3['default'])({}, others, { className: classString }),
        avatarDom,
        MetaDetail
    );
};

module.exports = exports['default'];

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _typeof2 = __webpack_require__(38);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(15);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _rcTabs = __webpack_require__(686);

var _rcTabs2 = _interopRequireDefault(_rcTabs);

var _ScrollableInkTabBar = __webpack_require__(690);

var _ScrollableInkTabBar2 = _interopRequireDefault(_ScrollableInkTabBar);

var _TabContent = __webpack_require__(705);

var _TabContent2 = _interopRequireDefault(_TabContent);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = __webpack_require__(6);

var _icon2 = _interopRequireDefault(_icon);

var _warning = __webpack_require__(48);

var _warning2 = _interopRequireDefault(_warning);

var _isFlexSupported = __webpack_require__(706);

var _isFlexSupported2 = _interopRequireDefault(_isFlexSupported);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Tabs = function (_React$Component) {
    (0, _inherits3['default'])(Tabs, _React$Component);

    function Tabs() {
        (0, _classCallCheck3['default'])(this, Tabs);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).apply(this, arguments));

        _this.createNewTab = function (targetKey) {
            var onEdit = _this.props.onEdit;
            if (onEdit) {
                onEdit(targetKey, 'add');
            }
        };
        _this.removeTab = function (targetKey, e) {
            e.stopPropagation();
            if (!targetKey) {
                return;
            }
            var onEdit = _this.props.onEdit;
            if (onEdit) {
                onEdit(targetKey, 'remove');
            }
        };
        _this.handleChange = function (activeKey) {
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange(activeKey);
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(Tabs, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var NO_FLEX = ' no-flex';
            var tabNode = ReactDOM.findDOMNode(this);
            if (tabNode && !(0, _isFlexSupported2['default'])() && tabNode.className.indexOf(NO_FLEX) === -1) {
                tabNode.className += NO_FLEX;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames,
                _this2 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                size = _props.size,
                _props$type = _props.type,
                type = _props$type === undefined ? 'line' : _props$type,
                tabPosition = _props.tabPosition,
                children = _props.children,
                tabBarExtraContent = _props.tabBarExtraContent,
                tabBarStyle = _props.tabBarStyle,
                hideAdd = _props.hideAdd,
                onTabClick = _props.onTabClick,
                onPrevClick = _props.onPrevClick,
                onNextClick = _props.onNextClick,
                _props$animated = _props.animated,
                animated = _props$animated === undefined ? true : _props$animated,
                tabBarGutter = _props.tabBarGutter;

            var _ref = (typeof animated === 'undefined' ? 'undefined' : (0, _typeof3['default'])(animated)) === 'object' ? {
                inkBarAnimated: animated.inkBar, tabPaneAnimated: animated.tabPane
            } : {
                inkBarAnimated: animated, tabPaneAnimated: animated
            },
                inkBarAnimated = _ref.inkBarAnimated,
                tabPaneAnimated = _ref.tabPaneAnimated;
            // card tabs should not have animation


            if (type !== 'line') {
                tabPaneAnimated = 'animated' in this.props ? tabPaneAnimated : false;
            }
            (0, _warning2['default'])(!(type.indexOf('card') >= 0 && (size === 'small' || size === 'large')), 'Tabs[type=card|editable-card] doesn\'t have small or large size, it\'s by designed.');
            var cls = (0, _classnames2['default'])(className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-vertical', tabPosition === 'left' || tabPosition === 'right'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + size, !!size), (0, _defineProperty3['default'])(_classNames, prefixCls + '-card', type.indexOf('card') >= 0), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + type, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-no-animation', !tabPaneAnimated), _classNames));
            // only card type tabs can be added and closed
            var childrenWithClose = [];
            if (type === 'editable-card') {
                childrenWithClose = [];
                React.Children.forEach(children, function (child, index) {
                    var closable = child.props.closable;
                    closable = typeof closable === 'undefined' ? true : closable;
                    var closeIcon = closable ? React.createElement(_icon2['default'], { type: 'close', onClick: function onClick(e) {
                            return _this2.removeTab(child.key, e);
                        } }) : null;
                    childrenWithClose.push(React.cloneElement(child, {
                        tab: React.createElement(
                            'div',
                            { className: closable ? undefined : prefixCls + '-tab-unclosable' },
                            child.props.tab,
                            closeIcon
                        ),
                        key: child.key || index
                    }));
                });
                // Add new tab handler
                if (!hideAdd) {
                    tabBarExtraContent = React.createElement(
                        'span',
                        null,
                        React.createElement(_icon2['default'], { type: 'plus', className: prefixCls + '-new-tab', onClick: this.createNewTab }),
                        tabBarExtraContent
                    );
                }
            }
            tabBarExtraContent = tabBarExtraContent ? React.createElement(
                'div',
                { className: prefixCls + '-extra-content' },
                tabBarExtraContent
            ) : null;
            var renderTabBar = function renderTabBar() {
                return React.createElement(_ScrollableInkTabBar2['default'], { inkBarAnimated: inkBarAnimated, extraContent: tabBarExtraContent, onTabClick: onTabClick, onPrevClick: onPrevClick, onNextClick: onNextClick, style: tabBarStyle, tabBarGutter: tabBarGutter });
            };
            return React.createElement(
                _rcTabs2['default'],
                (0, _extends3['default'])({}, this.props, { className: cls, tabBarPosition: tabPosition, renderTabBar: renderTabBar, renderTabContent: function renderTabContent() {
                        return React.createElement(_TabContent2['default'], { animated: tabPaneAnimated, animatedWithMargin: true });
                    }, onChange: this.handleChange }),
                childrenWithClose.length > 0 ? childrenWithClose : children
            );
        }
    }]);
    return Tabs;
}(React.Component);

exports['default'] = Tabs;

Tabs.TabPane = _rcTabs.TabPane;
Tabs.defaultProps = {
    prefixCls: 'ant-tabs',
    hideAdd: false
};
module.exports = exports['default'];

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TabPane__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TabContent__ = __webpack_require__(689);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabPane", function() { return __WEBPACK_IMPORTED_MODULE_1__TabPane__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabContent", function() { return __WEBPACK_IMPORTED_MODULE_2__TabContent__["a"]; });




/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Tabs__["a" /* default */]);


/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__KeyCode__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TabPane__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(182);














function noop() {}

function getDefaultActiveKey(props) {
  var activeKey = void 0;
  __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(props.children, function (child) {
    if (child && !activeKey && !child.props.disabled) {
      activeKey = child.key;
    }
  });
  return activeKey;
}

function activeKeyIsValid(props, key) {
  var keys = __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.map(props.children, function (child) {
    return child && child.key;
  });
  return keys.indexOf(key) >= 0;
}

var Tabs = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Tabs, _React$Component);

  function Tabs(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Tabs);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

    _initialiseProps.call(_this);

    var activeKey = void 0;
    if ('activeKey' in props) {
      activeKey = props.activeKey;
    } else if ('defaultActiveKey' in props) {
      activeKey = props.defaultActiveKey;
    } else {
      activeKey = getDefaultActiveKey(props);
    }

    _this.state = {
      activeKey: activeKey
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Tabs, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('activeKey' in nextProps) {
        this.setState({
          activeKey: nextProps.activeKey
        });
      } else if (!activeKeyIsValid(nextProps, this.state.activeKey)) {
        // https://github.com/ant-design/ant-design/issues/7093
        this.setState({
          activeKey: getDefaultActiveKey(nextProps)
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var props = this.props;

      var prefixCls = props.prefixCls,
          navWrapper = props.navWrapper,
          tabBarPosition = props.tabBarPosition,
          className = props.className,
          renderTabContent = props.renderTabContent,
          renderTabBar = props.renderTabBar,
          destroyInactiveTabPane = props.destroyInactiveTabPane,
          restProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(props, ['prefixCls', 'navWrapper', 'tabBarPosition', 'className', 'renderTabContent', 'renderTabBar', 'destroyInactiveTabPane']);

      var cls = __WEBPACK_IMPORTED_MODULE_11_classnames___default()((_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-' + tabBarPosition, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, className, !!className), _classnames));

      this.tabBar = renderTabBar();
      var contents = [__WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(this.tabBar, {
        prefixCls: prefixCls,
        navWrapper: navWrapper,
        key: 'tabBar',
        onKeyDown: this.onNavKeyDown,
        tabBarPosition: tabBarPosition,
        onTabClick: this.onTabClick,
        panels: props.children,
        activeKey: this.state.activeKey
      }), __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(renderTabContent(), {
        prefixCls: prefixCls,
        tabBarPosition: tabBarPosition,
        activeKey: this.state.activeKey,
        destroyInactiveTabPane: destroyInactiveTabPane,
        children: props.children,
        onChange: this.setActiveKey,
        key: 'tabContent'
      })];
      if (tabBarPosition === 'bottom') {
        contents.reverse();
      }
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          className: cls,
          style: props.style
        }, Object(__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* getDataAttr */])(restProps)),
        contents
      );
    }
  }]);

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onTabClick = function (activeKey, e) {
    if (_this2.tabBar.props.onTabClick) {
      _this2.tabBar.props.onTabClick(activeKey, e);
    }
    _this2.setActiveKey(activeKey);
  };

  this.onNavKeyDown = function (e) {
    var eventKeyCode = e.keyCode;
    if (eventKeyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].RIGHT || eventKeyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].DOWN) {
      e.preventDefault();
      var nextKey = _this2.getNextActiveKey(true);
      _this2.onTabClick(nextKey);
    } else if (eventKeyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].LEFT || eventKeyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].UP) {
      e.preventDefault();
      var previousKey = _this2.getNextActiveKey(false);
      _this2.onTabClick(previousKey);
    }
  };

  this.setActiveKey = function (activeKey) {
    if (_this2.state.activeKey !== activeKey) {
      if (!('activeKey' in _this2.props)) {
        _this2.setState({
          activeKey: activeKey
        });
      }
      _this2.props.onChange(activeKey);
    }
  };

  this.getNextActiveKey = function (next) {
    var activeKey = _this2.state.activeKey;
    var children = [];
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(_this2.props.children, function (c) {
      if (c && !c.props.disabled) {
        if (next) {
          children.push(c);
        } else {
          children.unshift(c);
        }
      }
    });
    var length = children.length;
    var ret = length && children[0].key;
    children.forEach(function (child, i) {
      if (child.key === activeKey) {
        if (i === length - 1) {
          ret = children[0].key;
        } else {
          ret = children[i + 1].key;
        }
      }
    });
    return ret;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Tabs);


Tabs.propTypes = {
  destroyInactiveTabPane: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  renderTabBar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  renderTabContent: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  navWrapper: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  tabBarPosition: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  defaultActiveKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

Tabs.defaultProps = {
  prefixCls: 'rc-tabs',
  destroyInactiveTabPane: false,
  onChange: noop,
  navWrapper: function navWrapper(arg) {
    return arg;
  },
  tabBarPosition: 'top',
  children: null,
  style: {}
};

Tabs.TabPane = __WEBPACK_IMPORTED_MODULE_10__TabPane__["a" /* default */];

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * LEFT
   */
  LEFT: 37, // also NUM_WEST
  /**
   * UP
   */
  UP: 38, // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39, // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40 // also NUM_SOUTH
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(182);











var TabContent = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TabContent, _React$Component);

  function TabContent() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TabContent);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TabContent, [{
    key: 'getTabPanes',
    value: function getTabPanes() {
      var props = this.props;
      var activeKey = props.activeKey;
      var children = props.children;
      var newChildren = [];

      __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.forEach(children, function (child) {
        if (!child) {
          return;
        }
        var key = child.key;
        var active = activeKey === key;
        newChildren.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
          active: active,
          destroyInactiveTabPane: props.destroyInactiveTabPane,
          rootPrefixCls: props.prefixCls
        }));
      });

      return newChildren;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var props = this.props;
      var prefixCls = props.prefixCls,
          children = props.children,
          activeKey = props.activeKey,
          tabBarPosition = props.tabBarPosition,
          animated = props.animated,
          animatedWithMargin = props.animatedWithMargin;
      var style = props.style;

      var classes = __WEBPACK_IMPORTED_MODULE_8_classnames___default()((_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-content', true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, animated ? prefixCls + '-content-animated' : prefixCls + '-content-no-animated', true), _classnames));
      if (animated) {
        var activeIndex = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* getActiveIndex */])(children, activeKey);
        if (activeIndex !== -1) {
          var animatedStyle = animatedWithMargin ? Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* getMarginStyle */])(activeIndex, tabBarPosition) : Object(__WEBPACK_IMPORTED_MODULE_9__utils__["e" /* getTransformPropValue */])(Object(__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* getTransformByIndex */])(activeIndex, tabBarPosition));
          style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, animatedStyle);
        } else {
          style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, {
            display: 'none'
          });
        }
      }
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        {
          className: classes,
          style: style
        },
        this.getTabPanes()
      );
    }
  }]);

  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (TabContent);


TabContent.propTypes = {
  animated: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  animatedWithMargin: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  tabBarPosition: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

TabContent.defaultProps = {
  animated: true
};

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _InkTabBarNode = __webpack_require__(691);

var _InkTabBarNode2 = _interopRequireDefault(_InkTabBarNode);

var _TabBarTabsNode = __webpack_require__(692);

var _TabBarTabsNode2 = _interopRequireDefault(_TabBarTabsNode);

var _TabBarRootNode = __webpack_require__(693);

var _TabBarRootNode2 = _interopRequireDefault(_TabBarRootNode);

var _ScrollableTabBarNode = __webpack_require__(694);

var _ScrollableTabBarNode2 = _interopRequireDefault(_ScrollableTabBarNode);

var _SaveRef = __webpack_require__(704);

var _SaveRef2 = _interopRequireDefault(_SaveRef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ScrollableInkTabBar = function (_React$Component) {
  (0, _inherits3['default'])(ScrollableInkTabBar, _React$Component);

  function ScrollableInkTabBar() {
    (0, _classCallCheck3['default'])(this, ScrollableInkTabBar);
    return (0, _possibleConstructorReturn3['default'])(this, (ScrollableInkTabBar.__proto__ || Object.getPrototypeOf(ScrollableInkTabBar)).apply(this, arguments));
  }

  (0, _createClass3['default'])(ScrollableInkTabBar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2['default'].createElement(
        _SaveRef2['default'],
        null,
        function (saveRef, getRef) {
          return _react2['default'].createElement(
            _TabBarRootNode2['default'],
            (0, _extends3['default'])({ saveRef: saveRef }, _this2.props),
            _react2['default'].createElement(
              _ScrollableTabBarNode2['default'],
              (0, _extends3['default'])({ saveRef: saveRef, getRef: getRef }, _this2.props),
              _react2['default'].createElement(_TabBarTabsNode2['default'], (0, _extends3['default'])({ saveRef: saveRef }, _this2.props)),
              _react2['default'].createElement(_InkTabBarNode2['default'], (0, _extends3['default'])({ saveRef: saveRef, getRef: getRef }, _this2.props))
            )
          );
        }
      );
    }
  }]);
  return ScrollableInkTabBar;
}(_react2['default'].Component);

exports['default'] = ScrollableInkTabBar;
module.exports = exports['default'];

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.getScroll = getScroll;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(11);

var _classnames3 = _interopRequireDefault(_classnames2);

var _utils = __webpack_require__(114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function offset(elem) {
  var box = void 0;
  var x = void 0;
  var y = void 0;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  box = elem.getBoundingClientRect();
  x = box.left;
  y = box.top;
  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  var w = doc.defaultView || doc.parentWindow;
  x += getScroll(w);
  y += getScroll(w, true);
  return {
    left: x, top: y
  };
}

function _componentDidUpdate(component, init) {
  var styles = component.props.styles;

  var rootNode = component.props.getRef('root');
  var wrapNode = component.props.getRef('nav') || rootNode;
  var containerOffset = offset(wrapNode);
  var inkBarNode = component.props.getRef('inkBar');
  var activeTab = component.props.getRef('activeTab');
  var inkBarNodeStyle = inkBarNode.style;
  var tabBarPosition = component.props.tabBarPosition;
  if (init) {
    // prevent mount animation
    inkBarNodeStyle.display = 'none';
  }
  if (activeTab) {
    var tabNode = activeTab;
    var tabOffset = offset(tabNode);
    var transformSupported = (0, _utils.isTransformSupported)(inkBarNodeStyle);
    if (tabBarPosition === 'top' || tabBarPosition === 'bottom') {
      var left = tabOffset.left - containerOffset.left;
      var width = tabNode.offsetWidth;

      // If tabNode'width width equal to wrapNode'width when tabBarPosition is top or bottom
      // It means no css working, then ink bar should not have width until css is loaded
      // Fix https://github.com/ant-design/ant-design/issues/7564
      if (width === rootNode.offsetWidth) {
        width = 0;
      } else if (styles.inkBar && styles.inkBar.width !== undefined) {
        width = parseFloat(styles.inkBar.width, 10);
        if (width) {
          left = left + (tabNode.offsetWidth - width) / 2;
        }
      }
      // use 3d gpu to optimize render
      if (transformSupported) {
        (0, _utils.setTransform)(inkBarNodeStyle, 'translate3d(' + left + 'px,0,0)');
        inkBarNodeStyle.width = width + 'px';
        inkBarNodeStyle.height = '';
      } else {
        inkBarNodeStyle.left = left + 'px';
        inkBarNodeStyle.top = '';
        inkBarNodeStyle.bottom = '';
        inkBarNodeStyle.right = wrapNode.offsetWidth - left - width + 'px';
      }
    } else {
      var top = tabOffset.top - containerOffset.top;
      var height = tabNode.offsetHeight;
      if (styles.inkBar && styles.inkBar.height !== undefined) {
        height = parseFloat(styles.inkBar.height, 10);
        if (height) {
          top = top + (tabNode.offsetHeight - height) / 2;
        }
      }
      if (transformSupported) {
        (0, _utils.setTransform)(inkBarNodeStyle, 'translate3d(0,' + top + 'px,0)');
        inkBarNodeStyle.height = height + 'px';
        inkBarNodeStyle.width = '';
      } else {
        inkBarNodeStyle.left = '';
        inkBarNodeStyle.right = '';
        inkBarNodeStyle.top = top + 'px';
        inkBarNodeStyle.bottom = wrapNode.offsetHeight - top - height + 'px';
      }
    }
  }
  inkBarNodeStyle.display = activeTab ? 'block' : 'none';
}

var InkTabBarNode = function (_React$Component) {
  (0, _inherits3['default'])(InkTabBarNode, _React$Component);

  function InkTabBarNode() {
    (0, _classCallCheck3['default'])(this, InkTabBarNode);
    return (0, _possibleConstructorReturn3['default'])(this, (InkTabBarNode.__proto__ || Object.getPrototypeOf(InkTabBarNode)).apply(this, arguments));
  }

  (0, _createClass3['default'])(InkTabBarNode, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // ref https://github.com/ant-design/ant-design/issues/8678
      // ref https://github.com/react-component/tabs/issues/135
      // InkTabBarNode need parent/root ref for calculating position
      // since parent componentDidMount triggered after child componentDidMount
      // we're doing a quick fix here to use setTimeout to calculate position
      // after parent/root component mounted
      this.timeout = setTimeout(function () {
        _componentDidUpdate(_this2, true);
      }, 0);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      _componentDidUpdate(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          styles = _props.styles,
          inkBarAnimated = _props.inkBarAnimated;

      var className = prefixCls + '-ink-bar';
      var classes = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, className, true), (0, _defineProperty3['default'])(_classnames, inkBarAnimated ? className + '-animated' : className + '-no-animated', true), _classnames));
      return _react2['default'].createElement('div', {
        style: styles.inkBar,
        className: classes,
        key: 'inkBar',
        ref: this.props.saveRef('inkBar')
      });
    }
  }]);
  return InkTabBarNode;
}(_react2['default'].Component);

exports['default'] = InkTabBarNode;


InkTabBarNode.propTypes = {
  prefixCls: _propTypes2['default'].string,
  styles: _propTypes2['default'].object,
  inkBarAnimated: _propTypes2['default'].bool,
  saveRef: _propTypes2['default'].func
};

InkTabBarNode.defaultProps = {
  prefixCls: '',
  inkBarAnimated: true,
  styles: {},
  saveRef: function saveRef() {}
};

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _warning = __webpack_require__(30);

var _warning2 = _interopRequireDefault(_warning);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TabBarTabsNode = function (_React$Component) {
  (0, _inherits3['default'])(TabBarTabsNode, _React$Component);

  function TabBarTabsNode() {
    (0, _classCallCheck3['default'])(this, TabBarTabsNode);
    return (0, _possibleConstructorReturn3['default'])(this, (TabBarTabsNode.__proto__ || Object.getPrototypeOf(TabBarTabsNode)).apply(this, arguments));
  }

  (0, _createClass3['default'])(TabBarTabsNode, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.panels,
          activeKey = _props.activeKey,
          prefixCls = _props.prefixCls,
          tabBarGutter = _props.tabBarGutter;

      var rst = [];

      _react2['default'].Children.forEach(children, function (child, index) {
        if (!child) {
          return;
        }
        var key = child.key;
        var cls = activeKey === key ? prefixCls + '-tab-active' : '';
        cls += ' ' + prefixCls + '-tab';
        var events = {};
        if (child.props.disabled) {
          cls += ' ' + prefixCls + '-tab-disabled';
        } else {
          events = {
            onClick: _this2.props.onTabClick.bind(_this2, key)
          };
        }
        var ref = {};
        if (activeKey === key) {
          ref.ref = _this2.props.saveRef('activeTab');
        }
        (0, _warning2['default'])('tab' in child.props, 'There must be `tab` property on children of Tabs.');
        rst.push(_react2['default'].createElement(
          'div',
          (0, _extends3['default'])({
            role: 'tab',
            'aria-disabled': child.props.disabled ? 'true' : 'false',
            'aria-selected': activeKey === key ? 'true' : 'false'
          }, events, {
            className: cls,
            key: key,
            style: { marginRight: tabBarGutter && index === children.length - 1 ? 0 : tabBarGutter }
          }, ref),
          child.props.tab
        ));
      });

      return _react2['default'].createElement(
        'div',
        null,
        rst
      );
    }
  }]);
  return TabBarTabsNode;
}(_react2['default'].Component);

exports['default'] = TabBarTabsNode;


TabBarTabsNode.propTypes = {
  activeKey: _propTypes2['default'].string,
  panels: _propTypes2['default'].node,
  prefixCls: _propTypes2['default'].string,
  tabBarGutter: _propTypes2['default'].number,
  onTabClick: _propTypes2['default'].func,
  saveRef: _propTypes2['default'].func
};

TabBarTabsNode.defaultProps = {
  panels: [],
  prefixCls: [],
  tabBarGutter: null,
  onTabClick: function onTabClick() {},
  saveRef: function saveRef() {}
};
module.exports = exports['default'];

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(39);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(11);

var _classnames3 = _interopRequireDefault(_classnames2);

var _utils = __webpack_require__(114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TabBarRootNode = function (_React$Component) {
  (0, _inherits3['default'])(TabBarRootNode, _React$Component);

  function TabBarRootNode() {
    (0, _classCallCheck3['default'])(this, TabBarRootNode);
    return (0, _possibleConstructorReturn3['default'])(this, (TabBarRootNode.__proto__ || Object.getPrototypeOf(TabBarRootNode)).apply(this, arguments));
  }

  (0, _createClass3['default'])(TabBarRootNode, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          prefixCls = _props.prefixCls,
          onKeyDown = _props.onKeyDown,
          className = _props.className,
          extraContent = _props.extraContent,
          style = _props.style,
          tabBarPosition = _props.tabBarPosition,
          children = _props.children,
          restProps = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'onKeyDown', 'className', 'extraContent', 'style', 'tabBarPosition', 'children']);

      var cls = (0, _classnames3['default'])(prefixCls + '-bar', (0, _defineProperty3['default'])({}, className, !!className));
      var topOrBottom = tabBarPosition === 'top' || tabBarPosition === 'bottom';
      var tabBarExtraContentStyle = topOrBottom ? { float: 'right' } : {};
      var extraContentStyle = extraContent && extraContent.props ? extraContent.props.style : {};
      var newChildren = children;
      if (extraContent) {
        newChildren = [(0, _react.cloneElement)(extraContent, {
          key: 'extra',
          style: (0, _extends3['default'])({}, tabBarExtraContentStyle, extraContentStyle)
        }), (0, _react.cloneElement)(children, { key: 'content' })];
        newChildren = topOrBottom ? newChildren : newChildren.reverse();
      }
      return _react2['default'].createElement(
        'div',
        (0, _extends3['default'])({
          role: 'tablist',
          className: cls,
          tabIndex: '0',
          ref: this.props.saveRef('root'),
          onKeyDown: onKeyDown,
          style: style
        }, (0, _utils.getDataAttr)(restProps)),
        newChildren
      );
    }
  }]);
  return TabBarRootNode;
}(_react2['default'].Component);

exports['default'] = TabBarRootNode;


TabBarRootNode.propTypes = {
  prefixCls: _propTypes2['default'].string,
  className: _propTypes2['default'].string,
  style: _propTypes2['default'].object,
  tabBarPosition: _propTypes2['default'].oneOf(['left', 'right', 'top', 'bottom']),
  children: _propTypes2['default'].node,
  extraContent: _propTypes2['default'].node,
  onKeyDown: _propTypes2['default'].func,
  saveRef: _propTypes2['default'].func
};

TabBarRootNode.defaultProps = {
  prefixCls: '',
  className: '',
  style: {},
  tabBarPosition: 'top',
  extraContent: null,
  children: null,
  onKeyDown: function onKeyDown() {},
  saveRef: function saveRef() {}
};
module.exports = exports['default'];

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames5 = __webpack_require__(11);

var _classnames6 = _interopRequireDefault(_classnames5);

var _utils = __webpack_require__(114);

var _addEventListener = __webpack_require__(181);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _debounce = __webpack_require__(695);

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ScrollableTabBarNode = function (_React$Component) {
  (0, _inherits3['default'])(ScrollableTabBarNode, _React$Component);

  function ScrollableTabBarNode(props) {
    (0, _classCallCheck3['default'])(this, ScrollableTabBarNode);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (ScrollableTabBarNode.__proto__ || Object.getPrototypeOf(ScrollableTabBarNode)).call(this, props));

    _this.prevTransitionEnd = function (e) {
      if (e.propertyName !== 'opacity') {
        return;
      }
      var container = _this.props.getRef('container');
      _this.scrollToActiveTab({
        target: container,
        currentTarget: container
      });
    };

    _this.scrollToActiveTab = function (e) {
      var activeTab = _this.props.getRef('activeTab');
      var navWrap = _this.props.getRef('navWrap');
      if (e && e.target !== e.currentTarget || !activeTab) {
        return;
      }

      // when not scrollable or enter scrollable first time, don't emit scrolling
      var needToSroll = _this.isNextPrevShown() && _this.lastNextPrevShown;
      _this.lastNextPrevShown = _this.isNextPrevShown();
      if (!needToSroll) {
        return;
      }

      var activeTabWH = _this.getScrollWH(activeTab);
      var navWrapNodeWH = _this.getOffsetWH(navWrap);
      var offset = _this.offset;

      var wrapOffset = _this.getOffsetLT(navWrap);
      var activeTabOffset = _this.getOffsetLT(activeTab);
      if (wrapOffset > activeTabOffset) {
        offset += wrapOffset - activeTabOffset;
        _this.setOffset(offset);
      } else if (wrapOffset + navWrapNodeWH < activeTabOffset + activeTabWH) {
        offset -= activeTabOffset + activeTabWH - (wrapOffset + navWrapNodeWH);
        _this.setOffset(offset);
      }
    };

    _this.prev = function (e) {
      _this.props.onPrevClick(e);
      var navWrapNode = _this.props.getRef('navWrap');
      var navWrapNodeWH = _this.getOffsetWH(navWrapNode);
      var offset = _this.offset;

      _this.setOffset(offset + navWrapNodeWH);
    };

    _this.next = function (e) {
      _this.props.onNextClick(e);
      var navWrapNode = _this.props.getRef('navWrap');
      var navWrapNodeWH = _this.getOffsetWH(navWrapNode);
      var offset = _this.offset;

      _this.setOffset(offset - navWrapNodeWH);
    };

    _this.offset = 0;

    _this.state = {
      next: false,
      prev: false
    };
    return _this;
  }

  (0, _createClass3['default'])(ScrollableTabBarNode, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.componentDidUpdate();
      this.debouncedResize = (0, _debounce2['default'])(function () {
        _this2.setNextPrev();
        _this2.scrollToActiveTab();
      }, 200);
      this.resizeEvent = (0, _addEventListener2['default'])(window, 'resize', this.debouncedResize);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var props = this.props;
      if (prevProps && prevProps.tabBarPosition !== props.tabBarPosition) {
        this.setOffset(0);
        return;
      }
      var nextPrev = this.setNextPrev();
      // wait next, prev show hide
      /* eslint react/no-did-update-set-state:0 */
      if (this.isNextPrevShown(this.state) !== this.isNextPrevShown(nextPrev)) {
        this.setState({}, this.scrollToActiveTab);
      } else if (!prevProps || props.activeKey !== prevProps.activeKey) {
        // can not use props.activeKey
        this.scrollToActiveTab();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.resizeEvent) {
        this.resizeEvent.remove();
      }
      if (this.debouncedResize && this.debouncedResize.cancel) {
        this.debouncedResize.cancel();
      }
    }
  }, {
    key: 'setNextPrev',
    value: function setNextPrev() {
      var navNode = this.props.getRef('nav');
      var navNodeWH = this.getScrollWH(navNode);
      var containerWH = this.getOffsetWH(this.props.getRef('container'));
      var navWrapNodeWH = this.getOffsetWH(this.props.getRef('navWrap'));
      var offset = this.offset;

      var minOffset = containerWH - navNodeWH;
      var _state = this.state,
          next = _state.next,
          prev = _state.prev;

      if (minOffset >= 0) {
        next = false;
        this.setOffset(0, false);
        offset = 0;
      } else if (minOffset < offset) {
        next = true;
      } else {
        next = false;
        // Fix https://github.com/ant-design/ant-design/issues/8861
        // Test with container offset which is stable
        // and set the offset of the nav wrap node
        var realOffset = navWrapNodeWH - navNodeWH;
        this.setOffset(realOffset, false);
        offset = realOffset;
      }

      if (offset < 0) {
        prev = true;
      } else {
        prev = false;
      }

      this.setNext(next);
      this.setPrev(prev);
      return {
        next: next,
        prev: prev
      };
    }
  }, {
    key: 'getOffsetWH',
    value: function getOffsetWH(node) {
      var tabBarPosition = this.props.tabBarPosition;
      var prop = 'offsetWidth';
      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        prop = 'offsetHeight';
      }
      return node[prop];
    }
  }, {
    key: 'getScrollWH',
    value: function getScrollWH(node) {
      var tabBarPosition = this.props.tabBarPosition;
      var prop = 'scrollWidth';
      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        prop = 'scrollHeight';
      }
      return node[prop];
    }
  }, {
    key: 'getOffsetLT',
    value: function getOffsetLT(node) {
      var tabBarPosition = this.props.tabBarPosition;
      var prop = 'left';
      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        prop = 'top';
      }
      return node.getBoundingClientRect()[prop];
    }
  }, {
    key: 'setOffset',
    value: function setOffset(offset) {
      var checkNextPrev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var target = Math.min(0, offset);
      if (this.offset !== target) {
        this.offset = target;
        var navOffset = {};
        var tabBarPosition = this.props.tabBarPosition;
        var navStyle = this.props.getRef('nav').style;
        var transformSupported = (0, _utils.isTransformSupported)(navStyle);
        if (tabBarPosition === 'left' || tabBarPosition === 'right') {
          if (transformSupported) {
            navOffset = {
              value: 'translate3d(0,' + target + 'px,0)'
            };
          } else {
            navOffset = {
              name: 'top',
              value: target + 'px'
            };
          }
        } else {
          if (transformSupported) {
            navOffset = {
              value: 'translate3d(' + target + 'px,0,0)'
            };
          } else {
            navOffset = {
              name: 'left',
              value: target + 'px'
            };
          }
        }
        if (transformSupported) {
          (0, _utils.setTransform)(navStyle, navOffset.value);
        } else {
          navStyle[navOffset.name] = navOffset.value;
        }
        if (checkNextPrev) {
          this.setNextPrev();
        }
      }
    }
  }, {
    key: 'setPrev',
    value: function setPrev(v) {
      if (this.state.prev !== v) {
        this.setState({
          prev: v
        });
      }
    }
  }, {
    key: 'setNext',
    value: function setNext(v) {
      if (this.state.next !== v) {
        this.setState({
          next: v
        });
      }
    }
  }, {
    key: 'isNextPrevShown',
    value: function isNextPrevShown(state) {
      if (state) {
        return state.next || state.prev;
      }
      return this.state.next || this.state.prev;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames, _classnames2, _classnames3, _classnames4;

      var _state2 = this.state,
          next = _state2.next,
          prev = _state2.prev;
      var _props = this.props,
          prefixCls = _props.prefixCls,
          scrollAnimated = _props.scrollAnimated,
          navWrapper = _props.navWrapper;

      var showNextPrev = prev || next;

      var prevButton = _react2['default'].createElement(
        'span',
        {
          onClick: prev ? this.prev : null,
          unselectable: 'unselectable',
          className: (0, _classnames6['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-prev', 1), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-btn-disabled', !prev), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-arrow-show', showNextPrev), _classnames)),
          onTransitionEnd: this.prevTransitionEnd
        },
        _react2['default'].createElement('span', { className: prefixCls + '-tab-prev-icon' })
      );

      var nextButton = _react2['default'].createElement(
        'span',
        {
          onClick: next ? this.next : null,
          unselectable: 'unselectable',
          className: (0, _classnames6['default'])((_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-next', 1), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-btn-disabled', !next), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-arrow-show', showNextPrev), _classnames2))
        },
        _react2['default'].createElement('span', { className: prefixCls + '-tab-next-icon' })
      );

      var navClassName = prefixCls + '-nav';
      var navClasses = (0, _classnames6['default'])((_classnames3 = {}, (0, _defineProperty3['default'])(_classnames3, navClassName, true), (0, _defineProperty3['default'])(_classnames3, scrollAnimated ? navClassName + '-animated' : navClassName + '-no-animated', true), _classnames3));

      return _react2['default'].createElement(
        'div',
        {
          className: (0, _classnames6['default'])((_classnames4 = {}, (0, _defineProperty3['default'])(_classnames4, prefixCls + '-nav-container', 1), (0, _defineProperty3['default'])(_classnames4, prefixCls + '-nav-container-scrolling', showNextPrev), _classnames4)),
          key: 'container',
          ref: this.props.saveRef('container')
        },
        prevButton,
        nextButton,
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-nav-wrap', ref: this.props.saveRef('navWrap') },
          _react2['default'].createElement(
            'div',
            { className: prefixCls + '-nav-scroll' },
            _react2['default'].createElement(
              'div',
              { className: navClasses, ref: this.props.saveRef('nav') },
              navWrapper(this.props.children)
            )
          )
        )
      );
    }
  }]);
  return ScrollableTabBarNode;
}(_react2['default'].Component);

exports['default'] = ScrollableTabBarNode;


ScrollableTabBarNode.propTypes = {
  getRef: _propTypes2['default'].func.isRequired,
  saveRef: _propTypes2['default'].func.isRequired,
  tabBarPosition: _propTypes2['default'].oneOf(['left', 'right', 'top', 'bottom']),
  prefixCls: _propTypes2['default'].string,
  scrollAnimated: _propTypes2['default'].bool,
  onPrevClick: _propTypes2['default'].func,
  onNextClick: _propTypes2['default'].func,
  navWrapper: _propTypes2['default'].func,
  children: _propTypes2['default'].node
};

ScrollableTabBarNode.defaultProps = {
  tabBarPosition: 'left',
  prefixCls: '',
  scrollAnimated: true,
  onPrevClick: function onPrevClick() {},
  onNextClick: function onNextClick() {},
  navWrapper: function navWrapper(ele) {
    return ele;
  }
};
module.exports = exports['default'];

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(298),
    now = __webpack_require__(696),
    toNumber = __webpack_require__(698);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(299);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(298),
    isSymbol = __webpack_require__(699);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(700),
    isObjectLike = __webpack_require__(703);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(300),
    getRawTag = __webpack_require__(701),
    objectToString = __webpack_require__(702);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(300);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 702 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 703 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SaveRef = function (_React$Component) {
  (0, _inherits3['default'])(SaveRef, _React$Component);

  function SaveRef() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3['default'])(this, SaveRef);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = SaveRef.__proto__ || Object.getPrototypeOf(SaveRef)).call.apply(_ref, [this].concat(args))), _this), _this.getRef = function (name) {
      return _this[name];
    }, _this.saveRef = function (name) {
      return function (node) {
        if (node) {
          _this[name] = node;
        }
      };
    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
  }

  (0, _createClass3['default'])(SaveRef, [{
    key: 'render',
    value: function render() {
      return this.props.children(this.saveRef, this.getRef);
    }
  }]);
  return SaveRef;
}(_react2['default'].Component);

exports['default'] = SaveRef;


SaveRef.propTypes = {
  children: _propTypes2['default'].func
};

SaveRef.defaultProps = {
  children: function children() {
    return null;
  }
};
module.exports = exports['default'];

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(11);

var _classnames3 = _interopRequireDefault(_classnames2);

var _utils = __webpack_require__(114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TabContent = function (_React$Component) {
  (0, _inherits3['default'])(TabContent, _React$Component);

  function TabContent() {
    (0, _classCallCheck3['default'])(this, TabContent);
    return (0, _possibleConstructorReturn3['default'])(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).apply(this, arguments));
  }

  (0, _createClass3['default'])(TabContent, [{
    key: 'getTabPanes',
    value: function getTabPanes() {
      var props = this.props;
      var activeKey = props.activeKey;
      var children = props.children;
      var newChildren = [];

      _react2['default'].Children.forEach(children, function (child) {
        if (!child) {
          return;
        }
        var key = child.key;
        var active = activeKey === key;
        newChildren.push(_react2['default'].cloneElement(child, {
          active: active,
          destroyInactiveTabPane: props.destroyInactiveTabPane,
          rootPrefixCls: props.prefixCls
        }));
      });

      return newChildren;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var props = this.props;
      var prefixCls = props.prefixCls,
          children = props.children,
          activeKey = props.activeKey,
          tabBarPosition = props.tabBarPosition,
          animated = props.animated,
          animatedWithMargin = props.animatedWithMargin;
      var style = props.style;

      var classes = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-content', true), (0, _defineProperty3['default'])(_classnames, animated ? prefixCls + '-content-animated' : prefixCls + '-content-no-animated', true), _classnames));
      if (animated) {
        var activeIndex = (0, _utils.getActiveIndex)(children, activeKey);
        if (activeIndex !== -1) {
          var animatedStyle = animatedWithMargin ? (0, _utils.getMarginStyle)(activeIndex, tabBarPosition) : (0, _utils.getTransformPropValue)((0, _utils.getTransformByIndex)(activeIndex, tabBarPosition));
          style = (0, _extends3['default'])({}, style, animatedStyle);
        } else {
          style = (0, _extends3['default'])({}, style, {
            display: 'none'
          });
        }
      }
      return _react2['default'].createElement(
        'div',
        {
          className: classes,
          style: style
        },
        this.getTabPanes()
      );
    }
  }]);
  return TabContent;
}(_react2['default'].Component);

exports['default'] = TabContent;


TabContent.propTypes = {
  animated: _propTypes2['default'].bool,
  animatedWithMargin: _propTypes2['default'].bool,
  prefixCls: _propTypes2['default'].string,
  children: _propTypes2['default'].node,
  activeKey: _propTypes2['default'].string,
  style: _propTypes2['default'].any,
  tabBarPosition: _propTypes2['default'].string
};

TabContent.defaultProps = {
  animated: true
};
module.exports = exports['default'];

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = isFlexSupported;
function isFlexSupported() {
    if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
        var documentElement = window.document.documentElement;

        return 'flex' in documentElement.style || 'webkitFlex' in documentElement.style || 'Flex' in documentElement.style || 'msFlex' in documentElement.style;
    }
    return false;
}
module.exports = exports['default'];

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(68);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports['default'] = throttleByAnimationFrame;
exports.throttleByAnimationFrameDecorator = throttleByAnimationFrameDecorator;

var _raf = __webpack_require__(178);

var _raf2 = _interopRequireDefault(_raf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function throttleByAnimationFrame(fn) {
    var requestId = void 0;
    var later = function later(args) {
        return function () {
            requestId = null;
            fn.apply(undefined, (0, _toConsumableArray3['default'])(args));
        };
    };
    var throttled = function throttled() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        if (requestId == null) {
            requestId = (0, _raf2['default'])(later(args));
        }
    };
    throttled.cancel = function () {
        return _raf2['default'].cancel(requestId);
    };
    return throttled;
}
function throttleByAnimationFrameDecorator() {
    return function (target, key, descriptor) {
        var fn = descriptor.value;
        var definingProperty = false;
        return {
            configurable: true,
            get: function get() {
                if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
                    return fn;
                }
                var boundFn = throttleByAnimationFrame(fn.bind(this));
                definingProperty = true;
                Object.defineProperty(this, key, {
                    value: boundFn,
                    configurable: true,
                    writable: true
                });
                definingProperty = false;
                return boundFn;
            }
        };
    };
}

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__caseTableClient__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__caseTableStaff__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__caseNew__ = __webpack_require__(923);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import CaseUpload from "./caseUpload";
var FormItem=__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item;var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var Form1=function(_React$Component){_inherits(Form1,_React$Component);function Form1(props){_classCallCheck(this,Form1);var _this=_possibleConstructorReturn(this,(Form1.__proto__||Object.getPrototypeOf(Form1)).call(this,props));_this.state={fileList:[]};return _this;}_createClass(Form1,[{key:'render',value:function render(){var formItemLayout={labelCol:{span:6},wrapperCol:{span:14}};var formItemFiels={labelCol:{span:10},wrapperCol:{span:6}};var tailFormItemLayout={wrapperCol:{xs:{span:14,offset:0},sm:{span:14,offset:10}}};return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__caseNew__["a" /* default */],null),this.props.user.is_client?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__caseTableClient__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__caseTableStaff__["a" /* default */],null));}}]);return Form1;}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps)(Form1));

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_table_style__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_table__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_jobs__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var case_status={'-3':'-3','-2':'-2','-1':'-1','0':'Draft','1':'Upload','10':'Upload done','20':'Computing','30':'30','40':'Ready','45':'45','50':'50','100':'100'};var download_links={'bone_aligned_l':'Lower bone','teeth_aligned_l':'Lower teeth','bone_aligned_u':'Upper bone','teeth_aligned_u':'Upper teeth'};var mapStateToProps=function mapStateToProps(state){return{jobs:state.jobs,links:state.links};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getClientJobs:function getClientJobs(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_jobs__["b" /* getClientJobs */])());},getLinks:function getLinks(uuid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_jobs__["d" /* getLinks */])(uuid));},eraseJobs:function eraseJobs(){return dispatch({type:'ERASE_JOBS'});},eraseLinks:function eraseLinks(){return dispatch({type:'ERASE_LINKS'});}};};var CaseTableClient=function(_Component){_inherits(CaseTableClient,_Component);function CaseTableClient(props){_classCallCheck(this,CaseTableClient);var _this=_possibleConstructorReturn(this,(CaseTableClient.__proto__||Object.getPrototypeOf(CaseTableClient)).call(this,props));_this.handleChange=function(pagination,filters,sorter){_this.setState({filteredInfo:filters,sortedInfo:sorter});};_this.state={showModal:false,sorted_jobs:[],searchValue:'',sortedInfo:{order:'descend',columnKey:'created'}};_this.getLinks=_this.getLinks.bind(_this);_this.showDownloadModal=_this.showDownloadModal.bind(_this);return _this;}_createClass(CaseTableClient,[{key:'componentDidMount',value:function componentDidMount(){this.props.getClientJobs();this.setState({'tableLoading':true});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){nextProps.jobs?this.setState({tableLoading:false}):null;this.state.showModal&&nextProps.links&&this.showDownloadModal(nextProps.links);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.eraseJobs();}},{key:'onSearcHandler',value:function onSearcHandler(searchText){var filtred_data=[];var table_data=this.props.jobs;this.setState({'searchValue':searchText});if(searchText!==''){table_data.map(function(record){var match=false;Object.values(record).map(function(value){if(value&&Object.values(value).length){Object.values(value).map(function(subvalue){if(subvalue&&subvalue.toString().toUpperCase().indexOf(searchText.toUpperCase())!=-1){match=true;}});}else if(value&&value.toString().toUpperCase().indexOf(searchText.toUpperCase())!=-1){match=true;}});match?filtred_data.push(record):null;});}this.setState({'sorted_jobs':filtred_data});}},{key:'showDownloadModal',value:function showDownloadModal(links){this.setState({showModal:false});__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a.info({title:'Download files',iconType:"download",content:Object.keys(links).length?__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{style:{marginTop:8}},Object.keys(links).map(function(item,key){return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('p',{key:key},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('a',{href:links[item]},download_links[item]));})):__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{style:{marginTop:8}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('p',null,'No files available')),onOk:function onOk(){}});}},{key:'getLinks',value:function getLinks(uuid){this.props.getLinks(uuid);this.setState({showModal:true});}},{key:'render',value:function render(){var _this2=this;var sortedInfo=this.state.sortedInfo;sortedInfo=sortedInfo||{};var columns=[{title:'id',dataIndex:'uuid',render:function render(id){return id.slice(0,8);},key:'id',sorter:function sorter(a,b){return a.uuid-b.uuid;},sortOrder:sortedInfo.columnKey==='uuid'&&sortedInfo.order},{title:'Patient tag',dataIndex:'ct_scan.patient_tag',key:'patient_tag',sorter:function sorter(a,b){return a.ct_scan.patient_tag-b.ct_scan.patient_tag;},sortOrder:sortedInfo.columnKey==='patient_tag'&&sortedInfo.order},{title:'Status',dataIndex:'status',key:'status',render:function render(status){return case_status[status];},sorter:function sorter(a,b){return a.status-b.status;},sortOrder:sortedInfo.columnKey==='status'&&sortedInfo.order},{title:'Updated',dataIndex:'last_modified',render:function render(date){return __WEBPACK_IMPORTED_MODULE_14_moment___default()(date).format('DD-MM-YYYY');},key:'last_modified',sorter:function sorter(a,b){return Date.parse(a.last_modified)-Date.parse(b.last_modified);},sortOrder:sortedInfo.columnKey==='last_modified'&&sortedInfo.order},{title:'Created',dataIndex:'created',render:function render(date){return __WEBPACK_IMPORTED_MODULE_14_moment___default()(date).format('DD-MM-YYYY');},key:'created',sorter:function sorter(a,b){return Date.parse(a.created)-Date.parse(b.created);},sortOrder:sortedInfo.columnKey==='created'&&sortedInfo.order}];return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_PanelBox__["a" /* default */],{title:"Case table"},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row___default.a,{type:'flex',justify:'end',style:{marginBottom:16}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a,{type:'search'}),placeholder:'Search',style:{width:200},onChange:function onChange(e){return _this2.onSearcHandler(e.target.value);}})),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_table___default.a,{dataSource:this.state.searchValue!=''?this.state.sorted_jobs:this.props.jobs,columns:columns,rowKey:'uuid',loading:this.state.tableLoading,onChange:this.handleChange,onRowClick:function onRowClick(index){_this2.getLinks(index.uuid);}}));}}]);return CaseTableClient;}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CaseTableClient));

/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(716);

__webpack_require__(18);

__webpack_require__(20);

/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__(38);

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(5);

var _extends5 = _interopRequireDefault(_extends4);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(15);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _rcTable = __webpack_require__(719);

var _rcTable2 = _interopRequireDefault(_rcTable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _pagination = __webpack_require__(810);

var _pagination2 = _interopRequireDefault(_pagination);

var _icon = __webpack_require__(6);

var _icon2 = _interopRequireDefault(_icon);

var _spin = __webpack_require__(192);

var _spin2 = _interopRequireDefault(_spin);

var _LocaleReceiver = __webpack_require__(71);

var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);

var _default = __webpack_require__(107);

var _default2 = _interopRequireDefault(_default);

var _warning = __webpack_require__(48);

var _warning2 = _interopRequireDefault(_warning);

var _filterDropdown = __webpack_require__(823);

var _filterDropdown2 = _interopRequireDefault(_filterDropdown);

var _createStore = __webpack_require__(841);

var _createStore2 = _interopRequireDefault(_createStore);

var _SelectionBox = __webpack_require__(842);

var _SelectionBox2 = _interopRequireDefault(_SelectionBox);

var _SelectionCheckboxAll = __webpack_require__(843);

var _SelectionCheckboxAll2 = _interopRequireDefault(_SelectionCheckboxAll);

var _Column = __webpack_require__(844);

var _Column2 = _interopRequireDefault(_Column);

var _ColumnGroup = __webpack_require__(845);

var _ColumnGroup2 = _interopRequireDefault(_ColumnGroup);

var _createBodyRow = __webpack_require__(846);

var _createBodyRow2 = _interopRequireDefault(_createBodyRow);

var _util = __webpack_require__(847);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

function noop() {}
function stopPropagation(e) {
    e.stopPropagation();
    if (e.nativeEvent.stopImmediatePropagation) {
        e.nativeEvent.stopImmediatePropagation();
    }
}
function getRowSelection(props) {
    return props.rowSelection || {};
}
var defaultPagination = {
    onChange: noop,
    onShowSizeChange: noop
};
/**
 * Avoid creating new object, so that parent component's shouldComponentUpdate
 * can works appropriately。
 */
var emptyObject = {};

var Table = function (_React$Component) {
    (0, _inherits3['default'])(Table, _React$Component);

    function Table(props) {
        (0, _classCallCheck3['default'])(this, Table);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

        _this.getCheckboxPropsByItem = function (item, index) {
            var rowSelection = getRowSelection(_this.props);
            if (!rowSelection.getCheckboxProps) {
                return {};
            }
            var key = _this.getRecordKey(item, index);
            // Cache checkboxProps
            if (!_this.CheckboxPropsCache[key]) {
                _this.CheckboxPropsCache[key] = rowSelection.getCheckboxProps(item);
            }
            return _this.CheckboxPropsCache[key];
        };
        _this.onRow = function (record, index) {
            var _this$props = _this.props,
                onRow = _this$props.onRow,
                prefixCls = _this$props.prefixCls;

            var custom = onRow ? onRow(record, index) : {};
            return (0, _extends5['default'])({}, custom, { prefixCls: prefixCls, store: _this.store, rowKey: _this.getRecordKey(record, index) });
        };
        _this.handleFilter = function (column, nextFilters) {
            var props = _this.props;
            var pagination = (0, _extends5['default'])({}, _this.state.pagination);
            var filters = (0, _extends5['default'])({}, _this.state.filters, (0, _defineProperty3['default'])({}, _this.getColumnKey(column), nextFilters));
            // Remove filters not in current columns
            var currentColumnKeys = [];
            (0, _util.treeMap)(_this.columns, function (c) {
                if (!c.children) {
                    currentColumnKeys.push(_this.getColumnKey(c));
                }
            });
            Object.keys(filters).forEach(function (columnKey) {
                if (currentColumnKeys.indexOf(columnKey) < 0) {
                    delete filters[columnKey];
                }
            });
            if (props.pagination) {
                // Reset current prop
                pagination.current = 1;
                pagination.onChange(pagination.current);
            }
            var newState = {
                pagination: pagination,
                filters: {}
            };
            var filtersToSetState = (0, _extends5['default'])({}, filters);
            // Remove filters which is controlled
            _this.getFilteredValueColumns().forEach(function (col) {
                var columnKey = _this.getColumnKey(col);
                if (columnKey) {
                    delete filtersToSetState[columnKey];
                }
            });
            if (Object.keys(filtersToSetState).length > 0) {
                newState.filters = filtersToSetState;
            }
            // Controlled current prop will not respond user interaction
            if ((0, _typeof3['default'])(props.pagination) === 'object' && 'current' in props.pagination) {
                newState.pagination = (0, _extends5['default'])({}, pagination, { current: _this.state.pagination.current });
            }
            _this.setState(newState, function () {
                _this.store.setState({
                    selectionDirty: false
                });
                var onChange = _this.props.onChange;
                if (onChange) {
                    onChange.apply(null, _this.prepareParamsArguments((0, _extends5['default'])({}, _this.state, { selectionDirty: false, filters: filters,
                        pagination: pagination })));
                }
            });
        };
        _this.handleSelect = function (record, rowIndex, e) {
            var checked = e.target.checked;
            var nativeEvent = e.nativeEvent;
            var defaultSelection = _this.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
            var selectedRowKeys = _this.store.getState().selectedRowKeys.concat(defaultSelection);
            var key = _this.getRecordKey(record, rowIndex);
            var pivot = _this.state.pivot;
            var rows = _this.getFlatCurrentPageData();
            var realIndex = rowIndex;
            if (_this.props.expandedRowRender) {
                realIndex = rows.findIndex(function (row) {
                    return _this.getRecordKey(row, rowIndex) === key;
                });
            }
            if (nativeEvent.shiftKey && pivot !== undefined && realIndex !== pivot) {
                var changeRowKeys = [];
                var direction = Math.sign(pivot - realIndex);
                var dist = Math.abs(pivot - realIndex);
                var step = 0;

                var _loop = function _loop() {
                    var i = realIndex + step * direction;
                    step += 1;
                    var row = rows[i];
                    var rowKey = _this.getRecordKey(row, i);
                    var checkboxProps = _this.getCheckboxPropsByItem(row, i);
                    if (!checkboxProps.disabled) {
                        if (selectedRowKeys.includes(rowKey)) {
                            if (!checked) {
                                selectedRowKeys = selectedRowKeys.filter(function (j) {
                                    return rowKey !== j;
                                });
                                changeRowKeys.push(rowKey);
                            }
                        } else if (checked) {
                            selectedRowKeys.push(rowKey);
                            changeRowKeys.push(rowKey);
                        }
                    }
                };

                while (step <= dist) {
                    _loop();
                }
                _this.setState({ pivot: realIndex });
                _this.store.setState({
                    selectionDirty: true
                });
                _this.setSelectedRowKeys(selectedRowKeys, {
                    selectWay: 'onSelectMultiple',
                    record: record,
                    checked: checked,
                    changeRowKeys: changeRowKeys,
                    nativeEvent: nativeEvent
                });
            } else {
                if (checked) {
                    selectedRowKeys.push(_this.getRecordKey(record, realIndex));
                } else {
                    selectedRowKeys = selectedRowKeys.filter(function (i) {
                        return key !== i;
                    });
                }
                _this.setState({ pivot: realIndex });
                _this.store.setState({
                    selectionDirty: true
                });
                _this.setSelectedRowKeys(selectedRowKeys, {
                    selectWay: 'onSelect',
                    record: record,
                    checked: checked,
                    changeRowKeys: void 0,
                    nativeEvent: nativeEvent
                });
            }
        };
        _this.handleRadioSelect = function (record, rowIndex, e) {
            var checked = e.target.checked;
            var nativeEvent = e.nativeEvent;
            var defaultSelection = _this.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
            var selectedRowKeys = _this.store.getState().selectedRowKeys.concat(defaultSelection);
            var key = _this.getRecordKey(record, rowIndex);
            selectedRowKeys = [key];
            _this.store.setState({
                selectionDirty: true
            });
            _this.setSelectedRowKeys(selectedRowKeys, {
                selectWay: 'onSelect',
                record: record,
                checked: checked,
                changeRowKeys: void 0,
                nativeEvent: nativeEvent
            });
        };
        _this.handleSelectRow = function (selectionKey, index, onSelectFunc) {
            var data = _this.getFlatCurrentPageData();
            var defaultSelection = _this.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
            var selectedRowKeys = _this.store.getState().selectedRowKeys.concat(defaultSelection);
            var changeableRowKeys = data.filter(function (item, i) {
                return !_this.getCheckboxPropsByItem(item, i).disabled;
            }).map(function (item, i) {
                return _this.getRecordKey(item, i);
            });
            var changeRowKeys = [];
            var selectWay = 'onSelectAll';
            var checked = void 0;
            // handle default selection
            switch (selectionKey) {
                case 'all':
                    changeableRowKeys.forEach(function (key) {
                        if (selectedRowKeys.indexOf(key) < 0) {
                            selectedRowKeys.push(key);
                            changeRowKeys.push(key);
                        }
                    });
                    selectWay = 'onSelectAll';
                    checked = true;
                    break;
                case 'removeAll':
                    changeableRowKeys.forEach(function (key) {
                        if (selectedRowKeys.indexOf(key) >= 0) {
                            selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
                            changeRowKeys.push(key);
                        }
                    });
                    selectWay = 'onSelectAll';
                    checked = false;
                    break;
                case 'invert':
                    changeableRowKeys.forEach(function (key) {
                        if (selectedRowKeys.indexOf(key) < 0) {
                            selectedRowKeys.push(key);
                        } else {
                            selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
                        }
                        changeRowKeys.push(key);
                        selectWay = 'onSelectInvert';
                    });
                    break;
                default:
                    break;
            }
            _this.store.setState({
                selectionDirty: true
            });
            // when select custom selection, callback selections[n].onSelect
            var rowSelection = _this.props.rowSelection;

            var customSelectionStartIndex = 2;
            if (rowSelection && rowSelection.hideDefaultSelections) {
                customSelectionStartIndex = 0;
            }
            if (index >= customSelectionStartIndex && typeof onSelectFunc === 'function') {
                return onSelectFunc(changeableRowKeys);
            }
            _this.setSelectedRowKeys(selectedRowKeys, {
                selectWay: selectWay,
                checked: checked,
                changeRowKeys: changeRowKeys
            });
        };
        _this.handlePageChange = function (current) {
            for (var _len = arguments.length, otherArguments = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                otherArguments[_key - 1] = arguments[_key];
            }

            var props = _this.props;
            var pagination = (0, _extends5['default'])({}, _this.state.pagination);
            if (current) {
                pagination.current = current;
            } else {
                pagination.current = pagination.current || 1;
            }
            pagination.onChange.apply(pagination, [pagination.current].concat(otherArguments));
            var newState = {
                pagination: pagination
            };
            // Controlled current prop will not respond user interaction
            if (props.pagination && (0, _typeof3['default'])(props.pagination) === 'object' && 'current' in props.pagination) {
                newState.pagination = (0, _extends5['default'])({}, pagination, { current: _this.state.pagination.current });
            }
            _this.setState(newState);
            _this.store.setState({
                selectionDirty: false
            });
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange.apply(null, _this.prepareParamsArguments((0, _extends5['default'])({}, _this.state, { selectionDirty: false, pagination: pagination })));
            }
        };
        _this.renderSelectionBox = function (type) {
            return function (_, record, index) {
                var rowKey = _this.getRecordKey(record, index);
                var props = _this.getCheckboxPropsByItem(record, index);
                var handleChange = function handleChange(e) {
                    type === 'radio' ? _this.handleRadioSelect(record, index, e) : _this.handleSelect(record, index, e);
                };
                return React.createElement(
                    'span',
                    { onClick: stopPropagation },
                    React.createElement(_SelectionBox2['default'], (0, _extends5['default'])({ type: type, store: _this.store, rowIndex: rowKey, onChange: handleChange, defaultSelection: _this.getDefaultSelection() }, props))
                );
            };
        };
        _this.getRecordKey = function (record, index) {
            var rowKey = _this.props.rowKey;
            var recordKey = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
            (0, _warning2['default'])(recordKey !== undefined, 'Each record in dataSource of table should have a unique `key` prop, ' + 'or set `rowKey` of Table to an unique primary key, ' + 'see https://u.ant.design/table-row-key');
            return recordKey === undefined ? index : recordKey;
        };
        _this.getPopupContainer = function () {
            return ReactDOM.findDOMNode(_this);
        };
        _this.handleShowSizeChange = function (current, pageSize) {
            var pagination = _this.state.pagination;
            pagination.onShowSizeChange(current, pageSize);
            var nextPagination = (0, _extends5['default'])({}, pagination, { pageSize: pageSize,
                current: current });
            _this.setState({ pagination: nextPagination });
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange.apply(null, _this.prepareParamsArguments((0, _extends5['default'])({}, _this.state, { pagination: nextPagination })));
            }
        };
        _this.renderTable = function (contextLocale, loading) {
            var _classNames;

            var locale = (0, _extends5['default'])({}, contextLocale, _this.props.locale);
            var _a = _this.props,
                style = _a.style,
                className = _a.className,
                prefixCls = _a.prefixCls,
                showHeader = _a.showHeader,
                restProps = __rest(_a, ["style", "className", "prefixCls", "showHeader"]);
            var data = _this.getCurrentPageData();
            var expandIconAsCell = _this.props.expandedRowRender && _this.props.expandIconAsCell !== false;
            var classString = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + _this.props.size, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-bordered', _this.props.bordered), (0, _defineProperty3['default'])(_classNames, prefixCls + '-empty', !data.length), (0, _defineProperty3['default'])(_classNames, prefixCls + '-without-column-header', !showHeader), _classNames));
            var columns = _this.renderRowSelection(locale);
            columns = _this.renderColumnsDropdown(columns, locale);
            columns = columns.map(function (column, i) {
                var newColumn = (0, _extends5['default'])({}, column);
                newColumn.key = _this.getColumnKey(newColumn, i);
                return newColumn;
            });
            var expandIconColumnIndex = columns[0] && columns[0].key === 'selection-column' ? 1 : 0;
            if ('expandIconColumnIndex' in restProps) {
                expandIconColumnIndex = restProps.expandIconColumnIndex;
            }
            return React.createElement(_rcTable2['default'], (0, _extends5['default'])({ key: 'table' }, restProps, { onRow: _this.onRow, components: _this.components, prefixCls: prefixCls, data: data, columns: columns, showHeader: showHeader, className: classString, expandIconColumnIndex: expandIconColumnIndex, expandIconAsCell: expandIconAsCell, emptyText: !loading.spinning && locale.emptyText }));
        };
        (0, _warning2['default'])(!('columnsPageRange' in props || 'columnsPageSize' in props), '`columnsPageRange` and `columnsPageSize` are removed, please use ' + 'fixed columns instead, see: https://u.ant.design/fixed-columns.');
        _this.columns = props.columns || (0, _util.normalizeColumns)(props.children);
        _this.createComponents(props.components);
        _this.state = (0, _extends5['default'])({}, _this.getDefaultSortOrder(_this.columns), {
            // 减少状态
            filters: _this.getFiltersFromColumns(), pagination: _this.getDefaultPagination(props), pivot: undefined });
        _this.CheckboxPropsCache = {};
        _this.store = (0, _createStore2['default'])({
            selectedRowKeys: getRowSelection(props).selectedRowKeys || [],
            selectionDirty: false
        });
        return _this;
    }

    (0, _createClass3['default'])(Table, [{
        key: 'getDefaultSelection',
        value: function getDefaultSelection() {
            var _this2 = this;

            var rowSelection = getRowSelection(this.props);
            if (!rowSelection.getCheckboxProps) {
                return [];
            }
            return this.getFlatData().filter(function (item, rowIndex) {
                return _this2.getCheckboxPropsByItem(item, rowIndex).defaultChecked;
            }).map(function (record, rowIndex) {
                return _this2.getRecordKey(record, rowIndex);
            });
        }
    }, {
        key: 'getDefaultPagination',
        value: function getDefaultPagination(props) {
            var pagination = props.pagination || {};
            return this.hasPagination(props) ? (0, _extends5['default'])({}, defaultPagination, pagination, { current: pagination.defaultCurrent || pagination.current || 1, pageSize: pagination.defaultPageSize || pagination.pageSize || 10 }) : {};
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.columns = nextProps.columns || (0, _util.normalizeColumns)(nextProps.children);
            if ('pagination' in nextProps || 'pagination' in this.props) {
                this.setState(function (previousState) {
                    var newPagination = (0, _extends5['default'])({}, defaultPagination, previousState.pagination, nextProps.pagination);
                    newPagination.current = newPagination.current || 1;
                    newPagination.pageSize = newPagination.pageSize || 10;
                    return { pagination: nextProps.pagination !== false ? newPagination : emptyObject };
                });
            }
            if (nextProps.rowSelection && 'selectedRowKeys' in nextProps.rowSelection) {
                this.store.setState({
                    selectedRowKeys: nextProps.rowSelection.selectedRowKeys || []
                });
            }
            if ('dataSource' in nextProps && nextProps.dataSource !== this.props.dataSource) {
                this.store.setState({
                    selectionDirty: false
                });
            }
            // https://github.com/ant-design/ant-design/issues/10133
            this.CheckboxPropsCache = {};
            if (this.getSortOrderColumns(this.columns).length > 0) {
                var sortState = this.getSortStateFromColumns(this.columns);
                if (sortState.sortColumn !== this.state.sortColumn || sortState.sortOrder !== this.state.sortOrder) {
                    this.setState(sortState);
                }
            }
            var filteredValueColumns = this.getFilteredValueColumns(this.columns);
            if (filteredValueColumns.length > 0) {
                var filtersFromColumns = this.getFiltersFromColumns(this.columns);
                var newFilters = (0, _extends5['default'])({}, this.state.filters);
                Object.keys(filtersFromColumns).forEach(function (key) {
                    newFilters[key] = filtersFromColumns[key];
                });
                if (this.isFiltersChanged(newFilters)) {
                    this.setState({ filters: newFilters });
                }
            }
            this.createComponents(nextProps.components, this.props.components);
        }
    }, {
        key: 'setSelectedRowKeys',
        value: function setSelectedRowKeys(selectedRowKeys, selectionInfo) {
            var _this3 = this;

            var selectWay = selectionInfo.selectWay,
                record = selectionInfo.record,
                checked = selectionInfo.checked,
                changeRowKeys = selectionInfo.changeRowKeys,
                nativeEvent = selectionInfo.nativeEvent;

            var rowSelection = getRowSelection(this.props);
            if (rowSelection && !('selectedRowKeys' in rowSelection)) {
                this.store.setState({ selectedRowKeys: selectedRowKeys });
            }
            var data = this.getFlatData();
            if (!rowSelection.onChange && !rowSelection[selectWay]) {
                return;
            }
            var selectedRows = data.filter(function (row, i) {
                return selectedRowKeys.indexOf(_this3.getRecordKey(row, i)) >= 0;
            });
            if (rowSelection.onChange) {
                rowSelection.onChange(selectedRowKeys, selectedRows);
            }
            if (selectWay === 'onSelect' && rowSelection.onSelect) {
                rowSelection.onSelect(record, checked, selectedRows, nativeEvent);
            } else if (selectWay === 'onSelectMultiple' && rowSelection.onSelectMultiple) {
                var changeRows = data.filter(function (row, i) {
                    return changeRowKeys.indexOf(_this3.getRecordKey(row, i)) >= 0;
                });
                rowSelection.onSelectMultiple(checked, selectedRows, changeRows);
            } else if (selectWay === 'onSelectAll' && rowSelection.onSelectAll) {
                var _changeRows = data.filter(function (row, i) {
                    return changeRowKeys.indexOf(_this3.getRecordKey(row, i)) >= 0;
                });
                rowSelection.onSelectAll(checked, selectedRows, _changeRows);
            } else if (selectWay === 'onSelectInvert' && rowSelection.onSelectInvert) {
                rowSelection.onSelectInvert(selectedRowKeys);
            }
        }
    }, {
        key: 'hasPagination',
        value: function hasPagination(props) {
            return (props || this.props).pagination !== false;
        }
    }, {
        key: 'isFiltersChanged',
        value: function isFiltersChanged(filters) {
            var _this4 = this;

            var filtersChanged = false;
            if (Object.keys(filters).length !== Object.keys(this.state.filters).length) {
                filtersChanged = true;
            } else {
                Object.keys(filters).forEach(function (columnKey) {
                    if (filters[columnKey] !== _this4.state.filters[columnKey]) {
                        filtersChanged = true;
                    }
                });
            }
            return filtersChanged;
        }
    }, {
        key: 'getSortOrderColumns',
        value: function getSortOrderColumns(columns) {
            return (0, _util.flatFilter)(columns || this.columns || [], function (column) {
                return 'sortOrder' in column;
            });
        }
    }, {
        key: 'getFilteredValueColumns',
        value: function getFilteredValueColumns(columns) {
            return (0, _util.flatFilter)(columns || this.columns || [], function (column) {
                return typeof column.filteredValue !== 'undefined';
            });
        }
    }, {
        key: 'getFiltersFromColumns',
        value: function getFiltersFromColumns(columns) {
            var _this5 = this;

            var filters = {};
            this.getFilteredValueColumns(columns).forEach(function (col) {
                var colKey = _this5.getColumnKey(col);
                filters[colKey] = col.filteredValue;
            });
            return filters;
        }
    }, {
        key: 'getDefaultSortOrder',
        value: function getDefaultSortOrder(columns) {
            var definedSortState = this.getSortStateFromColumns(columns);
            var defaultSortedColumn = (0, _util.flatFilter)(columns || [], function (column) {
                return column.defaultSortOrder != null;
            })[0];
            if (defaultSortedColumn && !definedSortState.sortColumn) {
                return {
                    sortColumn: defaultSortedColumn,
                    sortOrder: defaultSortedColumn.defaultSortOrder
                };
            }
            return definedSortState;
        }
    }, {
        key: 'getSortStateFromColumns',
        value: function getSortStateFromColumns(columns) {
            // return first column which sortOrder is not falsy
            var sortedColumn = this.getSortOrderColumns(columns).filter(function (col) {
                return col.sortOrder;
            })[0];
            if (sortedColumn) {
                return {
                    sortColumn: sortedColumn,
                    sortOrder: sortedColumn.sortOrder
                };
            }
            return {
                sortColumn: null,
                sortOrder: null
            };
        }
    }, {
        key: 'getSorterFn',
        value: function getSorterFn() {
            var _state = this.state,
                sortOrder = _state.sortOrder,
                sortColumn = _state.sortColumn;

            if (!sortOrder || !sortColumn || typeof sortColumn.sorter !== 'function') {
                return;
            }
            return function (a, b) {
                var result = sortColumn.sorter(a, b, sortOrder);
                if (result !== 0) {
                    return sortOrder === 'descend' ? -result : result;
                }
                return 0;
            };
        }
    }, {
        key: 'toggleSortOrder',
        value: function toggleSortOrder(order, column) {
            var _state2 = this.state,
                sortColumn = _state2.sortColumn,
                sortOrder = _state2.sortOrder;
            // 只同时允许一列进行排序，否则会导致排序顺序的逻辑问题

            var isSortColumn = this.isSortColumn(column);
            if (!isSortColumn) {
                // 当前列未排序
                sortOrder = order;
                sortColumn = column;
            } else {
                // 当前列已排序
                if (sortOrder === order) {
                    // 切换为未排序状态
                    sortOrder = undefined;
                    sortColumn = null;
                } else {
                    // 切换为排序状态
                    sortOrder = order;
                }
            }
            var newState = {
                sortOrder: sortOrder,
                sortColumn: sortColumn
            };
            // Controlled
            if (this.getSortOrderColumns().length === 0) {
                this.setState(newState);
            }
            var onChange = this.props.onChange;
            if (onChange) {
                onChange.apply(null, this.prepareParamsArguments((0, _extends5['default'])({}, this.state, newState)));
            }
        }
    }, {
        key: 'renderRowSelection',
        value: function renderRowSelection(locale) {
            var _this6 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                rowSelection = _props.rowSelection;

            var columns = this.columns.concat();
            if (rowSelection) {
                var data = this.getFlatCurrentPageData().filter(function (item, index) {
                    if (rowSelection.getCheckboxProps) {
                        return !_this6.getCheckboxPropsByItem(item, index).disabled;
                    }
                    return true;
                });
                var selectionColumnClass = (0, _classnames2['default'])(prefixCls + '-selection-column', (0, _defineProperty3['default'])({}, prefixCls + '-selection-column-custom', rowSelection.selections));
                var selectionColumn = {
                    key: 'selection-column',
                    render: this.renderSelectionBox(rowSelection.type),
                    className: selectionColumnClass,
                    fixed: rowSelection.fixed,
                    width: rowSelection.columnWidth,
                    title: rowSelection.columnTitle
                };
                if (rowSelection.type !== 'radio') {
                    var checkboxAllDisabled = data.every(function (item, index) {
                        return _this6.getCheckboxPropsByItem(item, index).disabled;
                    });
                    selectionColumn.title = selectionColumn.title || React.createElement(_SelectionCheckboxAll2['default'], { store: this.store, locale: locale, data: data, getCheckboxPropsByItem: this.getCheckboxPropsByItem, getRecordKey: this.getRecordKey, disabled: checkboxAllDisabled, prefixCls: prefixCls, onSelect: this.handleSelectRow, selections: rowSelection.selections, hideDefaultSelections: rowSelection.hideDefaultSelections, getPopupContainer: this.getPopupContainer });
                }
                if ('fixed' in rowSelection) {
                    selectionColumn.fixed = rowSelection.fixed;
                } else if (columns.some(function (column) {
                    return column.fixed === 'left' || column.fixed === true;
                })) {
                    selectionColumn.fixed = 'left';
                }
                if (columns[0] && columns[0].key === 'selection-column') {
                    columns[0] = selectionColumn;
                } else {
                    columns.unshift(selectionColumn);
                }
            }
            return columns;
        }
    }, {
        key: 'getColumnKey',
        value: function getColumnKey(column, index) {
            return column.key || column.dataIndex || index;
        }
    }, {
        key: 'getMaxCurrent',
        value: function getMaxCurrent(total) {
            var _state$pagination = this.state.pagination,
                current = _state$pagination.current,
                pageSize = _state$pagination.pageSize;

            if ((current - 1) * pageSize >= total) {
                return Math.floor((total - 1) / pageSize) + 1;
            }
            return current;
        }
    }, {
        key: 'isSortColumn',
        value: function isSortColumn(column) {
            var sortColumn = this.state.sortColumn;

            if (!column || !sortColumn) {
                return false;
            }
            return this.getColumnKey(sortColumn) === this.getColumnKey(column);
        }
    }, {
        key: 'renderColumnsDropdown',
        value: function renderColumnsDropdown(columns, locale) {
            var _this7 = this;

            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                dropdownPrefixCls = _props2.dropdownPrefixCls;
            var sortOrder = this.state.sortOrder;

            return (0, _util.treeMap)(columns, function (originColumn, i) {
                var column = (0, _extends5['default'])({}, originColumn);
                var key = _this7.getColumnKey(column, i);
                var filterDropdown = void 0;
                var sortButton = void 0;
                if (column.filters && column.filters.length > 0 || column.filterDropdown) {
                    var colFilters = _this7.state.filters[key] || [];
                    filterDropdown = React.createElement(_filterDropdown2['default'], { locale: locale, column: column, selectedKeys: colFilters, confirmFilter: _this7.handleFilter, prefixCls: prefixCls + '-filter', dropdownPrefixCls: dropdownPrefixCls || 'ant-dropdown', getPopupContainer: _this7.getPopupContainer });
                }
                if (column.sorter) {
                    var isSortColumn = _this7.isSortColumn(column);
                    if (isSortColumn) {
                        column.className = (0, _classnames2['default'])(column.className, (0, _defineProperty3['default'])({}, prefixCls + '-column-sort', sortOrder));
                    }
                    var isAscend = isSortColumn && sortOrder === 'ascend';
                    var isDescend = isSortColumn && sortOrder === 'descend';
                    sortButton = React.createElement(
                        'div',
                        { className: prefixCls + '-column-sorter' },
                        React.createElement(
                            'span',
                            { className: prefixCls + '-column-sorter-up ' + (isAscend ? 'on' : 'off'), title: '\u2191', onClick: function onClick() {
                                    return _this7.toggleSortOrder('ascend', column);
                                } },
                            React.createElement(_icon2['default'], { type: 'caret-up' })
                        ),
                        React.createElement(
                            'span',
                            { className: prefixCls + '-column-sorter-down ' + (isDescend ? 'on' : 'off'), title: '\u2193', onClick: function onClick() {
                                    return _this7.toggleSortOrder('descend', column);
                                } },
                            React.createElement(_icon2['default'], { type: 'caret-down' })
                        )
                    );
                }
                column.title = React.createElement(
                    'span',
                    { key: key },
                    column.title,
                    sortButton,
                    filterDropdown
                );
                if (sortButton || filterDropdown) {
                    column.className = (0, _classnames2['default'])(prefixCls + '-column-has-filters', column.className);
                }
                return column;
            });
        }
    }, {
        key: 'renderPagination',
        value: function renderPagination(paginationPosition) {
            // 强制不需要分页
            if (!this.hasPagination()) {
                return null;
            }
            var size = 'default';
            var pagination = this.state.pagination;

            if (pagination.size) {
                size = pagination.size;
            } else if (this.props.size === 'middle' || this.props.size === 'small') {
                size = 'small';
            }
            var position = pagination.position || 'bottom';
            var total = pagination.total || this.getLocalData().length;
            return total > 0 && (position === paginationPosition || position === 'both') ? React.createElement(_pagination2['default'], (0, _extends5['default'])({ key: 'pagination-' + paginationPosition }, pagination, { className: (0, _classnames2['default'])(pagination.className, this.props.prefixCls + '-pagination'), onChange: this.handlePageChange, total: total, size: size, current: this.getMaxCurrent(total), onShowSizeChange: this.handleShowSizeChange })) : null;
        }
        // Get pagination, filters, sorter

    }, {
        key: 'prepareParamsArguments',
        value: function prepareParamsArguments(state) {
            var pagination = (0, _extends5['default'])({}, state.pagination);
            // remove useless handle function in Table.onChange
            delete pagination.onChange;
            delete pagination.onShowSizeChange;
            var filters = state.filters;
            var sorter = {};
            if (state.sortColumn && state.sortOrder) {
                sorter.column = state.sortColumn;
                sorter.order = state.sortOrder;
                sorter.field = state.sortColumn.dataIndex;
                sorter.columnKey = this.getColumnKey(state.sortColumn);
            }
            return [pagination, filters, sorter];
        }
    }, {
        key: 'findColumn',
        value: function findColumn(myKey) {
            var _this8 = this;

            var column = void 0;
            (0, _util.treeMap)(this.columns, function (c) {
                if (_this8.getColumnKey(c) === myKey) {
                    column = c;
                }
            });
            return column;
        }
    }, {
        key: 'getCurrentPageData',
        value: function getCurrentPageData() {
            var data = this.getLocalData();
            var current = void 0;
            var pageSize = void 0;
            var state = this.state;
            // 如果没有分页的话，默认全部展示
            if (!this.hasPagination()) {
                pageSize = Number.MAX_VALUE;
                current = 1;
            } else {
                pageSize = state.pagination.pageSize;
                current = this.getMaxCurrent(state.pagination.total || data.length);
            }
            // 分页
            // ---
            // 当数据量少于等于每页数量时，直接设置数据
            // 否则进行读取分页数据
            if (data.length > pageSize || pageSize === Number.MAX_VALUE) {
                data = data.filter(function (_, i) {
                    return i >= (current - 1) * pageSize && i < current * pageSize;
                });
            }
            return data;
        }
    }, {
        key: 'getFlatData',
        value: function getFlatData() {
            return (0, _util.flatArray)(this.getLocalData());
        }
    }, {
        key: 'getFlatCurrentPageData',
        value: function getFlatCurrentPageData() {
            return (0, _util.flatArray)(this.getCurrentPageData());
        }
    }, {
        key: 'recursiveSort',
        value: function recursiveSort(data, sorterFn) {
            var _this9 = this;

            var _props$childrenColumn = this.props.childrenColumnName,
                childrenColumnName = _props$childrenColumn === undefined ? 'children' : _props$childrenColumn;

            return data.sort(sorterFn).map(function (item) {
                return item[childrenColumnName] ? (0, _extends5['default'])({}, item, (0, _defineProperty3['default'])({}, childrenColumnName, _this9.recursiveSort(item[childrenColumnName], sorterFn))) : item;
            });
        }
    }, {
        key: 'getLocalData',
        value: function getLocalData() {
            var _this10 = this;

            var state = this.state;
            var dataSource = this.props.dataSource;

            var data = dataSource || [];
            // 优化本地排序
            data = data.slice(0);
            var sorterFn = this.getSorterFn();
            if (sorterFn) {
                data = this.recursiveSort(data, sorterFn);
            }
            // 筛选
            if (state.filters) {
                Object.keys(state.filters).forEach(function (columnKey) {
                    var col = _this10.findColumn(columnKey);
                    if (!col) {
                        return;
                    }
                    var values = state.filters[columnKey] || [];
                    if (values.length === 0) {
                        return;
                    }
                    var onFilter = col.onFilter;
                    data = onFilter ? data.filter(function (record) {
                        return values.some(function (v) {
                            return onFilter(v, record);
                        });
                    }) : data;
                });
            }
            return data;
        }
    }, {
        key: 'createComponents',
        value: function createComponents() {
            var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var prevComponents = arguments[1];

            var bodyRow = components && components.body && components.body.row;
            var preBodyRow = prevComponents && prevComponents.body && prevComponents.body.row;
            if (!this.row || bodyRow !== preBodyRow) {
                this.row = (0, _createBodyRow2['default'])(bodyRow);
            }
            this.components = (0, _extends5['default'])({}, components, { body: (0, _extends5['default'])({}, components.body, { row: this.row }) });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this11 = this;

            var _props3 = this.props,
                style = _props3.style,
                className = _props3.className,
                prefixCls = _props3.prefixCls;

            var data = this.getCurrentPageData();
            var loading = this.props.loading;
            if (typeof loading === 'boolean') {
                loading = {
                    spinning: loading
                };
            }
            var table = React.createElement(
                _LocaleReceiver2['default'],
                { componentName: 'Table', defaultLocale: _default2['default'].Table },
                function (locale) {
                    return _this11.renderTable(locale, loading);
                }
            );
            // if there is no pagination or no data,
            // the height of spin should decrease by half of pagination
            var paginationPatchClass = this.hasPagination() && data && data.length !== 0 ? prefixCls + '-with-pagination' : prefixCls + '-without-pagination';
            return React.createElement(
                'div',
                { className: (0, _classnames2['default'])(prefixCls + '-wrapper', className), style: style },
                React.createElement(
                    _spin2['default'],
                    (0, _extends5['default'])({}, loading, { className: loading.spinning ? paginationPatchClass + ' ' + prefixCls + '-spin-holder' : '' }),
                    this.renderPagination('top'),
                    table,
                    this.renderPagination('bottom')
                )
            );
        }
    }]);
    return Table;
}(React.Component);

exports['default'] = Table;

Table.Column = _Column2['default'];
Table.ColumnGroup = _ColumnGroup2['default'];
Table.propTypes = {
    dataSource: _propTypes2['default'].array,
    columns: _propTypes2['default'].array,
    prefixCls: _propTypes2['default'].string,
    useFixedHeader: _propTypes2['default'].bool,
    rowSelection: _propTypes2['default'].object,
    className: _propTypes2['default'].string,
    size: _propTypes2['default'].string,
    loading: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].object]),
    bordered: _propTypes2['default'].bool,
    onChange: _propTypes2['default'].func,
    locale: _propTypes2['default'].object,
    dropdownPrefixCls: _propTypes2['default'].string
};
Table.defaultProps = {
    dataSource: [],
    prefixCls: 'ant-table',
    useFixedHeader: false,
    className: '',
    size: 'default',
    loading: false,
    bordered: false,
    indentSize: 20,
    locale: {},
    rowKey: 'key',
    showHeader: true
};
module.exports = exports['default'];

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Column__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColumnGroup__ = __webpack_require__(809);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Column", function() { return __WEBPACK_IMPORTED_MODULE_1__Column__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ColumnGroup", function() { return __WEBPACK_IMPORTED_MODULE_2__ColumnGroup__["a"]; });




__WEBPACK_IMPORTED_MODULE_0__Table__["a" /* default */].Column = __WEBPACK_IMPORTED_MODULE_1__Column__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Table__["a" /* default */].ColumnGroup = __WEBPACK_IMPORTED_MODULE_2__ColumnGroup__["a" /* default */];

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Table__["a" /* default */]);


/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shallowequal__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mini_store__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_merge__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_component_classes__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_component_classes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_lifecycles_compat__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ColumnManager__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HeadTable__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__BodyTable__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ExpandableTable__ = __webpack_require__(807);



















var Table = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Table, _React$Component);

  function Table(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Table);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

    _this.state = {};

    _this.getRowKey = function (record, index) {
      var rowKey = _this.props.rowKey;
      var key = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
      Object(__WEBPACK_IMPORTED_MODULE_13__utils__["d" /* warningOnce */])(key !== undefined, 'Each record in table should have a unique `key` prop,' + 'or set `rowKey` to an unique primary key.');
      return key === undefined ? index : key;
    };

    _this.handleWindowResize = function () {
      _this.syncFixedTableRowHeight();
      _this.setScrollPositionClassName();
    };

    _this.syncFixedTableRowHeight = function () {
      var tableRect = _this.tableNode.getBoundingClientRect();
      // If tableNode's height less than 0, suppose it is hidden and don't recalculate rowHeight.
      // see: https://github.com/ant-design/ant-design/issues/4836
      if (tableRect.height !== undefined && tableRect.height <= 0) {
        return;
      }
      var prefixCls = _this.props.prefixCls;

      var headRows = _this.headTable ? _this.headTable.querySelectorAll('thead') : _this.bodyTable.querySelectorAll('thead');
      var bodyRows = _this.bodyTable.querySelectorAll('.' + prefixCls + '-row') || [];
      var fixedColumnsHeadRowsHeight = [].map.call(headRows, function (row) {
        return row.getBoundingClientRect().height || 'auto';
      });
      var state = _this.store.getState();
      var fixedColumnsBodyRowsHeight = [].reduce.call(bodyRows, function (acc, row) {
        var rowKey = row.getAttribute('data-row-key');
        var height = row.getBoundingClientRect().height || state.fixedColumnsBodyRowsHeight[rowKey] || 'auto';
        acc[rowKey] = height;
        return acc;
      }, {});
      if (__WEBPACK_IMPORTED_MODULE_7_shallowequal___default()(state.fixedColumnsHeadRowsHeight, fixedColumnsHeadRowsHeight) && __WEBPACK_IMPORTED_MODULE_7_shallowequal___default()(state.fixedColumnsBodyRowsHeight, fixedColumnsBodyRowsHeight)) {
        return;
      }

      _this.store.setState({
        fixedColumnsHeadRowsHeight: fixedColumnsHeadRowsHeight,
        fixedColumnsBodyRowsHeight: fixedColumnsBodyRowsHeight
      });
    };

    _this.handleBodyScrollLeft = function (e) {
      // Fix https://github.com/ant-design/ant-design/issues/7635
      if (e.currentTarget !== e.target) {
        return;
      }
      var target = e.target;
      var _this$props$scroll = _this.props.scroll,
          scroll = _this$props$scroll === undefined ? {} : _this$props$scroll;
      var headTable = _this.headTable,
          bodyTable = _this.bodyTable;

      if (target.scrollLeft !== _this.lastScrollLeft && scroll.x) {
        if (target === bodyTable && headTable) {
          headTable.scrollLeft = target.scrollLeft;
        } else if (target === headTable && bodyTable) {
          bodyTable.scrollLeft = target.scrollLeft;
        }
        _this.setScrollPositionClassName();
      }
      // Remember last scrollLeft for scroll direction detecting.
      _this.lastScrollLeft = target.scrollLeft;
    };

    _this.handleBodyScrollTop = function (e) {
      var target = e.target;
      // Fix https://github.com/ant-design/ant-design/issues/9033
      if (e.currentTarget !== target) {
        return;
      }
      var _this$props$scroll2 = _this.props.scroll,
          scroll = _this$props$scroll2 === undefined ? {} : _this$props$scroll2;
      var headTable = _this.headTable,
          bodyTable = _this.bodyTable,
          fixedColumnsBodyLeft = _this.fixedColumnsBodyLeft,
          fixedColumnsBodyRight = _this.fixedColumnsBodyRight;

      if (target.scrollTop !== _this.lastScrollTop && scroll.y && target !== headTable) {
        var scrollTop = target.scrollTop;
        if (fixedColumnsBodyLeft && target !== fixedColumnsBodyLeft) {
          fixedColumnsBodyLeft.scrollTop = scrollTop;
        }
        if (fixedColumnsBodyRight && target !== fixedColumnsBodyRight) {
          fixedColumnsBodyRight.scrollTop = scrollTop;
        }
        if (bodyTable && target !== bodyTable) {
          bodyTable.scrollTop = scrollTop;
        }
      }
      // Remember last scrollTop for scroll direction detecting.
      _this.lastScrollTop = target.scrollTop;
    };

    _this.handleBodyScroll = function (e) {
      _this.handleBodyScrollLeft(e);
      _this.handleBodyScrollTop(e);
    };

    _this.handleWheel = function (event) {
      var _this$props$scroll3 = _this.props.scroll,
          scroll = _this$props$scroll3 === undefined ? {} : _this$props$scroll3;

      if (window.navigator.userAgent.match(/Trident\/7\./) && scroll.y) {
        event.preventDefault();
        var wd = event.deltaY;
        var target = event.target;
        var bodyTable = _this.bodyTable,
            fixedColumnsBodyLeft = _this.fixedColumnsBodyLeft,
            fixedColumnsBodyRight = _this.fixedColumnsBodyRight;

        var scrollTop = 0;

        if (_this.lastScrollTop) {
          scrollTop = _this.lastScrollTop + wd;
        } else {
          scrollTop = wd;
        }

        if (fixedColumnsBodyLeft && target !== fixedColumnsBodyLeft) {
          fixedColumnsBodyLeft.scrollTop = scrollTop;
        }
        if (fixedColumnsBodyRight && target !== fixedColumnsBodyRight) {
          fixedColumnsBodyRight.scrollTop = scrollTop;
        }
        if (bodyTable && target !== bodyTable) {
          bodyTable.scrollTop = scrollTop;
        }
      }
    };

    _this.saveRef = function (name) {
      return function (node) {
        _this[name] = node;
      };
    };

    ['onRowClick', 'onRowDoubleClick', 'onRowContextMenu', 'onRowMouseEnter', 'onRowMouseLeave'].forEach(function (name) {
      Object(__WEBPACK_IMPORTED_MODULE_13__utils__["d" /* warningOnce */])(props[name] === undefined, name + ' is deprecated, please use onRow instead.');
    });

    Object(__WEBPACK_IMPORTED_MODULE_13__utils__["d" /* warningOnce */])(props.getBodyWrapper === undefined, 'getBodyWrapper is deprecated, please use custom components instead.');

    _this.columnManager = new __WEBPACK_IMPORTED_MODULE_14__ColumnManager__["a" /* default */](props.columns, props.children);

    _this.store = Object(__WEBPACK_IMPORTED_MODULE_9_mini_store__["create"])({
      currentHoverKey: null,
      fixedColumnsHeadRowsHeight: [],
      fixedColumnsBodyRowsHeight: {}
    });

    _this.setScrollPosition('left');

    _this.debouncedWindowResize = Object(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* debounce */])(_this.handleWindowResize, 150);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Table, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        table: {
          props: this.props,
          columnManager: this.columnManager,
          saveRef: this.saveRef,
          components: __WEBPACK_IMPORTED_MODULE_10_lodash_merge___default()({
            table: 'table',
            header: {
              wrapper: 'thead',
              row: 'tr',
              cell: 'th'
            },
            body: {
              wrapper: 'tbody',
              row: 'tr',
              cell: 'td'
            }
          }, this.props.components)
        }
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.columnManager.isAnyColumnsFixed()) {
        this.handleWindowResize();
        this.resizeEvent = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.debouncedWindowResize);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.columnManager.isAnyColumnsFixed()) {
        this.handleWindowResize();
        if (!this.resizeEvent) {
          this.resizeEvent = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.debouncedWindowResize);
        }
      }
      // when table changes to empty, reset scrollLeft
      if (prevProps.data.length > 0 && this.props.data.length === 0 && this.hasScrollX()) {
        this.resetScrollX();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.resizeEvent) {
        this.resizeEvent.remove();
      }
      if (this.debouncedWindowResize) {
        this.debouncedWindowResize.cancel();
      }
    }
  }, {
    key: 'setScrollPosition',
    value: function setScrollPosition(position) {
      this.scrollPosition = position;
      if (this.tableNode) {
        var prefixCls = this.props.prefixCls;

        if (position === 'both') {
          __WEBPACK_IMPORTED_MODULE_11_component_classes___default()(this.tableNode).remove(new RegExp('^' + prefixCls + '-scroll-position-.+$')).add(prefixCls + '-scroll-position-left').add(prefixCls + '-scroll-position-right');
        } else {
          __WEBPACK_IMPORTED_MODULE_11_component_classes___default()(this.tableNode).remove(new RegExp('^' + prefixCls + '-scroll-position-.+$')).add(prefixCls + '-scroll-position-' + position);
        }
      }
    }
  }, {
    key: 'setScrollPositionClassName',
    value: function setScrollPositionClassName() {
      var node = this.bodyTable;
      var scrollToLeft = node.scrollLeft === 0;
      var scrollToRight = node.scrollLeft + 1 >= node.children[0].getBoundingClientRect().width - node.getBoundingClientRect().width;
      if (scrollToLeft && scrollToRight) {
        this.setScrollPosition('both');
      } else if (scrollToLeft) {
        this.setScrollPosition('left');
      } else if (scrollToRight) {
        this.setScrollPosition('right');
      } else if (this.scrollPosition !== 'middle') {
        this.setScrollPosition('middle');
      }
    }
  }, {
    key: 'resetScrollX',
    value: function resetScrollX() {
      if (this.headTable) {
        this.headTable.scrollLeft = 0;
      }
      if (this.bodyTable) {
        this.bodyTable.scrollLeft = 0;
      }
    }
  }, {
    key: 'hasScrollX',
    value: function hasScrollX() {
      var _props$scroll = this.props.scroll,
          scroll = _props$scroll === undefined ? {} : _props$scroll;

      return 'x' in scroll;
    }
  }, {
    key: 'renderMainTable',
    value: function renderMainTable() {
      var _props = this.props,
          scroll = _props.scroll,
          prefixCls = _props.prefixCls;

      var isAnyColumnsFixed = this.columnManager.isAnyColumnsFixed();
      var scrollable = isAnyColumnsFixed || scroll.x || scroll.y;

      var table = [this.renderTable({
        columns: this.columnManager.groupedColumns(),
        isAnyColumnsFixed: isAnyColumnsFixed
      }), this.renderEmptyText(), this.renderFooter()];

      return scrollable ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-scroll' },
        table
      ) : table;
    }
  }, {
    key: 'renderLeftFixedTable',
    value: function renderLeftFixedTable() {
      var prefixCls = this.props.prefixCls;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-fixed-left' },
        this.renderTable({
          columns: this.columnManager.leftColumns(),
          fixed: 'left'
        })
      );
    }
  }, {
    key: 'renderRightFixedTable',
    value: function renderRightFixedTable() {
      var prefixCls = this.props.prefixCls;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-fixed-right' },
        this.renderTable({
          columns: this.columnManager.rightColumns(),
          fixed: 'right'
        })
      );
    }
  }, {
    key: 'renderTable',
    value: function renderTable(options) {
      var columns = options.columns,
          fixed = options.fixed,
          isAnyColumnsFixed = options.isAnyColumnsFixed;
      var _props2 = this.props,
          prefixCls = _props2.prefixCls,
          _props2$scroll = _props2.scroll,
          scroll = _props2$scroll === undefined ? {} : _props2$scroll;

      var tableClassName = scroll.x || fixed ? prefixCls + '-fixed' : '';

      var headTable = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__HeadTable__["a" /* default */], {
        key: 'head',
        columns: columns,
        fixed: fixed,
        tableClassName: tableClassName,
        handleBodyScrollLeft: this.handleBodyScrollLeft,
        expander: this.expander
      });

      var bodyTable = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__BodyTable__["a" /* default */], {
        key: 'body',
        columns: columns,
        fixed: fixed,
        tableClassName: tableClassName,
        getRowKey: this.getRowKey,
        handleWheel: this.handleWheel,
        handleBodyScroll: this.handleBodyScroll,
        expander: this.expander,
        isAnyColumnsFixed: isAnyColumnsFixed
      });

      return [headTable, bodyTable];
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle() {
      var _props3 = this.props,
          title = _props3.title,
          prefixCls = _props3.prefixCls;

      return title ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-title', key: 'title' },
        title(this.props.data)
      ) : null;
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      var _props4 = this.props,
          footer = _props4.footer,
          prefixCls = _props4.prefixCls;

      return footer ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-footer', key: 'footer' },
        footer(this.props.data)
      ) : null;
    }
  }, {
    key: 'renderEmptyText',
    value: function renderEmptyText() {
      var _props5 = this.props,
          emptyText = _props5.emptyText,
          prefixCls = _props5.prefixCls,
          data = _props5.data;

      if (data.length) {
        return null;
      }
      var emptyClassName = prefixCls + '-placeholder';
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: emptyClassName, key: 'emptyText' },
        typeof emptyText === 'function' ? emptyText() : emptyText
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var prefixCls = props.prefixCls;

      if (this.state.columns) {
        this.columnManager.reset(props.columns);
      } else if (this.state.children) {
        this.columnManager.reset(null, props.children);
      }

      var className = props.prefixCls;
      if (props.className) {
        className += ' ' + props.className;
      }
      if (props.useFixedHeader || props.scroll && props.scroll.y) {
        className += ' ' + prefixCls + '-fixed-header';
      }
      if (this.scrollPosition === 'both') {
        className += ' ' + prefixCls + '-scroll-position-left ' + prefixCls + '-scroll-position-right';
      } else {
        className += ' ' + prefixCls + '-scroll-position-' + this.scrollPosition;
      }
      var hasLeftFixed = this.columnManager.isAnyColumnsLeftFixed();
      var hasRightFixed = this.columnManager.isAnyColumnsRightFixed();

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_mini_store__["Provider"],
        { store: this.store },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17__ExpandableTable__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { columnManager: this.columnManager, getRowKey: this.getRowKey }),
          function (expander) {
            _this2.expander = expander;
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              {
                ref: _this2.saveRef('tableNode'),
                className: className,
                style: props.style,
                id: props.id
              },
              _this2.renderTitle(),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: prefixCls + '-content' },
                _this2.renderMainTable(),
                hasLeftFixed && _this2.renderLeftFixedTable(),
                hasRightFixed && _this2.renderRightFixedTable()
              )
            );
          }
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.columns && nextProps.columns !== prevState.columns) {
        return {
          columns: nextProps.columns,
          children: null
        };
      } else if (nextProps.children !== prevState.children) {
        return {
          columns: null,
          children: nextProps.children
        };
      }
      return null;
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Table.propTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  data: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  useFixedHeader: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  columns: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  bodyStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  rowKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  rowClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  onRow: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onHeaderRow: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onRowClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onRowDoubleClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onRowContextMenu: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onRowMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onRowMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  showHeader: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  footer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  emptyText: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  scroll: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  rowRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  getBodyWrapper: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  components: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    table: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    header: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
      wrapper: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
      row: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
      cell: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
    }),
    body: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
      wrapper: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
      row: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
      cell: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
    })
  })
}, __WEBPACK_IMPORTED_MODULE_17__ExpandableTable__["a" /* default */].PropTypes);
Table.childContextTypes = {
  table: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  components: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
Table.defaultProps = {
  data: [],
  useFixedHeader: false,
  rowKey: 'key',
  rowClassName: function rowClassName() {
    return '';
  },
  onRow: function onRow() {},
  onHeaderRow: function onHeaderRow() {},

  prefixCls: 'rc-table',
  bodyStyle: {},
  style: {},
  showHeader: true,
  scroll: {},
  rowRef: function rowRef() {
    return null;
  },
  emptyText: function emptyText() {
    return 'No Data';
  }
};


Object(__WEBPACK_IMPORTED_MODULE_12_react_lifecycles_compat__["polyfill"])(Table);

/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(722),
    createAssigner = __webpack_require__(778);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(723),
    assignMergeValue = __webpack_require__(307),
    baseFor = __webpack_require__(753),
    baseMergeDeep = __webpack_require__(755),
    isObject = __webpack_require__(70),
    keysIn = __webpack_require__(316),
    safeGet = __webpack_require__(315);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(116),
    stackClear = __webpack_require__(729),
    stackDelete = __webpack_require__(730),
    stackGet = __webpack_require__(731),
    stackHas = __webpack_require__(732),
    stackSet = __webpack_require__(733);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 724 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(117);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(117);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(117);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(117);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(116);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 730 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 731 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 732 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(116),
    Map = __webpack_require__(304),
    MapCache = __webpack_require__(306);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(186),
    isMasked = __webpack_require__(737),
    isObject = __webpack_require__(70),
    toSource = __webpack_require__(739);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(187);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 736 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(738);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(82);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 739 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 740 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(742),
    ListCache = __webpack_require__(116),
    Map = __webpack_require__(304);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(743),
    hashDelete = __webpack_require__(744),
    hashGet = __webpack_require__(745),
    hashHas = __webpack_require__(746),
    hashSet = __webpack_require__(747);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(119);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 744 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(119);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(119);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(119);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(120);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 749 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(120);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(120);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(120);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(754);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 754 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(307),
    cloneBuffer = __webpack_require__(756),
    cloneTypedArray = __webpack_require__(757),
    copyArray = __webpack_require__(760),
    initCloneObject = __webpack_require__(761),
    isArguments = __webpack_require__(311),
    isArray = __webpack_require__(94),
    isArrayLikeObject = __webpack_require__(765),
    isBuffer = __webpack_require__(313),
    isFunction = __webpack_require__(186),
    isObject = __webpack_require__(70),
    isPlainObject = __webpack_require__(767),
    isTypedArray = __webpack_require__(314),
    safeGet = __webpack_require__(315),
    toPlainObject = __webpack_require__(771);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(82);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)(module)))

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(758);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(759);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(82);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 760 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(762),
    getPrototype = __webpack_require__(309),
    isPrototype = __webpack_require__(310);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(70);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 763 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(93),
    isObjectLike = __webpack_require__(83);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(189),
    isObjectLike = __webpack_require__(83);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 766 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(93),
    getPrototype = __webpack_require__(309),
    isObjectLike = __webpack_require__(83);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(93),
    isLength = __webpack_require__(312),
    isObjectLike = __webpack_require__(83);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 769 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(305);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)(module)))

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(772),
    keysIn = __webpack_require__(316);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(773),
    baseAssignValue = __webpack_require__(188);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(188),
    eq = __webpack_require__(118);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(775),
    isArguments = __webpack_require__(311),
    isArray = __webpack_require__(94),
    isBuffer = __webpack_require__(313),
    isIndex = __webpack_require__(317),
    isTypedArray = __webpack_require__(314);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 775 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(70),
    isPrototype = __webpack_require__(310),
    nativeKeysIn = __webpack_require__(777);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 777 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(779),
    isIterateeCall = __webpack_require__(786);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(318),
    overRest = __webpack_require__(780),
    setToString = __webpack_require__(782);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(781);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 781 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(783),
    shortOut = __webpack_require__(785);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(784),
    defineProperty = __webpack_require__(308),
    identity = __webpack_require__(318);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 784 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 785 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(118),
    isArrayLike = __webpack_require__(189),
    isIndex = __webpack_require__(317),
    isObject = __webpack_require__(70);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var ColumnManager = function () {
  function ColumnManager(columns, elements) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ColumnManager);

    this._cached = {};

    this.columns = columns || this.normalize(elements);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ColumnManager, [{
    key: 'isAnyColumnsFixed',
    value: function isAnyColumnsFixed() {
      var _this = this;

      return this._cache('isAnyColumnsFixed', function () {
        return _this.columns.some(function (column) {
          return !!column.fixed;
        });
      });
    }
  }, {
    key: 'isAnyColumnsLeftFixed',
    value: function isAnyColumnsLeftFixed() {
      var _this2 = this;

      return this._cache('isAnyColumnsLeftFixed', function () {
        return _this2.columns.some(function (column) {
          return column.fixed === 'left' || column.fixed === true;
        });
      });
    }
  }, {
    key: 'isAnyColumnsRightFixed',
    value: function isAnyColumnsRightFixed() {
      var _this3 = this;

      return this._cache('isAnyColumnsRightFixed', function () {
        return _this3.columns.some(function (column) {
          return column.fixed === 'right';
        });
      });
    }
  }, {
    key: 'leftColumns',
    value: function leftColumns() {
      var _this4 = this;

      return this._cache('leftColumns', function () {
        return _this4.groupedColumns().filter(function (column) {
          return column.fixed === 'left' || column.fixed === true;
        });
      });
    }
  }, {
    key: 'rightColumns',
    value: function rightColumns() {
      var _this5 = this;

      return this._cache('rightColumns', function () {
        return _this5.groupedColumns().filter(function (column) {
          return column.fixed === 'right';
        });
      });
    }
  }, {
    key: 'leafColumns',
    value: function leafColumns() {
      var _this6 = this;

      return this._cache('leafColumns', function () {
        return _this6._leafColumns(_this6.columns);
      });
    }
  }, {
    key: 'leftLeafColumns',
    value: function leftLeafColumns() {
      var _this7 = this;

      return this._cache('leftLeafColumns', function () {
        return _this7._leafColumns(_this7.leftColumns());
      });
    }
  }, {
    key: 'rightLeafColumns',
    value: function rightLeafColumns() {
      var _this8 = this;

      return this._cache('rightLeafColumns', function () {
        return _this8._leafColumns(_this8.rightColumns());
      });
    }

    // add appropriate rowspan and colspan to column

  }, {
    key: 'groupedColumns',
    value: function groupedColumns() {
      var _this9 = this;

      return this._cache('groupedColumns', function () {
        var _groupColumns = function _groupColumns(columns) {
          var currentRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          var parentColumn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var rows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

          // track how many rows we got
          rows[currentRow] = rows[currentRow] || [];
          var grouped = [];
          var setRowSpan = function setRowSpan(column) {
            var rowSpan = rows.length - currentRow;
            if (column && !column.children && // parent columns are supposed to be one row
            rowSpan > 1 && (!column.rowSpan || column.rowSpan < rowSpan)) {
              column.rowSpan = rowSpan;
            }
          };
          columns.forEach(function (column, index) {
            var newColumn = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, column);
            rows[currentRow].push(newColumn);
            parentColumn.colSpan = parentColumn.colSpan || 0;
            if (newColumn.children && newColumn.children.length > 0) {
              newColumn.children = _groupColumns(newColumn.children, currentRow + 1, newColumn, rows);
              parentColumn.colSpan += newColumn.colSpan;
            } else {
              parentColumn.colSpan++;
            }
            // update rowspan to all same row columns
            for (var i = 0; i < rows[currentRow].length - 1; ++i) {
              setRowSpan(rows[currentRow][i]);
            }
            // last column, update rowspan immediately
            if (index + 1 === columns.length) {
              setRowSpan(newColumn);
            }
            grouped.push(newColumn);
          });
          return grouped;
        };
        return _groupColumns(_this9.columns);
      });
    }
  }, {
    key: 'normalize',
    value: function normalize(elements) {
      var _this10 = this;

      var columns = [];
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.forEach(elements, function (element) {
        if (!__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(element)) {
          return;
        }
        var column = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, element.props);
        if (element.key) {
          column.key = element.key;
        }
        if (element.type.isTableColumnGroup) {
          column.children = _this10.normalize(column.children);
        }
        columns.push(column);
      });
      return columns;
    }
  }, {
    key: 'reset',
    value: function reset(columns, elements) {
      this.columns = columns || this.normalize(elements);
      this._cached = {};
    }
  }, {
    key: '_cache',
    value: function _cache(name, fn) {
      if (name in this._cached) {
        return this._cached[name];
      }
      this._cached[name] = fn();
      return this._cached[name];
    }
  }, {
    key: '_leafColumns',
    value: function _leafColumns(columns) {
      var _this11 = this;

      var leafColumns = [];
      columns.forEach(function (column) {
        if (!column.children) {
          leafColumns.push(column);
        } else {
          leafColumns.push.apply(leafColumns, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this11._leafColumns(column.children)));
        }
      });
      return leafColumns;
    }
  }]);

  return ColumnManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (ColumnManager);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HeadTable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BaseTable__ = __webpack_require__(319);





function HeadTable(props, _ref) {
  var table = _ref.table;
  var _table$props = table.props,
      prefixCls = _table$props.prefixCls,
      scroll = _table$props.scroll,
      showHeader = _table$props.showHeader;
  var columns = props.columns,
      fixed = props.fixed,
      tableClassName = props.tableClassName,
      handleBodyScrollLeft = props.handleBodyScrollLeft,
      expander = props.expander;
  var saveRef = table.saveRef;
  var useFixedHeader = table.props.useFixedHeader;

  var headStyle = {};

  if (scroll.y) {
    useFixedHeader = true;
    // Add negative margin bottom for scroll bar overflow bug
    var scrollbarWidth = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* measureScrollbar */])('horizontal');
    if (scrollbarWidth > 0 && !fixed) {
      headStyle.marginBottom = '-' + scrollbarWidth + 'px';
      headStyle.paddingBottom = '0px';
    }
  }

  if (!useFixedHeader || !showHeader) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      key: 'headTable',
      ref: fixed ? null : saveRef('headTable'),
      className: prefixCls + '-header',
      style: headStyle,
      onScroll: handleBodyScrollLeft
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BaseTable__["a" /* default */], {
      tableClassName: tableClassName,
      hasHead: true,
      hasBody: false,
      fixed: fixed,
      columns: columns,
      expander: expander
    })
  );
}

HeadTable.propTypes = {
  fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  columns: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  tableClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  handleBodyScrollLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  expander: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

HeadTable.contextTypes = {
  table: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ColGroup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function ColGroup(props, _ref) {
  var table = _ref.table;
  var _table$props = table.props,
      prefixCls = _table$props.prefixCls,
      expandIconAsCell = _table$props.expandIconAsCell;
  var fixed = props.fixed;


  var cols = [];

  if (expandIconAsCell && fixed !== 'right') {
    cols.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col', { className: prefixCls + '-expand-icon-col', key: 'rc-table-expand-icon-col' }));
  }

  var leafColumns = void 0;

  if (fixed === 'left') {
    leafColumns = table.columnManager.leftLeafColumns();
  } else if (fixed === 'right') {
    leafColumns = table.columnManager.rightLeafColumns();
  } else {
    leafColumns = table.columnManager.leafColumns();
  }
  cols = cols.concat(leafColumns.map(function (c) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col', { key: c.key || c.dataIndex, style: { width: c.width, minWidth: c.width } });
  }));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'colgroup',
    null,
    cols
  );
}

ColGroup.propTypes = {
  fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

ColGroup.contextTypes = {
  table: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TableHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TableHeaderRow__ = __webpack_require__(791);




function getHeaderRows(columns) {
  var currentRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var rows = arguments[2];

  rows = rows || [];
  rows[currentRow] = rows[currentRow] || [];

  columns.forEach(function (column) {
    if (column.rowSpan && rows.length < column.rowSpan) {
      while (rows.length < column.rowSpan) {
        rows.push([]);
      }
    }
    var cell = {
      key: column.key,
      className: column.className || '',
      children: column.title,
      column: column
    };
    if (column.children) {
      getHeaderRows(column.children, currentRow + 1, rows);
    }
    if ('colSpan' in column) {
      cell.colSpan = column.colSpan;
    }
    if ('rowSpan' in column) {
      cell.rowSpan = column.rowSpan;
    }
    if (cell.colSpan !== 0) {
      rows[currentRow].push(cell);
    }
  });
  return rows.filter(function (row) {
    return row.length > 0;
  });
}

function TableHeader(props, _ref) {
  var table = _ref.table;
  var components = table.components;
  var _table$props = table.props,
      prefixCls = _table$props.prefixCls,
      showHeader = _table$props.showHeader,
      onHeaderRow = _table$props.onHeaderRow;
  var expander = props.expander,
      columns = props.columns,
      fixed = props.fixed;


  if (!showHeader) {
    return null;
  }

  var rows = getHeaderRows(columns);

  expander.renderExpandIndentCell(rows, fixed);

  var HeaderWrapper = components.header.wrapper;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    HeaderWrapper,
    { className: prefixCls + '-thead' },
    rows.map(function (row, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TableHeaderRow__["a" /* default */], {
        key: index,
        index: index,
        fixed: fixed,
        columns: columns,
        rows: rows,
        row: row,
        components: components,
        onHeaderRow: onHeaderRow
      });
    })
  );
}

TableHeader.propTypes = {
  fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  columns: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  expander: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onHeaderRow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

TableHeader.contextTypes = {
  table: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mini_store__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mini_store__);






function TableHeaderRow(_ref) {
  var row = _ref.row,
      index = _ref.index,
      height = _ref.height,
      components = _ref.components,
      onHeaderRow = _ref.onHeaderRow;

  var HeaderRow = components.header.row;
  var HeaderCell = components.header.cell;
  var rowProps = onHeaderRow(row.map(function (cell) {
    return cell.column;
  }), index);
  var customStyle = rowProps ? rowProps.style : {};
  var style = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ height: height }, customStyle);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    HeaderRow,
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rowProps, { style: style }),
    row.map(function (cell, i) {
      var column = cell.column,
          cellProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(cell, ['column']);

      var customProps = column.onHeaderCell ? column.onHeaderCell(column) : {};
      if (column.align) {
        customProps.style = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, customProps.style, { textAlign: column.align });
      }
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(HeaderCell, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, cellProps, customProps, { key: column.key || column.dataIndex || i }));
    })
  );
}

TableHeaderRow.propTypes = {
  row: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  index: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  components: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
  onHeaderRow: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

function getRowHeight(state, props) {
  var fixedColumnsHeadRowsHeight = state.fixedColumnsHeadRowsHeight;
  var columns = props.columns,
      rows = props.rows,
      fixed = props.fixed;

  var headerHeight = fixedColumnsHeadRowsHeight[0];

  if (!fixed) {
    return null;
  }

  if (headerHeight && columns) {
    if (headerHeight === 'auto') {
      return 'auto';
    }
    return headerHeight / rows.length;
  }
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mini_store__["connect"])(function (state, props) {
  return {
    height: getRowHeight(state, props)
  };
})(TableHeaderRow));

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);









function isInvalidRenderCellText(text) {
  return text && !__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(text) && Object.prototype.toString.call(text) === '[object Object]';
}

var TableCell = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TableCell, _React$Component);

  function TableCell() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TableCell);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = TableCell.__proto__ || Object.getPrototypeOf(TableCell)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var _this$props = _this.props,
          record = _this$props.record,
          onCellClick = _this$props.column.onCellClick;

      if (onCellClick) {
        onCellClick(record, e);
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TableCell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          record = _props.record,
          indentSize = _props.indentSize,
          prefixCls = _props.prefixCls,
          indent = _props.indent,
          index = _props.index,
          expandIcon = _props.expandIcon,
          column = _props.column,
          BodyCell = _props.component;
      var dataIndex = column.dataIndex,
          render = column.render,
          _column$className = column.className,
          className = _column$className === undefined ? '' : _column$className;

      // We should return undefined if no dataIndex is specified, but in order to
      // be compatible with object-path's behavior, we return the record object instead.

      var text = void 0;
      if (typeof dataIndex === 'number') {
        text = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(record, dataIndex);
      } else if (!dataIndex || dataIndex.length === 0) {
        text = record;
      } else {
        text = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(record, dataIndex);
      }
      var tdProps = {};
      var colSpan = void 0;
      var rowSpan = void 0;

      if (render) {
        text = render(text, record, index);
        if (isInvalidRenderCellText(text)) {
          tdProps = text.props || tdProps;
          colSpan = tdProps.colSpan;
          rowSpan = tdProps.rowSpan;
          text = text.children;
        }
      }

      if (column.onCell) {
        tdProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, tdProps, column.onCell(record));
      }

      // Fix https://github.com/ant-design/ant-design/issues/1202
      if (isInvalidRenderCellText(text)) {
        text = null;
      }

      var indentText = expandIcon ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', {
        style: { paddingLeft: indentSize * indent + 'px' },
        className: prefixCls + '-indent indent-level-' + indent
      }) : null;

      if (rowSpan === 0 || colSpan === 0) {
        return null;
      }

      if (column.align) {
        tdProps.style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, tdProps.style, { textAlign: column.align });
      }

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        BodyCell,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: className, onClick: this.handleClick }, tdProps),
        indentText,
        expandIcon,
        text
      );
    }
  }]);

  return TableCell;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TableCell.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  index: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  indent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  indentSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  column: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  expandIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  component: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (TableCell);

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(794);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(795),
    toKey = __webpack_require__(803);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(94),
    isKey = __webpack_require__(796),
    stringToPath = __webpack_require__(797),
    toString = __webpack_require__(800);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(94),
    isSymbol = __webpack_require__(190);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(798);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(799);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(306);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(801);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(187),
    arrayMap = __webpack_require__(802),
    isArray = __webpack_require__(94),
    isSymbol = __webpack_require__(190);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 802 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(190);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mini_store__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ExpandIcon__ = __webpack_require__(805);









var ExpandableRow = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ExpandableRow, _React$Component);

  function ExpandableRow() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ExpandableRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ExpandableRow.__proto__ || Object.getPrototypeOf(ExpandableRow)).call.apply(_ref, [this].concat(args))), _this), _this.hasExpandIcon = function (columnIndex) {
      var expandRowByClick = _this.props.expandRowByClick;

      return !_this.expandIconAsCell && !expandRowByClick && columnIndex === _this.expandIconColumnIndex;
    }, _this.handleExpandChange = function (record, event) {
      var _this$props = _this.props,
          onExpandedChange = _this$props.onExpandedChange,
          expanded = _this$props.expanded,
          rowKey = _this$props.rowKey;

      if (_this.expandable) {
        onExpandedChange(!expanded, record, event, rowKey);
      }
    }, _this.handleRowClick = function (record, index, event) {
      var _this$props2 = _this.props,
          expandRowByClick = _this$props2.expandRowByClick,
          onRowClick = _this$props2.onRowClick;

      if (expandRowByClick) {
        _this.handleExpandChange(record, event);
      }
      if (onRowClick) {
        onRowClick(record, index, event);
      }
    }, _this.renderExpandIcon = function () {
      var _this$props3 = _this.props,
          prefixCls = _this$props3.prefixCls,
          expanded = _this$props3.expanded,
          record = _this$props3.record,
          needIndentSpaced = _this$props3.needIndentSpaced;


      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ExpandIcon__["a" /* default */], {
        expandable: _this.expandable,
        prefixCls: prefixCls,
        onExpand: _this.handleExpandChange,
        needIndentSpaced: needIndentSpaced,
        expanded: expanded,
        record: record
      });
    }, _this.renderExpandIconCell = function (cells) {
      if (!_this.expandIconAsCell) {
        return;
      }
      var prefixCls = _this.props.prefixCls;


      cells.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'td',
        { className: prefixCls + '-expand-icon-cell', key: 'rc-table-expand-icon-cell' },
        _this.renderExpandIcon()
      ));
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ExpandableRow, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleDestroy();
    }
  }, {
    key: 'handleDestroy',
    value: function handleDestroy() {
      var _props = this.props,
          onExpandedChange = _props.onExpandedChange,
          rowKey = _props.rowKey,
          record = _props.record;

      if (this.expandable) {
        onExpandedChange(false, record, null, rowKey, true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          childrenColumnName = _props2.childrenColumnName,
          expandedRowRender = _props2.expandedRowRender,
          indentSize = _props2.indentSize,
          record = _props2.record,
          fixed = _props2.fixed;


      this.expandIconAsCell = fixed !== 'right' ? this.props.expandIconAsCell : false;
      this.expandIconColumnIndex = fixed !== 'right' ? this.props.expandIconColumnIndex : -1;
      var childrenData = record[childrenColumnName];
      this.expandable = !!(childrenData || expandedRowRender);

      var expandableRowProps = {
        indentSize: indentSize,
        onRowClick: this.handleRowClick,
        hasExpandIcon: this.hasExpandIcon,
        renderExpandIcon: this.renderExpandIcon,
        renderExpandIconCell: this.renderExpandIconCell
      };

      return this.props.children(expandableRowProps);
    }
  }]);

  return ExpandableRow;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ExpandableRow.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  rowKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]).isRequired,
  fixed: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool]),
  record: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  indentSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  needIndentSpaced: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  expandRowByClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  expanded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  expandIconAsCell: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  expandIconColumnIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  childrenColumnName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  expandedRowRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onExpandedChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  onRowClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_mini_store__["connect"])(function (_ref2, _ref3) {
  var expandedRowKeys = _ref2.expandedRowKeys;
  var rowKey = _ref3.rowKey;
  return {
    expanded: !!~expandedRowKeys.indexOf(rowKey)
  };
})(ExpandableRow));

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shallowequal__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shallowequal__);








var ExpandIcon = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ExpandIcon, _React$Component);

  function ExpandIcon() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ExpandIcon);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ExpandIcon.__proto__ || Object.getPrototypeOf(ExpandIcon)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ExpandIcon, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_6_shallowequal___default()(nextProps, this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          expandable = _props.expandable,
          prefixCls = _props.prefixCls,
          onExpand = _props.onExpand,
          needIndentSpaced = _props.needIndentSpaced,
          expanded = _props.expanded,
          record = _props.record;

      if (expandable) {
        var expandClassName = expanded ? 'expanded' : 'collapsed';
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', {
          className: prefixCls + '-expand-icon ' + prefixCls + '-' + expandClassName,
          onClick: function onClick(e) {
            return onExpand(record, e);
          }
        });
      } else if (needIndentSpaced) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: prefixCls + '-expand-icon ' + prefixCls + '-spaced' });
      }
      return null;
    }
  }]);

  return ExpandIcon;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ExpandIcon.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  expandable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  expanded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  needIndentSpaced: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onExpand: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (ExpandIcon);

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BodyTable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BaseTable__ = __webpack_require__(319);






function BodyTable(props, _ref) {
  var table = _ref.table;
  var _table$props = table.props,
      prefixCls = _table$props.prefixCls,
      scroll = _table$props.scroll;
  var columns = props.columns,
      fixed = props.fixed,
      tableClassName = props.tableClassName,
      getRowKey = props.getRowKey,
      handleBodyScroll = props.handleBodyScroll,
      handleWheel = props.handleWheel,
      expander = props.expander,
      isAnyColumnsFixed = props.isAnyColumnsFixed;
  var saveRef = table.saveRef;
  var useFixedHeader = table.props.useFixedHeader;

  var bodyStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, table.props.bodyStyle);
  var innerBodyStyle = {};

  if (scroll.x || fixed) {
    bodyStyle.overflowX = bodyStyle.overflowX || 'scroll';
    // Fix weired webkit render bug
    // https://github.com/ant-design/ant-design/issues/7783
    bodyStyle.WebkitTransform = 'translate3d (0, 0, 0)';
  }

  if (scroll.y) {
    // maxHeight will make fixed-Table scrolling not working
    // so we only set maxHeight to body-Table here
    if (fixed) {
      innerBodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
      innerBodyStyle.overflowY = bodyStyle.overflowY || 'scroll';
    } else {
      bodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
    }
    bodyStyle.overflowY = bodyStyle.overflowY || 'scroll';
    useFixedHeader = true;

    // Add negative margin bottom for scroll bar overflow bug
    var scrollbarWidth = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* measureScrollbar */])();
    if (scrollbarWidth > 0 && fixed) {
      bodyStyle.marginBottom = '-' + scrollbarWidth + 'px';
      bodyStyle.paddingBottom = '0px';
    }
  }

  var baseTable = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BaseTable__["a" /* default */], {
    tableClassName: tableClassName,
    hasHead: !useFixedHeader,
    hasBody: true,
    fixed: fixed,
    columns: columns,
    expander: expander,
    getRowKey: getRowKey,
    isAnyColumnsFixed: isAnyColumnsFixed
  });

  if (fixed && columns.length) {
    var refName = void 0;
    if (columns[0].fixed === 'left' || columns[0].fixed === true) {
      refName = 'fixedColumnsBodyLeft';
    } else if (columns[0].fixed === 'right') {
      refName = 'fixedColumnsBodyRight';
    }
    delete bodyStyle.overflowX;
    delete bodyStyle.overflowY;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { key: 'bodyTable', className: prefixCls + '-body-outer', style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, bodyStyle) },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: prefixCls + '-body-inner',
          style: innerBodyStyle,
          ref: saveRef(refName),
          onWheel: handleWheel,
          onScroll: handleBodyScroll
        },
        baseTable
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      key: 'bodyTable',
      className: prefixCls + '-body',
      style: bodyStyle,
      ref: saveRef('bodyTable'),
      onWheel: handleWheel,
      onScroll: handleBodyScroll
    },
    baseTable
  );
}

BodyTable.propTypes = {
  fixed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool]),
  columns: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,
  tableClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  handleWheel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  handleBodyScroll: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getRowKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  expander: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  isAnyColumnsFixed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

BodyTable.contextTypes = {
  table: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any
};

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mini_store__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TableRow__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(95);













var ExpandableTable = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ExpandableTable, _React$Component);

  function ExpandableTable(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ExpandableTable);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ExpandableTable.__proto__ || Object.getPrototypeOf(ExpandableTable)).call(this, props));

    _initialiseProps.call(_this);

    var data = props.data,
        childrenColumnName = props.childrenColumnName,
        defaultExpandAllRows = props.defaultExpandAllRows,
        expandedRowKeys = props.expandedRowKeys,
        defaultExpandedRowKeys = props.defaultExpandedRowKeys,
        getRowKey = props.getRowKey;


    var finnalExpandedRowKeys = [];
    var rows = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data));

    if (defaultExpandAllRows) {
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        finnalExpandedRowKeys.push(getRowKey(row, i));
        rows = rows.concat(row[childrenColumnName] || []);
      }
    } else {
      finnalExpandedRowKeys = expandedRowKeys || defaultExpandedRowKeys;
    }

    _this.columnManager = props.columnManager;
    _this.store = props.store;

    _this.store.setState({
      expandedRowsHeight: {},
      expandedRowKeys: finnalExpandedRowKeys
    });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ExpandableTable, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if ('expandedRowKeys' in this.props) {
        this.store.setState({
          expandedRowKeys: this.props.expandedRowKeys
        });
      }
    }
  }, {
    key: 'renderExpandedRow',
    value: function renderExpandedRow(record, index, _render, className, ancestorKeys, indent, fixed) {
      var _this2 = this;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          expandIconAsCell = _props.expandIconAsCell,
          indentSize = _props.indentSize;

      var parentKey = ancestorKeys[ancestorKeys.length - 1];
      var rowKey = parentKey + '-extra-row';
      var components = {
        body: {
          row: 'tr',
          cell: 'td'
        }
      };
      var colCount = void 0;
      if (fixed === 'left') {
        colCount = this.columnManager.leftLeafColumns().length;
      } else if (fixed === 'right') {
        colCount = this.columnManager.rightLeafColumns().length;
      } else {
        colCount = this.columnManager.leafColumns().length;
      }
      var columns = [{
        key: 'extra-row',
        render: function render() {
          var _store$getState = _this2.store.getState(),
              expandedRowKeys = _store$getState.expandedRowKeys;

          var expanded = !!~expandedRowKeys.indexOf(parentKey);
          return {
            props: {
              colSpan: colCount
            },
            children: fixed !== 'right' ? _render(record, index, indent, expanded) : '&nbsp;'
          };
        }
      }];
      if (expandIconAsCell && fixed !== 'right') {
        columns.unshift({
          key: 'expand-icon-placeholder',
          render: function render() {
            return null;
          }
        });
      }

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TableRow__["a" /* default */], {
        key: rowKey,
        columns: columns,
        className: className,
        rowKey: rowKey,
        ancestorKeys: ancestorKeys,
        prefixCls: prefixCls + '-expanded-row',
        indentSize: indentSize,
        indent: indent,
        fixed: fixed,
        components: components,
        expandedRow: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          data = _props2.data,
          childrenColumnName = _props2.childrenColumnName,
          children = _props2.children;

      var needIndentSpaced = data.some(function (record) {
        return record[childrenColumnName];
      });

      return children({
        props: this.props,
        needIndentSpaced: needIndentSpaced,
        renderRows: this.renderRows,
        handleExpandChange: this.handleExpandChange,
        renderExpandIndentCell: this.renderExpandIndentCell
      });
    }
  }]);

  return ExpandableTable;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ExpandableTable.propTypes = {
  expandIconAsCell: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  expandedRowKeys: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,
  expandedRowClassName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  defaultExpandAllRows: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  defaultExpandedRowKeys: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,
  expandIconColumnIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  expandedRowRender: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  childrenColumnName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  indentSize: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  onExpand: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onExpandedRowsChange: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  columnManager: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,
  store: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  getRowKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
};
ExpandableTable.defaultProps = {
  expandIconAsCell: false,
  expandedRowClassName: function expandedRowClassName() {
    return '';
  },
  expandIconColumnIndex: 0,
  defaultExpandAllRows: false,
  defaultExpandedRowKeys: [],
  childrenColumnName: 'children',
  indentSize: 15,
  onExpand: function onExpand() {},
  onExpandedRowsChange: function onExpandedRowsChange() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleExpandChange = function (expanded, record, event, rowKey) {
    var destroy = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    var _props3 = _this3.props,
        onExpandedRowsChange = _props3.onExpandedRowsChange,
        onExpand = _props3.onExpand;

    var _store$getState2 = _this3.store.getState(),
        expandedRowKeys = _store$getState2.expandedRowKeys;

    if (expanded) {
      // row was expaned
      expandedRowKeys = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(expandedRowKeys), [rowKey]);
    } else {
      // row was collapse
      var expandedRowIndex = expandedRowKeys.indexOf(rowKey);
      if (expandedRowIndex !== -1) {
        expandedRowKeys = Object(__WEBPACK_IMPORTED_MODULE_11__utils__["c" /* remove */])(expandedRowKeys, rowKey);
      }
    }

    if (!_this3.props.expandedRowKeys) {
      _this3.store.setState({ expandedRowKeys: expandedRowKeys });
    }

    onExpandedRowsChange(expandedRowKeys);
    if (!destroy) {
      onExpand(expanded, record);
    }
  };

  this.renderExpandIndentCell = function (rows, fixed) {
    var _props4 = _this3.props,
        prefixCls = _props4.prefixCls,
        expandIconAsCell = _props4.expandIconAsCell;

    if (!expandIconAsCell || fixed === 'right' || !rows.length) {
      return;
    }

    var iconColumn = {
      key: 'rc-table-expand-icon-cell',
      className: prefixCls + '-expand-icon-th',
      title: '',
      rowSpan: rows.length
    };

    rows[0].unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, iconColumn, { column: iconColumn }));
  };

  this.renderRows = function (renderRows, rows, record, index, indent, fixed, parentKey, ancestorKeys) {
    var _props5 = _this3.props,
        expandedRowClassName = _props5.expandedRowClassName,
        expandedRowRender = _props5.expandedRowRender,
        childrenColumnName = _props5.childrenColumnName;

    var childrenData = record[childrenColumnName];
    var nextAncestorKeys = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(ancestorKeys), [parentKey]);
    var nextIndent = indent + 1;

    if (expandedRowRender) {
      rows.push(_this3.renderExpandedRow(record, index, expandedRowRender, expandedRowClassName(record, index, indent), nextAncestorKeys, nextIndent, fixed));
    }

    if (childrenData) {
      renderRows(childrenData, nextIndent, rows, nextAncestorKeys);
    }
  };
};

Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["polyfill"])(ExpandableTable);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_mini_store__["connect"])()(ExpandableTable));

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function Column() {}

Column.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  colSpan: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  dataIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
  fixed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf([true, 'left', 'right']),
  render: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onCellClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onCell: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onHeaderCell: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Column);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var ColumnGroup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ColumnGroup, _Component);

  function ColumnGroup() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ColumnGroup);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ColumnGroup.__proto__ || Object.getPrototypeOf(ColumnGroup)).apply(this, arguments));
  }

  return ColumnGroup;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

ColumnGroup.isTableColumnGroup = true;
ColumnGroup.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (ColumnGroup);

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pagination = __webpack_require__(811);

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _Pagination2['default'];
module.exports = exports['default'];

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _rcPagination = __webpack_require__(812);

var _rcPagination2 = _interopRequireDefault(_rcPagination);

var _en_US = __webpack_require__(236);

var _en_US2 = _interopRequireDefault(_en_US);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _LocaleReceiver = __webpack_require__(71);

var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);

var _select = __webpack_require__(16);

var _select2 = _interopRequireDefault(_select);

var _MiniSelect = __webpack_require__(822);

var _MiniSelect2 = _interopRequireDefault(_MiniSelect);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Pagination = function (_React$Component) {
    (0, _inherits3['default'])(Pagination, _React$Component);

    function Pagination() {
        (0, _classCallCheck3['default'])(this, Pagination);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).apply(this, arguments));

        _this.renderPagination = function (contextLocale) {
            var _a = _this.props,
                className = _a.className,
                size = _a.size,
                customLocale = _a.locale,
                restProps = __rest(_a, ["className", "size", "locale"]);
            var locale = (0, _extends3['default'])({}, contextLocale, customLocale);
            var isSmall = size === 'small';
            return React.createElement(_rcPagination2['default'], (0, _extends3['default'])({}, restProps, { className: (0, _classnames2['default'])(className, { mini: isSmall }), selectComponentClass: isSmall ? _MiniSelect2['default'] : _select2['default'], locale: locale }));
        };
        return _this;
    }

    (0, _createClass3['default'])(Pagination, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                _LocaleReceiver2['default'],
                { componentName: 'Pagination', defaultLocale: _en_US2['default'] },
                this.renderPagination
            );
        }
    }]);
    return Pagination;
}(React.Component);

exports['default'] = Pagination;

Pagination.defaultProps = {
    prefixCls: 'ant-pagination',
    selectPrefixCls: 'ant-select'
};
module.exports = exports['default'];

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination__ = __webpack_require__(813);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__Pagination__["a"]; });


/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Pager__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Options__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__KeyCode__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__locale_zh_CN__ = __webpack_require__(816);












function noop() {}

function isInteger(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

function defaultItemRender(page, type, element) {
  return element;
}

var Pagination = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Pagination, _React$Component);

  function Pagination(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Pagination);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));

    _initialiseProps.call(_this);

    var hasOnChange = props.onChange !== noop;
    var hasCurrent = 'current' in props;
    if (hasCurrent && !hasOnChange) {
      console.warn('Warning: You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.'); // eslint-disable-line
    }

    var current = props.defaultCurrent;
    if ('current' in props) {
      current = props.current;
    }

    var pageSize = props.defaultPageSize;
    if ('pageSize' in props) {
      pageSize = props.pageSize;
    }

    _this.state = {
      current: current,
      currentInputValue: current,
      pageSize: pageSize
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Pagination, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('current' in nextProps) {
        this.setState({
          current: nextProps.current,
          currentInputValue: nextProps.current
        });
      }

      if ('pageSize' in nextProps) {
        var newState = {};
        var current = this.state.current;
        var newCurrent = this.calculatePage(nextProps.pageSize);
        current = current > newCurrent ? newCurrent : current;
        if (!('current' in nextProps)) {
          newState.current = current;
          newState.currentInputValue = current;
        }
        newState.pageSize = nextProps.pageSize;
        this.setState(newState);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // When current page change, fix focused style of prev item
      // A hacky solution of https://github.com/ant-design/ant-design/issues/8948
      var prefixCls = this.props.prefixCls;

      if (prevState.current !== this.state.current && this.paginationNode) {
        var lastCurrentNode = this.paginationNode.querySelector('.' + prefixCls + '-item-' + prevState.current);
        if (lastCurrentNode && document.activeElement === lastCurrentNode) {
          lastCurrentNode.blur();
        }
      }
    }
  }, {
    key: 'getJumpPrevPage',
    value: function getJumpPrevPage() {
      return Math.max(1, this.state.current - (this.props.showLessItems ? 3 : 5));
    }
  }, {
    key: 'getJumpNextPage',
    value: function getJumpNextPage() {
      return Math.min(this.calculatePage(), this.state.current + (this.props.showLessItems ? 3 : 5));
    }
  }, {
    key: 'getJumpPrevPage',
    value: function getJumpPrevPage() {
      return Math.max(1, this.state.current - (this.props.showLessItems ? 3 : 5));
    }
  }, {
    key: 'getJumpNextPage',
    value: function getJumpNextPage() {
      return Math.min(this.calculatePage(), this.state.current + (this.props.showLessItems ? 3 : 5));
    }
  }, {
    key: 'render',
    value: function render() {
      // When hideOnSinglePage is true and there is only 1 page, hide the pager
      if (this.props.hideOnSinglePage === true && this.props.total <= this.state.pageSize) {
        return null;
      }

      var props = this.props;
      var locale = props.locale;

      var prefixCls = props.prefixCls;
      var allPages = this.calculatePage();
      var pagerList = [];
      var jumpPrev = null;
      var jumpNext = null;
      var firstPager = null;
      var lastPager = null;
      var gotoButton = null;

      var goButton = props.showQuickJumper && props.showQuickJumper.goButton;
      var pageBufferSize = props.showLessItems ? 1 : 2;
      var _state = this.state,
          current = _state.current,
          pageSize = _state.pageSize;


      var prevPage = current - 1 > 0 ? current - 1 : 0;
      var nextPage = current + 1 < allPages ? current + 1 : allPages;

      var dataOrAriaAttributeProps = Object.keys(props).reduce(function (prev, key) {
        if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') {
          prev[key] = props[key];
        }
        return prev;
      }, {});

      if (props.simple) {
        if (goButton) {
          if (typeof goButton === 'boolean') {
            gotoButton = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'button',
              {
                type: 'button',
                onClick: this.handleGoTO,
                onKeyUp: this.handleGoTO
              },
              locale.jump_to_confirm
            );
          } else {
            gotoButton = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'span',
              {
                onClick: this.handleGoTO,
                onKeyUp: this.handleGoTO
              },
              goButton
            );
          }
          gotoButton = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? '' + locale.jump_to + this.state.current + '/' + allPages : null,
              className: prefixCls + '-simple-pager'
            },
            gotoButton
          );
        }

        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'ul',
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: prefixCls + ' ' + prefixCls + '-simple ' + props.className,
            style: props.style,
            ref: this.savePaginationNode
          }, dataOrAriaAttributeProps),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? locale.prev_page : null,
              onClick: this.prev,
              tabIndex: this.hasPrev() ? 0 : null,
              onKeyPress: this.runIfEnterPrev,
              className: (this.hasPrev() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
              'aria-disabled': !this.hasPrev()
            },
            props.itemRender(prevPage, 'prev', __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('a', { className: prefixCls + '-item-link' }))
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? this.state.current + '/' + allPages : null,
              className: prefixCls + '-simple-pager'
            },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', {
              type: 'text',
              value: this.state.currentInputValue,
              onKeyDown: this.handleKeyDown,
              onKeyUp: this.handleKeyUp,
              onChange: this.handleKeyUp,
              size: '3'
            }),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'span',
              { className: prefixCls + '-slash' },
              '\uFF0F'
            ),
            allPages
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? locale.next_page : null,
              onClick: this.next,
              tabIndex: this.hasPrev() ? 0 : null,
              onKeyPress: this.runIfEnterNext,
              className: (this.hasNext() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
              'aria-disabled': !this.hasNext()
            },
            props.itemRender(nextPage, 'next', __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('a', { className: prefixCls + '-item-link' }))
          ),
          gotoButton
        );
      }

      if (allPages <= 5 + pageBufferSize * 2) {
        for (var i = 1; i <= allPages; i++) {
          var active = this.state.current === i;
          pagerList.push(__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Pager__["a" /* default */], {
            locale: locale,
            rootPrefixCls: prefixCls,
            onClick: this.handleChange,
            onKeyPress: this.runIfEnter,
            key: i,
            page: i,
            active: active,
            showTitle: props.showTitle,
            itemRender: props.itemRender
          }));
        }
      } else {
        var prevItemTitle = props.showLessItems ? locale.prev_3 : locale.prev_5;
        var nextItemTitle = props.showLessItems ? locale.next_3 : locale.next_5;
        if (props.showPrevNextJumpers) {
          jumpPrev = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? prevItemTitle : null,
              key: 'prev',
              onClick: this.jumpPrev,
              tabIndex: '0',
              onKeyPress: this.runIfEnterJumpPrev,
              className: prefixCls + '-jump-prev'
            },
            props.itemRender(this.getJumpPrevPage(), 'jump-prev', __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('a', { className: prefixCls + '-item-link' }))
          );
          jumpNext = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'li',
            {
              title: props.showTitle ? nextItemTitle : null,
              key: 'next',
              tabIndex: '0',
              onClick: this.jumpNext,
              onKeyPress: this.runIfEnterJumpNext,
              className: prefixCls + '-jump-next'
            },
            props.itemRender(this.getJumpNextPage(), 'jump-next', __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('a', { className: prefixCls + '-item-link' }))
          );
        }
        lastPager = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Pager__["a" /* default */], {
          locale: props.locale,
          last: true,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          key: allPages,
          page: allPages,
          active: false,
          showTitle: props.showTitle,
          itemRender: props.itemRender
        });
        firstPager = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Pager__["a" /* default */], {
          locale: props.locale,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          key: 1,
          page: 1,
          active: false,
          showTitle: props.showTitle,
          itemRender: props.itemRender
        });

        var left = Math.max(1, current - pageBufferSize);
        var right = Math.min(current + pageBufferSize, allPages);

        if (current - 1 <= pageBufferSize) {
          right = 1 + pageBufferSize * 2;
        }

        if (allPages - current <= pageBufferSize) {
          left = allPages - pageBufferSize * 2;
        }

        for (var _i = left; _i <= right; _i++) {
          var _active = current === _i;
          pagerList.push(__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Pager__["a" /* default */], {
            locale: props.locale,
            rootPrefixCls: prefixCls,
            onClick: this.handleChange,
            onKeyPress: this.runIfEnter,
            key: _i,
            page: _i,
            active: _active,
            showTitle: props.showTitle,
            itemRender: props.itemRender
          }));
        }

        if (current - 1 >= pageBufferSize * 2 && current !== 1 + 2) {
          pagerList[0] = __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(pagerList[0], {
            className: prefixCls + '-item-after-jump-prev'
          });
          pagerList.unshift(jumpPrev);
        }
        if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
          pagerList[pagerList.length - 1] = __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(pagerList[pagerList.length - 1], {
            className: prefixCls + '-item-before-jump-next'
          });
          pagerList.push(jumpNext);
        }

        if (left !== 1) {
          pagerList.unshift(firstPager);
        }
        if (right !== allPages) {
          pagerList.push(lastPager);
        }
      }

      var totalText = null;

      if (props.showTotal) {
        totalText = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'li',
          { className: prefixCls + '-total-text' },
          props.showTotal(props.total, [(current - 1) * pageSize + 1, current * pageSize > props.total ? props.total : current * pageSize])
        );
      }
      var prevDisabled = !this.hasPrev();
      var nextDisabled = !this.hasNext();
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'ul',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          className: prefixCls + ' ' + props.className,
          style: props.style,
          unselectable: 'unselectable',
          ref: this.savePaginationNode
        }, dataOrAriaAttributeProps),
        totalText,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'li',
          {
            title: props.showTitle ? locale.prev_page : null,
            onClick: this.prev,
            tabIndex: prevDisabled ? null : 0,
            onKeyPress: this.runIfEnterPrev,
            className: (!prevDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
            'aria-disabled': prevDisabled
          },
          props.itemRender(prevPage, 'prev', __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('a', { className: prefixCls + '-item-link' }))
        ),
        pagerList,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'li',
          {
            title: props.showTitle ? locale.next_page : null,
            onClick: this.next,
            tabIndex: nextDisabled ? null : 0,
            onKeyPress: this.runIfEnterNext,
            className: (!nextDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
            'aria-disabled': nextDisabled
          },
          props.itemRender(nextPage, 'next', __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('a', { className: prefixCls + '-item-link' }))
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Options__["a" /* default */], {
          locale: props.locale,
          rootPrefixCls: prefixCls,
          selectComponentClass: props.selectComponentClass,
          selectPrefixCls: props.selectPrefixCls,
          changeSize: this.props.showSizeChanger ? this.changePageSize : null,
          current: this.state.current,
          pageSize: this.state.pageSize,
          pageSizeOptions: this.props.pageSizeOptions,
          quickGo: this.props.showQuickJumper ? this.handleChange : null,
          goButton: goButton
        })
      );
    }
  }]);

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Pagination.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  current: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  defaultCurrent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  total: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  pageSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  defaultPageSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  hideOnSinglePage: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  showSizeChanger: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  showLessItems: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onShowSizeChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  selectComponentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  showPrevNextJumpers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  showQuickJumper: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  showTitle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  pageSizeOptions: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  showTotal: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  locale: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  itemRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
Pagination.defaultProps = {
  defaultCurrent: 1,
  total: 0,
  defaultPageSize: 10,
  onChange: noop,
  className: '',
  selectPrefixCls: 'rc-select',
  prefixCls: 'rc-pagination',
  selectComponentClass: null,
  hideOnSinglePage: false,
  showPrevNextJumpers: true,
  showQuickJumper: false,
  showSizeChanger: false,
  showLessItems: false,
  showTitle: true,
  onShowSizeChange: noop,
  locale: __WEBPACK_IMPORTED_MODULE_10__locale_zh_CN__["a" /* default */],
  style: {},
  itemRender: defaultItemRender
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.savePaginationNode = function (node) {
    _this2.paginationNode = node;
  };

  this.calculatePage = function (p) {
    var pageSize = p;
    if (typeof pageSize === 'undefined') {
      pageSize = _this2.state.pageSize;
    }
    return Math.floor((_this2.props.total - 1) / pageSize) + 1;
  };

  this.isValid = function (page) {
    return isInteger(page) && page >= 1 && page !== _this2.state.current;
  };

  this.handleKeyDown = function (e) {
    if (e.keyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].ARROW_UP || e.keyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].ARROW_DOWN) {
      e.preventDefault();
    }
  };

  this.handleKeyUp = function (e) {
    var inputValue = e.target.value;
    var currentInputValue = _this2.state.currentInputValue;
    var value = void 0;

    if (inputValue === '') {
      value = inputValue;
    } else if (isNaN(Number(inputValue))) {
      value = currentInputValue;
    } else {
      value = Number(inputValue);
    }

    if (value !== currentInputValue) {
      _this2.setState({
        currentInputValue: value
      });
    }

    if (e.keyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].ENTER) {
      _this2.handleChange(value);
    } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].ARROW_UP) {
      _this2.handleChange(value - 1);
    } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].ARROW_DOWN) {
      _this2.handleChange(value + 1);
    }
  };

  this.changePageSize = function (size) {
    var current = _this2.state.current;
    var newCurrent = _this2.calculatePage(size);
    current = current > newCurrent ? newCurrent : current;
    // fix the issue:
    // Once 'total' is 0, 'current' in 'onShowSizeChange' is 0, which is not correct.
    if (newCurrent === 0) {
      current = _this2.state.current;
    }

    if (typeof size === 'number') {
      if (!('pageSize' in _this2.props)) {
        _this2.setState({
          pageSize: size
        });
      }
      if (!('current' in _this2.props)) {
        _this2.setState({
          current: current,
          currentInputValue: current
        });
      }
    }
    _this2.props.onShowSizeChange(current, size);
  };

  this.handleChange = function (p) {
    var page = p;
    if (_this2.isValid(page)) {
      if (page > _this2.calculatePage()) {
        page = _this2.calculatePage();
      }

      if (!('current' in _this2.props)) {
        _this2.setState({
          current: page,
          currentInputValue: page
        });
      }

      var pageSize = _this2.state.pageSize;
      _this2.props.onChange(page, pageSize);

      return page;
    }

    return _this2.state.current;
  };

  this.prev = function () {
    if (_this2.hasPrev()) {
      _this2.handleChange(_this2.state.current - 1);
    }
  };

  this.next = function () {
    if (_this2.hasNext()) {
      _this2.handleChange(_this2.state.current + 1);
    }
  };

  this.jumpPrev = function () {
    _this2.handleChange(_this2.getJumpPrevPage());
  };

  this.jumpNext = function () {
    _this2.handleChange(_this2.getJumpNextPage());
  };

  this.hasPrev = function () {
    return _this2.state.current > 1;
  };

  this.hasNext = function () {
    return _this2.state.current < _this2.calculatePage();
  };

  this.runIfEnter = function (event, callback) {
    for (var _len = arguments.length, restParams = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      restParams[_key - 2] = arguments[_key];
    }

    if (event.key === 'Enter' || event.charCode === 13) {
      callback.apply(undefined, restParams);
    }
  };

  this.runIfEnterPrev = function (e) {
    _this2.runIfEnter(e, _this2.prev);
  };

  this.runIfEnterNext = function (e) {
    _this2.runIfEnter(e, _this2.next);
  };

  this.runIfEnterJumpPrev = function (e) {
    _this2.runIfEnter(e, _this2.jumpPrev);
  };

  this.runIfEnterJumpNext = function (e) {
    _this2.runIfEnter(e, _this2.jumpNext);
  };

  this.handleGoTO = function (e) {
    if (e.keyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].ENTER || e.type === 'click') {
      _this2.handleChange(_this2.state.currentInputValue);
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Pagination);

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var Pager = function Pager(props) {
  var prefixCls = props.rootPrefixCls + '-item';
  var cls = prefixCls + ' ' + prefixCls + '-' + props.page;

  if (props.active) {
    cls = cls + ' ' + prefixCls + '-active';
  }

  if (props.className) {
    cls = cls + ' ' + props.className;
  }

  var handleClick = function handleClick() {
    props.onClick(props.page);
  };

  var handleKeyPress = function handleKeyPress(e) {
    props.onKeyPress(e, props.onClick, props.page);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'li',
    {
      title: props.showTitle ? props.page : null,
      className: cls,
      onClick: handleClick,
      onKeyPress: handleKeyPress,
      tabIndex: '0'
    },
    props.itemRender(props.page, 'page', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      null,
      props.page
    ))
  );
};

Pager.propTypes = {
  page: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  last: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  showTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onKeyPress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  itemRender: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Pager);

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__KeyCode__ = __webpack_require__(321);








var Options = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Options, _React$Component);

  function Options(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Options);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Options.__proto__ || Object.getPrototypeOf(Options)).call(this, props));

    _this.buildOptionText = function (value) {
      return value + ' ' + _this.props.locale.items_per_page;
    };

    _this.changeSize = function (value) {
      _this.props.changeSize(Number(value));
    };

    _this.handleChange = function (e) {
      _this.setState({
        goInputText: e.target.value
      });
    };

    _this.go = function (e) {
      var val = _this.state.goInputText;
      if (val === '') {
        return;
      }
      val = isNaN(val) ? _this.props.current : Number(val);
      if (e.keyCode === __WEBPACK_IMPORTED_MODULE_6__KeyCode__["a" /* default */].ENTER || e.type === 'click') {
        _this.setState({
          goInputText: ''
        });
        _this.props.quickGo(val);
      }
    };

    _this.state = {
      goInputText: ''
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Options, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var state = this.state;
      var locale = props.locale;
      var prefixCls = props.rootPrefixCls + '-options';
      var changeSize = props.changeSize;
      var quickGo = props.quickGo;
      var goButton = props.goButton;
      var buildOptionText = props.buildOptionText || this.buildOptionText;
      var Select = props.selectComponentClass;
      var changeSelect = null;
      var goInput = null;
      var gotoButton = null;

      if (!(changeSize || quickGo)) {
        return null;
      }

      if (changeSize && Select) {
        var Option = Select.Option;
        var pageSize = props.pageSize || props.pageSizeOptions[0];
        var options = props.pageSizeOptions.map(function (opt, i) {
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            Option,
            { key: i, value: opt },
            buildOptionText(opt)
          );
        });

        changeSelect = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          Select,
          {
            prefixCls: props.selectPrefixCls,
            showSearch: false,
            className: prefixCls + '-size-changer',
            optionLabelProp: 'children',
            dropdownMatchSelectWidth: false,
            value: pageSize.toString(),
            onChange: this.changeSize,
            getPopupContainer: function getPopupContainer(triggerNode) {
              return triggerNode.parentNode;
            }
          },
          options
        );
      }

      if (quickGo) {
        if (goButton) {
          if (typeof goButton === 'boolean') {
            gotoButton = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'button',
              {
                type: 'button',
                onClick: this.go,
                onKeyUp: this.go
              },
              locale.jump_to_confirm
            );
          } else {
            gotoButton = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'span',
              {
                onClick: this.go,
                onKeyUp: this.go
              },
              goButton
            );
          }
        }
        goInput = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          { className: prefixCls + '-quick-jumper' },
          locale.jump_to,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input', {
            type: 'text',
            value: state.goInputText,
            onChange: this.handleChange,
            onKeyUp: this.go
          }),
          locale.page,
          gotoButton
        );
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'li',
        { className: '' + prefixCls },
        changeSelect,
        goInput
      );
    }
  }]);

  return Options;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Options.propTypes = {
  changeSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  quickGo: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  selectComponentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  current: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  pageSizeOptions: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string),
  pageSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  buildOptionText: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  locale: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};
Options.defaultProps = {
  pageSizeOptions: ['10', '20', '30', '40']
};


/* harmony default export */ __webpack_exports__["a"] = (Options);

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  // Options.jsx
  items_per_page: '条/页',
  jump_to: '跳至',
  jump_to_confirm: '确定',
  page: '页',

  // Pagination.jsx
  prev_page: '上一页',
  next_page: '下一页',
  prev_5: '向前 5 页',
  next_5: '向后 5 页',
  prev_3: '向前 3 页',
  next_3: '向后 3 页'
});

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Option__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PropTypes__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OptGroup__ = __webpack_require__(821);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Option", function() { return __WEBPACK_IMPORTED_MODULE_1__Option__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OptGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__OptGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SelectPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_2__PropTypes__["a"]; });




__WEBPACK_IMPORTED_MODULE_0__Select__["a" /* default */].Option = __WEBPACK_IMPORTED_MODULE_1__Option__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Select__["a" /* default */].OptGroup = __WEBPACK_IMPORTED_MODULE_3__OptGroup__["a" /* default */];

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Select__["a" /* default */]);

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Children_toArray__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_animate__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_component_classes__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_component_classes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rc_menu__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Option__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SelectTrigger__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__PropTypes__ = __webpack_require__(324);




/* eslint func-names: 1 */
















function noop() {}

function chaining() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    // eslint-disable-line
    // eslint-disable-line
    for (var i = 0; i < fns.length; i++) {
      if (fns[i] && typeof fns[i] === 'function') {
        fns[i].apply(this, args);
      }
    }
  };
}

var Select = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Select, _React$Component);

  function Select(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Select);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var optionsInfo = Select.getOptionsInfoFromProps(props);
    _this.state = {
      value: Select.getValueFromProps(props, true), // true: use default value
      inputValue: props.combobox ? Select.getInputValueForCombobox(props, optionsInfo, true // use default value
      ) : '',
      open: props.defaultOpen,
      optionsInfo: optionsInfo,
      // a flag for aviod redundant getOptionsInfoFromProps call
      skipBuildOptionsInfo: true
    };

    _this.saveInputRef = Object(__WEBPACK_IMPORTED_MODULE_15__util__["q" /* saveRef */])(_this, 'inputRef');
    _this.saveInputMirrorRef = Object(__WEBPACK_IMPORTED_MODULE_15__util__["q" /* saveRef */])(_this, 'inputMirrorRef');
    _this.saveTopCtrlRef = Object(__WEBPACK_IMPORTED_MODULE_15__util__["q" /* saveRef */])(_this, 'topCtrlRef');
    _this.saveSelectTriggerRef = Object(__WEBPACK_IMPORTED_MODULE_15__util__["q" /* saveRef */])(_this, 'selectTriggerRef');
    _this.saveRootRef = Object(__WEBPACK_IMPORTED_MODULE_15__util__["q" /* saveRef */])(_this, 'rootRef');
    _this.saveSelectionRef = Object(__WEBPACK_IMPORTED_MODULE_15__util__["q" /* saveRef */])(_this, 'selectionRef');
    return _this;
  }

  Select.prototype.componentDidMount = function componentDidMount() {
    if (this.props.autoFocus) {
      this.focus();
    }
  };

  Select.prototype.componentDidUpdate = function componentDidUpdate() {
    if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["m" /* isMultipleOrTags */])(this.props)) {
      var inputNode = this.getInputDOMNode();
      var mirrorNode = this.getInputMirrorDOMNode();
      if (inputNode.value) {
        inputNode.style.width = '';
        inputNode.style.width = mirrorNode.clientWidth + 'px';
      } else {
        inputNode.style.width = '';
      }
    }
    this.forcePopupAlign();
  };

  Select.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearFocusTime();
    this.clearBlurTime();
    if (this.dropdownContainer) {
      __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(this.dropdownContainer);
      document.body.removeChild(this.dropdownContainer);
      this.dropdownContainer = null;
    }
  };

  // combobox ignore


  Select.prototype.focus = function focus() {
    if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["o" /* isSingleMode */])(this.props)) {
      this.selectionRef.focus();
    } else {
      this.getInputDOMNode().focus();
    }
  };

  Select.prototype.blur = function blur() {
    if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["o" /* isSingleMode */])(this.props)) {
      this.selectionRef.blur();
    } else {
      this.getInputDOMNode().blur();
    }
  };

  Select.prototype.renderClear = function renderClear() {
    var _props = this.props,
        prefixCls = _props.prefixCls,
        allowClear = _props.allowClear;
    var _state = this.state,
        value = _state.value,
        inputValue = _state.inputValue;

    var clear = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      key: 'clear',
      onMouseDown: __WEBPACK_IMPORTED_MODULE_15__util__["p" /* preventDefaultEvent */],
      style: __WEBPACK_IMPORTED_MODULE_15__util__["b" /* UNSELECTABLE_STYLE */]
    }, __WEBPACK_IMPORTED_MODULE_15__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
      className: prefixCls + '-selection__clear',
      onClick: this.onClearSelection
    }));
    if (!allowClear) {
      return null;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["l" /* isCombobox */])(this.props)) {
      if (inputValue) {
        return clear;
      }
      return null;
    }
    if (inputValue || value.length) {
      return clear;
    }
    return null;
  };

  Select.prototype.render = function render() {
    var _rootCls;

    var props = this.props;
    var multiple = Object(__WEBPACK_IMPORTED_MODULE_15__util__["m" /* isMultipleOrTags */])(props);
    var state = this.state;
    var className = props.className,
        disabled = props.disabled,
        prefixCls = props.prefixCls;

    var ctrlNode = this.renderTopControlNode();
    var open = this.state.open;

    if (open) {
      this._options = this.renderFilterOptions();
    }
    var realOpen = this.getRealOpenState();
    var options = this._options || [];
    var dataOrAriaAttributeProps = {};
    for (var key in props) {
      if (props.hasOwnProperty(key) && (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role')) {
        dataOrAriaAttributeProps[key] = props[key];
      }
    }
    var extraSelectionProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, dataOrAriaAttributeProps);
    if (!Object(__WEBPACK_IMPORTED_MODULE_15__util__["n" /* isMultipleOrTagsOrCombobox */])(props)) {
      extraSelectionProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, extraSelectionProps, {
        onKeyDown: this.onKeyDown,
        tabIndex: props.disabled ? -1 : 0
      });
    }
    var rootCls = (_rootCls = {}, _rootCls[className] = !!className, _rootCls[prefixCls] = 1, _rootCls[prefixCls + '-open'] = open, _rootCls[prefixCls + '-focused'] = open || !!this._focused, _rootCls[prefixCls + '-combobox'] = Object(__WEBPACK_IMPORTED_MODULE_15__util__["l" /* isCombobox */])(props), _rootCls[prefixCls + '-disabled'] = disabled, _rootCls[prefixCls + '-enabled'] = !disabled, _rootCls[prefixCls + '-allow-clear'] = !!props.allowClear, _rootCls[prefixCls + '-no-arrow'] = !props.showArrow, _rootCls);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_16__SelectTrigger__["a" /* default */],
      {
        onPopupFocus: this.onPopupFocus,
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave,
        dropdownAlign: props.dropdownAlign,
        dropdownClassName: props.dropdownClassName,
        dropdownMatchSelectWidth: props.dropdownMatchSelectWidth,
        defaultActiveFirstOption: props.defaultActiveFirstOption,
        dropdownMenuStyle: props.dropdownMenuStyle,
        transitionName: props.transitionName,
        animation: props.animation,
        prefixCls: props.prefixCls,
        dropdownStyle: props.dropdownStyle,
        combobox: props.combobox,
        showSearch: props.showSearch,
        options: options,
        multiple: multiple,
        disabled: disabled,
        visible: realOpen,
        inputValue: state.inputValue,
        value: state.value,
        backfillValue: state.backfillValue,
        firstActiveValue: props.firstActiveValue,
        onDropdownVisibleChange: this.onDropdownVisibleChange,
        getPopupContainer: props.getPopupContainer,
        onMenuSelect: this.onMenuSelect,
        onMenuDeselect: this.onMenuDeselect,
        onPopupScroll: props.onPopupScroll,
        showAction: props.showAction,
        ref: this.saveSelectTriggerRef
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        {
          id: props.id,
          style: props.style,
          ref: this.saveRootRef,
          onBlur: this.onOuterBlur,
          onFocus: this.onOuterFocus,
          className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()(rootCls)
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            ref: this.saveSelectionRef,
            key: 'selection',
            className: prefixCls + '-selection\n            ' + prefixCls + '-selection--' + (multiple ? 'multiple' : 'single'),
            role: 'combobox',
            'aria-autocomplete': 'list',
            'aria-haspopup': 'true',
            'aria-expanded': realOpen
          }, extraSelectionProps),
          ctrlNode,
          this.renderClear(),
          multiple || !props.showArrow ? null : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'span',
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              key: 'arrow',
              className: prefixCls + '-arrow',
              style: __WEBPACK_IMPORTED_MODULE_15__util__["b" /* UNSELECTABLE_STYLE */]
            }, __WEBPACK_IMPORTED_MODULE_15__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
              onClick: this.onArrowClick
            }),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b', null)
          )
        )
      )
    );
  };

  return Select;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Select.propTypes = __WEBPACK_IMPORTED_MODULE_17__PropTypes__["a" /* SelectPropTypes */];
Select.defaultProps = {
  prefixCls: 'rc-select',
  defaultOpen: false,
  labelInValue: false,
  defaultActiveFirstOption: true,
  showSearch: true,
  allowClear: false,
  placeholder: '',
  onChange: noop,
  onFocus: noop,
  onBlur: noop,
  onSelect: noop,
  onSearch: noop,
  onDeselect: noop,
  onInputKeyDown: noop,
  showArrow: true,
  dropdownMatchSelectWidth: true,
  dropdownStyle: {},
  dropdownMenuStyle: {},
  optionFilterProp: 'value',
  optionLabelProp: 'value',
  notFoundContent: 'Not Found',
  backfill: false,
  showAction: ['click'],
  tokenSeparators: [],
  autoClearSearchValue: true
};

Select.getDerivedStateFromProps = function (nextProps, prevState) {
  var optionsInfo = prevState.skipBuildOptionsInfo ? prevState.optionsInfo : Select.getOptionsInfoFromProps(nextProps, prevState);

  var newState = {
    optionsInfo: optionsInfo,
    skipBuildOptionsInfo: false
  };

  if ('open' in nextProps) {
    newState.open = nextProps.open;
  }

  if ('value' in nextProps) {
    var value = Select.getValueFromProps(nextProps);
    newState.value = value;
    if (nextProps.combobox) {
      newState.inputValue = Select.getInputValueForCombobox(nextProps, optionsInfo);
    }
  }
  return newState;
};

Select.getOptionsFromChildren = function (children) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.forEach(children, function (child) {
    if (!child) {
      return;
    }
    if (child.type.isSelectOptGroup) {
      Select.getOptionsFromChildren(child.props.children, options);
    } else {
      options.push(child);
    }
  });
  return options;
};

Select.getInputValueForCombobox = function (props, optionsInfo, useDefaultValue) {
  var value = [];
  if ('value' in props && !useDefaultValue) {
    value = Object(__WEBPACK_IMPORTED_MODULE_15__util__["s" /* toArray */])(props.value);
  }
  if ('defaultValue' in props && useDefaultValue) {
    value = Object(__WEBPACK_IMPORTED_MODULE_15__util__["s" /* toArray */])(props.defaultValue);
  }
  if (value.length) {
    value = value[0];
  } else {
    return '';
  }
  var label = value;
  if (props.labelInValue) {
    label = value.label;
  } else if (optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_15__util__["g" /* getMapKey */])(value)]) {
    label = optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_15__util__["g" /* getMapKey */])(value)].label;
  }
  if (label === undefined) {
    label = '';
  }
  return label;
};

Select.getLabelFromOption = function (props, option) {
  return Object(__WEBPACK_IMPORTED_MODULE_15__util__["h" /* getPropValue */])(option, props.optionLabelProp);
};

Select.getOptionsInfoFromProps = function (props, preState) {
  var options = Select.getOptionsFromChildren(props.children);
  var optionsInfo = {};
  options.forEach(function (option) {
    var singleValue = Object(__WEBPACK_IMPORTED_MODULE_15__util__["j" /* getValuePropValue */])(option);
    optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_15__util__["g" /* getMapKey */])(singleValue)] = {
      option: option,
      value: singleValue,
      label: Select.getLabelFromOption(props, option),
      title: option.props.title
    };
  });
  if (preState) {
    // keep option info in pre state value.
    var oldOptionsInfo = preState.optionsInfo;
    var value = preState.value;
    value.forEach(function (v) {
      var key = Object(__WEBPACK_IMPORTED_MODULE_15__util__["g" /* getMapKey */])(v);
      if (!optionsInfo[key] && oldOptionsInfo[key] !== undefined) {
        optionsInfo[key] = oldOptionsInfo[key];
      }
    });
  }
  return optionsInfo;
};

Select.getValueFromProps = function (props, useDefaultValue) {
  var value = [];
  if ('value' in props && !useDefaultValue) {
    value = Object(__WEBPACK_IMPORTED_MODULE_15__util__["s" /* toArray */])(props.value);
  }
  if ('defaultValue' in props && useDefaultValue) {
    value = Object(__WEBPACK_IMPORTED_MODULE_15__util__["s" /* toArray */])(props.defaultValue);
  }
  if (props.labelInValue) {
    value = value.map(function (v) {
      return v.key;
    });
  }
  return value;
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onInputChange = function (event) {
    var tokenSeparators = _this2.props.tokenSeparators;

    var val = event.target.value;
    if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["m" /* isMultipleOrTags */])(_this2.props) && tokenSeparators.length && Object(__WEBPACK_IMPORTED_MODULE_15__util__["k" /* includesSeparators */])(val, tokenSeparators)) {
      var nextValue = _this2.getValueByInput(val);
      if (nextValue !== undefined) {
        _this2.fireChange(nextValue);
      }
      _this2.setOpenState(false, true);
      _this2.setInputValue('', false);
      return;
    }
    _this2.setInputValue(val);
    _this2.setState({
      open: true
    });
    if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["l" /* isCombobox */])(_this2.props)) {
      _this2.fireChange([val]);
    }
  };

  this.onDropdownVisibleChange = function (open) {
    if (open && !_this2._focused) {
      _this2.clearBlurTime();
      _this2.timeoutFocus();
      _this2._focused = true;
      _this2.updateFocusClassName();
    }
    _this2.setOpenState(open);
  };

  this.onKeyDown = function (event) {
    var props = _this2.props;
    if (props.disabled) {
      return;
    }
    var keyCode = event.keyCode;
    if (_this2.state.open && !_this2.getInputDOMNode()) {
      _this2.onInputKeyDown(event);
    } else if (keyCode === __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].ENTER || keyCode === __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].DOWN) {
      _this2.setOpenState(true);
      event.preventDefault();
    }
  };

  this.onInputKeyDown = function (event) {
    var props = _this2.props;
    if (props.disabled) {
      return;
    }
    var state = _this2.state;
    var keyCode = event.keyCode;
    if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["m" /* isMultipleOrTags */])(props) && !event.target.value && keyCode === __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].BACKSPACE) {
      event.preventDefault();
      var value = state.value;

      if (value.length) {
        _this2.removeSelected(value[value.length - 1]);
      }
      return;
    }
    if (keyCode === __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].DOWN) {
      if (!state.open) {
        _this2.openIfHasChildren();
        event.preventDefault();
        event.stopPropagation();
        return;
      }
    } else if (keyCode === __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].ENTER && state.open) {
      // Aviod trigger form submit when select item
      // https://github.com/ant-design/ant-design/issues/10861
      event.preventDefault();
    } else if (keyCode === __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].ESC) {
      if (state.open) {
        _this2.setOpenState(false);
        event.preventDefault();
        event.stopPropagation();
      }
      return;
    }

    if (state.open) {
      var menu = _this2.selectTriggerRef.getInnerMenu();
      if (menu && menu.onKeyDown(event, _this2.handleBackfill)) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  };

  this.onMenuSelect = function (_ref) {
    var item = _ref.item;

    if (!item) {
      return;
    }
    var value = _this2.state.value;
    var props = _this2.props;
    var selectedValue = Object(__WEBPACK_IMPORTED_MODULE_15__util__["j" /* getValuePropValue */])(item);
    var lastValue = value[value.length - 1];
    _this2.fireSelect(selectedValue);
    if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["m" /* isMultipleOrTags */])(props)) {
      if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["e" /* findIndexInValueBySingleValue */])(value, selectedValue) !== -1) {
        return;
      }
      value = value.concat([selectedValue]);
    } else {
      if (lastValue && lastValue === selectedValue && selectedValue !== _this2.state.backfillValue) {
        _this2.setOpenState(false, true);
        return;
      }
      value = [selectedValue];
      _this2.setOpenState(false, true);
    }
    _this2.fireChange(value);
    var inputValue = void 0;
    if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["l" /* isCombobox */])(props)) {
      inputValue = Object(__WEBPACK_IMPORTED_MODULE_15__util__["h" /* getPropValue */])(item, props.optionLabelProp);
    } else {
      inputValue = '';
    }
    if (props.autoClearSearchValue) {
      _this2.setInputValue(inputValue, false);
    }
  };

  this.onMenuDeselect = function (_ref2) {
    var item = _ref2.item,
        domEvent = _ref2.domEvent;

    if (domEvent.type === 'click') {
      _this2.removeSelected(Object(__WEBPACK_IMPORTED_MODULE_15__util__["j" /* getValuePropValue */])(item));
    }
    var props = _this2.props;

    if (props.autoClearSearchValue) {
      _this2.setInputValue('', false);
    }
  };

  this.onArrowClick = function (e) {
    e.stopPropagation();
    e.preventDefault();
    if (!_this2.props.disabled) {
      _this2.setOpenState(!_this2.state.open, !_this2.state.open);
    }
  };

  this.onPlaceholderClick = function () {
    if (_this2.getInputDOMNode()) {
      _this2.getInputDOMNode().focus();
    }
  };

  this.onOuterFocus = function (e) {
    if (_this2.props.disabled) {
      e.preventDefault();
      return;
    }
    _this2.clearBlurTime();
    if (!Object(__WEBPACK_IMPORTED_MODULE_15__util__["n" /* isMultipleOrTagsOrCombobox */])(_this2.props) && e.target === _this2.getInputDOMNode()) {
      return;
    }
    if (_this2._focused) {
      return;
    }
    _this2._focused = true;
    _this2.updateFocusClassName();
    _this2.timeoutFocus();
  };

  this.onPopupFocus = function () {
    // fix ie scrollbar, focus element again
    _this2.maybeFocus(true, true);
  };

  this.onOuterBlur = function (e) {
    if (_this2.props.disabled) {
      e.preventDefault();
      return;
    }
    _this2.blurTimer = setTimeout(function () {
      _this2._focused = false;
      _this2.updateFocusClassName();
      var props = _this2.props;
      var value = _this2.state.value;
      var inputValue = _this2.state.inputValue;

      if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["o" /* isSingleMode */])(props) && props.showSearch && inputValue && props.defaultActiveFirstOption) {
        var options = _this2._options || [];
        if (options.length) {
          var firstOption = Object(__WEBPACK_IMPORTED_MODULE_15__util__["d" /* findFirstMenuItem */])(options);
          if (firstOption) {
            value = [Object(__WEBPACK_IMPORTED_MODULE_15__util__["j" /* getValuePropValue */])(firstOption)];
            _this2.fireChange(value);
          }
        }
      } else if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["m" /* isMultipleOrTags */])(props) && inputValue) {
        // why not use setState?
        _this2.state.inputValue = _this2.getInputDOMNode().value = '';

        value = _this2.getValueByInput(inputValue);
        if (value !== undefined) {
          _this2.fireChange(value);
        }
      }
      props.onBlur(_this2.getVLForOnChange(value));
      _this2.setOpenState(false);
    }, 10);
  };

  this.onClearSelection = function (event) {
    var props = _this2.props;
    var state = _this2.state;
    if (props.disabled) {
      return;
    }
    var inputValue = state.inputValue,
        value = state.value;

    event.stopPropagation();
    if (inputValue || value.length) {
      if (value.length) {
        _this2.fireChange([]);
      }
      _this2.setOpenState(false, true);
      if (inputValue) {
        _this2.setInputValue('');
      }
    }
  };

  this.onChoiceAnimationLeave = function () {
    _this2.forcePopupAlign();
  };

  this.getOptionInfoBySingleValue = function (value, optionsInfo) {
    var info = void 0;
    optionsInfo = optionsInfo || _this2.state.optionsInfo;
    if (optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_15__util__["g" /* getMapKey */])(value)]) {
      info = optionsInfo[Object(__WEBPACK_IMPORTED_MODULE_15__util__["g" /* getMapKey */])(value)];
    }
    if (info) {
      return info;
    }
    var defaultLabel = value;
    if (_this2.props.labelInValue) {
      var label = Object(__WEBPACK_IMPORTED_MODULE_15__util__["f" /* getLabelFromPropsValue */])(_this2.props.value, value);
      if (label !== undefined) {
        defaultLabel = label;
      }
    }
    var defaultInfo = {
      option: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_14__Option__["a" /* default */],
        { value: value, key: value },
        value
      ),
      value: value,
      label: defaultLabel
    };
    return defaultInfo;
  };

  this.getOptionBySingleValue = function (value) {
    var _getOptionInfoBySingl = _this2.getOptionInfoBySingleValue(value),
        option = _getOptionInfoBySingl.option;

    return option;
  };

  this.getOptionsBySingleValue = function (values) {
    return values.map(function (value) {
      return _this2.getOptionBySingleValue(value);
    });
  };

  this.getValueByLabel = function (label) {
    if (label === undefined) {
      return null;
    }
    var value = null;
    Object.keys(_this2.state.optionsInfo).forEach(function (key) {
      var info = _this2.state.optionsInfo[key];
      if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["s" /* toArray */])(info.label).join('') === label) {
        value = info.value;
      }
    });
    return value;
  };

  this.getVLBySingleValue = function (value) {
    if (_this2.props.labelInValue) {
      return {
        key: value,
        label: _this2.getLabelBySingleValue(value)
      };
    }
    return value;
  };

  this.getVLForOnChange = function (vls_) {
    var vls = vls_;
    if (vls !== undefined) {
      if (!_this2.props.labelInValue) {
        vls = vls.map(function (v) {
          return v;
        });
      } else {
        vls = vls.map(function (vl) {
          return {
            key: vl,
            label: _this2.getLabelBySingleValue(vl)
          };
        });
      }
      return Object(__WEBPACK_IMPORTED_MODULE_15__util__["m" /* isMultipleOrTags */])(_this2.props) ? vls : vls[0];
    }
    return vls;
  };

  this.getLabelBySingleValue = function (value, optionsInfo) {
    var _getOptionInfoBySingl2 = _this2.getOptionInfoBySingleValue(value, optionsInfo),
        label = _getOptionInfoBySingl2.label;

    return label;
  };

  this.getDropdownContainer = function () {
    if (!_this2.dropdownContainer) {
      _this2.dropdownContainer = document.createElement('div');
      document.body.appendChild(_this2.dropdownContainer);
    }
    return _this2.dropdownContainer;
  };

  this.getPlaceholderElement = function () {
    var props = _this2.props,
        state = _this2.state;

    var hidden = false;
    if (state.inputValue) {
      hidden = true;
    }
    if (state.value.length) {
      hidden = true;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["l" /* isCombobox */])(props) && state.value.length === 1 && !state.value[0]) {
      hidden = false;
    }
    var placeholder = props.placeholder;
    if (placeholder) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          onMouseDown: __WEBPACK_IMPORTED_MODULE_15__util__["p" /* preventDefaultEvent */],
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            display: hidden ? 'none' : 'block'
          }, __WEBPACK_IMPORTED_MODULE_15__util__["b" /* UNSELECTABLE_STYLE */])
        }, __WEBPACK_IMPORTED_MODULE_15__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
          onClick: _this2.onPlaceholderClick,
          className: props.prefixCls + '-selection__placeholder'
        }),
        placeholder
      );
    }
    return null;
  };

  this.getInputElement = function () {
    var _classnames;

    var props = _this2.props;
    var inputElement = props.getInputElement ? props.getInputElement() : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input', { id: props.id, autoComplete: 'off' });
    var inputCls = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(inputElement.props.className, (_classnames = {}, _classnames[props.prefixCls + '-search__field'] = true, _classnames));
    // https://github.com/ant-design/ant-design/issues/4992#issuecomment-281542159
    // Add space to the end of the inputValue as the width measurement tolerance
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      { className: props.prefixCls + '-search__field__wrap' },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(inputElement, {
        ref: _this2.saveInputRef,
        onChange: _this2.onInputChange,
        onKeyDown: chaining(_this2.onInputKeyDown, inputElement.props.onKeyDown, _this2.props.onInputKeyDown),
        value: _this2.state.inputValue,
        disabled: props.disabled,
        className: inputCls
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'span',
        {
          ref: _this2.saveInputMirrorRef,
          className: props.prefixCls + '-search__field__mirror'
        },
        _this2.state.inputValue,
        '\xA0'
      )
    );
  };

  this.getInputDOMNode = function () {
    return _this2.topCtrlRef ? _this2.topCtrlRef.querySelector('input,textarea,div[contentEditable]') : _this2.inputRef;
  };

  this.getInputMirrorDOMNode = function () {
    return _this2.inputMirrorRef;
  };

  this.getPopupDOMNode = function () {
    return _this2.selectTriggerRef.getPopupDOMNode();
  };

  this.getPopupMenuComponent = function () {
    return _this2.selectTriggerRef.getInnerMenu();
  };

  this.setOpenState = function (open, needFocus) {
    var props = _this2.props,
        state = _this2.state;

    if (state.open === open) {
      _this2.maybeFocus(open, needFocus);
      return;
    }
    var nextState = {
      open: open,
      backfillValue: undefined
    };
    // clear search input value when open is false in singleMode.
    if (!open && Object(__WEBPACK_IMPORTED_MODULE_15__util__["o" /* isSingleMode */])(props) && props.showSearch) {
      _this2.setInputValue('', false);
    }
    if (!open) {
      _this2.maybeFocus(open, needFocus);
    }
    _this2.setState(nextState, function () {
      if (open) {
        _this2.maybeFocus(open, needFocus);
      }
    });
  };

  this.setInputValue = function (inputValue) {
    var fireSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (inputValue !== _this2.state.inputValue) {
      _this2.setState({
        inputValue: inputValue
      }, _this2.forcePopupAlign);
      if (fireSearch) {
        _this2.props.onSearch(inputValue);
      }
    }
  };

  this.getValueByInput = function (string) {
    var _props2 = _this2.props,
        multiple = _props2.multiple,
        tokenSeparators = _props2.tokenSeparators;

    var nextValue = _this2.state.value;
    var hasNewValue = false;
    Object(__WEBPACK_IMPORTED_MODULE_15__util__["r" /* splitBySeparators */])(string, tokenSeparators).forEach(function (label) {
      var selectedValue = [label];
      if (multiple) {
        var value = _this2.getValueByLabel(label);
        if (value && Object(__WEBPACK_IMPORTED_MODULE_15__util__["e" /* findIndexInValueBySingleValue */])(nextValue, value) === -1) {
          nextValue = nextValue.concat(value);
          hasNewValue = true;
          _this2.fireSelect(value);
        }
      } else {
        // tag
        if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["e" /* findIndexInValueBySingleValue */])(nextValue, label) === -1) {
          nextValue = nextValue.concat(selectedValue);
          hasNewValue = true;
          _this2.fireSelect(label);
        }
      }
    });
    return hasNewValue ? nextValue : undefined;
  };

  this.getRealOpenState = function () {
    var open = _this2.state.open;
    var options = _this2._options || [];
    if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["n" /* isMultipleOrTagsOrCombobox */])(_this2.props) || !_this2.props.showSearch) {
      if (open && !options.length) {
        open = false;
      }
    }
    return open;
  };

  this.handleBackfill = function (item) {
    if (!_this2.props.backfill || !(Object(__WEBPACK_IMPORTED_MODULE_15__util__["o" /* isSingleMode */])(_this2.props) || Object(__WEBPACK_IMPORTED_MODULE_15__util__["l" /* isCombobox */])(_this2.props))) {
      return;
    }

    var key = Object(__WEBPACK_IMPORTED_MODULE_15__util__["j" /* getValuePropValue */])(item);

    if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["l" /* isCombobox */])(_this2.props)) {
      _this2.setInputValue(key, false);
    }

    _this2.setState({
      value: [key],
      backfillValue: key
    });
  };

  this.filterOption = function (input, child) {
    var defaultFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_15__util__["c" /* defaultFilterFn */];
    var value = _this2.state.value;

    var lastValue = value[value.length - 1];
    if (!input || lastValue && lastValue === _this2.state.backfillValue) {
      return true;
    }
    var filterFn = _this2.props.filterOption;
    if ('filterOption' in _this2.props) {
      if (_this2.props.filterOption === true) {
        filterFn = defaultFilter;
      }
    } else {
      filterFn = defaultFilter;
    }

    if (!filterFn) {
      return true;
    } else if (typeof filterFn === 'function') {
      return filterFn.call(_this2, input, child);
    } else if (child.props.disabled) {
      return false;
    }
    return true;
  };

  this.timeoutFocus = function () {
    if (_this2.focusTimer) {
      _this2.clearFocusTime();
    }
    _this2.focusTimer = setTimeout(function () {
      _this2.props.onFocus();
    }, 10);
  };

  this.clearFocusTime = function () {
    if (_this2.focusTimer) {
      clearTimeout(_this2.focusTimer);
      _this2.focusTimer = null;
    }
  };

  this.clearBlurTime = function () {
    if (_this2.blurTimer) {
      clearTimeout(_this2.blurTimer);
      _this2.blurTimer = null;
    }
  };

  this.updateFocusClassName = function () {
    var rootRef = _this2.rootRef,
        props = _this2.props;
    // avoid setState and its side effect

    if (_this2._focused) {
      __WEBPACK_IMPORTED_MODULE_11_component_classes___default()(rootRef).add(props.prefixCls + '-focused');
    } else {
      __WEBPACK_IMPORTED_MODULE_11_component_classes___default()(rootRef).remove(props.prefixCls + '-focused');
    }
  };

  this.maybeFocus = function (open, needFocus) {
    if (needFocus || open) {
      var input = _this2.getInputDOMNode();
      var _document = document,
          activeElement = _document.activeElement;

      if (input && (open || Object(__WEBPACK_IMPORTED_MODULE_15__util__["n" /* isMultipleOrTagsOrCombobox */])(_this2.props))) {
        if (activeElement !== input) {
          input.focus();
          _this2._focused = true;
        }
      } else {
        if (activeElement !== _this2.selectionRef) {
          _this2.selectionRef.focus();
          _this2._focused = true;
        }
      }
    }
  };

  this.removeSelected = function (selectedKey, e) {
    var props = _this2.props;
    if (props.disabled || _this2.isChildDisabled(selectedKey)) {
      return;
    }

    // Do not trigger Trigger popup
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }

    var value = _this2.state.value.filter(function (singleValue) {
      return singleValue !== selectedKey;
    });
    var canMultiple = Object(__WEBPACK_IMPORTED_MODULE_15__util__["m" /* isMultipleOrTags */])(props);

    if (canMultiple) {
      var event = selectedKey;
      if (props.labelInValue) {
        event = {
          key: selectedKey,
          label: _this2.getLabelBySingleValue(selectedKey)
        };
      }
      props.onDeselect(event, _this2.getOptionBySingleValue(selectedKey));
    }
    _this2.fireChange(value);
  };

  this.openIfHasChildren = function () {
    var props = _this2.props;
    if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) || Object(__WEBPACK_IMPORTED_MODULE_15__util__["o" /* isSingleMode */])(props)) {
      _this2.setOpenState(true);
    }
  };

  this.fireSelect = function (value) {
    _this2.props.onSelect(_this2.getVLBySingleValue(value), _this2.getOptionBySingleValue(value));
  };

  this.fireChange = function (value) {
    var props = _this2.props;
    if (!('value' in props)) {
      _this2.setState({
        value: value
      }, _this2.forcePopupAlign);
    }
    var vls = _this2.getVLForOnChange(value);
    var options = _this2.getOptionsBySingleValue(value);
    props.onChange(vls, Object(__WEBPACK_IMPORTED_MODULE_15__util__["m" /* isMultipleOrTags */])(_this2.props) ? options : options[0]);
  };

  this.isChildDisabled = function (key) {
    return Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Children_toArray__["a" /* default */])(_this2.props.children).some(function (child) {
      var childValue = Object(__WEBPACK_IMPORTED_MODULE_15__util__["j" /* getValuePropValue */])(child);
      return childValue === key && child.props && child.props.disabled;
    });
  };

  this.forcePopupAlign = function () {
    _this2.selectTriggerRef.triggerRef.forcePopupAlign();
  };

  this.renderFilterOptions = function () {
    var inputValue = _this2.state.inputValue;
    var _props3 = _this2.props,
        children = _props3.children,
        tags = _props3.tags,
        filterOption = _props3.filterOption,
        notFoundContent = _props3.notFoundContent;

    var menuItems = [];
    var childrenKeys = [];
    var options = _this2.renderFilterOptionsFromChildren(children, childrenKeys, menuItems);
    if (tags) {
      // tags value must be string
      var value = _this2.state.value;
      value = value.filter(function (singleValue) {
        return childrenKeys.indexOf(singleValue) === -1 && (!inputValue || String(singleValue).indexOf(String(inputValue)) > -1);
      });
      value.forEach(function (singleValue) {
        var key = singleValue;
        var menuItem = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_rc_menu__["Item"],
          {
            style: __WEBPACK_IMPORTED_MODULE_15__util__["b" /* UNSELECTABLE_STYLE */],
            role: 'option',
            attribute: __WEBPACK_IMPORTED_MODULE_15__util__["a" /* UNSELECTABLE_ATTRIBUTE */],
            value: key,
            key: key
          },
          key
        );
        options.push(menuItem);
        menuItems.push(menuItem);
      });
      if (inputValue) {
        var notFindInputItem = menuItems.every(function (option) {
          // this.filterOption return true has two meaning,
          // 1, some one exists after filtering
          // 2, filterOption is set to false
          // condition 2 does not mean the option has same value with inputValue
          var filterFn = function filterFn() {
            return Object(__WEBPACK_IMPORTED_MODULE_15__util__["j" /* getValuePropValue */])(option) === inputValue;
          };
          if (filterOption !== false) {
            return !_this2.filterOption.call(_this2, inputValue, option, filterFn);
          }
          return !filterFn();
        });
        if (notFindInputItem) {
          options.unshift(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_rc_menu__["Item"],
            {
              style: __WEBPACK_IMPORTED_MODULE_15__util__["b" /* UNSELECTABLE_STYLE */],
              role: 'option',
              attribute: __WEBPACK_IMPORTED_MODULE_15__util__["a" /* UNSELECTABLE_ATTRIBUTE */],
              value: inputValue,
              key: inputValue
            },
            inputValue
          ));
        }
      }
    }

    if (!options.length && notFoundContent) {
      options = [__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_rc_menu__["Item"],
        {
          style: __WEBPACK_IMPORTED_MODULE_15__util__["b" /* UNSELECTABLE_STYLE */],
          attribute: __WEBPACK_IMPORTED_MODULE_15__util__["a" /* UNSELECTABLE_ATTRIBUTE */],
          disabled: true,
          role: 'option',
          value: 'NOT_FOUND',
          key: 'NOT_FOUND'
        },
        notFoundContent
      )];
    }
    return options;
  };

  this.renderFilterOptionsFromChildren = function (children, childrenKeys, menuItems) {
    var sel = [];
    var props = _this2.props;
    var inputValue = _this2.state.inputValue;

    var tags = props.tags;
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.forEach(children, function (child) {
      if (!child) {
        return;
      }
      if (child.type.isSelectOptGroup) {
        var innerItems = _this2.renderFilterOptionsFromChildren(child.props.children, childrenKeys, menuItems);
        if (innerItems.length) {
          var label = child.props.label;
          var key = child.key;
          if (!key && typeof label === 'string') {
            key = label;
          } else if (!label && key) {
            label = key;
          }
          sel.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_rc_menu__["ItemGroup"],
            { key: key, title: label },
            innerItems
          ));
        }
        return;
      }

      __WEBPACK_IMPORTED_MODULE_13_warning___default()(child.type.isSelectOption, 'the children of `Select` should be `Select.Option` or `Select.OptGroup`, ' + ('instead of `' + (child.type.name || child.type.displayName || child.type) + '`.'));

      var childValue = Object(__WEBPACK_IMPORTED_MODULE_15__util__["j" /* getValuePropValue */])(child);

      Object(__WEBPACK_IMPORTED_MODULE_15__util__["u" /* validateOptionValue */])(childValue, _this2.props);

      if (_this2.filterOption(inputValue, child)) {
        var menuItem = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_rc_menu__["Item"], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          style: __WEBPACK_IMPORTED_MODULE_15__util__["b" /* UNSELECTABLE_STYLE */],
          attribute: __WEBPACK_IMPORTED_MODULE_15__util__["a" /* UNSELECTABLE_ATTRIBUTE */],
          value: childValue,
          key: childValue,
          role: 'option'
        }, child.props));
        sel.push(menuItem);
        menuItems.push(menuItem);
      }

      if (tags) {
        childrenKeys.push(childValue);
      }
    });

    return sel;
  };

  this.renderTopControlNode = function () {
    var _state2 = _this2.state,
        value = _state2.value,
        open = _state2.open,
        inputValue = _state2.inputValue;

    var props = _this2.props;
    var choiceTransitionName = props.choiceTransitionName,
        prefixCls = props.prefixCls,
        maxTagTextLength = props.maxTagTextLength,
        maxTagCount = props.maxTagCount,
        maxTagPlaceholder = props.maxTagPlaceholder,
        showSearch = props.showSearch;

    var className = prefixCls + '-selection__rendered';
    // search input is inside topControlNode in single, multiple & combobox. 2016/04/13
    var innerNode = null;
    if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["o" /* isSingleMode */])(props)) {
      var selectedValue = null;
      if (value.length) {
        var showSelectedValue = false;
        var opacity = 1;
        if (!showSearch) {
          showSelectedValue = true;
        } else {
          if (open) {
            showSelectedValue = !inputValue;
            if (showSelectedValue) {
              opacity = 0.4;
            }
          } else {
            showSelectedValue = true;
          }
        }
        var singleValue = value[0];

        var _getOptionInfoBySingl3 = _this2.getOptionInfoBySingleValue(singleValue),
            label = _getOptionInfoBySingl3.label,
            title = _getOptionInfoBySingl3.title;

        selectedValue = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          {
            key: 'value',
            className: prefixCls + '-selection-selected-value',
            title: Object(__WEBPACK_IMPORTED_MODULE_15__util__["t" /* toTitle */])(title || label),
            style: {
              display: showSelectedValue ? 'block' : 'none',
              opacity: opacity
            }
          },
          label
        );
      }
      if (!showSearch) {
        innerNode = [selectedValue];
      } else {
        innerNode = [selectedValue, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          {
            className: prefixCls + '-search ' + prefixCls + '-search--inline',
            key: 'input',
            style: {
              display: open ? 'block' : 'none'
            }
          },
          _this2.getInputElement()
        )];
      }
    } else {
      var selectedValueNodes = [];
      var limitedCountValue = value;
      var maxTagPlaceholderEl = void 0;
      if (maxTagCount !== undefined && value.length > maxTagCount) {
        limitedCountValue = limitedCountValue.slice(0, maxTagCount);
        var omittedValues = _this2.getVLForOnChange(value.slice(maxTagCount, value.length));
        var content = '+ ' + (value.length - maxTagCount) + ' ...';
        if (maxTagPlaceholder) {
          content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
        }
        maxTagPlaceholderEl = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'li',
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            style: __WEBPACK_IMPORTED_MODULE_15__util__["b" /* UNSELECTABLE_STYLE */]
          }, __WEBPACK_IMPORTED_MODULE_15__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
            onMouseDown: __WEBPACK_IMPORTED_MODULE_15__util__["p" /* preventDefaultEvent */],
            className: prefixCls + '-selection__choice ' + prefixCls + '-selection__choice__disabled',
            key: 'maxTagPlaceholder',
            title: Object(__WEBPACK_IMPORTED_MODULE_15__util__["t" /* toTitle */])(content)
          }),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'div',
            { className: prefixCls + '-selection__choice__content' },
            content
          )
        );
      }
      if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["m" /* isMultipleOrTags */])(props)) {
        selectedValueNodes = limitedCountValue.map(function (singleValue) {
          var info = _this2.getOptionInfoBySingleValue(singleValue);
          var content = info.label;
          var title = info.title || content;
          if (maxTagTextLength && typeof content === 'string' && content.length > maxTagTextLength) {
            content = content.slice(0, maxTagTextLength) + '...';
          }
          var disabled = _this2.isChildDisabled(singleValue);
          var choiceClassName = disabled ? prefixCls + '-selection__choice ' + prefixCls + '-selection__choice__disabled' : prefixCls + '-selection__choice';
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'li',
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              style: __WEBPACK_IMPORTED_MODULE_15__util__["b" /* UNSELECTABLE_STYLE */]
            }, __WEBPACK_IMPORTED_MODULE_15__util__["a" /* UNSELECTABLE_ATTRIBUTE */], {
              onMouseDown: __WEBPACK_IMPORTED_MODULE_15__util__["p" /* preventDefaultEvent */],
              className: choiceClassName,
              key: singleValue,
              title: Object(__WEBPACK_IMPORTED_MODULE_15__util__["t" /* toTitle */])(title)
            }),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'div',
              { className: prefixCls + '-selection__choice__content' },
              content
            ),
            disabled ? null : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', {
              className: prefixCls + '-selection__choice__remove',
              onClick: function onClick(event) {
                _this2.removeSelected(singleValue, event);
              }
            })
          );
        });
      }
      if (maxTagPlaceholderEl) {
        selectedValueNodes.push(maxTagPlaceholderEl);
      }
      selectedValueNodes.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'li',
        {
          className: prefixCls + '-search ' + prefixCls + '-search--inline',
          key: '__input'
        },
        _this2.getInputElement()
      ));

      if (Object(__WEBPACK_IMPORTED_MODULE_15__util__["m" /* isMultipleOrTags */])(props) && choiceTransitionName) {
        innerNode = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_rc_animate__["default"],
          {
            onLeave: _this2.onChoiceAnimationLeave,
            component: 'ul',
            transitionName: choiceTransitionName
          },
          selectedValueNodes
        );
      } else {
        innerNode = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'ul',
          null,
          selectedValueNodes
        );
      }
    }
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      { className: className, ref: _this2.saveTopCtrlRef },
      _this2.getPlaceholderElement(),
      innerNode
    );
  };
};

Select.displayName = 'Select';

Object(__WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__["polyfill"])(Select);

/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_trigger__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DropdownMenu__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(191);













__WEBPACK_IMPORTED_MODULE_5_rc_trigger__["default"].displayName = 'Trigger';

var BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ['tl', 'bl'],
    offset: [0, 4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topLeft: {
    points: ['bl', 'tl'],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};

var SelectTrigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SelectTrigger, _React$Component);

  function SelectTrigger(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SelectTrigger);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    _this.saveDropdownMenuRef = Object(__WEBPACK_IMPORTED_MODULE_11__util__["q" /* saveRef */])(_this, 'dropdownMenuRef');
    _this.saveTriggerRef = Object(__WEBPACK_IMPORTED_MODULE_11__util__["q" /* saveRef */])(_this, 'triggerRef');

    _this.state = {
      dropdownWidth: null
    };
    return _this;
  }

  SelectTrigger.prototype.componentDidMount = function componentDidMount() {
    this.setDropdownWidth();
  };

  SelectTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setDropdownWidth();
  };

  SelectTrigger.prototype.render = function render() {
    var _popupClassName;

    var _props = this.props,
        onPopupFocus = _props.onPopupFocus,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onPopupFocus']);

    var multiple = props.multiple,
        visible = props.visible,
        inputValue = props.inputValue,
        dropdownAlign = props.dropdownAlign,
        disabled = props.disabled,
        showSearch = props.showSearch,
        dropdownClassName = props.dropdownClassName,
        dropdownStyle = props.dropdownStyle,
        dropdownMatchSelectWidth = props.dropdownMatchSelectWidth;

    var dropdownPrefixCls = this.getDropdownPrefixCls();
    var popupClassName = (_popupClassName = {}, _popupClassName[dropdownClassName] = !!dropdownClassName, _popupClassName[dropdownPrefixCls + '--' + (multiple ? 'multiple' : 'single')] = 1, _popupClassName);
    var popupElement = this.getDropdownElement({
      menuItems: props.options,
      onPopupFocus: onPopupFocus,
      multiple: multiple,
      inputValue: inputValue,
      visible: visible
    });
    var hideAction = void 0;
    if (disabled) {
      hideAction = [];
    } else if (Object(__WEBPACK_IMPORTED_MODULE_11__util__["o" /* isSingleMode */])(props) && !showSearch) {
      hideAction = ['click'];
    } else {
      hideAction = ['blur'];
    }
    var popupStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, dropdownStyle);
    var widthProp = dropdownMatchSelectWidth ? 'width' : 'minWidth';
    if (this.state.dropdownWidth) {
      popupStyle[widthProp] = this.state.dropdownWidth + 'px';
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_rc_trigger__["default"],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        showAction: disabled ? [] : this.props.showAction,
        hideAction: hideAction,
        ref: this.saveTriggerRef,
        popupPlacement: 'bottomLeft',
        builtinPlacements: BUILT_IN_PLACEMENTS,
        prefixCls: dropdownPrefixCls,
        popupTransitionName: this.getDropdownTransitionName(),
        onPopupVisibleChange: props.onDropdownVisibleChange,
        popup: popupElement,
        popupAlign: dropdownAlign,
        popupVisible: visible,
        getPopupContainer: props.getPopupContainer,
        popupClassName: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(popupClassName),
        popupStyle: popupStyle
      }),
      props.children
    );
  };

  return SelectTrigger;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

SelectTrigger.propTypes = {
  onPopupFocus: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onPopupScroll: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  dropdownMatchSelectWidth: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  dropdownAlign: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  visible: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  showSearch: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  dropdownClassName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  multiple: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  inputValue: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  filterOption: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  options: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  showAction: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string)
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.setDropdownWidth = function () {
    var width = __WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.findDOMNode(_this2).offsetWidth;
    if (width !== _this2.state.dropdownWidth) {
      _this2.setState({ dropdownWidth: width });
    }
  };

  this.getInnerMenu = function () {
    return _this2.dropdownMenuRef && _this2.dropdownMenuRef.menuRef;
  };

  this.getPopupDOMNode = function () {
    return _this2.triggerRef.getPopupDomNode();
  };

  this.getDropdownElement = function (newProps) {
    var props = _this2.props;
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__DropdownMenu__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      ref: _this2.saveDropdownMenuRef
    }, newProps, {
      prefixCls: _this2.getDropdownPrefixCls(),
      onMenuSelect: props.onMenuSelect,
      onMenuDeselect: props.onMenuDeselect,
      onPopupScroll: props.onPopupScroll,
      value: props.value,
      backfillValue: props.backfillValue,
      firstActiveValue: props.firstActiveValue,
      defaultActiveFirstOption: props.defaultActiveFirstOption,
      dropdownMenuStyle: props.dropdownMenuStyle
    }));
  };

  this.getDropdownTransitionName = function () {
    var props = _this2.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = _this2.getDropdownPrefixCls() + '-' + props.animation;
    }
    return transitionName;
  };

  this.getDropdownPrefixCls = function () {
    return _this2.props.prefixCls + '-dropdown';
  };
};

/* harmony default export */ __webpack_exports__["a"] = (SelectTrigger);


SelectTrigger.displayName = 'SelectTrigger';

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Children_toArray__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_menu__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raf__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(191);













var DropdownMenu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DropdownMenu);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    _this.lastInputValue = props.inputValue;
    _this.saveMenuRef = Object(__WEBPACK_IMPORTED_MODULE_11__util__["q" /* saveRef */])(_this, 'menuRef');
    return _this;
  }

  DropdownMenu.prototype.componentDidMount = function componentDidMount() {
    this.scrollActiveItemToView();
    this.lastVisible = this.props.visible;
  };

  DropdownMenu.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    if (!nextProps.visible) {
      this.lastVisible = false;
    }
    // freeze when hide
    return nextProps.visible;
  };

  DropdownMenu.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var props = this.props;
    if (!prevProps.visible && props.visible) {
      this.scrollActiveItemToView();
    }
    this.lastVisible = props.visible;
    this.lastInputValue = props.inputValue;
  };

  DropdownMenu.prototype.renderMenu = function renderMenu() {
    var _this2 = this;

    var props = this.props;
    var menuItems = props.menuItems,
        defaultActiveFirstOption = props.defaultActiveFirstOption,
        value = props.value,
        prefixCls = props.prefixCls,
        multiple = props.multiple,
        onMenuSelect = props.onMenuSelect,
        inputValue = props.inputValue,
        firstActiveValue = props.firstActiveValue,
        backfillValue = props.backfillValue;

    if (menuItems && menuItems.length) {
      var menuProps = {};
      if (multiple) {
        menuProps.onDeselect = props.onMenuDeselect;
        menuProps.onSelect = onMenuSelect;
      } else {
        menuProps.onClick = onMenuSelect;
      }

      var selectedKeys = Object(__WEBPACK_IMPORTED_MODULE_11__util__["i" /* getSelectKeys */])(menuItems, value);
      var activeKeyProps = {};

      var clonedMenuItems = menuItems;
      if (selectedKeys.length || firstActiveValue) {
        if (props.visible && !this.lastVisible) {
          activeKeyProps.activeKey = selectedKeys[0] || firstActiveValue;
        }
        var foundFirst = false;
        // set firstActiveItem via cloning menus
        // for scroll into view
        var clone = function clone(item) {
          if (!foundFirst && selectedKeys.indexOf(item.key) !== -1 || !foundFirst && !selectedKeys.length && firstActiveValue.indexOf(item.key) !== -1) {
            foundFirst = true;
            return Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(item, {
              ref: function ref(_ref) {
                _this2.firstActiveItem = _ref;
              }
            });
          }
          return item;
        };

        clonedMenuItems = menuItems.map(function (item) {
          if (item.type.isMenuItemGroup) {
            var children = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Children_toArray__["a" /* default */])(item.props.children).map(clone);
            return Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(item, {}, children);
          }
          return clone(item);
        });
      } else {
        // Clear firstActiveItem when dropdown menu items was empty
        // Avoid `Unable to find node on an unmounted component`
        // https://github.com/ant-design/ant-design/issues/10774
        this.firstActiveItem = null;
      }

      // clear activeKey when inputValue change
      var lastValue = value && value[value.length - 1];
      if (inputValue !== this.lastInputValue && (!lastValue || lastValue !== backfillValue)) {
        activeKeyProps.activeKey = '';
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_menu__["default"],
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          ref: this.saveMenuRef,
          style: this.props.dropdownMenuStyle,
          defaultActiveFirst: defaultActiveFirstOption,
          role: 'listbox'
        }, activeKeyProps, {
          multiple: multiple
        }, menuProps, {
          selectedKeys: selectedKeys,
          prefixCls: prefixCls + '-menu'
        }),
        clonedMenuItems
      );
    }
    return null;
  };

  DropdownMenu.prototype.render = function render() {
    var renderMenu = this.renderMenu();
    return renderMenu ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      {
        style: { overflow: 'auto' },
        onFocus: this.props.onPopupFocus,
        onMouseDown: __WEBPACK_IMPORTED_MODULE_11__util__["p" /* preventDefaultEvent */],
        onScroll: this.props.onPopupScroll
      },
      renderMenu
    ) : null;
  };

  return DropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

DropdownMenu.propTypes = {
  defaultActiveFirstOption: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  dropdownMenuStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onPopupFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onPopupScroll: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMenuDeSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMenuSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  menuItems: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  inputValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.scrollActiveItemToView = function () {
    // scroll into view
    var itemComponent = Object(__WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"])(_this3.firstActiveItem);
    var props = _this3.props;

    if (itemComponent) {
      var scrollIntoViewOpts = {
        onlyScrollIfNeeded: true
      };
      if ((!props.value || props.value.length === 0) && props.firstActiveValue) {
        scrollIntoViewOpts.alignWithTop = true;
      }

      // Delay to scroll since current frame item position is not ready when pre view is by filter
      // https://github.com/ant-design/ant-design/issues/11268#issuecomment-406634462
      __WEBPACK_IMPORTED_MODULE_10_raf___default()(function () {
        __WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view___default()(itemComponent, Object(__WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"])(_this3.menuRef), scrollIntoViewOpts);
      });
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (DropdownMenu);


DropdownMenu.displayName = 'DropdownMenu';

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);





var OptGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(OptGroup, _React$Component);

  function OptGroup() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, OptGroup);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  return OptGroup;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

OptGroup.isSelectOptGroup = true;
/* harmony default export */ __webpack_exports__["a"] = (OptGroup);

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _select = __webpack_require__(16);

var _select2 = _interopRequireDefault(_select);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MiniSelect = function (_React$Component) {
    (0, _inherits3['default'])(MiniSelect, _React$Component);

    function MiniSelect() {
        (0, _classCallCheck3['default'])(this, MiniSelect);
        return (0, _possibleConstructorReturn3['default'])(this, (MiniSelect.__proto__ || Object.getPrototypeOf(MiniSelect)).apply(this, arguments));
    }

    (0, _createClass3['default'])(MiniSelect, [{
        key: 'render',
        value: function render() {
            return React.createElement(_select2['default'], (0, _extends3['default'])({ size: 'small' }, this.props));
        }
    }]);
    return MiniSelect;
}(React.Component);

exports['default'] = MiniSelect;

MiniSelect.Option = _select2['default'].Option;
module.exports = exports['default'];

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(15);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _rcMenu = __webpack_require__(79);

var _rcMenu2 = _interopRequireDefault(_rcMenu);

var _domClosest = __webpack_require__(824);

var _domClosest2 = _interopRequireDefault(_domClosest);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _shallowequal = __webpack_require__(52);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _dropdown = __webpack_require__(121);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _icon = __webpack_require__(6);

var _icon2 = _interopRequireDefault(_icon);

var _checkbox = __webpack_require__(46);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _radio = __webpack_require__(96);

var _radio2 = _interopRequireDefault(_radio);

var _FilterDropdownMenuWrapper = __webpack_require__(840);

var _FilterDropdownMenuWrapper2 = _interopRequireDefault(_FilterDropdownMenuWrapper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var FilterMenu = function (_React$Component) {
    (0, _inherits3['default'])(FilterMenu, _React$Component);

    function FilterMenu(props) {
        (0, _classCallCheck3['default'])(this, FilterMenu);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (FilterMenu.__proto__ || Object.getPrototypeOf(FilterMenu)).call(this, props));

        _this.setNeverShown = function (column) {
            var rootNode = ReactDOM.findDOMNode(_this);
            var filterBelongToScrollBody = !!(0, _domClosest2['default'])(rootNode, '.ant-table-scroll');
            if (filterBelongToScrollBody) {
                // When fixed column have filters, there will be two dropdown menus
                // Filter dropdown menu inside scroll body should never be shown
                // To fix https://github.com/ant-design/ant-design/issues/5010 and
                // https://github.com/ant-design/ant-design/issues/7909
                _this.neverShown = !!column.fixed;
            }
        };
        _this.setSelectedKeys = function (_ref) {
            var selectedKeys = _ref.selectedKeys;

            _this.setState({ selectedKeys: selectedKeys });
        };
        _this.handleClearFilters = function () {
            _this.setState({
                selectedKeys: []
            }, _this.handleConfirm);
        };
        _this.handleConfirm = function () {
            _this.setVisible(false);
            _this.confirmFilter();
        };
        _this.onVisibleChange = function (visible) {
            _this.setVisible(visible);
            if (!visible) {
                _this.confirmFilter();
            }
        };
        _this.handleMenuItemClick = function (info) {
            if (!info.keyPath || info.keyPath.length <= 1) {
                return;
            }
            var keyPathOfSelectedItem = _this.state.keyPathOfSelectedItem;
            if (_this.state.selectedKeys.indexOf(info.key) >= 0) {
                // deselect SubMenu child
                delete keyPathOfSelectedItem[info.key];
            } else {
                // select SubMenu child
                keyPathOfSelectedItem[info.key] = info.keyPath;
            }
            _this.setState({ keyPathOfSelectedItem: keyPathOfSelectedItem });
        };
        _this.renderFilterIcon = function () {
            var _this$props = _this.props,
                column = _this$props.column,
                locale = _this$props.locale,
                prefixCls = _this$props.prefixCls;

            var filterd = _this.props.selectedKeys.length > 0;
            var filterIcon = column.filterIcon;
            if (typeof filterIcon === 'function') {
                filterIcon = filterIcon(filterd);
            }
            var dropdownSelectedClass = filterd ? prefixCls + '-selected' : '';
            return filterIcon ? React.cloneElement(filterIcon, {
                title: locale.filterTitle,
                className: (0, _classnames2['default'])(prefixCls + '-icon', filterIcon.props.className)
            }) : React.createElement(_icon2['default'], { title: locale.filterTitle, type: 'filter', className: dropdownSelectedClass });
        };
        var visible = 'filterDropdownVisible' in props.column ? props.column.filterDropdownVisible : false;
        _this.state = {
            selectedKeys: props.selectedKeys,
            keyPathOfSelectedItem: {},
            visible: visible
        };
        return _this;
    }

    (0, _createClass3['default'])(FilterMenu, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var column = this.props.column;

            this.setNeverShown(column);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var column = nextProps.column;

            this.setNeverShown(column);
            var newState = {};
            /**
             * if the state is visible the component should ignore updates on selectedKeys prop to avoid
             * that the user selection is lost
             * this happens frequently when a table is connected on some sort of realtime data
             * Fixes https://github.com/ant-design/ant-design/issues/10289 and
             * https://github.com/ant-design/ant-design/issues/10209
             */
            if ('selectedKeys' in nextProps && !(0, _shallowequal2['default'])(this.props.selectedKeys, nextProps.selectedKeys)) {
                newState.selectedKeys = nextProps.selectedKeys;
            }
            if ('filterDropdownVisible' in column) {
                newState.visible = column.filterDropdownVisible;
            }
            if (Object.keys(newState).length > 0) {
                this.setState(newState);
            }
        }
    }, {
        key: 'setVisible',
        value: function setVisible(visible) {
            var column = this.props.column;

            if (!('filterDropdownVisible' in column)) {
                this.setState({ visible: visible });
            }
            if (column.onFilterDropdownVisibleChange) {
                column.onFilterDropdownVisibleChange(visible);
            }
        }
    }, {
        key: 'confirmFilter',
        value: function confirmFilter() {
            var selectedKeys = this.state.selectedKeys;

            if (!(0, _shallowequal2['default'])(selectedKeys, this.props.selectedKeys)) {
                this.props.confirmFilter(this.props.column, selectedKeys);
            }
        }
    }, {
        key: 'renderMenuItem',
        value: function renderMenuItem(item) {
            var column = this.props.column;
            var selectedKeys = this.state.selectedKeys;

            var multiple = 'filterMultiple' in column ? column.filterMultiple : true;
            var input = multiple ? React.createElement(_checkbox2['default'], { checked: selectedKeys.indexOf(item.value.toString()) >= 0 }) : React.createElement(_radio2['default'], { checked: selectedKeys.indexOf(item.value.toString()) >= 0 });
            return React.createElement(
                _rcMenu.Item,
                { key: item.value },
                input,
                React.createElement(
                    'span',
                    null,
                    item.text
                )
            );
        }
    }, {
        key: 'hasSubMenu',
        value: function hasSubMenu() {
            var _props$column$filters = this.props.column.filters,
                filters = _props$column$filters === undefined ? [] : _props$column$filters;

            return filters.some(function (item) {
                return !!(item.children && item.children.length > 0);
            });
        }
    }, {
        key: 'renderMenus',
        value: function renderMenus(items) {
            var _this2 = this;

            return items.map(function (item) {
                if (item.children && item.children.length > 0) {
                    var keyPathOfSelectedItem = _this2.state.keyPathOfSelectedItem;

                    var containSelected = Object.keys(keyPathOfSelectedItem).some(function (key) {
                        return keyPathOfSelectedItem[key].indexOf(item.value) >= 0;
                    });
                    var subMenuCls = containSelected ? _this2.props.dropdownPrefixCls + '-submenu-contain-selected' : '';
                    return React.createElement(
                        _rcMenu.SubMenu,
                        { title: item.text, className: subMenuCls, key: item.value.toString() },
                        _this2.renderMenus(item.children)
                    );
                }
                return _this2.renderMenuItem(item);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                column = _props.column,
                locale = _props.locale,
                prefixCls = _props.prefixCls,
                dropdownPrefixCls = _props.dropdownPrefixCls,
                getPopupContainer = _props.getPopupContainer;
            // default multiple selection in filter dropdown

            var multiple = 'filterMultiple' in column ? column.filterMultiple : true;
            var dropdownMenuClass = (0, _classnames2['default'])((0, _defineProperty3['default'])({}, dropdownPrefixCls + '-menu-without-submenu', !this.hasSubMenu()));
            var filterDropdown = column.filterDropdown;

            if (filterDropdown && typeof filterDropdown === 'function') {
                filterDropdown = filterDropdown({
                    prefixCls: dropdownPrefixCls + '-custom',
                    setSelectedKeys: function setSelectedKeys(selectedKeys) {
                        return _this3.setSelectedKeys({ selectedKeys: selectedKeys });
                    },
                    selectedKeys: this.state.selectedKeys,
                    confirm: this.handleConfirm,
                    clearFilters: this.handleClearFilters,
                    filters: column.filters,
                    getPopupContainer: function getPopupContainer(triggerNode) {
                        return triggerNode.parentNode;
                    }
                });
            }
            var menus = filterDropdown ? React.createElement(
                _FilterDropdownMenuWrapper2['default'],
                null,
                filterDropdown
            ) : React.createElement(
                _FilterDropdownMenuWrapper2['default'],
                { className: prefixCls + '-dropdown' },
                React.createElement(
                    _rcMenu2['default'],
                    { multiple: multiple, onClick: this.handleMenuItemClick, prefixCls: dropdownPrefixCls + '-menu', className: dropdownMenuClass, onSelect: this.setSelectedKeys, onDeselect: this.setSelectedKeys, selectedKeys: this.state.selectedKeys, getPopupContainer: function getPopupContainer(triggerNode) {
                            return triggerNode.parentNode;
                        } },
                    this.renderMenus(column.filters)
                ),
                React.createElement(
                    'div',
                    { className: prefixCls + '-dropdown-btns' },
                    React.createElement(
                        'a',
                        { className: prefixCls + '-dropdown-link confirm', onClick: this.handleConfirm },
                        locale.filterConfirm
                    ),
                    React.createElement(
                        'a',
                        { className: prefixCls + '-dropdown-link clear', onClick: this.handleClearFilters },
                        locale.filterReset
                    )
                )
            );
            return React.createElement(
                _dropdown2['default'],
                { trigger: ['click'], overlay: menus, visible: this.neverShown ? false : this.state.visible, onVisibleChange: this.onVisibleChange, getPopupContainer: getPopupContainer, forceRender: true },
                this.renderFilterIcon()
            );
        }
    }]);
    return FilterMenu;
}(React.Component);

exports['default'] = FilterMenu;

FilterMenu.defaultProps = {
    handleFilter: function handleFilter() {},

    column: {}
};
module.exports = exports['default'];

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var matches = __webpack_require__(825);

/**
 * @param element {Element}
 * @param selector {String}
 * @param context {Element}
 * @return {Element}
 */
module.exports = function (element, selector, context) {
  context = context || document;
  // guard against orphans
  element = { parentNode: element };

  while ((element = element.parentNode) && element !== context) {
    if (matches(element, selector)) {
      return element;
    }
  }
};


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determine if a DOM element matches a CSS selector
 *
 * @param {Element} elem
 * @param {String} selector
 * @return {Boolean}
 * @api public
 */

function matches(elem, selector) {
  // Vendor-specific implementations of `Element.prototype.matches()`.
  var proto = window.Element.prototype;
  var nativeMatches = proto.matches ||
      proto.mozMatchesSelector ||
      proto.msMatchesSelector ||
      proto.oMatchesSelector ||
      proto.webkitMatchesSelector;

  if (!elem || elem.nodeType !== 1) {
    return false;
  }

  var parentElem = elem.parentNode;

  // use native 'matches'
  if (nativeMatches) {
    return nativeMatches.call(elem, selector);
  }

  // native support for `matches` is missing and a fallback is required
  var nodes = parentElem.querySelectorAll(selector);
  var len = nodes.length;

  for (var i = 0; i < len; i++) {
    if (nodes[i] === elem) {
      return true;
    }
  }

  return false;
}

/**
 * Expose `matches`
 */

module.exports = matches;


/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropdown__ = __webpack_require__(827);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Dropdown__["a" /* default */]);

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_trigger__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__placements__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lifecycles_compat__ = __webpack_require__(54);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown(props) {
    _classCallCheck(this, Dropdown);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    if ('visible' in props) {
      _this.state = {
        visible: props.visible
      };
    } else {
      _this.state = {
        visible: props.defaultVisible
      };
    }
    return _this;
  }

  Dropdown.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
    if ('visible' in nextProps) {
      return {
        visible: nextProps.visible
      };
    }
    return null;
  };

  Dropdown.prototype.getMenuElement = function getMenuElement() {
    var _props = this.props,
        overlay = _props.overlay,
        prefixCls = _props.prefixCls;

    var extraOverlayProps = {
      prefixCls: prefixCls + '-menu',
      onClick: this.onClick
    };
    if (typeof overlay.type === 'string') {
      delete extraOverlayProps.prefixCls;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(overlay, extraOverlayProps);
  };

  Dropdown.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Dropdown.prototype.render = function render() {
    var _props2 = this.props,
        prefixCls = _props2.prefixCls,
        children = _props2.children,
        transitionName = _props2.transitionName,
        animation = _props2.animation,
        align = _props2.align,
        placement = _props2.placement,
        getPopupContainer = _props2.getPopupContainer,
        showAction = _props2.showAction,
        hideAction = _props2.hideAction,
        overlayClassName = _props2.overlayClassName,
        overlayStyle = _props2.overlayStyle,
        trigger = _props2.trigger,
        otherProps = _objectWithoutProperties(_props2, ['prefixCls', 'children', 'transitionName', 'animation', 'align', 'placement', 'getPopupContainer', 'showAction', 'hideAction', 'overlayClassName', 'overlayStyle', 'trigger']);

    var triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf('contextMenu') !== -1) {
      triggerHideAction = ['click'];
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_rc_trigger__["default"],
      _extends({}, otherProps, {
        prefixCls: prefixCls,
        ref: this.saveTrigger,
        popupClassName: overlayClassName,
        popupStyle: overlayStyle,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_4__placements__["a" /* default */],
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction || [],
        popupPlacement: placement,
        popupAlign: align,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupVisible: this.state.visible,
        afterPopupVisibleChange: this.afterVisibleChange,
        popup: this.getMenuElement(),
        onPopupVisibleChange: this.onVisibleChange,
        getPopupContainer: getPopupContainer
      }),
      children
    );
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Dropdown.propTypes = {
  minOverlayWidthMatchTrigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onOverlayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  animation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  overlay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  trigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  alignPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showAction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  hideAction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
Dropdown.defaultProps = {
  prefixCls: 'rc-dropdown',
  trigger: ['hover'],
  showAction: [],
  overlayClassName: '',
  overlayStyle: {},
  defaultVisible: false,
  onVisibleChange: function onVisibleChange() {},

  placement: 'bottomLeft'
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onClick = function (e) {
    var props = _this2.props;
    var overlayProps = props.overlay.props;
    // do no call onVisibleChange, if you need click to hide, use onClick and control visible
    if (!('visible' in props)) {
      _this2.setState({
        visible: false
      });
    }
    if (props.onOverlayClick) {
      props.onOverlayClick(e);
    }
    if (overlayProps.onClick) {
      overlayProps.onClick(e);
    }
  };

  this.onVisibleChange = function (visible) {
    var props = _this2.props;
    if (!('visible' in props)) {
      _this2.setState({
        visible: visible
      });
    }
    props.onVisibleChange(visible);
  };

  this.getMinOverlayWidthMatchTrigger = function () {
    var _props3 = _this2.props,
        minOverlayWidthMatchTrigger = _props3.minOverlayWidthMatchTrigger,
        alignPoint = _props3.alignPoint;

    if ('minOverlayWidthMatchTrigger' in _this2.props) {
      return minOverlayWidthMatchTrigger;
    }

    return !alignPoint;
  };

  this.afterVisibleChange = function (visible) {
    if (visible && _this2.getMinOverlayWidthMatchTrigger()) {
      var overlayNode = _this2.getPopupDomNode();
      var rootNode = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(_this2);
      if (rootNode && overlayNode && rootNode.offsetWidth > overlayNode.offsetWidth) {
        overlayNode.style.minWidth = rootNode.offsetWidth + 'px';
        if (_this2.trigger && _this2.trigger._component && _this2.trigger._component.alignInstance) {
          _this2.trigger._component.alignInstance.forceAlign();
        }
      }
    }
  };

  this.saveTrigger = function (node) {
    _this2.trigger = node;
  };
};

Object(__WEBPACK_IMPORTED_MODULE_5_react_lifecycles_compat__["polyfill"])(Dropdown);

/* harmony default export */ __webpack_exports__["a"] = (Dropdown);

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placements */
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  topCenter: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  bottomCenter: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  }
};

/* harmony default export */ __webpack_exports__["a"] = (placements);

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _button = __webpack_require__(21);

var _button2 = _interopRequireDefault(_button);

var _dropdown = __webpack_require__(325);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var ButtonGroup = _button2['default'].Group;

var DropdownButton = function (_React$Component) {
    (0, _inherits3['default'])(DropdownButton, _React$Component);

    function DropdownButton() {
        (0, _classCallCheck3['default'])(this, DropdownButton);
        return (0, _possibleConstructorReturn3['default'])(this, (DropdownButton.__proto__ || Object.getPrototypeOf(DropdownButton)).apply(this, arguments));
    }

    (0, _createClass3['default'])(DropdownButton, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                type = _a.type,
                disabled = _a.disabled,
                onClick = _a.onClick,
                children = _a.children,
                prefixCls = _a.prefixCls,
                className = _a.className,
                overlay = _a.overlay,
                trigger = _a.trigger,
                align = _a.align,
                visible = _a.visible,
                onVisibleChange = _a.onVisibleChange,
                placement = _a.placement,
                getPopupContainer = _a.getPopupContainer,
                restProps = __rest(_a, ["type", "disabled", "onClick", "children", "prefixCls", "className", "overlay", "trigger", "align", "visible", "onVisibleChange", "placement", "getPopupContainer"]);
            var dropdownProps = {
                align: align,
                overlay: overlay,
                disabled: disabled,
                trigger: disabled ? [] : trigger,
                onVisibleChange: onVisibleChange,
                placement: placement,
                getPopupContainer: getPopupContainer
            };
            if ('visible' in this.props) {
                dropdownProps.visible = visible;
            }
            return React.createElement(
                ButtonGroup,
                (0, _extends3['default'])({}, restProps, { className: (0, _classnames2['default'])(prefixCls, className) }),
                React.createElement(
                    _button2['default'],
                    { type: type, disabled: disabled, onClick: onClick },
                    children
                ),
                React.createElement(
                    _dropdown2['default'],
                    dropdownProps,
                    React.createElement(_button2['default'], { type: type, icon: 'ellipsis' })
                )
            );
        }
    }]);
    return DropdownButton;
}(React.Component);

exports['default'] = DropdownButton;

DropdownButton.defaultProps = {
    placement: 'bottomRight',
    type: 'default',
    prefixCls: 'ant-dropdown-button'
};
module.exports = exports['default'];

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_PureRenderMixin__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_PureRenderMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_PureRenderMixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);










var Checkbox = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Checkbox, _React$Component);

  function Checkbox(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Checkbox);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var checked = 'checked' in props ? props.checked : props.defaultChecked;

    _this.state = {
      checked: checked
    };
    return _this;
  }

  Checkbox.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('checked' in nextProps) {
      this.setState({
        checked: nextProps.checked
      });
    }
  };

  Checkbox.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return __WEBPACK_IMPORTED_MODULE_7_rc_util_es_PureRenderMixin___default.a.shouldComponentUpdate.apply(this, args);
  };

  Checkbox.prototype.focus = function focus() {
    this.input.focus();
  };

  Checkbox.prototype.blur = function blur() {
    this.input.blur();
  };

  Checkbox.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        prefixCls = _props.prefixCls,
        className = _props.className,
        style = _props.style,
        name = _props.name,
        id = _props.id,
        type = _props.type,
        disabled = _props.disabled,
        readOnly = _props.readOnly,
        tabIndex = _props.tabIndex,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onBlur = _props.onBlur,
        autoFocus = _props.autoFocus,
        value = _props.value,
        others = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['prefixCls', 'className', 'style', 'name', 'id', 'type', 'disabled', 'readOnly', 'tabIndex', 'onClick', 'onFocus', 'onBlur', 'autoFocus', 'value']);

    var globalProps = Object.keys(others).reduce(function (prev, key) {
      if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
        prev[key] = others[key];
      }
      return prev;
    }, {});

    var checked = this.state.checked;

    var classString = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(prefixCls, className, (_classNames = {}, _classNames[prefixCls + '-checked'] = checked, _classNames[prefixCls + '-disabled'] = disabled, _classNames));

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'span',
      { className: classString, style: style },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        name: name,
        id: id,
        type: type,
        readOnly: readOnly,
        disabled: disabled,
        tabIndex: tabIndex,
        className: prefixCls + '-input',
        checked: !!checked,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onChange: this.handleChange,
        autoFocus: autoFocus,
        ref: this.saveInput,
        value: value
      }, globalProps)),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: prefixCls + '-inner' })
    );
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Checkbox.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  name: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  defaultChecked: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  checked: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  readOnly: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
Checkbox.defaultProps = {
  prefixCls: 'rc-checkbox',
  className: '',
  style: {},
  type: 'checkbox',
  defaultChecked: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleChange = function (e) {
    var props = _this2.props;

    if (props.disabled) {
      return;
    }
    if (!('checked' in props)) {
      _this2.setState({
        checked: e.target.checked
      });
    }
    props.onChange({
      target: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        checked: e.target.checked
      }),
      stopPropagation: function stopPropagation() {
        e.stopPropagation();
      },
      preventDefault: function preventDefault() {
        e.preventDefault();
      },

      nativeEvent: e.nativeEvent
    });
  };

  this.saveInput = function (node) {
    _this2.input = node;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentWithPureRenderMixin
 */

var shallowEqual = __webpack_require__(832);

function shallowCompare(instance, nextProps, nextState) {
  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
}

/**
 * If your React component's render function is "pure", e.g. it will render the
 * same result given the same props and state, provide this mixin for a
 * considerable performance boost.
 *
 * Most React components have pure render functions.
 *
 * Example:
 *
 *   var ReactComponentWithPureRenderMixin =
 *     require('ReactComponentWithPureRenderMixin');
 *   React.createClass({
 *     mixins: [ReactComponentWithPureRenderMixin],
 *
 *     render: function() {
 *       return <div className={this.props.className}>foo</div>;
 *     }
 *   });
 *
 * Note: This only checks shallow equality for props and state. If these contain
 * complex data structures this mixin may have false-negatives for deeper
 * differences. Only mixin to components which have simple props and state, or
 * use `forceUpdate()` when you know deep data structures have changed.
 *
 * See https://facebook.github.io/react/docs/pure-render-mixin.html
 */
var ReactComponentWithPureRenderMixin = {
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
};

module.exports = ReactComponentWithPureRenderMixin;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fetchKeys = __webpack_require__(833);

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if (ret !== void 0) {
        return !!ret;
    }

    if (objA === objB) {
        return true;
    }

    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
        return false;
    }

    var keysA = fetchKeys(objA);
    var keysB = fetchKeys(objB);

    var len = keysA.length;
    if (len !== keysB.length) {
        return false;
    }

    compareContext = compareContext || null;

    // Test for A's keys different from B.
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for (var i = 0; i < len; i++) {
        var key = keysA[i];
        if (!bHasOwnProperty(key)) {
            return false;
        }
        var valueA = objA[key];
        var valueB = objB[key];

        var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (_ret === false || _ret === void 0 && valueA !== valueB) {
            return false;
        }
    }

    return true;
};

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(834),
    isArguments = __webpack_require__(835),
    isArray = __webpack_require__(836);

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/* Native method references for those with the same name as other `lodash` methods. */
var nativeKeys = getNative(Object, 'keys');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function shimKeys(object) {
  var props = keysIn(object),
      propsLength = props.length,
      length = propsLength && object.length;

  var allowIndexes = !!length && isLength(length) &&
    (isArray(object) || isArguments(object));

  var index = -1,
      result = [];

  while (++index < propsLength) {
    var key = props[index];
    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  var Ctor = object == null ? undefined : object.constructor;
  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
      (typeof object != 'function' && isArrayLike(object))) {
    return shimKeys(object);
  }
  return isObject(object) ? nativeKeys(object) : [];
};

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keys;


/***/ }),
/* 834 */
/***/ (function(module, exports) {

/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = getNative;


/***/ }),
/* 835 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isArguments;


/***/ }),
/* 836 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(68);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _shallowequal = __webpack_require__(52);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _Checkbox = __webpack_require__(326);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CheckboxGroup = function (_React$Component) {
    (0, _inherits3['default'])(CheckboxGroup, _React$Component);

    function CheckboxGroup(props) {
        (0, _classCallCheck3['default'])(this, CheckboxGroup);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (CheckboxGroup.__proto__ || Object.getPrototypeOf(CheckboxGroup)).call(this, props));

        _this.toggleOption = function (option) {
            var optionIndex = _this.state.value.indexOf(option.value);
            var value = [].concat((0, _toConsumableArray3['default'])(_this.state.value));
            if (optionIndex === -1) {
                value.push(option.value);
            } else {
                value.splice(optionIndex, 1);
            }
            if (!('value' in _this.props)) {
                _this.setState({ value: value });
            }
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange(value);
            }
        };
        _this.state = {
            value: props.value || props.defaultValue || []
        };
        return _this;
    }

    (0, _createClass3['default'])(CheckboxGroup, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                checkboxGroup: {
                    toggleOption: this.toggleOption,
                    value: this.state.value,
                    disabled: this.props.disabled
                }
            };
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
                this.setState({
                    value: nextProps.value || []
                });
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return !(0, _shallowequal2['default'])(this.props, nextProps) || !(0, _shallowequal2['default'])(this.state, nextState);
        }
    }, {
        key: 'getOptions',
        value: function getOptions() {
            var options = this.props.options;
            // https://github.com/Microsoft/TypeScript/issues/7960

            return options.map(function (option) {
                if (typeof option === 'string') {
                    return {
                        label: option,
                        value: option
                    };
                }
                return option;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var props = this.props,
                state = this.state;
            var prefixCls = props.prefixCls,
                className = props.className,
                style = props.style,
                options = props.options;

            var groupPrefixCls = prefixCls + '-group';
            var children = props.children;
            if (options && options.length > 0) {
                children = this.getOptions().map(function (option) {
                    return React.createElement(
                        _Checkbox2['default'],
                        { prefixCls: prefixCls, key: option.value.toString(), disabled: 'disabled' in option ? option.disabled : props.disabled, value: option.value, checked: state.value.indexOf(option.value) !== -1, onChange: function onChange() {
                                return _this2.toggleOption(option);
                            }, className: groupPrefixCls + '-item' },
                        option.label
                    );
                });
            }
            var classString = (0, _classnames2['default'])(groupPrefixCls, className);
            return React.createElement(
                'div',
                { className: classString, style: style },
                children
            );
        }
    }]);
    return CheckboxGroup;
}(React.Component);

exports['default'] = CheckboxGroup;

CheckboxGroup.defaultProps = {
    options: [],
    prefixCls: 'ant-checkbox'
};
CheckboxGroup.propTypes = {
    defaultValue: _propTypes2['default'].array,
    value: _propTypes2['default'].array,
    options: _propTypes2['default'].array.isRequired,
    onChange: _propTypes2['default'].func
};
CheckboxGroup.childContextTypes = {
    checkboxGroup: _propTypes2['default'].any
};
module.exports = exports['default'];

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _shallowequal = __webpack_require__(52);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _radio = __webpack_require__(193);

var _radio2 = _interopRequireDefault(_radio);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getCheckedValue(children) {
    var value = null;
    var matched = false;
    React.Children.forEach(children, function (radio) {
        if (radio && radio.props && radio.props.checked) {
            value = radio.props.value;
            matched = true;
        }
    });
    return matched ? { value: value } : undefined;
}

var RadioGroup = function (_React$Component) {
    (0, _inherits3['default'])(RadioGroup, _React$Component);

    function RadioGroup(props) {
        (0, _classCallCheck3['default'])(this, RadioGroup);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).call(this, props));

        _this.onRadioChange = function (ev) {
            var lastValue = _this.state.value;
            var value = ev.target.value;

            if (!('value' in _this.props)) {
                _this.setState({
                    value: value
                });
            }
            var onChange = _this.props.onChange;
            if (onChange && value !== lastValue) {
                onChange(ev);
            }
        };
        var value = void 0;
        if ('value' in props) {
            value = props.value;
        } else if ('defaultValue' in props) {
            value = props.defaultValue;
        } else {
            var checkedValue = getCheckedValue(props.children);
            value = checkedValue && checkedValue.value;
        }
        _this.state = {
            value: value
        };
        return _this;
    }

    (0, _createClass3['default'])(RadioGroup, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                radioGroup: {
                    onChange: this.onRadioChange,
                    value: this.state.value,
                    disabled: this.props.disabled,
                    name: this.props.name
                }
            };
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
                this.setState({
                    value: nextProps.value
                });
            } else {
                var checkedValue = getCheckedValue(nextProps.children);
                if (checkedValue) {
                    this.setState({
                        value: checkedValue.value
                    });
                }
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return !(0, _shallowequal2['default'])(this.props, nextProps) || !(0, _shallowequal2['default'])(this.state, nextState);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var props = this.props;
            var prefixCls = props.prefixCls,
                _props$className = props.className,
                className = _props$className === undefined ? '' : _props$className,
                options = props.options,
                buttonStyle = props.buttonStyle;

            var groupPrefixCls = prefixCls + '-group';
            var classString = (0, _classnames2['default'])(groupPrefixCls, groupPrefixCls + '-' + buttonStyle, (0, _defineProperty3['default'])({}, groupPrefixCls + '-' + props.size, props.size), className);
            var children = props.children;
            // 如果存在 options, 优先使用
            if (options && options.length > 0) {
                children = options.map(function (option, index) {
                    if (typeof option === 'string') {
                        // 此处类型自动推导为 string
                        return React.createElement(
                            _radio2['default'],
                            { key: index, prefixCls: prefixCls, disabled: _this2.props.disabled, value: option, onChange: _this2.onRadioChange, checked: _this2.state.value === option },
                            option
                        );
                    } else {
                        // 此处类型自动推导为 { label: string value: string }
                        return React.createElement(
                            _radio2['default'],
                            { key: index, prefixCls: prefixCls, disabled: option.disabled || _this2.props.disabled, value: option.value, onChange: _this2.onRadioChange, checked: _this2.state.value === option.value },
                            option.label
                        );
                    }
                });
            }
            return React.createElement(
                'div',
                { className: classString, style: props.style, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave, id: props.id },
                children
            );
        }
    }]);
    return RadioGroup;
}(React.Component);

exports['default'] = RadioGroup;

RadioGroup.defaultProps = {
    disabled: false,
    prefixCls: 'ant-radio',
    buttonStyle: 'outline'
};
RadioGroup.childContextTypes = {
    radioGroup: _propTypes2['default'].any
};
module.exports = exports['default'];

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radio = __webpack_require__(193);

var _radio2 = _interopRequireDefault(_radio);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var RadioButton = function (_React$Component) {
    (0, _inherits3['default'])(RadioButton, _React$Component);

    function RadioButton() {
        (0, _classCallCheck3['default'])(this, RadioButton);
        return (0, _possibleConstructorReturn3['default'])(this, (RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).apply(this, arguments));
    }

    (0, _createClass3['default'])(RadioButton, [{
        key: 'render',
        value: function render() {
            var radioProps = (0, _extends3['default'])({}, this.props);
            if (this.context.radioGroup) {
                radioProps.onChange = this.context.radioGroup.onChange;
                radioProps.checked = this.props.value === this.context.radioGroup.value;
                radioProps.disabled = this.props.disabled || this.context.radioGroup.disabled;
            }
            return React.createElement(_radio2['default'], radioProps);
        }
    }]);
    return RadioButton;
}(React.Component);

exports['default'] = RadioButton;

RadioButton.defaultProps = {
    prefixCls: 'ant-radio-button'
};
RadioButton.contextTypes = {
    radioGroup: _propTypes2['default'].any
};
module.exports = exports['default'];

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

exports['default'] = function (props) {
    return React.createElement(
        'div',
        { className: props.className, onClick: props.onClick },
        props.children
    );
};

module.exports = exports['default'];

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

exports["default"] = createStore;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function createStore(initialState) {
    var state = initialState;
    var listeners = [];
    function setState(partial) {
        state = (0, _extends3["default"])({}, state, partial);
        for (var i = 0; i < listeners.length; i++) {
            listeners[i]();
        }
    }
    function getState() {
        return state;
    }
    function subscribe(listener) {
        listeners.push(listener);
        return function unsubscribe() {
            var index = listeners.indexOf(listener);
            listeners.splice(index, 1);
        };
    }
    return {
        setState: setState,
        getState: getState,
        subscribe: subscribe
    };
}
module.exports = exports["default"];

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _checkbox = __webpack_require__(46);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _radio = __webpack_require__(96);

var _radio2 = _interopRequireDefault(_radio);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var SelectionBox = function (_React$Component) {
    (0, _inherits3['default'])(SelectionBox, _React$Component);

    function SelectionBox(props) {
        (0, _classCallCheck3['default'])(this, SelectionBox);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (SelectionBox.__proto__ || Object.getPrototypeOf(SelectionBox)).call(this, props));

        _this.state = {
            checked: _this.getCheckState(props)
        };
        return _this;
    }

    (0, _createClass3['default'])(SelectionBox, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.subscribe();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.unsubscribe) {
                this.unsubscribe();
            }
        }
    }, {
        key: 'subscribe',
        value: function subscribe() {
            var _this2 = this;

            var store = this.props.store;

            this.unsubscribe = store.subscribe(function () {
                var checked = _this2.getCheckState(_this2.props);
                _this2.setState({ checked: checked });
            });
        }
    }, {
        key: 'getCheckState',
        value: function getCheckState(props) {
            var store = props.store,
                defaultSelection = props.defaultSelection,
                rowIndex = props.rowIndex;

            var checked = false;
            if (store.getState().selectionDirty) {
                checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0;
            } else {
                checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0 || defaultSelection.indexOf(rowIndex) >= 0;
            }
            return checked;
        }
    }, {
        key: 'render',
        value: function render() {
            var _a = this.props,
                type = _a.type,
                rowIndex = _a.rowIndex,
                rest = __rest(_a, ["type", "rowIndex"]);var checked = this.state.checked;

            if (type === 'radio') {
                return React.createElement(_radio2['default'], (0, _extends3['default'])({ checked: checked, value: rowIndex }, rest));
            } else {
                return React.createElement(_checkbox2['default'], (0, _extends3['default'])({ checked: checked }, rest));
            }
        }
    }]);
    return SelectionBox;
}(React.Component);

exports['default'] = SelectionBox;
module.exports = exports['default'];

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _checkbox = __webpack_require__(46);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _dropdown = __webpack_require__(121);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _menu = __webpack_require__(51);

var _menu2 = _interopRequireDefault(_menu);

var _icon = __webpack_require__(6);

var _icon2 = _interopRequireDefault(_icon);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SelectionCheckboxAll = function (_React$Component) {
    (0, _inherits3['default'])(SelectionCheckboxAll, _React$Component);

    function SelectionCheckboxAll(props) {
        (0, _classCallCheck3['default'])(this, SelectionCheckboxAll);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (SelectionCheckboxAll.__proto__ || Object.getPrototypeOf(SelectionCheckboxAll)).call(this, props));

        _this.handleSelectAllChagne = function (e) {
            var checked = e.target.checked;
            _this.props.onSelect(checked ? 'all' : 'removeAll', 0, null);
        };
        _this.defaultSelections = props.hideDefaultSelections ? [] : [{
            key: 'all',
            text: props.locale.selectAll,
            onSelect: function onSelect() {}
        }, {
            key: 'invert',
            text: props.locale.selectInvert,
            onSelect: function onSelect() {}
        }];
        _this.state = {
            checked: _this.getCheckState(props),
            indeterminate: _this.getIndeterminateState(props)
        };
        return _this;
    }

    (0, _createClass3['default'])(SelectionCheckboxAll, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.subscribe();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setCheckState(nextProps);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.unsubscribe) {
                this.unsubscribe();
            }
        }
    }, {
        key: 'subscribe',
        value: function subscribe() {
            var _this2 = this;

            var store = this.props.store;

            this.unsubscribe = store.subscribe(function () {
                _this2.setCheckState(_this2.props);
            });
        }
    }, {
        key: 'checkSelection',
        value: function checkSelection(data, type, byDefaultChecked) {
            var _props = this.props,
                store = _props.store,
                getCheckboxPropsByItem = _props.getCheckboxPropsByItem,
                getRecordKey = _props.getRecordKey;
            // type should be 'every' | 'some'

            if (type === 'every' || type === 'some') {
                return byDefaultChecked ? data[type](function (item, i) {
                    return getCheckboxPropsByItem(item, i).defaultChecked;
                }) : data[type](function (item, i) {
                    return store.getState().selectedRowKeys.indexOf(getRecordKey(item, i)) >= 0;
                });
            }
            return false;
        }
    }, {
        key: 'setCheckState',
        value: function setCheckState(props) {
            var checked = this.getCheckState(props);
            var indeterminate = this.getIndeterminateState(props);
            this.setState(function (prevState) {
                var newState = {};
                if (indeterminate !== prevState.indeterminate) {
                    newState.indeterminate = indeterminate;
                }
                if (checked !== prevState.checked) {
                    newState.checked = checked;
                }
                return newState;
            });
        }
    }, {
        key: 'getCheckState',
        value: function getCheckState(props) {
            var store = props.store,
                data = props.data;

            var checked = void 0;
            if (!data.length) {
                checked = false;
            } else {
                checked = store.getState().selectionDirty ? this.checkSelection(data, 'every', false) : this.checkSelection(data, 'every', false) || this.checkSelection(data, 'every', true);
            }
            return checked;
        }
    }, {
        key: 'getIndeterminateState',
        value: function getIndeterminateState(props) {
            var store = props.store,
                data = props.data;

            var indeterminate = void 0;
            if (!data.length) {
                indeterminate = false;
            } else {
                indeterminate = store.getState().selectionDirty ? this.checkSelection(data, 'some', false) && !this.checkSelection(data, 'every', false) : this.checkSelection(data, 'some', false) && !this.checkSelection(data, 'every', false) || this.checkSelection(data, 'some', true) && !this.checkSelection(data, 'every', true);
            }
            return indeterminate;
        }
    }, {
        key: 'renderMenus',
        value: function renderMenus(selections) {
            var _this3 = this;

            return selections.map(function (selection, index) {
                return React.createElement(
                    _menu2['default'].Item,
                    { key: selection.key || index },
                    React.createElement(
                        'div',
                        { onClick: function onClick() {
                                _this3.props.onSelect(selection.key, index, selection.onSelect);
                            } },
                        selection.text
                    )
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                disabled = _props2.disabled,
                prefixCls = _props2.prefixCls,
                selections = _props2.selections,
                getPopupContainer = _props2.getPopupContainer;
            var _state = this.state,
                checked = _state.checked,
                indeterminate = _state.indeterminate;

            var selectionPrefixCls = prefixCls + '-selection';
            var customSelections = null;
            if (selections) {
                var newSelections = Array.isArray(selections) ? this.defaultSelections.concat(selections) : this.defaultSelections;
                var menu = React.createElement(
                    _menu2['default'],
                    { className: selectionPrefixCls + '-menu', selectedKeys: [] },
                    this.renderMenus(newSelections)
                );
                customSelections = newSelections.length > 0 ? React.createElement(
                    _dropdown2['default'],
                    { overlay: menu, getPopupContainer: getPopupContainer },
                    React.createElement(
                        'div',
                        { className: selectionPrefixCls + '-down' },
                        React.createElement(_icon2['default'], { type: 'down' })
                    )
                ) : null;
            }
            return React.createElement(
                'div',
                { className: selectionPrefixCls },
                React.createElement(_checkbox2['default'], { className: (0, _classnames2['default'])((0, _defineProperty3['default'])({}, selectionPrefixCls + '-select-all-custom', customSelections)), checked: checked, indeterminate: indeterminate, disabled: disabled, onChange: this.handleSelectAllChagne }),
                customSelections
            );
        }
    }]);
    return SelectionCheckboxAll;
}(React.Component);

exports['default'] = SelectionCheckboxAll;
module.exports = exports['default'];

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Column = function (_React$Component) {
  (0, _inherits3['default'])(Column, _React$Component);

  function Column() {
    (0, _classCallCheck3['default'])(this, Column);
    return (0, _possibleConstructorReturn3['default'])(this, (Column.__proto__ || Object.getPrototypeOf(Column)).apply(this, arguments));
  }

  return Column;
}(React.Component);

exports['default'] = Column;
module.exports = exports['default'];

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ColumnGroup = function (_React$Component) {
  (0, _inherits3['default'])(ColumnGroup, _React$Component);

  function ColumnGroup() {
    (0, _classCallCheck3['default'])(this, ColumnGroup);
    return (0, _possibleConstructorReturn3['default'])(this, (ColumnGroup.__proto__ || Object.getPrototypeOf(ColumnGroup)).apply(this, arguments));
  }

  return ColumnGroup;
}(React.Component);

exports['default'] = ColumnGroup;

ColumnGroup.__ANT_TABLE_COLUMN_GROUP = true;
module.exports = exports['default'];

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

exports['default'] = createTableRow;

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _classnames2 = __webpack_require__(11);

var _classnames3 = _interopRequireDefault(_classnames2);

var _omit = __webpack_require__(47);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function createTableRow() {
    var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tr';

    var BodyRow = function (_React$Component) {
        (0, _inherits3['default'])(BodyRow, _React$Component);

        function BodyRow(props) {
            (0, _classCallCheck3['default'])(this, BodyRow);

            var _this = (0, _possibleConstructorReturn3['default'])(this, (BodyRow.__proto__ || Object.getPrototypeOf(BodyRow)).call(this, props));

            _this.store = props.store;

            var _this$store$getState = _this.store.getState(),
                selectedRowKeys = _this$store$getState.selectedRowKeys;

            _this.state = {
                selected: selectedRowKeys.indexOf(props.rowKey) >= 0
            };
            return _this;
        }

        (0, _createClass3['default'])(BodyRow, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.subscribe();
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this.unsubscribe) {
                    this.unsubscribe();
                }
            }
        }, {
            key: 'subscribe',
            value: function subscribe() {
                var _this2 = this;

                var _props = this.props,
                    store = _props.store,
                    rowKey = _props.rowKey;

                this.unsubscribe = store.subscribe(function () {
                    var _store$getState = _this2.store.getState(),
                        selectedRowKeys = _store$getState.selectedRowKeys;

                    var selected = selectedRowKeys.indexOf(rowKey) >= 0;
                    if (selected !== _this2.state.selected) {
                        _this2.setState({ selected: selected });
                    }
                });
            }
        }, {
            key: 'render',
            value: function render() {
                var rowProps = (0, _omit2['default'])(this.props, ['prefixCls', 'rowKey', 'store']);
                var className = (0, _classnames3['default'])(this.props.className, (0, _defineProperty3['default'])({}, this.props.prefixCls + '-row-selected', this.state.selected));
                return React.createElement(
                    Component,
                    (0, _extends3['default'])({}, rowProps, { className: className }),
                    this.props.children
                );
            }
        }]);
        return BodyRow;
    }(React.Component);

    return BodyRow;
}
module.exports = exports['default'];

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(68);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

exports.flatArray = flatArray;
exports.treeMap = treeMap;
exports.flatFilter = flatFilter;
exports.normalizeColumns = normalizeColumns;

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function flatArray() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var childrenName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'children';

    var result = [];
    var loop = function loop(array) {
        array.forEach(function (item) {
            if (item[childrenName]) {
                var newItem = (0, _extends3['default'])({}, item);
                delete newItem[childrenName];
                result.push(newItem);
                if (item[childrenName].length > 0) {
                    loop(item[childrenName]);
                }
            } else {
                result.push(item);
            }
        });
    };
    loop(data);
    return result;
}
function treeMap(tree, mapper) {
    var childrenName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';

    return tree.map(function (node, index) {
        var extra = {};
        if (node[childrenName]) {
            extra[childrenName] = treeMap(node[childrenName], mapper, childrenName);
        }
        return (0, _extends3['default'])({}, mapper(node, index), extra);
    });
}
function flatFilter(tree, callback) {
    return tree.reduce(function (acc, node) {
        if (callback(node)) {
            acc.push(node);
        }
        if (node.children) {
            var children = flatFilter(node.children, callback);
            acc.push.apply(acc, (0, _toConsumableArray3['default'])(children));
        }
        return acc;
    }, []);
}
function normalizeColumns(elements) {
    var columns = [];
    React.Children.forEach(elements, function (element) {
        if (!React.isValidElement(element)) {
            return;
        }
        var column = (0, _extends3['default'])({}, element.props);
        if (element.key) {
            column.key = element.key;
        }
        if (element.type && element.type.__ANT_TABLE_COLUMN_GROUP) {
            column.children = normalizeColumns(column.children);
        }
        columns.push(column);
    });
    return columns;
}

/***/ }),
/* 848 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Dialog__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_ContainerRender__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Portal__ = __webpack_require__(294);









var IS_REACT_16 = 'createPortal' in __WEBPACK_IMPORTED_MODULE_5_react_dom__;

var DialogWrap = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DialogWrap, _React$Component);

    function DialogWrap() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DialogWrap);

        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));

        _this.saveDialog = function (node) {
            _this._component = node;
        };
        _this.getComponent = function () {
            var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Dialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ ref: _this.saveDialog }, _this.props, extra, { key: "dialog" }));
        };
        // fix issue #10656
        /*
        * Custom container should not be return, because in the Portal component, it will remove the
        * return container element here, if the custom container is the only child of it's component,
        * like issue #10656, It will has a conflict with removeChild method in react-dom.
        * So here should add a child (div element) to custom container.
        * */
        _this.getContainer = function () {
            var container = document.createElement('div');
            if (_this.props.getContainer) {
                _this.props.getContainer().appendChild(container);
            } else {
                document.body.appendChild(container);
            }
            return container;
        };
        return _this;
    }

    DialogWrap.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref) {
        var visible = _ref.visible;

        return !!(this.props.visible || visible);
    };

    DialogWrap.prototype.componentWillUnmount = function componentWillUnmount() {
        if (IS_REACT_16) {
            return;
        }
        if (this.props.visible) {
            this.renderComponent({
                afterClose: this.removeContainer,
                onClose: function onClose() {},

                visible: false
            });
        } else {
            this.removeContainer();
        }
    };

    DialogWrap.prototype.render = function render() {
        var _this2 = this;

        var visible = this.props.visible;

        var portal = null;
        if (!IS_REACT_16) {
            return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_rc_util_es_ContainerRender__["a" /* default */], { parent: this, visible: visible, autoDestroy: false, getComponent: this.getComponent, getContainer: this.getContainer }, function (_ref2) {
                var renderComponent = _ref2.renderComponent,
                    removeContainer = _ref2.removeContainer;

                _this2.renderComponent = renderComponent;
                _this2.removeContainer = removeContainer;
                return null;
            });
        }
        if (visible || this._component) {
            portal = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Portal__["a" /* default */], { getContainer: this.getContainer }, this.getComponent());
        }
        return portal;
    };

    return DialogWrap;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

DialogWrap.defaultProps = {
    visible: false
};
/* harmony default export */ __webpack_exports__["default"] = (DialogWrap);

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LazyRenderBox__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_getScrollBarSize__ = __webpack_require__(852);











var uuid = 0;
var openCount = 0;
/* eslint react/no-is-mounted:0 */
function getScroll(w, top) {
    var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
    var method = 'scroll' + (top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== 'number') {
            ret = d.body[method];
        }
    }
    return ret;
}
function setTransformOrigin(node, value) {
    var style = node.style;
    ['Webkit', 'Moz', 'Ms', 'ms'].forEach(function (prefix) {
        style[prefix + 'TransformOrigin'] = value;
    });
    style['transformOrigin'] = value;
}
function offset(el) {
    var rect = el.getBoundingClientRect();
    var pos = {
        left: rect.left,
        top: rect.top
    };
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += getScroll(w);
    pos.top += getScroll(w, true);
    return pos;
}

var Dialog = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Dialog, _React$Component);

    function Dialog() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Dialog);

        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));

        _this.onAnimateLeave = function () {
            var afterClose = _this.props.afterClose;
            // need demo?
            // https://github.com/react-component/dialog/pull/28

            if (_this.wrap) {
                _this.wrap.style.display = 'none';
            }
            _this.inTransition = false;
            _this.removeScrollingEffect();
            if (afterClose) {
                afterClose();
            }
        };
        _this.onMaskClick = function (e) {
            // android trigger click on open (fastclick??)
            if (Date.now() - _this.openTime < 300) {
                return;
            }
            if (e.target === e.currentTarget) {
                _this.close(e);
            }
        };
        _this.onKeyDown = function (e) {
            var props = _this.props;
            if (props.keyboard && e.keyCode === __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].ESC) {
                e.stopPropagation();
                _this.close(e);
                return;
            }
            // keep focus inside dialog
            if (props.visible) {
                if (e.keyCode === __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].TAB) {
                    var activeElement = document.activeElement;
                    var dialogRoot = _this.wrap;
                    if (e.shiftKey) {
                        if (activeElement === dialogRoot) {
                            _this.sentinel.focus();
                        }
                    } else if (activeElement === _this.sentinel) {
                        dialogRoot.focus();
                    }
                }
            }
        };
        _this.getDialogElement = function () {
            var props = _this.props;
            var closable = props.closable;
            var prefixCls = props.prefixCls;
            var dest = {};
            if (props.width !== undefined) {
                dest.width = props.width;
            }
            if (props.height !== undefined) {
                dest.height = props.height;
            }
            var footer = void 0;
            if (props.footer) {
                footer = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: prefixCls + '-footer', ref: _this.saveRef('footer') }, props.footer);
            }
            var header = void 0;
            if (props.title) {
                header = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: prefixCls + '-header', ref: _this.saveRef('header') }, __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: prefixCls + '-title', id: _this.titleId }, props.title));
            }
            var closer = void 0;
            if (closable) {
                closer = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("button", { onClick: _this.close, "aria-label": "Close", className: prefixCls + '-close' }, props.closeIcon || __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("span", { className: prefixCls + '-close-x' }));
            }
            var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props.style, dest);
            var transitionName = _this.getTransitionName();
            var dialogElement = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__LazyRenderBox__["a" /* default */], { key: "dialog-element", role: "document", ref: _this.saveRef('dialog'), style: style, className: prefixCls + ' ' + (props.className || ''), visible: props.visible }, __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: prefixCls + '-content' }, closer, header, __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: prefixCls + '-body', style: props.bodyStyle, ref: _this.saveRef('body') }, props.bodyProps), props.children), footer), __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { tabIndex: 0, ref: _this.saveRef('sentinel'), style: { width: 0, height: 0, overflow: 'hidden' } }, "sentinel"));
            return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"], { key: "dialog", showProp: "visible", onLeave: _this.onAnimateLeave, transitionName: transitionName, component: "", transitionAppear: true }, props.visible || !props.destroyOnClose ? dialogElement : null);
        };
        _this.getZIndexStyle = function () {
            var style = {};
            var props = _this.props;
            if (props.zIndex !== undefined) {
                style.zIndex = props.zIndex;
            }
            return style;
        };
        _this.getWrapStyle = function () {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.getZIndexStyle(), _this.props.wrapStyle);
        };
        _this.getMaskStyle = function () {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.getZIndexStyle(), _this.props.maskStyle);
        };
        _this.getMaskElement = function () {
            var props = _this.props;
            var maskElement = void 0;
            if (props.mask) {
                var maskTransition = _this.getMaskTransitionName();
                maskElement = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__LazyRenderBox__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ style: _this.getMaskStyle(), key: "mask", className: props.prefixCls + '-mask', hiddenClassName: props.prefixCls + '-mask-hidden', visible: props.visible }, props.maskProps));
                if (maskTransition) {
                    maskElement = __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_rc_animate__["default"], { key: "mask", showProp: "visible", transitionAppear: true, component: "", transitionName: maskTransition }, maskElement);
                }
            }
            return maskElement;
        };
        _this.getMaskTransitionName = function () {
            var props = _this.props;
            var transitionName = props.maskTransitionName;
            var animation = props.maskAnimation;
            if (!transitionName && animation) {
                transitionName = props.prefixCls + '-' + animation;
            }
            return transitionName;
        };
        _this.getTransitionName = function () {
            var props = _this.props;
            var transitionName = props.transitionName;
            var animation = props.animation;
            if (!transitionName && animation) {
                transitionName = props.prefixCls + '-' + animation;
            }
            return transitionName;
        };
        _this.setScrollbar = function () {
            if (_this.bodyIsOverflowing && _this.scrollbarWidth !== undefined) {
                document.body.style.paddingRight = _this.scrollbarWidth + 'px';
            }
        };
        _this.addScrollingEffect = function () {
            openCount++;
            if (openCount !== 1) {
                return;
            }
            _this.checkScrollbar();
            _this.setScrollbar();
            document.body.style.overflow = 'hidden';
            // this.adjustDialog();
        };
        _this.removeScrollingEffect = function () {
            openCount--;
            if (openCount !== 0) {
                return;
            }
            document.body.style.overflow = '';
            _this.resetScrollbar();
            // this.resetAdjustments();
        };
        _this.close = function (e) {
            var onClose = _this.props.onClose;

            if (onClose) {
                onClose(e);
            }
        };
        _this.checkScrollbar = function () {
            var fullWindowWidth = window.innerWidth;
            if (!fullWindowWidth) {
                // workaround for missing window.innerWidth in IE8
                var documentElementRect = document.documentElement.getBoundingClientRect();
                fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
            }
            _this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
            if (_this.bodyIsOverflowing) {
                _this.scrollbarWidth = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_getScrollBarSize__["a" /* default */])();
            }
        };
        _this.resetScrollbar = function () {
            document.body.style.paddingRight = '';
        };
        _this.adjustDialog = function () {
            if (_this.wrap && _this.scrollbarWidth !== undefined) {
                var modalIsOverflowing = _this.wrap.scrollHeight > document.documentElement.clientHeight;
                _this.wrap.style.paddingLeft = (!_this.bodyIsOverflowing && modalIsOverflowing ? _this.scrollbarWidth : '') + 'px';
                _this.wrap.style.paddingRight = (_this.bodyIsOverflowing && !modalIsOverflowing ? _this.scrollbarWidth : '') + 'px';
            }
        };
        _this.resetAdjustments = function () {
            if (_this.wrap) {
                _this.wrap.style.paddingLeft = _this.wrap.style.paddingLeft = '';
            }
        };
        _this.saveRef = function (name) {
            return function (node) {
                _this[name] = node;
            };
        };
        return _this;
    }

    Dialog.prototype.componentWillMount = function componentWillMount() {
        this.inTransition = false;
        this.titleId = 'rcDialogTitle' + uuid++;
    };

    Dialog.prototype.componentDidMount = function componentDidMount() {
        this.componentDidUpdate({});
    };

    Dialog.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var props = this.props;
        var mousePosition = this.props.mousePosition;
        if (props.visible) {
            // first show
            if (!prevProps.visible) {
                this.openTime = Date.now();
                this.addScrollingEffect();
                this.tryFocus();
                var dialogNode = __WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"](this.dialog);
                if (mousePosition) {
                    var elOffset = offset(dialogNode);
                    setTransformOrigin(dialogNode, mousePosition.x - elOffset.left + 'px ' + (mousePosition.y - elOffset.top) + 'px');
                } else {
                    setTransformOrigin(dialogNode, '');
                }
            }
        } else if (prevProps.visible) {
            this.inTransition = true;
            if (props.mask && this.lastOutSideFocusNode) {
                try {
                    this.lastOutSideFocusNode.focus();
                } catch (e) {
                    this.lastOutSideFocusNode = null;
                }
                this.lastOutSideFocusNode = null;
            }
        }
    };

    Dialog.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.props.visible || this.inTransition) {
            this.removeScrollingEffect();
        }
    };

    Dialog.prototype.tryFocus = function tryFocus() {
        if (!Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(this.wrap, document.activeElement)) {
            this.lastOutSideFocusNode = document.activeElement;
            this.wrap.focus();
        }
    };

    Dialog.prototype.render = function render() {
        var props = this.props;
        var prefixCls = props.prefixCls,
            maskClosable = props.maskClosable;

        var style = this.getWrapStyle();
        // clear hide display
        // and only set display after async anim, not here for hide
        if (props.visible) {
            style.display = null;
        }
        return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", null, this.getMaskElement(), __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ tabIndex: -1, onKeyDown: this.onKeyDown, className: prefixCls + '-wrap ' + (props.wrapClassName || ''), ref: this.saveRef('wrap'), onClick: maskClosable ? this.onMaskClick : undefined, role: "dialog", "aria-labelledby": props.title ? this.titleId : null, style: style }, props.wrapProps), this.getDialogElement()));
    };

    return Dialog;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Dialog);

Dialog.defaultProps = {
    className: '',
    mask: true,
    visible: false,
    keyboard: true,
    closable: true,
    maskClosable: true,
    destroyOnClose: false,
    prefixCls: 'rc-dialog'
};

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var LazyRenderBox = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _React$Component);

    function LazyRenderBox() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
    }

    LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !!nextProps.hiddenClassName || !!nextProps.visible;
    };

    LazyRenderBox.prototype.render = function render() {
        var className = this.props.className;
        if (!!this.props.hiddenClassName && !this.props.visible) {
            className += " " + this.props.hiddenClassName;
        }
        var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props);
        delete props.hiddenClassName;
        delete props.visible;
        props.className = className;
        return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props));
    };

    return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getScrollBarSize;
var cached = void 0;

function getScrollBarSize(fresh) {
  if (fresh || cached === undefined) {
    var inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '200px';

    var outer = document.createElement('div');
    var outerStyle = outer.style;

    outerStyle.position = 'absolute';
    outerStyle.top = 0;
    outerStyle.left = 0;
    outerStyle.pointerEvents = 'none';
    outerStyle.visibility = 'hidden';
    outerStyle.width = '200px';
    outerStyle.height = '150px';
    outerStyle.overflow = 'hidden';

    outer.appendChild(inner);

    document.body.appendChild(outer);

    var widthContained = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var widthScroll = inner.offsetWidth;

    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }

    document.body.removeChild(outer);

    cached = widthContained - widthScroll;
  }
  return cached;
}

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports['default'] = confirm;

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(15);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = __webpack_require__(6);

var _icon2 = _interopRequireDefault(_icon);

var _Modal = __webpack_require__(330);

var _Modal2 = _interopRequireDefault(_Modal);

var _ActionButton = __webpack_require__(854);

var _ActionButton2 = _interopRequireDefault(_ActionButton);

var _locale = __webpack_require__(148);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var IS_REACT_16 = !!ReactDOM.createPortal;
var ConfirmDialog = function ConfirmDialog(props) {
    var onCancel = props.onCancel,
        onOk = props.onOk,
        close = props.close,
        zIndex = props.zIndex,
        afterClose = props.afterClose,
        visible = props.visible,
        keyboard = props.keyboard;

    var iconType = props.iconType || 'question-circle';
    var okType = props.okType || 'primary';
    var prefixCls = props.prefixCls || 'ant-confirm';
    // 默认为 true，保持向下兼容
    var okCancel = 'okCancel' in props ? props.okCancel : true;
    var width = props.width || 416;
    var style = props.style || {};
    // 默认为 false，保持旧版默认行为
    var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
    var runtimeLocale = (0, _locale.getConfirmLocale)();
    var okText = props.okText || (okCancel ? runtimeLocale.okText : runtimeLocale.justOkText);
    var cancelText = props.cancelText || runtimeLocale.cancelText;
    var classString = (0, _classnames2['default'])(prefixCls, prefixCls + '-' + props.type, props.className);
    var cancelButton = okCancel && React.createElement(
        _ActionButton2['default'],
        { actionFn: onCancel, closeModal: close },
        cancelText
    );
    return React.createElement(
        _Modal2['default'],
        { className: classString, wrapClassName: (0, _classnames2['default'])((0, _defineProperty3['default'])({}, prefixCls + '-centered', !!props.centered)), onCancel: close.bind(undefined, { triggerCancel: true }), visible: visible, title: '', transitionName: 'zoom', footer: '', maskTransitionName: 'fade', maskClosable: maskClosable, style: style, width: width, zIndex: zIndex, afterClose: afterClose, keyboard: keyboard },
        React.createElement(
            'div',
            { className: prefixCls + '-body-wrapper' },
            React.createElement(
                'div',
                { className: prefixCls + '-body' },
                React.createElement(_icon2['default'], { type: iconType }),
                React.createElement(
                    'span',
                    { className: prefixCls + '-title' },
                    props.title
                ),
                React.createElement(
                    'div',
                    { className: prefixCls + '-content' },
                    props.content
                )
            ),
            React.createElement(
                'div',
                { className: prefixCls + '-btns' },
                cancelButton,
                React.createElement(
                    _ActionButton2['default'],
                    { type: okType, actionFn: onOk, closeModal: close, autoFocus: true },
                    okText
                )
            )
        )
    );
};
function confirm(config) {
    var div = document.createElement('div');
    document.body.appendChild(div);
    function close() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        if (IS_REACT_16) {
            render((0, _extends3['default'])({}, config, { close: close, visible: false, afterClose: destroy.bind.apply(destroy, [this].concat(args)) }));
        } else {
            destroy.apply(undefined, args);
        }
    }
    function destroy() {
        var unmountResult = ReactDOM.unmountComponentAtNode(div);
        if (unmountResult && div.parentNode) {
            div.parentNode.removeChild(div);
        }

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        var triggerCancel = args && args.length && args.some(function (param) {
            return param && param.triggerCancel;
        });
        if (config.onCancel && triggerCancel) {
            config.onCancel.apply(config, args);
        }
    }
    function render(props) {
        ReactDOM.render(React.createElement(ConfirmDialog, props), div);
    }
    render((0, _extends3['default'])({}, config, { visible: true, close: close }));
    return {
        destroy: close
    };
}
module.exports = exports['default'];

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(15);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _button = __webpack_require__(21);

var _button2 = _interopRequireDefault(_button);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ActionButton = function (_React$Component) {
    (0, _inherits3['default'])(ActionButton, _React$Component);

    function ActionButton(props) {
        (0, _classCallCheck3['default'])(this, ActionButton);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (ActionButton.__proto__ || Object.getPrototypeOf(ActionButton)).call(this, props));

        _this.onClick = function () {
            var _this$props = _this.props,
                actionFn = _this$props.actionFn,
                closeModal = _this$props.closeModal;

            if (actionFn) {
                var ret = void 0;
                if (actionFn.length) {
                    ret = actionFn(closeModal);
                } else {
                    ret = actionFn();
                    if (!ret) {
                        closeModal();
                    }
                }
                if (ret && ret.then) {
                    _this.setState({ loading: true });
                    ret.then(function () {
                        // It's unnecessary to set loading=false, for the Modal will be unmounted after close.
                        // this.setState({ loading: false });
                        closeModal.apply(undefined, arguments);
                    }, function () {
                        // See: https://github.com/ant-design/ant-design/issues/6183
                        _this.setState({ loading: false });
                    });
                }
            } else {
                closeModal();
            }
        };
        _this.state = {
            loading: false
        };
        return _this;
    }

    (0, _createClass3['default'])(ActionButton, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.autoFocus) {
                var $this = ReactDOM.findDOMNode(this);
                this.timeoutId = setTimeout(function () {
                    return $this.focus();
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this.timeoutId);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                type = _props.type,
                children = _props.children;

            var loading = this.state.loading;
            return React.createElement(
                _button2['default'],
                { type: type, onClick: this.onClick, loading: loading },
                children
            );
        }
    }]);
    return ActionButton;
}(React.Component);

exports['default'] = ActionButton;
module.exports = exports['default'];

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_radio__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker_style__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_date_picker__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ActionMenu__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actionStaffMenu__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__statusComponent__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions_jobs__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__api_json__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__api_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__api_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_svgicons_3d_plan_Roots_add_svg__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_svgicons_3d_plan_Roots_add_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_svgicons_3d_plan_Roots_add_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import ct from '../../assets/svgicons/DeepCBCT_analysis.svg';
// import plan_roots from '../../assets/svgicons/3d-plan_roots.svg';
// import plan_deepct from '../../assets/svgicons/3d-plan_DeepCBCT.svg';
var RangePicker=__WEBPACK_IMPORTED_MODULE_15_antd_lib_date_picker___default.a.RangePicker;var dateFormat='YYYY-MM-DD';var dateFormatList=['YYYY-MM-DD'];var actions={plan_standart:[{icon:__WEBPACK_IMPORTED_MODULE_25__assets_svgicons_3d_plan_Roots_add_svg___default.a,link:function link(uuid){return'/case/upload/plan-roots/'+uuid;},title:'3D-Plan Roots'}]};var case_status={"S_DICOM_DOWNLOAD":"Downloading DICOMs","S_DICOM_CONVERT":"Converting DICOMs","S_DATA_CHECK":"Check incoming data","S_NN_SEGMENT":"Automatic segentation","S_TEETH_SEPARATION":"Teeth separation","S_AUTO_3D_TEETH_LABELING":"Auto teeth labeling","S_BUILD_MODELS":"3D models building","S_TRANSFER_ALIGN":"Alignment transfer","S_PUBLISH_RESULT":"Results publishing","S_DATA_DOWNLOAD":"Data downloading","S_XLS_PARSE":"XLS parsing","S_DATA_UPDATE":"Update plan data","S_CENTROID_COMPUTE":"IPR computing","S_OCCLUSION_COMPUTE":"Occlusogram computing","S_PUBLISH":"Publishing","S_ASSETS_CREATE":"Assets creating","S_PDF_RENDER":"PDF rendering","S_QUALITY_CONTROL":"Quality control","S_ALIGN_MANUAL":"Manual alignment","S_TEETH_ROI_QUALITY_CONTROL":"Check Teeth ROI","S_TEETH_ROI":"Compute Teeth ROI","S_OCCLUSAL_PLANE_SETUP":"Occlusal plane setup","S_OCCLUSAL_PLANE":"Occlusal plane orientation","S_TRIM_BASE":"Model base trim setup","S_GENERATE_BASE":"Model base creation","S_TEETH_MARKUP":"Teeth markup","S_CROWN_SEGMENTATION":"Crown segmentation","S_SEGMENTED_ASSET_CREATION":"Segmented asset creation","S_LOCAL_C_S":"Crown local coordinates setup","S_MODELLING":"Movement Modelling","S_CLINICIAN_REVIEW":"Clinician review",0:"Draft",1:"Link for upload generated",'-20':"Failed"};var tableTypes={ct:'DeepCT analysis',ct_align:'DeepCBCT analysis v1.1 (align)',ct_v2:'DeepCT analysis v2',ct_v2_auto:'DeepCT analysis v2 auto',plan_standart:'Crowns plan',plan_roots:'Roots plan',plan_deep_ct:'DeepCT plan',plan_standard_orthostudio:'Crowns plan Orthostudio',plan_standard_3shape_1c:'Crowns plan 3Shape',plan_standard_3shape_color:'Crowns plan 3Shape Color',plan_standard_archform_1c:'Crowns plan Archform',plan_standard_onyxceph:'Crowns plan OnyxCeph',plan_standard_orthostudio_v5:'Crowns plan Orthostudio v5',plan_standard_suresmile_sou:'Crowns plan SureSmile',teeth_alignment_modelling:'Teeth alignment modelling'};var JON_WAITING_JOBS=[0,1,-20];var JOB_STATUS_WAITING="waiting";var JOB_STATUS_ALL="all";var FLOW_STEP_TYPE_MANUAL=0;function isWaitingJob(status){return JON_WAITING_JOBS.indexOf(status)>-1?true:false;}var mapStateToProps=function mapStateToProps(state){var jobs=state.jobs||[];return{jobs:jobs,isSupervisor:state.user.is_supervisor,waitingJobs:jobs.filter(function(job){return isWaitingJob(job.status);})};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getTechJobs2:function getTechJobs2(date_from,date_to){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_jobs__["e" /* getTechJobs2 */])(date_from,date_to));},eraseJobs:function eraseJobs(){return dispatch({type:'ERASE_JOBS'});},deleteJob:function deleteJob(uuid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_jobs__["a" /* deleteJob */])(uuid));}};};var CaseTableStaff=function(_Component){_inherits(CaseTableStaff,_Component);function CaseTableStaff(props){_classCallCheck(this,CaseTableStaff);var _this=_possibleConstructorReturn(this,(CaseTableStaff.__proto__||Object.getPrototypeOf(CaseTableStaff)).call(this,props));_this.handleChange=function(pagination,filters,sorter){_this.setState({filteredInfo:filters,sortedInfo:sorter});};_this.handleCaseTableRadioSwitch=function(e){var value=e.target.value;_this.setState({'filterWaitingJobs':value===JOB_STATUS_WAITING});};_this.state={shareModal:false,uuid:null,sorted_jobs:[],searchValue:'',tableLoading:false,filterWaitingJobs:false,sortedInfo:{order:'descend',columnKey:'created'}};return _this;}_createClass(CaseTableStaff,[{key:'shouldShowWaitingRadioButton',value:function shouldShowWaitingRadioButton(){return this.props.waitingJobs.length>0;}},{key:'componentDidMount',value:function componentDidMount(){this.props.getTechJobs2(__WEBPACK_IMPORTED_MODULE_23_moment___default()().subtract(30,'days').format('YYYY-MM-DD'),__WEBPACK_IMPORTED_MODULE_23_moment___default()().format('YYYY-MM-DD'));this.setState({'tableLoading':true});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){nextProps.jobs?this.setState({tableLoading:false}):null;}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.eraseJobs();}},{key:'requestJobs',value:function requestJobs(date_from,date_to){this.props.getTechJobs2(date_from,date_to);this.setState({'tableLoading':true});}},{key:'isManualStep',value:function isManualStep(data){return data.flow_step_queue&&data.flow_step_queue.step.step_type==FLOW_STEP_TYPE_MANUAL;}},{key:'shouldShowDeleteButton',value:function shouldShowDeleteButton(data){return isWaitingJob(data.status)||data.flow_step_queue&&data.flow_step_queue.step.step_type==FLOW_STEP_TYPE_MANUAL;}},{key:'filterByWaitingJobs',value:function filterByWaitingJobs(jobs){var hasWaitingJobs=this.props.waitingJobs.length>0;if(hasWaitingJobs){if(this.state.filterWaitingJobs){jobs=jobs.filter(function(job){return isWaitingJob(job.status)===true;});}else{jobs=jobs.filter(function(job){return isWaitingJob(job.status)===false;});}}return jobs;}},{key:'filterJobs',value:function filterJobs(searchText){var filtred_data=[];var table_data=this.props.jobs;if(searchText!==''){table_data.map(function(record){var match=false;Object.values(record).map(function(value){if(value&&Object.values(value).length){Object.values(value).map(function(subvalue){if(subvalue&&subvalue.toString().toUpperCase().indexOf(searchText.toUpperCase())!=-1){match=true;}});}else if(value&&value.toString().toUpperCase().indexOf(searchText.toUpperCase())!=-1){match=true;}});match?filtred_data.push(record):null;});}else{filtred_data=this.props.jobs;}return this.filterByWaitingJobs(filtred_data);}},{key:'onSearchHandler',value:function onSearchHandler(searchText){this.setState({'searchValue':searchText});}},{key:'render',value:function render(){var _this2=this;var sortedInfo=this.state.sortedInfo;sortedInfo=sortedInfo||{};var source=this.filterJobs(this.state.searchValue);var columns=[{title:'id',dataIndex:'uuid',render:function render(id){return id.slice(0,8);},key:'id',sorter:function sorter(a,b){return a.uuid-b.uuid;},sortOrder:sortedInfo.columnKey==='id'&&sortedInfo.order},{title:'Owner',dataIndex:'member',key:'member',render:function render(member){var res='';if(member){if(member.username){res=member.username;}else if(member.first_name&&member.last_name){res=member.first_name+' '+member.last_name;}}return res;}// sorter: (a, b) => a.ct_scan.patient_tag - b.ct_scan.patient_tag,
// sortOrder: sortedInfo.columnKey === 'patient_tag' && sortedInfo.order,
},{title:'Patient tag',dataIndex:'ct_scan.patient_tag',key:'patient_tag',sorter:function sorter(a,b){return a.ct_scan.patient_tag-b.ct_scan.patient_tag;},sortOrder:sortedInfo.columnKey==='patient_tag'&&sortedInfo.order},{title:'Status',key:'status',render:function render(data){var status="";if(data.flow_step_queue&&data.flow_step_queue.step){status=case_status[data.flow_step_queue.step.note];}if(!status){status=case_status[data.status];}return __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__statusComponent__["a" /* default */],{data:data,isManualStep:_this2.isManualStep(data)}),'  ',status);},sorter:function sorter(a,b){return a.status-b.status;},sortOrder:sortedInfo.columnKey==='status'&&sortedInfo.order},{title:'Updated',dataIndex:'last_modified',render:function render(date){return __WEBPACK_IMPORTED_MODULE_23_moment___default()(date).format('DD-MM-YYYY HH:mm:ss');},key:'last_modified',sorter:function sorter(a,b){return Date.parse(a.last_modified)-Date.parse(b.last_modified);},sortOrder:sortedInfo.columnKey==='last_modified'&&sortedInfo.order},{title:'Created',dataIndex:'created',render:function render(date){return __WEBPACK_IMPORTED_MODULE_23_moment___default()(date).format('DD-MM-YYYY HH:mm:ss');},key:'created',sorter:function sorter(a,b){return Date.parse(a.created)-Date.parse(b.created);},sortOrder:sortedInfo.columnKey==='created'&&sortedInfo.order},{title:'Flow',dataIndex:'flow.type',render:function render(type){return tableTypes[type];},key:'flow'},{title:'Plan type',dataIndex:'t_plan.plan_type.name',render:function render(plan_type){return plan_type;},key:'plan_type'},{title:'Actions',render:function render(data){if(_this2.props.isSupervisor===true&&_this2.shouldShowDeleteButton(data)){var menuOverlay=__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__actionStaffMenu__["b" /* default */],{data:data,actions:actions,onJobDelete:_this2.props.deleteJob});return __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_ActionMenu__["a" /* default */],{overlay:menuOverlay,ignoreOnClick:true,iconType:"down"});}else{return __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__actionStaffMenu__["a" /* DataFlowItem */],{data:data,actions:actions});}},key:'actions'}];return __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_PanelBox__["a" /* default */],{title:"Case table"},__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,{style:{marginBottom:16}},__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:8,align:'left'},this.shouldShowWaitingRadioButton()&&__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Group,{defaultValue:JOB_STATUS_ALL,onChange:this.handleCaseTableRadioSwitch},__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Button,{value:JOB_STATUS_ALL},'Active'),__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Button,{value:JOB_STATUS_WAITING},'Pending'))),__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,{span:8,offset:8,align:'right'},__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(RangePicker,{placeholder:['Start date','End date'],style:{width:220,marginBottom:10,textAlign:'left'},defaultValue:[__WEBPACK_IMPORTED_MODULE_23_moment___default()().subtract(30,'days'),__WEBPACK_IMPORTED_MODULE_23_moment___default()()],format:dateFormat,onChange:function onChange(evt){var from=__WEBPACK_IMPORTED_MODULE_23_moment___default()().subtract(30,'days').format('YYYY-MM-DD');var to=__WEBPACK_IMPORTED_MODULE_23_moment___default()().format('YYYY-MM-DD');if(evt[0]&&evt[0]._d){from=__WEBPACK_IMPORTED_MODULE_23_moment___default()(evt[0]._d).format('YYYY-MM-DD');}if(evt[1]&&evt[1]._d){to=__WEBPACK_IMPORTED_MODULE_23_moment___default()(evt[1]._d).format('YYYY-MM-DD');}_this2.requestJobs(from,to);}}),__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:'search'}),placeholder:'Search',style:{width:220},onChange:function onChange(e){return _this2.onSearchHandler(e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default.a,{dataSource:source,id:'case-table',columns:columns,rowKey:'uuid',loading:this.state.tableLoading,onChange:this.handleChange,onRowClick:function onRowClick(item){var note=item.flow_step_queue.step.note;if(note==='S_DATA_UPDATE'){window.location='/case/plan-update-form/'+item.uuid;}else if(note==='S_QUALITY_CONTROL'||note==='S_CLINICIAN_REVIEW'){window.location='/case/control/'+item.flow.type.replace(/\_/g,'-')+'/'+item.uuid;}else if(note==='S_PUBLISH'&&__WEBPACK_IMPORTED_MODULE_24__api_json__["type"]==='standalone'){_this2.setState({shareModal:true,uuid:item.uuid});}else if(note==='S_OCCLUSAL_PLANE_SETUP'||note==='S_OCCLUSAL_PLANE'||note==='S_TRIM_BASE'||note==='S_GENERATE_BASE'||note==='S_TEETH_MARKUP'||note==='S_CROWN_SEGMENTATION'||note==='S_SEGMENTED_ASSET_CREATION'||note==='S_LOCAL_C_S'||note==='S_MODELLING'){window.open(window.location.origin+'/teeth-alignment-modelling/?uuid='+item.uuid,'_blank');}else{window.location=('/ctscan/?uuid='+item.uuid+'&remote='+localStorage.getItem('API').replace('api/v1','')).replace(/\/$/g,'');}}})),__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a,{title:'Share links',centered:true,visible:this.state.shareModal,onOk:function onOk(){return _this2.setState({shareModal:false});},onCancel:function onCancel(){return _this2.setState({shareModal:false});},cancelButtonProps:{style:{display:'none'}}},__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('p',{style:{margin:0}},'Tech: ',__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('a',{target:'_blank',href:__WEBPACK_IMPORTED_MODULE_24__api_json__["tech_api"]+'/'+__WEBPACK_IMPORTED_MODULE_24__api_json__["public_path"]+'?uuid='+this.state.uuid},__WEBPACK_IMPORTED_MODULE_24__api_json__["tech_api"]+'/'+__WEBPACK_IMPORTED_MODULE_24__api_json__["public_path"]+'?uuid='+this.state.uuid)),__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('p',{style:{margin:'10px 0 0 0'}},'Client: ',__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('a',{target:'_blank',href:__WEBPACK_IMPORTED_MODULE_24__api_json__["client_api"]+'/'+__WEBPACK_IMPORTED_MODULE_24__api_json__["public_path"]+'?uuid='+this.state.uuid},__WEBPACK_IMPORTED_MODULE_24__api_json__["client_api"]+'/'+__WEBPACK_IMPORTED_MODULE_24__api_json__["public_path"]+'?uuid='+this.state.uuid))));}}]);return CaseTableStaff;}(__WEBPACK_IMPORTED_MODULE_20_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_21_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CaseTableStaff));

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(857);

__webpack_require__(20);

__webpack_require__(858);

__webpack_require__(860);

/***/ }),
/* 857 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(859);

__webpack_require__(20);

/***/ }),
/* 859 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(861);

/***/ }),
/* 861 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _rcCalendar = __webpack_require__(331);

var _rcCalendar2 = _interopRequireDefault(_rcCalendar);

var _MonthCalendar = __webpack_require__(334);

var _MonthCalendar2 = _interopRequireDefault(_MonthCalendar);

var _createPicker = __webpack_require__(887);

var _createPicker2 = _interopRequireDefault(_createPicker);

var _wrapPicker = __webpack_require__(891);

var _wrapPicker2 = _interopRequireDefault(_wrapPicker);

var _RangePicker = __webpack_require__(898);

var _RangePicker2 = _interopRequireDefault(_RangePicker);

var _WeekPicker = __webpack_require__(915);

var _WeekPicker2 = _interopRequireDefault(_WeekPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DatePicker = (0, _wrapPicker2['default'])((0, _createPicker2['default'])(_rcCalendar2['default']));
var MonthPicker = (0, _wrapPicker2['default'])((0, _createPicker2['default'])(_MonthCalendar2['default']), 'YYYY-MM');
(0, _extends3['default'])(DatePicker, {
    RangePicker: (0, _wrapPicker2['default'])(_RangePicker2['default']),
    MonthPicker: MonthPicker,
    WeekPicker: (0, _wrapPicker2['default'])(_WeekPicker2['default'], 'gggg-wo')
});
exports['default'] = DatePicker;
module.exports = exports['default'];

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__date_DateTable__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__calendar_CalendarHeader__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__calendar_CalendarFooter__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixin_CalendarMixin__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixin_CommonMixin__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__date_DateInput__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_toTime__ = __webpack_require__(880);















function noop() {}

var Calendar = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'Calendar',

  propTypes: {
    prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    style: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
    defaultValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
    value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
    selectedValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
    mode: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['time', 'date', 'month', 'year', 'decade']),
    locale: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
    showDateInput: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    showWeekNumber: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    showToday: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    showOk: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    onOk: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    onKeyDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    timePicker: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element,
    dateInputPlaceholder: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    onClear: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    onPanelChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    disabledDate: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    disabledTime: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    renderFooter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    renderSidebar: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixin_CommonMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixin_CalendarMixin__["a" /* default */]],

  getDefaultProps: function getDefaultProps() {
    return {
      showToday: true,
      showDateInput: true,
      timePicker: null,
      onOk: noop,
      onPanelChange: noop
    };
  },
  getInitialState: function getInitialState() {
    return {
      mode: this.props.mode || 'date'
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if ('mode' in nextProps && this.state.mode !== nextProps.mode) {
      this.setState({ mode: nextProps.mode });
    }
  },
  onKeyDown: function onKeyDown(event) {
    if (event.target.nodeName.toLowerCase() === 'input') {
      return undefined;
    }
    var keyCode = event.keyCode;
    // mac
    var ctrlKey = event.ctrlKey || event.metaKey;
    var disabledDate = this.props.disabledDate;
    var value = this.state.value;

    switch (keyCode) {
      case __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].DOWN:
        this.goTime(1, 'weeks');
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].UP:
        this.goTime(-1, 'weeks');
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].LEFT:
        if (ctrlKey) {
          this.goTime(-1, 'years');
        } else {
          this.goTime(-1, 'days');
        }
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].RIGHT:
        if (ctrlKey) {
          this.goTime(1, 'years');
        } else {
          this.goTime(1, 'days');
        }
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].HOME:
        this.setValue(Object(__WEBPACK_IMPORTED_MODULE_13__util_toTime__["b" /* goStartMonth */])(this.state.value));
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].END:
        this.setValue(Object(__WEBPACK_IMPORTED_MODULE_13__util_toTime__["a" /* goEndMonth */])(this.state.value));
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].PAGE_DOWN:
        this.goTime(1, 'month');
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].PAGE_UP:
        this.goTime(-1, 'month');
        event.preventDefault();
        return 1;
      case __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].ENTER:
        if (!disabledDate || !disabledDate(value)) {
          this.onSelect(value, {
            source: 'keyboard'
          });
        }
        event.preventDefault();
        return 1;
      default:
        this.props.onKeyDown(event);
        return 1;
    }
  },
  onClear: function onClear() {
    this.onSelect(null);
    this.props.onClear();
  },
  onOk: function onOk() {
    var selectedValue = this.state.selectedValue;

    if (this.isAllowedDate(selectedValue)) {
      this.props.onOk(selectedValue);
    }
  },
  onDateInputChange: function onDateInputChange(value) {
    this.onSelect(value, {
      source: 'dateInput'
    });
  },
  onDateTableSelect: function onDateTableSelect(value) {
    var timePicker = this.props.timePicker;
    var selectedValue = this.state.selectedValue;

    if (!selectedValue && timePicker) {
      var timePickerDefaultValue = timePicker.props.defaultValue;
      if (timePickerDefaultValue) {
        Object(__WEBPACK_IMPORTED_MODULE_12__util__["g" /* syncTime */])(timePickerDefaultValue, value);
      }
    }
    this.onSelect(value);
  },
  onToday: function onToday() {
    var value = this.state.value;

    var now = Object(__WEBPACK_IMPORTED_MODULE_12__util__["d" /* getTodayTime */])(value);
    this.onSelect(now, {
      source: 'todayButton'
    });
  },
  onPanelChange: function onPanelChange(value, mode) {
    var props = this.props,
        state = this.state;

    if (!('mode' in props)) {
      this.setState({ mode: mode });
    }
    props.onPanelChange(value || state.value, mode);
  },
  getRootDOMNode: function getRootDOMNode() {
    return __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this);
  },
  openTimePicker: function openTimePicker() {
    this.onPanelChange(null, 'time');
  },
  closeTimePicker: function closeTimePicker() {
    this.onPanelChange(null, 'date');
  },
  goTime: function goTime(direction, unit) {
    this.setValue(Object(__WEBPACK_IMPORTED_MODULE_13__util_toTime__["c" /* goTime */])(this.state.value, direction, unit));
  },
  render: function render() {
    var props = this.props,
        state = this.state;
    var locale = props.locale,
        prefixCls = props.prefixCls,
        disabledDate = props.disabledDate,
        dateInputPlaceholder = props.dateInputPlaceholder,
        timePicker = props.timePicker,
        disabledTime = props.disabledTime;
    var value = state.value,
        selectedValue = state.selectedValue,
        mode = state.mode;

    var showTimePicker = mode === 'time';
    var disabledTimeConfig = showTimePicker && disabledTime && timePicker ? Object(__WEBPACK_IMPORTED_MODULE_12__util__["b" /* getTimeConfig */])(selectedValue, disabledTime) : null;

    var timePickerEle = null;

    if (timePicker && showTimePicker) {
      var timePickerProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        showHour: true,
        showSecond: true,
        showMinute: true
      }, timePicker.props, disabledTimeConfig, {
        onChange: this.onDateInputChange,
        value: selectedValue,
        disabledTime: disabledTime
      });

      if (timePicker.props.defaultValue !== undefined) {
        timePickerProps.defaultOpenValue = timePicker.props.defaultValue;
      }

      timePickerEle = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(timePicker, timePickerProps);
    }

    var dateInputElement = props.showDateInput ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__date_DateInput__["a" /* default */], {
      format: this.getFormat(),
      key: 'date-input',
      value: value,
      locale: locale,
      placeholder: dateInputPlaceholder,
      showClear: true,
      disabledTime: disabledTime,
      disabledDate: disabledDate,
      onClear: this.onClear,
      prefixCls: prefixCls,
      selectedValue: selectedValue,
      onChange: this.onDateInputChange
    }) : null;
    var children = [props.renderSidebar(), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: prefixCls + '-panel', key: 'panel' },
      dateInputElement,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: prefixCls + '-date-panel' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__calendar_CalendarHeader__["a" /* default */], {
          locale: locale,
          mode: mode,
          value: value,
          onValueChange: this.setValue,
          onPanelChange: this.onPanelChange,
          showTimePicker: showTimePicker,
          prefixCls: prefixCls
        }),
        timePicker && showTimePicker ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: prefixCls + '-time-picker' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: prefixCls + '-time-picker-panel' },
            timePickerEle
          )
        ) : null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: prefixCls + '-body' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__date_DateTable__["a" /* default */], {
            locale: locale,
            value: value,
            selectedValue: selectedValue,
            prefixCls: prefixCls,
            dateRender: props.dateRender,
            onSelect: this.onDateTableSelect,
            disabledDate: disabledDate,
            showWeekNumber: props.showWeekNumber
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__calendar_CalendarFooter__["a" /* default */], {
          showOk: props.showOk,
          renderFooter: props.renderFooter,
          locale: locale,
          prefixCls: prefixCls,
          showToday: props.showToday,
          disabledTime: disabledTime,
          showTimePicker: showTimePicker,
          showDateInput: props.showDateInput,
          timePicker: timePicker,
          selectedValue: selectedValue,
          value: value,
          disabledDate: disabledDate,
          okDisabled: !this.isAllowedDate(selectedValue),
          onOk: this.onOk,
          onSelect: this.onSelect,
          onToday: this.onToday,
          onOpenTimePicker: this.openTimePicker,
          onCloseTimePicker: this.closeTimePicker
        })
      )
    )];

    return this.renderRoot({
      children: children,
      className: props.showWeekNumber ? prefixCls + '-week-number' : ''
    });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Calendar);

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DateTHead__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DateTBody__ = __webpack_require__(866);








var DateTable = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DateTable, _React$Component);

  function DateTable() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DateTable);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DateTable.prototype.render = function render() {
    var props = this.props;
    var prefixCls = props.prefixCls;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'table',
      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DateTHead__["a" /* default */], props),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DateTBody__["a" /* default */], props)
    );
  };

  return DateTable;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (DateTable);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DateConstants__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);







var DateTHead = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DateTHead, _React$Component);

  function DateTHead() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DateTHead);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DateTHead.prototype.render = function render() {
    var props = this.props;
    var value = props.value;
    var localeData = value.localeData();
    var prefixCls = props.prefixCls;
    var veryShortWeekdays = [];
    var weekDays = [];
    var firstDayOfWeek = localeData.firstDayOfWeek();
    var showWeekNumberEl = void 0;
    var now = __WEBPACK_IMPORTED_MODULE_5_moment___default()();
    for (var dateColIndex = 0; dateColIndex < __WEBPACK_IMPORTED_MODULE_4__DateConstants__["a" /* default */].DATE_COL_COUNT; dateColIndex++) {
      var index = (firstDayOfWeek + dateColIndex) % __WEBPACK_IMPORTED_MODULE_4__DateConstants__["a" /* default */].DATE_COL_COUNT;
      now.day(index);
      veryShortWeekdays[dateColIndex] = localeData.weekdaysMin(now);
      weekDays[dateColIndex] = localeData.weekdaysShort(now);
    }

    if (props.showWeekNumber) {
      showWeekNumberEl = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'th',
        {
          role: 'columnheader',
          className: prefixCls + '-column-header ' + prefixCls + '-week-number-header'
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'span',
          { className: prefixCls + '-column-header-inner' },
          'x'
        )
      );
    }
    var weekDaysEls = weekDays.map(function (day, xindex) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'th',
        {
          key: xindex,
          role: 'columnheader',
          title: day,
          className: prefixCls + '-column-header'
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'span',
          { className: prefixCls + '-column-header-inner' },
          veryShortWeekdays[xindex]
        )
      );
    });
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'thead',
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        { role: 'row' },
        showWeekNumberEl,
        weekDaysEls
      )
    );
  };

  return DateTHead;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (DateTHead);

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DateConstants__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util___ = __webpack_require__(97);







function isSameDay(one, two) {
  return one && two && one.isSame(two, 'day');
}

function beforeCurrentMonthYear(current, today) {
  if (current.year() < today.year()) {
    return 1;
  }
  return current.year() === today.year() && current.month() < today.month();
}

function afterCurrentMonthYear(current, today) {
  if (current.year() > today.year()) {
    return 1;
  }
  return current.year() === today.year() && current.month() > today.month();
}

function getIdFromDate(date) {
  return 'rc-calendar-' + date.year() + '-' + date.month() + '-' + date.date();
}

var DateTBody = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'DateTBody',

  propTypes: {
    contentRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    dateRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    disabledDate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    prefixCls: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    selectedValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object)]),
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    hoverValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    showWeekNumber: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      hoverValue: []
    };
  },
  render: function render() {
    var props = this.props;
    var contentRender = props.contentRender,
        prefixCls = props.prefixCls,
        selectedValue = props.selectedValue,
        value = props.value,
        showWeekNumber = props.showWeekNumber,
        dateRender = props.dateRender,
        disabledDate = props.disabledDate,
        hoverValue = props.hoverValue;

    var iIndex = void 0;
    var jIndex = void 0;
    var current = void 0;
    var dateTable = [];
    var today = Object(__WEBPACK_IMPORTED_MODULE_5__util___["d" /* getTodayTime */])(value);
    var cellClass = prefixCls + '-cell';
    var weekNumberCellClass = prefixCls + '-week-number-cell';
    var dateClass = prefixCls + '-date';
    var todayClass = prefixCls + '-today';
    var selectedClass = prefixCls + '-selected-day';
    var selectedDateClass = prefixCls + '-selected-date'; // do not move with mouse operation
    var selectedStartDateClass = prefixCls + '-selected-start-date';
    var selectedEndDateClass = prefixCls + '-selected-end-date';
    var inRangeClass = prefixCls + '-in-range-cell';
    var lastMonthDayClass = prefixCls + '-last-month-cell';
    var nextMonthDayClass = prefixCls + '-next-month-btn-day';
    var disabledClass = prefixCls + '-disabled-cell';
    var firstDisableClass = prefixCls + '-disabled-cell-first-of-row';
    var lastDisableClass = prefixCls + '-disabled-cell-last-of-row';
    var lastDayOfMonthClass = prefixCls + '-last-day-of-month';
    var month1 = value.clone();
    month1.date(1);
    var day = month1.day();
    var lastMonthDiffDay = (day + 7 - value.localeData().firstDayOfWeek()) % 7;
    // calculate last month
    var lastMonth1 = month1.clone();
    lastMonth1.add(0 - lastMonthDiffDay, 'days');
    var passed = 0;

    for (iIndex = 0; iIndex < __WEBPACK_IMPORTED_MODULE_4__DateConstants__["a" /* default */].DATE_ROW_COUNT; iIndex++) {
      for (jIndex = 0; jIndex < __WEBPACK_IMPORTED_MODULE_4__DateConstants__["a" /* default */].DATE_COL_COUNT; jIndex++) {
        current = lastMonth1;
        if (passed) {
          current = current.clone();
          current.add(passed, 'days');
        }
        dateTable.push(current);
        passed++;
      }
    }
    var tableHtml = [];
    passed = 0;

    for (iIndex = 0; iIndex < __WEBPACK_IMPORTED_MODULE_4__DateConstants__["a" /* default */].DATE_ROW_COUNT; iIndex++) {
      var _cx;

      var isCurrentWeek = void 0;
      var weekNumberCell = void 0;
      var isActiveWeek = false;
      var dateCells = [];
      if (showWeekNumber) {
        weekNumberCell = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          {
            key: dateTable[passed].week(),
            role: 'gridcell',
            className: weekNumberCellClass
          },
          dateTable[passed].week()
        );
      }
      for (jIndex = 0; jIndex < __WEBPACK_IMPORTED_MODULE_4__DateConstants__["a" /* default */].DATE_COL_COUNT; jIndex++) {
        var next = null;
        var last = null;
        current = dateTable[passed];
        if (jIndex < __WEBPACK_IMPORTED_MODULE_4__DateConstants__["a" /* default */].DATE_COL_COUNT - 1) {
          next = dateTable[passed + 1];
        }
        if (jIndex > 0) {
          last = dateTable[passed - 1];
        }
        var cls = cellClass;
        var disabled = false;
        var selected = false;

        if (isSameDay(current, today)) {
          cls += ' ' + todayClass;
          isCurrentWeek = true;
        }

        var isBeforeCurrentMonthYear = beforeCurrentMonthYear(current, value);
        var isAfterCurrentMonthYear = afterCurrentMonthYear(current, value);

        if (selectedValue && Array.isArray(selectedValue)) {
          var rangeValue = hoverValue.length ? hoverValue : selectedValue;
          if (!isBeforeCurrentMonthYear && !isAfterCurrentMonthYear) {
            var startValue = rangeValue[0];
            var endValue = rangeValue[1];
            if (startValue) {
              if (isSameDay(current, startValue)) {
                selected = true;
                isActiveWeek = true;
                cls += ' ' + selectedStartDateClass;
              }
            }
            if (startValue && endValue) {
              if (isSameDay(current, endValue)) {
                selected = true;
                isActiveWeek = true;
                cls += ' ' + selectedEndDateClass;
              } else if (current.isAfter(startValue, 'day') && current.isBefore(endValue, 'day')) {
                cls += ' ' + inRangeClass;
              }
            }
          }
        } else if (isSameDay(current, value)) {
          // keyboard change value, highlight works
          selected = true;
          isActiveWeek = true;
        }

        if (isSameDay(current, selectedValue)) {
          cls += ' ' + selectedDateClass;
        }

        if (isBeforeCurrentMonthYear) {
          cls += ' ' + lastMonthDayClass;
        }

        if (isAfterCurrentMonthYear) {
          cls += ' ' + nextMonthDayClass;
        }

        if (current.clone().endOf('month').date() === current.date()) {
          cls += ' ' + lastDayOfMonthClass;
        }

        if (disabledDate) {
          if (disabledDate(current, value)) {
            disabled = true;

            if (!last || !disabledDate(last, value)) {
              cls += ' ' + firstDisableClass;
            }

            if (!next || !disabledDate(next, value)) {
              cls += ' ' + lastDisableClass;
            }
          }
        }

        if (selected) {
          cls += ' ' + selectedClass;
        }

        if (disabled) {
          cls += ' ' + disabledClass;
        }

        var dateHtml = void 0;
        if (dateRender) {
          dateHtml = dateRender(current, value);
        } else {
          var content = contentRender ? contentRender(current, value) : current.date();
          dateHtml = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              key: getIdFromDate(current),
              className: dateClass,
              'aria-selected': selected,
              'aria-disabled': disabled
            },
            content
          );
        }

        dateCells.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          {
            key: passed,
            onClick: disabled ? undefined : props.onSelect.bind(null, current),
            onMouseEnter: disabled ? undefined : props.onDayHover && props.onDayHover.bind(null, current) || undefined,
            role: 'gridcell',
            title: Object(__WEBPACK_IMPORTED_MODULE_5__util___["c" /* getTitleString */])(current),
            className: cls
          },
          dateHtml
        ));

        passed++;
      }

      tableHtml.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tr',
        {
          key: iIndex,
          role: 'row',
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()((_cx = {}, _cx[prefixCls + '-current-week'] = isCurrentWeek, _cx[prefixCls + '-active-week'] = isActiveWeek, _cx))
        },
        weekNumberCell,
        dateCells
      ));
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'tbody',
      { className: prefixCls + '-tbody' },
      tableHtml
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (DateTBody);

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_Children_mapSelf__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__month_MonthPanel__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__year_YearPanel__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__decade_DecadePanel__ = __webpack_require__(871);








function goMonth(direction) {
  var next = this.props.value.clone();
  next.add(direction, 'months');
  this.props.onValueChange(next);
}

function goYear(direction) {
  var next = this.props.value.clone();
  next.add(direction, 'years');
  this.props.onValueChange(next);
}

function showIf(condition, el) {
  return condition ? el : null;
}

var CalendarHeader = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'CalendarHeader',

  propTypes: {
    prefixCls: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    onValueChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    showTimePicker: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    onPanelChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    locale: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    enablePrev: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    enableNext: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    disabledMonth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      enableNext: 1,
      enablePrev: 1,
      onPanelChange: function onPanelChange() {},
      onValueChange: function onValueChange() {}
    };
  },
  getInitialState: function getInitialState() {
    this.nextMonth = goMonth.bind(this, 1);
    this.previousMonth = goMonth.bind(this, -1);
    this.nextYear = goYear.bind(this, 1);
    this.previousYear = goYear.bind(this, -1);
    return { yearPanelReferer: null };
  },
  onMonthSelect: function onMonthSelect(value) {
    this.props.onPanelChange(value, 'date');
    if (this.props.onMonthSelect) {
      this.props.onMonthSelect(value);
    } else {
      this.props.onValueChange(value);
    }
  },
  onYearSelect: function onYearSelect(value) {
    var referer = this.state.yearPanelReferer;
    this.setState({ yearPanelReferer: null });
    this.props.onPanelChange(value, referer);
    this.props.onValueChange(value);
  },
  onDecadeSelect: function onDecadeSelect(value) {
    this.props.onPanelChange(value, 'year');
    this.props.onValueChange(value);
  },
  monthYearElement: function monthYearElement(showTimePicker) {
    var _this = this;

    var props = this.props;
    var prefixCls = props.prefixCls;
    var locale = props.locale;
    var value = props.value;
    var localeData = value.localeData();
    var monthBeforeYear = locale.monthBeforeYear;
    var selectClassName = prefixCls + '-' + (monthBeforeYear ? 'my-select' : 'ym-select');
    var year = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      {
        className: prefixCls + '-year-select',
        role: 'button',
        onClick: showTimePicker ? null : function () {
          return _this.showYearPanel('date');
        },
        title: locale.yearSelect
      },
      value.format(locale.yearFormat)
    );
    var month = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      {
        className: prefixCls + '-month-select',
        role: 'button',
        onClick: showTimePicker ? null : this.showMonthPanel,
        title: locale.monthSelect
      },
      locale.monthFormat ? value.format(locale.monthFormat) : localeData.monthsShort(value)
    );
    var day = void 0;
    if (showTimePicker) {
      day = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        {
          className: prefixCls + '-day-select',
          role: 'button'
        },
        value.format(locale.dayFormat)
      );
    }
    var my = [];
    if (monthBeforeYear) {
      my = [month, day, year];
    } else {
      my = [year, month, day];
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: selectClassName },
      Object(__WEBPACK_IMPORTED_MODULE_3_rc_util_es_Children_mapSelf__["a" /* default */])(my)
    );
  },
  showMonthPanel: function showMonthPanel() {
    // null means that users' interaction doesn't change value
    this.props.onPanelChange(null, 'month');
  },
  showYearPanel: function showYearPanel(referer) {
    this.setState({ yearPanelReferer: referer });
    this.props.onPanelChange(null, 'year');
  },
  showDecadePanel: function showDecadePanel() {
    this.props.onPanelChange(null, 'decade');
  },
  render: function render() {
    var _this2 = this;

    var props = this.props;
    var prefixCls = props.prefixCls,
        locale = props.locale,
        mode = props.mode,
        value = props.value,
        showTimePicker = props.showTimePicker,
        enableNext = props.enableNext,
        enablePrev = props.enablePrev,
        disabledMonth = props.disabledMonth;


    var panel = null;
    if (mode === 'month') {
      panel = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__month_MonthPanel__["a" /* default */], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onMonthSelect,
        onYearPanelShow: function onYearPanelShow() {
          return _this2.showYearPanel('month');
        },
        disabledDate: disabledMonth,
        cellRender: props.monthCellRender,
        contentRender: props.monthCellContentRender
      });
    }
    if (mode === 'year') {
      panel = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__year_YearPanel__["a" /* default */], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onYearSelect,
        onDecadePanelShow: this.showDecadePanel
      });
    }
    if (mode === 'decade') {
      panel = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__decade_DecadePanel__["a" /* default */], {
        locale: locale,
        defaultValue: value,
        rootPrefixCls: prefixCls,
        onSelect: this.onDecadeSelect
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: prefixCls + '-header' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { position: 'relative' } },
        showIf(enablePrev && !showTimePicker, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', {
          className: prefixCls + '-prev-year-btn',
          role: 'button',
          onClick: this.previousYear,
          title: locale.previousYear
        })),
        showIf(enablePrev && !showTimePicker, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', {
          className: prefixCls + '-prev-month-btn',
          role: 'button',
          onClick: this.previousMonth,
          title: locale.previousMonth
        })),
        this.monthYearElement(showTimePicker),
        showIf(enableNext && !showTimePicker, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', {
          className: prefixCls + '-next-month-btn',
          onClick: this.nextMonth,
          title: locale.nextMonth
        })),
        showIf(enableNext && !showTimePicker, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', {
          className: prefixCls + '-next-year-btn',
          onClick: this.nextYear,
          title: locale.nextYear
        }))
      ),
      panel
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (CalendarHeader);

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MonthTable__ = __webpack_require__(869);





function goYear(direction) {
  var next = this.state.value.clone();
  next.add(direction, 'year');
  this.setAndChangeValue(next);
}

function noop() {}

var MonthPanel = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'MonthPanel',

  propTypes: {
    onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    disabledDate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onChange: noop,
      onSelect: noop
    };
  },
  getInitialState: function getInitialState() {
    var props = this.props;
    // bind methods
    this.nextYear = goYear.bind(this, 1);
    this.previousYear = goYear.bind(this, -1);
    this.prefixCls = props.rootPrefixCls + '-month-panel';
    return {
      value: props.value || props.defaultValue
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      this.setState({
        value: nextProps.value
      });
    }
  },
  setAndChangeValue: function setAndChangeValue(value) {
    this.setValue(value);
    this.props.onChange(value);
  },
  setAndSelectValue: function setAndSelectValue(value) {
    this.setValue(value);
    this.props.onSelect(value);
  },
  setValue: function setValue(value) {
    if (!('value' in this.props)) {
      this.setState({
        value: value
      });
    }
  },
  render: function render() {
    var props = this.props;
    var value = this.state.value;
    var cellRender = props.cellRender;
    var contentRender = props.contentRender;
    var locale = props.locale;
    var year = value.year();
    var prefixCls = this.prefixCls;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: prefixCls, style: props.style },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: prefixCls + '-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', {
            className: prefixCls + '-prev-year-btn',
            role: 'button',
            onClick: this.previousYear,
            title: locale.previousYear
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            {
              className: prefixCls + '-year-select',
              role: 'button',
              onClick: props.onYearPanelShow,
              title: locale.yearSelect
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: prefixCls + '-year-select-content' },
              year
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: prefixCls + '-year-select-arrow' },
              'x'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', {
            className: prefixCls + '-next-year-btn',
            role: 'button',
            onClick: this.nextYear,
            title: locale.nextYear
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: prefixCls + '-body' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MonthTable__["a" /* default */], {
            disabledDate: props.disabledDate,
            onSelect: this.setAndSelectValue,
            locale: locale,
            value: value,
            cellRender: cellRender,
            contentRender: contentRender,
            prefixCls: prefixCls
          })
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (MonthPanel);

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_index__ = __webpack_require__(97);








var ROW = 4;
var COL = 3;

function chooseMonth(month) {
  var next = this.state.value.clone();
  next.month(month);
  this.setAndSelectValue(next);
}

function noop() {}

var MonthTable = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(MonthTable, _Component);

  function MonthTable(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MonthTable);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _this.state = {
      value: props.value
    };
    return _this;
  }

  MonthTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      this.setState({
        value: nextProps.value
      });
    }
  };

  MonthTable.prototype.setAndSelectValue = function setAndSelectValue(value) {
    this.setState({
      value: value
    });
    this.props.onSelect(value);
  };

  MonthTable.prototype.months = function months() {
    var value = this.state.value;
    var current = value.clone();
    var months = [];
    var index = 0;
    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      months[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        current.month(index);
        var content = Object(__WEBPACK_IMPORTED_MODULE_6__util_index__["a" /* getMonthName */])(current);
        months[rowIndex][colIndex] = {
          value: index,
          content: content,
          title: content
        };
        index++;
      }
    }
    return months;
  };

  MonthTable.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var value = this.state.value;
    var today = Object(__WEBPACK_IMPORTED_MODULE_6__util_index__["d" /* getTodayTime */])(value);
    var months = this.months();
    var currentMonth = value.month();
    var prefixCls = props.prefixCls,
        locale = props.locale,
        contentRender = props.contentRender,
        cellRender = props.cellRender;

    var monthsEls = months.map(function (month, index) {
      var tds = month.map(function (monthData) {
        var _classNameMap;

        var disabled = false;
        if (props.disabledDate) {
          var testValue = value.clone();
          testValue.month(monthData.value);
          disabled = props.disabledDate(testValue);
        }
        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-cell-disabled'] = disabled, _classNameMap[prefixCls + '-selected-cell'] = monthData.value === currentMonth, _classNameMap[prefixCls + '-current-cell'] = today.year() === value.year() && monthData.value === today.month(), _classNameMap);
        var cellEl = void 0;
        if (cellRender) {
          var currentValue = value.clone();
          currentValue.month(monthData.value);
          cellEl = cellRender(currentValue, locale);
        } else {
          var content = void 0;
          if (contentRender) {
            var _currentValue = value.clone();
            _currentValue.month(monthData.value);
            content = contentRender(_currentValue, locale);
          } else {
            content = monthData.content;
          }
          cellEl = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            { className: prefixCls + '-month' },
            content
          );
        }
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          {
            role: 'gridcell',
            key: monthData.value,
            onClick: disabled ? null : chooseMonth.bind(_this2, monthData.value),
            title: monthData.title,
            className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classNameMap)
          },
          cellEl
        );
      });
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        { key: index, role: 'row' },
        tds
      );
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'table',
      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tbody',
        { className: prefixCls + '-tbody' },
        monthsEls
      )
    );
  };

  return MonthTable;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

MonthTable.defaultProps = {
  onSelect: noop
};
MonthTable.propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  cellRender: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (MonthTable);

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);






var ROW = 4;
var COL = 3;

function goYear(direction) {
  var value = this.state.value.clone();
  value.add(direction, 'year');
  this.setState({
    value: value
  });
}

function chooseYear(year) {
  var value = this.state.value.clone();
  value.year(year);
  value.month(this.state.value.month());
  this.props.onSelect(value);
}

var YearPanel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(YearPanel, _React$Component);

  function YearPanel(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, YearPanel);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.prefixCls = props.rootPrefixCls + '-year-panel';
    _this.state = {
      value: props.value || props.defaultValue
    };
    _this.nextDecade = goYear.bind(_this, 10);
    _this.previousDecade = goYear.bind(_this, -10);
    return _this;
  }

  YearPanel.prototype.years = function years() {
    var value = this.state.value;
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 10, 10) * 10;
    var previousYear = startYear - 1;
    var years = [];
    var index = 0;
    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      years[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        var year = previousYear + index;
        var content = String(year);
        years[rowIndex][colIndex] = {
          content: content,
          year: year,
          title: content
        };
        index++;
      }
    }
    return years;
  };

  YearPanel.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var value = this.state.value;
    var locale = props.locale;
    var years = this.years();
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 10, 10) * 10;
    var endYear = startYear + 9;
    var prefixCls = this.prefixCls;

    var yeasEls = years.map(function (row, index) {
      var tds = row.map(function (yearData) {
        var _classNameMap;

        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = yearData.year === currentYear, _classNameMap[prefixCls + '-last-decade-cell'] = yearData.year < startYear, _classNameMap[prefixCls + '-next-decade-cell'] = yearData.year > endYear, _classNameMap);
        var clickHandler = void 0;
        if (yearData.year < startYear) {
          clickHandler = _this2.previousDecade;
        } else if (yearData.year > endYear) {
          clickHandler = _this2.nextDecade;
        } else {
          clickHandler = chooseYear.bind(_this2, yearData.year);
        }
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          {
            role: 'gridcell',
            title: yearData.title,
            key: yearData.content,
            onClick: clickHandler,
            className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classNameMap)
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            {
              className: prefixCls + '-year'
            },
            yearData.content
          )
        );
      });
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        { key: index, role: 'row' },
        tds
      );
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: this.prefixCls },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-header' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
            className: prefixCls + '-prev-decade-btn',
            role: 'button',
            onClick: this.previousDecade,
            title: locale.previousDecade
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            {
              className: prefixCls + '-decade-select',
              role: 'button',
              onClick: props.onDecadePanelShow,
              title: locale.decadeSelect
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'span',
              { className: prefixCls + '-decade-select-content' },
              startYear,
              '-',
              endYear
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'span',
              { className: prefixCls + '-decade-select-arrow' },
              'x'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
            className: prefixCls + '-next-decade-btn',
            role: 'button',
            onClick: this.nextDecade,
            title: locale.nextDecade
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-body' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'table',
            { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'tbody',
              { className: prefixCls + '-tbody' },
              yeasEls
            )
          )
        )
      )
    );
  };

  return YearPanel;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (YearPanel);


YearPanel.propTypes = {
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  defaultValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
};

YearPanel.defaultProps = {
  onSelect: function onSelect() {}
};

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);





var ROW = 4;
var COL = 3;


function goYear(direction) {
  var next = this.state.value.clone();
  next.add(direction, 'years');
  this.setState({
    value: next
  });
}

function chooseDecade(year, event) {
  var next = this.state.value.clone();
  next.year(year);
  next.month(this.state.value.month());
  this.props.onSelect(next);
  event.preventDefault();
}

var DecadePanel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DecadePanel, _React$Component);

  function DecadePanel(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DecadePanel);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      value: props.value || props.defaultValue
    };

    // bind methods
    _this.prefixCls = props.rootPrefixCls + '-decade-panel';
    _this.nextCentury = goYear.bind(_this, 100);
    _this.previousCentury = goYear.bind(_this, -100);
    return _this;
  }

  DecadePanel.prototype.render = function render() {
    var _this2 = this;

    var value = this.state.value;
    var locale = this.props.locale;
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 100, 10) * 100;
    var preYear = startYear - 10;
    var endYear = startYear + 99;
    var decades = [];
    var index = 0;
    var prefixCls = this.prefixCls;

    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      decades[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        var startDecade = preYear + index * 10;
        var endDecade = preYear + index * 10 + 9;
        decades[rowIndex][colIndex] = {
          startDecade: startDecade,
          endDecade: endDecade
        };
        index++;
      }
    }

    var decadesEls = decades.map(function (row, decadeIndex) {
      var tds = row.map(function (decadeData) {
        var _classNameMap;

        var dStartDecade = decadeData.startDecade;
        var dEndDecade = decadeData.endDecade;
        var isLast = dStartDecade < startYear;
        var isNext = dEndDecade > endYear;
        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = dStartDecade <= currentYear && currentYear <= dEndDecade, _classNameMap[prefixCls + '-last-century-cell'] = isLast, _classNameMap[prefixCls + '-next-century-cell'] = isNext, _classNameMap);
        var content = dStartDecade + '-' + dEndDecade;
        var clickHandler = void 0;
        if (isLast) {
          clickHandler = _this2.previousCentury;
        } else if (isNext) {
          clickHandler = _this2.nextCentury;
        } else {
          clickHandler = chooseDecade.bind(_this2, dStartDecade);
        }
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'td',
          {
            key: dStartDecade,
            onClick: clickHandler,
            role: 'gridcell',
            className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classNameMap)
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            {
              className: prefixCls + '-decade'
            },
            content
          )
        );
      });
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'tr',
        { key: decadeIndex, role: 'row' },
        tds
      );
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: this.prefixCls },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: prefixCls + '-header' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-prev-century-btn',
          role: 'button',
          onClick: this.previousCentury,
          title: locale.previousCentury
        }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: prefixCls + '-century' },
          startYear,
          '-',
          endYear
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', {
          className: prefixCls + '-next-century-btn',
          role: 'button',
          onClick: this.nextCentury,
          title: locale.nextCentury
        })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: prefixCls + '-body' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'table',
          { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'tbody',
            { className: prefixCls + '-tbody' },
            decadesEls
          )
        )
      )
    );
  };

  return DecadePanel;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (DecadePanel);


DecadePanel.propTypes = {
  locale: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  defaultValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
};

DecadePanel.defaultProps = {
  onSelect: function onSelect() {}
};

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_Children_mapSelf__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__calendar_TodayButton__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__calendar_OkButton__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__calendar_TimePickerButton__ = __webpack_require__(875);











var CalendarFooter = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'CalendarFooter',

  propTypes: {
    prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    showDateInput: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    disabledTime: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    timePicker: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element,
    selectedValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    showOk: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
    renderFooter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    defaultValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
  },

  onSelect: function onSelect(value) {
    this.props.onSelect(value);
  },
  getRootDOMNode: function getRootDOMNode() {
    return __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this);
  },
  render: function render() {
    var props = this.props;
    var value = props.value,
        prefixCls = props.prefixCls,
        showOk = props.showOk,
        timePicker = props.timePicker,
        renderFooter = props.renderFooter;

    var footerEl = null;
    var extraFooter = renderFooter();
    if (props.showToday || timePicker || extraFooter) {
      var _cx;

      var nowEl = void 0;
      if (props.showToday) {
        nowEl = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__calendar_TodayButton__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { value: value }));
      }
      var okBtn = void 0;
      if (showOk === true || showOk !== false && !!props.timePicker) {
        okBtn = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__calendar_OkButton__["a" /* default */], props);
      }
      var timePickerBtn = void 0;
      if (!!props.timePicker) {
        timePickerBtn = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__calendar_TimePickerButton__["a" /* default */], props);
      }

      var footerBtn = void 0;
      if (nowEl || timePickerBtn || okBtn) {
        footerBtn = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: prefixCls + '-footer-btn' },
          Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_Children_mapSelf__["a" /* default */])([nowEl, timePickerBtn, okBtn])
        );
      }
      var cls = __WEBPACK_IMPORTED_MODULE_6_classnames___default()((_cx = {}, _cx[prefixCls + '-footer'] = true, _cx[prefixCls + '-footer-show-ok'] = okBtn, _cx));
      footerEl = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: cls },
        extraFooter,
        footerBtn
      );
    }
    return footerEl;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (CalendarFooter);

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TodayButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___ = __webpack_require__(97);



function TodayButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      value = _ref.value,
      timePicker = _ref.timePicker,
      disabled = _ref.disabled,
      disabledDate = _ref.disabledDate,
      onToday = _ref.onToday,
      text = _ref.text;

  var localeNow = (!text && timePicker ? locale.now : text) || locale.today;
  var disabledToday = disabledDate && !Object(__WEBPACK_IMPORTED_MODULE_1__util___["f" /* isAllowedDate */])(Object(__WEBPACK_IMPORTED_MODULE_1__util___["d" /* getTodayTime */])(value), disabledDate);
  var isDisabled = disabledToday || disabled;
  var disabledTodayClass = isDisabled ? prefixCls + '-today-btn-disabled' : '';
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: prefixCls + '-today-btn ' + disabledTodayClass,
      role: 'button',
      onClick: isDisabled ? null : onToday,
      title: Object(__WEBPACK_IMPORTED_MODULE_1__util___["e" /* getTodayTimeStr */])(value)
    },
    localeNow
  );
}

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = OkButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function OkButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      okDisabled = _ref.okDisabled,
      onOk = _ref.onOk;

  var className = prefixCls + "-ok-btn";
  if (okDisabled) {
    className += " " + prefixCls + "-ok-btn-disabled";
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "a",
    {
      className: className,
      role: "button",
      onClick: okDisabled ? null : onOk
    },
    locale.ok
  );
}

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TimePickerButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);



function TimePickerButton(_ref) {
  var _classnames;

  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      showTimePicker = _ref.showTimePicker,
      onOpenTimePicker = _ref.onOpenTimePicker,
      onCloseTimePicker = _ref.onCloseTimePicker,
      timePickerDisabled = _ref.timePickerDisabled;

  var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classnames = {}, _classnames[prefixCls + '-time-picker-btn'] = true, _classnames[prefixCls + '-time-picker-btn-disabled'] = timePickerDisabled, _classnames));
  var onClick = null;
  if (!timePickerDisabled) {
    onClick = showTimePicker ? onCloseTimePicker : onOpenTimePicker;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: className,
      role: 'button',
      onClick: onClick
    },
    showTimePicker ? locale.dateSelect : locale.timeSelect
  );
}

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_index__ = __webpack_require__(97);






function noop() {}

function getNow() {
  return __WEBPACK_IMPORTED_MODULE_3_moment___default()();
}

function getNowByCurrentStateValue(value) {
  var ret = void 0;
  if (value) {
    ret = Object(__WEBPACK_IMPORTED_MODULE_4__util_index__["d" /* getTodayTime */])(value);
  } else {
    ret = getNow();
  }
  return ret;
}

var CalendarMixin = {
  propTypes: {
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    defaultValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onKeyDown: noop
    };
  },
  getInitialState: function getInitialState() {
    var props = this.props;
    var value = props.value || props.defaultValue || getNow();
    return {
      value: value,
      selectedValue: props.selectedValue || props.defaultSelectedValue
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var value = nextProps.value;
    var selectedValue = nextProps.selectedValue;

    if ('value' in nextProps) {
      value = value || nextProps.defaultValue || getNowByCurrentStateValue(this.state.value);
      this.setState({
        value: value
      });
    }
    if ('selectedValue' in nextProps) {
      this.setState({
        selectedValue: selectedValue
      });
    }
  },
  onSelect: function onSelect(value, cause) {
    if (value) {
      this.setValue(value);
    }
    this.setSelectedValue(value, cause);
  },
  renderRoot: function renderRoot(newProps) {
    var _className;

    var props = this.props;
    var prefixCls = props.prefixCls;

    var className = (_className = {}, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[props.className] = !!props.className, _className[newProps.className] = !!newProps.className, _className);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        ref: this.saveRoot,
        className: '' + __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className),
        style: this.props.style,
        tabIndex: '0',
        onKeyDown: this.onKeyDown
      },
      newProps.children
    );
  },
  setSelectedValue: function setSelectedValue(selectedValue, cause) {
    // if (this.isAllowedDate(selectedValue)) {
    if (!('selectedValue' in this.props)) {
      this.setState({
        selectedValue: selectedValue
      });
    }
    this.props.onSelect(selectedValue, cause);
    // }
  },
  setValue: function setValue(value) {
    var originalValue = this.state.value;
    if (!('value' in this.props)) {
      this.setState({
        value: value
      });
    }
    if (originalValue && value && !originalValue.isSame(value) || !originalValue && value || originalValue && !value) {
      this.props.onChange(value);
    }
  },
  isAllowedDate: function isAllowedDate(value) {
    var disabledDate = this.props.disabledDate;
    var disabledTime = this.props.disabledTime;
    return Object(__WEBPACK_IMPORTED_MODULE_4__util_index__["f" /* isAllowedDate */])(value, disabledDate, disabledTime);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (CalendarMixin);

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_en_US__ = __webpack_require__(878);



function noop() {}

/* harmony default export */ __webpack_exports__["a"] = ({
  propTypes: {
    className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    locale: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    visible: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    onSelect: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    prefixCls: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    onOk: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      locale: __WEBPACK_IMPORTED_MODULE_1__locale_en_US__["a" /* default */],
      style: {},
      visible: true,
      prefixCls: 'rc-calendar',
      className: '',
      onSelect: noop,
      onChange: noop,
      onClear: noop,
      renderFooter: function renderFooter() {
        return null;
      },
      renderSidebar: function renderSidebar() {
        return null;
      }
    };
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
    return this.props.visible || nextProps.visible;
  },
  getFormat: function getFormat() {
    var format = this.props.format;
    var _props = this.props,
        locale = _props.locale,
        timePicker = _props.timePicker;

    if (!format) {
      if (timePicker) {
        format = locale.dateTimeFormat;
      } else {
        format = locale.dateFormat;
      }
    }
    return format;
  },
  focus: function focus() {
    if (this.rootInstance) {
      this.rootInstance.focus();
    }
  },
  saveRoot: function saveRoot(root) {
    this.rootInstance = root;
  }
});

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  today: 'Today',
  now: 'Now',
  backToToday: 'Back to today',
  ok: 'Ok',
  clear: 'Clear',
  month: 'Month',
  year: 'Year',
  timeSelect: 'select time',
  dateSelect: 'select date',
  weekSelect: 'Choose a week',
  monthSelect: 'Choose a month',
  yearSelect: 'Choose a year',
  decadeSelect: 'Choose a decade',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Previous month (PageUp)',
  nextMonth: 'Next month (PageDown)',
  previousYear: 'Last year (Control + left)',
  nextYear: 'Next year (Control + right)',
  previousDecade: 'Last decade',
  nextDecade: 'Next decade',
  previousCentury: 'Last century',
  nextCentury: 'Next century'
});

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);






var DateInput = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'DateInput',

  propTypes: {
    prefixCls: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    timePicker: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
    value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
    disabledTime: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
    format: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    locale: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
    disabledDate: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    onClear: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    placeholder: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    onSelect: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    selectedValue: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  },

  getInitialState: function getInitialState() {
    var selectedValue = this.props.selectedValue;
    return {
      str: selectedValue && selectedValue.format(this.props.format) || '',
      invalid: false
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.cachedSelectionStart = this.dateInputInstance.selectionStart;
    this.cachedSelectionEnd = this.dateInputInstance.selectionEnd;
    // when popup show, click body will call this, bug!
    var selectedValue = nextProps.selectedValue;
    this.setState({
      str: selectedValue && selectedValue.format(nextProps.format) || '',
      invalid: false
    });
  },
  componentDidUpdate: function componentDidUpdate() {
    if (!this.state.invalid) {
      this.dateInputInstance.setSelectionRange(this.cachedSelectionStart, this.cachedSelectionEnd);
    }
  },
  onInputChange: function onInputChange(event) {
    var str = event.target.value;
    this.setState({
      str: str
    });
    var value = void 0;
    var _props = this.props,
        disabledDate = _props.disabledDate,
        format = _props.format,
        onChange = _props.onChange;

    if (str) {
      var parsed = __WEBPACK_IMPORTED_MODULE_4_moment___default()(str, format, true);
      if (!parsed.isValid()) {
        this.setState({
          invalid: true
        });
        return;
      }
      value = this.props.value.clone();
      value.year(parsed.year()).month(parsed.month()).date(parsed.date()).hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());

      if (value && (!disabledDate || !disabledDate(value))) {
        var originalValue = this.props.selectedValue;
        if (originalValue && value) {
          if (!originalValue.isSame(value)) {
            onChange(value);
          }
        } else if (originalValue !== value) {
          onChange(value);
        }
      } else {
        this.setState({
          invalid: true
        });
        return;
      }
    } else {
      onChange(null);
    }
    this.setState({
      invalid: false
    });
  },
  onClear: function onClear() {
    this.setState({
      str: ''
    });
    this.props.onClear(null);
  },
  getRootDOMNode: function getRootDOMNode() {
    return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this);
  },
  focus: function focus() {
    if (this.dateInputInstance) {
      this.dateInputInstance.focus();
    }
  },
  saveDateInput: function saveDateInput(dateInput) {
    this.dateInputInstance = dateInput;
  },
  render: function render() {
    var props = this.props;
    var _state = this.state,
        invalid = _state.invalid,
        str = _state.str;
    var locale = props.locale,
        prefixCls = props.prefixCls,
        placeholder = props.placeholder;

    var invalidClass = invalid ? prefixCls + '-input-invalid' : '';
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: prefixCls + '-input-wrap' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: prefixCls + '-date-input-wrap' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
          ref: this.saveDateInput,
          className: prefixCls + '-input ' + invalidClass,
          value: str,
          disabled: props.disabled,
          placeholder: placeholder,
          onChange: this.onInputChange
        })
      ),
      props.showClear ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', {
        className: prefixCls + '-clear-btn',
        role: 'button',
        title: locale.clear,
        onClick: this.onClear
      }) : null
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (DateInput);

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = goStartMonth;
/* harmony export (immutable) */ __webpack_exports__["a"] = goEndMonth;
/* harmony export (immutable) */ __webpack_exports__["c"] = goTime;
/* unused harmony export includesTime */
function goStartMonth(time) {
  return time.clone().startOf('month');
}

function goEndMonth(time) {
  return time.clone().endOf('month');
}

function goTime(time, direction, unit) {
  return time.clone().add(direction, unit);
}

function includesTime() {
  var timeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var time = arguments[1];
  var unit = arguments[2];

  return timeList.some(function (t) {
    return t.isSame(time, unit);
  });
}

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(36);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MonthTable = __webpack_require__(882);

var _MonthTable2 = _interopRequireDefault(_MonthTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function goYear(direction) {
  var next = this.state.value.clone();
  next.add(direction, 'year');
  this.setAndChangeValue(next);
}

function noop() {}

var MonthPanel = (0, _createReactClass2['default'])({
  displayName: 'MonthPanel',

  propTypes: {
    onChange: _propTypes2['default'].func,
    disabledDate: _propTypes2['default'].func,
    onSelect: _propTypes2['default'].func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onChange: noop,
      onSelect: noop
    };
  },
  getInitialState: function getInitialState() {
    var props = this.props;
    // bind methods
    this.nextYear = goYear.bind(this, 1);
    this.previousYear = goYear.bind(this, -1);
    this.prefixCls = props.rootPrefixCls + '-month-panel';
    return {
      value: props.value || props.defaultValue
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      this.setState({
        value: nextProps.value
      });
    }
  },
  setAndChangeValue: function setAndChangeValue(value) {
    this.setValue(value);
    this.props.onChange(value);
  },
  setAndSelectValue: function setAndSelectValue(value) {
    this.setValue(value);
    this.props.onSelect(value);
  },
  setValue: function setValue(value) {
    if (!('value' in this.props)) {
      this.setState({
        value: value
      });
    }
  },
  render: function render() {
    var props = this.props;
    var value = this.state.value;
    var cellRender = props.cellRender;
    var contentRender = props.contentRender;
    var locale = props.locale;
    var year = value.year();
    var prefixCls = this.prefixCls;
    return _react2['default'].createElement(
      'div',
      { className: prefixCls, style: props.style },
      _react2['default'].createElement(
        'div',
        null,
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-header' },
          _react2['default'].createElement('a', {
            className: prefixCls + '-prev-year-btn',
            role: 'button',
            onClick: this.previousYear,
            title: locale.previousYear
          }),
          _react2['default'].createElement(
            'a',
            {
              className: prefixCls + '-year-select',
              role: 'button',
              onClick: props.onYearPanelShow,
              title: locale.yearSelect
            },
            _react2['default'].createElement(
              'span',
              { className: prefixCls + '-year-select-content' },
              year
            ),
            _react2['default'].createElement(
              'span',
              { className: prefixCls + '-year-select-arrow' },
              'x'
            )
          ),
          _react2['default'].createElement('a', {
            className: prefixCls + '-next-year-btn',
            role: 'button',
            onClick: this.nextYear,
            title: locale.nextYear
          })
        ),
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-body' },
          _react2['default'].createElement(_MonthTable2['default'], {
            disabledDate: props.disabledDate,
            onSelect: this.setAndSelectValue,
            locale: locale,
            value: value,
            cellRender: cellRender,
            contentRender: contentRender,
            prefixCls: prefixCls
          })
        )
      )
    );
  }
});

exports['default'] = MonthPanel;
module.exports = exports['default'];

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(84);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ROW = 4;
var COL = 3;

function chooseMonth(month) {
  var next = this.state.value.clone();
  next.month(month);
  this.setAndSelectValue(next);
}

function noop() {}

var MonthTable = function (_Component) {
  (0, _inherits3['default'])(MonthTable, _Component);

  function MonthTable(props) {
    (0, _classCallCheck3['default'])(this, MonthTable);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _Component.call(this, props));

    _this.state = {
      value: props.value
    };
    return _this;
  }

  MonthTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      this.setState({
        value: nextProps.value
      });
    }
  };

  MonthTable.prototype.setAndSelectValue = function setAndSelectValue(value) {
    this.setState({
      value: value
    });
    this.props.onSelect(value);
  };

  MonthTable.prototype.months = function months() {
    var value = this.state.value;
    var current = value.clone();
    var months = [];
    var index = 0;
    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      months[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        current.month(index);
        var content = (0, _index.getMonthName)(current);
        months[rowIndex][colIndex] = {
          value: index,
          content: content,
          title: content
        };
        index++;
      }
    }
    return months;
  };

  MonthTable.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var value = this.state.value;
    var today = (0, _index.getTodayTime)(value);
    var months = this.months();
    var currentMonth = value.month();
    var prefixCls = props.prefixCls,
        locale = props.locale,
        contentRender = props.contentRender,
        cellRender = props.cellRender;

    var monthsEls = months.map(function (month, index) {
      var tds = month.map(function (monthData) {
        var _classNameMap;

        var disabled = false;
        if (props.disabledDate) {
          var testValue = value.clone();
          testValue.month(monthData.value);
          disabled = props.disabledDate(testValue);
        }
        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-cell-disabled'] = disabled, _classNameMap[prefixCls + '-selected-cell'] = monthData.value === currentMonth, _classNameMap[prefixCls + '-current-cell'] = today.year() === value.year() && monthData.value === today.month(), _classNameMap);
        var cellEl = void 0;
        if (cellRender) {
          var currentValue = value.clone();
          currentValue.month(monthData.value);
          cellEl = cellRender(currentValue, locale);
        } else {
          var content = void 0;
          if (contentRender) {
            var _currentValue = value.clone();
            _currentValue.month(monthData.value);
            content = contentRender(_currentValue, locale);
          } else {
            content = monthData.content;
          }
          cellEl = _react2['default'].createElement(
            'a',
            { className: prefixCls + '-month' },
            content
          );
        }
        return _react2['default'].createElement(
          'td',
          {
            role: 'gridcell',
            key: monthData.value,
            onClick: disabled ? null : chooseMonth.bind(_this2, monthData.value),
            title: monthData.title,
            className: (0, _classnames2['default'])(classNameMap)
          },
          cellEl
        );
      });
      return _react2['default'].createElement(
        'tr',
        { key: index, role: 'row' },
        tds
      );
    });

    return _react2['default'].createElement(
      'table',
      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
      _react2['default'].createElement(
        'tbody',
        { className: prefixCls + '-tbody' },
        monthsEls
      )
    );
  };

  return MonthTable;
}(_react.Component);

MonthTable.defaultProps = {
  onSelect: noop
};
MonthTable.propTypes = {
  onSelect: _propTypes2['default'].func,
  cellRender: _propTypes2['default'].func,
  prefixCls: _propTypes2['default'].string,
  value: _propTypes2['default'].object
};
exports['default'] = MonthTable;
module.exports = exports['default'];

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ROW = 4;
var COL = 3;

function goYear(direction) {
  var value = this.state.value.clone();
  value.add(direction, 'year');
  this.setState({
    value: value
  });
}

function chooseYear(year) {
  var value = this.state.value.clone();
  value.year(year);
  value.month(this.state.value.month());
  this.props.onSelect(value);
}

var YearPanel = function (_React$Component) {
  (0, _inherits3['default'])(YearPanel, _React$Component);

  function YearPanel(props) {
    (0, _classCallCheck3['default'])(this, YearPanel);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.prefixCls = props.rootPrefixCls + '-year-panel';
    _this.state = {
      value: props.value || props.defaultValue
    };
    _this.nextDecade = goYear.bind(_this, 10);
    _this.previousDecade = goYear.bind(_this, -10);
    return _this;
  }

  YearPanel.prototype.years = function years() {
    var value = this.state.value;
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 10, 10) * 10;
    var previousYear = startYear - 1;
    var years = [];
    var index = 0;
    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      years[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        var year = previousYear + index;
        var content = String(year);
        years[rowIndex][colIndex] = {
          content: content,
          year: year,
          title: content
        };
        index++;
      }
    }
    return years;
  };

  YearPanel.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var value = this.state.value;
    var locale = props.locale;
    var years = this.years();
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 10, 10) * 10;
    var endYear = startYear + 9;
    var prefixCls = this.prefixCls;

    var yeasEls = years.map(function (row, index) {
      var tds = row.map(function (yearData) {
        var _classNameMap;

        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = yearData.year === currentYear, _classNameMap[prefixCls + '-last-decade-cell'] = yearData.year < startYear, _classNameMap[prefixCls + '-next-decade-cell'] = yearData.year > endYear, _classNameMap);
        var clickHandler = void 0;
        if (yearData.year < startYear) {
          clickHandler = _this2.previousDecade;
        } else if (yearData.year > endYear) {
          clickHandler = _this2.nextDecade;
        } else {
          clickHandler = chooseYear.bind(_this2, yearData.year);
        }
        return _react2['default'].createElement(
          'td',
          {
            role: 'gridcell',
            title: yearData.title,
            key: yearData.content,
            onClick: clickHandler,
            className: (0, _classnames2['default'])(classNameMap)
          },
          _react2['default'].createElement(
            'a',
            {
              className: prefixCls + '-year'
            },
            yearData.content
          )
        );
      });
      return _react2['default'].createElement(
        'tr',
        { key: index, role: 'row' },
        tds
      );
    });

    return _react2['default'].createElement(
      'div',
      { className: this.prefixCls },
      _react2['default'].createElement(
        'div',
        null,
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-header' },
          _react2['default'].createElement('a', {
            className: prefixCls + '-prev-decade-btn',
            role: 'button',
            onClick: this.previousDecade,
            title: locale.previousDecade
          }),
          _react2['default'].createElement(
            'a',
            {
              className: prefixCls + '-decade-select',
              role: 'button',
              onClick: props.onDecadePanelShow,
              title: locale.decadeSelect
            },
            _react2['default'].createElement(
              'span',
              { className: prefixCls + '-decade-select-content' },
              startYear,
              '-',
              endYear
            ),
            _react2['default'].createElement(
              'span',
              { className: prefixCls + '-decade-select-arrow' },
              'x'
            )
          ),
          _react2['default'].createElement('a', {
            className: prefixCls + '-next-decade-btn',
            role: 'button',
            onClick: this.nextDecade,
            title: locale.nextDecade
          })
        ),
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-body' },
          _react2['default'].createElement(
            'table',
            { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
            _react2['default'].createElement(
              'tbody',
              { className: prefixCls + '-tbody' },
              yeasEls
            )
          )
        )
      )
    );
  };

  return YearPanel;
}(_react2['default'].Component);

exports['default'] = YearPanel;


YearPanel.propTypes = {
  rootPrefixCls: _propTypes2['default'].string,
  value: _propTypes2['default'].object,
  defaultValue: _propTypes2['default'].object
};

YearPanel.defaultProps = {
  onSelect: function onSelect() {}
};
module.exports = exports['default'];

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ROW = 4;
var COL = 3;


function goYear(direction) {
  var next = this.state.value.clone();
  next.add(direction, 'years');
  this.setState({
    value: next
  });
}

function chooseDecade(year, event) {
  var next = this.state.value.clone();
  next.year(year);
  next.month(this.state.value.month());
  this.props.onSelect(next);
  event.preventDefault();
}

var DecadePanel = function (_React$Component) {
  (0, _inherits3['default'])(DecadePanel, _React$Component);

  function DecadePanel(props) {
    (0, _classCallCheck3['default'])(this, DecadePanel);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.state = {
      value: props.value || props.defaultValue
    };

    // bind methods
    _this.prefixCls = props.rootPrefixCls + '-decade-panel';
    _this.nextCentury = goYear.bind(_this, 100);
    _this.previousCentury = goYear.bind(_this, -100);
    return _this;
  }

  DecadePanel.prototype.render = function render() {
    var _this2 = this;

    var value = this.state.value;
    var locale = this.props.locale;
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 100, 10) * 100;
    var preYear = startYear - 10;
    var endYear = startYear + 99;
    var decades = [];
    var index = 0;
    var prefixCls = this.prefixCls;

    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
      decades[rowIndex] = [];
      for (var colIndex = 0; colIndex < COL; colIndex++) {
        var startDecade = preYear + index * 10;
        var endDecade = preYear + index * 10 + 9;
        decades[rowIndex][colIndex] = {
          startDecade: startDecade,
          endDecade: endDecade
        };
        index++;
      }
    }

    var decadesEls = decades.map(function (row, decadeIndex) {
      var tds = row.map(function (decadeData) {
        var _classNameMap;

        var dStartDecade = decadeData.startDecade;
        var dEndDecade = decadeData.endDecade;
        var isLast = dStartDecade < startYear;
        var isNext = dEndDecade > endYear;
        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = dStartDecade <= currentYear && currentYear <= dEndDecade, _classNameMap[prefixCls + '-last-century-cell'] = isLast, _classNameMap[prefixCls + '-next-century-cell'] = isNext, _classNameMap);
        var content = dStartDecade + '-' + dEndDecade;
        var clickHandler = void 0;
        if (isLast) {
          clickHandler = _this2.previousCentury;
        } else if (isNext) {
          clickHandler = _this2.nextCentury;
        } else {
          clickHandler = chooseDecade.bind(_this2, dStartDecade);
        }
        return _react2['default'].createElement(
          'td',
          {
            key: dStartDecade,
            onClick: clickHandler,
            role: 'gridcell',
            className: (0, _classnames2['default'])(classNameMap)
          },
          _react2['default'].createElement(
            'a',
            {
              className: prefixCls + '-decade'
            },
            content
          )
        );
      });
      return _react2['default'].createElement(
        'tr',
        { key: decadeIndex, role: 'row' },
        tds
      );
    });

    return _react2['default'].createElement(
      'div',
      { className: this.prefixCls },
      _react2['default'].createElement(
        'div',
        { className: prefixCls + '-header' },
        _react2['default'].createElement('a', {
          className: prefixCls + '-prev-century-btn',
          role: 'button',
          onClick: this.previousCentury,
          title: locale.previousCentury
        }),
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-century' },
          startYear,
          '-',
          endYear
        ),
        _react2['default'].createElement('a', {
          className: prefixCls + '-next-century-btn',
          role: 'button',
          onClick: this.nextCentury,
          title: locale.nextCentury
        })
      ),
      _react2['default'].createElement(
        'div',
        { className: prefixCls + '-body' },
        _react2['default'].createElement(
          'table',
          { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
          _react2['default'].createElement(
            'tbody',
            { className: prefixCls + '-tbody' },
            decadesEls
          )
        )
      )
    );
  };

  return DecadePanel;
}(_react2['default'].Component);

exports['default'] = DecadePanel;


DecadePanel.propTypes = {
  locale: _propTypes2['default'].object,
  value: _propTypes2['default'].object,
  defaultValue: _propTypes2['default'].object,
  rootPrefixCls: _propTypes2['default'].string
};

DecadePanel.defaultProps = {
  onSelect: function onSelect() {}
};
module.exports = exports['default'];

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _createReactClass = __webpack_require__(36);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mapSelf = __webpack_require__(336);

var _mapSelf2 = _interopRequireDefault(_mapSelf);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _TodayButton = __webpack_require__(337);

var _TodayButton2 = _interopRequireDefault(_TodayButton);

var _OkButton = __webpack_require__(338);

var _OkButton2 = _interopRequireDefault(_OkButton);

var _TimePickerButton = __webpack_require__(339);

var _TimePickerButton2 = _interopRequireDefault(_TimePickerButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CalendarFooter = (0, _createReactClass2['default'])({
  displayName: 'CalendarFooter',

  propTypes: {
    prefixCls: _propTypes2['default'].string,
    showDateInput: _propTypes2['default'].bool,
    disabledTime: _propTypes2['default'].any,
    timePicker: _propTypes2['default'].element,
    selectedValue: _propTypes2['default'].any,
    showOk: _propTypes2['default'].bool,
    onSelect: _propTypes2['default'].func,
    value: _propTypes2['default'].object,
    renderFooter: _propTypes2['default'].func,
    defaultValue: _propTypes2['default'].object
  },

  onSelect: function onSelect(value) {
    this.props.onSelect(value);
  },
  getRootDOMNode: function getRootDOMNode() {
    return _reactDom2['default'].findDOMNode(this);
  },
  render: function render() {
    var props = this.props;
    var value = props.value,
        prefixCls = props.prefixCls,
        showOk = props.showOk,
        timePicker = props.timePicker,
        renderFooter = props.renderFooter;

    var footerEl = null;
    var extraFooter = renderFooter();
    if (props.showToday || timePicker || extraFooter) {
      var _cx;

      var nowEl = void 0;
      if (props.showToday) {
        nowEl = _react2['default'].createElement(_TodayButton2['default'], (0, _extends3['default'])({}, props, { value: value }));
      }
      var okBtn = void 0;
      if (showOk === true || showOk !== false && !!props.timePicker) {
        okBtn = _react2['default'].createElement(_OkButton2['default'], props);
      }
      var timePickerBtn = void 0;
      if (!!props.timePicker) {
        timePickerBtn = _react2['default'].createElement(_TimePickerButton2['default'], props);
      }

      var footerBtn = void 0;
      if (nowEl || timePickerBtn || okBtn) {
        footerBtn = _react2['default'].createElement(
          'span',
          { className: prefixCls + '-footer-btn' },
          (0, _mapSelf2['default'])([nowEl, timePickerBtn, okBtn])
        );
      }
      var cls = (0, _classnames2['default'])((_cx = {}, _cx[prefixCls + '-footer'] = true, _cx[prefixCls + '-footer-show-ok'] = okBtn, _cx));
      footerEl = _react2['default'].createElement(
        'div',
        { className: cls },
        extraFooter,
        footerBtn
      );
    }
    return footerEl;
  }
});

exports['default'] = CalendarFooter;
module.exports = exports['default'];

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = __webpack_require__(31);

var _moment2 = _interopRequireDefault(_moment);

var _index = __webpack_require__(84);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

function getNow() {
  return (0, _moment2['default'])();
}

function getNowByCurrentStateValue(value) {
  var ret = void 0;
  if (value) {
    ret = (0, _index.getTodayTime)(value);
  } else {
    ret = getNow();
  }
  return ret;
}

var CalendarMixin = {
  propTypes: {
    value: _propTypes2['default'].object,
    defaultValue: _propTypes2['default'].object,
    onKeyDown: _propTypes2['default'].func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onKeyDown: noop
    };
  },
  getInitialState: function getInitialState() {
    var props = this.props;
    var value = props.value || props.defaultValue || getNow();
    return {
      value: value,
      selectedValue: props.selectedValue || props.defaultSelectedValue
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var value = nextProps.value;
    var selectedValue = nextProps.selectedValue;

    if ('value' in nextProps) {
      value = value || nextProps.defaultValue || getNowByCurrentStateValue(this.state.value);
      this.setState({
        value: value
      });
    }
    if ('selectedValue' in nextProps) {
      this.setState({
        selectedValue: selectedValue
      });
    }
  },
  onSelect: function onSelect(value, cause) {
    if (value) {
      this.setValue(value);
    }
    this.setSelectedValue(value, cause);
  },
  renderRoot: function renderRoot(newProps) {
    var _className;

    var props = this.props;
    var prefixCls = props.prefixCls;

    var className = (_className = {}, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[props.className] = !!props.className, _className[newProps.className] = !!newProps.className, _className);

    return _react2['default'].createElement(
      'div',
      {
        ref: this.saveRoot,
        className: '' + (0, _classnames2['default'])(className),
        style: this.props.style,
        tabIndex: '0',
        onKeyDown: this.onKeyDown
      },
      newProps.children
    );
  },
  setSelectedValue: function setSelectedValue(selectedValue, cause) {
    // if (this.isAllowedDate(selectedValue)) {
    if (!('selectedValue' in this.props)) {
      this.setState({
        selectedValue: selectedValue
      });
    }
    this.props.onSelect(selectedValue, cause);
    // }
  },
  setValue: function setValue(value) {
    var originalValue = this.state.value;
    if (!('value' in this.props)) {
      this.setState({
        value: value
      });
    }
    if (originalValue && value && !originalValue.isSame(value) || !originalValue && value || originalValue && !value) {
      this.props.onChange(value);
    }
  },
  isAllowedDate: function isAllowedDate(value) {
    var disabledDate = this.props.disabledDate;
    var disabledTime = this.props.disabledTime;
    return (0, _index.isAllowedDate)(value, disabledDate, disabledTime);
  }
};

exports['default'] = CalendarMixin;
module.exports = exports['default'];

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

exports['default'] = createPicker;

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _moment = __webpack_require__(31);

var moment = _interopRequireWildcard(_moment);

var _reactLifecyclesCompat = __webpack_require__(54);

var _MonthCalendar = __webpack_require__(334);

var _MonthCalendar2 = _interopRequireDefault(_MonthCalendar);

var _Picker = __webpack_require__(196);

var _Picker2 = _interopRequireDefault(_Picker);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = __webpack_require__(47);

var _omit2 = _interopRequireDefault(_omit);

var _icon = __webpack_require__(6);

var _icon2 = _interopRequireDefault(_icon);

var _warning = __webpack_require__(48);

var _warning2 = _interopRequireDefault(_warning);

var _interopDefault = __webpack_require__(89);

var _interopDefault2 = _interopRequireDefault(_interopDefault);

var _getDataOrAriaProps = __webpack_require__(890);

var _getDataOrAriaProps2 = _interopRequireDefault(_getDataOrAriaProps);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function createPicker(TheCalendar) {
    var CalenderWrapper = function (_React$Component) {
        (0, _inherits3['default'])(CalenderWrapper, _React$Component);

        function CalenderWrapper(props) {
            (0, _classCallCheck3['default'])(this, CalenderWrapper);

            var _this = (0, _possibleConstructorReturn3['default'])(this, (CalenderWrapper.__proto__ || Object.getPrototypeOf(CalenderWrapper)).call(this, props));

            _this.renderFooter = function () {
                var _this$props = _this.props,
                    prefixCls = _this$props.prefixCls,
                    renderExtraFooter = _this$props.renderExtraFooter;

                return renderExtraFooter ? React.createElement(
                    'div',
                    { className: prefixCls + '-footer-extra' },
                    renderExtraFooter.apply(undefined, arguments)
                ) : null;
            };
            _this.clearSelection = function (e) {
                e.preventDefault();
                e.stopPropagation();
                _this.handleChange(null);
            };
            _this.handleChange = function (value) {
                var props = _this.props;
                if (!('value' in props)) {
                    _this.setState({
                        value: value,
                        showDate: value
                    });
                }
                props.onChange(value, value && value.format(props.format) || '');
            };
            _this.handleCalendarChange = function (value) {
                _this.setState({ showDate: value });
            };
            _this.saveInput = function (node) {
                _this.input = node;
            };
            var value = props.value || props.defaultValue;
            if (value && !(0, _interopDefault2['default'])(moment).isMoment(value)) {
                throw new Error('The value/defaultValue of DatePicker or MonthPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
            }
            _this.state = {
                value: value,
                showDate: value
            };
            return _this;
        }

        (0, _createClass3['default'])(CalenderWrapper, [{
            key: 'focus',
            value: function focus() {
                this.input.focus();
            }
        }, {
            key: 'blur',
            value: function blur() {
                this.input.blur();
            }
        }, {
            key: 'render',
            value: function render() {
                var _classNames,
                    _this2 = this;

                var _state = this.state,
                    value = _state.value,
                    showDate = _state.showDate;

                var props = (0, _omit2['default'])(this.props, ['onChange']);
                var prefixCls = props.prefixCls,
                    locale = props.locale,
                    localeCode = props.localeCode;

                var placeholder = 'placeholder' in props ? props.placeholder : locale.lang.placeholder;
                var disabledTime = props.showTime ? props.disabledTime : null;
                var calendarClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-time', props.showTime), (0, _defineProperty3['default'])(_classNames, prefixCls + '-month', _MonthCalendar2['default'] === TheCalendar), _classNames));
                if (value && localeCode) {
                    value.locale(localeCode);
                }
                var pickerProps = {};
                var calendarProps = {};
                if (props.showTime) {
                    calendarProps = {
                        // fix https://github.com/ant-design/ant-design/issues/1902
                        onSelect: this.handleChange
                    };
                } else {
                    pickerProps = {
                        onChange: this.handleChange
                    };
                }
                if ('mode' in props) {
                    calendarProps.mode = props.mode;
                }
                (0, _warning2['default'])(!('onOK' in props), 'It should be `DatePicker[onOk]` or `MonthPicker[onOk]`, instead of `onOK`!');
                var calendar = React.createElement(TheCalendar, (0, _extends3['default'])({}, calendarProps, { disabledDate: props.disabledDate, disabledTime: disabledTime, locale: locale.lang, timePicker: props.timePicker, defaultValue: props.defaultPickerValue || (0, _interopDefault2['default'])(moment)(), dateInputPlaceholder: placeholder, prefixCls: prefixCls, className: calendarClassName, onOk: props.onOk, dateRender: props.dateRender, format: props.format, showToday: props.showToday, monthCellContentRender: props.monthCellContentRender, renderFooter: this.renderFooter, onPanelChange: props.onPanelChange, onChange: this.handleCalendarChange, value: showDate }));
                var clearIcon = !props.disabled && props.allowClear && value ? React.createElement(_icon2['default'], { type: 'cross-circle', className: prefixCls + '-picker-clear', onClick: this.clearSelection }) : null;
                var dataOrAriaProps = (0, _getDataOrAriaProps2['default'])(props);
                var input = function input(_ref) {
                    var inputValue = _ref.value;
                    return React.createElement(
                        'div',
                        null,
                        React.createElement('input', (0, _extends3['default'])({ ref: _this2.saveInput, disabled: props.disabled, readOnly: true, value: inputValue && inputValue.format(props.format) || '', placeholder: placeholder, className: props.pickerInputClass }, dataOrAriaProps)),
                        clearIcon,
                        React.createElement('span', { className: prefixCls + '-picker-icon' })
                    );
                };
                return React.createElement(
                    'span',
                    { id: props.id, className: (0, _classnames2['default'])(props.className, props.pickerClass), style: props.style, onFocus: props.onFocus, onBlur: props.onBlur, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave },
                    React.createElement(
                        _Picker2['default'],
                        (0, _extends3['default'])({}, props, pickerProps, { calendar: calendar, value: value, prefixCls: prefixCls + '-picker-container', style: props.popupStyle }),
                        input
                    )
                );
            }
        }], [{
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var state = null;
                if ('value' in nextProps) {
                    state = {
                        value: nextProps.value
                    };
                    if (nextProps.value !== prevState.value) {
                        state = (0, _extends3['default'])({}, state, { showDate: nextProps.value });
                    }
                }
                return state;
            }
        }]);
        return CalenderWrapper;
    }(React.Component);

    CalenderWrapper.defaultProps = {
        prefixCls: 'ant-calendar',
        allowClear: true,
        showToday: true
    };
    (0, _reactLifecyclesCompat.polyfill)(CalenderWrapper);
    return CalenderWrapper;
}
module.exports = exports['default'];

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createChainedFunction;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);
  if (args.length === 1) {
    return args[0];
  }

  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  bottomLeft: {
    points: ['tl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  }
};

exports['default'] = placements;
module.exports = exports['default'];

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = getDataOrAriaProps;
function getDataOrAriaProps(props) {
    return Object.keys(props).reduce(function (prev, key) {
        if ((key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') && key.substr(0, 7) !== 'data-__') {
            prev[key] = props[key];
        }
        return prev;
    }, {});
}
module.exports = exports['default'];

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

exports['default'] = wrapPicker;

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _Panel = __webpack_require__(341);

var _Panel2 = _interopRequireDefault(_Panel);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _LocaleReceiver = __webpack_require__(71);

var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);

var _timePicker = __webpack_require__(895);

var _en_US = __webpack_require__(149);

var _en_US2 = _interopRequireDefault(_en_US);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getColumns(_ref) {
    var showHour = _ref.showHour,
        showMinute = _ref.showMinute,
        showSecond = _ref.showSecond,
        use12Hours = _ref.use12Hours;

    var column = 0;
    if (showHour) {
        column += 1;
    }
    if (showMinute) {
        column += 1;
    }
    if (showSecond) {
        column += 1;
    }
    if (use12Hours) {
        column += 1;
    }
    return column;
}
function wrapPicker(Picker, defaultFormat) {
    var _a;
    return _a = function (_React$Component) {
        (0, _inherits3['default'])(PickerWrapper, _React$Component);

        function PickerWrapper() {
            (0, _classCallCheck3['default'])(this, PickerWrapper);

            var _this = (0, _possibleConstructorReturn3['default'])(this, (PickerWrapper.__proto__ || Object.getPrototypeOf(PickerWrapper)).apply(this, arguments));

            _this.handleOpenChange = function (open) {
                var onOpenChange = _this.props.onOpenChange;

                onOpenChange(open);
            };
            _this.handleFocus = function (e) {
                var onFocus = _this.props.onFocus;

                if (onFocus) {
                    onFocus(e);
                }
            };
            _this.handleBlur = function (e) {
                var onBlur = _this.props.onBlur;

                if (onBlur) {
                    onBlur(e);
                }
            };
            _this.handleMouseEnter = function (e) {
                var onMouseEnter = _this.props.onMouseEnter;

                if (onMouseEnter) {
                    onMouseEnter(e);
                }
            };
            _this.handleMouseLeave = function (e) {
                var onMouseLeave = _this.props.onMouseLeave;

                if (onMouseLeave) {
                    onMouseLeave(e);
                }
            };
            _this.savePicker = function (node) {
                _this.picker = node;
            };
            _this.getDefaultLocale = function () {
                var result = (0, _extends3['default'])({}, _en_US2['default'], _this.props.locale);
                result.lang = (0, _extends3['default'])({}, result.lang, (_this.props.locale || {}).lang);
                return result;
            };
            _this.renderPicker = function (locale, localeCode) {
                var _classNames2;

                var props = _this.props;
                var prefixCls = props.prefixCls,
                    inputPrefixCls = props.inputPrefixCls;

                var pickerClass = (0, _classnames2['default'])(prefixCls + '-picker', (0, _defineProperty3['default'])({}, prefixCls + '-picker-' + props.size, !!props.size));
                var pickerInputClass = (0, _classnames2['default'])(prefixCls + '-picker-input', inputPrefixCls, (_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, inputPrefixCls + '-lg', props.size === 'large'), (0, _defineProperty3['default'])(_classNames2, inputPrefixCls + '-sm', props.size === 'small'), (0, _defineProperty3['default'])(_classNames2, inputPrefixCls + '-disabled', props.disabled), _classNames2));
                var timeFormat = props.showTime && props.showTime.format || 'HH:mm:ss';
                var rcTimePickerProps = (0, _extends3['default'])({}, (0, _timePicker.generateShowHourMinuteSecond)(timeFormat), { format: timeFormat, use12Hours: props.showTime && props.showTime.use12Hours });
                var columns = getColumns(rcTimePickerProps);
                var timePickerCls = prefixCls + '-time-picker-column-' + columns;
                var timePicker = props.showTime ? React.createElement(_Panel2['default'], (0, _extends3['default'])({}, rcTimePickerProps, props.showTime, { prefixCls: prefixCls + '-time-picker', className: timePickerCls, placeholder: locale.timePickerLocale.placeholder, transitionName: 'slide-up' })) : null;
                return React.createElement(Picker, (0, _extends3['default'])({}, props, { ref: _this.savePicker, pickerClass: pickerClass, pickerInputClass: pickerInputClass, locale: locale, localeCode: localeCode, timePicker: timePicker, onOpenChange: _this.handleOpenChange, onFocus: _this.handleFocus, onBlur: _this.handleBlur, onMouseEnter: _this.handleMouseEnter, onMouseLeave: _this.handleMouseLeave }));
            };
            return _this;
        }

        (0, _createClass3['default'])(PickerWrapper, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _props = this.props,
                    autoFocus = _props.autoFocus,
                    disabled = _props.disabled;

                if (autoFocus && !disabled) {
                    this.focus();
                }
            }
        }, {
            key: 'focus',
            value: function focus() {
                this.picker.focus();
            }
        }, {
            key: 'blur',
            value: function blur() {
                this.picker.blur();
            }
        }, {
            key: 'render',
            value: function render() {
                return React.createElement(
                    _LocaleReceiver2['default'],
                    { componentName: 'DatePicker', defaultLocale: this.getDefaultLocale },
                    this.renderPicker
                );
            }
        }]);
        return PickerWrapper;
    }(React.Component), _a.defaultProps = {
        format: defaultFormat || 'YYYY-MM-DD',
        transitionName: 'slide-up',
        popupStyle: {},
        onChange: function onChange() {},
        onOk: function onOk() {},
        onOpenChange: function onOpenChange() {},

        locale: {},
        prefixCls: 'ant-calendar',
        inputPrefixCls: 'ant-input'
    }, _a;
}
module.exports = exports['default'];

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(31);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Header = function (_Component) {
  (0, _inherits3['default'])(Header, _Component);

  function Header(props) {
    (0, _classCallCheck3['default'])(this, Header);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

    _initialiseProps.call(_this);

    var value = props.value,
        format = props.format;

    _this.state = {
      str: value && value.format(format) || '',
      invalid: false
    };
    return _this;
  }

  (0, _createClass3['default'])(Header, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.focusOnOpen) {
        // Wait one frame for the panel to be positioned before focusing
        var requestAnimationFrame = window.requestAnimationFrame || window.setTimeout;
        requestAnimationFrame(function () {
          _this2.refs.input.focus();
          _this2.refs.input.select();
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value,
          format = nextProps.format;

      this.setState({
        str: value && value.format(format) || '',
        invalid: false
      });
    }
  }, {
    key: 'getClearButton',
    value: function getClearButton() {
      var _props = this.props,
          prefixCls = _props.prefixCls,
          allowEmpty = _props.allowEmpty;

      if (!allowEmpty) {
        return null;
      }
      return _react2['default'].createElement('a', {
        className: prefixCls + '-clear-btn',
        role: 'button',
        title: this.props.clearText,
        onMouseDown: this.onClear
      });
    }
  }, {
    key: 'getProtoValue',
    value: function getProtoValue() {
      return this.props.value || this.props.defaultOpenValue;
    }
  }, {
    key: 'getInput',
    value: function getInput() {
      var _props2 = this.props,
          prefixCls = _props2.prefixCls,
          placeholder = _props2.placeholder,
          inputReadOnly = _props2.inputReadOnly;
      var _state = this.state,
          invalid = _state.invalid,
          str = _state.str;

      var invalidClass = invalid ? prefixCls + '-input-invalid' : '';
      return _react2['default'].createElement('input', {
        className: prefixCls + '-input  ' + invalidClass,
        ref: 'input',
        onKeyDown: this.onKeyDown,
        value: str,
        placeholder: placeholder,
        onChange: this.onInputChange,
        readOnly: !!inputReadOnly
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var prefixCls = this.props.prefixCls;

      return _react2['default'].createElement(
        'div',
        { className: prefixCls + '-input-wrap' },
        this.getInput(),
        this.getClearButton()
      );
    }
  }]);
  return Header;
}(_react.Component);

Header.propTypes = {
  format: _propTypes2['default'].string,
  prefixCls: _propTypes2['default'].string,
  disabledDate: _propTypes2['default'].func,
  placeholder: _propTypes2['default'].string,
  clearText: _propTypes2['default'].string,
  value: _propTypes2['default'].object,
  inputReadOnly: _propTypes2['default'].bool,
  hourOptions: _propTypes2['default'].array,
  minuteOptions: _propTypes2['default'].array,
  secondOptions: _propTypes2['default'].array,
  disabledHours: _propTypes2['default'].func,
  disabledMinutes: _propTypes2['default'].func,
  disabledSeconds: _propTypes2['default'].func,
  onChange: _propTypes2['default'].func,
  onClear: _propTypes2['default'].func,
  onEsc: _propTypes2['default'].func,
  allowEmpty: _propTypes2['default'].bool,
  defaultOpenValue: _propTypes2['default'].object,
  currentSelectPanel: _propTypes2['default'].string,
  focusOnOpen: _propTypes2['default'].bool,
  onKeyDown: _propTypes2['default'].func
};
Header.defaultProps = {
  inputReadOnly: false
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onInputChange = function (event) {
    var str = event.target.value;
    _this3.setState({
      str: str
    });
    var _props3 = _this3.props,
        format = _props3.format,
        hourOptions = _props3.hourOptions,
        minuteOptions = _props3.minuteOptions,
        secondOptions = _props3.secondOptions,
        disabledHours = _props3.disabledHours,
        disabledMinutes = _props3.disabledMinutes,
        disabledSeconds = _props3.disabledSeconds,
        onChange = _props3.onChange,
        allowEmpty = _props3.allowEmpty;


    if (str) {
      var originalValue = _this3.props.value;
      var value = _this3.getProtoValue().clone();
      var parsed = (0, _moment2['default'])(str, format, true);
      if (!parsed.isValid()) {
        _this3.setState({
          invalid: true
        });
        return;
      }
      value.hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());

      // if time value not allowed, response warning.
      if (hourOptions.indexOf(value.hour()) < 0 || minuteOptions.indexOf(value.minute()) < 0 || secondOptions.indexOf(value.second()) < 0) {
        _this3.setState({
          invalid: true
        });
        return;
      }

      // if time value is disabled, response warning.
      var disabledHourOptions = disabledHours();
      var disabledMinuteOptions = disabledMinutes(value.hour());
      var disabledSecondOptions = disabledSeconds(value.hour(), value.minute());
      if (disabledHourOptions && disabledHourOptions.indexOf(value.hour()) >= 0 || disabledMinuteOptions && disabledMinuteOptions.indexOf(value.minute()) >= 0 || disabledSecondOptions && disabledSecondOptions.indexOf(value.second()) >= 0) {
        _this3.setState({
          invalid: true
        });
        return;
      }

      if (originalValue) {
        if (originalValue.hour() !== value.hour() || originalValue.minute() !== value.minute() || originalValue.second() !== value.second()) {
          // keep other fields for rc-calendar
          var changedValue = originalValue.clone();
          changedValue.hour(value.hour());
          changedValue.minute(value.minute());
          changedValue.second(value.second());
          onChange(changedValue);
        }
      } else if (originalValue !== value) {
        onChange(value);
      }
    } else if (allowEmpty) {
      onChange(null);
    } else {
      _this3.setState({
        invalid: true
      });
      return;
    }

    _this3.setState({
      invalid: false
    });
  };

  this.onKeyDown = function (e) {
    var _props4 = _this3.props,
        onEsc = _props4.onEsc,
        onKeyDown = _props4.onKeyDown;

    if (e.keyCode === 27) {
      onEsc();
    }

    onKeyDown(e);
  };

  this.onClear = function () {
    _this3.setState({ str: '' });
    _this3.props.onClear();
  };
};

exports['default'] = Header;
module.exports = exports['default'];

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(894);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var formatOption = function formatOption(option, disabledOptions) {
  var value = '' + option;
  if (option < 10) {
    value = '0' + option;
  }

  var disabled = false;
  if (disabledOptions && disabledOptions.indexOf(option) >= 0) {
    disabled = true;
  }

  return {
    value: value,
    disabled: disabled
  };
};

var Combobox = function (_Component) {
  (0, _inherits3['default'])(Combobox, _Component);

  function Combobox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3['default'])(this, Combobox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Combobox.__proto__ || Object.getPrototypeOf(Combobox)).call.apply(_ref, [this].concat(args))), _this), _this.onItemChange = function (type, itemValue) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          defaultOpenValue = _this$props.defaultOpenValue,
          use12Hours = _this$props.use12Hours;

      var value = (_this.props.value || defaultOpenValue).clone();

      if (type === 'hour') {
        if (use12Hours) {
          if (_this.props.isAM) {
            value.hour(+itemValue % 12);
          } else {
            value.hour(+itemValue % 12 + 12);
          }
        } else {
          value.hour(+itemValue);
        }
      } else if (type === 'minute') {
        value.minute(+itemValue);
      } else if (type === 'ampm') {
        var ampm = itemValue.toUpperCase();
        if (use12Hours) {
          if (ampm === 'PM' && value.hour() < 12) {
            value.hour(value.hour() % 12 + 12);
          }

          if (ampm === 'AM') {
            if (value.hour() >= 12) {
              value.hour(value.hour() - 12);
            }
          }
        }
      } else {
        value.second(+itemValue);
      }
      onChange(value);
    }, _this.onEnterSelectPanel = function (range) {
      _this.props.onCurrentSelectPanelChange(range);
    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
  }

  (0, _createClass3['default'])(Combobox, [{
    key: 'getHourSelect',
    value: function getHourSelect(hour) {
      var _props = this.props,
          prefixCls = _props.prefixCls,
          hourOptions = _props.hourOptions,
          disabledHours = _props.disabledHours,
          showHour = _props.showHour,
          use12Hours = _props.use12Hours;

      if (!showHour) {
        return null;
      }
      var disabledOptions = disabledHours();
      var hourOptionsAdj = void 0;
      var hourAdj = void 0;
      if (use12Hours) {
        hourOptionsAdj = [12].concat(hourOptions.filter(function (h) {
          return h < 12 && h > 0;
        }));
        hourAdj = hour % 12 || 12;
      } else {
        hourOptionsAdj = hourOptions;
        hourAdj = hour;
      }

      return _react2['default'].createElement(_Select2['default'], {
        prefixCls: prefixCls,
        options: hourOptionsAdj.map(function (option) {
          return formatOption(option, disabledOptions);
        }),
        selectedIndex: hourOptionsAdj.indexOf(hourAdj),
        type: 'hour',
        onSelect: this.onItemChange,
        onMouseEnter: this.onEnterSelectPanel.bind(this, 'hour')
      });
    }
  }, {
    key: 'getMinuteSelect',
    value: function getMinuteSelect(minute) {
      var _props2 = this.props,
          prefixCls = _props2.prefixCls,
          minuteOptions = _props2.minuteOptions,
          disabledMinutes = _props2.disabledMinutes,
          defaultOpenValue = _props2.defaultOpenValue,
          showMinute = _props2.showMinute;

      if (!showMinute) {
        return null;
      }
      var value = this.props.value || defaultOpenValue;
      var disabledOptions = disabledMinutes(value.hour());

      return _react2['default'].createElement(_Select2['default'], {
        prefixCls: prefixCls,
        options: minuteOptions.map(function (option) {
          return formatOption(option, disabledOptions);
        }),
        selectedIndex: minuteOptions.indexOf(minute),
        type: 'minute',
        onSelect: this.onItemChange,
        onMouseEnter: this.onEnterSelectPanel.bind(this, 'minute')
      });
    }
  }, {
    key: 'getSecondSelect',
    value: function getSecondSelect(second) {
      var _props3 = this.props,
          prefixCls = _props3.prefixCls,
          secondOptions = _props3.secondOptions,
          disabledSeconds = _props3.disabledSeconds,
          showSecond = _props3.showSecond,
          defaultOpenValue = _props3.defaultOpenValue;

      if (!showSecond) {
        return null;
      }
      var value = this.props.value || defaultOpenValue;
      var disabledOptions = disabledSeconds(value.hour(), value.minute());

      return _react2['default'].createElement(_Select2['default'], {
        prefixCls: prefixCls,
        options: secondOptions.map(function (option) {
          return formatOption(option, disabledOptions);
        }),
        selectedIndex: secondOptions.indexOf(second),
        type: 'second',
        onSelect: this.onItemChange,
        onMouseEnter: this.onEnterSelectPanel.bind(this, 'second')
      });
    }
  }, {
    key: 'getAMPMSelect',
    value: function getAMPMSelect() {
      var _props4 = this.props,
          prefixCls = _props4.prefixCls,
          use12Hours = _props4.use12Hours,
          format = _props4.format;

      if (!use12Hours) {
        return null;
      }

      var AMPMOptions = ['am', 'pm'] // If format has A char, then we should uppercase AM/PM
      .map(function (c) {
        return format.match(/\sA/) ? c.toUpperCase() : c;
      }).map(function (c) {
        return { value: c };
      });

      var selected = this.props.isAM ? 0 : 1;

      return _react2['default'].createElement(_Select2['default'], {
        prefixCls: prefixCls,
        options: AMPMOptions,
        selectedIndex: selected,
        type: 'ampm',
        onSelect: this.onItemChange,
        onMouseEnter: this.onEnterSelectPanel.bind(this, 'ampm')
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          prefixCls = _props5.prefixCls,
          defaultOpenValue = _props5.defaultOpenValue;

      var value = this.props.value || defaultOpenValue;
      return _react2['default'].createElement(
        'div',
        { className: prefixCls + '-combobox' },
        this.getHourSelect(value.hour()),
        this.getMinuteSelect(value.minute()),
        this.getSecondSelect(value.second()),
        this.getAMPMSelect(value.hour())
      );
    }
  }]);
  return Combobox;
}(_react.Component);

Combobox.propTypes = {
  format: _propTypes2['default'].string,
  defaultOpenValue: _propTypes2['default'].object,
  prefixCls: _propTypes2['default'].string,
  value: _propTypes2['default'].object,
  onChange: _propTypes2['default'].func,
  showHour: _propTypes2['default'].bool,
  showMinute: _propTypes2['default'].bool,
  showSecond: _propTypes2['default'].bool,
  hourOptions: _propTypes2['default'].array,
  minuteOptions: _propTypes2['default'].array,
  secondOptions: _propTypes2['default'].array,
  disabledHours: _propTypes2['default'].func,
  disabledMinutes: _propTypes2['default'].func,
  disabledSeconds: _propTypes2['default'].func,
  onCurrentSelectPanelChange: _propTypes2['default'].func,
  use12Hours: _propTypes2['default'].bool,
  isAM: _propTypes2['default'].bool
};
exports['default'] = Combobox;
module.exports = exports['default'];

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames3 = __webpack_require__(11);

var _classnames4 = _interopRequireDefault(_classnames3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var scrollTo = function scrollTo(element, to, duration) {
  var requestAnimationFrame = window.requestAnimationFrame || function requestAnimationFrameTimeout() {
    return setTimeout(arguments[0], 10);
  };
  // jump to target if duration zero
  if (duration <= 0) {
    element.scrollTop = to;
    return;
  }
  var difference = to - element.scrollTop;
  var perTick = difference / duration * 10;

  requestAnimationFrame(function () {
    element.scrollTop = element.scrollTop + perTick;
    if (element.scrollTop === to) return;
    scrollTo(element, to, duration - 10);
  });
};

var Select = function (_Component) {
  (0, _inherits3['default'])(Select, _Component);

  function Select() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3['default'])(this, Select);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      active: false
    }, _this.onSelect = function (value) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          type = _this$props.type;

      onSelect(type, value);
    }, _this.handleMouseEnter = function (e) {
      _this.setState({ active: true });
      _this.props.onMouseEnter(e);
    }, _this.handleMouseLeave = function () {
      _this.setState({ active: false });
    }, _this.saveList = function (node) {
      _this.list = node;
    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
  }

  (0, _createClass3['default'])(Select, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // jump to selected option
      this.scrollToSelected(0);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // smooth scroll to selected option
      if (prevProps.selectedIndex !== this.props.selectedIndex) {
        this.scrollToSelected(120);
      }
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var _this2 = this;

      var _props = this.props,
          options = _props.options,
          selectedIndex = _props.selectedIndex,
          prefixCls = _props.prefixCls;

      return options.map(function (item, index) {
        var _classnames;

        var cls = (0, _classnames4['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-select-option-selected', selectedIndex === index), (0, _defineProperty3['default'])(_classnames, prefixCls + '-select-option-disabled', item.disabled), _classnames));
        var onclick = null;
        if (!item.disabled) {
          onclick = _this2.onSelect.bind(_this2, item.value);
        }
        return _react2['default'].createElement(
          'li',
          {
            className: cls,
            key: index,
            onClick: onclick,
            disabled: item.disabled
          },
          item.value
        );
      });
    }
  }, {
    key: 'scrollToSelected',
    value: function scrollToSelected(duration) {
      // move to selected item
      var select = _reactDom2['default'].findDOMNode(this);
      var list = _reactDom2['default'].findDOMNode(this.list);
      if (!list) {
        return;
      }
      var index = this.props.selectedIndex;
      if (index < 0) {
        index = 0;
      }
      var topOption = list.children[index];
      var to = topOption.offsetTop;
      scrollTo(select, to, duration);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames2;

      if (this.props.options.length === 0) {
        return null;
      }

      var prefixCls = this.props.prefixCls;

      var cls = (0, _classnames4['default'])((_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-select', 1), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-select-active', this.state.active), _classnames2));

      return _react2['default'].createElement(
        'div',
        {
          className: cls,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave
        },
        _react2['default'].createElement(
          'ul',
          { ref: this.saveList },
          this.getOptions()
        )
      );
    }
  }]);
  return Select;
}(_react.Component);

Select.propTypes = {
  prefixCls: _propTypes2['default'].string,
  options: _propTypes2['default'].array,
  selectedIndex: _propTypes2['default'].number,
  type: _propTypes2['default'].string,
  onSelect: _propTypes2['default'].func,
  onMouseEnter: _propTypes2['default'].func
};
exports['default'] = Select;
module.exports = exports['default'];

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.generateShowHourMinuteSecond = generateShowHourMinuteSecond;

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _moment = __webpack_require__(31);

var moment = _interopRequireWildcard(_moment);

var _TimePicker = __webpack_require__(896);

var _TimePicker2 = _interopRequireDefault(_TimePicker);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _LocaleReceiver = __webpack_require__(71);

var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);

var _en_US = __webpack_require__(150);

var _en_US2 = _interopRequireDefault(_en_US);

var _interopDefault = __webpack_require__(89);

var _interopDefault2 = _interopRequireDefault(_interopDefault);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function generateShowHourMinuteSecond(format) {
    // Ref: http://momentjs.com/docs/#/parsing/string-format/
    return {
        showHour: format.indexOf('H') > -1 || format.indexOf('h') > -1 || format.indexOf('k') > -1,
        showMinute: format.indexOf('m') > -1,
        showSecond: format.indexOf('s') > -1
    };
}

var TimePicker = function (_React$Component) {
    (0, _inherits3['default'])(TimePicker, _React$Component);

    function TimePicker(props) {
        (0, _classCallCheck3['default'])(this, TimePicker);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call(this, props));

        _this.handleChange = function (value) {
            if (!('value' in _this.props)) {
                _this.setState({ value: value });
            }
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                _this$props$format = _this$props.format,
                format = _this$props$format === undefined ? 'HH:mm:ss' : _this$props$format;

            if (onChange) {
                onChange(value, value && value.format(format) || '');
            }
        };
        _this.handleOpenClose = function (_ref) {
            var open = _ref.open;
            var onOpenChange = _this.props.onOpenChange;

            if (onOpenChange) {
                onOpenChange(open);
            }
        };
        _this.saveTimePicker = function (timePickerRef) {
            _this.timePickerRef = timePickerRef;
        };
        _this.renderTimePicker = function (locale) {
            var props = (0, _extends3['default'])({}, _this.props);
            delete props.defaultValue;
            var format = _this.getDefaultFormat();
            var className = (0, _classnames2['default'])(props.className, (0, _defineProperty3['default'])({}, props.prefixCls + '-' + props.size, !!props.size));
            var addon = function addon(panel) {
                return props.addon ? React.createElement(
                    'div',
                    { className: props.prefixCls + '-panel-addon' },
                    props.addon(panel)
                ) : null;
            };
            return React.createElement(_TimePicker2['default'], (0, _extends3['default'])({}, generateShowHourMinuteSecond(format), props, { ref: _this.saveTimePicker, format: format, className: className, value: _this.state.value, placeholder: props.placeholder === undefined ? locale.placeholder : props.placeholder, onChange: _this.handleChange, onOpen: _this.handleOpenClose, onClose: _this.handleOpenClose, addon: addon }));
        };
        var value = props.value || props.defaultValue;
        if (value && !(0, _interopDefault2['default'])(moment).isMoment(value)) {
            throw new Error('The value/defaultValue of TimePicker must be a moment object after `antd@2.0`, ' + 'see: https://u.ant.design/time-picker-value');
        }
        _this.state = {
            value: value
        };
        return _this;
    }

    (0, _createClass3['default'])(TimePicker, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
                this.setState({ value: nextProps.value });
            }
        }
    }, {
        key: 'focus',
        value: function focus() {
            this.timePickerRef.focus();
        }
    }, {
        key: 'blur',
        value: function blur() {
            this.timePickerRef.blur();
        }
    }, {
        key: 'getDefaultFormat',
        value: function getDefaultFormat() {
            var _props = this.props,
                format = _props.format,
                use12Hours = _props.use12Hours;

            if (format) {
                return format;
            } else if (use12Hours) {
                return 'h:mm:ss a';
            }
            return 'HH:mm:ss';
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement(
                _LocaleReceiver2['default'],
                { componentName: 'TimePicker', defaultLocale: _en_US2['default'] },
                this.renderTimePicker
            );
        }
    }]);
    return TimePicker;
}(React.Component);

exports['default'] = TimePicker;

TimePicker.defaultProps = {
    prefixCls: 'ant-time-picker',
    align: {
        offset: [0, -2]
    },
    disabled: false,
    disabledHours: undefined,
    disabledMinutes: undefined,
    disabledSeconds: undefined,
    hideDisabledOptions: false,
    placement: 'bottomLeft',
    transitionName: 'slide-up',
    focusOnOpen: true
};

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rcTrigger = __webpack_require__(81);

var _rcTrigger2 = _interopRequireDefault(_rcTrigger);

var _Panel = __webpack_require__(341);

var _Panel2 = _interopRequireDefault(_Panel);

var _placements = __webpack_require__(897);

var _placements2 = _interopRequireDefault(_placements);

var _moment = __webpack_require__(31);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

function refFn(field, component) {
  this[field] = component;
}

var Picker = function (_Component) {
  (0, _inherits3['default'])(Picker, _Component);

  function Picker(props) {
    (0, _classCallCheck3['default'])(this, Picker);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (Picker.__proto__ || Object.getPrototypeOf(Picker)).call(this, props));

    _initialiseProps.call(_this);

    _this.saveInputRef = refFn.bind(_this, 'picker');
    _this.savePanelRef = refFn.bind(_this, 'panelInstance');
    var defaultOpen = props.defaultOpen,
        defaultValue = props.defaultValue,
        _props$open = props.open,
        open = _props$open === undefined ? defaultOpen : _props$open,
        _props$value = props.value,
        value = _props$value === undefined ? defaultValue : _props$value;

    _this.state = {
      open: open,
      value: value
    };
    return _this;
  }

  (0, _createClass3['default'])(Picker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value,
          open = nextProps.open;

      if ('value' in nextProps) {
        this.setState({
          value: value
        });
      }
      if (open !== undefined) {
        this.setState({ open: open });
      }
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      if (!('value' in this.props)) {
        this.setState({
          value: value
        });
      }
      this.props.onChange(value);
    }
  }, {
    key: 'getFormat',
    value: function getFormat() {
      var _props = this.props,
          format = _props.format,
          showHour = _props.showHour,
          showMinute = _props.showMinute,
          showSecond = _props.showSecond,
          use12Hours = _props.use12Hours;

      if (format) {
        return format;
      }

      if (use12Hours) {
        var fmtString = [showHour ? 'h' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
          return !!item;
        }).join(':');

        return fmtString.concat(' a');
      }

      return [showHour ? 'HH' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
        return !!item;
      }).join(':');
    }
  }, {
    key: 'getPanelElement',
    value: function getPanelElement() {
      var _props2 = this.props,
          prefixCls = _props2.prefixCls,
          placeholder = _props2.placeholder,
          disabledHours = _props2.disabledHours,
          disabledMinutes = _props2.disabledMinutes,
          disabledSeconds = _props2.disabledSeconds,
          hideDisabledOptions = _props2.hideDisabledOptions,
          inputReadOnly = _props2.inputReadOnly,
          allowEmpty = _props2.allowEmpty,
          showHour = _props2.showHour,
          showMinute = _props2.showMinute,
          showSecond = _props2.showSecond,
          defaultOpenValue = _props2.defaultOpenValue,
          clearText = _props2.clearText,
          addon = _props2.addon,
          use12Hours = _props2.use12Hours,
          focusOnOpen = _props2.focusOnOpen,
          onKeyDown = _props2.onKeyDown,
          hourStep = _props2.hourStep,
          minuteStep = _props2.minuteStep,
          secondStep = _props2.secondStep;

      return _react2['default'].createElement(_Panel2['default'], {
        clearText: clearText,
        prefixCls: prefixCls + '-panel',
        ref: this.savePanelRef,
        value: this.state.value,
        inputReadOnly: inputReadOnly,
        onChange: this.onPanelChange,
        onClear: this.onPanelClear,
        defaultOpenValue: defaultOpenValue,
        showHour: showHour,
        showMinute: showMinute,
        showSecond: showSecond,
        onEsc: this.onEsc,
        allowEmpty: allowEmpty,
        format: this.getFormat(),
        placeholder: placeholder,
        disabledHours: disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        hideDisabledOptions: hideDisabledOptions,
        use12Hours: use12Hours,
        hourStep: hourStep,
        minuteStep: minuteStep,
        secondStep: secondStep,
        addon: addon,
        focusOnOpen: focusOnOpen,
        onKeyDown: onKeyDown
      });
    }
  }, {
    key: 'getPopupClassName',
    value: function getPopupClassName() {
      var _props3 = this.props,
          showHour = _props3.showHour,
          showMinute = _props3.showMinute,
          showSecond = _props3.showSecond,
          use12Hours = _props3.use12Hours,
          prefixCls = _props3.prefixCls;

      var popupClassName = this.props.popupClassName;
      // Keep it for old compatibility
      if ((!showHour || !showMinute || !showSecond) && !use12Hours) {
        popupClassName += ' ' + prefixCls + '-panel-narrow';
      }
      var selectColumnCount = 0;
      if (showHour) {
        selectColumnCount += 1;
      }
      if (showMinute) {
        selectColumnCount += 1;
      }
      if (showSecond) {
        selectColumnCount += 1;
      }
      if (use12Hours) {
        selectColumnCount += 1;
      }
      popupClassName += ' ' + prefixCls + '-panel-column-' + selectColumnCount;
      return popupClassName;
    }
  }, {
    key: 'setOpen',
    value: function setOpen(open) {
      var _props4 = this.props,
          onOpen = _props4.onOpen,
          onClose = _props4.onClose;

      if (this.state.open !== open) {
        if (!('open' in this.props)) {
          this.setState({ open: open });
        }
        if (open) {
          onOpen({ open: open });
        } else {
          onClose({ open: open });
        }
      }
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.picker.focus();
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.picker.blur();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          prefixCls = _props5.prefixCls,
          placeholder = _props5.placeholder,
          placement = _props5.placement,
          align = _props5.align,
          disabled = _props5.disabled,
          transitionName = _props5.transitionName,
          style = _props5.style,
          className = _props5.className,
          getPopupContainer = _props5.getPopupContainer,
          name = _props5.name,
          autoComplete = _props5.autoComplete,
          onFocus = _props5.onFocus,
          onBlur = _props5.onBlur,
          autoFocus = _props5.autoFocus,
          inputReadOnly = _props5.inputReadOnly;
      var _state = this.state,
          open = _state.open,
          value = _state.value;

      var popupClassName = this.getPopupClassName();
      return _react2['default'].createElement(
        _rcTrigger2['default'],
        {
          prefixCls: prefixCls + '-panel',
          popupClassName: popupClassName,
          popup: this.getPanelElement(),
          popupAlign: align,
          builtinPlacements: _placements2['default'],
          popupPlacement: placement,
          action: disabled ? [] : ['click'],
          destroyPopupOnHide: true,
          getPopupContainer: getPopupContainer,
          popupTransitionName: transitionName,
          popupVisible: open,
          onPopupVisibleChange: this.onVisibleChange
        },
        _react2['default'].createElement(
          'span',
          { className: prefixCls + ' ' + className, style: style },
          _react2['default'].createElement('input', {
            className: prefixCls + '-input',
            ref: this.saveInputRef,
            type: 'text',
            placeholder: placeholder,
            name: name,
            onKeyDown: this.onKeyDown,
            disabled: disabled,
            value: value && value.format(this.getFormat()) || '',
            autoComplete: autoComplete,
            onFocus: onFocus,
            onBlur: onBlur,
            autoFocus: autoFocus,
            onChange: noop,
            readOnly: !!inputReadOnly
          }),
          _react2['default'].createElement('span', { className: prefixCls + '-icon' })
        )
      );
    }
  }]);
  return Picker;
}(_react.Component);

Picker.propTypes = {
  prefixCls: _propTypes2['default'].string,
  clearText: _propTypes2['default'].string,
  value: _propTypes2['default'].object,
  defaultOpenValue: _propTypes2['default'].object,
  inputReadOnly: _propTypes2['default'].bool,
  disabled: _propTypes2['default'].bool,
  allowEmpty: _propTypes2['default'].bool,
  defaultValue: _propTypes2['default'].object,
  open: _propTypes2['default'].bool,
  defaultOpen: _propTypes2['default'].bool,
  align: _propTypes2['default'].object,
  placement: _propTypes2['default'].any,
  transitionName: _propTypes2['default'].string,
  getPopupContainer: _propTypes2['default'].func,
  placeholder: _propTypes2['default'].string,
  format: _propTypes2['default'].string,
  showHour: _propTypes2['default'].bool,
  showMinute: _propTypes2['default'].bool,
  showSecond: _propTypes2['default'].bool,
  style: _propTypes2['default'].object,
  className: _propTypes2['default'].string,
  popupClassName: _propTypes2['default'].string,
  disabledHours: _propTypes2['default'].func,
  disabledMinutes: _propTypes2['default'].func,
  disabledSeconds: _propTypes2['default'].func,
  hideDisabledOptions: _propTypes2['default'].bool,
  onChange: _propTypes2['default'].func,
  onOpen: _propTypes2['default'].func,
  onClose: _propTypes2['default'].func,
  onFocus: _propTypes2['default'].func,
  onBlur: _propTypes2['default'].func,
  addon: _propTypes2['default'].func,
  name: _propTypes2['default'].string,
  autoComplete: _propTypes2['default'].string,
  use12Hours: _propTypes2['default'].bool,
  hourStep: _propTypes2['default'].number,
  minuteStep: _propTypes2['default'].number,
  secondStep: _propTypes2['default'].number,
  focusOnOpen: _propTypes2['default'].bool,
  onKeyDown: _propTypes2['default'].func,
  autoFocus: _propTypes2['default'].bool
};
Picker.defaultProps = {
  clearText: 'clear',
  prefixCls: 'rc-time-picker',
  defaultOpen: false,
  inputReadOnly: false,
  style: {},
  className: '',
  popupClassName: '',
  align: {},
  defaultOpenValue: (0, _moment2['default'])(),
  allowEmpty: true,
  showHour: true,
  showMinute: true,
  showSecond: true,
  disabledHours: noop,
  disabledMinutes: noop,
  disabledSeconds: noop,
  hideDisabledOptions: false,
  placement: 'bottomLeft',
  onChange: noop,
  onOpen: noop,
  onClose: noop,
  onFocus: noop,
  onBlur: noop,
  addon: noop,
  use12Hours: false,
  focusOnOpen: false,
  onKeyDown: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onPanelChange = function (value) {
    _this2.setValue(value);
  };

  this.onPanelClear = function () {
    _this2.setValue(null);
    _this2.setOpen(false);
  };

  this.onVisibleChange = function (open) {
    _this2.setOpen(open);
  };

  this.onEsc = function () {
    _this2.setOpen(false);
    _this2.focus();
  };

  this.onKeyDown = function (e) {
    if (e.keyCode === 40) {
      _this2.setOpen(true);
    }
  };
};

exports['default'] = Picker;
module.exports = exports['default'];

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  bottomLeft: {
    points: ['tl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  }
};

exports['default'] = placements;
module.exports = exports['default'];

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _slicedToArray2 = __webpack_require__(899);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _moment = __webpack_require__(31);

var moment = _interopRequireWildcard(_moment);

var _reactLifecyclesCompat = __webpack_require__(54);

var _RangeCalendar = __webpack_require__(906);

var _RangeCalendar2 = _interopRequireDefault(_RangeCalendar);

var _Picker = __webpack_require__(196);

var _Picker2 = _interopRequireDefault(_Picker);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _shallowequal = __webpack_require__(52);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _icon = __webpack_require__(6);

var _icon2 = _interopRequireDefault(_icon);

var _tag = __webpack_require__(913);

var _tag2 = _interopRequireDefault(_tag);

var _warning = __webpack_require__(48);

var _warning2 = _interopRequireDefault(_warning);

var _interopDefault = __webpack_require__(89);

var _interopDefault2 = _interopRequireDefault(_interopDefault);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getShowDateFromValue(value) {
    var _value = (0, _slicedToArray3['default'])(value, 2),
        start = _value[0],
        end = _value[1];
    // value could be an empty array, then we should not reset showDate


    if (!start && !end) {
        return;
    }
    var newEnd = end && end.isSame(start, 'month') ? end.clone().add(1, 'month') : end;
    return [start, newEnd];
} /* tslint:disable jsx-no-multiline-js */

function formatValue(value, format) {
    return value && value.format(format) || '';
}
function pickerValueAdapter(value) {
    if (!value) {
        return;
    }
    if (Array.isArray(value)) {
        return value;
    }
    return [value, value.clone().add(1, 'month')];
}
function isEmptyArray(arr) {
    if (Array.isArray(arr)) {
        return arr.length === 0 || arr.every(function (i) {
            return !i;
        });
    }
    return false;
}
function fixLocale(value, localeCode) {
    if (!localeCode) {
        return;
    }
    if (!value || value.length === 0) {
        return;
    }
    if (value[0]) {
        value[0].locale(localeCode);
    }
    if (value[1]) {
        value[1].locale(localeCode);
    }
}

var RangePicker = function (_React$Component) {
    (0, _inherits3['default'])(RangePicker, _React$Component);

    function RangePicker(props) {
        (0, _classCallCheck3['default'])(this, RangePicker);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (RangePicker.__proto__ || Object.getPrototypeOf(RangePicker)).call(this, props));

        _this.clearSelection = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.setState({ value: [] });
            _this.handleChange([]);
        };
        _this.clearHoverValue = function () {
            return _this.setState({ hoverValue: [] });
        };
        _this.handleChange = function (value) {
            var props = _this.props;
            if (!('value' in props)) {
                _this.setState(function (_ref) {
                    var showDate = _ref.showDate;
                    return {
                        value: value,
                        showDate: getShowDateFromValue(value) || showDate
                    };
                });
            }
            props.onChange(value, [formatValue(value[0], props.format), formatValue(value[1], props.format)]);
        };
        _this.handleOpenChange = function (open) {
            if (!('open' in _this.props)) {
                _this.setState({ open: open });
            }
            if (open === false) {
                _this.clearHoverValue();
            }
            var onOpenChange = _this.props.onOpenChange;

            if (onOpenChange) {
                onOpenChange(open);
            }
        };
        _this.handleShowDateChange = function (showDate) {
            return _this.setState({ showDate: showDate });
        };
        _this.handleHoverChange = function (hoverValue) {
            return _this.setState({ hoverValue: hoverValue });
        };
        _this.handleRangeMouseLeave = function () {
            if (_this.state.open) {
                _this.clearHoverValue();
            }
        };
        _this.handleCalendarInputSelect = function (value) {
            if (!value[0]) {
                return;
            }
            _this.setState(function (_ref2) {
                var showDate = _ref2.showDate;
                return {
                    value: value,
                    showDate: getShowDateFromValue(value) || showDate
                };
            });
        };
        _this.handleRangeClick = function (value) {
            if (typeof value === 'function') {
                value = value();
            }
            _this.setValue(value, true);
            var onOk = _this.props.onOk;

            if (onOk) {
                onOk(value);
            }
        };
        _this.savePicker = function (node) {
            _this.picker = node;
        };
        _this.renderFooter = function () {
            var _this$props = _this.props,
                prefixCls = _this$props.prefixCls,
                ranges = _this$props.ranges,
                renderExtraFooter = _this$props.renderExtraFooter,
                tagPrefixCls = _this$props.tagPrefixCls;

            if (!ranges && !renderExtraFooter) {
                return null;
            }
            var customFooter = renderExtraFooter ? React.createElement(
                'div',
                { className: prefixCls + '-footer-extra', key: 'extra' },
                renderExtraFooter.apply(undefined, arguments)
            ) : null;
            var operations = Object.keys(ranges || {}).map(function (range) {
                var value = ranges[range];
                return React.createElement(
                    _tag2['default'],
                    { key: range, prefixCls: tagPrefixCls, color: 'blue', onClick: function onClick() {
                            return _this.handleRangeClick(value);
                        }, onMouseEnter: function onMouseEnter() {
                            return _this.setState({ hoverValue: value });
                        }, onMouseLeave: _this.handleRangeMouseLeave },
                    range
                );
            });
            var rangeNode = React.createElement(
                'div',
                { className: prefixCls + '-footer-extra ' + prefixCls + '-range-quick-selector', key: 'range' },
                operations
            );
            return [rangeNode, customFooter];
        };
        var value = props.value || props.defaultValue || [];
        if (value[0] && !(0, _interopDefault2['default'])(moment).isMoment(value[0]) || value[1] && !(0, _interopDefault2['default'])(moment).isMoment(value[1])) {
            throw new Error('The value/defaultValue of RangePicker must be a moment object array after `antd@2.0`, ' + 'see: https://u.ant.design/date-picker-value');
        }
        var pickerValue = !value || isEmptyArray(value) ? props.defaultPickerValue : value;
        _this.state = {
            value: value,
            showDate: pickerValueAdapter(pickerValue || (0, _interopDefault2['default'])(moment)()),
            open: props.open,
            hoverValue: []
        };
        return _this;
    }

    (0, _createClass3['default'])(RangePicker, [{
        key: 'setValue',
        value: function setValue(value, hidePanel) {
            this.handleChange(value);
            if ((hidePanel || !this.props.showTime) && !('open' in this.props)) {
                this.setState({ open: false });
            }
        }
    }, {
        key: 'focus',
        value: function focus() {
            this.picker.focus();
        }
    }, {
        key: 'blur',
        value: function blur() {
            this.picker.blur();
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames,
                _this2 = this;

            var state = this.state,
                props = this.props;
            var value = state.value,
                showDate = state.showDate,
                hoverValue = state.hoverValue,
                open = state.open;
            var prefixCls = props.prefixCls,
                popupStyle = props.popupStyle,
                style = props.style,
                disabledDate = props.disabledDate,
                disabledTime = props.disabledTime,
                showTime = props.showTime,
                showToday = props.showToday,
                ranges = props.ranges,
                onOk = props.onOk,
                locale = props.locale,
                localeCode = props.localeCode,
                format = props.format,
                dateRender = props.dateRender,
                onCalendarChange = props.onCalendarChange;

            fixLocale(value, localeCode);
            fixLocale(showDate, localeCode);
            (0, _warning2['default'])(!('onOK' in props), 'It should be `RangePicker[onOk]`, instead of `onOK`!');
            var calendarClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-time', showTime), (0, _defineProperty3['default'])(_classNames, prefixCls + '-range-with-ranges', ranges), _classNames));
            // 需要选择时间时，点击 ok 时才触发 onChange
            var pickerChangeHandler = {
                onChange: this.handleChange
            };
            var calendarProps = {
                onOk: this.handleChange
            };
            if (props.timePicker) {
                pickerChangeHandler.onChange = function (changedValue) {
                    return _this2.handleChange(changedValue);
                };
            } else {
                calendarProps = {};
            }
            if ('mode' in props) {
                calendarProps.mode = props.mode;
            }
            var startPlaceholder = 'placeholder' in props ? props.placeholder[0] : locale.lang.rangePlaceholder[0];
            var endPlaceholder = 'placeholder' in props ? props.placeholder[1] : locale.lang.rangePlaceholder[1];
            var calendar = React.createElement(_RangeCalendar2['default'], (0, _extends3['default'])({}, calendarProps, { onChange: onCalendarChange, format: format, prefixCls: prefixCls, className: calendarClassName, renderFooter: this.renderFooter, timePicker: props.timePicker, disabledDate: disabledDate, disabledTime: disabledTime, dateInputPlaceholder: [startPlaceholder, endPlaceholder], locale: locale.lang, onOk: onOk, dateRender: dateRender, value: showDate, onValueChange: this.handleShowDateChange, hoverValue: hoverValue, onHoverChange: this.handleHoverChange, onPanelChange: props.onPanelChange, showToday: showToday, onInputSelect: this.handleCalendarInputSelect }));
            // default width for showTime
            var pickerStyle = {};
            if (props.showTime) {
                pickerStyle.width = style && style.width || 350;
            }
            var clearIcon = !props.disabled && props.allowClear && value && (value[0] || value[1]) ? React.createElement(_icon2['default'], { type: 'cross-circle', className: prefixCls + '-picker-clear', onClick: this.clearSelection }) : null;
            var input = function input(_ref3) {
                var inputValue = _ref3.value;

                var start = inputValue[0];
                var end = inputValue[1];
                return React.createElement(
                    'span',
                    { className: props.pickerInputClass },
                    React.createElement('input', { disabled: props.disabled, readOnly: true, value: start && start.format(props.format) || '', placeholder: startPlaceholder, className: prefixCls + '-range-picker-input', tabIndex: -1 }),
                    React.createElement(
                        'span',
                        { className: prefixCls + '-range-picker-separator' },
                        ' ~ '
                    ),
                    React.createElement('input', { disabled: props.disabled, readOnly: true, value: end && end.format(props.format) || '', placeholder: endPlaceholder, className: prefixCls + '-range-picker-input', tabIndex: -1 }),
                    clearIcon,
                    React.createElement('span', { className: prefixCls + '-picker-icon' })
                );
            };
            return React.createElement(
                'span',
                { ref: this.savePicker, id: props.id, className: (0, _classnames2['default'])(props.className, props.pickerClass), style: (0, _extends3['default'])({}, style, pickerStyle), tabIndex: props.disabled ? -1 : 0, onFocus: props.onFocus, onBlur: props.onBlur, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave },
                React.createElement(
                    _Picker2['default'],
                    (0, _extends3['default'])({}, props, pickerChangeHandler, { calendar: calendar, value: value, open: open, onOpenChange: this.handleOpenChange, prefixCls: prefixCls + '-picker-container', style: popupStyle }),
                    input
                )
            );
        }
    }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
            var state = null;
            if ('value' in nextProps) {
                var value = nextProps.value || [];
                state = {
                    value: value
                };
                if (!(0, _shallowequal2['default'])(nextProps.value, prevState.value)) {
                    state = (0, _extends3['default'])({}, state, { showDate: getShowDateFromValue(value) || prevState.showDate });
                }
            }
            if ('open' in nextProps && prevState.open !== nextProps.open) {
                state = (0, _extends3['default'])({}, state, { open: nextProps.open });
            }
            return state;
        }
    }]);
    return RangePicker;
}(React.Component);

RangePicker.defaultProps = {
    prefixCls: 'ant-calendar',
    tagPrefixCls: 'ant-tag',
    allowClear: true,
    showToday: false
};
(0, _reactLifecyclesCompat.polyfill)(RangePicker);
exports['default'] = RangePicker;
module.exports = exports['default'];

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(900);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(903);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(901), __esModule: true };

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(143);
__webpack_require__(105);
module.exports = __webpack_require__(902);


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(261);
var ITERATOR = __webpack_require__(45)('iterator');
var Iterators = __webpack_require__(76);
module.exports = __webpack_require__(44).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(904), __esModule: true };

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(143);
__webpack_require__(105);
module.exports = __webpack_require__(905);


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(63);
var get = __webpack_require__(260);
module.exports = __webpack_require__(44).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(36);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(31);

var _moment2 = _interopRequireDefault(_moment);

var _classnames2 = __webpack_require__(11);

var _classnames3 = _interopRequireDefault(_classnames2);

var _KeyCode = __webpack_require__(195);

var _KeyCode2 = _interopRequireDefault(_KeyCode);

var _CalendarPart = __webpack_require__(907);

var _CalendarPart2 = _interopRequireDefault(_CalendarPart);

var _TodayButton = __webpack_require__(337);

var _TodayButton2 = _interopRequireDefault(_TodayButton);

var _OkButton = __webpack_require__(338);

var _OkButton2 = _interopRequireDefault(_OkButton);

var _TimePickerButton = __webpack_require__(339);

var _TimePickerButton2 = _interopRequireDefault(_TimePickerButton);

var _CommonMixin = __webpack_require__(340);

var _CommonMixin2 = _interopRequireDefault(_CommonMixin);

var _util = __webpack_require__(84);

var _toTime = __webpack_require__(912);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

function isEmptyArray(arr) {
  return Array.isArray(arr) && (arr.length === 0 || arr.every(function (i) {
    return !i;
  }));
}

function isArraysEqual(a, b) {
  if (a === b) return true;
  if (a === null || typeof a === 'undefined' || b === null || typeof b === 'undefined') {
    return false;
  }
  if (a.length !== b.length) return false;

  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

function getValueFromSelectedValue(selectedValue) {
  var start = selectedValue[0],
      end = selectedValue[1];

  var newEnd = end && end.isSame(start, 'month') ? end.clone().add(1, 'month') : end;
  return [start, newEnd];
}

function normalizeAnchor(props, init) {
  var selectedValue = props.selectedValue || init && props.defaultSelectedValue;
  var value = props.value || init && props.defaultValue;
  var normalizedValue = value ? getValueFromSelectedValue(value) : getValueFromSelectedValue(selectedValue);
  return !isEmptyArray(normalizedValue) ? normalizedValue : init && [(0, _moment2['default'])(), (0, _moment2['default'])().add(1, 'months')];
}

function generateOptions(length, extraOptionGen) {
  var arr = extraOptionGen ? extraOptionGen().concat() : [];
  for (var value = 0; value < length; value++) {
    if (arr.indexOf(value) === -1) {
      arr.push(value);
    }
  }
  return arr;
}

function onInputSelect(direction, value) {
  if (!value) {
    return;
  }
  var originalValue = this.state.selectedValue;
  var selectedValue = originalValue.concat();
  var index = direction === 'left' ? 0 : 1;
  selectedValue[index] = value;
  if (selectedValue[0] && this.compare(selectedValue[0], selectedValue[1]) > 0) {
    selectedValue[1 - index] = this.state.showTimePicker ? selectedValue[index] : undefined;
  }
  this.props.onInputSelect(selectedValue);
  this.fireSelectValueChange(selectedValue);
}

var RangeCalendar = (0, _createReactClass2['default'])({
  displayName: 'RangeCalendar',

  propTypes: {
    prefixCls: _propTypes2['default'].string,
    dateInputPlaceholder: _propTypes2['default'].any,
    defaultValue: _propTypes2['default'].any,
    value: _propTypes2['default'].any,
    hoverValue: _propTypes2['default'].any,
    mode: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOf(['date', 'month', 'year', 'decade'])),
    showDateInput: _propTypes2['default'].bool,
    timePicker: _propTypes2['default'].any,
    showOk: _propTypes2['default'].bool,
    showToday: _propTypes2['default'].bool,
    defaultSelectedValue: _propTypes2['default'].array,
    selectedValue: _propTypes2['default'].array,
    onOk: _propTypes2['default'].func,
    showClear: _propTypes2['default'].bool,
    locale: _propTypes2['default'].object,
    onChange: _propTypes2['default'].func,
    onSelect: _propTypes2['default'].func,
    onValueChange: _propTypes2['default'].func,
    onHoverChange: _propTypes2['default'].func,
    onPanelChange: _propTypes2['default'].func,
    format: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].string]),
    onClear: _propTypes2['default'].func,
    type: _propTypes2['default'].any,
    disabledDate: _propTypes2['default'].func,
    disabledTime: _propTypes2['default'].func
  },

  mixins: [_CommonMixin2['default']],

  getDefaultProps: function getDefaultProps() {
    return {
      type: 'both',
      defaultSelectedValue: [],
      onValueChange: noop,
      onHoverChange: noop,
      onPanelChange: noop,
      disabledTime: noop,
      onInputSelect: noop,
      showToday: true,
      showDateInput: true
    };
  },
  getInitialState: function getInitialState() {
    var props = this.props;
    var selectedValue = props.selectedValue || props.defaultSelectedValue;
    var value = normalizeAnchor(props, 1);
    return {
      selectedValue: selectedValue,
      prevSelectedValue: selectedValue,
      firstSelectedValue: null,
      hoverValue: props.hoverValue || [],
      value: value,
      showTimePicker: false,
      mode: props.mode || ['date', 'date']
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var state = this.state;

    var newState = {};
    if ('value' in nextProps) {
      newState.value = normalizeAnchor(nextProps, 0);
      this.setState(newState);
    }
    if ('hoverValue' in nextProps && !isArraysEqual(state.hoverValue, nextProps.hoverValue)) {
      this.setState({ hoverValue: nextProps.hoverValue });
    }
    if ('selectedValue' in nextProps) {
      newState.selectedValue = nextProps.selectedValue;
      newState.prevSelectedValue = nextProps.selectedValue;
      this.setState(newState);
    }
    if ('mode' in nextProps && !isArraysEqual(state.mode, nextProps.mode)) {
      this.setState({ mode: nextProps.mode });
    }
  },
  onDatePanelEnter: function onDatePanelEnter() {
    if (this.hasSelectedValue()) {
      this.fireHoverValueChange(this.state.selectedValue.concat());
    }
  },
  onDatePanelLeave: function onDatePanelLeave() {
    if (this.hasSelectedValue()) {
      this.fireHoverValueChange([]);
    }
  },
  onSelect: function onSelect(value) {
    var type = this.props.type;
    var _state = this.state,
        selectedValue = _state.selectedValue,
        prevSelectedValue = _state.prevSelectedValue,
        firstSelectedValue = _state.firstSelectedValue;

    var nextSelectedValue = void 0;
    if (type === 'both') {
      if (!firstSelectedValue) {
        (0, _util.syncTime)(prevSelectedValue[0], value);
        nextSelectedValue = [value];
      } else if (this.compare(firstSelectedValue, value) < 0) {
        (0, _util.syncTime)(prevSelectedValue[1], value);
        nextSelectedValue = [firstSelectedValue, value];
      } else {
        (0, _util.syncTime)(prevSelectedValue[0], value);
        (0, _util.syncTime)(prevSelectedValue[1], firstSelectedValue);
        nextSelectedValue = [value, firstSelectedValue];
      }
    } else if (type === 'start') {
      (0, _util.syncTime)(prevSelectedValue[0], value);
      var endValue = selectedValue[1];
      nextSelectedValue = endValue && this.compare(endValue, value) > 0 ? [value, endValue] : [value];
    } else {
      // type === 'end'
      var startValue = selectedValue[0];
      if (startValue && this.compare(startValue, value) <= 0) {
        (0, _util.syncTime)(prevSelectedValue[1], value);
        nextSelectedValue = [startValue, value];
      } else {
        (0, _util.syncTime)(prevSelectedValue[0], value);
        nextSelectedValue = [value];
      }
    }

    this.fireSelectValueChange(nextSelectedValue);
  },
  onKeyDown: function onKeyDown(event) {
    var _this = this;

    if (event.target.nodeName.toLowerCase() === 'input') {
      return;
    }

    var keyCode = event.keyCode;

    var ctrlKey = event.ctrlKey || event.metaKey;

    var _state2 = this.state,
        selectedValue = _state2.selectedValue,
        hoverValue = _state2.hoverValue,
        firstSelectedValue = _state2.firstSelectedValue,
        value = _state2.value;
    var _props = this.props,
        onKeyDown = _props.onKeyDown,
        disabledDate = _props.disabledDate;

    // Update last time of the picker

    var updateHoverPoint = function updateHoverPoint(func) {
      // Change hover to make focus in UI
      var currentHoverTime = void 0;
      var nextHoverTime = void 0;
      var nextHoverValue = void 0;

      if (!firstSelectedValue) {
        currentHoverTime = hoverValue[0] || selectedValue[0] || value[0] || (0, _moment2['default'])();
        nextHoverTime = func(currentHoverTime);
        nextHoverValue = [nextHoverTime];
        _this.fireHoverValueChange(nextHoverValue);
      } else {
        if (hoverValue.length === 1) {
          currentHoverTime = hoverValue[0].clone();
          nextHoverTime = func(currentHoverTime);
          nextHoverValue = _this.onDayHover(nextHoverTime);
        } else {
          currentHoverTime = hoverValue[0].isSame(firstSelectedValue, 'day') ? hoverValue[1] : hoverValue[0];
          nextHoverTime = func(currentHoverTime);
          nextHoverValue = _this.onDayHover(nextHoverTime);
        }
      }

      // Find origin hover time on value index
      if (nextHoverValue.length >= 2) {
        var miss = nextHoverValue.some(function (ht) {
          return !(0, _toTime.includesTime)(value, ht, 'month');
        });
        if (miss) {
          var newValue = nextHoverValue.slice().sort(function (t1, t2) {
            return t1.valueOf() - t2.valueOf();
          });
          if (newValue[0].isSame(newValue[1], 'month')) {
            newValue[1] = newValue[0].clone().add(1, 'month');
          }
          _this.fireValueChange(newValue);
        }
      } else if (nextHoverValue.length === 1) {
        // If only one value, let's keep the origin panel
        var oriValueIndex = value.findIndex(function (time) {
          return time.isSame(currentHoverTime, 'month');
        });
        if (oriValueIndex === -1) oriValueIndex = 0;

        if (value.every(function (time) {
          return !time.isSame(nextHoverTime, 'month');
        })) {
          var _newValue = value.slice();
          _newValue[oriValueIndex] = nextHoverTime.clone();
          _this.fireValueChange(_newValue);
        }
      }

      event.preventDefault();

      return nextHoverTime;
    };

    switch (keyCode) {
      case _KeyCode2['default'].DOWN:
        updateHoverPoint(function (time) {
          return (0, _toTime.goTime)(time, 1, 'weeks');
        });
        return;
      case _KeyCode2['default'].UP:
        updateHoverPoint(function (time) {
          return (0, _toTime.goTime)(time, -1, 'weeks');
        });
        return;
      case _KeyCode2['default'].LEFT:
        if (ctrlKey) {
          updateHoverPoint(function (time) {
            return (0, _toTime.goTime)(time, -1, 'years');
          });
        } else {
          updateHoverPoint(function (time) {
            return (0, _toTime.goTime)(time, -1, 'days');
          });
        }
        return;
      case _KeyCode2['default'].RIGHT:
        if (ctrlKey) {
          updateHoverPoint(function (time) {
            return (0, _toTime.goTime)(time, 1, 'years');
          });
        } else {
          updateHoverPoint(function (time) {
            return (0, _toTime.goTime)(time, 1, 'days');
          });
        }
        return;
      case _KeyCode2['default'].HOME:
        updateHoverPoint(function (time) {
          return (0, _toTime.goStartMonth)(time);
        });
        return;
      case _KeyCode2['default'].END:
        updateHoverPoint(function (time) {
          return (0, _toTime.goEndMonth)(time);
        });
        return;
      case _KeyCode2['default'].PAGE_DOWN:
        updateHoverPoint(function (time) {
          return (0, _toTime.goTime)(time, 1, 'month');
        });
        return;
      case _KeyCode2['default'].PAGE_UP:
        updateHoverPoint(function (time) {
          return (0, _toTime.goTime)(time, -1, 'month');
        });
        return;
      case _KeyCode2['default'].ENTER:
        {
          var lastValue = void 0;
          if (hoverValue.length === 0) {
            lastValue = updateHoverPoint(function (time) {
              return time;
            });
          } else if (hoverValue.length === 1) {
            lastValue = hoverValue[0];
          } else {
            lastValue = hoverValue[0].isSame(firstSelectedValue, 'day') ? hoverValue[1] : hoverValue[0];
          }
          if (lastValue && (!disabledDate || !disabledDate(lastValue))) {
            this.onSelect(lastValue);
          }
          event.preventDefault();
          return;
        }
      default:
        if (onKeyDown) {
          onKeyDown(event);
        }
    }
  },
  onDayHover: function onDayHover(value) {
    var hoverValue = [];
    var _state3 = this.state,
        selectedValue = _state3.selectedValue,
        firstSelectedValue = _state3.firstSelectedValue;
    var type = this.props.type;

    if (type === 'start' && selectedValue[1]) {
      hoverValue = this.compare(value, selectedValue[1]) < 0 ? [value, selectedValue[1]] : [value];
    } else if (type === 'end' && selectedValue[0]) {
      hoverValue = this.compare(value, selectedValue[0]) > 0 ? [selectedValue[0], value] : [];
    } else {
      if (!firstSelectedValue) {
        if (this.state.hoverValue.length) {
          this.setState({ hoverValue: [] });
        }
        return hoverValue;
      }
      hoverValue = this.compare(value, firstSelectedValue) < 0 ? [value, firstSelectedValue] : [firstSelectedValue, value];
    }
    this.fireHoverValueChange(hoverValue);

    return hoverValue;
  },
  onToday: function onToday() {
    var startValue = (0, _util.getTodayTime)(this.state.value[0]);
    var endValue = startValue.clone().add(1, 'months');
    this.setState({ value: [startValue, endValue] });
  },
  onOpenTimePicker: function onOpenTimePicker() {
    this.setState({
      showTimePicker: true
    });
  },
  onCloseTimePicker: function onCloseTimePicker() {
    this.setState({
      showTimePicker: false
    });
  },
  onOk: function onOk() {
    var selectedValue = this.state.selectedValue;

    if (this.isAllowedDateAndTime(selectedValue)) {
      this.props.onOk(this.state.selectedValue);
    }
  },
  onStartInputSelect: function onStartInputSelect() {
    for (var _len = arguments.length, oargs = Array(_len), _key = 0; _key < _len; _key++) {
      oargs[_key] = arguments[_key];
    }

    var args = ['left'].concat(oargs);
    return onInputSelect.apply(this, args);
  },
  onEndInputSelect: function onEndInputSelect() {
    for (var _len2 = arguments.length, oargs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      oargs[_key2] = arguments[_key2];
    }

    var args = ['right'].concat(oargs);
    return onInputSelect.apply(this, args);
  },
  onStartValueChange: function onStartValueChange(leftValue) {
    var value = [].concat(this.state.value);
    value[0] = leftValue;
    return this.fireValueChange(value);
  },
  onEndValueChange: function onEndValueChange(rightValue) {
    var value = [].concat(this.state.value);
    value[1] = rightValue;
    return this.fireValueChange(value);
  },
  onStartPanelChange: function onStartPanelChange(value, mode) {
    var props = this.props,
        state = this.state;

    var newMode = [mode, state.mode[1]];
    if (!('mode' in props)) {
      this.setState({
        mode: newMode
      });
    }
    var newValue = [value || state.value[0], state.value[1]];
    props.onPanelChange(newValue, newMode);
  },
  onEndPanelChange: function onEndPanelChange(value, mode) {
    var props = this.props,
        state = this.state;

    var newMode = [state.mode[0], mode];
    if (!('mode' in props)) {
      this.setState({
        mode: newMode
      });
    }
    var newValue = [state.value[0], value || state.value[1]];
    props.onPanelChange(newValue, newMode);
  },
  getStartValue: function getStartValue() {
    var value = this.state.value[0];
    var selectedValue = this.state.selectedValue;
    // keep selectedTime when select date
    if (selectedValue[0] && this.props.timePicker) {
      value = value.clone();
      (0, _util.syncTime)(selectedValue[0], value);
    }
    if (this.state.showTimePicker && selectedValue[0]) {
      return selectedValue[0];
    }
    return value;
  },
  getEndValue: function getEndValue() {
    var _state4 = this.state,
        value = _state4.value,
        selectedValue = _state4.selectedValue,
        showTimePicker = _state4.showTimePicker;

    var endValue = value[1] ? value[1].clone() : value[0].clone().add(1, 'month');
    // keep selectedTime when select date
    if (selectedValue[1] && this.props.timePicker) {
      (0, _util.syncTime)(selectedValue[1], endValue);
    }
    if (showTimePicker) {
      return selectedValue[1] ? selectedValue[1] : this.getStartValue();
    }
    return endValue;
  },

  // get disabled hours for second picker
  getEndDisableTime: function getEndDisableTime() {
    var _state5 = this.state,
        selectedValue = _state5.selectedValue,
        value = _state5.value;
    var disabledTime = this.props.disabledTime;

    var userSettingDisabledTime = disabledTime(selectedValue, 'end') || {};
    var startValue = selectedValue && selectedValue[0] || value[0].clone();
    // if startTime and endTime is same day..
    // the second time picker will not able to pick time before first time picker
    if (!selectedValue[1] || startValue.isSame(selectedValue[1], 'day')) {
      var hours = startValue.hour();
      var minutes = startValue.minute();
      var second = startValue.second();
      var _disabledHours = userSettingDisabledTime.disabledHours,
          _disabledMinutes = userSettingDisabledTime.disabledMinutes,
          _disabledSeconds = userSettingDisabledTime.disabledSeconds;

      var oldDisabledMinutes = _disabledMinutes ? _disabledMinutes() : [];
      var olddisabledSeconds = _disabledSeconds ? _disabledSeconds() : [];
      _disabledHours = generateOptions(hours, _disabledHours);
      _disabledMinutes = generateOptions(minutes, _disabledMinutes);
      _disabledSeconds = generateOptions(second, _disabledSeconds);
      return {
        disabledHours: function disabledHours() {
          return _disabledHours;
        },
        disabledMinutes: function disabledMinutes(hour) {
          if (hour === hours) {
            return _disabledMinutes;
          }
          return oldDisabledMinutes;
        },
        disabledSeconds: function disabledSeconds(hour, minute) {
          if (hour === hours && minute === minutes) {
            return _disabledSeconds;
          }
          return olddisabledSeconds;
        }
      };
    }
    return userSettingDisabledTime;
  },
  isAllowedDateAndTime: function isAllowedDateAndTime(selectedValue) {
    return (0, _util.isAllowedDate)(selectedValue[0], this.props.disabledDate, this.disabledStartTime) && (0, _util.isAllowedDate)(selectedValue[1], this.props.disabledDate, this.disabledEndTime);
  },
  isMonthYearPanelShow: function isMonthYearPanelShow(mode) {
    return ['month', 'year', 'decade'].indexOf(mode) > -1;
  },
  hasSelectedValue: function hasSelectedValue() {
    var selectedValue = this.state.selectedValue;

    return !!selectedValue[1] && !!selectedValue[0];
  },
  compare: function compare(v1, v2) {
    if (this.props.timePicker) {
      return v1.diff(v2);
    }
    return v1.diff(v2, 'days');
  },
  fireSelectValueChange: function fireSelectValueChange(selectedValue, direct) {
    var timePicker = this.props.timePicker;
    var prevSelectedValue = this.state.prevSelectedValue;

    if (timePicker && timePicker.props.defaultValue) {
      var timePickerDefaultValue = timePicker.props.defaultValue;
      if (!prevSelectedValue[0] && selectedValue[0]) {
        (0, _util.syncTime)(timePickerDefaultValue[0], selectedValue[0]);
      }
      if (!prevSelectedValue[1] && selectedValue[1]) {
        (0, _util.syncTime)(timePickerDefaultValue[1], selectedValue[1]);
      }
    }

    if (!('selectedValue' in this.props)) {
      this.setState({
        selectedValue: selectedValue
      });
    }

    // 尚未选择过时间，直接输入的话
    if (!this.state.selectedValue[0] || !this.state.selectedValue[1]) {
      var startValue = selectedValue[0] || (0, _moment2['default'])();
      var endValue = selectedValue[1] || startValue.clone().add(1, 'months');
      this.setState({
        selectedValue: selectedValue,
        value: getValueFromSelectedValue([startValue, endValue])
      });
    }

    if (selectedValue[0] && !selectedValue[1]) {
      this.setState({ firstSelectedValue: selectedValue[0] });
      this.fireHoverValueChange(selectedValue.concat());
    }
    this.props.onChange(selectedValue);
    if (direct || selectedValue[0] && selectedValue[1]) {
      this.setState({
        prevSelectedValue: selectedValue,
        firstSelectedValue: null
      });
      this.fireHoverValueChange([]);
      this.props.onSelect(selectedValue);
    }
  },
  fireValueChange: function fireValueChange(value) {
    var props = this.props;
    if (!('value' in props)) {
      this.setState({
        value: value
      });
    }
    props.onValueChange(value);
  },
  fireHoverValueChange: function fireHoverValueChange(hoverValue) {
    var props = this.props;
    if (!('hoverValue' in props)) {
      this.setState({ hoverValue: hoverValue });
    }
    props.onHoverChange(hoverValue);
  },
  clear: function clear() {
    this.fireSelectValueChange([], true);
    this.props.onClear();
  },
  disabledStartTime: function disabledStartTime(time) {
    return this.props.disabledTime(time, 'start');
  },
  disabledEndTime: function disabledEndTime(time) {
    return this.props.disabledTime(time, 'end');
  },
  disabledStartMonth: function disabledStartMonth(month) {
    var value = this.state.value;

    return month.isSameOrAfter(value[1], 'month');
  },
  disabledEndMonth: function disabledEndMonth(month) {
    var value = this.state.value;

    return month.isSameOrBefore(value[0], 'month');
  },
  render: function render() {
    var _className, _classnames;

    var props = this.props,
        state = this.state;
    var prefixCls = props.prefixCls,
        dateInputPlaceholder = props.dateInputPlaceholder,
        timePicker = props.timePicker,
        showOk = props.showOk,
        locale = props.locale,
        showClear = props.showClear,
        showToday = props.showToday,
        type = props.type;
    var hoverValue = state.hoverValue,
        selectedValue = state.selectedValue,
        mode = state.mode,
        showTimePicker = state.showTimePicker;

    var className = (_className = {}, _className[props.className] = !!props.className, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[prefixCls + '-range'] = 1, _className[prefixCls + '-show-time-picker'] = showTimePicker, _className[prefixCls + '-week-number'] = props.showWeekNumber, _className);
    var classes = (0, _classnames3['default'])(className);
    var newProps = {
      selectedValue: state.selectedValue,
      onSelect: this.onSelect,
      onDayHover: type === 'start' && selectedValue[1] || type === 'end' && selectedValue[0] || !!hoverValue.length ? this.onDayHover : undefined
    };

    var placeholder1 = void 0;
    var placeholder2 = void 0;

    if (dateInputPlaceholder) {
      if (Array.isArray(dateInputPlaceholder)) {
        placeholder1 = dateInputPlaceholder[0];
        placeholder2 = dateInputPlaceholder[1];
      } else {
        placeholder1 = placeholder2 = dateInputPlaceholder;
      }
    }
    var showOkButton = showOk === true || showOk !== false && !!timePicker;
    var cls = (0, _classnames3['default'])((_classnames = {}, _classnames[prefixCls + '-footer'] = true, _classnames[prefixCls + '-range-bottom'] = true, _classnames[prefixCls + '-footer-show-ok'] = showOkButton, _classnames));

    var startValue = this.getStartValue();
    var endValue = this.getEndValue();
    var todayTime = (0, _util.getTodayTime)(startValue);
    var thisMonth = todayTime.month();
    var thisYear = todayTime.year();
    var isTodayInView = startValue.year() === thisYear && startValue.month() === thisMonth || endValue.year() === thisYear && endValue.month() === thisMonth;
    var nextMonthOfStart = startValue.clone().add(1, 'months');
    var isClosestMonths = nextMonthOfStart.year() === endValue.year() && nextMonthOfStart.month() === endValue.month();

    // console.warn('Render:', selectedValue.map(t => t.format('YYYY-MM-DD')).join(', '));
    // console.log('start:', startValue.format('YYYY-MM-DD'));
    // console.log('end:', endValue.format('YYYY-MM-DD'));

    return _react2['default'].createElement(
      'div',
      {
        ref: this.saveRoot,
        className: classes,
        style: props.style,
        tabIndex: '0',
        onKeyDown: this.onKeyDown
      },
      props.renderSidebar(),
      _react2['default'].createElement(
        'div',
        { className: prefixCls + '-panel' },
        showClear && selectedValue[0] && selectedValue[1] ? _react2['default'].createElement('a', {
          className: prefixCls + '-clear-btn',
          role: 'button',
          title: locale.clear,
          onClick: this.clear
        }) : null,
        _react2['default'].createElement(
          'div',
          {
            className: prefixCls + '-date-panel',
            onMouseLeave: type !== 'both' ? this.onDatePanelLeave : undefined,
            onMouseEnter: type !== 'both' ? this.onDatePanelEnter : undefined
          },
          _react2['default'].createElement(_CalendarPart2['default'], (0, _extends3['default'])({}, props, newProps, {
            hoverValue: hoverValue,
            direction: 'left',
            disabledTime: this.disabledStartTime,
            disabledMonth: this.disabledStartMonth,
            format: this.getFormat(),
            value: startValue,
            mode: mode[0],
            placeholder: placeholder1,
            onInputSelect: this.onStartInputSelect,
            onValueChange: this.onStartValueChange,
            onPanelChange: this.onStartPanelChange,
            showDateInput: this.props.showDateInput,
            timePicker: timePicker,
            showTimePicker: showTimePicker,
            enablePrev: true,
            enableNext: !isClosestMonths || this.isMonthYearPanelShow(mode[1])
          })),
          _react2['default'].createElement(
            'span',
            { className: prefixCls + '-range-middle' },
            '~'
          ),
          _react2['default'].createElement(_CalendarPart2['default'], (0, _extends3['default'])({}, props, newProps, {
            hoverValue: hoverValue,
            direction: 'right',
            format: this.getFormat(),
            timePickerDisabledTime: this.getEndDisableTime(),
            placeholder: placeholder2,
            value: endValue,
            mode: mode[1],
            onInputSelect: this.onEndInputSelect,
            onValueChange: this.onEndValueChange,
            onPanelChange: this.onEndPanelChange,
            showDateInput: this.props.showDateInput,
            timePicker: timePicker,
            showTimePicker: showTimePicker,
            disabledTime: this.disabledEndTime,
            disabledMonth: this.disabledEndMonth,
            enablePrev: !isClosestMonths || this.isMonthYearPanelShow(mode[0]),
            enableNext: true
          }))
        ),
        _react2['default'].createElement(
          'div',
          { className: cls },
          props.renderFooter(),
          showToday || props.timePicker || showOkButton ? _react2['default'].createElement(
            'div',
            { className: prefixCls + '-footer-btn' },
            showToday ? _react2['default'].createElement(_TodayButton2['default'], (0, _extends3['default'])({}, props, {
              disabled: isTodayInView,
              value: state.value[0],
              onToday: this.onToday,
              text: locale.backToToday
            })) : null,
            props.timePicker ? _react2['default'].createElement(_TimePickerButton2['default'], (0, _extends3['default'])({}, props, {
              showTimePicker: showTimePicker,
              onOpenTimePicker: this.onOpenTimePicker,
              onCloseTimePicker: this.onCloseTimePicker,
              timePickerDisabled: !this.hasSelectedValue() || hoverValue.length
            })) : null,
            showOkButton ? _react2['default'].createElement(_OkButton2['default'], (0, _extends3['default'])({}, props, {
              onOk: this.onOk,
              okDisabled: !this.isAllowedDateAndTime(selectedValue) || !this.hasSelectedValue() || hoverValue.length
            })) : null
          ) : null
        )
      )
    );
  }
});

exports['default'] = RangeCalendar;
module.exports = exports['default'];

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(36);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CalendarHeader = __webpack_require__(335);

var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);

var _DateTable = __webpack_require__(908);

var _DateTable2 = _interopRequireDefault(_DateTable);

var _DateInput = __webpack_require__(911);

var _DateInput2 = _interopRequireDefault(_DateInput);

var _index = __webpack_require__(84);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CalendarPart = (0, _createReactClass2['default'])({
  displayName: 'CalendarPart',

  propTypes: {
    prefixCls: _propTypes2['default'].string,
    value: _propTypes2['default'].any,
    hoverValue: _propTypes2['default'].any,
    selectedValue: _propTypes2['default'].any,
    direction: _propTypes2['default'].any,
    locale: _propTypes2['default'].any,
    showDateInput: _propTypes2['default'].bool,
    showTimePicker: _propTypes2['default'].bool,
    format: _propTypes2['default'].any,
    placeholder: _propTypes2['default'].any,
    disabledDate: _propTypes2['default'].any,
    timePicker: _propTypes2['default'].any,
    disabledTime: _propTypes2['default'].any,
    onInputSelect: _propTypes2['default'].func,
    timePickerDisabledTime: _propTypes2['default'].object,
    enableNext: _propTypes2['default'].any,
    enablePrev: _propTypes2['default'].any
  },
  render: function render() {
    var props = this.props;
    var prefixCls = props.prefixCls,
        value = props.value,
        hoverValue = props.hoverValue,
        selectedValue = props.selectedValue,
        mode = props.mode,
        direction = props.direction,
        locale = props.locale,
        format = props.format,
        placeholder = props.placeholder,
        disabledDate = props.disabledDate,
        timePicker = props.timePicker,
        disabledTime = props.disabledTime,
        timePickerDisabledTime = props.timePickerDisabledTime,
        showTimePicker = props.showTimePicker,
        onInputSelect = props.onInputSelect,
        enablePrev = props.enablePrev,
        enableNext = props.enableNext;

    var shouldShowTimePicker = showTimePicker && timePicker;
    var disabledTimeConfig = shouldShowTimePicker && disabledTime ? (0, _index.getTimeConfig)(selectedValue, disabledTime) : null;
    var rangeClassName = prefixCls + '-range';
    var newProps = {
      locale: locale,
      value: value,
      prefixCls: prefixCls,
      showTimePicker: showTimePicker
    };
    var index = direction === 'left' ? 0 : 1;
    var timePickerEle = shouldShowTimePicker && _react2['default'].cloneElement(timePicker, (0, _extends3['default'])({
      showHour: true,
      showMinute: true,
      showSecond: true
    }, timePicker.props, disabledTimeConfig, timePickerDisabledTime, {
      onChange: onInputSelect,
      defaultOpenValue: value,
      value: selectedValue[index]
    }));

    var dateInputElement = props.showDateInput && _react2['default'].createElement(_DateInput2['default'], {
      format: format,
      locale: locale,
      prefixCls: prefixCls,
      timePicker: timePicker,
      disabledDate: disabledDate,
      placeholder: placeholder,
      disabledTime: disabledTime,
      value: value,
      showClear: false,
      selectedValue: selectedValue[index],
      onChange: onInputSelect
    });

    return _react2['default'].createElement(
      'div',
      {
        className: rangeClassName + '-part ' + rangeClassName + '-' + direction
      },
      dateInputElement,
      _react2['default'].createElement(
        'div',
        { style: { outline: 'none' } },
        _react2['default'].createElement(_CalendarHeader2['default'], (0, _extends3['default'])({}, newProps, {
          mode: mode,
          enableNext: enableNext,
          enablePrev: enablePrev,
          onValueChange: props.onValueChange,
          onPanelChange: props.onPanelChange,
          disabledMonth: props.disabledMonth
        })),
        showTimePicker ? _react2['default'].createElement(
          'div',
          { className: prefixCls + '-time-picker' },
          _react2['default'].createElement(
            'div',
            { className: prefixCls + '-time-picker-panel' },
            timePickerEle
          )
        ) : null,
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-body' },
          _react2['default'].createElement(_DateTable2['default'], (0, _extends3['default'])({}, newProps, {
            hoverValue: hoverValue,
            selectedValue: selectedValue,
            dateRender: props.dateRender,
            onSelect: props.onSelect,
            onDayHover: props.onDayHover,
            disabledDate: disabledDate,
            showWeekNumber: props.showWeekNumber
          }))
        )
      )
    );
  }
});

exports['default'] = CalendarPart;
module.exports = exports['default'];

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _DateTHead = __webpack_require__(909);

var _DateTHead2 = _interopRequireDefault(_DateTHead);

var _DateTBody = __webpack_require__(910);

var _DateTBody2 = _interopRequireDefault(_DateTBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DateTable = function (_React$Component) {
  (0, _inherits3['default'])(DateTable, _React$Component);

  function DateTable() {
    (0, _classCallCheck3['default'])(this, DateTable);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  DateTable.prototype.render = function render() {
    var props = this.props;
    var prefixCls = props.prefixCls;
    return _react2['default'].createElement(
      'table',
      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
      _react2['default'].createElement(_DateTHead2['default'], props),
      _react2['default'].createElement(_DateTBody2['default'], props)
    );
  };

  return DateTable;
}(_react2['default'].Component);

exports['default'] = DateTable;
module.exports = exports['default'];

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _DateConstants = __webpack_require__(342);

var _DateConstants2 = _interopRequireDefault(_DateConstants);

var _moment = __webpack_require__(31);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DateTHead = function (_React$Component) {
  (0, _inherits3['default'])(DateTHead, _React$Component);

  function DateTHead() {
    (0, _classCallCheck3['default'])(this, DateTHead);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  DateTHead.prototype.render = function render() {
    var props = this.props;
    var value = props.value;
    var localeData = value.localeData();
    var prefixCls = props.prefixCls;
    var veryShortWeekdays = [];
    var weekDays = [];
    var firstDayOfWeek = localeData.firstDayOfWeek();
    var showWeekNumberEl = void 0;
    var now = (0, _moment2['default'])();
    for (var dateColIndex = 0; dateColIndex < _DateConstants2['default'].DATE_COL_COUNT; dateColIndex++) {
      var index = (firstDayOfWeek + dateColIndex) % _DateConstants2['default'].DATE_COL_COUNT;
      now.day(index);
      veryShortWeekdays[dateColIndex] = localeData.weekdaysMin(now);
      weekDays[dateColIndex] = localeData.weekdaysShort(now);
    }

    if (props.showWeekNumber) {
      showWeekNumberEl = _react2['default'].createElement(
        'th',
        {
          role: 'columnheader',
          className: prefixCls + '-column-header ' + prefixCls + '-week-number-header'
        },
        _react2['default'].createElement(
          'span',
          { className: prefixCls + '-column-header-inner' },
          'x'
        )
      );
    }
    var weekDaysEls = weekDays.map(function (day, xindex) {
      return _react2['default'].createElement(
        'th',
        {
          key: xindex,
          role: 'columnheader',
          title: day,
          className: prefixCls + '-column-header'
        },
        _react2['default'].createElement(
          'span',
          { className: prefixCls + '-column-header-inner' },
          veryShortWeekdays[xindex]
        )
      );
    });
    return _react2['default'].createElement(
      'thead',
      null,
      _react2['default'].createElement(
        'tr',
        { role: 'row' },
        showWeekNumberEl,
        weekDaysEls
      )
    );
  };

  return DateTHead;
}(_react2['default'].Component);

exports['default'] = DateTHead;
module.exports = exports['default'];

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(36);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _DateConstants = __webpack_require__(342);

var _DateConstants2 = _interopRequireDefault(_DateConstants);

var _util = __webpack_require__(84);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isSameDay(one, two) {
  return one && two && one.isSame(two, 'day');
}

function beforeCurrentMonthYear(current, today) {
  if (current.year() < today.year()) {
    return 1;
  }
  return current.year() === today.year() && current.month() < today.month();
}

function afterCurrentMonthYear(current, today) {
  if (current.year() > today.year()) {
    return 1;
  }
  return current.year() === today.year() && current.month() > today.month();
}

function getIdFromDate(date) {
  return 'rc-calendar-' + date.year() + '-' + date.month() + '-' + date.date();
}

var DateTBody = (0, _createReactClass2['default'])({
  displayName: 'DateTBody',

  propTypes: {
    contentRender: _propTypes2['default'].func,
    dateRender: _propTypes2['default'].func,
    disabledDate: _propTypes2['default'].func,
    prefixCls: _propTypes2['default'].string,
    selectedValue: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
    value: _propTypes2['default'].object,
    hoverValue: _propTypes2['default'].any,
    showWeekNumber: _propTypes2['default'].bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      hoverValue: []
    };
  },
  render: function render() {
    var props = this.props;
    var contentRender = props.contentRender,
        prefixCls = props.prefixCls,
        selectedValue = props.selectedValue,
        value = props.value,
        showWeekNumber = props.showWeekNumber,
        dateRender = props.dateRender,
        disabledDate = props.disabledDate,
        hoverValue = props.hoverValue;

    var iIndex = void 0;
    var jIndex = void 0;
    var current = void 0;
    var dateTable = [];
    var today = (0, _util.getTodayTime)(value);
    var cellClass = prefixCls + '-cell';
    var weekNumberCellClass = prefixCls + '-week-number-cell';
    var dateClass = prefixCls + '-date';
    var todayClass = prefixCls + '-today';
    var selectedClass = prefixCls + '-selected-day';
    var selectedDateClass = prefixCls + '-selected-date'; // do not move with mouse operation
    var selectedStartDateClass = prefixCls + '-selected-start-date';
    var selectedEndDateClass = prefixCls + '-selected-end-date';
    var inRangeClass = prefixCls + '-in-range-cell';
    var lastMonthDayClass = prefixCls + '-last-month-cell';
    var nextMonthDayClass = prefixCls + '-next-month-btn-day';
    var disabledClass = prefixCls + '-disabled-cell';
    var firstDisableClass = prefixCls + '-disabled-cell-first-of-row';
    var lastDisableClass = prefixCls + '-disabled-cell-last-of-row';
    var lastDayOfMonthClass = prefixCls + '-last-day-of-month';
    var month1 = value.clone();
    month1.date(1);
    var day = month1.day();
    var lastMonthDiffDay = (day + 7 - value.localeData().firstDayOfWeek()) % 7;
    // calculate last month
    var lastMonth1 = month1.clone();
    lastMonth1.add(0 - lastMonthDiffDay, 'days');
    var passed = 0;

    for (iIndex = 0; iIndex < _DateConstants2['default'].DATE_ROW_COUNT; iIndex++) {
      for (jIndex = 0; jIndex < _DateConstants2['default'].DATE_COL_COUNT; jIndex++) {
        current = lastMonth1;
        if (passed) {
          current = current.clone();
          current.add(passed, 'days');
        }
        dateTable.push(current);
        passed++;
      }
    }
    var tableHtml = [];
    passed = 0;

    for (iIndex = 0; iIndex < _DateConstants2['default'].DATE_ROW_COUNT; iIndex++) {
      var _cx;

      var isCurrentWeek = void 0;
      var weekNumberCell = void 0;
      var isActiveWeek = false;
      var dateCells = [];
      if (showWeekNumber) {
        weekNumberCell = _react2['default'].createElement(
          'td',
          {
            key: dateTable[passed].week(),
            role: 'gridcell',
            className: weekNumberCellClass
          },
          dateTable[passed].week()
        );
      }
      for (jIndex = 0; jIndex < _DateConstants2['default'].DATE_COL_COUNT; jIndex++) {
        var next = null;
        var last = null;
        current = dateTable[passed];
        if (jIndex < _DateConstants2['default'].DATE_COL_COUNT - 1) {
          next = dateTable[passed + 1];
        }
        if (jIndex > 0) {
          last = dateTable[passed - 1];
        }
        var cls = cellClass;
        var disabled = false;
        var selected = false;

        if (isSameDay(current, today)) {
          cls += ' ' + todayClass;
          isCurrentWeek = true;
        }

        var isBeforeCurrentMonthYear = beforeCurrentMonthYear(current, value);
        var isAfterCurrentMonthYear = afterCurrentMonthYear(current, value);

        if (selectedValue && Array.isArray(selectedValue)) {
          var rangeValue = hoverValue.length ? hoverValue : selectedValue;
          if (!isBeforeCurrentMonthYear && !isAfterCurrentMonthYear) {
            var startValue = rangeValue[0];
            var endValue = rangeValue[1];
            if (startValue) {
              if (isSameDay(current, startValue)) {
                selected = true;
                isActiveWeek = true;
                cls += ' ' + selectedStartDateClass;
              }
            }
            if (startValue && endValue) {
              if (isSameDay(current, endValue)) {
                selected = true;
                isActiveWeek = true;
                cls += ' ' + selectedEndDateClass;
              } else if (current.isAfter(startValue, 'day') && current.isBefore(endValue, 'day')) {
                cls += ' ' + inRangeClass;
              }
            }
          }
        } else if (isSameDay(current, value)) {
          // keyboard change value, highlight works
          selected = true;
          isActiveWeek = true;
        }

        if (isSameDay(current, selectedValue)) {
          cls += ' ' + selectedDateClass;
        }

        if (isBeforeCurrentMonthYear) {
          cls += ' ' + lastMonthDayClass;
        }

        if (isAfterCurrentMonthYear) {
          cls += ' ' + nextMonthDayClass;
        }

        if (current.clone().endOf('month').date() === current.date()) {
          cls += ' ' + lastDayOfMonthClass;
        }

        if (disabledDate) {
          if (disabledDate(current, value)) {
            disabled = true;

            if (!last || !disabledDate(last, value)) {
              cls += ' ' + firstDisableClass;
            }

            if (!next || !disabledDate(next, value)) {
              cls += ' ' + lastDisableClass;
            }
          }
        }

        if (selected) {
          cls += ' ' + selectedClass;
        }

        if (disabled) {
          cls += ' ' + disabledClass;
        }

        var dateHtml = void 0;
        if (dateRender) {
          dateHtml = dateRender(current, value);
        } else {
          var content = contentRender ? contentRender(current, value) : current.date();
          dateHtml = _react2['default'].createElement(
            'div',
            {
              key: getIdFromDate(current),
              className: dateClass,
              'aria-selected': selected,
              'aria-disabled': disabled
            },
            content
          );
        }

        dateCells.push(_react2['default'].createElement(
          'td',
          {
            key: passed,
            onClick: disabled ? undefined : props.onSelect.bind(null, current),
            onMouseEnter: disabled ? undefined : props.onDayHover && props.onDayHover.bind(null, current) || undefined,
            role: 'gridcell',
            title: (0, _util.getTitleString)(current),
            className: cls
          },
          dateHtml
        ));

        passed++;
      }

      tableHtml.push(_react2['default'].createElement(
        'tr',
        {
          key: iIndex,
          role: 'row',
          className: (0, _classnames2['default'])((_cx = {}, _cx[prefixCls + '-current-week'] = isCurrentWeek, _cx[prefixCls + '-active-week'] = isActiveWeek, _cx))
        },
        weekNumberCell,
        dateCells
      ));
    }
    return _react2['default'].createElement(
      'tbody',
      { className: prefixCls + '-tbody' },
      tableHtml
    );
  }
});

exports['default'] = DateTBody;
module.exports = exports['default'];

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _createReactClass = __webpack_require__(36);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(31);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DateInput = (0, _createReactClass2['default'])({
  displayName: 'DateInput',

  propTypes: {
    prefixCls: _propTypes2['default'].string,
    timePicker: _propTypes2['default'].object,
    value: _propTypes2['default'].object,
    disabledTime: _propTypes2['default'].any,
    format: _propTypes2['default'].string,
    locale: _propTypes2['default'].object,
    disabledDate: _propTypes2['default'].func,
    onChange: _propTypes2['default'].func,
    onClear: _propTypes2['default'].func,
    placeholder: _propTypes2['default'].string,
    onSelect: _propTypes2['default'].func,
    selectedValue: _propTypes2['default'].object
  },

  getInitialState: function getInitialState() {
    var selectedValue = this.props.selectedValue;
    return {
      str: selectedValue && selectedValue.format(this.props.format) || '',
      invalid: false
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.cachedSelectionStart = this.dateInputInstance.selectionStart;
    this.cachedSelectionEnd = this.dateInputInstance.selectionEnd;
    // when popup show, click body will call this, bug!
    var selectedValue = nextProps.selectedValue;
    this.setState({
      str: selectedValue && selectedValue.format(nextProps.format) || '',
      invalid: false
    });
  },
  componentDidUpdate: function componentDidUpdate() {
    if (!this.state.invalid) {
      this.dateInputInstance.setSelectionRange(this.cachedSelectionStart, this.cachedSelectionEnd);
    }
  },
  onInputChange: function onInputChange(event) {
    var str = event.target.value;
    this.setState({
      str: str
    });
    var value = void 0;
    var _props = this.props,
        disabledDate = _props.disabledDate,
        format = _props.format,
        onChange = _props.onChange;

    if (str) {
      var parsed = (0, _moment2['default'])(str, format, true);
      if (!parsed.isValid()) {
        this.setState({
          invalid: true
        });
        return;
      }
      value = this.props.value.clone();
      value.year(parsed.year()).month(parsed.month()).date(parsed.date()).hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());

      if (value && (!disabledDate || !disabledDate(value))) {
        var originalValue = this.props.selectedValue;
        if (originalValue && value) {
          if (!originalValue.isSame(value)) {
            onChange(value);
          }
        } else if (originalValue !== value) {
          onChange(value);
        }
      } else {
        this.setState({
          invalid: true
        });
        return;
      }
    } else {
      onChange(null);
    }
    this.setState({
      invalid: false
    });
  },
  onClear: function onClear() {
    this.setState({
      str: ''
    });
    this.props.onClear(null);
  },
  getRootDOMNode: function getRootDOMNode() {
    return _reactDom2['default'].findDOMNode(this);
  },
  focus: function focus() {
    if (this.dateInputInstance) {
      this.dateInputInstance.focus();
    }
  },
  saveDateInput: function saveDateInput(dateInput) {
    this.dateInputInstance = dateInput;
  },
  render: function render() {
    var props = this.props;
    var _state = this.state,
        invalid = _state.invalid,
        str = _state.str;
    var locale = props.locale,
        prefixCls = props.prefixCls,
        placeholder = props.placeholder;

    var invalidClass = invalid ? prefixCls + '-input-invalid' : '';
    return _react2['default'].createElement(
      'div',
      { className: prefixCls + '-input-wrap' },
      _react2['default'].createElement(
        'div',
        { className: prefixCls + '-date-input-wrap' },
        _react2['default'].createElement('input', {
          ref: this.saveDateInput,
          className: prefixCls + '-input ' + invalidClass,
          value: str,
          disabled: props.disabled,
          placeholder: placeholder,
          onChange: this.onInputChange
        })
      ),
      props.showClear ? _react2['default'].createElement('a', {
        className: prefixCls + '-clear-btn',
        role: 'button',
        title: locale.clear,
        onClick: this.onClear
      }) : null
    );
  }
});

exports['default'] = DateInput;
module.exports = exports['default'];

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.goStartMonth = goStartMonth;
exports.goEndMonth = goEndMonth;
exports.goTime = goTime;
exports.includesTime = includesTime;
function goStartMonth(time) {
  return time.clone().startOf('month');
}

function goEndMonth(time) {
  return time.clone().endOf('month');
}

function goTime(time, direction, unit) {
  return time.clone().add(direction, unit);
}

function includesTime() {
  var timeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var time = arguments[1];
  var unit = arguments[2];

  return timeList.some(function (t) {
    return t.isSame(time, unit);
  });
}

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(15);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _rcAnimate = __webpack_require__(50);

var _rcAnimate2 = _interopRequireDefault(_rcAnimate);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = __webpack_require__(47);

var _omit2 = _interopRequireDefault(_omit);

var _reactLifecyclesCompat = __webpack_require__(54);

var _icon = __webpack_require__(6);

var _icon2 = _interopRequireDefault(_icon);

var _CheckableTag = __webpack_require__(914);

var _CheckableTag2 = _interopRequireDefault(_CheckableTag);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Tag = function (_React$Component) {
    (0, _inherits3['default'])(Tag, _React$Component);

    function Tag() {
        (0, _classCallCheck3['default'])(this, Tag);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Tag.__proto__ || Object.getPrototypeOf(Tag)).apply(this, arguments));

        _this.state = {
            closing: false,
            closed: false,
            visible: true
        };
        _this.handleIconClick = function (e) {
            var onClose = _this.props.onClose;
            if (onClose) {
                onClose(e);
            }
            if (e.defaultPrevented || 'visible' in _this.props) {
                return;
            }
            _this.setState({ visible: false });
        };
        _this.close = function () {
            if (_this.state.closing || _this.state.closed) {
                return;
            }
            var dom = ReactDOM.findDOMNode(_this);
            dom.style.width = dom.getBoundingClientRect().width + 'px';
            // It's Magic Code, don't know why
            dom.style.width = dom.getBoundingClientRect().width + 'px';
            _this.setState({
                closing: true
            });
        };
        _this.show = function () {
            _this.setState({
                closed: false
            });
        };
        _this.animationEnd = function (_, existed) {
            if (!existed && !_this.state.closed) {
                _this.setState({
                    closed: true,
                    closing: false
                });
                var afterClose = _this.props.afterClose;
                if (afterClose) {
                    afterClose();
                }
            } else {
                _this.setState({
                    closed: false
                });
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(Tag, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(_prevProps, prevState) {
            if (prevState.visible && !this.state.visible) {
                this.close();
            } else if (!prevState.visible && this.state.visible) {
                this.show();
            }
        }
    }, {
        key: 'isPresetColor',
        value: function isPresetColor(color) {
            if (!color) {
                return false;
            }
            return (/^(pink|red|yellow|orange|cyan|green|blue|purple|geekblue|magenta|volcano|gold|lime)(-inverse)?$/.test(color)
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                closable = _a.closable,
                color = _a.color,
                className = _a.className,
                children = _a.children,
                style = _a.style,
                otherProps = __rest(_a, ["prefixCls", "closable", "color", "className", "children", "style"]);
            var closeIcon = closable ? React.createElement(_icon2['default'], { type: 'cross', onClick: this.handleIconClick }) : '';
            var isPresetColor = this.isPresetColor(color);
            var classString = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + color, isPresetColor), (0, _defineProperty3['default'])(_classNames, prefixCls + '-has-color', color && !isPresetColor), (0, _defineProperty3['default'])(_classNames, prefixCls + '-close', this.state.closing), _classNames), className);
            // fix https://fb.me/react-unknown-prop
            var divProps = (0, _omit2['default'])(otherProps, ['onClose', 'afterClose', 'visible']);
            var tagStyle = (0, _extends3['default'])({ backgroundColor: color && !isPresetColor ? color : null }, style);
            var tag = this.state.closed ? null : React.createElement(
                'div',
                (0, _extends3['default'])({ 'data-show': !this.state.closing }, divProps, { className: classString, style: tagStyle }),
                children,
                closeIcon
            );
            return React.createElement(
                _rcAnimate2['default'],
                { component: '', showProp: 'data-show', transitionName: prefixCls + '-zoom', transitionAppear: true, onEnd: this.animationEnd },
                tag
            );
        }
    }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps) {
            return 'visible' in nextProps ? { visible: nextProps.visible } : null;
        }
    }]);
    return Tag;
}(React.Component);

Tag.CheckableTag = _CheckableTag2['default'];
Tag.defaultProps = {
    prefixCls: 'ant-tag',
    closable: false
};
(0, _reactLifecyclesCompat.polyfill)(Tag);
exports['default'] = Tag;
module.exports = exports['default'];

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var CheckableTag = function (_React$Component) {
    (0, _inherits3['default'])(CheckableTag, _React$Component);

    function CheckableTag() {
        (0, _classCallCheck3['default'])(this, CheckableTag);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (CheckableTag.__proto__ || Object.getPrototypeOf(CheckableTag)).apply(this, arguments));

        _this.handleClick = function () {
            var _this$props = _this.props,
                checked = _this$props.checked,
                onChange = _this$props.onChange;

            if (onChange) {
                onChange(!checked);
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(CheckableTag, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                _a$prefixCls = _a.prefixCls,
                prefixCls = _a$prefixCls === undefined ? 'ant-tag' : _a$prefixCls,
                className = _a.className,
                checked = _a.checked,
                restProps = __rest(_a, ["prefixCls", "className", "checked"]);
            var cls = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-checkable', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-checkable-checked', checked), _classNames), className);
            delete restProps.onChange; // TypeScript cannot check delete now.
            return React.createElement('div', (0, _extends3['default'])({}, restProps, { className: cls, onClick: this.handleClick }));
        }
    }]);
    return CheckableTag;
}(React.Component);

exports['default'] = CheckableTag;
module.exports = exports['default'];

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _moment = __webpack_require__(31);

var moment = _interopRequireWildcard(_moment);

var _reactLifecyclesCompat = __webpack_require__(54);

var _rcCalendar = __webpack_require__(331);

var _rcCalendar2 = _interopRequireDefault(_rcCalendar);

var _Picker = __webpack_require__(196);

var _Picker2 = _interopRequireDefault(_Picker);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = __webpack_require__(6);

var _icon2 = _interopRequireDefault(_icon);

var _interopDefault = __webpack_require__(89);

var _interopDefault2 = _interopRequireDefault(_interopDefault);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function formatValue(value, format) {
    return value && value.format(format) || '';
}

var WeekPicker = function (_React$Component) {
    (0, _inherits3['default'])(WeekPicker, _React$Component);

    function WeekPicker(props) {
        (0, _classCallCheck3['default'])(this, WeekPicker);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (WeekPicker.__proto__ || Object.getPrototypeOf(WeekPicker)).call(this, props));

        _this.weekDateRender = function (current) {
            var selectedValue = _this.state.value;
            var prefixCls = _this.props.prefixCls;

            if (selectedValue && current.year() === selectedValue.year() && current.week() === selectedValue.week()) {
                return React.createElement(
                    'div',
                    { className: prefixCls + '-selected-day' },
                    React.createElement(
                        'div',
                        { className: prefixCls + '-date' },
                        current.date()
                    )
                );
            }
            return React.createElement(
                'div',
                { className: prefixCls + '-date' },
                current.date()
            );
        };
        _this.handleChange = function (value) {
            if (!('value' in _this.props)) {
                _this.setState({ value: value });
            }
            _this.props.onChange(value, formatValue(value, _this.props.format));
        };
        _this.clearSelection = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.handleChange(null);
        };
        _this.saveInput = function (node) {
            _this.input = node;
        };
        var value = props.value || props.defaultValue;
        if (value && !(0, _interopDefault2['default'])(moment).isMoment(value)) {
            throw new Error('The value/defaultValue of DatePicker or MonthPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
        }
        _this.state = {
            value: value
        };
        return _this;
    }

    (0, _createClass3['default'])(WeekPicker, [{
        key: 'focus',
        value: function focus() {
            this.input.focus();
        }
    }, {
        key: 'blur',
        value: function blur() {
            this.input.blur();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                disabled = _props.disabled,
                pickerClass = _props.pickerClass,
                popupStyle = _props.popupStyle,
                pickerInputClass = _props.pickerInputClass,
                format = _props.format,
                allowClear = _props.allowClear,
                locale = _props.locale,
                localeCode = _props.localeCode,
                disabledDate = _props.disabledDate,
                style = _props.style,
                onFocus = _props.onFocus,
                onBlur = _props.onBlur;

            var pickerValue = this.state.value;
            if (pickerValue && localeCode) {
                pickerValue.locale(localeCode);
            }
            var placeholder = 'placeholder' in this.props ? this.props.placeholder : locale.lang.placeholder;
            var calendar = React.createElement(_rcCalendar2['default'], { showWeekNumber: true, dateRender: this.weekDateRender, prefixCls: prefixCls, format: format, locale: locale.lang, showDateInput: false, showToday: false, disabledDate: disabledDate });
            var clearIcon = !disabled && allowClear && this.state.value ? React.createElement(_icon2['default'], { type: 'cross-circle', className: prefixCls + '-picker-clear', onClick: this.clearSelection }) : null;
            var input = function input(_ref) {
                var value = _ref.value;

                return React.createElement(
                    'span',
                    null,
                    React.createElement('input', { ref: _this2.saveInput, disabled: disabled, readOnly: true, value: value && value.format(format) || '', placeholder: placeholder, className: pickerInputClass, onFocus: onFocus, onBlur: onBlur, style: style }),
                    clearIcon,
                    React.createElement('span', { className: prefixCls + '-picker-icon' })
                );
            };
            return React.createElement(
                'span',
                { className: (0, _classnames2['default'])(className, pickerClass), id: this.props.id },
                React.createElement(
                    _Picker2['default'],
                    (0, _extends3['default'])({}, this.props, { calendar: calendar, prefixCls: prefixCls + '-picker-container', value: pickerValue, onChange: this.handleChange, style: popupStyle }),
                    input
                )
            );
        }
    }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps) {
            if ('value' in nextProps) {
                return { value: nextProps.value };
            }
            return null;
        }
    }]);
    return WeekPicker;
}(React.Component);

WeekPicker.defaultProps = {
    format: 'gggg-wo',
    allowClear: true
};
(0, _reactLifecyclesCompat.polyfill)(WeekPicker);
exports['default'] = WeekPicker;
module.exports = exports['default'];

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_dropdown_style__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_dropdown_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_dropdown_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_less__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__index_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActionMenu=function(_React$Component){_inherits(ActionMenu,_React$Component);function ActionMenu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ActionMenu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ActionMenu.__proto__||Object.getPrototypeOf(ActionMenu)).call.apply(_ref,[this].concat(args))),_this),_this.onClick=function(event){event.preventDefault();event.stopPropagation();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ActionMenu,[{key:'render',value:function render(){var _props=this.props,overlay=_props.overlay,ignoreOnClick=_props.ignoreOnClick,iconType=_props.iconType;if(ignoreOnClick===true){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown___default.a,{overlay:overlay,onClick:this.onClick},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{type:iconType})));}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_dropdown___default.a,{overlay:overlay},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon___default.a,{type:iconType})));}}]);return ActionMenu;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ActionMenu);

/***/ }),
/* 917 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataFlowItem; });
/* unused harmony export DeleteJobComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_menu_style__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_menu_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_menu_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_menu__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DataFlowItem=function(_React$Component){_inherits(DataFlowItem,_React$Component);function DataFlowItem(){_classCallCheck(this,DataFlowItem);return _possibleConstructorReturn(this,(DataFlowItem.__proto__||Object.getPrototypeOf(DataFlowItem)).apply(this,arguments));}_createClass(DataFlowItem,[{key:'render',value:function render(){var _props=this.props,data=_props.data,actions=_props.actions;if(data.flow&&actions[data.flow.type]&&data.flow_step_queue&&data.flow_step_queue.step.note==='S_QUALITY_CONTROL'){return actions[data.flow.type].map(function(elm){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{key:elm.title},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:elm.icon,style:{width:'81px',cursor:'pointer',marginTop:'-13px',marginLeft:"-16px"},title:elm.title,onClick:function onClick(e){e.preventDefault();e.stopPropagation();window.location=''+elm.link(data.uuid);}}));});}return null;}}]);return DataFlowItem;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);var DeleteJobComponent=function(_React$Component2){_inherits(DeleteJobComponent,_React$Component2);function DeleteJobComponent(){var _ref;var _temp,_this2,_ret;_classCallCheck(this,DeleteJobComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this2=_possibleConstructorReturn(this,(_ref=DeleteJobComponent.__proto__||Object.getPrototypeOf(DeleteJobComponent)).call.apply(_ref,[this].concat(args))),_this2),_this2.handleJobDelete=function(event){event.preventDefault();event.stopPropagation();_this2.props.onJobDelete(_this2.props.data.uuid);},_temp),_possibleConstructorReturn(_this2,_ret);}_createClass(DeleteJobComponent,[{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'delete',style:{fontSize:"20px",marginRight:"0px",marginTop:"0px"},title:'Delete',align:'center',alt:'Delete',onClick:function onClick(event){_this3.handleJobDelete(event);}});}}]);return DeleteJobComponent;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);var JobsMenu=function(_React$Component3){_inherits(JobsMenu,_React$Component3);function JobsMenu(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,JobsMenu);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=JobsMenu.__proto__||Object.getPrototypeOf(JobsMenu)).call.apply(_ref2,[this].concat(args))),_this4),_this4.handleJobDelete=function(event){event.domEvent.stopPropagation();event.domEvent.preventDefault();_this4.props.onJobDelete(_this4.props.data.uuid);},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(JobsMenu,[{key:'render',value:function render(){var _this5=this;var menuList=[];var width=null;var _props2=this.props,data=_props2.data,actions=_props2.actions;var shouldRenderMenuItem=data.flow&&actions[data.flow.type]&&data.flow_step_queue&&data.flow_step_queue.step.note==='S_QUALITY_CONTROL';if(shouldRenderMenuItem){width="84px";menuList=[__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_menu___default.a.Item,{key:'1',style:{height:"42px"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(DataFlowItem,{data:data,actions:actions})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_menu___default.a.Item,{key:'2',align:'center',title:'Delete',style:{height:"38px"},onClick:function onClick(event){_this5.handleJobDelete(event);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'delete',style:{fontSize:"20px",marginRight:"0px",marginTop:"2px"},title:'Delete',align:'center',alt:'Delete'}))];}else{menuList=[__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_menu___default.a.Item,{key:'2',align:'center',title:'Delete',onClick:function onClick(event){_this5.handleJobDelete(event);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_icon___default.a,{type:'delete',style:{fontSize:"20px",marginRight:"0px",marginTop:"10px"},title:'Delete',align:'center',alt:'Delete'}))];}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_menu___default.a,{style:{borderWidth:"1px",borderRightColor:"black",borderStyle:"solid",overflow:"hidden",width:width}},menuList);}}]);return JobsMenu;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["b"] = (JobsMenu);

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Alerts__ = __webpack_require__(920);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var JOB_STATUS_DRAFT=0;var JOB_STATUS_LINK_FOR_UPLOAD=1;var JOB_STATUS_RUN=20;var JOB_STATUS_FAILED=-20;var JOB_STATUS_SUCCESS=40;var JobStatusComponent=function(_React$Component){_inherits(JobStatusComponent,_React$Component);function JobStatusComponent(){_classCallCheck(this,JobStatusComponent);return _possibleConstructorReturn(this,(JobStatusComponent.__proto__||Object.getPrototypeOf(JobStatusComponent)).apply(this,arguments));}_createClass(JobStatusComponent,[{key:'render',value:function render(){var _props=this.props,data=_props.data,isManualStep=_props.isManualStep;var element=null;if(data.status==JOB_STATUS_FAILED){element=__WEBPACK_IMPORTED_MODULE_1__components_Alerts__["a" /* jobFailedIcon */];}else if(data.status==JOB_STATUS_SUCCESS){element=__WEBPACK_IMPORTED_MODULE_1__components_Alerts__["e" /* jobSuccessIcon */];}else if(data.status==JOB_STATUS_RUN){if(isManualStep){element=__WEBPACK_IMPORTED_MODULE_1__components_Alerts__["d" /* jobRunManualIcon */];}else{element=__WEBPACK_IMPORTED_MODULE_1__components_Alerts__["c" /* jobRunAutoSpin */];}}else if(data.status==JOB_STATUS_DRAFT||data.status==JOB_STATUS_LINK_FOR_UPLOAD){element=__WEBPACK_IMPORTED_MODULE_1__components_Alerts__["b" /* jobPendingIcon */];}return element;}}]);return JobStatusComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (JobStatusComponent);

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return jobFailedIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return jobSuccessIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return jobRunManualIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return jobRunAutoSpin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return jobPendingIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_less__);
var jobFailedIcon=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'close-circle',className:'ant-icon-failed'});var jobSuccessIcon=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'check-circle',className:'ant-icon-success'});var jobRunManualIcon=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'exclamation-circle',className:'ant-icon-run-manual'});var jobRunAutoSpin=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default.a,{size:'small',spinning:true,type:'loading'});var jobPendingIcon=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:'exclamation-circle',className:'ant-icon-pending'});

/***/ }),
/* 921 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3d-plan_Roots_add.5d722ac0.svg";

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_card_style__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_card__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_upload_style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_svgicons_DeepCBCT_analysis_svg__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_svgicons_DeepCBCT_analysis_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_svgicons_DeepCBCT_analysis_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_svgicons_DeepCBCT_analysis_auto_svg__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_svgicons_DeepCBCT_analysis_auto_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_svgicons_DeepCBCT_analysis_auto_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_svgicons_3d_plan_general_OrthoStudio_V4_svg__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_svgicons_3d_plan_general_OrthoStudio_V4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_svgicons_3d_plan_general_OrthoStudio_V4_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_svgicons_3d_plan_roots_svg__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_svgicons_3d_plan_roots_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_svgicons_3d_plan_roots_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_svgicons_3d_plan_DeepCBCT_svg__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_svgicons_3d_plan_DeepCBCT_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_svgicons_3d_plan_DeepCBCT_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_svgicons_3d_plan_general_svg__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_svgicons_3d_plan_general_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_svgicons_3d_plan_general_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_svgicons_3d_plan_general_3Shape_svg__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_svgicons_3d_plan_general_3Shape_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_svgicons_3d_plan_general_3Shape_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_svgicons_3d_plan_general_3Shape_Color_svg__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_svgicons_3d_plan_general_3Shape_Color_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_svgicons_3d_plan_general_3Shape_Color_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_svgicons_3d_plan_general_Archform_svg__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_svgicons_3d_plan_general_Archform_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_svgicons_3d_plan_general_Archform_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_svgicons_3d_plan_general_OnyxCeph3D_svg__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_svgicons_3d_plan_general_OnyxCeph3D_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_svgicons_3d_plan_general_OnyxCeph3D_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_svgicons_3d_plan_general_SureSmile_svg__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_svgicons_3d_plan_general_SureSmile_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_svgicons_3d_plan_general_SureSmile_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_svgicons_3d_plan_general_OrthoStudio_V5_svg__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_svgicons_3d_plan_general_OrthoStudio_V5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_svgicons_3d_plan_general_OrthoStudio_V5_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_svgicons_Teeth_alignment_modelling_svg__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_svgicons_Teeth_alignment_modelling_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_svgicons_Teeth_alignment_modelling_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_svgicons_3d_plan_general_Nemo_svg__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_svgicons_3d_plan_general_Nemo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_svgicons_3d_plan_general_Nemo_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var svgDict={ct:__WEBPACK_IMPORTED_MODULE_12__assets_svgicons_DeepCBCT_analysis_svg___default.a,ct_align:__WEBPACK_IMPORTED_MODULE_12__assets_svgicons_DeepCBCT_analysis_svg___default.a,ct_v2:__WEBPACK_IMPORTED_MODULE_12__assets_svgicons_DeepCBCT_analysis_svg___default.a,ct_v2_auto:__WEBPACK_IMPORTED_MODULE_13__assets_svgicons_DeepCBCT_analysis_auto_svg___default.a,plan_standart:__WEBPACK_IMPORTED_MODULE_14__assets_svgicons_3d_plan_general_OrthoStudio_V4_svg___default.a,plan_standard_orthostudio:__WEBPACK_IMPORTED_MODULE_17__assets_svgicons_3d_plan_general_svg___default.a,plan_standard_3shape_1c:__WEBPACK_IMPORTED_MODULE_18__assets_svgicons_3d_plan_general_3Shape_svg___default.a,plan_standard_3shape_color:__WEBPACK_IMPORTED_MODULE_19__assets_svgicons_3d_plan_general_3Shape_Color_svg___default.a,plan_standard_archform_1c:__WEBPACK_IMPORTED_MODULE_20__assets_svgicons_3d_plan_general_Archform_svg___default.a,plan_roots:__WEBPACK_IMPORTED_MODULE_15__assets_svgicons_3d_plan_roots_svg___default.a,plan_deep_ct:__WEBPACK_IMPORTED_MODULE_16__assets_svgicons_3d_plan_DeepCBCT_svg___default.a,plan_standard_onyxceph:__WEBPACK_IMPORTED_MODULE_21__assets_svgicons_3d_plan_general_OnyxCeph3D_svg___default.a,plan_standard_orthostudio_v5:__WEBPACK_IMPORTED_MODULE_23__assets_svgicons_3d_plan_general_OrthoStudio_V5_svg___default.a,plan_standard_suresmile_sou:__WEBPACK_IMPORTED_MODULE_22__assets_svgicons_3d_plan_general_SureSmile_svg___default.a,teeth_alignment_modelling:__WEBPACK_IMPORTED_MODULE_24__assets_svgicons_Teeth_alignment_modelling_svg___default.a,plan_standard_nemo:__WEBPACK_IMPORTED_MODULE_25__assets_svgicons_3d_plan_general_Nemo_svg___default.a};var Dragger=__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload___default.a.Dragger;var typeDict={ct:'DeepCBCT',ct_align:'DeepCBCT (Smartee)',ct_v2:'DeepCBCT v2',ct_v2_auto:'DeepCBCT v2 Auto',plan_standart:'3D-Plan Standard',plan_roots:'3D-Plan Roots',plan_deep_ct:'3D-Plan DeepCT',plan_standard_orthostudio:'3D-Plan Orthostudio',plan_standard_3shape_1c:'3D-Plan 3Shape',plan_standard_3shape_color:'3D-Plan 3Shape Color',plan_standard_archform_1c:'3D-Plan Archform',plan_standard_onyxceph:'3D-Plan OnyxCeph',plan_standard_orthostudio_v5:'3D-Plan Orthostudio v5',plan_standard_suresmile_sou:'3D-Plan SureSmile SOU',plan_standard_nemo:'3D-Plan Nemo',teeth_alignment_modelling:'Teeth alignment modelling'};var CaseNew=function(_Component){_inherits(CaseNew,_Component);function CaseNew(props){_classCallCheck(this,CaseNew);var _this=_possibleConstructorReturn(this,(CaseNew.__proto__||Object.getPrototypeOf(CaseNew)).call(this,props));_this.state={};return _this;}_createClass(CaseNew,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_PanelBox__["a" /* default */],{title:"New case"},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'spaceAround'},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:24},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},this.props.user.flow.map(function(elm){return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */],{key:elm.type,id:elm.type.replace(/\_/g,'-'),to:'case/upload/'+elm.type.replace(/\_/g,'-'),className:'ant-upload-text',style:{margin:10,color:'#4a4a4a'}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_card___default.a,{noHovering:false,style:{borderRadius:200}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('img',{src:svgDict[elm.type],style:{width:'100px'}})),typeDict[elm.type]);}))),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_col___default.a,{span:24})));}}]);return CaseNew;}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["connect"])(function(_ref){var user=_ref.user;return{user:user};})(CaseNew));

/***/ }),
/* 924 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Upload__ = __webpack_require__(927);
// export this package's api


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Upload__["a" /* default */]);

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AjaxUploader__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IframeUploader__ = __webpack_require__(932);










function empty() {}

var Upload = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Upload, _Component);

  function Upload() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Upload);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Upload.__proto__ || Object.getPrototypeOf(Upload)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      Component: null
    }, _this.saveUploader = function (node) {
      _this.uploader = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Upload, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.supportServerRender) {
        /* eslint react/no-did-mount-set-state:0 */
        this.setState({
          Component: this.getComponent()
        }, this.props.onReady);
      }
    }
  }, {
    key: 'getComponent',
    value: function getComponent() {
      return typeof File !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_7__AjaxUploader__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_8__IframeUploader__["a" /* default */];
    }
  }, {
    key: 'abort',
    value: function abort(file) {
      this.uploader.abort(file);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.supportServerRender) {
        var _ComponentUploader = this.state.Component;
        if (_ComponentUploader) {
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(_ComponentUploader, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, { ref: this.saveUploader }));
        }
        return null;
      }
      var ComponentUploader = this.getComponent();
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ComponentUploader, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, { ref: this.saveUploader }));
    }
  }]);

  return Upload;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Upload.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  action: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  name: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  multipart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  directory: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onError: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSuccess: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onProgress: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onStart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  data: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  headers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  accept: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  beforeUpload: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  customRequest: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onReady: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  withCredentials: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  supportServerRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
Upload.defaultProps = {
  component: 'span',
  prefixCls: 'rc-upload',
  data: {},
  headers: {},
  name: 'file',
  multipart: false,
  onReady: empty,
  onStart: empty,
  onError: empty,
  onSuccess: empty,
  supportServerRender: false,
  multiple: false,
  beforeUpload: null,
  customRequest: null,
  withCredentials: false
};


/* harmony default export */ __webpack_exports__["a"] = (Upload);

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__request__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__uid__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__attr_accept__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__traverseFileTree__ = __webpack_require__(931);






/* eslint react/no-is-mounted:0 react/sort-comp:0 */









var AjaxUploader = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AjaxUploader, _Component);

  function AjaxUploader() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AjaxUploader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AjaxUploader.__proto__ || Object.getPrototypeOf(AjaxUploader)).call.apply(_ref, [this].concat(args))), _this), _this.state = { uid: Object(__WEBPACK_IMPORTED_MODULE_10__uid__["a" /* default */])() }, _this.reqs = {}, _this.onChange = function (e) {
      var files = e.target.files;
      _this.uploadFiles(files);
      _this.reset();
    }, _this.onClick = function () {
      var el = _this.fileInput;
      if (!el) {
        return;
      }
      el.click();
    }, _this.onKeyDown = function (e) {
      if (e.key === 'Enter') {
        _this.onClick();
      }
    }, _this.onFileDrop = function (e) {
      e.preventDefault();

      if (e.type === 'dragover') {
        return;
      }

      if (_this.props.directory) {
        Object(__WEBPACK_IMPORTED_MODULE_12__traverseFileTree__["a" /* default */])(e.dataTransfer.items, _this.uploadFiles, function (_file) {
          return Object(__WEBPACK_IMPORTED_MODULE_11__attr_accept__["a" /* default */])(_file, _this.props.accept);
        });
      } else {
        var files = Array.prototype.slice.call(e.dataTransfer.files).filter(function (file) {
          return Object(__WEBPACK_IMPORTED_MODULE_11__attr_accept__["a" /* default */])(file, _this.props.accept);
        });
        _this.uploadFiles(files);
      }
    }, _this.uploadFiles = function (files) {
      var postFiles = Array.prototype.slice.call(files);
      postFiles.forEach(function (file) {
        file.uid = Object(__WEBPACK_IMPORTED_MODULE_10__uid__["a" /* default */])();
        _this.upload(file, postFiles);
      });
    }, _this.saveFileInput = function (node) {
      _this.fileInput = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AjaxUploader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
      this.abort();
    }
  }, {
    key: 'upload',
    value: function upload(file, fileList) {
      var _this2 = this;

      var props = this.props;

      if (!props.beforeUpload) {
        // always async in case use react state to keep fileList
        return setTimeout(function () {
          return _this2.post(file);
        }, 0);
      }

      var before = props.beforeUpload(file, fileList);
      if (before && before.then) {
        before.then(function (processedFile) {
          var processedFileType = Object.prototype.toString.call(processedFile);
          if (processedFileType === '[object File]' || processedFileType === '[object Blob]') {
            return _this2.post(processedFile);
          }
          return _this2.post(file);
        })['catch'](function (e) {
          console && console.log(e); // eslint-disable-line
        });
      } else if (before !== false) {
        setTimeout(function () {
          return _this2.post(file);
        }, 0);
      }
    }
  }, {
    key: 'post',
    value: function post(file) {
      var _this3 = this;

      if (!this._isMounted) {
        return;
      }
      var props = this.props;
      var data = props.data;
      var onStart = props.onStart,
          onProgress = props.onProgress;

      if (typeof data === 'function') {
        data = data(file);
      }
      new Promise(function (resolve) {
        var action = props.action;

        if (typeof action === 'function') {
          return resolve(action(file));
        }
        resolve(action);
      }).then(function (action) {
        var uid = file.uid;

        var request = props.customRequest || __WEBPACK_IMPORTED_MODULE_9__request__["a" /* default */];
        _this3.reqs[uid] = request({
          action: action,
          filename: props.name,
          file: file,
          data: data,
          headers: props.headers,
          withCredentials: props.withCredentials,
          onProgress: onProgress ? function (e) {
            onProgress(e, file);
          } : null,
          onSuccess: function onSuccess(ret, xhr) {
            delete _this3.reqs[uid];
            props.onSuccess(ret, file, xhr);
          },
          onError: function onError(err, ret) {
            delete _this3.reqs[uid];
            props.onError(err, ret, file);
          }
        });
        onStart(file);
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.setState({
        uid: Object(__WEBPACK_IMPORTED_MODULE_10__uid__["a" /* default */])()
      });
    }
  }, {
    key: 'abort',
    value: function abort(file) {
      var reqs = this.reqs;

      if (file) {
        var uid = file;
        if (file && file.uid) {
          uid = file.uid;
        }
        if (reqs[uid]) {
          reqs[uid].abort();
          delete reqs[uid];
        }
      } else {
        Object.keys(reqs).forEach(function (uid) {
          if (reqs[uid]) {
            reqs[uid].abort();
          }

          delete reqs[uid];
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          Tag = _props.component,
          prefixCls = _props.prefixCls,
          className = _props.className,
          disabled = _props.disabled,
          style = _props.style,
          multiple = _props.multiple,
          accept = _props.accept,
          children = _props.children,
          directory = _props.directory;

      var cls = __WEBPACK_IMPORTED_MODULE_8_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls, true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-disabled', disabled), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, className, className), _classNames));
      var events = disabled ? {} : {
        onClick: this.onClick,
        onKeyDown: this.onKeyDown,
        onDrop: this.onFileDrop,
        onDragOver: this.onFileDrop,
        tabIndex: '0'
      };
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        Tag,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, events, {
          className: cls,
          role: 'button',
          style: style
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', {
          type: 'file',
          ref: this.saveFileInput,
          key: this.state.uid,
          style: { display: 'none' },
          accept: accept,
          directory: directory ? 'directory' : null,
          webkitdirectory: directory ? 'webkitdirectory' : null,
          multiple: multiple,
          onChange: this.onChange
        }),
        children
      );
    }
  }]);

  return AjaxUploader;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

AjaxUploader.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  multiple: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  directory: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  accept: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  onStart: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  data: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  action: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  headers: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  beforeUpload: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  customRequest: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onProgress: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  withCredentials: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};


/* harmony default export */ __webpack_exports__["a"] = (AjaxUploader);

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = upload;
function getError(option, xhr) {
  var msg = 'cannot post ' + option.action + ' ' + xhr.status + '\'';
  var err = new Error(msg);
  err.status = xhr.status;
  err.method = 'post';
  err.url = option.action;
  return err;
}

function getBody(xhr) {
  var text = xhr.responseText || xhr.response;
  if (!text) {
    return text;
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}

// option {
//  onProgress: (event: { percent: number }): void,
//  onError: (event: Error, body?: Object): void,
//  onSuccess: (body: Object): void,
//  data: Object,
//  filename: String,
//  file: File,
//  withCredentials: Boolean,
//  action: String,
//  headers: Object,
// }
function upload(option) {
  var xhr = new XMLHttpRequest();

  if (option.onProgress && xhr.upload) {
    xhr.upload.onprogress = function progress(e) {
      if (e.total > 0) {
        e.percent = e.loaded / e.total * 100;
      }
      option.onProgress(e);
    };
  }

  var formData = new FormData();

  if (option.data) {
    Object.keys(option.data).map(function (key) {
      formData.append(key, option.data[key]);
    });
  }

  formData.append(option.filename, option.file);

  xhr.onerror = function error(e) {
    option.onError(e);
  };

  xhr.onload = function onload() {
    // allow success when 2xx status
    // see https://github.com/react-component/upload/issues/34
    if (xhr.status < 200 || xhr.status >= 300) {
      return option.onError(getError(option, xhr), getBody(xhr));
    }

    option.onSuccess(getBody(xhr), xhr);
  };

  xhr.open('post', option.action, true);

  // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
  if (option.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true;
  }

  var headers = option.headers || {};

  // when set headers['X-Requested-With'] = null , can close default XHR header
  // see https://github.com/react-component/upload/issues/33
  if (headers['X-Requested-With'] !== null) {
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  }

  for (var h in headers) {
    if (headers.hasOwnProperty(h) && headers[h] !== null) {
      xhr.setRequestHeader(h, headers[h]);
    }
  }
  xhr.send(formData);

  return {
    abort: function abort() {
      xhr.abort();
    }
  };
}

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function endsWith(str, suffix) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

/* harmony default export */ __webpack_exports__["a"] = (function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = file.type || '';
    var baseMimeType = mimeType.replace(/\/.*$/, '');

    return acceptedFilesArray.some(function (type) {
      var validType = type.trim();
      if (validType.charAt(0) === '.') {
        return endsWith(fileName.toLowerCase(), validType.toLowerCase());
      } else if (/\/\*$/.test(validType)) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }
      return mimeType === validType;
    });
  }
  return true;
});

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var traverseFileTree = function traverseFileTree(files, callback, isAccepted) {
  var _traverseFileTree = function _traverseFileTree(item, path) {
    path = path || '';
    if (item.isFile) {
      item.file(function (file) {
        if (isAccepted(file)) {
          callback([file]);
        }
      });
    } else if (item.isDirectory) {
      var dirReader = item.createReader();

      dirReader.readEntries(function (entries) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var entrieItem = _step.value;

            _traverseFileTree(entrieItem, '' + path + item.name + '/');
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator['return']) {
              _iterator['return']();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
  };
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = files[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var file = _step2.value;

      _traverseFileTree(file.webkitGetAsEntry());
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2['return']) {
        _iterator2['return']();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (traverseFileTree);

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__uid__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_warning__);






/* eslint react/sort-comp:0 */







var IFRAME_STYLE = {
  position: 'absolute',
  top: 0,
  opacity: 0,
  filter: 'alpha(opacity=0)',
  left: 0,
  zIndex: 9999
};

// diferent from AjaxUpload, can only upload on at one time, serial seriously

var IframeUploader = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(IframeUploader, _Component);

  function IframeUploader() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, IframeUploader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = IframeUploader.__proto__ || Object.getPrototypeOf(IframeUploader)).call.apply(_ref, [this].concat(args))), _this), _this.state = { uploading: false }, _this.file = {}, _this.onLoad = function () {
      if (!_this.state.uploading) {
        return;
      }
      var _this2 = _this,
          props = _this2.props,
          file = _this2.file;

      var response = void 0;
      try {
        var doc = _this.getIframeDocument();
        var script = doc.getElementsByTagName('script')[0];
        if (script && script.parentNode === doc.body) {
          doc.body.removeChild(script);
        }
        response = doc.body.innerHTML;
        props.onSuccess(response, file);
      } catch (err) {
        __WEBPACK_IMPORTED_MODULE_11_warning___default()(false, 'cross domain error for Upload. Maybe server should return document.domain script. see Note from https://github.com/react-component/upload');
        response = 'cross-domain';
        props.onError(err, null, file);
      }
      _this.endUpload();
    }, _this.onChange = function () {
      var target = _this.getFormInputNode();
      // ie8/9 don't support FileList Object
      // http://stackoverflow.com/questions/12830058/ie8-input-type-file-get-files
      var file = _this.file = {
        uid: Object(__WEBPACK_IMPORTED_MODULE_10__uid__["a" /* default */])(),
        name: target.value
      };
      _this.startUpload();
      var _this3 = _this,
          props = _this3.props;

      if (!props.beforeUpload) {
        return _this.post(file);
      }
      var before = props.beforeUpload(file);
      if (before && before.then) {
        before.then(function () {
          _this.post(file);
        }, function () {
          _this.endUpload();
        });
      } else if (before !== false) {
        _this.post(file);
      } else {
        _this.endUpload();
      }
    }, _this.saveIframe = function (node) {
      _this.iframe = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(IframeUploader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateIframeWH();
      this.initIframe();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateIframeWH();
    }
  }, {
    key: 'getIframeNode',
    value: function getIframeNode() {
      return this.iframe;
    }
  }, {
    key: 'getIframeDocument',
    value: function getIframeDocument() {
      return this.getIframeNode().contentDocument;
    }
  }, {
    key: 'getFormNode',
    value: function getFormNode() {
      return this.getIframeDocument().getElementById('form');
    }
  }, {
    key: 'getFormInputNode',
    value: function getFormInputNode() {
      return this.getIframeDocument().getElementById('input');
    }
  }, {
    key: 'getFormDataNode',
    value: function getFormDataNode() {
      return this.getIframeDocument().getElementById('data');
    }
  }, {
    key: 'getFileForMultiple',
    value: function getFileForMultiple(file) {
      return this.props.multiple ? [file] : file;
    }
  }, {
    key: 'getIframeHTML',
    value: function getIframeHTML(domain) {
      var domainScript = '';
      var domainInput = '';
      if (domain) {
        var script = 'script';
        domainScript = '<' + script + '>document.domain="' + domain + '";</' + script + '>';
        domainInput = '<input name="_documentDomain" value="' + domain + '" />';
      }
      return '\n    <!DOCTYPE html>\n    <html>\n    <head>\n    <meta http-equiv="X-UA-Compatible" content="IE=edge" />\n    <style>\n    body,html {padding:0;margin:0;border:0;overflow:hidden;}\n    </style>\n    ' + domainScript + '\n    </head>\n    <body>\n    <form method="post"\n    encType="multipart/form-data"\n    action="" id="form"\n    style="display:block;height:9999px;position:relative;overflow:hidden;">\n    <input id="input" type="file"\n     name="' + this.props.name + '"\n     style="position:absolute;top:0;right:0;height:9999px;font-size:9999px;cursor:pointer;"/>\n    ' + domainInput + '\n    <span id="data"></span>\n    </form>\n    </body>\n    </html>\n    ';
    }
  }, {
    key: 'initIframeSrc',
    value: function initIframeSrc() {
      if (this.domain) {
        this.getIframeNode().src = 'javascript:void((function(){\n        var d = document;\n        d.open();\n        d.domain=\'' + this.domain + '\';\n        d.write(\'\');\n        d.close();\n      })())';
      }
    }
  }, {
    key: 'initIframe',
    value: function initIframe() {
      var iframeNode = this.getIframeNode();
      var win = iframeNode.contentWindow;
      var doc = void 0;
      this.domain = this.domain || '';
      this.initIframeSrc();
      try {
        doc = win.document;
      } catch (e) {
        this.domain = document.domain;
        this.initIframeSrc();
        win = iframeNode.contentWindow;
        doc = win.document;
      }
      doc.open('text/html', 'replace');
      doc.write(this.getIframeHTML(this.domain));
      doc.close();
      this.getFormInputNode().onchange = this.onChange;
    }
  }, {
    key: 'endUpload',
    value: function endUpload() {
      if (this.state.uploading) {
        this.file = {};
        // hack avoid batch
        this.state.uploading = false;
        this.setState({
          uploading: false
        });
        this.initIframe();
      }
    }
  }, {
    key: 'startUpload',
    value: function startUpload() {
      if (!this.state.uploading) {
        this.state.uploading = true;
        this.setState({
          uploading: true
        });
      }
    }
  }, {
    key: 'updateIframeWH',
    value: function updateIframeWH() {
      var rootNode = __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this);
      var iframeNode = this.getIframeNode();
      iframeNode.style.height = rootNode.offsetHeight + 'px';
      iframeNode.style.width = rootNode.offsetWidth + 'px';
    }
  }, {
    key: 'abort',
    value: function abort(file) {
      if (file) {
        var uid = file;
        if (file && file.uid) {
          uid = file.uid;
        }
        if (uid === this.file.uid) {
          this.endUpload();
        }
      } else {
        this.endUpload();
      }
    }
  }, {
    key: 'post',
    value: function post(file) {
      var _this4 = this;

      var formNode = this.getFormNode();
      var dataSpan = this.getFormDataNode();
      var data = this.props.data;
      var onStart = this.props.onStart;

      if (typeof data === 'function') {
        data = data(file);
      }
      var inputs = document.createDocumentFragment();
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          var input = document.createElement('input');
          input.setAttribute('name', key);
          input.value = data[key];
          inputs.appendChild(input);
        }
      }
      dataSpan.appendChild(inputs);
      new Promise(function (resolve) {
        var action = _this4.props.action;

        if (typeof action === 'function') {
          return resolve(action(file));
        }
        resolve(action);
      }).then(function (action) {
        formNode.setAttribute('action', action);
        formNode.submit();
        dataSpan.innerHTML = '';
        onStart(file);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          Tag = _props.component,
          disabled = _props.disabled,
          className = _props.className,
          prefixCls = _props.prefixCls,
          children = _props.children,
          style = _props.style;

      var iframeStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, IFRAME_STYLE, {
        display: this.state.uploading || disabled ? 'none' : ''
      });
      var cls = __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-disabled', disabled), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, className, className), _classNames));
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        Tag,
        {
          className: cls,
          style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ position: 'relative', zIndex: 0 }, style)
        },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('iframe', {
          ref: this.saveIframe,
          onLoad: this.onLoad,
          style: iframeStyle
        }),
        children
      );
    }
  }]);

  return IframeUploader;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

IframeUploader.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  accept: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  onStart: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  multiple: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  data: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  action: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  name: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (IframeUploader);

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(935),
    baseUniq = __webpack_require__(1012);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(936),
    baseMatchesProperty = __webpack_require__(997),
    identity = __webpack_require__(1008),
    isArray = __webpack_require__(61),
    property = __webpack_require__(1009);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(937),
    getMatchData = __webpack_require__(996),
    matchesStrictComparable = __webpack_require__(361);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(345),
    baseIsEqual = __webpack_require__(350);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 938 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(123);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(123);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(123);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(123);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(122);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 944 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 945 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 946 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(122),
    Map = __webpack_require__(197),
    MapCache = __webpack_require__(199);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(347),
    isMasked = __webpack_require__(951),
    isObject = __webpack_require__(198),
    toSource = __webpack_require__(349);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(124);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 950 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(952);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(55);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 953 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(955),
    ListCache = __webpack_require__(122),
    Map = __webpack_require__(197);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(956),
    hashDelete = __webpack_require__(957),
    hashGet = __webpack_require__(958),
    hashHas = __webpack_require__(959),
    hashSet = __webpack_require__(960);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(125);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 957 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(125);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(125);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(125);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(126);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 962 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(126);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(126);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(126);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(345),
    equalArrays = __webpack_require__(351),
    equalByTag = __webpack_require__(970),
    equalObjects = __webpack_require__(973),
    getTag = __webpack_require__(992),
    isArray = __webpack_require__(61),
    isBuffer = __webpack_require__(356),
    isTypedArray = __webpack_require__(358);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 967 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 968 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 969 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(124),
    Uint8Array = __webpack_require__(971),
    eq = __webpack_require__(346),
    equalArrays = __webpack_require__(351),
    mapToArray = __webpack_require__(972),
    setToArray = __webpack_require__(200);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(55);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 972 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(974);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(975),
    getSymbols = __webpack_require__(977),
    keys = __webpack_require__(354);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(976),
    isArray = __webpack_require__(61);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 976 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(978),
    stubArray = __webpack_require__(979);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 978 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 979 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(981),
    isArguments = __webpack_require__(355),
    isArray = __webpack_require__(61),
    isBuffer = __webpack_require__(356),
    isIndex = __webpack_require__(357),
    isTypedArray = __webpack_require__(358);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 981 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(98),
    isObjectLike = __webpack_require__(99);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 983 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(98),
    isLength = __webpack_require__(201),
    isObjectLike = __webpack_require__(99);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 985 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(348);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)(module)))

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(988),
    nativeKeys = __webpack_require__(989);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 988 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(990);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 990 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(347),
    isLength = __webpack_require__(201);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(993),
    Map = __webpack_require__(197),
    Promise = __webpack_require__(994),
    Set = __webpack_require__(359),
    WeakMap = __webpack_require__(995),
    baseGetTag = __webpack_require__(98),
    toSource = __webpack_require__(349);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(85),
    root = __webpack_require__(55);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(85),
    root = __webpack_require__(55);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(85),
    root = __webpack_require__(55);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(360),
    keys = __webpack_require__(354);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(350),
    get = __webpack_require__(998),
    hasIn = __webpack_require__(1005),
    isKey = __webpack_require__(202),
    isStrictComparable = __webpack_require__(360),
    matchesStrictComparable = __webpack_require__(361),
    toKey = __webpack_require__(127);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(362);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1000);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1001);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(199);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1003);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(124),
    arrayMap = __webpack_require__(1004),
    isArray = __webpack_require__(61),
    isSymbol = __webpack_require__(203);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1004 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1006),
    hasPath = __webpack_require__(1007);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1006 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(363),
    isArguments = __webpack_require__(355),
    isArray = __webpack_require__(61),
    isIndex = __webpack_require__(357),
    isLength = __webpack_require__(201),
    toKey = __webpack_require__(127);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1008 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1010),
    basePropertyDeep = __webpack_require__(1011),
    isKey = __webpack_require__(202),
    toKey = __webpack_require__(127);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1010 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(362);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(352),
    arrayIncludes = __webpack_require__(1013),
    arrayIncludesWith = __webpack_require__(1018),
    cacheHas = __webpack_require__(353),
    createSet = __webpack_require__(1019),
    setToArray = __webpack_require__(200);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(1014);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1015),
    baseIsNaN = __webpack_require__(1016),
    strictIndexOf = __webpack_require__(1017);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 1015 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 1016 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1017 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1018 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(359),
    noop = __webpack_require__(1020),
    setToArray = __webpack_require__(200);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1020 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _rcAnimate = __webpack_require__(50);

var _rcAnimate2 = _interopRequireDefault(_rcAnimate);

var _icon = __webpack_require__(6);

var _icon2 = _interopRequireDefault(_icon);

var _tooltip = __webpack_require__(296);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _progress = __webpack_require__(35);

var _progress2 = _interopRequireDefault(_progress);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
var previewFile = function previewFile(file, callback) {
    var reader = new FileReader();
    reader.onloadend = function () {
        return callback(reader.result);
    };
    reader.readAsDataURL(file);
};
var extname = function extname(url) {
    if (!url) {
        return '';
    }
    var temp = url.split('/');
    var filename = temp[temp.length - 1];
    var filenameWithoutSuffix = filename.split(/#|\?/)[0];
    return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [''])[0];
};
var isImageUrl = function isImageUrl(url) {
    var extension = extname(url);
    if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|bmp)$/i.test(extension)) {
        return true;
    } else if (/^data:/.test(url)) {
        // other file types of base64
        return false;
    } else if (extension) {
        // other file types which have extension
        return false;
    }
    return true;
};

var UploadList = function (_React$Component) {
    (0, _inherits3['default'])(UploadList, _React$Component);

    function UploadList() {
        (0, _classCallCheck3['default'])(this, UploadList);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (UploadList.__proto__ || Object.getPrototypeOf(UploadList)).apply(this, arguments));

        _this.handleClose = function (file) {
            var onRemove = _this.props.onRemove;

            if (onRemove) {
                onRemove(file);
            }
        };
        _this.handlePreview = function (file, e) {
            var onPreview = _this.props.onPreview;

            if (!onPreview) {
                return;
            }
            e.preventDefault();
            return onPreview(file);
        };
        return _this;
    }

    (0, _createClass3['default'])(UploadList, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _this2 = this;

            if (this.props.listType !== 'picture' && this.props.listType !== 'picture-card') {
                return;
            }
            (this.props.items || []).forEach(function (file) {
                if (typeof document === 'undefined' || typeof window === 'undefined' || !window.FileReader || !window.File || !(file.originFileObj instanceof File) || file.thumbUrl !== undefined) {
                    return;
                }
                /*eslint-disable */
                file.thumbUrl = '';
                /*eslint-enable */
                previewFile(file.originFileObj, function (previewDataUrl) {
                    /*eslint-disable */
                    file.thumbUrl = previewDataUrl;
                    /*eslint-enable */
                    _this2.forceUpdate();
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this,
                _classNames2;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                _props$items = _props.items,
                items = _props$items === undefined ? [] : _props$items,
                listType = _props.listType,
                showPreviewIcon = _props.showPreviewIcon,
                showRemoveIcon = _props.showRemoveIcon,
                locale = _props.locale;

            var list = items.map(function (file) {
                var _classNames;

                var progress = void 0;
                var icon = React.createElement(_icon2['default'], { type: file.status === 'uploading' ? 'loading' : 'paper-clip' });
                if (listType === 'picture' || listType === 'picture-card') {
                    if (listType === 'picture-card' && file.status === 'uploading') {
                        icon = React.createElement(
                            'div',
                            { className: prefixCls + '-list-item-uploading-text' },
                            locale.uploading
                        );
                    } else if (!file.thumbUrl && !file.url) {
                        icon = React.createElement(_icon2['default'], { className: prefixCls + '-list-item-thumbnail', type: 'picture' });
                    } else {
                        var thumbnail = isImageUrl(file.thumbUrl || file.url) ? React.createElement('img', { src: file.thumbUrl || file.url, alt: file.name }) : React.createElement(_icon2['default'], { type: 'file', className: prefixCls + '-list-item-icon' });
                        icon = React.createElement(
                            'a',
                            { className: prefixCls + '-list-item-thumbnail', onClick: function onClick(e) {
                                    return _this3.handlePreview(file, e);
                                }, href: file.url || file.thumbUrl, target: '_blank', rel: 'noopener noreferrer' },
                            thumbnail
                        );
                    }
                }
                if (file.status === 'uploading') {
                    // show loading icon if upload progress listener is disabled
                    var loadingProgress = 'percent' in file ? React.createElement(_progress2['default'], (0, _extends3['default'])({ type: 'line' }, _this3.props.progressAttr, { percent: file.percent })) : null;
                    progress = React.createElement(
                        'div',
                        { className: prefixCls + '-list-item-progress', key: 'progress' },
                        loadingProgress
                    );
                }
                var infoUploadingClass = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-list-item', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-list-item-' + file.status, true), _classNames));
                var preview = file.url ? React.createElement(
                    'a',
                    (0, _extends3['default'])({}, file.linkProps, { href: file.url, target: '_blank', rel: 'noopener noreferrer', className: prefixCls + '-list-item-name', onClick: function onClick(e) {
                            return _this3.handlePreview(file, e);
                        }, title: file.name }),
                    file.name
                ) : React.createElement(
                    'span',
                    { className: prefixCls + '-list-item-name', onClick: function onClick(e) {
                            return _this3.handlePreview(file, e);
                        }, title: file.name },
                    file.name
                );
                var style = {
                    pointerEvents: 'none',
                    opacity: 0.5
                };
                var previewIcon = showPreviewIcon ? React.createElement(
                    'a',
                    { href: file.url || file.thumbUrl, target: '_blank', rel: 'noopener noreferrer', style: file.url || file.thumbUrl ? undefined : style, onClick: function onClick(e) {
                            return _this3.handlePreview(file, e);
                        }, title: locale.previewFile },
                    React.createElement(_icon2['default'], { type: 'eye-o' })
                ) : null;
                var removeIcon = showRemoveIcon ? React.createElement(_icon2['default'], { type: 'delete', title: locale.removeFile, onClick: function onClick() {
                        return _this3.handleClose(file);
                    } }) : null;
                var removeIconCross = showRemoveIcon ? React.createElement(_icon2['default'], { type: 'cross', title: locale.removeFile, onClick: function onClick() {
                        return _this3.handleClose(file);
                    } }) : null;
                var actions = listType === 'picture-card' && file.status !== 'uploading' ? React.createElement(
                    'span',
                    { className: prefixCls + '-list-item-actions' },
                    previewIcon,
                    removeIcon
                ) : removeIconCross;
                var message = void 0;
                if (file.response && typeof file.response === 'string') {
                    message = file.response;
                } else {
                    message = file.error && file.error.statusText || locale.uploadError;
                }
                var iconAndPreview = file.status === 'error' ? React.createElement(
                    _tooltip2['default'],
                    { title: message },
                    icon,
                    preview
                ) : React.createElement(
                    'span',
                    null,
                    icon,
                    preview
                );
                return React.createElement(
                    'div',
                    { className: infoUploadingClass, key: file.uid },
                    React.createElement(
                        'div',
                        { className: prefixCls + '-list-item-info' },
                        iconAndPreview
                    ),
                    actions,
                    React.createElement(
                        _rcAnimate2['default'],
                        { transitionName: 'fade', component: '' },
                        progress
                    )
                );
            });
            var listClassNames = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-list', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-list-' + listType, true), _classNames2));
            var animationDirection = listType === 'picture-card' ? 'animate-inline' : 'animate';
            return React.createElement(
                _rcAnimate2['default'],
                { transitionName: prefixCls + '-' + animationDirection, component: 'div', className: listClassNames },
                list
            );
        }
    }]);
    return UploadList;
}(React.Component);

exports['default'] = UploadList;

UploadList.defaultProps = {
    listType: 'text',
    progressAttr: {
        strokeWidth: 2,
        showInfo: false
    },
    prefixCls: 'ant-upload',
    showRemoveIcon: true,
    showPreviewIcon: true
};
module.exports = exports['default'];

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _icon = __webpack_require__(6);

var _icon2 = _interopRequireDefault(_icon);

var _rcProgress = __webpack_require__(1023);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var statusColorMap = {
    normal: '#108ee9',
    exception: '#ff5500',
    success: '#87d068'
};
var validProgress = function validProgress(progress) {
    if (!progress || progress < 0) {
        return 0;
    } else if (progress > 100) {
        return 100;
    }
    return progress;
};

var Progress = function (_React$Component) {
    (0, _inherits3['default'])(Progress, _React$Component);

    function Progress() {
        (0, _classCallCheck3['default'])(this, Progress);
        return (0, _possibleConstructorReturn3['default'])(this, (Progress.__proto__ || Object.getPrototypeOf(Progress)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Progress, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var props = this.props;

            var prefixCls = props.prefixCls,
                className = props.className,
                _props$percent = props.percent,
                percent = _props$percent === undefined ? 0 : _props$percent,
                status = props.status,
                format = props.format,
                trailColor = props.trailColor,
                size = props.size,
                successPercent = props.successPercent,
                type = props.type,
                strokeWidth = props.strokeWidth,
                width = props.width,
                showInfo = props.showInfo,
                _props$gapDegree = props.gapDegree,
                gapDegree = _props$gapDegree === undefined ? 0 : _props$gapDegree,
                gapPosition = props.gapPosition,
                strokeColor = props.strokeColor,
                _props$strokeLinecap = props.strokeLinecap,
                strokeLinecap = _props$strokeLinecap === undefined ? 'round' : _props$strokeLinecap,
                restProps = __rest(props, ["prefixCls", "className", "percent", "status", "format", "trailColor", "size", "successPercent", "type", "strokeWidth", "width", "showInfo", "gapDegree", "gapPosition", "strokeColor", "strokeLinecap"]);

            var progressStatus = parseInt(successPercent ? successPercent.toString() : percent.toString(), 10) >= 100 && !('status' in props) ? 'success' : status || 'normal';
            var progressInfo = void 0;
            var progress = void 0;
            var textFormatter = format || function (percentNumber) {
                return percentNumber + '%';
            };
            if (showInfo) {
                var text = void 0;
                var iconType = type === 'circle' || type === 'dashboard' ? '' : '-circle';
                if (format || progressStatus !== 'exception' && progressStatus !== 'success') {
                    text = textFormatter(validProgress(percent), validProgress(successPercent));
                } else if (progressStatus === 'exception') {
                    text = React.createElement(_icon2['default'], { type: 'cross' + iconType });
                } else if (progressStatus === 'success') {
                    text = React.createElement(_icon2['default'], { type: 'check' + iconType });
                }
                progressInfo = React.createElement(
                    'span',
                    { className: prefixCls + '-text' },
                    text
                );
            }
            if (type === 'line') {
                var percentStyle = {
                    width: validProgress(percent) + '%',
                    height: strokeWidth || (size === 'small' ? 6 : 8),
                    background: strokeColor,
                    borderRadius: strokeLinecap === 'square' ? 0 : '100px'
                };
                var successPercentStyle = {
                    width: validProgress(successPercent) + '%',
                    height: strokeWidth || (size === 'small' ? 6 : 8),
                    borderRadius: strokeLinecap === 'square' ? 0 : '100px'
                };
                var successSegment = successPercent !== undefined ? React.createElement('div', { className: prefixCls + '-success-bg', style: successPercentStyle }) : null;
                progress = React.createElement(
                    'div',
                    null,
                    React.createElement(
                        'div',
                        { className: prefixCls + '-outer' },
                        React.createElement(
                            'div',
                            { className: prefixCls + '-inner' },
                            React.createElement('div', { className: prefixCls + '-bg', style: percentStyle }),
                            successSegment
                        )
                    ),
                    progressInfo
                );
            } else if (type === 'circle' || type === 'dashboard') {
                var circleSize = width || 120;
                var circleStyle = {
                    width: circleSize,
                    height: circleSize,
                    fontSize: circleSize * 0.15 + 6
                };
                var circleWidth = strokeWidth || 6;
                var gapPos = gapPosition || type === 'dashboard' && 'bottom' || 'top';
                var gapDeg = gapDegree || type === 'dashboard' && 75;
                progress = React.createElement(
                    'div',
                    { className: prefixCls + '-inner', style: circleStyle },
                    React.createElement(_rcProgress.Circle, { percent: validProgress(percent), strokeWidth: circleWidth, trailWidth: circleWidth, strokeColor: statusColorMap[progressStatus], strokeLinecap: strokeLinecap, trailColor: trailColor, prefixCls: prefixCls, gapDegree: gapDeg, gapPosition: gapPos }),
                    progressInfo
                );
            }
            var classString = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + (type === 'dashboard' && 'circle' || type), true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-status-' + progressStatus, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-show-info', showInfo), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + size, size), _classNames), className);
            return React.createElement(
                'div',
                (0, _extends3['default'])({}, restProps, { className: classString }),
                progress
            );
        }
    }]);
    return Progress;
}(React.Component);

exports['default'] = Progress;

Progress.defaultProps = {
    type: 'line',
    percent: 0,
    showInfo: true,
    trailColor: '#f3f3f3',
    prefixCls: 'ant-progress',
    size: 'default'
};
Progress.propTypes = {
    status: _propTypes2['default'].oneOf(['normal', 'exception', 'active', 'success']),
    type: _propTypes2['default'].oneOf(['line', 'circle', 'dashboard']),
    showInfo: _propTypes2['default'].bool,
    percent: _propTypes2['default'].number,
    width: _propTypes2['default'].number,
    strokeWidth: _propTypes2['default'].number,
    strokeLinecap: _propTypes2['default'].oneOf(['round', 'square']),
    strokeColor: _propTypes2['default'].string,
    trailColor: _propTypes2['default'].string,
    format: _propTypes2['default'].func,
    gapDegree: _propTypes2['default'].number,
    'default': _propTypes2['default'].oneOf(['default', 'small'])
};
module.exports = exports['default'];

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Line__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Circle__ = __webpack_require__(1025);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Line", function() { return __WEBPACK_IMPORTED_MODULE_0__Line__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Circle", function() { return __WEBPACK_IMPORTED_MODULE_1__Circle__["a"]; });





/* harmony default export */ __webpack_exports__["default"] = ({
  Line: __WEBPACK_IMPORTED_MODULE_0__Line__["a" /* default */],
  Circle: __WEBPACK_IMPORTED_MODULE_1__Circle__["a" /* default */]
});

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enhancer__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(365);









var Line = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Line, _Component);

  function Line() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Line);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  Line.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        className = _props.className,
        percent = _props.percent,
        prefixCls = _props.prefixCls,
        strokeColor = _props.strokeColor,
        strokeLinecap = _props.strokeLinecap,
        strokeWidth = _props.strokeWidth,
        style = _props.style,
        trailColor = _props.trailColor,
        trailWidth = _props.trailWidth,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'percent', 'prefixCls', 'strokeColor', 'strokeLinecap', 'strokeWidth', 'style', 'trailColor', 'trailWidth']);

    delete restProps.gapPosition;

    var pathStyle = {
      strokeDasharray: '100px, 100px',
      strokeDashoffset: 100 - percent + 'px',
      transition: 'stroke-dashoffset 0.3s ease 0s, stroke 0.3s linear'
    };

    var center = strokeWidth / 2;
    var right = 100 - strokeWidth / 2;
    var pathString = 'M ' + (strokeLinecap === 'round' ? center : 0) + ',' + center + '\n           L ' + (strokeLinecap === 'round' ? right : 100) + ',' + center;
    var viewBoxString = '0 0 100 ' + strokeWidth;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'svg',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        className: prefixCls + '-line ' + className,
        viewBox: viewBoxString,
        preserveAspectRatio: 'none',
        style: style
      }, restProps),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('path', {
        className: prefixCls + '-line-trail',
        d: pathString,
        strokeLinecap: strokeLinecap,
        stroke: trailColor,
        strokeWidth: trailWidth || strokeWidth,
        fillOpacity: '0'
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('path', {
        className: prefixCls + '-line-path',
        d: pathString,
        strokeLinecap: strokeLinecap,
        stroke: strokeColor,
        strokeWidth: strokeWidth,
        fillOpacity: '0',
        ref: function ref(path) {
          _this2.path = path;
        },
        style: pathStyle
      })
    );
  };

  return Line;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Line.propTypes = __WEBPACK_IMPORTED_MODULE_7__types__["b" /* propTypes */];

Line.defaultProps = __WEBPACK_IMPORTED_MODULE_7__types__["a" /* defaultProps */];

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__enhancer__["a" /* default */])(Line));

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enhancer__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types__ = __webpack_require__(365);





/* eslint react/prop-types: 0 */





var Circle = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Circle, _Component);

  function Circle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Circle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  Circle.prototype.getPathStyles = function getPathStyles() {
    var _props = this.props,
        percent = _props.percent,
        strokeWidth = _props.strokeWidth,
        _props$gapDegree = _props.gapDegree,
        gapDegree = _props$gapDegree === undefined ? 0 : _props$gapDegree,
        gapPosition = _props.gapPosition;

    var radius = 50 - strokeWidth / 2;
    var beginPositionX = 0;
    var beginPositionY = -radius;
    var endPositionX = 0;
    var endPositionY = -2 * radius;
    switch (gapPosition) {
      case 'left':
        beginPositionX = -radius;
        beginPositionY = 0;
        endPositionX = 2 * radius;
        endPositionY = 0;
        break;
      case 'right':
        beginPositionX = radius;
        beginPositionY = 0;
        endPositionX = -2 * radius;
        endPositionY = 0;
        break;
      case 'bottom':
        beginPositionY = radius;
        endPositionY = 2 * radius;
        break;
      default:
    }
    var pathString = 'M 50,50 m ' + beginPositionX + ',' + beginPositionY + '\n     a ' + radius + ',' + radius + ' 0 1 1 ' + endPositionX + ',' + -endPositionY + '\n     a ' + radius + ',' + radius + ' 0 1 1 ' + -endPositionX + ',' + endPositionY;
    var len = Math.PI * 2 * radius;
    var trailPathStyle = {
      strokeDasharray: len - gapDegree + 'px ' + len + 'px',
      strokeDashoffset: '-' + gapDegree / 2 + 'px',
      transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s'
    };
    var strokePathStyle = {
      strokeDasharray: percent / 100 * (len - gapDegree) + 'px ' + len + 'px',
      strokeDashoffset: '-' + gapDegree / 2 + 'px',
      transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s' // eslint-disable-line
    };
    return { pathString: pathString, trailPathStyle: trailPathStyle, strokePathStyle: strokePathStyle };
  };

  Circle.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        prefixCls = _props2.prefixCls,
        strokeWidth = _props2.strokeWidth,
        trailWidth = _props2.trailWidth,
        strokeColor = _props2.strokeColor,
        percent = _props2.percent,
        trailColor = _props2.trailColor,
        strokeLinecap = _props2.strokeLinecap,
        style = _props2.style,
        className = _props2.className,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['prefixCls', 'strokeWidth', 'trailWidth', 'strokeColor', 'percent', 'trailColor', 'strokeLinecap', 'style', 'className']);

    var _getPathStyles = this.getPathStyles(),
        pathString = _getPathStyles.pathString,
        trailPathStyle = _getPathStyles.trailPathStyle,
        strokePathStyle = _getPathStyles.strokePathStyle;

    delete restProps.percent;
    delete restProps.gapDegree;
    delete restProps.gapPosition;
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'svg',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        className: prefixCls + '-circle ' + className,
        viewBox: '0 0 100 100',
        style: style
      }, restProps),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('path', {
        className: prefixCls + '-circle-trail',
        d: pathString,
        stroke: trailColor,
        strokeWidth: trailWidth || strokeWidth,
        fillOpacity: '0',
        style: trailPathStyle
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('path', {
        className: prefixCls + '-circle-path',
        d: pathString,
        strokeLinecap: strokeLinecap,
        stroke: strokeColor,
        strokeWidth: this.props.percent === 0 ? 0 : strokeWidth,
        fillOpacity: '0',
        ref: function ref(path) {
          _this2.path = path;
        },
        style: strokePathStyle
      })
    );
  };

  return Circle;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Circle.propTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__types__["b" /* propTypes */], {
  gapPosition: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['top', 'bottom', 'left', 'right'])
});

Circle.defaultProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__types__["a" /* defaultProps */], {
  gapPosition: 'top'
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__enhancer__["a" /* default */])(Circle));

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

exports.T = T;
exports.fileToObject = fileToObject;
exports.genPercentAdd = genPercentAdd;
exports.getFileItem = getFileItem;
exports.removeFileItem = removeFileItem;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function T() {
    return true;
}
// Fix IE file.status problem
// via coping a new Object
function fileToObject(file) {
    return (0, _extends3['default'])({}, file, { lastModified: file.lastModified, lastModifiedDate: file.lastModifiedDate, name: file.name, size: file.size, type: file.type, uid: file.uid, percent: 0, originFileObj: file });
}
/**
 * 生成Progress percent: 0.1 -> 0.98
 *   - for ie
 */
function genPercentAdd() {
    var k = 0.1;
    var i = 0.01;
    var end = 0.98;
    return function (s) {
        var start = s;
        if (start >= end) {
            return start;
        }
        start += k;
        k = k - i;
        if (k < 0.001) {
            k = 0.001;
        }
        return start;
    };
}
function getFileItem(file, fileList) {
    var matchKey = file.uid !== undefined ? 'uid' : 'name';
    return fileList.filter(function (item) {
        return item[matchKey] === file[matchKey];
    })[0];
}
function removeFileItem(file, fileList) {
    var matchKey = file.uid !== undefined ? 'uid' : 'name';
    var removed = fileList.filter(function (item) {
        return item[matchKey] !== file[matchKey];
    });
    if (removed.length === fileList.length) {
        return null;
    }
    return removed;
}

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _Upload = __webpack_require__(343);

var _Upload2 = _interopRequireDefault(_Upload);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Dragger = function (_React$Component) {
    (0, _inherits3['default'])(Dragger, _React$Component);

    function Dragger() {
        (0, _classCallCheck3['default'])(this, Dragger);
        return (0, _possibleConstructorReturn3['default'])(this, (Dragger.__proto__ || Object.getPrototypeOf(Dragger)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Dragger, [{
        key: 'render',
        value: function render() {
            var props = this.props;

            return React.createElement(_Upload2['default'], (0, _extends3['default'])({}, props, { type: 'drag', style: (0, _extends3['default'])({}, props.style, { height: props.height }) }));
        }
    }]);
    return Dragger;
}(React.Component);

exports['default'] = Dragger;
module.exports = exports['default'];

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/DeepCBCT_analysis_auto.9d5e312a.svg";

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3d-plan_general OrthoStudio V4.d192e490.svg";

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3d-plan_roots.2b6ce76a.svg";

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3d-plan_DeepCBCT.babbae58.svg";

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3d-plan_general.b0580d48.svg";

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3d-plan_general_3Shape.ebcd32cb.svg";

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3d-plan_general_3Shape_Color.5affdeaa.svg";

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3d-plan_general_Archform.91197f67.svg";

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3d-plan_general_OnyxCeph3D.5329644a.svg";

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3d-plan_general SureSmile.e3c5e8be.svg";

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3d-plan_general OrthoStudio V5.56f0c372.svg";

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Teeth_alignment_modelling.ef8f0171.svg";

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3d-plan_general_Nemo.b7239887.svg";

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_progress_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_progress_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_progress_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_progress__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_upload_style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_dropzone__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormItem=__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item;// const Dragger = Upload.Dragger;
var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var CaseUploadCT=function(_Component){_inherits(CaseUploadCT,_Component);function CaseUploadCT(props){_classCallCheck(this,CaseUploadCT);var _this=_possibleConstructorReturn(this,(CaseUploadCT.__proto__||Object.getPrototypeOf(CaseUploadCT)).call(this,props));_this.state={fileList:[],fileUploadLinks:[],fileLoaded:0,fileProgress:0,fileUploading:false,patient_id:null,complieted_dict:{},showFileList:false};_this.tryToUpload=_this.tryToUpload.bind(_this);_this.createJob=_this.createJob.bind(_this);_this.uploadCompliete=_this.uploadCompliete.bind(_this);_this.createUploadLink=_this.createUploadLink.bind(_this);_this.sendToSpace=_this.sendToSpace.bind(_this);_this.setPatientId=_this.setPatientId.bind(_this);_this.incProgress=_this.incProgress.bind(_this);_this.toggleShowFileList=_this.toggleShowFileList.bind(_this);return _this;}_createClass(CaseUploadCT,[{key:'tryToUpload',value:function tryToUpload(){this.setState({fileUploading:true});this.createJob();}//TODO: Move to action/jobs
},{key:'createJob',value:function createJob(){var _this2=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_19__config__["b" /* API_CREATE_JOB */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({'patient_tag':this.state.patient_id})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(json){var fileList=[];_this2.state.fileList.forEach(function(file){fileList.push(file.name);});_this2.createUploadLink(fileList);});}},{key:'createUploadLink',value:function createUploadLink(fileList){var _this3=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_19__config__["c" /* API_CREATE_JOB_LINK */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify(fileList)}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(response){return response.json();}).then(function(json){return _this3.sendToSpace(json);}).catch(function(e){console.warn(e);});}},{key:'uploadCompliete',value:function uploadCompliete(){var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_19__config__["m" /* API_JOB_UPLOAD_COMPLETE */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'});}},{key:'sendToSpace',value:function sendToSpace(fileUploadLinks){var ComplietedDict={};if(fileUploadLinks){this.state.fileList.forEach(function(file){// fileUploadLinks.map((link_item)=>link_item.filename == file.name ? this.sendFile(link_item.link,file) : null)
fileUploadLinks.map(function(link_item){return link_item.filename==file.name?ComplietedDict[link_item.filename]={'link':link_item.link,'file':file}:null;});});}this.setState({'complieted_dict':ComplietedDict});this.sendFile();}},{key:'incProgress',value:function incProgress(){if(this.state.fileProgress!=this.state.fileList.length){this.setState({fileProgress:this.state.fileProgress+1});this.sendFile();}}},{key:'sendFile',value:function sendFile(){var _this4=this;var fileList=this.state.complieted_dict;if(Object.keys(fileList).length){var fileItem=Object.keys(fileList)[0];var URL=fileList[fileItem]['link'];var file=fileList[fileItem]['file'];var blob=new Blob([file],{type:file.type});fetch(URL,{method:'PUT',body:blob}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error('Upload Failed');}return response;})// .then((response) => console.warn(response))
.then(function(){delete fileList[fileItem];_this4.setState({complieted_dict:fileList});_this4.incProgress();if(_this4.state.fileProgress==_this4.state.fileList.length){_this4.setState({fileUploading:false,fileProgress:0,fileList:[],patient_id:null});__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success('Files has been uploaded!');_this4.uploadCompliete();_this4.props.history.push('/home');}}).catch(function(e){console.warn(e);__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error('Upload Failed');_this4.setState({fileUploading:false,fileProgress:0});});}}},{key:'setPatientId',value:function setPatientId(data){this.setState({'patient_id':data});}},{key:'toggleShowFileList',value:function toggleShowFileList(){this.setState({showFileList:!this.state.showFileList});}},{key:'render',value:function render(){var _this5=this;var formPatientField={labelCol:{span:10},wrapperCol:{span:6}};var formItemFiels={labelCol:{span:10},wrapperCol:{span:24}};var tailFormItemLayout={wrapperCol:{xs:{span:14,offset:0},sm:{span:14,offset:10}}};var uploadProgress=Math.round(this.state.fileProgress*100/this.state.fileList.length);return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_PanelBox__["a" /* default */],{title:"Case Upload"},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(FormItem,Object.assign({},formPatientField,{label:'Patient id',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:'user',style:{fontSize:13}}),id:'patient-id-input',value:this.state.patient_id?this.state.patient_id:"",onChange:function onChange(e){return _this5.setPatientId(e.target.value);},disabled:this.state.fileUploading,style:{width:100}}))),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(FormItem,formItemFiels,__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_dropzone__["a" /* default */],{accept:['.dcm','.dicom'],id:'dicom-dropzone',onDrop:function onDrop(e){_this5.setState(function(_ref){var fileList=_ref.fileList;return{fileList:e.map(function(elm,i){elm.uid=i;return elm;})};});},style:{border:'1px dashed #d9d9d9',transition:'border-color 0.3s',cursor:'pointer',borderRadius:'4px',textAlign:'center',width:'100%',height:'100%',position:'relative',padding:'16px 0',background:'#fafafa'}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p',{className:'ant-upload-drag-icon'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:'inbox'})),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p',{className:'ant-upload-text',style:{margin:10}},'Click or drag file to this area to upload')),this.state.fileList.length?__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',{className:'ant-upload-list-box'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',{style:{'cursor':'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',margin:10},onClick:function onClick(){return _this5.toggleShowFileList();}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:'copy',style:{margin:5}}),'files (',this.state.fileList.length,')'),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:this.state.showFileList?"caret-down":"caret-right"})),this.state.showFileList&&__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload___default.a,{fileList:this.state.fileList,onRemove:function onRemove(file){_this5.setState(function(_ref2){var fileList=_ref2.fileList;var index=fileList.indexOf(file);var newFileList=fileList.slice();newFileList.splice(index,1);return{fileList:newFileList};});}})):null,Boolean(uploadProgress)?__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_progress___default.a,{percent:uploadProgress,strokeWidth:5}):null)),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{loading:this.state.fileUploading,className:'upload-demo-start',id:'submit-new-case-button',type:'primary',onClick:this.tryToUpload,disabled:this.state.fileList.length&&this.state.patient_id?false:true},'Start Upload')));}}]);return CaseUploadCT;}(__WEBPACK_IMPORTED_MODULE_17_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_18_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CaseUploadCT));

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1044)();
}


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1045);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportMultiple; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getDataTransferItems;
/* harmony export (immutable) */ __webpack_exports__["b"] = fileAccepted;
/* harmony export (immutable) */ __webpack_exports__["c"] = fileMatchSize;
/* harmony export (immutable) */ __webpack_exports__["a"] = allFilesAccepted;
/* harmony export (immutable) */ __webpack_exports__["f"] = onDocumentDragOver;
/* harmony export (immutable) */ __webpack_exports__["e"] = isIeOrEdge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);


var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

function getDataTransferItems(event) {
  var dataTransferItemsList = [];
  if (event.dataTransfer) {
    var dt = event.dataTransfer;

    if (dt.files && dt.files.length) {
      dataTransferItemsList = dt.files;
    } else if (dt.items && dt.items.length) {
      // During the drag even the dataTransfer.files is null
      // but Chrome implements some drag store, which is accesible via dataTransfer.items
      dataTransferItemsList = dt.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }

  // Convert from DataTransferItemsList to the native Array
  return Array.prototype.slice.call(dataTransferItemsList);
}

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default()(file, accept);
}

function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}

function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
}

// allow the entire document to be a drag target
function onDocumentDragOver(evt) {
  evt.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

  return isIe(userAgent) || isEdge(userAgent);
}

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={i:e,l:!1,exports:{}};return t[e].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var r={};return n.m=t,n.c=r,n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=13)}([function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n){var r=t.exports={version:"2.5.0"};"number"==typeof __e&&(__e=r)},function(t,n,r){t.exports=!r(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(32)("wks"),o=r(9),i=r(0).Symbol,u="function"==typeof i;(t.exports=function(t){return e[t]||(e[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=e},function(t,n,r){var e=r(0),o=r(2),i=r(8),u=r(22),c=r(10),f=function(t,n,r){var a,s,p,l,v=t&f.F,y=t&f.G,h=t&f.S,d=t&f.P,x=t&f.B,g=y?e:h?e[n]||(e[n]={}):(e[n]||{}).prototype,m=y?o:o[n]||(o[n]={}),b=m.prototype||(m.prototype={});y&&(r=n);for(a in r)s=!v&&g&&void 0!==g[a],p=(s?g:r)[a],l=x&&s?c(p,e):d&&"function"==typeof p?c(Function.call,p):p,g&&u(g,a,p,t&f.U),m[a]!=p&&i(m,a,l),d&&b[a]!=p&&(b[a]=p)};e.core=o,f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f},function(t,n,r){var e=r(16),o=r(21);t.exports=r(3)?function(t,n,r){return e.f(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(24);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){var e=r(28),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";n.__esModule=!0,n.default=function(t,n){if(t&&n){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):n.endsWith("/*")?i===n.replace(/\/.*$/,""):o===n})}return!0},r(14),r(34)},function(t,n,r){r(15),t.exports=r(2).Array.some},function(t,n,r){"use strict";var e=r(7),o=r(25)(3);e(e.P+e.F*!r(33)([].some,!0),"Array",{some:function(t){return o(this,t,arguments[1])}})},function(t,n,r){var e=r(17),o=r(18),i=r(20),u=Object.defineProperty;n.f=r(3)?Object.defineProperty:function(t,n,r){if(e(t),n=i(n,!0),e(r),o)try{return u(t,n,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(t[n]=r.value),t}},function(t,n,r){var e=r(1);t.exports=function(t){if(!e(t))throw TypeError(t+" is not an object!");return t}},function(t,n,r){t.exports=!r(3)&&!r(4)(function(){return 7!=Object.defineProperty(r(19)("div"),"a",{get:function(){return 7}}).a})},function(t,n,r){var e=r(1),o=r(0).document,i=e(o)&&e(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,n,r){var e=r(1);t.exports=function(t,n){if(!e(t))return t;var r,o;if(n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;if("function"==typeof(r=t.valueOf)&&!e(o=r.call(t)))return o;if(!n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(0),o=r(8),i=r(23),u=r(9)("src"),c=Function.toString,f=(""+c).split("toString");r(2).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,c){var a="function"==typeof r;a&&(i(r,"name")||o(r,"name",n)),t[n]!==r&&(a&&(i(r,u)||o(r,u,t[n]?""+t[n]:f.join(String(n)))),t===e?t[n]=r:c?t[n]?t[n]=r:o(t,n,r):(delete t[n],o(t,n,r)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[u]||c.call(this)})},function(t,n){var r={}.hasOwnProperty;t.exports=function(t,n){return r.call(t,n)}},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n,r){var e=r(10),o=r(26),i=r(27),u=r(12),c=r(29);t.exports=function(t,n){var r=1==t,f=2==t,a=3==t,s=4==t,p=6==t,l=5==t||p,v=n||c;return function(n,c,y){for(var h,d,x=i(n),g=o(x),m=e(c,y,3),b=u(g.length),_=0,w=r?v(n,b):f?v(n,0):void 0;b>_;_++)if((l||_ in g)&&(h=g[_],d=m(h,_,x),t))if(r)w[_]=d;else if(d)switch(t){case 3:return!0;case 5:return h;case 6:return _;case 2:w.push(h)}else if(s)return!1;return p?-1:a||s?s:w}}},function(t,n,r){var e=r(5);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==e(t)?t.split(""):Object(t)}},function(t,n,r){var e=r(11);t.exports=function(t){return Object(e(t))}},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(30);t.exports=function(t,n){return new(e(t))(n)}},function(t,n,r){var e=r(1),o=r(31),i=r(6)("species");t.exports=function(t){var n;return o(t)&&(n=t.constructor,"function"!=typeof n||n!==Array&&!o(n.prototype)||(n=void 0),e(n)&&null===(n=n[i])&&(n=void 0)),void 0===n?Array:n}},function(t,n,r){var e=r(5);t.exports=Array.isArray||function(t){return"Array"==e(t)}},function(t,n,r){var e=r(0),o=e["__core-js_shared__"]||(e["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,n,r){"use strict";var e=r(4);t.exports=function(t,n){return!!t&&e(function(){n?t.call(null,function(){},1):t.call(null)})}},function(t,n,r){r(35),t.exports=r(2).String.endsWith},function(t,n,r){"use strict";var e=r(7),o=r(12),i=r(36),u="".endsWith;e(e.P+e.F*r(38)("endsWith"),"String",{endsWith:function(t){var n=i(this,t,"endsWith"),r=arguments.length>1?arguments[1]:void 0,e=o(n.length),c=void 0===r?e:Math.min(o(r),e),f=String(t);return u?u.call(n,f,c):n.slice(c-f.length,c)===f}})},function(t,n,r){var e=r(37),o=r(11);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){var e=r(1),o=r(5),i=r(6)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n,r){var e=r(6)("match");t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(r){try{return n[e]=!1,!"/./"[t](n)}catch(t){}}return!0}}]);

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  rejected: {
    borderStyle: 'solid',
    borderColor: '#c66',
    backgroundColor: '#eee'
  },
  disabled: {
    opacity: 0.5
  },
  active: {
    borderStyle: 'solid',
    borderColor: '#6c6',
    backgroundColor: '#eee'
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5
  }
});

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_progress_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_progress_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_progress_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_progress__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_upload_style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_dropzone__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormItem=__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item;// const Dragger = Upload.Dragger;
var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var CaseUploadCT=function(_Component){_inherits(CaseUploadCT,_Component);function CaseUploadCT(props){_classCallCheck(this,CaseUploadCT);var _this=_possibleConstructorReturn(this,(CaseUploadCT.__proto__||Object.getPrototypeOf(CaseUploadCT)).call(this,props));_this.state={fileList:[],fileUploadLinks:[],fileLoaded:0,fileProgress:0,fileUploading:false,patient_id:null,complieted_dict:{},showFileList:false};_this.tryToUpload=_this.tryToUpload.bind(_this);_this.createJob=_this.createJob.bind(_this);_this.uploadCompliete=_this.uploadCompliete.bind(_this);_this.createUploadLink=_this.createUploadLink.bind(_this);_this.sendToSpace=_this.sendToSpace.bind(_this);_this.setPatientId=_this.setPatientId.bind(_this);_this.incProgress=_this.incProgress.bind(_this);_this.toggleShowFileList=_this.toggleShowFileList.bind(_this);return _this;}_createClass(CaseUploadCT,[{key:'tryToUpload',value:function tryToUpload(){this.setState({fileUploading:true});this.createJob();}//TODO: Move to action/jobs
},{key:'createJob',value:function createJob(){var _this2=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_19__config__["b" /* API_CREATE_JOB */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({'patient_tag':this.state.patient_id,'flow':this.props.user.flow.filter(function(elm){return elm.type==='ct_align';})[0].uuid})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(json){var fileList=[];_this2.state.fileList.forEach(function(file){fileList.push(file.name);});_this2.createUploadLink(fileList);});}},{key:'createUploadLink',value:function createUploadLink(fileList){var _this3=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_19__config__["c" /* API_CREATE_JOB_LINK */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify(fileList)}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(response){return response.json();}).then(function(json){return _this3.sendToSpace(json);}).catch(function(e){console.warn(e);});}},{key:'uploadCompliete',value:function uploadCompliete(){var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_19__config__["m" /* API_JOB_UPLOAD_COMPLETE */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'});}},{key:'sendToSpace',value:function sendToSpace(fileUploadLinks){var ComplietedDict={};if(fileUploadLinks){this.state.fileList.forEach(function(file){// fileUploadLinks.map((link_item)=>link_item.filename == file.name ? this.sendFile(link_item.link,file) : null)
fileUploadLinks.map(function(link_item){return link_item.filename==file.name?ComplietedDict[link_item.filename]={'link':link_item.link,'file':file}:null;});});}this.setState({'complieted_dict':ComplietedDict});this.sendFile();}},{key:'incProgress',value:function incProgress(){if(this.state.fileProgress!=this.state.fileList.length){this.setState({fileProgress:this.state.fileProgress+1});this.sendFile();}}},{key:'sendFile',value:function sendFile(){var _this4=this;var fileList=this.state.complieted_dict;if(Object.keys(fileList).length){var fileItem=Object.keys(fileList)[0];var URL=fileList[fileItem]['link'];var file=fileList[fileItem]['file'];var blob=new Blob([file],{type:file.type});fetch(URL,{method:'PUT',body:blob}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error('Upload Failed');}return response;})// .then((response) => console.warn(response))
.then(function(){delete fileList[fileItem];_this4.setState({complieted_dict:fileList});_this4.incProgress();if(_this4.state.fileProgress==_this4.state.fileList.length){_this4.setState({fileUploading:false,fileProgress:0,fileList:[],patient_id:null});__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success('Files has been uploaded!');_this4.uploadCompliete();_this4.props.history.push('/home');}}).catch(function(e){console.warn(e);__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error('Upload Failed');_this4.setState({fileUploading:false,fileProgress:0});});}}},{key:'setPatientId',value:function setPatientId(data){this.setState({'patient_id':data});}},{key:'toggleShowFileList',value:function toggleShowFileList(){this.setState({showFileList:!this.state.showFileList});}},{key:'render',value:function render(){var _this5=this;var formPatientField={labelCol:{span:10},wrapperCol:{span:6}};var formItemFiels={labelCol:{span:10},wrapperCol:{span:24}};var tailFormItemLayout={wrapperCol:{xs:{span:14,offset:0},sm:{span:14,offset:10}}};var uploadProgress=Math.round(this.state.fileProgress*100/this.state.fileList.length);return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_PanelBox__["a" /* default */],{title:"Case Upload"},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(FormItem,Object.assign({},formPatientField,{label:'Patient id',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:'user',style:{fontSize:13}}),id:'patient-id-input',value:this.state.patient_id?this.state.patient_id:"",onChange:function onChange(e){return _this5.setPatientId(e.target.value);},disabled:this.state.fileUploading,style:{width:100}}))),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(FormItem,formItemFiels,__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_dropzone__["a" /* default */],{accept:['.zip','.obj'],id:'zipped-ct-dropzone',onDrop:function onDrop(e){_this5.setState(function(_ref){var fileList=_ref.fileList;return{fileList:e.map(function(elm,i){elm.uid=i;return elm;})};});},style:{border:'1px dashed #d9d9d9',transition:'border-color 0.3s',cursor:'pointer',borderRadius:'4px',textAlign:'center',width:'100%',height:'100%',position:'relative',padding:'16px 0',background:'#fafafa'}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p',{className:'ant-upload-drag-icon'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:'inbox'})),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p',{className:'ant-upload-text',style:{margin:10}},'Click or drag file to this area to upload')),this.state.fileList.length?__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',{className:'ant-upload-list-box'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',{style:{'cursor':'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',margin:10},onClick:function onClick(){return _this5.toggleShowFileList();}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:'copy',style:{margin:5}}),'files (',this.state.fileList.length,')'),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:this.state.showFileList?"caret-down":"caret-right"})),this.state.showFileList&&__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload___default.a,{fileList:this.state.fileList,onRemove:function onRemove(file){_this5.setState(function(_ref2){var fileList=_ref2.fileList;var index=fileList.indexOf(file);var newFileList=fileList.slice();newFileList.splice(index,1);return{fileList:newFileList};});}})):null,Boolean(uploadProgress)?__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_progress___default.a,{percent:uploadProgress,strokeWidth:5}):null)),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{loading:this.state.fileUploading,className:'upload-demo-start',id:'submit-new-case-button',type:'primary',onClick:this.tryToUpload,disabled:this.state.fileList.length&&this.state.patient_id?false:true},'Start Upload')));}}]);return CaseUploadCT;}(__WEBPACK_IMPORTED_MODULE_17_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_18_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CaseUploadCT));

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_progress_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_progress_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_progress_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_progress__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_upload_style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_dropzone__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormItem=__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item;// const Dragger = Upload.Dragger;
var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var CaseUploadCT=function(_Component){_inherits(CaseUploadCT,_Component);function CaseUploadCT(props){_classCallCheck(this,CaseUploadCT);var _this=_possibleConstructorReturn(this,(CaseUploadCT.__proto__||Object.getPrototypeOf(CaseUploadCT)).call(this,props));_this.state={fileList:[],fileUploadLinks:[],fileLoaded:0,fileProgress:0,fileUploading:false,patient_id:null,complieted_dict:{},showFileList:false};_this.tryToUpload=_this.tryToUpload.bind(_this);_this.createJob=_this.createJob.bind(_this);_this.uploadCompliete=_this.uploadCompliete.bind(_this);_this.createUploadLink=_this.createUploadLink.bind(_this);_this.sendToSpace=_this.sendToSpace.bind(_this);_this.setPatientId=_this.setPatientId.bind(_this);_this.incProgress=_this.incProgress.bind(_this);_this.toggleShowFileList=_this.toggleShowFileList.bind(_this);return _this;}_createClass(CaseUploadCT,[{key:'tryToUpload',value:function tryToUpload(){this.setState({fileUploading:true});this.createJob();}//TODO: Move to action/jobs
},{key:'createJob',value:function createJob(){var _this2=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_19__config__["b" /* API_CREATE_JOB */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({'patient_tag':this.state.patient_id,'flow':this.props.user.flow.filter(function(elm){return elm.type==='ct_v2';})[0].uuid})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(json){var fileList=[];_this2.state.fileList.forEach(function(file){fileList.push(file.name);});_this2.createUploadLink(fileList);});}},{key:'createUploadLink',value:function createUploadLink(fileList){var _this3=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_19__config__["c" /* API_CREATE_JOB_LINK */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify(fileList)}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(response){return response.json();}).then(function(json){return _this3.sendToSpace(json);}).catch(function(e){console.warn(e);});}},{key:'uploadCompliete',value:function uploadCompliete(){var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_19__config__["m" /* API_JOB_UPLOAD_COMPLETE */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'});}},{key:'sendToSpace',value:function sendToSpace(fileUploadLinks){var ComplietedDict={};if(fileUploadLinks){this.state.fileList.forEach(function(file){// fileUploadLinks.map((link_item)=>link_item.filename == file.name ? this.sendFile(link_item.link,file) : null)
fileUploadLinks.map(function(link_item){return link_item.filename==file.name?ComplietedDict[link_item.filename]={'link':link_item.link,'file':file}:null;});});}this.setState({'complieted_dict':ComplietedDict});this.sendFile();}},{key:'incProgress',value:function incProgress(){if(this.state.fileProgress!=this.state.fileList.length){this.setState({fileProgress:this.state.fileProgress+1});this.sendFile();}}},{key:'sendFile',value:function sendFile(){var _this4=this;var fileList=this.state.complieted_dict;if(Object.keys(fileList).length){var fileItem=Object.keys(fileList)[0];var URL=fileList[fileItem]['link'];var file=fileList[fileItem]['file'];var blob=new Blob([file],{type:file.type});fetch(URL,{method:'PUT',body:blob}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error('Upload Failed');}return response;})// .then((response) => console.warn(response))
.then(function(){delete fileList[fileItem];_this4.setState({complieted_dict:fileList});_this4.incProgress();if(_this4.state.fileProgress==_this4.state.fileList.length){_this4.setState({fileUploading:false,fileProgress:0,fileList:[],patient_id:null});__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success('Files has been uploaded!');_this4.uploadCompliete();_this4.props.history.push('/home');}}).catch(function(e){console.warn(e);__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error('Upload Failed');_this4.setState({fileUploading:false,fileProgress:0});});}}},{key:'setPatientId',value:function setPatientId(data){this.setState({'patient_id':data});}},{key:'toggleShowFileList',value:function toggleShowFileList(){this.setState({showFileList:!this.state.showFileList});}},{key:'render',value:function render(){var _this5=this;var formPatientField={labelCol:{span:10},wrapperCol:{span:6}};var formItemFiels={labelCol:{span:10},wrapperCol:{span:24}};var tailFormItemLayout={wrapperCol:{xs:{span:14,offset:0},sm:{span:14,offset:10}}};var uploadProgress=Math.round(this.state.fileProgress*100/this.state.fileList.length);return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_PanelBox__["a" /* default */],{title:"Case Upload"},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(FormItem,Object.assign({},formPatientField,{label:'Patient id',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:'user',style:{fontSize:13}}),id:'patient-id-input',value:this.state.patient_id?this.state.patient_id:"",onChange:function onChange(e){return _this5.setPatientId(e.target.value);},disabled:this.state.fileUploading,style:{width:100}}))),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(FormItem,formItemFiels,__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_dropzone__["a" /* default */],{accept:['.dcm','.dicom'],id:'dicom-dropzone',onDrop:function onDrop(e){_this5.setState(function(_ref){var fileList=_ref.fileList;return{fileList:e.map(function(elm,i){elm.uid=i;return elm;})};});},style:{border:'1px dashed #d9d9d9',transition:'border-color 0.3s',cursor:'pointer',borderRadius:'4px',textAlign:'center',width:'100%',height:'100%',position:'relative',padding:'16px 0',background:'#fafafa'}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p',{className:'ant-upload-drag-icon'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:'inbox'})),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p',{className:'ant-upload-text',style:{margin:10}},'Click or drag file to this area to upload')),this.state.fileList.length?__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',{className:'ant-upload-list-box'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',{style:{'cursor':'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',margin:10},onClick:function onClick(){return _this5.toggleShowFileList();}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:'copy',style:{margin:5}}),'files (',this.state.fileList.length,')'),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:this.state.showFileList?"caret-down":"caret-right"})),this.state.showFileList&&__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload___default.a,{fileList:this.state.fileList,onRemove:function onRemove(file){_this5.setState(function(_ref2){var fileList=_ref2.fileList;var index=fileList.indexOf(file);var newFileList=fileList.slice();newFileList.splice(index,1);return{fileList:newFileList};});}})):null,Boolean(uploadProgress)?__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_progress___default.a,{percent:uploadProgress,strokeWidth:5}):null)),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{loading:this.state.fileUploading,className:'upload-demo-start',id:'submit-new-case-button',type:'primary',onClick:this.tryToUpload,disabled:this.state.fileList.length&&this.state.patient_id?false:true},'Start Upload')));}}]);return CaseUploadCT;}(__WEBPACK_IMPORTED_MODULE_17_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_18_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CaseUploadCT));

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_progress_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_progress_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_progress_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_progress__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_upload_style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_dropzone__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormItem=__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item;// const Dragger = Upload.Dragger;
var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var CaseUploadCT=function(_Component){_inherits(CaseUploadCT,_Component);function CaseUploadCT(props){_classCallCheck(this,CaseUploadCT);var _this=_possibleConstructorReturn(this,(CaseUploadCT.__proto__||Object.getPrototypeOf(CaseUploadCT)).call(this,props));_this.state={fileList:[],fileUploadLinks:[],fileLoaded:0,fileProgress:0,fileUploading:false,patient_id:null,complieted_dict:{},showFileList:false};_this.tryToUpload=_this.tryToUpload.bind(_this);_this.createJob=_this.createJob.bind(_this);_this.uploadCompliete=_this.uploadCompliete.bind(_this);_this.createUploadLink=_this.createUploadLink.bind(_this);_this.sendToSpace=_this.sendToSpace.bind(_this);_this.setPatientId=_this.setPatientId.bind(_this);_this.incProgress=_this.incProgress.bind(_this);_this.toggleShowFileList=_this.toggleShowFileList.bind(_this);return _this;}_createClass(CaseUploadCT,[{key:'tryToUpload',value:function tryToUpload(){this.setState({fileUploading:true});this.createJob();}//TODO: Move to action/jobs
},{key:'createJob',value:function createJob(){var _this2=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_19__config__["b" /* API_CREATE_JOB */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({'patient_tag':this.state.patient_id,'flow':this.props.user.flow.filter(function(elm){return elm.type==='ct_v2_auto';})[0].uuid})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(json){var fileList=[];_this2.state.fileList.forEach(function(file){fileList.push(file.name);});_this2.createUploadLink(fileList);});}},{key:'createUploadLink',value:function createUploadLink(fileList){var _this3=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_19__config__["c" /* API_CREATE_JOB_LINK */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify(fileList)}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(response){return response.json();}).then(function(json){return _this3.sendToSpace(json);}).catch(function(e){console.warn(e);});}},{key:'uploadCompliete',value:function uploadCompliete(){var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_19__config__["m" /* API_JOB_UPLOAD_COMPLETE */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'});}},{key:'sendToSpace',value:function sendToSpace(fileUploadLinks){var ComplietedDict={};if(fileUploadLinks){this.state.fileList.forEach(function(file){// fileUploadLinks.map((link_item)=>link_item.filename == file.name ? this.sendFile(link_item.link,file) : null)
fileUploadLinks.map(function(link_item){return link_item.filename==file.name?ComplietedDict[link_item.filename]={'link':link_item.link,'file':file}:null;});});}this.setState({'complieted_dict':ComplietedDict});this.sendFile();}},{key:'incProgress',value:function incProgress(){if(this.state.fileProgress!=this.state.fileList.length){this.setState({fileProgress:this.state.fileProgress+1});this.sendFile();}}},{key:'sendFile',value:function sendFile(){var _this4=this;var fileList=this.state.complieted_dict;if(Object.keys(fileList).length){var fileItem=Object.keys(fileList)[0];var URL=fileList[fileItem]['link'];var file=fileList[fileItem]['file'];var blob=new Blob([file],{type:file.type});fetch(URL,{method:'PUT',body:blob}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error('Upload Failed');}return response;})// .then((response) => console.warn(response))
.then(function(){delete fileList[fileItem];_this4.setState({complieted_dict:fileList});_this4.incProgress();if(_this4.state.fileProgress==_this4.state.fileList.length){_this4.setState({fileUploading:false,fileProgress:0,fileList:[],patient_id:null});__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success('Files has been uploaded!');_this4.uploadCompliete();_this4.props.history.push('/home');}}).catch(function(e){console.warn(e);__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error('Upload Failed');_this4.setState({fileUploading:false,fileProgress:0});});}}},{key:'setPatientId',value:function setPatientId(data){this.setState({'patient_id':data});}},{key:'toggleShowFileList',value:function toggleShowFileList(){this.setState({showFileList:!this.state.showFileList});}},{key:'render',value:function render(){var _this5=this;var formPatientField={labelCol:{span:10},wrapperCol:{span:6}};var formItemFiels={labelCol:{span:10},wrapperCol:{span:24}};var tailFormItemLayout={wrapperCol:{xs:{span:14,offset:0},sm:{span:14,offset:10}}};var uploadProgress=Math.round(this.state.fileProgress*100/this.state.fileList.length);return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_PanelBox__["a" /* default */],{title:"Case Upload"},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(FormItem,Object.assign({},formPatientField,{label:'Patient id',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:'user',style:{fontSize:13}}),id:'patient-id-input',value:this.state.patient_id?this.state.patient_id:"",onChange:function onChange(e){return _this5.setPatientId(e.target.value);},disabled:this.state.fileUploading,style:{width:100}}))),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(FormItem,formItemFiels,__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_dropzone__["a" /* default */],{accept:['.dcm','.dicom'],id:'dicom-dropzone',onDrop:function onDrop(e){_this5.setState(function(_ref){var fileList=_ref.fileList;return{fileList:e.map(function(elm,i){elm.uid=i;return elm;})};});},style:{border:'1px dashed #d9d9d9',transition:'border-color 0.3s',cursor:'pointer',borderRadius:'4px',textAlign:'center',width:'100%',height:'100%',position:'relative',padding:'16px 0',background:'#fafafa'}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p',{className:'ant-upload-drag-icon'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:'inbox'})),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('p',{className:'ant-upload-text',style:{margin:10}},'Click or drag file to this area to upload')),this.state.fileList.length?__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',{className:'ant-upload-list-box'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',{style:{'cursor':'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',margin:10},onClick:function onClick(){return _this5.toggleShowFileList();}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:'copy',style:{margin:5}}),'files (',this.state.fileList.length,')'),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a,{type:this.state.showFileList?"caret-down":"caret-right"})),this.state.showFileList&&__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload___default.a,{fileList:this.state.fileList,onRemove:function onRemove(file){_this5.setState(function(_ref2){var fileList=_ref2.fileList;var index=fileList.indexOf(file);var newFileList=fileList.slice();newFileList.splice(index,1);return{fileList:newFileList};});}})):null,Boolean(uploadProgress)?__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_progress___default.a,{percent:uploadProgress,strokeWidth:5}):null)),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{loading:this.state.fileUploading,className:'upload-demo-start',id:'submit-new-case-button',type:'primary',onClick:this.tryToUpload,disabled:this.state.fileList.length&&this.state.patient_id?false:true},'Start Upload')));}}]);return CaseUploadCT;}(__WEBPACK_IMPORTED_MODULE_17_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_18_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CaseUploadCT));

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_upload__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_dropzone__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gums_svg__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gums_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gums_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_svgicons_attachments_svg__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_svgicons_attachments_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_svgicons_attachments_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_xls_svg__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_xls_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_svgicons_xls_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_json__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__api_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option;var FormItem=__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;// const Dragger = Upload.Dragger;
var formPatientField={labelCol:{span:10},wrapperCol:{span:6}};var formItemFiels={labelCol:{span:10},wrapperCol:{span:24}};var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var CaseUploadPlanStandart=function(_Component){_inherits(CaseUploadPlanStandart,_Component);function CaseUploadPlanStandart(props){_classCallCheck(this,CaseUploadPlanStandart);var _this=_possibleConstructorReturn(this,(CaseUploadPlanStandart.__proto__||Object.getPrototypeOf(CaseUploadPlanStandart)).call(this,props));console.log(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]);_this.state={fileList:[],planCloudProvider:null,planType:null,fileListGums:[],fileListLocks:[],fileListTeeth:[],fileListXLS:[],fileUploadLinks:[],fileLoaded:0,fileProgress:0,fileUploading:false,patient_id:null,complieted_dict:{},showFileListGums:false,showFileListLocks:false,showFileListTeeth:false,showFileListXLS:false};_this.uploadProgress=0;_this.tryToUpload=_this.tryToUpload.bind(_this);_this.createJob=_this.createJob.bind(_this);_this.uploadCompliete=_this.uploadCompliete.bind(_this);_this.createUploadLink=_this.createUploadLink.bind(_this);// this.sendToSpace = this.sendToSpace.bind(this)
_this.setPatientId=_this.setPatientId.bind(_this);_this.incProgress=_this.incProgress.bind(_this);_this.toggleShowFileList=_this.toggleShowFileList.bind(_this);_this.setPlanType=_this.setPlanType.bind(_this);_this.setPlanCloudProvider=_this.setPlanCloudProvider.bind(_this);_this.planTypes=[];_this.getPlanType().then(function(response){_this.planTypes=response;_this.forceUpdate();});_this.planCloudProviders=[];_this.getPlanCloudProvider().then(function(response){if(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]!=='standalone'){_this.planCloudProviders=response;_this.forceUpdate();}});return _this;}_createClass(CaseUploadPlanStandart,[{key:'setPlanType',value:function setPlanType(e){// this.state.planType = e;
this.setState({planType:e});}},{key:'setPlanCloudProvider',value:function setPlanCloudProvider(e){// this.state.planCloudProvider = e;
this.setState({planCloudProvider:e});}},{key:'getPlanType',value:function getPlanType(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["l" /* API_GET_PLAN_TYPE */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_TYPE }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'API_GET_PLAN_TYPE', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'getPlanCloudProvider',value:function getPlanCloudProvider(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["k" /* API_GET_PLAN_CLOUD_PROVIDER */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_CLOUD_PROVIDER }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'GET_PLAN_CLOUD_PROVIDER', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'tryToUpload',value:function tryToUpload(){this.setState({fileUploading:true});this.createJob();}},{key:'createLinks',value:function createLinks(){var _this2=this;this.state.fileListGums.forEach(function(elm){return elm._type='gums';});this.state.fileListLocks.forEach(function(elm){return elm._type='locks';});this.state.fileListTeeth.forEach(function(elm){return elm._type='teeth';});this.state.fileListXLS.forEach(function(elm){return elm._type='xls';});var fileListGums=this.state.fileListGums.map(function(elm){return elm.name;});var fileListLocks=this.state.fileListLocks.map(function(elm){return elm.name;});var fileListTeeth=this.state.fileListTeeth.map(function(elm){return elm.name;});var fileListXLS=this.state.fileListXLS.map(function(elm){return elm.name;});this.createUploadLink(fileListGums,'gums').then(function(gumsJson){_this2.createUploadLink(fileListLocks,'locks').then(function(locksJson){_this2.createUploadLink(fileListTeeth,'teeth').then(function(teethJson){_this2.createUploadLink(fileListXLS,'xls').then(function(xlsJson){_this2.state.fileList=[].concat(_toConsumableArray(_this2.state.fileListGums),_toConsumableArray(_this2.state.fileListLocks),_toConsumableArray(_this2.state.fileListTeeth),_toConsumableArray(_this2.state.fileListXLS));_this2.sendToSpace(gumsJson,locksJson,teethJson,xlsJson);});});});});}//TODO: Move to action/jobs
},{key:'createJob',value:function createJob(){var _this3=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["b" /* API_CREATE_JOB */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({'patient_tag':this.state.patient_id,'plan_cloud_provider':this.state.planCloudProvider,'plan_type':this.state.planType,'flow':this.props.user.flow.filter(function(elm){return elm.type==='plan_standart';})[0].uuid})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(){return _this3.createLinks();});}},{key:'createUploadLink',value:function createUploadLink(files,folder){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["d" /* API_CREATE_JOB_LINK_FOR_PLAN */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({files:files,folder:folder})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(response){return response.json();}).catch(function(e){console.warn(e);});}},{key:'uploadCompliete',value:function uploadCompliete(){var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["m" /* API_JOB_UPLOAD_COMPLETE */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'});}},{key:'sendToSpace',value:function sendToSpace(gumsJson,locksJson,teethJson,xlsJson){var ComplietedDict={};if(gumsJson&&locksJson&&teethJson&&xlsJson){this.state.fileList.forEach(function(file){gumsJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['gums_'+link_item.filename]={'link':link_item.link,'file':file}:null;});locksJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['locks_'+link_item.filename]={'link':link_item.link,'file':file}:null;});teethJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['teeth_'+link_item.filename]={'link':link_item.link,'file':file}:null;});xlsJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['xls_'+link_item.filename]={'link':link_item.link,'file':file}:null;});});}this.setState({'complieted_dict':ComplietedDict});this.sendFile();}},{key:'incProgress',value:function incProgress(){if(this.state.fileProgress!=this.state.fileList.length){this.setState({fileProgress:this.state.fileProgress+1});this.sendFile();}}},{key:'sendFile',value:function sendFile(){var _this4=this;var fileList=this.state.complieted_dict;if(Object.keys(fileList).length){var fileItem=Object.keys(fileList)[0];var URL=fileList[fileItem]['link'];var file=fileList[fileItem]['file'];var blob=new Blob([file],{type:file.type});fetch(URL,{method:'PUT',body:blob}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('Upload Failed');}return response;})// .then((response) => console.warn(response))
.then(function(){delete fileList[fileItem];_this4.setState({complieted_dict:fileList});_this4.incProgress();if(_this4.state.fileProgress==_this4.state.fileList.length){_this4.setState({fileUploading:false,fileProgress:0,fileList:[],patient_id:null});__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success('Files has been uploaded!');_this4.uploadCompliete();setTimeout(function(){_this4.props.history.push('/home');},100);}}).catch(function(e){console.warn(e);__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('Upload Failed');_this4.setState({fileUploading:false,fileProgress:0});});}}},{key:'setPatientId',value:function setPatientId(data){this.setState({'patient_id':data});}},{key:'toggleShowFileList',value:function toggleShowFileList(showFileList){var obj={};obj[showFileList]=!this.state[showFileList];this.setState(obj);}},{key:'renderUploadItem',value:function renderUploadItem(fileList,format,icon,name,showFileList){var _this5=this;return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,Object.assign({},formItemFiels,{style:{padding:'0 5px 0 5px',marginBottom:'0'}}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_dropzone__["a" /* default */],{accept:format,id:name+'-dropzone',onDrop:function onDrop(e){_this5.setState(function(state){var obj={};obj[fileList]=e.map(function(elm,i){elm.uid=i;return elm;});return obj;});},style:{border:'1px dashed #d9d9d9',transition:'border-color 0.3s',cursor:'pointer',borderRadius:'4px',textAlign:'center',width:'100%',height:'100%',position:'relative',padding:'16px 0',background:'#fafafa'}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p',{className:'ant-upload-drag-icon'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('img',{src:icon,style:{width:'100px'}})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p',{className:'ant-upload-text',style:{margin:10}},'Drag to upload ',name,' files')),this.state[fileList].length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',{className:'ant-upload-list-box'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',{style:{'cursor':'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',margin:10},onClick:function onClick(){return _this5.toggleShowFileList(showFileList);}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:'copy',style:{margin:5}}),'files (',this.state[fileList].length,')'),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:this.state[showFileList]?"caret-down":"caret-right"})),this.state[showFileList]&&__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_upload___default.a,{fileList:this.state[fileList],onRemove:function onRemove(file){_this5.setState(function(state){var index=state[fileList].indexOf(file);var newFileList=state[fileList].slice();newFileList.splice(index,1);var obj={};obj[fileList]=newFileList;return obj;});}})):null);}},{key:'render',value:function render(){var _this6=this;if(!(this.state.fileList.length===0&&this.uploadProgress>0)){this.uploadProgress=Math.round(this.state.fileProgress*100/this.state.fileList.length);}return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_PanelBox__["a" /* default */],{title:"Case Upload"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,Object.assign({},formPatientField,{label:'Patient id',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:'user',style:{fontSize:13}}),id:'patient-id-input',value:this.state.patient_id?this.state.patient_id:"",onChange:function onChange(e){return _this6.setPatientId(e.target.value);},disabled:this.state.fileUploading,style:{width:100}}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center',style:{display:'inline-flex'}},this.renderUploadItem('fileListGums','.stl',__WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gums_svg___default.a,'gums','showFileListGums'),this.renderUploadItem('fileListLocks','.stl',__WEBPACK_IMPORTED_MODULE_25__assets_svgicons_attachments_svg___default.a,'locks','showFileListLocks'),this.renderUploadItem('fileListTeeth','.stl',__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg___default.a,'teeth','showFileListTeeth'),this.renderUploadItem('fileListXLS','.xls',__WEBPACK_IMPORTED_MODULE_27__assets_svgicons_xls_svg___default.a,'xls','showFileListXLS'),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{style:{width:'calc(100% - 42px)',marginBottom:'24px',padding:'0 20px 0 22px'}},Boolean(this.uploadProgress)?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default.a,{percent:this.uploadProgress,strokeWidth:5}):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,null,this.planTypes.length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-type-selector',defaultValue:'selectPlanType',onChange:this.setPlanType},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanType',key:'selectPlanType'},'Select Plan Type'),this.planTypes.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-type-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,null,this.planCloudProviders.length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-cloud-provider-selector',defaultValue:'selectPlanCloudProviders',onChange:this.setPlanCloudProvider},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanCloudProviders',key:'selectPlanCloudProviders'},'Select Plan Cloud Provider'),this.planCloudProviders.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-cloud-provider-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{loading:this.state.fileUploading,className:'upload-demo-start',id:'submit-new-case-button',type:'primary',onClick:this.tryToUpload,disabled:this.state.fileListGums.length&&// this.state.fileListLocks.length &&
this.state.fileListTeeth.length&&this.state.fileListXLS.length&&this.state.planType&&(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]==='standalone'||this.state.planCloudProvider)&&this.state.patient_id?false:true},'Start Upload')));}}]);return CaseUploadPlanStandart;}(__WEBPACK_IMPORTED_MODULE_19_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_20_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CaseUploadPlanStandart));

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_progress_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_progress_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_progress_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_progress__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_upload__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_select_style__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_dropzone__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_roots_svg__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_roots_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_roots_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_bone_svg__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_bone_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_svgicons_bone_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=__WEBPACK_IMPORTED_MODULE_19_antd_lib_select___default.a.Option;var FormItem=__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;// const Dragger = Upload.Dragger;
var formPatientField={labelCol:{span:10},wrapperCol:{span:6}};var formItemFiels={labelCol:{span:10},wrapperCol:{span:24}};var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var parseNames=function parseNames(name,type){var res='';var dotParts=name.trim().split('.');var parts=dotParts[0].split('_');if(parts.indexOf('upper')>-1||parts.indexOf('u')>-1){res='upper_'+type;}else if(parts.indexOf('lower')>-1||parts.indexOf('l')>-1){res='lower_'+type;}return res+'.'+dotParts[1];};var CaseUploadPlanStandart=function(_Component){_inherits(CaseUploadPlanStandart,_Component);function CaseUploadPlanStandart(props){_classCallCheck(this,CaseUploadPlanStandart);var _this=_possibleConstructorReturn(this,(CaseUploadPlanStandart.__proto__||Object.getPrototypeOf(CaseUploadPlanStandart)).call(this,props));_this.state={fileList:[],fileListRoots:[],fileListBone:[],fileUploadLinks:[],fileLoaded:0,fileProgress:0,fileUploading:false,movement_plan_id:null,complieted_dict:{},showFileListRoots:false,showFileListBone:false,remodel:false};_this.uploadProgress=0;_this.tryToUpload=_this.tryToUpload.bind(_this);_this.createJob=_this.createJob.bind(_this);_this.uploadCompliete=_this.uploadCompliete.bind(_this);_this.createUploadLink=_this.createUploadLink.bind(_this);// this.sendToSpace = this.sendToSpace.bind(this)
_this.incProgress=_this.incProgress.bind(_this);_this.toggleShowFileList=_this.toggleShowFileList.bind(_this);return _this;}_createClass(CaseUploadPlanStandart,[{key:'componentDidMount',value:function componentDidMount(){var urlParams=window.location.pathname.split('/case/upload/plan-roots/');if(urlParams.length>1){this.setMovementPlanId(urlParams.pop());}}},{key:'tryToUpload',value:function tryToUpload(){this.setState({fileUploading:true});this.createJob();}},{key:'createLinks',value:function createLinks(){var _this2=this;var fileListRoots=this.state.fileListRoots.map(function(elm){return elm.name;});var fileListBone=this.state.fileListBone.map(function(elm){return parseNames(elm.name,'jaw');});this.createUploadLink(fileListRoots,'teeth').then(function(rootsJson){_this2.createUploadLink(fileListBone,'jaws').then(function(boneJson){_this2.state.fileList=[].concat(_toConsumableArray(_this2.state.fileListRoots),_toConsumableArray(_this2.state.fileListBone.map(function(elm){return new File([elm],parseNames(elm.name,'jaw'),{type:'application/vnd.ms-pkistl'});})));_this2.sendToSpace(rootsJson,boneJson);});});}//TODO: Move to action/jobs
},{key:'createJob',value:function createJob(){var _this3=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["b" /* API_CREATE_JOB */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({'job_crown_uuid':this.state.movement_plan_id,'flow':this.props.user.flow.filter(function(elm){return elm.type==='plan_roots';})[0].uuid,'remodel':this.state.remodel})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(){return _this3.createLinks();});}},{key:'createUploadLink',value:function createUploadLink(files,folder){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["d" /* API_CREATE_JOB_LINK_FOR_PLAN */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({files:files,folder:folder})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(response){return response.json();}).catch(function(e){console.warn(e);});}},{key:'uploadCompliete',value:function uploadCompliete(){var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["m" /* API_JOB_UPLOAD_COMPLETE */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'});}},{key:'sendToSpace',value:function sendToSpace(rootsJson,boneJson){var ComplietedDict={};if(rootsJson&&boneJson){this.state.fileList.forEach(function(file){rootsJson.map(function(link_item){return link_item.filename==file.name?ComplietedDict['roots_'+link_item.filename]={'link':link_item.link,'file':file}:null;});boneJson.map(function(link_item){return link_item.filename==file.name?ComplietedDict['bone_'+link_item.filename]={'link':link_item.link,'file':file}:null;});});}this.setState({'complieted_dict':ComplietedDict});this.sendFile();}},{key:'incProgress',value:function incProgress(){if(this.state.fileProgress!=this.state.fileList.length){this.setState({fileProgress:this.state.fileProgress+1});this.sendFile();}}},{key:'sendFile',value:function sendFile(){var _this4=this;var fileList=this.state.complieted_dict;if(Object.keys(fileList).length){var fileItem=Object.keys(fileList)[0];var URL=fileList[fileItem]['link'];var file=fileList[fileItem]['file'];var blob=new Blob([file],{type:file.type});fetch(URL,{method:'PUT',body:blob}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('Upload Failed');}return response;})// .then((response) => console.warn(response))
.then(function(){delete fileList[fileItem];_this4.setState({complieted_dict:fileList});_this4.incProgress();if(_this4.state.fileProgress==_this4.state.fileList.length){_this4.setState({fileUploading:false,fileProgress:0,fileList:[],movement_plan_id:null});__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success('Files has been uploaded!');_this4.uploadCompliete();setTimeout(function(){_this4.props.history.push('/home');},100);}}).catch(function(e){console.warn(e);__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('Upload Failed');_this4.setState({fileUploading:false,fileProgress:0});});}}},{key:'setMovementPlanId',value:function setMovementPlanId(data){this.setState({'movement_plan_id':data});}},{key:'toggleShowFileList',value:function toggleShowFileList(showFileList){var obj={};obj[showFileList]=!this.state[showFileList];this.setState(obj);}},{key:'renderUploadItem',value:function renderUploadItem(fileList,format,icon,name,showFileList){var _this5=this;return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(FormItem,Object.assign({},formItemFiels,{style:{padding:'0 5px 0 5px',marginBottom:'0'}}),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_react_dropzone__["a" /* default */],{accept:format,id:name+'-dropzone',onDrop:function onDrop(e){_this5.setState(function(state){var obj={};obj[fileList]=e.map(function(elm,i){elm.uid=i;return elm;});return obj;});},style:{border:'1px dashed #d9d9d9',transition:'border-color 0.3s',cursor:'pointer',borderRadius:'4px',textAlign:'center',width:'100%',height:'100%',position:'relative',padding:'16px 0',background:'#fafafa'}},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('p',{className:'ant-upload-drag-icon'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('img',{src:icon,style:{width:'100px'}})),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('p',{className:'ant-upload-text',style:{margin:10}},'Drag to upload ',name,' files')),this.state[fileList].length?__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div',{className:'ant-upload-list-box'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div',{style:{'cursor':'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',margin:10},onClick:function onClick(){return _this5.toggleShowFileList(showFileList);}},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a,{type:'copy',style:{margin:5}}),'files (',this.state[fileList].length,')'),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a,{type:this.state[showFileList]?"caret-down":"caret-right"})),this.state[showFileList]&&__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_upload___default.a,{fileList:this.state[fileList],onRemove:function onRemove(file){_this5.setState(function(state){var index=state[fileList].indexOf(file);var newFileList=state[fileList].slice();newFileList.splice(index,1);var obj={};obj[fileList]=newFileList;return obj;});}})):null);}},{key:'render',value:function render(){var _this6=this;if(!(this.state.fileList.length===0&&this.uploadProgress>0)){this.uploadProgress=Math.round(this.state.fileProgress*100/this.state.fileList.length);}return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_PanelBox__["a" /* default */],{title:"Case Upload"},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center',style:{display:'inline-flex'}},this.renderUploadItem('fileListRoots','.stl',__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_roots_svg___default.a,'roots','showFileListRoots'),this.renderUploadItem('fileListBone','.stl',__WEBPACK_IMPORTED_MODULE_27__assets_svgicons_bone_svg___default.a,'bone','showFileListBone'),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{style:{width:'calc(100% - 42px)',marginBottom:'24px',padding:'0 20px 0 22px'}},Boolean(this.uploadProgress)?__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_progress___default.a,{percent:this.uploadProgress,strokeWidth:5}):null)),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default.a,{onChange:function onChange(evt){return _this6.setState({remodel:evt.target.checked});}}),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('span',null,'Remodelling')),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(FormItem,{label:'Reference crown movement plan id',hasFeedback:true},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a,{type:'user',style:{fontSize:13}}),value:this.state.movement_plan_id,onChange:function onChange(e){return _this6.setMovementPlanId(e.target.value);},disabled:this.state.fileUploading,style:{width:'100%'}}))),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{loading:this.state.fileUploading,className:'upload-demo-start',type:'primary',onClick:this.tryToUpload,disabled:this.state.fileListRoots.length&&this.state.fileListBone.length&&this.state.movement_plan_id?false:true},'Start Upload')));}}]);return CaseUploadPlanStandart;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_22_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CaseUploadPlanStandart));

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_upload__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_dropzone__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gum_svg__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gum_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gum_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_svgicons_roots_svg__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_svgicons_roots_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_svgicons_roots_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_bone_svg__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_bone_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_bone_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__api_json__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__api_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__api_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option;var FormItem=__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;// const Dragger = Upload.Dragger;
var formPatientField={labelCol:{span:10},wrapperCol:{span:6}};var formItemFiels={labelCol:{span:10},wrapperCol:{span:24}};var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var parseNames=function parseNames(name,type){var res='';var dotParts=name.trim().replace(/\s/g,'_').split('.');var parts=dotParts[0].split('_');if(parts.indexOf('upper')>-1||parts.indexOf('u')>-1){res='upper_'+type;}else if(parts.indexOf('lower')>-1||parts.indexOf('l')>-1){res='lower_'+type;}return res+'.'+dotParts[1];};var CaseUploadPlanDeepCT=function(_Component){_inherits(CaseUploadPlanDeepCT,_Component);function CaseUploadPlanDeepCT(props){_classCallCheck(this,CaseUploadPlanDeepCT);var _this=_possibleConstructorReturn(this,(CaseUploadPlanDeepCT.__proto__||Object.getPrototypeOf(CaseUploadPlanDeepCT)).call(this,props));_this.state={fileList:[],planCloudProvider:null,fileListGum:[],fileListRoots:[],fileListBone:[],fileUploadLinks:[],fileLoaded:0,fileProgress:0,fileUploading:false,patient_id:null,complieted_dict:{},showFileListGum:false,showFileListRoots:false,showFileListBone:false};_this.uploadProgress=0;_this.tryToUpload=_this.tryToUpload.bind(_this);_this.createJob=_this.createJob.bind(_this);_this.uploadCompliete=_this.uploadCompliete.bind(_this);_this.createUploadLink=_this.createUploadLink.bind(_this);// this.sendToSpace = this.sendToSpace.bind(this)
_this.setPatientId=_this.setPatientId.bind(_this);_this.incProgress=_this.incProgress.bind(_this);_this.toggleShowFileList=_this.toggleShowFileList.bind(_this);_this.setPlanCloudProvider=_this.setPlanCloudProvider.bind(_this);_this.planCloudProviders=[];_this.getPlanCloudProvider().then(function(response){if(__WEBPACK_IMPORTED_MODULE_27__api_json__["type"]!=='standalone'){_this.planCloudProviders=response;_this.forceUpdate();}});return _this;}_createClass(CaseUploadPlanDeepCT,[{key:'setPlanCloudProvider',value:function setPlanCloudProvider(e){// this.state.planCloudProvider = e;
this.setState({planCloudProvider:e});}},{key:'getPlanCloudProvider',value:function getPlanCloudProvider(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["k" /* API_GET_PLAN_CLOUD_PROVIDER */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_CLOUD_PROVIDER }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'GET_PLAN_CLOUD_PROVIDER', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'tryToUpload',value:function tryToUpload(){this.setState({fileUploading:true});this.createJob();}},{key:'createLinks',value:function createLinks(){var _this2=this;var fileListGum=this.state.fileListGum.map(function(elm){return parseNames(elm.name,'gum');});var fileListRoots=this.state.fileListRoots.map(function(elm){return parseNames(elm.name,'teeth');});var fileListBone=this.state.fileListBone.map(function(elm){return parseNames(elm.name,'jaw');});this.createUploadLink(fileListGum,'gums').then(function(gumJson){_this2.createUploadLink(fileListRoots,'teeth').then(function(rootsJson){_this2.createUploadLink(fileListBone,'bone').then(function(boneJson){_this2.state.fileList=[].concat(_toConsumableArray(_this2.state.fileListGum.map(function(elm){return new File([elm],parseNames(elm.name,'gum'),{type:'application/vnd.ms-pkistl'});})),_toConsumableArray(_this2.state.fileListRoots.map(function(elm){return new File([elm],parseNames(elm.name,'teeth'),{type:'application/vnd.ms-pkistl'});})),_toConsumableArray(_this2.state.fileListBone.map(function(elm){return new File([elm],parseNames(elm.name,'jaw'),{type:'application/vnd.ms-pkistl'});})));_this2.sendToSpace(gumJson,rootsJson,boneJson);});});});}},{key:'createJob',value:function createJob(){var _this3=this;var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["l" /* API_GET_PLAN_TYPE */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_TYPE }: "+response.statusText);}return response;}).then(function(response){return response.json();}).then(function(json){var plan_type=json.filter(function(elm){return elm.name==='Initial condition';})[0].uuid;fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["b" /* API_CREATE_JOB */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({'patient_tag':_this3.state.patient_id,plan_type:plan_type,'plan_cloud_provider':_this3.state.planCloudProvider,'flow':_this3.props.user.flow.filter(function(elm){return elm.type==='plan_deep_ct';})[0].uuid})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(){return _this3.createLinks();});}).catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}//TODO: Move to action/jobs
// createJob(plan_type) {
//   let token = localStorage.getItem('token')
//   fetch(switch_api(API_CREATE_JOB), {
//     method: 'POST',
//     headers: {
//       'Accept': 'application/json',
//       'Authorization': 'Token '+token,
//       'Content-Type': 'application/json; charset=utf-8'
//     },
//     credentials: 'include',
//     body: JSON.stringify({
//       'patient_tag': this.state.patient_id,
//       plan_type,
//       'plan_cloud_provider': this.state.planCloudProvider,
//       'flow': this.props.user.flow.filter((elm) => (elm.type === 'plan_deep_ct'))[0].uuid
//     })
//   })
//   .then((response) => {
//     if (!response.ok) {
//       console.error("Failed loading { API_CREATE_LINK }: " + response.statusText);
//     }
//     return response;
//   })
//   .then(() => this.createLinks())
// }
},{key:'createUploadLink',value:function createUploadLink(files,folder){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["d" /* API_CREATE_JOB_LINK_FOR_PLAN */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({files:files,folder:folder})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(response){return response.json();}).catch(function(e){console.warn(e);});}},{key:'uploadCompliete',value:function uploadCompliete(){var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["m" /* API_JOB_UPLOAD_COMPLETE */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'});}},{key:'sendToSpace',value:function sendToSpace(gumJson,rootsJson,boneJson){var ComplietedDict={};if(gumJson&&rootsJson&&boneJson){this.state.fileList.forEach(function(file){gumJson.map(function(link_item){return link_item.filename==file.name?ComplietedDict['gum_'+link_item.filename]={'link':link_item.link,'file':file}:null;});rootsJson.map(function(link_item){return link_item.filename==file.name?ComplietedDict['roots_'+link_item.filename]={'link':link_item.link,'file':file}:null;});boneJson.map(function(link_item){return link_item.filename==file.name?ComplietedDict['bone_'+link_item.filename]={'link':link_item.link,'file':file}:null;});});}this.setState({'complieted_dict':ComplietedDict});this.sendFile();}},{key:'incProgress',value:function incProgress(){if(this.state.fileProgress!=this.state.fileList.length){this.setState({fileProgress:this.state.fileProgress+1});this.sendFile();}}},{key:'sendFile',value:function sendFile(){var _this4=this;var fileList=this.state.complieted_dict;if(Object.keys(fileList).length){var fileItem=Object.keys(fileList)[0];var URL=fileList[fileItem]['link'];var file=fileList[fileItem]['file'];var blob=new Blob([file],{type:file.type});fetch(URL,{method:'PUT',body:blob}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('Upload Failed');}return response;})// .then((response) => console.warn(response))
.then(function(){delete fileList[fileItem];_this4.setState({complieted_dict:fileList});_this4.incProgress();if(_this4.state.fileProgress==_this4.state.fileList.length){_this4.setState({fileUploading:false,fileProgress:0,fileList:[],patient_id:null});__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success('Files has been uploaded!');_this4.uploadCompliete();setTimeout(function(){_this4.props.history.push('/home');},100);}}).catch(function(e){console.warn(e);__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('Upload Failed');_this4.setState({fileUploading:false,fileProgress:0});});}}},{key:'setPatientId',value:function setPatientId(data){this.setState({'patient_id':data});}},{key:'toggleShowFileList',value:function toggleShowFileList(showFileList){var obj={};obj[showFileList]=!this.state[showFileList];this.setState(obj);}},{key:'renderUploadItem',value:function renderUploadItem(fileList,format,icon,name,showFileList){var _this5=this;return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,Object.assign({},formItemFiels,{style:{padding:'0 5px 0 5px',marginBottom:'0'}}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_dropzone__["a" /* default */],{accept:format,id:name+'-dropzone',onDrop:function onDrop(e){_this5.setState(function(state){var obj={};obj[fileList]=e.map(function(elm,i){elm.uid=i;return elm;});return obj;});},style:{border:'1px dashed #d9d9d9',transition:'border-color 0.3s',cursor:'pointer',borderRadius:'4px',textAlign:'center',width:'100%',height:'100%',position:'relative',padding:'16px 0',background:'#fafafa'}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p',{className:'ant-upload-drag-icon'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('img',{src:icon,style:{width:'100px'}})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p',{className:'ant-upload-text',style:{margin:10}},'Drag to upload ',name,' files')),this.state[fileList].length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',{className:'ant-upload-list-box'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',{style:{'cursor':'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',margin:10},onClick:function onClick(){return _this5.toggleShowFileList(showFileList);}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:'copy',style:{margin:5}}),'files (',this.state[fileList].length,')'),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:this.state[showFileList]?"caret-down":"caret-right"})),this.state[showFileList]&&__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_upload___default.a,{fileList:this.state[fileList],onRemove:function onRemove(file){_this5.setState(function(state){var index=state[fileList].indexOf(file);var newFileList=state[fileList].slice();newFileList.splice(index,1);var obj={};obj[fileList]=newFileList;return obj;});}})):null);}},{key:'render',value:function render(){var _this6=this;if(!(this.state.fileList.length===0&&this.uploadProgress>0)){this.uploadProgress=Math.round(this.state.fileProgress*100/this.state.fileList.length);}return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_PanelBox__["a" /* default */],{title:"Case Upload"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,Object.assign({},formPatientField,{label:'Patient id',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:'user',style:{fontSize:13}}),id:'patient-id-input',value:this.state.patient_id?this.state.patient_id:"",onChange:function onChange(e){return _this6.setPatientId(e.target.value);},disabled:this.state.fileUploading,style:{width:100}}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center',style:{display:'inline-flex'}},this.renderUploadItem('fileListRoots','.stl',__WEBPACK_IMPORTED_MODULE_25__assets_svgicons_roots_svg___default.a,'roots','showFileListRoots'),this.renderUploadItem('fileListBone','.stl',__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_bone_svg___default.a,'bone','showFileListBone'),this.renderUploadItem('fileListGum','.stl',__WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gum_svg___default.a,'gum','showFileListGum'),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{style:{width:'calc(100% - 42px)',marginBottom:'24px',padding:'0 20px 0 22px'}},Boolean(this.uploadProgress)?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default.a,{percent:this.uploadProgress,strokeWidth:5}):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,null,this.planCloudProviders.length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,defaultValue:'selectPlanCloudProviders',onChange:this.setPlanCloudProvider},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanCloudProviders',key:'selectPlanCloudProviders'},'Select Plan Cloud Provider'),this.planCloudProviders.map(function(elm){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{value:elm.uuid,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{loading:this.state.fileUploading,className:'upload-demo-start',id:'submit-new-case-button',type:'primary',onClick:this.tryToUpload,disabled:this.state.fileListGum.length&&this.state.fileListRoots.length&&this.state.fileListBone.length&&(__WEBPACK_IMPORTED_MODULE_27__api_json__["type"]==='standalone'||this.state.planCloudProvider)&&this.state.patient_id?false:true},'Start Upload')));}}]);return CaseUploadPlanDeepCT;}(__WEBPACK_IMPORTED_MODULE_19_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_20_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CaseUploadPlanDeepCT));

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gum.cef7154e.svg";

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_upload__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_dropzone__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gums_svg__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gums_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gums_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_svgicons_attachments_svg__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_svgicons_attachments_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_svgicons_attachments_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_xls_svg__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_xls_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_svgicons_xls_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_json__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__api_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option;var FormItem=__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;// const Dragger = Upload.Dragger;
var formPatientField={labelCol:{span:10},wrapperCol:{span:6}};var formItemFiels={labelCol:{span:10},wrapperCol:{span:24}};var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var CaseUploadPlanStandart=function(_Component){_inherits(CaseUploadPlanStandart,_Component);function CaseUploadPlanStandart(props){_classCallCheck(this,CaseUploadPlanStandart);var _this=_possibleConstructorReturn(this,(CaseUploadPlanStandart.__proto__||Object.getPrototypeOf(CaseUploadPlanStandart)).call(this,props));console.log(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]);_this.state={fileList:[],planCloudProvider:null,planType:null,fileListGums:[],fileListLocks:[],fileListTeeth:[],fileListXLS:[],fileUploadLinks:[],fileLoaded:0,fileProgress:0,fileUploading:false,patient_id:null,complieted_dict:{},showFileListGums:false,showFileListLocks:false,showFileListTeeth:false,showFileListXLS:false};_this.uploadProgress=0;_this.tryToUpload=_this.tryToUpload.bind(_this);_this.createJob=_this.createJob.bind(_this);_this.uploadCompliete=_this.uploadCompliete.bind(_this);_this.createUploadLink=_this.createUploadLink.bind(_this);// this.sendToSpace = this.sendToSpace.bind(this)
_this.setPatientId=_this.setPatientId.bind(_this);_this.incProgress=_this.incProgress.bind(_this);_this.toggleShowFileList=_this.toggleShowFileList.bind(_this);_this.setPlanType=_this.setPlanType.bind(_this);_this.setPlanCloudProvider=_this.setPlanCloudProvider.bind(_this);_this.planTypes=[];_this.getPlanType().then(function(response){_this.planTypes=response;_this.forceUpdate();});_this.planCloudProviders=[];_this.getPlanCloudProvider().then(function(response){if(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]!=='standalone'){_this.planCloudProviders=response;_this.forceUpdate();}});return _this;}_createClass(CaseUploadPlanStandart,[{key:'setPlanType',value:function setPlanType(e){// this.state.planType = e;
this.setState({planType:e});}},{key:'setPlanCloudProvider',value:function setPlanCloudProvider(e){// this.state.planCloudProvider = e;
this.setState({planCloudProvider:e});}},{key:'getPlanType',value:function getPlanType(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["l" /* API_GET_PLAN_TYPE */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_TYPE }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'API_GET_PLAN_TYPE', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'getPlanCloudProvider',value:function getPlanCloudProvider(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["k" /* API_GET_PLAN_CLOUD_PROVIDER */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_CLOUD_PROVIDER }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'GET_PLAN_CLOUD_PROVIDER', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'tryToUpload',value:function tryToUpload(){this.setState({fileUploading:true});this.createJob();}},{key:'createLinks',value:function createLinks(){var _this2=this;this.state.fileListGums.forEach(function(elm){return elm._type='gums';});this.state.fileListLocks.forEach(function(elm){return elm._type='locks';});this.state.fileListTeeth.forEach(function(elm){return elm._type='teeth';});this.state.fileListXLS.forEach(function(elm){return elm._type='xls';});var fileListGums=this.state.fileListGums.map(function(elm){return elm.name;});var fileListLocks=this.state.fileListLocks.map(function(elm){return elm.name;});var fileListTeeth=this.state.fileListTeeth.map(function(elm){return elm.name;});var fileListXLS=this.state.fileListXLS.map(function(elm){return elm.name;});this.createUploadLink(fileListGums,'gums').then(function(gumsJson){_this2.createUploadLink(fileListLocks,'locks').then(function(locksJson){_this2.createUploadLink(fileListTeeth,'teeth').then(function(teethJson){_this2.createUploadLink(fileListXLS,'xls').then(function(xlsJson){_this2.state.fileList=[].concat(_toConsumableArray(_this2.state.fileListGums),_toConsumableArray(_this2.state.fileListLocks),_toConsumableArray(_this2.state.fileListTeeth),_toConsumableArray(_this2.state.fileListXLS));_this2.sendToSpace(gumsJson,locksJson,teethJson,xlsJson);});});});});}//TODO: Move to action/jobs
},{key:'createJob',value:function createJob(){var _this3=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["b" /* API_CREATE_JOB */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({'patient_tag':this.state.patient_id,'plan_cloud_provider':this.state.planCloudProvider,'plan_type':this.state.planType,'flow':this.props.user.flow.filter(function(elm){return elm.type==='plan_standard_orthostudio';})[0].uuid})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(){return _this3.createLinks();});}},{key:'createUploadLink',value:function createUploadLink(files,folder){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["d" /* API_CREATE_JOB_LINK_FOR_PLAN */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({files:files,folder:folder})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(response){return response.json();}).catch(function(e){console.warn(e);});}},{key:'uploadCompliete',value:function uploadCompliete(){var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["m" /* API_JOB_UPLOAD_COMPLETE */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'});}},{key:'sendToSpace',value:function sendToSpace(gumsJson,locksJson,teethJson,xlsJson){var ComplietedDict={};if(gumsJson&&locksJson&&teethJson&&xlsJson){this.state.fileList.forEach(function(file){gumsJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['gums_'+link_item.filename]={'link':link_item.link,'file':file}:null;});locksJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['locks_'+link_item.filename]={'link':link_item.link,'file':file}:null;});teethJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['teeth_'+link_item.filename]={'link':link_item.link,'file':file}:null;});xlsJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['xls_'+link_item.filename]={'link':link_item.link,'file':file}:null;});});}this.setState({'complieted_dict':ComplietedDict});this.sendFile();}},{key:'incProgress',value:function incProgress(){if(this.state.fileProgress!=this.state.fileList.length){this.setState({fileProgress:this.state.fileProgress+1});this.sendFile();}}},{key:'sendFile',value:function sendFile(){var _this4=this;var fileList=this.state.complieted_dict;if(Object.keys(fileList).length){var fileItem=Object.keys(fileList)[0];var URL=fileList[fileItem]['link'];var file=fileList[fileItem]['file'];var blob=new Blob([file],{type:file.type});fetch(URL,{method:'PUT',body:blob}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('Upload Failed');}return response;})// .then((response) => console.warn(response))
.then(function(){delete fileList[fileItem];_this4.setState({complieted_dict:fileList});_this4.incProgress();if(_this4.state.fileProgress==_this4.state.fileList.length){_this4.setState({fileUploading:false,fileProgress:0,fileList:[],patient_id:null});__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success('Files has been uploaded!');_this4.uploadCompliete();setTimeout(function(){_this4.props.history.push('/home');},100);}}).catch(function(e){console.warn(e);__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('Upload Failed');_this4.setState({fileUploading:false,fileProgress:0});});}}},{key:'setPatientId',value:function setPatientId(data){this.setState({'patient_id':data});}},{key:'toggleShowFileList',value:function toggleShowFileList(showFileList){var obj={};obj[showFileList]=!this.state[showFileList];this.setState(obj);}},{key:'renderUploadItem',value:function renderUploadItem(fileList,format,icon,name,showFileList){var _this5=this;return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,Object.assign({},formItemFiels,{style:{padding:'0 5px 0 5px',marginBottom:'0'}}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_dropzone__["a" /* default */],{accept:format,id:name+'-dropzone',onDrop:function onDrop(e){_this5.setState(function(state){var obj={};obj[fileList]=e.map(function(elm,i){elm.uid=i;return elm;});return obj;});},style:{border:'1px dashed #d9d9d9',transition:'border-color 0.3s',cursor:'pointer',borderRadius:'4px',textAlign:'center',width:'100%',height:'100%',position:'relative',padding:'16px 0',background:'#fafafa'}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p',{className:'ant-upload-drag-icon'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('img',{src:icon,style:{width:'100px'}})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p',{className:'ant-upload-text',style:{margin:10}},'Drag to upload ',name,' files')),this.state[fileList].length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',{className:'ant-upload-list-box'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',{style:{'cursor':'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',margin:10},onClick:function onClick(){return _this5.toggleShowFileList(showFileList);}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:'copy',style:{margin:5}}),'files (',this.state[fileList].length,')'),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:this.state[showFileList]?"caret-down":"caret-right"})),this.state[showFileList]&&__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_upload___default.a,{fileList:this.state[fileList],onRemove:function onRemove(file){_this5.setState(function(state){var index=state[fileList].indexOf(file);var newFileList=state[fileList].slice();newFileList.splice(index,1);var obj={};obj[fileList]=newFileList;return obj;});}})):null);}},{key:'render',value:function render(){var _this6=this;if(!(this.state.fileList.length===0&&this.uploadProgress>0)){this.uploadProgress=Math.round(this.state.fileProgress*100/this.state.fileList.length);}return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_PanelBox__["a" /* default */],{title:"Case Upload"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,Object.assign({},formPatientField,{label:'Patient id',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:'user',style:{fontSize:13}}),id:'patient-id-input',value:this.state.patient_id?this.state.patient_id:"",onChange:function onChange(e){return _this6.setPatientId(e.target.value);},disabled:this.state.fileUploading,style:{width:100}}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center',style:{display:'inline-flex'}},this.renderUploadItem('fileListGums','.stl',__WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gums_svg___default.a,'gums','showFileListGums'),this.renderUploadItem('fileListLocks','.stl',__WEBPACK_IMPORTED_MODULE_25__assets_svgicons_attachments_svg___default.a,'locks','showFileListLocks'),this.renderUploadItem('fileListTeeth','.stl',__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg___default.a,'teeth','showFileListTeeth'),this.renderUploadItem('fileListXLS','.xls',__WEBPACK_IMPORTED_MODULE_27__assets_svgicons_xls_svg___default.a,'xls','showFileListXLS'),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{style:{width:'calc(100% - 42px)',marginBottom:'24px',padding:'0 20px 0 22px'}},Boolean(this.uploadProgress)?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default.a,{percent:this.uploadProgress,strokeWidth:5}):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,null,this.planTypes.length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-type-selector',defaultValue:'selectPlanType',onChange:this.setPlanType},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanType',key:'selectPlanType'},'Select Plan Type'),this.planTypes.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-type-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,null,this.planCloudProviders.length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-cloud-provider-selector',defaultValue:'selectPlanCloudProviders',onChange:this.setPlanCloudProvider},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanCloudProviders',key:'selectPlanCloudProviders'},'Select Plan Cloud Provider'),this.planCloudProviders.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-cloud-provider-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{loading:this.state.fileUploading,className:'upload-demo-start',id:'submit-new-case-button',type:'primary',onClick:this.tryToUpload,disabled:this.state.fileListGums.length&&// this.state.fileListLocks.length &&
this.state.fileListTeeth.length&&this.state.fileListXLS.length&&this.state.planType&&(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]==='standalone'||this.state.planCloudProvider)&&this.state.patient_id?false:true},'Start Upload')));}}]);return CaseUploadPlanStandart;}(__WEBPACK_IMPORTED_MODULE_19_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_20_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CaseUploadPlanStandart));

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_upload_style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_upload__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_dropzone__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_pdf_svg__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_pdf_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_svgicons_pdf_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_json__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__api_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import gums from '../../assets/svgicons/gums.svg';
// import locks from '../../assets/svgicons/attachments.svg';
// import xls from '../../assets/svgicons/xls.svg';
var Option=__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option;var FormItem=__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item;// const Dragger = Upload.Dragger;
var formPatientField={labelCol:{span:10},wrapperCol:{span:6}};var formItemFiels={labelCol:{span:10},wrapperCol:{span:24}};var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var CaseUploadPlanStandart=function(_Component){_inherits(CaseUploadPlanStandart,_Component);function CaseUploadPlanStandart(props){_classCallCheck(this,CaseUploadPlanStandart);var _this=_possibleConstructorReturn(this,(CaseUploadPlanStandart.__proto__||Object.getPrototypeOf(CaseUploadPlanStandart)).call(this,props));_this.state={fileList:[],planCloudProvider:null,planType:null,// fileListGums: [],
// fileListLocks: [],
fileListTeeth:[],// fileListXLS: [],
fileListPDF:[],fileUploadLinks:[],fileLoaded:0,fileProgress:0,fileUploading:false,patient_id:null,complieted_dict:{},// showFileListGums: false,
// showFileListLocks: false,
showFileListTeeth:false,// showFileListXLS: false,
showFileListPDF:false,pdf:false};_this.uploadProgress=0;_this.tryToUpload=_this.tryToUpload.bind(_this);_this.createJob=_this.createJob.bind(_this);_this.uploadCompliete=_this.uploadCompliete.bind(_this);_this.createUploadLink=_this.createUploadLink.bind(_this);// this.sendToSpace = this.sendToSpace.bind(this)
_this.setPatientId=_this.setPatientId.bind(_this);_this.incProgress=_this.incProgress.bind(_this);_this.toggleShowFileList=_this.toggleShowFileList.bind(_this);_this.setPlanType=_this.setPlanType.bind(_this);_this.setPlanCloudProvider=_this.setPlanCloudProvider.bind(_this);_this.planTypes=[];_this.getPlanType().then(function(response){_this.planTypes=response;_this.forceUpdate();});_this.planCloudProviders=[];_this.getPlanCloudProvider().then(function(response){if(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]!=='standalone'){_this.planCloudProviders=response;_this.forceUpdate();}});return _this;}_createClass(CaseUploadPlanStandart,[{key:'setPlanType',value:function setPlanType(e){// this.state.planType = e;
this.setState({planType:e});}},{key:'setPlanCloudProvider',value:function setPlanCloudProvider(e){// this.state.planCloudProvider = e;
this.setState({planCloudProvider:e});}},{key:'getPlanType',value:function getPlanType(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["l" /* API_GET_PLAN_TYPE */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_TYPE }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'API_GET_PLAN_TYPE', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'getPlanCloudProvider',value:function getPlanCloudProvider(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["k" /* API_GET_PLAN_CLOUD_PROVIDER */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_CLOUD_PROVIDER }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'GET_PLAN_CLOUD_PROVIDER', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'tryToUpload',value:function tryToUpload(){this.setState({fileUploading:true});this.createJob();}},{key:'createLinks',value:function createLinks(){var _this2=this;this.state.fileListTeeth.forEach(function(elm){return elm._type='teeth';});this.state.fileListPDF.forEach(function(elm){return elm._type='pdf';});var fileListTeeth=this.state.fileListTeeth.map(function(elm){return elm.name;});var fileListPDF=this.state.fileListPDF.map(function(elm){return elm.name;});this.createUploadLink(fileListTeeth,'teeth').then(function(teethJson){_this2.createUploadLink(fileListPDF,'pdf').then(function(pdfJson){_this2.state.fileList=[].concat(_toConsumableArray(_this2.state.fileListTeeth),_toConsumableArray(_this2.state.fileListPDF));_this2.sendToSpace(teethJson,pdfJson);});// this.state.fileList = [
//   ...this.state.fileListTeeth,
// ];
// this.sendToSpace(teethJson);
});}//TODO: Move to action/jobs
},{key:'createJob',value:function createJob(){var _this3=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["b" /* API_CREATE_JOB */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({'patient_tag':this.state.patient_id,'plan_cloud_provider':this.state.planCloudProvider,'plan_type':this.state.planType,'flow':this.props.user.flow.filter(function(elm){return elm.type==='plan_standard_3shape_1c';})[0].uuid})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(){return _this3.createLinks();});}},{key:'createUploadLink',value:function createUploadLink(files,folder){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["d" /* API_CREATE_JOB_LINK_FOR_PLAN */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({files:files,folder:folder})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(response){return response.json();}).catch(function(e){console.warn(e);});}},{key:'uploadCompliete',value:function uploadCompliete(){var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["m" /* API_JOB_UPLOAD_COMPLETE */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'});}},{key:'sendToSpace',value:function sendToSpace(teethJson,pdfJson){var ComplietedDict={};if(teethJson&&pdfJson){this.state.fileList.forEach(function(file){teethJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['teeth_'+link_item.filename]={'link':link_item.link,'file':file}:null;});pdfJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['pdf_'+link_item.filename]={'link':link_item.link,'file':file}:null;});});}this.setState({'complieted_dict':ComplietedDict});this.sendFile();}},{key:'incProgress',value:function incProgress(){if(this.state.fileProgress!=this.state.fileList.length){this.setState({fileProgress:this.state.fileProgress+1});this.sendFile();}}},{key:'sendFile',value:function sendFile(){var _this4=this;var fileList=this.state.complieted_dict;if(Object.keys(fileList).length){var fileItem=Object.keys(fileList)[0];var URL=fileList[fileItem]['link'];var file=fileList[fileItem]['file'];var blob=new Blob([file],{type:file.type});fetch(URL,{method:'PUT',body:blob}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);__WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error('Upload Failed');}return response;})// .then((response) => console.warn(response))
.then(function(){delete fileList[fileItem];_this4.setState({complieted_dict:fileList});_this4.incProgress();if(_this4.state.fileProgress==_this4.state.fileList.length){_this4.setState({fileUploading:false,fileProgress:0,fileList:[],patient_id:null});__WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.success('Files has been uploaded!');_this4.uploadCompliete();setTimeout(function(){_this4.props.history.push('/home');},100);}}).catch(function(e){console.warn(e);__WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error('Upload Failed');_this4.setState({fileUploading:false,fileProgress:0});});}}},{key:'setPatientId',value:function setPatientId(data){this.setState({'patient_id':data});}},{key:'toggleShowFileList',value:function toggleShowFileList(showFileList){var obj={};obj[showFileList]=!this.state[showFileList];this.setState(obj);}},{key:'renderUploadItem',value:function renderUploadItem(fileList,format,icon,name,showFileList){var _this5=this;return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(FormItem,Object.assign({},formItemFiels,{style:{padding:'0 5px 0 5px',marginBottom:'0'}}),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_react_dropzone__["a" /* default */],{accept:format,id:name+'-dropzone',onDrop:function onDrop(e){_this5.setState(function(state){var obj={};obj[fileList]=e.map(function(elm,i){elm.uid=i;return elm;});return obj;});},style:{border:'1px dashed #d9d9d9',transition:'border-color 0.3s',cursor:'pointer',borderRadius:'4px',textAlign:'center',width:'100%',height:'100%',position:'relative',padding:'16px 0',background:'#fafafa'}},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('p',{className:'ant-upload-drag-icon'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('img',{src:icon,style:{width:'100px'}})),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('p',{className:'ant-upload-text',style:{margin:10}},'Drag to upload ',name,' files')),this.state[fileList].length?__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div',{className:'ant-upload-list-box'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div',{style:{'cursor':'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',margin:10},onClick:function onClick(){return _this5.toggleShowFileList(showFileList);}},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default.a,{type:'copy',style:{margin:5}}),'files (',this.state[fileList].length,')'),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default.a,{type:this.state[showFileList]?"caret-down":"caret-right"})),this.state[showFileList]&&__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_upload___default.a,{fileList:this.state[fileList],onRemove:function onRemove(file){_this5.setState(function(state){var index=state[fileList].indexOf(file);var newFileList=state[fileList].slice();newFileList.splice(index,1);var obj={};obj[fileList]=newFileList;return obj;});}})):null);}},{key:'render',value:function render(){var _this6=this;if(!(this.state.fileList.length===0&&this.uploadProgress>0)){this.uploadProgress=Math.round(this.state.fileProgress*100/this.state.fileList.length);}return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_PanelBox__["a" /* default */],{title:"Case Upload"},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(FormItem,Object.assign({},formPatientField,{label:'Patient id',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default.a,{type:'user',style:{fontSize:13}}),id:'patient-id-input',value:this.state.patient_id?this.state.patient_id:"",onChange:function onChange(e){return _this6.setPatientId(e.target.value);},disabled:this.state.fileUploading,style:{width:100}}))),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default.a,{onChange:function onChange(evt){return _this6.setState({pdf:evt.target.checked});}}),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('span',null,'Add PDF')),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center',style:{display:'inline-flex'}},this.renderUploadItem('fileListTeeth','.stl',__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg___default.a,'teeth','showFileListTeeth'),this.state.pdf?this.renderUploadItem('fileListPDF','.pdf',__WEBPACK_IMPORTED_MODULE_27__assets_svgicons_pdf_svg___default.a,'pdf','showFileListPDF'):null,__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{style:{width:'calc(100% - 42px)',marginBottom:'24px',padding:'0 20px 0 22px'}},Boolean(this.uploadProgress)?__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default.a,{percent:this.uploadProgress,strokeWidth:5}):null)),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(FormItem,null,this.planTypes.length?__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-type-selector',defaultValue:'selectPlanType',onChange:this.setPlanType},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanType',key:'selectPlanType'},'Select Plan Type'),this.planTypes.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-type-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(FormItem,null,this.planCloudProviders.length?__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-cloud-provider-selector',defaultValue:'selectPlanCloudProviders',onChange:this.setPlanCloudProvider},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanCloudProviders',key:'selectPlanCloudProviders'},'Select Plan Cloud Provider'),this.planCloudProviders.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-cloud-provider-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{loading:this.state.fileUploading,className:'upload-demo-start',id:'submit-new-case-button',type:'primary',onClick:this.tryToUpload,disabled:this.state.fileListTeeth.length&&this.state.planType&&(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]==='standalone'||this.state.planCloudProvider)&&this.state.patient_id?false:true},'Start Upload')));}}]);return CaseUploadPlanStandart;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_22_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CaseUploadPlanStandart));

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_upload__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_dropzone__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gums_svg__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gums_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gums_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_svgicons_attachments_svg__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_svgicons_attachments_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_svgicons_attachments_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_xls_svg__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_xls_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_svgicons_xls_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_json__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__api_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option;var FormItem=__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;// const Dragger = Upload.Dragger;
var formPatientField={labelCol:{span:10},wrapperCol:{span:6}};var formItemFiels={labelCol:{span:10},wrapperCol:{span:24}};var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var CaseUploadPlanStandart=function(_Component){_inherits(CaseUploadPlanStandart,_Component);function CaseUploadPlanStandart(props){_classCallCheck(this,CaseUploadPlanStandart);var _this=_possibleConstructorReturn(this,(CaseUploadPlanStandart.__proto__||Object.getPrototypeOf(CaseUploadPlanStandart)).call(this,props));_this.state={fileList:[],planCloudProvider:null,planType:null,fileListGums:[],fileListLocks:[],fileListTeeth:[],fileListXLS:[],fileUploadLinks:[],fileLoaded:0,fileProgress:0,fileUploading:false,patient_id:null,complieted_dict:{},// showFileListGums: false,
// showFileListLocks: false,
showFileListTeeth:false// showFileListXLS: false
};_this.uploadProgress=0;_this.tryToUpload=_this.tryToUpload.bind(_this);_this.createJob=_this.createJob.bind(_this);_this.uploadCompliete=_this.uploadCompliete.bind(_this);_this.createUploadLink=_this.createUploadLink.bind(_this);// this.sendToSpace = this.sendToSpace.bind(this)
_this.setPatientId=_this.setPatientId.bind(_this);_this.incProgress=_this.incProgress.bind(_this);_this.toggleShowFileList=_this.toggleShowFileList.bind(_this);_this.setPlanType=_this.setPlanType.bind(_this);_this.setPlanCloudProvider=_this.setPlanCloudProvider.bind(_this);_this.planTypes=[];_this.getPlanType().then(function(response){_this.planTypes=response;_this.forceUpdate();});_this.planCloudProviders=[];_this.getPlanCloudProvider().then(function(response){if(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]!=='standalone'){_this.planCloudProviders=response;_this.forceUpdate();}});return _this;}_createClass(CaseUploadPlanStandart,[{key:'setPlanType',value:function setPlanType(e){// this.state.planType = e;
this.setState({planType:e});}},{key:'setPlanCloudProvider',value:function setPlanCloudProvider(e){// this.state.planCloudProvider = e;
this.setState({planCloudProvider:e});}},{key:'getPlanType',value:function getPlanType(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["l" /* API_GET_PLAN_TYPE */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_TYPE }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'API_GET_PLAN_TYPE', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'getPlanCloudProvider',value:function getPlanCloudProvider(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["k" /* API_GET_PLAN_CLOUD_PROVIDER */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_CLOUD_PROVIDER }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'GET_PLAN_CLOUD_PROVIDER', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'tryToUpload',value:function tryToUpload(){this.setState({fileUploading:true});this.createJob();}},{key:'createLinks',value:function createLinks(){var _this2=this;this.state.fileListTeeth.forEach(function(elm){return elm._type='teeth';});var fileListTeeth=this.state.fileListTeeth.map(function(elm){return elm.name;});this.createUploadLink(fileListTeeth,'teeth').then(function(teethJson){_this2.state.fileList=[].concat(_toConsumableArray(_this2.state.fileListTeeth));_this2.sendToSpace(teethJson);});}//TODO: Move to action/jobs
},{key:'createJob',value:function createJob(){var _this3=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["b" /* API_CREATE_JOB */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({'patient_tag':this.state.patient_id,'plan_cloud_provider':this.state.planCloudProvider,'plan_type':this.state.planType,'flow':this.props.user.flow.filter(function(elm){return elm.type==='plan_standard_3shape_color';})[0].uuid})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(){return _this3.createLinks();});}},{key:'createUploadLink',value:function createUploadLink(files,folder){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["d" /* API_CREATE_JOB_LINK_FOR_PLAN */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({files:files,folder:folder})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(response){return response.json();}).catch(function(e){console.warn(e);});}},{key:'uploadCompliete',value:function uploadCompliete(){var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["m" /* API_JOB_UPLOAD_COMPLETE */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'});}},{key:'sendToSpace',value:function sendToSpace(teethJson){var ComplietedDict={};if(teethJson){this.state.fileList.forEach(function(file){teethJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['teeth_'+link_item.filename]={'link':link_item.link,'file':file}:null;});});}this.setState({'complieted_dict':ComplietedDict});this.sendFile();}},{key:'incProgress',value:function incProgress(){if(this.state.fileProgress!=this.state.fileList.length){this.setState({fileProgress:this.state.fileProgress+1});this.sendFile();}}},{key:'sendFile',value:function sendFile(){var _this4=this;var fileList=this.state.complieted_dict;if(Object.keys(fileList).length){var fileItem=Object.keys(fileList)[0];var URL=fileList[fileItem]['link'];var file=fileList[fileItem]['file'];var blob=new Blob([file],{type:file.type});fetch(URL,{method:'PUT',body:blob}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('Upload Failed');}return response;})// .then((response) => console.warn(response))
.then(function(){delete fileList[fileItem];_this4.setState({complieted_dict:fileList});_this4.incProgress();if(_this4.state.fileProgress==_this4.state.fileList.length){_this4.setState({fileUploading:false,fileProgress:0,fileList:[],patient_id:null});__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success('Files has been uploaded!');_this4.uploadCompliete();setTimeout(function(){_this4.props.history.push('/home');},100);}}).catch(function(e){console.warn(e);__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('Upload Failed');_this4.setState({fileUploading:false,fileProgress:0});});}}},{key:'setPatientId',value:function setPatientId(data){this.setState({'patient_id':data});}},{key:'toggleShowFileList',value:function toggleShowFileList(showFileList){var obj={};obj[showFileList]=!this.state[showFileList];this.setState(obj);}},{key:'renderUploadItem',value:function renderUploadItem(fileList,format,icon,name,showFileList){var _this5=this;return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,Object.assign({},formItemFiels,{style:{padding:'0 5px 0 5px',marginBottom:'0'}}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_dropzone__["a" /* default */],{accept:format,id:name+'-dropzone',onDrop:function onDrop(e){_this5.setState(function(state){var obj={};obj[fileList]=e.map(function(elm,i){elm.uid=i;return elm;});return obj;});},style:{border:'1px dashed #d9d9d9',transition:'border-color 0.3s',cursor:'pointer',borderRadius:'4px',textAlign:'center',width:'100%',height:'100%',position:'relative',padding:'16px 0',background:'#fafafa'}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p',{className:'ant-upload-drag-icon'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('img',{src:icon,style:{width:'100px'}})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p',{className:'ant-upload-text',style:{margin:10}},'Drag to upload ',name,' files')),this.state[fileList].length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',{className:'ant-upload-list-box'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',{style:{'cursor':'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',margin:10},onClick:function onClick(){return _this5.toggleShowFileList(showFileList);}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:'copy',style:{margin:5}}),'files (',this.state[fileList].length,')'),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:this.state[showFileList]?"caret-down":"caret-right"})),this.state[showFileList]&&__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_upload___default.a,{fileList:this.state[fileList],onRemove:function onRemove(file){_this5.setState(function(state){var index=state[fileList].indexOf(file);var newFileList=state[fileList].slice();newFileList.splice(index,1);var obj={};obj[fileList]=newFileList;return obj;});}})):null);}},{key:'render',value:function render(){var _this6=this;if(!(this.state.fileList.length===0&&this.uploadProgress>0)){this.uploadProgress=Math.round(this.state.fileProgress*100/this.state.fileList.length);}return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_PanelBox__["a" /* default */],{title:"Case Upload"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,Object.assign({},formPatientField,{label:'Patient id',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:'user',style:{fontSize:13}}),id:'patient-id-input',value:this.state.patient_id?this.state.patient_id:"",onChange:function onChange(e){return _this6.setPatientId(e.target.value);},disabled:this.state.fileUploading,style:{width:100}}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center',style:{display:'inline-flex'}},this.renderUploadItem('fileListTeeth',['.wrl','.jpg','.jpeg'],__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg___default.a,'teeth','showFileListTeeth'),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{style:{width:'calc(100% - 42px)',marginBottom:'24px',padding:'0 20px 0 22px'}},Boolean(this.uploadProgress)?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default.a,{percent:this.uploadProgress,strokeWidth:5}):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,null,this.planTypes.length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-type-selector',defaultValue:'selectPlanType',onChange:this.setPlanType},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanType',key:'selectPlanType'},'Select Plan Type'),this.planTypes.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-type-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,null,this.planCloudProviders.length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-cloud-provider-selector',defaultValue:'selectPlanCloudProviders',onChange:this.setPlanCloudProvider},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanCloudProviders',key:'selectPlanCloudProviders'},'Select Plan Cloud Provider'),this.planCloudProviders.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-cloud-provider-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{loading:this.state.fileUploading,className:'upload-demo-start',id:'submit-new-case-button',type:'primary',onClick:this.tryToUpload,disabled:this.state.fileListTeeth.length&&this.state.planType&&(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]==='standalone'||this.state.planCloudProvider)&&this.state.patient_id?false:true},'Start Upload')));}}]);return CaseUploadPlanStandart;}(__WEBPACK_IMPORTED_MODULE_19_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_20_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CaseUploadPlanStandart));

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_upload__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_dropzone__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gums_svg__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gums_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gums_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_svgicons_attachments_svg__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_svgicons_attachments_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_svgicons_attachments_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_xls_svg__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_xls_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_svgicons_xls_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_json__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__api_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option;var FormItem=__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;// const Dragger = Upload.Dragger;
var formPatientField={labelCol:{span:10},wrapperCol:{span:6}};var formItemFiels={labelCol:{span:10},wrapperCol:{span:24}};var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var CaseUploadPlanStandart=function(_Component){_inherits(CaseUploadPlanStandart,_Component);function CaseUploadPlanStandart(props){_classCallCheck(this,CaseUploadPlanStandart);var _this=_possibleConstructorReturn(this,(CaseUploadPlanStandart.__proto__||Object.getPrototypeOf(CaseUploadPlanStandart)).call(this,props));_this.state={fileList:[],planCloudProvider:null,planType:null,fileListGums:[],fileListLocks:[],fileListTeeth:[],fileListXLS:[],fileUploadLinks:[],fileLoaded:0,fileProgress:0,fileUploading:false,patient_id:null,complieted_dict:{},// showFileListGums: false,
// showFileListLocks: false,
showFileListTeeth:false// showFileListXLS: false
};_this.uploadProgress=0;_this.tryToUpload=_this.tryToUpload.bind(_this);_this.createJob=_this.createJob.bind(_this);_this.uploadCompliete=_this.uploadCompliete.bind(_this);_this.createUploadLink=_this.createUploadLink.bind(_this);// this.sendToSpace = this.sendToSpace.bind(this)
_this.setPatientId=_this.setPatientId.bind(_this);_this.incProgress=_this.incProgress.bind(_this);_this.toggleShowFileList=_this.toggleShowFileList.bind(_this);_this.setPlanType=_this.setPlanType.bind(_this);_this.setPlanCloudProvider=_this.setPlanCloudProvider.bind(_this);_this.planTypes=[];_this.getPlanType().then(function(response){_this.planTypes=response;_this.forceUpdate();});_this.planCloudProviders=[];_this.getPlanCloudProvider().then(function(response){if(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]!=='standalone'){_this.planCloudProviders=response;_this.forceUpdate();}});return _this;}_createClass(CaseUploadPlanStandart,[{key:'setPlanType',value:function setPlanType(e){// this.state.planType = e;
this.setState({planType:e});}},{key:'setPlanCloudProvider',value:function setPlanCloudProvider(e){// this.state.planCloudProvider = e;
this.setState({planCloudProvider:e});}},{key:'getPlanType',value:function getPlanType(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["l" /* API_GET_PLAN_TYPE */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_TYPE }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'API_GET_PLAN_TYPE', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'getPlanCloudProvider',value:function getPlanCloudProvider(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["k" /* API_GET_PLAN_CLOUD_PROVIDER */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_CLOUD_PROVIDER }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'GET_PLAN_CLOUD_PROVIDER', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'tryToUpload',value:function tryToUpload(){this.setState({fileUploading:true});this.createJob();}},{key:'createLinks',value:function createLinks(){var _this2=this;this.state.fileListTeeth.forEach(function(elm){return elm._type='teeth';});var fileListTeeth=this.state.fileListTeeth.map(function(elm){return elm.name;});this.createUploadLink(fileListTeeth,'teeth').then(function(teethJson){_this2.state.fileList=[].concat(_toConsumableArray(_this2.state.fileListTeeth));_this2.sendToSpace(teethJson);});}//TODO: Move to action/jobs
},{key:'createJob',value:function createJob(){var _this3=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["b" /* API_CREATE_JOB */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({'patient_tag':this.state.patient_id,'plan_cloud_provider':this.state.planCloudProvider,'plan_type':this.state.planType,'flow':this.props.user.flow.filter(function(elm){return elm.type==='plan_standard_archform_1c';})[0].uuid})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(){return _this3.createLinks();});}},{key:'createUploadLink',value:function createUploadLink(files,folder){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["d" /* API_CREATE_JOB_LINK_FOR_PLAN */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({files:files,folder:folder})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(response){return response.json();}).catch(function(e){console.warn(e);});}},{key:'uploadCompliete',value:function uploadCompliete(){var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["m" /* API_JOB_UPLOAD_COMPLETE */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'});}},{key:'sendToSpace',value:function sendToSpace(teethJson){var ComplietedDict={};if(teethJson){this.state.fileList.forEach(function(file){teethJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['teeth_'+link_item.filename]={'link':link_item.link,'file':file}:null;});});}this.setState({'complieted_dict':ComplietedDict});this.sendFile();}},{key:'incProgress',value:function incProgress(){if(this.state.fileProgress!=this.state.fileList.length){this.setState({fileProgress:this.state.fileProgress+1});this.sendFile();}}},{key:'sendFile',value:function sendFile(){var _this4=this;var fileList=this.state.complieted_dict;if(Object.keys(fileList).length){var fileItem=Object.keys(fileList)[0];var URL=fileList[fileItem]['link'];var file=fileList[fileItem]['file'];var blob=new Blob([file],{type:file.type});fetch(URL,{method:'PUT',body:blob}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('Upload Failed');}return response;})// .then((response) => console.warn(response))
.then(function(){delete fileList[fileItem];_this4.setState({complieted_dict:fileList});_this4.incProgress();if(_this4.state.fileProgress==_this4.state.fileList.length){_this4.setState({fileUploading:false,fileProgress:0,fileList:[],patient_id:null});__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success('Files has been uploaded!');_this4.uploadCompliete();setTimeout(function(){_this4.props.history.push('/home');},100);}}).catch(function(e){console.warn(e);__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('Upload Failed');_this4.setState({fileUploading:false,fileProgress:0});});}}},{key:'setPatientId',value:function setPatientId(data){this.setState({'patient_id':data});}},{key:'toggleShowFileList',value:function toggleShowFileList(showFileList){var obj={};obj[showFileList]=!this.state[showFileList];this.setState(obj);}},{key:'renderUploadItem',value:function renderUploadItem(fileList,format,icon,name,showFileList){var _this5=this;return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,Object.assign({},formItemFiels,{style:{padding:'0 5px 0 5px',marginBottom:'0'}}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_dropzone__["a" /* default */],{accept:format,id:name+'-dropzone',onDrop:function onDrop(e){_this5.setState(function(state){var obj={};obj[fileList]=e.map(function(elm,i){elm.uid=i;return elm;});return obj;});},style:{border:'1px dashed #d9d9d9',transition:'border-color 0.3s',cursor:'pointer',borderRadius:'4px',textAlign:'center',width:'100%',height:'100%',position:'relative',padding:'16px 0',background:'#fafafa'}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p',{className:'ant-upload-drag-icon'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('img',{src:icon,style:{width:'100px'}})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p',{className:'ant-upload-text',style:{margin:10}},'Drag to upload ',name,' files')),this.state[fileList].length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',{className:'ant-upload-list-box'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',{style:{'cursor':'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',margin:10},onClick:function onClick(){return _this5.toggleShowFileList(showFileList);}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:'copy',style:{margin:5}}),'files (',this.state[fileList].length,')'),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:this.state[showFileList]?"caret-down":"caret-right"})),this.state[showFileList]&&__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_upload___default.a,{fileList:this.state[fileList],onRemove:function onRemove(file){_this5.setState(function(state){var index=state[fileList].indexOf(file);var newFileList=state[fileList].slice();newFileList.splice(index,1);var obj={};obj[fileList]=newFileList;return obj;});}})):null);}},{key:'render',value:function render(){var _this6=this;if(!(this.state.fileList.length===0&&this.uploadProgress>0)){this.uploadProgress=Math.round(this.state.fileProgress*100/this.state.fileList.length);}return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_PanelBox__["a" /* default */],{title:"Case Upload"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,Object.assign({},formPatientField,{label:'Patient id',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:'user',style:{fontSize:13}}),id:'patient-id-input',value:this.state.patient_id?this.state.patient_id:"",onChange:function onChange(e){return _this6.setPatientId(e.target.value);},disabled:this.state.fileUploading,style:{width:100}}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center',style:{display:'inline-flex'}},this.renderUploadItem('fileListTeeth','.stl',__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg___default.a,'teeth','showFileListTeeth'),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{style:{width:'calc(100% - 42px)',marginBottom:'24px',padding:'0 20px 0 22px'}},Boolean(this.uploadProgress)?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default.a,{percent:this.uploadProgress,strokeWidth:5}):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,null,this.planTypes.length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-type-selector',defaultValue:'selectPlanType',onChange:this.setPlanType},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanType',key:'selectPlanType'},'Select Plan Type'),this.planTypes.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-type-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,null,this.planCloudProviders.length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-cloud-provider-selector',defaultValue:'selectPlanCloudProviders',onChange:this.setPlanCloudProvider},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanCloudProviders',key:'selectPlanCloudProviders'},'Select Plan Cloud Provider'),this.planCloudProviders.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-cloud-provider-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{loading:this.state.fileUploading,className:'upload-demo-start',id:'submit-new-case-button',type:'primary',onClick:this.tryToUpload,disabled:this.state.fileListTeeth.length&&this.state.planType&&(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]==='standalone'||this.state.planCloudProvider)&&this.state.patient_id?false:true},'Start Upload')));}}]);return CaseUploadPlanStandart;}(__WEBPACK_IMPORTED_MODULE_19_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_20_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CaseUploadPlanStandart));

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_upload__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_dropzone__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gums_svg__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gums_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_svgicons_gums_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_svgicons_attachments_svg__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_svgicons_attachments_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_svgicons_attachments_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_joint_svg__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_joint_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_joint_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_csv_svg__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_csv_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_svgicons_csv_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_json__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__api_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option;var FormItem=__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;// const Dragger = Upload.Dragger;
var formPatientField={labelCol:{span:10},wrapperCol:{span:6}};var formItemFiels={labelCol:{span:10},wrapperCol:{span:24}};var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var CaseUploadPlanStandart=function(_Component){_inherits(CaseUploadPlanStandart,_Component);function CaseUploadPlanStandart(props){_classCallCheck(this,CaseUploadPlanStandart);var _this=_possibleConstructorReturn(this,(CaseUploadPlanStandart.__proto__||Object.getPrototypeOf(CaseUploadPlanStandart)).call(this,props));_this.state={fileList:[],planCloudProvider:null,planType:null,fileListTeeth:[],fileListXLS:[],fileUploadLinks:[],fileLoaded:0,fileProgress:0,fileUploading:false,patient_id:null,complieted_dict:{},showFileListGums:false,showFileListLocks:false,showFileListTeeth:false,showFileListXLS:false};_this.uploadProgress=0;_this.tryToUpload=_this.tryToUpload.bind(_this);_this.createJob=_this.createJob.bind(_this);_this.uploadCompliete=_this.uploadCompliete.bind(_this);_this.createUploadLink=_this.createUploadLink.bind(_this);// this.sendToSpace = this.sendToSpace.bind(this)
_this.setPatientId=_this.setPatientId.bind(_this);_this.incProgress=_this.incProgress.bind(_this);_this.toggleShowFileList=_this.toggleShowFileList.bind(_this);_this.setPlanType=_this.setPlanType.bind(_this);_this.setPlanCloudProvider=_this.setPlanCloudProvider.bind(_this);_this.planTypes=[];_this.getPlanType().then(function(response){_this.planTypes=response;_this.forceUpdate();});_this.planCloudProviders=[];_this.getPlanCloudProvider().then(function(response){if(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]!=='standalone'){_this.planCloudProviders=response;_this.forceUpdate();}});return _this;}_createClass(CaseUploadPlanStandart,[{key:'setPlanType',value:function setPlanType(e){// this.state.planType = e;
this.setState({planType:e});}},{key:'setPlanCloudProvider',value:function setPlanCloudProvider(e){// this.state.planCloudProvider = e;
this.setState({planCloudProvider:e});}},{key:'getPlanType',value:function getPlanType(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["l" /* API_GET_PLAN_TYPE */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_TYPE }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'API_GET_PLAN_TYPE', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'getPlanCloudProvider',value:function getPlanCloudProvider(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["k" /* API_GET_PLAN_CLOUD_PROVIDER */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_CLOUD_PROVIDER }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'GET_PLAN_CLOUD_PROVIDER', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'tryToUpload',value:function tryToUpload(){this.setState({fileUploading:true});this.createJob();}},{key:'createLinks',value:function createLinks(){var _this2=this;this.state.fileListTeeth.forEach(function(elm){return elm._type='teeth';});this.state.fileListXLS.forEach(function(elm){return elm._type='xls';});var fileListTeeth=this.state.fileListTeeth.map(function(elm){return elm.name;});var fileListXLS=this.state.fileListXLS.map(function(elm){return elm.name;});this.createUploadLink(fileListTeeth,'teeth').then(function(teethJson){_this2.createUploadLink(fileListXLS,'xls').then(function(xlsJson){_this2.state.fileList=[].concat(_toConsumableArray(_this2.state.fileListTeeth),_toConsumableArray(_this2.state.fileListXLS));_this2.sendToSpace(teethJson,xlsJson);});});}//TODO: Move to action/jobs
},{key:'createJob',value:function createJob(){var _this3=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["b" /* API_CREATE_JOB */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({'patient_tag':this.state.patient_id,'plan_cloud_provider':this.state.planCloudProvider,'plan_type':this.state.planType,'flow':this.props.user.flow.filter(function(elm){return elm.type==='plan_standard_onyxceph';})[0].uuid})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(){return _this3.createLinks();});}},{key:'createUploadLink',value:function createUploadLink(files,folder){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["d" /* API_CREATE_JOB_LINK_FOR_PLAN */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({files:files,folder:folder})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(response){return response.json();}).catch(function(e){console.warn(e);});}},{key:'uploadCompliete',value:function uploadCompliete(){var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["m" /* API_JOB_UPLOAD_COMPLETE */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'});}},{key:'sendToSpace',value:function sendToSpace(teethJson,xlsJson){var ComplietedDict={};if(teethJson&&xlsJson){this.state.fileList.forEach(function(file){teethJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['teeth_'+link_item.filename]={'link':link_item.link,'file':file}:null;});xlsJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['xls_'+link_item.filename]={'link':link_item.link,'file':file}:null;});});}this.setState({'complieted_dict':ComplietedDict});this.sendFile();}},{key:'incProgress',value:function incProgress(){if(this.state.fileProgress!=this.state.fileList.length){this.setState({fileProgress:this.state.fileProgress+1});this.sendFile();}}},{key:'sendFile',value:function sendFile(){var _this4=this;var fileList=this.state.complieted_dict;if(Object.keys(fileList).length){var fileItem=Object.keys(fileList)[0];var URL=fileList[fileItem]['link'];var file=fileList[fileItem]['file'];var blob=new Blob([file],{type:file.type});fetch(URL,{method:'PUT',body:blob}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('Upload Failed');}return response;})// .then((response) => console.warn(response))
.then(function(){delete fileList[fileItem];_this4.setState({complieted_dict:fileList});_this4.incProgress();if(_this4.state.fileProgress==_this4.state.fileList.length){_this4.setState({fileUploading:false,fileProgress:0,fileList:[],patient_id:null});__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success('Files has been uploaded!');_this4.uploadCompliete();setTimeout(function(){_this4.props.history.push('/home');},100);}}).catch(function(e){console.warn(e);__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('Upload Failed');_this4.setState({fileUploading:false,fileProgress:0});});}}},{key:'setPatientId',value:function setPatientId(data){this.setState({'patient_id':data});}},{key:'toggleShowFileList',value:function toggleShowFileList(showFileList){var obj={};obj[showFileList]=!this.state[showFileList];this.setState(obj);}},{key:'renderUploadItem',value:function renderUploadItem(fileList,format,icon,name,showFileList){var _this5=this;return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,Object.assign({},formItemFiels,{style:{padding:'0 5px 0 5px',marginBottom:'0'}}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_dropzone__["a" /* default */],{accept:format,id:name+'-dropzone',onDrop:function onDrop(e){_this5.setState(function(state){var obj={};obj[fileList]=e.map(function(elm,i){elm.uid=i;return elm;});return obj;});},style:{border:'1px dashed #d9d9d9',transition:'border-color 0.3s',cursor:'pointer',borderRadius:'4px',textAlign:'center',width:'100%',height:'100%',position:'relative',padding:'16px 0',background:'#fafafa'}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p',{className:'ant-upload-drag-icon'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('img',{src:icon,style:{width:'100px'}})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p',{className:'ant-upload-text',style:{margin:10}},'Drag to upload ',name,' files')),this.state[fileList].length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',{className:'ant-upload-list-box'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',{style:{'cursor':'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',margin:10},onClick:function onClick(){return _this5.toggleShowFileList(showFileList);}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:'copy',style:{margin:5}}),'files (',this.state[fileList].length,')'),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:this.state[showFileList]?"caret-down":"caret-right"})),this.state[showFileList]&&__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_upload___default.a,{fileList:this.state[fileList],onRemove:function onRemove(file){_this5.setState(function(state){var index=state[fileList].indexOf(file);var newFileList=state[fileList].slice();newFileList.splice(index,1);var obj={};obj[fileList]=newFileList;return obj;});}})):null);}},{key:'render',value:function render(){var _this6=this;if(!(this.state.fileList.length===0&&this.uploadProgress>0)){this.uploadProgress=Math.round(this.state.fileProgress*100/this.state.fileList.length);}return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_PanelBox__["a" /* default */],{title:"Case Upload"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,Object.assign({},formPatientField,{label:'Patient id',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:'user',style:{fontSize:13}}),id:'patient-id-input',value:this.state.patient_id?this.state.patient_id:"",onChange:function onChange(e){return _this6.setPatientId(e.target.value);},disabled:this.state.fileUploading,style:{width:100}}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center',style:{display:'inline-flex'}},this.renderUploadItem('fileListTeeth','.obj',__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_joint_svg___default.a,'','showFileListTeeth'),this.renderUploadItem('fileListXLS','.csv',__WEBPACK_IMPORTED_MODULE_27__assets_svgicons_csv_svg___default.a,'csv','showFileListXLS'),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{style:{width:'calc(100% - 42px)',marginBottom:'24px',padding:'0 20px 0 22px'}},Boolean(this.uploadProgress)?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default.a,{percent:this.uploadProgress,strokeWidth:5}):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,null,this.planTypes.length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-type-selector',defaultValue:'selectPlanType',onChange:this.setPlanType},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanType',key:'selectPlanType'},'Select Plan Type'),this.planTypes.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-type-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,null,this.planCloudProviders.length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-cloud-provider-selector',defaultValue:'selectPlanCloudProviders',onChange:this.setPlanCloudProvider},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanCloudProviders',key:'selectPlanCloudProviders'},'Select Plan Cloud Provider'),this.planCloudProviders.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-cloud-provider-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{loading:this.state.fileUploading,className:'upload-demo-start',id:'submit-new-case-button',type:'primary',onClick:this.tryToUpload,disabled:this.state.fileListTeeth.length&&this.state.fileListXLS.length&&this.state.planType&&(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]==='standalone'||this.state.planCloudProvider)&&this.state.patient_id?false:true},'Start Upload')));}}]);return CaseUploadPlanStandart;}(__WEBPACK_IMPORTED_MODULE_19_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_20_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CaseUploadPlanStandart));

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/csv.992a3c50.svg";

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_upload_style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_upload__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_dropzone__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_pdf_svg__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_pdf_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_svgicons_pdf_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_json__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__api_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import gums from '../../assets/svgicons/gums.svg';
// import locks from '../../assets/svgicons/attachments.svg';
// import xls from '../../assets/svgicons/xls.svg';
var Option=__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option;var FormItem=__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item;// const Dragger = Upload.Dragger;
var formPatientField={labelCol:{span:10},wrapperCol:{span:6}};var formItemFiels={labelCol:{span:10},wrapperCol:{span:24}};var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var CaseUploadPlanStandart=function(_Component){_inherits(CaseUploadPlanStandart,_Component);function CaseUploadPlanStandart(props){_classCallCheck(this,CaseUploadPlanStandart);var _this=_possibleConstructorReturn(this,(CaseUploadPlanStandart.__proto__||Object.getPrototypeOf(CaseUploadPlanStandart)).call(this,props));_this.state={fileList:[],planCloudProvider:null,planType:null,// fileListGums: [],
// fileListLocks: [],
fileListTeeth:[],// fileListXLS: [],
fileListPDF:[],fileUploadLinks:[],fileLoaded:0,fileProgress:0,fileUploading:false,patient_id:null,complieted_dict:{},// showFileListGums: false,
// showFileListLocks: false,
showFileListTeeth:false,// showFileListXLS: false,
showFileListPDF:false,pdf:false};_this.uploadProgress=0;_this.tryToUpload=_this.tryToUpload.bind(_this);_this.createJob=_this.createJob.bind(_this);_this.uploadCompliete=_this.uploadCompliete.bind(_this);_this.createUploadLink=_this.createUploadLink.bind(_this);// this.sendToSpace = this.sendToSpace.bind(this)
_this.setPatientId=_this.setPatientId.bind(_this);_this.incProgress=_this.incProgress.bind(_this);_this.toggleShowFileList=_this.toggleShowFileList.bind(_this);_this.setPlanType=_this.setPlanType.bind(_this);_this.setPlanCloudProvider=_this.setPlanCloudProvider.bind(_this);_this.planTypes=[];_this.getPlanType().then(function(response){_this.planTypes=response;_this.forceUpdate();});_this.planCloudProviders=[];_this.getPlanCloudProvider().then(function(response){if(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]!=='standalone'){_this.planCloudProviders=response;_this.forceUpdate();}});return _this;}_createClass(CaseUploadPlanStandart,[{key:'setPlanType',value:function setPlanType(e){// this.state.planType = e;
this.setState({planType:e});}},{key:'setPlanCloudProvider',value:function setPlanCloudProvider(e){// this.state.planCloudProvider = e;
this.setState({planCloudProvider:e});}},{key:'getPlanType',value:function getPlanType(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["l" /* API_GET_PLAN_TYPE */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_TYPE }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'API_GET_PLAN_TYPE', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'getPlanCloudProvider',value:function getPlanCloudProvider(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["k" /* API_GET_PLAN_CLOUD_PROVIDER */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_CLOUD_PROVIDER }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'GET_PLAN_CLOUD_PROVIDER', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'tryToUpload',value:function tryToUpload(){this.setState({fileUploading:true});this.createJob();}},{key:'createLinks',value:function createLinks(){var _this2=this;this.state.fileListTeeth.forEach(function(elm){return elm._type='teeth';});this.state.fileListPDF.forEach(function(elm){return elm._type='pdf';});var fileListTeeth=this.state.fileListTeeth.map(function(elm){return elm.name;});var fileListPDF=this.state.fileListPDF.map(function(elm){return elm.name;});this.createUploadLink(fileListTeeth,'teeth').then(function(teethJson){_this2.createUploadLink(fileListPDF,'pdf').then(function(pdfJson){_this2.state.fileList=[].concat(_toConsumableArray(_this2.state.fileListTeeth),_toConsumableArray(_this2.state.fileListPDF));_this2.sendToSpace(teethJson,pdfJson);});// this.state.fileList = [
//   ...this.state.fileListTeeth,
// ];
// this.sendToSpace(teethJson);
});}//TODO: Move to action/jobs
},{key:'createJob',value:function createJob(){var _this3=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["b" /* API_CREATE_JOB */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({'patient_tag':this.state.patient_id,'plan_cloud_provider':this.state.planCloudProvider,'plan_type':this.state.planType,'flow':this.props.user.flow.filter(function(elm){return elm.type==='plan_standard_suresmile_sou';})[0].uuid})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(){return _this3.createLinks();});}},{key:'createUploadLink',value:function createUploadLink(files,folder){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["d" /* API_CREATE_JOB_LINK_FOR_PLAN */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({files:files,folder:folder})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(response){return response.json();}).catch(function(e){console.warn(e);});}},{key:'uploadCompliete',value:function uploadCompliete(){var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["m" /* API_JOB_UPLOAD_COMPLETE */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'});}},{key:'sendToSpace',value:function sendToSpace(teethJson,pdfJson){var ComplietedDict={};if(teethJson&&pdfJson){this.state.fileList.forEach(function(file){teethJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['teeth_'+link_item.filename]={'link':link_item.link,'file':file}:null;});pdfJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['pdf_'+link_item.filename]={'link':link_item.link,'file':file}:null;});});}this.setState({'complieted_dict':ComplietedDict});this.sendFile();}},{key:'incProgress',value:function incProgress(){if(this.state.fileProgress!=this.state.fileList.length){this.setState({fileProgress:this.state.fileProgress+1});this.sendFile();}}},{key:'sendFile',value:function sendFile(){var _this4=this;var fileList=this.state.complieted_dict;if(Object.keys(fileList).length){var fileItem=Object.keys(fileList)[0];var URL=fileList[fileItem]['link'];var file=fileList[fileItem]['file'];var blob=new Blob([file],{type:file.type});fetch(URL,{method:'PUT',body:blob}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);__WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error('Upload Failed');}return response;})// .then((response) => console.warn(response))
.then(function(){delete fileList[fileItem];_this4.setState({complieted_dict:fileList});_this4.incProgress();if(_this4.state.fileProgress==_this4.state.fileList.length){_this4.setState({fileUploading:false,fileProgress:0,fileList:[],patient_id:null});__WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.success('Files has been uploaded!');_this4.uploadCompliete();setTimeout(function(){_this4.props.history.push('/home');},100);}}).catch(function(e){console.warn(e);__WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error('Upload Failed');_this4.setState({fileUploading:false,fileProgress:0});});}}},{key:'setPatientId',value:function setPatientId(data){this.setState({'patient_id':data});}},{key:'toggleShowFileList',value:function toggleShowFileList(showFileList){var obj={};obj[showFileList]=!this.state[showFileList];this.setState(obj);}},{key:'renderUploadItem',value:function renderUploadItem(fileList,format,icon,name,showFileList){var _this5=this;return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(FormItem,Object.assign({},formItemFiels,{style:{padding:'0 5px 0 5px',marginBottom:'0'}}),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_react_dropzone__["a" /* default */],{accept:format,id:name+'-dropzone',onDrop:function onDrop(e){_this5.setState(function(state){var obj={};obj[fileList]=e.map(function(elm,i){elm.uid=i;return elm;});return obj;});},style:{border:'1px dashed #d9d9d9',transition:'border-color 0.3s',cursor:'pointer',borderRadius:'4px',textAlign:'center',width:'100%',height:'100%',position:'relative',padding:'16px 0',background:'#fafafa'}},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('p',{className:'ant-upload-drag-icon'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('img',{src:icon,style:{width:'100px'}})),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('p',{className:'ant-upload-text',style:{margin:10}},'Drag to upload ',name,' files')),this.state[fileList].length?__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div',{className:'ant-upload-list-box'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div',{style:{'cursor':'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',margin:10},onClick:function onClick(){return _this5.toggleShowFileList(showFileList);}},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default.a,{type:'copy',style:{margin:5}}),'files (',this.state[fileList].length,')'),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default.a,{type:this.state[showFileList]?"caret-down":"caret-right"})),this.state[showFileList]&&__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_upload___default.a,{fileList:this.state[fileList],onRemove:function onRemove(file){_this5.setState(function(state){var index=state[fileList].indexOf(file);var newFileList=state[fileList].slice();newFileList.splice(index,1);var obj={};obj[fileList]=newFileList;return obj;});}})):null);}},{key:'render',value:function render(){var _this6=this;if(!(this.state.fileList.length===0&&this.uploadProgress>0)){this.uploadProgress=Math.round(this.state.fileProgress*100/this.state.fileList.length);}return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_PanelBox__["a" /* default */],{title:"Case Upload"},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(FormItem,Object.assign({},formPatientField,{label:'Patient id',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default.a,{type:'user',style:{fontSize:13}}),id:'patient-id-input',value:this.state.patient_id?this.state.patient_id:"",onChange:function onChange(e){return _this6.setPatientId(e.target.value);},disabled:this.state.fileUploading,style:{width:100}}))),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default.a,{onChange:function onChange(evt){return _this6.setState({pdf:evt.target.checked});}}),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('span',null,'Add PDF')),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center',style:{display:'inline-flex'}},this.renderUploadItem('fileListTeeth','.stl',__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg___default.a,'teeth','showFileListTeeth'),this.state.pdf?this.renderUploadItem('fileListPDF','.pdf',__WEBPACK_IMPORTED_MODULE_27__assets_svgicons_pdf_svg___default.a,'pdf','showFileListPDF'):null,__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{style:{width:'calc(100% - 42px)',marginBottom:'24px',padding:'0 20px 0 22px'}},Boolean(this.uploadProgress)?__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default.a,{percent:this.uploadProgress,strokeWidth:5}):null)),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(FormItem,null,this.planTypes.length?__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-type-selector',defaultValue:'selectPlanType',onChange:this.setPlanType},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanType',key:'selectPlanType'},'Select Plan Type'),this.planTypes.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-type-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(FormItem,null,this.planCloudProviders.length?__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-cloud-provider-selector',defaultValue:'selectPlanCloudProviders',onChange:this.setPlanCloudProvider},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanCloudProviders',key:'selectPlanCloudProviders'},'Select Plan Cloud Provider'),this.planCloudProviders.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-cloud-provider-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{loading:this.state.fileUploading,className:'upload-demo-start',id:'submit-new-case-button',type:'primary',onClick:this.tryToUpload,disabled:this.state.fileListTeeth.length&&this.state.planType&&(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]==='standalone'||this.state.planCloudProvider)&&this.state.patient_id?false:true},'Start Upload')));}}]);return CaseUploadPlanStandart;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_22_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CaseUploadPlanStandart));

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_upload_style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_upload__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_dropzone__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_joint_svg__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_joint_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_joint_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_pdf_svg__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_pdf_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_svgicons_pdf_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_json__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__api_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import gums from '../../assets/svgicons/gums.svg';
// import locks from '../../assets/svgicons/attachments.svg';
var Option=__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option;var FormItem=__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item;// const Dragger = Upload.Dragger;
var formPatientField={labelCol:{span:10},wrapperCol:{span:6}};var formItemFiels={labelCol:{span:10},wrapperCol:{span:24}};var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var CaseUploadPlanStandart=function(_Component){_inherits(CaseUploadPlanStandart,_Component);function CaseUploadPlanStandart(props){_classCallCheck(this,CaseUploadPlanStandart);var _this=_possibleConstructorReturn(this,(CaseUploadPlanStandart.__proto__||Object.getPrototypeOf(CaseUploadPlanStandart)).call(this,props));_this.state={fileList:[],planCloudProvider:null,planType:null,fileListTeeth:[],fileListPDF:[],fileUploadLinks:[],fileLoaded:0,fileProgress:0,fileUploading:false,patient_id:null,complieted_dict:{},showFileListGums:false,showFileListLocks:false,showFileListTeeth:false,showFileListPDF:false,pdf:false};_this.uploadProgress=0;_this.tryToUpload=_this.tryToUpload.bind(_this);_this.createJob=_this.createJob.bind(_this);_this.uploadCompliete=_this.uploadCompliete.bind(_this);_this.createUploadLink=_this.createUploadLink.bind(_this);// this.sendToSpace = this.sendToSpace.bind(this)
_this.setPatientId=_this.setPatientId.bind(_this);_this.incProgress=_this.incProgress.bind(_this);_this.toggleShowFileList=_this.toggleShowFileList.bind(_this);_this.setPlanType=_this.setPlanType.bind(_this);_this.setPlanCloudProvider=_this.setPlanCloudProvider.bind(_this);_this.planTypes=[];_this.getPlanType().then(function(response){_this.planTypes=response;_this.forceUpdate();});_this.planCloudProviders=[];_this.getPlanCloudProvider().then(function(response){if(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]!=='standalone'){_this.planCloudProviders=response;_this.forceUpdate();}});return _this;}_createClass(CaseUploadPlanStandart,[{key:'setPlanType',value:function setPlanType(e){// this.state.planType = e;
this.setState({planType:e});}},{key:'setPlanCloudProvider',value:function setPlanCloudProvider(e){// this.state.planCloudProvider = e;
this.setState({planCloudProvider:e});}},{key:'getPlanType',value:function getPlanType(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["l" /* API_GET_PLAN_TYPE */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_TYPE }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'API_GET_PLAN_TYPE', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'getPlanCloudProvider',value:function getPlanCloudProvider(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["k" /* API_GET_PLAN_CLOUD_PROVIDER */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_CLOUD_PROVIDER }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'GET_PLAN_CLOUD_PROVIDER', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'tryToUpload',value:function tryToUpload(){this.setState({fileUploading:true});this.createJob();}},{key:'createLinks',value:function createLinks(){var _this2=this;this.state.fileListTeeth.forEach(function(elm){return elm._type='teeth';});this.state.fileListPDF.forEach(function(elm){return elm._type='pdf';});var fileListTeeth=this.state.fileListTeeth.map(function(elm){return elm.name;});var fileListPDF=this.state.fileListPDF.map(function(elm){return elm.name;});this.createUploadLink(fileListTeeth,'teeth').then(function(teethJson){_this2.state.fileList=[].concat(_toConsumableArray(_this2.state.fileListTeeth));_this2.sendToSpace(teethJson);});this.createUploadLink(fileListTeeth,'teeth').then(function(teethJson){_this2.createUploadLink(fileListPDF,'pdf').then(function(pdfJson){_this2.state.fileList=[].concat(_toConsumableArray(_this2.state.fileListTeeth),_toConsumableArray(_this2.state.fileListPDF));_this2.sendToSpace(teethJson,pdfJson);});});}//TODO: Move to action/jobs
},{key:'createJob',value:function createJob(){var _this3=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["b" /* API_CREATE_JOB */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({'patient_tag':this.state.patient_id,'plan_cloud_provider':this.state.planCloudProvider,'plan_type':this.state.planType,'flow':this.props.user.flow.filter(function(elm){return elm.type==='plan_standard_orthostudio_v5';})[0].uuid})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(){return _this3.createLinks();});}},{key:'createUploadLink',value:function createUploadLink(files,folder){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["d" /* API_CREATE_JOB_LINK_FOR_PLAN */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({files:files,folder:folder})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(response){return response.json();}).catch(function(e){console.warn(e);});}},{key:'uploadCompliete',value:function uploadCompliete(){var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["m" /* API_JOB_UPLOAD_COMPLETE */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'});}},{key:'sendToSpace',value:function sendToSpace(teethJson,pdfJson){var ComplietedDict={};if(teethJson&&pdfJson){this.state.fileList.forEach(function(file){teethJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['teeth_'+link_item.filename]={'link':link_item.link,'file':file}:null;});pdfJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['pdf_'+link_item.filename]={'link':link_item.link,'file':file}:null;});});}this.setState({'complieted_dict':ComplietedDict});this.sendFile();}},{key:'incProgress',value:function incProgress(){if(this.state.fileProgress!=this.state.fileList.length){this.setState({fileProgress:this.state.fileProgress+1});this.sendFile();}}},{key:'sendFile',value:function sendFile(){var _this4=this;var fileList=this.state.complieted_dict;if(Object.keys(fileList).length){var fileItem=Object.keys(fileList)[0];var URL=fileList[fileItem]['link'];var file=fileList[fileItem]['file'];var blob=new Blob([file],{type:file.type});fetch(URL,{method:'PUT',body:blob}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);__WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error('Upload Failed');}return response;})// .then((response) => console.warn(response))
.then(function(){delete fileList[fileItem];_this4.setState({complieted_dict:fileList});_this4.incProgress();if(_this4.state.fileProgress==_this4.state.fileList.length){_this4.setState({fileUploading:false,fileProgress:0,fileList:[],patient_id:null});__WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.success('Files has been uploaded!');_this4.uploadCompliete();setTimeout(function(){_this4.props.history.push('/home');},100);}}).catch(function(e){console.warn(e);__WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error('Upload Failed');_this4.setState({fileUploading:false,fileProgress:0});});}}},{key:'setPatientId',value:function setPatientId(data){this.setState({'patient_id':data});}},{key:'toggleShowFileList',value:function toggleShowFileList(showFileList){var obj={};obj[showFileList]=!this.state[showFileList];this.setState(obj);}},{key:'renderUploadItem',value:function renderUploadItem(fileList,format,icon,name,showFileList){var _this5=this;return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(FormItem,Object.assign({},formItemFiels,{style:{padding:'0 5px 0 5px',marginBottom:'0'}}),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_react_dropzone__["a" /* default */],{accept:format,id:name+'-dropzone',onDrop:function onDrop(e){_this5.setState(function(state){var obj={};obj[fileList]=e.map(function(elm,i){elm.uid=i;return elm;});return obj;});},style:{border:'1px dashed #d9d9d9',transition:'border-color 0.3s',cursor:'pointer',borderRadius:'4px',textAlign:'center',width:'100%',height:'100%',position:'relative',padding:'16px 0',background:'#fafafa'}},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('p',{className:'ant-upload-drag-icon'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('img',{src:icon,style:{width:'100px'}})),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('p',{className:'ant-upload-text',style:{margin:10}},'Drag to upload ',name,' files')),this.state[fileList].length?__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div',{className:'ant-upload-list-box'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div',{style:{'cursor':'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',margin:10},onClick:function onClick(){return _this5.toggleShowFileList(showFileList);}},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default.a,{type:'copy',style:{margin:5}}),'files (',this.state[fileList].length,')'),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default.a,{type:this.state[showFileList]?"caret-down":"caret-right"})),this.state[showFileList]&&__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_upload___default.a,{fileList:this.state[fileList],onRemove:function onRemove(file){_this5.setState(function(state){var index=state[fileList].indexOf(file);var newFileList=state[fileList].slice();newFileList.splice(index,1);var obj={};obj[fileList]=newFileList;return obj;});}})):null);}},{key:'render',value:function render(){var _this6=this;if(!(this.state.fileList.length===0&&this.uploadProgress>0)){this.uploadProgress=Math.round(this.state.fileProgress*100/this.state.fileList.length);}return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_PanelBox__["a" /* default */],{title:"Case Upload"},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(FormItem,Object.assign({},formPatientField,{label:'Patient id',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default.a,{type:'user',style:{fontSize:13}}),id:'patient-id-input',value:this.state.patient_id?this.state.patient_id:"",onChange:function onChange(e){return _this6.setPatientId(e.target.value);},disabled:this.state.fileUploading,style:{width:100}}))),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default.a,{onChange:function onChange(evt){return _this6.setState({pdf:evt.target.checked});}}),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('span',null,'Add PDF')),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center',style:{display:'inline-flex'}},this.renderUploadItem('fileListTeeth','.obj',__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_joint_svg___default.a,'','showFileListTeeth'),this.state.pdf?this.renderUploadItem('fileListPDF','.pdf',__WEBPACK_IMPORTED_MODULE_27__assets_svgicons_pdf_svg___default.a,'pdf','showFileListPDF'):null,__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{style:{width:'calc(100% - 42px)',marginBottom:'24px',padding:'0 20px 0 22px'}},Boolean(this.uploadProgress)?__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default.a,{percent:this.uploadProgress,strokeWidth:5}):null)),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(FormItem,null,this.planTypes.length?__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-type-selector',defaultValue:'selectPlanType',onChange:this.setPlanType},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanType',key:'selectPlanType'},'Select Plan Type'),this.planTypes.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-type-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(FormItem,null,this.planCloudProviders.length?__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-cloud-provider-selector',defaultValue:'selectPlanCloudProviders',onChange:this.setPlanCloudProvider},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanCloudProviders',key:'selectPlanCloudProviders'},'Select Plan Cloud Provider'),this.planCloudProviders.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-cloud-provider-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{loading:this.state.fileUploading,className:'upload-demo-start',id:'submit-new-case-button',type:'primary',onClick:this.tryToUpload,disabled:this.state.fileListTeeth.length&&this.state.planType&&(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]==='standalone'||this.state.planCloudProvider)&&this.state.patient_id?false:true},'Start Upload')));}}]);return CaseUploadPlanStandart;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_22_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CaseUploadPlanStandart));

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_upload_style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_upload__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_dropzone__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_pdf_svg__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_svgicons_pdf_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_svgicons_pdf_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_json__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__api_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import gums from '../../assets/svgicons/gums.svg';
// import locks from '../../assets/svgicons/attachments.svg';
// import xls from '../../assets/svgicons/xls.svg';
var Option=__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option;var FormItem=__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item;// const Dragger = Upload.Dragger;
var formPatientField={labelCol:{span:10},wrapperCol:{span:6}};var formItemFiels={labelCol:{span:10},wrapperCol:{span:24}};var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var CaseUploadPlanStandart=function(_Component){_inherits(CaseUploadPlanStandart,_Component);function CaseUploadPlanStandart(props){_classCallCheck(this,CaseUploadPlanStandart);var _this=_possibleConstructorReturn(this,(CaseUploadPlanStandart.__proto__||Object.getPrototypeOf(CaseUploadPlanStandart)).call(this,props));_this.state={fileList:[],planCloudProvider:null,planType:null,// fileListGums: [],
// fileListLocks: [],
fileListTeeth:[],// fileListXLS: [],
fileListPDF:[],fileUploadLinks:[],fileLoaded:0,fileProgress:0,fileUploading:false,patient_id:null,complieted_dict:{},// showFileListGums: false,
// showFileListLocks: false,
showFileListTeeth:false,// showFileListXLS: false,
showFileListPDF:false,pdf:false};_this.uploadProgress=0;_this.tryToUpload=_this.tryToUpload.bind(_this);_this.createJob=_this.createJob.bind(_this);_this.uploadCompliete=_this.uploadCompliete.bind(_this);_this.createUploadLink=_this.createUploadLink.bind(_this);// this.sendToSpace = this.sendToSpace.bind(this)
_this.setPatientId=_this.setPatientId.bind(_this);_this.incProgress=_this.incProgress.bind(_this);_this.toggleShowFileList=_this.toggleShowFileList.bind(_this);_this.setPlanType=_this.setPlanType.bind(_this);_this.setPlanCloudProvider=_this.setPlanCloudProvider.bind(_this);_this.planTypes=[];_this.getPlanType().then(function(response){_this.planTypes=response;_this.forceUpdate();});_this.planCloudProviders=[];_this.getPlanCloudProvider().then(function(response){if(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]!=='standalone'){_this.planCloudProviders=response;_this.forceUpdate();}});return _this;}_createClass(CaseUploadPlanStandart,[{key:'setPlanType',value:function setPlanType(e){// this.state.planType = e;
this.setState({planType:e});}},{key:'setPlanCloudProvider',value:function setPlanCloudProvider(e){// this.state.planCloudProvider = e;
this.setState({planCloudProvider:e});}},{key:'getPlanType',value:function getPlanType(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["l" /* API_GET_PLAN_TYPE */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_TYPE }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'API_GET_PLAN_TYPE', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'getPlanCloudProvider',value:function getPlanCloudProvider(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["k" /* API_GET_PLAN_CLOUD_PROVIDER */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_CLOUD_PROVIDER }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'GET_PLAN_CLOUD_PROVIDER', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'tryToUpload',value:function tryToUpload(){this.setState({fileUploading:true});this.createJob();}},{key:'createLinks',value:function createLinks(){var _this2=this;this.state.fileListTeeth.forEach(function(elm){return elm._type='teeth';});this.state.fileListPDF.forEach(function(elm){return elm._type='pdf';});var fileListTeeth=this.state.fileListTeeth.map(function(elm){return elm.name;});var fileListPDF=this.state.fileListPDF.map(function(elm){return elm.name;});this.createUploadLink(fileListTeeth,'teeth').then(function(teethJson){_this2.createUploadLink(fileListPDF,'pdf').then(function(pdfJson){_this2.state.fileList=[].concat(_toConsumableArray(_this2.state.fileListTeeth),_toConsumableArray(_this2.state.fileListPDF));_this2.sendToSpace(teethJson,pdfJson);});// this.state.fileList = [
//   ...this.state.fileListTeeth,
// ];
// this.sendToSpace(teethJson);
});}//TODO: Move to action/jobs
},{key:'createJob',value:function createJob(){var _this3=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["b" /* API_CREATE_JOB */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({'patient_tag':this.state.patient_id,'plan_cloud_provider':this.state.planCloudProvider,'plan_type':this.state.planType,'flow':this.props.user.flow.filter(function(elm){return elm.type==='plan_standard_nemo';})[0].uuid})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(){return _this3.createLinks();});}},{key:'createUploadLink',value:function createUploadLink(files,folder){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["d" /* API_CREATE_JOB_LINK_FOR_PLAN */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({files:files,folder:folder})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(response){return response.json();}).catch(function(e){console.warn(e);});}},{key:'uploadCompliete',value:function uploadCompliete(){var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_23__config__["m" /* API_JOB_UPLOAD_COMPLETE */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'});}},{key:'sendToSpace',value:function sendToSpace(teethJson,pdfJson){var ComplietedDict={};if(teethJson&&pdfJson){this.state.fileList.forEach(function(file){teethJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['teeth_'+link_item.filename]={'link':link_item.link,'file':file}:null;});pdfJson.map(function(link_item){return link_item.link.indexOf(file._type)>0&&link_item.filename===file.name?ComplietedDict['pdf_'+link_item.filename]={'link':link_item.link,'file':file}:null;});});}this.setState({'complieted_dict':ComplietedDict});this.sendFile();}},{key:'incProgress',value:function incProgress(){if(this.state.fileProgress!=this.state.fileList.length){this.setState({fileProgress:this.state.fileProgress+1});this.sendFile();}}},{key:'sendFile',value:function sendFile(){var _this4=this;var fileList=this.state.complieted_dict;if(Object.keys(fileList).length){var fileItem=Object.keys(fileList)[0];var URL=fileList[fileItem]['link'];var file=fileList[fileItem]['file'];var blob=new Blob([file],{type:file.type});fetch(URL,{method:'PUT',body:blob}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);__WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error('Upload Failed');}return response;})// .then((response) => console.warn(response))
.then(function(){delete fileList[fileItem];_this4.setState({complieted_dict:fileList});_this4.incProgress();if(_this4.state.fileProgress==_this4.state.fileList.length){_this4.setState({fileUploading:false,fileProgress:0,fileList:[],patient_id:null});__WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.success('Files has been uploaded!');_this4.uploadCompliete();setTimeout(function(){_this4.props.history.push('/home');},100);}}).catch(function(e){console.warn(e);__WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error('Upload Failed');_this4.setState({fileUploading:false,fileProgress:0});});}}},{key:'setPatientId',value:function setPatientId(data){this.setState({'patient_id':data});}},{key:'toggleShowFileList',value:function toggleShowFileList(showFileList){var obj={};obj[showFileList]=!this.state[showFileList];this.setState(obj);}},{key:'renderUploadItem',value:function renderUploadItem(fileList,format,icon,name,showFileList){var _this5=this;return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(FormItem,Object.assign({},formItemFiels,{style:{padding:'0 5px 0 5px',marginBottom:'0'}}),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_react_dropzone__["a" /* default */],{accept:format,id:name+'-dropzone',onDrop:function onDrop(e){_this5.setState(function(state){var obj={};obj[fileList]=e.map(function(elm,i){elm.uid=i;return elm;});return obj;});},style:{border:'1px dashed #d9d9d9',transition:'border-color 0.3s',cursor:'pointer',borderRadius:'4px',textAlign:'center',width:'100%',height:'100%',position:'relative',padding:'16px 0',background:'#fafafa'}},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('p',{className:'ant-upload-drag-icon'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('img',{src:icon,style:{width:'100px'}})),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('p',{className:'ant-upload-text',style:{margin:10}},'Drag to upload ',name,' files')),this.state[fileList].length?__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div',{className:'ant-upload-list-box'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div',{style:{'cursor':'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',margin:10},onClick:function onClick(){return _this5.toggleShowFileList(showFileList);}},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default.a,{type:'copy',style:{margin:5}}),'files (',this.state[fileList].length,')'),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default.a,{type:this.state[showFileList]?"caret-down":"caret-right"})),this.state[showFileList]&&__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_upload___default.a,{fileList:this.state[fileList],onRemove:function onRemove(file){_this5.setState(function(state){var index=state[fileList].indexOf(file);var newFileList=state[fileList].slice();newFileList.splice(index,1);var obj={};obj[fileList]=newFileList;return obj;});}})):null);}},{key:'render',value:function render(){var _this6=this;if(!(this.state.fileList.length===0&&this.uploadProgress>0)){this.uploadProgress=Math.round(this.state.fileProgress*100/this.state.fileList.length);}return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_PanelBox__["a" /* default */],{title:"Case Upload"},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(FormItem,Object.assign({},formPatientField,{label:'Patient id',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon___default.a,{type:'user',style:{fontSize:13}}),id:'patient-id-input',value:this.state.patient_id?this.state.patient_id:"",onChange:function onChange(e){return _this6.setPatientId(e.target.value);},disabled:this.state.fileUploading,style:{width:100}}))),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default.a,{onChange:function onChange(evt){return _this6.setState({pdf:evt.target.checked});}}),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('span',null,'Add PDF')),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center',style:{display:'inline-flex'}},this.renderUploadItem('fileListTeeth','.stl',__WEBPACK_IMPORTED_MODULE_26__assets_svgicons_crowns_svg___default.a,'teeth','showFileListTeeth'),this.state.pdf?this.renderUploadItem('fileListPDF','.pdf',__WEBPACK_IMPORTED_MODULE_27__assets_svgicons_pdf_svg___default.a,'pdf','showFileListPDF'):null,__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{style:{width:'calc(100% - 42px)',marginBottom:'24px',padding:'0 20px 0 22px'}},Boolean(this.uploadProgress)?__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default.a,{percent:this.uploadProgress,strokeWidth:5}):null)),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(FormItem,null,this.planTypes.length?__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-type-selector',defaultValue:'selectPlanType',onChange:this.setPlanType},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanType',key:'selectPlanType'},'Select Plan Type'),this.planTypes.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-type-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(FormItem,null,this.planCloudProviders.length?__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-cloud-provider-selector',defaultValue:'selectPlanCloudProviders',onChange:this.setPlanCloudProvider},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanCloudProviders',key:'selectPlanCloudProviders'},'Select Plan Cloud Provider'),this.planCloudProviders.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-cloud-provider-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{loading:this.state.fileUploading,className:'upload-demo-start',id:'submit-new-case-button',type:'primary',onClick:this.tryToUpload,disabled:this.state.fileListTeeth.length&&this.state.planType&&(__WEBPACK_IMPORTED_MODULE_28__api_json__["type"]==='standalone'||this.state.planCloudProvider)&&this.state.patient_id?false:true},'Start Upload')));}}]);return CaseUploadPlanStandart;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_22_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CaseUploadPlanStandart));

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_progress_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_upload__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_dropzone__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_svgicons_upper_svg__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_svgicons_upper_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_svgicons_upper_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_svgicons_lower_svg__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_svgicons_lower_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_svgicons_lower_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__api_json__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__api_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__api_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option;var FormItem=__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;// const Dragger = Upload.Dragger;
var formPatientField={labelCol:{span:10},wrapperCol:{span:6}};var formItemFiels={labelCol:{span:10},wrapperCol:{span:24}};var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var parseNames=function parseNames(name,type){var res='';var dotParts=name.trim().replace(/\s/g,'_').split('.');var parts=dotParts[0].split('_');if(parts.indexOf('upper')>-1||parts.indexOf('u')>-1){res='upper_'+type;}else if(parts.indexOf('lower')>-1||parts.indexOf('l')>-1){res='lower_'+type;}return res+'.'+dotParts[1];};var CaseUploadPlanDeepCT=function(_Component){_inherits(CaseUploadPlanDeepCT,_Component);function CaseUploadPlanDeepCT(props){_classCallCheck(this,CaseUploadPlanDeepCT);var _this=_possibleConstructorReturn(this,(CaseUploadPlanDeepCT.__proto__||Object.getPrototypeOf(CaseUploadPlanDeepCT)).call(this,props));_this.state={fileList:[],planCloudProvider:null,planType:null,fileListUpper:[],fileListLower:[],fileUploadLinks:[],fileLoaded:0,fileProgress:0,fileUploading:false,patient_id:null,complieted_dict:{},showFileListUpper:false,showFileListLower:false};_this.uploadProgress=0;_this.tryToUpload=_this.tryToUpload.bind(_this);_this.createJob=_this.createJob.bind(_this);_this.uploadCompliete=_this.uploadCompliete.bind(_this);_this.createUploadLink=_this.createUploadLink.bind(_this);// this.sendToSpace = this.sendToSpace.bind(this)
_this.setPatientId=_this.setPatientId.bind(_this);_this.incProgress=_this.incProgress.bind(_this);_this.toggleShowFileList=_this.toggleShowFileList.bind(_this);_this.setPlanType=_this.setPlanType.bind(_this);_this.setPlanCloudProvider=_this.setPlanCloudProvider.bind(_this);_this.planTypes=[];_this.getPlanType().then(function(response){_this.planTypes=response;_this.forceUpdate();});_this.planCloudProviders=[];_this.getPlanCloudProvider().then(function(response){// if (app_type !== 'standalone') {
_this.planCloudProviders=response;_this.forceUpdate();// }
});return _this;}_createClass(CaseUploadPlanDeepCT,[{key:'setPlanType',value:function setPlanType(e){// this.state.planType = e;
this.setState({planType:e});}},{key:'setPlanCloudProvider',value:function setPlanCloudProvider(e){// this.state.planCloudProvider = e;
this.setState({planCloudProvider:e});}},{key:'getPlanType',value:function getPlanType(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["l" /* API_GET_PLAN_TYPE */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_TYPE }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'API_GET_PLAN_TYPE', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'getPlanCloudProvider',value:function getPlanCloudProvider(){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["k" /* API_GET_PLAN_CLOUD_PROVIDER */]),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error("Failed loading { API_GET_PLAN_CLOUD_PROVIDER }: "+response.statusText);}return response;}).then(function(response){return response.json();})// .then((json) => dispatch({type: 'GET_PLAN_CLOUD_PROVIDER', json}))
.catch(function(e){// dispatch(userLoggedInFailure('' + e))
});}},{key:'tryToUpload',value:function tryToUpload(){this.setState({fileUploading:true});this.createJob();}},{key:'createLinks',value:function createLinks(){var _this2=this;// const fileListUpper = this.state.fileListUpper.map((elm) => parseNames(elm.name, 'upper'));
// const fileListLower = this.state.fileListLower.map((elm) => parseNames(elm.name, 'lower'));
this.createUploadLink(['upper.stl'],'upper').then(function(upperJson){_this2.createUploadLink(['lower.stl'],'lower').then(function(lowerJson){_this2.state.fileList=[].concat(_toConsumableArray(_this2.state.fileListUpper.map(function(elm){return new File([elm],'upper.stl',{type:'application/vnd.ms-pkistl'});})),_toConsumableArray(_this2.state.fileListLower.map(function(elm){return new File([elm],'lower.stl',{type:'application/vnd.ms-pkistl'});})));_this2.sendToSpace(upperJson,lowerJson);});});}// createJob() {
//   let token =  localStorage.getItem('token')
//   return fetch(switch_api(API_GET_PLAN_TYPE), {
//     method: 'GET',
//     headers: {
//       'Accept': 'application/json',
//       'Authorization': 'Token '+token,
//       'Content-Type': 'application/json; charset=utf-8'
//     },
//     credentials: 'include'
//   })
//   .then((response) => {
//     if (!response.ok) {
//       console.error("Failed loading { API_GET_PLAN_TYPE }: " + response.statusText);
//     }
//     return response;
//   })
//   .then((response) => response.json())
//   .then((json) => {
//     // const plan_type = json.filter((elm) => elm.name === 'Initial condition')[0].uuid;
//     fetch(switch_api(API_CREATE_JOB), {
//       method: 'POST',
//       headers: {
//         'Accept': 'application/json',
//         'Authorization': 'Token '+token,
//         'Content-Type': 'application/json; charset=utf-8'
//       },
//       credentials: 'include',
//       body: JSON.stringify({
//         'patient_tag': this.state.patient_id,
//         'plan_type': this.state.planType,
//         'plan_cloud_provider': this.state.planCloudProvider,
//         'flow': this.props.user.flow.filter((elm) => (elm.type === 'teeth_alignment_modelling'))[0].uuid
//       })
//     })
//     .then((response) => {
//       if (!response.ok) {
//         console.error("Failed loading { API_CREATE_LINK }: " + response.statusText);
//       }
//       return response;
//     })
//     .then(() => this.createLinks())
//   })
//   .catch((e) => {
//     // dispatch(userLoggedInFailure('' + e))
//   })
// }
},{key:'createJob',value:function createJob(){var _this3=this;var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["b" /* API_CREATE_JOB */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({'patient_tag':this.state.patient_id,'plan_cloud_provider':this.state.planCloudProvider,'plan_type':this.state.planType,'flow':this.props.user.flow.filter(function(elm){return elm.type==='teeth_alignment_modelling';})[0].uuid})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(){return _this3.createLinks();});}//TODO: Move to action/jobs
// createJob(plan_type) {
//   let token = localStorage.getItem('token')
//   fetch(switch_api(API_CREATE_JOB), {
//     method: 'POST',
//     headers: {
//       'Accept': 'application/json',
//       'Authorization': 'Token '+token,
//       'Content-Type': 'application/json; charset=utf-8'
//     },
//     credentials: 'include',
//     body: JSON.stringify({
//       'patient_tag': this.state.patient_id,
//       plan_type,
//       'plan_cloud_provider': this.state.planCloudProvider,
//       'flow': this.props.user.flow.filter((elm) => (elm.type === 'plan_deep_ct'))[0].uuid
//     })
//   })
//   .then((response) => {
//     if (!response.ok) {
//       console.error("Failed loading { API_CREATE_LINK }: " + response.statusText);
//     }
//     return response;
//   })
//   .then(() => this.createLinks())
// }
},{key:'createUploadLink',value:function createUploadLink(files,folder){var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["d" /* API_CREATE_JOB_LINK_FOR_PLAN */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({files:files,folder:folder})}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);}return response;}).then(function(response){return response.json();}).catch(function(e){console.warn(e);});}},{key:'uploadCompliete',value:function uploadCompliete(){var token=localStorage.getItem('token');fetch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_switch_api__["a" /* switch_api */])(__WEBPACK_IMPORTED_MODULE_21__config__["m" /* API_JOB_UPLOAD_COMPLETE */]),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'});}},{key:'sendToSpace',value:function sendToSpace(upperJson,lowerJson){var ComplietedDict={};if(upperJson&&lowerJson){this.state.fileList.forEach(function(file){upperJson.map(function(link_item){return link_item.filename==file.name?ComplietedDict['upper_'+link_item.filename]={'link':link_item.link,'file':file}:null;});lowerJson.map(function(link_item){return link_item.filename==file.name?ComplietedDict['lower_'+link_item.filename]={'link':link_item.link,'file':file}:null;});});}this.setState({'complieted_dict':ComplietedDict});this.sendFile();}},{key:'incProgress',value:function incProgress(){if(this.state.fileProgress!=this.state.fileList.length){this.setState({fileProgress:this.state.fileProgress+1});this.sendFile();}}},{key:'sendFile',value:function sendFile(){var _this4=this;var fileList=this.state.complieted_dict;if(Object.keys(fileList).length){var fileItem=Object.keys(fileList)[0];var URL=fileList[fileItem]['link'];var file=fileList[fileItem]['file'];var blob=new Blob([file],{type:file.type});fetch(URL,{method:'PUT',body:blob}).then(function(response){if(!response.ok){console.error("Failed loading { API_CREATE_LINK }: "+response.statusText);__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('Upload Failed',5);}return response;})// .then((response) => console.warn(response))
.then(function(){delete fileList[fileItem];_this4.setState({complieted_dict:fileList});_this4.incProgress();if(_this4.state.fileProgress==_this4.state.fileList.length){_this4.setState({fileUploading:false,fileProgress:0,fileList:[],patient_id:null});__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success('Files have been uploaded!',5);_this4.uploadCompliete();setTimeout(function(){_this4.props.history.push('/home');},100);}}).catch(function(e){console.warn(e);__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('Upload Failed');_this4.setState({fileUploading:false,fileProgress:0});});}}},{key:'setPatientId',value:function setPatientId(data){this.setState({'patient_id':data});}},{key:'toggleShowFileList',value:function toggleShowFileList(showFileList){var obj={};obj[showFileList]=!this.state[showFileList];this.setState(obj);}},{key:'renderUploadItem',value:function renderUploadItem(fileList,format,icon,name,showFileList){var _this5=this;return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,Object.assign({},formItemFiels,{style:{padding:'0 5px 0 5px',marginBottom:'0'}}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_dropzone__["a" /* default */],{accept:format,maxFiles:1,multiple:false,id:name+'-dropzone',onDrop:function onDrop(e){_this5.setState(function(state){var obj={};obj[fileList]=e.map(function(elm,i){elm.uid=i;return elm;});return obj;});},style:{border:'1px dashed #d9d9d9',transition:'border-color 0.3s',cursor:'pointer',borderRadius:'4px',textAlign:'center',width:'100%',height:'100%',position:'relative',padding:'16px 0',background:'#fafafa'}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p',{className:'ant-upload-drag-icon'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('img',{src:icon,style:{width:'100px'}})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('p',{className:'ant-upload-text',style:{margin:10}},'Drag to upload ',name,' files')),this.state[fileList].length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div',{className:'ant-upload-list-box'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_upload___default.a,{fileList:this.state[fileList],onRemove:function onRemove(file){_this5.setState(function(state){var index=state[fileList].indexOf(file);var newFileList=state[fileList].slice();newFileList.splice(index,1);var obj={};obj[fileList]=newFileList;return obj;});}})):null);}},{key:'render',value:function render(){var _this6=this;if(!(this.state.fileList.length===0&&this.uploadProgress>0)){this.uploadProgress=Math.round(this.state.fileProgress*100/this.state.fileList.length);}return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_PanelBox__["a" /* default */],{title:"Case Upload"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,Object.assign({},formPatientField,{label:'Patient id',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:'user',style:{fontSize:13}}),id:'patient-id-input',value:this.state.patient_id?this.state.patient_id:"",onChange:function onChange(e){return _this6.setPatientId(e.target.value);},disabled:this.state.fileUploading,style:{width:100}}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center',style:{display:'inline-flex'}},this.renderUploadItem('fileListUpper','.stl',__WEBPACK_IMPORTED_MODULE_24__assets_svgicons_upper_svg___default.a,'upper','showFileListUpper'),this.renderUploadItem('fileListLower','.stl',__WEBPACK_IMPORTED_MODULE_25__assets_svgicons_lower_svg___default.a,'lower','showFileListLower'),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{style:{width:'calc(100% - 42px)',marginBottom:'24px',padding:'0 20px 0 22px'}},Boolean(this.uploadProgress)?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_progress___default.a,{percent:this.uploadProgress,id:'upload-progress',strokeWidth:5}):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,null,this.planTypes.length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-type-selector',defaultValue:'selectPlanType',onChange:this.setPlanType},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanType',key:'selectPlanType'},'Select Plan Type'),this.planTypes.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-type-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(FormItem,null,this.planCloudProviders.length?__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{disabled:this.state.fileUploading,id:'plan-cloud-provider-selector',defaultValue:'selectPlanCloudProviders',onChange:this.setPlanCloudProvider},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{selected:true,disabled:true,value:'selectPlanCloudProviders',key:'selectPlanCloudProviders'},'Select Plan Cloud Provider'),this.planCloudProviders.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(Option,{value:elm.uuid,id:'plan-cloud-provider-option-'+i,key:elm.uuid},elm.name);})):null)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{loading:this.state.fileUploading,className:'upload-demo-start',id:'submit-new-case-button',type:'primary',onClick:this.tryToUpload,disabled:(this.state.fileListUpper.length||this.state.fileListLower.length)&&this.state.planType&&this.state.planCloudProvider&&this.state.patient_id?false:true},'Start Upload')));}}]);return CaseUploadPlanDeepCT;}(__WEBPACK_IMPORTED_MODULE_19_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_20_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CaseUploadPlanDeepCT));

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/upper.9e27d2d4.svg";

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lower.2a0f49bb.svg";

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_card_style__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_card__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_jobs__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_svgicons_teeth_sprites_svg__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_svgicons_teeth_sprites_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_svgicons_teeth_sprites_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_svgicons_cross_svg__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_svgicons_cross_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_svgicons_cross_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_PanelBox_index_less__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_PanelBox_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_PanelBox_index_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PanelBox=function(_React$Component){_inherits(PanelBox,_React$Component);function PanelBox(){_classCallCheck(this,PanelBox);return _possibleConstructorReturn(this,(PanelBox.__proto__||Object.getPrototypeOf(PanelBox)).apply(this,arguments));}_createClass(PanelBox,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_card___default.a,{className:'panel-box'+this.props.className,title:this.props.title,bordered:false,bodyStyle:this.props.bodyStyle,style:{textAlign:'center',maxWidth:'580px',margin:'auto'}},this.props.children);}}]);return PanelBox;}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);var upperTeeth=[18,17,16,15,14,13,12,11,21,22,23,24,25,26,27,28];var upperSprites=[7,6,5,4,3,2,1,0,8,9,10,11,12,13,14,15];var lowerTeeth=[48,47,46,45,44,43,42,41,31,32,33,34,35,36,37,38];var lowerSprites=[31,30,29,28,27,26,25,24,16,17,18,19,20,21,22,23];var teeth={};upperTeeth.concat(lowerTeeth).forEach(function(elm){teeth[elm]=true;});var PlanUpdateForm=function(_Component){_inherits(PlanUpdateForm,_Component);function PlanUpdateForm(props){_classCallCheck(this,PlanUpdateForm);var _this2=_possibleConstructorReturn(this,(PlanUpdateForm.__proto__||Object.getPrototypeOf(PlanUpdateForm)).call(this,props));_this2.isModelsValid=true;_this2.updatePlan=_this2.updatePlan.bind(_this2);_this2.state={};_this2.state.loading=false;_this2.state.teeth={};_this2.state.job={};_this2.state.upperLayers=[];_this2.state.lowerLayers=[];_this2.state.upperModels=[];_this2.state.lowerModels=[];Object(__WEBPACK_IMPORTED_MODULE_14__actions_jobs__["c" /* getJobUuid */])(_this2.props.match.params.uuid).then(function(job){_this2.state.teeth=Object.assign({},teeth);_this2.state.job=job;_this2.state.upperLayers=_this2.state.job.t_plan.json_data.plan.upper?[].concat(_toConsumableArray(Object.keys(_this2.state.job.t_plan.json_data.plan.upper))):[];_this2.state.lowerLayers=_this2.state.job.t_plan.json_data.plan.lower?[].concat(_toConsumableArray(Object.keys(_this2.state.job.t_plan.json_data.plan.lower))):[];_this2.state.upperModels=new Array(_this2.state.upperLayers.length*2).fill(null);_this2.state.lowerModels=new Array(_this2.state.lowerLayers.length*2).fill(null);_this2.forceUpdate();}).catch();return _this2;}_createClass(PlanUpdateForm,[{key:'checkModels',value:function checkModels(){this.isModelsValid=true;for(var i=0;i<this.state.upperModels.length;i++){if(i&&(i%2!==0&&parseInt(this.state.upperModels[i])<parseInt(this.state.upperModels[i-1])||i%2===0&&parseInt(this.state.upperModels[i])<=parseInt(this.state.upperModels[i-1]))){this.isModelsValid=false;break;}}for(var _i=0;_i<this.state.lowerModels.length;_i++){if(_i&&(_i%2!==0&&parseInt(this.state.lowerModels[_i])<parseInt(this.state.lowerModels[_i-1])||_i%2===0&&parseInt(this.state.lowerModels[_i])<=parseInt(this.state.lowerModels[_i-1]))){this.isModelsValid=false;break;}}}},{key:'checkbox',value:function checkbox(e,elm){this.state.teeth[elm]=!e.target.checked;this.forceUpdate();}},{key:'getInputs',value:function getInputs(elm,i,position){var _this3=this;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{key:elm,className:'sf-plan_update-specify_models'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'sf-plan_update-specify_models-h2'},'Layer \u2116',elm,' models'),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'left'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'sf-plan_update-specify_models-input_container'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{value:this.state[position][i*2],disabled:this.state.loading,onChange:function onChange(e){var pos=_this3.state[position];e.target.value=e.target.value.replace(/[^0-9]/g,'');pos[i*2]=e.target.value;pos[i*2-1]!=='undefined'?pos[i*2-1]=parseInt(pos[i*2])-1:null;isNaN(pos[i*2-1])?pos[i*2-1]='':null;_this3.checkModels();_this3.forceUpdate();}})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'sf-plan_update-specify_models-input_container -right'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{value:this.state[position][i*2+1],disabled:this.state.loading,onChange:function onChange(e){var pos=_this3.state[position];e.target.value=e.target.value.replace(/[^0-9]/g,'');pos[i*2+1]=e.target.value;pos[i*2+2]!=='undefined'?pos[i*2+2]=parseInt(pos[i*2+1])+1:null;isNaN(pos[i*2+2])?pos[i*2+2]='':null;_this3.checkModels();_this3.forceUpdate();}}))));}},{key:'nextStep',value:function nextStep(){var _this4=this;var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_switch_api__["a" /* switch_api */])(Object(__WEBPACK_IMPORTED_MODULE_12__config__["q" /* API_NEXT_STEP */])(this.props.match.params.uuid)),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error('Failed loading { API_NEXT_STEP }: '+response.statusText);_this4.setState({loading:false});}window.location='/home';}).catch(function(e){console.warn(e);_this4.setState({loading:false});});}},{key:'updatePlan',value:function updatePlan(){var _this5=this;var token=localStorage.getItem('token');var models=[];var newTeeth={};for(var i=0;i<this.state.upperModels.length-1;i+=2){models.push({index_from:parseInt(this.state.upperModels[i]),index_to:parseInt(this.state.upperModels[i+1]),layer_number:i*0.5+1,jaw_type:'upper'});}for(var _i2=0;_i2<this.state.lowerModels.length-1;_i2+=2){models.push({index_from:parseInt(this.state.lowerModels[_i2]),index_to:parseInt(this.state.lowerModels[_i2+1]),layer_number:_i2*0.5+1,jaw_type:'lower'});}for(var key in this.state.teeth){if(!this.state.teeth[key]){newTeeth[key]=false;}}this.setState({loading:true});return fetch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_switch_api__["a" /* switch_api */])(Object(__WEBPACK_IMPORTED_MODULE_12__config__["u" /* API_UPDATE_PLAN */])(this.props.match.params.uuid)),{method:'PATCH',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({setup:newTeeth,models:models})}).then(function(response){if(!response.ok){console.error('Failed loading { API_UPDATE_PLAN }: '+response.statusText);}_this5.nextStep();// return response;
}).catch(function(e){console.warn(e);_this5.setState({loading:false});});}},{key:'render',value:function render(){var _this6=this;return JSON.parse(localStorage.getItem('techJobs')).map(function(elm){return elm.uuid;}).indexOf(this.props.match.params.uuid)<0?window.location='/home':__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(PanelBox,{title:'Plan Update'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},upperTeeth.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{key:elm,className:'sf-plan_update-remove_teeth-item'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'sf-plan_update-remove_teeth-item-icon',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_15__assets_svgicons_teeth_sprites_svg___default.a+')',backgroundPositionY:-32*upperSprites[i]+'px'}}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'sf-plan_update-remove_teeth-item-cross '+(_this6.state.teeth[elm]?'':'-visible'),style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_16__assets_svgicons_cross_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',null,elm),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,{onChange:function onChange(e){return _this6.checkbox(e,elm);}}));})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},lowerTeeth.map(function(elm,i){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{key:elm,className:'sf-plan_update-remove_teeth-item'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,{onChange:function onChange(e){return _this6.checkbox(e,elm);}}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',null,elm),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'sf-plan_update-remove_teeth-item-icon',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_15__assets_svgicons_teeth_sprites_svg___default.a+')',backgroundPositionY:-32*lowerSprites[i]+'px'}}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'sf-plan_update-remove_teeth-item-cross -lower '+(_this6.state.teeth[elm]?'':'-visible'),style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_16__assets_svgicons_cross_svg___default.a+')'}}));})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'left',style:{padding:'0 20px 0 20px'}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'sf-plan_update-specify_models-h1'},'Upper arch'),this.state.upperLayers.map(function(elm,i){return _this6.getInputs(elm,i,'upperModels');}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'sf-plan_update-specify_models-h1'},'Lower arch'),this.state.lowerLayers.map(function(elm,i){return _this6.getInputs(elm,i,'lowerModels');})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{style:{margin:'24px 0 0 0'},loading:this.state.loading,className:'upload-demo-start',type:'primary',disabled:!this.isModelsValid||this.state.loading||this.state.upperModels.filter(function(elm){return!Boolean(elm);}).length||this.state.lowerModels.filter(function(elm){return!Boolean(elm);}).length,onClick:this.updatePlan},'Update')));}}]);return PlanUpdateForm;}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);;// export default connect(({ jobs }) => ({ jobs }))(PlanUpdateForm);
/* harmony default export */ __webpack_exports__["a"] = (PlanUpdateForm);

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/teeth-sprites.8ef1ed06.svg";

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cross.5f1304cb.svg";

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_PanelBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_router_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions_auth__ = __webpack_require__(108);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormItem=__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item;var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{updateUser:function updateUser(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_auth__["e" /* updateUser */])(data));},updateProfile:function updateProfile(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_auth__["d" /* updateProfile */])(data));}};};var UserProfile=function(_Component){_inherits(UserProfile,_Component);function UserProfile(props){_classCallCheck(this,UserProfile);var _this=_possibleConstructorReturn(this,(UserProfile.__proto__||Object.getPrototypeOf(UserProfile)).call(this,props));_this.state={first_name:null,last_name:null,notification_to_email:null,notification_to_telegram:null,loading:false};_this.setData=_this.setData.bind(_this);_this.toggleEmailNotify=_this.toggleEmailNotify.bind(_this);_this.disableTelegramNotify=_this.disableTelegramNotify.bind(_this);return _this;}_createClass(UserProfile,[{key:'setData',value:function setData(fieldName,value){var stateObject={};stateObject[fieldName]=value;this.setState(stateObject);}},{key:'updateUserData',value:function updateUserData(){var _this2=this;var updateUserData={};var updateProfileData={};var updatingValue=['first_name','last_name'];var updatingProfileValue=['notification_to_email','notification_to_telegram'];updatingValue.map(function(value){var updateItem={};updateItem[value]=_this2.state[value];_this2.state[value]&&Object.assign(updateUserData,updateItem);});updatingProfileValue.map(function(value){var updateItem={};updateItem[value]=_this2.state[value];_this2.state[value]!=null&&Object.assign(updateProfileData,updateItem);});// console.warn(updateUserData)
// console.warn(updateProfileData)
Object.keys(updateUserData).length||Object.keys(updateProfileData).length?(this.setState({loading:true}),this.props.updateProfile(updateProfileData),this.props.updateUser(updateUserData)):null;}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.state.loading==true&&nextProps.user?(this.setState({loading:false}),__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success('Profile has been updated!')):null;}},{key:'toggleEmailNotify',value:function toggleEmailNotify(data){this.setState({notification_to_email:data});}},{key:'disableTelegramNotify',value:function disableTelegramNotify(data){this.setState({notification_to_telegram:false});}},{key:'render',value:function render(){var _this3=this;var formProfileField={labelCol:{span:14},wrapperCol:{span:10},colon:false};return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_PanelBox__["a" /* default */],{title:"User Profile"},__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,null,__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(FormItem,Object.assign({},formProfileField,{label:'First name',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:'user',style:{fontSize:13}}),style:{width:150},defaultValue:this.props.user.first_name,onChange:function onChange(e){return _this3.setData('first_name',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(FormItem,Object.assign({},formProfileField,{label:'Last name',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:'contacts',style:{fontSize:13}}),style:{width:150},defaultValue:this.props.user.last_name,onChange:function onChange(e){return _this3.setData('last_name',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(FormItem,Object.assign({},formProfileField,{label:'Telegram secret key',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{prefix:__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a,{type:'lock',style:{fontSize:13}}),style:{width:150},value:this.props.user.profile.telegram_secret_key})),__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(FormItem,Object.assign({},formProfileField,{label:'Telegram notification',hasFeedback:true}),this.props.user.profile.notification_to_telegram?__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('div',{style:{'display':'flex','justifyContent':'center'}},__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('span',{style:{marginLeft:10}},' Enabled '),__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{onClick:function onClick(e){return _this3.disableTelegramNotify(e.target.checked);},style:{marginLeft:10}},'Disable')):__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('a',{href:'http://telegram.me/dddct_bot'},'http://telegram.me/dddct_bot')),__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(FormItem,Object.assign({},formProfileField,{label:'E-mail notification',hasFeedback:true}),__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_checkbox___default.a,{onClick:function onClick(e){return _this3.toggleEmailNotify(e.target.checked);},defaultChecked:this.props.user.profile.notification_to_email?true:false})))),__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_row___default.a,{type:'flex',justify:'center'},__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:'primary',htmlType:'submit',onClick:function onClick(e){return _this3.updateUserData();},loading:this.state.loading},'Update')));}}]);return UserProfile;}(__WEBPACK_IMPORTED_MODULE_15_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(UserProfile));

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(59);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var loading={display:'flex',height:'100%',flexDirection:'column',justifyContent:'center',alignContent:'center'};var mapStateToProps=function mapStateToProps(state){return{user:state.user,userIsLoading:state.userIsLoading,errorMessage:state.errorMessage};};var LoadingSpinner=function(_React$Component){_inherits(LoadingSpinner,_React$Component);function LoadingSpinner(props){_classCallCheck(this,LoadingSpinner);var _this=_possibleConstructorReturn(this,(LoadingSpinner.__proto__||Object.getPrototypeOf(LoadingSpinner)).call(this,props));_this.state={needToLogout:false};return _this;}_createClass(LoadingSpinner,[{key:"componentWillUpdate",value:function componentWillUpdate(nextProps){if(!nextProps.user.username){this.setState({needToLogout:true});}}},{key:"render",value:function render(){var username=this.props.user.username;if(this.state.needToLogout||this.props.needToLogout){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Redirect */],{to:"/login"});}else{return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:loading},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default.a,null));}}}]);return LoadingSpinner;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps)(LoadingSpinner));

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_index_css__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_index__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__js_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_both_svg__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_both_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_icons_both_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_icons_upper_svg__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_icons_upper_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_icons_upper_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_icons_lower_svg__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_icons_lower_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_icons_lower_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_icons_occlusion_svg__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_icons_occlusion_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_icons_occlusion_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_icons_menu_svg__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_icons_menu_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_icons_menu_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_icons_locks_svg__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_icons_locks_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_icons_locks_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_icons_separations_svg__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_icons_separations_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_icons_separations_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_icons_mm_grid_svg__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_icons_mm_grid_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_icons_mm_grid_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_icons_pdf_svg__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_icons_pdf_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_icons_pdf_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_icons_transp_svg__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_icons_transp_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_icons_transp_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_icons_m_i_svg__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_icons_m_i_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_icons_m_i_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_icons_en_svg__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_icons_en_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_icons_en_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_icons_ru_svg__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_icons_ru_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_icons_ru_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_icons_first_svg__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_icons_first_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_icons_first_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_icons_pause_svg__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_icons_pause_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_icons_pause_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_icons_play_svg__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_icons_play_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_icons_play_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_icons_last_svg__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_icons_last_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_icons_last_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_icons_occlusion_en_svg__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_icons_occlusion_en_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_icons_occlusion_en_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_icons_occlusion_ru_svg__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_icons_occlusion_ru_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_icons_occlusion_ru_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import back from '../../assets/icons/back.svg';
// import plan_bone from '../../assets/icons/plan_bone.svg';
// const getHTML = () => {
//   return { __html: '<div class=ortho-gl-container><div class=ortho-nav-mobile><div class=ortho-nav-mobile-row><a class="ortho-nav-mobile-icon -both"></a><a class="ortho-nav-mobile-icon -upper"></a><a class="ortho-nav-mobile-icon -lower"></a><a class="ortho-nav-mobile-icon -occlusion"></a><a class="ortho-nav-mobile-icon -menu"></a></div><div class=ortho-nav-mobile-row><a class="ortho-nav-mobile-icon -locks"></a><a class="ortho-nav-mobile-icon -separations"></a><a class="ortho-nav-mobile-icon -grid"></a><a class="ortho-nav-mobile-icon -pdf"></a><a class="ortho-nav-mobile-icon -info"></a></div><div class=ortho-nav-mobile-row><a class="ortho-nav-mobile-icon -test" style=float:right;></a><a class="ortho-nav-mobile-icon -plan_bone"></a></div></div><div class=ortho-nav><div class=ortho-nav-row><a class="ortho-nav-cell -active"><div class="ortho-nav-icon -both"></div></a><a class=ortho-nav-cell><div class="ortho-nav-icon -upper"></div></a></div><div class=ortho-nav-row><a class=ortho-nav-cell><div class="ortho-nav-icon -occlusion"></div></a><a class=ortho-nav-cell><div class="ortho-nav-icon -lower"></div></a></div><div class="ortho-nav-row -line"></div><div class=ortho-nav-row><a class="ortho-nav-cell -active"><div class="ortho-nav-icon -locks"></div></a><a class="ortho-nav-cell -active"><div class="ortho-nav-icon -separations"></div></a></div><div class="ortho-nav-row -line"></div><div class=ortho-nav-row><a class=ortho-nav-cell><div class="ortho-nav-icon -grid"></div></a><a class=ortho-nav-cell><div class="ortho-nav-icon -pdf"></div></a></div><div class=ortho-nav-row><a class=ortho-nav-cell><div class="ortho-nav-icon -plan_bone"></div></a><a class=ortho-nav-cell><div class="ortho-nav-icon -test"></div></a></div></div><div class=ortho-info><div class=ortho-info-inner></div></div><div class=ortho-controls><div class=ortho-controls-inner><div class=ortho-controls-line draggable=false></div><div class="ortho-controls-current -up"><span>Капа 1</span></div><div class="ortho-controls-current -down"><span>Капа 1</span></div><div class=ortho-controls-actions><div class=ortho-controls-actions-inner><div class=ortho-controls-actions-item></div><div class=ortho-controls-actions-item></div><div class=ortho-controls-actions-item></div><div class=ortho-controls-actions-item></div></div></div><div class=ortho-controls-slider draggable=false></div></div></div><div class=ortho-loader><div class=ortho-loader-inner><svg width=100 height=100><circle cx=50 cy=50 r=45></circle></svg><div class=ortho-perc>0%</div></div></div><div class=ortho-nowebgl><span>No WebGL Support</span></div></div>' };
// };
var Viewer=function(_React$Component){_inherits(Viewer,_React$Component);function Viewer(props){_classCallCheck(this,Viewer);var _this=_possibleConstructorReturn(this,(Viewer.__proto__||Object.getPrototypeOf(Viewer)).call(this,props));_this.state={};return _this;}_createClass(Viewer,[{key:'nextStep',value:function nextStep(){var _this2=this;var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_switch_api__["a" /* switch_api */])(Object(__WEBPACK_IMPORTED_MODULE_4__config__["q" /* API_NEXT_STEP */])(this.props.match.params.uuid)),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error('Failed loading { API_NEXT_STEP }: '+response.statusText);_this2.setState({loading:false});}window.location='/home';}).catch(function(e){console.warn(e);// this.setState({loading:false});
});}},{key:'comment',value:function comment(_comment,cb){var _this3=this;var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_switch_api__["a" /* switch_api */])(Object(__WEBPACK_IMPORTED_MODULE_4__config__["r" /* API_SEND_COMMENT */])(this.props.match.params.uuid)),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({comment:_comment})}).then(function(response){if(!response.ok){console.error('Failed loading { API_SEND_COMMENT }: '+response.statusText);_this3.setState({loading:false});}else{cb();}}).catch(function(e){console.warn(e);// this.setState({loading:false});
});}},{key:'getJobAssets',value:function getJobAssets(){var _this4=this;fetch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_switch_api__["a" /* switch_api */])(Object(__WEBPACK_IMPORTED_MODULE_4__config__["f" /* API_GET_JOB_ASSETS */])(this.props.match.params.uuid)),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+localStorage.getItem('token'),'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error('Failed loading { API_GET_JOB_ASSETS }: '+response.statusText);}return response;}).then(function(response){return response.json();}).then(function(json){window.ortho({base_url:__WEBPACK_IMPORTED_MODULE_4__config__["x" /* BASE_URL */],type:'main',json:json,case:json.patient_tag,pdf:{en:json.pdf['report_en.pdf'],ru:json.pdf['report.pdf']},nextStep:function nextStep(){return _this4.nextStep();},comment:function comment(data,cb){return _this4.comment(data,cb);}});}).catch(function(e){console.error(e);// dispatch(userLoggedInFailure('' + e))
// window.location = '/home';
});}},{key:'componentDidMount',value:function componentDidMount(){this.getJobAssets();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-gl-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-mobile-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -menu',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_10__assets_icons_menu_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -occlusion',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9__assets_icons_occlusion_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -lower',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_8__assets_icons_lower_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -upper',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_7__assets_icons_upper_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -both',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_6__assets_icons_both_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-mobile-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -info',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_16__assets_icons_m_i_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -pdf',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_14__assets_icons_pdf_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -grid',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_13__assets_icons_mm_grid_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -separations',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_12__assets_icons_separations_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -locks',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_11__assets_icons_locks_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-mobile-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -transp',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_15__assets_icons_transp_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -transp_back'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -back'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -plan_bone'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -both -active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -both',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_6__assets_icons_both_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -upper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -upper',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_7__assets_icons_upper_svg___default.a+')'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -occlusion'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -occlusion',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9__assets_icons_occlusion_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -lower'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -lower',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_8__assets_icons_lower_svg___default.a+')'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row -line'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -locks -active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -locks',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_11__assets_icons_locks_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -separations -active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -separations',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_12__assets_icons_separations_svg___default.a+')'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row -line'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -grid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -grid',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_13__assets_icons_mm_grid_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -pdf'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -pdf',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_14__assets_icons_pdf_svg___default.a+')'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -plan_bone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -plan_bone'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -back'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -transp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -transp',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_15__assets_icons_transp_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -transp_back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -transp_back'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-subnav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-subnav-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-subnav-cell -en'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-subnav-icon -en',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_17__assets_icons_en_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-subnav-cell -ru'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-subnav-icon -ru',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_18__assets_icons_ru_svg___default.a+')'}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-card ortho-card--dotted ortho-correction',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-card__header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-btn ortho-card__close',icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon icon--close'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-card__text',style:{padding:0,alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-info-inner ps--focus'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-occl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-occl-en',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_23__assets_icons_occlusion_en_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-occl-ru',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_24__assets_icons_occlusion_ru_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-card ortho-card--dotted ortho-rework-comment',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-card__header'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-card__text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-card__actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'ortho-btn',disabled:true,color:'primary'},'Send'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'ortho-btn',color:'error'},'Cancel')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-comment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-comment-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'ortho-comment-inner-textarea',col:'10'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-info-block -bottom -comment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:true,className:'ortho-comment-btn'},'Send'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'ortho-comment-cancel'},'Cancel')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-line',draggable:'false'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-current -up'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-current -down'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-actions-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-actions-item',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_19__assets_icons_first_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-actions-item',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_20__assets_icons_pause_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-actions-item',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_21__assets_icons_play_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-actions-item',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_22__assets_icons_last_svg___default.a+')'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-slider',draggable:'false'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-loader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-loader-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:100,height:100},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{cx:50,cy:50,r:45})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-perc'},'0%'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nowebgl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'No WebGL Support')));}}]);return Viewer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function(_ref){var user=_ref.user;return{user:user};})(Viewer));

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/occlusion_en.41a59203.svg";

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/occlusion_ru.06feda4a.svg";

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_index_css__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_index__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__js_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_both_svg__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_both_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_icons_both_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_icons_upper_svg__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_icons_upper_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_icons_upper_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_icons_lower_svg__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_icons_lower_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_icons_lower_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_icons_occlusion_svg__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_icons_occlusion_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_icons_occlusion_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_icons_menu_svg__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_icons_menu_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_icons_menu_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_icons_locks_svg__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_icons_locks_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_icons_locks_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_icons_separations_svg__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_icons_separations_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_icons_separations_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_icons_mm_grid_svg__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_icons_mm_grid_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_icons_mm_grid_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_icons_pdf_svg__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_icons_pdf_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_icons_pdf_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_icons_transp_svg__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_icons_transp_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_icons_transp_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_icons_plan_bone_svg__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_icons_plan_bone_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_icons_plan_bone_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_icons_m_i_svg__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_icons_m_i_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_icons_m_i_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_icons_en_svg__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_icons_en_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_icons_en_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_icons_ru_svg__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_icons_ru_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_icons_ru_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_icons_first_svg__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_icons_first_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_icons_first_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_icons_pause_svg__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_icons_pause_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_icons_pause_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_icons_play_svg__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_icons_play_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_icons_play_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_icons_last_svg__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_icons_last_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_icons_last_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import back from '../../assets/icons/back.svg';
// const getHTML = () => {
//   return { __html: '<div class=ortho-gl-container><div class=ortho-nav-mobile><div class=ortho-nav-mobile-row><a class="ortho-nav-mobile-icon -both"></a><a class="ortho-nav-mobile-icon -upper"></a><a class="ortho-nav-mobile-icon -lower"></a><a class="ortho-nav-mobile-icon -occlusion"></a><a class="ortho-nav-mobile-icon -menu"></a></div><div class=ortho-nav-mobile-row><a class="ortho-nav-mobile-icon -locks"></a><a class="ortho-nav-mobile-icon -separations"></a><a class="ortho-nav-mobile-icon -grid"></a><a class="ortho-nav-mobile-icon -pdf"></a><a class="ortho-nav-mobile-icon -info"></a></div><div class=ortho-nav-mobile-row><a class="ortho-nav-mobile-icon -test" style=float:right;></a><a class="ortho-nav-mobile-icon -plan_bone"></a></div></div><div class=ortho-nav><div class=ortho-nav-row><a class="ortho-nav-cell -active"><div class="ortho-nav-icon -both"></div></a><a class=ortho-nav-cell><div class="ortho-nav-icon -upper"></div></a></div><div class=ortho-nav-row><a class=ortho-nav-cell><div class="ortho-nav-icon -occlusion"></div></a><a class=ortho-nav-cell><div class="ortho-nav-icon -lower"></div></a></div><div class="ortho-nav-row -line"></div><div class=ortho-nav-row><a class="ortho-nav-cell -active"><div class="ortho-nav-icon -locks"></div></a><a class="ortho-nav-cell -active"><div class="ortho-nav-icon -separations"></div></a></div><div class="ortho-nav-row -line"></div><div class=ortho-nav-row><a class=ortho-nav-cell><div class="ortho-nav-icon -grid"></div></a><a class=ortho-nav-cell><div class="ortho-nav-icon -pdf"></div></a></div><div class=ortho-nav-row><a class=ortho-nav-cell><div class="ortho-nav-icon -plan_bone"></div></a><a class=ortho-nav-cell><div class="ortho-nav-icon -test"></div></a></div></div><div class=ortho-info><div class=ortho-info-inner></div></div><div class=ortho-controls><div class=ortho-controls-inner><div class=ortho-controls-line draggable=false></div><div class="ortho-controls-current -up"><span>Капа 1</span></div><div class="ortho-controls-current -down"><span>Капа 1</span></div><div class=ortho-controls-actions><div class=ortho-controls-actions-inner><div class=ortho-controls-actions-item></div><div class=ortho-controls-actions-item></div><div class=ortho-controls-actions-item></div><div class=ortho-controls-actions-item></div></div></div><div class=ortho-controls-slider draggable=false></div></div></div><div class=ortho-loader><div class=ortho-loader-inner><svg width=100 height=100><circle cx=50 cy=50 r=45></circle></svg><div class=ortho-perc>0%</div></div></div><div class=ortho-nowebgl><span>No WebGL Support</span></div></div>' };
// };
var Viewer=function(_React$Component){_inherits(Viewer,_React$Component);function Viewer(props){_classCallCheck(this,Viewer);var _this=_possibleConstructorReturn(this,(Viewer.__proto__||Object.getPrototypeOf(Viewer)).call(this,props));_this.state={};return _this;}_createClass(Viewer,[{key:'nextStep',value:function nextStep(){var _this2=this;var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_switch_api__["a" /* switch_api */])(Object(__WEBPACK_IMPORTED_MODULE_4__config__["q" /* API_NEXT_STEP */])(this.props.match.params.uuid)),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error('Failed loading { API_NEXT_STEP }: '+response.statusText);_this2.setState({loading:false});}window.location='/home';}).catch(function(e){console.warn(e);// this.setState({loading:false});
});}},{key:'comment',value:function comment(_comment,cb){var _this3=this;var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_switch_api__["a" /* switch_api */])(Object(__WEBPACK_IMPORTED_MODULE_4__config__["r" /* API_SEND_COMMENT */])(this.props.match.params.uuid)),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({comment:_comment})}).then(function(response){if(!response.ok){console.error('Failed loading { API_SEND_COMMENT }: '+response.statusText);_this3.setState({loading:false});}else{cb();}}).catch(function(e){console.warn(e);// this.setState({loading:false});
});}},{key:'getJobAssets',value:function getJobAssets(){var _this4=this;fetch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_switch_api__["a" /* switch_api */])(Object(__WEBPACK_IMPORTED_MODULE_4__config__["f" /* API_GET_JOB_ASSETS */])(this.props.match.params.uuid)),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+localStorage.getItem('token'),'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error('Failed loading { API_GET_JOB_ASSETS }: '+response.statusText);}return response;}).then(function(response){return response.json();}).then(function(json){window.ortho({type:'roots',json:json,case:json.patient_tag,// pdf: {
//   en: json.pdf['report_en.pdf'],
//   ru: json.pdf['report.pdf']
// },
nextStep:function nextStep(){return _this4.nextStep();},comment:function comment(data,cb){return _this4.comment(data,cb);}});}).catch(function(e){console.error(e);// dispatch(userLoggedInFailure('' + e))
// window.location = '/home';
});}},{key:'componentDidMount',value:function componentDidMount(){this.getJobAssets();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-gl-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-mobile-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -menu',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_10__assets_icons_menu_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -occlusion',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9__assets_icons_occlusion_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -lower',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_8__assets_icons_lower_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -upper',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_7__assets_icons_upper_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -both',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_6__assets_icons_both_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-mobile-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -info',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_17__assets_icons_m_i_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -pdf',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_14__assets_icons_pdf_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -grid',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_13__assets_icons_mm_grid_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -separations',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_12__assets_icons_separations_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -locks',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_11__assets_icons_locks_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-mobile-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -transp',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_15__assets_icons_transp_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -transp_back',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_16__assets_icons_plan_bone_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -back'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -plan_bone'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -both -active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -both',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_6__assets_icons_both_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -upper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -upper',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_7__assets_icons_upper_svg___default.a+')'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -occlusion'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -occlusion',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9__assets_icons_occlusion_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -lower'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -lower',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_8__assets_icons_lower_svg___default.a+')'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row -line'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -locks -active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -locks',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_11__assets_icons_locks_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -separations -active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -separations',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_12__assets_icons_separations_svg___default.a+')'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row -line'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -grid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -grid',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_13__assets_icons_mm_grid_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -pdf'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -pdf',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_14__assets_icons_pdf_svg___default.a+')'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -plan_bone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -plan_bone'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -back'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -transp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -transp',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_15__assets_icons_transp_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -transp_back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -transp_back',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_16__assets_icons_plan_bone_svg___default.a+')'}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-subnav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-subnav-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-subnav-cell -en'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-subnav-icon -en',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_18__assets_icons_en_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-subnav-cell -ru'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-subnav-icon -ru',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_19__assets_icons_ru_svg___default.a+')'}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-info-inner'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-occl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-occl-en'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-occl-ru'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-comment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-comment-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'ortho-comment-inner-textarea',col:'10'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-info-block -bottom -comment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:true,className:'ortho-comment-btn'},'Send'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'ortho-comment-cancel'},'Cancel')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-line',draggable:'false'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-current -up'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-current -down'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-actions-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-actions-item',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_20__assets_icons_first_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-actions-item',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_21__assets_icons_pause_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-actions-item',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_22__assets_icons_play_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-actions-item',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_23__assets_icons_last_svg___default.a+')'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-slider',draggable:'false'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-loader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-loader-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:100,height:100},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{cx:50,cy:50,r:45})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-perc'},'0%'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nowebgl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'No WebGL Support')));}}]);return Viewer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function(_ref){var user=_ref.user;return{user:user};})(Viewer));

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_index_css__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_index__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__js_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_switch_api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_both_svg__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_both_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_icons_both_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_icons_upper_svg__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_icons_upper_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_icons_upper_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_icons_lower_svg__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_icons_lower_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_icons_lower_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_icons_occlusion_svg__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_icons_occlusion_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_icons_occlusion_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_icons_menu_svg__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_icons_menu_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_icons_menu_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_icons_locks_svg__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_icons_locks_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_icons_locks_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_icons_separations_svg__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_icons_separations_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_icons_separations_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_icons_mm_grid_svg__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_icons_mm_grid_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_icons_mm_grid_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_icons_pdf_svg__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_icons_pdf_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_icons_pdf_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_icons_transp_svg__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_icons_transp_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_icons_transp_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_icons_plan_bone_svg__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_icons_plan_bone_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_icons_plan_bone_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_icons_m_i_svg__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_icons_m_i_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_icons_m_i_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_icons_en_svg__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_icons_en_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_icons_en_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_icons_ru_svg__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_icons_ru_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_icons_ru_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_icons_first_svg__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_icons_first_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_icons_first_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_icons_pause_svg__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_icons_pause_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_icons_pause_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_icons_play_svg__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_icons_play_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_icons_play_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_icons_last_svg__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_icons_last_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_icons_last_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import back from '../../assets/icons/back.svg';
var Viewer=function(_React$Component){_inherits(Viewer,_React$Component);function Viewer(props){_classCallCheck(this,Viewer);var _this=_possibleConstructorReturn(this,(Viewer.__proto__||Object.getPrototypeOf(Viewer)).call(this,props));_this.state={};return _this;}_createClass(Viewer,[{key:'nextStep',value:function nextStep(){var _this2=this;var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_switch_api__["a" /* switch_api */])(Object(__WEBPACK_IMPORTED_MODULE_4__config__["q" /* API_NEXT_STEP */])(this.props.match.params.uuid)),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error('Failed loading { API_NEXT_STEP }: '+response.statusText);_this2.setState({loading:false});}window.location='/home';}).catch(function(e){console.warn(e);// this.setState({loading:false});
});}},{key:'comment',value:function comment(_comment,cb){var _this3=this;var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_switch_api__["a" /* switch_api */])(Object(__WEBPACK_IMPORTED_MODULE_4__config__["r" /* API_SEND_COMMENT */])(this.props.match.params.uuid)),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({comment:_comment})}).then(function(response){if(!response.ok){console.error('Failed loading { API_SEND_COMMENT }: '+response.statusText);_this3.setState({loading:false});}else{cb();}}).catch(function(e){console.warn(e);// this.setState({loading:false});
});}},{key:'getJobAssets',value:function getJobAssets(){var _this4=this;fetch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_switch_api__["a" /* switch_api */])(Object(__WEBPACK_IMPORTED_MODULE_4__config__["f" /* API_GET_JOB_ASSETS */])(this.props.match.params.uuid)),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+localStorage.getItem('token'),'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error('Failed loading { API_GET_JOB_ASSETS }: '+response.statusText);}return response;}).then(function(response){return response.json();}).then(function(json){window.ortho({type:'deepct',json:json,case:json.patient_tag,// pdf: {
//   en: json.pdf['report_en.pdf'],
//   ru: json.pdf['report.pdf']
// },
nextStep:function nextStep(){return _this4.nextStep();},comment:function comment(data,cb){return _this4.comment(data,cb);}});}).catch(function(e){console.error(e);// dispatch(userLoggedInFailure('' + e))
// window.location = '/home';
});}},{key:'componentDidMount',value:function componentDidMount(){this.getJobAssets();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-gl-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-mobile-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -menu',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_10__assets_icons_menu_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -occlusion',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9__assets_icons_occlusion_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -lower',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_8__assets_icons_lower_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -upper',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_7__assets_icons_upper_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -both',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_6__assets_icons_both_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-mobile-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -info',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_17__assets_icons_m_i_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -pdf',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_14__assets_icons_pdf_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -grid',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_13__assets_icons_mm_grid_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -separations',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_12__assets_icons_separations_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -locks',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_11__assets_icons_locks_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-mobile-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -transp',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_15__assets_icons_transp_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -transp_back',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_16__assets_icons_plan_bone_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -back'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-mobile-icon -plan_bone'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -both -active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -both',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_6__assets_icons_both_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -upper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -upper',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_7__assets_icons_upper_svg___default.a+')'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -occlusion'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -occlusion',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9__assets_icons_occlusion_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -lower'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -lower',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_8__assets_icons_lower_svg___default.a+')'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row -line'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -locks -active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -locks',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_11__assets_icons_locks_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -separations -active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -separations',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_12__assets_icons_separations_svg___default.a+')'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row -line'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -grid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -grid',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_13__assets_icons_mm_grid_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -pdf'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -pdf',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_14__assets_icons_pdf_svg___default.a+')'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -plan_bone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -plan_bone'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -back'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -transp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -transp',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_15__assets_icons_transp_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-nav-cell -transp_back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nav-icon -transp_back',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_16__assets_icons_plan_bone_svg___default.a+')'}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-subnav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-subnav-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-subnav-cell -en'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-subnav-icon -en',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_18__assets_icons_en_svg___default.a+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ortho-subnav-cell -ru'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-subnav-icon -ru',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_19__assets_icons_ru_svg___default.a+')'}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-info-inner'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-occl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-occl-en'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-occl-ru'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-comment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-comment-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'ortho-comment-inner-textarea',col:'10'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-info-block -bottom -comment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:true,className:'ortho-comment-btn'},'Send'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'ortho-comment-cancel'},'Cancel')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-line',draggable:'false'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-current -up'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-current -down'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-actions-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-actions-item',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_20__assets_icons_first_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-actions-item',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_21__assets_icons_pause_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-actions-item',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_22__assets_icons_play_svg___default.a+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-actions-item',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_23__assets_icons_last_svg___default.a+')'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-controls-slider',draggable:'false'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-loader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-loader-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:100,height:100},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{cx:50,cy:50,r:45})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-perc'},'0%'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ortho-nowebgl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'No WebGL Support')));}}]);return Viewer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function(_ref){var user=_ref.user;return{user:user};})(Viewer));

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__css_index_css__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__css_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bowser__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bowser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_js_excel_template_js_excel_template_min_js__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_js_excel_template_js_excel_template_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_js_excel_template_js_excel_template_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__3d_smile_glkit__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__3d_smile_glkit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__3d_smile_glkit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__xgk_js_web_loader__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__xgk_js_web_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__xgk_js_web_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__js_index__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__js_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__js_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_switch_api__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Viewer=function(_React$Component){_inherits(Viewer,_React$Component);function Viewer(props){_classCallCheck(this,Viewer);var _this=_possibleConstructorReturn(this,(Viewer.__proto__||Object.getPrototypeOf(Viewer)).call(this,props));_this.state={};return _this;}_createClass(Viewer,[{key:'nextStep',value:function nextStep(){var _this2=this;var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_switch_api__["a" /* switch_api */])(Object(__WEBPACK_IMPORTED_MODULE_10__config__["q" /* API_NEXT_STEP */])(this.props.match.params.uuid)),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error('Failed loading { API_NEXT_STEP }: '+response.statusText);_this2.setState({loading:false});}window.location='/home';}).catch(function(e){console.warn(e);// this.setState({loading:false});
});}},{key:'comment',value:function comment(_comment,cb){var _this3=this;var token=localStorage.getItem('token');return fetch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_switch_api__["a" /* switch_api */])(Object(__WEBPACK_IMPORTED_MODULE_10__config__["r" /* API_SEND_COMMENT */])(this.props.match.params.uuid)),{method:'POST',headers:{'Accept':'application/json','Authorization':'Token '+token,'Content-Type':'application/json; charset=utf-8'},credentials:'include',body:JSON.stringify({comment:_comment})}).then(function(response){if(!response.ok){console.error('Failed loading { API_SEND_COMMENT }: '+response.statusText);_this3.setState({loading:false});}else{cb();}}).catch(function(e){console.warn(e);// this.setState({loading:false});
});}},{key:'getJobAssets',value:function getJobAssets(){var _this4=this;fetch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_switch_api__["a" /* switch_api */])(Object(__WEBPACK_IMPORTED_MODULE_10__config__["f" /* API_GET_JOB_ASSETS */])(this.props.match.params.uuid)),{method:'GET',headers:{'Accept':'application/json','Authorization':'Token '+localStorage.getItem('token'),'Content-Type':'application/json; charset=utf-8'},credentials:'include'}).then(function(response){if(!response.ok){console.error('Failed loading { API_GET_JOB_ASSETS }: '+response.statusText);}return response;}).then(function(response){return response.json();}).then(function(json){Object(__WEBPACK_IMPORTED_MODULE_9__js_index__["runViewer"])({case_json:json['case.json'],pdf:json.pdf,patient_tag:json.patient_tag,libs:{$:__WEBPACK_IMPORTED_MODULE_3_jquery___default.a,Bowser:__WEBPACK_IMPORTED_MODULE_4_bowser___default.a,FileSaver:__WEBPACK_IMPORTED_MODULE_5_file_saver___default.a,JsExcelTemplate:__WEBPACK_IMPORTED_MODULE_6_js_excel_template_js_excel_template_min_js___default.a,Glkit:__WEBPACK_IMPORTED_MODULE_7__3d_smile_glkit___default.a,Loader:__WEBPACK_IMPORTED_MODULE_8__xgk_js_web_loader___default.a},nextStep:function nextStep(){return _this4.nextStep();},comment:function comment(data,cb){return _this4.comment(data,cb);}});}).catch(function(evt){// window.location = '/home';
console.error(evt);});}},{key:'componentDidMount',value:function componentDidMount(){this.getJobAssets();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-wrapper',id:'_3d_plan-wrapper',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-wrapper-screen_flag',id:'_3d_plan-wrapper-screen_flag',draggable:'false'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-canvas',id:'_3d_plan-canvas',draggable:'false'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-controls',id:'_3d_plan-controls',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-controls-button',id:'_3d_plan-controls-button',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{width:'100%',height:'100%',draggable:'false'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-controls-actions-logo',id:'_3d_plan-controls-actions-logo',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{width:'100%',height:'100%',draggable:'false'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-controls-actions',id:'_3d_plan-controls-actions',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-controls-actions-cell',id:'_3d_plan-controls-actions-cell-both',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{width:'100%',height:'100%',draggable:'false'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-controls-actions-cell',id:'_3d_plan-controls-actions-cell-occlusion',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{width:'100%',height:'100%',draggable:'false'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-controls-actions-cell',id:'_3d_plan-controls-actions-cell-upper',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{width:'100%',height:'100%',draggable:'false'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-controls-actions-cell',id:'_3d_plan-controls-actions-cell-lower',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{width:'100%',height:'100%',draggable:'false'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-controls-actions-cell',id:'_3d_plan-controls-actions-cell-grid',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{width:'100%',height:'100%',draggable:'false'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-controls-actions-cell',id:'_3d_plan-controls-actions-cell-separations',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{width:'100%',height:'100%',draggable:'false'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-controls-actions-cell',id:'_3d_plan-controls-actions-cell-locks',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{width:'100%',height:'100%',draggable:'false'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-controls-actions-cell',id:'_3d_plan-controls-actions-cell-pdf',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{width:'100%',height:'100%',draggable:'false'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-controls-actions-cell',id:'_3d_plan-controls-actions-cell-info',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{width:'100%',height:'100%',draggable:'false'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-info',id:'_3d_plan-info',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-info-inner',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-info-title',id:'_3d_plan-info-title',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-info-upper',id:'_3d_plan-info-upper',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-info-lower',id:'_3d_plan-info-lower',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-info-actions',id:'_3d_plan-info-actions',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'_3d_plan-info-actions-publish',id:'_3d_plan-info-actions-publish',draggable:'false'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'_3d_plan-info-actions-rework',id:'_3d_plan-info-actions-rework',draggable:'false'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-info-debug',id:'_3d_plan-info-debug',draggable:'false'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-info-close',id:'_3d_plan-info-close',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'+')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-info-occlusion',id:'_3d_plan-info-occlusion',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'_3d_plan-info-occlusion-en',id:'_3d_plan-info-occlusion-en',width:'100%',height:'100%',draggable:'false'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'_3d_plan-info-occlusion-ru',id:'_3d_plan-info-occlusion-ru',width:'100%',height:'100%',draggable:'false'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-sequencer',id:'_3d_plan-sequencer',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-sequencer-upper_title',id:'_3d_plan-sequencer-upper_title',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-sequencer-lower_title',id:'_3d_plan-sequencer-lower_title',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-sequencer-container',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-sequencer-actions',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-sequencer-cell',draggable:'false',unselectable:'on'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-sequencer-button',id:'_3d_plan-sequencer-button-first_step',draggable:'false',unselectable:'on'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{draggable:'false',unselectable:'on'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-sequencer-cell',draggable:'false',unselectable:'on'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-sequencer-button',id:'_3d_plan-sequencer-button-pause',draggable:'false',unselectable:'on'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{draggable:'false',unselectable:'on'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-sequencer-cell',draggable:'false',unselectable:'on'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-sequencer-button',id:'_3d_plan-sequencer-button-play',draggable:'false',unselectable:'on'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{draggable:'false',unselectable:'on'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-sequencer-cell',draggable:'false',unselectable:'on'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-sequencer-button',id:'_3d_plan-sequencer-button-last_step',draggable:'false',unselectable:'on'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{draggable:'false',unselectable:'on'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-sequencer-track',id:'_3d_plan-sequencer-track',draggable:'false'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-sequencer-runner',id:'_3d_plan-sequencer-runner',draggable:'false'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-comment',id:'_3d_plan-comment',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{className:'_3d_plan-comment-text',id:'_3d_plan-comment-text',draggable:'false'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-comment-actions',id:'_3d_plan-comment-actions',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'_3d_plan-comment-actions-send -disabled',id:'_3d_plan-comment-actions-send',draggable:'false'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'_3d_plan-comment-actions-cancel',id:'_3d_plan-comment-actions-cancel',draggable:'false'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-nowebgl',id:'_3d_plan-nowebgl',draggable:'false'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-loader',id:'_3d_plan-loader',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-loader-inner',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{width:'100',height:'100',draggable:'false'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('circle',{id:'_3d_plan-loader-circle',cx:'50',cy:'50',r:'45',draggable:'false'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'_3d_plan-loader-percentage',id:'_3d_plan-loader-percentage',draggable:'false'},'0%'))));}}]);return Viewer;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function(_ref){var user=_ref.user;return{user:user};})(Viewer));

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.bowser=t():e.bowser=t()}(this,function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var i=t[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)r.d(n,i,function(t){return e[t]}.bind(null,i));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=70)}({18:function(e,t,r){var n,i,s;i=[e],void 0===(s="function"==typeof(n=function(e){"use strict";var t=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),r=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e)}return t(e,null,[{key:"getFirstMatch",value:function(e,t){var r=t.match(e);return r&&r.length>0&&r[1]||""}},{key:"getSecondMatch",value:function(e,t){var r=t.match(e);return r&&r.length>1&&r[2]||""}},{key:"matchAndReturnConst",value:function(e,t,r){if(e.test(t))return r}},{key:"getWindowsVersionName",value:function(e){switch(e){case"NT":return"NT";case"XP":return"XP";case"NT 5.0":return"2000";case"NT 5.1":return"XP";case"NT 5.2":return"2003";case"NT 6.0":return"Vista";case"NT 6.1":return"7";case"NT 6.2":return"8";case"NT 6.3":return"8.1";case"NT 10.0":return"10";default:return}}},{key:"getVersionPrecision",value:function(e){return e.split(".").length}},{key:"compareVersions",value:function(t,r){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],i=e.getVersionPrecision(t),s=e.getVersionPrecision(r),o=Math.max(i,s),a=0,u=e.map([t,r],function(t){var r=o-e.getVersionPrecision(t),n=t+new Array(r+1).join(".0");return e.map(n.split("."),function(e){return new Array(20-e.length).join("0")+e}).reverse()});for(n&&(a=o-Math.min(i,s)),o-=1;o>=a;){if(u[0][o]>u[1][o])return 1;if(u[0][o]===u[1][o]){if(o===a)return 0;o-=1}else if(u[0][o]<u[1][o])return-1}}},{key:"map",value:function(e,t){var r=[],n=void 0;if(Array.prototype.map)return Array.prototype.map.call(e,t);for(n=0;n<e.length;n+=1)r.push(t(e[n]));return r}}]),e}();e.exports=r})?n.apply(t,i):n)||(e.exports=s)},65:function(e,t,r){var n,i,s;i=[t,r(18)],void 0===(s="function"==typeof(n=function(t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=[{test:function(e){return"microsoft edge"===e.getBrowserName(!0)},describe:function(e){var t=(0,r.getFirstMatch)(/edge\/(\d+(\.?_?\d+)+)/i,e);return{name:"EdgeHTML",version:t}}},{test:[/trident/i],describe:function(e){var t={name:"Trident"},n=(0,r.getFirstMatch)(/trident\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:function(e){return e.test(/presto/i)},describe:function(e){var t={name:"Presto"},n=(0,r.getFirstMatch)(/presto\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:function(e){var t=e.test(/gecko/i),r=e.test(/like gecko/i);return t&&!r},describe:function(e){var t={name:"Gecko"},n=(0,r.getFirstMatch)(/gecko\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/(apple)?webkit\/537\.36/i],describe:function(){return{name:"Blink"}}},{test:[/(apple)?webkit/i],describe:function(e){var t={name:"WebKit"},n=(0,r.getFirstMatch)(/webkit\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}}],e.exports=t.default})?n.apply(t,i):n)||(e.exports=s)},66:function(e,t,r){var n,i,s;i=[t,r(18)],void 0===(s="function"==typeof(n=function(t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n={tablet:"tablet",mobile:"mobile",desktop:"desktop"};t.default=[{test:[/nexus\s*(?:7|8|9|10).*/i],describe:function(){return{type:n.tablet,vendor:"Nexus"}}},{test:[/ipad/i],describe:function(){return{type:n.tablet,vendor:"Apple",model:"iPad"}}},{test:[/kftt build/i],describe:function(){return{type:n.tablet,vendor:"Amazon",model:"Kindle Fire HD 7"}}},{test:[/silk/i],describe:function(){return{type:n.tablet,vendor:"Amazon"}}},{test:[/tablet/i],describe:function(){return{type:n.tablet}}},{test:function(e){var t=e.test(/ipod|iphone/i),r=e.test(/like (ipod|iphone)/i);return t&&!r},describe:function(e){var t=(0,r.getFirstMatch)(/(ipod|iphone)/i,e);return{type:n.mobile,vendor:"Apple",model:t}}},{test:[/nexus\s*[0-6].*/i,/galaxy nexus/i],describe:function(){return{type:n.mobile,vendor:"Nexus"}}},{test:[/[^-]mobi/i],describe:function(){return{type:n.mobile}}},{test:function(e){return"blackberry"===e.getBrowserName(!0)},describe:function(){return{type:n.mobile,vendor:"BlackBerry"}}},{test:function(e){return"bada"===e.getBrowserName(!0)},describe:function(){return{type:n.mobile}}},{test:function(e){return"windows phone"===e.getBrowserName()},describe:function(){return{type:n.mobile,vendor:"Microsoft"}}},{test:function(e){var t=Number(String(e.getOSVersion()).split(".")[0]);return"android"===e.getOSName(!0)&&t>=3},describe:function(){return{type:n.tablet}}},{test:function(e){return"android"===e.getOSName(!0)},describe:function(){return{type:n.mobile}}},{test:function(e){return"macos"===e.getOSName(!0)},describe:function(){return{type:n.desktop,vendor:"Apple"}}},{test:function(e){return"windows"===e.getOSName(!0)},describe:function(){return{type:n.desktop}}},{test:function(e){return"linux"===e.getOSName(!0)},describe:function(){return{type:n.desktop}}}],e.exports=t.default})?n.apply(t,i):n)||(e.exports=s)},67:function(e,t,r){var n,i,s;i=[t,r(18)],void 0===(s="function"==typeof(n=function(t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=[{test:[/windows phone/i],describe:function(e){var t=(0,r.getFirstMatch)(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i,e);return{name:"Windows Phone",version:t}}},{test:[/windows/i],describe:function(e){var t=(0,r.getFirstMatch)(/Windows ((NT|XP)( \d\d?.\d)?)/i,e),n=(0,r.getWindowsVersionName)(t);return{name:"Windows",version:t,versionName:n}}},{test:[/macintosh/i],describe:function(e){var t=(0,r.getFirstMatch)(/mac os x (\d+(\.?_?\d+)+)/i,e).replace(/[_\s]/g,".");return{name:"macOS",version:t}}},{test:[/(ipod|iphone|ipad)/i],describe:function(e){var t=(0,r.getFirstMatch)(/os (\d+([_\s]\d+)*) like mac os x/i,e).replace(/[_\s]/g,".");return{name:"iOS",version:t}}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t=(0,r.getFirstMatch)(/android[\s/-](\d+(\.\d+)*)/i,e);return{name:"Android",version:t}}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t=(0,r.getFirstMatch)(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i,e),n={name:"WebOS"};return t&&t.length&&(n.version=t),n}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t=(0,r.getFirstMatch)(/rim\stablet\sos\s(\d+(\.\d+)*)/i,e)||(0,r.getFirstMatch)(/blackberry\d+\/(\d+([_\s]\d+)*)/i,e)||(0,r.getFirstMatch)(/\bbb(\d+)/i,e);return{name:"BlackBerry",version:t}}},{test:[/bada/i],describe:function(e){var t=(0,r.getFirstMatch)(/bada\/(\d+(\.\d+)*)/i,e);return{name:"Bada",version:t}}},{test:[/tizen/i],describe:function(e){var t=(0,r.getFirstMatch)(/tizen[/\s](\d+(\.\d+)*)/i,e);return{name:"Tizen",version:t}}},{test:[/linux/i],describe:function(){return{name:"Linux"}}}],e.exports=t.default})?n.apply(t,i):n)||(e.exports=s)},68:function(e,t,r){var n,i,s;i=[t,r(18)],void 0===(s="function"==typeof(n=function(t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=/version\/(\d+(\.?_?\d+)+)/i,i=[{test:[/opera/i],describe:function(e){var t={name:"Opera"},i=(0,r.getFirstMatch)(n,e)||(0,r.getFirstMatch)(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i,e);return i&&(t.version=i),t}},{test:[/opr\/|opios/i],describe:function(e){var t={name:"Opera"},i=(0,r.getFirstMatch)(/(?:opr|opios)[\s/](\S+)/i,e)||(0,r.getFirstMatch)(n,e);return i&&(t.version=i),t}},{test:[/SamsungBrowser/i],describe:function(e){var t={name:"Samsung Internet for Android"},i=(0,r.getFirstMatch)(n,e)||(0,r.getFirstMatch)(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return i&&(t.version=i),t}},{test:[/Whale/i],describe:function(e){var t={name:"NAVER Whale Browser"},i=(0,r.getFirstMatch)(n,e)||(0,r.getFirstMatch)(/(?:whale)[\s/](\d+(?:\.\d+)+)/i,e);return i&&(t.version=i),t}},{test:[/MZBrowser/i],describe:function(e){var t={name:"MZ Browser"},i=(0,r.getFirstMatch)(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i,e)||(0,r.getFirstMatch)(n,e);return i&&(t.version=i),t}},{test:[/focus/i],describe:function(e){var t={name:"Focus"},i=(0,r.getFirstMatch)(/(?:focus)[\s/](\d+(?:\.\d+)+)/i,e)||(0,r.getFirstMatch)(n,e);return i&&(t.version=i),t}},{test:[/swing/i],describe:function(e){var t={name:"Swing"},i=(0,r.getFirstMatch)(/(?:swing)[\s/](\d+(?:\.\d+)+)/i,e)||(0,r.getFirstMatch)(n,e);return i&&(t.version=i),t}},{test:[/coast/i],describe:function(e){var t={name:"Opera Coast"},i=(0,r.getFirstMatch)(n,e)||(0,r.getFirstMatch)(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i,e);return i&&(t.version=i),t}},{test:[/yabrowser/i],describe:function(e){var t={name:"Yandex Browser"},i=(0,r.getFirstMatch)(n,e)||(0,r.getFirstMatch)(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return i&&(t.version=i),t}},{test:[/ucbrowser/i],describe:function(e){var t={name:"UC Browser"},i=(0,r.getFirstMatch)(n,e)||(0,r.getFirstMatch)(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return i&&(t.version=i),t}},{test:[/Maxthon|mxios/i],describe:function(e){var t={name:"Maxthon"},i=(0,r.getFirstMatch)(n,e)||(0,r.getFirstMatch)(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i,e);return i&&(t.version=i),t}},{test:[/epiphany/i],describe:function(e){var t={name:"Epiphany"},i=(0,r.getFirstMatch)(n,e)||(0,r.getFirstMatch)(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i,e);return i&&(t.version=i),t}},{test:[/puffin/i],describe:function(e){var t={name:"Puffin"},i=(0,r.getFirstMatch)(n,e)||(0,r.getFirstMatch)(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i,e);return i&&(t.version=i),t}},{test:[/sleipnir/i],describe:function(e){var t={name:"Sleipnir"},i=(0,r.getFirstMatch)(n,e)||(0,r.getFirstMatch)(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i,e);return i&&(t.version=i),t}},{test:[/k-meleon/i],describe:function(e){var t={name:"K-Meleon"},i=(0,r.getFirstMatch)(n,e)||(0,r.getFirstMatch)(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i,e);return i&&(t.version=i),t}},{test:[/msie|trident/i],describe:function(e){var t={name:"Internet Explorer"},n=(0,r.getFirstMatch)(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/edg([ea]|ios)/i],describe:function(e){var t={name:"Microsoft Edge"},n=(0,r.getSecondMatch)(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/vivaldi/i],describe:function(e){var t={name:"Vivaldi"},n=(0,r.getFirstMatch)(/vivaldi\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/seamonkey/i],describe:function(e){var t={name:"SeaMonkey"},n=(0,r.getFirstMatch)(/seamonkey\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/sailfish/i],describe:function(e){var t={name:"Sailfish"},n=(0,r.getFirstMatch)(/sailfish\s?browser\/(\d+(\.\d+)?)/i,e);return n&&(t.version=n),t}},{test:[/silk/i],describe:function(e){var t={name:"Amazon Silk"},n=(0,r.getFirstMatch)(/silk\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/phantom/i],describe:function(e){var t={name:"PhantomJS"},n=(0,r.getFirstMatch)(/phantomjs\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/slimerjs/i],describe:function(e){var t={name:"SlimerJS"},n=(0,r.getFirstMatch)(/slimerjs\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t={name:"BlackBerry"},i=(0,r.getFirstMatch)(n,e)||(0,r.getFirstMatch)(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i,e);return i&&(t.version=i),t}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t={name:"WebOS Browser"},i=(0,r.getFirstMatch)(n,e)||(0,r.getFirstMatch)(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i,e);return i&&(t.version=i),t}},{test:[/bada/i],describe:function(e){var t={name:"Bada"},n=(0,r.getFirstMatch)(/dolfin\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/tizen/i],describe:function(e){var t={name:"Tizen"},i=(0,r.getFirstMatch)(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,e)||(0,r.getFirstMatch)(n,e);return i&&(t.version=i),t}},{test:[/qupzilla/i],describe:function(e){var t={name:"QupZilla"},i=(0,r.getFirstMatch)(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i,e)||(0,r.getFirstMatch)(n,e);return i&&(t.version=i),t}},{test:[/firefox|iceweasel|fxios/i],describe:function(e){var t={name:"Firefox"},n=(0,r.getFirstMatch)(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/chromium/i],describe:function(e){var t={name:"Chromium"},i=(0,r.getFirstMatch)(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,e)||(0,r.getFirstMatch)(n,e);return i&&(t.version=i),t}},{test:[/chrome|crios|crmo/i],describe:function(e){var t={name:"Chrome"},n=(0,r.getFirstMatch)(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t={name:"Android Browser"},i=(0,r.getFirstMatch)(n,e);return i&&(t.version=i),t}},{test:[/safari|applewebkit/i],describe:function(e){var t={name:"Safari"},i=(0,r.getFirstMatch)(n,e);return i&&(t.version=i),t}},{test:[/googlebot/i],describe:function(e){var t={name:"Googlebot"},i=(0,r.getFirstMatch)(/googlebot\/(\d+(\.\d+))/i,e)||(0,r.getFirstMatch)(n,e);return i&&(t.version=i),t}},{test:[/.*/i],describe:function(e){return{name:(0,r.getFirstMatch)(/^(.*)\/(.*) /,e),version:(0,r.getSecondMatch)(/^(.*)\/(.*) /,e)}}}];t.default=i,e.exports=t.default})?n.apply(t,i):n)||(e.exports=s)},69:function(e,t,r){var n,i,s;i=[t,r(68),r(67),r(66),r(65),r(18)],void 0===(s="function"==typeof(n=function(t,r,n,i,s,o){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=f(r),u=f(n),c=f(i),d=f(s);function f(e){return e&&e.__esModule?e:{default:e}}var l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},v=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),p=function(){function e(t){var r=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),void 0===t||null===t||""===t)throw new Error("UserAgent parameter can't be empty");this._ua=t,this.parsedResult={},!0!==r&&this.parse()}return v(e,[{key:"getUA",value:function(){return this._ua}},{key:"test",value:function(e){return e.test(this._ua)}},{key:"parseBrowser",value:function(){var e=this;this.parsedResult.browser={};var t=a.default.find(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some(function(t){return e.test(t)});throw new Error("Browser's test function is not valid")});return t&&(this.parsedResult.browser=t.describe(this.getUA())),this.parsedResult.browser}},{key:"getBrowser",value:function(){return this.parsedResult.browser?this.parsedResult.browser:this.parseBrowser()}},{key:"getBrowserName",value:function(e){return e?String(this.getBrowser().name).toLowerCase()||"":this.getBrowser().name||""}},{key:"getBrowserVersion",value:function(){return this.getBrowser().version}},{key:"getOS",value:function(){return this.parsedResult.os?this.parsedResult.os:this.parseOS()}},{key:"parseOS",value:function(){var e=this;this.parsedResult.os={};var t=u.default.find(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some(function(t){return e.test(t)});throw new Error("Browser's test function is not valid")});return t&&(this.parsedResult.os=t.describe(this.getUA())),this.parsedResult.os}},{key:"getOSName",value:function(e){var t=this.getOS(),r=t.name;return e?String(r).toLowerCase()||"":r||""}},{key:"getOSVersion",value:function(){return this.getOS().version}},{key:"getPlatform",value:function(){return this.parsedResult.platform?this.parsedResult.platform:this.parsePlatform()}},{key:"getPlatformType",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=this.getPlatform(),r=t.type;return e?String(r).toLowerCase()||"":r||""}},{key:"parsePlatform",value:function(){var e=this;this.parsedResult.platform={};var t=c.default.find(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some(function(t){return e.test(t)});throw new Error("Browser's test function is not valid")});return t&&(this.parsedResult.platform=t.describe(this.getUA())),this.parsedResult.platform}},{key:"getEngine",value:function(){return this.parsedResult.engine?this.parsedResult.engine:this.parseEngine()}},{key:"parseEngine",value:function(){var e=this;this.parsedResult.engine={};var t=d.default.find(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some(function(t){return e.test(t)});throw new Error("Browser's test function is not valid")});return t&&(this.parsedResult.engine=t.describe(this.getUA())),this.parsedResult.engine}},{key:"parse",value:function(){return this.parseBrowser(),this.parseOS(),this.parsePlatform(),this.parseEngine(),this}},{key:"getResult",value:function(){return this.parsedResult}},{key:"satisfies",value:function(e){var t=this,r={},n=0,i={},s=0,o=Object.keys(e);if(o.forEach(function(t){var o=e[t];"string"==typeof o?(i[t]=o,s+=1):"object"===(void 0===o?"undefined":l(o))&&(r[t]=o,n+=1)}),n>0){var a=Object.keys(r),u=a.find(function(e){return t.isOS(e)});if(u){var c=this.satisfies(r[u]);if(void 0!==c)return c}var d=a.find(function(e){return t.isPlatform(e)});if(d){var f=this.satisfies(r[d]);if(void 0!==f)return f}}if(s>0){var v=Object.keys(i),p=v.find(function(e){return t.isBrowser(e)});if(void 0!==p)return this.compareVersion(i[p])}}},{key:"isBrowser",value:function(e){return this.getBrowserName(!0)===String(e).toLowerCase()}},{key:"compareVersion",value:function(e){var t=0,r=e,n=!1,i=this.getBrowserVersion();if("string"==typeof i)return">"===e[0]?(t=1,r=e.substr(1)):"<"===e[0]?(t=-1,r=e.substr(1)):"="===e[0]?r=e.substr(1):"~"===e[0]&&(n=!0,r=e.substr(1)),(0,o.compareVersions)(i,r,n)===t}},{key:"isOS",value:function(e){return this.getOSName(!0)===String(e).toLowerCase()}},{key:"isPlatform",value:function(e){return this.getPlatformType(!0)===String(e).toLowerCase()}},{key:"is",value:function(e){return this.isBrowser(e)||this.isOS(e)||this.isPlatform(e)}},{key:"some",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];return t.some(function(t){return e.is(t)})}}]),e}();t.default=p,e.exports=t.default})?n.apply(t,i):n)||(e.exports=s)},70:function(e,t,r){var n,i,s;i=[t,r(69)],void 0===(s="function"==typeof(n=function(t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){return e&&e.__esModule?e:{default:e}}(r),i=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),s=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e)}return i(e,null,[{key:"getParser",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if("string"!=typeof e)throw new Error("UserAgent should be a string");return new n.default(e,t)}},{key:"parse",value:function(e){return new n.default(e).getResult()}}]),e}();t.default=s,e.exports=t.default})?n.apply(t,i):n)||(e.exports=s)}})});

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		}
		, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
		, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		, arbitrary_revoke_timeout = 1000 * 40 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, auto_bom = function(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
			}
			return blob;
		}
		, FileSaver = function(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, force = type === force_saveable_type
				, object_url
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
						// Safari doesn't allow downloading of blob urls
						var reader = new FileReader();
						reader.onloadend = function() {
							var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
							var popup = view.open(url, '_blank');
							if(!popup) view.location.href = url;
							url=undefined; // release reference before dispatching
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						};
						reader.readAsDataURL(blob);
						filesaver.readyState = filesaver.INIT;
						return;
					}
					// don't create more object URLs than needed
					if (!object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (force) {
						view.location.href = object_url;
					} else {
						var opened = view.open(object_url, "_blank");
						if (!opened) {
							// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
							view.location.href = object_url;
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
			;
			filesaver.readyState = filesaver.INIT;

			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function() {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}

			fs_error();
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		}
	;
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function(blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function(){};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
  module.exports.saveAs = saveAs;
} else if (("function" !== "undefined" && __webpack_require__(1083) !== null) && (__webpack_require__(370) !== null)) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
    return saveAs;
  }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}


/***/ }),
/* 1083 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

!function(r,t){ true?module.exports=t(__webpack_require__(1085)):"function"==typeof define&&define.amd?define(["xlsx"],t):r.JsExcelTemplate=t(r.XLSX)}(this,function(n){"use strict";var o=function(r,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(r,t){r.__proto__=t}||function(r,t){for(var e in t)t.hasOwnProperty(e)&&(r[e]=t[e])})(r,t)};function j(r){var t="function"==typeof Symbol&&r[Symbol.iterator],e=0;return t?t.call(r):{next:function(){return r&&e>=r.length&&(r=void 0),{value:r&&r[e++],done:!r}}}}function B(r,t){var e="function"==typeof Symbol&&r[Symbol.iterator];if(!e)return r;var n,o,i=e.call(r),f=[];try{for(;(void 0===t||0<t--)&&!(n=i.next()).done;)f.push(n.value)}catch(r){o={error:r}}finally{try{n&&!n.done&&(e=i.return)&&e.call(i)}finally{if(o)throw o.error}}return f}function i(r){return String.fromCharCode.apply(String,function(){for(var r=[],t=0;t<arguments.length;t++)r=r.concat(B(arguments[t]));return r}(new Uint8Array(r)))}return function(r){function e(){return null!==r&&r.apply(this,arguments)||this}return function(r,t){function e(){this.constructor=r}o(r,t),r.prototype=null===t?Object.create(t):(e.prototype=t.prototype,new e)}(e,r),e.fromArrayBuffer=function(r){var t=btoa(i(r));return new e(n.read(t,{type:"base64",cellNF:!0,cellStyles:!0,cellDates:!0}))},e.prototype.toArrayBuffer=function(r){return function(r){for(var t=new ArrayBuffer(r.length),e=new Uint8Array(t),n=0;n<r.length;n++)e[n]=255&r.charCodeAt(n);return t}(n.write(this.workbook,{bookType:r,type:"binary"}))},e.prototype.toBlob=function(r){void 0===r&&(r="xlsx");var t=this.toArrayBuffer(r);return new Blob([t],{type:"application/octet-stream"})},e}(function(){function r(r){this.workbook=r}return r.prototype.set=function(r,t){var e,n,o,i;if(Array.isArray(t)){if(0===t.length)return;try{for(var f=j(this.workbook.SheetNames),a=f.next();!a.done;a=f.next()){var l=a.value,u=this.workbook.Sheets[l],s=this.findRowIndex(r,u);if(0<=s){var c=u["!ref"];if(c){var y=B(c.split(":"),2),p=y[0],h=y[1],v=this.parseCellName(h),d=v.column,w=v.rowIndex,x=w+t.length;0<=w&&(u["!ref"]=p+":"+d+x)}for(var b in u)if(u.hasOwnProperty(b)&&0!==b.indexOf("!")){var m=this.parseCellName(b),g=m.column,O=m.rowIndex,S=u[b];if(O===s&&S.w){var k=S.w.indexOf("{"+r+".");if(0<=k){for(var N=void 0,A=k+("{"+r+".").length;A<S.w.length;A++)if("}"===S.w[A]){N=S.w.substring(k+("{"+r+".").length,A);break}if(N){for(A=1;A<t.length;A++)u[g+(O+A)]=JSON.parse(JSON.stringify(u[b]));for(A=0;A<t.length;A++){var C=u[g+(O+A)];this.setCell(C,"{"+r+"."+N+"}",t[A][N])}}}}}return}}}catch(r){e={error:r}}finally{try{a&&!a.done&&(n=f.return)&&n.call(f)}finally{if(e)throw e.error}}}else try{for(var _=j(this.workbook.SheetNames),I=_.next();!I.done;I=_.next()){l=I.value,u=this.workbook.Sheets[l];for(var b in u)if(u.hasOwnProperty(b)&&0!==b.indexOf("!")){S=u[b];this.setCell(S,"{"+r+"}",t)}}}catch(r){o={error:r}}finally{try{I&&!I.done&&(i=_.return)&&i.call(_)}finally{if(o)throw o.error}}},r.prototype.setCell=function(r,t,e){r.v&&"string"==typeof r.v&&0<=r.v.indexOf(t)&&(r.v=r.v===t?e:r.v.split(t).join(e),"number"==typeof r.v?r.t="n":"[object Date]"===Object.prototype.toString.call(r.v)?r.t="d":!0!==r.v&&!1!==r.v||(r.t="b"))},r.prototype.parseCellName=function(r){for(var t=0;t<r.length;t++)if(!isNaN(+r[t]))return{column:r.substring(0,t),rowIndex:+r.substring(t)};return{column:"",rowIndex:-1}},r.prototype.findRowIndex=function(r,t){for(var e in t)if(t.hasOwnProperty(e)&&0!==e.indexOf("!")){var n=t[e];if(n.w&&0<=n.w.indexOf("{"+r+"."))return this.parseCellName(e).rowIndex}return-1},r}())});


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, Buffer, process) {/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*exported XLSX */
/*global global, exports, module, require:false, process:false, Buffer:false, ArrayBuffer:false */
var XLSX = {};
function make_xlsx_lib(XLSX){
XLSX.version = '0.13.5';
var current_codepage = 1200, current_ansi = 1252;
/*global cptable:true, window */
if(true) {
	if(typeof cptable === 'undefined') {
		if(typeof global !== 'undefined') global.cptable = __webpack_require__(371);
		else if(typeof window !== 'undefined') window.cptable = __webpack_require__(371);
	}
}

var VALID_ANSI = [ 874, 932, 936, 949, 950 ];
for(var i = 0; i <= 8; ++i) VALID_ANSI.push(1250 + i);
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */
var CS2CP = ({
0:    1252, /* ANSI */
1:   65001, /* DEFAULT */
2:   65001, /* SYMBOL */
77:  10000, /* MAC */
128:   932, /* SHIFTJIS */
129:   949, /* HANGUL */
130:  1361, /* JOHAB */
134:   936, /* GB2312 */
136:   950, /* CHINESEBIG5 */
161:  1253, /* GREEK */
162:  1254, /* TURKISH */
163:  1258, /* VIETNAMESE */
177:  1255, /* HEBREW */
178:  1256, /* ARABIC */
186:  1257, /* BALTIC */
204:  1251, /* RUSSIAN */
222:   874, /* THAI */
238:  1250, /* EASTEUROPE */
255:  1252, /* OEM */
69:   6969  /* MISC */
});

var set_ansi = function(cp) { if(VALID_ANSI.indexOf(cp) == -1) return; current_ansi = CS2CP[0] = cp; };
function reset_ansi() { set_ansi(1252); }

var set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
function reset_cp() { set_cp(1200); reset_ansi(); }

function char_codes(data) { var o = []; for(var i = 0, len = data.length; i < len; ++i) o[i] = data.charCodeAt(i); return o; }

function utf16leread(data) {
	var o = [];
	for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i) + (data.charCodeAt(2*i+1)<<8));
	return o.join("");
}
function utf16beread(data) {
	var o = [];
	for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i+1) + (data.charCodeAt(2*i)<<8));
	return o.join("");
}

var debom = function(data) {
	var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
	if(c1 == 0xFF && c2 == 0xFE) return utf16leread(data.slice(2));
	if(c1 == 0xFE && c2 == 0xFF) return utf16beread(data.slice(2));
	if(c1 == 0xFEFF) return data.slice(1);
	return data;
};

var _getchar = function _gc1(x) { return String.fromCharCode(x); };
if(typeof cptable !== 'undefined') {
	set_cp = function(cp) { current_codepage = cp; };
	debom = function(data) {
		if(data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) { return cptable.utils.decode(1200, char_codes(data.slice(2))); }
		return data;
	};
	_getchar = function _gc2(x) {
		if(current_codepage === 1200) return String.fromCharCode(x);
		return cptable.utils.decode(current_codepage, [x&255,x>>8])[0];
	};
}
var DENSE = null;
var DIF_XL = true;
var Base64 = (function make_b64(){
	var map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	return {
		encode: function(input) {
			var o = "";
			var c1=0, c2=0, c3=0, e1=0, e2=0, e3=0, e4=0;
			for(var i = 0; i < input.length; ) {
				c1 = input.charCodeAt(i++);
				e1 = (c1 >> 2);

				c2 = input.charCodeAt(i++);
				e2 = ((c1 & 3) << 4) | (c2 >> 4);

				c3 = input.charCodeAt(i++);
				e3 = ((c2 & 15) << 2) | (c3 >> 6);
				e4 = (c3 & 63);
				if (isNaN(c2)) { e3 = e4 = 64; }
				else if (isNaN(c3)) { e4 = 64; }
				o += map.charAt(e1) + map.charAt(e2) + map.charAt(e3) + map.charAt(e4);
			}
			return o;
		},
		decode: function b64_decode(input) {
			var o = "";
			var c1=0, c2=0, c3=0, e1=0, e2=0, e3=0, e4=0;
			input = input.replace(/[^\w\+\/\=]/g, "");
			for(var i = 0; i < input.length;) {
				e1 = map.indexOf(input.charAt(i++));
				e2 = map.indexOf(input.charAt(i++));
				c1 = (e1 << 2) | (e2 >> 4);
				o += String.fromCharCode(c1);

				e3 = map.indexOf(input.charAt(i++));
				c2 = ((e2 & 15) << 4) | (e3 >> 2);
				if (e3 !== 64) { o += String.fromCharCode(c2); }

				e4 = map.indexOf(input.charAt(i++));
				c3 = ((e3 & 3) << 6) | e4;
				if (e4 !== 64) { o += String.fromCharCode(c3); }
			}
			return o;
		}
	};
})();
var has_buf = (typeof Buffer !== 'undefined' && typeof process !== 'undefined' && typeof process.versions !== 'undefined' && process.versions.node);

var Buffer_from = function(){};

if(typeof Buffer !== 'undefined') {
	var nbfs = !Buffer.from;
	if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
	Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
	// $FlowIgnore
	if(!Buffer.alloc) Buffer.alloc = function(n) { return new Buffer(n); };
}

function new_raw_buf(len) {
	/* jshint -W056 */
	return has_buf ? Buffer.alloc(len) : new Array(len);
	/* jshint +W056 */
}

var s2a = function s2a(s) {
	// $FlowIgnore
	if(has_buf) return Buffer_from(s, "binary");
	return s.split("").map(function(x){ return x.charCodeAt(0) & 0xff; });
};

function s2ab(s) {
	if(typeof ArrayBuffer === 'undefined') return s2a(s);
	var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
	for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
	return buf;
}

function a2s(data) {
	if(Array.isArray(data)) return data.map(_chr).join("");
	var o = []; for(var i = 0; i < data.length; ++i) o[i] = _chr(data[i]); return o.join("");
}

function a2u(data) {
	if(typeof Uint8Array === 'undefined') throw new Error("Unsupported");
	return new Uint8Array(data);
}

function ab2a(data) {
	if(typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
	if(data instanceof ArrayBuffer) return ab2a(new Uint8Array(data));
var o = new Array(data.length);
	for(var i = 0; i < data.length; ++i) o[i] = data[i];
	return o;
}

var bconcat = function(bufs) { return [].concat.apply([], bufs); };

var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
/* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */
/*jshint -W041 */
var SSF = ({});
var make_ssf = function make_ssf(SSF){
SSF.version = '0.10.2';
function _strrev(x) { var o = "", i = x.length-1; while(i>=0) o += x.charAt(i--); return o; }
function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }
function pad0(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
function pad_(v,d){var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}
function rpad_(v,d){var t=""+v; return t.length>=d?t:t+fill(' ',d-t.length);}
function pad0r1(v,d){var t=""+Math.round(v); return t.length>=d?t:fill('0',d-t.length)+t;}
function pad0r2(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
var p2_32 = Math.pow(2,32);
function pad0r(v,d){if(v>p2_32||v<-p2_32) return pad0r1(v,d); var i = Math.round(v); return pad0r2(i,d); }
function isgeneral(s, i) { i = i || 0; return s.length >= 7 + i && (s.charCodeAt(i)|32) === 103 && (s.charCodeAt(i+1)|32) === 101 && (s.charCodeAt(i+2)|32) === 110 && (s.charCodeAt(i+3)|32) === 101 && (s.charCodeAt(i+4)|32) === 114 && (s.charCodeAt(i+5)|32) === 97 && (s.charCodeAt(i+6)|32) === 108; }
var days = [
	['Sun', 'Sunday'],
	['Mon', 'Monday'],
	['Tue', 'Tuesday'],
	['Wed', 'Wednesday'],
	['Thu', 'Thursday'],
	['Fri', 'Friday'],
	['Sat', 'Saturday']
];
var months = [
	['J', 'Jan', 'January'],
	['F', 'Feb', 'February'],
	['M', 'Mar', 'March'],
	['A', 'Apr', 'April'],
	['M', 'May', 'May'],
	['J', 'Jun', 'June'],
	['J', 'Jul', 'July'],
	['A', 'Aug', 'August'],
	['S', 'Sep', 'September'],
	['O', 'Oct', 'October'],
	['N', 'Nov', 'November'],
	['D', 'Dec', 'December']
];
function init_table(t) {
	t[0]=  'General';
	t[1]=  '0';
	t[2]=  '0.00';
	t[3]=  '#,##0';
	t[4]=  '#,##0.00';
	t[9]=  '0%';
	t[10]= '0.00%';
	t[11]= '0.00E+00';
	t[12]= '# ?/?';
	t[13]= '# ??/??';
	t[14]= 'm/d/yy';
	t[15]= 'd-mmm-yy';
	t[16]= 'd-mmm';
	t[17]= 'mmm-yy';
	t[18]= 'h:mm AM/PM';
	t[19]= 'h:mm:ss AM/PM';
	t[20]= 'h:mm';
	t[21]= 'h:mm:ss';
	t[22]= 'm/d/yy h:mm';
	t[37]= '#,##0 ;(#,##0)';
	t[38]= '#,##0 ;[Red](#,##0)';
	t[39]= '#,##0.00;(#,##0.00)';
	t[40]= '#,##0.00;[Red](#,##0.00)';
	t[45]= 'mm:ss';
	t[46]= '[h]:mm:ss';
	t[47]= 'mmss.0';
	t[48]= '##0.0E+0';
	t[49]= '@';
	t[56]= '"上午/下午 "hh"時"mm"分"ss"秒 "';
	t[65535]= 'General';
}

var table_fmt = {};
init_table(table_fmt);
function frac(x, D, mixed) {
	var sgn = x < 0 ? -1 : 1;
	var B = x * sgn;
	var P_2 = 0, P_1 = 1, P = 0;
	var Q_2 = 1, Q_1 = 0, Q = 0;
	var A = Math.floor(B);
	while(Q_1 < D) {
		A = Math.floor(B);
		P = A * P_1 + P_2;
		Q = A * Q_1 + Q_2;
		if((B - A) < 0.00000005) break;
		B = 1 / (B - A);
		P_2 = P_1; P_1 = P;
		Q_2 = Q_1; Q_1 = Q;
	}
	if(Q > D) { if(Q_1 > D) { Q = Q_2; P = P_2; } else { Q = Q_1; P = P_1; } }
	if(!mixed) return [0, sgn * P, Q];
	var q = Math.floor(sgn * P/Q);
	return [q, sgn*P - q*Q, Q];
}
function parse_date_code(v,opts,b2) {
	if(v > 2958465 || v < 0) return null;
	var date = (v|0), time = Math.floor(86400 * (v - date)), dow=0;
	var dout=[];
	var out={D:date, T:time, u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};
	if(Math.abs(out.u) < 1e-6) out.u = 0;
	if(opts && opts.date1904) date += 1462;
	if(out.u > 0.9999) {
		out.u = 0;
		if(++time == 86400) { out.T = time = 0; ++date; ++out.D; }
	}
	if(date === 60) {dout = b2 ? [1317,10,29] : [1900,2,29]; dow=3;}
	else if(date === 0) {dout = b2 ? [1317,8,29] : [1900,1,0]; dow=6;}
	else {
		if(date > 60) --date;
		/* 1 = Jan 1 1900 in Gregorian */
		var d = new Date(1900, 0, 1);
		d.setDate(d.getDate() + date - 1);
		dout = [d.getFullYear(), d.getMonth()+1,d.getDate()];
		dow = d.getDay();
		if(date < 60) dow = (dow + 6) % 7;
		if(b2) dow = fix_hijri(d, dout);
	}
	out.y = dout[0]; out.m = dout[1]; out.d = dout[2];
	out.S = time % 60; time = Math.floor(time / 60);
	out.M = time % 60; time = Math.floor(time / 60);
	out.H = time;
	out.q = dow;
	return out;
}
SSF.parse_date_code = parse_date_code;
var basedate = new Date(1899, 11, 31, 0, 0, 0);
var dnthresh = basedate.getTime();
var base1904 = new Date(1900, 2, 1, 0, 0, 0);
function datenum_local(v, date1904) {
	var epoch = v.getTime();
	if(date1904) epoch -= 1461*24*60*60*1000;
	else if(v >= base1904) epoch += 24*60*60*1000;
	return (epoch - (dnthresh + (v.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000)) / (24 * 60 * 60 * 1000);
}
function general_fmt_int(v) { return v.toString(10); }
SSF._general_int = general_fmt_int;
var general_fmt_num = (function make_general_fmt_num() {
var gnr1 = /\.(\d*[1-9])0+$/, gnr2 = /\.0*$/, gnr4 = /\.(\d*[1-9])0+/, gnr5 = /\.0*[Ee]/, gnr6 = /(E[+-])(\d)$/;
function gfn2(v) {
	var w = (v<0?12:11);
	var o = gfn5(v.toFixed(12)); if(o.length <= w) return o;
	o = v.toPrecision(10); if(o.length <= w) return o;
	return v.toExponential(5);
}
function gfn3(v) {
	var o = v.toFixed(11).replace(gnr1,".$1");
	if(o.length > (v<0?12:11)) o = v.toPrecision(6);
	return o;
}
function gfn4(o) {
	for(var i = 0; i != o.length; ++i) if((o.charCodeAt(i) | 0x20) === 101) return o.replace(gnr4,".$1").replace(gnr5,"E").replace("e","E").replace(gnr6,"$10$2");
	return o;
}
function gfn5(o) {
	return o.indexOf(".") > -1 ? o.replace(gnr2,"").replace(gnr1,".$1") : o;
}
return function general_fmt_num(v) {
	var V = Math.floor(Math.log(Math.abs(v))*Math.LOG10E), o;
	if(V >= -4 && V <= -1) o = v.toPrecision(10+V);
	else if(Math.abs(V) <= 9) o = gfn2(v);
	else if(V === 10) o = v.toFixed(10).substr(0,12);
	else o = gfn3(v);
	return gfn5(gfn4(o));
};})();
SSF._general_num = general_fmt_num;
function general_fmt(v, opts) {
	switch(typeof v) {
		case 'string': return v;
		case 'boolean': return v ? "TRUE" : "FALSE";
		case 'number': return (v|0) === v ? general_fmt_int(v) : general_fmt_num(v);
		case 'undefined': return "";
		case 'object':
			if(v == null) return "";
			if(v instanceof Date) return format(14, datenum_local(v, opts && opts.date1904), opts);
	}
	throw new Error("unsupported value in General format: " + v);
}
SSF._general = general_fmt;
function fix_hijri() { return 0; }
/*jshint -W086 */
function write_date(type, fmt, val, ss0) {
	var o="", ss=0, tt=0, y = val.y, out, outl = 0;
	switch(type) {
		case 98: /* 'b' buddhist year */
			y = val.y + 543;
			/* falls through */
		case 121: /* 'y' year */
		switch(fmt.length) {
			case 1: case 2: out = y % 100; outl = 2; break;
			default: out = y % 10000; outl = 4; break;
		} break;
		case 109: /* 'm' month */
		switch(fmt.length) {
			case 1: case 2: out = val.m; outl = fmt.length; break;
			case 3: return months[val.m-1][1];
			case 5: return months[val.m-1][0];
			default: return months[val.m-1][2];
		} break;
		case 100: /* 'd' day */
		switch(fmt.length) {
			case 1: case 2: out = val.d; outl = fmt.length; break;
			case 3: return days[val.q][0];
			default: return days[val.q][1];
		} break;
		case 104: /* 'h' 12-hour */
		switch(fmt.length) {
			case 1: case 2: out = 1+(val.H+11)%12; outl = fmt.length; break;
			default: throw 'bad hour format: ' + fmt;
		} break;
		case 72: /* 'H' 24-hour */
		switch(fmt.length) {
			case 1: case 2: out = val.H; outl = fmt.length; break;
			default: throw 'bad hour format: ' + fmt;
		} break;
		case 77: /* 'M' minutes */
		switch(fmt.length) {
			case 1: case 2: out = val.M; outl = fmt.length; break;
			default: throw 'bad minute format: ' + fmt;
		} break;
		case 115: /* 's' seconds */
			if(fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
			if(val.u === 0 && (fmt == "s" || fmt == "ss")) return pad0(val.S, fmt.length);
if(ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
			else tt = ss0 === 1 ? 10 : 1;
			ss = Math.round((tt)*(val.S + val.u));
			if(ss >= 60*tt) ss = 0;
			if(fmt === 's') return ss === 0 ? "0" : ""+ss/tt;
			o = pad0(ss,2 + ss0);
			if(fmt === 'ss') return o.substr(0,2);
			return "." + o.substr(2,fmt.length-1);
		case 90: /* 'Z' absolute time */
		switch(fmt) {
			case '[h]': case '[hh]': out = val.D*24+val.H; break;
			case '[m]': case '[mm]': out = (val.D*24+val.H)*60+val.M; break;
			case '[s]': case '[ss]': out = ((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u); break;
			default: throw 'bad abstime format: ' + fmt;
		} outl = fmt.length === 3 ? 1 : 2; break;
		case 101: /* 'e' era */
			out = y; outl = 1;
	}
	if(outl > 0) return pad0(out, outl); else return "";
}
/*jshint +W086 */
function commaify(s) {
	var w = 3;
	if(s.length <= w) return s;
	var j = (s.length % w), o = s.substr(0,j);
	for(; j!=s.length; j+=w) o+=(o.length > 0 ? "," : "") + s.substr(j,w);
	return o;
}
var write_num = (function make_write_num(){
var pct1 = /%/g;
function write_num_pct(type, fmt, val){
	var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
	return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
}
function write_num_cm(type, fmt, val){
	var idx = fmt.length - 1;
	while(fmt.charCodeAt(idx-1) === 44) --idx;
	return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
}
function write_num_exp(fmt, val){
	var o;
	var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
	if(fmt.match(/^#+0.0E\+0$/)) {
		if(val == 0) return "0.0E+0";
		else if(val < 0) return "-" + write_num_exp(fmt, -val);
		var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
		var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
		if(ee < 0) ee += period;
		o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
		if(o.indexOf("e") === -1) {
			var fakee = Math.floor(Math.log(val)*Math.LOG10E);
			if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
			else o += "E+" + (fakee - ee);
			while(o.substr(0,2) === "0.") {
				o = o.charAt(0) + o.substr(2,period) + "." + o.substr(2+period);
				o = o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");
			}
			o = o.replace(/\+-/,"-");
		}
		o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
	} else o = val.toExponential(idx);
	if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
	if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
	return o.replace("e","E");
}
var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function write_num_f1(r, aval, sign) {
	var den = parseInt(r[4],10), rr = Math.round(aval * den), base = Math.floor(rr/den);
	var myn = (rr - base*den), myd = den;
	return sign + (base === 0 ? "" : ""+base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn,r[1].length) + r[2] + "/" + r[3] + pad0(myd,r[4].length));
}
function write_num_f2(r, aval, sign) {
	return sign + (aval === 0 ? "" : ""+aval) + fill(" ", r[1].length + 2 + r[4].length);
}
var dec1 = /^#*0*\.([0#]+)/;
var closeparen = /\).*[0#]/;
var phone = /\(###\) ###\\?-####/;
function hashq(str) {
	var o = "", cc;
	for(var i = 0; i != str.length; ++i) switch((cc=str.charCodeAt(i))) {
		case 35: break;
		case 63: o+= " "; break;
		case 48: o+= "0"; break;
		default: o+= String.fromCharCode(cc);
	}
	return o;
}
function rnd(val, d) { var dd = Math.pow(10,d); return ""+(Math.round(val * dd)/dd); }
function dec(val, d) {
	if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
		return 0;
	}
	return Math.round((val-Math.floor(val))*Math.pow(10,d));
}
function carry(val, d) {
	if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
		return 1;
	}
	return 0;
}
function flr(val) { if(val < 2147483647 && val > -2147483648) return ""+(val >= 0 ? (val|0) : (val-1|0)); return ""+Math.floor(val); }
function write_num_flt(type, fmt, val) {
	if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
		var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
		if(val >= 0) return write_num_flt('n', ffmt, val);
		return '(' + write_num_flt('n', ffmt, -val) + ')';
	}
	if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
	if(fmt.indexOf('%') !== -1) return write_num_pct(type, fmt, val);
	if(fmt.indexOf('E') !== -1) return write_num_exp(fmt, val);
	if(fmt.charCodeAt(0) === 36) return "$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
	var o;
	var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
	if(fmt.match(/^00+$/)) return sign + pad0r(aval,fmt.length);
	if(fmt.match(/^[#?]+$/)) {
		o = pad0r(val,0); if(o === "0") o = "";
		return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(frac1))) return write_num_f1(r, aval, sign);
	if(fmt.match(/^#+0+$/)) return sign + pad0r(aval,fmt.length - fmt.indexOf("0"));
	if((r = fmt.match(dec1))) {
		o = rnd(val, r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$, $1) { return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
		return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
	}
	fmt = fmt.replace(/^#+([0.])/, "$1");
	if((r = fmt.match(/^(0*)\.(#*)$/))) {
		return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
	}
	if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify(pad0r(aval,0));
	if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
		return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(""+(Math.floor(val) + carry(val, r[1].length))) + "." + pad0(dec(val, r[1].length),r[1].length);
	}
	if((r = fmt.match(/^#,#*,#0/))) return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);
	if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
		o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g,""), val));
		ri = 0;
		return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
	}
	if(fmt.match(phone)) {
		o = write_num_flt(type, "##########", val);
		return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
	}
	var oa = "";
	if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(r[4].length,7);
		ff = frac(aval, Math.pow(10,ri)-1, false);
		o = "" + sign;
		oa = write_num("n", r[1], ff[1]);
		if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
		o += oa + r[2] + "/" + r[3];
		oa = rpad_(ff[2],ri);
		if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
		o += oa;
		return o;
	}
	if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(Math.max(r[1].length, r[4].length),7);
		ff = frac(aval, Math.pow(10,ri)-1, true);
		return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
	}
	if((r = fmt.match(/^[#0?]+$/))) {
		o = pad0r(val, 0);
		if(fmt.length <= o.length) return o;
		return hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(/^([#0?]+)\.([#0]+)$/))) {
		o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
		ri = o.indexOf(".");
		var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
		return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
	}
	if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
		ri = dec(val, r[1].length);
		return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(ri,r[1].length);
	}
	switch(fmt) {
		case "###,##0.00": return write_num_flt(type, "#,##0.00", val);
		case "###,###":
		case "##,###":
		case "#,###": var x = commaify(pad0r(aval,0)); return x !== "0" ? sign + x : "";
		case "###,###.00": return write_num_flt(type, "###,##0.00",val).replace(/^0\./,".");
		case "#,###.00": return write_num_flt(type, "#,##0.00",val).replace(/^0\./,".");
		default:
	}
	throw new Error("unsupported format |" + fmt + "|");
}
function write_num_cm2(type, fmt, val){
	var idx = fmt.length - 1;
	while(fmt.charCodeAt(idx-1) === 44) --idx;
	return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
}
function write_num_pct2(type, fmt, val){
	var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
	return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
}
function write_num_exp2(fmt, val){
	var o;
	var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
	if(fmt.match(/^#+0.0E\+0$/)) {
		if(val == 0) return "0.0E+0";
		else if(val < 0) return "-" + write_num_exp2(fmt, -val);
		var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
		var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
		if(ee < 0) ee += period;
		o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
		if(!o.match(/[Ee]/)) {
			var fakee = Math.floor(Math.log(val)*Math.LOG10E);
			if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
			else o += "E+" + (fakee - ee);
			o = o.replace(/\+-/,"-");
		}
		o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
	} else o = val.toExponential(idx);
	if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
	if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
	return o.replace("e","E");
}
function write_num_int(type, fmt, val) {
	if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
		var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
		if(val >= 0) return write_num_int('n', ffmt, val);
		return '(' + write_num_int('n', ffmt, -val) + ')';
	}
	if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
	if(fmt.indexOf('%') !== -1) return write_num_pct2(type, fmt, val);
	if(fmt.indexOf('E') !== -1) return write_num_exp2(fmt, val);
	if(fmt.charCodeAt(0) === 36) return "$"+write_num_int(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
	var o;
	var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
	if(fmt.match(/^00+$/)) return sign + pad0(aval,fmt.length);
	if(fmt.match(/^[#?]+$/)) {
		o = (""+val); if(val === 0) o = "";
		return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(frac1))) return write_num_f2(r, aval, sign);
	if(fmt.match(/^#+0+$/)) return sign + pad0(aval,fmt.length - fmt.indexOf("0"));
	if((r = fmt.match(dec1))) {
o = (""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));
		o = o.replace(/\.(\d*)$/,function($$, $1) {
return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
		return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
	}
	fmt = fmt.replace(/^#+([0.])/, "$1");
	if((r = fmt.match(/^(0*)\.(#*)$/))) {
		return sign + (""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
	}
	if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify((""+aval));
	if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
		return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify((""+val)) + "." + fill('0',r[1].length);
	}
	if((r = fmt.match(/^#,#*,#0/))) return write_num_int(type,fmt.replace(/^#,#*,/,""),val);
	if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
		o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g,""), val));
		ri = 0;
		return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
	}
	if(fmt.match(phone)) {
		o = write_num_int(type, "##########", val);
		return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
	}
	var oa = "";
	if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(r[4].length,7);
		ff = frac(aval, Math.pow(10,ri)-1, false);
		o = "" + sign;
		oa = write_num("n", r[1], ff[1]);
		if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
		o += oa + r[2] + "/" + r[3];
		oa = rpad_(ff[2],ri);
		if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
		o += oa;
		return o;
	}
	if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(Math.max(r[1].length, r[4].length),7);
		ff = frac(aval, Math.pow(10,ri)-1, true);
		return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
	}
	if((r = fmt.match(/^[#0?]+$/))) {
		o = "" + val;
		if(fmt.length <= o.length) return o;
		return hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(/^([#0]+)\.([#0]+)$/))) {
		o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
		ri = o.indexOf(".");
		var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
		return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
	}
	if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
		return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(0,r[1].length);
	}
	switch(fmt) {
		case "###,###":
		case "##,###":
		case "#,###": var x = commaify(""+aval); return x !== "0" ? sign + x : "";
		default:
			if(fmt.match(/\.[0#?]*$/)) return write_num_int(type, fmt.slice(0,fmt.lastIndexOf(".")), val) + hashq(fmt.slice(fmt.lastIndexOf(".")));
	}
	throw new Error("unsupported format |" + fmt + "|");
}
return function write_num(type, fmt, val) {
	return (val|0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
};})();
function split_fmt(fmt) {
	var out = [];
	var in_str = false/*, cc*/;
	for(var i = 0, j = 0; i < fmt.length; ++i) switch((/*cc=*/fmt.charCodeAt(i))) {
		case 34: /* '"' */
			in_str = !in_str; break;
		case 95: case 42: case 92: /* '_' '*' '\\' */
			++i; break;
		case 59: /* ';' */
			out[out.length] = fmt.substr(j,i-j);
			j = i+1;
	}
	out[out.length] = fmt.substr(j);
	if(in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
	return out;
}
SSF._split = split_fmt;
var abstime = /\[[HhMmSs]*\]/;
function fmt_is_date(fmt) {
	var i = 0, /*cc = 0,*/ c = "", o = "";
	while(i < fmt.length) {
		switch((c = fmt.charAt(i))) {
			case 'G': if(isgeneral(fmt, i)) i+= 6; i++; break;
			case '"': for(;(/*cc=*/fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) ++i; ++i; break;
			case '\\': i+=2; break;
			case '_': i+=2; break;
			case '@': ++i; break;
			case 'B': case 'b':
				if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") return true;
				/* falls through */
			case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
				/* falls through */
			case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g': return true;
			case 'A': case 'a':
				if(fmt.substr(i, 3).toUpperCase() === "A/P") return true;
				if(fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
				++i; break;
			case '[':
				o = c;
				while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
				if(o.match(abstime)) return true;
				break;
			case '.':
				/* falls through */
			case '0': case '#':
				while(i < fmt.length && ("0#?.,E+-%".indexOf(c=fmt.charAt(++i)) > -1 || (c=='\\' && fmt.charAt(i+1) == "-" && "0#".indexOf(fmt.charAt(i+2))>-1))){/* empty */}
				break;
			case '?': while(fmt.charAt(++i) === c){/* empty */} break;
			case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break;
			case '(': case ')': ++i; break;
			case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
				while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1){/* empty */} break;
			case ' ': ++i; break;
			default: ++i; break;
		}
	}
	return false;
}
SSF.is_date = fmt_is_date;
function eval_fmt(fmt, v, opts, flen) {
	var out = [], o = "", i = 0, c = "", lst='t', dt, j, cc;
	var hr='H';
	/* Tokenize */
	while(i < fmt.length) {
		switch((c = fmt.charAt(i))) {
			case 'G': /* General */
				if(!isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' +fmt);
				out[out.length] = {t:'G', v:'General'}; i+=7; break;
			case '"': /* Literal text */
				for(o="";(cc=fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) o += String.fromCharCode(cc);
				out[out.length] = {t:'t', v:o}; ++i; break;
			case '\\': var w = fmt.charAt(++i), t = (w === "(" || w === ")") ? w : 't';
				out[out.length] = {t:t, v:w}; ++i; break;
			case '_': out[out.length] = {t:'t', v:" "}; i+=2; break;
			case '@': /* Text Placeholder */
				out[out.length] = {t:'T', v:v}; ++i; break;
			case 'B': case 'b':
				if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") {
					if(dt==null) { dt=parse_date_code(v, opts, fmt.charAt(i+1) === "2"); if(dt==null) return ""; }
					out[out.length] = {t:'X', v:fmt.substr(i,2)}; lst = c; i+=2; break;
				}
				/* falls through */
			case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
				c = c.toLowerCase();
				/* falls through */
			case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g':
				if(v < 0) return "";
				if(dt==null) { dt=parse_date_code(v, opts); if(dt==null) return ""; }
				o = c; while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c) o+=c;
				if(c === 'm' && lst.toLowerCase() === 'h') c = 'M';
				if(c === 'h') c = hr;
				out[out.length] = {t:c, v:o}; lst = c; break;
			case 'A': case 'a':
				var q={t:c, v:c};
				if(dt==null) dt=parse_date_code(v, opts);
				if(fmt.substr(i, 3).toUpperCase() === "A/P") { if(dt!=null) q.v = dt.H >= 12 ? "P" : "A"; q.t = 'T'; hr='h';i+=3;}
				else if(fmt.substr(i,5).toUpperCase() === "AM/PM") { if(dt!=null) q.v = dt.H >= 12 ? "PM" : "AM"; q.t = 'T'; i+=5; hr='h'; }
				else { q.t = "t"; ++i; }
				if(dt==null && q.t === 'T') return "";
				out[out.length] = q; lst = c; break;
			case '[':
				o = c;
				while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
				if(o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
				if(o.match(abstime)) {
					if(dt==null) { dt=parse_date_code(v, opts); if(dt==null) return ""; }
					out[out.length] = {t:'Z', v:o.toLowerCase()};
					lst = o.charAt(1);
				} else if(o.indexOf("$") > -1) {
					o = (o.match(/\$([^-\[\]]*)/)||[])[1]||"$";
					if(!fmt_is_date(fmt)) out[out.length] = {t:'t',v:o};
				}
				break;
			/* Numbers */
			case '.':
				if(dt != null) {
					o = c; while(++i < fmt.length && (c=fmt.charAt(i)) === "0") o += c;
					out[out.length] = {t:'s', v:o}; break;
				}
				/* falls through */
			case '0': case '#':
				o = c; while((++i < fmt.length && "0#?.,E+-%".indexOf(c=fmt.charAt(i)) > -1) || (c=='\\' && fmt.charAt(i+1) == "-" && i < fmt.length - 2 && "0#".indexOf(fmt.charAt(i+2))>-1)) o += c;
				out[out.length] = {t:'n', v:o}; break;
			case '?':
				o = c; while(fmt.charAt(++i) === c) o+=c;
				out[out.length] = {t:c, v:o}; lst = c; break;
			case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break; // **
			case '(': case ')': out[out.length] = {t:(flen===1?'t':c), v:c}; ++i; break;
			case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
				o = c; while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1) o+=fmt.charAt(i);
				out[out.length] = {t:'D', v:o}; break;
			case ' ': out[out.length] = {t:c, v:c}; ++i; break;
			default:
				if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
				out[out.length] = {t:'t', v:c}; ++i; break;
		}
	}
	var bt = 0, ss0 = 0, ssm;
	for(i=out.length-1, lst='t'; i >= 0; --i) {
		switch(out[i].t) {
			case 'h': case 'H': out[i].t = hr; lst='h'; if(bt < 1) bt = 1; break;
			case 's':
				if((ssm=out[i].v.match(/\.0+$/))) ss0=Math.max(ss0,ssm[0].length-1);
				if(bt < 3) bt = 3;
			/* falls through */
			case 'd': case 'y': case 'M': case 'e': lst=out[i].t; break;
			case 'm': if(lst === 's') { out[i].t = 'M'; if(bt < 2) bt = 2; } break;
			case 'X': /*if(out[i].v === "B2");*/
				break;
			case 'Z':
				if(bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
				if(bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
				if(bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
		}
	}
	switch(bt) {
		case 0: break;
		case 1:
if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
			if(dt.S >=  60) { dt.S = 0; ++dt.M; }
			if(dt.M >=  60) { dt.M = 0; ++dt.H; }
			break;
		case 2:
if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
			if(dt.S >=  60) { dt.S = 0; ++dt.M; }
			break;
	}
	/* replace fields */
	var nstr = "", jj;
	for(i=0; i < out.length; ++i) {
		switch(out[i].t) {
			case 't': case 'T': case ' ': case 'D': break;
			case 'X': out[i].v = ""; out[i].t = ";"; break;
			case 'd': case 'm': case 'y': case 'h': case 'H': case 'M': case 's': case 'e': case 'b': case 'Z':
out[i].v = write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
				out[i].t = 't'; break;
			case 'n': case '(': case '?':
				jj = i+1;
				while(out[jj] != null && (
					(c=out[jj].t) === "?" || c === "D" ||
					((c === " " || c === "t") && out[jj+1] != null && (out[jj+1].t === '?' || out[jj+1].t === "t" && out[jj+1].v === '/')) ||
					(out[i].t === '(' && (c === ' ' || c === 'n' || c === ')')) ||
					(c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj+1] != null && out[jj+1].t == '?'))
				)) {
					out[i].v += out[jj].v;
					out[jj] = {v:"", t:";"}; ++jj;
				}
				nstr += out[i].v;
				i = jj-1; break;
			case 'G': out[i].t = 't'; out[i].v = general_fmt(v,opts); break;
		}
	}
	var vv = "", myv, ostr;
	if(nstr.length > 0) {
		if(nstr.charCodeAt(0) == 40) /* '(' */ {
			myv = (v<0&&nstr.charCodeAt(0) === 45 ? -v : v);
			ostr = write_num('(', nstr, myv);
		} else {
			myv = (v<0 && flen > 1 ? -v : v);
			ostr = write_num('n', nstr, myv);
			if(myv < 0 && out[0] && out[0].t == 't') {
				ostr = ostr.substr(1);
				out[0].v = "-" + out[0].v;
			}
		}
		jj=ostr.length-1;
		var decpt = out.length;
		for(i=0; i < out.length; ++i) if(out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) { decpt = i; break; }
		var lasti=out.length;
		if(decpt === out.length && ostr.indexOf("E") === -1) {
			for(i=out.length-1; i>= 0;--i) {
				if(out[i] == null || 'n?('.indexOf(out[i].t) === -1) continue;
				if(jj>=out[i].v.length-1) { jj -= out[i].v.length; out[i].v = ostr.substr(jj+1, out[i].v.length); }
				else if(jj < 0) out[i].v = "";
				else { out[i].v = ostr.substr(0, jj+1); jj = -1; }
				out[i].t = 't';
				lasti = i;
			}
			if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
		}
		else if(decpt !== out.length && ostr.indexOf("E") === -1) {
			jj = ostr.indexOf(".")-1;
			for(i=decpt; i>= 0; --i) {
				if(out[i] == null || 'n?('.indexOf(out[i].t) === -1) continue;
				j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;
				vv = out[i].v.substr(j+1);
				for(; j>=0; --j) {
					if(jj>=0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
				}
				out[i].v = vv;
				out[i].t = 't';
				lasti = i;
			}
			if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
			jj = ostr.indexOf(".")+1;
			for(i=decpt; i<out.length; ++i) {
				if(out[i] == null || ('n?('.indexOf(out[i].t) === -1 && i !== decpt)) continue;
				j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;
				vv = out[i].v.substr(0,j);
				for(; j<out[i].v.length; ++j) {
					if(jj<ostr.length) vv += ostr.charAt(jj++);
				}
				out[i].v = vv;
				out[i].t = 't';
				lasti = i;
			}
		}
	}
	for(i=0; i<out.length; ++i) if(out[i] != null && 'n(?'.indexOf(out[i].t)>-1) {
		myv = (flen >1 && v < 0 && i>0 && out[i-1].v === "-" ? -v:v);
		out[i].v = write_num(out[i].t, out[i].v, myv);
		out[i].t = 't';
	}
	var retval = "";
	for(i=0; i !== out.length; ++i) if(out[i] != null) retval += out[i].v;
	return retval;
}
SSF._eval = eval_fmt;
var cfregex = /\[[=<>]/;
var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function chkcond(v, rr) {
	if(rr == null) return false;
	var thresh = parseFloat(rr[2]);
	switch(rr[1]) {
		case "=":  if(v == thresh) return true; break;
		case ">":  if(v >  thresh) return true; break;
		case "<":  if(v <  thresh) return true; break;
		case "<>": if(v != thresh) return true; break;
		case ">=": if(v >= thresh) return true; break;
		case "<=": if(v <= thresh) return true; break;
	}
	return false;
}
function choose_fmt(f, v) {
	var fmt = split_fmt(f);
	var l = fmt.length, lat = fmt[l-1].indexOf("@");
	if(l<4 && lat>-1) --l;
	if(fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
	if(typeof v !== "number") return [4, fmt.length === 4 || lat>-1?fmt[fmt.length-1]:"@"];
	switch(fmt.length) {
		case 1: fmt = lat>-1 ? ["General", "General", "General", fmt[0]] : [fmt[0], fmt[0], fmt[0], "@"]; break;
		case 2: fmt = lat>-1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], "@"]; break;
		case 3: fmt = lat>-1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], "@"]; break;
		case 4: break;
	}
	var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
	if(fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [l, ff];
	if(fmt[0].match(cfregex) != null || fmt[1].match(cfregex) != null) {
		var m1 = fmt[0].match(cfregex2);
		var m2 = fmt[1].match(cfregex2);
		return chkcond(v, m1) ? [l, fmt[0]] : chkcond(v, m2) ? [l, fmt[1]] : [l, fmt[m1 != null && m2 != null ? 2 : 1]];
	}
	return [l, ff];
}
function format(fmt,v,o) {
	if(o == null) o = {};
	var sfmt = "";
	switch(typeof fmt) {
		case "string":
			if(fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
			else sfmt = fmt;
			break;
		case "number":
			if(fmt == 14 && o.dateNF) sfmt = o.dateNF;
			else sfmt = (o.table != null ? (o.table) : table_fmt)[fmt];
			break;
	}
	if(isgeneral(sfmt,0)) return general_fmt(v, o);
	if(v instanceof Date) v = datenum_local(v, o.date1904);
	var f = choose_fmt(sfmt, v);
	if(isgeneral(f[1])) return general_fmt(v, o);
	if(v === true) v = "TRUE"; else if(v === false) v = "FALSE";
	else if(v === "" || v == null) return "";
	return eval_fmt(f[1], v, o, f[0]);
}
function load_entry(fmt, idx) {
	if(typeof idx != 'number') {
		idx = +idx || -1;
for(var i = 0; i < 0x0188; ++i) {
if(table_fmt[i] == undefined) { if(idx < 0) idx = i; continue; }
			if(table_fmt[i] == fmt) { idx = i; break; }
		}
if(idx < 0) idx = 0x187;
	}
table_fmt[idx] = fmt;
	return idx;
}
SSF.load = load_entry;
SSF._table = table_fmt;
SSF.get_table = function get_table() { return table_fmt; };
SSF.load_table = function load_table(tbl) {
	for(var i=0; i!=0x0188; ++i)
		if(tbl[i] !== undefined) load_entry(tbl[i], i);
};
SSF.init_table = init_table;
SSF.format = format;
};
make_ssf(SSF);
/* map from xlml named formats to SSF TODO: localize */
var XLMLFormatMap/*{[string]:string}*/ = ({
	"General Number": "General",
	"General Date": SSF._table[22],
	"Long Date": "dddd, mmmm dd, yyyy",
	"Medium Date": SSF._table[15],
	"Short Date": SSF._table[14],
	"Long Time": SSF._table[19],
	"Medium Time": SSF._table[18],
	"Short Time": SSF._table[20],
	"Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	"Fixed": SSF._table[2],
	"Standard": SSF._table[4],
	"Percent": SSF._table[10],
	"Scientific": SSF._table[11],
	"Yes/No": '"Yes";"Yes";"No";@',
	"True/False": '"True";"True";"False";@',
	"On/Off": '"Yes";"Yes";"No";@'
});

var SSFImplicit/*{[number]:string}*/ = ({
	"5": '"$"#,##0_);\\("$"#,##0\\)',
	"6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
	"7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
	"8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	"23": 'General', "24": 'General', "25": 'General', "26": 'General',
	"27": 'm/d/yy', "28": 'm/d/yy', "29": 'm/d/yy', "30": 'm/d/yy', "31": 'm/d/yy',
	"32": 'h:mm:ss', "33": 'h:mm:ss', "34": 'h:mm:ss', "35": 'h:mm:ss',
	"36": 'm/d/yy',
	"41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
	"42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
	"43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
	"44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
	"50": 'm/d/yy', "51": 'm/d/yy', "52": 'm/d/yy', "53": 'm/d/yy', "54": 'm/d/yy',
	"55": 'm/d/yy', "56": 'm/d/yy', "57": 'm/d/yy', "58": 'm/d/yy',
	"59": '0',
	"60": '0.00',
	"61": '#,##0',
	"62": '#,##0.00',
	"63": '"$"#,##0_);\\("$"#,##0\\)',
	"64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
	"65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
	"66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	"67": '0%',
	"68": '0.00%',
	"69": '# ?/?',
	"70": '# ??/??',
	"71": 'm/d/yy',
	"72": 'm/d/yy',
	"73": 'd-mmm-yy',
	"74": 'd-mmm',
	"75": 'mmm-yy',
	"76": 'h:mm',
	"77": 'h:mm:ss',
	"78": 'm/d/yy h:mm',
	"79": 'mm:ss',
	"80": '[h]:mm:ss',
	"81": 'mmss.0'
});

/* dateNF parse TODO: move to SSF */
var dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function dateNF_regex(dateNF) {
	var fmt = typeof dateNF == "number" ? SSF._table[dateNF] : dateNF;
	fmt = fmt.replace(dateNFregex, "(\\d+)");
	return new RegExp("^" + fmt + "$");
}
function dateNF_fix(str, dateNF, match) {
	var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
	(dateNF.match(dateNFregex)||[]).forEach(function(n, i) {
		var v = parseInt(match[i+1], 10);
		switch(n.toLowerCase().charAt(0)) {
			case 'y': Y = v; break; case 'd': d = v; break;
			case 'h': H = v; break; case 's': S = v; break;
			case 'm': if(H >= 0) M = v; else m = v; break;
		}
	});
	if(S >= 0 && M == -1 && m >= 0) { M = m; m = -1; }
	var datestr = (("" + (Y>=0?Y: new Date().getFullYear())).slice(-4) + "-" + ("00" + (m>=1?m:1)).slice(-2) + "-" + ("00" + (d>=1?d:1)).slice(-2));
	if(datestr.length == 7) datestr = "0" + datestr;
	if(datestr.length == 8) datestr = "20" + datestr;
	var timestr = (("00" + (H>=0?H:0)).slice(-2) + ":" + ("00" + (M>=0?M:0)).slice(-2) + ":" + ("00" + (S>=0?S:0)).slice(-2));
	if(H == -1 && M == -1 && S == -1) return datestr;
	if(Y == -1 && m == -1 && d == -1) return timestr;
	return datestr + "T" + timestr;
}

var DO_NOT_EXPORT_CFB = true;
/* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*jshint eqnull:true */
/*exported CFB */
/*global module, require:false, process:false, Buffer:false, Uint8Array:false */

/* [MS-CFB] v20171201 */
var CFB = (function _CFB(){
var exports = {};
exports.version = '1.0.8';
/* [MS-CFB] 2.6.4 */
function namecmp(l, r) {
	var L = l.split("/"), R = r.split("/");
	for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i) {
		if((c = L[i].length - R[i].length)) return c;
		if(L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
	}
	return L.length - R.length;
}
function dirname(p) {
	if(p.charAt(p.length - 1) == "/") return (p.slice(0,-1).indexOf("/") === -1) ? p : dirname(p.slice(0, -1));
	var c = p.lastIndexOf("/");
	return (c === -1) ? p : p.slice(0, c+1);
}

function filename(p) {
	if(p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
	var c = p.lastIndexOf("/");
	return (c === -1) ? p : p.slice(c+1);
}
var fs;
function get_fs() { return fs || (fs = __webpack_require__(372)); }
function parse(file, options) {
if(file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
var mver = 3;
var ssz = 512;
var nmfs = 0; // number of mini FAT sectors
var difat_sec_cnt = 0;
var dir_start = 0;
var minifat_start = 0;
var difat_start = 0;

var fat_addrs = []; // locations of FAT sectors

/* [MS-CFB] 2.2 Compound File Header */
var blob = file.slice(0,512);
prep_blob(blob, 0);

/* major version */
var mv = check_get_mver(blob);
mver = mv[0];
switch(mver) {
	case 3: ssz = 512; break; case 4: ssz = 4096; break;
	default: throw new Error("Major Version: Expected 3 or 4 saw " + mver);
}

/* reprocess header */
if(ssz !== 512) { blob = file.slice(0,ssz); prep_blob(blob, 28 /* blob.l */); }
/* Save header for final object */
var header = file.slice(0,ssz);

check_shifts(blob, mver);

// Number of Directory Sectors
var dir_cnt = blob.read_shift(4, 'i');
if(mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);

// Number of FAT Sectors
blob.l += 4;

// First Directory Sector Location
dir_start = blob.read_shift(4, 'i');

// Transaction Signature
blob.l += 4;

// Mini Stream Cutoff Size
blob.chk('00100000', 'Mini Stream Cutoff Size: ');

// First Mini FAT Sector Location
minifat_start = blob.read_shift(4, 'i');

// Number of Mini FAT Sectors
nmfs = blob.read_shift(4, 'i');

// First DIFAT sector location
difat_start = blob.read_shift(4, 'i');

// Number of DIFAT Sectors
difat_sec_cnt = blob.read_shift(4, 'i');

// Grab FAT Sector Locations
for(var q = -1, j = 0; j < 109; ++j) { /* 109 = (512 - blob.l)>>>2; */
	q = blob.read_shift(4, 'i');
	if(q<0) break;
	fat_addrs[j] = q;
}

/** Break the file up into sectors */
var sectors = sectorify(file, ssz);

sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);

/** Chains */
var sector_list = make_sector_list(sectors, dir_start, fat_addrs, ssz);

sector_list[dir_start].name = "!Directory";
if(nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
sector_list[fat_addrs[0]].name = "!FAT";
sector_list.fat_addrs = fat_addrs;
sector_list.ssz = ssz;

/* [MS-CFB] 2.6.1 Compound File Directory Entry */
var files = {}, Paths = [], FileIndex = [], FullPaths = [];
read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);

build_full_paths(FileIndex, FullPaths, Paths);
Paths.shift();

var o = {
	FileIndex: FileIndex,
	FullPaths: FullPaths
};

// $FlowIgnore
if(options && options.raw) o.raw = {header: header, sectors: sectors};
return o;
} // parse

/* [MS-CFB] 2.2 Compound File Header -- read up to major version */
function check_get_mver(blob) {
	// header signature 8
	blob.chk(HEADER_SIGNATURE, 'Header Signature: ');

	// clsid 16
	blob.chk(HEADER_CLSID, 'CLSID: ');

	// minor version 2
	var mver = blob.read_shift(2, 'u');

	return [blob.read_shift(2,'u'), mver];
}
function check_shifts(blob, mver) {
	var shift = 0x09;

	// Byte Order
	//blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
	blob.l += 2;

	// Sector Shift
	switch((shift = blob.read_shift(2))) {
		case 0x09: if(mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift); break;
		case 0x0c: if(mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift); break;
		default: throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
	}

	// Mini Sector Shift
	blob.chk('0600', 'Mini Sector Shift: ');

	// Reserved
	blob.chk('000000000000', 'Reserved: ');
}

/** Break the file up into sectors */
function sectorify(file, ssz) {
	var nsectors = Math.ceil(file.length/ssz)-1;
	var sectors = [];
	for(var i=1; i < nsectors; ++i) sectors[i-1] = file.slice(i*ssz,(i+1)*ssz);
	sectors[nsectors-1] = file.slice(nsectors*ssz);
	return sectors;
}

/* [MS-CFB] 2.6.4 Red-Black Tree */
function build_full_paths(FI, FP, Paths) {
	var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
	var dad = [], q = [];

	for(; i < pl; ++i) { dad[i]=q[i]=i; FP[i]=Paths[i]; }

	for(; j < q.length; ++j) {
		i = q[j];
		L = FI[i].L; R = FI[i].R; C = FI[i].C;
		if(dad[i] === i) {
			if(L !== -1 /*NOSTREAM*/ && dad[L] !== L) dad[i] = dad[L];
			if(R !== -1 && dad[R] !== R) dad[i] = dad[R];
		}
		if(C !== -1 /*NOSTREAM*/) dad[C] = i;
		if(L !== -1) { dad[L] = dad[i]; if(q.lastIndexOf(L) < j) q.push(L); }
		if(R !== -1) { dad[R] = dad[i]; if(q.lastIndexOf(R) < j) q.push(R); }
	}
	for(i=1; i < pl; ++i) if(dad[i] === i) {
		if(R !== -1 /*NOSTREAM*/ && dad[R] !== R) dad[i] = dad[R];
		else if(L !== -1 && dad[L] !== L) dad[i] = dad[L];
	}

	for(i=1; i < pl; ++i) {
		if(FI[i].type === 0 /* unknown */) continue;
		j = dad[i];
		if(j === 0) FP[i] = FP[0] + "/" + FP[i];
		else while(j !== 0 && j !== dad[j]) {
			FP[i] = FP[j] + "/" + FP[i];
			j = dad[j];
		}
		dad[i] = 0;
	}

	FP[0] += "/";
	for(i=1; i < pl; ++i) {
		if(FI[i].type !== 2 /* stream */) FP[i] += "/";
	}
}

function get_mfat_entry(entry, payload, mini) {
	var start = entry.start, size = entry.size;
	//return (payload.slice(start*MSSZ, start*MSSZ + size));
	var o = [];
	var idx = start;
	while(mini && size > 0 && idx >= 0) {
		o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
		size -= MSSZ;
		idx = __readInt32LE(mini, idx * 4);
	}
	if(o.length === 0) return (new_buf(0));
	return (bconcat(o).slice(0, entry.size));
}

/** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */
function sleuth_fat(idx, cnt, sectors, ssz, fat_addrs) {
	var q = ENDOFCHAIN;
	if(idx === ENDOFCHAIN) {
		if(cnt !== 0) throw new Error("DIFAT chain shorter than expected");
	} else if(idx !== -1 /*FREESECT*/) {
		var sector = sectors[idx], m = (ssz>>>2)-1;
		if(!sector) return;
		for(var i = 0; i < m; ++i) {
			if((q = __readInt32LE(sector,i*4)) === ENDOFCHAIN) break;
			fat_addrs.push(q);
		}
		sleuth_fat(__readInt32LE(sector,ssz-4),cnt - 1, sectors, ssz, fat_addrs);
	}
}

/** Follow the linked list of sectors for a given starting point */
function get_sector_list(sectors, start, fat_addrs, ssz, chkd) {
	var buf = [], buf_chain = [];
	if(!chkd) chkd = [];
	var modulus = ssz - 1, j = 0, jj = 0;
	for(j=start; j>=0;) {
		chkd[j] = true;
		buf[buf.length] = j;
		buf_chain.push(sectors[j]);
		var addr = fat_addrs[Math.floor(j*4/ssz)];
		jj = ((j*4) & modulus);
		if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
		if(!sectors[addr]) break;
		j = __readInt32LE(sectors[addr], jj);
	}
	return {nodes: buf, data:__toBuffer([buf_chain])};
}

/** Chase down the sector linked lists */
function make_sector_list(sectors, dir_start, fat_addrs, ssz) {
	var sl = sectors.length, sector_list = ([]);
	var chkd = [], buf = [], buf_chain = [];
	var modulus = ssz - 1, i=0, j=0, k=0, jj=0;
	for(i=0; i < sl; ++i) {
		buf = ([]);
		k = (i + dir_start); if(k >= sl) k-=sl;
		if(chkd[k]) continue;
		buf_chain = [];
		for(j=k; j>=0;) {
			chkd[j] = true;
			buf[buf.length] = j;
			buf_chain.push(sectors[j]);
			var addr = fat_addrs[Math.floor(j*4/ssz)];
			jj = ((j*4) & modulus);
			if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
			if(!sectors[addr]) break;
			j = __readInt32LE(sectors[addr], jj);
		}
		sector_list[k] = ({nodes: buf, data:__toBuffer([buf_chain])});
	}
	return sector_list;
}

/* [MS-CFB] 2.6.1 Compound File Directory Entry */
function read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, mini) {
	var minifat_store = 0, pl = (Paths.length?2:0);
	var sector = sector_list[dir_start].data;
	var i = 0, namelen = 0, name;
	for(; i < sector.length; i+= 128) {
		var blob = sector.slice(i, i+128);
		prep_blob(blob, 64);
		namelen = blob.read_shift(2);
		name = __utf16le(blob,0,namelen-pl);
		Paths.push(name);
		var o = ({
			name:  name,
			type:  blob.read_shift(1),
			color: blob.read_shift(1),
			L:     blob.read_shift(4, 'i'),
			R:     blob.read_shift(4, 'i'),
			C:     blob.read_shift(4, 'i'),
			clsid: blob.read_shift(16),
			state: blob.read_shift(4, 'i'),
			start: 0,
			size: 0
		});
		var ctime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
		if(ctime !== 0) o.ct = read_date(blob, blob.l-8);
		var mtime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
		if(mtime !== 0) o.mt = read_date(blob, blob.l-8);
		o.start = blob.read_shift(4, 'i');
		o.size = blob.read_shift(4, 'i');
		if(o.size < 0 && o.start < 0) { o.size = o.type = 0; o.start = ENDOFCHAIN; o.name = ""; }
		if(o.type === 5) { /* root */
			minifat_store = o.start;
			if(nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
			/*minifat_size = o.size;*/
		} else if(o.size >= 4096 /* MSCSZ */) {
			o.storage = 'fat';
			if(sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
			sector_list[o.start].name = o.name;
			o.content = (sector_list[o.start].data.slice(0,o.size));
		} else {
			o.storage = 'minifat';
			if(o.size < 0) o.size = 0;
			else if(minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) {
				o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini]||{}).data);
			}
		}
		if(o.content) prep_blob(o.content, 0);
		files[name] = o;
		FileIndex.push(o);
	}
}

function read_date(blob, offset) {
	return new Date(( ( (__readUInt32LE(blob,offset+4)/1e7)*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7 ) - 11644473600)*1000);
}

function read_file(filename, options) {
	get_fs();
	return parse(fs.readFileSync(filename), options);
}

function read(blob, options) {
	switch(options && options.type || "base64") {
		case "file": return read_file(blob, options);
		case "base64": return parse(s2a(Base64.decode(blob)), options);
		case "binary": return parse(s2a(blob), options);
	}
	return parse(blob, options);
}

function init_cfb(cfb, opts) {
	var o = opts || {}, root = o.root || "Root Entry";
	if(!cfb.FullPaths) cfb.FullPaths = [];
	if(!cfb.FileIndex) cfb.FileIndex = [];
	if(cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
	if(cfb.FullPaths.length === 0) {
		cfb.FullPaths[0] = root + "/";
		cfb.FileIndex[0] = ({ name: root, type: 5 });
	}
	if(o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
	seed_cfb(cfb);
}
function seed_cfb(cfb) {
	var nm = "\u0001Sh33tJ5";
	if(CFB.find(cfb, "/" + nm)) return;
	var p = new_buf(4); p[0] = 55; p[1] = p[3] = 50; p[2] = 54;
	cfb.FileIndex.push(({ name: nm, type: 2, content:p, size:4, L:69, R:69, C:69 }));
	cfb.FullPaths.push(cfb.FullPaths[0] + nm);
	rebuild_cfb(cfb);
}
function rebuild_cfb(cfb, f) {
	init_cfb(cfb);
	var gc = false, s = false;
	for(var i = cfb.FullPaths.length - 1; i >= 0; --i) {
		var _file = cfb.FileIndex[i];
		switch(_file.type) {
			case 0:
				if(s) gc = true;
				else { cfb.FileIndex.pop(); cfb.FullPaths.pop(); }
				break;
			case 1: case 2: case 5:
				s = true;
				if(isNaN(_file.R * _file.L * _file.C)) gc = true;
				if(_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
				break;
			default: gc = true; break;
		}
	}
	if(!gc && !f) return;

	var now = new Date(1987, 1, 19), j = 0;
	var data = [];
	for(i = 0; i < cfb.FullPaths.length; ++i) {
		if(cfb.FileIndex[i].type === 0) continue;
		data.push([cfb.FullPaths[i], cfb.FileIndex[i]]);
	}
	for(i = 0; i < data.length; ++i) {
		var dad = dirname(data[i][0]);
		s = false;
		for(j = 0; j < data.length; ++j) if(data[j][0] === dad) s = true;
		if(!s) data.push([dad, ({
			name: filename(dad).replace("/",""),
			type: 1,
			clsid: HEADER_CLSID,
			ct: now, mt: now,
			content: null
		})]);
	}

	data.sort(function(x,y) { return namecmp(x[0], y[0]); });
	cfb.FullPaths = []; cfb.FileIndex = [];
	for(i = 0; i < data.length; ++i) { cfb.FullPaths[i] = data[i][0]; cfb.FileIndex[i] = data[i][1]; }
	for(i = 0; i < data.length; ++i) {
		var elt = cfb.FileIndex[i];
		var nm = cfb.FullPaths[i];

		elt.name =  filename(nm).replace("/","");
		elt.L = elt.R = elt.C = -(elt.color = 1);
		elt.size = elt.content ? elt.content.length : 0;
		elt.start = 0;
		elt.clsid = (elt.clsid || HEADER_CLSID);
		if(i === 0) {
			elt.C = data.length > 1 ? 1 : -1;
			elt.size = 0;
			elt.type = 5;
		} else if(nm.slice(-1) == "/") {
			for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==nm) break;
			elt.C = j >= data.length ? -1 : j;
			for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==dirname(nm)) break;
			elt.R = j >= data.length ? -1 : j;
			elt.type = 1;
		} else {
			if(dirname(cfb.FullPaths[i+1]||"") == dirname(nm)) elt.R = i + 1;
			elt.type = 2;
		}
	}

}

function _write(cfb, options) {
	var _opts = options || {};
	rebuild_cfb(cfb);
	var L = (function(cfb){
		var mini_size = 0, fat_size = 0;
		for(var i = 0; i < cfb.FileIndex.length; ++i) {
			var file = cfb.FileIndex[i];
			if(!file.content) continue;
var flen = file.content.length;
			if(flen > 0){
				if(flen < 0x1000) mini_size += (flen + 0x3F) >> 6;
				else fat_size += (flen + 0x01FF) >> 9;
			}
		}
		var dir_cnt = (cfb.FullPaths.length +3) >> 2;
		var mini_cnt = (mini_size + 7) >> 3;
		var mfat_cnt = (mini_size + 0x7F) >> 7;
		var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
		var fat_cnt = (fat_base + 0x7F) >> 7;
		var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
		while(((fat_base + fat_cnt + difat_cnt + 0x7F) >> 7) > fat_cnt) difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
		var L =  [1, difat_cnt, fat_cnt, mfat_cnt, dir_cnt, fat_size, mini_size, 0];
		cfb.FileIndex[0].size = mini_size << 6;
		L[7] = (cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+((L[6]+7) >> 3);
		return L;
	})(cfb);
	var o = new_buf(L[7] << 9);
	var i = 0, T = 0;
	{
		for(i = 0; i < 8; ++i) o.write_shift(1, HEADER_SIG[i]);
		for(i = 0; i < 8; ++i) o.write_shift(2, 0);
		o.write_shift(2, 0x003E);
		o.write_shift(2, 0x0003);
		o.write_shift(2, 0xFFFE);
		o.write_shift(2, 0x0009);
		o.write_shift(2, 0x0006);
		for(i = 0; i < 3; ++i) o.write_shift(2, 0);
		o.write_shift(4, 0);
		o.write_shift(4, L[2]);
		o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
		o.write_shift(4, 0);
		o.write_shift(4, 1<<12);
		o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1: ENDOFCHAIN);
		o.write_shift(4, L[3]);
		o.write_shift(-4, L[1] ? L[0] - 1: ENDOFCHAIN);
		o.write_shift(4, L[1]);
		for(i = 0; i < 109; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
	}
	if(L[1]) {
		for(T = 0; T < L[1]; ++T) {
			for(; i < 236 + T * 127; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
			o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
		}
	}
	var chainit = function(w) {
		for(T += w; i<T-1; ++i) o.write_shift(-4, i+1);
		if(w) { ++i; o.write_shift(-4, ENDOFCHAIN); }
	};
	T = i = 0;
	for(T+=L[1]; i<T; ++i) o.write_shift(-4, consts.DIFSECT);
	for(T+=L[2]; i<T; ++i) o.write_shift(-4, consts.FATSECT);
	chainit(L[3]);
	chainit(L[4]);
	var j = 0, flen = 0;
	var file = cfb.FileIndex[0];
	for(; j < cfb.FileIndex.length; ++j) {
		file = cfb.FileIndex[j];
		if(!file.content) continue;
flen = file.content.length;
		if(flen < 0x1000) continue;
		file.start = T;
		chainit((flen + 0x01FF) >> 9);
	}
	chainit((L[6] + 7) >> 3);
	while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
	T = i = 0;
	for(j = 0; j < cfb.FileIndex.length; ++j) {
		file = cfb.FileIndex[j];
		if(!file.content) continue;
flen = file.content.length;
		if(!flen || flen >= 0x1000) continue;
		file.start = T;
		chainit((flen + 0x3F) >> 6);
	}
	while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
	for(i = 0; i < L[4]<<2; ++i) {
		var nm = cfb.FullPaths[i];
		if(!nm || nm.length === 0) {
			for(j = 0; j < 17; ++j) o.write_shift(4, 0);
			for(j = 0; j < 3; ++j) o.write_shift(4, -1);
			for(j = 0; j < 12; ++j) o.write_shift(4, 0);
			continue;
		}
		file = cfb.FileIndex[i];
		if(i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
		var _nm = (i === 0 && _opts.root) || file.name;
		flen = 2*(_nm.length+1);
		o.write_shift(64, _nm, "utf16le");
		o.write_shift(2, flen);
		o.write_shift(1, file.type);
		o.write_shift(1, file.color);
		o.write_shift(-4, file.L);
		o.write_shift(-4, file.R);
		o.write_shift(-4, file.C);
		if(!file.clsid) for(j = 0; j < 4; ++j) o.write_shift(4, 0);
		else o.write_shift(16, file.clsid, "hex");
		o.write_shift(4, file.state || 0);
		o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(4, file.start);
		o.write_shift(4, file.size); o.write_shift(4, 0);
	}
	for(i = 1; i < cfb.FileIndex.length; ++i) {
		file = cfb.FileIndex[i];
if(file.size >= 0x1000) {
			o.l = (file.start+1) << 9;
			for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
			for(; j & 0x1FF; ++j) o.write_shift(1, 0);
		}
	}
	for(i = 1; i < cfb.FileIndex.length; ++i) {
		file = cfb.FileIndex[i];
if(file.size > 0 && file.size < 0x1000) {
			for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
			for(; j & 0x3F; ++j) o.write_shift(1, 0);
		}
	}
	while(o.l < o.length) o.write_shift(1, 0);
	return o;
}
/* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */
function find(cfb, path) {
	var UCFullPaths = cfb.FullPaths.map(function(x) { return x.toUpperCase(); });
	var UCPaths = UCFullPaths.map(function(x) { var y = x.split("/"); return y[y.length - (x.slice(-1) == "/" ? 2 : 1)]; });
	var k = false;
	if(path.charCodeAt(0) === 47 /* "/" */) { k = true; path = UCFullPaths[0].slice(0, -1) + path; }
	else k = path.indexOf("/") !== -1;
	var UCPath = path.toUpperCase();
	var w = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
	if(w !== -1) return cfb.FileIndex[w];

	var m = !UCPath.match(chr1);
	UCPath = UCPath.replace(chr0,'');
	if(m) UCPath = UCPath.replace(chr1,'!');
	for(w = 0; w < UCFullPaths.length; ++w) {
		if((m ? UCFullPaths[w].replace(chr1,'!') : UCFullPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
		if((m ? UCPaths[w].replace(chr1,'!') : UCPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
	}
	return null;
}
/** CFB Constants */
var MSSZ = 64; /* Mini Sector Size = 1<<6 */
//var MSCSZ = 4096; /* Mini Stream Cutoff Size */
/* 2.1 Compound File Sector Numbers and Types */
var ENDOFCHAIN = -2;
/* 2.2 Compound File Header */
var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
var HEADER_SIG = [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1];
var HEADER_CLSID = '00000000000000000000000000000000';
var consts = {
	/* 2.1 Compund File Sector Numbers and Types */
	MAXREGSECT: -6,
	DIFSECT: -4,
	FATSECT: -3,
	ENDOFCHAIN: ENDOFCHAIN,
	FREESECT: -1,
	/* 2.2 Compound File Header */
	HEADER_SIGNATURE: HEADER_SIGNATURE,
	HEADER_MINOR_VERSION: '3e00',
	MAXREGSID: -6,
	NOSTREAM: -1,
	HEADER_CLSID: HEADER_CLSID,
	/* 2.6.1 Compound File Directory Entry */
	EntryTypes: ['unknown','storage','stream','lockbytes','property','root']
};

function write_file(cfb, filename, options) {
	get_fs();
	var o = _write(cfb, options);
fs.writeFileSync(filename, o);
}

function a2s(o) {
	var out = new Array(o.length);
	for(var i = 0; i < o.length; ++i) out[i] = String.fromCharCode(o[i]);
	return out.join("");
}

function write(cfb, options) {
	var o = _write(cfb, options);
	switch(options && options.type) {
		case "file": get_fs(); fs.writeFileSync(options.filename, (o)); return o;
		case "binary": return a2s(o);
		case "base64": return Base64.encode(a2s(o));
	}
	return o;
}
function cfb_new(opts) {
	var o = ({});
	init_cfb(o, opts);
	return o;
}

function cfb_add(cfb, name, content, opts) {
	var unsafe = opts && opts.unsafe;
	if(!unsafe) init_cfb(cfb);
	var file = !unsafe && CFB.find(cfb, name);
	if(!file) {
		var fpath = cfb.FullPaths[0];
		if(name.slice(0, fpath.length) == fpath) fpath = name;
		else {
			if(fpath.slice(-1) != "/") fpath += "/";
			fpath = (fpath + name).replace("//","/");
		}
		file = ({name: filename(name), type: 2});
		cfb.FileIndex.push(file);
		cfb.FullPaths.push(fpath);
		if(!unsafe) CFB.utils.cfb_gc(cfb);
	}
file.content = (content);
	file.size = content ? content.length : 0;
	if(opts) {
		if(opts.CLSID) file.clsid = opts.CLSID;
	}
	return file;
}

function cfb_del(cfb, name) {
	init_cfb(cfb);
	var file = CFB.find(cfb, name);
	if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
		cfb.FileIndex.splice(j, 1);
		cfb.FullPaths.splice(j, 1);
		return true;
	}
	return false;
}

function cfb_mov(cfb, old_name, new_name) {
	init_cfb(cfb);
	var file = CFB.find(cfb, old_name);
	if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
		cfb.FileIndex[j].name = filename(new_name);
		cfb.FullPaths[j] = new_name;
		return true;
	}
	return false;
}

function cfb_gc(cfb) { rebuild_cfb(cfb, true); }

exports.find = find;
exports.read = read;
exports.parse = parse;
exports.write = write;
exports.writeFile = write_file;
exports.utils = {
	cfb_new: cfb_new,
	cfb_add: cfb_add,
	cfb_del: cfb_del,
	cfb_mov: cfb_mov,
	cfb_gc: cfb_gc,
	ReadShift: ReadShift,
	CheckField: CheckField,
	prep_blob: prep_blob,
	bconcat: bconcat,
	consts: consts
};

return exports;
})();

if("function" !== 'undefined' && typeof module !== 'undefined' && typeof DO_NOT_EXPORT_CFB === 'undefined') { module.exports = CFB; }
var _fs;
if(true) try { _fs = __webpack_require__(372); } catch(e) {}

/* normalize data for blob ctor */
function blobify(data) {
	if(typeof data === "string") return s2ab(data);
	if(Array.isArray(data)) return a2u(data);
	return data;
}
/* write or download file */
function write_dl(fname, payload, enc) {
	/*global IE_SaveFile, Blob, navigator, saveAs, URL, document, File, chrome */
	if(typeof _fs !== 'undefined' && _fs.writeFileSync) return enc ? _fs.writeFileSync(fname, payload, enc) : _fs.writeFileSync(fname, payload);
	var data = (enc == "utf8") ? utf8write(payload) : payload;
if(typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
	if(typeof Blob !== 'undefined') {
		var blob = new Blob([blobify(data)], {type:"application/octet-stream"});
if(typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
if(typeof saveAs !== 'undefined') return saveAs(blob, fname);
		if(typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
			var url = URL.createObjectURL(blob);
if(typeof chrome === 'object' && typeof (chrome.downloads||{}).download == "function") {
				if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
				return chrome.downloads.download({ url: url, filename: fname, saveAs: true});
			}
			var a = document.createElement("a");
			if(a.download != null) {
a.download = fname; a.href = url; document.body.appendChild(a); a.click();
document.body.removeChild(a);
				if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
				return url;
			}
		}
	}
	// $FlowIgnore
	if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
		// $FlowIgnore
		var out = File(fname); out.open("w"); out.encoding = "binary";
		if(Array.isArray(payload)) payload = a2s(payload);
		out.write(payload); out.close(); return payload;
	} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
	throw new Error("cannot save file " + fname);
}

/* read binary data from file */
function read_binary(path) {
	if(typeof _fs !== 'undefined') return _fs.readFileSync(path);
	// $FlowIgnore
	if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
		// $FlowIgnore
		var infile = File(path); infile.open("r"); infile.encoding = "binary";
		var data = infile.read(); infile.close();
		return data;
	} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
	throw new Error("Cannot access file " + path);
}
function keys(o) {
	var ks = Object.keys(o), o2 = [];
	for(var i = 0; i < ks.length; ++i) if(o.hasOwnProperty(ks[i])) o2.push(ks[i]);
	return o2;
}

function evert_key(obj, key) {
	var o = ([]), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) if(o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
	return o;
}

function evert(obj) {
	var o = ([]), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = K[i];
	return o;
}

function evert_num(obj) {
	var o = ([]), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = parseInt(K[i],10);
	return o;
}

function evert_arr(obj) {
	var o = ([]), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) {
		if(o[obj[K[i]]] == null) o[obj[K[i]]] = [];
		o[obj[K[i]]].push(K[i]);
	}
	return o;
}

var basedate = new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
var dnthresh = basedate.getTime() + (new Date().getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
function datenum(v, date1904) {
	var epoch = v.getTime();
	if(date1904) epoch -= 1462*24*60*60*1000;
	return (epoch - dnthresh) / (24 * 60 * 60 * 1000);
}
function numdate(v) {
	var out = new Date();
	out.setTime(v * 24 * 60 * 60 * 1000 + dnthresh);
	return out;
}

/* ISO 8601 Duration */
function parse_isodur(s) {
	var sec = 0, mt = 0, time = false;
	var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
	if(!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
	for(var i = 1; i != m.length; ++i) {
		if(!m[i]) continue;
		mt = 1;
		if(i > 3) time = true;
		switch(m[i].slice(m[i].length-1)) {
			case 'Y':
				throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length-1));
			case 'D': mt *= 24;
				/* falls through */
			case 'H': mt *= 60;
				/* falls through */
			case 'M':
				if(!time) throw new Error("Unsupported ISO Duration Field: M");
				else mt *= 60;
				/* falls through */
			case 'S': break;
		}
		sec += mt * parseInt(m[i], 10);
	}
	return sec;
}

var good_pd_date = new Date('2017-02-19T19:06:09.000Z');
if(isNaN(good_pd_date.getFullYear())) good_pd_date = new Date('2/19/17');
var good_pd = good_pd_date.getFullYear() == 2017;
/* parses a date as a local date */
function parseDate(str, fixdate) {
	var d = new Date(str);
	if(good_pd) {
if(fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
		else if(fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
		return d;
	}
	if(str instanceof Date) return str;
	if(good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
		var s = d.getFullYear();
		if(str.indexOf("" + s) > -1) return d;
		d.setFullYear(d.getFullYear() + 100); return d;
	}
	var n = str.match(/\d+/g)||["2017","2","19","0","0","0"];
	var out = new Date(+n[0], +n[1] - 1, +n[2], (+n[3]||0), (+n[4]||0), (+n[5]||0));
	if(str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60 * 1000);
	return out;
}

function cc2str(arr) {
	var o = "";
	for(var i = 0; i != arr.length; ++i) o += String.fromCharCode(arr[i]);
	return o;
}

function dup(o) {
	if(typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
	if(typeof o != 'object' || o == null) return o;
	if(o instanceof Date) return new Date(o.getTime());
	var out = {};
	for(var k in o) if(o.hasOwnProperty(k)) out[k] = dup(o[k]);
	return out;
}

function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }

/* TODO: stress test */
function fuzzynum(s) {
	var v = Number(s);
	if(!isNaN(v)) return v;
	var wt = 1;
	var ss = s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g, function() { wt *= 100; return "";});
	if(!isNaN(v = Number(ss))) return v / wt;
	ss = ss.replace(/[(](.*)[)]/,function($$, $1) { wt = -wt; return $1;});
	if(!isNaN(v = Number(ss))) return v / wt;
	return v;
}
function fuzzydate(s) {
	var o = new Date(s), n = new Date(NaN);
	var y = o.getYear(), m = o.getMonth(), d = o.getDate();
	if(isNaN(d)) return n;
	if(y < 0 || y > 8099) return n;
	if((m > 0 || d > 1) && y != 101) return o;
	if(s.toLowerCase().match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) return o;
	if(s.match(/[^-0-9:,\/\\]/)) return n;
	return o;
}

var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
function split_regex(str, re, def) {
	if(safe_split_regex || typeof re == "string") return str.split(re);
	var p = str.split(re), o = [p[0]];
	for(var i = 1; i < p.length; ++i) { o.push(def); o.push(p[i]); }
	return o;
}
function getdatastr(data) {
	if(!data) return null;
	if(data.data) return debom(data.data);
	if(data.asNodeBuffer && has_buf) return debom(data.asNodeBuffer().toString('binary'));
	if(data.asBinary) return debom(data.asBinary());
	if(data._data && data._data.getContent) return debom(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));
	return null;
}

function getdatabin(data) {
	if(!data) return null;
	if(data.data) return char_codes(data.data);
	if(data.asNodeBuffer && has_buf) return data.asNodeBuffer();
	if(data._data && data._data.getContent) {
		var o = data._data.getContent();
		if(typeof o == "string") return char_codes(o);
		return Array.prototype.slice.call(o);
	}
	return null;
}

function getdata(data) { return (data && data.name.slice(-4) === ".bin") ? getdatabin(data) : getdatastr(data); }

/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */
/* OASIS does not comment on filename case sensitivity */
function safegetzipfile(zip, file) {
	var k = keys(zip.files);
	var f = file.toLowerCase(), g = f.replace(/\//g,'\\');
	for(var i=0; i<k.length; ++i) {
		var n = k[i].toLowerCase();
		if(f == n || g == n) return zip.files[k[i]];
	}
	return null;
}

function getzipfile(zip, file) {
	var o = safegetzipfile(zip, file);
	if(o == null) throw new Error("Cannot find file " + file + " in zip");
	return o;
}

function getzipdata(zip, file, safe) {
	if(!safe) return getdata(getzipfile(zip, file));
	if(!file) return null;
	try { return getzipdata(zip, file); } catch(e) { return null; }
}

function getzipstr(zip, file, safe) {
	if(!safe) return getdatastr(getzipfile(zip, file));
	if(!file) return null;
	try { return getzipstr(zip, file); } catch(e) { return null; }
}

function zipentries(zip) {
	var k = keys(zip.files), o = [];
	for(var i = 0; i < k.length; ++i) if(k[i].slice(-1) != '/') o.push(k[i]);
	return o.sort();
}

var jszip;
/*global JSZipSync:true */
if(typeof JSZipSync !== 'undefined') jszip = JSZipSync;
if(true) {
	if(typeof module !== 'undefined' && module.exports) {
		if(typeof jszip === 'undefined') jszip = __webpack_require__(1089);
	}
}

function resolve_path(path, base) {
	var result = base.split('/');
	if(base.slice(-1) != "/") result.pop(); // folder path
	var target = path.split('/');
	while (target.length !== 0) {
		var step = target.shift();
		if (step === '..') result.pop();
		else if (step !== '.') result.push(step);
	}
	return result.join('/');
}
var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var attregexg=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var tagregex=/<[\/\?]?[a-zA-Z0-9:]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s?[\/\?]?>/g;
if(!(XML_HEADER.match(tagregex))) tagregex = /<[^>]*>/g;
var nsregex=/<\w*:/, nsregex2 = /<(\/?)\w+:/;
function parsexmltag(tag, skip_root) {
	var z = ({});
	var eq = 0, c = 0;
	for(; eq !== tag.length; ++eq) if((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
	if(!skip_root) z[0] = tag.slice(0, eq);
	if(eq === tag.length) return z;
	var m = tag.match(attregexg), j=0, v="", i=0, q="", cc="", quot = 1;
	if(m) for(i = 0; i != m.length; ++i) {
		cc = m[i];
		for(c=0; c != cc.length; ++c) if(cc.charCodeAt(c) === 61) break;
		q = cc.slice(0,c).trim();
		while(cc.charCodeAt(c+1) == 32) ++c;
		quot = ((eq=cc.charCodeAt(c+1)) == 34 || eq == 39) ? 1 : 0;
		v = cc.slice(c+1+quot, cc.length-quot);
		for(j=0;j!=q.length;++j) if(q.charCodeAt(j) === 58) break;
		if(j===q.length) {
			if(q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
			z[q] = v;
			z[q.toLowerCase()] = v;
		}
		else {
			var k = (j===5 && q.slice(0,5)==="xmlns"?"xmlns":"")+q.slice(j+1);
			if(z[k] && q.slice(j-3,j) == "ext") continue; // from ods
			z[k] = v;
			z[k.toLowerCase()] = v;
		}
	}
	return z;
}
function strip_ns(x) { return x.replace(nsregex2, "<$1"); }

var encodings = {
	'&quot;': '"',
	'&apos;': "'",
	'&gt;': '>',
	'&lt;': '<',
	'&amp;': '&'
};
var rencoding = evert(encodings);
//var rencstr = "&<>'\"".split("");

// TODO: CP remap (need to read file version to determine OS)
var unescapexml = (function() {
	/* 22.4.2.4 bstr (Basic String) */
	var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/g, coderegex = /_x([\da-fA-F]{4})_/g;
	return function unescapexml(text) {
		var s = text + '', i = s.indexOf("<![CDATA[");
		if(i == -1) return s.replace(encregex, function($$, $1) { return encodings[$$]||String.fromCharCode(parseInt($1,$$.indexOf("x")>-1?16:10))||$$; }).replace(coderegex,function(m,c) {return String.fromCharCode(parseInt(c,16));});
		var j = s.indexOf("]]>");
		return unescapexml(s.slice(0, i)) + s.slice(i+9,j) + unescapexml(s.slice(j+3));
	};
})();

var decregex=/[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f]/g;
function escapexml(text){
	var s = text + '';
	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(charegex,function(s) { return "_x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + "_";});
}
function escapexmltag(text){ return escapexml(text).replace(/ /g,"_x0020_"); }

var htmlcharegex = /[\u0000-\u001f]/g;
function escapehtml(text){
	var s = text + '';
	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(/\n/g, "<br/>").replace(htmlcharegex,function(s) { return "&#x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + ";"; });
}

function escapexlml(text){
	var s = text + '';
	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(htmlcharegex,function(s) { return "&#x" + (s.charCodeAt(0).toString(16)).toUpperCase() + ";"; });
}

/* TODO: handle codepages */
var xlml_fixstr = (function() {
	var entregex = /&#(\d+);/g;
	function entrepl($$,$1) { return String.fromCharCode(parseInt($1,10)); }
	return function xlml_fixstr(str) { return str.replace(entregex,entrepl); };
})();
var xlml_unfixstr = (function() {
	return function xlml_unfixstr(str) { return str.replace(/(\r\n|[\r\n])/g,"\&#10;"); };
})();

function parsexmlbool(value) {
	switch(value) {
		case 1: case true: case '1': case 'true': case 'TRUE': return true;
		/* case '0': case 'false': case 'FALSE':*/
		default: return false;
	}
}

var utf8read = function utf8reada(orig) {
	var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
	while (i < orig.length) {
		c = orig.charCodeAt(i++);
		if (c < 128) { out += String.fromCharCode(c); continue; }
		d = orig.charCodeAt(i++);
		if (c>191 && c<224) { f = ((c & 31) << 6); f |= (d & 63); out += String.fromCharCode(f); continue; }
		e = orig.charCodeAt(i++);
		if (c < 240) { out += String.fromCharCode(((c & 15) << 12) | ((d & 63) << 6) | (e & 63)); continue; }
		f = orig.charCodeAt(i++);
		w = (((c & 7) << 18) | ((d & 63) << 12) | ((e & 63) << 6) | (f & 63))-65536;
		out += String.fromCharCode(0xD800 + ((w>>>10)&1023));
		out += String.fromCharCode(0xDC00 + (w&1023));
	}
	return out;
};

var utf8write = function(orig) {
	var out = [], i = 0, c = 0, d = 0;
	while(i < orig.length) {
		c = orig.charCodeAt(i++);
		switch(true) {
			case c < 128: out.push(String.fromCharCode(c)); break;
			case c < 2048:
				out.push(String.fromCharCode(192 + (c >> 6)));
				out.push(String.fromCharCode(128 + (c & 63)));
				break;
			case c >= 55296 && c < 57344:
				c -= 55296; d = orig.charCodeAt(i++) - 56320 + (c<<10);
				out.push(String.fromCharCode(240 + ((d >>18) & 7)));
				out.push(String.fromCharCode(144 + ((d >>12) & 63)));
				out.push(String.fromCharCode(128 + ((d >> 6) & 63)));
				out.push(String.fromCharCode(128 + (d & 63)));
				break;
			default:
				out.push(String.fromCharCode(224 + (c >> 12)));
				out.push(String.fromCharCode(128 + ((c >> 6) & 63)));
				out.push(String.fromCharCode(128 + (c & 63)));
		}
	}
	return out.join("");
};

if(has_buf) {
	var utf8readb = function utf8readb(data) {
		var out = Buffer.alloc(2*data.length), w, i, j = 1, k = 0, ww=0, c;
		for(i = 0; i < data.length; i+=j) {
			j = 1;
			if((c=data.charCodeAt(i)) < 128) w = c;
			else if(c < 224) { w = (c&31)*64+(data.charCodeAt(i+1)&63); j=2; }
			else if(c < 240) { w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63); j=3; }
			else { j = 4;
				w = (c & 7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);
				w -= 65536; ww = 0xD800 + ((w>>>10)&1023); w = 0xDC00 + (w&1023);
			}
			if(ww !== 0) { out[k++] = ww&255; out[k++] = ww>>>8; ww = 0; }
			out[k++] = w%256; out[k++] = w>>>8;
		}
		return out.slice(0,k).toString('ucs2');
	};
	var corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
	if(utf8read(corpus) == utf8readb(corpus)) utf8read = utf8readb;
	// $FlowIgnore
	var utf8readc = function utf8readc(data) { return Buffer_from(data, 'binary').toString('utf8'); };
	if(utf8read(corpus) == utf8readc(corpus)) utf8read = utf8readc;

	// $FlowIgnore
	utf8write = function(data) { return Buffer_from(data, 'utf8').toString("binary"); };
}

// matches <foo>...</foo> extracts content
var matchtag = (function() {
	var mtcache = ({});
	return function matchtag(f,g) {
		var t = f+"|"+(g||"");
		if(mtcache[t]) return mtcache[t];
		return (mtcache[t] = new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+f+'>',((g||""))));
	};
})();

var htmldecode = (function() {
	var entities = [
		['nbsp', ' '], ['middot', '·'],
		['quot', '"'], ['apos', "'"], ['gt',   '>'], ['lt',   '<'], ['amp',  '&']
	].map(function(x) { return [new RegExp('&' + x[0] + ';', "g"), x[1]]; });
	return function htmldecode(str) {
		var o = str.replace(/^[\t\n\r ]+/, "").replace(/[\t\n\r ]+$/,"").replace(/[\t\n\r ]+/g, " ").replace(/<\s*[bB][rR]\s*\/?>/g,"\n").replace(/<[^>]*>/g,"");
		for(var i = 0; i < entities.length; ++i) o = o.replace(entities[i][0], entities[i][1]);
		return o;
	};
})();

var vtregex = (function(){ var vt_cache = {};
	return function vt_regex(bt) {
		if(vt_cache[bt] !== undefined) return vt_cache[bt];
		return (vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", 'g') );
};})();
var vtvregex = /<\/?(?:vt:)?variant>/g, vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
function parseVector(data, opts) {
	var h = parsexmltag(data);

	var matches = data.match(vtregex(h.baseType))||[];
	var res = [];
	if(matches.length != h.size) {
		if(opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
		return res;
	}
	matches.forEach(function(x) {
		var v = x.replace(vtvregex,"").match(vtmregex);
		if(v) res.push({v:utf8read(v[2]), t:v[1]});
	});
	return res;
}

var wtregex = /(^\s|\s$|\n)/;
function writetag(f,g) { return '<' + f + (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f + '>'; }

function wxt_helper(h) { return keys(h).map(function(k) { return " " + k + '="' + h[k] + '"';}).join(""); }
function writextag(f,g,h) { return '<' + f + ((h != null) ? wxt_helper(h) : "") + ((g != null) ? (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';}

function write_w3cdtf(d, t) { try { return d.toISOString().replace(/\.\d*/,""); } catch(e) { if(t) throw e; } return ""; }

function write_vt(s) {
	switch(typeof s) {
		case 'string': return writextag('vt:lpwstr', s);
		case 'number': return writextag((s|0)==s?'vt:i4':'vt:r8', String(s));
		case 'boolean': return writextag('vt:bool',s?'true':'false');
	}
	if(s instanceof Date) return writextag('vt:filetime', write_w3cdtf(s));
	throw new Error("Unable to serialize " + s);
}

var XMLNS = ({
	'dc': 'http://purl.org/dc/elements/1.1/',
	'dcterms': 'http://purl.org/dc/terms/',
	'dcmitype': 'http://purl.org/dc/dcmitype/',
	'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
	'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
	'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
	'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
	'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
	'xsd': 'http://www.w3.org/2001/XMLSchema'
});

XMLNS.main = [
	'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
	'http://purl.oclc.org/ooxml/spreadsheetml/main',
	'http://schemas.microsoft.com/office/excel/2006/main',
	'http://schemas.microsoft.com/office/excel/2006/2'
];

var XLMLNS = ({
	'o':    'urn:schemas-microsoft-com:office:office',
	'x':    'urn:schemas-microsoft-com:office:excel',
	'ss':   'urn:schemas-microsoft-com:office:spreadsheet',
	'dt':   'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
	'mv':   'http://macVmlSchemaUri',
	'v':    'urn:schemas-microsoft-com:vml',
	'html': 'http://www.w3.org/TR/REC-html40'
});
function read_double_le(b, idx) {
	var s = 1 - 2 * (b[idx + 7] >>> 7);
	var e = ((b[idx + 7] & 0x7f) << 4) + ((b[idx + 6] >>> 4) & 0x0f);
	var m = (b[idx+6]&0x0f);
	for(var i = 5; i >= 0; --i) m = m * 256 + b[idx + i];
	if(e == 0x7ff) return m == 0 ? (s * Infinity) : NaN;
	if(e == 0) e = -1022;
	else { e -= 1023; m += Math.pow(2,52); }
	return s * Math.pow(2, e - 52) * m;
}

function write_double_le(b, v, idx) {
	var bs = ((((v < 0) || (1/v == -Infinity)) ? 1 : 0) << 7), e = 0, m = 0;
	var av = bs ? (-v) : v;
	if(!isFinite(av)) { e = 0x7ff; m = isNaN(v) ? 0x6969 : 0; }
	else if(av == 0) e = m = 0;
	else {
		e = Math.floor(Math.log(av) / Math.LN2);
		m = av * Math.pow(2, 52 - e);
		if((e <= -1023) && (!isFinite(m) || (m < Math.pow(2,52)))) { e = -1022; }
		else { m -= Math.pow(2,52); e+=1023; }
	}
	for(var i = 0; i <= 5; ++i, m/=256) b[idx + i] = m & 0xff;
	b[idx + 6] = ((e & 0x0f) << 4) | (m & 0xf);
	b[idx + 7] = (e >> 4) | bs;
}

var __toBuffer = function(bufs) { var x=[],w=10240; for(var i=0;i<bufs[0].length;++i) if(bufs[0][i]) for(var j=0,L=bufs[0][i].length;j<L;j+=w) x.push.apply(x, bufs[0][i].slice(j,j+w)); return x; };
var ___toBuffer = __toBuffer;
var __utf16le = function(b,s,e) { var ss=[]; for(var i=s; i<e; i+=2) ss.push(String.fromCharCode(__readUInt16LE(b,i))); return ss.join("").replace(chr0,''); };
var ___utf16le = __utf16le;
var __hexlify = function(b,s,l) { var ss=[]; for(var i=s; i<s+l; ++i) ss.push(("0" + b[i].toString(16)).slice(-2)); return ss.join(""); };
var ___hexlify = __hexlify;
var __utf8 = function(b,s,e) { var ss=[]; for(var i=s; i<e; i++) ss.push(String.fromCharCode(__readUInt8(b,i))); return ss.join(""); };
var ___utf8 = __utf8;
var __lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
var ___lpstr = __lpstr;
var __cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
var ___cpstr = __cpstr;
var __lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
var ___lpwstr = __lpwstr;
var __lpp4, ___lpp4;
__lpp4 = ___lpp4 = function lpp4_(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf16le(b, i+4,i+4+len) : "";};
var __8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len) : "";};
var ___8lpp4 = __8lpp4;
var __double, ___double;
__double = ___double = function(b, idx) { return read_double_le(b, idx);};
var is_buf = function is_buf_a(a) { return Array.isArray(a); };

if(has_buf) {
	__utf16le = function(b,s,e) { if(!Buffer.isBuffer(b)) return ___utf16le(b,s,e); return b.toString('utf16le',s,e).replace(chr0,'')/*.replace(chr1,'!')*/; };
	__hexlify = function(b,s,l) { return Buffer.isBuffer(b) ? b.toString('hex',s,s+l) : ___hexlify(b,s,l); };
	__lpstr = function lpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
	__cpstr = function cpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___cpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
	__lpwstr = function lpwstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpwstr(b, i); var len = 2*b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len-1);};
	__lpp4 = function lpp4_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len);};
	__8lpp4 = function lpp4_8b(b, i) { if(!Buffer.isBuffer(b)) return ___8lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf8',i+4,i+4+len);};
	__utf8 = function utf8_b(b, s, e) { return (Buffer.isBuffer(b)) ? b.toString('utf8',s,e) : ___utf8(b,s,e); };
	__toBuffer = function(bufs) { return (bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0])) ? Buffer.concat(bufs[0]) : ___toBuffer(bufs);};
	bconcat = function(bufs) { return Buffer.isBuffer(bufs[0]) ? Buffer.concat(bufs) : [].concat.apply([], bufs); };
	__double = function double_(b, i) { if(Buffer.isBuffer(b)) return b.readDoubleLE(i); return ___double(b,i); };
	is_buf = function is_buf_b(a) { return Buffer.isBuffer(a) || Array.isArray(a); };
}

/* from js-xls */
if(typeof cptable !== 'undefined') {
	__utf16le = function(b,s,e) { return cptable.utils.decode(1200, b.slice(s,e)).replace(chr0, ''); };
	__utf8 = function(b,s,e) { return cptable.utils.decode(65001, b.slice(s,e)); };
	__lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(current_ansi, b.slice(i+4, i+4+len-1)) : "";};
	__cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(current_codepage, b.slice(i+4, i+4+len-1)) : "";};
	__lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(1200, b.slice(i+4,i+4+len-1)) : "";};
	__lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(1200, b.slice(i+4,i+4+len)) : "";};
	__8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(65001, b.slice(i+4,i+4+len)) : "";};
}

var __readUInt8 = function(b, idx) { return b[idx]; };
var __readUInt16LE = function(b, idx) { return (b[idx+1]*(1<<8))+b[idx]; };
var __readInt16LE = function(b, idx) { var u = (b[idx+1]*(1<<8))+b[idx]; return (u < 0x8000) ? u : ((0xffff - u + 1) * -1); };
var __readUInt32LE = function(b, idx) { return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx]; };
var __readInt32LE = function(b, idx) { return (b[idx+3]<<24)|(b[idx+2]<<16)|(b[idx+1]<<8)|b[idx]; };
var __readInt32BE = function(b, idx) { return (b[idx]<<24)|(b[idx+1]<<16)|(b[idx+2]<<8)|b[idx+3]; };

function ReadShift(size, t) {
	var o="", oI, oR, oo=[], w, vv, i, loc;
	switch(t) {
		case 'dbcs':
			loc = this.l;
			if(has_buf && Buffer.isBuffer(this)) o = this.slice(this.l, this.l+2*size).toString("utf16le");
			else for(i = 0; i < size; ++i) { o+=String.fromCharCode(__readUInt16LE(this, loc)); loc+=2; }
			size *= 2;
			break;

		case 'utf8': o = __utf8(this, this.l, this.l + size); break;
		case 'utf16le': size *= 2; o = __utf16le(this, this.l, this.l + size); break;

		case 'wstr':
			if(typeof cptable !== 'undefined') o = cptable.utils.decode(current_codepage, this.slice(this.l, this.l+2*size));
			else return ReadShift.call(this, size, 'dbcs');
			size = 2 * size; break;

		/* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */
		case 'lpstr-ansi': o = __lpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
		case 'lpstr-cp': o = __cpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
		/* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */
		case 'lpwstr': o = __lpwstr(this, this.l); size = 4 + 2 * __readUInt32LE(this, this.l); break;
		/* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */
		case 'lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __lpp4(this, this.l); if(size & 0x02) size += 2; break;
		/* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */
		case '8lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __8lpp4(this, this.l); if(size & 0x03) size += 4 - (size & 0x03); break;

		case 'cstr': size = 0; o = "";
			while((w=__readUInt8(this, this.l + size++))!==0) oo.push(_getchar(w));
			o = oo.join(""); break;
		case '_wstr': size = 0; o = "";
			while((w=__readUInt16LE(this,this.l +size))!==0){oo.push(_getchar(w));size+=2;}
			size+=2; o = oo.join(""); break;

		/* sbcs and dbcs support continue records in the SST way TODO codepages */
		case 'dbcs-cont': o = ""; loc = this.l;
			for(i = 0; i < size; ++i) {
				if(this.lens && this.lens.indexOf(loc) !== -1) {
					w = __readUInt8(this, loc);
					this.l = loc + 1;
					vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
					return oo.join("") + vv;
				}
				oo.push(_getchar(__readUInt16LE(this, loc)));
				loc+=2;
			} o = oo.join(""); size *= 2; break;

		case 'cpstr':
			if(typeof cptable !== 'undefined') {
				o = cptable.utils.decode(current_codepage, this.slice(this.l, this.l + size));
				break;
			}
		/* falls through */
		case 'sbcs-cont': o = ""; loc = this.l;
			for(i = 0; i != size; ++i) {
				if(this.lens && this.lens.indexOf(loc) !== -1) {
					w = __readUInt8(this, loc);
					this.l = loc + 1;
					vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
					return oo.join("") + vv;
				}
				oo.push(_getchar(__readUInt8(this, loc)));
				loc+=1;
			} o = oo.join(""); break;

		default:
	switch(size) {
		case 1: oI = __readUInt8(this, this.l); this.l++; return oI;
		case 2: oI = (t === 'i' ? __readInt16LE : __readUInt16LE)(this, this.l); this.l += 2; return oI;
		case 4: case -4:
			if(t === 'i' || ((this[this.l+3] & 0x80)===0)) { oI = ((size > 0) ? __readInt32LE : __readInt32BE)(this, this.l); this.l += 4; return oI; }
			else { oR = __readUInt32LE(this, this.l); this.l += 4; } return oR;
		case 8: case -8:
			if(t === 'f') {
				if(size == 8) oR = __double(this, this.l);
				else oR = __double([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]], 0);
				this.l += 8; return oR;
			} else size = 8;
		/* falls through */
		case 16: o = __hexlify(this, this.l, size); break;
	}}
	this.l+=size; return o;
}

var __writeUInt32LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); b[idx+2] = ((val >>> 16) & 0xFF); b[idx+3] = ((val >>> 24) & 0xFF); };
var __writeInt32LE  = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >> 8) & 0xFF); b[idx+2] = ((val >> 16) & 0xFF); b[idx+3] = ((val >> 24) & 0xFF); };
var __writeUInt16LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); };

function WriteShift(t, val, f) {
	var size = 0, i = 0;
	if(f === 'dbcs') {
for(i = 0; i != val.length; ++i) __writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
		size = 2 * val.length;
	} else if(f === 'sbcs') {
		/* TODO: codepage */
val = val.replace(/[^\x00-\x7F]/g, "_");
for(i = 0; i != val.length; ++i) this[this.l + i] = (val.charCodeAt(i) & 0xFF);
		size = val.length;
	} else if(f === 'hex') {
		for(; i < t; ++i) {
this[this.l++] = (parseInt(val.slice(2*i, 2*i+2), 16)||0);
		} return this;
	} else if(f === 'utf16le') {
var end = Math.min(this.l + t, this.length);
			for(i = 0; i < Math.min(val.length, t); ++i) {
				var cc = val.charCodeAt(i);
				this[this.l++] = (cc & 0xff);
				this[this.l++] = (cc >> 8);
			}
			while(this.l < end) this[this.l++] = 0;
			return this;
	} else  switch(t) {
		case  1: size = 1; this[this.l] = val&0xFF; break;
		case  2: size = 2; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; break;
		case  3: size = 3; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; val >>>= 8; this[this.l+2] = val&0xFF; break;
		case  4: size = 4; __writeUInt32LE(this, val, this.l); break;
		case  8: size = 8; if(f === 'f') { write_double_le(this, val, this.l); break; }
		/* falls through */
		case 16: break;
		case -4: size = 4; __writeInt32LE(this, val, this.l); break;
	}
	this.l += size; return this;
}

function CheckField(hexstr, fld) {
	var m = __hexlify(this,this.l,hexstr.length>>1);
	if(m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
	this.l += hexstr.length>>1;
}

function prep_blob(blob, pos) {
	blob.l = pos;
	blob.read_shift = ReadShift;
	blob.chk = CheckField;
	blob.write_shift = WriteShift;
}

function parsenoop(blob, length) { blob.l += length; }

function new_buf(sz) {
	var o = new_raw_buf(sz);
	prep_blob(o, 0);
	return o;
}

/* [MS-XLSB] 2.1.4 Record */
function recordhopper(data, cb, opts) {
	if(!data) return;
	var tmpbyte, cntbyte, length;
	prep_blob(data, data.l || 0);
	var L = data.length, RT = 0, tgt = 0;
	while(data.l < L) {
		RT = data.read_shift(1);
		if(RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F)<<7);
		var R = XLSBRecordEnum[RT] || XLSBRecordEnum[0xFFFF];
		tmpbyte = data.read_shift(1);
		length = tmpbyte & 0x7F;
		for(cntbyte = 1; cntbyte <4 && (tmpbyte & 0x80); ++cntbyte) length += ((tmpbyte = data.read_shift(1)) & 0x7F)<<(7*cntbyte);
		tgt = data.l + length;
		var d = (R.f||parsenoop)(data, length, opts);
		data.l = tgt;
		if(cb(d, R.n, RT)) return;
	}
}

/* control buffer usage for fixed-length buffers */
function buf_array() {
	var bufs = [], blksz = has_buf ? 256 : 2048;
	var newblk = function ba_newblk(sz) {
		var o = (new_buf(sz));
		prep_blob(o, 0);
		return o;
	};

	var curbuf = newblk(blksz);

	var endbuf = function ba_endbuf() {
		if(!curbuf) return;
		if(curbuf.length > curbuf.l) { curbuf = curbuf.slice(0, curbuf.l); curbuf.l = curbuf.length; }
		if(curbuf.length > 0) bufs.push(curbuf);
		curbuf = null;
	};

	var next = function ba_next(sz) {
		if(curbuf && (sz < (curbuf.length - curbuf.l))) return curbuf;
		endbuf();
		return (curbuf = newblk(Math.max(sz+1, blksz)));
	};

	var end = function ba_end() {
		endbuf();
		return __toBuffer([bufs]);
	};

	var push = function ba_push(buf) { endbuf(); curbuf = buf; if(curbuf.l == null) curbuf.l = curbuf.length; next(blksz); };

	return ({ next:next, push:push, end:end, _bufs:bufs });
}

function write_record(ba, type, payload, length) {
	var t = +XLSBRE[type], l;
	if(isNaN(t)) return; // TODO: throw something here?
	if(!length) length = XLSBRecordEnum[t].p || (payload||[]).length || 0;
	l = 1 + (t >= 0x80 ? 1 : 0) + 1/* + length*/;
	if(length >= 0x80) ++l; if(length >= 0x4000) ++l; if(length >= 0x200000) ++l;
	var o = ba.next(l);
	if(t <= 0x7F) o.write_shift(1, t);
	else {
		o.write_shift(1, (t & 0x7F) + 0x80);
		o.write_shift(1, (t >> 7));
	}
	for(var i = 0; i != 4; ++i) {
		if(length >= 0x80) { o.write_shift(1, (length & 0x7F)+0x80); length >>= 7; }
		else { o.write_shift(1, length); break; }
	}
	if(length > 0 && is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */
function shift_cell_xls(cell, tgt, opts) {
	var out = dup(cell);
	if(tgt.s) {
		if(out.cRel) out.c += tgt.s.c;
		if(out.rRel) out.r += tgt.s.r;
	} else {
		if(out.cRel) out.c += tgt.c;
		if(out.rRel) out.r += tgt.r;
	}
	if(!opts || opts.biff < 12) {
		while(out.c >= 0x100) out.c -= 0x100;
		while(out.r >= 0x10000) out.r -= 0x10000;
	}
	return out;
}

function shift_range_xls(cell, range, opts) {
	var out = dup(cell);
	out.s = shift_cell_xls(out.s, range.s, opts);
	out.e = shift_cell_xls(out.e, range.s, opts);
	return out;
}

function encode_cell_xls(c, biff) {
	if(c.cRel && c.c < 0) { c = dup(c); c.c += (biff > 8) ? 0x4000 : 0x100; }
	if(c.rRel && c.r < 0) { c = dup(c); c.r += (biff > 8) ? 0x100000 : ((biff > 5) ? 0x10000 : 0x4000); }
	var s = encode_cell(c);
	if(c.cRel === 0) s = fix_col(s);
	if(c.rRel === 0) s = fix_row(s);
	return s;
}

function encode_range_xls(r, opts) {
	if(r.s.r == 0 && !r.s.rRel) {
		if(r.e.r == (opts.biff >= 12 ? 0xFFFFF : (opts.biff >= 8 ? 0x10000 : 0x4000)) && !r.e.rRel) {
			return (r.s.cRel ? "" : "$") + encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + encode_col(r.e.c);
		}
	}
	if(r.s.c == 0 && !r.s.cRel) {
		if(r.e.c == (opts.biff >= 12 ? 0xFFFF : 0xFF) && !r.e.cRel) {
			return (r.s.rRel ? "" : "$") + encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + encode_row(r.e.r);
		}
	}
	return encode_cell_xls(r.s, opts.biff) + ":" + encode_cell_xls(r.e, opts.biff);
}
var OFFCRYPTO = {};

var make_offcrypto = function(O, _crypto) {
	var crypto;
	if(typeof _crypto !== 'undefined') crypto = _crypto;
	else if(true) {
		try { crypto = __webpack_require__(1090); }
		catch(e) { crypto = null; }
	}

	O.rc4 = function(key, data) {
		var S = new Array(256);
		var c = 0, i = 0, j = 0, t = 0;
		for(i = 0; i != 256; ++i) S[i] = i;
		for(i = 0; i != 256; ++i) {
			j = (j + S[i] + (key[i%key.length]).charCodeAt(0))&255;
			t = S[i]; S[i] = S[j]; S[j] = t;
		}
		// $FlowIgnore
		i = j = 0; var out = Buffer(data.length);
		for(c = 0; c != data.length; ++c) {
			i = (i + 1)&255;
			j = (j + S[i])%256;
			t = S[i]; S[i] = S[j]; S[j] = t;
			out[c] = (data[c] ^ S[(S[i]+S[j])&255]);
		}
		return out;
	};

	O.md5 = function(hex) {
		if(!crypto) throw new Error("Unsupported crypto");
		return crypto.createHash('md5').update(hex).digest('hex');
	};
};
/*global crypto:true */
make_offcrypto(OFFCRYPTO, typeof crypto !== "undefined" ? crypto : undefined);

function decode_row(rowstr) { return parseInt(unfix_row(rowstr),10) - 1; }
function encode_row(row) { return "" + (row + 1); }
function fix_row(cstr) { return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2"); }
function unfix_row(cstr) { return cstr.replace(/\$(\d+)$/,"$1"); }

function decode_col(colstr) { var c = unfix_col(colstr), d = 0, i = 0; for(; i !== c.length; ++i) d = 26*d + c.charCodeAt(i) - 64; return d - 1; }
function encode_col(col) { var s=""; for(++col; col; col=Math.floor((col-1)/26)) s = String.fromCharCode(((col-1)%26) + 65) + s; return s; }
function fix_col(cstr) { return cstr.replace(/^([A-Z])/,"$$$1"); }
function unfix_col(cstr) { return cstr.replace(/^\$([A-Z])/,"$1"); }

function split_cell(cstr) { return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(","); }
function decode_cell(cstr) { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
function encode_cell(cell) { return encode_col(cell.c) + encode_row(cell.r); }
function decode_range(range) { var x =range.split(":").map(decode_cell); return {s:x[0],e:x[x.length-1]}; }
function encode_range(cs,ce) {
	if(typeof ce === 'undefined' || typeof ce === 'number') {
return encode_range(cs.s, cs.e);
	}
if(typeof cs !== 'string') cs = encode_cell((cs));
	if(typeof ce !== 'string') ce = encode_cell((ce));
return cs == ce ? cs : cs + ":" + ce;
}

function safe_decode_range(range) {
	var o = {s:{c:0,r:0},e:{c:0,r:0}};
	var idx = 0, i = 0, cc = 0;
	var len = range.length;
	for(idx = 0; i < len; ++i) {
		if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
		idx = 26*idx + cc;
	}
	o.s.c = --idx;

	for(idx = 0; i < len; ++i) {
		if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
		idx = 10*idx + cc;
	}
	o.s.r = --idx;

	if(i === len || range.charCodeAt(++i) === 58) { o.e.c=o.s.c; o.e.r=o.s.r; return o; }

	for(idx = 0; i != len; ++i) {
		if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
		idx = 26*idx + cc;
	}
	o.e.c = --idx;

	for(idx = 0; i != len; ++i) {
		if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
		idx = 10*idx + cc;
	}
	o.e.r = --idx;
	return o;
}

function safe_format_cell(cell, v) {
	var q = (cell.t == 'd' && v instanceof Date);
	if(cell.z != null) try { return (cell.w = SSF.format(cell.z, q ? datenum(v) : v)); } catch(e) { }
	try { return (cell.w = SSF.format((cell.XF||{}).numFmtId||(q ? 14 : 0),  q ? datenum(v) : v)); } catch(e) { return ''+v; }
}

function format_cell(cell, v, o) {
	if(cell == null || cell.t == null || cell.t == 'z') return "";
	if(cell.w !== undefined) return cell.w;
	if(cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
	if(v == undefined) return safe_format_cell(cell, cell.v);
	return safe_format_cell(cell, v);
}

function sheet_to_workbook(sheet, opts) {
	var n = opts && opts.sheet ? opts.sheet : "Sheet1";
	var sheets = {}; sheets[n] = sheet;
	return { SheetNames: [n], Sheets: sheets };
}

function sheet_add_aoa(_ws, data, opts) {
	var o = opts || {};
	var dense = _ws ? Array.isArray(_ws) : o.dense;
	if(DENSE != null && dense == null) dense = DENSE;
	var ws = _ws || (dense ? ([]) : ({}));
	var _R = 0, _C = 0;
	if(ws && o.origin != null) {
		if(typeof o.origin == 'number') _R = o.origin;
		else {
			var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
			_R = _origin.r; _C = _origin.c;
		}
	}
	var range = ({s: {c:10000000, r:10000000}, e: {c:0, r:0}});
	if(ws['!ref']) {
		var _range = safe_decode_range(ws['!ref']);
		range.s.c = _range.s.c;
		range.s.r = _range.s.r;
		range.e.c = Math.max(range.e.c, _range.e.c);
		range.e.r = Math.max(range.e.r, _range.e.r);
		if(_R == -1) range.e.r = _R = _range.e.r + 1;
	}
	for(var R = 0; R != data.length; ++R) {
		if(!data[R]) continue;
		if(!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
		for(var C = 0; C != data[R].length; ++C) {
			if(typeof data[R][C] === 'undefined') continue;
			var cell = ({v: data[R][C] });
			if(Array.isArray(cell.v)) { cell.f = data[R][C][1]; cell.v = cell.v[0]; }
			var __R = _R + R, __C = _C + C;
			if(range.s.r > __R) range.s.r = __R;
			if(range.s.c > __C) range.s.c = __C;
			if(range.e.r < __R) range.e.r = __R;
			if(range.e.c < __C) range.e.c = __C;
			if(cell.v === null) { if(cell.f) cell.t = 'n'; else if(!o.cellStubs) continue; else cell.t = 'z'; }
			else if(typeof cell.v === 'number') cell.t = 'n';
			else if(typeof cell.v === 'boolean') cell.t = 'b';
			else if(cell.v instanceof Date) {
				cell.z = o.dateNF || SSF._table[14];
				if(o.cellDates) { cell.t = 'd'; cell.w = SSF.format(cell.z, datenum(cell.v)); }
				else { cell.t = 'n'; cell.v = datenum(cell.v); cell.w = SSF.format(cell.z, cell.v); }
			}
			else cell.t = 's';
			if(dense) {
				if(!ws[__R]) ws[__R] = [];
				ws[__R][__C] = cell;
			} else {
				var cell_ref = encode_cell(({c:__C,r:__R}));
				ws[cell_ref] = cell;
			}
		}
	}
	if(range.s.c < 10000000) ws['!ref'] = encode_range(range);
	return ws;
}
function aoa_to_sheet(data, opts) { return sheet_add_aoa(null, data, opts); }

function write_UInt32LE(x, o) {
	if(!o) o = new_buf(4);
	o.write_shift(4, x);
	return o;
}

/* [MS-XLSB] 2.5.168 */
function parse_XLWideString(data) {
	var cchCharacters = data.read_shift(4);
	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function write_XLWideString(data, o) {
	var _null = false; if(o == null) { _null = true; o = new_buf(4+2*data.length); }
	o.write_shift(4, data.length);
	if(data.length > 0) o.write_shift(0, data, 'dbcs');
	return _null ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.5.143 */
function parse_StrRun(data) {
	return { ich: data.read_shift(2), ifnt: data.read_shift(2) };
}
function write_StrRun(run, o) {
	if(!o) o = new_buf(4);
	o.write_shift(2, run.ich || 0);
	o.write_shift(2, run.ifnt || 0);
	return o;
}

/* [MS-XLSB] 2.5.121 */
function parse_RichStr(data, length) {
	var start = data.l;
	var flags = data.read_shift(1);
	var str = parse_XLWideString(data);
	var rgsStrRun = [];
	var z = ({ t: str, h: str });
	if((flags & 1) !== 0) { /* fRichStr */
		/* TODO: formatted string */
		var dwSizeStrRun = data.read_shift(4);
		for(var i = 0; i != dwSizeStrRun; ++i) rgsStrRun.push(parse_StrRun(data));
		z.r = rgsStrRun;
	}
	else z.r = [{ich:0, ifnt:0}];
	//if((flags & 2) !== 0) { /* fExtStr */
	//	/* TODO: phonetic string */
	//}
	data.l = start + length;
	return z;
}
function write_RichStr(str, o) {
	/* TODO: formatted string */
	var _null = false; if(o == null) { _null = true; o = new_buf(15+4*str.t.length); }
	o.write_shift(1,0);
	write_XLWideString(str.t, o);
	return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */
var parse_BrtCommentText = parse_RichStr;
function write_BrtCommentText(str, o) {
	/* TODO: formatted string */
	var _null = false; if(o == null) { _null = true; o = new_buf(23+4*str.t.length); }
	o.write_shift(1,1);
	write_XLWideString(str.t, o);
	o.write_shift(4,1);
	write_StrRun({ich:0,ifnt:0}, o);
	return _null ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.5.9 */
function parse_XLSBCell(data) {
	var col = data.read_shift(4);
	var iStyleRef = data.read_shift(2);
	iStyleRef += data.read_shift(1) <<16;
	data.l++; //var fPhShow = data.read_shift(1);
	return { c:col, iStyleRef: iStyleRef };
}
function write_XLSBCell(cell, o) {
	if(o == null) o = new_buf(8);
	o.write_shift(-4, cell.c);
	o.write_shift(3, cell.iStyleRef || cell.s);
	o.write_shift(1, 0); /* fPhShow */
	return o;
}


/* [MS-XLSB] 2.5.21 */
var parse_XLSBCodeName = parse_XLWideString;
var write_XLSBCodeName = write_XLWideString;

/* [MS-XLSB] 2.5.166 */
function parse_XLNullableWideString(data) {
	var cchCharacters = data.read_shift(4);
	return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function write_XLNullableWideString(data, o) {
	var _null = false; if(o == null) { _null = true; o = new_buf(127); }
	o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
	if(data.length > 0) o.write_shift(0, data, 'dbcs');
	return _null ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.5.165 */
var parse_XLNameWideString = parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;

/* [MS-XLSB] 2.5.114 */
var parse_RelID = parse_XLNullableWideString;
var write_RelID = write_XLNullableWideString;


/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */
function parse_RkNumber(data) {
	var b = data.slice(data.l, data.l+4);
	var fX100 = (b[0] & 1), fInt = (b[0] & 2);
	data.l+=4;
	b[0] &= 0xFC; // b[0] &= ~3;
	var RK = fInt === 0 ? __double([0,0,0,0,b[0],b[1],b[2],b[3]],0) : __readInt32LE(b,0)>>2;
	return fX100 ? (RK/100) : RK;
}
function write_RkNumber(data, o) {
	if(o == null) o = new_buf(4);
	var fX100 = 0, fInt = 0, d100 = data * 100;
	if((data == (data | 0)) && (data >= -(1<<29)) && (data < (1 << 29))) { fInt = 1; }
	else if((d100 == (d100 | 0)) && (d100 >= -(1<<29)) && (d100 < (1 << 29))) { fInt = 1; fX100 = 1; }
	if(fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
	else throw new Error("unsupported RkNumber " + data); // TODO
}


/* [MS-XLSB] 2.5.117 RfX */
function parse_RfX(data ) {
	var cell = ({s: {}, e: {}});
	cell.s.r = data.read_shift(4);
	cell.e.r = data.read_shift(4);
	cell.s.c = data.read_shift(4);
	cell.e.c = data.read_shift(4);
	return cell;
}
function write_RfX(r, o) {
	if(!o) o = new_buf(16);
	o.write_shift(4, r.s.r);
	o.write_shift(4, r.e.r);
	o.write_shift(4, r.s.c);
	o.write_shift(4, r.e.c);
	return o;
}

/* [MS-XLSB] 2.5.153 UncheckedRfX */
var parse_UncheckedRfX = parse_RfX;
var write_UncheckedRfX = write_RfX;

/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */
/* TODO: error checking, NaN and Infinity values are not valid Xnum */
function parse_Xnum(data) { return data.read_shift(8, 'f'); }
function write_Xnum(data, o) { return (o || new_buf(8)).write_shift(8, data, 'f'); }

/* [MS-XLSB] 2.5.97.2 */
var BErr = {
0x00: "#NULL!",
0x07: "#DIV/0!",
0x0F: "#VALUE!",
0x17: "#REF!",
0x1D: "#NAME?",
0x24: "#NUM!",
0x2A: "#N/A",
0x2B: "#GETTING_DATA",
0xFF: "#WTF?"
};
var RBErr = evert_num(BErr);

/* [MS-XLSB] 2.4.324 BrtColor */
function parse_BrtColor(data) {
	var out = {};
	var d = data.read_shift(1);

	//var fValidRGB = d & 1;
	var xColorType = d >>> 1;

	var index = data.read_shift(1);
	var nTS = data.read_shift(2, 'i');
	var bR = data.read_shift(1);
	var bG = data.read_shift(1);
	var bB = data.read_shift(1);
	data.l++; //var bAlpha = data.read_shift(1);

	switch(xColorType) {
		case 0: out.auto = 1; break;
		case 1:
			out.index = index;
			var icv = XLSIcv[index];
			/* automatic pseudo index 81 */
			if(icv) out.rgb = rgb2Hex(icv);
			break;
		case 2:
			/* if(!fValidRGB) throw new Error("invalid"); */
			out.rgb = rgb2Hex([bR, bG, bB]);
			break;
		case 3: out.theme = index; break;
	}
	if(nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;

	return out;
}
function write_BrtColor(color, o) {
	if(!o) o = new_buf(8);
	if(!color||color.auto) { o.write_shift(4, 0); o.write_shift(4, 0); return o; }
	if(color.index) {
		o.write_shift(1, 0x02);
		o.write_shift(1, color.index);
	} else if(color.theme) {
		o.write_shift(1, 0x06);
		o.write_shift(1, color.theme);
	} else {
		o.write_shift(1, 0x05);
		o.write_shift(1, 0);
	}
	var nTS = color.tint || 0;
	if(nTS > 0) nTS *= 32767;
	else if(nTS < 0) nTS *= 32768;
	o.write_shift(2, nTS);
	if(!color.rgb) {
		o.write_shift(2, 0);
		o.write_shift(1, 0);
		o.write_shift(1, 0);
	} else {
		var rgb = (color.rgb || 'FFFFFF');
		o.write_shift(1, parseInt(rgb.slice(0,2),16));
		o.write_shift(1, parseInt(rgb.slice(2,4),16));
		o.write_shift(1, parseInt(rgb.slice(4,6),16));
		o.write_shift(1, 0xFF);
	}
	return o;
}

/* [MS-XLSB] 2.5.52 */
function parse_FontFlags(data) {
	var d = data.read_shift(1);
	data.l++;
	var out = {
		/* fBold: d & 0x01 */
		fItalic: d & 0x02,
		/* fUnderline: d & 0x04 */
		fStrikeout: d & 0x08,
		fOutline: d & 0x10,
		fShadow: d & 0x20,
		fCondense: d & 0x40,
		fExtend: d & 0x80
	};
	return out;
}
function write_FontFlags(font, o) {
	if(!o) o = new_buf(2);
	var grbit =
		(font.italic   ? 0x02 : 0) |
		(font.strike   ? 0x08 : 0) |
		(font.outline  ? 0x10 : 0) |
		(font.shadow   ? 0x20 : 0) |
		(font.condense ? 0x40 : 0) |
		(font.extend   ? 0x80 : 0);
	o.write_shift(1, grbit);
	o.write_shift(1, 0);
	return o;
}

/* [MS-OLEDS] 2.3.1 and 2.3.2 */
function parse_ClipboardFormatOrString(o, w) {
	// $FlowIgnore
	var ClipFmt = {2:"BITMAP",3:"METAFILEPICT",8:"DIB",14:"ENHMETAFILE"};
	var m = o.read_shift(4);
	switch(m) {
		case 0x00000000: return "";
		case 0xffffffff: case 0xfffffffe: return ClipFmt[o.read_shift(4)]||"";
	}
	if(m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
	o.l -= 4;
	return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function parse_ClipboardFormatOrAnsiString(o) { return parse_ClipboardFormatOrString(o, 1); }
function parse_ClipboardFormatOrUnicodeString(o) { return parse_ClipboardFormatOrString(o, 2); }

/* [MS-OLEPS] 2.2 PropertyType */
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var VT_I2       = 0x0002;
var VT_I4       = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var VT_BOOL     = 0x000B;
var VT_VARIANT  = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var VT_UI4      = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
var VT_LPSTR    = 0x001E;
//var VT_LPWSTR   = 0x001F;
var VT_FILETIME = 0x0040;
var VT_BLOB     = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var VT_CF       = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
var VT_VECTOR   = 0x1000;
//var VT_ARRAY    = 0x2000;

var VT_STRING   = 0x0050; // 2.3.3.1.11 VtString
var VT_USTR     = 0x0051; // 2.3.3.1.12 VtUnalignedString
var VT_CUSTOM   = [VT_STRING, VT_USTR];

/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */
var DocSummaryPIDDSI = {
0x01: { n: 'CodePage', t: VT_I2 },
0x02: { n: 'Category', t: VT_STRING },
0x03: { n: 'PresentationFormat', t: VT_STRING },
0x04: { n: 'ByteCount', t: VT_I4 },
0x05: { n: 'LineCount', t: VT_I4 },
0x06: { n: 'ParagraphCount', t: VT_I4 },
0x07: { n: 'SlideCount', t: VT_I4 },
0x08: { n: 'NoteCount', t: VT_I4 },
0x09: { n: 'HiddenCount', t: VT_I4 },
0x0a: { n: 'MultimediaClipCount', t: VT_I4 },
0x0b: { n: 'ScaleCrop', t: VT_BOOL },
0x0c: { n: 'HeadingPairs', t: VT_VECTOR | VT_VARIANT },
0x0d: { n: 'TitlesOfParts', t: VT_VECTOR | VT_LPSTR },
0x0e: { n: 'Manager', t: VT_STRING },
0x0f: { n: 'Company', t: VT_STRING },
0x10: { n: 'LinksUpToDate', t: VT_BOOL },
0x11: { n: 'CharacterCount', t: VT_I4 },
0x13: { n: 'SharedDoc', t: VT_BOOL },
0x16: { n: 'HyperlinksChanged', t: VT_BOOL },
0x17: { n: 'AppVersion', t: VT_I4, p: 'version' },
0x18: { n: 'DigSig', t: VT_BLOB },
0x1A: { n: 'ContentType', t: VT_STRING },
0x1B: { n: 'ContentStatus', t: VT_STRING },
0x1C: { n: 'Language', t: VT_STRING },
0x1D: { n: 'Version', t: VT_STRING },
0xFF: {}
};

/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */
var SummaryPIDSI = {
0x01: { n: 'CodePage', t: VT_I2 },
0x02: { n: 'Title', t: VT_STRING },
0x03: { n: 'Subject', t: VT_STRING },
0x04: { n: 'Author', t: VT_STRING },
0x05: { n: 'Keywords', t: VT_STRING },
0x06: { n: 'Comments', t: VT_STRING },
0x07: { n: 'Template', t: VT_STRING },
0x08: { n: 'LastAuthor', t: VT_STRING },
0x09: { n: 'RevNumber', t: VT_STRING },
0x0A: { n: 'EditTime', t: VT_FILETIME },
0x0B: { n: 'LastPrinted', t: VT_FILETIME },
0x0C: { n: 'CreatedDate', t: VT_FILETIME },
0x0D: { n: 'ModifiedDate', t: VT_FILETIME },
0x0E: { n: 'PageCount', t: VT_I4 },
0x0F: { n: 'WordCount', t: VT_I4 },
0x10: { n: 'CharCount', t: VT_I4 },
0x11: { n: 'Thumbnail', t: VT_CF },
0x12: { n: 'Application', t: VT_STRING },
0x13: { n: 'DocSecurity', t: VT_I4 },
0xFF: {}
};

/* [MS-OLEPS] 2.18 */
var SpecialProperties = {
0x80000000: { n: 'Locale', t: VT_UI4 },
0x80000003: { n: 'Behavior', t: VT_UI4 },
0x72627262: {}
};

(function() {
	for(var y in SpecialProperties) if(SpecialProperties.hasOwnProperty(y))
	DocSummaryPIDDSI[y] = SummaryPIDSI[y] = SpecialProperties[y];
})();

var DocSummaryRE = evert_key(DocSummaryPIDDSI, "n");
var SummaryRE = evert_key(SummaryPIDSI, "n");

/* [MS-XLS] 2.4.63 Country/Region codes */
var CountryEnum = {
0x0001: "US", // United States
0x0002: "CA", // Canada
0x0003: "", // Latin America (except Brazil)
0x0007: "RU", // Russia
0x0014: "EG", // Egypt
0x001E: "GR", // Greece
0x001F: "NL", // Netherlands
0x0020: "BE", // Belgium
0x0021: "FR", // France
0x0022: "ES", // Spain
0x0024: "HU", // Hungary
0x0027: "IT", // Italy
0x0029: "CH", // Switzerland
0x002B: "AT", // Austria
0x002C: "GB", // United Kingdom
0x002D: "DK", // Denmark
0x002E: "SE", // Sweden
0x002F: "NO", // Norway
0x0030: "PL", // Poland
0x0031: "DE", // Germany
0x0034: "MX", // Mexico
0x0037: "BR", // Brazil
0x003d: "AU", // Australia
0x0040: "NZ", // New Zealand
0x0042: "TH", // Thailand
0x0051: "JP", // Japan
0x0052: "KR", // Korea
0x0054: "VN", // Viet Nam
0x0056: "CN", // China
0x005A: "TR", // Turkey
0x0069: "JS", // Ramastan
0x00D5: "DZ", // Algeria
0x00D8: "MA", // Morocco
0x00DA: "LY", // Libya
0x015F: "PT", // Portugal
0x0162: "IS", // Iceland
0x0166: "FI", // Finland
0x01A4: "CZ", // Czech Republic
0x0376: "TW", // Taiwan
0x03C1: "LB", // Lebanon
0x03C2: "JO", // Jordan
0x03C3: "SY", // Syria
0x03C4: "IQ", // Iraq
0x03C5: "KW", // Kuwait
0x03C6: "SA", // Saudi Arabia
0x03CB: "AE", // United Arab Emirates
0x03CC: "IL", // Israel
0x03CE: "QA", // Qatar
0x03D5: "IR", // Iran
0xFFFF: "US"  // United States
};

/* [MS-XLS] 2.5.127 */
var XLSFillPattern = [
	null,
	'solid',
	'mediumGray',
	'darkGray',
	'lightGray',
	'darkHorizontal',
	'darkVertical',
	'darkDown',
	'darkUp',
	'darkGrid',
	'darkTrellis',
	'lightHorizontal',
	'lightVertical',
	'lightDown',
	'lightUp',
	'lightGrid',
	'lightTrellis',
	'gray125',
	'gray0625'
];

function rgbify(arr) { return arr.map(function(x) { return [(x>>16)&255,(x>>8)&255,x&255]; }); }

/* [MS-XLS] 2.5.161 */
/* [MS-XLSB] 2.5.75 Icv */
var XLSIcv = rgbify([
	/* Color Constants */
	0x000000,
	0xFFFFFF,
	0xFF0000,
	0x00FF00,
	0x0000FF,
	0xFFFF00,
	0xFF00FF,
	0x00FFFF,

	/* Overridable Defaults */
	0x000000,
	0xFFFFFF,
	0xFF0000,
	0x00FF00,
	0x0000FF,
	0xFFFF00,
	0xFF00FF,
	0x00FFFF,

	0x800000,
	0x008000,
	0x000080,
	0x808000,
	0x800080,
	0x008080,
	0xC0C0C0,
	0x808080,
	0x9999FF,
	0x993366,
	0xFFFFCC,
	0xCCFFFF,
	0x660066,
	0xFF8080,
	0x0066CC,
	0xCCCCFF,

	0x000080,
	0xFF00FF,
	0xFFFF00,
	0x00FFFF,
	0x800080,
	0x800000,
	0x008080,
	0x0000FF,
	0x00CCFF,
	0xCCFFFF,
	0xCCFFCC,
	0xFFFF99,
	0x99CCFF,
	0xFF99CC,
	0xCC99FF,
	0xFFCC99,

	0x3366FF,
	0x33CCCC,
	0x99CC00,
	0xFFCC00,
	0xFF9900,
	0xFF6600,
	0x666699,
	0x969696,
	0x003366,
	0x339966,
	0x003300,
	0x333300,
	0x993300,
	0x993366,
	0x333399,
	0x333333,

	/* Other entries to appease BIFF8/12 */
	0xFFFFFF, /* 0x40 icvForeground ?? */
	0x000000, /* 0x41 icvBackground ?? */
	0x000000, /* 0x42 icvFrame ?? */
	0x000000, /* 0x43 icv3D ?? */
	0x000000, /* 0x44 icv3DText ?? */
	0x000000, /* 0x45 icv3DHilite ?? */
	0x000000, /* 0x46 icv3DShadow ?? */
	0x000000, /* 0x47 icvHilite ?? */
	0x000000, /* 0x48 icvCtlText ?? */
	0x000000, /* 0x49 icvCtlScrl ?? */
	0x000000, /* 0x4A icvCtlInv ?? */
	0x000000, /* 0x4B icvCtlBody ?? */
	0x000000, /* 0x4C icvCtlFrame ?? */
	0x000000, /* 0x4D icvCtlFore ?? */
	0x000000, /* 0x4E icvCtlBack ?? */
	0x000000, /* 0x4F icvCtlNeutral */
	0x000000, /* 0x50 icvInfoBk ?? */
	0x000000 /* 0x51 icvInfoText ?? */
]);

/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */
/* 12.3 Part Summary <SpreadsheetML> */
/* 14.2 Part Summary <DrawingML> */
/* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */
var ct2type/*{[string]:string}*/ = ({
	/* Workbook */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",

	/* Worksheet */
	"application/vnd.ms-excel.binIndexWs": "TODO", /* Binary Index */

	/* Macrosheet */
	"application/vnd.ms-excel.intlmacrosheet": "TODO",
	"application/vnd.ms-excel.binIndexMs": "TODO", /* Binary Index */

	/* File Properties */
	"application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
	"application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
	"application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",

	/* Custom Data Properties */
	"application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",

	/* PivotTable */
	"application/vnd.ms-excel.pivotTable": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",

	/* Chart Colors */
	"application/vnd.ms-office.chartcolorstyle+xml": "TODO",

	/* Chart Style */
	"application/vnd.ms-office.chartstyle+xml": "TODO",

	/* Calculation Chain */
	"application/vnd.ms-excel.calcChain": "calcchains",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",

	/* Printer Settings */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",

	/* ActiveX */
	"application/vnd.ms-office.activeX": "TODO",
	"application/vnd.ms-office.activeX+xml": "TODO",

	/* Custom Toolbars */
	"application/vnd.ms-excel.attachedToolbars": "TODO",

	/* External Data Connections */
	"application/vnd.ms-excel.connections": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",

	/* External Links */
	"application/vnd.ms-excel.externalLink": "links",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",

	/* Metadata */
	"application/vnd.ms-excel.sheetMetadata": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "TODO",

	/* PivotCache */
	"application/vnd.ms-excel.pivotCacheDefinition": "TODO",
	"application/vnd.ms-excel.pivotCacheRecords": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",

	/* Query Table */
	"application/vnd.ms-excel.queryTable": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",

	/* Shared Workbook */
	"application/vnd.ms-excel.userNames": "TODO",
	"application/vnd.ms-excel.revisionHeaders": "TODO",
	"application/vnd.ms-excel.revisionLog": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",

	/* Single Cell Table */
	"application/vnd.ms-excel.tableSingleCells": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",

	/* Slicer */
	"application/vnd.ms-excel.slicer": "TODO",
	"application/vnd.ms-excel.slicerCache": "TODO",
	"application/vnd.ms-excel.slicer+xml": "TODO",
	"application/vnd.ms-excel.slicerCache+xml": "TODO",

	/* Sort Map */
	"application/vnd.ms-excel.wsSortMap": "TODO",

	/* Table */
	"application/vnd.ms-excel.table": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",

	/* Themes */
	"application/vnd.openxmlformats-officedocument.theme+xml": "themes",

	/* Theme Override */
	"application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",

	/* Timeline */
	"application/vnd.ms-excel.Timeline+xml": "TODO", /* verify */
	"application/vnd.ms-excel.TimelineCache+xml": "TODO", /* verify */

	/* VBA */
	"application/vnd.ms-office.vbaProject": "vba",
	"application/vnd.ms-office.vbaProjectSignature": "vba",

	/* Volatile Dependencies */
	"application/vnd.ms-office.volatileDependencies": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",

	/* Control Properties */
	"application/vnd.ms-excel.controlproperties+xml": "TODO",

	/* Data Model */
	"application/vnd.openxmlformats-officedocument.model+data": "TODO",

	/* Survey */
	"application/vnd.ms-excel.Survey+xml": "TODO",

	/* Drawing */
	"application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
	"application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",

	/* VML */
	"application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",

	"application/vnd.openxmlformats-package.relationships+xml": "rels",
	"application/vnd.openxmlformats-officedocument.oleObject": "TODO",

	/* Image */
	"image/png": "TODO",

	"sheet": "js"
});

var CT_LIST = (function(){
	var o = {
		workbooks: {
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
			xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
			xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
			xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
			xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
		},
		strs: { /* Shared Strings */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
			xlsb: "application/vnd.ms-excel.sharedStrings"
		},
		comments: { /* Comments */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
			xlsb: "application/vnd.ms-excel.comments"
		},
		sheets: { /* Worksheet */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
			xlsb: "application/vnd.ms-excel.worksheet"
		},
		charts: { /* Chartsheet */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
			xlsb: "application/vnd.ms-excel.chartsheet"
		},
		dialogs: { /* Dialogsheet */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
			xlsb: "application/vnd.ms-excel.dialogsheet"
		},
		macros: { /* Macrosheet (Excel 4.0 Macros) */
			xlsx: "application/vnd.ms-excel.macrosheet+xml",
			xlsb: "application/vnd.ms-excel.macrosheet"
		},
		styles: { /* Styles */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
			xlsb: "application/vnd.ms-excel.styles"
		}
	};
	keys(o).forEach(function(k) { ["xlsm", "xlam"].forEach(function(v) { if(!o[k][v]) o[k][v] = o[k].xlsx; }); });
	keys(o).forEach(function(k){ keys(o[k]).forEach(function(v) { ct2type[o[k][v]] = k; }); });
	return o;
})();

var type2ct/*{[string]:Array<string>}*/ = evert_arr(ct2type);

XMLNS.CT = 'http://schemas.openxmlformats.org/package/2006/content-types';

function new_ct() {
	return ({
		workbooks:[], sheets:[], charts:[], dialogs:[], macros:[],
		rels:[], strs:[], comments:[], links:[],
		coreprops:[], extprops:[], custprops:[], themes:[], styles:[],
		calcchains:[], vba: [], drawings: [],
		TODO:[], xmlns: "" });
}

function parse_ct(data) {
	var ct = new_ct();
	if(!data || !data.match) return ct;
	var ctext = {};
	(data.match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0].replace(nsregex,"<")) {
			case '<?xml': break;
			case '<Types': ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/)||["",""])[1] ]; break;
			case '<Default': ctext[y.Extension] = y.ContentType; break;
			case '<Override':
				if(ct[ct2type[y.ContentType]] !== undefined) ct[ct2type[y.ContentType]].push(y.PartName);
				break;
		}
	});
	if(ct.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
	ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
	ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
	ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
	ct.defaults = ctext;
	delete ct.calcchains;
	return ct;
}

var CTYPE_XML_ROOT = writextag('Types', null, {
	'xmlns': XMLNS.CT,
	'xmlns:xsd': XMLNS.xsd,
	'xmlns:xsi': XMLNS.xsi
});

var CTYPE_DEFAULTS = [
	['xml', 'application/xml'],
	['bin', 'application/vnd.ms-excel.sheet.binary.macroEnabled.main'],
	['vml', 'application/vnd.openxmlformats-officedocument.vmlDrawing'],
	/* from test files */
	['bmp', 'image/bmp'],
	['png', 'image/png'],
	['gif', 'image/gif'],
	['emf', 'image/x-emf'],
	['wmf', 'image/x-wmf'],
	['jpg', 'image/jpeg'], ['jpeg', 'image/jpeg'],
	['tif', 'image/tiff'], ['tiff', 'image/tiff'],
	['pdf', 'application/pdf'],
	['rels', type2ct.rels[0]]
].map(function(x) {
	return writextag('Default', null, {'Extension':x[0], 'ContentType': x[1]});
});

function write_ct(ct, opts) {
	var o = [], v;
	o[o.length] = (XML_HEADER);
	o[o.length] = (CTYPE_XML_ROOT);
	o = o.concat(CTYPE_DEFAULTS);
	var f1 = function(w) {
		if(ct[w] && ct[w].length > 0) {
			v = ct[w][0];
			o[o.length] = (writextag('Override', null, {
				'PartName': (v[0] == '/' ? "":"/") + v,
				'ContentType': CT_LIST[w][opts.bookType || 'xlsx']
			}));
		}
	};
	var f2 = function(w) {
		(ct[w]||[]).forEach(function(v) {
			o[o.length] = (writextag('Override', null, {
				'PartName': (v[0] == '/' ? "":"/") + v,
				'ContentType': CT_LIST[w][opts.bookType || 'xlsx']
			}));
		});
	};
	var f3 = function(t) {
		(ct[t]||[]).forEach(function(v) {
			o[o.length] = (writextag('Override', null, {
				'PartName': (v[0] == '/' ? "":"/") + v,
				'ContentType': type2ct[t][0]
			}));
		});
	};
	f1('workbooks');
	f2('sheets');
	f2('charts');
	f3('themes');
	['strs', 'styles'].forEach(f1);
	['coreprops', 'extprops', 'custprops'].forEach(f3);
	f3('vba');
	f3('comments');
	f3('drawings');
	if(o.length>2){ o[o.length] = ('</Types>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* 9.3 Relationships */
var RELS = ({
	WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
	SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
	HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
	VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
	VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
});

/* 9.3.3 Representing Relationships */
function get_rels_path(file) {
	var n = file.lastIndexOf("/");
	return file.slice(0,n+1) + '_rels/' + file.slice(n+1) + ".rels";
}

function parse_rels(data, currentFilePath) {
	if (!data) return data;
	if (currentFilePath.charAt(0) !== '/') {
		currentFilePath = '/'+currentFilePath;
	}
	var rels = {};
	var hash = {};

	(data.match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		/* 9.3.2.2 OPC_Relationships */
		if (y[0] === '<Relationship') {
			var rel = {}; rel.Type = y.Type; rel.Target = y.Target; rel.Id = y.Id; rel.TargetMode = y.TargetMode;
			var canonictarget = y.TargetMode === 'External' ? y.Target : resolve_path(y.Target, currentFilePath);
			rels[canonictarget] = rel;
			hash[y.Id] = rel;
		}
	});
	rels["!id"] = hash;
	return rels;
}

XMLNS.RELS = 'http://schemas.openxmlformats.org/package/2006/relationships';

var RELS_ROOT = writextag('Relationships', null, {
	//'xmlns:ns0': XMLNS.RELS,
	'xmlns': XMLNS.RELS
});

/* TODO */
function write_rels(rels) {
	var o = [XML_HEADER, RELS_ROOT];
	keys(rels['!id']).forEach(function(rid) {
		o[o.length] = (writextag('Relationship', null, rels['!id'][rid]));
	});
	if(o.length>2){ o[o.length] = ('</Relationships>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}

function add_rels(rels, rId, f, type, relobj) {
	if(!relobj) relobj = {};
	if(!rels['!id']) rels['!id'] = {};
	if(rId < 0) for(rId = 1; rels['!id']['rId' + rId]; ++rId){/* empty */}
	relobj.Id = 'rId' + rId;
	relobj.Type = type;
	relobj.Target = f;
	if(relobj.Type == RELS.HLINK) relobj.TargetMode = "External";
	if(rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
	rels['!id'][relobj.Id] = relobj;
	rels[('/' + relobj.Target).replace("//","/")] = relobj;
	return rId;
}
/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */
/* Part 3 Section 4 Manifest File */
var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function parse_manifest(d, opts) {
	var str = xlml_normalize(d);
	var Rn;
	var FEtag;
	while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
		case 'manifest': break; // 4.2 <manifest:manifest>
		case 'file-entry': // 4.3 <manifest:file-entry>
			FEtag = parsexmltag(Rn[0], false);
			if(FEtag.path == '/' && FEtag.type !== CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
			break;
		case 'encryption-data': // 4.4 <manifest:encryption-data>
		case 'algorithm': // 4.5 <manifest:algorithm>
		case 'start-key-generation': // 4.6 <manifest:start-key-generation>
		case 'key-derivation': // 4.7 <manifest:key-derivation>
			throw new Error("Unsupported ODS Encryption");
		default: if(opts && opts.WTF) throw Rn;
	}
}

function write_manifest(manifest) {
	var o = [XML_HEADER];
	o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
	o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
	for(var i = 0; i < manifest.length; ++i) o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
	o.push('</manifest:manifest>');
	return o.join("");
}

/* Part 3 Section 6 Metadata Manifest File */
function write_rdf_type(file, res, tag) {
	return [
		'  <rdf:Description rdf:about="' + file + '">\n',
		'    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + '#' + res + '"/>\n',
		'  </rdf:Description>\n'
	].join("");
}
function write_rdf_has(base, file) {
	return [
		'  <rdf:Description rdf:about="' + base + '">\n',
		'    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
		'  </rdf:Description>\n'
	].join("");
}
function write_rdf(rdf) {
	var o = [XML_HEADER];
	o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
	for(var i = 0; i != rdf.length; ++i) {
		o.push(write_rdf_type(rdf[i][0], rdf[i][1]));
		o.push(write_rdf_has("",rdf[i][0]));
	}
	o.push(write_rdf_type("","Document", "pkg"));
	o.push('</rdf:RDF>');
	return o.join("");
}
/* TODO: pull properties */
var write_meta_ods = (function() {
	var payload = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet' + 'JS ' + XLSX.version + '</meta:generator></office:meta></office:document-meta>';
	return function wmo() {
		return payload;
	};
})();

/* ECMA-376 Part II 11.1 Core Properties Part */
/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
var CORE_PROPS = [
	["cp:category", "Category"],
	["cp:contentStatus", "ContentStatus"],
	["cp:keywords", "Keywords"],
	["cp:lastModifiedBy", "LastAuthor"],
	["cp:lastPrinted", "LastPrinted"],
	["cp:revision", "RevNumber"],
	["cp:version", "Version"],
	["dc:creator", "Author"],
	["dc:description", "Comments"],
	["dc:identifier", "Identifier"],
	["dc:language", "Language"],
	["dc:subject", "Subject"],
	["dc:title", "Title"],
	["dcterms:created", "CreatedDate", 'date'],
	["dcterms:modified", "ModifiedDate", 'date']
];

XMLNS.CORE_PROPS = "http://schemas.openxmlformats.org/package/2006/metadata/core-properties";
RELS.CORE_PROPS  = 'http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties';

var CORE_PROPS_REGEX = (function() {
	var r = new Array(CORE_PROPS.length);
	for(var i = 0; i < CORE_PROPS.length; ++i) {
		var f = CORE_PROPS[i];
		var g = "(?:"+ f[0].slice(0,f[0].indexOf(":")) +":)"+ f[0].slice(f[0].indexOf(":")+1);
		r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)<\/" + g + ">");
	}
	return r;
})();

function parse_core_props(data) {
	var p = {};
	data = utf8read(data);

	for(var i = 0; i < CORE_PROPS.length; ++i) {
		var f = CORE_PROPS[i], cur = data.match(CORE_PROPS_REGEX[i]);
		if(cur != null && cur.length > 0) p[f[1]] = cur[1];
		if(f[2] === 'date' && p[f[1]]) p[f[1]] = parseDate(p[f[1]]);
	}

	return p;
}

var CORE_PROPS_XML_ROOT = writextag('cp:coreProperties', null, {
	//'xmlns': XMLNS.CORE_PROPS,
	'xmlns:cp': XMLNS.CORE_PROPS,
	'xmlns:dc': XMLNS.dc,
	'xmlns:dcterms': XMLNS.dcterms,
	'xmlns:dcmitype': XMLNS.dcmitype,
	'xmlns:xsi': XMLNS.xsi
});

function cp_doit(f, g, h, o, p) {
	if(p[f] != null || g == null || g === "") return;
	p[f] = g;
	o[o.length] = (h ? writextag(f,g,h) : writetag(f,g));
}

function write_core_props(cp, _opts) {
	var opts = _opts || {};
	var o = [XML_HEADER, CORE_PROPS_XML_ROOT], p = {};
	if(!cp && !opts.Props) return o.join("");

	if(cp) {
		if(cp.CreatedDate != null) cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : write_w3cdtf(cp.CreatedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
		if(cp.ModifiedDate != null) cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : write_w3cdtf(cp.ModifiedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
	}

	for(var i = 0; i != CORE_PROPS.length; ++i) {
		var f = CORE_PROPS[i];
		var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
		if(v === true) v = "1";
		else if(v === false) v = "0";
		else if(typeof v == "number") v = String(v);
		if(v != null) cp_doit(f[0], v, null, o, p);
	}
	if(o.length>2){ o[o.length] = ('</cp:coreProperties>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */
/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
var EXT_PROPS = [
	["Application", "Application", "string"],
	["AppVersion", "AppVersion", "string"],
	["Company", "Company", "string"],
	["DocSecurity", "DocSecurity", "string"],
	["Manager", "Manager", "string"],
	["HyperlinksChanged", "HyperlinksChanged", "bool"],
	["SharedDoc", "SharedDoc", "bool"],
	["LinksUpToDate", "LinksUpToDate", "bool"],
	["ScaleCrop", "ScaleCrop", "bool"],
	["HeadingPairs", "HeadingPairs", "raw"],
	["TitlesOfParts", "TitlesOfParts", "raw"]
];

XMLNS.EXT_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";
RELS.EXT_PROPS  = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties';

var PseudoPropsPairs = [
	"Worksheets",  "SheetNames",
	"NamedRanges", "DefinedNames",
	"Chartsheets", "ChartNames"
];
function load_props_pairs(HP, TOP, props, opts) {
	var v = [];
	if(typeof HP == "string") v = parseVector(HP, opts);
	else for(var j = 0; j < HP.length; ++j) v = v.concat(HP[j].map(function(hp) { return {v:hp}; }));
	var parts = (typeof TOP == "string") ? parseVector(TOP, opts).map(function (x) { return x.v; }) : TOP;
	var idx = 0, len = 0;
	if(parts.length > 0) for(var i = 0; i !== v.length; i += 2) {
		len = +(v[i+1].v);
		switch(v[i].v) {
			case "Worksheets":
			case "工作表":
			case "Листы":
			case "أوراق العمل":
			case "ワークシート":
			case "גליונות עבודה":
			case "Arbeitsblätter":
			case "Çalışma Sayfaları":
			case "Feuilles de calcul":
			case "Fogli di lavoro":
			case "Folhas de cálculo":
			case "Planilhas":
			case "Regneark":
			case "Werkbladen":
				props.Worksheets = len;
				props.SheetNames = parts.slice(idx, idx + len);
				break;

			case "Named Ranges":
			case "名前付き一覧":
			case "Benannte Bereiche":
			case "Navngivne områder":
				props.NamedRanges = len;
				props.DefinedNames = parts.slice(idx, idx + len);
				break;

			case "Charts":
			case "Diagramme":
				props.Chartsheets = len;
				props.ChartNames = parts.slice(idx, idx + len);
				break;
		}
		idx += len;
	}
}

function parse_ext_props(data, p, opts) {
	var q = {}; if(!p) p = {};
	data = utf8read(data);

	EXT_PROPS.forEach(function(f) {
		switch(f[2]) {
			case "string": p[f[1]] = (data.match(matchtag(f[0]))||[])[1]; break;
			case "bool": p[f[1]] = (data.match(matchtag(f[0]))||[])[1] === "true"; break;
			case "raw":
				var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)<\/" + f[0] + ">"));
				if(cur && cur.length > 0) q[f[1]] = cur[1];
				break;
		}
	});

	if(q.HeadingPairs && q.TitlesOfParts) load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);

	return p;
}

var EXT_PROPS_XML_ROOT = writextag('Properties', null, {
	'xmlns': XMLNS.EXT_PROPS,
	'xmlns:vt': XMLNS.vt
});

function write_ext_props(cp) {
	var o = [], W = writextag;
	if(!cp) cp = {};
	cp.Application = "SheetJS";
	o[o.length] = (XML_HEADER);
	o[o.length] = (EXT_PROPS_XML_ROOT);

	EXT_PROPS.forEach(function(f) {
		if(cp[f[1]] === undefined) return;
		var v;
		switch(f[2]) {
			case 'string': v = String(cp[f[1]]); break;
			case 'bool': v = cp[f[1]] ? 'true' : 'false'; break;
		}
		if(v !== undefined) o[o.length] = (W(f[0], v));
	});

	/* TODO: HeadingPairs, TitlesOfParts */
	o[o.length] = (W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>')+W('vt:variant', W('vt:i4', String(cp.Worksheets))), {size:2, baseType:"variant"})));
	o[o.length] = (W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) { return "<vt:lpstr>" + escapexml(s) + "</vt:lpstr>"; }).join(""), {size: cp.Worksheets, baseType:"lpstr"})));
	if(o.length>2){ o[o.length] = ('</Properties>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */
XMLNS.CUST_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";
RELS.CUST_PROPS  = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties';

var custregex = /<[^>]+>[^<]*/g;
function parse_cust_props(data, opts) {
	var p = {}, name = "";
	var m = data.match(custregex);
	if(m) for(var i = 0; i != m.length; ++i) {
		var x = m[i], y = parsexmltag(x);
		switch(y[0]) {
			case '<?xml': break;
			case '<Properties': break;
			case '<property': name = y.name; break;
			case '</property>': name = null; break;
			default: if (x.indexOf('<vt:') === 0) {
				var toks = x.split('>');
				var type = toks[0].slice(4), text = toks[1];
				/* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */
				switch(type) {
					case 'lpstr': case 'bstr': case 'lpwstr':
						p[name] = unescapexml(text);
						break;
					case 'bool':
						p[name] = parsexmlbool(text);
						break;
					case 'i1': case 'i2': case 'i4': case 'i8': case 'int': case 'uint':
						p[name] = parseInt(text, 10);
						break;
					case 'r4': case 'r8': case 'decimal':
						p[name] = parseFloat(text);
						break;
					case 'filetime': case 'date':
						p[name] = parseDate(text);
						break;
					case 'cy': case 'error':
						p[name] = unescapexml(text);
						break;
					default:
						if(type.slice(-1) == '/') break;
						if(opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
				}
			} else if(x.slice(0,2) === "</") {/* empty */
			} else if(opts.WTF) throw new Error(x);
		}
	}
	return p;
}

var CUST_PROPS_XML_ROOT = writextag('Properties', null, {
	'xmlns': XMLNS.CUST_PROPS,
	'xmlns:vt': XMLNS.vt
});

function write_cust_props(cp) {
	var o = [XML_HEADER, CUST_PROPS_XML_ROOT];
	if(!cp) return o.join("");
	var pid = 1;
	keys(cp).forEach(function custprop(k) { ++pid;
		o[o.length] = (writextag('property', write_vt(cp[k]), {
			'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
			'pid': pid,
			'name': k
		}));
	});
	if(o.length>2){ o[o.length] = '</Properties>'; o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* Common Name -> XLML Name */
var XLMLDocPropsMap = {
	Title: 'Title',
	Subject: 'Subject',
	Author: 'Author',
	Keywords: 'Keywords',
	Comments: 'Description',
	LastAuthor: 'LastAuthor',
	RevNumber: 'Revision',
	Application: 'AppName',
	/* TotalTime: 'TotalTime', */
	LastPrinted: 'LastPrinted',
	CreatedDate: 'Created',
	ModifiedDate: 'LastSaved',
	/* Pages */
	/* Words */
	/* Characters */
	Category: 'Category',
	/* PresentationFormat */
	Manager: 'Manager',
	Company: 'Company',
	/* Guid */
	/* HyperlinkBase */
	/* Bytes */
	/* Lines */
	/* Paragraphs */
	/* CharactersWithSpaces */
	AppVersion: 'Version',

	ContentStatus: 'ContentStatus', /* NOTE: missing from schema */
	Identifier: 'Identifier', /* NOTE: missing from schema */
	Language: 'Language' /* NOTE: missing from schema */
};
var evert_XLMLDPM = evert(XLMLDocPropsMap);

function xlml_set_prop(Props, tag, val) {
	tag = evert_XLMLDPM[tag] || tag;
	Props[tag] = val;
}

function xlml_write_docprops(Props, opts) {
	var o = [];
	keys(XLMLDocPropsMap).map(function(m) {
		for(var i = 0; i < CORE_PROPS.length; ++i) if(CORE_PROPS[i][1] == m) return CORE_PROPS[i];
		for(i = 0; i < EXT_PROPS.length; ++i) if(EXT_PROPS[i][1] == m) return EXT_PROPS[i];
		throw m;
	}).forEach(function(p) {
		if(Props[p[1]] == null) return;
		var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
		switch(p[2]) {
			case 'date': m = new Date(m).toISOString().replace(/\.\d*Z/,"Z"); break;
		}
		if(typeof m == 'number') m = String(m);
		else if(m === true || m === false) { m = m ? "1" : "0"; }
		else if(m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/,"");
		o.push(writetag(XLMLDocPropsMap[p[1]] || p[1], m));
	});
	return writextag('DocumentProperties', o.join(""), {xmlns:XLMLNS.o });
}
function xlml_write_custprops(Props, Custprops) {
	var BLACKLIST = ["Worksheets","SheetNames"];
	var T = 'CustomDocumentProperties';
	var o = [];
	if(Props) keys(Props).forEach(function(k) {
if(!Props.hasOwnProperty(k)) return;
		for(var i = 0; i < CORE_PROPS.length; ++i) if(k == CORE_PROPS[i][1]) return;
		for(i = 0; i < EXT_PROPS.length; ++i) if(k == EXT_PROPS[i][1]) return;
		for(i = 0; i < BLACKLIST.length; ++i) if(k == BLACKLIST[i]) return;

		var m = Props[k];
		var t = "string";
		if(typeof m == 'number') { t = "float"; m = String(m); }
		else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
		else m = String(m);
		o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
	});
	if(Custprops) keys(Custprops).forEach(function(k) {
if(!Custprops.hasOwnProperty(k)) return;
		if(Props && Props.hasOwnProperty(k)) return;
		var m = Custprops[k];
		var t = "string";
		if(typeof m == 'number') { t = "float"; m = String(m); }
		else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
		else if(m instanceof Date) { t = "dateTime.tz"; m = m.toISOString(); }
		else m = String(m);
		o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
	});
	return '<' + T + ' xmlns="' + XLMLNS.o + '">' + o.join("") + '</' + T + '>';
}
/* [MS-DTYP] 2.3.3 FILETIME */
/* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */
/* [MS-OLEPS] 2.8 FILETIME (Packet Version) */
function parse_FILETIME(blob) {
	var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
	return new Date(((dwHighDateTime/1e7*Math.pow(2,32) + dwLowDateTime/1e7) - 11644473600)*1000).toISOString().replace(/\.000/,"");
}
function write_FILETIME(time) {
	var date = (typeof time == "string") ? new Date(Date.parse(time)) : time;
	var t = date.getTime() / 1000 + 11644473600;
	var l = t % Math.pow(2,32), h = (t - l) / Math.pow(2,32);
	l *= 1e7; h *= 1e7;
	var w = (l / Math.pow(2,32)) | 0;
	if(w > 0) { l = l % Math.pow(2,32); h += w; }
	var o = new_buf(8); o.write_shift(4, l); o.write_shift(4, h); return o;
}

/* [MS-OSHARED] 2.3.3.1.4 Lpstr */
function parse_lpstr(blob, type, pad) {
	var start = blob.l;
	var str = blob.read_shift(0, 'lpstr-cp');
	if(pad) while((blob.l - start) & 3) ++blob.l;
	return str;
}

/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */
function parse_lpwstr(blob, type, pad) {
	var str = blob.read_shift(0, 'lpwstr');
	if(pad) blob.l += (4 - ((str.length+1) & 3)) & 3;
	return str;
}


/* [MS-OSHARED] 2.3.3.1.11 VtString */
/* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */
function parse_VtStringBase(blob, stringType, pad) {
	if(stringType === 0x1F /*VT_LPWSTR*/) return parse_lpwstr(blob);
	return parse_lpstr(blob, stringType, pad);
}

function parse_VtString(blob, t, pad) { return parse_VtStringBase(blob, t, pad === false ? 0: 4); }
function parse_VtUnalignedString(blob, t) { if(!t) throw new Error("VtUnalignedString must have positive length"); return parse_VtStringBase(blob, t, 0); }

/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */
function parse_VtVecUnalignedLpstrValue(blob) {
	var length = blob.read_shift(4);
	var ret = [];
	for(var i = 0; i != length; ++i) ret[i] = blob.read_shift(0, 'lpstr-cp').replace(chr0,'');
	return ret;
}

/* [MS-OSHARED] 2.3.3.1.10 VtVecUnalignedLpstr */
function parse_VtVecUnalignedLpstr(blob) {
	return parse_VtVecUnalignedLpstrValue(blob);
}

/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */
function parse_VtHeadingPair(blob) {
	var headingString = parse_TypedPropertyValue(blob, VT_USTR);
	var headerParts = parse_TypedPropertyValue(blob, VT_I4);
	return [headingString, headerParts];
}

/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */
function parse_VtVecHeadingPairValue(blob) {
	var cElements = blob.read_shift(4);
	var out = [];
	for(var i = 0; i != cElements / 2; ++i) out.push(parse_VtHeadingPair(blob));
	return out;
}

/* [MS-OSHARED] 2.3.3.1.15 VtVecHeadingPair */
function parse_VtVecHeadingPair(blob) {
	// NOTE: When invoked, wType & padding were already consumed
	return parse_VtVecHeadingPairValue(blob);
}

/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */
function parse_dictionary(blob,CodePage) {
	var cnt = blob.read_shift(4);
	var dict = ({});
	for(var j = 0; j != cnt; ++j) {
		var pid = blob.read_shift(4);
		var len = blob.read_shift(4);
		dict[pid] = blob.read_shift(len, (CodePage === 0x4B0 ?'utf16le':'utf8')).replace(chr0,'').replace(chr1,'!');
		if(CodePage === 0x4B0 && (len % 2)) blob.l += 2;
	}
	if(blob.l & 3) blob.l = (blob.l>>2+1)<<2;
	return dict;
}

/* [MS-OLEPS] 2.9 BLOB */
function parse_BLOB(blob) {
	var size = blob.read_shift(4);
	var bytes = blob.slice(blob.l,blob.l+size);
	blob.l += size;
	if((size & 3) > 0) blob.l += (4 - (size & 3)) & 3;
	return bytes;
}

/* [MS-OLEPS] 2.11 ClipboardData */
function parse_ClipboardData(blob) {
	// TODO
	var o = {};
	o.Size = blob.read_shift(4);
	//o.Format = blob.read_shift(4);
	blob.l += o.Size + 3 - (o.Size - 1) % 4;
	return o;
}

/* [MS-OLEPS] 2.15 TypedPropertyValue */
function parse_TypedPropertyValue(blob, type, _opts) {
	var t = blob.read_shift(2), ret, opts = _opts||{};
	blob.l += 2;
	if(type !== VT_VARIANT)
	if(t !== type && VT_CUSTOM.indexOf(type)===-1) throw new Error('Expected type ' + type + ' saw ' + t);
	switch(type === VT_VARIANT ? t : type) {
		case 0x02 /*VT_I2*/: ret = blob.read_shift(2, 'i'); if(!opts.raw) blob.l += 2; return ret;
		case 0x03 /*VT_I4*/: ret = blob.read_shift(4, 'i'); return ret;
		case 0x0B /*VT_BOOL*/: return blob.read_shift(4) !== 0x0;
		case 0x13 /*VT_UI4*/: ret = blob.read_shift(4); return ret;
		case 0x1E /*VT_LPSTR*/: return parse_lpstr(blob, t, 4).replace(chr0,'');
		case 0x1F /*VT_LPWSTR*/: return parse_lpwstr(blob);
		case 0x40 /*VT_FILETIME*/: return parse_FILETIME(blob);
		case 0x41 /*VT_BLOB*/: return parse_BLOB(blob);
		case 0x47 /*VT_CF*/: return parse_ClipboardData(blob);
		case 0x50 /*VT_STRING*/: return parse_VtString(blob, t, !opts.raw).replace(chr0,'');
		case 0x51 /*VT_USTR*/: return parse_VtUnalignedString(blob, t/*, 4*/).replace(chr0,'');
		case 0x100C /*VT_VECTOR|VT_VARIANT*/: return parse_VtVecHeadingPair(blob);
		case 0x101E /*VT_LPSTR*/: return parse_VtVecUnalignedLpstr(blob);
		default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
	}
}
function write_TypedPropertyValue(type, value) {
	var o = new_buf(4), p = new_buf(4);
	o.write_shift(4, type == 0x50 ? 0x1F : type);
	switch(type) {
		case 0x03 /*VT_I4*/: p.write_shift(-4, value); break;
		case 0x05 /*VT_I4*/: p = new_buf(8); p.write_shift(8, value, 'f'); break;
		case 0x0B /*VT_BOOL*/: p.write_shift(4, value ? 0x01 : 0x00); break;
		case 0x40 /*VT_FILETIME*/:  p = write_FILETIME(value); break;
		case 0x1F /*VT_LPWSTR*/:
		case 0x50 /*VT_STRING*/:
p = new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
			p.write_shift(4, value.length + 1);
			p.write_shift(0, value, "dbcs");
			while(p.l != p.length) p.write_shift(1, 0);
			break;
		default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
	}
	return bconcat([o, p]);
}

/* [MS-OLEPS] 2.20 PropertySet */
function parse_PropertySet(blob, PIDSI) {
	var start_addr = blob.l;
	var size = blob.read_shift(4);
	var NumProps = blob.read_shift(4);
	var Props = [], i = 0;
	var CodePage = 0;
	var Dictionary = -1, DictObj = ({});
	for(i = 0; i != NumProps; ++i) {
		var PropID = blob.read_shift(4);
		var Offset = blob.read_shift(4);
		Props[i] = [PropID, Offset + start_addr];
	}
	Props.sort(function(x,y) { return x[1] - y[1]; });
	var PropH = {};
	for(i = 0; i != NumProps; ++i) {
		if(blob.l !== Props[i][1]) {
			var fail = true;
			if(i>0 && PIDSI) switch(PIDSI[Props[i-1][0]].t) {
				case 0x02 /*VT_I2*/: if(blob.l+2 === Props[i][1]) { blob.l+=2; fail = false; } break;
				case 0x50 /*VT_STRING*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
				case 0x100C /*VT_VECTOR|VT_VARIANT*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
			}
			if((!PIDSI||i==0) && blob.l <= Props[i][1]) { fail=false; blob.l = Props[i][1]; }
			if(fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
		}
		if(PIDSI) {
			var piddsi = PIDSI[Props[i][0]];
			PropH[piddsi.n] = parse_TypedPropertyValue(blob, piddsi.t, {raw:true});
			if(piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
			if(piddsi.n == "CodePage") switch(PropH[piddsi.n]) {
				case 0: PropH[piddsi.n] = 1252;
					/* falls through */
				case 874:
				case 932:
				case 936:
				case 949:
				case 950:
				case 1250:
				case 1251:
				case 1253:
				case 1254:
				case 1255:
				case 1256:
				case 1257:
				case 1258:
				case 10000:
				case 1200:
				case 1201:
				case 1252:
				case 65000: case -536:
				case 65001: case -535:
					set_cp(CodePage = (PropH[piddsi.n]>>>0) & 0xFFFF); break;
				default: throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
			}
		} else {
			if(Props[i][0] === 0x1) {
				CodePage = PropH.CodePage = (parse_TypedPropertyValue(blob, VT_I2));
				set_cp(CodePage);
				if(Dictionary !== -1) {
					var oldpos = blob.l;
					blob.l = Props[Dictionary][1];
					DictObj = parse_dictionary(blob,CodePage);
					blob.l = oldpos;
				}
			} else if(Props[i][0] === 0) {
				if(CodePage === 0) { Dictionary = i; blob.l = Props[i+1][1]; continue; }
				DictObj = parse_dictionary(blob,CodePage);
			} else {
				var name = DictObj[Props[i][0]];
				var val;
				/* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */
				switch(blob[blob.l]) {
					case 0x41 /*VT_BLOB*/: blob.l += 4; val = parse_BLOB(blob); break;
					case 0x1E /*VT_LPSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
					case 0x1F /*VT_LPWSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
					case 0x03 /*VT_I4*/: blob.l += 4; val = blob.read_shift(4, 'i'); break;
					case 0x13 /*VT_UI4*/: blob.l += 4; val = blob.read_shift(4); break;
					case 0x05 /*VT_R8*/: blob.l += 4; val = blob.read_shift(8, 'f'); break;
					case 0x0B /*VT_BOOL*/: blob.l += 4; val = parsebool(blob, 4); break;
					case 0x40 /*VT_FILETIME*/: blob.l += 4; val = parseDate(parse_FILETIME(blob)); break;
					default: throw new Error("unparsed value: " + blob[blob.l]);
				}
				PropH[name] = val;
			}
		}
	}
	blob.l = start_addr + size; /* step ahead to skip padding */
	return PropH;
}
var XLSPSSkip = [ "CodePage", "Thumbnail", "_PID_LINKBASE", "_PID_HLINKS", "SystemIdentifier", "FMTID" ].concat(PseudoPropsPairs);
function guess_property_type(val) {
	switch(typeof val) {
		case "boolean": return 0x0B;
		case "number": return ((val|0)==val) ? 0x03 : 0x05;
		case "string": return 0x1F;
		case "object": if(val instanceof Date) return 0x40; break;
	}
	return -1;
}
function write_PropertySet(entries, RE, PIDSI) {
	var hdr = new_buf(8), piao = [], prop = [];
	var sz = 8, i = 0;

	var pr = new_buf(8), pio = new_buf(8);
	pr.write_shift(4, 0x0002);
	pr.write_shift(4, 0x04B0);
	pio.write_shift(4, 0x0001);
	prop.push(pr); piao.push(pio);
	sz += 8 + pr.length;

	if(!RE) {
		pio = new_buf(8);
		pio.write_shift(4, 0);
		piao.unshift(pio);

		var bufs = [new_buf(4)];
		bufs[0].write_shift(4, entries.length);
		for(i = 0; i < entries.length; ++i) {
			var value = entries[i][0];
			pr = new_buf(4 + 4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
			pr.write_shift(4, i+2);
			pr.write_shift(4, value.length + 1);
			pr.write_shift(0, value, "dbcs");
			while(pr.l != pr.length) pr.write_shift(1, 0);
			bufs.push(pr);
		}
		pr = bconcat(bufs);
		prop.unshift(pr);
		sz += 8 + pr.length;
	}

	for(i = 0; i < entries.length; ++i) {
		if(RE && !RE[entries[i][0]]) continue;
		if(XLSPSSkip.indexOf(entries[i][0]) > -1) continue;
		if(entries[i][1] == null) continue;

		var val = entries[i][1], idx = 0;
		if(RE) {
			idx = +RE[entries[i][0]];
			var pinfo = (PIDSI)[idx];
			if(pinfo.p == "version" && typeof val == "string") {
var arr = val.split(".");
				val = ((+arr[0])<<16) + ((+arr[1])||0);
			}
			pr = write_TypedPropertyValue(pinfo.t, val);
		} else {
			var T = guess_property_type(val);
			if(T == -1) { T = 0x1F; val = String(val); }
			pr = write_TypedPropertyValue(T, val);
		}
		prop.push(pr);

		pio = new_buf(8);
		pio.write_shift(4, !RE ? 2+i : idx);
		piao.push(pio);

		sz += 8 + pr.length;
	}

	var w = 8 * (prop.length + 1);
	for(i = 0; i < prop.length; ++i) { piao[i].write_shift(4, w); w += prop[i].length; }
	hdr.write_shift(4, sz);
	hdr.write_shift(4, prop.length);
	return bconcat([hdr].concat(piao).concat(prop));
}

/* [MS-OLEPS] 2.21 PropertySetStream */
function parse_PropertySetStream(file, PIDSI, clsid) {
	var blob = file.content;
	if(!blob) return ({});
	prep_blob(blob, 0);

	var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
	blob.chk('feff', 'Byte Order: ');

	/*var vers = */blob.read_shift(2); // TODO: check version
	var SystemIdentifier = blob.read_shift(4);
	var CLSID = blob.read_shift(16);
	if(CLSID !== CFB.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
	NumSets = blob.read_shift(4);
	if(NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
	FMTID0 = blob.read_shift(16); Offset0 = blob.read_shift(4);

	if(NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
	else if(NumSets === 2) { FMTID1 = blob.read_shift(16); Offset1 = blob.read_shift(4); }
	var PSet0 = parse_PropertySet(blob, PIDSI);

	var rval = ({ SystemIdentifier: SystemIdentifier });
	for(var y in PSet0) rval[y] = PSet0[y];
	//rval.blob = blob;
	rval.FMTID = FMTID0;
	//rval.PSet0 = PSet0;
	if(NumSets === 1) return rval;
	if(Offset1 - blob.l == 2) blob.l += 2;
	if(blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
	var PSet1;
	try { PSet1 = parse_PropertySet(blob, null); } catch(e) {/* empty */}
	for(y in PSet1) rval[y] = PSet1[y];
	rval.FMTID = [FMTID0, FMTID1]; // TODO: verify FMTID0/1
	return rval;
}
function write_PropertySetStream(entries, clsid, RE, PIDSI, entries2, clsid2) {
	var hdr = new_buf(entries2 ? 68 : 48);
	var bufs = [hdr];
	hdr.write_shift(2, 0xFFFE);
	hdr.write_shift(2, 0x0000); /* TODO: type 1 props */
	hdr.write_shift(4, 0x32363237);
	hdr.write_shift(16, CFB.utils.consts.HEADER_CLSID, "hex");
	hdr.write_shift(4, (entries2 ? 2 : 1));
	hdr.write_shift(16, clsid, "hex");
	hdr.write_shift(4, (entries2 ? 68 : 48));
	var ps0 = write_PropertySet(entries, RE, PIDSI);
	bufs.push(ps0);

	if(entries2) {
		var ps1 = write_PropertySet(entries2, null, null);
		hdr.write_shift(16, clsid2, "hex");
		hdr.write_shift(4, 68 + ps0.length);
		bufs.push(ps1);
	}
	return bconcat(bufs);
}

function parsenoop2(blob, length) { blob.read_shift(length); return null; }
function writezeroes(n, o) { if(!o) o=new_buf(n); for(var j=0; j<n; ++j) o.write_shift(1, 0); return o; }

function parslurp(blob, length, cb) {
	var arr = [], target = blob.l + length;
	while(blob.l < target) arr.push(cb(blob, target - blob.l));
	if(target !== blob.l) throw new Error("Slurp error");
	return arr;
}

function parsebool(blob, length) { return blob.read_shift(length) === 0x1; }
function writebool(v, o) { if(!o) o=new_buf(2); o.write_shift(2, +!!v); return o; }

function parseuint16(blob) { return blob.read_shift(2, 'u'); }
function writeuint16(v, o) { if(!o) o=new_buf(2); o.write_shift(2, v); return o; }
function parseuint16a(blob, length) { return parslurp(blob,length,parseuint16);}

/* --- 2.5 Structures --- */

/* [MS-XLS] 2.5.10 Bes (boolean or error) */
function parse_Bes(blob) {
	var v = blob.read_shift(1), t = blob.read_shift(1);
	return t === 0x01 ? v : v === 0x01;
}
function write_Bes(v, t, o) {
	if(!o) o = new_buf(2);
	o.write_shift(1, +v);
	o.write_shift(1, ((t == 'e') ? 1 : 0));
	return o;
}

/* [MS-XLS] 2.5.240 ShortXLUnicodeString */
function parse_ShortXLUnicodeString(blob, length, opts) {
	var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
	var encoding = 'sbcs-cont';
	var cp = current_codepage;
	if(opts && opts.biff >= 8) current_codepage = 1200;
	if(!opts || opts.biff == 8 ) {
		var fHighByte = blob.read_shift(1);
		if(fHighByte) { encoding = 'dbcs-cont'; }
	} else if(opts.biff == 12) {
		encoding = 'wstr';
	}
	if(opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
	var o = cch ? blob.read_shift(cch, encoding) : "";
	current_codepage = cp;
	return o;
}

/* 2.5.293 XLUnicodeRichExtendedString */
function parse_XLUnicodeRichExtendedString(blob) {
	var cp = current_codepage;
	current_codepage = 1200;
	var cch = blob.read_shift(2), flags = blob.read_shift(1);
	var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
	var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
	var cRun = 0, cbExtRst;
	var z = {};
	if(fRichSt) cRun = blob.read_shift(2);
	if(fExtSt) cbExtRst = blob.read_shift(4);
	var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
	var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
	if(fRichSt) blob.l += 4 * cRun; //TODO: parse this
	if(fExtSt) blob.l += cbExtRst; //TODO: parse this
	z.t = msg;
	if(!fRichSt) { z.raw = "<t>" + z.t + "</t>"; z.r = z.t; }
	current_codepage = cp;
	return z;
}

/* 2.5.296 XLUnicodeStringNoCch */
function parse_XLUnicodeStringNoCch(blob, cch, opts) {
	var retval;
	if(opts) {
		if(opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
		if(opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
	}
	var fHighByte = blob.read_shift(1);
	if(fHighByte===0) { retval = blob.read_shift(cch, 'sbcs-cont'); }
	else { retval = blob.read_shift(cch, 'dbcs-cont'); }
	return retval;
}

/* 2.5.294 XLUnicodeString */
function parse_XLUnicodeString(blob, length, opts) {
	var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	if(cch === 0) { blob.l++; return ""; }
	return parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */
function parse_XLUnicodeString2(blob, length, opts) {
	if(opts.biff > 5) return parse_XLUnicodeString(blob, length, opts);
	var cch = blob.read_shift(1);
	if(cch === 0) { blob.l++; return ""; }
	return blob.read_shift(cch, (opts.biff <= 4 || !blob.lens ) ? 'cpstr' : 'sbcs-cont');
}
/* TODO: BIFF5 and lower, codepage awareness */
function write_XLUnicodeString(str, opts, o) {
	if(!o) o = new_buf(3 + 2 * str.length);
	o.write_shift(2, str.length);
	o.write_shift(1, 1);
	o.write_shift(31, str, 'utf16le');
	return o;
}

/* [MS-XLS] 2.5.61 ControlInfo */
function parse_ControlInfo(blob) {
	var flags = blob.read_shift(1);
	blob.l++;
	var accel = blob.read_shift(2);
	blob.l += 2;
	return [flags, accel];
}

/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */
function parse_URLMoniker(blob) {
	var len = blob.read_shift(4), start = blob.l;
	var extra = false;
	if(len > 24) {
		/* look ahead */
		blob.l += len - 24;
		if(blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
		blob.l = start;
	}
	var url = blob.read_shift((extra?len-24:len)>>1, 'utf16le').replace(chr0,"");
	if(extra) blob.l += 24;
	return url;
}

/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */
function parse_FileMoniker(blob) {
	blob.l += 2; //var cAnti = blob.read_shift(2);
	var ansiPath = blob.read_shift(0, 'lpstr-ansi');
	blob.l += 2; //var endServer = blob.read_shift(2);
	if(blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
	var sz = blob.read_shift(4);
	if(sz === 0) return ansiPath.replace(/\\/g,"/");
	var bytes = blob.read_shift(4);
	if(blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
	var unicodePath = blob.read_shift(bytes>>1, 'utf16le').replace(chr0,"");
	return unicodePath;
}

/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */
function parse_HyperlinkMoniker(blob, length) {
	var clsid = blob.read_shift(16); length -= 16;
	switch(clsid) {
		case "e0c9ea79f9bace118c8200aa004ba90b": return parse_URLMoniker(blob, length);
		case "0303000000000000c000000000000046": return parse_FileMoniker(blob, length);
		default: throw new Error("Unsupported Moniker " + clsid);
	}
}

/* [MS-OSHARED] 2.3.7.9 HyperlinkString */
function parse_HyperlinkString(blob) {
	var len = blob.read_shift(4);
	var o = len > 0 ? blob.read_shift(len, 'utf16le').replace(chr0, "") : "";
	return o;
}

/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */
function parse_Hyperlink(blob, length) {
	var end = blob.l + length;
	var sVer = blob.read_shift(4);
	if(sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
	var flags = blob.read_shift(2);
	blob.l += 2;
	var displayName, targetFrameName, moniker, oleMoniker, Loc="", guid, fileTime;
	if(flags & 0x0010) displayName = parse_HyperlinkString(blob, end - blob.l);
	if(flags & 0x0080) targetFrameName = parse_HyperlinkString(blob, end - blob.l);
	if((flags & 0x0101) === 0x0101) moniker = parse_HyperlinkString(blob, end - blob.l);
	if((flags & 0x0101) === 0x0001) oleMoniker = parse_HyperlinkMoniker(blob, end - blob.l);
	if(flags & 0x0008) Loc = parse_HyperlinkString(blob, end - blob.l);
	if(flags & 0x0020) guid = blob.read_shift(16);
	if(flags & 0x0040) fileTime = parse_FILETIME(blob/*, 8*/);
	blob.l = end;
	var target = targetFrameName||moniker||oleMoniker||"";
	if(target && Loc) target+="#"+Loc;
	if(!target) target = "#" + Loc;
	var out = ({Target:target});
	if(guid) out.guid = guid;
	if(fileTime) out.time = fileTime;
	if(displayName) out.Tooltip = displayName;
	return out;
}
function write_Hyperlink(hl) {
	var out = new_buf(512), i = 0;
	var Target = hl.Target;
	var F = Target.indexOf("#") > -1 ? 0x1f : 0x17;
	switch(Target.charAt(0)) { case "#": F=0x1c; break; case ".": F&=~2; break; }
	out.write_shift(4,2); out.write_shift(4, F);
	var data = [8,6815827,6619237,4849780,83]; for(i = 0; i < data.length; ++i) out.write_shift(4, data[i]);
	if(F == 0x1C) {
		Target = Target.slice(1);
		out.write_shift(4, Target.length + 1);
		for(i = 0; i < Target.length; ++i) out.write_shift(2, Target.charCodeAt(i));
		out.write_shift(2, 0);
	} else if(F & 0x02) {
		data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
		for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
		out.write_shift(4, 2*(Target.length + 1));
		for(i = 0; i < Target.length; ++i) out.write_shift(2, Target.charCodeAt(i));
		out.write_shift(2, 0);
	} else {
		data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
		for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
		var P = 0;
		while(Target.slice(P*3,P*3+3)=="../"||Target.slice(P*3,P*3+3)=="..\\") ++P;
		out.write_shift(2, P);
		out.write_shift(4, Target.length + 1);
		for(i = 0; i < Target.length; ++i) out.write_shift(1, Target.charCodeAt(i) & 0xFF);
		out.write_shift(1, 0);
		out.write_shift(2, 0xFFFF);
		out.write_shift(2, 0xDEAD);
		for(i = 0; i < 6; ++i) out.write_shift(4, 0);
	}
	return out.slice(0, out.l);
}

/* 2.5.178 LongRGBA */
function parse_LongRGBA(blob) { var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1); return [r,g,b,a]; }

/* 2.5.177 LongRGB */
function parse_LongRGB(blob, length) { var x = parse_LongRGBA(blob, length); x[3] = 0; return x; }


/* [MS-XLS] 2.5.19 */
function parse_XLSCell(blob) {
	var rw = blob.read_shift(2); // 0-indexed
	var col = blob.read_shift(2);
	var ixfe = blob.read_shift(2);
	return ({r:rw, c:col, ixfe:ixfe});
}
function write_XLSCell(R, C, ixfe, o) {
	if(!o) o = new_buf(6);
	o.write_shift(2, R);
	o.write_shift(2, C);
	o.write_shift(2, ixfe||0);
	return o;
}

/* [MS-XLS] 2.5.134 */
function parse_frtHeader(blob) {
	var rt = blob.read_shift(2);
	var flags = blob.read_shift(2); // TODO: parse these flags
	blob.l += 8;
	return {type: rt, flags: flags};
}



function parse_OptXLUnicodeString(blob, length, opts) { return length === 0 ? "" : parse_XLUnicodeString2(blob, length, opts); }

/* [MS-XLS] 2.5.344 */
function parse_XTI(blob, length, opts) {
	var w = opts.biff > 8 ? 4 : 2;
	var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w,'i'), itabLast = blob.read_shift(w,'i');
	return [iSupBook, itabFirst, itabLast];
}

/* [MS-XLS] 2.5.218 */
function parse_RkRec(blob) {
	var ixfe = blob.read_shift(2);
	var RK = parse_RkNumber(blob);
	return [ixfe, RK];
}

/* [MS-XLS] 2.5.1 */
function parse_AddinUdf(blob, length, opts) {
	blob.l += 4; length -= 4;
	var l = blob.l + length;
	var udfName = parse_ShortXLUnicodeString(blob, length, opts);
	var cb = blob.read_shift(2);
	l -= blob.l;
	if(cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
	blob.l += cb;
	return udfName;
}

/* [MS-XLS] 2.5.209 TODO: Check sizes */
function parse_Ref8U(blob) {
	var rwFirst = blob.read_shift(2);
	var rwLast = blob.read_shift(2);
	var colFirst = blob.read_shift(2);
	var colLast = blob.read_shift(2);
	return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
}
function write_Ref8U(r, o) {
	if(!o) o = new_buf(8);
	o.write_shift(2, r.s.r);
	o.write_shift(2, r.e.r);
	o.write_shift(2, r.s.c);
	o.write_shift(2, r.e.c);
	return o;
}

/* [MS-XLS] 2.5.211 */
function parse_RefU(blob) {
	var rwFirst = blob.read_shift(2);
	var rwLast = blob.read_shift(2);
	var colFirst = blob.read_shift(1);
	var colLast = blob.read_shift(1);
	return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
}

/* [MS-XLS] 2.5.207 */
var parse_Ref = parse_RefU;

/* [MS-XLS] 2.5.143 */
function parse_FtCmo(blob) {
	blob.l += 4;
	var ot = blob.read_shift(2);
	var id = blob.read_shift(2);
	var flags = blob.read_shift(2);
	blob.l+=12;
	return [id, ot, flags];
}

/* [MS-XLS] 2.5.149 */
function parse_FtNts(blob) {
	var out = {};
	blob.l += 4;
	blob.l += 16; // GUID TODO
	out.fSharedNote = blob.read_shift(2);
	blob.l += 4;
	return out;
}

/* [MS-XLS] 2.5.142 */
function parse_FtCf(blob) {
	var out = {};
	blob.l += 4;
	blob.cf = blob.read_shift(2);
	return out;
}

/* [MS-XLS] 2.5.140 - 2.5.154 and friends */
function parse_FtSkip(blob) { blob.l += 2; blob.l += blob.read_shift(2); }
var FtTab = {
0x00: parse_FtSkip,      /* FtEnd */
0x04: parse_FtSkip,      /* FtMacro */
0x05: parse_FtSkip,      /* FtButton */
0x06: parse_FtSkip,      /* FtGmo */
0x07: parse_FtCf,        /* FtCf */
0x08: parse_FtSkip,      /* FtPioGrbit */
0x09: parse_FtSkip,      /* FtPictFmla */
0x0A: parse_FtSkip,      /* FtCbls */
0x0B: parse_FtSkip,      /* FtRbo */
0x0C: parse_FtSkip,      /* FtSbs */
0x0D: parse_FtNts,       /* FtNts */
0x0E: parse_FtSkip,      /* FtSbsFmla */
0x0F: parse_FtSkip,      /* FtGboData */
0x10: parse_FtSkip,      /* FtEdoData */
0x11: parse_FtSkip,      /* FtRboData */
0x12: parse_FtSkip,      /* FtCblsData */
0x13: parse_FtSkip,      /* FtLbsData */
0x14: parse_FtSkip,      /* FtCblsFmla */
0x15: parse_FtCmo
};
function parse_FtArray(blob, length) {
	var tgt = blob.l + length;
	var fts = [];
	while(blob.l < tgt) {
		var ft = blob.read_shift(2);
		blob.l-=2;
		try {
			fts.push(FtTab[ft](blob, tgt - blob.l));
		} catch(e) { blob.l = tgt; return fts; }
	}
	if(blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
	return fts;
}

/* --- 2.4 Records --- */

/* [MS-XLS] 2.4.21 */
function parse_BOF(blob, length) {
	var o = {BIFFVer:0, dt:0};
	o.BIFFVer = blob.read_shift(2); length -= 2;
	if(length >= 2) { o.dt = blob.read_shift(2); blob.l -= 2; }
	switch(o.BIFFVer) {
		case 0x0600: /* BIFF8 */
		case 0x0500: /* BIFF5 */
		case 0x0400: /* BIFF4 */
		case 0x0300: /* BIFF3 */
		case 0x0200: /* BIFF2 */
		case 0x0002: case 0x0007: /* BIFF2 */
			break;
		default: if(length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
	}

	blob.read_shift(length);
	return o;
}
function write_BOF(wb, t, o) {
	var h = 0x0600, w = 16;
	switch(o.bookType) {
		case 'biff8': break;
		case 'biff5': h = 0x0500; w = 8; break;
		case 'biff4': h = 0x0004; w = 6; break;
		case 'biff3': h = 0x0003; w = 6; break;
		case 'biff2': h = 0x0002; w = 4; break;
		case 'xla': break;
		default: throw new Error("unsupported BIFF version");
	}
	var out = new_buf(w);
	out.write_shift(2, h);
	out.write_shift(2, t);
	if(w > 4) out.write_shift(2, 0x7262);
	if(w > 6) out.write_shift(2, 0x07CD);
	if(w > 8) {
		out.write_shift(2, 0xC009);
		out.write_shift(2, 0x0001);
		out.write_shift(2, 0x0706);
		out.write_shift(2, 0x0000);
	}
	return out;
}


/* [MS-XLS] 2.4.146 */
function parse_InterfaceHdr(blob, length) {
	if(length === 0) return 0x04b0;
	if((blob.read_shift(2))!==0x04b0){/* empty */}
	return 0x04b0;
}


/* [MS-XLS] 2.4.349 */
function parse_WriteAccess(blob, length, opts) {
	if(opts.enc) { blob.l += length; return ""; }
	var l = blob.l;
	// TODO: make sure XLUnicodeString doesnt overrun
	var UserName = parse_XLUnicodeString2(blob, 0, opts);
	blob.read_shift(length + l - blob.l);
	return UserName;
}
function write_WriteAccess(s, opts) {
	var b8 = !opts || opts.biff == 8;
	var o = new_buf(b8 ? 112 : 54);
	o.write_shift(opts.biff == 8 ? 2 : 1, 7);
	if(b8) o.write_shift(1, 0);
	o.write_shift(4, 0x33336853);
	o.write_shift(4, (0x00534A74 | (b8 ? 0 : 0x20000000)));
	while(o.l < o.length) o.write_shift(1, (b8 ? 0 : 32));
	return o;
}

/* [MS-XLS] 2.4.351 */
function parse_WsBool(blob, length, opts) {
	var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
	return { fDialog: flags & 0x10 };
}

/* [MS-XLS] 2.4.28 */
function parse_BoundSheet8(blob, length, opts) {
	var pos = blob.read_shift(4);
	var hidden = blob.read_shift(1) & 0x03;
	var dt = blob.read_shift(1);
	switch(dt) {
		case 0: dt = 'Worksheet'; break;
		case 1: dt = 'Macrosheet'; break;
		case 2: dt = 'Chartsheet'; break;
		case 6: dt = 'VBAModule'; break;
	}
	var name = parse_ShortXLUnicodeString(blob, 0, opts);
	if(name.length === 0) name = "Sheet1";
	return { pos:pos, hs:hidden, dt:dt, name:name };
}
function write_BoundSheet8(data, opts) {
	var w = (!opts || opts.biff >= 8 ? 2 : 1);
	var o = new_buf(8 + w * data.name.length);
	o.write_shift(4, data.pos);
	o.write_shift(1, data.hs || 0);
	o.write_shift(1, data.dt);
	o.write_shift(1, data.name.length);
	if(opts.biff >= 8) o.write_shift(1, 1);
	o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
	var out = o.slice(0, o.l);
	out.l = o.l; return out;
}

/* [MS-XLS] 2.4.265 TODO */
function parse_SST(blob, length) {
	var end = blob.l + length;
	var cnt = blob.read_shift(4);
	var ucnt = blob.read_shift(4);
	var strs = ([]);
	for(var i = 0; i != ucnt && blob.l < end; ++i) {
		strs.push(parse_XLUnicodeRichExtendedString(blob));
	}
	strs.Count = cnt; strs.Unique = ucnt;
	return strs;
}

/* [MS-XLS] 2.4.107 */
function parse_ExtSST(blob, length) {
	var extsst = {};
	extsst.dsst = blob.read_shift(2);
	blob.l += length-2;
	return extsst;
}


/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */
function parse_Row(blob) {
	var z = ({});
	z.r = blob.read_shift(2);
	z.c = blob.read_shift(2);
	z.cnt = blob.read_shift(2) - z.c;
	var miyRw = blob.read_shift(2);
	blob.l += 4; // reserved(2), unused(2)
	var flags = blob.read_shift(1); // various flags
	blob.l += 3; // reserved(8), ixfe(12), flags(4)
	if(flags & 0x07) z.level = flags & 0x07;
	// collapsed: flags & 0x10
	if(flags & 0x20) z.hidden = true;
	if(flags & 0x40) z.hpt = miyRw / 20;
	return z;
}


/* [MS-XLS] 2.4.125 */
function parse_ForceFullCalculation(blob) {
	var header = parse_frtHeader(blob);
	if(header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
	var fullcalc = blob.read_shift(4);
	return fullcalc !== 0x0;
}





/* [MS-XLS] 2.4.215 rt */
function parse_RecalcId(blob) {
	blob.read_shift(2);
	return blob.read_shift(4);
}

/* [MS-XLS] 2.4.87 */
function parse_DefaultRowHeight(blob, length, opts) {
	var f = 0;
	if(!(opts && opts.biff == 2)) {
		f = blob.read_shift(2);
	}
	var miyRw = blob.read_shift(2);
	if((opts && opts.biff == 2)) {
		f = 1 - (miyRw >> 15); miyRw &= 0x7fff;
	}
	var fl = {Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};
	return [fl, miyRw];
}

/* [MS-XLS] 2.4.345 TODO */
function parse_Window1(blob) {
	var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
	var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
	var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
	return { Pos: [xWn, yWn], Dim: [dxWn, dyWn], Flags: flags, CurTab: iTabCur,
		FirstTab: iTabFirst, Selected: ctabSel, TabRatio: wTabRatio };
}
function write_Window1() {
	var o = new_buf(18);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 0x7260);
	o.write_shift(2, 0x44c0);
	o.write_shift(2, 0x38);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 1);
	o.write_shift(2, 0x01f4);
	return o;
}
/* [MS-XLS] 2.4.346 TODO */
function parse_Window2(blob, length, opts) {
	if(opts && opts.biff >= 2 && opts.biff < 8) return {};
	var f = blob.read_shift(2);
	return { RTL: f & 0x40 };
}
function write_Window2(view) {
	var o = new_buf(18), f = 0x6b6;
	if(view && view.RTL) f |= 0x40;
	o.write_shift(2, f);
	o.write_shift(4, 0);
	o.write_shift(4, 64);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	return o;
}

/* [MS-XLS] 2.4.122 TODO */
function parse_Font(blob, length, opts) {
	var o = {
		dyHeight: blob.read_shift(2),
		fl: blob.read_shift(2)
	};
	switch((opts && opts.biff) || 8) {
		case 2: break;
		case 3: case 4: blob.l += 2; break;
		default: blob.l += 10; break;
	}
	o.name = parse_ShortXLUnicodeString(blob, 0, opts);
	return o;
}
function write_Font(data, opts) {
	var name = data.name || "Arial";
	var b5 = (opts && (opts.biff == 5)), w = (b5 ? (15 + name.length) : (16 + 2 * name.length));
	var o = new_buf(w);
	o.write_shift(2, (data.sz || 12) * 20);
	o.write_shift(4, 0);
	o.write_shift(2, 400);
	o.write_shift(4, 0);
	o.write_shift(2, 0);
	o.write_shift(1, name.length);
	if(!b5) o.write_shift(1, 1);
	o.write_shift((b5 ? 1 : 2) * name.length, name, (b5 ? "sbcs" : "utf16le"));
	return o;
}

/* [MS-XLS] 2.4.149 */
function parse_LabelSst(blob) {
	var cell = parse_XLSCell(blob);
	cell.isst = blob.read_shift(4);
	return cell;
}

/* [MS-XLS] 2.4.148 */
function parse_Label(blob, length, opts) {
	var target = blob.l + length;
	var cell = parse_XLSCell(blob, 6);
	if(opts.biff == 2) blob.l++;
	var str = parse_XLUnicodeString(blob, target - blob.l, opts);
	cell.val = str;
	return cell;
}
function write_Label(R, C, v, os, opts) {
	var b8 = !opts || opts.biff == 8;
	var o = new_buf(6 + 2 + (+b8) + (1 + b8) * v.length);
	write_XLSCell(R, C, os, o);
	o.write_shift(2, v.length);
	if(b8) o.write_shift(1, 1);
	o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
	return o;
}


/* [MS-XLS] 2.4.126 Number Formats */
function parse_Format(blob, length, opts) {
	var numFmtId = blob.read_shift(2);
	var fmtstr = parse_XLUnicodeString2(blob, 0, opts);
	return [numFmtId, fmtstr];
}
function write_Format(i, f, opts, o) {
	var b5 = (opts && (opts.biff == 5));
	if(!o) o = new_buf(b5 ? (3 + f.length) : (5 + 2 * f.length));
	o.write_shift(2, i);
	o.write_shift((b5 ? 1 : 2), f.length);
	if(!b5) o.write_shift(1, 1);
	o.write_shift((b5 ? 1 : 2) * f.length, f, (b5 ? 'sbcs' : 'utf16le'));
	var out = (o.length > o.l) ? o.slice(0, o.l) : o;
	if(out.l == null) out.l = out.length;
	return out;
}
var parse_BIFF2Format = parse_XLUnicodeString2;

/* [MS-XLS] 2.4.90 */
function parse_Dimensions(blob, length, opts) {
	var end = blob.l + length;
	var w = opts.biff == 8 || !opts.biff ? 4 : 2;
	var r = blob.read_shift(w), R = blob.read_shift(w);
	var c = blob.read_shift(2), C = blob.read_shift(2);
	blob.l = end;
	return {s: {r:r, c:c}, e: {r:R, c:C}};
}
function write_Dimensions(range, opts) {
	var w = opts.biff == 8 || !opts.biff ? 4 : 2;
	var o = new_buf(2*w + 6);
	o.write_shift(w, range.s.r);
	o.write_shift(w, range.e.r + 1);
	o.write_shift(2, range.s.c);
	o.write_shift(2, range.e.c + 1);
	o.write_shift(2, 0);
	return o;
}

/* [MS-XLS] 2.4.220 */
function parse_RK(blob) {
	var rw = blob.read_shift(2), col = blob.read_shift(2);
	var rkrec = parse_RkRec(blob);
	return {r:rw, c:col, ixfe:rkrec[0], rknum:rkrec[1]};
}

/* [MS-XLS] 2.4.175 */
function parse_MulRk(blob, length) {
	var target = blob.l + length - 2;
	var rw = blob.read_shift(2), col = blob.read_shift(2);
	var rkrecs = [];
	while(blob.l < target) rkrecs.push(parse_RkRec(blob));
	if(blob.l !== target) throw new Error("MulRK read error");
	var lastcol = blob.read_shift(2);
	if(rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
	return {r:rw, c:col, C:lastcol, rkrec:rkrecs};
}
/* [MS-XLS] 2.4.174 */
function parse_MulBlank(blob, length) {
	var target = blob.l + length - 2;
	var rw = blob.read_shift(2), col = blob.read_shift(2);
	var ixfes = [];
	while(blob.l < target) ixfes.push(blob.read_shift(2));
	if(blob.l !== target) throw new Error("MulBlank read error");
	var lastcol = blob.read_shift(2);
	if(ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
	return {r:rw, c:col, C:lastcol, ixfe:ixfes};
}

/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */
function parse_CellStyleXF(blob, length, style, opts) {
	var o = {};
	var a = blob.read_shift(4), b = blob.read_shift(4);
	var c = blob.read_shift(4), d = blob.read_shift(2);
	o.patternType = XLSFillPattern[c >> 26];

	if(!opts.cellStyles) return o;
	o.alc = a & 0x07;
	o.fWrap = (a >> 3) & 0x01;
	o.alcV = (a >> 4) & 0x07;
	o.fJustLast = (a >> 7) & 0x01;
	o.trot = (a >> 8) & 0xFF;
	o.cIndent = (a >> 16) & 0x0F;
	o.fShrinkToFit = (a >> 20) & 0x01;
	o.iReadOrder = (a >> 22) & 0x02;
	o.fAtrNum = (a >> 26) & 0x01;
	o.fAtrFnt = (a >> 27) & 0x01;
	o.fAtrAlc = (a >> 28) & 0x01;
	o.fAtrBdr = (a >> 29) & 0x01;
	o.fAtrPat = (a >> 30) & 0x01;
	o.fAtrProt = (a >> 31) & 0x01;

	o.dgLeft = b & 0x0F;
	o.dgRight = (b >> 4) & 0x0F;
	o.dgTop = (b >> 8) & 0x0F;
	o.dgBottom = (b >> 12) & 0x0F;
	o.icvLeft = (b >> 16) & 0x7F;
	o.icvRight = (b >> 23) & 0x7F;
	o.grbitDiag = (b >> 30) & 0x03;

	o.icvTop = c & 0x7F;
	o.icvBottom = (c >> 7) & 0x7F;
	o.icvDiag = (c >> 14) & 0x7F;
	o.dgDiag = (c >> 21) & 0x0F;

	o.icvFore = d & 0x7F;
	o.icvBack = (d >> 7) & 0x7F;
	o.fsxButton = (d >> 14) & 0x01;
	return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}

/* [MS-XLS] 2.4.353 TODO: actually do this right */
function parse_XF(blob, length, opts) {
	var o = {};
	o.ifnt = blob.read_shift(2); o.numFmtId = blob.read_shift(2); o.flags = blob.read_shift(2);
	o.fStyle = (o.flags >> 2) & 0x01;
	length -= 6;
	o.data = parse_CellStyleXF(blob, length, o.fStyle, opts);
	return o;
}
function write_XF(data, ixfeP, opts, o) {
	var b5 = (opts && (opts.biff == 5));
	if(!o) o = new_buf(b5 ? 16 : 20);
	o.write_shift(2, 0);
	if(data.style) {
		o.write_shift(2, (data.numFmtId||0));
		o.write_shift(2, 0xFFF4);
	} else {
		o.write_shift(2, (data.numFmtId||0));
		o.write_shift(2, (ixfeP<<4));
	}
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	if(!b5) o.write_shift(4, 0);
	o.write_shift(2, 0);
	return o;
}

/* [MS-XLS] 2.4.134 */
function parse_Guts(blob) {
	blob.l += 4;
	var out = [blob.read_shift(2), blob.read_shift(2)];
	if(out[0] !== 0) out[0]--;
	if(out[1] !== 0) out[1]--;
	if(out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
	return out;
}
function write_Guts(guts) {
	var o = new_buf(8);
	o.write_shift(4, 0);
	o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
	o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
	return o;
}

/* [MS-XLS] 2.4.24 */
function parse_BoolErr(blob, length, opts) {
	var cell = parse_XLSCell(blob, 6);
	if(opts.biff == 2) ++blob.l;
	var val = parse_Bes(blob, 2);
	cell.val = val;
	cell.t = (val === true || val === false) ? 'b' : 'e';
	return cell;
}
function write_BoolErr(R, C, v, os, opts, t) {
	var o = new_buf(8);
	write_XLSCell(R, C, os, o);
	write_Bes(v, t, o);
	return o;
}

/* [MS-XLS] 2.4.180 Number */
function parse_Number(blob) {
	var cell = parse_XLSCell(blob, 6);
	var xnum = parse_Xnum(blob, 8);
	cell.val = xnum;
	return cell;
}
function write_Number(R, C, v, os) {
	var o = new_buf(14);
	write_XLSCell(R, C, os, o);
	write_Xnum(v, o);
	return o;
}

var parse_XLHeaderFooter = parse_OptXLUnicodeString; // TODO: parse 2.4.136

/* [MS-XLS] 2.4.271 */
function parse_SupBook(blob, length, opts) {
	var end = blob.l + length;
	var ctab = blob.read_shift(2);
	var cch = blob.read_shift(2);
	opts.sbcch = cch;
	if(cch == 0x0401 || cch == 0x3A01) return [cch, ctab];
	if(cch < 0x01 || cch >0xff) throw new Error("Unexpected SupBook type: "+cch);
	var virtPath = parse_XLUnicodeStringNoCch(blob, cch);
	/* TODO: 2.5.277 Virtual Path */
	var rgst = [];
	while(end > blob.l) rgst.push(parse_XLUnicodeString(blob));
	return [cch, ctab, virtPath, rgst];
}

/* [MS-XLS] 2.4.105 TODO */
function parse_ExternName(blob, length, opts) {
	var flags = blob.read_shift(2);
	var body;
	var o = ({
		fBuiltIn: flags & 0x01,
		fWantAdvise: (flags >>> 1) & 0x01,
		fWantPict: (flags >>> 2) & 0x01,
		fOle: (flags >>> 3) & 0x01,
		fOleLink: (flags >>> 4) & 0x01,
		cf: (flags >>> 5) & 0x3FF,
		fIcon: flags >>> 15 & 0x01
	});
	if(opts.sbcch === 0x3A01) body = parse_AddinUdf(blob, length-2, opts);
	//else throw new Error("unsupported SupBook cch: " + opts.sbcch);
	o.body = body || blob.read_shift(length-2);
	if(typeof body === "string") o.Name = body;
	return o;
}

/* [MS-XLS] 2.4.150 TODO */
var XLSLblBuiltIn = [
	"_xlnm.Consolidate_Area",
	"_xlnm.Auto_Open",
	"_xlnm.Auto_Close",
	"_xlnm.Extract",
	"_xlnm.Database",
	"_xlnm.Criteria",
	"_xlnm.Print_Area",
	"_xlnm.Print_Titles",
	"_xlnm.Recorder",
	"_xlnm.Data_Form",
	"_xlnm.Auto_Activate",
	"_xlnm.Auto_Deactivate",
	"_xlnm.Sheet_Title",
	"_xlnm._FilterDatabase"
];
function parse_Lbl(blob, length, opts) {
	var target = blob.l + length;
	var flags = blob.read_shift(2);
	var chKey = blob.read_shift(1);
	var cch = blob.read_shift(1);
	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	var itab = 0;
	if(!opts || opts.biff >= 5) {
		if(opts.biff != 5) blob.l += 2;
		itab = blob.read_shift(2);
		if(opts.biff == 5) blob.l += 2;
		blob.l += 4;
	}
	var name = parse_XLUnicodeStringNoCch(blob, cch, opts);
	if(flags & 0x20) name = XLSLblBuiltIn[name.charCodeAt(0)];
	var npflen = target - blob.l; if(opts && opts.biff == 2) --npflen;
	var rgce = target == blob.l || cce === 0 ? [] : parse_NameParsedFormula(blob, npflen, opts, cce);
	return {
		chKey: chKey,
		Name: name,
		itab: itab,
		rgce: rgce
	};
}

/* [MS-XLS] 2.4.106 TODO: verify filename encoding */
function parse_ExternSheet(blob, length, opts) {
	if(opts.biff < 8) return parse_BIFF5ExternSheet(blob, length, opts);
	var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
	while(len-- !== 0) o.push(parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
		// [iSupBook, itabFirst, itabLast];
	if(blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
	return o;
}
function parse_BIFF5ExternSheet(blob, length, opts) {
	if(blob[blob.l + 1] == 0x03) blob[blob.l]++;
	var o = parse_ShortXLUnicodeString(blob, length, opts);
	return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}

/* [MS-XLS] 2.4.176 TODO: check older biff */
function parse_NameCmt(blob, length, opts) {
	if(opts.biff < 8) { blob.l += length; return; }
	var cchName = blob.read_shift(2);
	var cchComment = blob.read_shift(2);
	var name = parse_XLUnicodeStringNoCch(blob, cchName, opts);
	var comment = parse_XLUnicodeStringNoCch(blob, cchComment, opts);
	return [name, comment];
}

/* [MS-XLS] 2.4.260 */
function parse_ShrFmla(blob, length, opts) {
	var ref = parse_RefU(blob, 6);
	blob.l++;
	var cUse = blob.read_shift(1);
	length -= 8;
	return [parse_SharedParsedFormula(blob, length, opts), cUse, ref];
}

/* [MS-XLS] 2.4.4 TODO */
function parse_Array(blob, length, opts) {
	var ref = parse_Ref(blob, 6);
	/* TODO: fAlwaysCalc */
	switch(opts.biff) {
		case 2: blob.l ++; length -= 7; break;
		case 3: case 4: blob.l += 2; length -= 8; break;
		default: blob.l += 6; length -= 12;
	}
	return [ref, parse_ArrayParsedFormula(blob, length, opts, ref)];
}

/* [MS-XLS] 2.4.173 */
function parse_MTRSettings(blob) {
	var fMTREnabled = blob.read_shift(4) !== 0x00;
	var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
	var cUserThreadCount = blob.read_shift(4);
	return [fMTREnabled, fUserSetThreadCount, cUserThreadCount];
}

/* [MS-XLS] 2.5.186 TODO: BIFF5 */
function parse_NoteSh(blob, length, opts) {
	if(opts.biff < 8) return;
	var row = blob.read_shift(2), col = blob.read_shift(2);
	var flags = blob.read_shift(2), idObj = blob.read_shift(2);
	var stAuthor = parse_XLUnicodeString2(blob, 0, opts);
	if(opts.biff < 8) blob.read_shift(1);
	return [{r:row,c:col}, stAuthor, idObj, flags];
}

/* [MS-XLS] 2.4.179 */
function parse_Note(blob, length, opts) {
	/* TODO: Support revisions */
	return parse_NoteSh(blob, length, opts);
}

/* [MS-XLS] 2.4.168 */
function parse_MergeCells(blob, length) {
	var merges = [];
	var cmcs = blob.read_shift(2);
	while (cmcs--) merges.push(parse_Ref8U(blob,length));
	return merges;
}
function write_MergeCells(merges) {
	var o = new_buf(2 + merges.length * 8);
	o.write_shift(2, merges.length);
	for(var i = 0; i < merges.length; ++i) write_Ref8U(merges[i], o);
	return o;
}

/* [MS-XLS] 2.4.181 TODO: parse all the things! */
function parse_Obj(blob, length, opts) {
	if(opts && opts.biff < 8) return parse_BIFF5Obj(blob, length, opts);
	var cmo = parse_FtCmo(blob, 22); // id, ot, flags
	var fts = parse_FtArray(blob, length-22, cmo[1]);
	return { cmo: cmo, ft:fts };
}
/* from older spec */
var parse_BIFF5OT = [];
parse_BIFF5OT[0x08] = function(blob, length) {
	var tgt = blob.l + length;
	blob.l += 10; // todo
	var cf = blob.read_shift(2);
	blob.l += 4;
	blob.l += 2; //var cbPictFmla = blob.read_shift(2);
	blob.l += 2;
	blob.l += 2; //var grbit = blob.read_shift(2);
	blob.l += 4;
	var cchName = blob.read_shift(1);
	blob.l += cchName; // TODO: stName
	blob.l = tgt; // TODO: fmla
	return { fmt:cf };
};

function parse_BIFF5Obj(blob, length, opts) {
	blob.l += 4; //var cnt = blob.read_shift(4);
	var ot = blob.read_shift(2);
	var id = blob.read_shift(2);
	var grbit = blob.read_shift(2);
	blob.l += 2; //var colL = blob.read_shift(2);
	blob.l += 2; //var dxL = blob.read_shift(2);
	blob.l += 2; //var rwT = blob.read_shift(2);
	blob.l += 2; //var dyT = blob.read_shift(2);
	blob.l += 2; //var colR = blob.read_shift(2);
	blob.l += 2; //var dxR = blob.read_shift(2);
	blob.l += 2; //var rwB = blob.read_shift(2);
	blob.l += 2; //var dyB = blob.read_shift(2);
	blob.l += 2; //var cbMacro = blob.read_shift(2);
	blob.l += 6;
	length -= 36;
	var fts = [];
	fts.push((parse_BIFF5OT[ot]||parsenoop)(blob, length, opts));
	return { cmo: [id, ot, grbit], ft:fts };
}

/* [MS-XLS] 2.4.329 TODO: parse properly */
function parse_TxO(blob, length, opts) {
	var s = blob.l;
	var texts = "";
try {
	blob.l += 4;
	var ot = (opts.lastobj||{cmo:[0,0]}).cmo[1];
	var controlInfo; // eslint-disable-line no-unused-vars
	if([0,5,7,11,12,14].indexOf(ot) == -1) blob.l += 6;
	else controlInfo = parse_ControlInfo(blob, 6, opts);
	var cchText = blob.read_shift(2);
	/*var cbRuns = */blob.read_shift(2);
	/*var ifntEmpty = */parseuint16(blob, 2);
	var len = blob.read_shift(2);
	blob.l += len;
	//var fmla = parse_ObjFmla(blob, s + length - blob.l);

	for(var i = 1; i < blob.lens.length-1; ++i) {
		if(blob.l-s != blob.lens[i]) throw new Error("TxO: bad continue record");
		var hdr = blob[blob.l];
		var t = parse_XLUnicodeStringNoCch(blob, blob.lens[i+1]-blob.lens[i]-1);
		texts += t;
		if(texts.length >= (hdr ? cchText : 2*cchText)) break;
	}
	if(texts.length !== cchText && texts.length !== cchText*2) {
		throw new Error("cchText: " + cchText + " != " + texts.length);
	}

	blob.l = s + length;
	/* [MS-XLS] 2.5.272 TxORuns */
//	var rgTxoRuns = [];
//	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
//	var cchText2 = blob.read_shift(2);
//	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
//	blob.l += 6;
//	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
	return { t: texts };
} catch(e) { blob.l = s + length; return { t: texts }; }
}

/* [MS-XLS] 2.4.140 */
function parse_HLink(blob, length) {
	var ref = parse_Ref8U(blob, 8);
	blob.l += 16; /* CLSID */
	var hlink = parse_Hyperlink(blob, length-24);
	return [ref, hlink];
}
function write_HLink(hl) {
	var O = new_buf(24);
	var ref = decode_cell(hl[0]);
	O.write_shift(2, ref.r); O.write_shift(2, ref.r);
	O.write_shift(2, ref.c); O.write_shift(2, ref.c);
	var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
	for(var i = 0; i < 16; ++i) O.write_shift(1, parseInt(clsid[i], 16));
	return bconcat([O, write_Hyperlink(hl[1])]);
}


/* [MS-XLS] 2.4.141 */
function parse_HLinkTooltip(blob, length) {
	blob.read_shift(2);
	var ref = parse_Ref8U(blob, 8);
	var wzTooltip = blob.read_shift((length-10)/2, 'dbcs-cont');
	wzTooltip = wzTooltip.replace(chr0,"");
	return [ref, wzTooltip];
}
function write_HLinkTooltip(hl) {
	var TT = hl[1].Tooltip;
	var O = new_buf(10 + 2 * (TT.length + 1));
	O.write_shift(2, 0x0800);
	var ref = decode_cell(hl[0]);
	O.write_shift(2, ref.r); O.write_shift(2, ref.r);
	O.write_shift(2, ref.c); O.write_shift(2, ref.c);
	for(var i = 0; i < TT.length; ++i) O.write_shift(2, TT.charCodeAt(i));
	O.write_shift(2, 0);
	return O;
}

/* [MS-XLS] 2.4.63 */
function parse_Country(blob) {
	var o = [0,0], d;
	d = blob.read_shift(2); o[0] = CountryEnum[d] || d;
	d = blob.read_shift(2); o[1] = CountryEnum[d] || d;
	return o;
}
function write_Country(o) {
	if(!o) o = new_buf(4);
	o.write_shift(2, 0x01);
	o.write_shift(2, 0x01);
	return o;
}

/* [MS-XLS] 2.4.50 ClrtClient */
function parse_ClrtClient(blob) {
	var ccv = blob.read_shift(2);
	var o = [];
	while(ccv-->0) o.push(parse_LongRGB(blob, 8));
	return o;
}

/* [MS-XLS] 2.4.188 */
function parse_Palette(blob) {
	var ccv = blob.read_shift(2);
	var o = [];
	while(ccv-->0) o.push(parse_LongRGB(blob, 8));
	return o;
}

/* [MS-XLS] 2.4.354 */
function parse_XFCRC(blob) {
	blob.l += 2;
	var o = {cxfs:0, crc:0};
	o.cxfs = blob.read_shift(2);
	o.crc = blob.read_shift(4);
	return o;
}

/* [MS-XLS] 2.4.53 TODO: parse flags */
/* [MS-XLSB] 2.4.323 TODO: parse flags */
function parse_ColInfo(blob, length, opts) {
	if(!opts.cellStyles) return parsenoop(blob, length);
	var w = opts && opts.biff >= 12 ? 4 : 2;
	var colFirst = blob.read_shift(w);
	var colLast = blob.read_shift(w);
	var coldx = blob.read_shift(w);
	var ixfe = blob.read_shift(w);
	var flags = blob.read_shift(2);
	if(w == 2) blob.l += 2;
	return {s:colFirst, e:colLast, w:coldx, ixfe:ixfe, flags:flags};
}

/* [MS-XLS] 2.4.257 */
function parse_Setup(blob, length) {
	var o = {};
	if(length < 32) return o;
	blob.l += 16;
	o.header = parse_Xnum(blob, 8);
	o.footer = parse_Xnum(blob, 8);
	blob.l += 2;
	return o;
}

/* [MS-XLS] 2.4.261 */
function parse_ShtProps(blob, length, opts) {
	var def = {area:false};
	if(opts.biff != 5) { blob.l += length; return def; }
	var d = blob.read_shift(1); blob.l += 3;
	if((d & 0x10)) def.area = true;
	return def;
}

/* [MS-XLS] 2.4.241 */
function write_RRTabId(n) {
	var out = new_buf(2 * n);
	for(var i = 0; i < n; ++i) out.write_shift(2, i+1);
	return out;
}

var parse_Blank = parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */
var parse_Scl = parseuint16a; /* [MS-XLS] 2.4.247 num, den */
var parse_String = parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */

/* --- Specific to versions before BIFF8 --- */
function parse_ImData(blob) {
	var cf = blob.read_shift(2);
	var env = blob.read_shift(2);
	var lcb = blob.read_shift(4);
	var o = {fmt:cf, env:env, len:lcb, data:blob.slice(blob.l,blob.l+lcb)};
	blob.l += lcb;
	return o;
}

/* BIFF2_??? where ??? is the name from [XLS] */
function parse_BIFF2STR(blob, length, opts) {
	var cell = parse_XLSCell(blob, 6);
	++blob.l;
	var str = parse_XLUnicodeString2(blob, length-7, opts);
	cell.t = 'str';
	cell.val = str;
	return cell;
}

function parse_BIFF2NUM(blob) {
	var cell = parse_XLSCell(blob, 6);
	++blob.l;
	var num = parse_Xnum(blob, 8);
	cell.t = 'n';
	cell.val = num;
	return cell;
}
function write_BIFF2NUM(r, c, val) {
	var out = new_buf(15);
	write_BIFF2Cell(out, r, c);
	out.write_shift(8, val, 'f');
	return out;
}

function parse_BIFF2INT(blob) {
	var cell = parse_XLSCell(blob, 6);
	++blob.l;
	var num = blob.read_shift(2);
	cell.t = 'n';
	cell.val = num;
	return cell;
}
function write_BIFF2INT(r, c, val) {
	var out = new_buf(9);
	write_BIFF2Cell(out, r, c);
	out.write_shift(2, val);
	return out;
}

function parse_BIFF2STRING(blob) {
	var cch = blob.read_shift(1);
	if(cch === 0) { blob.l++; return ""; }
	return blob.read_shift(cch, 'sbcs-cont');
}

/* TODO: convert to BIFF8 font struct */
function parse_BIFF2FONTXTRA(blob, length) {
	blob.l += 6; // unknown
	blob.l += 2; // font weight "bls"
	blob.l += 1; // charset
	blob.l += 3; // unknown
	blob.l += 1; // font family
	blob.l += length - 13;
}

/* TODO: parse rich text runs */
function parse_RString(blob, length, opts) {
	var end = blob.l + length;
	var cell = parse_XLSCell(blob, 6);
	var cch = blob.read_shift(2);
	var str = parse_XLUnicodeStringNoCch(blob, cch, opts);
	blob.l = end;
	cell.t = 'str';
	cell.val = str;
	return cell;
}
/* from js-harb (C) 2014-present  SheetJS */
var DBF = (function() {
var dbf_codepage_map = {
	/* Code Pages Supported by Visual FoxPro */
0x01:   437,           0x02:   850,
0x03:  1252,           0x04: 10000,
0x64:   852,           0x65:   866,
0x66:   865,           0x67:   861,
0x68:   895,           0x69:   620,
0x6A:   737,           0x6B:   857,
0x78:   950,           0x79:   949,
0x7A:   936,           0x7B:   932,
0x7C:   874,           0x7D:  1255,
0x7E:  1256,           0x96: 10007,
0x97: 10029,           0x98: 10006,
0xC8:  1250,           0xC9:  1251,
0xCA:  1254,           0xCB:  1253,

	/* shapefile DBF extension */
0x00: 20127,           0x08:   865,
0x09:   437,           0x0A:   850,
0x0B:   437,           0x0D:   437,
0x0E:   850,           0x0F:   437,
0x10:   850,           0x11:   437,
0x12:   850,           0x13:   932,
0x14:   850,           0x15:   437,
0x16:   850,           0x17:   865,
0x18:   437,           0x19:   437,
0x1A:   850,           0x1B:   437,
0x1C:   863,           0x1D:   850,
0x1F:   852,           0x22:   852,
0x23:   852,           0x24:   860,
0x25:   850,           0x26:   866,
0x37:   850,           0x40:   852,
0x4D:   936,           0x4E:   949,
0x4F:   950,           0x50:   874,
0x57:  1252,           0x58:  1252,
0x59:  1252,

0xFF: 16969
};

/* TODO: find an actual specification */
function dbf_to_aoa(buf, opts) {
	var out = [];
	/* TODO: browser based */
	var d = (new_raw_buf(1));
	switch(opts.type) {
		case 'base64': d = s2a(Base64.decode(buf)); break;
		case 'binary': d = s2a(buf); break;
		case 'buffer':
		case 'array': d = buf; break;
	}
	prep_blob(d, 0);
	/* header */
	var ft = d.read_shift(1);
	var memo = false;
	var vfp = false, l7 = false;
	switch(ft) {
		case 0x02: case 0x03: break;
		case 0x30: vfp = true; memo = true; break;
		case 0x31: vfp = true; break;
		case 0x83: memo = true; break;
		case 0x8B: memo = true; break;
		case 0x8C: memo = true; l7 = true; break;
		case 0xF5: memo = true; break;
		default: throw new Error("DBF Unsupported Version: " + ft.toString(16));
	}
	var /*filedate = new Date(),*/ nrow = 0, fpos = 0;
	if(ft == 0x02) nrow = d.read_shift(2);
	/*filedate = new Date(d.read_shift(1) + 1900, d.read_shift(1) - 1, d.read_shift(1));*/d.l += 3;
	if(ft != 0x02) nrow = d.read_shift(4);
	if(ft != 0x02) fpos = d.read_shift(2);
	var rlen = d.read_shift(2);

	var /*flags = 0,*/ current_cp = 1252;
	if(ft != 0x02) {
	d.l+=16;
	/*flags = */d.read_shift(1);
	//if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));

	/* codepage present in FoxPro */
	if(d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
	d.l+=1;

	d.l+=2;
	}
	if(l7) d.l += 36;
var fields = [], field = ({});
	var hend = fpos - 10 - (vfp ? 264 : 0), ww = l7 ? 32 : 11;
	while(ft == 0x02 ? d.l < d.length && d[d.l] != 0x0d: d.l < hend) {
		field = ({});
		field.name = cptable.utils.decode(current_cp, d.slice(d.l, d.l+ww)).replace(/[\u0000\r\n].*$/g,"");
		d.l += ww;
		field.type = String.fromCharCode(d.read_shift(1));
		if(ft != 0x02 && !l7) field.offset = d.read_shift(4);
		field.len = d.read_shift(1);
		if(ft == 0x02) field.offset = d.read_shift(2);
		field.dec = d.read_shift(1);
		if(field.name.length) fields.push(field);
		if(ft != 0x02) d.l += l7 ? 13 : 14;
		switch(field.type) {
			case 'B': // VFP Double
				if((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
				break;
			case 'G': // General
			case 'P': // Picture
				if(opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
				break;
			case 'C': // character
			case 'D': // date
			case 'F': // floating point
			case 'I': // long
			case 'L': // boolean
			case 'M': // memo
			case 'N': // number
			case 'O': // double
			case 'T': // datetime
			case 'Y': // currency
			case '0': // VFP _NullFlags
			case '@': // timestamp
			case '+': // autoincrement
				break;
			default: throw new Error('Unknown Field Type: ' + field.type);
		}
	}
	if(d[d.l] !== 0x0D) d.l = fpos-1;
	else if(ft == 0x02) d.l = 0x209;
	if(ft != 0x02) {
		if(d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
		d.l = fpos;
	}
	/* data */
	var R = 0, C = 0;
	out[0] = [];
	for(C = 0; C != fields.length; ++C) out[0][C] = fields[C].name;
	while(nrow-- > 0) {
		if(d[d.l] === 0x2A) { d.l+=rlen; continue; }
		++d.l;
		out[++R] = []; C = 0;
		for(C = 0; C != fields.length; ++C) {
			var dd = d.slice(d.l, d.l+fields[C].len); d.l+=fields[C].len;
			prep_blob(dd, 0);
			var s = cptable.utils.decode(current_cp, dd);
			switch(fields[C].type) {
				case 'C':
					out[R][C] = cptable.utils.decode(current_cp, dd);
					out[R][C] = out[R][C].trim();
					break;
				case 'D':
					if(s.length === 8) out[R][C] = new Date(+s.slice(0,4), +s.slice(4,6)-1, +s.slice(6,8));
					else out[R][C] = s;
					break;
				case 'F': out[R][C] = parseFloat(s.trim()); break;
				case '+': case 'I': out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i'); break;
				case 'L': switch(s.toUpperCase()) {
					case 'Y': case 'T': out[R][C] = true; break;
					case 'N': case 'F': out[R][C] = false; break;
					case ' ': case '?': out[R][C] = false; break; /* NOTE: technically uninitialized */
					default: throw new Error("DBF Unrecognized L:|" + s + "|");
					} break;
				case 'M': /* TODO: handle memo files */
					if(!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
					out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10): dd.read_shift(4));
					break;
				case 'N': out[R][C] = +s.replace(/\u0000/g,"").trim(); break;
				case '@': out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400); break;
				case 'T': out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4)); break;
				case 'Y': out[R][C] = dd.read_shift(4,'i')/1e4; break;
				case 'O': out[R][C] = -dd.read_shift(-8, 'f'); break;
				case 'B': if(vfp && fields[C].len == 8) { out[R][C] = dd.read_shift(8,'f'); break; }
					/* falls through */
				case 'G': case 'P': dd.l += fields[C].len; break;
				case '0':
					if(fields[C].name === '_NullFlags') break;
					/* falls through */
				default: throw new Error("DBF Unsupported data type " + fields[C].type);
			}
		}
	}
	if(ft != 0x02) if(d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l-1) + " of " + d.length + " " + d[d.l-1].toString(16));
	if(opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
	return out;
}

function dbf_to_sheet(buf, opts) {
	var o = opts || {};
	if(!o.dateNF) o.dateNF = "yyyymmdd";
	return aoa_to_sheet(dbf_to_aoa(buf, o), o);
}

function dbf_to_workbook(buf, opts) {
	try { return sheet_to_workbook(dbf_to_sheet(buf, opts), opts); }
	catch(e) { if(opts && opts.WTF) throw e; }
	return ({SheetNames:[],Sheets:{}});
}

var _RLEN = { 'B': 8, 'C': 250, 'L': 1, 'D': 8, '?': 0, '': 0 };
function sheet_to_dbf(ws, opts) {
	var o = opts || {};
	if(o.type == "string") throw new Error("Cannot write DBF to JS string");
	var ba = buf_array();
	var aoa = sheet_to_json(ws, {header:1, raw:true, cellDates:true});
	var headers = aoa[0], data = aoa.slice(1);
	var i = 0, j = 0, hcnt = 0, rlen = 1;
	for(i = 0; i < headers.length; ++i) {
		if(i == null) continue;
		++hcnt;
		if(typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
		if(typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + (typeof headers[i]) + "|");
		if(headers.indexOf(headers[i]) !== i) for(j=0; j<1024;++j)
			if(headers.indexOf(headers[i] + "_" + j) == -1) { headers[i] += "_" + j; break; }
	}
	var range = safe_decode_range(ws['!ref']);
	var coltypes = [];
	for(i = 0; i <= range.e.c - range.s.c; ++i) {
		var col = [];
		for(j=0; j < data.length; ++j) {
			if(data[j][i] != null) col.push(data[j][i]);
		}
		if(col.length == 0 || headers[i] == null) { coltypes[i] = '?'; continue; }
		var guess = '', _guess = '';
		for(j = 0; j < col.length; ++j) {
			switch(typeof col[j]) {
				/* TODO: check if L2 compat is desired */
				case 'number': _guess = 'B'; break;
				case 'string': _guess = 'C'; break;
				case 'boolean': _guess = 'L'; break;
				case 'object': _guess = col[j] instanceof Date ? 'D' : 'C'; break;
				default: _guess = 'C';
			}
			guess = guess && guess != _guess ? 'C' : _guess;
			if(guess == 'C') break;
		}
		rlen += _RLEN[guess] || 0;
		coltypes[i] = guess;
	}

	var h = ba.next(32);
	h.write_shift(4, 0x13021130);
	h.write_shift(4, data.length);
	h.write_shift(2, 296 + 32 * hcnt);
	h.write_shift(2, rlen);
	for(i=0; i < 4; ++i) h.write_shift(4, 0);
	h.write_shift(4, 0x00000300); // TODO: CP

	for(i = 0, j = 0; i < headers.length; ++i) {
		if(headers[i] == null) continue;
		var hf = ba.next(32);
		var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
		hf.write_shift(1, _f, "sbcs");
		hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
		hf.write_shift(4, j);
		hf.write_shift(1, _RLEN[coltypes[i]] || 0);
		hf.write_shift(1, 0);
		hf.write_shift(1, 0x02);
		hf.write_shift(4, 0);
		hf.write_shift(1, 0);
		hf.write_shift(4, 0);
		hf.write_shift(4, 0);
		j += _RLEN[coltypes[i]] || 0;
	}

	var hb = ba.next(264);
	hb.write_shift(4, 0x0000000D);
	for(i=0; i < 65;++i) hb.write_shift(4, 0x00000000);
	for(i=0; i < data.length; ++i) {
		var rout = ba.next(rlen);
		rout.write_shift(1, 0);
		for(j=0; j<headers.length; ++j) {
			if(headers[j] == null) continue;
			switch(coltypes[j]) {
				case 'L': rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46); break;
				case 'B': rout.write_shift(8, data[i][j]||0, 'f'); break;
				case 'D':
					if(!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
					else {
						rout.write_shift(4, ("0000"+data[i][j].getFullYear()).slice(-4), "sbcs");
						rout.write_shift(2, ("00"+(data[i][j].getMonth()+1)).slice(-2), "sbcs");
						rout.write_shift(2, ("00"+data[i][j].getDate()).slice(-2), "sbcs");
					} break;
				case 'C':
					var _s = String(data[i][j]||"");
					rout.write_shift(1, _s, "sbcs");
					for(hcnt=0; hcnt < 250-_s.length; ++hcnt) rout.write_shift(1, 0x20); break;
			}
		}
		// data
	}
	ba.next(1).write_shift(1, 0x1A);
	return ba.end();
}
	return {
		to_workbook: dbf_to_workbook,
		to_sheet: dbf_to_sheet,
		from_sheet: sheet_to_dbf
	};
})();

var SYLK = (function() {
	/* TODO: find an actual specification */
	function sylk_to_aoa(d, opts) {
		switch(opts.type) {
			case 'base64': return sylk_to_aoa_str(Base64.decode(d), opts);
			case 'binary': return sylk_to_aoa_str(d, opts);
			case 'buffer': return sylk_to_aoa_str(d.toString('binary'), opts);
			case 'array': return sylk_to_aoa_str(cc2str(d), opts);
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	function sylk_to_aoa_str(str, opts) {
		var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr = [];
		var formats = [];
		var next_cell_format = null;
		var sht = {}, rowinfo = [], colinfo = [], cw = [];
		var Mval = 0, j;
		for (; ri !== records.length; ++ri) {
			Mval = 0;
			var rstr=records[ri].trim();
			var record=rstr.replace(/;;/g, "\u0001").split(";").map(function(x) { return x.replace(/\u0001/g, ";"); });
			var RT=record[0], val;
			if(rstr.length > 0) switch(RT) {
			case 'ID': break; /* header */
			case 'E': break; /* EOF */
			case 'B': break; /* dimensions */
			case 'O': break; /* options? */
			case 'P':
				if(record[1].charAt(0) == 'P')
					formats.push(rstr.slice(3).replace(/;;/g, ";"));
				break;
			case 'C':
			var C_seen_K = false, C_seen_X = false;
			for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
				case 'X': C = parseInt(record[rj].slice(1))-1; C_seen_X = true; break;
				case 'Y':
					R = parseInt(record[rj].slice(1))-1; if(!C_seen_X) C = 0;
					for(j = arr.length; j <= R; ++j) arr[j] = [];
					break;
				case 'K':
					val = record[rj].slice(1);
					if(val.charAt(0) === '"') val = val.slice(1,val.length - 1);
					else if(val === 'TRUE') val = true;
					else if(val === 'FALSE') val = false;
					else if(!isNaN(fuzzynum(val))) {
						val = fuzzynum(val);
						if(next_cell_format !== null && SSF.is_date(next_cell_format)) val = numdate(val);
					} else if(!isNaN(fuzzydate(val).getDate())) {
						val = parseDate(val);
					}
					if(typeof cptable !== 'undefined' && typeof val == "string" && ((opts||{}).type != "string") && (opts||{}).codepage) val = cptable.utils.decode(opts.codepage, val);
					C_seen_K = true;
					break;
				case 'E':
					var formula = rc_to_a1(record[rj].slice(1), {r:R,c:C});
					arr[R][C] = [arr[R][C], formula];
					break;
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
			}
			if(C_seen_K) { arr[R][C] = val; next_cell_format = null; }
			break;
			case 'F':
			var F_seen = 0;
			for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
				case 'X': C = parseInt(record[rj].slice(1))-1; ++F_seen; break;
				case 'Y':
					R = parseInt(record[rj].slice(1))-1; /*C = 0;*/
					for(j = arr.length; j <= R; ++j) arr[j] = [];
					break;
				case 'M': Mval = parseInt(record[rj].slice(1)) / 20; break;
				case 'F': break; /* ??? */
				case 'G': break; /* hide grid */
				case 'P':
					next_cell_format = formats[parseInt(record[rj].slice(1))];
					break;
				case 'S': break; /* cell style */
				case 'D': break; /* column */
				case 'N': break; /* font */
				case 'W':
					cw = record[rj].slice(1).split(" ");
					for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j) {
						Mval = parseInt(cw[2], 10);
						colinfo[j-1] = Mval === 0 ? {hidden:true}: {wch:Mval}; process_col(colinfo[j-1]);
					} break;
				case 'C': /* default column format */
					C = parseInt(record[rj].slice(1))-1;
					if(!colinfo[C]) colinfo[C] = {};
					break;
				case 'R': /* row properties */
					R = parseInt(record[rj].slice(1))-1;
					if(!rowinfo[R]) rowinfo[R] = {};
					if(Mval > 0) { rowinfo[R].hpt = Mval; rowinfo[R].hpx = pt2px(Mval); }
					else if(Mval === 0) rowinfo[R].hidden = true;
					break;
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
			}
			if(F_seen < 1) next_cell_format = null; break;
			default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
			}
		}
		if(rowinfo.length > 0) sht['!rows'] = rowinfo;
		if(colinfo.length > 0) sht['!cols'] = colinfo;
		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
		return [arr, sht];
	}

	function sylk_to_sheet(d, opts) {
		var aoasht = sylk_to_aoa(d, opts);
		var aoa = aoasht[0], ws = aoasht[1];
		var o = aoa_to_sheet(aoa, opts);
		keys(ws).forEach(function(k) { o[k] = ws[k]; });
		return o;
	}

	function sylk_to_workbook(d, opts) { return sheet_to_workbook(sylk_to_sheet(d, opts), opts); }

	function write_ws_cell_sylk(cell, ws, R, C) {
		var o = "C;Y" + (R+1) + ";X" + (C+1) + ";K";
		switch(cell.t) {
			case 'n':
				o += (cell.v||0);
				if(cell.f && !cell.F) o += ";E" + a1_to_rc(cell.f, {r:R, c:C}); break;
			case 'b': o += cell.v ? "TRUE" : "FALSE"; break;
			case 'e': o += cell.w || cell.v; break;
			case 'd': o += '"' + (cell.w || cell.v) + '"'; break;
			case 's': o += '"' + cell.v.replace(/"/g,"") + '"'; break;
		}
		return o;
	}

	function write_ws_cols_sylk(out, cols) {
		cols.forEach(function(col, i) {
			var rec = "F;W" + (i+1) + " " + (i+1) + " ";
			if(col.hidden) rec += "0";
			else {
				if(typeof col.width == 'number') col.wpx = width2px(col.width);
				if(typeof col.wpx == 'number') col.wch = px2char(col.wpx);
				if(typeof col.wch == 'number') rec += Math.round(col.wch);
			}
			if(rec.charAt(rec.length - 1) != " ") out.push(rec);
		});
	}

	function write_ws_rows_sylk(out, rows) {
		rows.forEach(function(row, i) {
			var rec = "F;";
			if(row.hidden) rec += "M0;";
			else if(row.hpt) rec += "M" + 20 * row.hpt + ";";
			else if(row.hpx) rec += "M" + 20 * px2pt(row.hpx) + ";";
			if(rec.length > 2) out.push(rec + "R" + (i+1));
		});
	}

	function sheet_to_sylk(ws, opts) {
		var preamble = ["ID;PWXL;N;E"], o = [];
		var r = safe_decode_range(ws['!ref']), cell;
		var dense = Array.isArray(ws);
		var RS = "\r\n";

		preamble.push("P;PGeneral");
		preamble.push("F;P0;DG0G8;M255");
		if(ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
		if(ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);

		preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [r.s.c,r.s.r,r.e.c,r.e.r].join(" "));
		for(var R = r.s.r; R <= r.e.r; ++R) {
			for(var C = r.s.c; C <= r.e.c; ++C) {
				var coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C]: ws[coord];
				if(!cell || (cell.v == null && (!cell.f || cell.F))) continue;
				o.push(write_ws_cell_sylk(cell, ws, R, C, opts));
			}
		}
		return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
	}

	return {
		to_workbook: sylk_to_workbook,
		to_sheet: sylk_to_sheet,
		from_sheet: sheet_to_sylk
	};
})();

var DIF = (function() {
	function dif_to_aoa(d, opts) {
		switch(opts.type) {
			case 'base64': return dif_to_aoa_str(Base64.decode(d), opts);
			case 'binary': return dif_to_aoa_str(d, opts);
			case 'buffer': return dif_to_aoa_str(d.toString('binary'), opts);
			case 'array': return dif_to_aoa_str(cc2str(d), opts);
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	function dif_to_aoa_str(str, opts) {
		var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
		for (; ri !== records.length; ++ri) {
			if (records[ri].trim() === 'BOT') { arr[++R] = []; C = 0; continue; }
			if (R < 0) continue;
			var metadata = records[ri].trim().split(",");
			var type = metadata[0], value = metadata[1];
			++ri;
			var data = records[ri].trim();
			switch (+type) {
				case -1:
					if (data === 'BOT') { arr[++R] = []; C = 0; continue; }
					else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
					break;
				case 0:
					if(data === 'TRUE') arr[R][C] = true;
					else if(data === 'FALSE') arr[R][C] = false;
					else if(!isNaN(fuzzynum(value))) arr[R][C] = fuzzynum(value);
					else if(!isNaN(fuzzydate(value).getDate())) arr[R][C] = parseDate(value);
					else arr[R][C] = value;
					++C; break;
				case 1:
					data = data.slice(1,data.length-1);
					arr[R][C++] = data !== '' ? data : null;
					break;
			}
			if (data === 'EOD') break;
		}
		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
		return arr;
	}

	function dif_to_sheet(str, opts) { return aoa_to_sheet(dif_to_aoa(str, opts), opts); }
	function dif_to_workbook(str, opts) { return sheet_to_workbook(dif_to_sheet(str, opts), opts); }

	var sheet_to_dif = (function() {
		var push_field = function pf(o, topic, v, n, s) {
			o.push(topic);
			o.push(v + "," + n);
			o.push('"' + s.replace(/"/g,'""') + '"');
		};
		var push_value = function po(o, type, v, s) {
			o.push(type + "," + v);
			o.push(type == 1 ? '"' + s.replace(/"/g,'""') + '"' : s);
		};
		return function sheet_to_dif(ws) {
			var o = [];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			push_field(o, "TABLE", 0, 1, "sheetjs");
			push_field(o, "VECTORS", 0, r.e.r - r.s.r + 1,"");
			push_field(o, "TUPLES", 0, r.e.c - r.s.c + 1,"");
			push_field(o, "DATA", 0, 0,"");
			for(var R = r.s.r; R <= r.e.r; ++R) {
				push_value(o, -1, 0, "BOT");
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell) { push_value(o, 1, 0, ""); continue;}
					switch(cell.t) {
						case 'n':
							var val = DIF_XL ? cell.w : cell.v;
							if(!val && cell.v != null) val = cell.v;
							if(val == null) {
								if(DIF_XL && cell.f && !cell.F) push_value(o, 1, 0, "=" + cell.f);
								else push_value(o, 1, 0, "");
							}
							else push_value(o, 0, val, "V");
							break;
						case 'b':
							push_value(o, 0, cell.v ? 1 : 0, cell.v ? "TRUE" : "FALSE");
							break;
						case 's':
							push_value(o, 1, 0, (!DIF_XL || isNaN(cell.v)) ? cell.v : '="' + cell.v + '"');
							break;
						case 'd':
							if(!cell.w) cell.w = SSF.format(cell.z || SSF._table[14], datenum(parseDate(cell.v)));
							if(DIF_XL) push_value(o, 0, cell.w, "V");
							else push_value(o, 1, 0, cell.w);
							break;
						default: push_value(o, 1, 0, "");
					}
				}
			}
			push_value(o, -1, 0, "EOD");
			var RS = "\r\n";
			var oo = o.join(RS);
			//while((oo.length & 0x7F) != 0) oo += "\0";
			return oo;
		};
	})();
	return {
		to_workbook: dif_to_workbook,
		to_sheet: dif_to_sheet,
		from_sheet: sheet_to_dif
	};
})();

var ETH = (function() {
	function decode(s) { return s.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n"); }
	function encode(s) { return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g,"\\n"); }

	function eth_to_aoa(str, opts) {
		var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
		for (; ri !== records.length; ++ri) {
			var record = records[ri].trim().split(":");
			if(record[0] !== 'cell') continue;
			var addr = decode_cell(record[1]);
			if(arr.length <= addr.r) for(R = arr.length; R <= addr.r; ++R) if(!arr[R]) arr[R] = [];
			R = addr.r; C = addr.c;
			switch(record[2]) {
				case 't': arr[R][C] = decode(record[3]); break;
				case 'v': arr[R][C] = +record[3]; break;
				case 'vtf': var _f = record[record.length - 1];
					/* falls through */
				case 'vtc':
					switch(record[3]) {
						case 'nl': arr[R][C] = +record[4] ? true : false; break;
						default: arr[R][C] = +record[4]; break;
					}
					if(record[2] == 'vtf') arr[R][C] = [arr[R][C], _f];
			}
		}
		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
		return arr;
	}

	function eth_to_sheet(d, opts) { return aoa_to_sheet(eth_to_aoa(d, opts), opts); }
	function eth_to_workbook(d, opts) { return sheet_to_workbook(eth_to_sheet(d, opts), opts); }

	var header = [
		"socialcalc:version:1.5",
		"MIME-Version: 1.0",
		"Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
	].join("\n");

	var sep = [
		"--SocialCalcSpreadsheetControlSave",
		"Content-type: text/plain; charset=UTF-8"
	].join("\n") + "\n";

	/* TODO: the other parts */
	var meta = [
		"# SocialCalc Spreadsheet Control Save",
		"part:sheet"
	].join("\n");

	var end = "--SocialCalcSpreadsheetControlSave--";

	function sheet_to_eth_data(ws) {
		if(!ws || !ws['!ref']) return "";
		var o = [], oo = [], cell, coord = "";
		var r = decode_range(ws['!ref']);
		var dense = Array.isArray(ws);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			for(var C = r.s.c; C <= r.e.c; ++C) {
				coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C] : ws[coord];
				if(!cell || cell.v == null || cell.t === 'z') continue;
				oo = ["cell", coord, 't'];
				switch(cell.t) {
					case 's': case 'str': oo.push(encode(cell.v)); break;
					case 'n':
						if(!cell.f) { oo[2]='v'; oo[3]=cell.v; }
						else { oo[2]='vtf'; oo[3]='n'; oo[4]=cell.v; oo[5]=encode(cell.f); }
						break;
					case 'b':
						oo[2] = 'vt'+(cell.f?'f':'c'); oo[3]='nl'; oo[4]=cell.v?"1":"0";
						oo[5] = encode(cell.f||(cell.v?'TRUE':'FALSE'));
						break;
					case 'd':
						var t = datenum(parseDate(cell.v));
						oo[2] = 'vtc'; oo[3] = 'nd'; oo[4] = ""+t;
						oo[5] = cell.w || SSF.format(cell.z || SSF._table[14], t);
						break;
					case 'e': continue;
				}
				o.push(oo.join(":"));
			}
		}
		o.push("sheet:c:" + (r.e.c-r.s.c+1) + ":r:" + (r.e.r-r.s.r+1) + ":tvf:1");
		o.push("valueformat:1:text-wiki");
		//o.push("copiedfrom:" + ws['!ref']); // clipboard only
		return o.join("\n");
	}

	function sheet_to_eth(ws) {
		return [header, sep, meta, sep, sheet_to_eth_data(ws), end].join("\n");
		// return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
	}

	return {
		to_workbook: eth_to_workbook,
		to_sheet: eth_to_sheet,
		from_sheet: sheet_to_eth
	};
})();

var PRN = (function() {
	function set_text_arr(data, arr, R, C, o) {
		if(o.raw) arr[R][C] = data;
		else if(data === 'TRUE') arr[R][C] = true;
		else if(data === 'FALSE') arr[R][C] = false;
		else if(data === ""){/* empty */}
		else if(!isNaN(fuzzynum(data))) arr[R][C] = fuzzynum(data);
		else if(!isNaN(fuzzydate(data).getDate())) arr[R][C] = parseDate(data);
		else arr[R][C] = data;
	}

	function prn_to_aoa_str(f, opts) {
		var o = opts || {};
		var arr = ([]);
		if(!f || f.length === 0) return arr;
		var lines = f.split(/[\r\n]/);
		var L = lines.length - 1;
		while(L >= 0 && lines[L].length === 0) --L;
		var start = 10, idx = 0;
		var R = 0;
		for(; R <= L; ++R) {
			idx = lines[R].indexOf(" ");
			if(idx == -1) idx = lines[R].length; else idx++;
			start = Math.max(start, idx);
		}
		for(R = 0; R <= L; ++R) {
			arr[R] = [];
			/* TODO: confirm that widths are always 10 */
			var C = 0;
			set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
			for(C = 1; C <= (lines[R].length - start)/10 + 1; ++C)
				set_text_arr(lines[R].slice(start+(C-1)*10,start+C*10).trim(),arr,R,C,o);
		}
		if(o.sheetRows) arr = arr.slice(0, o.sheetRows);
		return arr;
	}

	// List of accepted CSV separators
	var guess_seps = {
0x2C: ',',
0x09: "\t",
0x3B: ';'
	};

	// CSV separator weights to be used in case of equal numbers
	var guess_sep_weights = {
0x2C: 3,
0x09: 2,
0x3B: 1
	};

	function guess_sep(str) {
		var cnt = {}, instr = false, end = 0, cc = 0;
		for(;end < str.length;++end) {
			if((cc=str.charCodeAt(end)) == 0x22) instr = !instr;
			else if(!instr && cc in guess_seps) cnt[cc] = (cnt[cc]||0)+1;
		}

		cc = [];
		for(end in cnt) if ( cnt.hasOwnProperty(end) ) {
			cc.push([ cnt[end], end ]);
		}

		if ( !cc.length ) {
			cnt = guess_sep_weights;
			for(end in cnt) if ( cnt.hasOwnProperty(end) ) {
				cc.push([ cnt[end], end ]);
			}
		}

		cc.sort(function(a, b) { return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]]; });

		return guess_seps[cc.pop()[1]];
	}

	function dsv_to_sheet_str(str, opts) {
		var o = opts || {};
		var sep = "";
		if(DENSE != null && o.dense == null) o.dense = DENSE;
		var ws = o.dense ? ([]) : ({});
		var range = ({s: {c:0, r:0}, e: {c:0, r:0}});

		if(str.slice(0,4) == "sep=" && str.charCodeAt(5) == 10) { sep = str.charAt(4); str = str.slice(6); }
		else sep = guess_sep(str.slice(0,1024));
		var R = 0, C = 0, v = 0;
		var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc=0;
		str = str.replace(/\r\n/mg, "\n");
		var _re = o.dateNF != null ? dateNF_regex(o.dateNF) : null;
		function finish_cell() {
			var s = str.slice(start, end);
			var cell = ({});
			if(s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1,-1).replace(/""/g,'"');
			if(s.length === 0) cell.t = 'z';
			else if(o.raw) { cell.t = 's'; cell.v = s; }
			else if(s.trim().length === 0) { cell.t = 's'; cell.v = s; }
			else if(s.charCodeAt(0) == 0x3D) {
				if(s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) { cell.t = 's'; cell.v = s.slice(2,-1).replace(/""/g,'"'); }
				else if(fuzzyfmla(s)) { cell.t = 'n'; cell.f = s.slice(1); }
				else { cell.t = 's'; cell.v = s; } }
			else if(s == "TRUE") { cell.t = 'b'; cell.v = true; }
			else if(s == "FALSE") { cell.t = 'b'; cell.v = false; }
			else if(!isNaN(v = fuzzynum(s))) { cell.t = 'n'; if(o.cellText !== false) cell.w = s; cell.v = v; }
			else if(!isNaN(fuzzydate(s).getDate()) || _re && s.match(_re)) {
				cell.z = o.dateNF || SSF._table[14];
				var k = 0;
				if(_re && s.match(_re)){ s=dateNF_fix(s, o.dateNF, (s.match(_re)||[])); k=1; }
				if(o.cellDates) { cell.t = 'd'; cell.v = parseDate(s, k); }
				else { cell.t = 'n'; cell.v = datenum(parseDate(s, k)); }
				if(o.cellText !== false) cell.w = SSF.format(cell.z, cell.v instanceof Date ? datenum(cell.v):cell.v);
				if(!o.cellNF) delete cell.z;
			} else {
				cell.t = 's';
				cell.v = s;
			}
			if(cell.t == 'z'){}
			else if(o.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = cell; }
			else ws[encode_cell({c:C,r:R})] = cell;
			start = end+1;
			if(range.e.c < C) range.e.c = C;
			if(range.e.r < R) range.e.r = R;
			if(cc == sepcc) ++C; else { C = 0; ++R; if(o.sheetRows && o.sheetRows <= R) return true; }
		}
		outer: for(;end < str.length;++end) switch((cc=str.charCodeAt(end))) {
			case 0x22: instr = !instr; break;
			case sepcc: case 0x0a: case 0x0d: if(!instr && finish_cell()) break outer; break;
			default: break;
		}
		if(end - start > 0) finish_cell();

		ws['!ref'] = encode_range(range);
		return ws;
	}

	function prn_to_sheet_str(str, opts) {
		if(str.slice(0,4) == "sep=") return dsv_to_sheet_str(str, opts);
		if(str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
		return aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
	}

	function prn_to_sheet(d, opts) {
		var str = "", bytes = opts.type == 'string' ? [0,0,0,0] : firstbyte(d, opts);
		switch(opts.type) {
			case 'base64': str = Base64.decode(d); break;
			case 'binary': str = d; break;
			case 'buffer':
				if(opts.codepage == 65001) str = d.toString('utf8');
				else if(opts.codepage && typeof cptable !== 'undefined') str = cptable.utils.decode(opts.codepage, d);
				else str = d.toString('binary');
				break;
			case 'array': str = cc2str(d); break;
			case 'string': str = d; break;
			default: throw new Error("Unrecognized type " + opts.type);
		}
		if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str.slice(3));
		else if((opts.type == 'binary') && typeof cptable !== 'undefined' && opts.codepage)  str = cptable.utils.decode(opts.codepage, cptable.utils.encode(1252,str));
		if(str.slice(0,19) == "socialcalc:version:") return ETH.to_sheet(opts.type == 'string' ? str : utf8read(str), opts);
		return prn_to_sheet_str(str, opts);
	}

	function prn_to_workbook(d, opts) { return sheet_to_workbook(prn_to_sheet(d, opts), opts); }

	function sheet_to_prn(ws) {
		var o = [];
		var r = safe_decode_range(ws['!ref']), cell;
		var dense = Array.isArray(ws);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			var oo = [];
			for(var C = r.s.c; C <= r.e.c; ++C) {
				var coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C] : ws[coord];
				if(!cell || cell.v == null) { oo.push("          "); continue; }
				var w = (cell.w || (format_cell(cell), cell.w) || "").slice(0,10);
				while(w.length < 10) w += " ";
				oo.push(w + (C === 0 ? " " : ""));
			}
			o.push(oo.join(""));
		}
		return o.join("\n");
	}

	return {
		to_workbook: prn_to_workbook,
		to_sheet: prn_to_sheet,
		from_sheet: sheet_to_prn
	};
})();

/* Excel defaults to SYLK but warns if data is not valid */
function read_wb_ID(d, opts) {
	var o = opts || {}, OLD_WTF = !!o.WTF; o.WTF = true;
	try {
		var out = SYLK.to_workbook(d, o);
		o.WTF = OLD_WTF;
		return out;
	} catch(e) {
		o.WTF = OLD_WTF;
		if(!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
		return PRN.to_workbook(d, opts);
	}
}
var WK_ = (function() {
	function lotushopper(data, cb, opts) {
		if(!data) return;
		prep_blob(data, data.l || 0);
		var Enum = opts.Enum || WK1Enum;
		while(data.l < data.length) {
			var RT = data.read_shift(2);
			var R = Enum[RT] || Enum[0xFF];
			var length = data.read_shift(2);
			var tgt = data.l + length;
			var d = (R.f||parsenoop)(data, length, opts);
			data.l = tgt;
			if(cb(d, R.n, RT)) return;
		}
	}

	function lotus_to_workbook(d, opts) {
		switch(opts.type) {
			case 'base64': return lotus_to_workbook_buf(s2a(Base64.decode(d)), opts);
			case 'binary': return lotus_to_workbook_buf(s2a(d), opts);
			case 'buffer':
			case 'array': return lotus_to_workbook_buf(d, opts);
		}
		throw "Unsupported type " + opts.type;
	}

	function lotus_to_workbook_buf(d, opts) {
		if(!d) return d;
		var o = opts || {};
		if(DENSE != null && o.dense == null) o.dense = DENSE;
		var s = ((o.dense ? [] : {})), n = "Sheet1", sidx = 0;
		var sheets = {}, snames = [n];

		var refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
		var sheetRows = o.sheetRows || 0;

		if(d[2] == 0x02) o.Enum = WK1Enum;
		else if(d[2] == 0x1a) o.Enum = WK3Enum;
		else if(d[2] == 0x0e) { o.Enum = WK3Enum; o.qpro = true; d.l = 0; }
		else throw new Error("Unrecognized LOTUS BOF " + d[2]);
		lotushopper(d, function(val, Rn, RT) {
			if(d[2] == 0x02) switch(RT) {
				case 0x00:
					o.vers = val;
					if(val >= 0x1000) o.qpro = true;
					break;
				case 0x06: refguess = val; break; /* RANGE */
				case 0x0F: /* LABEL */
					if(!o.qpro) val[1].v = val[1].v.slice(1);
					/* falls through */
				case 0x0D: /* INTEGER */
				case 0x0E: /* NUMBER */
				case 0x10: /* FORMULA */
				case 0x33: /* STRING */
					/* TODO: actual translation of the format code */
					if(RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
						val[1].z = o.dateNF || SSF._table[14];
						if(o.cellDates) { val[1].t = 'd'; val[1].v = numdate(val[1].v); }
					}
					if(o.dense) {
						if(!s[val[0].r]) s[val[0].r] = [];
						s[val[0].r][val[0].c] = val[1];
					} else s[encode_cell(val[0])] = val[1];
					break;
			} else switch(RT) {
				case 0x16: /* LABEL16 */
					val[1].v = val[1].v.slice(1);
					/* falls through */
				case 0x17: /* NUMBER17 */
				case 0x18: /* NUMBER18 */
				case 0x19: /* FORMULA19 */
				case 0x25: /* NUMBER25 */
				case 0x27: /* NUMBER27 */
				case 0x28: /* FORMULA28 */
					if(val[3] > sidx) {
						s["!ref"] = encode_range(refguess);
						sheets[n] = s;
						s = (o.dense ? [] : {});
						refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
						sidx = val[3]; n = "Sheet" + (sidx + 1);
						snames.push(n);
					}
					if(sheetRows > 0 && val[0].r >= sheetRows) break;
					if(o.dense) {
						if(!s[val[0].r]) s[val[0].r] = [];
						s[val[0].r][val[0].c] = val[1];
					} else s[encode_cell(val[0])] = val[1];
					if(refguess.e.c < val[0].c) refguess.e.c = val[0].c;
					if(refguess.e.r < val[0].r) refguess.e.r = val[0].r;
					break;
				default: break;
			}
		}, o);

		s["!ref"] = encode_range(refguess);
		sheets[n] = s;
		return { SheetNames: snames, Sheets:sheets };
	}

	function parse_RANGE(blob) {
		var o = {s:{c:0,r:0},e:{c:0,r:0}};
		o.s.c = blob.read_shift(2);
		o.s.r = blob.read_shift(2);
		o.e.c = blob.read_shift(2);
		o.e.r = blob.read_shift(2);
		if(o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
		return o;
	}

	function parse_cell(blob, length, opts) {
		var o = [{c:0,r:0}, {t:'n',v:0}, 0];
		if(opts.qpro && opts.vers != 0x5120) {
			o[0].c = blob.read_shift(1);
			blob.l++;
			o[0].r = blob.read_shift(2);
			blob.l+=2;
		} else {
			o[2] = blob.read_shift(1);
			o[0].c = blob.read_shift(2); o[0].r = blob.read_shift(2);
		}
		return o;
	}

	function parse_LABEL(blob, length, opts) {
		var tgt = blob.l + length;
		var o = parse_cell(blob, length, opts);
		o[1].t = 's';
		if(opts.vers == 0x5120) {
			blob.l++;
			var len = blob.read_shift(1);
			o[1].v = blob.read_shift(len, 'utf8');
			return o;
		}
		if(opts.qpro) blob.l++;
		o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
		return o;
	}

	function parse_INTEGER(blob, length, opts) {
		var o = parse_cell(blob, length, opts);
		o[1].v = blob.read_shift(2, 'i');
		return o;
	}

	function parse_NUMBER(blob, length, opts) {
		var o = parse_cell(blob, length, opts);
		o[1].v = blob.read_shift(8, 'f');
		return o;
	}

	function parse_FORMULA(blob, length, opts) {
		var tgt = blob.l + length;
		var o = parse_cell(blob, length, opts);
		/* TODO: formula */
		o[1].v = blob.read_shift(8, 'f');
		if(opts.qpro) blob.l = tgt;
		else {
			var flen = blob.read_shift(2);
			blob.l += flen;
		}
		return o;
	}

	function parse_cell_3(blob) {
		var o = [{c:0,r:0}, {t:'n',v:0}, 0];
		o[0].r = blob.read_shift(2); o[3] = blob[blob.l++]; o[0].c = blob[blob.l++];
		return o;
	}

	function parse_LABEL_16(blob, length) {
		var o = parse_cell_3(blob, length);
		o[1].t = 's';
		o[1].v = blob.read_shift(length - 4, 'cstr');
		return o;
	}

	function parse_NUMBER_18(blob, length) {
		var o = parse_cell_3(blob, length);
		o[1].v = blob.read_shift(2);
		var v = o[1].v >> 1;
		/* TODO: figure out all of the corner cases */
		if(o[1].v & 0x1) {
			switch(v & 0x07) {
				case 1: v = (v >> 3) * 500; break;
				case 2: v = (v >> 3) / 20; break;
				case 4: v = (v >> 3) / 2000; break;
				case 6: v = (v >> 3) / 16; break;
				case 7: v = (v >> 3) / 64; break;
				default: throw "unknown NUMBER_18 encoding " + (v & 0x07);
			}
		}
		o[1].v = v;
		return o;
	}

	function parse_NUMBER_17(blob, length) {
		var o = parse_cell_3(blob, length);
		var v1 = blob.read_shift(4);
		var v2 = blob.read_shift(4);
		var e = blob.read_shift(2);
		if(e == 0xFFFF) { o[1].v = 0; return o; }
		var s = e & 0x8000; e = (e&0x7FFF) - 16446;
		o[1].v = (s*2 - 1) * ((e > 0 ? (v2 << e) : (v2 >>> -e)) + (e > -32 ? (v1 << (e + 32)) : (v1 >>> -(e + 32))));
		return o;
	}

	function parse_FORMULA_19(blob, length) {
		var o = parse_NUMBER_17(blob, 14);
		blob.l += length - 14; /* TODO: formula */
		return o;
	}

	function parse_NUMBER_25(blob, length) {
		var o = parse_cell_3(blob, length);
		var v1 = blob.read_shift(4);
		o[1].v = v1 >> 6;
		return o;
	}

	function parse_NUMBER_27(blob, length) {
		var o = parse_cell_3(blob, length);
		var v1 = blob.read_shift(8,'f');
		o[1].v = v1;
		return o;
	}

	function parse_FORMULA_28(blob, length) {
		var o = parse_NUMBER_27(blob, 14);
		blob.l += length - 10; /* TODO: formula */
		return o;
	}

	var WK1Enum = {
0x0000: { n:"BOF", f:parseuint16 },
0x0001: { n:"EOF" },
0x0002: { n:"CALCMODE" },
0x0003: { n:"CALCORDER" },
0x0004: { n:"SPLIT" },
0x0005: { n:"SYNC" },
0x0006: { n:"RANGE", f:parse_RANGE },
0x0007: { n:"WINDOW1" },
0x0008: { n:"COLW1" },
0x0009: { n:"WINTWO" },
0x000A: { n:"COLW2" },
0x000B: { n:"NAME" },
0x000C: { n:"BLANK" },
0x000D: { n:"INTEGER", f:parse_INTEGER },
0x000E: { n:"NUMBER", f:parse_NUMBER },
0x000F: { n:"LABEL", f:parse_LABEL },
0x0010: { n:"FORMULA", f:parse_FORMULA },
0x0018: { n:"TABLE" },
0x0019: { n:"ORANGE" },
0x001A: { n:"PRANGE" },
0x001B: { n:"SRANGE" },
0x001C: { n:"FRANGE" },
0x001D: { n:"KRANGE1" },
0x0020: { n:"HRANGE" },
0x0023: { n:"KRANGE2" },
0x0024: { n:"PROTEC" },
0x0025: { n:"FOOTER" },
0x0026: { n:"HEADER" },
0x0027: { n:"SETUP" },
0x0028: { n:"MARGINS" },
0x0029: { n:"LABELFMT" },
0x002A: { n:"TITLES" },
0x002B: { n:"SHEETJS" },
0x002D: { n:"GRAPH" },
0x002E: { n:"NGRAPH" },
0x002F: { n:"CALCCOUNT" },
0x0030: { n:"UNFORMATTED" },
0x0031: { n:"CURSORW12" },
0x0032: { n:"WINDOW" },
0x0033: { n:"STRING", f:parse_LABEL },
0x0037: { n:"PASSWORD" },
0x0038: { n:"LOCKED" },
0x003C: { n:"QUERY" },
0x003D: { n:"QUERYNAME" },
0x003E: { n:"PRINT" },
0x003F: { n:"PRINTNAME" },
0x0040: { n:"GRAPH2" },
0x0041: { n:"GRAPHNAME" },
0x0042: { n:"ZOOM" },
0x0043: { n:"SYMSPLIT" },
0x0044: { n:"NSROWS" },
0x0045: { n:"NSCOLS" },
0x0046: { n:"RULER" },
0x0047: { n:"NNAME" },
0x0048: { n:"ACOMM" },
0x0049: { n:"AMACRO" },
0x004A: { n:"PARSE" },
0x00FF: { n:"", f:parsenoop }
	};

	var WK3Enum = {
0x0000: { n:"BOF" },
0x0001: { n:"EOF" },
0x0003: { n:"??" },
0x0004: { n:"??" },
0x0005: { n:"??" },
0x0006: { n:"??" },
0x0007: { n:"??" },
0x0009: { n:"??" },
0x000a: { n:"??" },
0x000b: { n:"??" },
0x000c: { n:"??" },
0x000e: { n:"??" },
0x000f: { n:"??" },
0x0010: { n:"??" },
0x0011: { n:"??" },
0x0012: { n:"??" },
0x0013: { n:"??" },
0x0015: { n:"??" },
0x0016: { n:"LABEL16", f:parse_LABEL_16},
0x0017: { n:"NUMBER17", f:parse_NUMBER_17 },
0x0018: { n:"NUMBER18", f:parse_NUMBER_18 },
0x0019: { n:"FORMULA19", f:parse_FORMULA_19},
0x001a: { n:"??" },
0x001b: { n:"??" },
0x001c: { n:"??" },
0x001d: { n:"??" },
0x001e: { n:"??" },
0x001f: { n:"??" },
0x0021: { n:"??" },
0x0025: { n:"NUMBER25", f:parse_NUMBER_25 },
0x0027: { n:"NUMBER27", f:parse_NUMBER_27 },
0x0028: { n:"FORMULA28", f:parse_FORMULA_28 },
0x00FF: { n:"", f:parsenoop }
	};
	return {
		to_workbook: lotus_to_workbook
	};
})();
/* Parse a list of <r> tags */
var parse_rs = (function parse_rs_factory() {
	var tregex = matchtag("t"), rpregex = matchtag("rPr"), rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/, nlregex = /\r\n/g;
	/* 18.4.7 rPr CT_RPrElt */
	var parse_rpr = function parse_rpr(rpr, intro, outro) {
		var font = {}, cp = 65001, align = "";
		var pass = false;
		var m = rpr.match(tagregex), i = 0;
		if(m) for(;i!=m.length; ++i) {
			var y = parsexmltag(m[i]);
			switch(y[0].replace(/\w*:/g,"")) {
				/* 18.8.12 condense CT_BooleanProperty */
				/* ** not required . */
				case '<condense': break;
				/* 18.8.17 extend CT_BooleanProperty */
				/* ** not required . */
				case '<extend': break;
				/* 18.8.36 shadow CT_BooleanProperty */
				/* ** not required . */
				case '<shadow':
					if(!y.val) break;
					/* falls through */
				case '<shadow>':
				case '<shadow/>': font.shadow = 1; break;
				case '</shadow>': break;

				/* 18.4.1 charset CT_IntProperty TODO */
				case '<charset':
					if(y.val == '1') break;
					cp = CS2CP[parseInt(y.val, 10)];
					break;

				/* 18.4.2 outline CT_BooleanProperty TODO */
				case '<outline':
					if(!y.val) break;
					/* falls through */
				case '<outline>':
				case '<outline/>': font.outline = 1; break;
				case '</outline>': break;

				/* 18.4.5 rFont CT_FontName */
				case '<rFont': font.name = y.val; break;

				/* 18.4.11 sz CT_FontSize */
				case '<sz': font.sz = y.val; break;

				/* 18.4.10 strike CT_BooleanProperty */
				case '<strike':
					if(!y.val) break;
					/* falls through */
				case '<strike>':
				case '<strike/>': font.strike = 1; break;
				case '</strike>': break;

				/* 18.4.13 u CT_UnderlineProperty */
				case '<u':
					if(!y.val) break;
					switch(y.val) {
						case 'double': font.uval = "double"; break;
						case 'singleAccounting': font.uval = "single-accounting"; break;
						case 'doubleAccounting': font.uval = "double-accounting"; break;
					}
					/* falls through */
				case '<u>':
				case '<u/>': font.u = 1; break;
				case '</u>': break;

				/* 18.8.2 b */
				case '<b':
					if(y.val == '0') break;
					/* falls through */
				case '<b>':
				case '<b/>': font.b = 1; break;
				case '</b>': break;

				/* 18.8.26 i */
				case '<i':
					if(y.val == '0') break;
					/* falls through */
				case '<i>':
				case '<i/>': font.i = 1; break;
				case '</i>': break;

				/* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */
				case '<color':
					if(y.rgb) font.color = y.rgb.slice(2,8);
					break;

				/* 18.8.18 family ST_FontFamily */
				case '<family': font.family = y.val; break;

				/* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */
				case '<vertAlign': align = y.val; break;

				/* 18.8.35 scheme CT_FontScheme TODO */
				case '<scheme': break;

				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default:
					if(y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
			}
		}
		var style = [];

		if(font.u) style.push("text-decoration: underline;");
		if(font.uval) style.push("text-underline-style:" + font.uval + ";");
		if(font.sz) style.push("font-size:" + font.sz + "pt;");
		if(font.outline) style.push("text-effect: outline;");
		if(font.shadow) style.push("text-shadow: auto;");
		intro.push('<span style="' + style.join("") + '">');

		if(font.b) { intro.push("<b>"); outro.push("</b>"); }
		if(font.i) { intro.push("<i>"); outro.push("</i>"); }
		if(font.strike) { intro.push("<s>"); outro.push("</s>"); }

		if(align == "superscript") align = "sup";
		else if(align == "subscript") align = "sub";
		if(align != "") { intro.push("<" + align + ">"); outro.push("</" + align + ">"); }

		outro.push("</span>");
		return cp;
	};

	/* 18.4.4 r CT_RElt */
	function parse_r(r) {
		var terms = [[],"",[]];
		/* 18.4.12 t ST_Xstring */
		var t = r.match(tregex)/*, cp = 65001*/;
		if(!t) return "";
		terms[1] = t[1];

		var rpr = r.match(rpregex);
		if(rpr) /*cp = */parse_rpr(rpr[1], terms[0], terms[2]);

		return terms[0].join("") + terms[1].replace(nlregex,'<br/>') + terms[2].join("");
	}
	return function parse_rs(rs) {
		return rs.replace(rregex,"").split(rend).map(parse_r).join("");
	};
})();

/* 18.4.8 si CT_Rst */
var sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, sirregex = /<(?:\w+:)?r>/;
var sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function parse_si(x, opts) {
	var html = opts ? opts.cellHTML : true;
	var z = {};
	if(!x) return null;
	//var y;
	/* 18.4.12 t ST_Xstring (Plaintext String) */
	// TODO: is whitespace actually valid here?
	if(x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
		z.t = unescapexml(utf8read(x.slice(x.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));
		z.r = utf8read(x);
		if(html) z.h = escapehtml(z.t);
	}
	/* 18.4.4 r CT_RElt (Rich Text Run) */
	else if((/*y = */x.match(sirregex))) {
		z.r = utf8read(x);
		z.t = unescapexml(utf8read((x.replace(sirphregex, '').match(sitregex)||[]).join("").replace(tagregex,"")));
		if(html) z.h = parse_rs(z.r);
	}
	/* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */
	/* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */
	return z;
}

/* 18.4 Shared String Table */
var sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
var sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function parse_sst_xml(data, opts) {
	var s = ([]), ss = "";
	if(!data) return s;
	/* 18.4.9 sst CT_Sst */
	var sst = data.match(sstr0);
	if(sst) {
		ss = sst[2].replace(sstr1,"").split(sstr2);
		for(var i = 0; i != ss.length; ++i) {
			var o = parse_si(ss[i].trim(), opts);
			if(o != null) s[s.length] = o;
		}
		sst = parsexmltag(sst[1]); s.Count = sst.count; s.Unique = sst.uniqueCount;
	}
	return s;
}

RELS.SST = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";
var straywsregex = /^\s|\s$|[\t\n\r]/;
function write_sst_xml(sst, opts) {
	if(!opts.bookSST) return "";
	var o = [XML_HEADER];
	o[o.length] = (writextag('sst', null, {
		xmlns: XMLNS.main[0],
		count: sst.Count,
		uniqueCount: sst.Unique
	}));
	for(var i = 0; i != sst.length; ++i) { if(sst[i] == null) continue;
		var s = sst[i];
		var sitag = "<si>";
		if(s.r) sitag += s.r;
		else {
			sitag += "<t";
			if(!s.t) s.t = "";
			if(s.t.match(straywsregex)) sitag += ' xml:space="preserve"';
			sitag += ">" + escapexml(s.t) + "</t>";
		}
		sitag += "</si>";
		o[o.length] = (sitag);
	}
	if(o.length>2){ o[o.length] = ('</sst>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */
function parse_BrtBeginSst(data) {
	return [data.read_shift(4), data.read_shift(4)];
}

/* [MS-XLSB] 2.1.7.45 Shared Strings */
function parse_sst_bin(data, opts) {
	var s = ([]);
	var pass = false;
	recordhopper(data, function hopper_sst(val, R_n, RT) {
		switch(RT) {
			case 0x009F: /* 'BrtBeginSst' */
				s.Count = val[0]; s.Unique = val[1]; break;
			case 0x0013: /* 'BrtSSTItem' */
				s.push(val); break;
			case 0x00A0: /* 'BrtEndSst' */
				return true;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;

			default:
				if(R_n.indexOf("Begin") > 0){/* empty */}
				else if(R_n.indexOf("End") > 0){/* empty */}
				if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	});
	return s;
}

function write_BrtBeginSst(sst, o) {
	if(!o) o = new_buf(8);
	o.write_shift(4, sst.Count);
	o.write_shift(4, sst.Unique);
	return o;
}

var write_BrtSSTItem = write_RichStr;

function write_sst_bin(sst) {
	var ba = buf_array();
	write_record(ba, "BrtBeginSst", write_BrtBeginSst(sst));
	for(var i = 0; i < sst.length; ++i) write_record(ba, "BrtSSTItem", write_BrtSSTItem(sst[i]));
	/* FRTSST */
	write_record(ba, "BrtEndSst");
	return ba.end();
}
function _JS2ANSI(str) {
	if(typeof cptable !== 'undefined') return cptable.utils.encode(current_ansi, str);
	var o = [], oo = str.split("");
	for(var i = 0; i < oo.length; ++i) o[i] = oo[i].charCodeAt(0);
	return o;
}

/* [MS-OFFCRYPTO] 2.1.4 Version */
function parse_CRYPTOVersion(blob, length) {
	var o = {};
	o.Major = blob.read_shift(2);
	o.Minor = blob.read_shift(2);
if(length >= 4) blob.l += length - 4;
	return o;
}

/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */
function parse_DataSpaceVersionInfo(blob) {
	var o = {};
	o.id = blob.read_shift(0, 'lpp4');
	o.R = parse_CRYPTOVersion(blob, 4);
	o.U = parse_CRYPTOVersion(blob, 4);
	o.W = parse_CRYPTOVersion(blob, 4);
	return o;
}

/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */
function parse_DataSpaceMapEntry(blob) {
	var len = blob.read_shift(4);
	var end = blob.l + len - 4;
	var o = {};
	var cnt = blob.read_shift(4);
	var comps = [];
	/* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */
	while(cnt-- > 0) comps.push({ t: blob.read_shift(4), v: blob.read_shift(0, 'lpp4') });
	o.name = blob.read_shift(0, 'lpp4');
	o.comps = comps;
	if(blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
	return o;
}

/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */
function parse_DataSpaceMap(blob) {
	var o = [];
	blob.l += 4; // must be 0x8
	var cnt = blob.read_shift(4);
	while(cnt-- > 0) o.push(parse_DataSpaceMapEntry(blob));
	return o;
}

/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */
function parse_DataSpaceDefinition(blob) {
	var o = [];
	blob.l += 4; // must be 0x8
	var cnt = blob.read_shift(4);
	while(cnt-- > 0) o.push(blob.read_shift(0, 'lpp4'));
	return o;
}

/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */
function parse_TransformInfoHeader(blob) {
	var o = {};
	/*var len = */blob.read_shift(4);
	blob.l += 4; // must be 0x1
	o.id = blob.read_shift(0, 'lpp4');
	o.name = blob.read_shift(0, 'lpp4');
	o.R = parse_CRYPTOVersion(blob, 4);
	o.U = parse_CRYPTOVersion(blob, 4);
	o.W = parse_CRYPTOVersion(blob, 4);
	return o;
}

function parse_Primary(blob) {
	/* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */
	var hdr = parse_TransformInfoHeader(blob);
	/* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */
	hdr.ename = blob.read_shift(0, '8lpp4');
	hdr.blksz = blob.read_shift(4);
	hdr.cmode = blob.read_shift(4);
	if(blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
	return hdr;
}

/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */
function parse_EncryptionHeader(blob, length) {
	var tgt = blob.l + length;
	var o = {};
	o.Flags = (blob.read_shift(4) & 0x3F);
	blob.l += 4;
	o.AlgID = blob.read_shift(4);
	var valid = false;
	switch(o.AlgID) {
		case 0x660E: case 0x660F: case 0x6610: valid = (o.Flags == 0x24); break;
		case 0x6801: valid = (o.Flags == 0x04); break;
		case 0: valid = (o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24); break;
		default: throw 'Unrecognized encryption algorithm: ' + o.AlgID;
	}
	if(!valid) throw new Error("Encryption Flags/AlgID mismatch");
	o.AlgIDHash = blob.read_shift(4);
	o.KeySize = blob.read_shift(4);
	o.ProviderType = blob.read_shift(4);
	blob.l += 8;
	o.CSPName = blob.read_shift((tgt-blob.l)>>1, 'utf16le');
	blob.l = tgt;
	return o;
}

/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */
function parse_EncryptionVerifier(blob, length) {
	var o = {}, tgt = blob.l + length;
	blob.l += 4; // SaltSize must be 0x10
	o.Salt = blob.slice(blob.l, blob.l+16); blob.l += 16;
	o.Verifier = blob.slice(blob.l, blob.l+16); blob.l += 16;
	/*var sz = */blob.read_shift(4);
	o.VerifierHash = blob.slice(blob.l, tgt); blob.l = tgt;
	return o;
}

/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */
function parse_EncryptionInfo(blob) {
	var vers = parse_CRYPTOVersion(blob);
	switch(vers.Minor) {
		case 0x02: return [vers.Minor, parse_EncInfoStd(blob, vers)];
		case 0x03: return [vers.Minor, parse_EncInfoExt(blob, vers)];
		case 0x04: return [vers.Minor, parse_EncInfoAgl(blob, vers)];
	}
	throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}

/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */
function parse_EncInfoStd(blob) {
	var flags = blob.read_shift(4);
	if((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
	var sz = blob.read_shift(4);
	//var tgt = blob.l + sz;
	var hdr = parse_EncryptionHeader(blob, sz);
	var verifier = parse_EncryptionVerifier(blob, blob.length - blob.l);
	return { t:"Std", h:hdr, v:verifier };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */
function parse_EncInfoExt() { throw new Error("File is password-protected: ECMA-376 Extensible"); }
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */
function parse_EncInfoAgl(blob) {
	var KeyData = ["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];
	blob.l+=4;
	var xml = blob.read_shift(blob.length - blob.l, 'utf8');
	var o = {};
	xml.replace(tagregex, function xml_agile(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<?xml': break;
			case '<encryption': case '</encryption>': break;
			case '<keyData': KeyData.forEach(function(k) { o[k] = y[k]; }); break;
			case '<dataIntegrity': o.encryptedHmacKey = y.encryptedHmacKey; o.encryptedHmacValue = y.encryptedHmacValue; break;
			case '<keyEncryptors>': case '<keyEncryptors': o.encs = []; break;
			case '</keyEncryptors>': break;

			case '<keyEncryptor': o.uri = y.uri; break;
			case '</keyEncryptor>': break;
			case '<encryptedKey': o.encs.push(y); break;
			default: throw y[0];
		}
	});
	return o;
}

/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */
function parse_RC4CryptoHeader(blob, length) {
	var o = {};
	var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4); length -= 4;
	if(vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
	if(vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
	o.Flags = blob.read_shift(4); length -= 4;
	var sz = blob.read_shift(4); length -= 4;
	o.EncryptionHeader = parse_EncryptionHeader(blob, sz); length -= sz;
	o.EncryptionVerifier = parse_EncryptionVerifier(blob, length);
	return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */
function parse_RC4Header(blob) {
	var o = {};
	var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4);
	if(vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
	o.Salt = blob.read_shift(16);
	o.EncryptedVerifier = blob.read_shift(16);
	o.EncryptedVerifierHash = blob.read_shift(16);
	return o;
}

/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */
function crypto_CreatePasswordVerifier_Method1(Password) {
	var Verifier = 0x0000, PasswordArray;
	var PasswordDecoded = _JS2ANSI(Password);
	var len = PasswordDecoded.length + 1, i, PasswordByte;
	var Intermediate1, Intermediate2, Intermediate3;
	PasswordArray = new_raw_buf(len);
	PasswordArray[0] = PasswordDecoded.length;
	for(i = 1; i != len; ++i) PasswordArray[i] = PasswordDecoded[i-1];
	for(i = len-1; i >= 0; --i) {
		PasswordByte = PasswordArray[i];
		Intermediate1 = ((Verifier & 0x4000) === 0x0000) ? 0 : 1;
		Intermediate2 = (Verifier << 1) & 0x7FFF;
		Intermediate3 = Intermediate1 | Intermediate2;
		Verifier = Intermediate3 ^ PasswordByte;
	}
	return Verifier ^ 0xCE4B;
}

/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */
var crypto_CreateXorArray_Method1 = (function() {
	var PadArray = [0xBB, 0xFF, 0xFF, 0xBA, 0xFF, 0xFF, 0xB9, 0x80, 0x00, 0xBE, 0x0F, 0x00, 0xBF, 0x0F, 0x00];
	var InitialCode = [0xE1F0, 0x1D0F, 0xCC9C, 0x84C0, 0x110C, 0x0E10, 0xF1CE, 0x313E, 0x1872, 0xE139, 0xD40F, 0x84F9, 0x280C, 0xA96A, 0x4EC3];
	var XorMatrix = [0xAEFC, 0x4DD9, 0x9BB2, 0x2745, 0x4E8A, 0x9D14, 0x2A09, 0x7B61, 0xF6C2, 0xFDA5, 0xEB6B, 0xC6F7, 0x9DCF, 0x2BBF, 0x4563, 0x8AC6, 0x05AD, 0x0B5A, 0x16B4, 0x2D68, 0x5AD0, 0x0375, 0x06EA, 0x0DD4, 0x1BA8, 0x3750, 0x6EA0, 0xDD40, 0xD849, 0xA0B3, 0x5147, 0xA28E, 0x553D, 0xAA7A, 0x44D5, 0x6F45, 0xDE8A, 0xAD35, 0x4A4B, 0x9496, 0x390D, 0x721A, 0xEB23, 0xC667, 0x9CEF, 0x29FF, 0x53FE, 0xA7FC, 0x5FD9, 0x47D3, 0x8FA6, 0x0F6D, 0x1EDA, 0x3DB4, 0x7B68, 0xF6D0, 0xB861, 0x60E3, 0xC1C6, 0x93AD, 0x377B, 0x6EF6, 0xDDEC, 0x45A0, 0x8B40, 0x06A1, 0x0D42, 0x1A84, 0x3508, 0x6A10, 0xAA51, 0x4483, 0x8906, 0x022D, 0x045A, 0x08B4, 0x1168, 0x76B4, 0xED68, 0xCAF1, 0x85C3, 0x1BA7, 0x374E, 0x6E9C, 0x3730, 0x6E60, 0xDCC0, 0xA9A1, 0x4363, 0x86C6, 0x1DAD, 0x3331, 0x6662, 0xCCC4, 0x89A9, 0x0373, 0x06E6, 0x0DCC, 0x1021, 0x2042, 0x4084, 0x8108, 0x1231, 0x2462, 0x48C4];
	var Ror = function(Byte) { return ((Byte/2) | (Byte*128)) & 0xFF; };
	var XorRor = function(byte1, byte2) { return Ror(byte1 ^ byte2); };
	var CreateXorKey_Method1 = function(Password) {
		var XorKey = InitialCode[Password.length - 1];
		var CurrentElement = 0x68;
		for(var i = Password.length-1; i >= 0; --i) {
			var Char = Password[i];
			for(var j = 0; j != 7; ++j) {
				if(Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
				Char *= 2; --CurrentElement;
			}
		}
		return XorKey;
	};
	return function(password) {
		var Password = _JS2ANSI(password);
		var XorKey = CreateXorKey_Method1(Password);
		var Index = Password.length;
		var ObfuscationArray = new_raw_buf(16);
		for(var i = 0; i != 16; ++i) ObfuscationArray[i] = 0x00;
		var Temp, PasswordLastChar, PadIndex;
		if((Index & 1) === 1) {
			Temp = XorKey >> 8;
			ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
			--Index;
			Temp = XorKey & 0xFF;
			PasswordLastChar = Password[Password.length - 1];
			ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
		}
		while(Index > 0) {
			--Index;
			Temp = XorKey >> 8;
			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			--Index;
			Temp = XorKey & 0xFF;
			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
		}
		Index = 15;
		PadIndex = 15 - Password.length;
		while(PadIndex > 0) {
			Temp = XorKey >> 8;
			ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
			--Index;
			--PadIndex;
			Temp = XorKey & 0xFF;
			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			--Index;
			--PadIndex;
		}
		return ObfuscationArray;
	};
})();

/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */
var crypto_DecryptData_Method1 = function(password, Data, XorArrayIndex, XorArray, O) {
	/* If XorArray is set, use it; if O is not set, make changes in-place */
	if(!O) O = Data;
	if(!XorArray) XorArray = crypto_CreateXorArray_Method1(password);
	var Index, Value;
	for(Index = 0; Index != Data.length; ++Index) {
		Value = Data[Index];
		Value ^= XorArray[XorArrayIndex];
		Value = ((Value>>5) | (Value<<3)) & 0xFF;
		O[Index] = Value;
		++XorArrayIndex;
	}
	return [O, XorArrayIndex, XorArray];
};

var crypto_MakeXorDecryptor = function(password) {
	var XorArrayIndex = 0, XorArray = crypto_CreateXorArray_Method1(password);
	return function(Data) {
		var O = crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
		XorArrayIndex = O[1];
		return O[0];
	};
};

/* 2.5.343 */
function parse_XORObfuscation(blob, length, opts, out) {
	var o = ({ key: parseuint16(blob), verificationBytes: parseuint16(blob) });
	if(opts.password) o.verifier = crypto_CreatePasswordVerifier_Method1(opts.password);
	out.valid = o.verificationBytes === o.verifier;
	if(out.valid) out.insitu = crypto_MakeXorDecryptor(opts.password);
	return o;
}

/* 2.4.117 */
function parse_FilePassHeader(blob, length, oo) {
	var o = oo || {}; o.Info = blob.read_shift(2); blob.l -= 2;
	if(o.Info === 1) o.Data = parse_RC4Header(blob, length);
	else o.Data = parse_RC4CryptoHeader(blob, length);
	return o;
}
function parse_FilePass(blob, length, opts) {
	var o = ({ Type: opts.biff >= 8 ? blob.read_shift(2) : 0 }); /* wEncryptionType */
	if(o.Type) parse_FilePassHeader(blob, length-2, o);
	else parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
	return o;
}


var RTF = (function() {
	function rtf_to_sheet(d, opts) {
		switch(opts.type) {
			case 'base64': return rtf_to_sheet_str(Base64.decode(d), opts);
			case 'binary': return rtf_to_sheet_str(d, opts);
			case 'buffer': return rtf_to_sheet_str(d.toString('binary'), opts);
			case 'array':  return rtf_to_sheet_str(cc2str(d), opts);
		}
		throw new Error("Unrecognized type " + opts.type);
	}

	function rtf_to_sheet_str(str, opts) {
		var o = opts || {};
		var ws = o.dense ? ([]) : ({});
		var range = ({s: {c:0, r:0}, e: {c:0, r:0}});

		// TODO: parse
		if(!str.match(/\\trowd/)) throw new Error("RTF missing table");

		ws['!ref'] = encode_range(range);
		return ws;
	}

	function rtf_to_workbook(d, opts) { return sheet_to_workbook(rtf_to_sheet(d, opts), opts); }

	/* TODO: this is a stub */
	function sheet_to_rtf(ws) {
		var o = ["{\\rtf1\\ansi"];
		var r = safe_decode_range(ws['!ref']), cell;
		var dense = Array.isArray(ws);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			o.push("\\trowd\\trautofit1");
			for(var C = r.s.c; C <= r.e.c; ++C) o.push("\\cellx" + (C+1));
			o.push("\\pard\\intbl");
			for(C = r.s.c; C <= r.e.c; ++C) {
				var coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C]: ws[coord];
				if(!cell || cell.v == null && (!cell.f || cell.F)) continue;
				o.push(" " + (cell.w || (format_cell(cell), cell.w)));
				o.push("\\cell");
			}
			o.push("\\pard\\intbl\\row");
		}
		return o.join("") + "}";
	}

	return {
		to_workbook: rtf_to_workbook,
		to_sheet: rtf_to_sheet,
		from_sheet: sheet_to_rtf
	};
})();
function hex2RGB(h) {
	var o = h.slice(h[0]==="#"?1:0).slice(0,6);
	return [parseInt(o.slice(0,2),16),parseInt(o.slice(2,4),16),parseInt(o.slice(4,6),16)];
}
function rgb2Hex(rgb) {
	for(var i=0,o=1; i!=3; ++i) o = o*256 + (rgb[i]>255?255:rgb[i]<0?0:rgb[i]);
	return o.toString(16).toUpperCase().slice(1);
}

function rgb2HSL(rgb) {
	var R = rgb[0]/255, G = rgb[1]/255, B=rgb[2]/255;
	var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
	if(C === 0) return [0, 0, R];

	var H6 = 0, S = 0, L2 = (M + m);
	S = C / (L2 > 1 ? 2 - L2 : L2);
	switch(M){
		case R: H6 = ((G - B) / C + 6)%6; break;
		case G: H6 = ((B - R) / C + 2); break;
		case B: H6 = ((R - G) / C + 4); break;
	}
	return [H6 / 6, S, L2 / 2];
}

function hsl2RGB(hsl){
	var H = hsl[0], S = hsl[1], L = hsl[2];
	var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C/2;
	var rgb = [m,m,m], h6 = 6*H;

	var X;
	if(S !== 0) switch(h6|0) {
		case 0: case 6: X = C * h6; rgb[0] += C; rgb[1] += X; break;
		case 1: X = C * (2 - h6);   rgb[0] += X; rgb[1] += C; break;
		case 2: X = C * (h6 - 2);   rgb[1] += C; rgb[2] += X; break;
		case 3: X = C * (4 - h6);   rgb[1] += X; rgb[2] += C; break;
		case 4: X = C * (h6 - 4);   rgb[2] += C; rgb[0] += X; break;
		case 5: X = C * (6 - h6);   rgb[2] += X; rgb[0] += C; break;
	}
	for(var i = 0; i != 3; ++i) rgb[i] = Math.round(rgb[i]*255);
	return rgb;
}

/* 18.8.3 bgColor tint algorithm */
function rgb_tint(hex, tint) {
	if(tint === 0) return hex;
	var hsl = rgb2HSL(hex2RGB(hex));
	if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
	else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
	return rgb2Hex(hsl2RGB(hsl));
}

/* 18.3.1.13 width calculations */
/* [MS-OI29500] 2.1.595 Column Width & Formatting */
var DEF_MDW = 6, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
function width2px(width) { return Math.floor(( width + (Math.round(128/MDW))/256 )* MDW ); }
function px2char(px) { return (Math.floor((px - 5)/MDW * 100 + 0.5))/100; }
function char2width(chr) { return (Math.round((chr * MDW + 5)/MDW*256))/256; }
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function cycle_width(collw) { return char2width(px2char(width2px(collw))); }
/* XLSX/XLSB/XLS specify width in units of MDW */
function find_mdw_colw(collw) {
	var delta = Math.abs(collw - cycle_width(collw)), _MDW = MDW;
	if(delta > 0.005) for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) if(Math.abs(collw - cycle_width(collw)) <= delta) { delta = Math.abs(collw - cycle_width(collw)); _MDW = MDW; }
	MDW = _MDW;
}
/* XLML specifies width in terms of pixels */
/*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/

function process_col(coll) {
	if(coll.width) {
		coll.wpx = width2px(coll.width);
		coll.wch = px2char(coll.wpx);
		coll.MDW = MDW;
	} else if(coll.wpx) {
		coll.wch = px2char(coll.wpx);
		coll.width = char2width(coll.wch);
		coll.MDW = MDW;
	} else if(typeof coll.wch == 'number') {
		coll.width = char2width(coll.wch);
		coll.wpx = width2px(coll.width);
		coll.MDW = MDW;
	}
	if(coll.customWidth) delete coll.customWidth;
}

var DEF_PPI = 96, PPI = DEF_PPI;
function px2pt(px) { return px * 96 / PPI; }
function pt2px(pt) { return pt * PPI / 96; }

/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */
var XLMLPatternTypeMap = {
	"None": "none",
	"Solid": "solid",
	"Gray50": "mediumGray",
	"Gray75": "darkGray",
	"Gray25": "lightGray",
	"HorzStripe": "darkHorizontal",
	"VertStripe": "darkVertical",
	"ReverseDiagStripe": "darkDown",
	"DiagStripe": "darkUp",
	"DiagCross": "darkGrid",
	"ThickDiagCross": "darkTrellis",
	"ThinHorzStripe": "lightHorizontal",
	"ThinVertStripe": "lightVertical",
	"ThinReverseDiagStripe": "lightDown",
	"ThinHorzCross": "lightGrid"
};

/* 18.8.5 borders CT_Borders */
function parse_borders(t, styles, themes, opts) {
	styles.Borders = [];
	var border = {}/*, sub_border = {}*/;
	var pass = false;
	t[0].match(tagregex).forEach(function(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<borders': case '<borders>': case '</borders>': break;

			/* 18.8.4 border CT_Border */
			case '<border': case '<border>': case '<border/>':
				border = {};
				if (y.diagonalUp) { border.diagonalUp = y.diagonalUp; }
				if (y.diagonalDown) { border.diagonalDown = y.diagonalDown; }
				styles.Borders.push(border);
				break;
			case '</border>': break;

			/* note: not in spec, appears to be CT_BorderPr */
			case '<left/>': break;
			case '<left': case '<left>': break;
			case '</left>': break;

			/* note: not in spec, appears to be CT_BorderPr */
			case '<right/>': break;
			case '<right': case '<right>': break;
			case '</right>': break;

			/* 18.8.43 top CT_BorderPr */
			case '<top/>': break;
			case '<top': case '<top>': break;
			case '</top>': break;

			/* 18.8.6 bottom CT_BorderPr */
			case '<bottom/>': break;
			case '<bottom': case '<bottom>': break;
			case '</bottom>': break;

			/* 18.8.13 diagonal CT_BorderPr */
			case '<diagonal': case '<diagonal>': case '<diagonal/>': break;
			case '</diagonal>': break;

			/* 18.8.25 horizontal CT_BorderPr */
			case '<horizontal': case '<horizontal>': case '<horizontal/>': break;
			case '</horizontal>': break;

			/* 18.8.44 vertical CT_BorderPr */
			case '<vertical': case '<vertical>': case '<vertical/>': break;
			case '</vertical>': break;

			/* 18.8.37 start CT_BorderPr */
			case '<start': case '<start>': case '<start/>': break;
			case '</start>': break;

			/* 18.8.16 end CT_BorderPr */
			case '<end': case '<end>': case '<end/>': break;
			case '</end>': break;

			/* 18.8.? color CT_Color */
			case '<color': case '<color>': break;
			case '<color/>': case '</color>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
			}
		}
	});
}

/* 18.8.21 fills CT_Fills */
function parse_fills(t, styles, themes, opts) {
	styles.Fills = [];
	var fill = {};
	var pass = false;
	t[0].match(tagregex).forEach(function(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<fills': case '<fills>': case '</fills>': break;

			/* 18.8.20 fill CT_Fill */
			case '<fill>': case '<fill': case '<fill/>':
				fill = {}; styles.Fills.push(fill); break;
			case '</fill>': break;

			/* 18.8.24 gradientFill CT_GradientFill */
			case '<gradientFill>': break;
			case '<gradientFill':
			case '</gradientFill>': styles.Fills.push(fill); fill = {}; break;

			/* 18.8.32 patternFill CT_PatternFill */
			case '<patternFill': case '<patternFill>':
				if(y.patternType) fill.patternType = y.patternType;
				break;
			case '<patternFill/>': case '</patternFill>': break;

			/* 18.8.3 bgColor CT_Color */
			case '<bgColor':
				if(!fill.bgColor) fill.bgColor = {};
				if(y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
				if(y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
				if(y.tint) fill.bgColor.tint = parseFloat(y.tint);
				/* Excel uses ARGB strings */
				if(y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
				break;
			case '<bgColor/>': case '</bgColor>': break;

			/* 18.8.19 fgColor CT_Color */
			case '<fgColor':
				if(!fill.fgColor) fill.fgColor = {};
				if(y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
				if(y.tint) fill.fgColor.tint = parseFloat(y.tint);
				/* Excel uses ARGB strings */
				if(y.rgb) fill.fgColor.rgb = y.rgb.slice(-6);
				break;
			case '<fgColor/>': case '</fgColor>': break;

			/* 18.8.38 stop CT_GradientStop */
			case '<stop': case '<stop/>': break;
			case '</stop>': break;

			/* 18.8.? color CT_Color */
			case '<color': case '<color/>': break;
			case '</color>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
			}
		}
	});
}

/* 18.8.23 fonts CT_Fonts */
function parse_fonts(t, styles, themes, opts) {
	styles.Fonts = [];
	var font = {};
	var pass = false;
	t[0].match(tagregex).forEach(function(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<fonts': case '<fonts>': case '</fonts>': break;

			/* 18.8.22 font CT_Font */
			case '<font': case '<font>': break;
			case '</font>': case '<font/>':
				styles.Fonts.push(font);
				font = {};
				break;

			/* 18.8.29 name CT_FontName */
			case '<name': if(y.val) font.name = y.val; break;
			case '<name/>': case '</name>': break;

			/* 18.8.2  b CT_BooleanProperty */
			case '<b': font.bold = y.val ? parsexmlbool(y.val) : 1; break;
			case '<b/>': font.bold = 1; break;

			/* 18.8.26 i CT_BooleanProperty */
			case '<i': font.italic = y.val ? parsexmlbool(y.val) : 1; break;
			case '<i/>': font.italic = 1; break;

			/* 18.4.13 u CT_UnderlineProperty */
			case '<u':
				switch(y.val) {
					case "none": font.underline = 0x00; break;
					case "single": font.underline = 0x01; break;
					case "double": font.underline = 0x02; break;
					case "singleAccounting": font.underline = 0x21; break;
					case "doubleAccounting": font.underline = 0x22; break;
				} break;
			case '<u/>': font.underline = 1; break;

			/* 18.4.10 strike CT_BooleanProperty */
			case '<strike': font.strike = y.val ? parsexmlbool(y.val) : 1; break;
			case '<strike/>': font.strike = 1; break;

			/* 18.4.2  outline CT_BooleanProperty */
			case '<outline': font.outline = y.val ? parsexmlbool(y.val) : 1; break;
			case '<outline/>': font.outline = 1; break;

			/* 18.8.36 shadow CT_BooleanProperty */
			case '<shadow': font.shadow = y.val ? parsexmlbool(y.val) : 1; break;
			case '<shadow/>': font.shadow = 1; break;

			/* 18.8.12 condense CT_BooleanProperty */
			case '<condense': font.condense = y.val ? parsexmlbool(y.val) : 1; break;
			case '<condense/>': font.condense = 1; break;

			/* 18.8.17 extend CT_BooleanProperty */
			case '<extend': font.extend = y.val ? parsexmlbool(y.val) : 1; break;
			case '<extend/>': font.extend = 1; break;

			/* 18.4.11 sz CT_FontSize */
			case '<sz': if(y.val) font.sz = +y.val; break;
			case '<sz/>': case '</sz>': break;

			/* 18.4.14 vertAlign CT_VerticalAlignFontProperty */
			case '<vertAlign': if(y.val) font.vertAlign = y.val; break;
			case '<vertAlign/>': case '</vertAlign>': break;

			/* 18.8.18 family CT_FontFamily */
			case '<family': if(y.val) font.family = parseInt(y.val,10); break;
			case '<family/>': case '</family>': break;

			/* 18.8.35 scheme CT_FontScheme */
			case '<scheme': if(y.val) font.scheme = y.val; break;
			case '<scheme/>': case '</scheme>': break;

			/* 18.4.1 charset CT_IntProperty */
			case '<charset':
				if(y.val == '1') break;
				y.codepage = CS2CP[parseInt(y.val, 10)];
				break;

			/* 18.?.? color CT_Color */
			case '<color':
				if(!font.color) font.color = {};
				if(y.auto) font.color.auto = parsexmlbool(y.auto);

				if(y.rgb) font.color.rgb = y.rgb.slice(-6);
				else if(y.indexed) {
					font.color.index = parseInt(y.indexed, 10);
					var icv = XLSIcv[font.color.index];
					if(font.color.index == 81) icv = XLSIcv[1];
					if(!icv) throw new Error(x);
					font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
				} else if(y.theme) {
					font.color.theme = parseInt(y.theme, 10);
					if(y.tint) font.color.tint = parseFloat(y.tint);
					if(y.theme && themes.themeElements && themes.themeElements.clrScheme) {
						font.color.rgb = rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
					}
				}

				break;
			case '<color/>': case '</color>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
			}
		}
	});
}

/* 18.8.31 numFmts CT_NumFmts */
function parse_numFmts(t, styles, opts) {
	styles.NumberFmt = [];
	var k/*Array<number>*/ = (keys(SSF._table));
	for(var i=0; i < k.length; ++i) styles.NumberFmt[k[i]] = SSF._table[k[i]];
	var m = t[0].match(tagregex);
	if(!m) return;
	for(i=0; i < m.length; ++i) {
		var y = parsexmltag(m[i]);
		switch(strip_ns(y[0])) {
			case '<numFmts': case '</numFmts>': case '<numFmts/>': case '<numFmts>': break;
			case '<numFmt': {
				var f=unescapexml(utf8read(y.formatCode)), j=parseInt(y.numFmtId,10);
				styles.NumberFmt[j] = f;
				if(j>0) {
					if(j > 0x188) {
						for(j = 0x188; j > 0x3c; --j) if(styles.NumberFmt[j] == null) break;
						styles.NumberFmt[j] = f;
					}
					SSF.load(f,j);
				}
			} break;
			case '</numFmt>': break;
			default: if(opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
		}
	}
}

function write_numFmts(NF) {
	var o = ["<numFmts>"];
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
		for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) o[o.length] = (writextag('numFmt',null,{numFmtId:i,formatCode:escapexml(NF[i])}));
	});
	if(o.length === 1) return "";
	o[o.length] = ("</numFmts>");
	o[0] = writextag('numFmts', null, { count:o.length-2 }).replace("/>", ">");
	return o.join("");
}

/* 18.8.10 cellXfs CT_CellXfs */
var cellXF_uint = [ "numFmtId", "fillId", "fontId", "borderId", "xfId" ];
var cellXF_bool = [ "applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix" ];
function parse_cellXfs(t, styles, opts) {
	styles.CellXf = [];
	var xf;
	var pass = false;
	t[0].match(tagregex).forEach(function(x) {
		var y = parsexmltag(x), i = 0;
		switch(strip_ns(y[0])) {
			case '<cellXfs': case '<cellXfs>': case '<cellXfs/>': case '</cellXfs>': break;

			/* 18.8.45 xf CT_Xf */
			case '<xf': case '<xf/>':
				xf = y;
				delete xf[0];
				for(i = 0; i < cellXF_uint.length; ++i) if(xf[cellXF_uint[i]])
					xf[cellXF_uint[i]] = parseInt(xf[cellXF_uint[i]], 10);
				for(i = 0; i < cellXF_bool.length; ++i) if(xf[cellXF_bool[i]])
					xf[cellXF_bool[i]] = parsexmlbool(xf[cellXF_bool[i]]);
				if(xf.numFmtId > 0x188) {
					for(i = 0x188; i > 0x3c; --i) if(styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) { xf.numFmtId = i; break; }
				}
				styles.CellXf.push(xf); break;
			case '</xf>': break;

			/* 18.8.1 alignment CT_CellAlignment */
			case '<alignment': case '<alignment/>':
				var alignment = {};
				if(y.vertical) alignment.vertical = y.vertical;
				if(y.horizontal) alignment.horizontal = y.horizontal;
				if(y.textRotation != null) alignment.textRotation = y.textRotation;
				if(y.indent) alignment.indent = y.indent;
				if(y.wrapText) alignment.wrapText = y.wrapText;
				xf.alignment = alignment;
				break;
			case '</alignment>': break;

			/* 18.8.33 protection CT_CellProtection */
			case '<protection': case '</protection>': case '<protection/>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
			}
		}
	});
}

function write_cellXfs(cellXfs) {
	var o = [];
	o[o.length] = (writextag('cellXfs',null));
	cellXfs.forEach(function(c) { o[o.length] = (writextag('xf', null, c)); });
	o[o.length] = ("</cellXfs>");
	if(o.length === 2) return "";
	o[0] = writextag('cellXfs',null, {count:o.length-2}).replace("/>",">");
	return o.join("");
}

/* 18.8 Styles CT_Stylesheet*/
var parse_sty_xml= (function make_pstyx() {
var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;

return function parse_sty_xml(data, themes, opts) {
	var styles = {};
	if(!data) return styles;
	data = data.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
	/* 18.8.39 styleSheet CT_Stylesheet */
	var t;

	/* 18.8.31 numFmts CT_NumFmts ? */
	if((t=data.match(numFmtRegex))) parse_numFmts(t, styles, opts);

	/* 18.8.23 fonts CT_Fonts ? */
	if((t=data.match(fontsRegex))) parse_fonts(t, styles, themes, opts);

	/* 18.8.21 fills CT_Fills ? */
	if((t=data.match(fillsRegex))) parse_fills(t, styles, themes, opts);

	/* 18.8.5  borders CT_Borders ? */
	if((t=data.match(bordersRegex))) parse_borders(t, styles, themes, opts);

	/* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */

	/* 18.8.10 cellXfs CT_CellXfs ? */
	if((t=data.match(cellXfRegex))) parse_cellXfs(t, styles, opts);

	/* 18.8.8  cellStyles CT_CellStyles ? */
	/* 18.8.15 dxfs CT_Dxfs ? */
	/* 18.8.42 tableStyles CT_TableStyles ? */
	/* 18.8.11 colors CT_Colors ? */
	/* 18.2.10 extLst CT_ExtensionList ? */

	return styles;
};
})();

var STYLES_XML_ROOT = writextag('styleSheet', null, {
	'xmlns': XMLNS.main[0],
	'xmlns:vt': XMLNS.vt
});

RELS.STY = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";

function write_sty_xml(wb, opts) {
	var o = [XML_HEADER, STYLES_XML_ROOT], w;
	if(wb.SSF && (w = write_numFmts(wb.SSF)) != null) o[o.length] = w;
	o[o.length] = ('<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>');
	o[o.length] = ('<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>');
	o[o.length] = ('<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>');
	o[o.length] = ('<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>');
	if((w = write_cellXfs(opts.cellXfs))) o[o.length] = (w);
	o[o.length] = ('<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>');
	o[o.length] = ('<dxfs count="0"/>');
	o[o.length] = ('<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>');

	if(o.length>2){ o[o.length] = ('</styleSheet>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */
function parse_BrtFmt(data, length) {
	var numFmtId = data.read_shift(2);
	var stFmtCode = parse_XLWideString(data,length-2);
	return [numFmtId, stFmtCode];
}
function write_BrtFmt(i, f, o) {
	if(!o) o = new_buf(6 + 4 * f.length);
	o.write_shift(2, i);
	write_XLWideString(f, o);
	var out = (o.length > o.l) ? o.slice(0, o.l) : o;
	if(o.l == null) o.l = o.length;
	return out;
}

/* [MS-XLSB] 2.4.659 BrtFont TODO */
function parse_BrtFont(data, length, opts) {
	var out = ({});

	out.sz = data.read_shift(2) / 20;

	var grbit = parse_FontFlags(data, 2, opts);
	if(grbit.fCondense) out.condense = 1;
	if(grbit.fExtend) out.extend = 1;
	if(grbit.fShadow) out.shadow = 1;
	if(grbit.fOutline) out.outline = 1;
	if(grbit.fStrikeout) out.strike = 1;
	if(grbit.fItalic) out.italic = 1;

	var bls = data.read_shift(2);
	if(bls === 0x02BC) out.bold = 1;

	switch(data.read_shift(2)) {
		/* case 0: out.vertAlign = "baseline"; break; */
		case 1: out.vertAlign = "superscript"; break;
		case 2: out.vertAlign = "subscript"; break;
	}

	var underline = data.read_shift(1);
	if(underline != 0) out.underline = underline;

	var family = data.read_shift(1);
	if(family > 0) out.family = family;

	var bCharSet = data.read_shift(1);
	if(bCharSet > 0) out.charset = bCharSet;

	data.l++;
	out.color = parse_BrtColor(data, 8);

	switch(data.read_shift(1)) {
		/* case 0: out.scheme = "none": break; */
		case 1: out.scheme = "major"; break;
		case 2: out.scheme = "minor"; break;
	}

	out.name = parse_XLWideString(data, length - 21);

	return out;
}
function write_BrtFont(font, o) {
	if(!o) o = new_buf(25+4*32);
	o.write_shift(2, font.sz * 20);
	write_FontFlags(font, o);
	o.write_shift(2, font.bold ? 0x02BC : 0x0190);
	var sss = 0;
	if(font.vertAlign == "superscript") sss = 1;
	else if(font.vertAlign == "subscript") sss = 2;
	o.write_shift(2, sss);
	o.write_shift(1, font.underline || 0);
	o.write_shift(1, font.family || 0);
	o.write_shift(1, font.charset || 0);
	o.write_shift(1, 0);
	write_BrtColor(font.color, o);
	var scheme = 0;
	if(font.scheme == "major") scheme = 1;
	if(font.scheme == "minor") scheme = 2;
	o.write_shift(1, scheme);
	write_XLWideString(font.name, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.650 BrtFill */
var XLSBFillPTNames = [
	"none",
	"solid",
	"mediumGray",
	"darkGray",
	"lightGray",
	"darkHorizontal",
	"darkVertical",
	"darkDown",
	"darkUp",
	"darkGrid",
	"darkTrellis",
	"lightHorizontal",
	"lightVertical",
	"lightDown",
	"lightUp",
	"lightGrid",
	"lightTrellis",
	"gray125",
	"gray0625"
];
var rev_XLSBFillPTNames = (evert(XLSBFillPTNames));
/* TODO: gradient fill representation */
var parse_BrtFill = parsenoop;
function write_BrtFill(fill, o) {
	if(!o) o = new_buf(4*3 + 8*7 + 16*1);
	var fls = rev_XLSBFillPTNames[fill.patternType];
	if(fls == null) fls = 0x28;
	o.write_shift(4, fls);
	var j = 0;
	if(fls != 0x28) {
		/* TODO: custom FG Color */
		write_BrtColor({auto:1}, o);
		/* TODO: custom BG Color */
		write_BrtColor({auto:1}, o);

		for(; j < 12; ++j) o.write_shift(4, 0);
	} else {
		for(; j < 4; ++j) o.write_shift(4, 0);

		for(; j < 12; ++j) o.write_shift(4, 0); /* TODO */
		/* iGradientType */
		/* xnumDegree */
		/* xnumFillToLeft */
		/* xnumFillToRight */
		/* xnumFillToTop */
		/* xnumFillToBottom */
		/* cNumStop */
		/* xfillGradientStop */
	}
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.824 BrtXF */
function parse_BrtXF(data, length) {
	var tgt = data.l + length;
	var ixfeParent = data.read_shift(2);
	var ifmt = data.read_shift(2);
	data.l = tgt;
	return {ixfe:ixfeParent, numFmtId:ifmt };
}
function write_BrtXF(data, ixfeP, o) {
	if(!o) o = new_buf(16);
	o.write_shift(2, ixfeP||0);
	o.write_shift(2, data.numFmtId||0);
	o.write_shift(2, 0); /* iFont */
	o.write_shift(2, 0); /* iFill */
	o.write_shift(2, 0); /* ixBorder */
	o.write_shift(1, 0); /* trot */
	o.write_shift(1, 0); /* indent */
	o.write_shift(1, 0); /* flags */
	o.write_shift(1, 0); /* flags */
	o.write_shift(1, 0); /* xfGrbitAtr */
	o.write_shift(1, 0);
	return o;
}

/* [MS-XLSB] 2.5.4 Blxf TODO */
function write_Blxf(data, o) {
	if(!o) o = new_buf(10);
	o.write_shift(1, 0); /* dg */
	o.write_shift(1, 0);
	o.write_shift(4, 0); /* color */
	o.write_shift(4, 0); /* color */
	return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */
var parse_BrtBorder = parsenoop;
function write_BrtBorder(border, o) {
	if(!o) o = new_buf(51);
	o.write_shift(1, 0); /* diagonal */
	write_Blxf(null, o); /* top */
	write_Blxf(null, o); /* bottom */
	write_Blxf(null, o); /* left */
	write_Blxf(null, o); /* right */
	write_Blxf(null, o); /* diag */
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.763 BrtStyle TODO */
function write_BrtStyle(style, o) {
	if(!o) o = new_buf(12+4*10);
	o.write_shift(4, style.xfId);
	o.write_shift(2, 1);
	o.write_shift(1, +style.builtinId);
	o.write_shift(1, 0); /* iLevel */
	write_XLNullableWideString(style.name || "", o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */
function write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
	var o = new_buf(4+256*2*4);
	o.write_shift(4, cnt);
	write_XLNullableWideString(defTableStyle, o);
	write_XLNullableWideString(defPivotStyle, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.1.7.50 Styles */
function parse_sty_bin(data, themes, opts) {
	var styles = {};
	styles.NumberFmt = ([]);
	for(var y in SSF._table) styles.NumberFmt[y] = SSF._table[y];

	styles.CellXf = [];
	styles.Fonts = [];
	var state = [];
	var pass = false;
	recordhopper(data, function hopper_sty(val, R_n, RT) {
		switch(RT) {
			case 0x002C: /* 'BrtFmt' */
				styles.NumberFmt[val[0]] = val[1]; SSF.load(val[1], val[0]);
				break;
			case 0x002B: /* 'BrtFont' */
				styles.Fonts.push(val);
				if(val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) {
					val.color.rgb = rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
				}
				break;
			case 0x0401: /* 'BrtKnownFonts' */ break;
			case 0x002D: /* 'BrtFill' */ break;
			case 0x002E: /* 'BrtBorder' */ break;
			case 0x002F: /* 'BrtXF' */
				if(state[state.length - 1] == "BrtBeginCellXFs") {
					styles.CellXf.push(val);
				}
				break;
			case 0x0030: /* 'BrtStyle' */
			case 0x01FB: /* 'BrtDXF' */
			case 0x023C: /* 'BrtMRUColor' */
			case 0x01DB: /* 'BrtIndexedColor': */
				break;

			case 0x0493: /* 'BrtDXF14' */
			case 0x0836: /* 'BrtDXF15' */
			case 0x046A: /* 'BrtSlicerStyleElement' */
			case 0x0200: /* 'BrtTableStyleElement' */
			case 0x082F: /* 'BrtTimelineStyleElement' */
			case 0x0C00: /* 'BrtUid' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */
				state.push(R_n); break;
			case 0x0026: /* 'BrtACEnd' */
				state.pop(); break;

			default:
				if((R_n||"").indexOf("Begin") > 0) state.push(R_n);
				else if((R_n||"").indexOf("End") > 0) state.pop();
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	});
	return styles;
}

function write_FMTS_bin(ba, NF) {
	if(!NF) return;
	var cnt = 0;
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) ++cnt;
	});

	if(cnt == 0) return;
	write_record(ba, "BrtBeginFmts", write_UInt32LE(cnt));
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_record(ba, "BrtFmt", write_BrtFmt(i, NF[i]));
	});
	write_record(ba, "BrtEndFmts");
}

function write_FONTS_bin(ba) {
	var cnt = 1;

	if(cnt == 0) return;
	write_record(ba, "BrtBeginFonts", write_UInt32LE(cnt));
	write_record(ba, "BrtFont", write_BrtFont({
		sz:12,
		color: {theme:1},
		name: "Calibri",
		family: 2,
		scheme: "minor"
	}));
	/* 1*65491BrtFont [ACFONTS] */
	write_record(ba, "BrtEndFonts");
}

function write_FILLS_bin(ba) {
	var cnt = 2;

	if(cnt == 0) return;
	write_record(ba, "BrtBeginFills", write_UInt32LE(cnt));
	write_record(ba, "BrtFill", write_BrtFill({patternType:"none"}));
	write_record(ba, "BrtFill", write_BrtFill({patternType:"gray125"}));
	/* 1*65431BrtFill */
	write_record(ba, "BrtEndFills");
}

function write_BORDERS_bin(ba) {
	var cnt = 1;

	if(cnt == 0) return;
	write_record(ba, "BrtBeginBorders", write_UInt32LE(cnt));
	write_record(ba, "BrtBorder", write_BrtBorder({}));
	/* 1*65430BrtBorder */
	write_record(ba, "BrtEndBorders");
}

function write_CELLSTYLEXFS_bin(ba) {
	var cnt = 1;
	write_record(ba, "BrtBeginCellStyleXFs", write_UInt32LE(cnt));
	write_record(ba, "BrtXF", write_BrtXF({
		numFmtId:0,
		fontId:0,
		fillId:0,
		borderId:0
	}, 0xFFFF));
	/* 1*65430(BrtXF *FRT) */
	write_record(ba, "BrtEndCellStyleXFs");
}

function write_CELLXFS_bin(ba, data) {
	write_record(ba, "BrtBeginCellXFs", write_UInt32LE(data.length));
	data.forEach(function(c) { write_record(ba, "BrtXF", write_BrtXF(c,0)); });
	/* 1*65430(BrtXF *FRT) */
	write_record(ba, "BrtEndCellXFs");
}

function write_STYLES_bin(ba) {
	var cnt = 1;

	write_record(ba, "BrtBeginStyles", write_UInt32LE(cnt));
	write_record(ba, "BrtStyle", write_BrtStyle({
		xfId:0,
		builtinId:0,
		name:"Normal"
	}));
	/* 1*65430(BrtStyle *FRT) */
	write_record(ba, "BrtEndStyles");
}

function write_DXFS_bin(ba) {
	var cnt = 0;

	write_record(ba, "BrtBeginDXFs", write_UInt32LE(cnt));
	/* *2147483647(BrtDXF *FRT) */
	write_record(ba, "BrtEndDXFs");
}

function write_TABLESTYLES_bin(ba) {
	var cnt = 0;

	write_record(ba, "BrtBeginTableStyles", write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
	/* *TABLESTYLE */
	write_record(ba, "BrtEndTableStyles");
}

function write_COLORPALETTE_bin() {
	return;
	/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */
}

/* [MS-XLSB] 2.1.7.50 Styles */
function write_sty_bin(wb, opts) {
	var ba = buf_array();
	write_record(ba, "BrtBeginStyleSheet");
	write_FMTS_bin(ba, wb.SSF);
	write_FONTS_bin(ba, wb);
	write_FILLS_bin(ba, wb);
	write_BORDERS_bin(ba, wb);
	write_CELLSTYLEXFS_bin(ba, wb);
	write_CELLXFS_bin(ba, opts.cellXfs);
	write_STYLES_bin(ba, wb);
	write_DXFS_bin(ba, wb);
	write_TABLESTYLES_bin(ba, wb);
	write_COLORPALETTE_bin(ba, wb);
	/* FRTSTYLESHEET*/
	write_record(ba, "BrtEndStyleSheet");
	return ba.end();
}
RELS.THEME = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";

/* 20.1.6.2 clrScheme CT_ColorScheme */
function parse_clrScheme(t, themes, opts) {
	themes.themeElements.clrScheme = [];
	var color = {};
	(t[0].match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0]) {
			/* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */
			case '<a:clrScheme': case '</a:clrScheme>': break;

			/* 20.1.2.3.32 srgbClr CT_SRgbColor */
			case '<a:srgbClr':
				color.rgb = y.val; break;

			/* 20.1.2.3.33 sysClr CT_SystemColor */
			case '<a:sysClr':
				color.rgb = y.lastClr; break;

			/* 20.1.4.1.1 accent1 (Accent 1) */
			/* 20.1.4.1.2 accent2 (Accent 2) */
			/* 20.1.4.1.3 accent3 (Accent 3) */
			/* 20.1.4.1.4 accent4 (Accent 4) */
			/* 20.1.4.1.5 accent5 (Accent 5) */
			/* 20.1.4.1.6 accent6 (Accent 6) */
			/* 20.1.4.1.9 dk1 (Dark 1) */
			/* 20.1.4.1.10 dk2 (Dark 2) */
			/* 20.1.4.1.15 folHlink (Followed Hyperlink) */
			/* 20.1.4.1.19 hlink (Hyperlink) */
			/* 20.1.4.1.22 lt1 (Light 1) */
			/* 20.1.4.1.23 lt2 (Light 2) */
			case '<a:dk1>': case '</a:dk1>':
			case '<a:lt1>': case '</a:lt1>':
			case '<a:dk2>': case '</a:dk2>':
			case '<a:lt2>': case '</a:lt2>':
			case '<a:accent1>': case '</a:accent1>':
			case '<a:accent2>': case '</a:accent2>':
			case '<a:accent3>': case '</a:accent3>':
			case '<a:accent4>': case '</a:accent4>':
			case '<a:accent5>': case '</a:accent5>':
			case '<a:accent6>': case '</a:accent6>':
			case '<a:hlink>': case '</a:hlink>':
			case '<a:folHlink>': case '</a:folHlink>':
				if (y[0].charAt(1) === '/') {
					themes.themeElements.clrScheme.push(color);
					color = {};
				} else {
					color.name = y[0].slice(3, y[0].length - 1);
				}
				break;

			default: if(opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
		}
	});
}

/* 20.1.4.1.18 fontScheme CT_FontScheme */
function parse_fontScheme() { }

/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */
function parse_fmtScheme() { }

var clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
var fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
var fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;

/* 20.1.6.10 themeElements CT_BaseStyles */
function parse_themeElements(data, themes, opts) {
	themes.themeElements = {};

	var t;

	[
		/* clrScheme CT_ColorScheme */
		['clrScheme', clrsregex, parse_clrScheme],
		/* fontScheme CT_FontScheme */
		['fontScheme', fntsregex, parse_fontScheme],
		/* fmtScheme CT_StyleMatrix */
		['fmtScheme', fmtsregex, parse_fmtScheme]
	].forEach(function(m) {
		if(!(t=data.match(m[1]))) throw new Error(m[0] + ' not found in themeElements');
		m[2](t, themes, opts);
	});
}

var themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;

/* 14.2.7 Theme Part */
function parse_theme_xml(data, opts) {
	/* 20.1.6.9 theme CT_OfficeStyleSheet */
	if(!data || data.length === 0) return parse_theme_xml(write_theme());

	var t;
	var themes = {};

	/* themeElements CT_BaseStyles */
	if(!(t=data.match(themeltregex))) throw new Error('themeElements not found in theme');
	parse_themeElements(t[0], themes, opts);

	return themes;
}

function write_theme(Themes, opts) {
	if(opts && opts.themeXLSX) return opts.themeXLSX;
	var o = [XML_HEADER];
	o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
	o[o.length] =  '<a:themeElements>';

	o[o.length] =   '<a:clrScheme name="Office">';
	o[o.length] =    '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
	o[o.length] =    '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
	o[o.length] =    '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
	o[o.length] =    '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
	o[o.length] =    '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
	o[o.length] =    '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
	o[o.length] =    '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
	o[o.length] =    '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
	o[o.length] =    '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
	o[o.length] =    '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
	o[o.length] =    '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
	o[o.length] =    '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
	o[o.length] =   '</a:clrScheme>';

	o[o.length] =   '<a:fontScheme name="Office">';
	o[o.length] =    '<a:majorFont>';
	o[o.length] =     '<a:latin typeface="Cambria"/>';
	o[o.length] =     '<a:ea typeface=""/>';
	o[o.length] =     '<a:cs typeface=""/>';
	o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
	o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
	o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
	o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
	o[o.length] =     '<a:font script="Arab" typeface="Times New Roman"/>';
	o[o.length] =     '<a:font script="Hebr" typeface="Times New Roman"/>';
	o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
	o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
	o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
	o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
	o[o.length] =     '<a:font script="Khmr" typeface="MoolBoran"/>';
	o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
	o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
	o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
	o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
	o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
	o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
	o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
	o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
	o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
	o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
	o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
	o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
	o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
	o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
	o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
	o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
	o[o.length] =     '<a:font script="Viet" typeface="Times New Roman"/>';
	o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
	o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
	o[o.length] =    '</a:majorFont>';
	o[o.length] =    '<a:minorFont>';
	o[o.length] =     '<a:latin typeface="Calibri"/>';
	o[o.length] =     '<a:ea typeface=""/>';
	o[o.length] =     '<a:cs typeface=""/>';
	o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
	o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
	o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
	o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
	o[o.length] =     '<a:font script="Arab" typeface="Arial"/>';
	o[o.length] =     '<a:font script="Hebr" typeface="Arial"/>';
	o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
	o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
	o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
	o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
	o[o.length] =     '<a:font script="Khmr" typeface="DaunPenh"/>';
	o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
	o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
	o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
	o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
	o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
	o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
	o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
	o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
	o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
	o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
	o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
	o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
	o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
	o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
	o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
	o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
	o[o.length] =     '<a:font script="Viet" typeface="Arial"/>';
	o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
	o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
	o[o.length] =    '</a:minorFont>';
	o[o.length] =   '</a:fontScheme>';

	o[o.length] =   '<a:fmtScheme name="Office">';
	o[o.length] =    '<a:fillStyleLst>';
	o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:lin ang="16200000" scaled="1"/>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:lin ang="16200000" scaled="0"/>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =    '</a:fillStyleLst>';
	o[o.length] =    '<a:lnStyleLst>';
	o[o.length] =     '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
	o[o.length] =     '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
	o[o.length] =     '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
	o[o.length] =    '</a:lnStyleLst>';
	o[o.length] =    '<a:effectStyleLst>';
	o[o.length] =     '<a:effectStyle>';
	o[o.length] =      '<a:effectLst>';
	o[o.length] =       '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
	o[o.length] =      '</a:effectLst>';
	o[o.length] =     '</a:effectStyle>';
	o[o.length] =     '<a:effectStyle>';
	o[o.length] =      '<a:effectLst>';
	o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
	o[o.length] =      '</a:effectLst>';
	o[o.length] =     '</a:effectStyle>';
	o[o.length] =     '<a:effectStyle>';
	o[o.length] =      '<a:effectLst>';
	o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
	o[o.length] =      '</a:effectLst>';
	o[o.length] =      '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
	o[o.length] =      '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
	o[o.length] =     '</a:effectStyle>';
	o[o.length] =    '</a:effectStyleLst>';
	o[o.length] =    '<a:bgFillStyleLst>';
	o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =    '</a:bgFillStyleLst>';
	o[o.length] =   '</a:fmtScheme>';
	o[o.length] =  '</a:themeElements>';

	o[o.length] =  '<a:objectDefaults>';
	o[o.length] =   '<a:spDef>';
	o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
	o[o.length] =   '</a:spDef>';
	o[o.length] =   '<a:lnDef>';
	o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
	o[o.length] =   '</a:lnDef>';
	o[o.length] =  '</a:objectDefaults>';
	o[o.length] =  '<a:extraClrSchemeLst/>';
	o[o.length] = '</a:theme>';
	return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */
function parse_Theme(blob, length, opts) {
	var end = blob.l + length;
	var dwThemeVersion = blob.read_shift(4);
	if(dwThemeVersion === 124226) return;
	if(!opts.cellStyles || !jszip) { blob.l = end; return; }
	var data = blob.slice(blob.l);
	blob.l = end;
	var zip; try { zip = new jszip(data); } catch(e) { return; }
	var themeXML = getzipstr(zip, "theme/theme/theme1.xml", true);
	if(!themeXML) return;
	return parse_theme_xml(themeXML, opts);
}

/* 2.5.49 */
function parse_ColorTheme(blob) { return blob.read_shift(4); }

/* 2.5.155 */
function parse_FullColorExt(blob) {
	var o = {};
	o.xclrType = blob.read_shift(2);
	o.nTintShade = blob.read_shift(2);
	switch(o.xclrType) {
		case 0: blob.l += 4; break;
		case 1: o.xclrValue = parse_IcvXF(blob, 4); break;
		case 2: o.xclrValue = parse_LongRGBA(blob, 4); break;
		case 3: o.xclrValue = parse_ColorTheme(blob, 4); break;
		case 4: blob.l += 4; break;
	}
	blob.l += 8;
	return o;
}

/* 2.5.164 TODO: read 7 bits*/
function parse_IcvXF(blob, length) {
	return parsenoop(blob, length);
}

/* 2.5.280 */
function parse_XFExtGradient(blob, length) {
	return parsenoop(blob, length);
}

/* [MS-XLS] 2.5.108 */
function parse_ExtProp(blob) {
	var extType = blob.read_shift(2);
	var cb = blob.read_shift(2) - 4;
	var o = [extType];
	switch(extType) {
		case 0x04: case 0x05: case 0x07: case 0x08:
		case 0x09: case 0x0A: case 0x0B: case 0x0D:
			o[1] = parse_FullColorExt(blob, cb); break;
		case 0x06: o[1] = parse_XFExtGradient(blob, cb); break;
		case 0x0E: case 0x0F: o[1] = blob.read_shift(cb === 1 ? 1 : 2); break;
		default: throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
	}
	return o;
}

/* 2.4.355 */
function parse_XFExt(blob, length) {
	var end = blob.l + length;
	blob.l += 2;
	var ixfe = blob.read_shift(2);
	blob.l += 2;
	var cexts = blob.read_shift(2);
	var ext = [];
	while(cexts-- > 0) ext.push(parse_ExtProp(blob, end-blob.l));
	return {ixfe:ixfe, ext:ext};
}

/* xf is an XF, see parse_XFExt for xfext */
function update_xfext(xf, xfext) {
	xfext.forEach(function(xfe) {
		switch(xfe[0]) { /* 2.5.108 extPropData */
			case 0x04: break; /* foreground color */
			case 0x05: break; /* background color */
			case 0x06: break; /* gradient fill */
			case 0x07: break; /* top cell border color */
			case 0x08: break; /* bottom cell border color */
			case 0x09: break; /* left cell border color */
			case 0x0a: break; /* right cell border color */
			case 0x0b: break; /* diagonal cell border color */
			case 0x0d: break; /* text color */
			case 0x0e: break; /* font scheme */
			case 0x0f: break; /* indentation level */
		}
	});
}

/* 18.6 Calculation Chain */
function parse_cc_xml(data) {
	var d = [];
	if(!data) return d;
	var i = 1;
	(data.match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0]) {
			case '<?xml': break;
			/* 18.6.2  calcChain CT_CalcChain 1 */
			case '<calcChain': case '<calcChain>': case '</calcChain>': break;
			/* 18.6.1  c CT_CalcCell 1 */
			case '<c': delete y[0]; if(y.i) i = y.i; else y.i = i; d.push(y); break;
		}
	});
	return d;
}

//function write_cc_xml(data, opts) { }

/* [MS-XLSB] 2.6.4.1 */
function parse_BrtCalcChainItem$(data) {
	var out = {};
	out.i = data.read_shift(4);
	var cell = {};
	cell.r = data.read_shift(4);
	cell.c = data.read_shift(4);
	out.r = encode_cell(cell);
	var flags = data.read_shift(1);
	if(flags & 0x2) out.l = '1';
	if(flags & 0x8) out.a = '1';
	return out;
}

/* 18.6 Calculation Chain */
function parse_cc_bin(data, name, opts) {
	var out = [];
	var pass = false;
	recordhopper(data, function hopper_cc(val, R_n, RT) {
		switch(RT) {
			case 0x003F: /* 'BrtCalcChainItem$' */
				out.push(val); break;

			default:
				if((R_n||"").indexOf("Begin") > 0){/* empty */}
				else if((R_n||"").indexOf("End") > 0){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	});
	return out;
}

//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */
function parse_xlink_xml() {
	//var opts = _opts || {};
	//if(opts.WTF) throw "XLSX External Link";
}

/* [MS-XLSB] 2.1.7.25 External Link */
function parse_xlink_bin(data, name, _opts) {
	if(!data) return data;
	var opts = _opts || {};

	var pass = false, end = false;

	recordhopper(data, function xlink_parse(val, R_n, RT) {
		if(end) return;
		switch(RT) {
			case 0x0167: /* 'BrtSupTabs' */
			case 0x016B: /* 'BrtExternTableStart' */
			case 0x016C: /* 'BrtExternTableEnd' */
			case 0x016E: /* 'BrtExternRowHdr' */
			case 0x016F: /* 'BrtExternCellBlank' */
			case 0x0170: /* 'BrtExternCellReal' */
			case 0x0171: /* 'BrtExternCellBool' */
			case 0x0172: /* 'BrtExternCellError' */
			case 0x0173: /* 'BrtExternCellString' */
			case 0x01D8: /* 'BrtExternValueMeta' */
			case 0x0241: /* 'BrtSupNameStart' */
			case 0x0242: /* 'BrtSupNameValueStart' */
			case 0x0243: /* 'BrtSupNameValueEnd' */
			case 0x0244: /* 'BrtSupNameNum' */
			case 0x0245: /* 'BrtSupNameErr' */
			case 0x0246: /* 'BrtSupNameSt' */
			case 0x0247: /* 'BrtSupNameNil' */
			case 0x0248: /* 'BrtSupNameBool' */
			case 0x0249: /* 'BrtSupNameFmla' */
			case 0x024A: /* 'BrtSupNameBits' */
			case 0x024B: /* 'BrtSupNameEnd' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;

			default:
				if((R_n||"").indexOf("Begin") > 0){/* empty */}
				else if((R_n||"").indexOf("End") > 0){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT.toString(16) + " " + R_n);
		}
	}, opts);
}
RELS.IMG = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";
RELS.DRAW = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing";
/* 20.5 DrawingML - SpreadsheetML Drawing */
function parse_drawing(data, rels) {
	if(!data) return "??";
	/*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/
	var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];

	return rels['!id'][id].Target;
}

/* L.5.5.2 SpreadsheetML Comments + VML Schema */
var _shapeid = 1024;
function write_comments_vml(rId, comments) {
	var csize = [21600, 21600];
	/* L.5.2.1.2 Path Attribute */
	var bbox = ["m0,0l0",csize[1],csize[0],csize[1],csize[0],"0xe"].join(",");
	var o = [
		writextag("xml", null, { 'xmlns:v': XLMLNS.v, 'xmlns:o': XLMLNS.o, 'xmlns:x': XLMLNS.x, 'xmlns:mv': XLMLNS.mv }).replace(/\/>/,">"),
		writextag("o:shapelayout", writextag("o:idmap", null, {'v:ext':"edit", 'data':rId}), {'v:ext':"edit"}),
		writextag("v:shapetype", [
			writextag("v:stroke", null, {joinstyle:"miter"}),
			writextag("v:path", null, {gradientshapeok:"t", 'o:connecttype':"rect"})
		].join(""), {id:"_x0000_t202", 'o:spt':202, coordsize:csize.join(","),path:bbox})
	];
	while(_shapeid < rId * 1000) _shapeid += 1000;

	comments.forEach(function(x) { var c = decode_cell(x[0]);
	o = o.concat([
	'<v:shape' + wxt_helper({
		id:'_x0000_s' + (++_shapeid),
		type:"#_x0000_t202",
		style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : "") ,
		fillcolor:"#ECFAD4",
		strokecolor:"#edeaa1"
	}) + '>',
		writextag('v:fill', writextag("o:fill", null, {type:"gradientUnscaled", 'v:ext':"view"}), {'color2':"#BEFF82", 'angle':"-180", 'type':"gradient"}),
		writextag("v:shadow", null, {on:"t", 'obscured':"t"}),
		writextag("v:path", null, {'o:connecttype':"none"}),
		'<v:textbox><div style="text-align:left"></div></v:textbox>',
		'<x:ClientData ObjectType="Note">',
			'<x:MoveWithCells/>',
			'<x:SizeWithCells/>',
			/* Part 4 19.4.2.3 Anchor (Anchor) */
			writetag('x:Anchor', [c.c, 0, c.r, 0, c.c+3, 100, c.r+5, 100].join(",")),
			writetag('x:AutoFill', "False"),
			writetag('x:Row', String(c.r)),
			writetag('x:Column', String(c.c)),
			x[1].hidden ? '' : '<x:Visible/>',
		'</x:ClientData>',
	'</v:shape>'
	]); });
	o.push('</xml>');
	return o.join("");
}

RELS.CMNT = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";

function parse_comments(zip, dirComments, sheets, sheetRels, opts) {
	for(var i = 0; i != dirComments.length; ++i) {
		var canonicalpath=dirComments[i];
		var comments=parse_cmnt(getzipdata(zip, canonicalpath.replace(/^\//,''), true), canonicalpath, opts);
		if(!comments || !comments.length) continue;
		// find the sheets targeted by these comments
		var sheetNames = keys(sheets);
		for(var j = 0; j != sheetNames.length; ++j) {
			var sheetName = sheetNames[j];
			var rels = sheetRels[sheetName];
			if(rels) {
				var rel = rels[canonicalpath];
				if(rel) insertCommentsIntoSheet(sheetName, sheets[sheetName], comments);
			}
		}
	}
}

function insertCommentsIntoSheet(sheetName, sheet, comments) {
	var dense = Array.isArray(sheet);
	var cell, r;
	comments.forEach(function(comment) {
		if(dense) {
			r = decode_cell(comment.ref);
			if(!sheet[r.r]) sheet[r.r] = [];
			cell = sheet[r.r][r.c];
		} else cell = sheet[comment.ref];
		if (!cell) {
			cell = {};
			if(dense) sheet[r.r][r.c] = cell;
			else sheet[comment.ref] = cell;
			var range = safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");
			var thisCell = decode_cell(comment.ref);
			if(range.s.r > thisCell.r) range.s.r = thisCell.r;
			if(range.e.r < thisCell.r) range.e.r = thisCell.r;
			if(range.s.c > thisCell.c) range.s.c = thisCell.c;
			if(range.e.c < thisCell.c) range.e.c = thisCell.c;
			var encoded = encode_range(range);
			if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
		}

		if (!cell.c) cell.c = [];
		var o = ({a: comment.author, t: comment.t, r: comment.r});
		if(comment.h) o.h = comment.h;
		cell.c.push(o);
	});
}

/* 18.7 Comments */
function parse_comments_xml(data, opts) {
	/* 18.7.6 CT_Comments */
	if(data.match(/<(?:\w+:)?comments *\/>/)) return [];
	var authors = [];
	var commentList = [];
	var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
	if(authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
		if(x === "" || x.trim() === "") return;
		var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
		if(a) authors.push(a[1]);
	});
	var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
	if(cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
		if(x === "" || x.trim() === "") return;
		var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
		if(!cm) return;
		var y = parsexmltag(cm[0]);
		var comment = ({ author: y.authorId && authors[y.authorId] || "sheetjsghost", ref: y.ref, guid: y.guid });
		var cell = decode_cell(y.ref);
		if(opts.sheetRows && opts.sheetRows <= cell.r) return;
		var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
		var rt = !!textMatch && !!textMatch[1] && parse_si(textMatch[1]) || {r:"",t:"",h:""};
		comment.r = rt.r;
		if(rt.r == "<t></t>") rt.t = rt.h = "";
		comment.t = rt.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
		if(opts.cellHTML) comment.h = rt.h;
		commentList.push(comment);
	});
	return commentList;
}

var CMNT_XML_ROOT = writextag('comments', null, { 'xmlns': XMLNS.main[0] });
function write_comments_xml(data) {
	var o = [XML_HEADER, CMNT_XML_ROOT];

	var iauthor = [];
	o.push("<authors>");
	data.forEach(function(x) { x[1].forEach(function(w) { var a = escapexml(w.a);
		if(iauthor.indexOf(a) > -1) return;
		iauthor.push(a);
		o.push("<author>" + a + "</author>");
	}); });
	o.push("</authors>");
	o.push("<commentList>");
	data.forEach(function(d) {
		d[1].forEach(function(c) {
			/* 18.7.3 CT_Comment */
			o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf(escapexml(c.a)) + '"><text>');
			o.push(writetag("t", c.t == null ? "" : c.t));
			o.push('</text></comment>');
		});
	});
	o.push("</commentList>");
	if(o.length>2) { o[o.length] = ('</comments>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */
function parse_BrtBeginComment(data) {
	var out = {};
	out.iauthor = data.read_shift(4);
	var rfx = parse_UncheckedRfX(data, 16);
	out.rfx = rfx.s;
	out.ref = encode_cell(rfx.s);
	data.l += 16; /*var guid = parse_GUID(data); */
	return out;
}
function write_BrtBeginComment(data, o) {
	if(o == null) o = new_buf(36);
	o.write_shift(4, data[1].iauthor);
	write_UncheckedRfX((data[0]), o);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	return o;
}

/* [MS-XLSB] 2.4.327 BrtCommentAuthor */
var parse_BrtCommentAuthor = parse_XLWideString;
function write_BrtCommentAuthor(data) { return write_XLWideString(data.slice(0, 54)); }

/* [MS-XLSB] 2.1.7.8 Comments */
function parse_comments_bin(data, opts) {
	var out = [];
	var authors = [];
	var c = {};
	var pass = false;
	recordhopper(data, function hopper_cmnt(val, R_n, RT) {
		switch(RT) {
			case 0x0278: /* 'BrtCommentAuthor' */
				authors.push(val); break;
			case 0x027B: /* 'BrtBeginComment' */
				c = val; break;
			case 0x027D: /* 'BrtCommentText' */
				c.t = val.t; c.h = val.h; c.r = val.r; break;
			case 0x027C: /* 'BrtEndComment' */
				c.author = authors[c.iauthor];
				delete c.iauthor;
				if(opts.sheetRows && opts.sheetRows <= c.rfx.r) break;
				if(!c.t) c.t = "";
				delete c.rfx; out.push(c); break;

			case 0x0C00: /* 'BrtUid' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */ break;
			case 0x0026: /* 'BrtACEnd' */ break;


			default:
				if((R_n||"").indexOf("Begin") > 0){/* empty */}
				else if((R_n||"").indexOf("End") > 0){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	});
	return out;
}

function write_comments_bin(data) {
	var ba = buf_array();
	var iauthor = [];
	write_record(ba, "BrtBeginComments");

	write_record(ba, "BrtBeginCommentAuthors");
	data.forEach(function(comment) {
		comment[1].forEach(function(c) {
			if(iauthor.indexOf(c.a) > -1) return;
			iauthor.push(c.a.slice(0,54));
			write_record(ba, "BrtCommentAuthor", write_BrtCommentAuthor(c.a));
		});
	});
	write_record(ba, "BrtEndCommentAuthors");

	write_record(ba, "BrtBeginCommentList");
	data.forEach(function(comment) {
		comment[1].forEach(function(c) {
			c.iauthor = iauthor.indexOf(c.a);
			var range = {s:decode_cell(comment[0]),e:decode_cell(comment[0])};
			write_record(ba, "BrtBeginComment", write_BrtBeginComment([range, c]));
			if(c.t && c.t.length > 0) write_record(ba, "BrtCommentText", write_BrtCommentText(c));
			write_record(ba, "BrtEndComment");
			delete c.iauthor;
		});
	});
	write_record(ba, "BrtEndCommentList");

	write_record(ba, "BrtEndComments");
	return ba.end();
}
var CT_VBA = "application/vnd.ms-office.vbaProject";
function make_vba_xls(cfb) {
	var newcfb = CFB.utils.cfb_new({root:"R"});
	cfb.FullPaths.forEach(function(p, i) {
		if(p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
		var newpath = p.replace(/^[^\/]*/,"R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
		CFB.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
	});
	return CFB.write(newcfb);
}

function fill_vba_xls(cfb, vba) {
	vba.FullPaths.forEach(function(p, i) {
		if(i == 0) return;
		var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
		if(newpath.slice(-1) !== "/") CFB.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
	});
}

var VBAFMTS = [ "xlsb", "xlsm", "xlam", "biff8", "xla" ];

RELS.DS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet";
RELS.MS = "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet";

/* macro and dialog sheet stubs */
function parse_ds_bin() { return {'!type':'dialog'}; }
function parse_ds_xml() { return {'!type':'dialog'}; }
function parse_ms_bin() { return {'!type':'macro'}; }
function parse_ms_xml() { return {'!type':'macro'}; }
/* TODO: it will be useful to parse the function str */
var rc_to_a1 = (function(){
	var rcregex = /(^|[^A-Za-z])R(\[?)(-?\d+|)\]?C(\[?)(-?\d+|)\]?/g;
	var rcbase = ({r:0,c:0});
	function rcfunc($$,$1,$2,$3,$4,$5) {
		var R = $3.length>0?parseInt($3,10)|0:0, C = $5.length>0?parseInt($5,10)|0:0;
		if(C<0 && $4.length === 0) C=0;
		var cRel = false, rRel = false;
		if($4.length > 0 || $5.length == 0) cRel = true; if(cRel) C += rcbase.c; else --C;
		if($2.length > 0 || $3.length == 0) rRel = true; if(rRel) R += rcbase.r; else --R;
		return $1 + (cRel ? "" : "$") + encode_col(C) + (rRel ? "" : "$") + encode_row(R);
	}
	return function rc_to_a1(fstr, base) {
		rcbase = base;
		return fstr.replace(rcregex, rcfunc);
	};
})();

var crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)([1-9]\d{0,5}|10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6])(?![_.\(A-Za-z0-9])/g;
var a1_to_rc =(function(){
	return function a1_to_rc(fstr, base) {
		return fstr.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
			var c = decode_col($3) - ($2 ? 0 : base.c);
			var r = decode_row($5) - ($4 ? 0 : base.r);
			var R = (r == 0 ? "" : !$4 ? "[" + r + "]" : (r+1));
			var C = (c == 0 ? "" : !$2 ? "[" + c + "]" : (c+1));
			return $1 + "R" + R + "C" + C;
		});
	};
})();

/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */
function shift_formula_str(f, delta) {
	return f.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
		return $1+($2=="$" ? $2+$3 : encode_col(decode_col($3)+delta.c))+($4=="$" ? $4+$5 : encode_row(decode_row($5) + delta.r));
	});
}

function shift_formula_xlsx(f, range, cell) {
	var r = decode_range(range), s = r.s, c = decode_cell(cell);
	var delta = {r:c.r - s.r, c:c.c - s.c};
	return shift_formula_str(f, delta);
}

/* TODO: parse formula */
function fuzzyfmla(f) {
	if(f.length == 1) return false;
	return true;
}

function _xlfn(f) {
	return f.replace(/_xlfn\./g,"");
}
function parseread1(blob) { blob.l+=1; return; }

/* [MS-XLS] 2.5.51 */
function parse_ColRelU(blob, length) {
	var c = blob.read_shift(length == 1 ? 1 : 2);
	return [c & 0x3FFF, (c >> 14) & 1, (c >> 15) & 1];
}

/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */
function parse_RgceArea(blob, length, opts) {
	var w = 2;
	if(opts) {
		if(opts.biff >= 2 && opts.biff <= 5) return parse_RgceArea_BIFF2(blob, length, opts);
		else if(opts.biff == 12) w = 4;
	}
	var r=blob.read_shift(w), R=blob.read_shift(w);
	var c=parse_ColRelU(blob, 2);
	var C=parse_ColRelU(blob, 2);
	return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
}
/* BIFF 2-5 encodes flags in the row field */
function parse_RgceArea_BIFF2(blob) {
	var r=parse_ColRelU(blob, 2), R=parse_ColRelU(blob, 2);
	var c=blob.read_shift(1);
	var C=blob.read_shift(1);
	return { s:{r:r[0], c:c, cRel:r[1], rRel:r[2]}, e:{r:R[0], c:C, cRel:R[1], rRel:R[2]} };
}

/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */
function parse_RgceAreaRel(blob, length, opts) {
	if(opts.biff < 8) return parse_RgceArea_BIFF2(blob, length, opts);
	var r=blob.read_shift(opts.biff == 12 ? 4 : 2), R=blob.read_shift(opts.biff == 12 ? 4 : 2);
	var c=parse_ColRelU(blob, 2);
	var C=parse_ColRelU(blob, 2);
	return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
}

/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */
function parse_RgceLoc(blob, length, opts) {
	if(opts && opts.biff >= 2 && opts.biff <= 5) return parse_RgceLoc_BIFF2(blob, length, opts);
	var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
	var c = parse_ColRelU(blob, 2);
	return {r:r, c:c[0], cRel:c[1], rRel:c[2]};
}
function parse_RgceLoc_BIFF2(blob) {
	var r = parse_ColRelU(blob, 2);
	var c = blob.read_shift(1);
	return {r:r[0], c:c, cRel:r[1], rRel:r[2]};
}

/* [MS-XLS] 2.5.198.107, 2.5.47 */
function parse_RgceElfLoc(blob) {
	var r = blob.read_shift(2);
	var c = blob.read_shift(2);
	return {r:r, c:c & 0xFF, fQuoted:!!(c & 0x4000), cRel:c>>15, rRel:c>>15 };
}

/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */
function parse_RgceLocRel(blob, length, opts) {
	var biff = opts && opts.biff ? opts.biff : 8;
	if(biff >= 2 && biff <= 5) return parse_RgceLocRel_BIFF2(blob, length, opts);
	var r = blob.read_shift(biff >= 12 ? 4 : 2);
	var cl = blob.read_shift(2);
	var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
	cl &= 0x3FFF;
	if(rRel == 1) while(r > 0x7FFFF) r -= 0x100000;
	if(cRel == 1) while(cl > 0x1FFF) cl = cl - 0x4000;
	return {r:r,c:cl,cRel:cRel,rRel:rRel};
}
function parse_RgceLocRel_BIFF2(blob) {
	var rl = blob.read_shift(2);
	var c = blob.read_shift(1);
	var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
	rl &= 0x3FFF;
	if(rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
	if(cRel == 1 && c >= 0x80) c = c - 0x100;
	return {r:rl,c:c,cRel:cRel,rRel:rRel};
}

/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */
function parse_PtgArea(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var area = parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
	return [type, area];
}

/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */
function parse_PtgArea3d(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var ixti = blob.read_shift(2, 'i');
	var w = 8;
	if(opts) switch(opts.biff) {
		case 5: blob.l += 12; w = 6; break;
		case 12: w = 12; break;
	}
	var area = parse_RgceArea(blob, w, opts);
	return [type, ixti, area];
}

/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */
function parse_PtgAreaErr(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	blob.l += opts && (opts.biff > 8) ? 12 : (opts.biff < 8 ? 6 : 8);
	return [type];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */
function parse_PtgAreaErr3d(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var ixti = blob.read_shift(2);
	var w = 8;
	if(opts) switch(opts.biff) {
		case 5: blob.l += 12; w = 6; break;
		case 12: w = 12; break;
	}
	blob.l += w;
	return [type, ixti];
}

/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */
function parse_PtgAreaN(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var area = parse_RgceAreaRel(blob, length - 1, opts);
	return [type, area];
}

/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */
function parse_PtgArray(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
	return [type];
}

/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */
function parse_PtgAttrBaxcel(blob) {
	var bitSemi = blob[blob.l+1] & 0x01; /* 1 = volatile */
	var bitBaxcel = 1;
	blob.l += 4;
	return [bitSemi, bitBaxcel];
}

/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */
function parse_PtgAttrChoose(blob, length, opts) {
	blob.l +=2;
	var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	var o = [];
	/* offset is 1 less than the number of elements */
	for(var i = 0; i <= offset; ++i) o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
	return o;
}

/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */
function parse_PtgAttrGoto(blob, length, opts) {
	var bitGoto = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += 2;
	return [bitGoto, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
}

/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */
function parse_PtgAttrIf(blob, length, opts) {
	var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += 2;
	return [bitIf, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
}

/* [MS-XLSB] 2.5.97.28 */
function parse_PtgAttrIfError(blob) {
	var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += 2;
	return [bitIf, blob.read_shift(2)];
}

/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */
function parse_PtgAttrSemi(blob, length, opts) {
	var bitSemi = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += opts && opts.biff == 2 ? 3 : 4;
	return [bitSemi];
}

/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */
function parse_PtgAttrSpaceType(blob) {
	var type = blob.read_shift(1), cch = blob.read_shift(1);
	return [type, cch];
}

/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */
function parse_PtgAttrSpace(blob) {
	blob.read_shift(2);
	return parse_PtgAttrSpaceType(blob, 2);
}

/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */
function parse_PtgAttrSpaceSemi(blob) {
	blob.read_shift(2);
	return parse_PtgAttrSpaceType(blob, 2);
}

/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */
function parse_PtgRef(blob, length, opts) {
	//var ptg = blob[blob.l] & 0x1F;
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var loc = parse_RgceLoc(blob, 0, opts);
	return [type, loc];
}

/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */
function parse_PtgRefN(blob, length, opts) {
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var loc = parse_RgceLocRel(blob, 0, opts);
	return [type, loc];
}

/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */
function parse_PtgRef3d(blob, length, opts) {
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var ixti = blob.read_shift(2); // XtiIndex
	if(opts && opts.biff == 5) blob.l += 12;
	var loc = parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
	return [type, ixti, loc];
}


/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */
function parse_PtgFunc(blob, length, opts) {
	//var ptg = blob[blob.l] & 0x1F;
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
	return [FtabArgc[iftab], Ftab[iftab], type];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */
function parse_PtgFuncVar(blob, length, opts) {
	var type = blob[blob.l++];
	var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [(type == 0x58 ? -1 : 0), blob.read_shift(1)]: parsetab(blob);
	return [cparams, (tab[0] === 0 ? Ftab : Cetab)[tab[1]]];
}

function parsetab(blob) {
	return [blob[blob.l+1]>>7, blob.read_shift(2) & 0x7FFF];
}

/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */
function parse_PtgAttrSum(blob, length, opts) {
	blob.l += opts && opts.biff == 2 ? 3 : 4; return;
}

/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */
function parse_PtgExp(blob, length, opts) {
	blob.l++;
	if(opts && opts.biff == 12) return [blob.read_shift(4, 'i'), 0];
	var row = blob.read_shift(2);
	var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	return [row, col];
}

/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */
function parse_PtgErr(blob) { blob.l++; return BErr[blob.read_shift(1)]; }

/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */
function parse_PtgInt(blob) { blob.l++; return blob.read_shift(2); }

/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */
function parse_PtgBool(blob) { blob.l++; return blob.read_shift(1)!==0;}

/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */
function parse_PtgNum(blob) { blob.l++; return parse_Xnum(blob, 8); }

/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */
function parse_PtgStr(blob, length, opts) { blob.l++; return parse_ShortXLUnicodeString(blob, length-1, opts); }

/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */
/* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */
function parse_SerAr(blob, biff) {
	var val = [blob.read_shift(1)];
	if(biff == 12) switch(val[0]) {
		case 0x02: val[0] = 0x04; break; /* SerBool */
		case 0x04: val[0] = 0x10; break; /* SerErr */
		case 0x00: val[0] = 0x01; break; /* SerNum */
		case 0x01: val[0] = 0x02; break; /* SerStr */
	}
	switch(val[0]) {
		case 0x04: /* SerBool -- boolean */
			val[1] = parsebool(blob, 1) ? 'TRUE' : 'FALSE';
			if(biff != 12) blob.l += 7; break;
		case 0x25: /* appears to be an alias */
		case 0x10: /* SerErr -- error */
			val[1] = BErr[blob[blob.l]];
			blob.l += ((biff == 12) ? 4 : 8); break;
		case 0x00: /* SerNil -- honestly, I'm not sure how to reproduce this */
			blob.l += 8; break;
		case 0x01: /* SerNum -- Xnum */
			val[1] = parse_Xnum(blob, 8); break;
		case 0x02: /* SerStr -- XLUnicodeString (<256 chars) */
			val[1] = parse_XLUnicodeString2(blob, 0, {biff:biff > 0 && biff < 8 ? 2 : biff}); break;
		default: throw new Error("Bad SerAr: " + val[0]); /* Unreachable */
	}
	return val;
}

/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */
function parse_PtgExtraMem(blob, cce, opts) {
	var count = blob.read_shift((opts.biff == 12) ? 4 : 2);
	var out = [];
	for(var i = 0; i != count; ++i) out.push(((opts.biff == 12) ? parse_UncheckedRfX : parse_Ref8U)(blob, 8));
	return out;
}

/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */
function parse_PtgExtraArray(blob, length, opts) {
	var rows = 0, cols = 0;
	if(opts.biff == 12) {
		rows = blob.read_shift(4); // DRw
		cols = blob.read_shift(4); // DCol
	} else {
		cols = 1 + blob.read_shift(1); //DColByteU
		rows = 1 + blob.read_shift(2); //DRw
	}
	if(opts.biff >= 2 && opts.biff < 8) { --rows; if(--cols == 0) cols = 0x100; }
	// $FlowIgnore
	for(var i = 0, o = []; i != rows && (o[i] = []); ++i)
		for(var j = 0; j != cols; ++j) o[i][j] = parse_SerAr(blob, opts.biff);
	return o;
}

/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */
function parse_PtgName(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var w = (!opts || (opts.biff >= 8)) ? 4 : 2;
	var nameindex = blob.read_shift(w);
	switch(opts.biff) {
		case 2: blob.l += 5; break;
		case 3: case 4: blob.l += 8; break;
		case 5: blob.l += 12; break;
	}
	return [type, 0, nameindex];
}

/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */
function parse_PtgNameX(blob, length, opts) {
	if(opts.biff == 5) return parse_PtgNameX_BIFF5(blob, length, opts);
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var ixti = blob.read_shift(2); // XtiIndex
	var nameindex = blob.read_shift(4);
	return [type, ixti, nameindex];
}
function parse_PtgNameX_BIFF5(blob) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var ixti = blob.read_shift(2, 'i'); // XtiIndex
	blob.l += 8;
	var nameindex = blob.read_shift(2);
	blob.l += 12;
	return [type, ixti, nameindex];
}

/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */
function parse_PtgMemArea(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	blob.l += (opts && opts.biff == 2 ? 3 : 4);
	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	return [type, cce];
}

/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */
function parse_PtgMemFunc(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	return [type, cce];
}


/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */
function parse_PtgRefErr(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	blob.l += 4;
	if(opts.biff < 8) blob.l--;
	if(opts.biff == 12) blob.l += 2;
	return [type];
}

/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */
function parse_PtgRefErr3d(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var ixti = blob.read_shift(2);
	var w = 4;
	if(opts) switch(opts.biff) {
		case 5: w = 15; break;
		case 12: w = 6; break;
	}
	blob.l += w;
	return [type, ixti];
}

/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */
var parse_PtgMemErr = parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */
var parse_PtgMemNoMem = parsenoop;
/* [MS-XLS] 2.5.198.92 */
var parse_PtgTbl = parsenoop;

function parse_PtgElfLoc(blob, length, opts) {
	blob.l += 2;
	return [parse_RgceElfLoc(blob, 4, opts)];
}
function parse_PtgElfNoop(blob) {
	blob.l += 6;
	return [];
}
/* [MS-XLS] 2.5.198.46 */
var parse_PtgElfCol = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */
var parse_PtgElfColS = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */
var parse_PtgElfColSV = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */
var parse_PtgElfColV = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */
function parse_PtgElfLel(blob) {
	blob.l += 2;
	return [parseuint16(blob), blob.read_shift(2) & 0x01];
}
/* [MS-XLS] 2.5.198.51 */
var parse_PtgElfRadical = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */
var parse_PtgElfRadicalLel = parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */
var parse_PtgElfRadicalS = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */
var parse_PtgElfRw = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */
var parse_PtgElfRwV = parse_PtgElfLoc;

/* [MS-XLSB] 2.5.97.52 TODO */
var PtgListRT = [
	"Data",
	"All",
	"Headers",
	"??",
	"?Data2",
	"??",
	"?DataHeaders",
	"??",
	"Totals",
	"??",
	"??",
	"??",
	"?DataTotals",
	"??",
	"??",
	"??",
	"?Current"
];
function parse_PtgList(blob) {
	blob.l += 2;
	var ixti = blob.read_shift(2);
	var flags = blob.read_shift(2);
	var idx = blob.read_shift(4);
	var c = blob.read_shift(2);
	var C = blob.read_shift(2);
	var rt = PtgListRT[(flags >> 2) & 0x1F];
	return {ixti: ixti, coltype:(flags&0x3), rt:rt, idx:idx, c:c, C:C};
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */
function parse_PtgSxName(blob) {
	blob.l += 2;
	return [blob.read_shift(4)];
}

/* [XLS] old spec */
function parse_PtgSheet(blob, length, opts) {
	blob.l += 5;
	blob.l += 2;
	blob.l += (opts.biff == 2 ? 1 : 4);
	return ["PTGSHEET"];
}
function parse_PtgEndSheet(blob, length, opts) {
	blob.l += (opts.biff == 2 ? 4 : 5);
	return ["PTGENDSHEET"];
}
function parse_PtgMemAreaN(blob) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var cce = blob.read_shift(2);
	return [type, cce];
}
function parse_PtgMemNoMemN(blob) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var cce = blob.read_shift(2);
	return [type, cce];
}
function parse_PtgAttrNoop(blob) {
	blob.l += 4;
	return [0, 0];
}

/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */
var PtgTypes = {
0x01: { n:'PtgExp', f:parse_PtgExp },
0x02: { n:'PtgTbl', f:parse_PtgTbl },
0x03: { n:'PtgAdd', f:parseread1 },
0x04: { n:'PtgSub', f:parseread1 },
0x05: { n:'PtgMul', f:parseread1 },
0x06: { n:'PtgDiv', f:parseread1 },
0x07: { n:'PtgPower', f:parseread1 },
0x08: { n:'PtgConcat', f:parseread1 },
0x09: { n:'PtgLt', f:parseread1 },
0x0A: { n:'PtgLe', f:parseread1 },
0x0B: { n:'PtgEq', f:parseread1 },
0x0C: { n:'PtgGe', f:parseread1 },
0x0D: { n:'PtgGt', f:parseread1 },
0x0E: { n:'PtgNe', f:parseread1 },
0x0F: { n:'PtgIsect', f:parseread1 },
0x10: { n:'PtgUnion', f:parseread1 },
0x11: { n:'PtgRange', f:parseread1 },
0x12: { n:'PtgUplus', f:parseread1 },
0x13: { n:'PtgUminus', f:parseread1 },
0x14: { n:'PtgPercent', f:parseread1 },
0x15: { n:'PtgParen', f:parseread1 },
0x16: { n:'PtgMissArg', f:parseread1 },
0x17: { n:'PtgStr', f:parse_PtgStr },
0x1A: { n:'PtgSheet', f:parse_PtgSheet },
0x1B: { n:'PtgEndSheet', f:parse_PtgEndSheet },
0x1C: { n:'PtgErr', f:parse_PtgErr },
0x1D: { n:'PtgBool', f:parse_PtgBool },
0x1E: { n:'PtgInt', f:parse_PtgInt },
0x1F: { n:'PtgNum', f:parse_PtgNum },
0x20: { n:'PtgArray', f:parse_PtgArray },
0x21: { n:'PtgFunc', f:parse_PtgFunc },
0x22: { n:'PtgFuncVar', f:parse_PtgFuncVar },
0x23: { n:'PtgName', f:parse_PtgName },
0x24: { n:'PtgRef', f:parse_PtgRef },
0x25: { n:'PtgArea', f:parse_PtgArea },
0x26: { n:'PtgMemArea', f:parse_PtgMemArea },
0x27: { n:'PtgMemErr', f:parse_PtgMemErr },
0x28: { n:'PtgMemNoMem', f:parse_PtgMemNoMem },
0x29: { n:'PtgMemFunc', f:parse_PtgMemFunc },
0x2A: { n:'PtgRefErr', f:parse_PtgRefErr },
0x2B: { n:'PtgAreaErr', f:parse_PtgAreaErr },
0x2C: { n:'PtgRefN', f:parse_PtgRefN },
0x2D: { n:'PtgAreaN', f:parse_PtgAreaN },
0x2E: { n:'PtgMemAreaN', f:parse_PtgMemAreaN },
0x2F: { n:'PtgMemNoMemN', f:parse_PtgMemNoMemN },
0x39: { n:'PtgNameX', f:parse_PtgNameX },
0x3A: { n:'PtgRef3d', f:parse_PtgRef3d },
0x3B: { n:'PtgArea3d', f:parse_PtgArea3d },
0x3C: { n:'PtgRefErr3d', f:parse_PtgRefErr3d },
0x3D: { n:'PtgAreaErr3d', f:parse_PtgAreaErr3d },
0xFF: {}
};
/* These are duplicated in the PtgTypes table */
var PtgDupes = {
0x40: 0x20, 0x60: 0x20,
0x41: 0x21, 0x61: 0x21,
0x42: 0x22, 0x62: 0x22,
0x43: 0x23, 0x63: 0x23,
0x44: 0x24, 0x64: 0x24,
0x45: 0x25, 0x65: 0x25,
0x46: 0x26, 0x66: 0x26,
0x47: 0x27, 0x67: 0x27,
0x48: 0x28, 0x68: 0x28,
0x49: 0x29, 0x69: 0x29,
0x4A: 0x2A, 0x6A: 0x2A,
0x4B: 0x2B, 0x6B: 0x2B,
0x4C: 0x2C, 0x6C: 0x2C,
0x4D: 0x2D, 0x6D: 0x2D,
0x4E: 0x2E, 0x6E: 0x2E,
0x4F: 0x2F, 0x6F: 0x2F,
0x58: 0x22, 0x78: 0x22,
0x59: 0x39, 0x79: 0x39,
0x5A: 0x3A, 0x7A: 0x3A,
0x5B: 0x3B, 0x7B: 0x3B,
0x5C: 0x3C, 0x7C: 0x3C,
0x5D: 0x3D, 0x7D: 0x3D
};
(function(){for(var y in PtgDupes) PtgTypes[y] = PtgTypes[PtgDupes[y]];})();

var Ptg18 = {
0x01: { n:'PtgElfLel', f:parse_PtgElfLel },
0x02: { n:'PtgElfRw', f:parse_PtgElfRw },
0x03: { n:'PtgElfCol', f:parse_PtgElfCol },
0x06: { n:'PtgElfRwV', f:parse_PtgElfRwV },
0x07: { n:'PtgElfColV', f:parse_PtgElfColV },
0x0A: { n:'PtgElfRadical', f:parse_PtgElfRadical },
0x0B: { n:'PtgElfRadicalS', f:parse_PtgElfRadicalS },
0x0D: { n:'PtgElfColS', f:parse_PtgElfColS },
0x0F: { n:'PtgElfColSV', f:parse_PtgElfColSV },
0x10: { n:'PtgElfRadicalLel', f:parse_PtgElfRadicalLel },
0x19: { n:'PtgList', f:parse_PtgList },
0x1D: { n:'PtgSxName', f:parse_PtgSxName },
0xFF: {}
};
var Ptg19 = {
0x00: { n:'PtgAttrNoop', f:parse_PtgAttrNoop },
0x01: { n:'PtgAttrSemi', f:parse_PtgAttrSemi },
0x02: { n:'PtgAttrIf', f:parse_PtgAttrIf },
0x04: { n:'PtgAttrChoose', f:parse_PtgAttrChoose },
0x08: { n:'PtgAttrGoto', f:parse_PtgAttrGoto },
0x10: { n:'PtgAttrSum', f:parse_PtgAttrSum },
0x20: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
0x40: { n:'PtgAttrSpace', f:parse_PtgAttrSpace },
0x41: { n:'PtgAttrSpaceSemi', f:parse_PtgAttrSpaceSemi },
0x80: { n:'PtgAttrIfError', f:parse_PtgAttrIfError },
0xFF: {}
};
Ptg19[0x21] = Ptg19[0x20];

/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */
function parse_RgbExtra(blob, length, rgce, opts) {
	if(opts.biff < 8) return parsenoop(blob, length);
	var target = blob.l + length;
	var o = [];
	for(var i = 0; i !== rgce.length; ++i) {
		switch(rgce[i][0]) {
			case 'PtgArray': /* PtgArray -> PtgExtraArray */
				rgce[i][1] = parse_PtgExtraArray(blob, 0, opts);
				o.push(rgce[i][1]);
				break;
			case 'PtgMemArea': /* PtgMemArea -> PtgExtraMem */
				rgce[i][2] = parse_PtgExtraMem(blob, rgce[i][1], opts);
				o.push(rgce[i][2]);
				break;
			case 'PtgExp': /* PtgExp -> PtgExtraCol */
				if(opts && opts.biff == 12) {
					rgce[i][1][1] = blob.read_shift(4);
					o.push(rgce[i][1]);
				} break;
			case 'PtgList': /* TODO: PtgList -> PtgExtraList */
			case 'PtgElfRadicalS': /* TODO: PtgElfRadicalS -> PtgExtraElf */
			case 'PtgElfColS': /* TODO: PtgElfColS -> PtgExtraElf */
			case 'PtgElfColSV': /* TODO: PtgElfColSV -> PtgExtraElf */
				throw "Unsupported " + rgce[i][0];
			default: break;
		}
	}
	length = target - blob.l;
	/* note: this is technically an error but Excel disregards */
	//if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
	if(length !== 0) o.push(parsenoop(blob, length));
	return o;
}

/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */
function parse_Rgce(blob, length, opts) {
	var target = blob.l + length;
	var R, id, ptgs = [];
	while(target != blob.l) {
		length = target - blob.l;
		id = blob[blob.l];
		R = PtgTypes[id];
		if(id === 0x18 || id === 0x19) R = (id === 0x18 ? Ptg18 : Ptg19)[blob[blob.l + 1]];
		if(!R || !R.f) { /*ptgs.push*/(parsenoop(blob, length)); }
		else { ptgs.push([R.n, R.f(blob, length, opts)]); }
	}
	return ptgs;
}

function stringify_array(f) {
	var o = [];
	for(var i = 0; i < f.length; ++i) {
		var x = f[i], r = [];
		for(var j = 0; j < x.length; ++j) {
			var y = x[j];
			if(y) switch(y[0]) {
				// TODO: handle embedded quotes
				case 0x02:
r.push('"' + y[1].replace(/"/g,'""') + '"'); break;
				default: r.push(y[1]);
			} else r.push("");
		}
		o.push(r.join(","));
	}
	return o.join(";");
}

/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */
var PtgBinOp = {
	PtgAdd: "+",
	PtgConcat: "&",
	PtgDiv: "/",
	PtgEq: "=",
	PtgGe: ">=",
	PtgGt: ">",
	PtgLe: "<=",
	PtgLt: "<",
	PtgMul: "*",
	PtgNe: "<>",
	PtgPower: "^",
	PtgSub: "-"
};
function formula_quote_sheet_name(sname, opts) {
	if(!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
	if(sname.indexOf(" ") > -1) return "'" + sname + "'";
	return sname;
}
function get_ixti_raw(supbooks, ixti, opts) {
	if(!supbooks) return "SH33TJSERR0";
	if(!supbooks.XTI) return "SH33TJSERR6";
	var XTI = supbooks.XTI[ixti];
	if(opts.biff > 8 && !supbooks.XTI[ixti]) return supbooks.SheetNames[ixti];
	if(opts.biff < 8) {
		if(ixti > 10000) ixti-= 65536;
		if(ixti < 0) ixti = -ixti;
		return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
	}
	if(!XTI) return "SH33TJSERR1";
	var o = "";
	if(opts.biff > 8) switch(supbooks[XTI[0]][0]) {
		case 0x0165: /* 'BrtSupSelf' */
			o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
			return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
		case 0x0166: /* 'BrtSupSame' */
			if(opts.SID != null) return supbooks.SheetNames[opts.SID];
			return "SH33TJSSAME" + supbooks[XTI[0]][0];
		case 0x0163: /* 'BrtSupBookSrc' */
			/* falls through */
		default: return "SH33TJSSRC" + supbooks[XTI[0]][0];
	}
	switch(supbooks[XTI[0]][0][0]) {
		case 0x0401:
			o = XTI[1] == -1 ? "#REF" : (supbooks.SheetNames[XTI[1]] || "SH33TJSERR3");
			return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
		case 0x3A01: return "SH33TJSERR8";
		default:
			if(!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
			o = XTI[1] == -1 ? "#REF" : (supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4");
			return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
	}
}
function get_ixti(supbooks, ixti, opts) {
	return formula_quote_sheet_name(get_ixti_raw(supbooks, ixti, opts), opts);
}
function stringify_formula(formula/*Array<any>*/, range, cell, supbooks, opts) {
	var biff = (opts && opts.biff) || 8;
	var _range = /*range != null ? range :*/ {s:{c:0, r:0},e:{c:0, r:0}};
	var stack = [], e1, e2,  c, ixti=0, nameidx=0, r, sname="";
	if(!formula[0] || !formula[0][0]) return "";
	var last_sp = -1, sp = "";
	for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff) {
		var f = formula[0][ff];
		switch(f[0]) {
			case 'PtgUminus': /* [MS-XLS] 2.5.198.93 */
				stack.push("-" + stack.pop()); break;
			case 'PtgUplus': /* [MS-XLS] 2.5.198.95 */
				stack.push("+" + stack.pop()); break;
			case 'PtgPercent': /* [MS-XLS] 2.5.198.81 */
				stack.push(stack.pop() + "%"); break;

			case 'PtgAdd':    /* [MS-XLS] 2.5.198.26 */
			case 'PtgConcat': /* [MS-XLS] 2.5.198.43 */
			case 'PtgDiv':    /* [MS-XLS] 2.5.198.45 */
			case 'PtgEq':     /* [MS-XLS] 2.5.198.56 */
			case 'PtgGe':     /* [MS-XLS] 2.5.198.64 */
			case 'PtgGt':     /* [MS-XLS] 2.5.198.65 */
			case 'PtgLe':     /* [MS-XLS] 2.5.198.68 */
			case 'PtgLt':     /* [MS-XLS] 2.5.198.69 */
			case 'PtgMul':    /* [MS-XLS] 2.5.198.75 */
			case 'PtgNe':     /* [MS-XLS] 2.5.198.78 */
			case 'PtgPower':  /* [MS-XLS] 2.5.198.82 */
			case 'PtgSub':    /* [MS-XLS] 2.5.198.90 */
				e1 = stack.pop(); e2 = stack.pop();
				if(last_sp >= 0) {
					switch(formula[0][last_sp][1][0]) {
						case 0:
							// $FlowIgnore
							sp = fill(" ", formula[0][last_sp][1][1]); break;
						case 1:
							// $FlowIgnore
							sp = fill("\r", formula[0][last_sp][1][1]); break;
						default:
							sp = "";
							// $FlowIgnore
							if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
					}
					e2 = e2 + sp;
					last_sp = -1;
				}
				stack.push(e2+PtgBinOp[f[0]]+e1);
				break;

			case 'PtgIsect': /* [MS-XLS] 2.5.198.67 */
				e1 = stack.pop(); e2 = stack.pop();
				stack.push(e2+" "+e1);
				break;
			case 'PtgUnion': /* [MS-XLS] 2.5.198.94 */
				e1 = stack.pop(); e2 = stack.pop();
				stack.push(e2+","+e1);
				break;
			case 'PtgRange': /* [MS-XLS] 2.5.198.83 */
				e1 = stack.pop(); e2 = stack.pop();
				stack.push(e2+":"+e1);
				break;

			case 'PtgAttrChoose': /* [MS-XLS] 2.5.198.34 */
				break;
			case 'PtgAttrGoto': /* [MS-XLS] 2.5.198.35 */
				break;
			case 'PtgAttrIf': /* [MS-XLS] 2.5.198.36 */
				break;
			case 'PtgAttrIfError': /* [MS-XLSB] 2.5.97.28 */
				break;


			case 'PtgRef': /* [MS-XLS] 2.5.198.84 */
c = shift_cell_xls((f[1][1]), _range, opts);
				stack.push(encode_cell_xls(c, biff));
				break;
			case 'PtgRefN': /* [MS-XLS] 2.5.198.88 */
c = cell ? shift_cell_xls((f[1][1]), cell, opts) : (f[1][1]);
				stack.push(encode_cell_xls(c, biff));
				break;
			case 'PtgRef3d': /* [MS-XLS] 2.5.198.85 */
ixti = f[1][1]; c = shift_cell_xls((f[1][2]), _range, opts);
				sname = get_ixti(supbooks, ixti, opts);
				var w = sname; /* IE9 fails on defined names */ // eslint-disable-line no-unused-vars
				stack.push(sname + "!" + encode_cell_xls(c, biff));
				break;

			case 'PtgFunc': /* [MS-XLS] 2.5.198.62 */
			case 'PtgFuncVar': /* [MS-XLS] 2.5.198.63 */
				/* f[1] = [argc, func, type] */
				var argc = (f[1][0]), func = (f[1][1]);
				if(!argc) argc = 0;
				argc &= 0x7F;
				var args = argc == 0 ? [] : stack.slice(-argc);
				stack.length -= argc;
				if(func === 'User') func = args.shift();
				stack.push(func + "(" + args.join(",") + ")");
				break;

			case 'PtgBool': /* [MS-XLS] 2.5.198.42 */
				stack.push(f[1] ? "TRUE" : "FALSE"); break;
			case 'PtgInt': /* [MS-XLS] 2.5.198.66 */
				stack.push(f[1]); break;
			case 'PtgNum': /* [MS-XLS] 2.5.198.79 TODO: precision? */
				stack.push(String(f[1])); break;
			case 'PtgStr': /* [MS-XLS] 2.5.198.89 */
				// $FlowIgnore
				stack.push('"' + f[1] + '"'); break;
			case 'PtgErr': /* [MS-XLS] 2.5.198.57 */
				stack.push(f[1]); break;
			case 'PtgAreaN': /* [MS-XLS] 2.5.198.31 TODO */
r = shift_range_xls(f[1][1], cell ? {s:cell} : _range, opts);
				stack.push(encode_range_xls((r), opts));
				break;
			case 'PtgArea': /* [MS-XLS] 2.5.198.27 TODO: fixed points */
r = shift_range_xls(f[1][1], _range, opts);
				stack.push(encode_range_xls((r), opts));
				break;
			case 'PtgArea3d': /* [MS-XLS] 2.5.198.28 TODO */
ixti = f[1][1]; r = f[1][2];
				sname = get_ixti(supbooks, ixti, opts);
				stack.push(sname + "!" + encode_range_xls((r), opts));
				break;
			case 'PtgAttrSum': /* [MS-XLS] 2.5.198.41 */
				stack.push("SUM(" + stack.pop() + ")");
				break;

			case 'PtgAttrBaxcel': /* [MS-XLS] 2.5.198.33 */
			case 'PtgAttrSemi': /* [MS-XLS] 2.5.198.37 */
				break;

			case 'PtgName': /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */
				/* f[1] = type, 0, nameindex */
				nameidx = (f[1][2]);
				var lbl = (supbooks.names||[])[nameidx-1] || (supbooks[0]||[])[nameidx];
				var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
				if(name in XLSXFutureFunctions) name = XLSXFutureFunctions[name];
				stack.push(name);
				break;

			case 'PtgNameX': /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */
				/* f[1] = type, ixti, nameindex */
				var bookidx = (f[1][1]); nameidx = (f[1][2]); var externbook;
				/* TODO: Properly handle missing values */
				if(opts.biff <= 5) {
					if(bookidx < 0) bookidx = -bookidx;
					if(supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
				} else {
					var o = "";
					if(((supbooks[bookidx]||[])[0]||[])[0] == 0x3A01){/* empty */}
					else if(((supbooks[bookidx]||[])[0]||[])[0] == 0x0401){
						if(supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) {
							o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab-1] + "!";
						}
					}
					else o = supbooks.SheetNames[nameidx-1]+ "!";
					if(supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
					else if(supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
					else o += "SH33TJSERRX";
					stack.push(o);
					break;
				}
				if(!externbook) externbook = {Name: "SH33TJSERRY"};
				stack.push(externbook.Name);
				break;

			case 'PtgParen': /* [MS-XLS] 2.5.198.80 */
				var lp = '(', rp = ')';
				if(last_sp >= 0) {
					sp = "";
					switch(formula[0][last_sp][1][0]) {
						// $FlowIgnore
						case 2: lp = fill(" ", formula[0][last_sp][1][1]) + lp; break;
						// $FlowIgnore
						case 3: lp = fill("\r", formula[0][last_sp][1][1]) + lp; break;
						// $FlowIgnore
						case 4: rp = fill(" ", formula[0][last_sp][1][1]) + rp; break;
						// $FlowIgnore
						case 5: rp = fill("\r", formula[0][last_sp][1][1]) + rp; break;
						default:
							// $FlowIgnore
							if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
					}
					last_sp = -1;
				}
				stack.push(lp + stack.pop() + rp); break;

			case 'PtgRefErr': /* [MS-XLS] 2.5.198.86 */
				stack.push('#REF!'); break;

			case 'PtgRefErr3d': /* [MS-XLS] 2.5.198.87 */
				stack.push('#REF!'); break;

			case 'PtgExp': /* [MS-XLS] 2.5.198.58 TODO */
				c = {c:(f[1][1]),r:(f[1][0])};
				var q = ({c: cell.c, r:cell.r});
				if(supbooks.sharedf[encode_cell(c)]) {
					var parsedf = (supbooks.sharedf[encode_cell(c)]);
					stack.push(stringify_formula(parsedf, _range, q, supbooks, opts));
				}
				else {
					var fnd = false;
					for(e1=0;e1!=supbooks.arrayf.length; ++e1) {
						/* TODO: should be something like range_has */
						e2 = supbooks.arrayf[e1];
						if(c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
						if(c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
						stack.push(stringify_formula(e2[1], _range, q, supbooks, opts));
						fnd = true;
						break;
					}
					if(!fnd) stack.push(f[1]);
				}
				break;

			case 'PtgArray': /* [MS-XLS] 2.5.198.32 TODO */
				stack.push("{" + stringify_array(f[1]) + "}");
				break;

			case 'PtgMemArea': /* [MS-XLS] 2.5.198.70 TODO: confirm this is a non-display */
				//stack.push("(" + f[2].map(encode_range).join(",") + ")");
				break;

			case 'PtgAttrSpace': /* [MS-XLS] 2.5.198.38 */
			case 'PtgAttrSpaceSemi': /* [MS-XLS] 2.5.198.39 */
				last_sp = ff;
				break;

			case 'PtgTbl': /* [MS-XLS] 2.5.198.92 TODO */
				break;

			case 'PtgMemErr': /* [MS-XLS] 2.5.198.71 */
				break;

			case 'PtgMissArg': /* [MS-XLS] 2.5.198.74 */
				stack.push("");
				break;

			case 'PtgAreaErr': /* [MS-XLS] 2.5.198.29 */
				stack.push("#REF!"); break;

			case 'PtgAreaErr3d': /* [MS-XLS] 2.5.198.30 */
				stack.push("#REF!"); break;

			case 'PtgList': /* [MS-XLSB] 2.5.97.52 */
				// $FlowIgnore
				stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
				break;

			case 'PtgMemAreaN':
			case 'PtgMemNoMemN':
			case 'PtgAttrNoop':
			case 'PtgSheet':
			case 'PtgEndSheet':
				break;

			case 'PtgMemFunc': /* [MS-XLS] 2.5.198.72 TODO */
				break;
			case 'PtgMemNoMem': /* [MS-XLS] 2.5.198.73 TODO */
				break;

			case 'PtgElfCol': /* [MS-XLS] 2.5.198.46 */
			case 'PtgElfColS': /* [MS-XLS] 2.5.198.47 */
			case 'PtgElfColSV': /* [MS-XLS] 2.5.198.48 */
			case 'PtgElfColV': /* [MS-XLS] 2.5.198.49 */
			case 'PtgElfLel': /* [MS-XLS] 2.5.198.50 */
			case 'PtgElfRadical': /* [MS-XLS] 2.5.198.51 */
			case 'PtgElfRadicalLel': /* [MS-XLS] 2.5.198.52 */
			case 'PtgElfRadicalS': /* [MS-XLS] 2.5.198.53 */
			case 'PtgElfRw': /* [MS-XLS] 2.5.198.54 */
			case 'PtgElfRwV': /* [MS-XLS] 2.5.198.55 */
				throw new Error("Unsupported ELFs");

			case 'PtgSxName': /* [MS-XLS] 2.5.198.91 TODO -- find a test case */
				throw new Error('Unrecognized Formula Token: ' + String(f));
			default: throw new Error('Unrecognized Formula Token: ' + String(f));
		}
		var PtgNonDisp = ['PtgAttrSpace', 'PtgAttrSpaceSemi', 'PtgAttrGoto'];
		if(opts.biff != 3) if(last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
			f = formula[0][last_sp];
			var _left = true;
			switch(f[1][0]) {
				/* note: some bad XLSB files omit the PtgParen */
				case 4: _left = false;
				/* falls through */
				case 0:
					// $FlowIgnore
					sp = fill(" ", f[1][1]); break;
				case 5: _left = false;
				/* falls through */
				case 1:
					// $FlowIgnore
					sp = fill("\r", f[1][1]); break;
				default:
					sp = "";
					// $FlowIgnore
					if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
			}
			stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
			last_sp = -1;
		}
	}
	if(stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
	return stack[0];
}

/* [MS-XLS] 2.5.198.1 TODO */
function parse_ArrayParsedFormula(blob, length, opts) {
	var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
	var rgcb, cce = blob.read_shift(len); // length of rgce
	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
	var rgce = parse_Rgce(blob, cce, opts);
	if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
	blob.l = target;
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.198.3 TODO */
function parse_XLSCellParsedFormula(blob, length, opts) {
	var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
	var rgcb, cce = blob.read_shift(len); // length of rgce
	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
	var rgce = parse_Rgce(blob, cce, opts);
	if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
	blob.l = target;
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.198.21 */
function parse_NameParsedFormula(blob, length, opts, cce) {
	var target = blob.l + length;
	var rgce = parse_Rgce(blob, cce, opts);
	var rgcb;
	if(target !== blob.l) rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.198.118 TODO */
function parse_SharedParsedFormula(blob, length, opts) {
	var target = blob.l + length;
	var rgcb, cce = blob.read_shift(2); // length of rgce
	var rgce = parse_Rgce(blob, cce, opts);
	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
	if(length !== cce + 2) rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */
function parse_FormulaValue(blob) {
	var b;
	if(__readUInt16LE(blob,blob.l + 6) !== 0xFFFF) return [parse_Xnum(blob),'n'];
	switch(blob[blob.l]) {
		case 0x00: blob.l += 8; return ["String", 's'];
		case 0x01: b = blob[blob.l+2] === 0x1; blob.l += 8; return [b,'b'];
		case 0x02: b = blob[blob.l+2]; blob.l += 8; return [b,'e'];
		case 0x03: blob.l += 8; return ["",'s'];
	}
	return [];
}

/* [MS-XLS] 2.4.127 TODO */
function parse_Formula(blob, length, opts) {
	var end = blob.l + length;
	var cell = parse_XLSCell(blob, 6);
	if(opts.biff == 2) ++blob.l;
	var val = parse_FormulaValue(blob,8);
	var flags = blob.read_shift(1);
	if(opts.biff != 2) {
		blob.read_shift(1);
		if(opts.biff >= 5) {
			/*var chn = */blob.read_shift(4);
		}
	}
	var cbf = parse_XLSCellParsedFormula(blob, end - blob.l, opts);
	return {cell:cell, val:val[0], formula:cbf, shared: (flags >> 3) & 1, tt:val[1]};
}

/* XLSB Parsed Formula records have the same shape */
function parse_XLSBParsedFormula(data, length, opts) {
	var cce = data.read_shift(4);
	var rgce = parse_Rgce(data, cce, opts);
	var cb = data.read_shift(4);
	var rgcb = cb > 0 ? parse_RgbExtra(data, cb, rgce, opts) : null;
	return [rgce, rgcb];
}

/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */
var parse_XLSBArrayParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */
var parse_XLSBCellParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */
var parse_XLSBNameParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */
var parse_XLSBSharedParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLS] 2.5.198.4 */
var Cetab = {
0x0000: 'BEEP',
0x0001: 'OPEN',
0x0002: 'OPEN.LINKS',
0x0003: 'CLOSE.ALL',
0x0004: 'SAVE',
0x0005: 'SAVE.AS',
0x0006: 'FILE.DELETE',
0x0007: 'PAGE.SETUP',
0x0008: 'PRINT',
0x0009: 'PRINTER.SETUP',
0x000A: 'QUIT',
0x000B: 'NEW.WINDOW',
0x000C: 'ARRANGE.ALL',
0x000D: 'WINDOW.SIZE',
0x000E: 'WINDOW.MOVE',
0x000F: 'FULL',
0x0010: 'CLOSE',
0x0011: 'RUN',
0x0016: 'SET.PRINT.AREA',
0x0017: 'SET.PRINT.TITLES',
0x0018: 'SET.PAGE.BREAK',
0x0019: 'REMOVE.PAGE.BREAK',
0x001A: 'FONT',
0x001B: 'DISPLAY',
0x001C: 'PROTECT.DOCUMENT',
0x001D: 'PRECISION',
0x001E: 'A1.R1C1',
0x001F: 'CALCULATE.NOW',
0x0020: 'CALCULATION',
0x0022: 'DATA.FIND',
0x0023: 'EXTRACT',
0x0024: 'DATA.DELETE',
0x0025: 'SET.DATABASE',
0x0026: 'SET.CRITERIA',
0x0027: 'SORT',
0x0028: 'DATA.SERIES',
0x0029: 'TABLE',
0x002A: 'FORMAT.NUMBER',
0x002B: 'ALIGNMENT',
0x002C: 'STYLE',
0x002D: 'BORDER',
0x002E: 'CELL.PROTECTION',
0x002F: 'COLUMN.WIDTH',
0x0030: 'UNDO',
0x0031: 'CUT',
0x0032: 'COPY',
0x0033: 'PASTE',
0x0034: 'CLEAR',
0x0035: 'PASTE.SPECIAL',
0x0036: 'EDIT.DELETE',
0x0037: 'INSERT',
0x0038: 'FILL.RIGHT',
0x0039: 'FILL.DOWN',
0x003D: 'DEFINE.NAME',
0x003E: 'CREATE.NAMES',
0x003F: 'FORMULA.GOTO',
0x0040: 'FORMULA.FIND',
0x0041: 'SELECT.LAST.CELL',
0x0042: 'SHOW.ACTIVE.CELL',
0x0043: 'GALLERY.AREA',
0x0044: 'GALLERY.BAR',
0x0045: 'GALLERY.COLUMN',
0x0046: 'GALLERY.LINE',
0x0047: 'GALLERY.PIE',
0x0048: 'GALLERY.SCATTER',
0x0049: 'COMBINATION',
0x004A: 'PREFERRED',
0x004B: 'ADD.OVERLAY',
0x004C: 'GRIDLINES',
0x004D: 'SET.PREFERRED',
0x004E: 'AXES',
0x004F: 'LEGEND',
0x0050: 'ATTACH.TEXT',
0x0051: 'ADD.ARROW',
0x0052: 'SELECT.CHART',
0x0053: 'SELECT.PLOT.AREA',
0x0054: 'PATTERNS',
0x0055: 'MAIN.CHART',
0x0056: 'OVERLAY',
0x0057: 'SCALE',
0x0058: 'FORMAT.LEGEND',
0x0059: 'FORMAT.TEXT',
0x005A: 'EDIT.REPEAT',
0x005B: 'PARSE',
0x005C: 'JUSTIFY',
0x005D: 'HIDE',
0x005E: 'UNHIDE',
0x005F: 'WORKSPACE',
0x0060: 'FORMULA',
0x0061: 'FORMULA.FILL',
0x0062: 'FORMULA.ARRAY',
0x0063: 'DATA.FIND.NEXT',
0x0064: 'DATA.FIND.PREV',
0x0065: 'FORMULA.FIND.NEXT',
0x0066: 'FORMULA.FIND.PREV',
0x0067: 'ACTIVATE',
0x0068: 'ACTIVATE.NEXT',
0x0069: 'ACTIVATE.PREV',
0x006A: 'UNLOCKED.NEXT',
0x006B: 'UNLOCKED.PREV',
0x006C: 'COPY.PICTURE',
0x006D: 'SELECT',
0x006E: 'DELETE.NAME',
0x006F: 'DELETE.FORMAT',
0x0070: 'VLINE',
0x0071: 'HLINE',
0x0072: 'VPAGE',
0x0073: 'HPAGE',
0x0074: 'VSCROLL',
0x0075: 'HSCROLL',
0x0076: 'ALERT',
0x0077: 'NEW',
0x0078: 'CANCEL.COPY',
0x0079: 'SHOW.CLIPBOARD',
0x007A: 'MESSAGE',
0x007C: 'PASTE.LINK',
0x007D: 'APP.ACTIVATE',
0x007E: 'DELETE.ARROW',
0x007F: 'ROW.HEIGHT',
0x0080: 'FORMAT.MOVE',
0x0081: 'FORMAT.SIZE',
0x0082: 'FORMULA.REPLACE',
0x0083: 'SEND.KEYS',
0x0084: 'SELECT.SPECIAL',
0x0085: 'APPLY.NAMES',
0x0086: 'REPLACE.FONT',
0x0087: 'FREEZE.PANES',
0x0088: 'SHOW.INFO',
0x0089: 'SPLIT',
0x008A: 'ON.WINDOW',
0x008B: 'ON.DATA',
0x008C: 'DISABLE.INPUT',
0x008E: 'OUTLINE',
0x008F: 'LIST.NAMES',
0x0090: 'FILE.CLOSE',
0x0091: 'SAVE.WORKBOOK',
0x0092: 'DATA.FORM',
0x0093: 'COPY.CHART',
0x0094: 'ON.TIME',
0x0095: 'WAIT',
0x0096: 'FORMAT.FONT',
0x0097: 'FILL.UP',
0x0098: 'FILL.LEFT',
0x0099: 'DELETE.OVERLAY',
0x009B: 'SHORT.MENUS',
0x009F: 'SET.UPDATE.STATUS',
0x00A1: 'COLOR.PALETTE',
0x00A2: 'DELETE.STYLE',
0x00A3: 'WINDOW.RESTORE',
0x00A4: 'WINDOW.MAXIMIZE',
0x00A6: 'CHANGE.LINK',
0x00A7: 'CALCULATE.DOCUMENT',
0x00A8: 'ON.KEY',
0x00A9: 'APP.RESTORE',
0x00AA: 'APP.MOVE',
0x00AB: 'APP.SIZE',
0x00AC: 'APP.MINIMIZE',
0x00AD: 'APP.MAXIMIZE',
0x00AE: 'BRING.TO.FRONT',
0x00AF: 'SEND.TO.BACK',
0x00B9: 'MAIN.CHART.TYPE',
0x00BA: 'OVERLAY.CHART.TYPE',
0x00BB: 'SELECT.END',
0x00BC: 'OPEN.MAIL',
0x00BD: 'SEND.MAIL',
0x00BE: 'STANDARD.FONT',
0x00BF: 'CONSOLIDATE',
0x00C0: 'SORT.SPECIAL',
0x00C1: 'GALLERY.3D.AREA',
0x00C2: 'GALLERY.3D.COLUMN',
0x00C3: 'GALLERY.3D.LINE',
0x00C4: 'GALLERY.3D.PIE',
0x00C5: 'VIEW.3D',
0x00C6: 'GOAL.SEEK',
0x00C7: 'WORKGROUP',
0x00C8: 'FILL.GROUP',
0x00C9: 'UPDATE.LINK',
0x00CA: 'PROMOTE',
0x00CB: 'DEMOTE',
0x00CC: 'SHOW.DETAIL',
0x00CE: 'UNGROUP',
0x00CF: 'OBJECT.PROPERTIES',
0x00D0: 'SAVE.NEW.OBJECT',
0x00D1: 'SHARE',
0x00D2: 'SHARE.NAME',
0x00D3: 'DUPLICATE',
0x00D4: 'APPLY.STYLE',
0x00D5: 'ASSIGN.TO.OBJECT',
0x00D6: 'OBJECT.PROTECTION',
0x00D7: 'HIDE.OBJECT',
0x00D8: 'SET.EXTRACT',
0x00D9: 'CREATE.PUBLISHER',
0x00DA: 'SUBSCRIBE.TO',
0x00DB: 'ATTRIBUTES',
0x00DC: 'SHOW.TOOLBAR',
0x00DE: 'PRINT.PREVIEW',
0x00DF: 'EDIT.COLOR',
0x00E0: 'SHOW.LEVELS',
0x00E1: 'FORMAT.MAIN',
0x00E2: 'FORMAT.OVERLAY',
0x00E3: 'ON.RECALC',
0x00E4: 'EDIT.SERIES',
0x00E5: 'DEFINE.STYLE',
0x00F0: 'LINE.PRINT',
0x00F3: 'ENTER.DATA',
0x00F9: 'GALLERY.RADAR',
0x00FA: 'MERGE.STYLES',
0x00FB: 'EDITION.OPTIONS',
0x00FC: 'PASTE.PICTURE',
0x00FD: 'PASTE.PICTURE.LINK',
0x00FE: 'SPELLING',
0x0100: 'ZOOM',
0x0103: 'INSERT.OBJECT',
0x0104: 'WINDOW.MINIMIZE',
0x0109: 'SOUND.NOTE',
0x010A: 'SOUND.PLAY',
0x010B: 'FORMAT.SHAPE',
0x010C: 'EXTEND.POLYGON',
0x010D: 'FORMAT.AUTO',
0x0110: 'GALLERY.3D.BAR',
0x0111: 'GALLERY.3D.SURFACE',
0x0112: 'FILL.AUTO',
0x0114: 'CUSTOMIZE.TOOLBAR',
0x0115: 'ADD.TOOL',
0x0116: 'EDIT.OBJECT',
0x0117: 'ON.DOUBLECLICK',
0x0118: 'ON.ENTRY',
0x0119: 'WORKBOOK.ADD',
0x011A: 'WORKBOOK.MOVE',
0x011B: 'WORKBOOK.COPY',
0x011C: 'WORKBOOK.OPTIONS',
0x011D: 'SAVE.WORKSPACE',
0x0120: 'CHART.WIZARD',
0x0121: 'DELETE.TOOL',
0x0122: 'MOVE.TOOL',
0x0123: 'WORKBOOK.SELECT',
0x0124: 'WORKBOOK.ACTIVATE',
0x0125: 'ASSIGN.TO.TOOL',
0x0127: 'COPY.TOOL',
0x0128: 'RESET.TOOL',
0x0129: 'CONSTRAIN.NUMERIC',
0x012A: 'PASTE.TOOL',
0x012E: 'WORKBOOK.NEW',
0x0131: 'SCENARIO.CELLS',
0x0132: 'SCENARIO.DELETE',
0x0133: 'SCENARIO.ADD',
0x0134: 'SCENARIO.EDIT',
0x0135: 'SCENARIO.SHOW',
0x0136: 'SCENARIO.SHOW.NEXT',
0x0137: 'SCENARIO.SUMMARY',
0x0138: 'PIVOT.TABLE.WIZARD',
0x0139: 'PIVOT.FIELD.PROPERTIES',
0x013A: 'PIVOT.FIELD',
0x013B: 'PIVOT.ITEM',
0x013C: 'PIVOT.ADD.FIELDS',
0x013E: 'OPTIONS.CALCULATION',
0x013F: 'OPTIONS.EDIT',
0x0140: 'OPTIONS.VIEW',
0x0141: 'ADDIN.MANAGER',
0x0142: 'MENU.EDITOR',
0x0143: 'ATTACH.TOOLBARS',
0x0144: 'VBAActivate',
0x0145: 'OPTIONS.CHART',
0x0148: 'VBA.INSERT.FILE',
0x014A: 'VBA.PROCEDURE.DEFINITION',
0x0150: 'ROUTING.SLIP',
0x0152: 'ROUTE.DOCUMENT',
0x0153: 'MAIL.LOGON',
0x0156: 'INSERT.PICTURE',
0x0157: 'EDIT.TOOL',
0x0158: 'GALLERY.DOUGHNUT',
0x015E: 'CHART.TREND',
0x0160: 'PIVOT.ITEM.PROPERTIES',
0x0162: 'WORKBOOK.INSERT',
0x0163: 'OPTIONS.TRANSITION',
0x0164: 'OPTIONS.GENERAL',
0x0172: 'FILTER.ADVANCED',
0x0175: 'MAIL.ADD.MAILER',
0x0176: 'MAIL.DELETE.MAILER',
0x0177: 'MAIL.REPLY',
0x0178: 'MAIL.REPLY.ALL',
0x0179: 'MAIL.FORWARD',
0x017A: 'MAIL.NEXT.LETTER',
0x017B: 'DATA.LABEL',
0x017C: 'INSERT.TITLE',
0x017D: 'FONT.PROPERTIES',
0x017E: 'MACRO.OPTIONS',
0x017F: 'WORKBOOK.HIDE',
0x0180: 'WORKBOOK.UNHIDE',
0x0181: 'WORKBOOK.DELETE',
0x0182: 'WORKBOOK.NAME',
0x0184: 'GALLERY.CUSTOM',
0x0186: 'ADD.CHART.AUTOFORMAT',
0x0187: 'DELETE.CHART.AUTOFORMAT',
0x0188: 'CHART.ADD.DATA',
0x0189: 'AUTO.OUTLINE',
0x018A: 'TAB.ORDER',
0x018B: 'SHOW.DIALOG',
0x018C: 'SELECT.ALL',
0x018D: 'UNGROUP.SHEETS',
0x018E: 'SUBTOTAL.CREATE',
0x018F: 'SUBTOTAL.REMOVE',
0x0190: 'RENAME.OBJECT',
0x019C: 'WORKBOOK.SCROLL',
0x019D: 'WORKBOOK.NEXT',
0x019E: 'WORKBOOK.PREV',
0x019F: 'WORKBOOK.TAB.SPLIT',
0x01A0: 'FULL.SCREEN',
0x01A1: 'WORKBOOK.PROTECT',
0x01A4: 'SCROLLBAR.PROPERTIES',
0x01A5: 'PIVOT.SHOW.PAGES',
0x01A6: 'TEXT.TO.COLUMNS',
0x01A7: 'FORMAT.CHARTTYPE',
0x01A8: 'LINK.FORMAT',
0x01A9: 'TRACER.DISPLAY',
0x01AE: 'TRACER.NAVIGATE',
0x01AF: 'TRACER.CLEAR',
0x01B0: 'TRACER.ERROR',
0x01B1: 'PIVOT.FIELD.GROUP',
0x01B2: 'PIVOT.FIELD.UNGROUP',
0x01B3: 'CHECKBOX.PROPERTIES',
0x01B4: 'LABEL.PROPERTIES',
0x01B5: 'LISTBOX.PROPERTIES',
0x01B6: 'EDITBOX.PROPERTIES',
0x01B7: 'PIVOT.REFRESH',
0x01B8: 'LINK.COMBO',
0x01B9: 'OPEN.TEXT',
0x01BA: 'HIDE.DIALOG',
0x01BB: 'SET.DIALOG.FOCUS',
0x01BC: 'ENABLE.OBJECT',
0x01BD: 'PUSHBUTTON.PROPERTIES',
0x01BE: 'SET.DIALOG.DEFAULT',
0x01BF: 'FILTER',
0x01C0: 'FILTER.SHOW.ALL',
0x01C1: 'CLEAR.OUTLINE',
0x01C2: 'FUNCTION.WIZARD',
0x01C3: 'ADD.LIST.ITEM',
0x01C4: 'SET.LIST.ITEM',
0x01C5: 'REMOVE.LIST.ITEM',
0x01C6: 'SELECT.LIST.ITEM',
0x01C7: 'SET.CONTROL.VALUE',
0x01C8: 'SAVE.COPY.AS',
0x01CA: 'OPTIONS.LISTS.ADD',
0x01CB: 'OPTIONS.LISTS.DELETE',
0x01CC: 'SERIES.AXES',
0x01CD: 'SERIES.X',
0x01CE: 'SERIES.Y',
0x01CF: 'ERRORBAR.X',
0x01D0: 'ERRORBAR.Y',
0x01D1: 'FORMAT.CHART',
0x01D2: 'SERIES.ORDER',
0x01D3: 'MAIL.LOGOFF',
0x01D4: 'CLEAR.ROUTING.SLIP',
0x01D5: 'APP.ACTIVATE.MICROSOFT',
0x01D6: 'MAIL.EDIT.MAILER',
0x01D7: 'ON.SHEET',
0x01D8: 'STANDARD.WIDTH',
0x01D9: 'SCENARIO.MERGE',
0x01DA: 'SUMMARY.INFO',
0x01DB: 'FIND.FILE',
0x01DC: 'ACTIVE.CELL.FONT',
0x01DD: 'ENABLE.TIPWIZARD',
0x01DE: 'VBA.MAKE.ADDIN',
0x01E0: 'INSERTDATATABLE',
0x01E1: 'WORKGROUP.OPTIONS',
0x01E2: 'MAIL.SEND.MAILER',
0x01E5: 'AUTOCORRECT',
0x01E9: 'POST.DOCUMENT',
0x01EB: 'PICKLIST',
0x01ED: 'VIEW.SHOW',
0x01EE: 'VIEW.DEFINE',
0x01EF: 'VIEW.DELETE',
0x01FD: 'SHEET.BACKGROUND',
0x01FE: 'INSERT.MAP.OBJECT',
0x01FF: 'OPTIONS.MENONO',
0x0205: 'MSOCHECKS',
0x0206: 'NORMAL',
0x0207: 'LAYOUT',
0x0208: 'RM.PRINT.AREA',
0x0209: 'CLEAR.PRINT.AREA',
0x020A: 'ADD.PRINT.AREA',
0x020B: 'MOVE.BRK',
0x0221: 'HIDECURR.NOTE',
0x0222: 'HIDEALL.NOTES',
0x0223: 'DELETE.NOTE',
0x0224: 'TRAVERSE.NOTES',
0x0225: 'ACTIVATE.NOTES',
0x026C: 'PROTECT.REVISIONS',
0x026D: 'UNPROTECT.REVISIONS',
0x0287: 'OPTIONS.ME',
0x028D: 'WEB.PUBLISH',
0x029B: 'NEWWEBQUERY',
0x02A1: 'PIVOT.TABLE.CHART',
0x02F1: 'OPTIONS.SAVE',
0x02F3: 'OPTIONS.SPELL',
0x0328: 'HIDEALL.INKANNOTS'
};

/* [MS-XLS] 2.5.198.17 */
/* [MS-XLSB] 2.5.97.10 */
var Ftab = {
0x0000: 'COUNT',
0x0001: 'IF',
0x0002: 'ISNA',
0x0003: 'ISERROR',
0x0004: 'SUM',
0x0005: 'AVERAGE',
0x0006: 'MIN',
0x0007: 'MAX',
0x0008: 'ROW',
0x0009: 'COLUMN',
0x000A: 'NA',
0x000B: 'NPV',
0x000C: 'STDEV',
0x000D: 'DOLLAR',
0x000E: 'FIXED',
0x000F: 'SIN',
0x0010: 'COS',
0x0011: 'TAN',
0x0012: 'ATAN',
0x0013: 'PI',
0x0014: 'SQRT',
0x0015: 'EXP',
0x0016: 'LN',
0x0017: 'LOG10',
0x0018: 'ABS',
0x0019: 'INT',
0x001A: 'SIGN',
0x001B: 'ROUND',
0x001C: 'LOOKUP',
0x001D: 'INDEX',
0x001E: 'REPT',
0x001F: 'MID',
0x0020: 'LEN',
0x0021: 'VALUE',
0x0022: 'TRUE',
0x0023: 'FALSE',
0x0024: 'AND',
0x0025: 'OR',
0x0026: 'NOT',
0x0027: 'MOD',
0x0028: 'DCOUNT',
0x0029: 'DSUM',
0x002A: 'DAVERAGE',
0x002B: 'DMIN',
0x002C: 'DMAX',
0x002D: 'DSTDEV',
0x002E: 'VAR',
0x002F: 'DVAR',
0x0030: 'TEXT',
0x0031: 'LINEST',
0x0032: 'TREND',
0x0033: 'LOGEST',
0x0034: 'GROWTH',
0x0035: 'GOTO',
0x0036: 'HALT',
0x0037: 'RETURN',
0x0038: 'PV',
0x0039: 'FV',
0x003A: 'NPER',
0x003B: 'PMT',
0x003C: 'RATE',
0x003D: 'MIRR',
0x003E: 'IRR',
0x003F: 'RAND',
0x0040: 'MATCH',
0x0041: 'DATE',
0x0042: 'TIME',
0x0043: 'DAY',
0x0044: 'MONTH',
0x0045: 'YEAR',
0x0046: 'WEEKDAY',
0x0047: 'HOUR',
0x0048: 'MINUTE',
0x0049: 'SECOND',
0x004A: 'NOW',
0x004B: 'AREAS',
0x004C: 'ROWS',
0x004D: 'COLUMNS',
0x004E: 'OFFSET',
0x004F: 'ABSREF',
0x0050: 'RELREF',
0x0051: 'ARGUMENT',
0x0052: 'SEARCH',
0x0053: 'TRANSPOSE',
0x0054: 'ERROR',
0x0055: 'STEP',
0x0056: 'TYPE',
0x0057: 'ECHO',
0x0058: 'SET.NAME',
0x0059: 'CALLER',
0x005A: 'DEREF',
0x005B: 'WINDOWS',
0x005C: 'SERIES',
0x005D: 'DOCUMENTS',
0x005E: 'ACTIVE.CELL',
0x005F: 'SELECTION',
0x0060: 'RESULT',
0x0061: 'ATAN2',
0x0062: 'ASIN',
0x0063: 'ACOS',
0x0064: 'CHOOSE',
0x0065: 'HLOOKUP',
0x0066: 'VLOOKUP',
0x0067: 'LINKS',
0x0068: 'INPUT',
0x0069: 'ISREF',
0x006A: 'GET.FORMULA',
0x006B: 'GET.NAME',
0x006C: 'SET.VALUE',
0x006D: 'LOG',
0x006E: 'EXEC',
0x006F: 'CHAR',
0x0070: 'LOWER',
0x0071: 'UPPER',
0x0072: 'PROPER',
0x0073: 'LEFT',
0x0074: 'RIGHT',
0x0075: 'EXACT',
0x0076: 'TRIM',
0x0077: 'REPLACE',
0x0078: 'SUBSTITUTE',
0x0079: 'CODE',
0x007A: 'NAMES',
0x007B: 'DIRECTORY',
0x007C: 'FIND',
0x007D: 'CELL',
0x007E: 'ISERR',
0x007F: 'ISTEXT',
0x0080: 'ISNUMBER',
0x0081: 'ISBLANK',
0x0082: 'T',
0x0083: 'N',
0x0084: 'FOPEN',
0x0085: 'FCLOSE',
0x0086: 'FSIZE',
0x0087: 'FREADLN',
0x0088: 'FREAD',
0x0089: 'FWRITELN',
0x008A: 'FWRITE',
0x008B: 'FPOS',
0x008C: 'DATEVALUE',
0x008D: 'TIMEVALUE',
0x008E: 'SLN',
0x008F: 'SYD',
0x0090: 'DDB',
0x0091: 'GET.DEF',
0x0092: 'REFTEXT',
0x0093: 'TEXTREF',
0x0094: 'INDIRECT',
0x0095: 'REGISTER',
0x0096: 'CALL',
0x0097: 'ADD.BAR',
0x0098: 'ADD.MENU',
0x0099: 'ADD.COMMAND',
0x009A: 'ENABLE.COMMAND',
0x009B: 'CHECK.COMMAND',
0x009C: 'RENAME.COMMAND',
0x009D: 'SHOW.BAR',
0x009E: 'DELETE.MENU',
0x009F: 'DELETE.COMMAND',
0x00A0: 'GET.CHART.ITEM',
0x00A1: 'DIALOG.BOX',
0x00A2: 'CLEAN',
0x00A3: 'MDETERM',
0x00A4: 'MINVERSE',
0x00A5: 'MMULT',
0x00A6: 'FILES',
0x00A7: 'IPMT',
0x00A8: 'PPMT',
0x00A9: 'COUNTA',
0x00AA: 'CANCEL.KEY',
0x00AB: 'FOR',
0x00AC: 'WHILE',
0x00AD: 'BREAK',
0x00AE: 'NEXT',
0x00AF: 'INITIATE',
0x00B0: 'REQUEST',
0x00B1: 'POKE',
0x00B2: 'EXECUTE',
0x00B3: 'TERMINATE',
0x00B4: 'RESTART',
0x00B5: 'HELP',
0x00B6: 'GET.BAR',
0x00B7: 'PRODUCT',
0x00B8: 'FACT',
0x00B9: 'GET.CELL',
0x00BA: 'GET.WORKSPACE',
0x00BB: 'GET.WINDOW',
0x00BC: 'GET.DOCUMENT',
0x00BD: 'DPRODUCT',
0x00BE: 'ISNONTEXT',
0x00BF: 'GET.NOTE',
0x00C0: 'NOTE',
0x00C1: 'STDEVP',
0x00C2: 'VARP',
0x00C3: 'DSTDEVP',
0x00C4: 'DVARP',
0x00C5: 'TRUNC',
0x00C6: 'ISLOGICAL',
0x00C7: 'DCOUNTA',
0x00C8: 'DELETE.BAR',
0x00C9: 'UNREGISTER',
0x00CC: 'USDOLLAR',
0x00CD: 'FINDB',
0x00CE: 'SEARCHB',
0x00CF: 'REPLACEB',
0x00D0: 'LEFTB',
0x00D1: 'RIGHTB',
0x00D2: 'MIDB',
0x00D3: 'LENB',
0x00D4: 'ROUNDUP',
0x00D5: 'ROUNDDOWN',
0x00D6: 'ASC',
0x00D7: 'DBCS',
0x00D8: 'RANK',
0x00DB: 'ADDRESS',
0x00DC: 'DAYS360',
0x00DD: 'TODAY',
0x00DE: 'VDB',
0x00DF: 'ELSE',
0x00E0: 'ELSE.IF',
0x00E1: 'END.IF',
0x00E2: 'FOR.CELL',
0x00E3: 'MEDIAN',
0x00E4: 'SUMPRODUCT',
0x00E5: 'SINH',
0x00E6: 'COSH',
0x00E7: 'TANH',
0x00E8: 'ASINH',
0x00E9: 'ACOSH',
0x00EA: 'ATANH',
0x00EB: 'DGET',
0x00EC: 'CREATE.OBJECT',
0x00ED: 'VOLATILE',
0x00EE: 'LAST.ERROR',
0x00EF: 'CUSTOM.UNDO',
0x00F0: 'CUSTOM.REPEAT',
0x00F1: 'FORMULA.CONVERT',
0x00F2: 'GET.LINK.INFO',
0x00F3: 'TEXT.BOX',
0x00F4: 'INFO',
0x00F5: 'GROUP',
0x00F6: 'GET.OBJECT',
0x00F7: 'DB',
0x00F8: 'PAUSE',
0x00FB: 'RESUME',
0x00FC: 'FREQUENCY',
0x00FD: 'ADD.TOOLBAR',
0x00FE: 'DELETE.TOOLBAR',
0x00FF: 'User',
0x0100: 'RESET.TOOLBAR',
0x0101: 'EVALUATE',
0x0102: 'GET.TOOLBAR',
0x0103: 'GET.TOOL',
0x0104: 'SPELLING.CHECK',
0x0105: 'ERROR.TYPE',
0x0106: 'APP.TITLE',
0x0107: 'WINDOW.TITLE',
0x0108: 'SAVE.TOOLBAR',
0x0109: 'ENABLE.TOOL',
0x010A: 'PRESS.TOOL',
0x010B: 'REGISTER.ID',
0x010C: 'GET.WORKBOOK',
0x010D: 'AVEDEV',
0x010E: 'BETADIST',
0x010F: 'GAMMALN',
0x0110: 'BETAINV',
0x0111: 'BINOMDIST',
0x0112: 'CHIDIST',
0x0113: 'CHIINV',
0x0114: 'COMBIN',
0x0115: 'CONFIDENCE',
0x0116: 'CRITBINOM',
0x0117: 'EVEN',
0x0118: 'EXPONDIST',
0x0119: 'FDIST',
0x011A: 'FINV',
0x011B: 'FISHER',
0x011C: 'FISHERINV',
0x011D: 'FLOOR',
0x011E: 'GAMMADIST',
0x011F: 'GAMMAINV',
0x0120: 'CEILING',
0x0121: 'HYPGEOMDIST',
0x0122: 'LOGNORMDIST',
0x0123: 'LOGINV',
0x0124: 'NEGBINOMDIST',
0x0125: 'NORMDIST',
0x0126: 'NORMSDIST',
0x0127: 'NORMINV',
0x0128: 'NORMSINV',
0x0129: 'STANDARDIZE',
0x012A: 'ODD',
0x012B: 'PERMUT',
0x012C: 'POISSON',
0x012D: 'TDIST',
0x012E: 'WEIBULL',
0x012F: 'SUMXMY2',
0x0130: 'SUMX2MY2',
0x0131: 'SUMX2PY2',
0x0132: 'CHITEST',
0x0133: 'CORREL',
0x0134: 'COVAR',
0x0135: 'FORECAST',
0x0136: 'FTEST',
0x0137: 'INTERCEPT',
0x0138: 'PEARSON',
0x0139: 'RSQ',
0x013A: 'STEYX',
0x013B: 'SLOPE',
0x013C: 'TTEST',
0x013D: 'PROB',
0x013E: 'DEVSQ',
0x013F: 'GEOMEAN',
0x0140: 'HARMEAN',
0x0141: 'SUMSQ',
0x0142: 'KURT',
0x0143: 'SKEW',
0x0144: 'ZTEST',
0x0145: 'LARGE',
0x0146: 'SMALL',
0x0147: 'QUARTILE',
0x0148: 'PERCENTILE',
0x0149: 'PERCENTRANK',
0x014A: 'MODE',
0x014B: 'TRIMMEAN',
0x014C: 'TINV',
0x014E: 'MOVIE.COMMAND',
0x014F: 'GET.MOVIE',
0x0150: 'CONCATENATE',
0x0151: 'POWER',
0x0152: 'PIVOT.ADD.DATA',
0x0153: 'GET.PIVOT.TABLE',
0x0154: 'GET.PIVOT.FIELD',
0x0155: 'GET.PIVOT.ITEM',
0x0156: 'RADIANS',
0x0157: 'DEGREES',
0x0158: 'SUBTOTAL',
0x0159: 'SUMIF',
0x015A: 'COUNTIF',
0x015B: 'COUNTBLANK',
0x015C: 'SCENARIO.GET',
0x015D: 'OPTIONS.LISTS.GET',
0x015E: 'ISPMT',
0x015F: 'DATEDIF',
0x0160: 'DATESTRING',
0x0161: 'NUMBERSTRING',
0x0162: 'ROMAN',
0x0163: 'OPEN.DIALOG',
0x0164: 'SAVE.DIALOG',
0x0165: 'VIEW.GET',
0x0166: 'GETPIVOTDATA',
0x0167: 'HYPERLINK',
0x0168: 'PHONETIC',
0x0169: 'AVERAGEA',
0x016A: 'MAXA',
0x016B: 'MINA',
0x016C: 'STDEVPA',
0x016D: 'VARPA',
0x016E: 'STDEVA',
0x016F: 'VARA',
0x0170: 'BAHTTEXT',
0x0171: 'THAIDAYOFWEEK',
0x0172: 'THAIDIGIT',
0x0173: 'THAIMONTHOFYEAR',
0x0174: 'THAINUMSOUND',
0x0175: 'THAINUMSTRING',
0x0176: 'THAISTRINGLENGTH',
0x0177: 'ISTHAIDIGIT',
0x0178: 'ROUNDBAHTDOWN',
0x0179: 'ROUNDBAHTUP',
0x017A: 'THAIYEAR',
0x017B: 'RTD',

0x017C: 'CUBEVALUE',
0x017D: 'CUBEMEMBER',
0x017E: 'CUBEMEMBERPROPERTY',
0x017F: 'CUBERANKEDMEMBER',
0x0180: 'HEX2BIN',
0x0181: 'HEX2DEC',
0x0182: 'HEX2OCT',
0x0183: 'DEC2BIN',
0x0184: 'DEC2HEX',
0x0185: 'DEC2OCT',
0x0186: 'OCT2BIN',
0x0187: 'OCT2HEX',
0x0188: 'OCT2DEC',
0x0189: 'BIN2DEC',
0x018A: 'BIN2OCT',
0x018B: 'BIN2HEX',
0x018C: 'IMSUB',
0x018D: 'IMDIV',
0x018E: 'IMPOWER',
0x018F: 'IMABS',
0x0190: 'IMSQRT',
0x0191: 'IMLN',
0x0192: 'IMLOG2',
0x0193: 'IMLOG10',
0x0194: 'IMSIN',
0x0195: 'IMCOS',
0x0196: 'IMEXP',
0x0197: 'IMARGUMENT',
0x0198: 'IMCONJUGATE',
0x0199: 'IMAGINARY',
0x019A: 'IMREAL',
0x019B: 'COMPLEX',
0x019C: 'IMSUM',
0x019D: 'IMPRODUCT',
0x019E: 'SERIESSUM',
0x019F: 'FACTDOUBLE',
0x01A0: 'SQRTPI',
0x01A1: 'QUOTIENT',
0x01A2: 'DELTA',
0x01A3: 'GESTEP',
0x01A4: 'ISEVEN',
0x01A5: 'ISODD',
0x01A6: 'MROUND',
0x01A7: 'ERF',
0x01A8: 'ERFC',
0x01A9: 'BESSELJ',
0x01AA: 'BESSELK',
0x01AB: 'BESSELY',
0x01AC: 'BESSELI',
0x01AD: 'XIRR',
0x01AE: 'XNPV',
0x01AF: 'PRICEMAT',
0x01B0: 'YIELDMAT',
0x01B1: 'INTRATE',
0x01B2: 'RECEIVED',
0x01B3: 'DISC',
0x01B4: 'PRICEDISC',
0x01B5: 'YIELDDISC',
0x01B6: 'TBILLEQ',
0x01B7: 'TBILLPRICE',
0x01B8: 'TBILLYIELD',
0x01B9: 'PRICE',
0x01BA: 'YIELD',
0x01BB: 'DOLLARDE',
0x01BC: 'DOLLARFR',
0x01BD: 'NOMINAL',
0x01BE: 'EFFECT',
0x01BF: 'CUMPRINC',
0x01C0: 'CUMIPMT',
0x01C1: 'EDATE',
0x01C2: 'EOMONTH',
0x01C3: 'YEARFRAC',
0x01C4: 'COUPDAYBS',
0x01C5: 'COUPDAYS',
0x01C6: 'COUPDAYSNC',
0x01C7: 'COUPNCD',
0x01C8: 'COUPNUM',
0x01C9: 'COUPPCD',
0x01CA: 'DURATION',
0x01CB: 'MDURATION',
0x01CC: 'ODDLPRICE',
0x01CD: 'ODDLYIELD',
0x01CE: 'ODDFPRICE',
0x01CF: 'ODDFYIELD',
0x01D0: 'RANDBETWEEN',
0x01D1: 'WEEKNUM',
0x01D2: 'AMORDEGRC',
0x01D3: 'AMORLINC',
0x01D4: 'CONVERT',
0x02D4: 'SHEETJS',
0x01D5: 'ACCRINT',
0x01D6: 'ACCRINTM',
0x01D7: 'WORKDAY',
0x01D8: 'NETWORKDAYS',
0x01D9: 'GCD',
0x01DA: 'MULTINOMIAL',
0x01DB: 'LCM',
0x01DC: 'FVSCHEDULE',
0x01DD: 'CUBEKPIMEMBER',
0x01DE: 'CUBESET',
0x01DF: 'CUBESETCOUNT',
0x01E0: 'IFERROR',
0x01E1: 'COUNTIFS',
0x01E2: 'SUMIFS',
0x01E3: 'AVERAGEIF',
0x01E4: 'AVERAGEIFS'
};
var FtabArgc = {
0x0002: 1, /* ISNA */
0x0003: 1, /* ISERROR */
0x000A: 0, /* NA */
0x000F: 1, /* SIN */
0x0010: 1, /* COS */
0x0011: 1, /* TAN */
0x0012: 1, /* ATAN */
0x0013: 0, /* PI */
0x0014: 1, /* SQRT */
0x0015: 1, /* EXP */
0x0016: 1, /* LN */
0x0017: 1, /* LOG10 */
0x0018: 1, /* ABS */
0x0019: 1, /* INT */
0x001A: 1, /* SIGN */
0x001B: 2, /* ROUND */
0x001E: 2, /* REPT */
0x001F: 3, /* MID */
0x0020: 1, /* LEN */
0x0021: 1, /* VALUE */
0x0022: 0, /* TRUE */
0x0023: 0, /* FALSE */
0x0026: 1, /* NOT */
0x0027: 2, /* MOD */
0x0028: 3, /* DCOUNT */
0x0029: 3, /* DSUM */
0x002A: 3, /* DAVERAGE */
0x002B: 3, /* DMIN */
0x002C: 3, /* DMAX */
0x002D: 3, /* DSTDEV */
0x002F: 3, /* DVAR */
0x0030: 2, /* TEXT */
0x0035: 1, /* GOTO */
0x003D: 3, /* MIRR */
0x003F: 0, /* RAND */
0x0041: 3, /* DATE */
0x0042: 3, /* TIME */
0x0043: 1, /* DAY */
0x0044: 1, /* MONTH */
0x0045: 1, /* YEAR */
0x0046: 1, /* WEEKDAY */
0x0047: 1, /* HOUR */
0x0048: 1, /* MINUTE */
0x0049: 1, /* SECOND */
0x004A: 0, /* NOW */
0x004B: 1, /* AREAS */
0x004C: 1, /* ROWS */
0x004D: 1, /* COLUMNS */
0x004F: 2, /* ABSREF */
0x0050: 2, /* RELREF */
0x0053: 1, /* TRANSPOSE */
0x0055: 0, /* STEP */
0x0056: 1, /* TYPE */
0x0059: 0, /* CALLER */
0x005A: 1, /* DEREF */
0x005E: 0, /* ACTIVE.CELL */
0x005F: 0, /* SELECTION */
0x0061: 2, /* ATAN2 */
0x0062: 1, /* ASIN */
0x0063: 1, /* ACOS */
0x0065: 3, /* HLOOKUP */
0x0066: 3, /* VLOOKUP */
0x0069: 1, /* ISREF */
0x006A: 1, /* GET.FORMULA */
0x006C: 2, /* SET.VALUE */
0x006F: 1, /* CHAR */
0x0070: 1, /* LOWER */
0x0071: 1, /* UPPER */
0x0072: 1, /* PROPER */
0x0075: 2, /* EXACT */
0x0076: 1, /* TRIM */
0x0077: 4, /* REPLACE */
0x0079: 1, /* CODE */
0x007E: 1, /* ISERR */
0x007F: 1, /* ISTEXT */
0x0080: 1, /* ISNUMBER */
0x0081: 1, /* ISBLANK */
0x0082: 1, /* T */
0x0083: 1, /* N */
0x0085: 1, /* FCLOSE */
0x0086: 1, /* FSIZE */
0x0087: 1, /* FREADLN */
0x0088: 2, /* FREAD */
0x0089: 2, /* FWRITELN */
0x008A: 2, /* FWRITE */
0x008C: 1, /* DATEVALUE */
0x008D: 1, /* TIMEVALUE */
0x008E: 3, /* SLN */
0x008F: 4, /* SYD */
0x0090: 4, /* DDB */
0x00A1: 1, /* DIALOG.BOX */
0x00A2: 1, /* CLEAN */
0x00A3: 1, /* MDETERM */
0x00A4: 1, /* MINVERSE */
0x00A5: 2, /* MMULT */
0x00AC: 1, /* WHILE */
0x00AF: 2, /* INITIATE */
0x00B0: 2, /* REQUEST */
0x00B1: 3, /* POKE */
0x00B2: 2, /* EXECUTE */
0x00B3: 1, /* TERMINATE */
0x00B8: 1, /* FACT */
0x00BA: 1, /* GET.WORKSPACE */
0x00BD: 3, /* DPRODUCT */
0x00BE: 1, /* ISNONTEXT */
0x00C3: 3, /* DSTDEVP */
0x00C4: 3, /* DVARP */
0x00C5: 1, /* TRUNC */
0x00C6: 1, /* ISLOGICAL */
0x00C7: 3, /* DCOUNTA */
0x00C9: 1, /* UNREGISTER */
0x00CF: 4, /* REPLACEB */
0x00D2: 3, /* MIDB */
0x00D3: 1, /* LENB */
0x00D4: 2, /* ROUNDUP */
0x00D5: 2, /* ROUNDDOWN */
0x00D6: 1, /* ASC */
0x00D7: 1, /* DBCS */
0x00E1: 0, /* END.IF */
0x00E5: 1, /* SINH */
0x00E6: 1, /* COSH */
0x00E7: 1, /* TANH */
0x00E8: 1, /* ASINH */
0x00E9: 1, /* ACOSH */
0x00EA: 1, /* ATANH */
0x00EB: 3, /* DGET */
0x00F4: 1, /* INFO */
0x00F7: 4, /* DB */
0x00FC: 2, /* FREQUENCY */
0x0101: 1, /* EVALUATE */
0x0105: 1, /* ERROR.TYPE */
0x010F: 1, /* GAMMALN */
0x0111: 4, /* BINOMDIST */
0x0112: 2, /* CHIDIST */
0x0113: 2, /* CHIINV */
0x0114: 2, /* COMBIN */
0x0115: 3, /* CONFIDENCE */
0x0116: 3, /* CRITBINOM */
0x0117: 1, /* EVEN */
0x0118: 3, /* EXPONDIST */
0x0119: 3, /* FDIST */
0x011A: 3, /* FINV */
0x011B: 1, /* FISHER */
0x011C: 1, /* FISHERINV */
0x011D: 2, /* FLOOR */
0x011E: 4, /* GAMMADIST */
0x011F: 3, /* GAMMAINV */
0x0120: 2, /* CEILING */
0x0121: 4, /* HYPGEOMDIST */
0x0122: 3, /* LOGNORMDIST */
0x0123: 3, /* LOGINV */
0x0124: 3, /* NEGBINOMDIST */
0x0125: 4, /* NORMDIST */
0x0126: 1, /* NORMSDIST */
0x0127: 3, /* NORMINV */
0x0128: 1, /* NORMSINV */
0x0129: 3, /* STANDARDIZE */
0x012A: 1, /* ODD */
0x012B: 2, /* PERMUT */
0x012C: 3, /* POISSON */
0x012D: 3, /* TDIST */
0x012E: 4, /* WEIBULL */
0x012F: 2, /* SUMXMY2 */
0x0130: 2, /* SUMX2MY2 */
0x0131: 2, /* SUMX2PY2 */
0x0132: 2, /* CHITEST */
0x0133: 2, /* CORREL */
0x0134: 2, /* COVAR */
0x0135: 3, /* FORECAST */
0x0136: 2, /* FTEST */
0x0137: 2, /* INTERCEPT */
0x0138: 2, /* PEARSON */
0x0139: 2, /* RSQ */
0x013A: 2, /* STEYX */
0x013B: 2, /* SLOPE */
0x013C: 4, /* TTEST */
0x0145: 2, /* LARGE */
0x0146: 2, /* SMALL */
0x0147: 2, /* QUARTILE */
0x0148: 2, /* PERCENTILE */
0x014B: 2, /* TRIMMEAN */
0x014C: 2, /* TINV */
0x0151: 2, /* POWER */
0x0156: 1, /* RADIANS */
0x0157: 1, /* DEGREES */
0x015A: 2, /* COUNTIF */
0x015B: 1, /* COUNTBLANK */
0x015E: 4, /* ISPMT */
0x015F: 3, /* DATEDIF */
0x0160: 1, /* DATESTRING */
0x0161: 2, /* NUMBERSTRING */
0x0168: 1, /* PHONETIC */
0x0170: 1, /* BAHTTEXT */
0x0171: 1, /* THAIDAYOFWEEK */
0x0172: 1, /* THAIDIGIT */
0x0173: 1, /* THAIMONTHOFYEAR */
0x0174: 1, /* THAINUMSOUND */
0x0175: 1, /* THAINUMSTRING */
0x0176: 1, /* THAISTRINGLENGTH */
0x0177: 1, /* ISTHAIDIGIT */
0x0178: 1, /* ROUNDBAHTDOWN */
0x0179: 1, /* ROUNDBAHTUP */
0x017A: 1, /* THAIYEAR */
0x017E: 3, /* CUBEMEMBERPROPERTY */
0x0181: 1, /* HEX2DEC */
0x0188: 1, /* OCT2DEC */
0x0189: 1, /* BIN2DEC */
0x018C: 2, /* IMSUB */
0x018D: 2, /* IMDIV */
0x018E: 2, /* IMPOWER */
0x018F: 1, /* IMABS */
0x0190: 1, /* IMSQRT */
0x0191: 1, /* IMLN */
0x0192: 1, /* IMLOG2 */
0x0193: 1, /* IMLOG10 */
0x0194: 1, /* IMSIN */
0x0195: 1, /* IMCOS */
0x0196: 1, /* IMEXP */
0x0197: 1, /* IMARGUMENT */
0x0198: 1, /* IMCONJUGATE */
0x0199: 1, /* IMAGINARY */
0x019A: 1, /* IMREAL */
0x019E: 4, /* SERIESSUM */
0x019F: 1, /* FACTDOUBLE */
0x01A0: 1, /* SQRTPI */
0x01A1: 2, /* QUOTIENT */
0x01A4: 1, /* ISEVEN */
0x01A5: 1, /* ISODD */
0x01A6: 2, /* MROUND */
0x01A8: 1, /* ERFC */
0x01A9: 2, /* BESSELJ */
0x01AA: 2, /* BESSELK */
0x01AB: 2, /* BESSELY */
0x01AC: 2, /* BESSELI */
0x01AE: 3, /* XNPV */
0x01B6: 3, /* TBILLEQ */
0x01B7: 3, /* TBILLPRICE */
0x01B8: 3, /* TBILLYIELD */
0x01BB: 2, /* DOLLARDE */
0x01BC: 2, /* DOLLARFR */
0x01BD: 2, /* NOMINAL */
0x01BE: 2, /* EFFECT */
0x01BF: 6, /* CUMPRINC */
0x01C0: 6, /* CUMIPMT */
0x01C1: 2, /* EDATE */
0x01C2: 2, /* EOMONTH */
0x01D0: 2, /* RANDBETWEEN */
0x01D4: 3, /* CONVERT */
0x01DC: 2, /* FVSCHEDULE */
0x01DF: 1, /* CUBESETCOUNT */
0x01E0: 2, /* IFERROR */
0xFFFF: 0
};
/* [MS-XLSX] 2.2.3 Functions */
/* [MS-XLSB] 2.5.97.10 Ftab */
var XLSXFutureFunctions = {
	"_xlfn.ACOT": "ACOT",
	"_xlfn.ACOTH": "ACOTH",
	"_xlfn.AGGREGATE": "AGGREGATE",
	"_xlfn.ARABIC": "ARABIC",
	"_xlfn.AVERAGEIF": "AVERAGEIF",
	"_xlfn.AVERAGEIFS": "AVERAGEIFS",
	"_xlfn.BASE": "BASE",
	"_xlfn.BETA.DIST": "BETA.DIST",
	"_xlfn.BETA.INV": "BETA.INV",
	"_xlfn.BINOM.DIST": "BINOM.DIST",
	"_xlfn.BINOM.DIST.RANGE": "BINOM.DIST.RANGE",
	"_xlfn.BINOM.INV": "BINOM.INV",
	"_xlfn.BITAND": "BITAND",
	"_xlfn.BITLSHIFT": "BITLSHIFT",
	"_xlfn.BITOR": "BITOR",
	"_xlfn.BITRSHIFT": "BITRSHIFT",
	"_xlfn.BITXOR": "BITXOR",
	"_xlfn.CEILING.MATH": "CEILING.MATH",
	"_xlfn.CEILING.PRECISE": "CEILING.PRECISE",
	"_xlfn.CHISQ.DIST": "CHISQ.DIST",
	"_xlfn.CHISQ.DIST.RT": "CHISQ.DIST.RT",
	"_xlfn.CHISQ.INV": "CHISQ.INV",
	"_xlfn.CHISQ.INV.RT": "CHISQ.INV.RT",
	"_xlfn.CHISQ.TEST": "CHISQ.TEST",
	"_xlfn.COMBINA": "COMBINA",
	"_xlfn.CONCAT": "CONCAT",
	"_xlfn.CONFIDENCE.NORM": "CONFIDENCE.NORM",
	"_xlfn.CONFIDENCE.T": "CONFIDENCE.T",
	"_xlfn.COT": "COT",
	"_xlfn.COTH": "COTH",
	"_xlfn.COUNTIFS": "COUNTIFS",
	"_xlfn.COVARIANCE.P": "COVARIANCE.P",
	"_xlfn.COVARIANCE.S": "COVARIANCE.S",
	"_xlfn.CSC": "CSC",
	"_xlfn.CSCH": "CSCH",
	"_xlfn.DAYS": "DAYS",
	"_xlfn.DECIMAL": "DECIMAL",
	"_xlfn.ECMA.CEILING": "ECMA.CEILING",
	"_xlfn.ERF.PRECISE": "ERF.PRECISE",
	"_xlfn.ERFC.PRECISE": "ERFC.PRECISE",
	"_xlfn.EXPON.DIST": "EXPON.DIST",
	"_xlfn.F.DIST": "F.DIST",
	"_xlfn.F.DIST.RT": "F.DIST.RT",
	"_xlfn.F.INV": "F.INV",
	"_xlfn.F.INV.RT": "F.INV.RT",
	"_xlfn.F.TEST": "F.TEST",
	"_xlfn.FILTERXML": "FILTERXML",
	"_xlfn.FLOOR.MATH": "FLOOR.MATH",
	"_xlfn.FLOOR.PRECISE": "FLOOR.PRECISE",
	"_xlfn.FORECAST.ETS": "FORECAST.ETS",
	"_xlfn.FORECAST.ETS.CONFINT": "FORECAST.ETS.CONFINT",
	"_xlfn.FORECAST.ETS.SEASONALITY": "FORECAST.ETS.SEASONALITY",
	"_xlfn.FORECAST.ETS.STAT": "FORECAST.ETS.STAT",
	"_xlfn.FORECAST.LINEAR": "FORECAST.LINEAR",
	"_xlfn.FORMULATEXT": "FORMULATEXT",
	"_xlfn.GAMMA": "GAMMA",
	"_xlfn.GAMMA.DIST": "GAMMA.DIST",
	"_xlfn.GAMMA.INV": "GAMMA.INV",
	"_xlfn.GAMMALN.PRECISE": "GAMMALN.PRECISE",
	"_xlfn.GAUSS": "GAUSS",
	"_xlfn.HYPGEOM.DIST": "HYPGEOM.DIST",
	"_xlfn.IFERROR": "IFERROR",
	"_xlfn.IFNA": "IFNA",
	"_xlfn.IFS": "IFS",
	"_xlfn.IMCOSH": "IMCOSH",
	"_xlfn.IMCOT": "IMCOT",
	"_xlfn.IMCSC": "IMCSC",
	"_xlfn.IMCSCH": "IMCSCH",
	"_xlfn.IMSEC": "IMSEC",
	"_xlfn.IMSECH": "IMSECH",
	"_xlfn.IMSINH": "IMSINH",
	"_xlfn.IMTAN": "IMTAN",
	"_xlfn.ISFORMULA": "ISFORMULA",
	"_xlfn.ISO.CEILING": "ISO.CEILING",
	"_xlfn.ISOWEEKNUM": "ISOWEEKNUM",
	"_xlfn.LOGNORM.DIST": "LOGNORM.DIST",
	"_xlfn.LOGNORM.INV": "LOGNORM.INV",
	"_xlfn.MAXIFS": "MAXIFS",
	"_xlfn.MINIFS": "MINIFS",
	"_xlfn.MODE.MULT": "MODE.MULT",
	"_xlfn.MODE.SNGL": "MODE.SNGL",
	"_xlfn.MUNIT": "MUNIT",
	"_xlfn.NEGBINOM.DIST": "NEGBINOM.DIST",
	"_xlfn.NETWORKDAYS.INTL": "NETWORKDAYS.INTL",
	"_xlfn.NIGBINOM": "NIGBINOM",
	"_xlfn.NORM.DIST": "NORM.DIST",
	"_xlfn.NORM.INV": "NORM.INV",
	"_xlfn.NORM.S.DIST": "NORM.S.DIST",
	"_xlfn.NORM.S.INV": "NORM.S.INV",
	"_xlfn.NUMBERVALUE": "NUMBERVALUE",
	"_xlfn.PDURATION": "PDURATION",
	"_xlfn.PERCENTILE.EXC": "PERCENTILE.EXC",
	"_xlfn.PERCENTILE.INC": "PERCENTILE.INC",
	"_xlfn.PERCENTRANK.EXC": "PERCENTRANK.EXC",
	"_xlfn.PERCENTRANK.INC": "PERCENTRANK.INC",
	"_xlfn.PERMUTATIONA": "PERMUTATIONA",
	"_xlfn.PHI": "PHI",
	"_xlfn.POISSON.DIST": "POISSON.DIST",
	"_xlfn.QUARTILE.EXC": "QUARTILE.EXC",
	"_xlfn.QUARTILE.INC": "QUARTILE.INC",
	"_xlfn.QUERYSTRING": "QUERYSTRING",
	"_xlfn.RANK.AVG": "RANK.AVG",
	"_xlfn.RANK.EQ": "RANK.EQ",
	"_xlfn.RRI": "RRI",
	"_xlfn.SEC": "SEC",
	"_xlfn.SECH": "SECH",
	"_xlfn.SHEET": "SHEET",
	"_xlfn.SHEETS": "SHEETS",
	"_xlfn.SKEW.P": "SKEW.P",
	"_xlfn.STDEV.P": "STDEV.P",
	"_xlfn.STDEV.S": "STDEV.S",
	"_xlfn.SUMIFS": "SUMIFS",
	"_xlfn.SWITCH": "SWITCH",
	"_xlfn.T.DIST": "T.DIST",
	"_xlfn.T.DIST.2T": "T.DIST.2T",
	"_xlfn.T.DIST.RT": "T.DIST.RT",
	"_xlfn.T.INV": "T.INV",
	"_xlfn.T.INV.2T": "T.INV.2T",
	"_xlfn.T.TEST": "T.TEST",
	"_xlfn.TEXTJOIN": "TEXTJOIN",
	"_xlfn.UNICHAR": "UNICHAR",
	"_xlfn.UNICODE": "UNICODE",
	"_xlfn.VAR.P": "VAR.P",
	"_xlfn.VAR.S": "VAR.S",
	"_xlfn.WEBSERVICE": "WEBSERVICE",
	"_xlfn.WEIBULL.DIST": "WEIBULL.DIST",
	"_xlfn.WORKDAY.INTL": "WORKDAY.INTL",
	"_xlfn.XOR": "XOR",
	"_xlfn.Z.TEST": "Z.TEST"
};

/* Part 3 TODO: actually parse formulae */
function ods_to_csf_formula(f) {
	if(f.slice(0,3) == "of:") f = f.slice(3);
	/* 5.2 Basic Expressions */
	if(f.charCodeAt(0) == 61) {
		f = f.slice(1);
		if(f.charCodeAt(0) == 61) f = f.slice(1);
	}
	f = f.replace(/COM\.MICROSOFT\./g, "");
	/* Part 3 Section 5.8 References */
	f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) { return $1.replace(/\./g,""); });
	/* TODO: something other than this */
	f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
	return f.replace(/[;~]/g,",").replace(/\|/g,";");
}

function csf_to_ods_formula(f) {
	var o = "of:=" + f.replace(crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g,":");
	/* TODO: something other than this */
	return o.replace(/;/g, "|").replace(/,/g,";");
}

function ods_to_csf_3D(r) {
	var a = r.split(":");
	var s = a[0].split(".")[0];
	return [s, a[0].split(".")[1] + (a.length > 1 ? (":" + (a[1].split(".")[1] || a[1].split(".")[0])) : "")];
}

function csf_to_ods_3D(r) {
	return r.replace(/\./,"!");
}

var strs = {}; // shared strings
var _ssfopts = {}; // spreadsheet formatting options

RELS.WS = [
	"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
	"http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
];

/*global Map */
var browser_has_Map = typeof Map !== 'undefined';

function get_sst_id(sst, str, rev) {
	var i = 0, len = sst.length;
	if(rev) {
		if(browser_has_Map ? rev.has(str) : rev.hasOwnProperty(str)) {
			var revarr = browser_has_Map ? rev.get(str) : rev[str];
			for(; i < revarr.length; ++i) {
				if(sst[revarr[i]].t === str) { sst.Count ++; return revarr[i]; }
			}
		}
	} else for(; i < len; ++i) {
		if(sst[i].t === str) { sst.Count ++; return i; }
	}
	sst[len] = ({t:str}); sst.Count ++; sst.Unique ++;
	if(rev) {
		if(browser_has_Map) {
			if(!rev.has(str)) rev.set(str, []);
			rev.get(str).push(len);
		} else {
			if(!rev.hasOwnProperty(str)) rev[str] = [];
			rev[str].push(len);
		}
	}
	return len;
}

function col_obj_w(C, col) {
	var p = ({min:C+1,max:C+1});
	/* wch (chars), wpx (pixels) */
	var wch = -1;
	if(col.MDW) MDW = col.MDW;
	if(col.width != null) p.customWidth = 1;
	else if(col.wpx != null) wch = px2char(col.wpx);
	else if(col.wch != null) wch = col.wch;
	if(wch > -1) { p.width = char2width(wch); p.customWidth = 1; }
	else if(col.width != null) p.width = col.width;
	if(col.hidden) p.hidden = true;
	return p;
}

function default_margins(margins, mode) {
	if(!margins) return;
	var defs = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
	if(mode == 'xlml') defs = [1, 1, 1, 1, 0.5, 0.5];
	if(margins.left   == null) margins.left   = defs[0];
	if(margins.right  == null) margins.right  = defs[1];
	if(margins.top    == null) margins.top    = defs[2];
	if(margins.bottom == null) margins.bottom = defs[3];
	if(margins.header == null) margins.header = defs[4];
	if(margins.footer == null) margins.footer = defs[5];
}

function get_cell_style(styles, cell, opts) {
	var z = opts.revssf[cell.z != null ? cell.z : "General"];
	var i = 0x3c, len = styles.length;
	if(z == null && opts.ssf) {
		for(; i < 0x188; ++i) if(opts.ssf[i] == null) {
			SSF.load(cell.z, i);
			// $FlowIgnore
			opts.ssf[i] = cell.z;
			opts.revssf[cell.z] = z = i;
			break;
		}
	}
	for(i = 0; i != len; ++i) if(styles[i].numFmtId === z) return i;
	styles[len] = {
		numFmtId:z,
		fontId:0,
		fillId:0,
		borderId:0,
		xfId:0,
		applyNumberFormat:1
	};
	return len;
}

function safe_format(p, fmtid, fillid, opts, themes, styles) {
	if(p.t === 'z') return;
	if(p.t === 'd' && typeof p.v === 'string') p.v = parseDate(p.v);
	try {
		if(opts.cellNF) p.z = SSF._table[fmtid];
	} catch(e) { if(opts.WTF) throw e; }
	if(!opts || opts.cellText !== false) try {
		if(SSF._table[fmtid] == null) SSF.load(SSFImplicit[fmtid] || "General", fmtid);
		if(p.t === 'e') p.w = p.w || BErr[p.v];
		else if(fmtid === 0) {
			if(p.t === 'n') {
				if((p.v|0) === p.v) p.w = SSF._general_int(p.v);
				else p.w = SSF._general_num(p.v);
			}
			else if(p.t === 'd') {
				var dd = datenum(p.v);
				if((dd|0) === dd) p.w = SSF._general_int(dd);
				else p.w = SSF._general_num(dd);
			}
			else if(p.v === undefined) return "";
			else p.w = SSF._general(p.v,_ssfopts);
		}
		else if(p.t === 'd') p.w = SSF.format(fmtid,datenum(p.v),_ssfopts);
		else p.w = SSF.format(fmtid,p.v,_ssfopts);
	} catch(e) { if(opts.WTF) throw e; }
	if(!opts.cellStyles) return;
	if(fillid != null) try {
		p.s = styles.Fills[fillid];
		if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
			p.s.fgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
			if(opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
		}
		if (p.s.bgColor && p.s.bgColor.theme) {
			p.s.bgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
			if(opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
		}
	} catch(e) { if(opts.WTF && styles.Fills) throw e; }
}

function check_ws(ws, sname, i) {
	if(ws && ws['!ref']) {
		var range = safe_decode_range(ws['!ref']);
		if(range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
	}
}
function parse_ws_xml_dim(ws, s) {
	var d = safe_decode_range(s);
	if(d.s.r<=d.e.r && d.s.c<=d.e.c && d.s.r>=0 && d.s.c>=0) ws["!ref"] = encode_range(d);
}
var mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
var sheetdataregex = /<(?:\w+:)?sheetData>([\s\S]*)<\/(?:\w+:)?sheetData>/;
var hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
var dimregex = /"(\w*:\w*)"/;
var colregex = /<(?:\w:)?col[^>]*[\/]?>/g;
var afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
var marginregex= /<(?:\w:)?pageMargins[^>]*\/>/g;
var sheetprregex = /<(?:\w:)?sheetPr(?:[^>a-z][^>]*)?\/>/;
var svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
/* 18.3 Worksheets */
function parse_ws_xml(data, opts, idx, rels, wb, themes, styles) {
	if(!data) return data;
	if(DENSE != null && opts.dense == null) opts.dense = DENSE;

	/* 18.3.1.99 worksheet CT_Worksheet */
	var s = opts.dense ? ([]) : ({});
	var refguess = ({s: {r:2000000, c:2000000}, e: {r:0, c:0} });

	var data1 = "", data2 = "";
	var mtch = data.match(sheetdataregex);
	if(mtch) {
		data1 = data.slice(0, mtch.index);
		data2 = data.slice(mtch.index + mtch[0].length);
	} else data1 = data2 = data;

	/* 18.3.1.82 sheetPr CT_SheetPr */
	var sheetPr = data1.match(sheetprregex);
	if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);

	/* 18.3.1.35 dimension CT_SheetDimension */
	// $FlowIgnore
	var ridx = (data1.match(/<(?:\w*:)?dimension/)||{index:-1}).index;
	if(ridx > 0) {
		var ref = data1.slice(ridx,ridx+50).match(dimregex);
		if(ref) parse_ws_xml_dim(s, ref[1]);
	}

	/* 18.3.1.88 sheetViews CT_SheetViews */
	var svs = data1.match(svsregex);
	if(svs && svs[1]) parse_ws_xml_sheetviews(svs[1], wb);

	/* 18.3.1.17 cols CT_Cols */
	var columns = [];
	if(opts.cellStyles) {
		/* 18.3.1.13 col CT_Col */
		var cols = data1.match(colregex);
		if(cols) parse_ws_xml_cols(columns, cols);
	}

	/* 18.3.1.80 sheetData CT_SheetData ? */
	if(mtch) parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);

	/* 18.3.1.2  autoFilter CT_AutoFilter */
	var afilter = data2.match(afregex);
	if(afilter) s['!autofilter'] = parse_ws_xml_autofilter(afilter[0]);

	/* 18.3.1.55 mergeCells CT_MergeCells */
	var merges = [];
	var _merge = data2.match(mergecregex);
	if(_merge) for(ridx = 0; ridx != _merge.length; ++ridx)
		merges[ridx] = safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"")+1));

	/* 18.3.1.48 hyperlinks CT_Hyperlinks */
	var hlink = data2.match(hlinkregex);
	if(hlink) parse_ws_xml_hlinks(s, hlink, rels);

	/* 18.3.1.62 pageMargins CT_PageMargins */
	var margins = data2.match(marginregex);
	if(margins) s['!margins'] = parse_ws_xml_margins(parsexmltag(margins[0]));

	if(!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = encode_range(refguess);
	if(opts.sheetRows > 0 && s["!ref"]) {
		var tmpref = safe_decode_range(s["!ref"]);
		if(opts.sheetRows <= +tmpref.e.r) {
			tmpref.e.r = opts.sheetRows - 1;
			if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
			if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
			if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
			if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
			s["!fullref"] = s["!ref"];
			s["!ref"] = encode_range(tmpref);
		}
	}
	if(columns.length > 0) s["!cols"] = columns;
	if(merges.length > 0) s["!merges"] = merges;
	return s;
}

function write_ws_xml_merges(merges) {
	if(merges.length === 0) return "";
	var o = '<mergeCells count="' + merges.length + '">';
	for(var i = 0; i != merges.length; ++i) o += '<mergeCell ref="' + encode_range(merges[i]) + '"/>';
	return o + '</mergeCells>';
}

/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */
function parse_ws_xml_sheetpr(sheetPr, s, wb, idx) {
	var data = parsexmltag(sheetPr);
	if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
	if(data.codeName) wb.Sheets[idx].CodeName = data.codeName;
}

/* 18.3.1.85 sheetProtection CT_SheetProtection */
function write_ws_xml_protection(sp) {
	// algorithmName, hashValue, saltValue, spinCountpassword
	var o = ({sheet:1});
	var deffalse = ["objects", "scenarios", "selectLockedCells", "selectUnlockedCells"];
	var deftrue = [
		"formatColumns", "formatRows", "formatCells",
		"insertColumns", "insertRows", "insertHyperlinks",
		"deleteColumns", "deleteRows",
		"sort", "autoFilter", "pivotTables"
	];
	deffalse.forEach(function(n) { if(sp[n] != null && sp[n]) o[n] = "1"; });
	deftrue.forEach(function(n) { if(sp[n] != null && !sp[n]) o[n] = "0"; });
	/* TODO: algorithm */
	if(sp.password) o.password = crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
	return writextag('sheetProtection', null, o);
}

function parse_ws_xml_hlinks(s, data, rels) {
	var dense = Array.isArray(s);
	for(var i = 0; i != data.length; ++i) {
		var val = parsexmltag(utf8read(data[i]), true);
		if(!val.ref) return;
		var rel = ((rels || {})['!id']||[])[val.id];
		if(rel) {
			val.Target = rel.Target;
			if(val.location) val.Target += "#"+val.location;
		} else {
			val.Target = "#" + val.location;
			rel = {Target: val.Target, TargetMode: 'Internal'};
		}
		val.Rel = rel;
		if(val.tooltip) { val.Tooltip = val.tooltip; delete val.tooltip; }
		var rng = safe_decode_range(val.ref);
		for(var R=rng.s.r;R<=rng.e.r;++R) for(var C=rng.s.c;C<=rng.e.c;++C) {
			var addr = encode_cell({c:C,r:R});
			if(dense) {
				if(!s[R]) s[R] = [];
				if(!s[R][C]) s[R][C] = {t:"z",v:undefined};
				s[R][C].l = val;
			} else {
				if(!s[addr]) s[addr] = {t:"z",v:undefined};
				s[addr].l = val;
			}
		}
	}
}

function parse_ws_xml_margins(margin) {
	var o = {};
	["left", "right", "top", "bottom", "header", "footer"].forEach(function(k) {
		if(margin[k]) o[k] = parseFloat(margin[k]);
	});
	return o;
}
function write_ws_xml_margins(margin) {
	default_margins(margin);
	return writextag('pageMargins', null, margin);
}

function parse_ws_xml_cols(columns, cols) {
	var seencol = false;
	for(var coli = 0; coli != cols.length; ++coli) {
		var coll = parsexmltag(cols[coli], true);
		if(coll.hidden) coll.hidden = parsexmlbool(coll.hidden);
		var colm=parseInt(coll.min, 10)-1, colM=parseInt(coll.max,10)-1;
		delete coll.min; delete coll.max; coll.width = +coll.width;
		if(!seencol && coll.width) { seencol = true; find_mdw_colw(coll.width); }
		process_col(coll);
		while(colm <= colM) columns[colm++] = dup(coll);
	}
}

function write_ws_xml_cols(ws, cols) {
	var o = ["<cols>"], col;
	for(var i = 0; i != cols.length; ++i) {
		if(!(col = cols[i])) continue;
		o[o.length] = (writextag('col', null, col_obj_w(i, col)));
	}
	o[o.length] = "</cols>";
	return o.join("");
}

function parse_ws_xml_autofilter(data) {
	var o = { ref: (data.match(/ref="([^"]*)"/)||[])[1]};
	return o;
}
function write_ws_xml_autofilter(data) {
	return writextag("autoFilter", null, {ref:data.ref});
}

/* 18.3.1.88 sheetViews CT_SheetViews */
/* 18.3.1.87 sheetView CT_SheetView */
var sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/>/;
function parse_ws_xml_sheetviews(data, wb) {
	(data.match(sviewregex)||[]).forEach(function(r) {
		var tag = parsexmltag(r);
		if(parsexmlbool(tag.rightToLeft)) {
			if(!wb.Views) wb.Views = [{}];
			if(!wb.Views[0]) wb.Views[0] = {};
			wb.Views[0].RTL = true;
		}
	});
}
function write_ws_xml_sheetviews(ws, opts, idx, wb) {
	var sview = {workbookViewId:"0"};
	// $FlowIgnore
	if( (((wb||{}).Workbook||{}).Views||[])[0] ) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
	return writextag("sheetViews", writextag("sheetView", null, sview), {});
}

function write_ws_xml_cell(cell, ref, ws, opts) {
	if(cell.v === undefined && cell.f === undefined || cell.t === 'z') return "";
	var vv = "";
	var oldt = cell.t, oldv = cell.v;
	switch(cell.t) {
		case 'b': vv = cell.v ? "1" : "0"; break;
		case 'n': vv = ''+cell.v; break;
		case 'e': vv = BErr[cell.v]; break;
		case 'd':
			if(opts.cellDates) vv = parseDate(cell.v, -1).toISOString();
			else {
				cell = dup(cell);
				cell.t = 'n';
				vv = ''+(cell.v = datenum(parseDate(cell.v)));
			}
			if(typeof cell.z === 'undefined') cell.z = SSF._table[14];
			break;
		default: vv = cell.v; break;
	}
	var v = writetag('v', escapexml(vv)), o = ({r:ref});
	/* TODO: cell style */
	var os = get_cell_style(opts.cellXfs, cell, opts);
	if(os !== 0) o.s = os;
	switch(cell.t) {
		case 'n': break;
		case 'd': o.t = "d"; break;
		case 'b': o.t = "b"; break;
		case 'e': o.t = "e"; break;
		default: if(cell.v == null) { delete cell.t; break; }
			if(opts.bookSST) {
				v = writetag('v', ''+get_sst_id(opts.Strings, cell.v, opts.revStrings));
				o.t = "s"; break;
			}
			o.t = "str"; break;
	}
	if(cell.t != oldt) { cell.t = oldt; cell.v = oldv; }
	if(cell.f) {
		var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {t:"array", ref:cell.F} : null;
		v = writextag('f', escapexml(cell.f), ff) + (cell.v != null ? v : "");
	}
	if(cell.l) ws['!links'].push([ref, cell.l]);
	if(cell.c) ws['!comments'].push([ref, cell.c]);
	return writextag('c', v, o);
}

var parse_ws_xml_data = (function() {
	var cellregex = /<(?:\w+:)?c[ >]/, rowregex = /<\/(?:\w+:)?row>/;
	var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
	var refregex = /ref=["']([^"']*)["']/;
	var match_v = matchtag("v"), match_f = matchtag("f");

return function parse_ws_xml_data(sdata, s, opts, guess, themes, styles) {
	var ri = 0, x = "", cells = [], cref = [], idx=0, i=0, cc=0, d="", p;
	var tag, tagr = 0, tagc = 0;
	var sstr, ftag;
	var fmtid = 0, fillid = 0;
	var do_format = Array.isArray(styles.CellXf), cf;
	var arrayf = [];
	var sharedf = [];
	var dense = Array.isArray(s);
	var rows = [], rowobj = {}, rowrite = false;
	for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt) {
		x = marr[mt].trim();
		var xlen = x.length;
		if(xlen === 0) continue;

		/* 18.3.1.73 row CT_Row */
		for(ri = 0; ri < xlen; ++ri) if(x.charCodeAt(ri) === 62) break; ++ri;
		tag = parsexmltag(x.slice(0,ri), true);
		tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
		if(opts.sheetRows && opts.sheetRows < tagr) continue;
		if(guess.s.r > tagr - 1) guess.s.r = tagr - 1;
		if(guess.e.r < tagr - 1) guess.e.r = tagr - 1;

		if(opts && opts.cellStyles) {
			rowobj = {}; rowrite = false;
			if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
			if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
			if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
			if(rowrite) rows[tagr-1] = rowobj;
		}

		/* 18.3.1.4 c CT_Cell */
		cells = x.slice(ri).split(cellregex);
		for(ri = 0; ri != cells.length; ++ri) {
			x = cells[ri].trim();
			if(x.length === 0) continue;
			cref = x.match(rregex); idx = ri; i=0; cc=0;
			x = "<c " + (x.slice(0,1)=="<"?">":"") + x;
			if(cref != null && cref.length === 2) {
				idx = 0; d=cref[1];
				for(i=0; i != d.length; ++i) {
					if((cc=d.charCodeAt(i)-64) < 1 || cc > 26) break;
					idx = 26*idx + cc;
				}
				--idx;
				tagc = idx;
			} else ++tagc;
			for(i = 0; i != x.length; ++i) if(x.charCodeAt(i) === 62) break; ++i;
			tag = parsexmltag(x.slice(0,i), true);
			if(!tag.r) tag.r = encode_cell({r:tagr-1, c:tagc});
			d = x.slice(i);
			p = ({t:""});

			if((cref=d.match(match_v))!= null && cref[1] !== '') p.v=unescapexml(cref[1]);
			if(opts.cellFormula) {
				if((cref=d.match(match_f))!= null && cref[1] !== '') {
					/* TODO: match against XLSXFutureFunctions */
					p.f=_xlfn(unescapexml(utf8read(cref[1])));
					if(cref[0].indexOf('t="array"') > -1) {
						p.F = (d.match(refregex)||[])[1];
						if(p.F.indexOf(":") > -1) arrayf.push([safe_decode_range(p.F), p.F]);
					} else if(cref[0].indexOf('t="shared"') > -1) {
						// TODO: parse formula
						ftag = parsexmltag(cref[0]);
						sharedf[parseInt(ftag.si, 10)] = [ftag, _xlfn(unescapexml(utf8read(cref[1])))];
					}
				} else if((cref=d.match(/<f[^>]*\/>/))) {
					ftag = parsexmltag(cref[0]);
					if(sharedf[ftag.si]) p.f = shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][0].ref, tag.r);
				}
				/* TODO: factor out contains logic */
				var _tag = decode_cell(tag.r);
				for(i = 0; i < arrayf.length; ++i)
					if(_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r)
						if(_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c)
							p.F = arrayf[i][1];
			}

			if(tag.t == null && p.v === undefined) {
				if(p.f || p.F) {
					p.v = 0; p.t = "n";
				} else if(!opts.sheetStubs) continue;
				else p.t = "z";
			}
			else p.t = tag.t || "n";
			if(guess.s.c > tagc) guess.s.c = tagc;
			if(guess.e.c < tagc) guess.e.c = tagc;
			/* 18.18.11 t ST_CellType */
			switch(p.t) {
				case 'n':
					if(p.v == "" || p.v == null) {
						if(!opts.sheetStubs) continue;
						p.t = 'z';
					} else p.v = parseFloat(p.v);
					break;
				case 's':
					if(typeof p.v == 'undefined') {
						if(!opts.sheetStubs) continue;
						p.t = 'z';
					} else {
						sstr = strs[parseInt(p.v, 10)];
						p.v = sstr.t;
						p.r = sstr.r;
						if(opts.cellHTML) p.h = sstr.h;
					}
					break;
				case 'str':
					p.t = "s";
					p.v = (p.v!=null) ? utf8read(p.v) : '';
					if(opts.cellHTML) p.h = escapehtml(p.v);
					break;
				case 'inlineStr':
					cref = d.match(isregex);
					p.t = 's';
					if(cref != null && (sstr = parse_si(cref[1]))) p.v = sstr.t; else p.v = "";
					break;
				case 'b': p.v = parsexmlbool(p.v); break;
				case 'd':
					if(opts.cellDates) p.v = parseDate(p.v, 1);
					else { p.v = datenum(parseDate(p.v, 1)); p.t = 'n'; }
					break;
				/* error string in .w, number in .v */
				case 'e':
					if(!opts || opts.cellText !== false) p.w = p.v;
					p.v = RBErr[p.v]; break;
			}
			/* formatting */
			fmtid = fillid = 0;
			if(do_format && tag.s !== undefined) {
				cf = styles.CellXf[tag.s];
				if(cf != null) {
					if(cf.numFmtId != null) fmtid = cf.numFmtId;
					if(opts.cellStyles) {
						if(cf.fillId != null) fillid = cf.fillId;
					}
				}
			}
			safe_format(p, fmtid, fillid, opts, themes, styles);
			if(opts.cellDates && do_format && p.t == 'n' && SSF.is_date(SSF._table[fmtid])) { p.t = 'd'; p.v = numdate(p.v); }
			if(dense) {
				var _r = decode_cell(tag.r);
				if(!s[_r.r]) s[_r.r] = [];
				s[_r.r][_r.c] = p;
			} else s[tag.r] = p;
		}
	}
	if(rows.length > 0) s['!rows'] = rows;
}; })();

function write_ws_xml_data(ws, opts, idx, wb) {
	var o = [], r = [], range = safe_decode_range(ws['!ref']), cell="", ref, rr = "", cols = [], R=0, C=0, rows = ws['!rows'];
	var dense = Array.isArray(ws);
	var params = ({r:rr}), row, height = -1;
	for(C = range.s.c; C <= range.e.c; ++C) cols[C] = encode_col(C);
	for(R = range.s.r; R <= range.e.r; ++R) {
		r = [];
		rr = encode_row(R);
		for(C = range.s.c; C <= range.e.c; ++C) {
			ref = cols[C] + rr;
			var _cell = dense ? (ws[R]||[])[C]: ws[ref];
			if(_cell === undefined) continue;
			if((cell = write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
		}
		if(r.length > 0 || (rows && rows[R])) {
			params = ({r:rr});
			if(rows && rows[R]) {
				row = rows[R];
				if(row.hidden) params.hidden = 1;
				height = -1;
				if (row.hpx) height = px2pt(row.hpx);
				else if (row.hpt) height = row.hpt;
				if (height > -1) { params.ht = height; params.customHeight = 1; }
				if (row.level) { params.outlineLevel = row.level; }
			}
			o[o.length] = (writextag('row', r.join(""), params));
		}
	}
	if(rows) for(; R < rows.length; ++R) {
		if(rows && rows[R]) {
			params = ({r:R+1});
			row = rows[R];
			if(row.hidden) params.hidden = 1;
			height = -1;
			if (row.hpx) height = px2pt(row.hpx);
			else if (row.hpt) height = row.hpt;
			if (height > -1) { params.ht = height; params.customHeight = 1; }
			if (row.level) { params.outlineLevel = row.level; }
			o[o.length] = (writextag('row', "", params));
		}
	}
	return o.join("");
}

var WS_XML_ROOT = writextag('worksheet', null, {
	'xmlns': XMLNS.main[0],
	'xmlns:r': XMLNS.r
});

function write_ws_xml(idx, opts, wb, rels) {
	var o = [XML_HEADER, WS_XML_ROOT];
	var s = wb.SheetNames[idx], sidx = 0, rdata = "";
	var ws = wb.Sheets[s];
	if(ws == null) ws = {};
	var ref = ws['!ref'] || 'A1';
	var range = safe_decode_range(ref);
	if(range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
		if(opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
		range.e.c = Math.min(range.e.c, 0x3FFF);
		range.e.r = Math.min(range.e.c, 0xFFFFF);
		ref = encode_range(range);
	}
	if(!rels) rels = {};
	ws['!comments'] = [];
	ws['!drawing'] = [];

	if(opts.bookType !== 'xlsx' && wb.vbaraw) {
		var cname = wb.SheetNames[idx];
		try { if(wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname; } catch(e) {}
		o[o.length] = (writextag('sheetPr', null, {'codeName': escapexml(cname)}));
	}

	o[o.length] = (writextag('dimension', null, {'ref': ref}));

	o[o.length] = write_ws_xml_sheetviews(ws, opts, idx, wb);

	/* TODO: store in WB, process styles */
	if(opts.sheetFormat) o[o.length] = (writextag('sheetFormatPr', null, {
		defaultRowHeight:opts.sheetFormat.defaultRowHeight||'16',
		baseColWidth:opts.sheetFormat.baseColWidth||'10',
		outlineLevelRow:opts.sheetFormat.outlineLevelRow||'7'
	}));

	if(ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = (write_ws_xml_cols(ws, ws['!cols']));

	o[sidx = o.length] = '<sheetData/>';
	ws['!links'] = [];
	if(ws['!ref'] != null) {
		rdata = write_ws_xml_data(ws, opts, idx, wb, rels);
		if(rdata.length > 0) o[o.length] = (rdata);
	}
	if(o.length>sidx+1) { o[o.length] = ('</sheetData>'); o[sidx]=o[sidx].replace("/>",">"); }

	/* sheetCalcPr */

	if(ws['!protect'] != null) o[o.length] = write_ws_xml_protection(ws['!protect']);

	/* protectedRanges */
	/* scenarios */

	if(ws['!autofilter'] != null) o[o.length] = write_ws_xml_autofilter(ws['!autofilter']);

	/* sortState */
	/* dataConsolidate */
	/* customSheetViews */

	if(ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = (write_ws_xml_merges(ws['!merges']));

	/* phoneticPr */
	/* conditionalFormatting */
	/* dataValidations */

	var relc = -1, rel, rId = -1;
	if(ws['!links'].length > 0) {
		o[o.length] = "<hyperlinks>";
		ws['!links'].forEach(function(l) {
			if(!l[1].Target) return;
			rel = ({"ref":l[0]});
			if(l[1].Target.charAt(0) != "#") {
				rId = add_rels(rels, -1, escapexml(l[1].Target).replace(/#.*$/, ""), RELS.HLINK);
				rel["r:id"] = "rId"+rId;
			}
			if((relc = l[1].Target.indexOf("#")) > -1) rel.location = escapexml(l[1].Target.slice(relc+1));
			if(l[1].Tooltip) rel.tooltip = escapexml(l[1].Tooltip);
			o[o.length] = writextag("hyperlink",null,rel);
		});
		o[o.length] = "</hyperlinks>";
	}
	delete ws['!links'];

	/* printOptions */
	if (ws['!margins'] != null) o[o.length] =  write_ws_xml_margins(ws['!margins']);
	/* pageSetup */

	//var hfidx = o.length;
	o[o.length] = "";

	/* rowBreaks */
	/* colBreaks */
	/* customProperties */
	/* cellWatches */

	if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) o[o.length] = writetag("ignoredErrors", writextag("ignoredError", null, {numberStoredAsText:1, sqref:ref}));

	/* smartTags */

	if(ws['!drawing'].length > 0) {
		rId = add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
		o[o.length] = writextag("drawing", null, {"r:id":"rId" + rId});
	}
	else delete ws['!drawing'];

	if(ws['!comments'].length > 0) {
		rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
		o[o.length] = writextag("legacyDrawing", null, {"r:id":"rId" + rId});
		ws['!legacy'] = rId;
	}

	/* drawingHF */
	/* picture */
	/* oleObjects */
	/* controls */
	/* webPublishItems */
	/* tableParts */
	/* extList */

	if(o.length>2) { o[o.length] = ('</worksheet>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}

/* [MS-XLSB] 2.4.726 BrtRowHdr */
function parse_BrtRowHdr(data, length) {
	var z = ({});
	var tgt = data.l + length;
	z.r = data.read_shift(4);
	data.l += 4; // TODO: ixfe
	var miyRw = data.read_shift(2);
	data.l += 1; // TODO: top/bot padding
	var flags = data.read_shift(1);
	data.l = tgt;
	if(flags & 0x07) z.level = flags & 0x07;
	if(flags & 0x10) z.hidden = true;
	if(flags & 0x20) z.hpt = miyRw / 20;
	return z;
}
function write_BrtRowHdr(R, range, ws) {
	var o = new_buf(17+8*16);
	var row = (ws['!rows']||[])[R]||{};
	o.write_shift(4, R);

	o.write_shift(4, 0); /* TODO: ixfe */

	var miyRw = 0x0140;
	if(row.hpx) miyRw = px2pt(row.hpx) * 20;
	else if(row.hpt) miyRw = row.hpt * 20;
	o.write_shift(2, miyRw);

	o.write_shift(1, 0); /* top/bot padding */

	var flags = 0x0;
	if(row.level) flags |= row.level;
	if(row.hidden) flags |= 0x10;
	if(row.hpx || row.hpt) flags |= 0x20;
	o.write_shift(1, flags);

	o.write_shift(1, 0); /* phonetic guide */

	/* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */
	var ncolspan = 0, lcs = o.l;
	o.l += 4;

	var caddr = {r:R, c:0};
	for(var i = 0; i < 16; ++i) {
		if((range.s.c > ((i+1) << 10)) || (range.e.c < (i << 10))) continue;
		var first = -1, last = -1;
		for(var j = (i<<10); j < ((i+1)<<10); ++j) {
			caddr.c = j;
			var cell = Array.isArray(ws) ? (ws[caddr.r]||[])[caddr.c] : ws[encode_cell(caddr)];
			if(cell) { if(first < 0) first = j; last = j; }
		}
		if(first < 0) continue;
		++ncolspan;
		o.write_shift(4, first);
		o.write_shift(4, last);
	}

	var l = o.l;
	o.l = lcs;
	o.write_shift(4, ncolspan);
	o.l = l;

	return o.length > o.l ? o.slice(0, o.l) : o;
}
function write_row_header(ba, ws, range, R) {
	var o = write_BrtRowHdr(R, range, ws);
	if((o.length > 17) || (ws['!rows']||[])[R]) write_record(ba, 'BrtRowHdr', o);
}

/* [MS-XLSB] 2.4.820 BrtWsDim */
var parse_BrtWsDim = parse_UncheckedRfX;
var write_BrtWsDim = write_UncheckedRfX;

/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */
function parse_BrtWsFmtInfo() {
}
//function write_BrtWsFmtInfo(ws, o) { }

/* [MS-XLSB] 2.4.823 BrtWsProp */
function parse_BrtWsProp(data, length) {
	var z = {};
	/* TODO: pull flags */
	data.l += 19;
	z.name = parse_XLSBCodeName(data, length - 19);
	return z;
}
function write_BrtWsProp(str, o) {
	if(o == null) o = new_buf(84+4*str.length);
	for(var i = 0; i < 3; ++i) o.write_shift(1,0);
	write_BrtColor({auto:1}, o);
	o.write_shift(-4,-1);
	o.write_shift(-4,-1);
	write_XLSBCodeName(str, o);
	return o.slice(0, o.l);
}

/* [MS-XLSB] 2.4.306 BrtCellBlank */
function parse_BrtCellBlank(data) {
	var cell = parse_XLSBCell(data);
	return [cell];
}
function write_BrtCellBlank(cell, ncell, o) {
	if(o == null) o = new_buf(8);
	return write_XLSBCell(ncell, o);
}


/* [MS-XLSB] 2.4.307 BrtCellBool */
function parse_BrtCellBool(data) {
	var cell = parse_XLSBCell(data);
	var fBool = data.read_shift(1);
	return [cell, fBool, 'b'];
}
function write_BrtCellBool(cell, ncell, o) {
	if(o == null) o = new_buf(9);
	write_XLSBCell(ncell, o);
	o.write_shift(1, cell.v ? 1 : 0);
	return o;
}

/* [MS-XLSB] 2.4.308 BrtCellError */
function parse_BrtCellError(data) {
	var cell = parse_XLSBCell(data);
	var bError = data.read_shift(1);
	return [cell, bError, 'e'];
}

/* [MS-XLSB] 2.4.311 BrtCellIsst */
function parse_BrtCellIsst(data) {
	var cell = parse_XLSBCell(data);
	var isst = data.read_shift(4);
	return [cell, isst, 's'];
}
function write_BrtCellIsst(cell, ncell, o) {
	if(o == null) o = new_buf(12);
	write_XLSBCell(ncell, o);
	o.write_shift(4, ncell.v);
	return o;
}

/* [MS-XLSB] 2.4.313 BrtCellReal */
function parse_BrtCellReal(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_Xnum(data);
	return [cell, value, 'n'];
}
function write_BrtCellReal(cell, ncell, o) {
	if(o == null) o = new_buf(16);
	write_XLSBCell(ncell, o);
	write_Xnum(cell.v, o);
	return o;
}

/* [MS-XLSB] 2.4.314 BrtCellRk */
function parse_BrtCellRk(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_RkNumber(data);
	return [cell, value, 'n'];
}
function write_BrtCellRk(cell, ncell, o) {
	if(o == null) o = new_buf(12);
	write_XLSBCell(ncell, o);
	write_RkNumber(cell.v, o);
	return o;
}


/* [MS-XLSB] 2.4.317 BrtCellSt */
function parse_BrtCellSt(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_XLWideString(data);
	return [cell, value, 'str'];
}
function write_BrtCellSt(cell, ncell, o) {
	if(o == null) o = new_buf(12 + 4 * cell.v.length);
	write_XLSBCell(ncell, o);
	write_XLWideString(cell.v, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.653 BrtFmlaBool */
function parse_BrtFmlaBool(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = data.read_shift(1);
	var o = [cell, value, 'b'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.654 BrtFmlaError */
function parse_BrtFmlaError(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = data.read_shift(1);
	var o = [cell, value, 'e'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.655 BrtFmlaNum */
function parse_BrtFmlaNum(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = parse_Xnum(data);
	var o = [cell, value, 'n'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.656 BrtFmlaString */
function parse_BrtFmlaString(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = parse_XLWideString(data);
	var o = [cell, value, 'str'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.682 BrtMergeCell */
var parse_BrtMergeCell = parse_UncheckedRfX;
var write_BrtMergeCell = write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */
function write_BrtBeginMergeCells(cnt, o) {
	if(o == null) o = new_buf(4);
	o.write_shift(4, cnt);
	return o;
}

/* [MS-XLSB] 2.4.662 BrtHLink */
function parse_BrtHLink(data, length) {
	var end = data.l + length;
	var rfx = parse_UncheckedRfX(data, 16);
	var relId = parse_XLNullableWideString(data);
	var loc = parse_XLWideString(data);
	var tooltip = parse_XLWideString(data);
	var display = parse_XLWideString(data);
	data.l = end;
	var o = ({rfx:rfx, relId:relId, loc:loc, display:display});
	if(tooltip) o.Tooltip = tooltip;
	return o;
}
function write_BrtHLink(l, rId) {
	var o = new_buf(50+4*(l[1].Target.length + (l[1].Tooltip || "").length));
	write_UncheckedRfX({s:decode_cell(l[0]), e:decode_cell(l[0])}, o);
	write_RelID("rId" + rId, o);
	var locidx = l[1].Target.indexOf("#");
	var loc = locidx == -1 ? "" : l[1].Target.slice(locidx+1);
	write_XLWideString(loc || "", o);
	write_XLWideString(l[1].Tooltip || "", o);
	write_XLWideString("", o);
	return o.slice(0, o.l);
}

/* [MS-XLSB] 2.4.6 BrtArrFmla */
function parse_BrtArrFmla(data, length, opts) {
	var end = data.l + length;
	var rfx = parse_RfX(data, 16);
	var fAlwaysCalc = data.read_shift(1);
	var o = [rfx]; o[2] = fAlwaysCalc;
	if(opts.cellFormula) {
		var formula = parse_XLSBArrayParsedFormula(data, end - data.l, opts);
		o[1] = formula;
	} else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.750 BrtShrFmla */
function parse_BrtShrFmla(data, length, opts) {
	var end = data.l + length;
	var rfx = parse_UncheckedRfX(data, 16);
	var o = [rfx];
	if(opts.cellFormula) {
		var formula = parse_XLSBSharedParsedFormula(data, end - data.l, opts);
		o[1] = formula;
		data.l = end;
	} else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.323 BrtColInfo */
/* TODO: once XLS ColInfo is set, combine the functions */
function write_BrtColInfo(C, col, o) {
	if(o == null) o = new_buf(18);
	var p = col_obj_w(C, col);
	o.write_shift(-4, C);
	o.write_shift(-4, C);
	o.write_shift(4, (p.width || 10) * 256);
	o.write_shift(4, 0/*ixfe*/); // style
	var flags = 0;
	if(col.hidden) flags |= 0x01;
	if(typeof p.width == 'number') flags |= 0x02;
	o.write_shift(1, flags); // bit flag
	o.write_shift(1, 0); // bit flag
	return o;
}

/* [MS-XLSB] 2.4.678 BrtMargins */
var BrtMarginKeys = ["left","right","top","bottom","header","footer"];
function parse_BrtMargins(data) {
	var margins = ({});
	BrtMarginKeys.forEach(function(k) { margins[k] = parse_Xnum(data, 8); });
	return margins;
}
function write_BrtMargins(margins, o) {
	if(o == null) o = new_buf(6*8);
	default_margins(margins);
	BrtMarginKeys.forEach(function(k) { write_Xnum((margins)[k], o); });
	return o;
}

/* [MS-XLSB] 2.4.299 BrtBeginWsView */
function parse_BrtBeginWsView(data) {
	var f = data.read_shift(2);
	data.l += 28;
	return { RTL: f & 0x20 };
}
function write_BrtBeginWsView(ws, Workbook, o) {
	if(o == null) o = new_buf(30);
	var f = 0x39c;
	if((((Workbook||{}).Views||[])[0]||{}).RTL) f |= 0x20;
	o.write_shift(2, f); // bit flag
	o.write_shift(4, 0);
	o.write_shift(4, 0); // view first row
	o.write_shift(4, 0); // view first col
	o.write_shift(1, 0); // gridline color ICV
	o.write_shift(1, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 100); // zoom scale
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(4, 0); // workbook view id
	return o;
}

/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */
function write_BrtCellIgnoreEC(ref) {
	var o = new_buf(24);
	o.write_shift(4, 4);
	o.write_shift(4, 1);
	write_UncheckedRfX(ref, o);
	return o;
}

/* [MS-XLSB] 2.4.748 BrtSheetProtection */
function write_BrtSheetProtection(sp, o) {
	if(o == null) o = new_buf(16*4+2);
	o.write_shift(2, sp.password ? crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
	o.write_shift(4, 1); // this record should not be written if no protection
	[
		["objects",             false], // fObjects
		["scenarios",           false], // fScenarios
		["formatCells",          true], // fFormatCells
		["formatColumns",        true], // fFormatColumns
		["formatRows",           true], // fFormatRows
		["insertColumns",        true], // fInsertColumns
		["insertRows",           true], // fInsertRows
		["insertHyperlinks",     true], // fInsertHyperlinks
		["deleteColumns",        true], // fDeleteColumns
		["deleteRows",           true], // fDeleteRows
		["selectLockedCells",   false], // fSelLockedCells
		["sort",                 true], // fSort
		["autoFilter",           true], // fAutoFilter
		["pivotTables",          true], // fPivotTables
		["selectUnlockedCells", false]  // fSelUnlockedCells
	].forEach(function(n) {
if(n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
		else      o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
	});
	return o;
}

/* [MS-XLSB] 2.1.7.61 Worksheet */
function parse_ws_bin(data, _opts, idx, rels, wb, themes, styles) {
	if(!data) return data;
	var opts = _opts || {};
	if(!rels) rels = {'!id':{}};
	if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	var s = (opts.dense ? [] : {});

	var ref;
	var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };

	var pass = false, end = false;
	var row, p, cf, R, C, addr, sstr, rr, cell;
	var merges = [];
	opts.biff = 12;
	opts['!row'] = 0;

	var ai = 0, af = false;

	var arrayf = [];
	var sharedf = {};
	var supbooks = opts.supbooks || ([[]]);
	supbooks.sharedf = sharedf;
	supbooks.arrayf = arrayf;
	supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) { return x.name; });
	if(!opts.supbooks) {
		opts.supbooks = supbooks;
		if(wb.Names) for(var i = 0; i < wb.Names.length; ++i) supbooks[0][i+1] = wb.Names[i];
	}

	var colinfo = [], rowinfo = [];
	var seencol = false;

	recordhopper(data, function ws_parse(val, R_n, RT) {
		if(end) return;
		switch(RT) {
			case 0x0094: /* 'BrtWsDim' */
				ref = val; break;
			case 0x0000: /* 'BrtRowHdr' */
				row = val;
				if(opts.sheetRows && opts.sheetRows <= row.r) end=true;
				rr = encode_row(R = row.r);
				opts['!row'] = row.r;
				if(val.hidden || val.hpt || val.level != null) {
					if(val.hpt) val.hpx = pt2px(val.hpt);
					rowinfo[val.r] = val;
				}
				break;

			case 0x0002: /* 'BrtCellRk' */
			case 0x0003: /* 'BrtCellError' */
			case 0x0004: /* 'BrtCellBool' */
			case 0x0005: /* 'BrtCellReal' */
			case 0x0006: /* 'BrtCellSt' */
			case 0x0007: /* 'BrtCellIsst' */
			case 0x0008: /* 'BrtFmlaString' */
			case 0x0009: /* 'BrtFmlaNum' */
			case 0x000A: /* 'BrtFmlaBool' */
			case 0x000B: /* 'BrtFmlaError' */
				p = ({t:val[2]});
				switch(val[2]) {
					case 'n': p.v = val[1]; break;
					case 's': sstr = strs[val[1]]; p.v = sstr.t; p.r = sstr.r; break;
					case 'b': p.v = val[1] ? true : false; break;
					case 'e': p.v = val[1]; if(opts.cellText !== false) p.w = BErr[p.v]; break;
					case 'str': p.t = 's'; p.v = val[1]; break;
				}
				if((cf = styles.CellXf[val[0].iStyleRef])) safe_format(p,cf.numFmtId,null,opts, themes, styles);
				C = val[0].c;
				if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
				else s[encode_col(C) + rr] = p;
				if(opts.cellFormula) {
					af = false;
					for(ai = 0; ai < arrayf.length; ++ai) {
						var aii = arrayf[ai];
						if(row.r >= aii[0].s.r && row.r <= aii[0].e.r)
							if(C >= aii[0].s.c && C <= aii[0].e.c) {
								p.F = encode_range(aii[0]); af = true;
							}
					}
					if(!af && val.length > 3) p.f = val[3];
				}
				if(refguess.s.r > row.r) refguess.s.r = row.r;
				if(refguess.s.c > C) refguess.s.c = C;
				if(refguess.e.r < row.r) refguess.e.r = row.r;
				if(refguess.e.c < C) refguess.e.c = C;
				if(opts.cellDates && cf && p.t == 'n' && SSF.is_date(SSF._table[cf.numFmtId])) {
					var _d = SSF.parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
				}
				break;

			case 0x0001: /* 'BrtCellBlank' */
				if(!opts.sheetStubs || pass) break;
				p = ({t:'z',v:undefined});
				C = val[0].c;
				if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
				else s[encode_col(C) + rr] = p;
				if(refguess.s.r > row.r) refguess.s.r = row.r;
				if(refguess.s.c > C) refguess.s.c = C;
				if(refguess.e.r < row.r) refguess.e.r = row.r;
				if(refguess.e.c < C) refguess.e.c = C;
				break;

			case 0x00B0: /* 'BrtMergeCell' */
				merges.push(val); break;

			case 0x01EE: /* 'BrtHLink' */
				var rel = rels['!id'][val.relId];
				if(rel) {
					val.Target = rel.Target;
					if(val.loc) val.Target += "#"+val.loc;
					val.Rel = rel;
				} else if(val.relId == '') {
					val.Target = "#" + val.loc;
				}
				for(R=val.rfx.s.r;R<=val.rfx.e.r;++R) for(C=val.rfx.s.c;C<=val.rfx.e.c;++C) {
					if(opts.dense) {
						if(!s[R]) s[R] = [];
						if(!s[R][C]) s[R][C] = {t:'z',v:undefined};
						s[R][C].l = val;
					} else {
						addr = encode_cell({c:C,r:R});
						if(!s[addr]) s[addr] = {t:'z',v:undefined};
						s[addr].l = val;
					}
				}
				break;

			case 0x01AA: /* 'BrtArrFmla' */
				if(!opts.cellFormula) break;
				arrayf.push(val);
				cell = ((opts.dense ? s[R][C] : s[encode_col(C) + rr]));
				cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
				cell.F = encode_range(val[0]);
				break;
			case 0x01AB: /* 'BrtShrFmla' */
				if(!opts.cellFormula) break;
				sharedf[encode_cell(val[0].s)] = val[1];
				cell = (opts.dense ? s[R][C] : s[encode_col(C) + rr]);
				cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
				break;

			/* identical to 'ColInfo' in XLS */
			case 0x003C: /* 'BrtColInfo' */
				if(!opts.cellStyles) break;
				while(val.e >= val.s) {
					colinfo[val.e--] = { width: val.w/256, hidden: !!(val.flags & 0x01) };
					if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
					process_col(colinfo[val.e+1]);
				}
				break;

			case 0x00A1: /* 'BrtBeginAFilter' */
				s['!autofilter'] = { ref:encode_range(val) };
				break;

			case 0x01DC: /* 'BrtMargins' */
				s['!margins'] = val;
				break;

			case 0x0093: /* 'BrtWsProp' */
				if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
				if(val.name) wb.Sheets[idx].CodeName = val.name;
				break;

			case 0x0089: /* 'BrtBeginWsView' */
				if(!wb.Views) wb.Views = [{}];
				if(!wb.Views[0]) wb.Views[0] = {};
				if(val.RTL) wb.Views[0].RTL = true;
				break;

			case 0x01E5: /* 'BrtWsFmtInfo' */
				break;
			case 0x00AF: /* 'BrtAFilterDateGroupItem' */
			case 0x0284: /* 'BrtActiveX' */
			case 0x0271: /* 'BrtBigName' */
			case 0x0232: /* 'BrtBkHim' */
			case 0x018C: /* 'BrtBrk' */
			case 0x0458: /* 'BrtCFIcon' */
			case 0x047A: /* 'BrtCFRuleExt' */
			case 0x01D7: /* 'BrtCFVO' */
			case 0x041A: /* 'BrtCFVO14' */
			case 0x0289: /* 'BrtCellIgnoreEC' */
			case 0x0451: /* 'BrtCellIgnoreEC14' */
			case 0x0031: /* 'BrtCellMeta' */
			case 0x024D: /* 'BrtCellSmartTagProperty' */
			case 0x025F: /* 'BrtCellWatch' */
			case 0x0234: /* 'BrtColor' */
			case 0x041F: /* 'BrtColor14' */
			case 0x00A8: /* 'BrtColorFilter' */
			case 0x00AE: /* 'BrtCustomFilter' */
			case 0x049C: /* 'BrtCustomFilter14' */
			case 0x01F3: /* 'BrtDRef' */
			case 0x0040: /* 'BrtDVal' */
			case 0x041D: /* 'BrtDVal14' */
			case 0x0226: /* 'BrtDrawing' */
			case 0x00AB: /* 'BrtDynamicFilter' */
			case 0x00A7: /* 'BrtFilter' */
			case 0x0499: /* 'BrtFilter14' */
			case 0x00A9: /* 'BrtIconFilter' */
			case 0x049D: /* 'BrtIconFilter14' */
			case 0x0227: /* 'BrtLegacyDrawing' */
			case 0x0228: /* 'BrtLegacyDrawingHF' */
			case 0x0295: /* 'BrtListPart' */
			case 0x027F: /* 'BrtOleObject' */
			case 0x01DE: /* 'BrtPageSetup' */
			case 0x0097: /* 'BrtPane' */
			case 0x0219: /* 'BrtPhoneticInfo' */
			case 0x01DD: /* 'BrtPrintOptions' */
			case 0x0218: /* 'BrtRangeProtection' */
			case 0x044F: /* 'BrtRangeProtection14' */
			case 0x02A8: /* 'BrtRangeProtectionIso' */
			case 0x0450: /* 'BrtRangeProtectionIso14' */
			case 0x0400: /* 'BrtRwDescent' */
			case 0x0098: /* 'BrtSel' */
			case 0x0297: /* 'BrtSheetCalcProp' */
			case 0x0217: /* 'BrtSheetProtection' */
			case 0x02A6: /* 'BrtSheetProtectionIso' */
			case 0x01F8: /* 'BrtSlc' */
			case 0x0413: /* 'BrtSparkline' */
			case 0x01AC: /* 'BrtTable' */
			case 0x00AA: /* 'BrtTop10Filter' */
			case 0x0C00: /* 'BrtUid' */
			case 0x0032: /* 'BrtValueMeta' */
			case 0x0816: /* 'BrtWebExtension' */
			case 0x0415: /* 'BrtWsFmtInfoEx14' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */ break;
			case 0x0026: /* 'BrtACEnd' */ break;

			default:
				if((R_n||"").indexOf("Begin") > 0){/* empty */}
				else if((R_n||"").indexOf("End") > 0){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	}, opts);

	delete opts.supbooks;
	delete opts['!row'];

	if(!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = encode_range(ref || refguess);
	if(opts.sheetRows && s["!ref"]) {
		var tmpref = safe_decode_range(s["!ref"]);
		if(opts.sheetRows <= +tmpref.e.r) {
			tmpref.e.r = opts.sheetRows - 1;
			if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
			if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
			if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
			if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
			s["!fullref"] = s["!ref"];
			s["!ref"] = encode_range(tmpref);
		}
	}
	if(merges.length > 0) s["!merges"] = merges;
	if(colinfo.length > 0) s["!cols"] = colinfo;
	if(rowinfo.length > 0) s["!rows"] = rowinfo;
	return s;
}

/* TODO: something useful -- this is a stub */
function write_ws_bin_cell(ba, cell, R, C, opts, ws) {
	if(cell.v === undefined) return "";
	var vv = "";
	switch(cell.t) {
		case 'b': vv = cell.v ? "1" : "0"; break;
		case 'd': // no BrtCellDate :(
			cell = dup(cell);
			cell.z = cell.z || SSF._table[14];
			cell.v = datenum(parseDate(cell.v)); cell.t = 'n';
			break;
		/* falls through */
		case 'n': case 'e': vv = ''+cell.v; break;
		default: vv = cell.v; break;
	}
	var o = ({r:R, c:C});
	/* TODO: cell style */
	o.s = get_cell_style(opts.cellXfs, cell, opts);
	if(cell.l) ws['!links'].push([encode_cell(o), cell.l]);
	if(cell.c) ws['!comments'].push([encode_cell(o), cell.c]);
	switch(cell.t) {
		case 's': case 'str':
			if(opts.bookSST) {
				vv = get_sst_id(opts.Strings, (cell.v), opts.revStrings);
				o.t = "s"; o.v = vv;
				write_record(ba, "BrtCellIsst", write_BrtCellIsst(cell, o));
			} else {
				o.t = "str";
				write_record(ba, "BrtCellSt", write_BrtCellSt(cell, o));
			}
			return;
		case 'n':
			/* TODO: determine threshold for Real vs RK */
			if(cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) write_record(ba, "BrtCellRk", write_BrtCellRk(cell, o));
			else write_record(ba, "BrtCellReal", write_BrtCellReal(cell, o));
			return;
		case 'b':
			o.t = "b";
			write_record(ba, "BrtCellBool", write_BrtCellBool(cell, o));
			return;
		case 'e': /* TODO: error */ o.t = "e"; break;
	}
	write_record(ba, "BrtCellBlank", write_BrtCellBlank(cell, o));
}

function write_CELLTABLE(ba, ws, idx, opts) {
	var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
	write_record(ba, 'BrtBeginSheetData');
	var dense = Array.isArray(ws);
	var cap = range.e.r;
	if(ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
	for(var R = range.s.r; R <= cap; ++R) {
		rr = encode_row(R);
		/* [ACCELLTABLE] */
		/* BrtRowHdr */
		write_row_header(ba, ws, range, R);
		if(R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C) {
			/* *16384CELL */
			if(R === range.s.r) cols[C] = encode_col(C);
			ref = cols[C] + rr;
			var cell = dense ? (ws[R]||[])[C] : ws[ref];
			if(!cell) continue;
			/* write cell */
			write_ws_bin_cell(ba, cell, R, C, opts, ws);
		}
	}
	write_record(ba, 'BrtEndSheetData');
}

function write_MERGECELLS(ba, ws) {
	if(!ws || !ws['!merges']) return;
	write_record(ba, 'BrtBeginMergeCells', write_BrtBeginMergeCells(ws['!merges'].length));
	ws['!merges'].forEach(function(m) { write_record(ba, 'BrtMergeCell', write_BrtMergeCell(m)); });
	write_record(ba, 'BrtEndMergeCells');
}

function write_COLINFOS(ba, ws) {
	if(!ws || !ws['!cols']) return;
	write_record(ba, 'BrtBeginColInfos');
	ws['!cols'].forEach(function(m, i) { if(m) write_record(ba, 'BrtColInfo', write_BrtColInfo(i, m)); });
	write_record(ba, 'BrtEndColInfos');
}

function write_IGNOREECS(ba, ws) {
	if(!ws || !ws['!ref']) return;
	write_record(ba, 'BrtBeginCellIgnoreECs');
	write_record(ba, 'BrtCellIgnoreEC', write_BrtCellIgnoreEC(safe_decode_range(ws['!ref'])));
	write_record(ba, 'BrtEndCellIgnoreECs');
}

function write_HLINKS(ba, ws, rels) {
	/* *BrtHLink */
	ws['!links'].forEach(function(l) {
		if(!l[1].Target) return;
		var rId = add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), RELS.HLINK);
		write_record(ba, "BrtHLink", write_BrtHLink(l, rId));
	});
	delete ws['!links'];
}
function write_LEGACYDRAWING(ba, ws, idx, rels) {
	/* [BrtLegacyDrawing] */
	if(ws['!comments'].length > 0) {
		var rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
		write_record(ba, "BrtLegacyDrawing", write_RelID("rId" + rId));
		ws['!legacy'] = rId;
	}
}

function write_AUTOFILTER(ba, ws) {
	if(!ws['!autofilter']) return;
	write_record(ba, "BrtBeginAFilter", write_UncheckedRfX(safe_decode_range(ws['!autofilter'].ref)));
	/* *FILTERCOLUMN */
	/* [SORTSTATE] */
	/* BrtEndAFilter */
	write_record(ba, "BrtEndAFilter");
}

function write_WSVIEWS2(ba, ws, Workbook) {
	write_record(ba, "BrtBeginWsViews");
	{ /* 1*WSVIEW2 */
		/* [ACUID] */
		write_record(ba, "BrtBeginWsView", write_BrtBeginWsView(ws, Workbook));
		/* [BrtPane] */
		/* *4BrtSel */
		/* *4SXSELECT */
		/* *FRT */
		write_record(ba, "BrtEndWsView");
	}
	/* *FRT */
	write_record(ba, "BrtEndWsViews");
}

function write_WSFMTINFO() {
	/* [ACWSFMTINFO] */
	//write_record(ba, "BrtWsFmtInfo", write_BrtWsFmtInfo(ws));
}

function write_SHEETPROTECT(ba, ws) {
	if(!ws['!protect']) return;
	/* [BrtSheetProtectionIso] */
	write_record(ba, "BrtSheetProtection", write_BrtSheetProtection(ws['!protect']));
}

function write_ws_bin(idx, opts, wb, rels) {
	var ba = buf_array();
	var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
	var c = s; try { if(wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c; } catch(e) {}
	var r = safe_decode_range(ws['!ref'] || "A1");
	if(r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
		if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
		r.e.c = Math.min(r.e.c, 0x3FFF);
		r.e.r = Math.min(r.e.c, 0xFFFFF);
	}
	ws['!links'] = [];
	/* passed back to write_zip and removed there */
	ws['!comments'] = [];
	write_record(ba, "BrtBeginSheet");
	if(wb.vbaraw) write_record(ba, "BrtWsProp", write_BrtWsProp(c));
	write_record(ba, "BrtWsDim", write_BrtWsDim(r));
	write_WSVIEWS2(ba, ws, wb.Workbook);
	write_WSFMTINFO(ba, ws);
	write_COLINFOS(ba, ws, idx, opts, wb);
	write_CELLTABLE(ba, ws, idx, opts, wb);
	/* [BrtSheetCalcProp] */
	write_SHEETPROTECT(ba, ws);
	/* *([BrtRangeProtectionIso] BrtRangeProtection) */
	/* [SCENMAN] */
	write_AUTOFILTER(ba, ws);
	/* [SORTSTATE] */
	/* [DCON] */
	/* [USERSHVIEWS] */
	write_MERGECELLS(ba, ws);
	/* [BrtPhoneticInfo] */
	/* *CONDITIONALFORMATTING */
	/* [DVALS] */
	write_HLINKS(ba, ws, rels);
	/* [BrtPrintOptions] */
	if(ws['!margins']) write_record(ba, "BrtMargins", write_BrtMargins(ws['!margins']));
	/* [BrtPageSetup] */
	/* [HEADERFOOTER] */
	/* [RWBRK] */
	/* [COLBRK] */
	/* *BrtBigName */
	/* [CELLWATCHES] */
	if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) write_IGNOREECS(ba, ws);
	/* [SMARTTAGS] */
	/* [BrtDrawing] */
	write_LEGACYDRAWING(ba, ws, idx, rels);
	/* [BrtLegacyDrawingHF] */
	/* [BrtBkHim] */
	/* [OLEOBJECTS] */
	/* [ACTIVEXCONTROLS] */
	/* [WEBPUBITEMS] */
	/* [LISTPARTS] */
	/* FRTWORKSHEET */
	write_record(ba, "BrtEndSheet");
	return ba.end();
}
function parse_numCache(data) {
	var col = [];

	/* 21.2.2.150 pt CT_NumVal */
	(data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg)||[]).forEach(function(pt) {
		var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
		if(!q) return;
		col[+q[1]] = +q[2];
	});

	/* 21.2.2.71 formatCode CT_Xstring */
	var nf = unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["","General"])[1]);

	return [col, nf];
}

/* 21.2 DrawingML - Charts */
function parse_chart(data, name, opts, rels, wb, csheet) {
	var cs = ((csheet || {"!type":"chart"}));
	if(!data) return csheet;
	/* 21.2.2.27 chart CT_Chart */

	var C = 0, R = 0, col = "A";
	var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };

	/* 21.2.2.120 numCache CT_NumData */
	(data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(nc) {
		var cache = parse_numCache(nc);
		refguess.s.r = refguess.s.c = 0;
		refguess.e.c = C;
		col = encode_col(C);
		cache[0].forEach(function(n,i) {
			cs[col + encode_row(i)] = {t:'n', v:n, z:cache[1] };
			R = i;
		});
		if(refguess.e.r < R) refguess.e.r = R;
		++C;
	});
	if(C > 0) cs["!ref"] = encode_range(refguess);
	return cs;
}
RELS.CS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet";

var CS_XML_ROOT = writextag('chartsheet', null, {
	'xmlns': XMLNS.main[0],
	'xmlns:r': XMLNS.r
});

/* 18.3 Worksheets also covers Chartsheets */
function parse_cs_xml(data, opts, idx, rels, wb) {
	if(!data) return data;
	/* 18.3.1.12 chartsheet CT_ChartSheet */
	if(!rels) rels = {'!id':{}};
	var s = {'!type':"chart", '!chart':null, '!rel':""};
	var m;

	/* 18.3.1.83 sheetPr CT_ChartsheetPr */
	var sheetPr = data.match(sheetprregex);
	if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);

	/* 18.3.1.36 drawing CT_Drawing */
	if((m = data.match(/drawing r:id="(.*?)"/))) s['!rel'] = m[1];

	if(rels['!id'][s['!rel']]) s['!chart'] = rels['!id'][s['!rel']];
	return s;
}
function write_cs_xml(idx, opts, wb, rels) {
	var o = [XML_HEADER, CS_XML_ROOT];
	o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
	add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
	if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}

/* [MS-XLSB] 2.4.331 BrtCsProp */
function parse_BrtCsProp(data, length) {
	data.l += 10;
	var name = parse_XLWideString(data, length - 10);
	return { name: name };
}

/* [MS-XLSB] 2.1.7.7 Chart Sheet */
function parse_cs_bin(data, opts, idx, rels, wb) {
	if(!data) return data;
	if(!rels) rels = {'!id':{}};
	var s = {'!type':"chart", '!chart':null, '!rel':""};
	var state = [];
	var pass = false;
	recordhopper(data, function cs_parse(val, R_n, RT) {
		switch(RT) {

			case 0x0226: /* 'BrtDrawing' */
				s['!rel'] = val; break;

			case 0x028B: /* 'BrtCsProp' */
				if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
				if(val.name) wb.Sheets[idx].CodeName = val.name;
				break;

			case 0x0232: /* 'BrtBkHim' */
			case 0x028C: /* 'BrtCsPageSetup' */
			case 0x029D: /* 'BrtCsProtection' */
			case 0x02A7: /* 'BrtCsProtectionIso' */
			case 0x0227: /* 'BrtLegacyDrawing' */
			case 0x0228: /* 'BrtLegacyDrawingHF' */
			case 0x01DC: /* 'BrtMargins' */
			case 0x0C00: /* 'BrtUid' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */
				state.push(R_n); break;
			case 0x0026: /* 'BrtACEnd' */
				state.pop(); break;

			default:
				if((R_n||"").indexOf("Begin") > 0) state.push(R_n);
				else if((R_n||"").indexOf("End") > 0) state.pop();
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	}, opts);

	if(rels['!id'][s['!rel']]) s['!chart'] = rels['!id'][s['!rel']];
	return s;
}
function write_cs_bin() {
	var ba = buf_array();
	write_record(ba, "BrtBeginSheet");
	/* [BrtCsProp] */
	/* CSVIEWS */
	/* [[BrtCsProtectionIso] BrtCsProtection] */
	/* [USERCSVIEWS] */
	/* [BrtMargins] */
	/* [BrtCsPageSetup] */
	/* [HEADERFOOTER] */
	/* BrtDrawing */
	/* [BrtLegacyDrawing] */
	/* [BrtLegacyDrawingHF] */
	/* [BrtBkHim] */
	/* [WEBPUBITEMS] */
	/* FRTCHARTSHEET */
	write_record(ba, "BrtEndSheet");
	return ba.end();
}
/* 18.2.28 (CT_WorkbookProtection) Defaults */
var WBPropsDef = [
	['allowRefreshQuery',           false, "bool"],
	['autoCompressPictures',        true,  "bool"],
	['backupFile',                  false, "bool"],
	['checkCompatibility',          false, "bool"],
	['CodeName',                    ''],
	['date1904',                    false, "bool"],
	['defaultThemeVersion',         0,      "int"],
	['filterPrivacy',               false, "bool"],
	['hidePivotFieldList',          false, "bool"],
	['promptedSolutions',           false, "bool"],
	['publishItems',                false, "bool"],
	['refreshAllConnections',       false, "bool"],
	['saveExternalLinkValues',      true,  "bool"],
	['showBorderUnselectedTables',  true,  "bool"],
	['showInkAnnotation',           true,  "bool"],
	['showObjects',                 'all'],
	['showPivotChartFilter',        false, "bool"],
	['updateLinks', 'userSet']
];

/* 18.2.30 (CT_BookView) Defaults */
var WBViewDef = [
	['activeTab',                   0,      "int"],
	['autoFilterDateGrouping',      true,  "bool"],
	['firstSheet',                  0,      "int"],
	['minimized',                   false, "bool"],
	['showHorizontalScroll',        true,  "bool"],
	['showSheetTabs',               true,  "bool"],
	['showVerticalScroll',          true,  "bool"],
	['tabRatio',                    600,    "int"],
	['visibility',                  'visible']
	//window{Height,Width}, {x,y}Window
];

/* 18.2.19 (CT_Sheet) Defaults */
var SheetDef = [
	//['state', 'visible']
];

/* 18.2.2  (CT_CalcPr) Defaults */
var CalcPrDef = [
	['calcCompleted', 'true'],
	['calcMode', 'auto'],
	['calcOnSave', 'true'],
	['concurrentCalc', 'true'],
	['fullCalcOnLoad', 'false'],
	['fullPrecision', 'true'],
	['iterate', 'false'],
	['iterateCount', '100'],
	['iterateDelta', '0.001'],
	['refMode', 'A1']
];

/* 18.2.3 (CT_CustomWorkbookView) Defaults */
/*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/

function push_defaults_array(target, defaults) {
	for(var j = 0; j != target.length; ++j) { var w = target[j];
		for(var i=0; i != defaults.length; ++i) { var z = defaults[i];
			if(w[z[0]] == null) w[z[0]] = z[1];
			else switch(z[2]) {
			case "bool": if(typeof w[z[0]] == "string") w[z[0]] = parsexmlbool(w[z[0]]); break;
			case "int": if(typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10); break;
			}
		}
	}
}
function push_defaults(target, defaults) {
	for(var i = 0; i != defaults.length; ++i) { var z = defaults[i];
		if(target[z[0]] == null) target[z[0]] = z[1];
		else switch(z[2]) {
			case "bool": if(typeof target[z[0]] == "string") target[z[0]] = parsexmlbool(target[z[0]]); break;
			case "int": if(typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10); break;
		}
	}
}

function parse_wb_defaults(wb) {
	push_defaults(wb.WBProps, WBPropsDef);
	push_defaults(wb.CalcPr, CalcPrDef);

	push_defaults_array(wb.WBView, WBViewDef);
	push_defaults_array(wb.Sheets, SheetDef);

	_ssfopts.date1904 = parsexmlbool(wb.WBProps.date1904);
}

function safe1904(wb) {
	/* TODO: store date1904 somewhere else */
	if(!wb.Workbook) return "false";
	if(!wb.Workbook.WBProps) return "false";
	return parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}

var badchars = "][*?\/\\".split("");
function check_ws_name(n, safe) {
	if(n.length > 31) { if(safe) return false; throw new Error("Sheet names cannot exceed 31 chars"); }
	var _good = true;
	badchars.forEach(function(c) {
		if(n.indexOf(c) == -1) return;
		if(!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
		_good = false;
	});
	return _good;
}
function check_wb_names(N, S, codes) {
	N.forEach(function(n,i) {
		check_ws_name(n);
		for(var j = 0; j < i; ++j) if(n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
		if(codes) {
			var cn = (S && S[i] && S[i].CodeName) || n;
			if(cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
		}
	});
}
function check_wb(wb) {
	if(!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
	if(!wb.SheetNames.length) throw new Error("Workbook is empty");
	var Sheets = (wb.Workbook && wb.Workbook.Sheets) || [];
	check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
	for(var i = 0; i < wb.SheetNames.length; ++i) check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
	/* TODO: validate workbook */
}
/* 18.2 Workbook */
var wbnsregex = /<\w+:workbook/;
function parse_wb_xml(data, opts) {
	if(!data) throw new Error("Could not find file");
	var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, Names:[], xmlns: "" };
	var pass = false, xmlns = "xmlns";
	var dname = {}, dnstart = 0;
	data.replace(tagregex, function xml_wb(x, idx) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<?xml': break;

			/* 18.2.27 workbook CT_Workbook 1 */
			case '<workbook':
				if(x.match(wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
				wb.xmlns = y[xmlns];
				break;
			case '</workbook>': break;

			/* 18.2.13 fileVersion CT_FileVersion ? */
			case '<fileVersion': delete y[0]; wb.AppVersion = y; break;
			case '<fileVersion/>': case '</fileVersion>': break;

			/* 18.2.12 fileSharing CT_FileSharing ? */
			case '<fileSharing': case '<fileSharing/>': break;

			/* 18.2.28 workbookPr CT_WorkbookPr ? */
			case '<workbookPr':
			case '<workbookPr/>':
				WBPropsDef.forEach(function(w) {
					if(y[w[0]] == null) return;
					switch(w[2]) {
						case "bool": wb.WBProps[w[0]] = parsexmlbool(y[w[0]]); break;
						case "int": wb.WBProps[w[0]] = parseInt(y[w[0]], 10); break;
						default: wb.WBProps[w[0]] = y[w[0]];
					}
				});
				if(y.codeName) wb.WBProps.CodeName = y.codeName;
				break;
			case '</workbookPr>': break;

			/* 18.2.29 workbookProtection CT_WorkbookProtection ? */
			case '<workbookProtection': break;
			case '<workbookProtection/>': break;

			/* 18.2.1  bookViews CT_BookViews ? */
			case '<bookViews': case '<bookViews>': case '</bookViews>': break;
			/* 18.2.30   workbookView CT_BookView + */
			case '<workbookView': case '<workbookView/>': delete y[0]; wb.WBView.push(y); break;
			case '</workbookView>': break;

			/* 18.2.20 sheets CT_Sheets 1 */
			case '<sheets': case '<sheets>': case '</sheets>': break; // aggregate sheet
			/* 18.2.19   sheet CT_Sheet + */
			case '<sheet':
				switch(y.state) {
					case "hidden": y.Hidden = 1; break;
					case "veryHidden": y.Hidden = 2; break;
					default: y.Hidden = 0;
				}
				delete y.state;
				y.name = unescapexml(utf8read(y.name));
				delete y[0]; wb.Sheets.push(y); break;
			case '</sheet>': break;

			/* 18.2.15 functionGroups CT_FunctionGroups ? */
			case '<functionGroups': case '<functionGroups/>': break;
			/* 18.2.14   functionGroup CT_FunctionGroup + */
			case '<functionGroup': break;

			/* 18.2.9  externalReferences CT_ExternalReferences ? */
			case '<externalReferences': case '</externalReferences>': case '<externalReferences>': break;
			/* 18.2.8    externalReference CT_ExternalReference + */
			case '<externalReference': break;

			/* 18.2.6  definedNames CT_DefinedNames ? */
			case '<definedNames/>': break;
			case '<definedNames>': case '<definedNames': pass=true; break;
			case '</definedNames>': pass=false; break;
			/* 18.2.5    definedName CT_DefinedName + */
			case '<definedName': {
				dname = {};
				dname.Name = utf8read(y.name);
				if(y.comment) dname.Comment = y.comment;
				if(y.localSheetId) dname.Sheet = +y.localSheetId;
				dnstart = idx + x.length;
			}	break;
			case '</definedName>': {
				dname.Ref = unescapexml(utf8read(data.slice(dnstart, idx)));
				wb.Names.push(dname);
			} break;
			case '<definedName/>': break;

			/* 18.2.2  calcPr CT_CalcPr ? */
			case '<calcPr': delete y[0]; wb.CalcPr = y; break;
			case '<calcPr/>': delete y[0]; wb.CalcPr = y; break;
			case '</calcPr>': break;

			/* 18.2.16 oleSize CT_OleSize ? (ref required) */
			case '<oleSize': break;

			/* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */
			case '<customWorkbookViews>': case '</customWorkbookViews>': case '<customWorkbookViews': break;
			/* 18.2.3    customWorkbookView CT_CustomWorkbookView + */
			case '<customWorkbookView': case '</customWorkbookView>': break;

			/* 18.2.18 pivotCaches CT_PivotCaches ? */
			case '<pivotCaches>': case '</pivotCaches>': case '<pivotCaches': break;
			/* 18.2.17 pivotCache CT_PivotCache ? */
			case '<pivotCache': break;

			/* 18.2.21 smartTagPr CT_SmartTagPr ? */
			case '<smartTagPr': case '<smartTagPr/>': break;

			/* 18.2.23 smartTagTypes CT_SmartTagTypes ? */
			case '<smartTagTypes': case '<smartTagTypes>': case '</smartTagTypes>': break;
			/* 18.2.22   smartTagType CT_SmartTagType ? */
			case '<smartTagType': break;

			/* 18.2.24 webPublishing CT_WebPublishing ? */
			case '<webPublishing': case '<webPublishing/>': break;

			/* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */
			case '<fileRecoveryPr': case '<fileRecoveryPr/>': break;

			/* 18.2.26 webPublishObjects CT_WebPublishObjects ? */
			case '<webPublishObjects>': case '<webPublishObjects': case '</webPublishObjects>': break;
			/* 18.2.25 webPublishObject CT_WebPublishObject ? */
			case '<webPublishObject': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
			/* 18.2.7    ext CT_Extension + */
			case '<ext': pass=true; break; //TODO: check with versions of excel
			case '</ext>': pass=false; break;

			/* Others */
			case '<ArchID': break;
			case '<AlternateContent':
			case '<AlternateContent>': pass=true; break;
			case '</AlternateContent>': pass=false; break;

			/* TODO */
			case '<revisionPtr': break;

			default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
		}
		return x;
	});
	if(XMLNS.main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);

	parse_wb_defaults(wb);

	return wb;
}

var WB_XML_ROOT = writextag('workbook', null, {
	'xmlns': XMLNS.main[0],
	//'xmlns:mx': XMLNS.mx,
	//'xmlns:s': XMLNS.main[0],
	'xmlns:r': XMLNS.r
});

function write_wb_xml(wb) {
	var o = [XML_HEADER];
	o[o.length] = WB_XML_ROOT;

	var write_names = (wb.Workbook && (wb.Workbook.Names||[]).length > 0);

	/* fileVersion */
	/* fileSharing */

	var workbookPr = ({codeName:"ThisWorkbook"});
	if(wb.Workbook && wb.Workbook.WBProps) {
		WBPropsDef.forEach(function(x) {
if((wb.Workbook.WBProps[x[0]]) == null) return;
			if((wb.Workbook.WBProps[x[0]]) == x[1]) return;
			workbookPr[x[0]] = (wb.Workbook.WBProps[x[0]]);
		});
if(wb.Workbook.WBProps.CodeName) { workbookPr.codeName = wb.Workbook.WBProps.CodeName; delete workbookPr.CodeName; }
	}
	o[o.length] = (writextag('workbookPr', null, workbookPr));

	/* workbookProtection */
	/* bookViews */

	o[o.length] = "<sheets>";
	var sheets = wb.Workbook && wb.Workbook.Sheets || [];
	for(var i = 0; i != wb.SheetNames.length; ++i) {
		var sht = ({name:escapexml(wb.SheetNames[i].slice(0,31))});
		sht.sheetId = ""+(i+1);
		sht["r:id"] = "rId"+(i+1);
		if(sheets[i]) switch(sheets[i].Hidden) {
			case 1: sht.state = "hidden"; break;
			case 2: sht.state = "veryHidden"; break;
		}
		o[o.length] = (writextag('sheet',null,sht));
	}
	o[o.length] = "</sheets>";

	/* functionGroups */
	/* externalReferences */

	if(write_names) {
		o[o.length] = "<definedNames>";
		if(wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
			var d = {name:n.Name};
			if(n.Comment) d.comment = n.Comment;
			if(n.Sheet != null) d.localSheetId = ""+n.Sheet;
			if(!n.Ref) return;
			o[o.length] = writextag('definedName', String(n.Ref), d);
		});
		o[o.length] = "</definedNames>";
	}

	/* calcPr */
	/* oleSize */
	/* customWorkbookViews */
	/* pivotCaches */
	/* smartTagPr */
	/* smartTagTypes */
	/* webPublishing */
	/* fileRecoveryPr */
	/* webPublishObjects */
	/* extLst */

	if(o.length>2){ o[o.length] = '</workbook>'; o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */
function parse_BrtBundleSh(data, length) {
	var z = {};
	z.Hidden = data.read_shift(4); //hsState ST_SheetState
	z.iTabID = data.read_shift(4);
	z.strRelID = parse_RelID(data,length-8);
	z.name = parse_XLWideString(data);
	return z;
}
function write_BrtBundleSh(data, o) {
	if(!o) o = new_buf(127);
	o.write_shift(4, data.Hidden);
	o.write_shift(4, data.iTabID);
	write_RelID(data.strRelID, o);
	write_XLWideString(data.name.slice(0,31), o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.815 BrtWbProp */
function parse_BrtWbProp(data, length) {
	var o = ({});
	var flags = data.read_shift(4);
	o.defaultThemeVersion = data.read_shift(4);
	var strName = (length > 8) ? parse_XLWideString(data) : "";
	if(strName.length > 0) o.CodeName = strName;
	o.autoCompressPictures = !!(flags & 0x10000);
	o.backupFile = !!(flags & 0x40);
	o.checkCompatibility = !!(flags & 0x1000);
	o.date1904 = !!(flags & 0x01);
	o.filterPrivacy = !!(flags & 0x08);
	o.hidePivotFieldList = !!(flags & 0x400);
	o.promptedSolutions = !!(flags & 0x10);
	o.publishItems = !!(flags & 0x800);
	o.refreshAllConnections = !!(flags & 0x40000);
	o.saveExternalLinkValues = !!(flags & 0x80);
	o.showBorderUnselectedTables = !!(flags & 0x04);
	o.showInkAnnotation = !!(flags & 0x20);
	o.showObjects = ["all", "placeholders", "none"][(flags >> 13) & 0x03];
	o.showPivotChartFilter = !!(flags & 0x8000);
	o.updateLinks = ["userSet", "never", "always"][(flags >> 8) & 0x03];
	return o;
}
function write_BrtWbProp(data, o) {
	if(!o) o = new_buf(72);
	var flags = 0;
	if(data) {
		/* TODO: mirror parse_BrtWbProp fields */
		if(data.filterPrivacy) flags |= 0x08;
	}
	o.write_shift(4, flags);
	o.write_shift(4, 0);
	write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
	return o.slice(0, o.l);
}

function parse_BrtFRTArchID$(data, length) {
	var o = {};
	data.read_shift(4);
	o.ArchID = data.read_shift(4);
	data.l += length - 8;
	return o;
}

/* [MS-XLSB] 2.4.687 BrtName */
function parse_BrtName(data, length, opts) {
	var end = data.l + length;
	data.l += 4; //var flags = data.read_shift(4);
	data.l += 1; //var chKey = data.read_shift(1);
	var itab = data.read_shift(4);
	var name = parse_XLNameWideString(data);
	var formula = parse_XLSBNameParsedFormula(data, 0, opts);
	var comment = parse_XLNullableWideString(data);
	//if(0 /* fProc */) {
		// unusedstring1: XLNullableWideString
		// description: XLNullableWideString
		// helpTopic: XLNullableWideString
		// unusedstring2: XLNullableWideString
	//}
	data.l = end;
	var out = ({Name:name, Ptg:formula});
	if(itab < 0xFFFFFFF) out.Sheet = itab;
	if(comment) out.Comment = comment;
	return out;
}

/* [MS-XLSB] 2.1.7.61 Workbook */
function parse_wb_bin(data, opts) {
	var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, xmlns: "" };
	var pass = false;

	if(!opts) opts = {};
	opts.biff = 12;

	var Names = [];
	var supbooks = ([[]]);
	supbooks.SheetNames = [];
	supbooks.XTI = [];

	recordhopper(data, function hopper_wb(val, R_n, RT) {
		switch(RT) {
			case 0x009C: /* 'BrtBundleSh' */
				supbooks.SheetNames.push(val.name);
				wb.Sheets.push(val); break;

			case 0x0099: /* 'BrtWbProp' */
				wb.WBProps = val; break;

			case 0x0027: /* 'BrtName' */
				if(val.Sheet != null) opts.SID = val.Sheet;
				val.Ref = stringify_formula(val.Ptg, null, null, supbooks, opts);
				delete opts.SID;
				delete val.Ptg;
				Names.push(val);
				break;
			case 0x040C: /* 'BrtNameExt' */ break;

			case 0x0165: /* 'BrtSupSelf' */
			case 0x0166: /* 'BrtSupSame' */
			case 0x0163: /* 'BrtSupBookSrc' */
			case 0x029B: /* 'BrtSupAddin' */
				if(!supbooks[0].length) supbooks[0] = [RT, val];
				else supbooks.push([RT, val]);
				supbooks[supbooks.length - 1].XTI = [];
				break;
			case 0x016A: /* 'BrtExternSheet' */
				if(supbooks.length === 0) { supbooks[0] = []; supbooks[0].XTI = []; }
				supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
				supbooks.XTI = supbooks.XTI.concat(val);
				break;
			case 0x0169: /* 'BrtPlaceholderName' */
				break;

			/* case 'BrtModelTimeGroupingCalcCol' */
			case 0x0C00: /* 'BrtUid' */
			case 0x0C01: /* 'BrtRevisionPtr' */
			case 0x0817: /* 'BrtAbsPath15' */
			case 0x0216: /* 'BrtBookProtection' */
			case 0x02A5: /* 'BrtBookProtectionIso' */
			case 0x009E: /* 'BrtBookView' */
			case 0x009D: /* 'BrtCalcProp' */
			case 0x0262: /* 'BrtCrashRecErr' */
			case 0x0802: /* 'BrtDecoupledPivotCacheID' */
			case 0x009B: /* 'BrtFileRecover' */
			case 0x0224: /* 'BrtFileSharing' */
			case 0x02A4: /* 'BrtFileSharingIso' */
			case 0x0080: /* 'BrtFileVersion' */
			case 0x0299: /* 'BrtFnGroup' */
			case 0x0850: /* 'BrtModelRelationship' */
			case 0x084D: /* 'BrtModelTable' */
			case 0x0225: /* 'BrtOleSize' */
			case 0x0805: /* 'BrtPivotTableRef' */
			case 0x0254: /* 'BrtSmartTagType' */
			case 0x081C: /* 'BrtTableSlicerCacheID' */
			case 0x081B: /* 'BrtTableSlicerCacheIDs' */
			case 0x0822: /* 'BrtTimelineCachePivotCacheID' */
			case 0x018D: /* 'BrtUserBookView' */
			case 0x009A: /* 'BrtWbFactoid' */
			case 0x045D: /* 'BrtWbProp14' */
			case 0x0229: /* 'BrtWebOpt' */
			case 0x082B: /* 'BrtWorkBookPr15' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */ break;
			case 0x0026: /* 'BrtACEnd' */ break;

			case 0x0010: /* 'BrtFRTArchID$' */ break;

			default:
				if((R_n||"").indexOf("Begin") > 0){/* empty */}
				else if((R_n||"").indexOf("End") > 0){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	}, opts);

	parse_wb_defaults(wb);

	// $FlowIgnore
	wb.Names = Names;

	(wb).supbooks = supbooks;
	return wb;
}

function write_BUNDLESHS(ba, wb) {
	write_record(ba, "BrtBeginBundleShs");
	for(var idx = 0; idx != wb.SheetNames.length; ++idx) {
		var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
		var d = { Hidden: viz, iTabID: idx+1, strRelID: 'rId' + (idx+1), name: wb.SheetNames[idx] };
		write_record(ba, "BrtBundleSh", write_BrtBundleSh(d));
	}
	write_record(ba, "BrtEndBundleShs");
}

/* [MS-XLSB] 2.4.649 BrtFileVersion */
function write_BrtFileVersion(data, o) {
	if(!o) o = new_buf(127);
	for(var i = 0; i != 4; ++i) o.write_shift(4, 0);
	write_XLWideString("SheetJS", o);
	write_XLWideString(XLSX.version, o);
	write_XLWideString(XLSX.version, o);
	write_XLWideString("7262", o);
	o.length = o.l;
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.301 BrtBookView */
function write_BrtBookView(idx, o) {
	if(!o) o = new_buf(29);
	o.write_shift(-4, 0);
	o.write_shift(-4, 460);
	o.write_shift(4,  28800);
	o.write_shift(4,  17600);
	o.write_shift(4,  500);
	o.write_shift(4,  idx);
	o.write_shift(4,  idx);
	var flags = 0x78;
	o.write_shift(1,  flags);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

function write_BOOKVIEWS(ba, wb) {
	/* required if hidden tab appears before visible tab */
	if(!wb.Workbook || !wb.Workbook.Sheets) return;
	var sheets = wb.Workbook.Sheets;
	var i = 0, vistab = -1, hidden = -1;
	for(; i < sheets.length; ++i) {
		if(!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
		else if(sheets[i].Hidden == 1 && hidden == -1) hidden = i;
	}
	if(hidden > vistab) return;
	write_record(ba, "BrtBeginBookViews");
	write_record(ba, "BrtBookView", write_BrtBookView(vistab));
	/* 1*(BrtBookView *FRT) */
	write_record(ba, "BrtEndBookViews");
}

/* [MS-XLSB] 2.4.305 BrtCalcProp */
/*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/

/* [MS-XLSB] 2.4.646 BrtFileRecover */
/*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/

/* [MS-XLSB] 2.1.7.61 Workbook */
function write_wb_bin(wb, opts) {
	var ba = buf_array();
	write_record(ba, "BrtBeginBook");
	write_record(ba, "BrtFileVersion", write_BrtFileVersion());
	/* [[BrtFileSharingIso] BrtFileSharing] */
	write_record(ba, "BrtWbProp", write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
	/* [ACABSPATH] */
	/* [[BrtBookProtectionIso] BrtBookProtection] */
	write_BOOKVIEWS(ba, wb, opts);
	write_BUNDLESHS(ba, wb, opts);
	/* [FNGROUP] */
	/* [EXTERNALS] */
	/* *BrtName */
	/* write_record(ba, "BrtCalcProp", write_BrtCalcProp()); */
	/* [BrtOleSize] */
	/* *(BrtUserBookView *FRT) */
	/* [PIVOTCACHEIDS] */
	/* [BrtWbFactoid] */
	/* [SMARTTAGTYPES] */
	/* [BrtWebOpt] */
	/* write_record(ba, "BrtFileRecover", write_BrtFileRecover()); */
	/* [WEBPUBITEMS] */
	/* [CRERRS] */
	/* FRTWORKBOOK */
	write_record(ba, "BrtEndBook");

	return ba.end();
}
function parse_wb(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_wb_bin((data), opts);
	return parse_wb_xml((data), opts);
}

function parse_ws(data, name, idx, opts, rels, wb, themes, styles) {
	if(name.slice(-4)===".bin") return parse_ws_bin((data), opts, idx, rels, wb, themes, styles);
	return parse_ws_xml((data), opts, idx, rels, wb, themes, styles);
}

function parse_cs(data, name, idx, opts, rels, wb, themes, styles) {
	if(name.slice(-4)===".bin") return parse_cs_bin((data), opts, idx, rels, wb, themes, styles);
	return parse_cs_xml((data), opts, idx, rels, wb, themes, styles);
}

function parse_ms(data, name, idx, opts, rels, wb, themes, styles) {
	if(name.slice(-4)===".bin") return parse_ms_bin((data), opts, idx, rels, wb, themes, styles);
	return parse_ms_xml((data), opts, idx, rels, wb, themes, styles);
}

function parse_ds(data, name, idx, opts, rels, wb, themes, styles) {
	if(name.slice(-4)===".bin") return parse_ds_bin((data), opts, idx, rels, wb, themes, styles);
	return parse_ds_xml((data), opts, idx, rels, wb, themes, styles);
}

function parse_sty(data, name, themes, opts) {
	if(name.slice(-4)===".bin") return parse_sty_bin((data), themes, opts);
	return parse_sty_xml((data), themes, opts);
}

function parse_theme(data, name, opts) {
	return parse_theme_xml(data, opts);
}

function parse_sst(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_sst_bin((data), opts);
	return parse_sst_xml((data), opts);
}

function parse_cmnt(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_comments_bin((data), opts);
	return parse_comments_xml((data), opts);
}

function parse_cc(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_cc_bin((data), name, opts);
	return parse_cc_xml((data), name, opts);
}

function parse_xlink(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_xlink_bin((data), name, opts);
	return parse_xlink_xml((data), name, opts);
}

function write_wb(wb, name, opts) {
	return (name.slice(-4)===".bin" ? write_wb_bin : write_wb_xml)(wb, opts);
}

function write_ws(data, name, opts, wb, rels) {
	return (name.slice(-4)===".bin" ? write_ws_bin : write_ws_xml)(data, opts, wb, rels);
}

// eslint-disable-next-line no-unused-vars
function write_cs(data, name, opts, wb, rels) {
	return (name.slice(-4)===".bin" ? write_cs_bin : write_cs_xml)(data, opts, wb, rels);
}

function write_sty(data, name, opts) {
	return (name.slice(-4)===".bin" ? write_sty_bin : write_sty_xml)(data, opts);
}

function write_sst(data, name, opts) {
	return (name.slice(-4)===".bin" ? write_sst_bin : write_sst_xml)(data, opts);
}

function write_cmnt(data, name, opts) {
	return (name.slice(-4)===".bin" ? write_comments_bin : write_comments_xml)(data, opts);
}
/*
function write_cc(data, name:string, opts) {
	return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
}
*/
var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
var _chr = function(c) { return String.fromCharCode(c); };
function xlml_parsexmltag(tag, skip_root) {
	var words = tag.split(/\s+/);
	var z = ([]); if(!skip_root) z[0] = words[0];
	if(words.length === 1) return z;
	var m = tag.match(attregexg2), y, j, w, i;
	if(m) for(i = 0; i != m.length; ++i) {
		y = m[i].match(attregex2);
if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
		else {
			if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
			else w = y[1].slice(j+1);
			z[w] = y[2].slice(1,y[2].length-1);
		}
	}
	return z;
}
function xlml_parsexmltagobj(tag) {
	var words = tag.split(/\s+/);
	var z = {};
	if(words.length === 1) return z;
	var m = tag.match(attregexg2), y, j, w, i;
	if(m) for(i = 0; i != m.length; ++i) {
		y = m[i].match(attregex2);
if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
		else {
			if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
			else w = y[1].slice(j+1);
			z[w] = y[2].slice(1,y[2].length-1);
		}
	}
	return z;
}

// ----

function xlml_format(format, value) {
	var fmt = XLMLFormatMap[format] || unescapexml(format);
	if(fmt === "General") return SSF._general(value);
	return SSF.format(fmt, value);
}

function xlml_set_custprop(Custprops, key, cp, val) {
	var oval = val;
	switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]) {
		case "boolean": oval = parsexmlbool(val); break;
		case "i2": case "int": oval = parseInt(val, 10); break;
		case "r4": case "float": oval = parseFloat(val); break;
		case "date": case "dateTime.tz": oval = parseDate(val); break;
		case "i8": case "string": case "fixed": case "uuid": case "bin.base64": break;
		default: throw new Error("bad custprop:" + cp[0]);
	}
	Custprops[unescapexml(key)] = oval;
}

function safe_format_xlml(cell, nf, o) {
	if(cell.t === 'z') return;
	if(!o || o.cellText !== false) try {
		if(cell.t === 'e') { cell.w = cell.w || BErr[cell.v]; }
		else if(nf === "General") {
			if(cell.t === 'n') {
				if((cell.v|0) === cell.v) cell.w = SSF._general_int(cell.v);
				else cell.w = SSF._general_num(cell.v);
			}
			else cell.w = SSF._general(cell.v);
		}
		else cell.w = xlml_format(nf||"General", cell.v);
	} catch(e) { if(o.WTF) throw e; }
	try {
		var z = XLMLFormatMap[nf]||nf||"General";
		if(o.cellNF) cell.z = z;
		if(o.cellDates && cell.t == 'n' && SSF.is_date(z)) {
			var _d = SSF.parse_date_code(cell.v); if(_d) { cell.t = 'd'; cell.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
		}
	} catch(e) { if(o.WTF) throw e; }
}

function process_style_xlml(styles, stag, opts) {
	if(opts.cellStyles) {
		if(stag.Interior) {
			var I = stag.Interior;
			if(I.Pattern) I.patternType = XLMLPatternTypeMap[I.Pattern] || I.Pattern;
		}
	}
	styles[stag.ID] = stag;
}

/* TODO: there must exist some form of OSP-blessed spec */
function parse_xlml_data(xml, ss, data, cell, base, styles, csty, row, arrayf, o) {
	var nf = "General", sid = cell.StyleID, S = {}; o = o || {};
	var interiors = [];
	var i = 0;
	if(sid === undefined && row) sid = row.StyleID;
	if(sid === undefined && csty) sid = csty.StyleID;
	while(styles[sid] !== undefined) {
		if(styles[sid].nf) nf = styles[sid].nf;
		if(styles[sid].Interior) interiors.push(styles[sid].Interior);
		if(!styles[sid].Parent) break;
		sid = styles[sid].Parent;
	}
	switch(data.Type) {
		case 'Boolean':
			cell.t = 'b';
			cell.v = parsexmlbool(xml);
			break;
		case 'String':
			cell.t = 's'; cell.r = xlml_fixstr(unescapexml(xml));
			cell.v = xml.indexOf("<") > -1 ? unescapexml(ss) : cell.r;
			break;
		case 'DateTime':
			if(xml.slice(-1) != "Z") xml += "Z";
			cell.v = (parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
			if(cell.v !== cell.v) cell.v = unescapexml(xml);
			else if(cell.v<60) cell.v = cell.v -1;
			if(!nf || nf == "General") nf = "yyyy-mm-dd";
			/* falls through */
		case 'Number':
			if(cell.v === undefined) cell.v=+xml;
			if(!cell.t) cell.t = 'n';
			break;
		case 'Error': cell.t = 'e'; cell.v = RBErr[xml]; if(o.cellText !== false) cell.w = xml; break;
		default: cell.t = 's'; cell.v = xlml_fixstr(ss||xml); break;
	}
	safe_format_xlml(cell, nf, o);
	if(o.cellFormula !== false) {
		if(cell.Formula) {
			var fstr = unescapexml(cell.Formula);
			/* strictly speaking, the leading = is required but some writers omit */
			if(fstr.charCodeAt(0) == 61 /* = */) fstr = fstr.slice(1);
			cell.f = rc_to_a1(fstr, base);
			delete cell.Formula;
			if(cell.ArrayRange == "RC") cell.F = rc_to_a1("RC:RC", base);
			else if(cell.ArrayRange) {
				cell.F = rc_to_a1(cell.ArrayRange, base);
				arrayf.push([safe_decode_range(cell.F), cell.F]);
			}
		} else {
			for(i = 0; i < arrayf.length; ++i)
				if(base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r)
					if(base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c)
						cell.F = arrayf[i][1];
		}
	}
	if(o.cellStyles) {
		interiors.forEach(function(x) {
			if(!S.patternType && x.patternType) S.patternType = x.patternType;
		});
		cell.s = S;
	}
	if(cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}

function xlml_clean_comment(comment) {
	comment.t = comment.v || "";
	comment.t = comment.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
	comment.v = comment.w = comment.ixfe = undefined;
}

function xlml_normalize(d) {
	if(has_buf && Buffer.isBuffer(d)) return d.toString('utf8');
	if(typeof d === 'string') return d;
	/* duktape */
	if(typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return utf8read(a2s(ab2a(d)));
	throw new Error("Bad input format: expected Buffer or string");
}

/* TODO: Everything */
/* UOS uses CJK in tags */
var xlmlregex = /<(\/?)([^\s?>!\/:]*:|)([^\s?>:\/]+)[^>]*>/mg;
//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
function parse_xlml_xml(d, _opts) {
	var opts = _opts || {};
	make_ssf(SSF);
	var str = debom(xlml_normalize(d));
	if(opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
		if(typeof cptable !== 'undefined') str = cptable.utils.decode(65001, char_codes(str));
		else str = utf8read(str);
	}
	var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
	if(opening.indexOf("<?xml") == -1) ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(tag) { if(opening.indexOf("<" + tag) >= 0) ishtml = true; });
	if(ishtml) return HTML_.to_workbook(str, opts);
	var Rn;
	var state = [], tmp;
	if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	var sheets = {}, sheetnames = [], cursheet = (opts.dense ? [] : {}), sheetname = "";
	var table = {}, cell = ({}), row = {};// eslint-disable-line no-unused-vars
	var dtag = xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
	var c = 0, r = 0;
	var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	var styles = {}, stag = {};
	var ss = "", fidx = 0;
	var merges = [];
	var Props = {}, Custprops = {}, pidx = 0, cp = [];
	var comments = [], comment = ({});
	var cstys = [], csty, seencol = false;
	var arrayf = [];
	var rowinfo = [], rowobj = {}, cc = 0, rr = 0;
	var Workbook = ({ Sheets:[], WBProps:{date1904:false} }), wsprops = {};
	xlmlregex.lastIndex = 0;
	str = str.replace(/<!--([\s\S]*?)-->/mg,"");
	while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
		case 'Data':
			if(state[state.length-1][1]) break;
			if(Rn[1]==='/') parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length-1][0]=="Comment"?comment:cell, {c:c,r:r}, styles, cstys[c], row, arrayf, opts);
			else { ss = ""; dtag = xlml_parsexmltag(Rn[0]); didx = Rn.index + Rn[0].length; }
			break;
		case 'Cell':
			if(Rn[1]==='/'){
				if(comments.length > 0) cell.c = comments;
				if((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) {
					if(opts.dense) {
						if(!cursheet[r]) cursheet[r] = [];
						cursheet[r][c] = cell;
					} else cursheet[encode_col(c) + encode_row(r)] = cell;
				}
				if(cell.HRef) {
					cell.l = ({Target:cell.HRef});
					if(cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
					delete cell.HRef; delete cell.HRefScreenTip;
				}
				if(cell.MergeAcross || cell.MergeDown) {
					cc = c + (parseInt(cell.MergeAcross,10)|0);
					rr = r + (parseInt(cell.MergeDown,10)|0);
					merges.push({s:{c:c,r:r},e:{c:cc,r:rr}});
				}
				if(!opts.sheetStubs) { if(cell.MergeAcross) c = cc + 1; else ++c; }
				else if(cell.MergeAcross || cell.MergeDown) {
for(var cma = c; cma <= cc; ++cma) {
						for(var cmd = r; cmd <= rr; ++cmd) {
							if(cma > c || cmd > r) {
								if(opts.dense) {
									if(!cursheet[cmd]) cursheet[cmd] = [];
									cursheet[cmd][cma] = {t:'z'};
								} else cursheet[encode_col(cma) + encode_row(cmd)] = {t:'z'};
							}
						}
					}
					c = cc + 1;
				}
				else ++c;
			} else {
				cell = xlml_parsexmltagobj(Rn[0]);
				if(cell.Index) c = +cell.Index - 1;
				if(c < refguess.s.c) refguess.s.c = c;
				if(c > refguess.e.c) refguess.e.c = c;
				if(Rn[0].slice(-2) === "/>") ++c;
				comments = [];
			}
			break;
		case 'Row':
			if(Rn[1]==='/' || Rn[0].slice(-2) === "/>") {
				if(r < refguess.s.r) refguess.s.r = r;
				if(r > refguess.e.r) refguess.e.r = r;
				if(Rn[0].slice(-2) === "/>") {
					row = xlml_parsexmltag(Rn[0]);
					if(row.Index) r = +row.Index - 1;
				}
				c = 0; ++r;
			} else {
				row = xlml_parsexmltag(Rn[0]);
				if(row.Index) r = +row.Index - 1;
				rowobj = {};
				if(row.AutoFitHeight == "0" || row.Height) {
					rowobj.hpx = parseInt(row.Height, 10); rowobj.hpt = px2pt(rowobj.hpx);
					rowinfo[r] = rowobj;
				}
				if(row.Hidden == "1") { rowobj.hidden = true; rowinfo[r] = rowobj; }
			}
			break;
		case 'Worksheet': /* TODO: read range from FullRows/FullColumns */
			if(Rn[1]==='/'){
				if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
				sheetnames.push(sheetname);
				if(refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
					cursheet["!ref"] = encode_range(refguess);
					if(opts.sheetRows && opts.sheetRows <= refguess.e.r) {
						cursheet["!fullref"] = cursheet["!ref"];
						refguess.e.r = opts.sheetRows - 1;
						cursheet["!ref"] = encode_range(refguess);
					}
				}
				if(merges.length) cursheet["!merges"] = merges;
				if(cstys.length > 0) cursheet["!cols"] = cstys;
				if(rowinfo.length > 0) cursheet["!rows"] = rowinfo;
				sheets[sheetname] = cursheet;
			} else {
				refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
				r = c = 0;
				state.push([Rn[3], false]);
				tmp = xlml_parsexmltag(Rn[0]);
				sheetname = unescapexml(tmp.Name);
				cursheet = (opts.dense ? [] : {});
				merges = [];
				arrayf = [];
				rowinfo = [];
				wsprops = {name:sheetname, Hidden:0};
				Workbook.Sheets.push(wsprops);
			}
			break;
		case 'Table':
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else if(Rn[0].slice(-2) == "/>") break;
			else {
				table = xlml_parsexmltag(Rn[0]);
				state.push([Rn[3], false]);
				cstys = []; seencol = false;
			}
			break;

		case 'Style':
			if(Rn[1]==='/') process_style_xlml(styles, stag, opts);
			else stag = xlml_parsexmltag(Rn[0]);
			break;

		case 'NumberFormat':
			stag.nf = unescapexml(xlml_parsexmltag(Rn[0]).Format || "General");
			if(XLMLFormatMap[stag.nf]) stag.nf = XLMLFormatMap[stag.nf];
			for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx) if(SSF._table[ssfidx] == stag.nf) break;
			if(ssfidx == 0x188) for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx) if(SSF._table[ssfidx] == null) { SSF.load(stag.nf, ssfidx); break; }
			break;

		case 'Column':
			if(state[state.length-1][0] !== 'Table') break;
			csty = xlml_parsexmltag(Rn[0]);
			if(csty.Hidden) { csty.hidden = true; delete csty.Hidden; }
			if(csty.Width) csty.wpx = parseInt(csty.Width, 10);
			if(!seencol && csty.wpx > 10) {
				seencol = true; MDW = DEF_MDW; //find_mdw_wpx(csty.wpx);
				for(var _col = 0; _col < cstys.length; ++_col) if(cstys[_col]) process_col(cstys[_col]);
			}
			if(seencol) process_col(csty);
			cstys[(csty.Index-1||cstys.length)] = csty;
			for(var i = 0; i < +csty.Span; ++i) cstys[cstys.length] = dup(csty);
			break;

		case 'NamedRange':
			if(!Workbook.Names) Workbook.Names = [];
			var _NamedRange = parsexmltag(Rn[0]);
			var _DefinedName = ({
				Name: _NamedRange.Name,
				Ref: rc_to_a1(_NamedRange.RefersTo.slice(1), {r:0, c:0})
			});
			if(Workbook.Sheets.length>0) _DefinedName.Sheet=Workbook.Sheets.length-1;
Workbook.Names.push(_DefinedName);
			break;

		case 'NamedCell': break;
		case 'B': break;
		case 'I': break;
		case 'U': break;
		case 'S': break;
		case 'Sub': break;
		case 'Sup': break;
		case 'Span': break;
		case 'Border': break;
		case 'Alignment': break;
		case 'Borders': break;
		case 'Font':
			if(Rn[0].slice(-2) === "/>") break;
			else if(Rn[1]==="/") ss += str.slice(fidx, Rn.index);
			else fidx = Rn.index + Rn[0].length;
			break;
		case 'Interior':
			if(!opts.cellStyles) break;
			stag.Interior = xlml_parsexmltag(Rn[0]);
			break;
		case 'Protection': break;

		case 'Author':
		case 'Title':
		case 'Description':
		case 'Created':
		case 'Keywords':
		case 'Subject':
		case 'Category':
		case 'Company':
		case 'LastAuthor':
		case 'LastSaved':
		case 'LastPrinted':
		case 'Version':
		case 'Revision':
		case 'TotalTime':
		case 'HyperlinkBase':
		case 'Manager':
		case 'ContentStatus':
		case 'Identifier':
		case 'Language':
		case 'AppName':
			if(Rn[0].slice(-2) === "/>") break;
			else if(Rn[1]==="/") xlml_set_prop(Props, Rn[3], str.slice(pidx, Rn.index));
			else pidx = Rn.index + Rn[0].length;
			break;
		case 'Paragraphs': break;

		case 'Styles':
		case 'Workbook':
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else state.push([Rn[3], false]);
			break;

		case 'Comment':
			if(Rn[1]==='/'){
				if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
				xlml_clean_comment(comment);
				comments.push(comment);
			} else {
				state.push([Rn[3], false]);
				tmp = xlml_parsexmltag(Rn[0]);
				comment = ({a:tmp.Author});
			}
			break;

		case 'AutoFilter':
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
				var AutoFilter = xlml_parsexmltag(Rn[0]);
				cursheet['!autofilter'] = { ref:rc_to_a1(AutoFilter.Range).replace(/\$/g,"") };
				state.push([Rn[3], true]);
			}
			break;

		case 'Name': break;

		case 'ComponentOptions':
		case 'DocumentProperties':
		case 'CustomDocumentProperties':
		case 'OfficeDocumentSettings':
		case 'PivotTable':
		case 'PivotCache':
		case 'Names':
		case 'MapInfo':
		case 'PageBreaks':
		case 'QueryTable':
		case 'DataValidation':
		case 'Sorting':
		case 'Schema':
		case 'data':
		case 'ConditionalFormatting':
		case 'SmartTagType':
		case 'SmartTags':
		case 'ExcelWorkbook':
		case 'WorkbookOptions':
		case 'WorksheetOptions':
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
			break;

		default:
			/* FODS file root is <office:document> */
			if(state.length == 0 && Rn[3] == "document") return parse_fods(str, opts);
			/* UOS file root is <uof:UOF> */
			if(state.length == 0 && Rn[3] == "UOF") return parse_fods(str, opts);

			var seen = true;
			switch(state[state.length-1][0]) {
				/* OfficeDocumentSettings */
				case 'OfficeDocumentSettings': switch(Rn[3]) {
					case 'AllowPNG': break;
					case 'RemovePersonalInformation': break;
					case 'DownloadComponents': break;
					case 'LocationOfComponents': break;
					case 'Colors': break;
					case 'Color': break;
					case 'Index': break;
					case 'RGB': break;
					case 'PixelsPerInch': break; // TODO: set PPI
					case 'TargetScreenSize': break;
					case 'ReadOnlyRecommended': break;
					default: seen = false;
				} break;

				/* ComponentOptions */
				case 'ComponentOptions': switch(Rn[3]) {
					case 'Toolbar': break;
					case 'HideOfficeLogo': break;
					case 'SpreadsheetAutoFit': break;
					case 'Label': break;
					case 'Caption': break;
					case 'MaxHeight': break;
					case 'MaxWidth': break;
					case 'NextSheetNumber': break;
					default: seen = false;
				} break;

				/* ExcelWorkbook */
				case 'ExcelWorkbook': switch(Rn[3]) {
					case 'Date1904':
Workbook.WBProps.date1904 = true;
						break;
					case 'WindowHeight': break;
					case 'WindowWidth': break;
					case 'WindowTopX': break;
					case 'WindowTopY': break;
					case 'TabRatio': break;
					case 'ProtectStructure': break;
					case 'ProtectWindows': break;
					case 'ActiveSheet': break;
					case 'DisplayInkNotes': break;
					case 'FirstVisibleSheet': break;
					case 'SupBook': break;
					case 'SheetName': break;
					case 'SheetIndex': break;
					case 'SheetIndexFirst': break;
					case 'SheetIndexLast': break;
					case 'Dll': break;
					case 'AcceptLabelsInFormulas': break;
					case 'DoNotSaveLinkValues': break;
					case 'Iteration': break;
					case 'MaxIterations': break;
					case 'MaxChange': break;
					case 'Path': break;
					case 'Xct': break;
					case 'Count': break;
					case 'SelectedSheets': break;
					case 'Calculation': break;
					case 'Uncalced': break;
					case 'StartupPrompt': break;
					case 'Crn': break;
					case 'ExternName': break;
					case 'Formula': break;
					case 'ColFirst': break;
					case 'ColLast': break;
					case 'WantAdvise': break;
					case 'Boolean': break;
					case 'Error': break;
					case 'Text': break;
					case 'OLE': break;
					case 'NoAutoRecover': break;
					case 'PublishObjects': break;
					case 'DoNotCalculateBeforeSave': break;
					case 'Number': break;
					case 'RefModeR1C1': break;
					case 'EmbedSaveSmartTags': break;
					default: seen = false;
				} break;

				/* WorkbookOptions */
				case 'WorkbookOptions': switch(Rn[3]) {
					case 'OWCVersion': break;
					case 'Height': break;
					case 'Width': break;
					default: seen = false;
				} break;

				/* WorksheetOptions */
				case 'WorksheetOptions': switch(Rn[3]) {
					case 'Visible':
						if(Rn[0].slice(-2) === "/>"){/* empty */}
						else if(Rn[1]==="/") switch(str.slice(pidx, Rn.index)) {
							case "SheetHidden": wsprops.Hidden = 1; break;
							case "SheetVeryHidden": wsprops.Hidden = 2; break;
						}
						else pidx = Rn.index + Rn[0].length;
						break;
					case 'Header':
						if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
						cursheet['!margins'].header = parsexmltag(Rn[0]).Margin;
						break;
					case 'Footer':
						if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
						cursheet['!margins'].footer = parsexmltag(Rn[0]).Margin;
						break;
					case 'PageMargins':
						var pagemargins = parsexmltag(Rn[0]);
						if(!cursheet['!margins']) default_margins(cursheet['!margins']={},'xlml');
						if(pagemargins.Top) cursheet['!margins'].top = pagemargins.Top;
						if(pagemargins.Left) cursheet['!margins'].left = pagemargins.Left;
						if(pagemargins.Right) cursheet['!margins'].right = pagemargins.Right;
						if(pagemargins.Bottom) cursheet['!margins'].bottom = pagemargins.Bottom;
						break;
					case 'DisplayRightToLeft':
						if(!Workbook.Views) Workbook.Views = [];
						if(!Workbook.Views[0]) Workbook.Views[0] = {};
						Workbook.Views[0].RTL = true;
						break;

					case 'Unsynced': break;
					case 'Print': break;
					case 'Panes': break;
					case 'Scale': break;
					case 'Pane': break;
					case 'Number': break;
					case 'Layout': break;
					case 'PageSetup': break;
					case 'Selected': break;
					case 'ProtectObjects': break;
					case 'EnableSelection': break;
					case 'ProtectScenarios': break;
					case 'ValidPrinterInfo': break;
					case 'HorizontalResolution': break;
					case 'VerticalResolution': break;
					case 'NumberofCopies': break;
					case 'ActiveRow': break;
					case 'ActiveCol': break;
					case 'ActivePane': break;
					case 'TopRowVisible': break;
					case 'TopRowBottomPane': break;
					case 'LeftColumnVisible': break;
					case 'LeftColumnRightPane': break;
					case 'FitToPage': break;
					case 'RangeSelection': break;
					case 'PaperSizeIndex': break;
					case 'PageLayoutZoom': break;
					case 'PageBreakZoom': break;
					case 'FilterOn': break;
					case 'DoNotDisplayGridlines': break;
					case 'SplitHorizontal': break;
					case 'SplitVertical': break;
					case 'FreezePanes': break;
					case 'FrozenNoSplit': break;
					case 'FitWidth': break;
					case 'FitHeight': break;
					case 'CommentsLayout': break;
					case 'Zoom': break;
					case 'LeftToRight': break;
					case 'Gridlines': break;
					case 'AllowSort': break;
					case 'AllowFilter': break;
					case 'AllowInsertRows': break;
					case 'AllowDeleteRows': break;
					case 'AllowInsertCols': break;
					case 'AllowDeleteCols': break;
					case 'AllowInsertHyperlinks': break;
					case 'AllowFormatCells': break;
					case 'AllowSizeCols': break;
					case 'AllowSizeRows': break;
					case 'NoSummaryRowsBelowDetail': break;
					case 'TabColorIndex': break;
					case 'DoNotDisplayHeadings': break;
					case 'ShowPageLayoutZoom': break;
					case 'NoSummaryColumnsRightDetail': break;
					case 'BlackAndWhite': break;
					case 'DoNotDisplayZeros': break;
					case 'DisplayPageBreak': break;
					case 'RowColHeadings': break;
					case 'DoNotDisplayOutline': break;
					case 'NoOrientation': break;
					case 'AllowUsePivotTables': break;
					case 'ZeroHeight': break;
					case 'ViewableRange': break;
					case 'Selection': break;
					case 'ProtectContents': break;
					default: seen = false;
				} break;

				/* PivotTable */
				case 'PivotTable': case 'PivotCache': switch(Rn[3]) {
					case 'ImmediateItemsOnDrop': break;
					case 'ShowPageMultipleItemLabel': break;
					case 'CompactRowIndent': break;
					case 'Location': break;
					case 'PivotField': break;
					case 'Orientation': break;
					case 'LayoutForm': break;
					case 'LayoutSubtotalLocation': break;
					case 'LayoutCompactRow': break;
					case 'Position': break;
					case 'PivotItem': break;
					case 'DataType': break;
					case 'DataField': break;
					case 'SourceName': break;
					case 'ParentField': break;
					case 'PTLineItems': break;
					case 'PTLineItem': break;
					case 'CountOfSameItems': break;
					case 'Item': break;
					case 'ItemType': break;
					case 'PTSource': break;
					case 'CacheIndex': break;
					case 'ConsolidationReference': break;
					case 'FileName': break;
					case 'Reference': break;
					case 'NoColumnGrand': break;
					case 'NoRowGrand': break;
					case 'BlankLineAfterItems': break;
					case 'Hidden': break;
					case 'Subtotal': break;
					case 'BaseField': break;
					case 'MapChildItems': break;
					case 'Function': break;
					case 'RefreshOnFileOpen': break;
					case 'PrintSetTitles': break;
					case 'MergeLabels': break;
					case 'DefaultVersion': break;
					case 'RefreshName': break;
					case 'RefreshDate': break;
					case 'RefreshDateCopy': break;
					case 'VersionLastRefresh': break;
					case 'VersionLastUpdate': break;
					case 'VersionUpdateableMin': break;
					case 'VersionRefreshableMin': break;
					case 'Calculation': break;
					default: seen = false;
				} break;

				/* PageBreaks */
				case 'PageBreaks': switch(Rn[3]) {
					case 'ColBreaks': break;
					case 'ColBreak': break;
					case 'RowBreaks': break;
					case 'RowBreak': break;
					case 'ColStart': break;
					case 'ColEnd': break;
					case 'RowEnd': break;
					default: seen = false;
				} break;

				/* AutoFilter */
				case 'AutoFilter': switch(Rn[3]) {
					case 'AutoFilterColumn': break;
					case 'AutoFilterCondition': break;
					case 'AutoFilterAnd': break;
					case 'AutoFilterOr': break;
					default: seen = false;
				} break;

				/* QueryTable */
				case 'QueryTable': switch(Rn[3]) {
					case 'Id': break;
					case 'AutoFormatFont': break;
					case 'AutoFormatPattern': break;
					case 'QuerySource': break;
					case 'QueryType': break;
					case 'EnableRedirections': break;
					case 'RefreshedInXl9': break;
					case 'URLString': break;
					case 'HTMLTables': break;
					case 'Connection': break;
					case 'CommandText': break;
					case 'RefreshInfo': break;
					case 'NoTitles': break;
					case 'NextId': break;
					case 'ColumnInfo': break;
					case 'OverwriteCells': break;
					case 'DoNotPromptForFile': break;
					case 'TextWizardSettings': break;
					case 'Source': break;
					case 'Number': break;
					case 'Decimal': break;
					case 'ThousandSeparator': break;
					case 'TrailingMinusNumbers': break;
					case 'FormatSettings': break;
					case 'FieldType': break;
					case 'Delimiters': break;
					case 'Tab': break;
					case 'Comma': break;
					case 'AutoFormatName': break;
					case 'VersionLastEdit': break;
					case 'VersionLastRefresh': break;
					default: seen = false;
				} break;

				case 'Sorting':
				case 'ConditionalFormatting':
				case 'DataValidation':
				switch(Rn[3]) {
					case 'Range': break;
					case 'Type': break;
					case 'Min': break;
					case 'Max': break;
					case 'Sort': break;
					case 'Descending': break;
					case 'Order': break;
					case 'CaseSensitive': break;
					case 'Value': break;
					case 'ErrorStyle': break;
					case 'ErrorMessage': break;
					case 'ErrorTitle': break;
					case 'CellRangeList': break;
					case 'InputMessage': break;
					case 'InputTitle': break;
					case 'ComboHide': break;
					case 'InputHide': break;
					case 'Condition': break;
					case 'Qualifier': break;
					case 'UseBlank': break;
					case 'Value1': break;
					case 'Value2': break;
					case 'Format': break;
					default: seen = false;
				} break;

				/* MapInfo (schema) */
				case 'MapInfo': case 'Schema': case 'data': switch(Rn[3]) {
					case 'Map': break;
					case 'Entry': break;
					case 'Range': break;
					case 'XPath': break;
					case 'Field': break;
					case 'XSDType': break;
					case 'FilterOn': break;
					case 'Aggregate': break;
					case 'ElementType': break;
					case 'AttributeType': break;
				/* These are from xsd (XML Schema Definition) */
					case 'schema':
					case 'element':
					case 'complexType':
					case 'datatype':
					case 'all':
					case 'attribute':
					case 'extends': break;

					case 'row': break;
					default: seen = false;
				} break;

				/* SmartTags (can be anything) */
				case 'SmartTags': break;

				default: seen = false; break;
			}
			if(seen) break;
			/* CustomDocumentProperties */
			if(!state[state.length-1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
			if(state[state.length-1][0]==='CustomDocumentProperties') {
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") xlml_set_custprop(Custprops, Rn[3], cp, str.slice(pidx, Rn.index));
				else { cp = Rn; pidx = Rn.index + Rn[0].length; }
				break;
			}
			if(opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
	}
	var out = ({});
	if(!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
	out.SheetNames = sheetnames;
	out.Workbook = Workbook;
	out.SSF = SSF.get_table();
	out.Props = Props;
	out.Custprops = Custprops;
	return out;
}

function parse_xlml(data, opts) {
	fix_read_opts(opts=opts||{});
	switch(opts.type||"base64") {
		case "base64": return parse_xlml_xml(Base64.decode(data), opts);
		case "binary": case "buffer": case "file": return parse_xlml_xml(data, opts);
		case "array": return parse_xlml_xml(a2s(data), opts);
	}
}

/* TODO */
function write_props_xlml(wb, opts) {
	var o = [];
	/* DocumentProperties */
	if(wb.Props) o.push(xlml_write_docprops(wb.Props, opts));
	/* CustomDocumentProperties */
	if(wb.Custprops) o.push(xlml_write_custprops(wb.Props, wb.Custprops, opts));
	return o.join("");
}
/* TODO */
function write_wb_xlml() {
	/* OfficeDocumentSettings */
	/* ExcelWorkbook */
	return "";
}
/* TODO */
function write_sty_xlml(wb, opts) {
	/* Styles */
	var styles = ['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];
	opts.cellXfs.forEach(function(xf, id) {
		var payload = [];
		payload.push(writextag('NumberFormat', null, {"ss:Format": escapexml(SSF._table[xf.numFmtId])}));
		styles.push(writextag('Style', payload.join(""), {"ss:ID": "s" + (21+id)}));
	});
	return writextag("Styles", styles.join(""));
}
function write_name_xlml(n) { return writextag("NamedRange", null, {"ss:Name": n.Name, "ss:RefersTo":"=" + a1_to_rc(n.Ref, {r:0,c:0})}); }
function write_names_xlml(wb) {
	if(!((wb||{}).Workbook||{}).Names) return "";
var names = wb.Workbook.Names;
	var out = [];
	for(var i = 0; i < names.length; ++i) {
		var n = names[i];
		if(n.Sheet != null) continue;
		if(n.Name.match(/^_xlfn\./)) continue;
		out.push(write_name_xlml(n));
	}
	return writextag("Names", out.join(""));
}
function write_ws_xlml_names(ws, opts, idx, wb) {
	if(!ws) return "";
	if(!((wb||{}).Workbook||{}).Names) return "";
var names = wb.Workbook.Names;
	var out = [];
	for(var i = 0; i < names.length; ++i) {
		var n = names[i];
		if(n.Sheet != idx) continue;
		/*switch(n.Name) {
			case "_": continue;
		}*/
		if(n.Name.match(/^_xlfn\./)) continue;
		out.push(write_name_xlml(n));
	}
	return out.join("");
}
/* WorksheetOptions */
function write_ws_xlml_wsopts(ws, opts, idx, wb) {
	if(!ws) return "";
	var o = [];
	/* NOTE: spec technically allows any order, but stick with implied order */

	/* FitToPage */
	/* DoNotDisplayColHeaders */
	/* DoNotDisplayRowHeaders */
	/* ViewableRange */
	/* Selection */
	/* GridlineColor */
	/* Name */
	/* ExcelWorksheetType */
	/* IntlMacro */
	/* Unsynced */
	/* Selected */
	/* CodeName */

	if(ws['!margins']) {
		o.push("<PageSetup>");
		if(ws['!margins'].header) o.push(writextag("Header", null, {'x:Margin':ws['!margins'].header}));
		if(ws['!margins'].footer) o.push(writextag("Footer", null, {'x:Margin':ws['!margins'].footer}));
		o.push(writextag("PageMargins", null, {
			'x:Bottom': ws['!margins'].bottom || "0.75",
			'x:Left': ws['!margins'].left || "0.7",
			'x:Right': ws['!margins'].right || "0.7",
			'x:Top': ws['!margins'].top || "0.75"
		}));
		o.push("</PageSetup>");
	}

	/* PageSetup */
	/* DisplayPageBreak */
	/* TransitionExpressionEvaluation */
	/* TransitionFormulaEntry */
	/* Print */
	/* Zoom */
	/* PageLayoutZoom */
	/* PageBreakZoom */
	/* ShowPageBreakZoom */
	/* DefaultRowHeight */
	/* DefaultColumnWidth */
	/* StandardWidth */

	if(wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
		/* Visible */
		if(wb.Workbook.Sheets[idx].Hidden) o.push(writextag("Visible", (wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden"), {}));
		else {
			/* Selected */
			for(var i = 0; i < idx; ++i) if(wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
			if(i == idx) o.push("<Selected/>");
		}
	}

	/* LeftColumnVisible */

	if(((((wb||{}).Workbook||{}).Views||[])[0]||{}).RTL) o.push("<DisplayRightToLeft/>");

	/* GridlineColorIndex */
	/* DisplayFormulas */
	/* DoNotDisplayGridlines */
	/* DoNotDisplayHeadings */
	/* DoNotDisplayOutline */
	/* ApplyAutomaticOutlineStyles */
	/* NoSummaryRowsBelowDetail */
	/* NoSummaryColumnsRightDetail */
	/* DoNotDisplayZeros */
	/* ActiveRow */
	/* ActiveColumn */
	/* FilterOn */
	/* RangeSelection */
	/* TopRowVisible */
	/* TopRowBottomPane */
	/* LeftColumnRightPane */
	/* ActivePane */
	/* SplitHorizontal */
	/* SplitVertical */
	/* FreezePanes */
	/* FrozenNoSplit */
	/* TabColorIndex */
	/* Panes */

	/* NOTE: Password not supported in XLML Format */
	if(ws['!protect']) {
		o.push(writetag("ProtectContents", "True"));
		if(ws['!protect'].objects) o.push(writetag("ProtectObjects", "True"));
		if(ws['!protect'].scenarios) o.push(writetag("ProtectScenarios", "True"));
		if(ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push(writetag("EnableSelection", "NoSelection"));
		else if(ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push(writetag("EnableSelection", "UnlockedCells"));
	[
		[ "formatCells", "AllowFormatCells" ],
		[ "formatColumns", "AllowSizeCols" ],
		[ "formatRows", "AllowSizeRows" ],
		[ "insertColumns", "AllowInsertCols" ],
		[ "insertRows", "AllowInsertRows" ],
		[ "insertHyperlinks", "AllowInsertHyperlinks" ],
		[ "deleteColumns", "AllowDeleteCols" ],
		[ "deleteRows", "AllowDeleteRows" ],
		[ "sort", "AllowSort" ],
		[ "autoFilter", "AllowFilter" ],
		[ "pivotTables", "AllowUsePivotTables" ]
	].forEach(function(x) { if(ws['!protect'][x[0]]) o.push("<"+x[1]+"/>"); });
	}

	if(o.length == 0) return "";
	return writextag("WorksheetOptions", o.join(""), {xmlns:XLMLNS.x});
}
function write_ws_xlml_comment(comments) {
	return comments.map(function(c) {
		// TODO: formatted text
		var t = xlml_unfixstr(c.t||"");
		var d =writextag("ss:Data", t, {"xmlns":"http://www.w3.org/TR/REC-html40"});
		return writextag("Comment", d, {"ss:Author":c.a});
	}).join("");
}
function write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr){
	if(!cell || (cell.v == undefined && cell.f == undefined)) return "";

	var attr = {};
	if(cell.f) attr["ss:Formula"] = "=" + escapexml(a1_to_rc(cell.f, addr));
	if(cell.F && cell.F.slice(0, ref.length) == ref) {
		var end = decode_cell(cell.F.slice(ref.length + 1));
		attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
	}

	if(cell.l && cell.l.Target) {
		attr["ss:HRef"] = escapexml(cell.l.Target);
		if(cell.l.Tooltip) attr["x:HRefScreenTip"] = escapexml(cell.l.Tooltip);
	}

	if(ws['!merges']) {
		var marr = ws['!merges'];
		for(var mi = 0; mi != marr.length; ++mi) {
			if(marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
			if(marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
			if(marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
		}
	}

	var t = "", p = "";
	switch(cell.t) {
		case 'z': return "";
		case 'n': t = 'Number'; p = String(cell.v); break;
		case 'b': t = 'Boolean'; p = (cell.v ? "1" : "0"); break;
		case 'e': t = 'Error'; p = BErr[cell.v]; break;
		case 'd': t = 'DateTime'; p = new Date(cell.v).toISOString(); if(cell.z == null) cell.z = cell.z || SSF._table[14]; break;
		case 's': t = 'String'; p = escapexlml(cell.v||""); break;
	}
	/* TODO: cell style */
	var os = get_cell_style(opts.cellXfs, cell, opts);
	attr["ss:StyleID"] = "s" + (21+os);
	attr["ss:Index"] = addr.c + 1;
	var _v = (cell.v != null ? p : "");
	var m = '<Data ss:Type="' + t + '">' + _v + '</Data>';

	if((cell.c||[]).length > 0) m += write_ws_xlml_comment(cell.c);

	return writextag("Cell", m, attr);
}
function write_ws_xlml_row(R, row) {
	var o = '<Row ss:Index="' + (R+1) + '"';
	if(row) {
		if(row.hpt && !row.hpx) row.hpx = pt2px(row.hpt);
		if(row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
		if(row.hidden) o += ' ss:Hidden="1"';
	}
	return o + '>';
}
/* TODO */
function write_ws_xlml_table(ws, opts, idx, wb) {
	if(!ws['!ref']) return "";
	var range = safe_decode_range(ws['!ref']);
	var marr = ws['!merges'] || [], mi = 0;
	var o = [];
	if(ws['!cols']) ws['!cols'].forEach(function(n, i) {
		process_col(n);
		var w = !!n.width;
		var p = col_obj_w(i, n);
		var k = {"ss:Index":i+1};
		if(w) k['ss:Width'] = width2px(p.width);
		if(n.hidden) k['ss:Hidden']="1";
		o.push(writextag("Column",null,k));
	});
	var dense = Array.isArray(ws);
	for(var R = range.s.r; R <= range.e.r; ++R) {
		var row = [write_ws_xlml_row(R, (ws['!rows']||[])[R])];
		for(var C = range.s.c; C <= range.e.c; ++C) {
			var skip = false;
			for(mi = 0; mi != marr.length; ++mi) {
				if(marr[mi].s.c > C) continue;
				if(marr[mi].s.r > R) continue;
				if(marr[mi].e.c < C) continue;
				if(marr[mi].e.r < R) continue;
				if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
				break;
			}
			if(skip) continue;
			var addr = {r:R,c:C};
			var ref = encode_cell(addr), cell = dense ? (ws[R]||[])[C] : ws[ref];
			row.push(write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
		}
		row.push("</Row>");
		if(row.length > 2) o.push(row.join(""));
	}
	return o.join("");
}
function write_ws_xlml(idx, opts, wb) {
	var o = [];
	var s = wb.SheetNames[idx];
	var ws = wb.Sheets[s];

	var t = ws ? write_ws_xlml_names(ws, opts, idx, wb) : "";
	if(t.length > 0) o.push("<Names>" + t + "</Names>");

	/* Table */
	t = ws ? write_ws_xlml_table(ws, opts, idx, wb) : "";
	if(t.length > 0) o.push("<Table>" + t + "</Table>");

	/* WorksheetOptions */
	o.push(write_ws_xlml_wsopts(ws, opts, idx, wb));

	return o.join("");
}
function write_xlml(wb, opts) {
	if(!opts) opts = {};
	if(!wb.SSF) wb.SSF = SSF.get_table();
	if(wb.SSF) {
		make_ssf(SSF); SSF.load_table(wb.SSF);
		// $FlowIgnore
		opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
		opts.ssf = wb.SSF;
		opts.cellXfs = [];
		get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
	}
	var d = [];
	d.push(write_props_xlml(wb, opts));
	d.push(write_wb_xlml(wb, opts));
	d.push("");
	d.push("");
	for(var i = 0; i < wb.SheetNames.length; ++i)
		d.push(writextag("Worksheet", write_ws_xlml(i, opts, wb), {"ss:Name":escapexml(wb.SheetNames[i])}));
	d[2] = write_sty_xlml(wb, opts);
	d[3] = write_names_xlml(wb, opts);
	return XML_HEADER + writextag("Workbook", d.join(""), {
		'xmlns':      XLMLNS.ss,
		'xmlns:o':    XLMLNS.o,
		'xmlns:x':    XLMLNS.x,
		'xmlns:ss':   XLMLNS.ss,
		'xmlns:dt':   XLMLNS.dt,
		'xmlns:html': XLMLNS.html
	});
}
/* [MS-OLEDS] 2.3.8 CompObjStream */
function parse_compobj(obj) {
	var v = {};
	var o = obj.content;
/* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */
	o.l = 28;

	v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
	v.AnsiClipboardFormat = parse_ClipboardFormatOrAnsiString(o);

	if(o.length - o.l <= 4) return v;

	var m = o.read_shift(4);
	if(m == 0 || m > 40) return v;
	o.l-=4; v.Reserved1 = o.read_shift(0, "lpstr-ansi");

	if(o.length - o.l <= 4) return v;
	m = o.read_shift(4);
	if(m !== 0x71b239f4) return v;
	v.UnicodeClipboardFormat = parse_ClipboardFormatOrUnicodeString(o);

	m = o.read_shift(4);
	if(m == 0 || m > 40) return v;
	o.l-=4; v.Reserved2 = o.read_shift(0, "lpwstr");
}

/*
	Continue logic for:
	- 2.4.58 Continue
	- 2.4.59 ContinueBigName
	- 2.4.60 ContinueFrt
	- 2.4.61 ContinueFrt11
	- 2.4.62 ContinueFrt12
*/
function slurp(R, blob, length, opts) {
	var l = length;
	var bufs = [];
	var d = blob.slice(blob.l,blob.l+l);
	if(opts && opts.enc && opts.enc.insitu) switch(R.n) {
	case 'BOF': case 'FilePass': case 'FileLock': case 'InterfaceHdr': case 'RRDInfo': case 'RRDHead': case 'UsrExcl': break;
	default:
		if(d.length === 0) break;
		opts.enc.insitu(d);
	}
	bufs.push(d);
	blob.l += l;
	var next = (XLSRecordEnum[__readUInt16LE(blob,blob.l)]);
	var start = 0;
	while(next != null && next.n.slice(0,8) === 'Continue') {
		l = __readUInt16LE(blob,blob.l+2);
		start = blob.l + 4;
		if(next.n == 'ContinueFrt') start += 4;
		else if(next.n.slice(0,11) == 'ContinueFrt') start += 12;
		bufs.push(blob.slice(start,blob.l+4+l));
		blob.l += 4+l;
		next = (XLSRecordEnum[__readUInt16LE(blob, blob.l)]);
	}
	var b = (bconcat(bufs));
	prep_blob(b, 0);
	var ll = 0; b.lens = [];
	for(var j = 0; j < bufs.length; ++j) { b.lens.push(ll); ll += bufs[j].length; }
	return R.f(b, b.length, opts);
}

function safe_format_xf(p, opts, date1904) {
	if(p.t === 'z') return;
	if(!p.XF) return;
	var fmtid = 0;
	try {
		fmtid = p.z || p.XF.numFmtId || 0;
		if(opts.cellNF) p.z = SSF._table[fmtid];
	} catch(e) { if(opts.WTF) throw e; }
	if(!opts || opts.cellText !== false) try {
		if(p.t === 'e') { p.w = p.w || BErr[p.v]; }
		else if(fmtid === 0 || fmtid == "General") {
			if(p.t === 'n') {
				if((p.v|0) === p.v) p.w = SSF._general_int(p.v);
				else p.w = SSF._general_num(p.v);
			}
			else p.w = SSF._general(p.v);
		}
		else p.w = SSF.format(fmtid,p.v, {date1904:!!date1904});
	} catch(e) { if(opts.WTF) throw e; }
	if(opts.cellDates && fmtid && p.t == 'n' && SSF.is_date(SSF._table[fmtid] || String(fmtid))) {
		var _d = SSF.parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
	}
}

function make_cell(val, ixfe, t) {
	return ({v:val, ixfe:ixfe, t:t});
}

// 2.3.2
function parse_workbook(blob, options) {
	var wb = ({opts:{}});
	var Sheets = {};
	if(DENSE != null && options.dense == null) options.dense = DENSE;
	var out = ((options.dense ? [] : {}));
	var Directory = {};
	var range = ({});
	var last_formula = null;
	var sst = ([]);
	var cur_sheet = "";
	var Preamble = {};
	var lastcell, last_cell = "", cc, cmnt, rngC, rngR;
	var sharedf = {};
	var arrayf = [];
	var temp_val;
	var country;
	var cell_valid = true;
	var XFs = []; /* XF records */
	var palette = [];
	var Workbook = ({ Sheets:[], WBProps:{date1904:false}, Views:[{}] }), wsprops = {};
	var get_rgb = function getrgb(icv) {
		if(icv < 8) return XLSIcv[icv];
		if(icv < 64) return palette[icv-8] || XLSIcv[icv];
		return XLSIcv[icv];
	};
	var process_cell_style = function pcs(cell, line, options) {
		var xfd = line.XF.data;
		if(!xfd || !xfd.patternType || !options || !options.cellStyles) return;
		line.s = ({});
		line.s.patternType = xfd.patternType;
		var t;
		if((t = rgb2Hex(get_rgb(xfd.icvFore)))) { line.s.fgColor = {rgb:t}; }
		if((t = rgb2Hex(get_rgb(xfd.icvBack)))) { line.s.bgColor = {rgb:t}; }
	};
	var addcell = function addcell(cell, line, options) {
		if(file_depth > 1) return;
		if(options.sheetRows && cell.r >= options.sheetRows) cell_valid = false;
		if(!cell_valid) return;
		if(options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
		delete line.ixfe; delete line.XF;
		lastcell = cell;
		last_cell = encode_cell(cell);
		if(range.s) {
			if(cell.r < range.s.r) range.s.r = cell.r;
			if(cell.c < range.s.c) range.s.c = cell.c;
		}
		if(range.e) {
			if(cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
			if(cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
		}
		if(options.cellFormula && line.f) {
			for(var afi = 0; afi < arrayf.length; ++afi) {
				if(arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
				if(arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
				line.F = encode_range(arrayf[afi][0]);
				if(arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
				if(line.f) line.f = "" + stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
				break;
			}
		}
		{
			if(options.dense) {
				if(!out[cell.r]) out[cell.r] = [];
				out[cell.r][cell.c] = line;
			} else out[last_cell] = line;
		}
	};
	var opts = ({
		enc: false, // encrypted
		sbcch: 0, // cch in the preceding SupBook
		snames: [], // sheetnames
		sharedf: sharedf, // shared formulae by address
		arrayf: arrayf, // array formulae array
		rrtabid: [], // RRTabId
		lastuser: "", // Last User from WriteAccess
		biff: 8, // BIFF version
		codepage: 0, // CP from CodePage record
		winlocked: 0, // fLockWn from WinProtect
		cellStyles: !!options && !!options.cellStyles,
		WTF: !!options && !!options.wtf
	});
	if(options.password) opts.password = options.password;
	var themes;
	var merges = [];
	var objects = [];
	var colinfo = [], rowinfo = [];
	// eslint-disable-next-line no-unused-vars
	var defwidth = 0, defheight = 0; // twips / MDW respectively
	var seencol = false;
	var supbooks = ([]); // 1-indexed, will hold extern names
	supbooks.SheetNames = opts.snames;
	supbooks.sharedf = opts.sharedf;
	supbooks.arrayf = opts.arrayf;
	supbooks.names = [];
	supbooks.XTI = [];
	var last_Rn = '';
	var file_depth = 0; /* TODO: make a real stack */
	var BIFF2Fmt = 0, BIFF2FmtTable = [];
	var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */
	var last_lbl;

	/* explicit override for some broken writers */
	opts.codepage = 1200;
	set_cp(1200);
	var seen_codepage = false;
	while(blob.l < blob.length - 1) {
		var s = blob.l;
		var RecordType = blob.read_shift(2);
		if(RecordType === 0 && last_Rn === 'EOF') break;
		var length = (blob.l === blob.length ? 0 : blob.read_shift(2));
		var R = XLSRecordEnum[RecordType];
		//console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
		//if(!R) console.log(blob.slice(blob.l, blob.l + length));
		if(R && R.f) {
			if(options.bookSheets) {
				if(last_Rn === 'BoundSheet8' && R.n !== 'BoundSheet8') break;
			}
			last_Rn = R.n;
			if(R.r === 2 || R.r == 12) {
				var rt = blob.read_shift(2); length -= 2;
				if(!opts.enc && rt !== RecordType && (((rt&0xFF)<<8)|(rt>>8)) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
				if(R.r == 12){ blob.l += 10; length -= 10; } // skip FRT
			}
			//console.error(R,blob.l,length,blob.length);
			var val;
			if(R.n === 'EOF') val = R.f(blob, length, opts);
			else val = slurp(R, blob, length, opts);
			var Rn = R.n;
			if(file_depth == 0 && Rn != 'BOF') continue;
			/* nested switch statements to workaround V8 128 limit */
			switch(Rn) {
				/* Workbook Options */
				case 'Date1904':
wb.opts.Date1904 = Workbook.WBProps.date1904 = val; break;
				case 'WriteProtect': wb.opts.WriteProtect = true; break;
				case 'FilePass':
					if(!opts.enc) blob.l = 0;
					opts.enc = val;
					if(!options.password) throw new Error("File is password-protected");
					if(val.valid == null) throw new Error("Encryption scheme unsupported");
					if(!val.valid) throw new Error("Password is incorrect");
					break;
				case 'WriteAccess': opts.lastuser = val; break;
				case 'FileSharing': break; //TODO
				case 'CodePage':
					/* overrides based on test cases */
					switch(val) {
						case 0x5212: val =  1200; break;
						case 0x8000: val = 10000; break;
						case 0x8001: val =  1252; break;
					}
					set_cp(opts.codepage = val);
					seen_codepage = true;
					break;
				case 'RRTabId': opts.rrtabid = val; break;
				case 'WinProtect': opts.winlocked = val; break;
				case 'Template': break; // TODO
				case 'BookBool': break; // TODO
				case 'UsesELFs': break;
				case 'MTRSettings': break;
				case 'RefreshAll':
				case 'CalcCount':
				case 'CalcDelta':
				case 'CalcIter':
				case 'CalcMode':
				case 'CalcPrecision':
				case 'CalcSaveRecalc':
					wb.opts[Rn] = val; break;
				case 'CalcRefMode': opts.CalcRefMode = val; break; // TODO: implement R1C1
				case 'Uncalced': break;
				case 'ForceFullCalculation': wb.opts.FullCalc = val; break;
				case 'WsBool':
					if(val.fDialog) out["!type"] = "dialog";
					break; // TODO
				case 'XF': XFs.push(val); break;
				case 'ExtSST': break; // TODO
				case 'BookExt': break; // TODO
				case 'RichTextStream': break;
				case 'BkHim': break;

				case 'SupBook':
					supbooks.push([val]);
					supbooks[supbooks.length-1].XTI = [];
					break;
				case 'ExternName':
					supbooks[supbooks.length-1].push(val);
					break;
				case 'Index': break; // TODO
				case 'Lbl':
					last_lbl = ({
						Name: val.Name,
						Ref: stringify_formula(val.rgce,range,null,supbooks,opts)
					});
					if(val.itab > 0) last_lbl.Sheet = val.itab - 1;
					supbooks.names.push(last_lbl);
					if(!supbooks[0]) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length-1].push(val);
					if(val.Name == "_xlnm._FilterDatabase" && val.itab > 0)
						if(val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == 'PtgArea3d')
							FilterDatabases[val.itab - 1] = { ref: encode_range(val.rgce[0][0][1][2]) };
					break;
				case 'ExternCount': opts.ExternCount = val; break;
				case 'ExternSheet':
					if(supbooks.length == 0) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val); supbooks.XTI = supbooks.XTI.concat(val); break;
				case 'NameCmt':
					/* TODO: search for correct name */
					if(opts.biff < 8) break;
					if(last_lbl != null) last_lbl.Comment = val[1];
					break;

				case 'Protect': out["!protect"] = val; break; /* for sheet or book */
				case 'Password': if(val !== 0 && opts.WTF) console.error("Password verifier: " + val); break;
				case 'Prot4Rev': case 'Prot4RevPass': break; /*TODO: Revision Control*/

				case 'BoundSheet8': {
					Directory[val.pos] = val;
					opts.snames.push(val.name);
				} break;
				case 'EOF': {
					if(--file_depth) break;
					if(range.e) {
						if(range.e.r > 0 && range.e.c > 0) {
							range.e.r--; range.e.c--;
							out["!ref"] = encode_range(range);
							if(options.sheetRows && options.sheetRows <= range.e.r) {
								var tmpri = range.e.r;
								range.e.r = options.sheetRows - 1;
								out["!fullref"] = out["!ref"];
								out["!ref"] = encode_range(range);
								range.e.r = tmpri;
							}
							range.e.r++; range.e.c++;
						}
						if(merges.length > 0) out["!merges"] = merges;
						if(objects.length > 0) out["!objects"] = objects;
						if(colinfo.length > 0) out["!cols"] = colinfo;
						if(rowinfo.length > 0) out["!rows"] = rowinfo;
						Workbook.Sheets.push(wsprops);
					}
					if(cur_sheet === "") Preamble = out; else Sheets[cur_sheet] = out;
					out = ((options.dense ? [] : {}));
				} break;
				case 'BOF': {
					if(opts.biff === 8) opts.biff = {
0x0009:2,
0x0209:3,
0x0409:4
					}[RecordType] || {
0x0200:2,
0x0300:3,
0x0400:4,
0x0500:5,
0x0600:8,
0x0002:2,
0x0007:2
					}[val.BIFFVer] || 8;
					if(opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
					if(file_depth++) break;
					cell_valid = true;
					out = ((options.dense ? [] : {}));

					if(opts.biff < 8 && !seen_codepage) { seen_codepage = true; set_cp(opts.codepage = options.codepage || 1252); }
					if(opts.biff < 5) {
						if(cur_sheet === "") cur_sheet = "Sheet1";
						range = {s:{r:0,c:0},e:{r:0,c:0}};
						/* fake BoundSheet8 */
						var fakebs8 = {pos: blob.l - length, name:cur_sheet};
						Directory[fakebs8.pos] = fakebs8;
						opts.snames.push(cur_sheet);
					}
					else cur_sheet = (Directory[s] || {name:""}).name;
					if(val.dt == 0x20) out["!type"] = "chart";
					if(val.dt == 0x40) out["!type"] = "macro";
					merges = [];
					objects = [];
					opts.arrayf = arrayf = [];
					colinfo = []; rowinfo = [];
					defwidth = defheight = 0;
					seencol = false;
					wsprops = {Hidden:(Directory[s]||{hs:0}).hs, name:cur_sheet };
				} break;

				case 'Number': case 'BIFF2NUM': case 'BIFF2INT': {
					if(out["!type"] == "chart") if(options.dense ? (out[val.r]||[])[val.c]: out[encode_cell({c:val.c, r:val.r})]) ++val.c;
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe]||{}, v:val.val, t:'n'});
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 'BoolErr': {
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.val, t:val.t});
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 'RK': {
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.rknum, t:'n'});
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 'MulRk': {
					for(var j = val.c; j <= val.C; ++j) {
						var ixfe = val.rkrec[j-val.c][0];
						temp_val= ({ixfe:ixfe, XF:XFs[ixfe], v:val.rkrec[j-val.c][1], t:'n'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:j, r:val.r}, temp_val, options);
					}
				} break;
				case 'Formula': {
					if(val.val == 'String') { last_formula = val; break; }
					temp_val = make_cell(val.val, val.cell.ixfe, val.tt);
					temp_val.XF = XFs[temp_val.ixfe];
					if(options.cellFormula) {
						var _f = val.formula;
						if(_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
							var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
							var _fe = encode_cell({r:_fr, c:_fc});
							if(sharedf[_fe]) temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
							else temp_val.F = ((options.dense ? (out[_fr]||[])[_fc]: out[_fe]) || {}).F;
						} else temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
					}
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell(val.cell, temp_val, options);
					last_formula = val;
				} break;
				case 'String': {
					if(last_formula) { /* technically always true */
						last_formula.val = val;
						temp_val = make_cell(val, last_formula.cell.ixfe, 's');
						temp_val.XF = XFs[temp_val.ixfe];
						if(options.cellFormula) {
							temp_val.f = ""+stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
						}
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell(last_formula.cell, temp_val, options);
						last_formula = null;
					} else throw new Error("String record expects Formula");
				} break;
				case 'Array': {
					arrayf.push(val);
					var _arraystart = encode_cell(val[0].s);
					cc = options.dense ? (out[val[0].s.r]||[])[val[0].s.c] : out[_arraystart];
					if(options.cellFormula && cc) {
						if(!last_formula) break; /* technically unreachable */
						if(!_arraystart || !cc) break;
						cc.f = ""+stringify_formula(val[1], range, val[0], supbooks, opts);
						cc.F = encode_range(val[0]);
					}
				} break;
				case 'ShrFmla': {
					if(!cell_valid) break;
					if(!options.cellFormula) break;
					if(last_cell) {
						/* TODO: capture range */
						if(!last_formula) break; /* technically unreachable */
						sharedf[encode_cell(last_formula.cell)]= val[0];
						cc = options.dense ? (out[last_formula.cell.r]||[])[last_formula.cell.c] : out[encode_cell(last_formula.cell)];
						(cc||{}).f = ""+stringify_formula(val[0], range, lastcell, supbooks, opts);
					}
				} break;
				case 'LabelSst':
					temp_val=make_cell(sst[val.isst].t, val.ixfe, 's');
					temp_val.XF = XFs[temp_val.ixfe];
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
					break;
				case 'Blank': if(options.sheetStubs) {
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], t:'z'});
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 'MulBlank': if(options.sheetStubs) {
					for(var _j = val.c; _j <= val.C; ++_j) {
						var _ixfe = val.ixfe[_j-val.c];
						temp_val= ({ixfe:_ixfe, XF:XFs[_ixfe], t:'z'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:_j, r:val.r}, temp_val, options);
					}
				} break;
				case 'RString':
				case 'Label': case 'BIFF2STR':
					temp_val=make_cell(val.val, val.ixfe, 's');
					temp_val.XF = XFs[temp_val.ixfe];
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
					break;

				case 'Dimensions': {
					if(file_depth === 1) range = val; /* TODO: stack */
				} break;
				case 'SST': {
					sst = val;
				} break;
				case 'Format': { /* val = [id, fmt] */
					if(opts.biff == 4) {
						BIFF2FmtTable[BIFF2Fmt++] = val[1];
						for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx) if(SSF._table[b4idx] == val[1]) break;
						if(b4idx >= 163) SSF.load(val[1], BIFF2Fmt + 163);
					}
					else SSF.load(val[1], val[0]);
				} break;
				case 'BIFF2FORMAT': {
					BIFF2FmtTable[BIFF2Fmt++] = val;
					for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx) if(SSF._table[b2idx] == val) break;
					if(b2idx >= 163) SSF.load(val, BIFF2Fmt + 163);
				} break;

				case 'MergeCells': merges = merges.concat(val); break;

				case 'Obj': objects[val.cmo[0]] = opts.lastobj = val; break;
				case 'TxO': opts.lastobj.TxO = val; break;
				case 'ImData': opts.lastobj.ImData = val; break;

				case 'HLink': {
					for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
						for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
							cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
							if(cc) cc.l = val[1];
						}
				} break;
				case 'HLinkTooltip': {
					for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
						for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
							cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
							if(cc && cc.l) cc.l.Tooltip = val[1];
							}
				} break;

				/* Comments */
				case 'Note': {
					if(opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */
					cc = options.dense ? (out[val[0].r]||[])[val[0].c] : out[encode_cell(val[0])];
					var noteobj = objects[val[2]];
					if(!cc) break;
					if(!cc.c) cc.c = [];
					cmnt = {a:val[1],t:noteobj.TxO.t};
					cc.c.push(cmnt);
				} break;

				default: switch(R.n) { /* nested */
				case 'ClrtClient': break;
				case 'XFExt': update_xfext(XFs[val.ixfe], val.ext); break;

				case 'DefColWidth': defwidth = val; break;
				case 'DefaultRowHeight': defheight = val[1]; break; // TODO: flags

				case 'ColInfo': {
					if(!opts.cellStyles) break;
					while(val.e >= val.s) {
						colinfo[val.e--] = { width: val.w/256 };
						if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
						process_col(colinfo[val.e+1]);
					}
				} break;
				case 'Row': {
					var rowobj = {};
					if(val.level != null) { rowinfo[val.r] = rowobj; rowobj.level = val.level; }
					if(val.hidden) { rowinfo[val.r] = rowobj; rowobj.hidden = true; }
					if(val.hpt) {
						rowinfo[val.r] = rowobj;
						rowobj.hpt = val.hpt; rowobj.hpx = pt2px(val.hpt);
					}
				} break;

				case 'LeftMargin':
				case 'RightMargin':
				case 'TopMargin':
				case 'BottomMargin':
					if(!out['!margins']) default_margins(out['!margins'] = {});
					out['!margins'][Rn.slice(0,-6).toLowerCase()] = val;
					break;

				case 'Setup': // TODO
					if(!out['!margins']) default_margins(out['!margins'] = {});
					out['!margins'].header = val.header;
					out['!margins'].footer = val.footer;
					break;

				case 'Window2': // TODO
					// $FlowIgnore
					if(val.RTL) Workbook.Views[0].RTL = true;
					break;

				case 'Header': break; // TODO
				case 'Footer': break; // TODO
				case 'HCenter': break; // TODO
				case 'VCenter': break; // TODO
				case 'Pls': break; // TODO
				case 'GCW': break;
				case 'LHRecord': break;
				case 'DBCell': break; // TODO
				case 'EntExU2': break; // TODO
				case 'SxView': break; // TODO
				case 'Sxvd': break; // TODO
				case 'SXVI': break; // TODO
				case 'SXVDEx': break; // TODO
				case 'SxIvd': break; // TODO
				case 'SXString': break; // TODO
				case 'Sync': break;
				case 'Addin': break;
				case 'SXDI': break; // TODO
				case 'SXLI': break; // TODO
				case 'SXEx': break; // TODO
				case 'QsiSXTag': break; // TODO
				case 'Selection': break;
				case 'Feat': break;
				case 'FeatHdr': case 'FeatHdr11': break;
				case 'Feature11': case 'Feature12': case 'List12': break;
				case 'Country': country = val; break;
				case 'RecalcId': break;
				case 'DxGCol': break; // TODO: htmlify
				case 'Fbi': case 'Fbi2': case 'GelFrame': break;
				case 'Font': break; // TODO
				case 'XFCRC': break; // TODO
				case 'Style': break; // TODO
				case 'StyleExt': break; // TODO
				case 'Palette': palette = val; break;
				case 'Theme': themes = val; break;
				/* Protection */
				case 'ScenarioProtect': break;
				case 'ObjProtect': break;

				/* Conditional Formatting */
				case 'CondFmt12': break;

				/* Table */
				case 'Table': break; // TODO
				case 'TableStyles': break; // TODO
				case 'TableStyle': break; // TODO
				case 'TableStyleElement': break; // TODO

				/* PivotTable */
				case 'SXStreamID': break; // TODO
				case 'SXVS': break; // TODO
				case 'DConRef': break; // TODO
				case 'SXAddl': break; // TODO
				case 'DConBin': break; // TODO
				case 'DConName': break; // TODO
				case 'SXPI': break; // TODO
				case 'SxFormat': break; // TODO
				case 'SxSelect': break; // TODO
				case 'SxRule': break; // TODO
				case 'SxFilt': break; // TODO
				case 'SxItm': break; // TODO
				case 'SxDXF': break; // TODO

				/* Scenario Manager */
				case 'ScenMan': break;

				/* Data Consolidation */
				case 'DCon': break;

				/* Watched Cell */
				case 'CellWatch': break;

				/* Print Settings */
				case 'PrintRowCol': break;
				case 'PrintGrid': break;
				case 'PrintSize': break;

				case 'XCT': break;
				case 'CRN': break;

				case 'Scl': {
					//console.log("Zoom Level:", val[0]/val[1],val);
				} break;
				case 'SheetExt': {
					/* empty */
				} break;
				case 'SheetExtOptional': {
					/* empty */
				} break;

				/* VBA */
				case 'ObNoMacros': {
					/* empty */
				} break;
				case 'ObProj': {
					/* empty */
				} break;
				case 'CodeName': {
if(!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
					else wsprops.CodeName = val || wsprops.name;
				} break;
				case 'GUIDTypeLib': {
					/* empty */
				} break;

				case 'WOpt': break; // TODO: WTF?
				case 'PhoneticInfo': break;

				case 'OleObjectSize': break;

				/* Differential Formatting */
				case 'DXF': case 'DXFN': case 'DXFN12': case 'DXFN12List': case 'DXFN12NoCB': break;

				/* Data Validation */
				case 'Dv': case 'DVal': break;

				/* Data Series */
				case 'BRAI': case 'Series': case 'SeriesText': break;

				/* Data Connection */
				case 'DConn': break;
				case 'DbOrParamQry': break;
				case 'DBQueryExt': break;

				case 'OleDbConn': break;
				case 'ExtString': break;

				/* Formatting */
				case 'IFmtRecord': break;
				case 'CondFmt': case 'CF': case 'CF12': case 'CFEx': break;

				/* Explicitly Ignored */
				case 'Excel9File': break;
				case 'Units': break;
				case 'InterfaceHdr': case 'Mms': case 'InterfaceEnd': case 'DSF': break;
				case 'BuiltInFnGroupCount': /* 2.4.30 0x0E or 0x10 but excel 2011 generates 0x11? */ break;
				/* View Stuff */
				case 'Window1': case 'HideObj': case 'GridSet': case 'Guts':
				case 'UserBView': case 'UserSViewBegin': case 'UserSViewEnd':
				case 'Pane': break;
				default: switch(R.n) { /* nested */
				/* Chart */
				case 'Dat':
				case 'Begin': case 'End':
				case 'StartBlock': case 'EndBlock':
				case 'Frame': case 'Area':
				case 'Axis': case 'AxisLine': case 'Tick': break;
				case 'AxesUsed':
				case 'CrtLayout12': case 'CrtLayout12A': case 'CrtLink': case 'CrtLine': case 'CrtMlFrt': case 'CrtMlFrtContinue': break;
				case 'LineFormat': case 'AreaFormat':
				case 'Chart': case 'Chart3d': case 'Chart3DBarShape': case 'ChartFormat': case 'ChartFrtInfo': break;
				case 'PlotArea': case 'PlotGrowth': break;
				case 'SeriesList': case 'SerParent': case 'SerAuxTrend': break;
				case 'DataFormat': case 'SerToCrt': case 'FontX': break;
				case 'CatSerRange': case 'AxcExt': case 'SerFmt': break;
				case 'ShtProps': break;
				case 'DefaultText': case 'Text': case 'CatLab': break;
				case 'DataLabExtContents': break;
				case 'Legend': case 'LegendException': break;
				case 'Pie': case 'Scatter': break;
				case 'PieFormat': case 'MarkerFormat': break;
				case 'StartObject': case 'EndObject': break;
				case 'AlRuns': case 'ObjectLink': break;
				case 'SIIndex': break;
				case 'AttachedLabel': case 'YMult': break;

				/* Chart Group */
				case 'Line': case 'Bar': break;
				case 'Surf': break;

				/* Axis Group */
				case 'AxisParent': break;
				case 'Pos': break;
				case 'ValueRange': break;

				/* Pivot Chart */
				case 'SXViewEx9': break; // TODO
				case 'SXViewLink': break;
				case 'PivotChartBits': break;
				case 'SBaseRef': break;
				case 'TextPropsStream': break;

				/* Chart Misc */
				case 'LnExt': break;
				case 'MkrExt': break;
				case 'CrtCoopt': break;

				/* Query Table */
				case 'Qsi': case 'Qsif': case 'Qsir': case 'QsiSXTag': break;
				case 'TxtQry': break;

				/* Filter */
				case 'FilterMode': break;
				case 'AutoFilter': case 'AutoFilterInfo': break;
				case 'AutoFilter12': break;
				case 'DropDownObjIds': break;
				case 'Sort': break;
				case 'SortData': break;

				/* Drawing */
				case 'ShapePropsStream': break;
				case 'MsoDrawing': case 'MsoDrawingGroup': case 'MsoDrawingSelection': break;
				/* Pub Stuff */
				case 'WebPub': case 'AutoWebPub': break;

				/* Print Stuff */
				case 'HeaderFooter': case 'HFPicture': case 'PLV':
				case 'HorizontalPageBreaks': case 'VerticalPageBreaks': break;
				/* Behavioral */
				case 'Backup': case 'CompressPictures': case 'Compat12': break;

				/* Should not Happen */
				case 'Continue': case 'ContinueFrt12': break;

				/* Future Records */
				case 'FrtFontList': case 'FrtWrapper': break;

				default: switch(R.n) { /* nested */
				/* BIFF5 records */
				case 'TabIdConf': case 'Radar': case 'RadarArea': case 'DropBar': case 'Intl': case 'CoordList': case 'SerAuxErrBar': break;

				/* BIFF2-4 records */
				case 'BIFF2FONTCLR': case 'BIFF2FMTCNT': case 'BIFF2FONTXTRA': break;
				case 'BIFF2XF': case 'BIFF3XF': case 'BIFF4XF': break;
				case 'BIFF4FMTCNT': case 'BIFF2ROW': case 'BIFF2WINDOW2': break;

				/* Miscellaneous */
				case 'SCENARIO': case 'DConBin': case 'PicF': case 'DataLabExt':
				case 'Lel': case 'BopPop': case 'BopPopCustom': case 'RealTimeData':
				case 'Name': break;
				case 'LHNGraph': case 'FnGroupName': case 'AddMenu': case 'LPr': break;
				case 'ListObj': case 'ListField': break;
				case 'RRSort': break;
				case 'BigName': break;
				case 'ToolbarHdr': case 'ToolbarEnd': break;
				case 'DDEObjName': break;
				case 'FRTArchId$': break;
				default: if(options.WTF) throw 'Unrecognized Record ' + R.n;
			}}}}
		} else blob.l += length;
	}
	wb.SheetNames=keys(Directory).sort(function(a,b) { return Number(a) - Number(b); }).map(function(x){return Directory[x].name;});
	if(!options.bookSheets) wb.Sheets=Sheets;
	if(wb.Sheets) FilterDatabases.forEach(function(r,i) { wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r; });
	wb.Preamble=Preamble;
	wb.Strings = sst;
	wb.SSF = SSF.get_table();
	if(opts.enc) wb.Encryption = opts.enc;
	if(themes) wb.Themes = themes;
	wb.Metadata = {};
	if(country !== undefined) wb.Metadata.Country = country;
	if(supbooks.names.length > 0) Workbook.Names = supbooks.names;
	wb.Workbook = Workbook;
	return wb;
}

/* TODO: split props*/
var PSCLSID = {
	SI: "e0859ff2f94f6810ab9108002b27b3d9",
	DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
	UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function parse_xls_props(cfb, props, o) {
	/* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */
	var DSI = CFB.find(cfb, '!DocumentSummaryInformation');
	if(DSI && DSI.size > 0) try {
		var DocSummary = parse_PropertySetStream(DSI, DocSummaryPIDDSI, PSCLSID.DSI);
		for(var d in DocSummary) props[d] = DocSummary[d];
	} catch(e) {if(o.WTF) throw e;/* empty */}

	/* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/
	var SI = CFB.find(cfb, '!SummaryInformation');
	if(SI && SI.size > 0) try {
		var Summary = parse_PropertySetStream(SI, SummaryPIDSI, PSCLSID.SI);
		for(var s in Summary) if(props[s] == null) props[s] = Summary[s];
	} catch(e) {if(o.WTF) throw e;/* empty */}

	if(props.HeadingPairs && props.TitlesOfParts) {
		load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
		delete props.HeadingPairs; delete props.TitlesOfParts;
	}
}
function write_xls_props(wb, cfb) {
	var DSEntries = [], SEntries = [], CEntries = [];
	var i = 0, Keys;
	if(wb.Props) {
		Keys = keys(wb.Props);
		// $FlowIgnore
		for(i = 0; i < Keys.length; ++i) (DocSummaryRE.hasOwnProperty(Keys[i]) ? DSEntries : SummaryRE.hasOwnProperty(Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Props[Keys[i]]]);
	}
	if(wb.Custprops) {
		Keys = keys(wb.Custprops);
		// $FlowIgnore
		for(i = 0; i < Keys.length; ++i) if(!(wb.Props||{}).hasOwnProperty(Keys[i])) (DocSummaryRE.hasOwnProperty(Keys[i]) ? DSEntries : SummaryRE.hasOwnProperty(Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Custprops[Keys[i]]]);
	}
	var CEntries2 = [];
	for(i = 0; i < CEntries.length; ++i) {
		if(XLSPSSkip.indexOf(CEntries[i][0]) > -1) continue;
		if(CEntries[i][1] == null) continue;
		CEntries2.push(CEntries[i]);
	}
	if(SEntries.length) CFB.utils.cfb_add(cfb, "/\u0005SummaryInformation", write_PropertySetStream(SEntries, PSCLSID.SI, SummaryRE, SummaryPIDSI));
	if(DSEntries.length || CEntries2.length) CFB.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", write_PropertySetStream(DSEntries, PSCLSID.DSI, DocSummaryRE, DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, PSCLSID.UDI));
}

function parse_xlscfb(cfb, options) {
if(!options) options = {};
fix_read_opts(options);
reset_cp();
if(options.codepage) set_ansi(options.codepage);
var CompObj, WB;
if(cfb.FullPaths) {
	if(CFB.find(cfb, '/encryption')) throw new Error("File is password-protected");
	CompObj = CFB.find(cfb, '!CompObj');
	WB = CFB.find(cfb, '/Workbook') || CFB.find(cfb, '/Book');
} else {
	switch(options.type) {
		case 'base64': cfb = s2a(Base64.decode(cfb)); break;
		case 'binary': cfb = s2a(cfb); break;
		case 'buffer': break;
		case 'array': if(!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb); break;
	}
	prep_blob(cfb, 0);
	WB = ({content: cfb});
}
var WorkbookP;

var _data;
if(CompObj) parse_compobj(CompObj);
if(options.bookProps && !options.bookSheets) WorkbookP = ({});
else {
	var T = has_buf ? 'buffer' : 'array';
	if(WB && WB.content) WorkbookP = parse_workbook(WB.content, options);
	/* Quattro Pro 7-8 */
	else if((_data=CFB.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
	/* Quattro Pro 9 */
	else if((_data=CFB.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
	else throw new Error("Cannot find Workbook stream");
	if(options.bookVBA && cfb.FullPaths && CFB.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = make_vba_xls(cfb);
}

var props = {};
if(cfb.FullPaths) parse_xls_props(cfb, props, options);

WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */
if(options.bookFiles) WorkbookP.cfb = cfb;
/*WorkbookP.CompObjP = CompObjP; // TODO: storage? */
return WorkbookP;
}


function write_xlscfb(wb, opts) {
	var o = opts || {};
	var cfb = CFB.utils.cfb_new({root:"R"});
	var wbpath = "/Workbook";
	switch(o.bookType || "xls") {
		case "xls": o.bookType = "biff8";
		/* falls through */
		case "xla": if(!o.bookType) o.bookType = "xla";
		/* falls through */
		case "biff8": wbpath = "/Workbook"; o.biff = 8; break;
		case "biff5": wbpath = "/Book"; o.biff = 5; break;
		default: throw new Error("invalid type " + o.bookType + " for XLS CFB");
	}
	CFB.utils.cfb_add(cfb, wbpath, write_biff_buf(wb, o));
	if(o.biff == 8 && (wb.Props || wb.Custprops)) write_xls_props(wb, cfb);
	// TODO: SI, DSI, CO
	if(o.biff == 8 && wb.vbaraw) fill_vba_xls(cfb, CFB.read(wb.vbaraw, {type: typeof wb.vbaraw == "string" ? "binary" : "buffer"}));
	return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */
var XLSBRecordEnum = {
0x0000: { n:"BrtRowHdr", f:parse_BrtRowHdr },
0x0001: { n:"BrtCellBlank", f:parse_BrtCellBlank },
0x0002: { n:"BrtCellRk", f:parse_BrtCellRk },
0x0003: { n:"BrtCellError", f:parse_BrtCellError },
0x0004: { n:"BrtCellBool", f:parse_BrtCellBool },
0x0005: { n:"BrtCellReal", f:parse_BrtCellReal },
0x0006: { n:"BrtCellSt", f:parse_BrtCellSt },
0x0007: { n:"BrtCellIsst", f:parse_BrtCellIsst },
0x0008: { n:"BrtFmlaString", f:parse_BrtFmlaString },
0x0009: { n:"BrtFmlaNum", f:parse_BrtFmlaNum },
0x000A: { n:"BrtFmlaBool", f:parse_BrtFmlaBool },
0x000B: { n:"BrtFmlaError", f:parse_BrtFmlaError },
0x0010: { n:"BrtFRTArchID$", f:parse_BrtFRTArchID$ },
0x0013: { n:"BrtSSTItem", f:parse_RichStr },
0x0014: { n:"BrtPCDIMissing" },
0x0015: { n:"BrtPCDINumber" },
0x0016: { n:"BrtPCDIBoolean" },
0x0017: { n:"BrtPCDIError" },
0x0018: { n:"BrtPCDIString" },
0x0019: { n:"BrtPCDIDatetime" },
0x001A: { n:"BrtPCDIIndex" },
0x001B: { n:"BrtPCDIAMissing" },
0x001C: { n:"BrtPCDIANumber" },
0x001D: { n:"BrtPCDIABoolean" },
0x001E: { n:"BrtPCDIAError" },
0x001F: { n:"BrtPCDIAString" },
0x0020: { n:"BrtPCDIADatetime" },
0x0021: { n:"BrtPCRRecord" },
0x0022: { n:"BrtPCRRecordDt" },
0x0023: { n:"BrtFRTBegin" },
0x0024: { n:"BrtFRTEnd" },
0x0025: { n:"BrtACBegin" },
0x0026: { n:"BrtACEnd" },
0x0027: { n:"BrtName", f:parse_BrtName },
0x0028: { n:"BrtIndexRowBlock" },
0x002A: { n:"BrtIndexBlock" },
0x002B: { n:"BrtFont", f:parse_BrtFont },
0x002C: { n:"BrtFmt", f:parse_BrtFmt },
0x002D: { n:"BrtFill", f:parse_BrtFill },
0x002E: { n:"BrtBorder", f:parse_BrtBorder },
0x002F: { n:"BrtXF", f:parse_BrtXF },
0x0030: { n:"BrtStyle" },
0x0031: { n:"BrtCellMeta" },
0x0032: { n:"BrtValueMeta" },
0x0033: { n:"BrtMdb" },
0x0034: { n:"BrtBeginFmd" },
0x0035: { n:"BrtEndFmd" },
0x0036: { n:"BrtBeginMdx" },
0x0037: { n:"BrtEndMdx" },
0x0038: { n:"BrtBeginMdxTuple" },
0x0039: { n:"BrtEndMdxTuple" },
0x003A: { n:"BrtMdxMbrIstr" },
0x003B: { n:"BrtStr" },
0x003C: { n:"BrtColInfo", f:parse_ColInfo },
0x003E: { n:"BrtCellRString" },
0x003F: { n:"BrtCalcChainItem$", f:parse_BrtCalcChainItem$ },
0x0040: { n:"BrtDVal" },
0x0041: { n:"BrtSxvcellNum" },
0x0042: { n:"BrtSxvcellStr" },
0x0043: { n:"BrtSxvcellBool" },
0x0044: { n:"BrtSxvcellErr" },
0x0045: { n:"BrtSxvcellDate" },
0x0046: { n:"BrtSxvcellNil" },
0x0080: { n:"BrtFileVersion" },
0x0081: { n:"BrtBeginSheet" },
0x0082: { n:"BrtEndSheet" },
0x0083: { n:"BrtBeginBook", f:parsenoop, p:0 },
0x0084: { n:"BrtEndBook" },
0x0085: { n:"BrtBeginWsViews" },
0x0086: { n:"BrtEndWsViews" },
0x0087: { n:"BrtBeginBookViews" },
0x0088: { n:"BrtEndBookViews" },
0x0089: { n:"BrtBeginWsView", f:parse_BrtBeginWsView },
0x008A: { n:"BrtEndWsView" },
0x008B: { n:"BrtBeginCsViews" },
0x008C: { n:"BrtEndCsViews" },
0x008D: { n:"BrtBeginCsView" },
0x008E: { n:"BrtEndCsView" },
0x008F: { n:"BrtBeginBundleShs" },
0x0090: { n:"BrtEndBundleShs" },
0x0091: { n:"BrtBeginSheetData" },
0x0092: { n:"BrtEndSheetData" },
0x0093: { n:"BrtWsProp", f:parse_BrtWsProp },
0x0094: { n:"BrtWsDim", f:parse_BrtWsDim, p:16 },
0x0097: { n:"BrtPane" },
0x0098: { n:"BrtSel" },
0x0099: { n:"BrtWbProp", f:parse_BrtWbProp },
0x009A: { n:"BrtWbFactoid" },
0x009B: { n:"BrtFileRecover" },
0x009C: { n:"BrtBundleSh", f:parse_BrtBundleSh },
0x009D: { n:"BrtCalcProp" },
0x009E: { n:"BrtBookView" },
0x009F: { n:"BrtBeginSst", f:parse_BrtBeginSst },
0x00A0: { n:"BrtEndSst" },
0x00A1: { n:"BrtBeginAFilter", f:parse_UncheckedRfX },
0x00A2: { n:"BrtEndAFilter" },
0x00A3: { n:"BrtBeginFilterColumn" },
0x00A4: { n:"BrtEndFilterColumn" },
0x00A5: { n:"BrtBeginFilters" },
0x00A6: { n:"BrtEndFilters" },
0x00A7: { n:"BrtFilter" },
0x00A8: { n:"BrtColorFilter" },
0x00A9: { n:"BrtIconFilter" },
0x00AA: { n:"BrtTop10Filter" },
0x00AB: { n:"BrtDynamicFilter" },
0x00AC: { n:"BrtBeginCustomFilters" },
0x00AD: { n:"BrtEndCustomFilters" },
0x00AE: { n:"BrtCustomFilter" },
0x00AF: { n:"BrtAFilterDateGroupItem" },
0x00B0: { n:"BrtMergeCell", f:parse_BrtMergeCell },
0x00B1: { n:"BrtBeginMergeCells" },
0x00B2: { n:"BrtEndMergeCells" },
0x00B3: { n:"BrtBeginPivotCacheDef" },
0x00B4: { n:"BrtEndPivotCacheDef" },
0x00B5: { n:"BrtBeginPCDFields" },
0x00B6: { n:"BrtEndPCDFields" },
0x00B7: { n:"BrtBeginPCDField" },
0x00B8: { n:"BrtEndPCDField" },
0x00B9: { n:"BrtBeginPCDSource" },
0x00BA: { n:"BrtEndPCDSource" },
0x00BB: { n:"BrtBeginPCDSRange" },
0x00BC: { n:"BrtEndPCDSRange" },
0x00BD: { n:"BrtBeginPCDFAtbl" },
0x00BE: { n:"BrtEndPCDFAtbl" },
0x00BF: { n:"BrtBeginPCDIRun" },
0x00C0: { n:"BrtEndPCDIRun" },
0x00C1: { n:"BrtBeginPivotCacheRecords" },
0x00C2: { n:"BrtEndPivotCacheRecords" },
0x00C3: { n:"BrtBeginPCDHierarchies" },
0x00C4: { n:"BrtEndPCDHierarchies" },
0x00C5: { n:"BrtBeginPCDHierarchy" },
0x00C6: { n:"BrtEndPCDHierarchy" },
0x00C7: { n:"BrtBeginPCDHFieldsUsage" },
0x00C8: { n:"BrtEndPCDHFieldsUsage" },
0x00C9: { n:"BrtBeginExtConnection" },
0x00CA: { n:"BrtEndExtConnection" },
0x00CB: { n:"BrtBeginECDbProps" },
0x00CC: { n:"BrtEndECDbProps" },
0x00CD: { n:"BrtBeginECOlapProps" },
0x00CE: { n:"BrtEndECOlapProps" },
0x00CF: { n:"BrtBeginPCDSConsol" },
0x00D0: { n:"BrtEndPCDSConsol" },
0x00D1: { n:"BrtBeginPCDSCPages" },
0x00D2: { n:"BrtEndPCDSCPages" },
0x00D3: { n:"BrtBeginPCDSCPage" },
0x00D4: { n:"BrtEndPCDSCPage" },
0x00D5: { n:"BrtBeginPCDSCPItem" },
0x00D6: { n:"BrtEndPCDSCPItem" },
0x00D7: { n:"BrtBeginPCDSCSets" },
0x00D8: { n:"BrtEndPCDSCSets" },
0x00D9: { n:"BrtBeginPCDSCSet" },
0x00DA: { n:"BrtEndPCDSCSet" },
0x00DB: { n:"BrtBeginPCDFGroup" },
0x00DC: { n:"BrtEndPCDFGroup" },
0x00DD: { n:"BrtBeginPCDFGItems" },
0x00DE: { n:"BrtEndPCDFGItems" },
0x00DF: { n:"BrtBeginPCDFGRange" },
0x00E0: { n:"BrtEndPCDFGRange" },
0x00E1: { n:"BrtBeginPCDFGDiscrete" },
0x00E2: { n:"BrtEndPCDFGDiscrete" },
0x00E3: { n:"BrtBeginPCDSDTupleCache" },
0x00E4: { n:"BrtEndPCDSDTupleCache" },
0x00E5: { n:"BrtBeginPCDSDTCEntries" },
0x00E6: { n:"BrtEndPCDSDTCEntries" },
0x00E7: { n:"BrtBeginPCDSDTCEMembers" },
0x00E8: { n:"BrtEndPCDSDTCEMembers" },
0x00E9: { n:"BrtBeginPCDSDTCEMember" },
0x00EA: { n:"BrtEndPCDSDTCEMember" },
0x00EB: { n:"BrtBeginPCDSDTCQueries" },
0x00EC: { n:"BrtEndPCDSDTCQueries" },
0x00ED: { n:"BrtBeginPCDSDTCQuery" },
0x00EE: { n:"BrtEndPCDSDTCQuery" },
0x00EF: { n:"BrtBeginPCDSDTCSets" },
0x00F0: { n:"BrtEndPCDSDTCSets" },
0x00F1: { n:"BrtBeginPCDSDTCSet" },
0x00F2: { n:"BrtEndPCDSDTCSet" },
0x00F3: { n:"BrtBeginPCDCalcItems" },
0x00F4: { n:"BrtEndPCDCalcItems" },
0x00F5: { n:"BrtBeginPCDCalcItem" },
0x00F6: { n:"BrtEndPCDCalcItem" },
0x00F7: { n:"BrtBeginPRule" },
0x00F8: { n:"BrtEndPRule" },
0x00F9: { n:"BrtBeginPRFilters" },
0x00FA: { n:"BrtEndPRFilters" },
0x00FB: { n:"BrtBeginPRFilter" },
0x00FC: { n:"BrtEndPRFilter" },
0x00FD: { n:"BrtBeginPNames" },
0x00FE: { n:"BrtEndPNames" },
0x00FF: { n:"BrtBeginPName" },
0x0100: { n:"BrtEndPName" },
0x0101: { n:"BrtBeginPNPairs" },
0x0102: { n:"BrtEndPNPairs" },
0x0103: { n:"BrtBeginPNPair" },
0x0104: { n:"BrtEndPNPair" },
0x0105: { n:"BrtBeginECWebProps" },
0x0106: { n:"BrtEndECWebProps" },
0x0107: { n:"BrtBeginEcWpTables" },
0x0108: { n:"BrtEndECWPTables" },
0x0109: { n:"BrtBeginECParams" },
0x010A: { n:"BrtEndECParams" },
0x010B: { n:"BrtBeginECParam" },
0x010C: { n:"BrtEndECParam" },
0x010D: { n:"BrtBeginPCDKPIs" },
0x010E: { n:"BrtEndPCDKPIs" },
0x010F: { n:"BrtBeginPCDKPI" },
0x0110: { n:"BrtEndPCDKPI" },
0x0111: { n:"BrtBeginDims" },
0x0112: { n:"BrtEndDims" },
0x0113: { n:"BrtBeginDim" },
0x0114: { n:"BrtEndDim" },
0x0115: { n:"BrtIndexPartEnd" },
0x0116: { n:"BrtBeginStyleSheet" },
0x0117: { n:"BrtEndStyleSheet" },
0x0118: { n:"BrtBeginSXView" },
0x0119: { n:"BrtEndSXVI" },
0x011A: { n:"BrtBeginSXVI" },
0x011B: { n:"BrtBeginSXVIs" },
0x011C: { n:"BrtEndSXVIs" },
0x011D: { n:"BrtBeginSXVD" },
0x011E: { n:"BrtEndSXVD" },
0x011F: { n:"BrtBeginSXVDs" },
0x0120: { n:"BrtEndSXVDs" },
0x0121: { n:"BrtBeginSXPI" },
0x0122: { n:"BrtEndSXPI" },
0x0123: { n:"BrtBeginSXPIs" },
0x0124: { n:"BrtEndSXPIs" },
0x0125: { n:"BrtBeginSXDI" },
0x0126: { n:"BrtEndSXDI" },
0x0127: { n:"BrtBeginSXDIs" },
0x0128: { n:"BrtEndSXDIs" },
0x0129: { n:"BrtBeginSXLI" },
0x012A: { n:"BrtEndSXLI" },
0x012B: { n:"BrtBeginSXLIRws" },
0x012C: { n:"BrtEndSXLIRws" },
0x012D: { n:"BrtBeginSXLICols" },
0x012E: { n:"BrtEndSXLICols" },
0x012F: { n:"BrtBeginSXFormat" },
0x0130: { n:"BrtEndSXFormat" },
0x0131: { n:"BrtBeginSXFormats" },
0x0132: { n:"BrtEndSxFormats" },
0x0133: { n:"BrtBeginSxSelect" },
0x0134: { n:"BrtEndSxSelect" },
0x0135: { n:"BrtBeginISXVDRws" },
0x0136: { n:"BrtEndISXVDRws" },
0x0137: { n:"BrtBeginISXVDCols" },
0x0138: { n:"BrtEndISXVDCols" },
0x0139: { n:"BrtEndSXLocation" },
0x013A: { n:"BrtBeginSXLocation" },
0x013B: { n:"BrtEndSXView" },
0x013C: { n:"BrtBeginSXTHs" },
0x013D: { n:"BrtEndSXTHs" },
0x013E: { n:"BrtBeginSXTH" },
0x013F: { n:"BrtEndSXTH" },
0x0140: { n:"BrtBeginISXTHRws" },
0x0141: { n:"BrtEndISXTHRws" },
0x0142: { n:"BrtBeginISXTHCols" },
0x0143: { n:"BrtEndISXTHCols" },
0x0144: { n:"BrtBeginSXTDMPS" },
0x0145: { n:"BrtEndSXTDMPs" },
0x0146: { n:"BrtBeginSXTDMP" },
0x0147: { n:"BrtEndSXTDMP" },
0x0148: { n:"BrtBeginSXTHItems" },
0x0149: { n:"BrtEndSXTHItems" },
0x014A: { n:"BrtBeginSXTHItem" },
0x014B: { n:"BrtEndSXTHItem" },
0x014C: { n:"BrtBeginMetadata" },
0x014D: { n:"BrtEndMetadata" },
0x014E: { n:"BrtBeginEsmdtinfo" },
0x014F: { n:"BrtMdtinfo" },
0x0150: { n:"BrtEndEsmdtinfo" },
0x0151: { n:"BrtBeginEsmdb" },
0x0152: { n:"BrtEndEsmdb" },
0x0153: { n:"BrtBeginEsfmd" },
0x0154: { n:"BrtEndEsfmd" },
0x0155: { n:"BrtBeginSingleCells" },
0x0156: { n:"BrtEndSingleCells" },
0x0157: { n:"BrtBeginList" },
0x0158: { n:"BrtEndList" },
0x0159: { n:"BrtBeginListCols" },
0x015A: { n:"BrtEndListCols" },
0x015B: { n:"BrtBeginListCol" },
0x015C: { n:"BrtEndListCol" },
0x015D: { n:"BrtBeginListXmlCPr" },
0x015E: { n:"BrtEndListXmlCPr" },
0x015F: { n:"BrtListCCFmla" },
0x0160: { n:"BrtListTrFmla" },
0x0161: { n:"BrtBeginExternals" },
0x0162: { n:"BrtEndExternals" },
0x0163: { n:"BrtSupBookSrc", f:parse_RelID},
0x0165: { n:"BrtSupSelf" },
0x0166: { n:"BrtSupSame" },
0x0167: { n:"BrtSupTabs" },
0x0168: { n:"BrtBeginSupBook" },
0x0169: { n:"BrtPlaceholderName" },
0x016A: { n:"BrtExternSheet", f:parse_ExternSheet },
0x016B: { n:"BrtExternTableStart" },
0x016C: { n:"BrtExternTableEnd" },
0x016E: { n:"BrtExternRowHdr" },
0x016F: { n:"BrtExternCellBlank" },
0x0170: { n:"BrtExternCellReal" },
0x0171: { n:"BrtExternCellBool" },
0x0172: { n:"BrtExternCellError" },
0x0173: { n:"BrtExternCellString" },
0x0174: { n:"BrtBeginEsmdx" },
0x0175: { n:"BrtEndEsmdx" },
0x0176: { n:"BrtBeginMdxSet" },
0x0177: { n:"BrtEndMdxSet" },
0x0178: { n:"BrtBeginMdxMbrProp" },
0x0179: { n:"BrtEndMdxMbrProp" },
0x017A: { n:"BrtBeginMdxKPI" },
0x017B: { n:"BrtEndMdxKPI" },
0x017C: { n:"BrtBeginEsstr" },
0x017D: { n:"BrtEndEsstr" },
0x017E: { n:"BrtBeginPRFItem" },
0x017F: { n:"BrtEndPRFItem" },
0x0180: { n:"BrtBeginPivotCacheIDs" },
0x0181: { n:"BrtEndPivotCacheIDs" },
0x0182: { n:"BrtBeginPivotCacheID" },
0x0183: { n:"BrtEndPivotCacheID" },
0x0184: { n:"BrtBeginISXVIs" },
0x0185: { n:"BrtEndISXVIs" },
0x0186: { n:"BrtBeginColInfos" },
0x0187: { n:"BrtEndColInfos" },
0x0188: { n:"BrtBeginRwBrk" },
0x0189: { n:"BrtEndRwBrk" },
0x018A: { n:"BrtBeginColBrk" },
0x018B: { n:"BrtEndColBrk" },
0x018C: { n:"BrtBrk" },
0x018D: { n:"BrtUserBookView" },
0x018E: { n:"BrtInfo" },
0x018F: { n:"BrtCUsr" },
0x0190: { n:"BrtUsr" },
0x0191: { n:"BrtBeginUsers" },
0x0193: { n:"BrtEOF" },
0x0194: { n:"BrtUCR" },
0x0195: { n:"BrtRRInsDel" },
0x0196: { n:"BrtRREndInsDel" },
0x0197: { n:"BrtRRMove" },
0x0198: { n:"BrtRREndMove" },
0x0199: { n:"BrtRRChgCell" },
0x019A: { n:"BrtRREndChgCell" },
0x019B: { n:"BrtRRHeader" },
0x019C: { n:"BrtRRUserView" },
0x019D: { n:"BrtRRRenSheet" },
0x019E: { n:"BrtRRInsertSh" },
0x019F: { n:"BrtRRDefName" },
0x01A0: { n:"BrtRRNote" },
0x01A1: { n:"BrtRRConflict" },
0x01A2: { n:"BrtRRTQSIF" },
0x01A3: { n:"BrtRRFormat" },
0x01A4: { n:"BrtRREndFormat" },
0x01A5: { n:"BrtRRAutoFmt" },
0x01A6: { n:"BrtBeginUserShViews" },
0x01A7: { n:"BrtBeginUserShView" },
0x01A8: { n:"BrtEndUserShView" },
0x01A9: { n:"BrtEndUserShViews" },
0x01AA: { n:"BrtArrFmla", f:parse_BrtArrFmla },
0x01AB: { n:"BrtShrFmla", f:parse_BrtShrFmla },
0x01AC: { n:"BrtTable" },
0x01AD: { n:"BrtBeginExtConnections" },
0x01AE: { n:"BrtEndExtConnections" },
0x01AF: { n:"BrtBeginPCDCalcMems" },
0x01B0: { n:"BrtEndPCDCalcMems" },
0x01B1: { n:"BrtBeginPCDCalcMem" },
0x01B2: { n:"BrtEndPCDCalcMem" },
0x01B3: { n:"BrtBeginPCDHGLevels" },
0x01B4: { n:"BrtEndPCDHGLevels" },
0x01B5: { n:"BrtBeginPCDHGLevel" },
0x01B6: { n:"BrtEndPCDHGLevel" },
0x01B7: { n:"BrtBeginPCDHGLGroups" },
0x01B8: { n:"BrtEndPCDHGLGroups" },
0x01B9: { n:"BrtBeginPCDHGLGroup" },
0x01BA: { n:"BrtEndPCDHGLGroup" },
0x01BB: { n:"BrtBeginPCDHGLGMembers" },
0x01BC: { n:"BrtEndPCDHGLGMembers" },
0x01BD: { n:"BrtBeginPCDHGLGMember" },
0x01BE: { n:"BrtEndPCDHGLGMember" },
0x01BF: { n:"BrtBeginQSI" },
0x01C0: { n:"BrtEndQSI" },
0x01C1: { n:"BrtBeginQSIR" },
0x01C2: { n:"BrtEndQSIR" },
0x01C3: { n:"BrtBeginDeletedNames" },
0x01C4: { n:"BrtEndDeletedNames" },
0x01C5: { n:"BrtBeginDeletedName" },
0x01C6: { n:"BrtEndDeletedName" },
0x01C7: { n:"BrtBeginQSIFs" },
0x01C8: { n:"BrtEndQSIFs" },
0x01C9: { n:"BrtBeginQSIF" },
0x01CA: { n:"BrtEndQSIF" },
0x01CB: { n:"BrtBeginAutoSortScope" },
0x01CC: { n:"BrtEndAutoSortScope" },
0x01CD: { n:"BrtBeginConditionalFormatting" },
0x01CE: { n:"BrtEndConditionalFormatting" },
0x01CF: { n:"BrtBeginCFRule" },
0x01D0: { n:"BrtEndCFRule" },
0x01D1: { n:"BrtBeginIconSet" },
0x01D2: { n:"BrtEndIconSet" },
0x01D3: { n:"BrtBeginDatabar" },
0x01D4: { n:"BrtEndDatabar" },
0x01D5: { n:"BrtBeginColorScale" },
0x01D6: { n:"BrtEndColorScale" },
0x01D7: { n:"BrtCFVO" },
0x01D8: { n:"BrtExternValueMeta" },
0x01D9: { n:"BrtBeginColorPalette" },
0x01DA: { n:"BrtEndColorPalette" },
0x01DB: { n:"BrtIndexedColor" },
0x01DC: { n:"BrtMargins", f:parse_BrtMargins },
0x01DD: { n:"BrtPrintOptions" },
0x01DE: { n:"BrtPageSetup" },
0x01DF: { n:"BrtBeginHeaderFooter" },
0x01E0: { n:"BrtEndHeaderFooter" },
0x01E1: { n:"BrtBeginSXCrtFormat" },
0x01E2: { n:"BrtEndSXCrtFormat" },
0x01E3: { n:"BrtBeginSXCrtFormats" },
0x01E4: { n:"BrtEndSXCrtFormats" },
0x01E5: { n:"BrtWsFmtInfo", f:parse_BrtWsFmtInfo },
0x01E6: { n:"BrtBeginMgs" },
0x01E7: { n:"BrtEndMGs" },
0x01E8: { n:"BrtBeginMGMaps" },
0x01E9: { n:"BrtEndMGMaps" },
0x01EA: { n:"BrtBeginMG" },
0x01EB: { n:"BrtEndMG" },
0x01EC: { n:"BrtBeginMap" },
0x01ED: { n:"BrtEndMap" },
0x01EE: { n:"BrtHLink", f:parse_BrtHLink },
0x01EF: { n:"BrtBeginDCon" },
0x01F0: { n:"BrtEndDCon" },
0x01F1: { n:"BrtBeginDRefs" },
0x01F2: { n:"BrtEndDRefs" },
0x01F3: { n:"BrtDRef" },
0x01F4: { n:"BrtBeginScenMan" },
0x01F5: { n:"BrtEndScenMan" },
0x01F6: { n:"BrtBeginSct" },
0x01F7: { n:"BrtEndSct" },
0x01F8: { n:"BrtSlc" },
0x01F9: { n:"BrtBeginDXFs" },
0x01FA: { n:"BrtEndDXFs" },
0x01FB: { n:"BrtDXF" },
0x01FC: { n:"BrtBeginTableStyles" },
0x01FD: { n:"BrtEndTableStyles" },
0x01FE: { n:"BrtBeginTableStyle" },
0x01FF: { n:"BrtEndTableStyle" },
0x0200: { n:"BrtTableStyleElement" },
0x0201: { n:"BrtTableStyleClient" },
0x0202: { n:"BrtBeginVolDeps" },
0x0203: { n:"BrtEndVolDeps" },
0x0204: { n:"BrtBeginVolType" },
0x0205: { n:"BrtEndVolType" },
0x0206: { n:"BrtBeginVolMain" },
0x0207: { n:"BrtEndVolMain" },
0x0208: { n:"BrtBeginVolTopic" },
0x0209: { n:"BrtEndVolTopic" },
0x020A: { n:"BrtVolSubtopic" },
0x020B: { n:"BrtVolRef" },
0x020C: { n:"BrtVolNum" },
0x020D: { n:"BrtVolErr" },
0x020E: { n:"BrtVolStr" },
0x020F: { n:"BrtVolBool" },
0x0210: { n:"BrtBeginCalcChain$" },
0x0211: { n:"BrtEndCalcChain$" },
0x0212: { n:"BrtBeginSortState" },
0x0213: { n:"BrtEndSortState" },
0x0214: { n:"BrtBeginSortCond" },
0x0215: { n:"BrtEndSortCond" },
0x0216: { n:"BrtBookProtection" },
0x0217: { n:"BrtSheetProtection" },
0x0218: { n:"BrtRangeProtection" },
0x0219: { n:"BrtPhoneticInfo" },
0x021A: { n:"BrtBeginECTxtWiz" },
0x021B: { n:"BrtEndECTxtWiz" },
0x021C: { n:"BrtBeginECTWFldInfoLst" },
0x021D: { n:"BrtEndECTWFldInfoLst" },
0x021E: { n:"BrtBeginECTwFldInfo" },
0x0224: { n:"BrtFileSharing" },
0x0225: { n:"BrtOleSize" },
0x0226: { n:"BrtDrawing", f:parse_RelID },
0x0227: { n:"BrtLegacyDrawing" },
0x0228: { n:"BrtLegacyDrawingHF" },
0x0229: { n:"BrtWebOpt" },
0x022A: { n:"BrtBeginWebPubItems" },
0x022B: { n:"BrtEndWebPubItems" },
0x022C: { n:"BrtBeginWebPubItem" },
0x022D: { n:"BrtEndWebPubItem" },
0x022E: { n:"BrtBeginSXCondFmt" },
0x022F: { n:"BrtEndSXCondFmt" },
0x0230: { n:"BrtBeginSXCondFmts" },
0x0231: { n:"BrtEndSXCondFmts" },
0x0232: { n:"BrtBkHim" },
0x0234: { n:"BrtColor" },
0x0235: { n:"BrtBeginIndexedColors" },
0x0236: { n:"BrtEndIndexedColors" },
0x0239: { n:"BrtBeginMRUColors" },
0x023A: { n:"BrtEndMRUColors" },
0x023C: { n:"BrtMRUColor" },
0x023D: { n:"BrtBeginDVals" },
0x023E: { n:"BrtEndDVals" },
0x0241: { n:"BrtSupNameStart" },
0x0242: { n:"BrtSupNameValueStart" },
0x0243: { n:"BrtSupNameValueEnd" },
0x0244: { n:"BrtSupNameNum" },
0x0245: { n:"BrtSupNameErr" },
0x0246: { n:"BrtSupNameSt" },
0x0247: { n:"BrtSupNameNil" },
0x0248: { n:"BrtSupNameBool" },
0x0249: { n:"BrtSupNameFmla" },
0x024A: { n:"BrtSupNameBits" },
0x024B: { n:"BrtSupNameEnd" },
0x024C: { n:"BrtEndSupBook" },
0x024D: { n:"BrtCellSmartTagProperty" },
0x024E: { n:"BrtBeginCellSmartTag" },
0x024F: { n:"BrtEndCellSmartTag" },
0x0250: { n:"BrtBeginCellSmartTags" },
0x0251: { n:"BrtEndCellSmartTags" },
0x0252: { n:"BrtBeginSmartTags" },
0x0253: { n:"BrtEndSmartTags" },
0x0254: { n:"BrtSmartTagType" },
0x0255: { n:"BrtBeginSmartTagTypes" },
0x0256: { n:"BrtEndSmartTagTypes" },
0x0257: { n:"BrtBeginSXFilters" },
0x0258: { n:"BrtEndSXFilters" },
0x0259: { n:"BrtBeginSXFILTER" },
0x025A: { n:"BrtEndSXFilter" },
0x025B: { n:"BrtBeginFills" },
0x025C: { n:"BrtEndFills" },
0x025D: { n:"BrtBeginCellWatches" },
0x025E: { n:"BrtEndCellWatches" },
0x025F: { n:"BrtCellWatch" },
0x0260: { n:"BrtBeginCRErrs" },
0x0261: { n:"BrtEndCRErrs" },
0x0262: { n:"BrtCrashRecErr" },
0x0263: { n:"BrtBeginFonts" },
0x0264: { n:"BrtEndFonts" },
0x0265: { n:"BrtBeginBorders" },
0x0266: { n:"BrtEndBorders" },
0x0267: { n:"BrtBeginFmts" },
0x0268: { n:"BrtEndFmts" },
0x0269: { n:"BrtBeginCellXFs" },
0x026A: { n:"BrtEndCellXFs" },
0x026B: { n:"BrtBeginStyles" },
0x026C: { n:"BrtEndStyles" },
0x0271: { n:"BrtBigName" },
0x0272: { n:"BrtBeginCellStyleXFs" },
0x0273: { n:"BrtEndCellStyleXFs" },
0x0274: { n:"BrtBeginComments" },
0x0275: { n:"BrtEndComments" },
0x0276: { n:"BrtBeginCommentAuthors" },
0x0277: { n:"BrtEndCommentAuthors" },
0x0278: { n:"BrtCommentAuthor", f:parse_BrtCommentAuthor },
0x0279: { n:"BrtBeginCommentList" },
0x027A: { n:"BrtEndCommentList" },
0x027B: { n:"BrtBeginComment", f:parse_BrtBeginComment},
0x027C: { n:"BrtEndComment" },
0x027D: { n:"BrtCommentText", f:parse_BrtCommentText },
0x027E: { n:"BrtBeginOleObjects" },
0x027F: { n:"BrtOleObject" },
0x0280: { n:"BrtEndOleObjects" },
0x0281: { n:"BrtBeginSxrules" },
0x0282: { n:"BrtEndSxRules" },
0x0283: { n:"BrtBeginActiveXControls" },
0x0284: { n:"BrtActiveX" },
0x0285: { n:"BrtEndActiveXControls" },
0x0286: { n:"BrtBeginPCDSDTCEMembersSortBy" },
0x0288: { n:"BrtBeginCellIgnoreECs" },
0x0289: { n:"BrtCellIgnoreEC" },
0x028A: { n:"BrtEndCellIgnoreECs" },
0x028B: { n:"BrtCsProp", f:parse_BrtCsProp },
0x028C: { n:"BrtCsPageSetup" },
0x028D: { n:"BrtBeginUserCsViews" },
0x028E: { n:"BrtEndUserCsViews" },
0x028F: { n:"BrtBeginUserCsView" },
0x0290: { n:"BrtEndUserCsView" },
0x0291: { n:"BrtBeginPcdSFCIEntries" },
0x0292: { n:"BrtEndPCDSFCIEntries" },
0x0293: { n:"BrtPCDSFCIEntry" },
0x0294: { n:"BrtBeginListParts" },
0x0295: { n:"BrtListPart" },
0x0296: { n:"BrtEndListParts" },
0x0297: { n:"BrtSheetCalcProp" },
0x0298: { n:"BrtBeginFnGroup" },
0x0299: { n:"BrtFnGroup" },
0x029A: { n:"BrtEndFnGroup" },
0x029B: { n:"BrtSupAddin" },
0x029C: { n:"BrtSXTDMPOrder" },
0x029D: { n:"BrtCsProtection" },
0x029F: { n:"BrtBeginWsSortMap" },
0x02A0: { n:"BrtEndWsSortMap" },
0x02A1: { n:"BrtBeginRRSort" },
0x02A2: { n:"BrtEndRRSort" },
0x02A3: { n:"BrtRRSortItem" },
0x02A4: { n:"BrtFileSharingIso" },
0x02A5: { n:"BrtBookProtectionIso" },
0x02A6: { n:"BrtSheetProtectionIso" },
0x02A7: { n:"BrtCsProtectionIso" },
0x02A8: { n:"BrtRangeProtectionIso" },
0x0400: { n:"BrtRwDescent" },
0x0401: { n:"BrtKnownFonts" },
0x0402: { n:"BrtBeginSXTupleSet" },
0x0403: { n:"BrtEndSXTupleSet" },
0x0404: { n:"BrtBeginSXTupleSetHeader" },
0x0405: { n:"BrtEndSXTupleSetHeader" },
0x0406: { n:"BrtSXTupleSetHeaderItem" },
0x0407: { n:"BrtBeginSXTupleSetData" },
0x0408: { n:"BrtEndSXTupleSetData" },
0x0409: { n:"BrtBeginSXTupleSetRow" },
0x040A: { n:"BrtEndSXTupleSetRow" },
0x040B: { n:"BrtSXTupleSetRowItem" },
0x040C: { n:"BrtNameExt" },
0x040D: { n:"BrtPCDH14" },
0x040E: { n:"BrtBeginPCDCalcMem14" },
0x040F: { n:"BrtEndPCDCalcMem14" },
0x0410: { n:"BrtSXTH14" },
0x0411: { n:"BrtBeginSparklineGroup" },
0x0412: { n:"BrtEndSparklineGroup" },
0x0413: { n:"BrtSparkline" },
0x0414: { n:"BrtSXDI14" },
0x0415: { n:"BrtWsFmtInfoEx14" },
0x0416: { n:"BrtBeginConditionalFormatting14" },
0x0417: { n:"BrtEndConditionalFormatting14" },
0x0418: { n:"BrtBeginCFRule14" },
0x0419: { n:"BrtEndCFRule14" },
0x041A: { n:"BrtCFVO14" },
0x041B: { n:"BrtBeginDatabar14" },
0x041C: { n:"BrtBeginIconSet14" },
0x041D: { n:"BrtDVal14" },
0x041E: { n:"BrtBeginDVals14" },
0x041F: { n:"BrtColor14" },
0x0420: { n:"BrtBeginSparklines" },
0x0421: { n:"BrtEndSparklines" },
0x0422: { n:"BrtBeginSparklineGroups" },
0x0423: { n:"BrtEndSparklineGroups" },
0x0425: { n:"BrtSXVD14" },
0x0426: { n:"BrtBeginSXView14" },
0x0427: { n:"BrtEndSXView14" },
0x0428: { n:"BrtBeginSXView16" },
0x0429: { n:"BrtEndSXView16" },
0x042A: { n:"BrtBeginPCD14" },
0x042B: { n:"BrtEndPCD14" },
0x042C: { n:"BrtBeginExtConn14" },
0x042D: { n:"BrtEndExtConn14" },
0x042E: { n:"BrtBeginSlicerCacheIDs" },
0x042F: { n:"BrtEndSlicerCacheIDs" },
0x0430: { n:"BrtBeginSlicerCacheID" },
0x0431: { n:"BrtEndSlicerCacheID" },
0x0433: { n:"BrtBeginSlicerCache" },
0x0434: { n:"BrtEndSlicerCache" },
0x0435: { n:"BrtBeginSlicerCacheDef" },
0x0436: { n:"BrtEndSlicerCacheDef" },
0x0437: { n:"BrtBeginSlicersEx" },
0x0438: { n:"BrtEndSlicersEx" },
0x0439: { n:"BrtBeginSlicerEx" },
0x043A: { n:"BrtEndSlicerEx" },
0x043B: { n:"BrtBeginSlicer" },
0x043C: { n:"BrtEndSlicer" },
0x043D: { n:"BrtSlicerCachePivotTables" },
0x043E: { n:"BrtBeginSlicerCacheOlapImpl" },
0x043F: { n:"BrtEndSlicerCacheOlapImpl" },
0x0440: { n:"BrtBeginSlicerCacheLevelsData" },
0x0441: { n:"BrtEndSlicerCacheLevelsData" },
0x0442: { n:"BrtBeginSlicerCacheLevelData" },
0x0443: { n:"BrtEndSlicerCacheLevelData" },
0x0444: { n:"BrtBeginSlicerCacheSiRanges" },
0x0445: { n:"BrtEndSlicerCacheSiRanges" },
0x0446: { n:"BrtBeginSlicerCacheSiRange" },
0x0447: { n:"BrtEndSlicerCacheSiRange" },
0x0448: { n:"BrtSlicerCacheOlapItem" },
0x0449: { n:"BrtBeginSlicerCacheSelections" },
0x044A: { n:"BrtSlicerCacheSelection" },
0x044B: { n:"BrtEndSlicerCacheSelections" },
0x044C: { n:"BrtBeginSlicerCacheNative" },
0x044D: { n:"BrtEndSlicerCacheNative" },
0x044E: { n:"BrtSlicerCacheNativeItem" },
0x044F: { n:"BrtRangeProtection14" },
0x0450: { n:"BrtRangeProtectionIso14" },
0x0451: { n:"BrtCellIgnoreEC14" },
0x0457: { n:"BrtList14" },
0x0458: { n:"BrtCFIcon" },
0x0459: { n:"BrtBeginSlicerCachesPivotCacheIDs" },
0x045A: { n:"BrtEndSlicerCachesPivotCacheIDs" },
0x045B: { n:"BrtBeginSlicers" },
0x045C: { n:"BrtEndSlicers" },
0x045D: { n:"BrtWbProp14" },
0x045E: { n:"BrtBeginSXEdit" },
0x045F: { n:"BrtEndSXEdit" },
0x0460: { n:"BrtBeginSXEdits" },
0x0461: { n:"BrtEndSXEdits" },
0x0462: { n:"BrtBeginSXChange" },
0x0463: { n:"BrtEndSXChange" },
0x0464: { n:"BrtBeginSXChanges" },
0x0465: { n:"BrtEndSXChanges" },
0x0466: { n:"BrtSXTupleItems" },
0x0468: { n:"BrtBeginSlicerStyle" },
0x0469: { n:"BrtEndSlicerStyle" },
0x046A: { n:"BrtSlicerStyleElement" },
0x046B: { n:"BrtBeginStyleSheetExt14" },
0x046C: { n:"BrtEndStyleSheetExt14" },
0x046D: { n:"BrtBeginSlicerCachesPivotCacheID" },
0x046E: { n:"BrtEndSlicerCachesPivotCacheID" },
0x046F: { n:"BrtBeginConditionalFormattings" },
0x0470: { n:"BrtEndConditionalFormattings" },
0x0471: { n:"BrtBeginPCDCalcMemExt" },
0x0472: { n:"BrtEndPCDCalcMemExt" },
0x0473: { n:"BrtBeginPCDCalcMemsExt" },
0x0474: { n:"BrtEndPCDCalcMemsExt" },
0x0475: { n:"BrtPCDField14" },
0x0476: { n:"BrtBeginSlicerStyles" },
0x0477: { n:"BrtEndSlicerStyles" },
0x0478: { n:"BrtBeginSlicerStyleElements" },
0x0479: { n:"BrtEndSlicerStyleElements" },
0x047A: { n:"BrtCFRuleExt" },
0x047B: { n:"BrtBeginSXCondFmt14" },
0x047C: { n:"BrtEndSXCondFmt14" },
0x047D: { n:"BrtBeginSXCondFmts14" },
0x047E: { n:"BrtEndSXCondFmts14" },
0x0480: { n:"BrtBeginSortCond14" },
0x0481: { n:"BrtEndSortCond14" },
0x0482: { n:"BrtEndDVals14" },
0x0483: { n:"BrtEndIconSet14" },
0x0484: { n:"BrtEndDatabar14" },
0x0485: { n:"BrtBeginColorScale14" },
0x0486: { n:"BrtEndColorScale14" },
0x0487: { n:"BrtBeginSxrules14" },
0x0488: { n:"BrtEndSxrules14" },
0x0489: { n:"BrtBeginPRule14" },
0x048A: { n:"BrtEndPRule14" },
0x048B: { n:"BrtBeginPRFilters14" },
0x048C: { n:"BrtEndPRFilters14" },
0x048D: { n:"BrtBeginPRFilter14" },
0x048E: { n:"BrtEndPRFilter14" },
0x048F: { n:"BrtBeginPRFItem14" },
0x0490: { n:"BrtEndPRFItem14" },
0x0491: { n:"BrtBeginCellIgnoreECs14" },
0x0492: { n:"BrtEndCellIgnoreECs14" },
0x0493: { n:"BrtDxf14" },
0x0494: { n:"BrtBeginDxF14s" },
0x0495: { n:"BrtEndDxf14s" },
0x0499: { n:"BrtFilter14" },
0x049A: { n:"BrtBeginCustomFilters14" },
0x049C: { n:"BrtCustomFilter14" },
0x049D: { n:"BrtIconFilter14" },
0x049E: { n:"BrtPivotCacheConnectionName" },
0x0800: { n:"BrtBeginDecoupledPivotCacheIDs" },
0x0801: { n:"BrtEndDecoupledPivotCacheIDs" },
0x0802: { n:"BrtDecoupledPivotCacheID" },
0x0803: { n:"BrtBeginPivotTableRefs" },
0x0804: { n:"BrtEndPivotTableRefs" },
0x0805: { n:"BrtPivotTableRef" },
0x0806: { n:"BrtSlicerCacheBookPivotTables" },
0x0807: { n:"BrtBeginSxvcells" },
0x0808: { n:"BrtEndSxvcells" },
0x0809: { n:"BrtBeginSxRow" },
0x080A: { n:"BrtEndSxRow" },
0x080C: { n:"BrtPcdCalcMem15" },
0x0813: { n:"BrtQsi15" },
0x0814: { n:"BrtBeginWebExtensions" },
0x0815: { n:"BrtEndWebExtensions" },
0x0816: { n:"BrtWebExtension" },
0x0817: { n:"BrtAbsPath15" },
0x0818: { n:"BrtBeginPivotTableUISettings" },
0x0819: { n:"BrtEndPivotTableUISettings" },
0x081B: { n:"BrtTableSlicerCacheIDs" },
0x081C: { n:"BrtTableSlicerCacheID" },
0x081D: { n:"BrtBeginTableSlicerCache" },
0x081E: { n:"BrtEndTableSlicerCache" },
0x081F: { n:"BrtSxFilter15" },
0x0820: { n:"BrtBeginTimelineCachePivotCacheIDs" },
0x0821: { n:"BrtEndTimelineCachePivotCacheIDs" },
0x0822: { n:"BrtTimelineCachePivotCacheID" },
0x0823: { n:"BrtBeginTimelineCacheIDs" },
0x0824: { n:"BrtEndTimelineCacheIDs" },
0x0825: { n:"BrtBeginTimelineCacheID" },
0x0826: { n:"BrtEndTimelineCacheID" },
0x0827: { n:"BrtBeginTimelinesEx" },
0x0828: { n:"BrtEndTimelinesEx" },
0x0829: { n:"BrtBeginTimelineEx" },
0x082A: { n:"BrtEndTimelineEx" },
0x082B: { n:"BrtWorkBookPr15" },
0x082C: { n:"BrtPCDH15" },
0x082D: { n:"BrtBeginTimelineStyle" },
0x082E: { n:"BrtEndTimelineStyle" },
0x082F: { n:"BrtTimelineStyleElement" },
0x0830: { n:"BrtBeginTimelineStylesheetExt15" },
0x0831: { n:"BrtEndTimelineStylesheetExt15" },
0x0832: { n:"BrtBeginTimelineStyles" },
0x0833: { n:"BrtEndTimelineStyles" },
0x0834: { n:"BrtBeginTimelineStyleElements" },
0x0835: { n:"BrtEndTimelineStyleElements" },
0x0836: { n:"BrtDxf15" },
0x0837: { n:"BrtBeginDxfs15" },
0x0838: { n:"brtEndDxfs15" },
0x0839: { n:"BrtSlicerCacheHideItemsWithNoData" },
0x083A: { n:"BrtBeginItemUniqueNames" },
0x083B: { n:"BrtEndItemUniqueNames" },
0x083C: { n:"BrtItemUniqueName" },
0x083D: { n:"BrtBeginExtConn15" },
0x083E: { n:"BrtEndExtConn15" },
0x083F: { n:"BrtBeginOledbPr15" },
0x0840: { n:"BrtEndOledbPr15" },
0x0841: { n:"BrtBeginDataFeedPr15" },
0x0842: { n:"BrtEndDataFeedPr15" },
0x0843: { n:"BrtTextPr15" },
0x0844: { n:"BrtRangePr15" },
0x0845: { n:"BrtDbCommand15" },
0x0846: { n:"BrtBeginDbTables15" },
0x0847: { n:"BrtEndDbTables15" },
0x0848: { n:"BrtDbTable15" },
0x0849: { n:"BrtBeginDataModel" },
0x084A: { n:"BrtEndDataModel" },
0x084B: { n:"BrtBeginModelTables" },
0x084C: { n:"BrtEndModelTables" },
0x084D: { n:"BrtModelTable" },
0x084E: { n:"BrtBeginModelRelationships" },
0x084F: { n:"BrtEndModelRelationships" },
0x0850: { n:"BrtModelRelationship" },
0x0851: { n:"BrtBeginECTxtWiz15" },
0x0852: { n:"BrtEndECTxtWiz15" },
0x0853: { n:"BrtBeginECTWFldInfoLst15" },
0x0854: { n:"BrtEndECTWFldInfoLst15" },
0x0855: { n:"BrtBeginECTWFldInfo15" },
0x0856: { n:"BrtFieldListActiveItem" },
0x0857: { n:"BrtPivotCacheIdVersion" },
0x0858: { n:"BrtSXDI15" },
0x0859: { n:"BrtBeginModelTimeGroupings" },
0x085A: { n:"BrtEndModelTimeGroupings" },
0x085B: { n:"BrtBeginModelTimeGrouping" },
0x085C: { n:"BrtEndModelTimeGrouping" },
0x085D: { n:"BrtModelTimeGroupingCalcCol" },
0x0C00: { n:"BrtUid" },
0x0C01: { n:"BrtRevisionPtr" },
0xFFFF: { n:"" }
};

var XLSBRE = evert_key(XLSBRecordEnum, 'n');

/* [MS-XLS] 2.3 Record Enumeration */
var XLSRecordEnum = {
0x0003: { n:"BIFF2NUM", f:parse_BIFF2NUM },
0x0004: { n:"BIFF2STR", f:parse_BIFF2STR },
0x0006: { n:"Formula", f:parse_Formula },
0x0009: { n:'BOF', f:parse_BOF },
0x000a: { n:'EOF', f:parsenoop2 },
0x000c: { n:"CalcCount", f:parseuint16 },
0x000d: { n:"CalcMode", f:parseuint16 },
0x000e: { n:"CalcPrecision", f:parsebool },
0x000f: { n:"CalcRefMode", f:parsebool },
0x0010: { n:"CalcDelta", f:parse_Xnum },
0x0011: { n:"CalcIter", f:parsebool },
0x0012: { n:"Protect", f:parsebool },
0x0013: { n:"Password", f:parseuint16 },
0x0014: { n:"Header", f:parse_XLHeaderFooter },
0x0015: { n:"Footer", f:parse_XLHeaderFooter },
0x0017: { n:"ExternSheet", f:parse_ExternSheet },
0x0018: { n:"Lbl", f:parse_Lbl },
0x0019: { n:"WinProtect", f:parsebool },
0x001a: { n:"VerticalPageBreaks" },
0x001b: { n:"HorizontalPageBreaks" },
0x001c: { n:"Note", f:parse_Note },
0x001d: { n:"Selection" },
0x0022: { n:"Date1904", f:parsebool },
0x0023: { n:"ExternName", f:parse_ExternName },
0x0026: { n:"LeftMargin", f:parse_Xnum },
0x0027: { n:"RightMargin", f:parse_Xnum },
0x0028: { n:"TopMargin", f:parse_Xnum },
0x0029: { n:"BottomMargin", f:parse_Xnum },
0x002a: { n:"PrintRowCol", f:parsebool },
0x002b: { n:"PrintGrid", f:parsebool },
0x002f: { n:"FilePass", f:parse_FilePass },
0x0031: { n:"Font", f:parse_Font },
0x0033: { n:"PrintSize", f:parseuint16 },
0x003c: { n:"Continue" },
0x003d: { n:"Window1", f:parse_Window1 },
0x0040: { n:"Backup", f:parsebool },
0x0041: { n:"Pane" },
0x0042: { n:'CodePage', f:parseuint16 },
0x004d: { n:"Pls" },
0x0050: { n:"DCon" },
0x0051: { n:"DConRef" },
0x0052: { n:"DConName" },
0x0055: { n:"DefColWidth", f:parseuint16 },
0x0059: { n:"XCT" },
0x005a: { n:"CRN" },
0x005b: { n:"FileSharing" },
0x005c: { n:'WriteAccess', f:parse_WriteAccess },
0x005d: { n:"Obj", f:parse_Obj },
0x005e: { n:"Uncalced" },
0x005f: { n:"CalcSaveRecalc", f:parsebool },
0x0060: { n:"Template" },
0x0061: { n:"Intl" },
0x0063: { n:"ObjProtect", f:parsebool },
0x007d: { n:"ColInfo", f:parse_ColInfo },
0x0080: { n:"Guts", f:parse_Guts },
0x0081: { n:"WsBool", f:parse_WsBool },
0x0082: { n:"GridSet", f:parseuint16 },
0x0083: { n:"HCenter", f:parsebool },
0x0084: { n:"VCenter", f:parsebool },
0x0085: { n:'BoundSheet8', f:parse_BoundSheet8 },
0x0086: { n:"WriteProtect" },
0x008c: { n:"Country", f:parse_Country },
0x008d: { n:"HideObj", f:parseuint16 },
0x0090: { n:"Sort" },
0x0092: { n:"Palette", f:parse_Palette },
0x0097: { n:"Sync" },
0x0098: { n:"LPr" },
0x0099: { n:"DxGCol" },
0x009a: { n:"FnGroupName" },
0x009b: { n:"FilterMode" },
0x009c: { n:"BuiltInFnGroupCount", f:parseuint16 },
0x009d: { n:"AutoFilterInfo" },
0x009e: { n:"AutoFilter" },
0x00a0: { n:"Scl", f:parse_Scl },
0x00a1: { n:"Setup", f:parse_Setup },
0x00ae: { n:"ScenMan" },
0x00af: { n:"SCENARIO" },
0x00b0: { n:"SxView" },
0x00b1: { n:"Sxvd" },
0x00b2: { n:"SXVI" },
0x00b4: { n:"SxIvd" },
0x00b5: { n:"SXLI" },
0x00b6: { n:"SXPI" },
0x00b8: { n:"DocRoute" },
0x00b9: { n:"RecipName" },
0x00bd: { n:"MulRk", f:parse_MulRk },
0x00be: { n:"MulBlank", f:parse_MulBlank },
0x00c1: { n:'Mms', f:parsenoop2 },
0x00c5: { n:"SXDI" },
0x00c6: { n:"SXDB" },
0x00c7: { n:"SXFDB" },
0x00c8: { n:"SXDBB" },
0x00c9: { n:"SXNum" },
0x00ca: { n:"SxBool", f:parsebool },
0x00cb: { n:"SxErr" },
0x00cc: { n:"SXInt" },
0x00cd: { n:"SXString" },
0x00ce: { n:"SXDtr" },
0x00cf: { n:"SxNil" },
0x00d0: { n:"SXTbl" },
0x00d1: { n:"SXTBRGIITM" },
0x00d2: { n:"SxTbpg" },
0x00d3: { n:"ObProj" },
0x00d5: { n:"SXStreamID" },
0x00d7: { n:"DBCell" },
0x00d8: { n:"SXRng" },
0x00d9: { n:"SxIsxoper" },
0x00da: { n:"BookBool", f:parseuint16 },
0x00dc: { n:"DbOrParamQry" },
0x00dd: { n:"ScenarioProtect", f:parsebool },
0x00de: { n:"OleObjectSize" },
0x00e0: { n:"XF", f:parse_XF },
0x00e1: { n:'InterfaceHdr', f:parse_InterfaceHdr },
0x00e2: { n:'InterfaceEnd', f:parsenoop2 },
0x00e3: { n:"SXVS" },
0x00e5: { n:"MergeCells", f:parse_MergeCells },
0x00e9: { n:"BkHim" },
0x00eb: { n:"MsoDrawingGroup" },
0x00ec: { n:"MsoDrawing" },
0x00ed: { n:"MsoDrawingSelection" },
0x00ef: { n:"PhoneticInfo" },
0x00f0: { n:"SxRule" },
0x00f1: { n:"SXEx" },
0x00f2: { n:"SxFilt" },
0x00f4: { n:"SxDXF" },
0x00f5: { n:"SxItm" },
0x00f6: { n:"SxName" },
0x00f7: { n:"SxSelect" },
0x00f8: { n:"SXPair" },
0x00f9: { n:"SxFmla" },
0x00fb: { n:"SxFormat" },
0x00fc: { n:"SST", f:parse_SST },
0x00fd: { n:"LabelSst", f:parse_LabelSst },
0x00ff: { n:"ExtSST", f:parse_ExtSST },
0x0100: { n:"SXVDEx" },
0x0103: { n:"SXFormula" },
0x0122: { n:"SXDBEx" },
0x0137: { n:"RRDInsDel" },
0x0138: { n:"RRDHead" },
0x013b: { n:"RRDChgCell" },
0x013d: { n:"RRTabId", f:parseuint16a },
0x013e: { n:"RRDRenSheet" },
0x013f: { n:"RRSort" },
0x0140: { n:"RRDMove" },
0x014a: { n:"RRFormat" },
0x014b: { n:"RRAutoFmt" },
0x014d: { n:"RRInsertSh" },
0x014e: { n:"RRDMoveBegin" },
0x014f: { n:"RRDMoveEnd" },
0x0150: { n:"RRDInsDelBegin" },
0x0151: { n:"RRDInsDelEnd" },
0x0152: { n:"RRDConflict" },
0x0153: { n:"RRDDefName" },
0x0154: { n:"RRDRstEtxp" },
0x015f: { n:"LRng" },
0x0160: { n:"UsesELFs", f:parsebool },
0x0161: { n:"DSF", f:parsenoop2 },
0x0191: { n:"CUsr" },
0x0192: { n:"CbUsr" },
0x0193: { n:"UsrInfo" },
0x0194: { n:"UsrExcl" },
0x0195: { n:"FileLock" },
0x0196: { n:"RRDInfo" },
0x0197: { n:"BCUsrs" },
0x0198: { n:"UsrChk" },
0x01a9: { n:"UserBView" },
0x01aa: { n:"UserSViewBegin" },
0x01ab: { n:"UserSViewEnd" },
0x01ac: { n:"RRDUserView" },
0x01ad: { n:"Qsi" },
0x01ae: { n:"SupBook", f:parse_SupBook },
0x01af: { n:"Prot4Rev", f:parsebool },
0x01b0: { n:"CondFmt" },
0x01b1: { n:"CF" },
0x01b2: { n:"DVal" },
0x01b5: { n:"DConBin" },
0x01b6: { n:"TxO", f:parse_TxO },
0x01b7: { n:"RefreshAll", f:parsebool },
0x01b8: { n:"HLink", f:parse_HLink },
0x01b9: { n:"Lel" },
0x01ba: { n:"CodeName", f:parse_XLUnicodeString },
0x01bb: { n:"SXFDBType" },
0x01bc: { n:"Prot4RevPass", f:parseuint16 },
0x01bd: { n:"ObNoMacros" },
0x01be: { n:"Dv" },
0x01c0: { n:"Excel9File", f:parsenoop2 },
0x01c1: { n:"RecalcId", f:parse_RecalcId, r:2},
0x01c2: { n:"EntExU2", f:parsenoop2 },
0x0200: { n:"Dimensions", f:parse_Dimensions },
0x0201: { n:"Blank", f:parse_Blank },
0x0203: { n:"Number", f:parse_Number },
0x0204: { n:"Label", f:parse_Label },
0x0205: { n:"BoolErr", f:parse_BoolErr },
0x0206: { n:"Formula", f:parse_Formula },
0x0207: { n:"String", f:parse_String },
0x0208: { n:'Row', f:parse_Row },
0x020b: { n:"Index" },
0x0221: { n:"Array", f:parse_Array },
0x0225: { n:"DefaultRowHeight", f:parse_DefaultRowHeight },
0x0236: { n:"Table" },
0x023e: { n:"Window2", f:parse_Window2 },
0x027e: { n:"RK", f:parse_RK },
0x0293: { n:"Style" },
0x0406: { n:"Formula", f:parse_Formula },
0x0418: { n:"BigName" },
0x041e: { n:"Format", f:parse_Format },
0x043c: { n:"ContinueBigName" },
0x04bc: { n:"ShrFmla", f:parse_ShrFmla },
0x0800: { n:"HLinkTooltip", f:parse_HLinkTooltip },
0x0801: { n:"WebPub" },
0x0802: { n:"QsiSXTag" },
0x0803: { n:"DBQueryExt" },
0x0804: { n:"ExtString" },
0x0805: { n:"TxtQry" },
0x0806: { n:"Qsir" },
0x0807: { n:"Qsif" },
0x0808: { n:"RRDTQSIF" },
0x0809: { n:'BOF', f:parse_BOF },
0x080a: { n:"OleDbConn" },
0x080b: { n:"WOpt" },
0x080c: { n:"SXViewEx" },
0x080d: { n:"SXTH" },
0x080e: { n:"SXPIEx" },
0x080f: { n:"SXVDTEx" },
0x0810: { n:"SXViewEx9" },
0x0812: { n:"ContinueFrt" },
0x0813: { n:"RealTimeData" },
0x0850: { n:"ChartFrtInfo" },
0x0851: { n:"FrtWrapper" },
0x0852: { n:"StartBlock" },
0x0853: { n:"EndBlock" },
0x0854: { n:"StartObject" },
0x0855: { n:"EndObject" },
0x0856: { n:"CatLab" },
0x0857: { n:"YMult" },
0x0858: { n:"SXViewLink" },
0x0859: { n:"PivotChartBits" },
0x085a: { n:"FrtFontList" },
0x0862: { n:"SheetExt" },
0x0863: { n:"BookExt", r:12},
0x0864: { n:"SXAddl" },
0x0865: { n:"CrErr" },
0x0866: { n:"HFPicture" },
0x0867: { n:'FeatHdr', f:parsenoop2 },
0x0868: { n:"Feat" },
0x086a: { n:"DataLabExt" },
0x086b: { n:"DataLabExtContents" },
0x086c: { n:"CellWatch" },
0x0871: { n:"FeatHdr11" },
0x0872: { n:"Feature11" },
0x0874: { n:"DropDownObjIds" },
0x0875: { n:"ContinueFrt11" },
0x0876: { n:"DConn" },
0x0877: { n:"List12" },
0x0878: { n:"Feature12" },
0x0879: { n:"CondFmt12" },
0x087a: { n:"CF12" },
0x087b: { n:"CFEx" },
0x087c: { n:"XFCRC", f:parse_XFCRC, r:12 },
0x087d: { n:"XFExt", f:parse_XFExt, r:12 },
0x087e: { n:"AutoFilter12" },
0x087f: { n:"ContinueFrt12" },
0x0884: { n:"MDTInfo" },
0x0885: { n:"MDXStr" },
0x0886: { n:"MDXTuple" },
0x0887: { n:"MDXSet" },
0x0888: { n:"MDXProp" },
0x0889: { n:"MDXKPI" },
0x088a: { n:"MDB" },
0x088b: { n:"PLV" },
0x088c: { n:"Compat12", f:parsebool, r:12 },
0x088d: { n:"DXF" },
0x088e: { n:"TableStyles", r:12 },
0x088f: { n:"TableStyle" },
0x0890: { n:"TableStyleElement" },
0x0892: { n:"StyleExt" },
0x0893: { n:"NamePublish" },
0x0894: { n:"NameCmt", f:parse_NameCmt, r:12 },
0x0895: { n:"SortData" },
0x0896: { n:"Theme", f:parse_Theme, r:12 },
0x0897: { n:"GUIDTypeLib" },
0x0898: { n:"FnGrp12" },
0x0899: { n:"NameFnGrp12" },
0x089a: { n:"MTRSettings", f:parse_MTRSettings, r:12 },
0x089b: { n:"CompressPictures", f:parsenoop2 },
0x089c: { n:"HeaderFooter" },
0x089d: { n:"CrtLayout12" },
0x089e: { n:"CrtMlFrt" },
0x089f: { n:"CrtMlFrtContinue" },
0x08a3: { n:"ForceFullCalculation", f:parse_ForceFullCalculation },
0x08a4: { n:"ShapePropsStream" },
0x08a5: { n:"TextPropsStream" },
0x08a6: { n:"RichTextStream" },
0x08a7: { n:"CrtLayout12A" },
0x1001: { n:"Units" },
0x1002: { n:"Chart" },
0x1003: { n:"Series" },
0x1006: { n:"DataFormat" },
0x1007: { n:"LineFormat" },
0x1009: { n:"MarkerFormat" },
0x100a: { n:"AreaFormat" },
0x100b: { n:"PieFormat" },
0x100c: { n:"AttachedLabel" },
0x100d: { n:"SeriesText" },
0x1014: { n:"ChartFormat" },
0x1015: { n:"Legend" },
0x1016: { n:"SeriesList" },
0x1017: { n:"Bar" },
0x1018: { n:"Line" },
0x1019: { n:"Pie" },
0x101a: { n:"Area" },
0x101b: { n:"Scatter" },
0x101c: { n:"CrtLine" },
0x101d: { n:"Axis" },
0x101e: { n:"Tick" },
0x101f: { n:"ValueRange" },
0x1020: { n:"CatSerRange" },
0x1021: { n:"AxisLine" },
0x1022: { n:"CrtLink" },
0x1024: { n:"DefaultText" },
0x1025: { n:"Text" },
0x1026: { n:"FontX", f:parseuint16 },
0x1027: { n:"ObjectLink" },
0x1032: { n:"Frame" },
0x1033: { n:"Begin" },
0x1034: { n:"End" },
0x1035: { n:"PlotArea" },
0x103a: { n:"Chart3d" },
0x103c: { n:"PicF" },
0x103d: { n:"DropBar" },
0x103e: { n:"Radar" },
0x103f: { n:"Surf" },
0x1040: { n:"RadarArea" },
0x1041: { n:"AxisParent" },
0x1043: { n:"LegendException" },
0x1044: { n:"ShtProps", f:parse_ShtProps },
0x1045: { n:"SerToCrt" },
0x1046: { n:"AxesUsed" },
0x1048: { n:"SBaseRef" },
0x104a: { n:"SerParent" },
0x104b: { n:"SerAuxTrend" },
0x104e: { n:"IFmtRecord" },
0x104f: { n:"Pos" },
0x1050: { n:"AlRuns" },
0x1051: { n:"BRAI" },
0x105b: { n:"SerAuxErrBar" },
0x105c: { n:"ClrtClient", f:parse_ClrtClient },
0x105d: { n:"SerFmt" },
0x105f: { n:"Chart3DBarShape" },
0x1060: { n:"Fbi" },
0x1061: { n:"BopPop" },
0x1062: { n:"AxcExt" },
0x1063: { n:"Dat" },
0x1064: { n:"PlotGrowth" },
0x1065: { n:"SIIndex" },
0x1066: { n:"GelFrame" },
0x1067: { n:"BopPopCustom" },
0x1068: { n:"Fbi2" },

0x0000: { n:"Dimensions", f:parse_Dimensions },
0x0002: { n:"BIFF2INT", f:parse_BIFF2INT },
0x0005: { n:"BoolErr", f:parse_BoolErr },
0x0007: { n:"String", f:parse_BIFF2STRING },
0x0008: { n:"BIFF2ROW" },
0x000b: { n:"Index" },
0x0016: { n:"ExternCount", f:parseuint16 },
0x001e: { n:"BIFF2FORMAT", f:parse_BIFF2Format },
0x001f: { n:"BIFF2FMTCNT" }, /* 16-bit cnt of BIFF2FORMAT records */
0x0020: { n:"BIFF2COLINFO" },
0x0021: { n:"Array", f:parse_Array },
0x0025: { n:"DefaultRowHeight", f:parse_DefaultRowHeight },
0x0032: { n:"BIFF2FONTXTRA", f:parse_BIFF2FONTXTRA },
0x0034: { n:"DDEObjName" },
0x003e: { n:"BIFF2WINDOW2" },
0x0043: { n:"BIFF2XF" },
0x0045: { n:"BIFF2FONTCLR" },
0x0056: { n:"BIFF4FMTCNT" }, /* 16-bit cnt, similar to BIFF2 */
0x007e: { n:"RK" }, /* Not necessarily same as 0x027e */
0x007f: { n:"ImData", f:parse_ImData },
0x0087: { n:"Addin" },
0x0088: { n:"Edg" },
0x0089: { n:"Pub" },
0x0091: { n:"Sub" },
0x0094: { n:"LHRecord" },
0x0095: { n:"LHNGraph" },
0x0096: { n:"Sound" },
0x00a9: { n:"CoordList" },
0x00ab: { n:"GCW" },
0x00bc: { n:"ShrFmla" }, /* Not necessarily same as 0x04bc */
0x00bf: { n:"ToolbarHdr" },
0x00c0: { n:"ToolbarEnd" },
0x00c2: { n:"AddMenu" },
0x00c3: { n:"DelMenu" },
0x00d6: { n:"RString", f:parse_RString },
0x00df: { n:"UDDesc" },
0x00ea: { n:"TabIdConf" },
0x0162: { n:"XL5Modify" },
0x01a5: { n:"FileSharing2" },
0x0209: { n:'BOF', f:parse_BOF },
0x0218: { n:"Lbl", f:parse_Lbl },
0x0223: { n:"ExternName", f:parse_ExternName },
0x0231: { n:"Font" },
0x0243: { n:"BIFF3XF" },
0x0409: { n:'BOF', f:parse_BOF },
0x0443: { n:"BIFF4XF" },
0x086d: { n:"FeatInfo" },
0x0873: { n:"FeatInfo11" },
0x0881: { n:"SXAddl12" },
0x08c0: { n:"AutoWebPub" },
0x08c1: { n:"ListObj" },
0x08c2: { n:"ListField" },
0x08c3: { n:"ListDV" },
0x08c4: { n:"ListCondFmt" },
0x08c5: { n:"ListCF" },
0x08c6: { n:"FMQry" },
0x08c7: { n:"FMSQry" },
0x08c8: { n:"PLV" },
0x08c9: { n:"LnExt" },
0x08ca: { n:"MkrExt" },
0x08cb: { n:"CrtCoopt" },
0x08d6: { n:"FRTArchId$", r:12 },

0x7262: {}
};

var XLSRE = evert_key(XLSRecordEnum, 'n');
function write_biff_rec(ba, type, payload, length) {
	var t = +type || +XLSRE[type];
	if(isNaN(t)) return;
	var len = length || (payload||[]).length || 0;
	var o = ba.next(4);
	o.write_shift(2, t);
	o.write_shift(2, len);
	if(len > 0 && is_buf(payload)) ba.push(payload);
}

function write_BIFF2Cell(out, r, c) {
	if(!out) out = new_buf(7);
	out.write_shift(2, r);
	out.write_shift(2, c);
	out.write_shift(2, 0);
	out.write_shift(1, 0);
	return out;
}

function write_BIFF2BERR(r, c, val, t) {
	var out = new_buf(9);
	write_BIFF2Cell(out, r, c);
	if(t == 'e') { out.write_shift(1, val); out.write_shift(1, 1); }
	else { out.write_shift(1, val?1:0); out.write_shift(1, 0); }
	return out;
}

/* TODO: codepage, large strings */
function write_BIFF2LABEL(r, c, val) {
	var out = new_buf(8 + 2*val.length);
	write_BIFF2Cell(out, r, c);
	out.write_shift(1, val.length);
	out.write_shift(val.length, val, 'sbcs');
	return out.l < out.length ? out.slice(0, out.l) : out;
}

function write_ws_biff2_cell(ba, cell, R, C) {
	if(cell.v != null) switch(cell.t) {
		case 'd': case 'n':
			var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
			if((v == (v|0)) && (v >= 0) && (v < 65536))
				write_biff_rec(ba, 0x0002, write_BIFF2INT(R, C, v));
			else
				write_biff_rec(ba, 0x0003, write_BIFF2NUM(R,C, v));
			return;
		case 'b': case 'e': write_biff_rec(ba, 0x0005, write_BIFF2BERR(R, C, cell.v, cell.t)); return;
		/* TODO: codepage, sst */
		case 's': case 'str':
			write_biff_rec(ba, 0x0004, write_BIFF2LABEL(R, C, cell.v));
			return;
	}
	write_biff_rec(ba, 0x0001, write_BIFF2Cell(null, R, C));
}

function write_ws_biff2(ba, ws, idx, opts) {
	var dense = Array.isArray(ws);
	var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
	if(range.e.c > 0xFF || range.e.r > 0x3FFF) {
		if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
		range.e.c = Math.min(range.e.c, 0xFF);
		range.e.r = Math.min(range.e.c, 0x3FFF);
		ref = encode_range(range);
	}
	for(var R = range.s.r; R <= range.e.r; ++R) {
		rr = encode_row(R);
		for(var C = range.s.c; C <= range.e.c; ++C) {
			if(R === range.s.r) cols[C] = encode_col(C);
			ref = cols[C] + rr;
			var cell = dense ? (ws[R]||[])[C] : ws[ref];
			if(!cell) continue;
			/* write cell */
			write_ws_biff2_cell(ba, cell, R, C, opts);
		}
	}
}

/* Based on test files */
function write_biff2_buf(wb, opts) {
	var o = opts || {};
	if(DENSE != null && o.dense == null) o.dense = DENSE;
	var ba = buf_array();
	var idx = 0;
	for(var i=0;i<wb.SheetNames.length;++i) if(wb.SheetNames[i] == o.sheet) idx=i;
	if(idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
	write_biff_rec(ba, 0x0009, write_BOF(wb, 0x10, o));
	/* ... */
	write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
	/* ... */
	write_biff_rec(ba, 0x000A);
	return ba.end();
}

function write_FONTS_biff8(ba, data, opts) {
	write_biff_rec(ba, "Font", write_Font({
		sz:12,
		color: {theme:1},
		name: "Arial",
		family: 2,
		scheme: "minor"
	}, opts));
}


function write_FMTS_biff8(ba, NF, opts) {
	if(!NF) return;
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_biff_rec(ba, "Format", write_Format(i, NF[i], opts));
	});
}

function write_FEAT(ba, ws) {
	/* [MS-XLS] 2.4.112 */
	var o = new_buf(19);
	o.write_shift(4, 0x867); o.write_shift(4, 0); o.write_shift(4, 0);
	o.write_shift(2, 3); o.write_shift(1, 1); o.write_shift(4, 0);
	write_biff_rec(ba, "FeatHdr", o);
	/* [MS-XLS] 2.4.111 */
	o = new_buf(39);
	o.write_shift(4, 0x868); o.write_shift(4, 0); o.write_shift(4, 0);
	o.write_shift(2, 3); o.write_shift(1, 0); o.write_shift(4, 0);
	o.write_shift(2, 1); o.write_shift(4, 4); o.write_shift(2, 0);
	write_Ref8U(safe_decode_range(ws['!ref']||"A1"), o);
	o.write_shift(4, 4);
	write_biff_rec(ba, "Feat", o);
}

function write_CELLXFS_biff8(ba, opts) {
	for(var i = 0; i < 16; ++i) write_biff_rec(ba, "XF", write_XF({numFmtId:0, style:true}, 0, opts));
	opts.cellXfs.forEach(function(c) {
		write_biff_rec(ba, "XF", write_XF(c, 0, opts));
	});
}

function write_ws_biff8_hlinks(ba, ws) {
	for(var R=0; R<ws['!links'].length; ++R) {
		var HL = ws['!links'][R];
		write_biff_rec(ba, "HLink", write_HLink(HL));
		if(HL[1].Tooltip) write_biff_rec(ba, "HLinkTooltip", write_HLinkTooltip(HL));
	}
	delete ws['!links'];
}

function write_ws_biff8_cell(ba, cell, R, C, opts) {
	var os = 16 + get_cell_style(opts.cellXfs, cell, opts);
	if(cell.v != null) switch(cell.t) {
		case 'd': case 'n':
			var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
			/* TODO: emit RK as appropriate */
			write_biff_rec(ba, "Number", write_Number(R, C, v, os, opts));
			return;
		case 'b': case 'e': write_biff_rec(ba, 0x0205, write_BoolErr(R, C, cell.v, os, opts, cell.t)); return;
		/* TODO: codepage, sst */
		case 's': case 'str':
			write_biff_rec(ba, "Label", write_Label(R, C, cell.v, os, opts));
			return;
	}
	write_biff_rec(ba, "Blank", write_XLSCell(R, C, os));
}

/* [MS-XLS] 2.1.7.20.5 */
function write_ws_biff8(idx, opts, wb) {
	var ba = buf_array();
	var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
	var _WB = ((wb||{}).Workbook||{});
	var _sheet = ((_WB.Sheets||[])[idx]||{});
	var dense = Array.isArray(ws);
	var b8 = opts.biff == 8;
	var ref, rr = "", cols = [];
	var range = safe_decode_range(ws['!ref'] || "A1");
	var MAX_ROWS = b8 ? 65536 : 16384;
	if(range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
		if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
		range.e.c = Math.min(range.e.c, 0xFF);
		range.e.r = Math.min(range.e.c, MAX_ROWS-1);
	}

	write_biff_rec(ba, 0x0809, write_BOF(wb, 0x10, opts));
	/* ... */
	write_biff_rec(ba, "CalcMode", writeuint16(1));
	write_biff_rec(ba, "CalcCount", writeuint16(100));
	write_biff_rec(ba, "CalcRefMode", writebool(true));
	write_biff_rec(ba, "CalcIter", writebool(false));
	write_biff_rec(ba, "CalcDelta", write_Xnum(0.001));
	write_biff_rec(ba, "CalcSaveRecalc", writebool(true));
	write_biff_rec(ba, "PrintRowCol", writebool(false));
	write_biff_rec(ba, "PrintGrid", writebool(false));
	write_biff_rec(ba, "GridSet", writeuint16(1));
	write_biff_rec(ba, "Guts", write_Guts([0,0]));
	/* ... */
	write_biff_rec(ba, "HCenter", writebool(false));
	write_biff_rec(ba, "VCenter", writebool(false));
	/* ... */
	write_biff_rec(ba, "Dimensions", write_Dimensions(range, opts));
	/* ... */

	if(b8) ws['!links'] = [];
	for(var R = range.s.r; R <= range.e.r; ++R) {
		rr = encode_row(R);
		for(var C = range.s.c; C <= range.e.c; ++C) {
			if(R === range.s.r) cols[C] = encode_col(C);
			ref = cols[C] + rr;
			var cell = dense ? (ws[R]||[])[C] : ws[ref];
			if(!cell) continue;
			/* write cell */
			write_ws_biff8_cell(ba, cell, R, C, opts);
			if(b8 && cell.l) ws['!links'].push([ref, cell.l]);
		}
	}
	var cname = _sheet.CodeName || _sheet.name || s;
	/* ... */
	if(b8 && _WB.Views) write_biff_rec(ba, "Window2", write_Window2(_WB.Views[0]));
	/* ... */
	if(b8 && (ws['!merges']||[]).length) write_biff_rec(ba, "MergeCells", write_MergeCells(ws['!merges']));
	/* ... */
	if(b8) write_ws_biff8_hlinks(ba, ws);
	/* ... */
	write_biff_rec(ba, "CodeName", write_XLUnicodeString(cname, opts));
	/* ... */
	if(b8) write_FEAT(ba, ws);
	/* ... */
	write_biff_rec(ba, "EOF");
	return ba.end();
}

/* [MS-XLS] 2.1.7.20.3 */
function write_biff8_global(wb, bufs, opts) {
	var A = buf_array();
	var _WB = ((wb||{}).Workbook||{});
	var _sheets = (_WB.Sheets||[]);
	var _wb = _WB.WBProps||{};
	var b8 = opts.biff == 8, b5 = opts.biff == 5;
	write_biff_rec(A, 0x0809, write_BOF(wb, 0x05, opts));
	if(opts.bookType == "xla") write_biff_rec(A, "Addin");
	write_biff_rec(A, "InterfaceHdr", b8 ? writeuint16(0x04b0) : null);
	write_biff_rec(A, "Mms", writezeroes(2));
	if(b5) write_biff_rec(A, "ToolbarHdr");
	if(b5) write_biff_rec(A, "ToolbarEnd");
	write_biff_rec(A, "InterfaceEnd");
	write_biff_rec(A, "WriteAccess", write_WriteAccess("SheetJS", opts));
	write_biff_rec(A, "CodePage", writeuint16(b8 ? 0x04b0 : 0x04E4));
	if(b8) write_biff_rec(A, "DSF", writeuint16(0));
	if(b8) write_biff_rec(A, "Excel9File");
	write_biff_rec(A, "RRTabId", write_RRTabId(wb.SheetNames.length));
	if(b8 && wb.vbaraw) {
		write_biff_rec(A, "ObProj");
		var cname = _wb.CodeName || "ThisWorkbook";
		write_biff_rec(A, "CodeName", write_XLUnicodeString(cname, opts));
	}
	write_biff_rec(A, "BuiltInFnGroupCount", writeuint16(0x11));
	write_biff_rec(A, "WinProtect", writebool(false));
	write_biff_rec(A, "Protect", writebool(false));
	write_biff_rec(A, "Password", writeuint16(0));
	if(b8) write_biff_rec(A, "Prot4Rev", writebool(false));
	if(b8) write_biff_rec(A, "Prot4RevPass", writeuint16(0));
	write_biff_rec(A, "Window1", write_Window1(opts));
	write_biff_rec(A, "Backup", writebool(false));
	write_biff_rec(A, "HideObj", writeuint16(0));
	write_biff_rec(A, "Date1904", writebool(safe1904(wb)=="true"));
	write_biff_rec(A, "CalcPrecision", writebool(true));
	if(b8) write_biff_rec(A, "RefreshAll", writebool(false));
	write_biff_rec(A, "BookBool", writeuint16(0));
	/* ... */
	write_FONTS_biff8(A, wb, opts);
	write_FMTS_biff8(A, wb.SSF, opts);
	write_CELLXFS_biff8(A, opts);
	/* ... */
	if(b8) write_biff_rec(A, "UsesELFs", writebool(false));
	var a = A.end();

	var C = buf_array();
	if(b8) write_biff_rec(C, "Country", write_Country());
	/* BIFF8: [SST *Continue] ExtSST */
	write_biff_rec(C, "EOF");
	var c = C.end();

	var B = buf_array();
	var blen = 0, j = 0;
	for(j = 0; j < wb.SheetNames.length; ++j) blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
	var start = a.length + blen + c.length;
	for(j = 0; j < wb.SheetNames.length; ++j) {
		var _sheet = _sheets[j] || ({});
		write_biff_rec(B, "BoundSheet8", write_BoundSheet8({pos:start, hs:_sheet.Hidden||0, dt:0, name:wb.SheetNames[j]}, opts));
		start += bufs[j].length;
	}
	/* 1*BoundSheet8 */
	var b = B.end();
	if(blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);

	var out = [];
	if(a.length) out.push(a);
	if(b.length) out.push(b);
	if(c.length) out.push(c);
	return __toBuffer([out]);
}

/* [MS-XLS] 2.1.7.20 Workbook Stream */
function write_biff8_buf(wb, opts) {
	var o = opts || {};
	var bufs = [];

	if(wb && !wb.SSF) {
		wb.SSF = SSF.get_table();
	}
	if(wb && wb.SSF) {
		make_ssf(SSF); SSF.load_table(wb.SSF);
		// $FlowIgnore
		o.revssf = evert_num(wb.SSF); o.revssf[wb.SSF[65535]] = 0;
		o.ssf = wb.SSF;
	}
	o.cellXfs = [];
	o.Strings = []; o.Strings.Count = 0; o.Strings.Unique = 0;
	get_cell_style(o.cellXfs, {}, {revssf:{"General":0}});

	for(var i = 0; i < wb.SheetNames.length; ++i) bufs[bufs.length] = write_ws_biff8(i, o, wb);
	bufs.unshift(write_biff8_global(wb, bufs, o));
	return __toBuffer([bufs]);
}

function write_biff_buf(wb, opts) {
	var o = opts || {};
	switch(o.biff || 2) {
		case 8: case 5: return write_biff8_buf(wb, opts);
		case 4: case 3: case 2: return write_biff2_buf(wb, opts);
	}
	throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */
var HTML_ = (function() {
	function html_to_sheet(str, _opts) {
		var opts = _opts || {};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var ws = opts.dense ? ([]) : ({});
		var mtch = str.match(/<table/i);
		if(!mtch) throw new Error("Invalid HTML: could not find <table>");
		var mtch2 = str.match(/<\/table/i);
		var i = mtch.index, j = mtch2 && mtch2.index || str.length;
		var rows = split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
		var R = -1, C = 0, RS = 0, CS = 0;
		var range = {s:{r:10000000, c:10000000},e:{r:0,c:0}};
		var merges = [];
		for(i = 0; i < rows.length; ++i) {
			var row = rows[i].trim();
			var hd = row.slice(0,3).toLowerCase();
			if(hd == "<tr") { ++R; if(opts.sheetRows && opts.sheetRows <= R) { --R; break; } C = 0; continue; }
			if(hd != "<td" && hd != "<th") continue;
			var cells = row.split(/<\/t[dh]>/i);
			for(j = 0; j < cells.length; ++j) {
				var cell = cells[j].trim();
				if(!cell.match(/<t[dh]/i)) continue;
				var m = cell, cc = 0;
				/* TODO: parse styles etc */
				while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1) m = m.slice(cc+1);
				var tag = parsexmltag(cell.slice(0, cell.indexOf(">")));
				CS = tag.colspan ? +tag.colspan : 1;
				if((RS = +tag.rowspan)>1 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
				var _t = tag.t || "";
				/* TODO: generate stub cells */
				if(!m.length) { C += CS; continue; }
				m = htmldecode(m);
				if(range.s.r > R) range.s.r = R; if(range.e.r < R) range.e.r = R;
				if(range.s.c > C) range.s.c = C; if(range.e.c < C) range.e.c = C;
				if(!m.length) continue;
				var o = {t:'s', v:m};
				if(opts.raw || !m.trim().length || _t == 's'){}
				else if(m === 'TRUE') o = {t:'b', v:true};
				else if(m === 'FALSE') o = {t:'b', v:false};
				else if(!isNaN(fuzzynum(m))) o = {t:'n', v:fuzzynum(m)};
				else if(!isNaN(fuzzydate(m).getDate())) {
					o = ({t:'d', v:parseDate(m)});
					if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
					o.z = opts.dateNF || SSF._table[14];
				}
				if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
				else ws[encode_cell({r:R, c:C})] = o;
				C += CS;
			}
		}
		ws['!ref'] = encode_range(range);
		return ws;
	}
	function html_to_book(str, opts) {
		return sheet_to_workbook(html_to_sheet(str, opts), opts);
	}
	function make_html_row(ws, r, R, o) {
		var M = (ws['!merges'] ||[]);
		var oo = [];
		for(var C = r.s.c; C <= r.e.c; ++C) {
			var RS = 0, CS = 0;
			for(var j = 0; j < M.length; ++j) {
				if(M[j].s.r > R || M[j].s.c > C) continue;
				if(M[j].e.r < R || M[j].e.c < C) continue;
				if(M[j].s.r < R || M[j].s.c < C) { RS = -1; break; }
				RS = M[j].e.r - M[j].s.r + 1; CS = M[j].e.c - M[j].s.c + 1; break;
			}
			if(RS < 0) continue;
			var coord = encode_cell({r:R,c:C});
			var cell = o.dense ? (ws[R]||[])[C] : ws[coord];
			var sp = {};
			if(RS > 1) sp.rowspan = RS;
			if(CS > 1) sp.colspan = CS;
			/* TODO: html entities */
			var w = (cell && cell.v != null) && (cell.h || escapehtml(cell.w || (format_cell(cell), cell.w) || "")) || "";
			sp.t = cell && cell.t || 'z';
			if(o.editable) w = '<span contenteditable="true">' + w + '</span>';
			sp.id = "sjs-" + coord;
			oo.push(writextag('td', w, sp));
		}
		var preamble = "<tr>";
		return preamble + oo.join("") + "</tr>";
	}
	function make_html_preamble(ws, R, o) {
		var out = [];
		return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
	}
	var _BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
	var _END = '</body></html>';
	function sheet_to_html(ws, opts/*, wb:?Workbook*/) {
		var o = opts || {};
		var header = o.header != null ? o.header : _BEGIN;
		var footer = o.footer != null ? o.footer : _END;
		var out = [header];
		var r = decode_range(ws['!ref']);
		o.dense = Array.isArray(ws);
		out.push(make_html_preamble(ws, r, o));
		for(var R = r.s.r; R <= r.e.r; ++R) out.push(make_html_row(ws, r, R, o));
		out.push("</table>" + footer);
		return out.join("");
	}

	return {
		to_workbook: html_to_book,
		to_sheet: html_to_sheet,
		_row: make_html_row,
		BEGIN: _BEGIN,
		END: _END,
		_preamble: make_html_preamble,
		from_sheet: sheet_to_html
	};
})();

function parse_dom_table(table, _opts) {
	var opts = _opts || {};
	if(DENSE != null) opts.dense = DENSE;
	var ws = opts.dense ? ([]) : ({});
	var rows = table.getElementsByTagName('tr');
	var sheetRows = opts.sheetRows || 10000000;
	var range = {s:{r:0,c:0},e:{r:0,c:0}};
	var merges = [], midx = 0;
	var rowinfo = [];
	var _R = 0, R = 0, _C, C, RS, CS;
	for(; _R < rows.length && R < sheetRows; ++_R) {
		var row = rows[_R];
		if (is_dom_element_hidden(row)) {
			if (opts.display) continue;
			rowinfo[R] = {hidden: true};
		}
		var elts = (row.children);
		for(_C = C = 0; _C < elts.length; ++_C) {
			var elt = elts[_C];
			if (opts.display && is_dom_element_hidden(elt)) continue;
			var v = htmldecode(elt.innerHTML);
			for(midx = 0; midx < merges.length; ++midx) {
				var m = merges[midx];
				if(m.s.c == C && m.s.r <= R && R <= m.e.r) { C = m.e.c+1; midx = -1; }
			}
			/* TODO: figure out how to extract nonstandard mso- style */
			CS = +elt.getAttribute("colspan") || 1;
			if((RS = +elt.getAttribute("rowspan"))>0 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
			var o = {t:'s', v:v};
			var _t = elt.getAttribute("t") || "";
			if(v != null) {
				if(v.length == 0) o.t = _t || 'z';
				else if(opts.raw || v.trim().length == 0 || _t == "s"){}
				else if(v === 'TRUE') o = {t:'b', v:true};
				else if(v === 'FALSE') o = {t:'b', v:false};
				else if(!isNaN(fuzzynum(v))) o = {t:'n', v:fuzzynum(v)};
				else if(!isNaN(fuzzydate(v).getDate())) {
					o = ({t:'d', v:parseDate(v)});
					if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
					o.z = opts.dateNF || SSF._table[14];
				}
			}
			if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
			else ws[encode_cell({c:C, r:R})] = o;
			if(range.e.c < C) range.e.c = C;
			C += CS;
		}
		++R;
	}
	if(merges.length) ws['!merges'] = merges;
	if(rowinfo.length) ws['!rows'] = rowinfo;
	range.e.r = R - 1;
	ws['!ref'] = encode_range(range);
	if(R >= sheetRows) ws['!fullref'] = encode_range((range.e.r = rows.length-_R+R-1,range)); // We can count the real number of rows to parse but we don't to improve the performance
	return ws;
}

function table_to_book(table, opts) {
	return sheet_to_workbook(parse_dom_table(table, opts), opts);
}

function is_dom_element_hidden(element) {
	var display = '';
	var get_computed_style = get_get_computed_style_function(element);
	if(get_computed_style) display = get_computed_style(element).getPropertyValue('display');
	if(!display) display = element.style.display; // Fallback for cases when getComputedStyle is not available (e.g. an old browser or some Node.js environments) or doesn't work (e.g. if the element is not inserted to a document)
	return display === 'none';
}

/* global getComputedStyle */
function get_get_computed_style_function(element) {
	// The proper getComputedStyle implementation is the one defined in the element window
	if(element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
	// If it is not available, try to get one from the global namespace
	if(typeof getComputedStyle === 'function') return getComputedStyle;
	return null;
}
/* OpenDocument */
var parse_content_xml = (function() {

	/* 6.1.2 White Space Characters */
	var parse_text_p = function(text) {
		return unescapexml(text
			.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ")
			.replace(/<text:s\/>/g," ")
			.replace(/<text:s text:c="(\d+)"\/>/g, function($$,$1) { return Array(parseInt($1,10)+1).join(" "); })
			.replace(/<text:tab[^>]*\/>/g,"\t")
			.replace(/<text:line-break\/>/g,"\n")
			.replace(/<[^>]*>/g,"")
		);
	};

	var number_formats = {
		/* ods name: [short ssf fmt, long ssf fmt] */
		day:           ["d",   "dd"],
		month:         ["m",   "mm"],
		year:          ["y",   "yy"],
		hours:         ["h",   "hh"],
		minutes:       ["m",   "mm"],
		seconds:       ["s",   "ss"],
		"am-pm":       ["A/P", "AM/PM"],
		"day-of-week": ["ddd", "dddd"],
		era:           ["e",   "ee"],
		/* there is no native representation of LO "Q" format */
		quarter:       ["\\Qm", "m\\\"th quarter\""]
	};

	return function pcx(d, _opts) {
		var opts = _opts || {};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var str = xlml_normalize(d);
		var state = [], tmp;
		var tag;
		var NFtag = {name:""}, NF = "", pidx = 0;
		var sheetag;
		var rowtag;
		var Sheets = {}, SheetNames = [];
		var ws = opts.dense ? ([]) : ({});
		var Rn, q;
		var ctag = ({value:""});
		var textp = "", textpidx = 0, textptag;
		var R = -1, C = -1, range = {s: {r:1000000,c:10000000}, e: {r:0, c:0}};
		var row_ol = 0;
		var number_format_map = {};
		var merges = [], mrange = {}, mR = 0, mC = 0;
		var rowinfo = [], rowpeat = 1, colpeat = 1;
		var arrayf = [];
		var WB = {Names:[]};
		var atag = ({});
		var _Ref = ["", ""];
		var comments = [], comment = ({});
		var creator = "", creatoridx = 0;
		var isstub = false, intable = false;
		var i = 0;
		xlmlregex.lastIndex = 0;
		str = str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
		while((Rn = xlmlregex.exec(str))) switch((Rn[3]=Rn[3].replace(/_.*$/,""))) {

			case 'table': case '工作表': // 9.1.2 <table:table>
				if(Rn[1]==='/') {
					if(range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = encode_range(range);
					if(opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
						ws['!fullref'] = ws['!ref'];
						range.e.r = opts.sheetRows - 1;
						ws['!ref'] = encode_range(range);
					}
					if(merges.length) ws['!merges'] = merges;
					if(rowinfo.length) ws["!rows"] = rowinfo;
					sheetag.name = sheetag['名称'] || sheetag.name;
					if(typeof JSON !== 'undefined') JSON.stringify(sheetag);
					SheetNames.push(sheetag.name);
					Sheets[sheetag.name] = ws;
					intable = false;
				}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					sheetag = parsexmltag(Rn[0], false);
					R = C = -1;
					range.s.r = range.s.c = 10000000; range.e.r = range.e.c = 0;
					ws = opts.dense ? ([]) : ({}); merges = [];
					rowinfo = [];
					intable = true;
				}
				break;

			case 'table-row-group': // 9.1.9 <table:table-row-group>
				if(Rn[1] === "/") --row_ol; else ++row_ol;
				break;
			case 'table-row': case '行': // 9.1.3 <table:table-row>
				if(Rn[1] === '/') { R+=rowpeat; rowpeat = 1; break; }
				rowtag = parsexmltag(Rn[0], false);
				if(rowtag['行号']) R = rowtag['行号'] - 1; else if(R == -1) R = 0;
				rowpeat = +rowtag['number-rows-repeated'] || 1;
				/* TODO: remove magic */
				if(rowpeat < 10) for(i = 0; i < rowpeat; ++i) if(row_ol > 0) rowinfo[R + i] = {level: row_ol};
				C = -1; break;
			case 'covered-table-cell': // 9.1.5 <table:covered-table-cell>
				++C;
				if(opts.sheetStubs) {
					if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = {t:'z'}; }
					else ws[encode_cell({r:R,c:C})] = {t:'z'};
				}
				break; /* stub */
			case 'table-cell': case '数据':
				if(Rn[0].charAt(Rn[0].length-2) === '/') {
					++C;
					ctag = parsexmltag(Rn[0], false);
					colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
					q = ({t:'z', v:null});
					if(ctag.formula && opts.cellFormula != false) q.f = ods_to_csf_formula(unescapexml(ctag.formula));
					if((ctag['数据类型'] || ctag['value-type']) == "string") {
						q.t = "s"; q.v = unescapexml(ctag['string-value'] || "");
						if(opts.dense) {
							if(!ws[R]) ws[R] = [];
							ws[R][C] = q;
						} else {
							ws[encode_cell({r:R,c:C})] = q;
						}
					}
					C+= colpeat-1;
				} else if(Rn[1]!=='/') {
					++C;
					colpeat = 1;
					var rptR = rowpeat ? R + rowpeat - 1 : R;
					if(C > range.e.c) range.e.c = C;
					if(C < range.s.c) range.s.c = C;
					if(R < range.s.r) range.s.r = R;
					if(rptR > range.e.r) range.e.r = rptR;
					ctag = parsexmltag(Rn[0], false);
					comments = []; comment = ({});
					q = ({t:ctag['数据类型'] || ctag['value-type'], v:null});
					if(opts.cellFormula) {
						if(ctag.formula) ctag.formula = unescapexml(ctag.formula);
						if(ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
							mR = parseInt(ctag['number-matrix-rows-spanned'],10) || 0;
							mC = parseInt(ctag['number-matrix-columns-spanned'],10) || 0;
							mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
							q.F = encode_range(mrange);
							arrayf.push([mrange, q.F]);
						}
						if(ctag.formula) q.f = ods_to_csf_formula(ctag.formula);
						else for(i = 0; i < arrayf.length; ++i)
							if(R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r)
								if(C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c)
									q.F = arrayf[i][1];
					}
					if(ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
						mR = parseInt(ctag['number-rows-spanned'],10) || 0;
						mC = parseInt(ctag['number-columns-spanned'],10) || 0;
						mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
						merges.push(mrange);
					}

					/* 19.675.2 table:number-columns-repeated */
					if(ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);

					/* 19.385 office:value-type */
					switch(q.t) {
						case 'boolean': q.t = 'b'; q.v = parsexmlbool(ctag['boolean-value']); break;
						case 'float': q.t = 'n'; q.v = parseFloat(ctag.value); break;
						case 'percentage': q.t = 'n'; q.v = parseFloat(ctag.value); break;
						case 'currency': q.t = 'n'; q.v = parseFloat(ctag.value); break;
						case 'date': q.t = 'd'; q.v = parseDate(ctag['date-value']);
							if(!opts.cellDates) { q.t = 'n'; q.v = datenum(q.v); }
							q.z = 'm/d/yy'; break;
						case 'time': q.t = 'n'; q.v = parse_isodur(ctag['time-value'])/86400; break;
						case 'number': q.t = 'n'; q.v = parseFloat(ctag['数据数值']); break;
						default:
							if(q.t === 'string' || q.t === 'text' || !q.t) {
								q.t = 's';
								if(ctag['string-value'] != null) textp = unescapexml(ctag['string-value']);
							} else throw new Error('Unsupported value type ' + q.t);
					}
				} else {
					isstub = false;
					if(q.t === 's') {
						q.v = textp || '';
						isstub = textpidx == 0;
					}
					if(atag.Target) q.l = atag;
					if(comments.length > 0) { q.c = comments; comments = []; }
					if(textp && opts.cellText !== false) q.w = textp;
					if(!isstub || opts.sheetStubs) {
						if(!(opts.sheetRows && opts.sheetRows <= R)) {
							for(var rpt = 0; rpt < rowpeat; ++rpt) {
								colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
								if(opts.dense) {
									if(!ws[R + rpt]) ws[R + rpt] = [];
									ws[R + rpt][C] = rpt == 0 ? q : dup(q);
									while(--colpeat > 0) ws[R + rpt][C + colpeat] = dup(q);
								} else {
									ws[encode_cell({r:R + rpt,c:C})] = q;
									while(--colpeat > 0) ws[encode_cell({r:R + rpt,c:C + colpeat})] = dup(q);
								}
								if(range.e.c <= C) range.e.c = C;
							}
						}
					}
					colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
					C += colpeat-1; colpeat = 0;
					q = {};
					textp = "";
				}
				atag = ({});
				break; // 9.1.4 <table:table-cell>

			/* pure state */
			case 'document': // TODO: <office:document> is the root for FODS
			case 'document-content': case '电子表格文档': // 3.1.3.2 <office:document-content>
			case 'spreadsheet': case '主体': // 3.7 <office:spreadsheet>
			case 'scripts': // 3.12 <office:scripts>
			case 'styles': // TODO <office:styles>
			case 'font-face-decls': // 3.14 <office:font-face-decls>
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				break;

			case 'annotation': // 14.1 <office:annotation>
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
					comment.t = textp;
					comment.a = creator;
					comments.push(comment);
				}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {state.push([Rn[3], false]);}
				creator = ""; creatoridx = 0;
				textp = ""; textpidx = 0;
				break;

			case 'creator': // 4.3.2.7 <dc:creator>
				if(Rn[1]==='/') { creator = str.slice(creatoridx,Rn.index); }
				else creatoridx = Rn.index + Rn[0].length;
				break;

			/* ignore state */
			case 'meta': case '元数据': // TODO: <office:meta> <uof:元数据> FODS/UOF
			case 'settings': // TODO: <office:settings>
			case 'config-item-set': // TODO: <office:config-item-set>
			case 'config-item-map-indexed': // TODO: <office:config-item-map-indexed>
			case 'config-item-map-entry': // TODO: <office:config-item-map-entry>
			case 'config-item-map-named': // TODO: <office:config-item-map-entry>
			case 'shapes': // 9.2.8 <table:shapes>
			case 'frame': // 10.4.2 <draw:frame>
			case 'text-box': // 10.4.3 <draw:text-box>
			case 'image': // 10.4.4 <draw:image>
			case 'data-pilot-tables': // 9.6.2 <table:data-pilot-tables>
			case 'list-style': // 16.30 <text:list-style>
			case 'form': // 13.13 <form:form>
			case 'dde-links': // 9.8 <table:dde-links>
			case 'event-listeners': // TODO
			case 'chart': // TODO
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], false]);
				textp = ""; textpidx = 0;
				break;

			case 'scientific-number': // TODO: <number:scientific-number>
				break;
			case 'currency-symbol': // TODO: <number:currency-symbol>
				break;
			case 'currency-style': // TODO: <number:currency-style>
				break;
			case 'number-style': // 16.27.2 <number:number-style>
			case 'percentage-style': // 16.27.9 <number:percentage-style>
			case 'date-style': // 16.27.10 <number:date-style>
			case 'time-style': // 16.27.18 <number:time-style>
				if(Rn[1]==='/'){
					number_format_map[NFtag.name] = NF;
					if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
				} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					NF = "";
					NFtag = parsexmltag(Rn[0], false);
					state.push([Rn[3], true]);
				} break;

			case 'script': break; // 3.13 <office:script>
			case 'libraries': break; // TODO: <ooo:libraries>
			case 'automatic-styles': break; // 3.15.3 <office:automatic-styles>
			case 'master-styles': break; // TODO: <office:master-styles>

			case 'default-style': // TODO: <style:default-style>
			case 'page-layout': break; // TODO: <style:page-layout>
			case 'style': break; // 16.2 <style:style>
			case 'map': break; // 16.3 <style:map>
			case 'font-face': break; // 16.21 <style:font-face>

			case 'paragraph-properties': break; // 17.6 <style:paragraph-properties>
			case 'table-properties': break; // 17.15 <style:table-properties>
			case 'table-column-properties': break; // 17.16 <style:table-column-properties>
			case 'table-row-properties': break; // 17.17 <style:table-row-properties>
			case 'table-cell-properties': break; // 17.18 <style:table-cell-properties>

			case 'number': // 16.27.3 <number:number>
				switch(state[state.length-1][0]) {
					case 'time-style':
					case 'date-style':
						tag = parsexmltag(Rn[0], false);
						NF += number_formats[Rn[3]][tag.style==='long'?1:0]; break;
				} break;

			case 'fraction': break; // TODO 16.27.6 <number:fraction>

			case 'day': // 16.27.11 <number:day>
			case 'month': // 16.27.12 <number:month>
			case 'year': // 16.27.13 <number:year>
			case 'era': // 16.27.14 <number:era>
			case 'day-of-week': // 16.27.15 <number:day-of-week>
			case 'week-of-year': // 16.27.16 <number:week-of-year>
			case 'quarter': // 16.27.17 <number:quarter>
			case 'hours': // 16.27.19 <number:hours>
			case 'minutes': // 16.27.20 <number:minutes>
			case 'seconds': // 16.27.21 <number:seconds>
			case 'am-pm': // 16.27.22 <number:am-pm>
				switch(state[state.length-1][0]) {
					case 'time-style':
					case 'date-style':
						tag = parsexmltag(Rn[0], false);
						NF += number_formats[Rn[3]][tag.style==='long'?1:0]; break;
				} break;

			case 'boolean-style': break; // 16.27.23 <number:boolean-style>
			case 'boolean': break; // 16.27.24 <number:boolean>
			case 'text-style': break; // 16.27.25 <number:text-style>
			case 'text': // 16.27.26 <number:text>
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") switch(state[state.length-1][0]) {
					case 'number-style':
					case 'date-style':
					case 'time-style':
						NF += str.slice(pidx, Rn.index);
						break;
				}
				else pidx = Rn.index + Rn[0].length;
				break;

			case 'named-range': // 9.4.12 <table:named-range>
				tag = parsexmltag(Rn[0], false);
				_Ref = ods_to_csf_3D(tag['cell-range-address']);
				var nrange = ({Name:tag.name, Ref:_Ref[0] + '!' + _Ref[1]});
				if(intable) nrange.Sheet = SheetNames.length;
				WB.Names.push(nrange);
				break;

			case 'text-content': break; // 16.27.27 <number:text-content>
			case 'text-properties': break; // 16.27.27 <style:text-properties>
			case 'embedded-text': break; // 16.27.4 <number:embedded-text>

			case 'body': case '电子表格': break; // 3.3 16.9.6 19.726.3

			case 'forms': break; // 12.25.2 13.2
			case 'table-column': break; // 9.1.6 <table:table-column>
			case 'table-header-rows': break; // 9.1.7 <table:table-header-rows>
			case 'table-rows': break; // 9.1.12 <table:table-rows>
			/* TODO: outline levels */
			case 'table-column-group': break; // 9.1.10 <table:table-column-group>
			case 'table-header-columns': break; // 9.1.11 <table:table-header-columns>
			case 'table-columns': break; // 9.1.12 <table:table-columns>

			case 'null-date': break; // 9.4.2 <table:null-date> TODO: date1904

			case 'graphic-properties': break; // 17.21 <style:graphic-properties>
			case 'calculation-settings': break; // 9.4.1 <table:calculation-settings>
			case 'named-expressions': break; // 9.4.11 <table:named-expressions>
			case 'label-range': break; // 9.4.9 <table:label-range>
			case 'label-ranges': break; // 9.4.10 <table:label-ranges>
			case 'named-expression': break; // 9.4.13 <table:named-expression>
			case 'sort': break; // 9.4.19 <table:sort>
			case 'sort-by': break; // 9.4.20 <table:sort-by>
			case 'sort-groups': break; // 9.4.22 <table:sort-groups>

			case 'tab': break; // 6.1.4 <text:tab>
			case 'line-break': break; // 6.1.5 <text:line-break>
			case 'span': break; // 6.1.7 <text:span>
			case 'p': case '文本串': // 5.1.3 <text:p>
				if(Rn[1]==='/' && (!ctag || !ctag['string-value'])) textp = (textp.length > 0 ? textp + "\n" : "") + parse_text_p(str.slice(textpidx,Rn.index), textptag);
				else { textptag = parsexmltag(Rn[0], false); textpidx = Rn.index + Rn[0].length; }
				break; // <text:p>
			case 's': break; // <text:s>

			case 'database-range': // 9.4.15 <table:database-range>
				if(Rn[1]==='/') break;
				try {
					_Ref = ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);
					Sheets[_Ref[0]]['!autofilter'] = { ref:_Ref[1] };
				} catch(e) {/* empty */}
				break;

			case 'date': break; // <*:date>

			case 'object': break; // 10.4.6.2 <draw:object>
			case 'title': case '标题': break; // <*:title> OR <uof:标题>
			case 'desc': break; // <*:desc>
			case 'binary-data': break; // 10.4.5 TODO: b64 blob

			/* 9.2 Advanced Tables */
			case 'table-source': break; // 9.2.6
			case 'scenario': break; // 9.2.6

			case 'iteration': break; // 9.4.3 <table:iteration>
			case 'content-validations': break; // 9.4.4 <table:
			case 'content-validation': break; // 9.4.5 <table:
			case 'help-message': break; // 9.4.6 <table:
			case 'error-message': break; // 9.4.7 <table:
			case 'database-ranges': break; // 9.4.14 <table:database-ranges>
			case 'filter': break; // 9.5.2 <table:filter>
			case 'filter-and': break; // 9.5.3 <table:filter-and>
			case 'filter-or': break; // 9.5.4 <table:filter-or>
			case 'filter-condition': break; // 9.5.5 <table:filter-condition>

			case 'list-level-style-bullet': break; // 16.31 <text:
			case 'list-level-style-number': break; // 16.32 <text:
			case 'list-level-properties': break; // 17.19 <style:

			/* 7.3 Document Fields */
			case 'sender-firstname': // 7.3.6.2
			case 'sender-lastname': // 7.3.6.3
			case 'sender-initials': // 7.3.6.4
			case 'sender-title': // 7.3.6.5
			case 'sender-position': // 7.3.6.6
			case 'sender-email': // 7.3.6.7
			case 'sender-phone-private': // 7.3.6.8
			case 'sender-fax': // 7.3.6.9
			case 'sender-company': // 7.3.6.10
			case 'sender-phone-work': // 7.3.6.11
			case 'sender-street': // 7.3.6.12
			case 'sender-city': // 7.3.6.13
			case 'sender-postal-code': // 7.3.6.14
			case 'sender-country': // 7.3.6.15
			case 'sender-state-or-province': // 7.3.6.16
			case 'author-name': // 7.3.7.1
			case 'author-initials': // 7.3.7.2
			case 'chapter': // 7.3.8
			case 'file-name': // 7.3.9
			case 'template-name': // 7.3.9
			case 'sheet-name': // 7.3.9
				break;

			case 'event-listener':
				break;
			/* TODO: FODS Properties */
			case 'initial-creator':
			case 'creation-date':
			case 'print-date':
			case 'generator':
			case 'document-statistic':
			case 'user-defined':
			case 'editing-duration':
			case 'editing-cycles':
				break;

			/* TODO: FODS Config */
			case 'config-item':
				break;

			/* TODO: style tokens */
			case 'page-number': break; // TODO <text:page-number>
			case 'page-count': break; // TODO <text:page-count>
			case 'time': break; // TODO <text:time>

			/* 9.3 Advanced Table Cells */
			case 'cell-range-source': break; // 9.3.1 <table:
			case 'detective': break; // 9.3.2 <table:
			case 'operation': break; // 9.3.3 <table:
			case 'highlighted-range': break; // 9.3.4 <table:

			/* 9.6 Data Pilot Tables <table: */
			case 'data-pilot-table': // 9.6.3
			case 'source-cell-range': // 9.6.5
			case 'source-service': // 9.6.6
			case 'data-pilot-field': // 9.6.7
			case 'data-pilot-level': // 9.6.8
			case 'data-pilot-subtotals': // 9.6.9
			case 'data-pilot-subtotal': // 9.6.10
			case 'data-pilot-members': // 9.6.11
			case 'data-pilot-member': // 9.6.12
			case 'data-pilot-display-info': // 9.6.13
			case 'data-pilot-sort-info': // 9.6.14
			case 'data-pilot-layout-info': // 9.6.15
			case 'data-pilot-field-reference': // 9.6.16
			case 'data-pilot-groups': // 9.6.17
			case 'data-pilot-group': // 9.6.18
			case 'data-pilot-group-member': // 9.6.19
				break;

			/* 10.3 Drawing Shapes */
			case 'rect': // 10.3.2
				break;

			/* 14.6 DDE Connections */
			case 'dde-connection-decls': // 14.6.2 <text:
			case 'dde-connection-decl': // 14.6.3 <text:
			case 'dde-link': // 14.6.4 <table:
			case 'dde-source': // 14.6.5 <office:
				break;

			case 'properties': break; // 13.7 <form:properties>
			case 'property': break; // 13.8 <form:property>

			case 'a': // 6.1.8 hyperlink
				if(Rn[1]!== '/') {
					atag = parsexmltag(Rn[0], false);
					if(!atag.href) break;
					atag.Target = atag.href; delete atag.href;
					if(atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
						_Ref = ods_to_csf_3D(atag.Target.slice(1));
						atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
					}
				}
				break;

			/* non-standard */
			case 'table-protection': break;
			case 'data-pilot-grand-total': break; // <table:
			case 'office-document-common-attrs': break; // bare
			default: switch(Rn[2]) {
				case 'dc:':       // TODO: properties
				case 'calcext:':  // ignore undocumented extensions
				case 'loext:':    // ignore undocumented extensions
				case 'ooo:':      // ignore undocumented extensions
				case 'chartooo:': // ignore undocumented extensions
				case 'draw:':     // TODO: drawing
				case 'style:':    // TODO: styles
				case 'chart:':    // TODO: charts
				case 'form:':     // TODO: forms
				case 'uof:':      // TODO: uof
				case '表:':       // TODO: uof
				case '字:':       // TODO: uof
					break;
				default: if(opts.WTF) throw new Error(Rn);
			}
		}
		var out = ({
			Sheets: Sheets,
			SheetNames: SheetNames,
			Workbook: WB
		});
		if(opts.bookSheets) delete out.Sheets;
		return out;
	};
})();

function parse_ods(zip, opts) {
	opts = opts || ({});
	var ods = !!safegetzipfile(zip, 'objectdata');
	if(ods) parse_manifest(getzipdata(zip, 'META-INF/manifest.xml'), opts);
	var content = getzipstr(zip, 'content.xml');
	if(!content) throw new Error("Missing content.xml in " + (ods ? "ODS" : "UOF")+ " file");
	var wb = parse_content_xml(ods ? content : utf8read(content), opts);
	if(safegetzipfile(zip, 'meta.xml')) wb.Props = parse_core_props(getzipdata(zip, 'meta.xml'));
	return wb;
}
function parse_fods(data, opts) {
	return parse_content_xml(data, opts);
}

/* OpenDocument */
var write_styles_ods = (function() {
	var payload = '<office:document-styles ' + wxt_helper({
		'xmlns:office':   "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
		'xmlns:table':    "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
		'xmlns:style':    "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
		'xmlns:text':     "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
		'xmlns:draw':     "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
		'xmlns:fo':       "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
		'xmlns:xlink':    "http://www.w3.org/1999/xlink",
		'xmlns:dc':       "http://purl.org/dc/elements/1.1/",
		'xmlns:number':   "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
		'xmlns:svg':      "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
		'xmlns:of':       "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
		'office:version': "1.2"
	}) + '></office:document-styles>';
	return function wso() {
		return XML_HEADER + payload;
	};
})();
var write_content_ods = (function() {
	/* 6.1.2 White Space Characters */
	var write_text_p = function(text) {
		return escapexml(text)
			.replace(/  +/g, function($$){return '<text:s text:c="'+$$.length+'"/>';})
			.replace(/\t/g, "<text:tab/>")
			.replace(/\n/g, "<text:line-break/>")
			.replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
	};

	var null_cell_xml = '          <table:table-cell />\n';
	var covered_cell_xml = '          <table:covered-table-cell/>\n';
	var write_ws = function(ws, wb, i) {
		/* Section 9 Tables */
		var o = [];
		o.push('      <table:table table:name="' + escapexml(wb.SheetNames[i]) + '">\n');
		var R=0,C=0, range = decode_range(ws['!ref']);
		var marr = ws['!merges'] || [], mi = 0;
		var dense = Array.isArray(ws);
		for(R = 0; R < range.s.r; ++R) o.push('        <table:table-row></table:table-row>\n');
		for(; R <= range.e.r; ++R) {
			o.push('        <table:table-row>\n');
			for(C=0; C < range.s.c; ++C) o.push(null_cell_xml);
			for(; C <= range.e.c; ++C) {
				var skip = false, ct = {}, textp = "";
				for(mi = 0; mi != marr.length; ++mi) {
					if(marr[mi].s.c > C) continue;
					if(marr[mi].s.r > R) continue;
					if(marr[mi].e.c < C) continue;
					if(marr[mi].e.r < R) continue;
					if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
					ct['table:number-columns-spanned'] = (marr[mi].e.c - marr[mi].s.c + 1);
					ct['table:number-rows-spanned'] =    (marr[mi].e.r - marr[mi].s.r + 1);
					break;
				}
				if(skip) { o.push(covered_cell_xml); continue; }
				var ref = encode_cell({r:R, c:C}), cell = dense ? (ws[R]||[])[C]: ws[ref];
				if(cell && cell.f) {
					ct['table:formula'] = escapexml(csf_to_ods_formula(cell.f));
					if(cell.F) {
						if(cell.F.slice(0, ref.length) == ref) {
							var _Fref = decode_range(cell.F);
							ct['table:number-matrix-columns-spanned'] = (_Fref.e.c - _Fref.s.c + 1);
							ct['table:number-matrix-rows-spanned'] =    (_Fref.e.r - _Fref.s.r + 1);
						}
					}
				}
				if(!cell) { o.push(null_cell_xml); continue; }
				switch(cell.t) {
					case 'b':
						textp = (cell.v ? 'TRUE' : 'FALSE');
						ct['office:value-type'] = "boolean";
						ct['office:boolean-value'] = (cell.v ? 'true' : 'false');
						break;
					case 'n':
						textp = (cell.w||String(cell.v||0));
						ct['office:value-type'] = "float";
						ct['office:value'] = (cell.v||0);
						break;
					case 's': case 'str':
						textp = cell.v;
						ct['office:value-type'] = "string";
						break;
					case 'd':
						textp = (cell.w||(parseDate(cell.v).toISOString()));
						ct['office:value-type'] = "date";
						ct['office:date-value'] = (parseDate(cell.v).toISOString());
						ct['table:style-name'] = "ce1";
						break;
					//case 'e':
					default: o.push(null_cell_xml); continue;
				}
				var text_p = write_text_p(textp);
				if(cell.l && cell.l.Target) {
					var _tgt = cell.l.Target; _tgt = _tgt.charAt(0) == "#" ? "#" + csf_to_ods_3D(_tgt.slice(1)) : _tgt;
					text_p = writextag('text:a', text_p, {'xlink:href': _tgt});
				}
				o.push('          ' + writextag('table:table-cell', writextag('text:p', text_p, {}), ct) + '\n');
			}
			o.push('        </table:table-row>\n');
		}
		o.push('      </table:table>\n');
		return o.join("");
	};

	var write_automatic_styles_ods = function(o) {
		o.push(' <office:automatic-styles>\n');
		o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
		o.push('   <number:month number:style="long"/>\n');
		o.push('   <number:text>/</number:text>\n');
		o.push('   <number:day number:style="long"/>\n');
		o.push('   <number:text>/</number:text>\n');
		o.push('   <number:year/>\n');
		o.push('  </number:date-style>\n');
		o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
		o.push(' </office:automatic-styles>\n');
	};

	return function wcx(wb, opts) {
		var o = [XML_HEADER];
		/* 3.1.3.2 */
		var attr = wxt_helper({
			'xmlns:office':       "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
			'xmlns:table':        "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
			'xmlns:style':        "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
			'xmlns:text':         "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
			'xmlns:draw':         "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
			'xmlns:fo':           "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
			'xmlns:xlink':        "http://www.w3.org/1999/xlink",
			'xmlns:dc':           "http://purl.org/dc/elements/1.1/",
			'xmlns:meta':         "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
			'xmlns:number':       "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
			'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
			'xmlns:svg':          "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
			'xmlns:chart':        "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
			'xmlns:dr3d':         "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
			'xmlns:math':         "http://www.w3.org/1998/Math/MathML",
			'xmlns:form':         "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
			'xmlns:script':       "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
			'xmlns:ooo':          "http://openoffice.org/2004/office",
			'xmlns:ooow':         "http://openoffice.org/2004/writer",
			'xmlns:oooc':         "http://openoffice.org/2004/calc",
			'xmlns:dom':          "http://www.w3.org/2001/xml-events",
			'xmlns:xforms':       "http://www.w3.org/2002/xforms",
			'xmlns:xsd':          "http://www.w3.org/2001/XMLSchema",
			'xmlns:xsi':          "http://www.w3.org/2001/XMLSchema-instance",
			'xmlns:sheet':        "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
			'xmlns:rpt':          "http://openoffice.org/2005/report",
			'xmlns:of':           "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
			'xmlns:xhtml':        "http://www.w3.org/1999/xhtml",
			'xmlns:grddl':        "http://www.w3.org/2003/g/data-view#",
			'xmlns:tableooo':     "http://openoffice.org/2009/table",
			'xmlns:drawooo':      "http://openoffice.org/2010/draw",
			'xmlns:calcext':      "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
			'xmlns:loext':        "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
			'xmlns:field':        "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
			'xmlns:formx':        "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
			'xmlns:css3t':        "http://www.w3.org/TR/css3-text/",
			'office:version':     "1.2"
		});

		var fods = wxt_helper({
			'xmlns:config':    "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
			'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
		});

		if(opts.bookType == "fods") o.push('<office:document' + attr + fods + '>\n');
		else o.push('<office:document-content' + attr  + '>\n');
		write_automatic_styles_ods(o);
		o.push('  <office:body>\n');
		o.push('    <office:spreadsheet>\n');
		for(var i = 0; i != wb.SheetNames.length; ++i) o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts));
		o.push('    </office:spreadsheet>\n');
		o.push('  </office:body>\n');
		if(opts.bookType == "fods") o.push('</office:document>');
		else o.push('</office:document-content>');
		return o.join("");
	};
})();

function write_ods(wb, opts) {
	if(opts.bookType == "fods") return write_content_ods(wb, opts);

var zip = new jszip();
	var f = "";

	var manifest = [];
	var rdf = [];

	/* Part 3 Section 3.3 MIME Media Type */
	f = "mimetype";
	zip.file(f, "application/vnd.oasis.opendocument.spreadsheet");

	/* Part 1 Section 2.2 Documents */
	f = "content.xml";
	zip.file(f, write_content_ods(wb, opts));
	manifest.push([f, "text/xml"]);
	rdf.push([f, "ContentFile"]);

	/* TODO: these are hard-coded styles to satiate excel */
	f = "styles.xml";
	zip.file(f, write_styles_ods(wb, opts));
	manifest.push([f, "text/xml"]);
	rdf.push([f, "StylesFile"]);

	/* TODO: this is hard-coded to satiate excel */
	f = "meta.xml";
	zip.file(f, write_meta_ods());
	manifest.push([f, "text/xml"]);
	rdf.push([f, "MetadataFile"]);

	/* Part 3 Section 6 Metadata Manifest File */
	f = "manifest.rdf";
	zip.file(f, write_rdf(rdf/*, opts*/));
	manifest.push([f, "application/rdf+xml"]);

	/* Part 3 Section 4 Manifest File */
	f = "META-INF/manifest.xml";
	zip.file(f, write_manifest(manifest/*, opts*/));

	return zip;
}

function write_sheet_index(wb, sheet) {
	if(!sheet) return 0;
	var idx = wb.SheetNames.indexOf(sheet);
	if(idx == -1) throw new Error("Sheet not found: " + sheet);
	return idx;
}

function write_obj_str(factory) {
	return function write_str(wb, o) {
		var idx = write_sheet_index(wb, o.sheet);
		return factory.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb);
	};
}

var write_htm_str = write_obj_str(HTML_);
var write_csv_str = write_obj_str({from_sheet:sheet_to_csv});
var write_slk_str = write_obj_str(SYLK);
var write_dif_str = write_obj_str(DIF);
var write_prn_str = write_obj_str(PRN);
var write_rtf_str = write_obj_str(RTF);
var write_txt_str = write_obj_str({from_sheet:sheet_to_txt});
var write_dbf_buf = write_obj_str(DBF);
var write_eth_str = write_obj_str(ETH);

function fix_opts_func(defaults) {
	return function fix_opts(opts) {
		for(var i = 0; i != defaults.length; ++i) {
			var d = defaults[i];
			if(opts[d[0]] === undefined) opts[d[0]] = d[1];
			if(d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
		}
	};
}

var fix_read_opts = fix_opts_func([
	['cellNF', false], /* emit cell number format string as .z */
	['cellHTML', true], /* emit html string as .h */
	['cellFormula', true], /* emit formulae as .f */
	['cellStyles', false], /* emits style/theme as .s */
	['cellText', true], /* emit formatted text as .w */
	['cellDates', false], /* emit date cells with type `d` */

	['sheetStubs', false], /* emit empty cells */
	['sheetRows', 0, 'n'], /* read n rows (0 = read all rows) */

	['bookDeps', false], /* parse calculation chains */
	['bookSheets', false], /* only try to get sheet names (no Sheets) */
	['bookProps', false], /* only try to get properties (no Sheets) */
	['bookFiles', false], /* include raw file structure (keys, files, cfb) */
	['bookVBA', false], /* include vba raw data (vbaraw) */

	['password',''], /* password */
	['WTF', false] /* WTF mode (throws errors) */
]);


var fix_write_opts = fix_opts_func([
	['cellDates', false], /* write date cells with type `d` */

	['bookSST', false], /* Generate Shared String Table */

	['bookType', 'xlsx'], /* Type of workbook (xlsx/m/b) */

	['compression', false], /* Use file compression */

	['WTF', false] /* WTF mode (throws errors) */
]);
function get_sheet_type(n) {
	if(RELS.WS.indexOf(n) > -1) return "sheet";
	if(RELS.CS && n == RELS.CS) return "chart";
	if(RELS.DS && n == RELS.DS) return "dialog";
	if(RELS.MS && n == RELS.MS) return "macro";
	return (n && n.length) ? n : "sheet";
}
function safe_parse_wbrels(wbrels, sheets) {
	if(!wbrels) return 0;
	try {
		wbrels = sheets.map(function pwbr(w) { if(!w.id) w.id = w.strRelID; return [w.name, wbrels['!id'][w.id].Target, get_sheet_type(wbrels['!id'][w.id].Type)]; });
	} catch(e) { return null; }
	return !wbrels || wbrels.length === 0 ? null : wbrels;
}

function safe_parse_sheet(zip, path, relsPath, sheet, idx, sheetRels, sheets, stype, opts, wb, themes, styles) {
	try {
		sheetRels[sheet]=parse_rels(getzipstr(zip, relsPath, true), path);
		var data = getzipdata(zip, path);
		var _ws;
		switch(stype) {
			case 'sheet':  _ws = parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
			case 'chart':  _ws = parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
				if(!_ws || !_ws['!chart']) break;
				var dfile = resolve_path(_ws['!chart'].Target, path);
				var drelsp = get_rels_path(dfile);
				var draw = parse_drawing(getzipstr(zip, dfile, true), parse_rels(getzipstr(zip, drelsp, true), dfile));
				var chartp = resolve_path(draw, dfile);
				var crelsp = get_rels_path(chartp);
				_ws = parse_chart(getzipstr(zip, chartp, true), chartp, opts, parse_rels(getzipstr(zip, crelsp, true), chartp), wb, _ws);
				break;
			case 'macro':  _ws = parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
			case 'dialog': _ws = parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
		}
		sheets[sheet] = _ws;
	} catch(e) { if(opts.WTF) throw e; }
}

function strip_front_slash(x) { return x.charAt(0) == '/' ? x.slice(1) : x; }

function parse_zip(zip, opts) {
	make_ssf(SSF);
	opts = opts || {};
	fix_read_opts(opts);

	/* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */
	if(safegetzipfile(zip, 'META-INF/manifest.xml')) return parse_ods(zip, opts);
	/* UOC */
	if(safegetzipfile(zip, 'objectdata.xml')) return parse_ods(zip, opts);
	/* Numbers */
	if(safegetzipfile(zip, 'Index/Document.iwa')) throw new Error('Unsupported NUMBERS file');

	var entries = zipentries(zip);
	var dir = parse_ct((getzipstr(zip, '[Content_Types].xml')));
	var xlsb = false;
	var sheets, binname;
	if(dir.workbooks.length === 0) {
		binname = "xl/workbook.xml";
		if(getzipdata(zip,binname, true)) dir.workbooks.push(binname);
	}
	if(dir.workbooks.length === 0) {
		binname = "xl/workbook.bin";
		if(!getzipdata(zip,binname,true)) throw new Error("Could not find workbook");
		dir.workbooks.push(binname);
		xlsb = true;
	}
	if(dir.workbooks[0].slice(-3) == "bin") xlsb = true;

	var themes = ({});
	var styles = ({});
	if(!opts.bookSheets && !opts.bookProps) {
		strs = [];
		if(dir.sst) try { strs=parse_sst(getzipdata(zip, strip_front_slash(dir.sst)), dir.sst, opts); } catch(e) { if(opts.WTF) throw e; }

		if(opts.cellStyles && dir.themes.length) themes = parse_theme(getzipstr(zip, dir.themes[0].replace(/^\//,''), true)||"",dir.themes[0], opts);

		if(dir.style) styles = parse_sty(getzipdata(zip, strip_front_slash(dir.style)), dir.style, themes, opts);
	}

	/*var externbooks = */dir.links.map(function(link) {
		return parse_xlink(getzipdata(zip, strip_front_slash(link)), link, opts);
	});

	var wb = parse_wb(getzipdata(zip, strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);

	var props = {}, propdata = "";

	if(dir.coreprops.length) {
		propdata = getzipdata(zip, strip_front_slash(dir.coreprops[0]), true);
		if(propdata) props = parse_core_props(propdata);
		if(dir.extprops.length !== 0) {
			propdata = getzipdata(zip, strip_front_slash(dir.extprops[0]), true);
			if(propdata) parse_ext_props(propdata, props, opts);
		}
	}

	var custprops = {};
	if(!opts.bookSheets || opts.bookProps) {
		if (dir.custprops.length !== 0) {
			propdata = getzipstr(zip, strip_front_slash(dir.custprops[0]), true);
			if(propdata) custprops = parse_cust_props(propdata, opts);
		}
	}

	var out = ({});
	if(opts.bookSheets || opts.bookProps) {
		if(wb.Sheets) sheets = wb.Sheets.map(function pluck(x){ return x.name; });
		else if(props.Worksheets && props.SheetNames.length > 0) sheets=props.SheetNames;
		if(opts.bookProps) { out.Props = props; out.Custprops = custprops; }
		if(opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
		if(opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
	}
	sheets = {};

	var deps = {};
	if(opts.bookDeps && dir.calcchain) deps=parse_cc(getzipdata(zip, strip_front_slash(dir.calcchain)),dir.calcchain,opts);

	var i=0;
	var sheetRels = ({});
	var path, relsPath;

	{
		var wbsheets = wb.Sheets;
		props.Worksheets = wbsheets.length;
		props.SheetNames = [];
		for(var j = 0; j != wbsheets.length; ++j) {
			props.SheetNames[j] = wbsheets[j].name;
		}
	}

	var wbext = xlsb ? "bin" : "xml";
	var wbrelsi = dir.workbooks[0].lastIndexOf("/");
	var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi+1) + "_rels/" + dir.workbooks[0].slice(wbrelsi+1) + ".rels").replace(/^\//,"");
	if(!safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
	var wbrels = parse_rels(getzipstr(zip, wbrelsfile, true), wbrelsfile);
	if(wbrels) wbrels = safe_parse_wbrels(wbrels, wb.Sheets);

	/* Numbers iOS hack */
	var nmode = (getzipdata(zip,"xl/worksheets/sheet.xml",true))?1:0;
	for(i = 0; i != props.Worksheets; ++i) {
		var stype = "sheet";
		if(wbrels && wbrels[i]) {
			path = 'xl/' + (wbrels[i][1]).replace(/[\/]?xl\//, "");
			if(!safegetzipfile(zip, path)) path = wbrels[i][1];
			if(!safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/,"") + wbrels[i][1];
			stype = wbrels[i][2];
		} else {
			path = 'xl/worksheets/sheet'+(i+1-nmode)+"." + wbext;
			path = path.replace(/sheet0\./,"sheet.");
		}
		relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
		safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
	}

	if(dir.comments) parse_comments(zip, dir.comments, sheets, sheetRels, opts);

	out = ({
		Directory: dir,
		Workbook: wb,
		Props: props,
		Custprops: custprops,
		Deps: deps,
		Sheets: sheets,
		SheetNames: props.SheetNames,
		Strings: strs,
		Styles: styles,
		Themes: themes,
		SSF: SSF.get_table()
	});
	if(opts.bookFiles) {
		out.keys = entries;
		out.files = zip.files;
	}
	if(opts.bookVBA) {
		if(dir.vba.length > 0) out.vbaraw = getzipdata(zip,strip_front_slash(dir.vba[0]),true);
		else if(dir.defaults && dir.defaults.bin === CT_VBA) out.vbaraw = getzipdata(zip, 'xl/vbaProject.bin',true);
	}
	return out;
}

/* [MS-OFFCRYPTO] 2.1.1 */
function parse_xlsxcfb(cfb, _opts) {
	var opts = _opts || {};
	var f = 'Workbook', data = CFB.find(cfb, f);
	try {
	f = '/!DataSpaces/Version';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	/*var version = */parse_DataSpaceVersionInfo(data.content);

	/* 2.3.4.1 */
	f = '/!DataSpaces/DataSpaceMap';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	var dsm = parse_DataSpaceMap(data.content);
	if(dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage")
		throw new Error("ECMA-376 Encrypted file bad " + f);

	/* 2.3.4.2 */
	f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	var seds = parse_DataSpaceDefinition(data.content);
	if(seds.length != 1 || seds[0] != "StrongEncryptionTransform")
		throw new Error("ECMA-376 Encrypted file bad " + f);

	/* 2.3.4.3 */
	f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	/*var hdr = */parse_Primary(data.content);
	} catch(e) {}

	f = '/EncryptionInfo';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	var einfo = parse_EncryptionInfo(data.content);

	/* 2.3.4.4 */
	f = '/EncryptedPackage';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);

/*global decrypt_agile */
if(einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
/*global decrypt_std76 */
if(einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
	throw new Error("File is password-protected");
}

function write_zip(wb, opts) {
	_shapeid = 1024;
	if(opts.bookType == "ods") return write_ods(wb, opts);
	if(wb && !wb.SSF) {
		wb.SSF = SSF.get_table();
	}
	if(wb && wb.SSF) {
		make_ssf(SSF); SSF.load_table(wb.SSF);
		// $FlowIgnore
		opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
		opts.ssf = wb.SSF;
	}
	opts.rels = {}; opts.wbrels = {};
	opts.Strings = []; opts.Strings.Count = 0; opts.Strings.Unique = 0;
	if(browser_has_Map) opts.revStrings = new Map();
	else { opts.revStrings = {}; opts.revStrings.foo = []; delete opts.revStrings.foo; }
	var wbext = opts.bookType == "xlsb" ? "bin" : "xml";
	var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
	var ct = new_ct();
	fix_write_opts(opts = opts || {});
var zip = new jszip();
	var f = "", rId = 0;

	opts.cellXfs = [];
	get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});

	if(!wb.Props) wb.Props = {};

	f = "docProps/core.xml";
	zip.file(f, write_core_props(wb.Props, opts));
	ct.coreprops.push(f);
	add_rels(opts.rels, 2, f, RELS.CORE_PROPS);

f = "docProps/app.xml";
	if(wb.Props && wb.Props.SheetNames){/* empty */}
	else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
	else {
		var _sn = [];
		for(var _i = 0; _i < wb.SheetNames.length; ++_i)
			if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
		wb.Props.SheetNames = _sn;
	}
	wb.Props.Worksheets = wb.Props.SheetNames.length;
	zip.file(f, write_ext_props(wb.Props, opts));
	ct.extprops.push(f);
	add_rels(opts.rels, 3, f, RELS.EXT_PROPS);

	if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
		f = "docProps/custom.xml";
		zip.file(f, write_cust_props(wb.Custprops, opts));
		ct.custprops.push(f);
		add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
	}

	for(rId=1;rId <= wb.SheetNames.length; ++rId) {
		var wsrels = {'!id':{}};
		var ws = wb.Sheets[wb.SheetNames[rId-1]];
		var _type = (ws || {})["!type"] || "sheet";
		switch(_type) {
		case "chart": /*
			f = "xl/chartsheets/sheet" + rId + "." + wbext;
			zip.file(f, write_cs(rId-1, f, opts, wb, wsrels));
			ct.charts.push(f);
			add_rels(wsrels, -1, "chartsheets/sheet" + rId + "." + wbext, RELS.CS);
			break; */
			/* falls through */
		default:
			f = "xl/worksheets/sheet" + rId + "." + wbext;
			zip.file(f, write_ws(rId-1, f, opts, wb, wsrels));
			ct.sheets.push(f);
			add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
		}

		if(ws) {
			var comments = ws['!comments'];
			if(comments && comments.length > 0) {
				var cf = "xl/comments" + rId + "." + wbext;
				zip.file(cf, write_cmnt(comments, cf, opts));
				ct.comments.push(cf);
				add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
			}
			if(ws['!legacy']) {
				zip.file("xl/drawings/vmlDrawing" + (rId) + ".vml", write_comments_vml(rId, ws['!comments']));
			}
			delete ws['!comments'];
			delete ws['!legacy'];
		}

		if(wsrels['!id'].rId1) zip.file(get_rels_path(f), write_rels(wsrels));
	}

	if(opts.Strings != null && opts.Strings.length > 0) {
		f = "xl/sharedStrings." + wbext;
		zip.file(f, write_sst(opts.Strings, f, opts));
		ct.strs.push(f);
		add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
	}

	f = "xl/workbook." + wbext;
	zip.file(f, write_wb(wb, f, opts));
	ct.workbooks.push(f);
	add_rels(opts.rels, 1, f, RELS.WB);

	/* TODO: something more intelligent with themes */

	f = "xl/theme/theme1.xml";
	zip.file(f, write_theme(wb.Themes, opts));
	ct.themes.push(f);
	add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);

	/* TODO: something more intelligent with styles */

	f = "xl/styles." + wbext;
	zip.file(f, write_sty(wb, f, opts));
	ct.styles.push(f);
	add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);

	if(wb.vbaraw && vbafmt) {
		f = "xl/vbaProject.bin";
		zip.file(f, wb.vbaraw);
		ct.vba.push(f);
		add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
	}

	zip.file("[Content_Types].xml", write_ct(ct, opts));
	zip.file('_rels/.rels', write_rels(opts.rels));
	zip.file('xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));

	delete opts.revssf; delete opts.ssf;
	return zip;
}
function firstbyte(f,o) {
	var x = "";
	switch((o||{}).type || "base64") {
		case 'buffer': return [f[0], f[1], f[2], f[3]];
		case 'base64': x = Base64.decode(f.slice(0,24)); break;
		case 'binary': x = f; break;
		case 'array':  return [f[0], f[1], f[2], f[3]];
		default: throw new Error("Unrecognized type " + (o && o.type || "undefined"));
	}
	return [x.charCodeAt(0), x.charCodeAt(1), x.charCodeAt(2), x.charCodeAt(3)];
}

function read_cfb(cfb, opts) {
	if(CFB.find(cfb, "EncryptedPackage")) return parse_xlsxcfb(cfb, opts);
	return parse_xlscfb(cfb, opts);
}

function read_zip(data, opts) {
var zip, d = data;
	var o = opts||{};
	if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
	switch(o.type) {
		case "base64": zip = new jszip(d, { base64:true }); break;
		case "binary": case "array": zip = new jszip(d, { base64:false }); break;
		case "buffer": zip = new jszip(d); break;
		default: throw new Error("Unrecognized type " + o.type);
	}
	return parse_zip(zip, o);
}

function read_plaintext(data, o) {
	var i = 0;
	main: while(i < data.length) switch(data.charCodeAt(i)) {
		case 0x0A: case 0x0D: case 0x20: ++i; break;
		case 0x3C: return parse_xlml(data.slice(i),o);
		default: break main;
	}
	return PRN.to_workbook(data, o);
}

function read_plaintext_raw(data, o) {
	var str = "", bytes = firstbyte(data, o);
	switch(o.type) {
		case 'base64': str = Base64.decode(data); break;
		case 'binary': str = data; break;
		case 'buffer': str = data.toString('binary'); break;
		case 'array': str = cc2str(data); break;
		default: throw new Error("Unrecognized type " + o.type);
	}
	if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str);
	return read_plaintext(str, o);
}

function read_utf16(data, o) {
	var d = data;
	if(o.type == 'base64') d = Base64.decode(d);
	d = cptable.utils.decode(1200, d.slice(2), 'str');
	o.type = "binary";
	return read_plaintext(d, o);
}

function bstrify(data) {
	return !data.match(/[^\x00-\x7F]/) ? data : utf8write(data);
}

function read_prn(data, d, o, str) {
	if(str) { o.type = "string"; return PRN.to_workbook(data, o); }
	return PRN.to_workbook(d, o);
}

function readSync(data, opts) {
	reset_cp();
	if(typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return readSync(new Uint8Array(data), opts);
	var d = data, n = [0,0,0,0], str = false;
	var o = opts||{};
	_ssfopts = {};
	if(o.dateNF) _ssfopts.dateNF = o.dateNF;
	if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
	if(o.type == "file") { o.type = has_buf ? "buffer" : "binary"; d = read_binary(data); }
	if(o.type == "string") { str = true; o.type = "binary"; o.codepage = 65001; d = bstrify(data); }
	if(o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
		// $FlowIgnore
		var ab=new ArrayBuffer(3), vu=new Uint8Array(ab); vu.foo="bar";
		// $FlowIgnore
		if(!vu.foo) {o=dup(o); o.type='array'; return readSync(ab2a(d), o);}
	}
	switch((n = firstbyte(d, o))[0]) {
		case 0xD0: return read_cfb(CFB.read(d, o), o);
		case 0x09: return parse_xlscfb(d, o);
		case 0x3C: return parse_xlml(d, o);
		case 0x49: if(n[1] === 0x44) return read_wb_ID(d, o); break;
		case 0x54: if(n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return DIF.to_workbook(d, o); break;
		case 0x50: return (n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09) ? read_zip(d, o) : read_prn(data, d, o, str);
		case 0xEF: return n[3] === 0x3C ? parse_xlml(d, o) : read_prn(data, d, o, str);
		case 0xFF: if(n[1] === 0xFE) { return read_utf16(d, o); } break;
		case 0x00: if(n[1] === 0x00 && n[2] >= 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o); break;
		case 0x03: case 0x83: case 0x8B: case 0x8C: return DBF.to_workbook(d, o);
		case 0x7B: if(n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return RTF.to_workbook(d, o); break;
		case 0x0A: case 0x0D: case 0x20: return read_plaintext_raw(d, o);
	}
	if(n[2] <= 12 && n[3] <= 31) return DBF.to_workbook(d, o);
	return read_prn(data, d, o, str);
}

function readFileSync(filename, opts) {
	var o = opts||{}; o.type = 'file';
	return readSync(filename, o);
}
function write_cfb_ctr(cfb, o) {
	switch(o.type) {
		case "base64": case "binary": break;
		case "buffer": case "array": o.type = ""; break;
		case "file": return write_dl(o.file, CFB.write(cfb, {type:has_buf ? 'buffer' : ""}));
		case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
		default: throw new Error("Unrecognized type " + o.type);
	}
	return CFB.write(cfb, o);
}

/*global encrypt_agile */
function write_zip_type(wb, opts) {
	var o = opts||{};
	var z = write_zip(wb, o);
	var oopts = {};
	if(o.compression) oopts.compression = 'DEFLATE';
	if(o.password) oopts.type = has_buf ? "nodebuffer" : "string";
	else switch(o.type) {
		case "base64": oopts.type = "base64"; break;
		case "binary": oopts.type = "string"; break;
		case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
		case "buffer":
		case "file": oopts.type = has_buf ? "nodebuffer" : "string"; break;
		default: throw new Error("Unrecognized type " + o.type);
	}
	var out = z.generate(oopts);
	if(o.password && typeof encrypt_agile !== 'undefined') return write_cfb_ctr(encrypt_agile(out, o.password), o);
	if(o.type === "file") return write_dl(o.file, out);
	return o.type == "string" ? utf8read(out) : out;
}

function write_cfb_type(wb, opts) {
	var o = opts||{};
	var cfb = write_xlscfb(wb, o);
	return write_cfb_ctr(cfb, o);
}

function write_string_type(out, opts, bom) {
	if(!bom) bom = "";
	var o = bom + out;
	switch(opts.type) {
		case "base64": return Base64.encode(utf8write(o));
		case "binary": return utf8write(o);
		case "string": return out;
		case "file": return write_dl(opts.file, o, 'utf8');
		case "buffer": {
			// $FlowIgnore
			if(has_buf) return Buffer_from(o, 'utf8');
			else return write_string_type(o, {type:'binary'}).split("").map(function(c) { return c.charCodeAt(0); });
		}
	}
	throw new Error("Unrecognized type " + opts.type);
}

function write_stxt_type(out, opts) {
	switch(opts.type) {
		case "base64": return Base64.encode(out);
		case "binary": return out;
		case "string": return out; /* override in sheet_to_txt */
		case "file": return write_dl(opts.file, out, 'binary');
		case "buffer": {
			// $FlowIgnore
			if(has_buf) return Buffer_from(out, 'binary');
			else return out.split("").map(function(c) { return c.charCodeAt(0); });
		}
	}
	throw new Error("Unrecognized type " + opts.type);
}

/* TODO: test consistency */
function write_binary_type(out, opts) {
	switch(opts.type) {
		case "string":
		case "base64":
		case "binary":
			var bstr = "";
			// $FlowIgnore
			for(var i = 0; i < out.length; ++i) bstr += String.fromCharCode(out[i]);
			return opts.type == 'base64' ? Base64.encode(bstr) : opts.type == 'string' ? utf8read(bstr) : bstr;
		case "file": return write_dl(opts.file, out);
		case "buffer": return out;
		default: throw new Error("Unrecognized type " + opts.type);
	}
}

function writeSync(wb, opts) {
	check_wb(wb);
	var o = opts||{};
	if(o.type == "array") { o.type = "binary"; var out = (writeSync(wb, o)); o.type = "array"; return s2ab(out); }
	switch(o.bookType || 'xlsb') {
		case 'xml':
		case 'xlml': return write_string_type(write_xlml(wb, o), o);
		case 'slk':
		case 'sylk': return write_string_type(write_slk_str(wb, o), o);
		case 'htm':
		case 'html': return write_string_type(write_htm_str(wb, o), o);
		case 'txt': return write_stxt_type(write_txt_str(wb, o), o);
		case 'csv': return write_string_type(write_csv_str(wb, o), o, "\ufeff");
		case 'dif': return write_string_type(write_dif_str(wb, o), o);
		case 'dbf': return write_binary_type(write_dbf_buf(wb, o), o);
		case 'prn': return write_string_type(write_prn_str(wb, o), o);
		case 'rtf': return write_string_type(write_rtf_str(wb, o), o);
		case 'eth': return write_string_type(write_eth_str(wb, o), o);
		case 'fods': return write_string_type(write_ods(wb, o), o);
		case 'biff2': if(!o.biff) o.biff = 2; /* falls through */
		case 'biff3': if(!o.biff) o.biff = 3; /* falls through */
		case 'biff4': if(!o.biff) o.biff = 4; return write_binary_type(write_biff_buf(wb, o), o);
		case 'biff5': if(!o.biff) o.biff = 5; /* falls through */
		case 'biff8':
		case 'xla':
		case 'xls': if(!o.biff) o.biff = 8; return write_cfb_type(wb, o);
		case 'xlsx':
		case 'xlsm':
		case 'xlam':
		case 'xlsb':
		case 'ods': return write_zip_type(wb, o);
		default: throw new Error ("Unrecognized bookType |" + o.bookType + "|");
	}
}

function resolve_book_type(o) {
	if(o.bookType) return;
	var _BT = {
		"xls": "biff8",
		"htm": "html",
		"slk": "sylk",
		"socialcalc": "eth",
		"Sh33tJS": "WTF"
	};
	var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
	if(ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
	o.bookType = _BT[o.bookType] || o.bookType;
}

function writeFileSync(wb, filename, opts) {
	var o = opts||{}; o.type = 'file';
	o.file = filename;
	resolve_book_type(o);
	return writeSync(wb, o);
}

function writeFileAsync(filename, wb, opts, cb) {
	var o = opts||{}; o.type = 'file';
	o.file = filename;
	resolve_book_type(o);
	o.type = 'buffer';
	var _cb = cb; if(!(_cb instanceof Function)) _cb = (opts);
	return _fs.writeFile(filename, writeSync(wb, o), _cb);
}
function make_json_row(sheet, r, R, cols, header, hdr, dense, o) {
	var rr = encode_row(R);
	var defval = o.defval, raw = o.raw;
	var isempty = true;
	var row = (header === 1) ? [] : {};
	if(header !== 1) {
		if(Object.defineProperty) try { Object.defineProperty(row, '__rowNum__', {value:R, enumerable:false}); } catch(e) { row.__rowNum__ = R; }
		else row.__rowNum__ = R;
	}
	if(!dense || sheet[R]) for (var C = r.s.c; C <= r.e.c; ++C) {
		var val = dense ? sheet[R][C] : sheet[cols[C] + rr];
		if(val === undefined || val.t === undefined) {
			if(defval === undefined) continue;
			if(hdr[C] != null) { row[hdr[C]] = defval; }
			continue;
		}
		var v = val.v;
		switch(val.t){
			case 'z': if(v == null) break; continue;
			case 'e': v = void 0; break;
			case 's': case 'd': case 'b': case 'n': break;
			default: throw new Error('unrecognized type ' + val.t);
		}
		if(hdr[C] != null) {
			if(v == null) {
				if(defval !== undefined) row[hdr[C]] = defval;
				else if(raw && v === null) row[hdr[C]] = null;
				else continue;
			} else {
				row[hdr[C]] = raw ? v : format_cell(val,v,o);
			}
			if(v != null) isempty = false;
		}
	}
	return { row: row, isempty: isempty };
}


function sheet_to_json(sheet, opts) {
	if(sheet == null || sheet["!ref"] == null) return [];
	var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], v=0, vv="";
	var r = {s:{r:0,c:0},e:{r:0,c:0}};
	var o = opts || {};
	var range = o.range != null ? o.range : sheet["!ref"];
	if(o.header === 1) header = 1;
	else if(o.header === "A") header = 2;
	else if(Array.isArray(o.header)) header = 3;
	switch(typeof range) {
		case 'string': r = safe_decode_range(range); break;
		case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
		default: r = range;
	}
	if(header > 0) offset = 0;
	var rr = encode_row(r.s.r);
	var cols = [];
	var out = [];
	var outi = 0, counter = 0;
	var dense = Array.isArray(sheet);
	var R = r.s.r, C = 0, CC = 0;
	if(dense && !sheet[R]) sheet[R] = [];
	for(C = r.s.c; C <= r.e.c; ++C) {
		cols[C] = encode_col(C);
		val = dense ? sheet[R][C] : sheet[cols[C] + rr];
		switch(header) {
			case 1: hdr[C] = C - r.s.c; break;
			case 2: hdr[C] = cols[C]; break;
			case 3: hdr[C] = o.header[C - r.s.c]; break;
			default:
				if(val == null) val = {w: "__EMPTY", t: "s"};
				vv = v = format_cell(val, null, o);
				counter = 0;
				for(CC = 0; CC < hdr.length; ++CC) if(hdr[CC] == vv) vv = v + "_" + (++counter);
				hdr[C] = vv;
		}
	}
	for (R = r.s.r + offset; R <= r.e.r; ++R) {
		var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
		if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
	}
	out.length = outi;
	return out;
}

var qreg = /"/g;
function make_csv_row(sheet, r, R, cols, fs, rs, FS, o) {
	var isempty = true;
	var row = [], txt = "", rr = encode_row(R);
	for(var C = r.s.c; C <= r.e.c; ++C) {
		if (!cols[C]) continue;
		var val = o.dense ? (sheet[R]||[])[C]: sheet[cols[C] + rr];
		if(val == null) txt = "";
		else if(val.v != null) {
			isempty = false;
			txt = ''+format_cell(val, null, o);
			for(var i = 0, cc = 0; i !== txt.length; ++i) if((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34) {txt = "\"" + txt.replace(qreg, '""') + "\""; break; }
			if(txt == "ID") txt = '"ID"';
		} else if(val.f != null && !val.F) {
			isempty = false;
			txt = '=' + val.f; if(txt.indexOf(",") >= 0) txt = '"' + txt.replace(qreg, '""') + '"';
		} else txt = "";
		/* NOTE: Excel CSV does not support array formulae */
		row.push(txt);
	}
	if(o.blankrows === false && isempty) return null;
	return row.join(FS);
}

function sheet_to_csv(sheet, opts) {
	var out = [];
	var o = opts == null ? {} : opts;
	if(sheet == null || sheet["!ref"] == null) return "";
	var r = safe_decode_range(sheet["!ref"]);
	var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
	var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
	var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
	var row = "", cols = [];
	o.dense = Array.isArray(sheet);
	var colinfo = o.skipHidden && sheet["!cols"] || [];
	var rowinfo = o.skipHidden && sheet["!rows"] || [];
	for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
	for(var R = r.s.r; R <= r.e.r; ++R) {
		if ((rowinfo[R]||{}).hidden) continue;
		row = make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
		if(row == null) { continue; }
		if(o.strip) row = row.replace(endregex,"");
		out.push(row + RS);
	}
	delete o.dense;
	return out.join("");
}

function sheet_to_txt(sheet, opts) {
	if(!opts) opts = {}; opts.FS = "\t"; opts.RS = "\n";
	var s = sheet_to_csv(sheet, opts);
	if(typeof cptable == 'undefined' || opts.type == 'string') return s;
	var o = cptable.utils.encode(1200, s, 'str');
	return String.fromCharCode(255) + String.fromCharCode(254) + o;
}

function sheet_to_formulae(sheet) {
	var y = "", x, val="";
	if(sheet == null || sheet["!ref"] == null) return [];
	var r = safe_decode_range(sheet['!ref']), rr = "", cols = [], C;
	var cmds = [];
	var dense = Array.isArray(sheet);
	for(C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C);
	for(var R = r.s.r; R <= r.e.r; ++R) {
		rr = encode_row(R);
		for(C = r.s.c; C <= r.e.c; ++C) {
			y = cols[C] + rr;
			x = dense ? (sheet[R]||[])[C] : sheet[y];
			val = "";
			if(x === undefined) continue;
			else if(x.F != null) {
				y = x.F;
				if(!x.f) continue;
				val = x.f;
				if(y.indexOf(":") == -1) y = y + ":" + y;
			}
			if(x.f != null) val = x.f;
			else if(x.t == 'z') continue;
			else if(x.t == 'n' && x.v != null) val = "" + x.v;
			else if(x.t == 'b') val = x.v ? "TRUE" : "FALSE";
			else if(x.w !== undefined) val = "'" + x.w;
			else if(x.v === undefined) continue;
			else if(x.t == 's') val = "'" + x.v;
			else val = ""+x.v;
			cmds[cmds.length] = y + "=" + val;
		}
	}
	return cmds;
}

function sheet_add_json(_ws, js, opts) {
	var o = opts || {};
	var offset = +!o.skipHeader;
	var ws = _ws || ({});
	var _R = 0, _C = 0;
	if(ws && o.origin != null) {
		if(typeof o.origin == 'number') _R = o.origin;
		else {
			var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
			_R = _origin.r; _C = _origin.c;
		}
	}
	var cell;
	var range = ({s: {c:0, r:0}, e: {c:_C, r:_R + js.length - 1 + offset}});
	if(ws['!ref']) {
		var _range = safe_decode_range(ws['!ref']);
		range.e.c = Math.max(range.e.c, _range.e.c);
		range.e.r = Math.max(range.e.r, _range.e.r);
		if(_R == -1) { _R = range.e.r + 1; range.e.r = _R + js.length - 1 + offset; }
	}
	var hdr = o.header || [], C = 0;

	js.forEach(function (JS, R) {
		keys(JS).forEach(function(k) {
			if((C=hdr.indexOf(k)) == -1) hdr[C=hdr.length] = k;
			var v = JS[k];
			var t = 'z';
			var z = "";
			if(v && typeof v === 'object' && !(v instanceof Date)){
				ws[encode_cell({c:_C + C,r:_R + R + offset})] = v;
			} else {
				if(typeof v == 'number') t = 'n';
				else if(typeof v == 'boolean') t = 'b';
				else if(typeof v == 'string') t = 's';
				else if(v instanceof Date) {
					t = 'd';
					if(!o.cellDates) { t = 'n'; v = datenum(v); }
					z = o.dateNF || SSF._table[14];
				}
				ws[encode_cell({c:_C + C,r:_R + R + offset})] = cell = ({t:t, v:v});
				if(z) cell.z = z;
			}
		});
	});
	range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
	var __R = encode_row(_R);
	if(offset) for(C = 0; C < hdr.length; ++C) ws[encode_col(C + _C) + __R] = {t:'s', v:hdr[C]};
	ws['!ref'] = encode_range(range);
	return ws;
}
function json_to_sheet(js, opts) { return sheet_add_json(null, js, opts); }

var utils = {
	encode_col: encode_col,
	encode_row: encode_row,
	encode_cell: encode_cell,
	encode_range: encode_range,
	decode_col: decode_col,
	decode_row: decode_row,
	split_cell: split_cell,
	decode_cell: decode_cell,
	decode_range: decode_range,
	format_cell: format_cell,
	get_formulae: sheet_to_formulae,
	make_csv: sheet_to_csv,
	make_json: sheet_to_json,
	make_formulae: sheet_to_formulae,
	sheet_add_aoa: sheet_add_aoa,
	sheet_add_json: sheet_add_json,
	aoa_to_sheet: aoa_to_sheet,
	json_to_sheet: json_to_sheet,
	table_to_sheet: parse_dom_table,
	table_to_book: table_to_book,
	sheet_to_csv: sheet_to_csv,
	sheet_to_txt: sheet_to_txt,
	sheet_to_json: sheet_to_json,
	sheet_to_html: HTML_.from_sheet,
	sheet_to_dif: DIF.from_sheet,
	sheet_to_slk: SYLK.from_sheet,
	sheet_to_eth: ETH.from_sheet,
	sheet_to_formulae: sheet_to_formulae,
	sheet_to_row_object_array: sheet_to_json
};

(function(utils) {
utils.consts = utils.consts || {};
function add_consts(R/*Array<any>*/) { R.forEach(function(a){ utils.consts[a[0]] = a[1]; }); }

function get_default(x, y, z) { return x[y] != null ? x[y] : (x[y] = z); }

/* get cell, creating a stub if necessary */
function ws_get_cell_stub(ws, R, C) {
	/* A1 cell address */
	if(typeof R == "string") return ws[R] || (ws[R] = {t:'z'});
	/* cell address object */
	if(typeof R != "number") return ws_get_cell_stub(ws, encode_cell(R));
	/* R and C are 0-based indices */
	return ws_get_cell_stub(ws, encode_cell({r:R,c:C||0}));
}

/* find sheet index for given name / validate index */
function wb_sheet_idx(wb, sh) {
	if(typeof sh == "number") {
		if(sh >= 0 && wb.SheetNames.length > sh) return sh;
		throw new Error("Cannot find sheet # " + sh);
	} else if(typeof sh == "string") {
		var idx = wb.SheetNames.indexOf(sh);
		if(idx > -1) return idx;
		throw new Error("Cannot find sheet name |" + sh + "|");
	} else throw new Error("Cannot find sheet |" + sh + "|");
}

/* simple blank workbook object */
utils.book_new = function() {
	return { SheetNames: [], Sheets: {} };
};

/* add a worksheet to the end of a given workbook */
utils.book_append_sheet = function(wb, ws, name) {
	if(!name) for(var i = 1; i <= 0xFFFF; ++i) if(wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
	if(!name) throw new Error("Too many worksheets");
	check_ws_name(name);
	if(wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");

	wb.SheetNames.push(name);
	wb.Sheets[name] = ws;
};

/* set sheet visibility (visible/hidden/very hidden) */
utils.book_set_sheet_visibility = function(wb, sh, vis) {
	get_default(wb,"Workbook",{});
	get_default(wb.Workbook,"Sheets",[]);

	var idx = wb_sheet_idx(wb, sh);
	// $FlowIgnore
	get_default(wb.Workbook.Sheets,idx, {});

	switch(vis) {
		case 0: case 1: case 2: break;
		default: throw new Error("Bad sheet visibility setting " + vis);
	}
	// $FlowIgnore
	wb.Workbook.Sheets[idx].Hidden = vis;
};
add_consts([
	["SHEET_VISIBLE", 0],
	["SHEET_HIDDEN", 1],
	["SHEET_VERY_HIDDEN", 2]
]);

/* set number format */
utils.cell_set_number_format = function(cell, fmt) {
	cell.z = fmt;
	return cell;
};

/* set cell hyperlink */
utils.cell_set_hyperlink = function(cell, target, tooltip) {
	if(!target) {
		delete cell.l;
	} else {
		cell.l = ({ Target: target });
		if(tooltip) cell.l.Tooltip = tooltip;
	}
	return cell;
};
utils.cell_set_internal_link = function(cell, range, tooltip) { return utils.cell_set_hyperlink(cell, "#" + range, tooltip); };

/* add to cell comments */
utils.cell_add_comment = function(cell, text, author) {
	if(!cell.c) cell.c = [];
	cell.c.push({t:text, a:author||"SheetJS"});
};

/* set array formula and flush related cells */
utils.sheet_set_array_formula = function(ws, range, formula) {
	var rng = typeof range != "string" ? range : safe_decode_range(range);
	var rngstr = typeof range == "string" ? range : encode_range(range);
	for(var R = rng.s.r; R <= rng.e.r; ++R) for(var C = rng.s.c; C <= rng.e.c; ++C) {
		var cell = ws_get_cell_stub(ws, R, C);
		cell.t = 'n';
		cell.F = rngstr;
		delete cell.v;
		if(R == rng.s.r && C == rng.s.c) cell.f = formula;
	}
	return ws;
};

return utils;
})(utils);

if(has_buf && "function" != 'undefined') (function() {
	var Readable = __webpack_require__(1091).Readable;

	var write_csv_stream = function(sheet, opts) {
		var stream = Readable();
		var o = opts == null ? {} : opts;
		if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
		var r = safe_decode_range(sheet["!ref"]);
		var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
		var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
		var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
		var row = "", cols = [];
		o.dense = Array.isArray(sheet);
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
		var R = r.s.r;
		var BOM = false;
		stream._read = function() {
			if(!BOM) { BOM = true; return stream.push("\uFEFF"); }
			if(R > r.e.r) return stream.push(null);
			while(R <= r.e.r) {
				++R;
				if ((rowinfo[R-1]||{}).hidden) continue;
				row = make_csv_row(sheet, r, R-1, cols, fs, rs, FS, o);
				if(row != null) {
					if(o.strip) row = row.replace(endregex,"");
					stream.push(row + RS);
					break;
				}
			}
		};
		return stream;
	};

	var write_html_stream = function(ws, opts) {
		var stream = Readable();

		var o = opts || {};
		var header = o.header != null ? o.header : HTML_.BEGIN;
		var footer = o.footer != null ? o.footer : HTML_.END;
		stream.push(header);
		var r = decode_range(ws['!ref']);
		o.dense = Array.isArray(ws);
		stream.push(HTML_._preamble(ws, r, o));
		var R = r.s.r;
		var end = false;
		stream._read = function() {
			if(R > r.e.r) {
				if(!end) { end = true; stream.push("</table>" + footer); }
				return stream.push(null);
			}
			while(R <= r.e.r) {
				stream.push(HTML_._row(ws, r, R, o));
				++R;
				break;
			}
		};
		return stream;
	};

	var write_json_stream = function(sheet, opts) {
		var stream = Readable({objectMode:true});

		if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
		var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], v=0, vv="";
		var r = {s:{r:0,c:0},e:{r:0,c:0}};
		var o = opts || {};
		var range = o.range != null ? o.range : sheet["!ref"];
		if(o.header === 1) header = 1;
		else if(o.header === "A") header = 2;
		else if(Array.isArray(o.header)) header = 3;
		switch(typeof range) {
			case 'string': r = safe_decode_range(range); break;
			case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
			default: r = range;
		}
		if(header > 0) offset = 0;
		var rr = encode_row(r.s.r);
		var cols = [];
		var counter = 0;
		var dense = Array.isArray(sheet);
		var R = r.s.r, C = 0, CC = 0;
		if(dense && !sheet[R]) sheet[R] = [];
		for(C = r.s.c; C <= r.e.c; ++C) {
			cols[C] = encode_col(C);
			val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			switch(header) {
				case 1: hdr[C] = C - r.s.c; break;
				case 2: hdr[C] = cols[C]; break;
				case 3: hdr[C] = o.header[C - r.s.c]; break;
				default:
					if(val == null) val = {w: "__EMPTY", t: "s"};
					vv = v = format_cell(val, null, o);
					counter = 0;
					for(CC = 0; CC < hdr.length; ++CC) if(hdr[CC] == vv) vv = v + "_" + (++counter);
					hdr[C] = vv;
			}
		}
		R = r.s.r + offset;
		stream._read = function() {
			if(R > r.e.r) return stream.push(null);
			while(R <= r.e.r) {
				++R;
				//if ((rowinfo[R-1]||{}).hidden) continue;
				var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
				if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
					stream.push(row.row);
					break;
				}
			}
		};
		return stream;
	};

	XLSX.stream = {
		to_json: write_json_stream,
		to_html: write_html_stream,
		to_csv: write_csv_stream
	};
})();

XLSX.parse_xlscfb = parse_xlscfb;
XLSX.parse_ods = parse_ods;
XLSX.parse_fods = parse_fods;
XLSX.write_ods = write_ods;
XLSX.parse_zip = parse_zip;
XLSX.read = readSync; //xlsread
XLSX.readFile = readFileSync; //readFile
XLSX.readFileSync = readFileSync;
XLSX.write = writeSync;
XLSX.writeFile = writeFileSync;
XLSX.writeFileSync = writeFileSync;
XLSX.writeFileAsync = writeFileAsync;
XLSX.utils = utils;
XLSX.SSF = SSF;
XLSX.CFB = CFB;
}
/*global define */
if(true) make_xlsx_lib(exports);
else if(typeof module !== 'undefined' && module.exports) make_xlsx_lib(module.exports);
else if(typeof define === 'function' && define.amd) define('xlsx', function() { if(!XLSX.version) make_xlsx_lib(XLSX); return XLSX; });
else make_xlsx_lib(XLSX);
/*exported XLS, ODS */
var XLS = XLSX, ODS = XLSX;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42), __webpack_require__(224).Buffer, __webpack_require__(295)))

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return (b64.length * 3 / 4) - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr((len * 3 / 4) - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0; i < l; i += 4) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 1087 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1088 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/*

JSZip - A Javascript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2014 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/master/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/master/LICENSE

Note: since JSZip 3 removed critical functionality, this version assigns to the
`JSZipSync` variable.  Another JSZip version can be loaded in parallel.
*/
(function(e){
	if("object"==typeof exports&&"undefined"!=typeof module&&"undefined"==typeof DO_NOT_EXPORT_JSZIP)module.exports=e();
	else if("function"=="function"&&__webpack_require__(370)&&"undefined"==typeof DO_NOT_EXPORT_JSZIP){JSZipSync=e();!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}
	else{
		var f;
		"undefined"!=typeof window?f=window:
		"undefined"!=typeof global?f=global:
		"undefined"!=typeof $ && $.global?f=$.global:
		"undefined"!=typeof self&&(f=self),f.JSZipSync=e()
	}
}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
'use strict';
// private property
var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";


// public method for encoding
exports.encode = function(input, utf8) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;

    while (i < input.length) {

        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        }
        else if (isNaN(chr3)) {
            enc4 = 64;
        }

        output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);

    }

    return output;
};

// public method for decoding
exports.decode = function(input, utf8) {
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;

    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    while (i < input.length) {

        enc1 = _keyStr.indexOf(input.charAt(i++));
        enc2 = _keyStr.indexOf(input.charAt(i++));
        enc3 = _keyStr.indexOf(input.charAt(i++));
        enc4 = _keyStr.indexOf(input.charAt(i++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        output = output + String.fromCharCode(chr1);

        if (enc3 != 64) {
            output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
            output = output + String.fromCharCode(chr3);
        }

    }

    return output;

};

},{}],2:[function(_dereq_,module,exports){
'use strict';
function CompressedObject() {
    this.compressedSize = 0;
    this.uncompressedSize = 0;
    this.crc32 = 0;
    this.compressionMethod = null;
    this.compressedContent = null;
}

CompressedObject.prototype = {
    /**
     * Return the decompressed content in an unspecified format.
     * The format will depend on the decompressor.
     * @return {Object} the decompressed content.
     */
    getContent: function() {
        return null; // see implementation
    },
    /**
     * Return the compressed content in an unspecified format.
     * The format will depend on the compressed conten source.
     * @return {Object} the compressed content.
     */
    getCompressedContent: function() {
        return null; // see implementation
    }
};
module.exports = CompressedObject;

},{}],3:[function(_dereq_,module,exports){
'use strict';
exports.STORE = {
    magic: "\x00\x00",
    compress: function(content) {
        return content; // no compression
    },
    uncompress: function(content) {
        return content; // no compression
    },
    compressInputType: null,
    uncompressInputType: null
};
exports.DEFLATE = _dereq_('./flate');

},{"./flate":8}],4:[function(_dereq_,module,exports){
'use strict';

var utils = _dereq_('./utils');

var table = [
    0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA,
    0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3,
    0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988,
    0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91,
    0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
    0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7,
    0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC,
    0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5,
    0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172,
    0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
    0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940,
    0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59,
    0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116,
    0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F,
    0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
    0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D,
    0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A,
    0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433,
    0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818,
    0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
    0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E,
    0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457,
    0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C,
    0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65,
    0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
    0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB,
    0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0,
    0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9,
    0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086,
    0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
    0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4,
    0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD,
    0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A,
    0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683,
    0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
    0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1,
    0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE,
    0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7,
    0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC,
    0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
    0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252,
    0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B,
    0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60,
    0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79,
    0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
    0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F,
    0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04,
    0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D,
    0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A,
    0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
    0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38,
    0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21,
    0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E,
    0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777,
    0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
    0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45,
    0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2,
    0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB,
    0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0,
    0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
    0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6,
    0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF,
    0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94,
    0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D
];

/**
 *
 *  Javascript crc32
 *  http://www.webtoolkit.info/
 *
 */
module.exports = function crc32(input, crc) {
    if (typeof input === "undefined" || !input.length) {
        return 0;
    }

    var isArray = utils.getTypeOf(input) !== "string";

    if (typeof(crc) == "undefined") {
        crc = 0;
    }
    var x = 0;
    var y = 0;
    var b = 0;

    crc = crc ^ (-1);
    for (var i = 0, iTop = input.length; i < iTop; i++) {
        b = isArray ? input[i] : input.charCodeAt(i);
        y = (crc ^ b) & 0xFF;
        x = table[y];
        crc = (crc >>> 8) ^ x;
    }

    return crc ^ (-1);
};
// vim: set shiftwidth=4 softtabstop=4:

},{"./utils":21}],5:[function(_dereq_,module,exports){
'use strict';
var utils = _dereq_('./utils');

function DataReader(data) {
    this.data = null; // type : see implementation
    this.length = 0;
    this.index = 0;
}
DataReader.prototype = {
    /**
     * Check that the offset will not go too far.
     * @param {string} offset the additional offset to check.
     * @throws {Error} an Error if the offset is out of bounds.
     */
    checkOffset: function(offset) {
        this.checkIndex(this.index + offset);
    },
    /**
     * Check that the specifed index will not be too far.
     * @param {string} newIndex the index to check.
     * @throws {Error} an Error if the index is out of bounds.
     */
    checkIndex: function(newIndex) {
        if (this.length < newIndex || newIndex < 0) {
            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
        }
    },
    /**
     * Change the index.
     * @param {number} newIndex The new index.
     * @throws {Error} if the new index is out of the data.
     */
    setIndex: function(newIndex) {
        this.checkIndex(newIndex);
        this.index = newIndex;
    },
    /**
     * Skip the next n bytes.
     * @param {number} n the number of bytes to skip.
     * @throws {Error} if the new index is out of the data.
     */
    skip: function(n) {
        this.setIndex(this.index + n);
    },
    /**
     * Get the byte at the specified index.
     * @param {number} i the index to use.
     * @return {number} a byte.
     */
    byteAt: function(i) {
        // see implementations
    },
    /**
     * Get the next number with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {number} the corresponding number.
     */
    readInt: function(size) {
        var result = 0,
            i;
        this.checkOffset(size);
        for (i = this.index + size - 1; i >= this.index; i--) {
            result = (result << 8) + this.byteAt(i);
        }
        this.index += size;
        return result;
    },
    /**
     * Get the next string with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {string} the corresponding string.
     */
    readString: function(size) {
        return utils.transformTo("string", this.readData(size));
    },
    /**
     * Get raw data without conversion, <size> bytes.
     * @param {number} size the number of bytes to read.
     * @return {Object} the raw data, implementation specific.
     */
    readData: function(size) {
        // see implementations
    },
    /**
     * Find the last occurence of a zip signature (4 bytes).
     * @param {string} sig the signature to find.
     * @return {number} the index of the last occurence, -1 if not found.
     */
    lastIndexOfSignature: function(sig) {
        // see implementations
    },
    /**
     * Get the next date.
     * @return {Date} the date.
     */
    readDate: function() {
        var dostime = this.readInt(4);
        return new Date(
        ((dostime >> 25) & 0x7f) + 1980, // year
        ((dostime >> 21) & 0x0f) - 1, // month
        (dostime >> 16) & 0x1f, // day
        (dostime >> 11) & 0x1f, // hour
        (dostime >> 5) & 0x3f, // minute
        (dostime & 0x1f) << 1); // second
    }
};
module.exports = DataReader;

},{"./utils":21}],6:[function(_dereq_,module,exports){
'use strict';
exports.base64 = false;
exports.binary = false;
exports.dir = false;
exports.createFolders = false;
exports.date = null;
exports.compression = null;
exports.comment = null;

},{}],7:[function(_dereq_,module,exports){
'use strict';
var utils = _dereq_('./utils');

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.string2binary = function(str) {
    return utils.string2binary(str);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.string2Uint8Array = function(str) {
    return utils.transformTo("uint8array", str);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.uint8Array2String = function(array) {
    return utils.transformTo("string", array);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.string2Blob = function(str) {
    var buffer = utils.transformTo("arraybuffer", str);
    return utils.arrayBuffer2Blob(buffer);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.arrayBuffer2Blob = function(buffer) {
    return utils.arrayBuffer2Blob(buffer);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.transformTo = function(outputType, input) {
    return utils.transformTo(outputType, input);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.getTypeOf = function(input) {
    return utils.getTypeOf(input);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.checkSupport = function(type) {
    return utils.checkSupport(type);
};

/**
 * @deprecated
 * This value will be removed in a future version without replacement.
 */
exports.MAX_VALUE_16BITS = utils.MAX_VALUE_16BITS;

/**
 * @deprecated
 * This value will be removed in a future version without replacement.
 */
exports.MAX_VALUE_32BITS = utils.MAX_VALUE_32BITS;


/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.pretty = function(str) {
    return utils.pretty(str);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.findCompression = function(compressionMethod) {
    return utils.findCompression(compressionMethod);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.isRegExp = function (object) {
    return utils.isRegExp(object);
};


},{"./utils":21}],8:[function(_dereq_,module,exports){
'use strict';
var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');

var pako = _dereq_("pako");
exports.uncompressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
exports.compressInputType = USE_TYPEDARRAY ? "uint8array" : "array";

exports.magic = "\x08\x00";
exports.compress = function(input) {
    return pako.deflateRaw(input);
};
exports.uncompress =  function(input) {
    return pako.inflateRaw(input);
};

},{"pako":24}],9:[function(_dereq_,module,exports){
'use strict';

var base64 = _dereq_('./base64');

/**
Usage:
   zip = new JSZip();
   zip.file("hello.txt", "Hello, World!").file("tempfile", "nothing");
   zip.folder("images").file("smile.gif", base64Data, {base64: true});
   zip.file("Xmas.txt", "Ho ho ho !", {date : new Date("December 25, 2007 00:00:01")});
   zip.remove("tempfile");

   base64zip = zip.generate();

**/

/**
 * Representation a of zip file in js
 * @constructor
 * @param {String=|ArrayBuffer=|Uint8Array=} data the data to load, if any (optional).
 * @param {Object=} options the options for creating this objects (optional).
 */
function JSZipSync(data, options) {
    // if this constructor is used without `new`, it adds `new` before itself:
    if(!(this instanceof JSZipSync)) return new JSZipSync(data, options);

    // object containing the files :
    // {
    //   "folder/" : {...},
    //   "folder/data.txt" : {...}
    // }
    this.files = {};

    this.comment = null;

    // Where we are in the hierarchy
    this.root = "";
    if (data) {
        this.load(data, options);
    }
    this.clone = function() {
        var newObj = new JSZipSync();
        for (var i in this) {
            if (typeof this[i] !== "function") {
                newObj[i] = this[i];
            }
        }
        return newObj;
    };
}
JSZipSync.prototype = _dereq_('./object');
JSZipSync.prototype.load = _dereq_('./load');
JSZipSync.support = _dereq_('./support');
JSZipSync.defaults = _dereq_('./defaults');

/**
 * @deprecated
 * This namespace will be removed in a future version without replacement.
 */
JSZipSync.utils = _dereq_('./deprecatedPublicUtils');

JSZipSync.base64 = {
    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */
    encode : function(input) {
        return base64.encode(input);
    },
    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */
    decode : function(input) {
        return base64.decode(input);
    }
};
JSZipSync.compressions = _dereq_('./compressions');
module.exports = JSZipSync;

},{"./base64":1,"./compressions":3,"./defaults":6,"./deprecatedPublicUtils":7,"./load":10,"./object":13,"./support":17}],10:[function(_dereq_,module,exports){
'use strict';
var base64 = _dereq_('./base64');
var ZipEntries = _dereq_('./zipEntries');
module.exports = function(data, options) {
    var files, zipEntries, i, input;
    options = options || {};
    if (options.base64) {
        data = base64.decode(data);
    }

    zipEntries = new ZipEntries(data, options);
    files = zipEntries.files;
    for (i = 0; i < files.length; i++) {
        input = files[i];
        this.file(input.fileName, input.decompressed, {
            binary: true,
            optimizedBinaryString: true,
            date: input.date,
            dir: input.dir,
            comment : input.fileComment.length ? input.fileComment : null,
            createFolders: options.createFolders
        });
    }
    if (zipEntries.zipComment.length) {
        this.comment = zipEntries.zipComment;
    }

    return this;
};

},{"./base64":1,"./zipEntries":22}],11:[function(_dereq_,module,exports){
(function (Buffer){
'use strict';
var Buffer_from = /*::(*/function(){}/*:: :any)*/;
if(typeof Buffer !== 'undefined') {
	var nbfs = !Buffer.from;
	if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
	Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
	// $FlowIgnore
	if(!Buffer.alloc) Buffer.alloc = function(n) { return new Buffer(n); };
}
module.exports = function(data, encoding){
    return typeof data == 'number' ? Buffer.alloc(data) : Buffer_from(data, encoding);
};
module.exports.test = function(b){
    return Buffer.isBuffer(b);
};
}).call(this,(typeof Buffer !== "undefined" ? Buffer : undefined))
},{}],12:[function(_dereq_,module,exports){
'use strict';
var Uint8ArrayReader = _dereq_('./uint8ArrayReader');

function NodeBufferReader(data) {
    this.data = data;
    this.length = this.data.length;
    this.index = 0;
}
NodeBufferReader.prototype = new Uint8ArrayReader();

/**
 * @see DataReader.readData
 */
NodeBufferReader.prototype.readData = function(size) {
    this.checkOffset(size);
    var result = this.data.slice(this.index, this.index + size);
    this.index += size;
    return result;
};
module.exports = NodeBufferReader;

},{"./uint8ArrayReader":18}],13:[function(_dereq_,module,exports){
'use strict';
var support = _dereq_('./support');
var utils = _dereq_('./utils');
var crc32 = _dereq_('./crc32');
var signature = _dereq_('./signature');
var defaults = _dereq_('./defaults');
var base64 = _dereq_('./base64');
var compressions = _dereq_('./compressions');
var CompressedObject = _dereq_('./compressedObject');
var nodeBuffer = _dereq_('./nodeBuffer');
var utf8 = _dereq_('./utf8');
var StringWriter = _dereq_('./stringWriter');
var Uint8ArrayWriter = _dereq_('./uint8ArrayWriter');

/**
 * Returns the raw data of a ZipObject, decompress the content if necessary.
 * @param {ZipObject} file the file to use.
 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
 */
var getRawData = function(file) {
    if (file._data instanceof CompressedObject) {
        file._data = file._data.getContent();
        file.options.binary = true;
        file.options.base64 = false;

        if (utils.getTypeOf(file._data) === "uint8array") {
            var copy = file._data;
            // when reading an arraybuffer, the CompressedObject mechanism will keep it and subarray() a Uint8Array.
            // if we request a file in the same format, we might get the same Uint8Array or its ArrayBuffer (the original zip file).
            file._data = new Uint8Array(copy.length);
            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
            if (copy.length !== 0) {
                file._data.set(copy, 0);
            }
        }
    }
    return file._data;
};

/**
 * Returns the data of a ZipObject in a binary form. If the content is an unicode string, encode it.
 * @param {ZipObject} file the file to use.
 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
 */
var getBinaryData = function(file) {
    var result = getRawData(file),
        type = utils.getTypeOf(result);
    if (type === "string") {
        if (!file.options.binary) {
            // unicode text !
            // unicode string => binary string is a painful process, check if we can avoid it.
            if (support.nodebuffer) {
                return nodeBuffer(result, "utf-8");
            }
        }
        return file.asBinary();
    }
    return result;
};

/**
 * Transform this._data into a string.
 * @param {function} filter a function String -> String, applied if not null on the result.
 * @return {String} the string representing this._data.
 */
var dataToString = function(asUTF8) {
    var result = getRawData(this);
    if (result === null || typeof result === "undefined") {
        return "";
    }
    // if the data is a base64 string, we decode it before checking the encoding !
    if (this.options.base64) {
        result = base64.decode(result);
    }
    if (asUTF8 && this.options.binary) {
        // JSZip.prototype.utf8decode supports arrays as input
        // skip to array => string step, utf8decode will do it.
        result = out.utf8decode(result);
    }
    else {
        // no utf8 transformation, do the array => string step.
        result = utils.transformTo("string", result);
    }

    if (!asUTF8 && !this.options.binary) {
        result = utils.transformTo("string", out.utf8encode(result));
    }
    return result;
};
/**
 * A simple object representing a file in the zip file.
 * @constructor
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
 * @param {Object} options the options of the file
 */
var ZipObject = function(name, data, options) {
    this.name = name;
    this.dir = options.dir;
    this.date = options.date;
    this.comment = options.comment;

    this._data = data;
    this.options = options;

    /*
     * This object contains initial values for dir and date.
     * With them, we can check if the user changed the deprecated metadata in
     * `ZipObject#options` or not.
     */
    this._initialMetadata = {
      dir : options.dir,
      date : options.date
    };
};

ZipObject.prototype = {
    /**
     * Return the content as UTF8 string.
     * @return {string} the UTF8 string.
     */
    asText: function() {
        return dataToString.call(this, true);
    },
    /**
     * Returns the binary content.
     * @return {string} the content as binary.
     */
    asBinary: function() {
        return dataToString.call(this, false);
    },
    /**
     * Returns the content as a nodejs Buffer.
     * @return {Buffer} the content as a Buffer.
     */
    asNodeBuffer: function() {
        var result = getBinaryData(this);
        return utils.transformTo("nodebuffer", result);
    },
    /**
     * Returns the content as an Uint8Array.
     * @return {Uint8Array} the content as an Uint8Array.
     */
    asUint8Array: function() {
        var result = getBinaryData(this);
        return utils.transformTo("uint8array", result);
    },
    /**
     * Returns the content as an ArrayBuffer.
     * @return {ArrayBuffer} the content as an ArrayBufer.
     */
    asArrayBuffer: function() {
        return this.asUint8Array().buffer;
    }
};

/**
 * Transform an integer into a string in hexadecimal.
 * @private
 * @param {number} dec the number to convert.
 * @param {number} bytes the number of bytes to generate.
 * @returns {string} the result.
 */
var decToHex = function(dec, bytes) {
    var hex = "",
        i;
    for (i = 0; i < bytes; i++) {
        hex += String.fromCharCode(dec & 0xff);
        dec = dec >>> 8;
    }
    return hex;
};

/**
 * Merge the objects passed as parameters into a new one.
 * @private
 * @param {...Object} var_args All objects to merge.
 * @return {Object} a new object with the data of the others.
 */
var extend = function() {
    var result = {}, i, attr;
    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
        for (attr in arguments[i]) {
            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
                result[attr] = arguments[i][attr];
            }
        }
    }
    return result;
};

/**
 * Transforms the (incomplete) options from the user into the complete
 * set of options to create a file.
 * @private
 * @param {Object} o the options from the user.
 * @return {Object} the complete set of options.
 */
var prepareFileAttrs = function(o) {
    o = o || {};
    if (o.base64 === true && (o.binary === null || o.binary === undefined)) {
        o.binary = true;
    }
    o = extend(o, defaults);
    o.date = o.date || new Date();
    if (o.compression !== null) o.compression = o.compression.toUpperCase();

    return o;
};

/**
 * Add a file in the current folder.
 * @private
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
 * @param {Object} o the options of the file
 * @return {Object} the new file.
 */
var fileAdd = function(name, data, o) {
    // be sure sub folders exist
    var dataType = utils.getTypeOf(data),
        parent;

    o = prepareFileAttrs(o);

    if (o.createFolders && (parent = parentFolder(name))) {
        folderAdd.call(this, parent, true);
    }

    if (o.dir || data === null || typeof data === "undefined") {
        o.base64 = false;
        o.binary = false;
        data = null;
    }
    else if (dataType === "string") {
        if (o.binary && !o.base64) {
            // optimizedBinaryString == true means that the file has already been filtered with a 0xFF mask
            if (o.optimizedBinaryString !== true) {
                // this is a string, not in a base64 format.
                // Be sure that this is a correct "binary string"
                data = utils.string2binary(data);
            }
        }
    }
    else { // arraybuffer, uint8array, ...
        o.base64 = false;
        o.binary = true;

        if (!dataType && !(data instanceof CompressedObject)) {
            throw new Error("The data of '" + name + "' is in an unsupported format !");
        }

        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
        if (dataType === "arraybuffer") {
            data = utils.transformTo("uint8array", data);
        }
    }

    var object = new ZipObject(name, data, o);
    this.files[name] = object;
    return object;
};

/**
 * Find the parent folder of the path.
 * @private
 * @param {string} path the path to use
 * @return {string} the parent folder, or ""
 */
var parentFolder = function (path) {
    if (path.slice(-1) == '/') {
        path = path.substring(0, path.length - 1);
    }
    var lastSlash = path.lastIndexOf('/');
    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
};

/**
 * Add a (sub) folder in the current folder.
 * @private
 * @param {string} name the folder's name
 * @param {boolean=} [createFolders] If true, automatically create sub
 *  folders. Defaults to false.
 * @return {Object} the new folder.
 */
var folderAdd = function(name, createFolders) {
    // Check the name ends with a /
    if (name.slice(-1) != "/") {
        name += "/"; // IE doesn't like substr(-1)
    }

    createFolders = (typeof createFolders !== 'undefined') ? createFolders : false;

    // Does this folder already exist?
    if (!this.files[name]) {
        fileAdd.call(this, name, null, {
            dir: true,
            createFolders: createFolders
        });
    }
    return this.files[name];
};

/**
 * Generate a JSZip.CompressedObject for a given zipOject.
 * @param {ZipObject} file the object to read.
 * @param {JSZip.compression} compression the compression to use.
 * @return {JSZip.CompressedObject} the compressed result.
 */
var generateCompressedObjectFrom = function(file, compression) {
    var result = new CompressedObject(),
        content;

    // the data has not been decompressed, we might reuse things !
    if (file._data instanceof CompressedObject) {
        result.uncompressedSize = file._data.uncompressedSize;
        result.crc32 = file._data.crc32;

        if (result.uncompressedSize === 0 || file.dir) {
            compression = compressions['STORE'];
            result.compressedContent = "";
            result.crc32 = 0;
        }
        else if (file._data.compressionMethod === compression.magic) {
            result.compressedContent = file._data.getCompressedContent();
        }
        else {
            content = file._data.getContent();
            // need to decompress / recompress
            result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
        }
    }
    else {
        // have uncompressed data
        content = getBinaryData(file);
        if (!content || content.length === 0 || file.dir) {
            compression = compressions['STORE'];
            content = "";
        }
        result.uncompressedSize = content.length;
        result.crc32 = crc32(content);
        result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
    }

    result.compressedSize = result.compressedContent.length;
    result.compressionMethod = compression.magic;

    return result;
};

/**
 * Generate the various parts used in the construction of the final zip file.
 * @param {string} name the file name.
 * @param {ZipObject} file the file content.
 * @param {JSZip.CompressedObject} compressedObject the compressed object.
 * @param {number} offset the current offset from the start of the zip file.
 * @return {object} the zip parts.
 */
var generateZipParts = function(name, file, compressedObject, offset) {
    var data = compressedObject.compressedContent,
        utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
        comment = file.comment || "",
        utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
        useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
        useUTF8ForComment = utfEncodedComment.length !== comment.length,
        o = file.options,
        dosTime,
        dosDate,
        extraFields = "",
        unicodePathExtraField = "",
        unicodeCommentExtraField = "",
        dir, date;


    // handle the deprecated options.dir
    if (file._initialMetadata.dir !== file.dir) {
        dir = file.dir;
    } else {
        dir = o.dir;
    }

    // handle the deprecated options.date
    if(file._initialMetadata.date !== file.date) {
        date = file.date;
    } else {
        date = o.date;
    }


    dosTime = date.getHours();
    dosTime = dosTime << 6;
    dosTime = dosTime | date.getMinutes();
    dosTime = dosTime << 5;
    dosTime = dosTime | date.getSeconds() / 2;

    dosDate = date.getFullYear() - 1980;
    dosDate = dosDate << 4;
    dosDate = dosDate | (date.getMonth() + 1);
    dosDate = dosDate << 5;
    dosDate = dosDate | date.getDate();

    if (useUTF8ForFileName) {
        // set the unicode path extra field. unzip needs at least one extra
        // field to correctly handle unicode path, so using the path is as good
        // as any other information. This could improve the situation with
        // other archive managers too.
        // This field is usually used without the utf8 flag, with a non
        // unicode path in the header (winrar, winzip). This helps (a bit)
        // with the messy Windows' default compressed folders feature but
        // breaks on p7zip which doesn't seek the unicode path extra field.
        // So for now, UTF-8 everywhere !
        unicodePathExtraField =
            // Version
            decToHex(1, 1) +
            // NameCRC32
            decToHex(crc32(utfEncodedFileName), 4) +
            // UnicodeName
            utfEncodedFileName;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x70" +
            // size
            decToHex(unicodePathExtraField.length, 2) +
            // content
            unicodePathExtraField;
    }

    if(useUTF8ForComment) {

        unicodeCommentExtraField =
            // Version
            decToHex(1, 1) +
            // CommentCRC32
            decToHex(this.crc32(utfEncodedComment), 4) +
            // UnicodeName
            utfEncodedComment;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x63" +
            // size
            decToHex(unicodeCommentExtraField.length, 2) +
            // content
            unicodeCommentExtraField;
    }

    var header = "";

    // version needed to extract
    header += "\x0A\x00";
    // general purpose bit flag
    // set bit 11 if utf8
    header += (useUTF8ForFileName || useUTF8ForComment) ? "\x00\x08" : "\x00\x00";
    // compression method
    header += compressedObject.compressionMethod;
    // last mod file time
    header += decToHex(dosTime, 2);
    // last mod file date
    header += decToHex(dosDate, 2);
    // crc-32
    header += decToHex(compressedObject.crc32, 4);
    // compressed size
    header += decToHex(compressedObject.compressedSize, 4);
    // uncompressed size
    header += decToHex(compressedObject.uncompressedSize, 4);
    // file name length
    header += decToHex(utfEncodedFileName.length, 2);
    // extra field length
    header += decToHex(extraFields.length, 2);


    var fileRecord = signature.LOCAL_FILE_HEADER + header + utfEncodedFileName + extraFields;

    var dirRecord = signature.CENTRAL_FILE_HEADER +
    // version made by (00: DOS)
    "\x14\x00" +
    // file header (common to file and central directory)
    header +
    // file comment length
    decToHex(utfEncodedComment.length, 2) +
    // disk number start
    "\x00\x00" +
    // internal file attributes TODO
    "\x00\x00" +
    // external file attributes
    (dir === true ? "\x10\x00\x00\x00" : "\x00\x00\x00\x00") +
    // relative offset of local header
    decToHex(offset, 4) +
    // file name
    utfEncodedFileName +
    // extra field
    extraFields +
    // file comment
    utfEncodedComment;

    return {
        fileRecord: fileRecord,
        dirRecord: dirRecord,
        compressedObject: compressedObject
    };
};


// return the actual prototype of JSZip
var out = {
    /**
     * Read an existing zip and merge the data in the current JSZip object.
     * The implementation is in jszip-load.js, don't forget to include it.
     * @param {String|ArrayBuffer|Uint8Array|Buffer} stream  The stream to load
     * @param {Object} options Options for loading the stream.
     *  options.base64 : is the stream in base64 ? default : false
     * @return {JSZip} the current JSZip object
     */
    load: function(stream, options) {
        throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
    },

    /**
     * Filter nested files/folders with the specified function.
     * @param {Function} search the predicate to use :
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     * @return {Array} An array of matching elements.
     */
    filter: function(search) {
        var result = [],
            filename, relativePath, file, fileClone;
        for (filename in this.files) {
            if (!this.files.hasOwnProperty(filename)) {
                continue;
            }
            file = this.files[filename];
            // return a new object, don't let the user mess with our internal objects :)
            fileClone = new ZipObject(file.name, file._data, extend(file.options));
            relativePath = filename.slice(this.root.length, filename.length);
            if (filename.slice(0, this.root.length) === this.root && // the file is in the current root
            search(relativePath, fileClone)) { // and the file matches the function
                result.push(fileClone);
            }
        }
        return result;
    },

    /**
     * Add a file to the zip file, or search a file.
     * @param   {string|RegExp} name The name of the file to add (if data is defined),
     * the name of the file to find (if no data) or a regex to match files.
     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
     * @param   {Object} o     File options
     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
     * a file (when searching by string) or an array of files (when searching by regex).
     */
    file: function(name, data, o) {
        if (arguments.length === 1) {
            if (utils.isRegExp(name)) {
                var regexp = name;
                return this.filter(function(relativePath, file) {
                    return !file.dir && regexp.test(relativePath);
                });
            }
            else { // text
                return this.filter(function(relativePath, file) {
                    return !file.dir && relativePath === name;
                })[0] || null;
            }
        }
        else { // more than one argument : we have data !
            name = this.root + name;
            fileAdd.call(this, name, data, o);
        }
        return this;
    },

    /**
     * Add a directory to the zip file, or search.
     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
     */
    folder: function(arg) {
        if (!arg) {
            return this;
        }

        if (utils.isRegExp(arg)) {
            return this.filter(function(relativePath, file) {
                return file.dir && arg.test(relativePath);
            });
        }

        // else, name is a new folder
        var name = this.root + arg;
        var newFolder = folderAdd.call(this, name);

        // Allow chaining by returning a new object with this folder as the root
        var ret = this.clone();
        ret.root = newFolder.name;
        return ret;
    },

    /**
     * Delete a file, or a directory and all sub-files, from the zip
     * @param {string} name the name of the file to delete
     * @return {JSZip} this JSZip object
     */
    remove: function(name) {
        name = this.root + name;
        var file = this.files[name];
        if (!file) {
            // Look for any folders
            if (name.slice(-1) != "/") {
                name += "/";
            }
            file = this.files[name];
        }

        if (file && !file.dir) {
            // file
            delete this.files[name];
        } else {
            // maybe a folder, delete recursively
            var kids = this.filter(function(relativePath, file) {
                return file.name.slice(0, name.length) === name;
            });
            for (var i = 0; i < kids.length; i++) {
                delete this.files[kids[i].name];
            }
        }

        return this;
    },

    /**
     * Generate the complete zip file
     * @param {Object} options the options to generate the zip file :
     * - base64, (deprecated, use type instead) true to generate base64.
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
     */
    generate: function(options) {
        options = extend(options || {}, {
            base64: true,
            compression: "STORE",
            type: "base64",
            comment: null
        });

        utils.checkSupport(options.type);

        var zipData = [],
            localDirLength = 0,
            centralDirLength = 0,
            writer, i,
            utfEncodedComment = utils.transformTo("string", this.utf8encode(options.comment || this.comment || ""));

        // first, generate all the zip parts.
        for (var name in this.files) {
            if (!this.files.hasOwnProperty(name)) {
                continue;
            }
            var file = this.files[name];

            var compressionName = file.options.compression || options.compression.toUpperCase();
            var compression = compressions[compressionName];
            if (!compression) {
                throw new Error(compressionName + " is not a valid compression method !");
            }

            var compressedObject = generateCompressedObjectFrom.call(this, file, compression);

            var zipPart = generateZipParts.call(this, name, file, compressedObject, localDirLength);
            localDirLength += zipPart.fileRecord.length + compressedObject.compressedSize;
            centralDirLength += zipPart.dirRecord.length;
            zipData.push(zipPart);
        }

        var dirEnd = "";

        // end of central dir signature
        dirEnd = signature.CENTRAL_DIRECTORY_END +
        // number of this disk
        "\x00\x00" +
        // number of the disk with the start of the central directory
        "\x00\x00" +
        // total number of entries in the central directory on this disk
        decToHex(zipData.length, 2) +
        // total number of entries in the central directory
        decToHex(zipData.length, 2) +
        // size of the central directory   4 bytes
        decToHex(centralDirLength, 4) +
        // offset of start of central directory with respect to the starting disk number
        decToHex(localDirLength, 4) +
        // .ZIP file comment length
        decToHex(utfEncodedComment.length, 2) +
        // .ZIP file comment
        utfEncodedComment;


        // we have all the parts (and the total length)
        // time to create a writer !
        var typeName = options.type.toLowerCase();
        if(typeName==="uint8array"||typeName==="arraybuffer"||typeName==="blob"||typeName==="nodebuffer") {
            writer = new Uint8ArrayWriter(localDirLength + centralDirLength + dirEnd.length);
        }else{
            writer = new StringWriter(localDirLength + centralDirLength + dirEnd.length);
        }

        for (i = 0; i < zipData.length; i++) {
            writer.append(zipData[i].fileRecord);
            writer.append(zipData[i].compressedObject.compressedContent);
        }
        for (i = 0; i < zipData.length; i++) {
            writer.append(zipData[i].dirRecord);
        }

        writer.append(dirEnd);

        var zip = writer.finalize();



        switch(options.type.toLowerCase()) {
            // case "zip is an Uint8Array"
            case "uint8array" :
            case "arraybuffer" :
            case "nodebuffer" :
               return utils.transformTo(options.type.toLowerCase(), zip);
            case "blob" :
               return utils.arrayBuffer2Blob(utils.transformTo("arraybuffer", zip));
            // case "zip is a string"
            case "base64" :
               return (options.base64) ? base64.encode(zip) : zip;
            default : // case "string" :
               return zip;
         }

    },

    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */
    crc32: function (input, crc) {
        return crc32(input, crc);
    },

    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */
    utf8encode: function (string) {
        return utils.transformTo("string", utf8.utf8encode(string));
    },

    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */
    utf8decode: function (input) {
        return utf8.utf8decode(input);
    }
};
module.exports = out;

},{"./base64":1,"./compressedObject":2,"./compressions":3,"./crc32":4,"./defaults":6,"./nodeBuffer":11,"./signature":14,"./stringWriter":16,"./support":17,"./uint8ArrayWriter":19,"./utf8":20,"./utils":21}],14:[function(_dereq_,module,exports){
'use strict';
exports.LOCAL_FILE_HEADER = "PK\x03\x04";
exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
exports.DATA_DESCRIPTOR = "PK\x07\x08";

},{}],15:[function(_dereq_,module,exports){
'use strict';
var DataReader = _dereq_('./dataReader');
var utils = _dereq_('./utils');

function StringReader(data, optimizedBinaryString) {
    this.data = data;
    if (!optimizedBinaryString) {
        this.data = utils.string2binary(this.data);
    }
    this.length = this.data.length;
    this.index = 0;
}
StringReader.prototype = new DataReader();
/**
 * @see DataReader.byteAt
 */
StringReader.prototype.byteAt = function(i) {
    return this.data.charCodeAt(i);
};
/**
 * @see DataReader.lastIndexOfSignature
 */
StringReader.prototype.lastIndexOfSignature = function(sig) {
    return this.data.lastIndexOf(sig);
};
/**
 * @see DataReader.readData
 */
StringReader.prototype.readData = function(size) {
    this.checkOffset(size);
    // this will work because the constructor applied the "& 0xff" mask.
    var result = this.data.slice(this.index, this.index + size);
    this.index += size;
    return result;
};
module.exports = StringReader;

},{"./dataReader":5,"./utils":21}],16:[function(_dereq_,module,exports){
'use strict';

var utils = _dereq_('./utils');

/**
 * An object to write any content to a string.
 * @constructor
 */
var StringWriter = function() {
    this.data = [];
};
StringWriter.prototype = {
    /**
     * Append any content to the current string.
     * @param {Object} input the content to add.
     */
    append: function(input) {
        input = utils.transformTo("string", input);
        this.data.push(input);
    },
    /**
     * Finalize the construction an return the result.
     * @return {string} the generated string.
     */
    finalize: function() {
        return this.data.join("");
    }
};

module.exports = StringWriter;

},{"./utils":21}],17:[function(_dereq_,module,exports){
(function (Buffer){
'use strict';
exports.base64 = true;
exports.array = true;
exports.string = true;
exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
// contains true if JSZip can read/generate nodejs Buffer, false otherwise.
// Browserify will provide a Buffer implementation for browsers, which is
// an augmented Uint8Array (i.e., can be used as either Buffer or U8).
exports.nodebuffer = typeof Buffer !== "undefined";
// contains true if JSZip can read/generate Uint8Array, false otherwise.
exports.uint8array = typeof Uint8Array !== "undefined";

if (typeof ArrayBuffer === "undefined") {
    exports.blob = false;
}
else {
    var buffer = new ArrayBuffer(0);
    try {
        exports.blob = new Blob([buffer], {
            type: "application/zip"
        }).size === 0;
    }
    catch (e) {
        try {
            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
            var builder = new Builder();
            builder.append(buffer);
            exports.blob = builder.getBlob('application/zip').size === 0;
        }
        catch (e) {
            exports.blob = false;
        }
    }
}

}).call(this,(typeof Buffer !== "undefined" ? Buffer : undefined))
},{}],18:[function(_dereq_,module,exports){
'use strict';
var DataReader = _dereq_('./dataReader');

function Uint8ArrayReader(data) {
    if (data) {
        this.data = data;
        this.length = this.data.length;
        this.index = 0;
    }
}
Uint8ArrayReader.prototype = new DataReader();
/**
 * @see DataReader.byteAt
 */
Uint8ArrayReader.prototype.byteAt = function(i) {
    return this.data[i];
};
/**
 * @see DataReader.lastIndexOfSignature
 */
Uint8ArrayReader.prototype.lastIndexOfSignature = function(sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3);
    for (var i = this.length - 4; i >= 0; --i) {
        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
            return i;
        }
    }

    return -1;
};
/**
 * @see DataReader.readData
 */
Uint8ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
        return new Uint8Array(0);
    }
    var result = this.data.subarray(this.index, this.index + size);
    this.index += size;
    return result;
};
module.exports = Uint8ArrayReader;

},{"./dataReader":5}],19:[function(_dereq_,module,exports){
'use strict';

var utils = _dereq_('./utils');

/**
 * An object to write any content to an Uint8Array.
 * @constructor
 * @param {number} length The length of the array.
 */
var Uint8ArrayWriter = function(length) {
    this.data = new Uint8Array(length);
    this.index = 0;
};
Uint8ArrayWriter.prototype = {
    /**
     * Append any content to the current array.
     * @param {Object} input the content to add.
     */
    append: function(input) {
        if (input.length !== 0) {
            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
            input = utils.transformTo("uint8array", input);
            this.data.set(input, this.index);
            this.index += input.length;
        }
    },
    /**
     * Finalize the construction an return the result.
     * @return {Uint8Array} the generated array.
     */
    finalize: function() {
        return this.data;
    }
};

module.exports = Uint8ArrayWriter;

},{"./utils":21}],20:[function(_dereq_,module,exports){
'use strict';

var utils = _dereq_('./utils');
var support = _dereq_('./support');
var nodeBuffer = _dereq_('./nodeBuffer');

/**
 * The following functions come from pako, from pako/lib/utils/strings
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new Array(256);
for (var i=0; i<256; i++) {
  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
}
_utf8len[254]=_utf8len[254]=1; // Invalid sequence start

// convert string to array (typed, when possible)
var string2buf = function (str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

    // count binary size
    for (m_pos = 0; m_pos < str_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if (((c & 0xfc00) === 0xd800) && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += (c < 0x80) ? 1 : ((c < 0x800) ? 2 : ((c < 0x10000) ? 3 : 4));
    }

    // allocate buffer
    if (support.uint8array) {
        buf = new Uint8Array(buf_len);
    } else {
        buf = new Array(buf_len);
    }

    // convert
    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
        } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | (c >>> 6);
            buf[i++] = 0x80 | (c & 0x3f);
        } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | (c >>> 12);
            buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        } else {
            /* four bytes */
            buf[i++] = 0xf0 | (c >>> 18);
            buf[i++] = 0x80 | ((c >>> 12) & 0x3f);
            buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        }
    }

    return buf;
};

// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var utf8border = function(buf, max) {
    var pos;

    max = max || buf.length;
    if (max > buf.length) { max = buf.length; }

    // go back from last position, until start of sequence found
    pos = max-1;
    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

    // Fuckup - very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) { return max; }

    // If we came to start of buffer - that means vuffer is too small,
    // return max too.
    if (pos === 0) { return max; }

    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

// convert array to string
var buf2string = function (buf) {
    var str, i, out, c, c_len;
    var len = buf.length;

    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len*2);

    for (out=0, i=0; i<len;) {
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) { utf16buf[out++] = c; continue; }

        c_len = _utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }

        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while (c_len > 1 && i < len) {
            c = (c << 6) | (buf[i++] & 0x3f);
            c_len--;
        }

        // terminated by end of string?
        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

        if (c < 0x10000) {
            utf16buf[out++] = c;
        } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
        }
    }

    // shrinkBuf(utf16buf, out)
    if (utf16buf.length !== out) {
        if(utf16buf.subarray) {
            utf16buf = utf16buf.subarray(0, out);
        } else {
            utf16buf.length = out;
        }
    }

    // return String.fromCharCode.apply(null, utf16buf);
    return utils.applyFromCharCode(utf16buf);
};


// That's all for the pako functions.


/**
 * Transform a javascript string into an array (typed if possible) of bytes,
 * UTF-8 encoded.
 * @param {String} str the string to encode
 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
 */
exports.utf8encode = function utf8encode(str) {
    if (support.nodebuffer) {
        return nodeBuffer(str, "utf-8");
    }

    return string2buf(str);
};


/**
 * Transform a bytes array (or a representation) representing an UTF-8 encoded
 * string into a javascript string.
 * @param {Array|Uint8Array|Buffer} buf the data de decode
 * @return {String} the decoded string.
 */
exports.utf8decode = function utf8decode(buf) {
    if (support.nodebuffer) {
        return utils.transformTo("nodebuffer", buf).toString("utf-8");
    }

    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);

    // return buf2string(buf);
    // Chrome prefers to work with "small" chunks of data
    // for the method buf2string.
    // Firefox and Chrome has their own shortcut, IE doesn't seem to really care.
    var result = [], k = 0, len = buf.length, chunk = 65536;
    while (k < len) {
        var nextBoundary = utf8border(buf, Math.min(k + chunk, len));
        if (support.uint8array) {
            result.push(buf2string(buf.subarray(k, nextBoundary)));
        } else {
            result.push(buf2string(buf.slice(k, nextBoundary)));
        }
        k = nextBoundary;
    }
    return result.join("");

};
// vim: set shiftwidth=4 softtabstop=4:

},{"./nodeBuffer":11,"./support":17,"./utils":21}],21:[function(_dereq_,module,exports){
'use strict';
var support = _dereq_('./support');
var compressions = _dereq_('./compressions');
var nodeBuffer = _dereq_('./nodeBuffer');
/**
 * Convert a string to a "binary string" : a string containing only char codes between 0 and 255.
 * @param {string} str the string to transform.
 * @return {String} the binary string.
 */
exports.string2binary = function(str) {
    var result = "";
    for (var i = 0; i < str.length; i++) {
        result += String.fromCharCode(str.charCodeAt(i) & 0xff);
    }
    return result;
};
exports.arrayBuffer2Blob = function(buffer) {
    exports.checkSupport("blob");

    try {
        // Blob constructor
        return new Blob([buffer], {
            type: "application/zip"
        });
    }
    catch (e) {

        try {
            // deprecated, browser only, old way
            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
            var builder = new Builder();
            builder.append(buffer);
            return builder.getBlob('application/zip');
        }
        catch (e) {

            // well, fuck ?!
            throw new Error("Bug : can't construct the Blob.");
        }
    }


};
/**
 * The identity function.
 * @param {Object} input the input.
 * @return {Object} the same input.
 */
function identity(input) {
    return input;
}

/**
 * Fill in an array with a string.
 * @param {String} str the string to use.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
 */
function stringToArrayLike(str, array) {
    for (var i = 0; i < str.length; ++i) {
        array[i] = str.charCodeAt(i) & 0xFF;
    }
    return array;
}

/**
 * Transform an array-like object to a string.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
 * @return {String} the result.
 */
function arrayLikeToString(array) {
    // Performances notes :
    // --------------------
    // String.fromCharCode.apply(null, array) is the fastest, see
    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
    // but the stack is limited (and we can get huge arrays !).
    //
    // result += String.fromCharCode(array[i]); generate too many strings !
    //
    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
    var chunk = 65536;
    var result = [],
        len = array.length,
        type = exports.getTypeOf(array),
        k = 0,
        canUseApply = true;
      try {
         switch(type) {
            case "uint8array":
               String.fromCharCode.apply(null, new Uint8Array(0));
               break;
            case "nodebuffer":
               String.fromCharCode.apply(null, nodeBuffer(0));
               break;
         }
      } catch(e) {
         canUseApply = false;
      }

      // no apply : slow and painful algorithm
      // default browser on android 4.*
      if (!canUseApply) {
         var resultStr = "";
         for(var i = 0; i < array.length;i++) {
            resultStr += String.fromCharCode(array[i]);
         }
    return resultStr;
    }
    while (k < len && chunk > 1) {
        try {
            if (type === "array" || type === "nodebuffer") {
                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
            }
            else {
                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
            }
            k += chunk;
        }
        catch (e) {
            chunk = Math.floor(chunk / 2);
        }
    }
    return result.join("");
}

exports.applyFromCharCode = arrayLikeToString;


/**
 * Copy the data from an array-like to an other array-like.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
 */
function arrayLikeToArrayLike(arrayFrom, arrayTo) {
    for (var i = 0; i < arrayFrom.length; i++) {
        arrayTo[i] = arrayFrom[i];
    }
    return arrayTo;
}

// a matrix containing functions to transform everything into everything.
var transform = {};

// string to ?
transform["string"] = {
    "string": identity,
    "array": function(input) {
        return stringToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["string"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return stringToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": function(input) {
        return stringToArrayLike(input, nodeBuffer(input.length));
    }
};

// array to ?
transform["array"] = {
    "string": arrayLikeToString,
    "array": identity,
    "arraybuffer": function(input) {
        return (new Uint8Array(input)).buffer;
    },
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodeBuffer(input);
    }
};

// arraybuffer to ?
transform["arraybuffer"] = {
    "string": function(input) {
        return arrayLikeToString(new Uint8Array(input));
    },
    "array": function(input) {
        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
    },
    "arraybuffer": identity,
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodeBuffer(new Uint8Array(input));
    }
};

// uint8array to ?
transform["uint8array"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return input.buffer;
    },
    "uint8array": identity,
    "nodebuffer": function(input) {
        return nodeBuffer(input);
    }
};

// nodebuffer to ?
transform["nodebuffer"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["nodebuffer"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": identity
};

/**
 * Transform an input into any type.
 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
 * If no output type is specified, the unmodified input will be returned.
 * @param {String} outputType the output type.
 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
 * @throws {Error} an Error if the browser doesn't support the requested output type.
 */
exports.transformTo = function(outputType, input) {
    if (!input) {
        // undefined, null, etc
        // an empty string won't harm.
        input = "";
    }
    if (!outputType) {
        return input;
    }
    exports.checkSupport(outputType);
    var inputType = exports.getTypeOf(input);
    var result = transform[inputType][outputType](input);
    return result;
};

/**
 * Return the type of the input.
 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
 * @param {Object} input the input to identify.
 * @return {String} the (lowercase) type of the input.
 */
exports.getTypeOf = function(input) {
    if (typeof input === "string") {
        return "string";
    }
    if (Object.prototype.toString.call(input) === "[object Array]") {
        return "array";
    }
    if (support.nodebuffer && nodeBuffer.test(input)) {
        return "nodebuffer";
    }
    if (support.uint8array && input instanceof Uint8Array) {
        return "uint8array";
    }
    if (support.arraybuffer && input instanceof ArrayBuffer) {
        return "arraybuffer";
    }
};

/**
 * Throw an exception if the type is not supported.
 * @param {String} type the type to check.
 * @throws {Error} an Error if the browser doesn't support the requested type.
 */
exports.checkSupport = function(type) {
    var supported = support[type.toLowerCase()];
    if (!supported) {
        throw new Error(type + " is not supported by this browser");
    }
};
exports.MAX_VALUE_16BITS = 65535;
exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1

/**
 * Prettify a string read as binary.
 * @param {string} str the string to prettify.
 * @return {string} a pretty string.
 */
exports.pretty = function(str) {
    var res = '',
        code, i;
    for (i = 0; i < (str || "").length; i++) {
        code = str.charCodeAt(i);
        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
    }
    return res;
};

/**
 * Find a compression registered in JSZip.
 * @param {string} compressionMethod the method magic to find.
 * @return {Object|null} the JSZip compression object, null if none found.
 */
exports.findCompression = function(compressionMethod) {
    for (var method in compressions) {
        if (!compressions.hasOwnProperty(method)) {
            continue;
        }
        if (compressions[method].magic === compressionMethod) {
            return compressions[method];
        }
    }
    return null;
};
/**
* Cross-window, cross-Node-context regular expression detection
* @param  {Object}  object Anything
* @return {Boolean}        true if the object is a regular expression,
* false otherwise
*/
exports.isRegExp = function (object) {
    return Object.prototype.toString.call(object) === "[object RegExp]";
};


},{"./compressions":3,"./nodeBuffer":11,"./support":17}],22:[function(_dereq_,module,exports){
'use strict';
var StringReader = _dereq_('./stringReader');
var NodeBufferReader = _dereq_('./nodeBufferReader');
var Uint8ArrayReader = _dereq_('./uint8ArrayReader');
var utils = _dereq_('./utils');
var sig = _dereq_('./signature');
var ZipEntry = _dereq_('./zipEntry');
var support = _dereq_('./support');
var jszipProto = _dereq_('./object');
//  class ZipEntries {{{
/**
 * All the entries in the zip file.
 * @constructor
 * @param {String|ArrayBuffer|Uint8Array} data the binary stream to load.
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntries(data, loadOptions) {
    this.files = [];
    this.loadOptions = loadOptions;
    if (data) {
        this.load(data);
    }
}
ZipEntries.prototype = {
    /**
     * Check that the reader is on the speficied signature.
     * @param {string} expectedSignature the expected signature.
     * @throws {Error} if it is an other signature.
     */
    checkSignature: function(expectedSignature) {
        var signature = this.reader.readString(4);
        if (signature !== expectedSignature) {
            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
        }
    },
    /**
     * Read the end of the central directory.
     */
    readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2);
        this.diskWithCentralDirStart = this.reader.readInt(2);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
        this.centralDirRecords = this.reader.readInt(2);
        this.centralDirSize = this.reader.readInt(4);
        this.centralDirOffset = this.reader.readInt(4);

        this.zipCommentLength = this.reader.readInt(2);
        // warning : the encoding depends of the system locale
        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
        // On a windows machine, this field is encoded with the localized windows code page.
        this.zipComment = this.reader.readString(this.zipCommentLength);
        // To get consistent behavior with the generation part, we will assume that
        // this is utf8 encoded.
        this.zipComment = jszipProto.utf8decode(this.zipComment);
    },
    /**
     * Read the end of the Zip 64 central directory.
     * Not merged with the method readEndOfCentral :
     * The end of central can coexist with its Zip64 brother,
     * I don't want to read the wrong number of bytes !
     */
    readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8);
        this.versionMadeBy = this.reader.readString(2);
        this.versionNeeded = this.reader.readInt(2);
        this.diskNumber = this.reader.readInt(4);
        this.diskWithCentralDirStart = this.reader.readInt(4);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
        this.centralDirRecords = this.reader.readInt(8);
        this.centralDirSize = this.reader.readInt(8);
        this.centralDirOffset = this.reader.readInt(8);

        this.zip64ExtensibleData = {};
        var extraDataSize = this.zip64EndOfCentralSize - 44,
            index = 0,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;
        while (index < extraDataSize) {
            extraFieldId = this.reader.readInt(2);
            extraFieldLength = this.reader.readInt(4);
            extraFieldValue = this.reader.readString(extraFieldLength);
            this.zip64ExtensibleData[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Read the end of the Zip 64 central directory locator.
     */
    readBlockZip64EndOfCentralLocator: function() {
        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
        this.disksCount = this.reader.readInt(4);
        if (this.disksCount > 1) {
            throw new Error("Multi-volumes zip are not supported");
        }
    },
    /**
     * Read the local files, based on the offset read in the central part.
     */
    readLocalFiles: function() {
        var i, file;
        for (i = 0; i < this.files.length; i++) {
            file = this.files[i];
            this.reader.setIndex(file.localHeaderOffset);
            this.checkSignature(sig.LOCAL_FILE_HEADER);
            file.readLocalPart(this.reader);
            file.handleUTF8();
        }
    },
    /**
     * Read the central directory.
     */
    readCentralDir: function() {
        var file;

        this.reader.setIndex(this.centralDirOffset);
        while (this.reader.readString(4) === sig.CENTRAL_FILE_HEADER) {
            file = new ZipEntry({
                zip64: this.zip64
            }, this.loadOptions);
            file.readCentralPart(this.reader);
            this.files.push(file);
        }
    },
    /**
     * Read the end of central directory.
     */
    readEndOfCentral: function() {
        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
        if (offset === -1) {
            throw new Error("Corrupted zip : can't find end of central directory");
        }
        this.reader.setIndex(offset);
        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
        this.readBlockEndOfCentral();


        /* extract from the zip spec :
            4)  If one of the fields in the end of central directory
                record is too small to hold required data, the field
                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
                ZIP64 format record should be created.
            5)  The end of central directory record and the
                Zip64 end of central directory locator record must
                reside on the same disk when splitting or spanning
                an archive.
         */
        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
            this.zip64 = true;

            /*
            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
            all numbers as 64-bit double precision IEEE 754 floating point numbers.
            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
            */

            // should look for a zip64 EOCD locator
            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            if (offset === -1) {
                throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
            }
            this.reader.setIndex(offset);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            this.readBlockZip64EndOfCentralLocator();

            // now the zip64 EOCD record
            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
            this.readBlockZip64EndOfCentral();
        }
    },
    prepareReader: function(data) {
        var type = utils.getTypeOf(data);
        if (type === "string" && !support.uint8array) {
            this.reader = new StringReader(data, this.loadOptions.optimizedBinaryString);
        }
        else if (type === "nodebuffer") {
            this.reader = new NodeBufferReader(data);
        }
        else {
            this.reader = new Uint8ArrayReader(utils.transformTo("uint8array", data));
        }
    },
    /**
     * Read a zip file and create ZipEntries.
     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
     */
    load: function(data) {
        this.prepareReader(data);
        this.readEndOfCentral();
        this.readCentralDir();
        this.readLocalFiles();
    }
};
// }}} end of ZipEntries
module.exports = ZipEntries;

},{"./nodeBufferReader":12,"./object":13,"./signature":14,"./stringReader":15,"./support":17,"./uint8ArrayReader":18,"./utils":21,"./zipEntry":23}],23:[function(_dereq_,module,exports){
'use strict';
var StringReader = _dereq_('./stringReader');
var utils = _dereq_('./utils');
var CompressedObject = _dereq_('./compressedObject');
var jszipProto = _dereq_('./object');
// class ZipEntry {{{
/**
 * An entry in the zip file.
 * @constructor
 * @param {Object} options Options of the current file.
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntry(options, loadOptions) {
    this.options = options;
    this.loadOptions = loadOptions;
}
ZipEntry.prototype = {
    /**
     * say if the file is encrypted.
     * @return {boolean} true if the file is encrypted, false otherwise.
     */
    isEncrypted: function() {
        // bit 1 is set
        return (this.bitFlag & 0x0001) === 0x0001;
    },
    /**
     * say if the file has utf-8 filename/comment.
     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
     */
    useUTF8: function() {
        // bit 11 is set
        return (this.bitFlag & 0x0800) === 0x0800;
    },
    /**
     * Prepare the function used to generate the compressed content from this ZipFile.
     * @param {DataReader} reader the reader to use.
     * @param {number} from the offset from where we should read the data.
     * @param {number} length the length of the data to read.
     * @return {Function} the callback to get the compressed content (the type depends of the DataReader class).
     */
    prepareCompressedContent: function(reader, from, length) {
        return function() {
            var previousIndex = reader.index;
            reader.setIndex(from);
            var compressedFileData = reader.readData(length);
            reader.setIndex(previousIndex);

            return compressedFileData;
        };
    },
    /**
     * Prepare the function used to generate the uncompressed content from this ZipFile.
     * @param {DataReader} reader the reader to use.
     * @param {number} from the offset from where we should read the data.
     * @param {number} length the length of the data to read.
     * @param {JSZip.compression} compression the compression used on this file.
     * @param {number} uncompressedSize the uncompressed size to expect.
     * @return {Function} the callback to get the uncompressed content (the type depends of the DataReader class).
     */
    prepareContent: function(reader, from, length, compression, uncompressedSize) {
        return function() {

            var compressedFileData = utils.transformTo(compression.uncompressInputType, this.getCompressedContent());
            var uncompressedFileData = compression.uncompress(compressedFileData);

            if (uncompressedFileData.length !== uncompressedSize) {
                throw new Error("Bug : uncompressed data size mismatch");
            }

            return uncompressedFileData;
        };
    },
    /**
     * Read the local part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readLocalPart: function(reader) {
        var compression, localExtraFieldsLength;

        // we already know everything from the central dir !
        // If the central dir data are false, we are doomed.
        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
        // The less data we get here, the more reliable this should be.
        // Let's skip the whole header and dash to the data !
        reader.skip(22);
        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
        // Strangely, the filename here is OK.
        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
        // the internet.
        //
        // I think I see the logic here : the central directory is used to display
        // content and the local directory is used to extract the files. Mixing / and \
        // may be used to display \ to windows users and use / when extracting the files.
        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
        this.fileNameLength = reader.readInt(2);
        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
        this.fileName = reader.readString(this.fileNameLength);
        reader.skip(localExtraFieldsLength);

        if (this.compressedSize == -1 || this.uncompressedSize == -1) {
            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize == -1 || uncompressedSize == -1)");
        }

        compression = utils.findCompression(this.compressionMethod);
        if (compression === null) { // no compression found
            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + this.fileName + ")");
        }
        this.decompressed = new CompressedObject();
        this.decompressed.compressedSize = this.compressedSize;
        this.decompressed.uncompressedSize = this.uncompressedSize;
        this.decompressed.crc32 = this.crc32;
        this.decompressed.compressionMethod = this.compressionMethod;
        this.decompressed.getCompressedContent = this.prepareCompressedContent(reader, reader.index, this.compressedSize, compression);
        this.decompressed.getContent = this.prepareContent(reader, reader.index, this.compressedSize, compression, this.uncompressedSize);

        // we need to compute the crc32...
        if (this.loadOptions.checkCRC32) {
            this.decompressed = utils.transformTo("string", this.decompressed.getContent());
            if (jszipProto.crc32(this.decompressed) !== this.crc32) {
                throw new Error("Corrupted zip : CRC32 mismatch");
            }
        }
    },

    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readCentralPart: function(reader) {
        this.versionMadeBy = reader.readString(2);
        this.versionNeeded = reader.readInt(2);
        this.bitFlag = reader.readInt(2);
        this.compressionMethod = reader.readString(2);
        this.date = reader.readDate();
        this.crc32 = reader.readInt(4);
        this.compressedSize = reader.readInt(4);
        this.uncompressedSize = reader.readInt(4);
        this.fileNameLength = reader.readInt(2);
        this.extraFieldsLength = reader.readInt(2);
        this.fileCommentLength = reader.readInt(2);
        this.diskNumberStart = reader.readInt(2);
        this.internalFileAttributes = reader.readInt(2);
        this.externalFileAttributes = reader.readInt(4);
        this.localHeaderOffset = reader.readInt(4);

        if (this.isEncrypted()) {
            throw new Error("Encrypted zip are not supported");
        }

        this.fileName = reader.readString(this.fileNameLength);
        this.readExtraFields(reader);
        this.parseZIP64ExtraField(reader);
        this.fileComment = reader.readString(this.fileCommentLength);

        // warning, this is true only for zip with madeBy == DOS (plateform dependent feature)
        this.dir = this.externalFileAttributes & 0x00000010 ? true : false;
    },
    /**
     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
     * @param {DataReader} reader the reader to use.
     */
    parseZIP64ExtraField: function(reader) {

        if (!this.extraFields[0x0001]) {
            return;
        }

        // should be something, preparing the extra reader
        var extraReader = new StringReader(this.extraFields[0x0001].value);

        // I really hope that these 64bits integer can fit in 32 bits integer, because js
        // won't let us have more.
        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
            this.uncompressedSize = extraReader.readInt(8);
        }
        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
            this.compressedSize = extraReader.readInt(8);
        }
        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
            this.localHeaderOffset = extraReader.readInt(8);
        }
        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
            this.diskNumberStart = extraReader.readInt(4);
        }
    },
    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readExtraFields: function(reader) {
        var start = reader.index,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;

        this.extraFields = this.extraFields || {};

        while (reader.index < start + this.extraFieldsLength) {
            extraFieldId = reader.readInt(2);
            extraFieldLength = reader.readInt(2);
            extraFieldValue = reader.readString(extraFieldLength);

            this.extraFields[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Apply an UTF8 transformation if needed.
     */
    handleUTF8: function() {
        if (this.useUTF8()) {
            this.fileName = jszipProto.utf8decode(this.fileName);
            this.fileComment = jszipProto.utf8decode(this.fileComment);
        } else {
            var upath = this.findExtraFieldUnicodePath();
            if (upath !== null) {
                this.fileName = upath;
            }
            var ucomment = this.findExtraFieldUnicodeComment();
            if (ucomment !== null) {
                this.fileComment = ucomment;
            }
        }
    },

    /**
     * Find the unicode path declared in the extra field, if any.
     * @return {String} the unicode path, null otherwise.
     */
    findExtraFieldUnicodePath: function() {
        var upathField = this.extraFields[0x7075];
        if (upathField) {
            var extraReader = new StringReader(upathField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the filename changed, this field is out of date.
            if (jszipProto.crc32(this.fileName) !== extraReader.readInt(4)) {
                return null;
            }

            return jszipProto.utf8decode(extraReader.readString(upathField.length - 5));
        }
        return null;
    },

    /**
     * Find the unicode comment declared in the extra field, if any.
     * @return {String} the unicode comment, null otherwise.
     */
    findExtraFieldUnicodeComment: function() {
        var ucommentField = this.extraFields[0x6375];
        if (ucommentField) {
            var extraReader = new StringReader(ucommentField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the comment changed, this field is out of date.
            if (jszipProto.crc32(this.fileComment) !== extraReader.readInt(4)) {
                return null;
            }

            return jszipProto.utf8decode(extraReader.readString(ucommentField.length - 5));
        }
        return null;
    }
};
module.exports = ZipEntry;

},{"./compressedObject":2,"./object":13,"./stringReader":15,"./utils":21}],24:[function(_dereq_,module,exports){
// Top level file is just a mixin of submodules & constants
'use strict';

var assign    = _dereq_('./lib/utils/common').assign;

var deflate   = _dereq_('./lib/deflate');
var inflate   = _dereq_('./lib/inflate');
var constants = _dereq_('./lib/zlib/constants');

var pako = {};

assign(pako, deflate, inflate, constants);

module.exports = pako;
},{"./lib/deflate":25,"./lib/inflate":26,"./lib/utils/common":27,"./lib/zlib/constants":30}],25:[function(_dereq_,module,exports){
'use strict';


var zlib_deflate = _dereq_('./zlib/deflate.js');
var utils = _dereq_('./utils/common');
var strings = _dereq_('./utils/strings');
var msg = _dereq_('./zlib/messages');
var zstream = _dereq_('./zlib/zstream');


/* Public constants ==========================================================*/
/* ===========================================================================*/

var Z_NO_FLUSH      = 0;
var Z_FINISH        = 4;

var Z_OK            = 0;
var Z_STREAM_END    = 1;

var Z_DEFAULT_COMPRESSION = -1;

var Z_DEFAULT_STRATEGY    = 0;

var Z_DEFLATED  = 8;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overriden.
 **/

/**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
var Deflate = function(options) {

  this.options = utils.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY,
    to: ''
  }, options || {});

  var opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new zstream();
  this.strm.avail_out = 0;

  var status = zlib_deflate.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK) {
    throw new Error(msg[status]);
  }

  if (opt.header) {
    zlib_deflate.deflateSetHeader(this.strm, opt.header);
  }
};

/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|String): input data. Strings will be converted to
 *   utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That flush internal pending buffers and call
 * [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate.prototype.push = function(data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;

  if (this.ended) { return false; }

  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */

    if (status !== Z_STREAM_END && status !== Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.avail_out === 0 || (strm.avail_in === 0 && _mode === Z_FINISH)) {
      if (this.options.to === 'string') {
        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
      } else {
        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
      }
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);

  // Finalize on the last chunk.
  if (_mode === Z_FINISH) {
    status = zlib_deflate.deflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === Z_OK;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate.prototype.onData = function(chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that input stream complete
 * or error happenned. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate.prototype.onEnd = function(status) {
  // On success - join
  if (status === Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate alrorythm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate(input, options) {
  var deflator = new Deflate(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return deflate(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate(input, options);
}


exports.Deflate = Deflate;
exports.deflate = deflate;
exports.deflateRaw = deflateRaw;
exports.gzip = gzip;
},{"./utils/common":27,"./utils/strings":28,"./zlib/deflate.js":32,"./zlib/messages":37,"./zlib/zstream":39}],26:[function(_dereq_,module,exports){
'use strict';


var zlib_inflate = _dereq_('./zlib/inflate.js');
var utils = _dereq_('./utils/common');
var strings = _dereq_('./utils/strings');
var c = _dereq_('./zlib/constants');
var msg = _dereq_('./zlib/messages');
var zstream = _dereq_('./zlib/zstream');
var gzheader = _dereq_('./zlib/gzheader');


/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/

/* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overriden.
 **/

/**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/

/**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/

/**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/


/**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/
var Inflate = function(options) {

  this.options = utils.assign({
    chunkSize: 16384,
    windowBits: 0,
    to: ''
  }, options || {});

  var opt = this.options;

  // Force window size for `raw` data, if not set directly,
  // because we have no header for autodetect.
  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) { opt.windowBits = -15; }
  }

  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
      !(options && options.windowBits)) {
    opt.windowBits += 32;
  }

  // Gzip header has no info about windows size, we can do autodetect only
  // for deflate. So, if window size not set, force it to max when gzip possible
  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
    // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm   = new zstream();
  this.strm.avail_out = 0;

  var status  = zlib_inflate.inflateInit2(
    this.strm,
    opt.windowBits
  );

  if (status !== c.Z_OK) {
    throw new Error(msg[status]);
  }

  this.header = new gzheader();

  zlib_inflate.inflateGetHeader(this.strm, this.header);
};

/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That flush internal pending buffers and call
 * [[Inflate#onEnd]].
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Inflate.prototype.push = function(data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;
  var next_out_utf8, tail, utf8str;

  if (this.ended) { return false; }
  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // Only binary strings can be decompressed on practice
    strm.input = strings.binstring2buf(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */

    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }

    if (strm.next_out) {
      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && _mode === c.Z_FINISH)) {

        if (this.options.to === 'string') {

          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

          tail = strm.next_out - next_out_utf8;
          utf8str = strings.buf2string(strm.output, next_out_utf8);

          // move tail
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }

          this.onData(utf8str);

        } else {
          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
        }
      }
    }
  } while ((strm.avail_in > 0) && status !== c.Z_STREAM_END);

  if (status === c.Z_STREAM_END) {
    _mode = c.Z_FINISH;
  }
  // Finalize on the last chunk.
  if (_mode === c.Z_FINISH) {
    status = zlib_inflate.inflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === c.Z_OK;
  }

  return true;
};


/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Inflate.prototype.onData = function(chunk) {
  this.chunks.push(chunk);
};


/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell inflate that input stream complete
 * or error happenned. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Inflate.prototype.onEnd = function(status) {
  // On success - join
  if (status === c.Z_OK) {
    if (this.options.to === 'string') {
      // Glue & convert here, until we teach pako to send
      // utf8 alligned strings to onData
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/
function inflate(input, options) {
  var inflator = new Inflate(options);

  inflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (inflator.err) { throw inflator.msg; }

  return inflator.result;
}


/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function inflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return inflate(input, options);
}


/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/


exports.Inflate = Inflate;
exports.inflate = inflate;
exports.inflateRaw = inflateRaw;
exports.ungzip  = inflate;

},{"./utils/common":27,"./utils/strings":28,"./zlib/constants":30,"./zlib/gzheader":33,"./zlib/inflate.js":35,"./zlib/messages":37,"./zlib/zstream":39}],27:[function(_dereq_,module,exports){
'use strict';


var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');


exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof(source) !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (source.hasOwnProperty(p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs+len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for(var i=0; i<len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function(chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i=0, l=chunks.length; i<l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i=0, l=chunks.length; i<l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for(var i=0; i<len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function(chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);
},{}],28:[function(_dereq_,module,exports){
// String encode/decode helpers
'use strict';


var utils = _dereq_('./common');


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safary
//
var STR_APPLY_OK = true;
var STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, [0]); } catch(__) { STR_APPLY_OK = false; }
try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch(__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new utils.Buf8(256);
for (var i=0; i<256; i++) {
  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
}
_utf8len[254]=_utf8len[254]=1; // Invalid sequence start


// convert string to array (typed, when possible)
exports.string2buf = function (str) {
  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
      c2 = str.charCodeAt(m_pos+1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new utils.Buf8(buf_len);

  // convert
  for (i=0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
      c2 = str.charCodeAt(m_pos+1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper (used in 2 places)
function buf2binstring(buf, len) {
  // use fallback for big arrays to avoid stack overflow
  if (len < 65537) {
    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
    }
  }

  var result = '';
  for(var i=0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
}


// Convert byte array to binary string
exports.buf2binstring = function(buf) {
  return buf2binstring(buf, buf.length);
};


// Convert binary string (typed, when possible)
exports.binstring2buf = function(str) {
  var buf = new utils.Buf8(str.length);
  for(var i=0, len=buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};


// convert array to string
exports.buf2string = function (buf, max) {
  var i, out, c, c_len;
  var len = max || buf.length;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  var utf16buf = new Array(len*2);

  for (out=0, i=0; i<len;) {
    c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
exports.utf8border = function(buf, max) {
  var pos;

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  pos = max-1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Fuckup - very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means vuffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

},{"./common":27}],29:[function(_dereq_,module,exports){
'use strict';

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It doesn't worth to make additional optimizationa as in original.
// Small size is preferable.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0
    , s2 = ((adler >>> 16) & 0xffff) |0
    , n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;
},{}],30:[function(_dereq_,module,exports){
module.exports = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
},{}],31:[function(_dereq_,module,exports){
'use strict';

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.


// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for(var n =0; n < 256; n++){
    c = n;
    for(var k =0; k < 8; k++){
      c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable
    , end = pos + len;

  crc = crc ^ (-1);

  for (var i = pos; i < end; i++ ) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;
},{}],32:[function(_dereq_,module,exports){
'use strict';

var utils   = _dereq_('../utils/common');
var trees   = _dereq_('./trees');
var adler32 = _dereq_('./adler32');
var crc32   = _dereq_('./crc32');
var msg   = _dereq_('./messages');

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2*L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only (s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH-1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH-1)) ? s.strstart : MIN_MATCH-1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH-1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size-MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH-1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1- s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length-1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH-1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart-1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart-1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH-1 ? s.strstart : MIN_MATCH-1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
var Config = function (good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
};

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2*D_CODES+1) * 2);
  this.bl_tree    = new utils.Buf16((2*BL_CODES+1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS+1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2*L_CODES+1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2*L_CODES+1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  s.d_buf = s.lit_bufsize >> 1;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
                );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg){
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}

/* =========================================================================
 * Copy the source state to the destination state
 */
//function deflateCopy(dest, source) {
//
//}

exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/
},{"../utils/common":27,"./adler32":29,"./crc32":31,"./messages":37,"./trees":38}],33:[function(_dereq_,module,exports){
'use strict';


function GZheader() {
  /* true if compressed data believed to be text */
  this.text       = 0;
  /* modification time */
  this.time       = 0;
  /* extra flags (not used when writing a gzip file) */
  this.xflags     = 0;
  /* operating system */
  this.os         = 0;
  /* pointer to extra field or Z_NULL if none */
  this.extra      = null;
  /* extra field length (valid if extra != Z_NULL) */
  this.extra_len  = 0; // Actually, we don't need it in JS,
                       // but leave for few code modifications

  //
  // Setup limits is not necessary because in js we should not preallocate memory
  // for inflate use constant limit in 65536 bytes
  //

  /* space at extra (only when reading header) */
  // this.extra_max  = 0;
  /* pointer to zero-terminated file name or Z_NULL */
  this.name       = '';
  /* space at name (only when reading header) */
  // this.name_max   = 0;
  /* pointer to zero-terminated comment or Z_NULL */
  this.comment    = '';
  /* space at comment (only when reading header) */
  // this.comm_max   = 0;
  /* true if there was or will be a header crc */
  this.hcrc       = 0;
  /* true when done reading gzip header (not used when writing a gzip file) */
  this.done       = false;
}

module.exports = GZheader;
},{}],34:[function(_dereq_,module,exports){
'use strict';

// See state defs from inflate.js
var BAD = 30;       /* got a data error -- remain here until reset */
var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
module.exports = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  var window;                 /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }

// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};

},{}],35:[function(_dereq_,module,exports){
'use strict';


var utils = _dereq_('../utils/common');
var adler32 = _dereq_('./adler32');
var crc32   = _dereq_('./crc32');
var inflate_fast = _dereq_('./inffast');
var inflate_table = _dereq_('./inftrees');

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function ZSWAP32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils.Buf32(512);
    distfix = new utils.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, {bits: 9});

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, {bits: 5});

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils.arraySet(state.window,src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils.arraySet(state.window,src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils.arraySet(state.window,src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
    case HEAD:
      if (state.wrap === 0) {
        state.mode = TYPEDO;
        break;
      }
      //=== NEEDBITS(16);
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//

        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = FLAGS;
        break;
      }
      state.flags = 0;           /* expect zlib header */
      if (state.head) {
        state.head.done = false;
      }
      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
        strm.msg = 'incorrect header check';
        state.mode = BAD;
        break;
      }
      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
        strm.msg = 'unknown compression method';
        state.mode = BAD;
        break;
      }
      //--- DROPBITS(4) ---//
      hold >>>= 4;
      bits -= 4;
      //---//
      len = (hold & 0x0f)/*BITS(4)*/ + 8;
      if (state.wbits === 0) {
        state.wbits = len;
      }
      else if (len > state.wbits) {
        strm.msg = 'invalid window size';
        state.mode = BAD;
        break;
      }
      state.dmax = 1 << len;
      //Tracev((stderr, "inflate:   zlib header ok\n"));
      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
      state.mode = hold & 0x200 ? DICTID : TYPE;
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      break;
    case FLAGS:
      //=== NEEDBITS(16); */
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.flags = hold;
      if ((state.flags & 0xff) !== Z_DEFLATED) {
        strm.msg = 'unknown compression method';
        state.mode = BAD;
        break;
      }
      if (state.flags & 0xe000) {
        strm.msg = 'unknown header flags set';
        state.mode = BAD;
        break;
      }
      if (state.head) {
        state.head.text = ((hold >> 8) & 1);
      }
      if (state.flags & 0x0200) {
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = TIME;
      /* falls through */
    case TIME:
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if (state.head) {
        state.head.time = hold;
      }
      if (state.flags & 0x0200) {
        //=== CRC4(state.check, hold)
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        hbuf[2] = (hold >>> 16) & 0xff;
        hbuf[3] = (hold >>> 24) & 0xff;
        state.check = crc32(state.check, hbuf, 4, 0);
        //===
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = OS;
      /* falls through */
    case OS:
      //=== NEEDBITS(16); */
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if (state.head) {
        state.head.xflags = (hold & 0xff);
        state.head.os = (hold >> 8);
      }
      if (state.flags & 0x0200) {
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = EXLEN;
      /* falls through */
    case EXLEN:
      if (state.flags & 0x0400) {
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.length = hold;
        if (state.head) {
          state.head.extra_len = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
      }
      else if (state.head) {
        state.head.extra = null/*Z_NULL*/;
      }
      state.mode = EXTRA;
      /* falls through */
    case EXTRA:
      if (state.flags & 0x0400) {
        copy = state.length;
        if (copy > have) { copy = have; }
        if (copy) {
          if (state.head) {
            len = state.head.extra_len - state.length;
            if (!state.head.extra) {
              // Use untyped array for more conveniend processing later
              state.head.extra = new Array(state.head.extra_len);
            }
            utils.arraySet(
              state.head.extra,
              input,
              next,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              copy,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              len
            );
            //zmemcpy(state.head.extra + len, next,
            //        len + copy > state.head.extra_max ?
            //        state.head.extra_max - len : copy);
          }
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          state.length -= copy;
        }
        if (state.length) { break inf_leave; }
      }
      state.length = 0;
      state.mode = NAME;
      /* falls through */
    case NAME:
      if (state.flags & 0x0800) {
        if (have === 0) { break inf_leave; }
        copy = 0;
        do {
          // TODO: 2 or 1 bytes?
          len = input[next + copy++];
          /* use constant limit because in js we should not preallocate memory */
          if (state.head && len &&
              (state.length < 65536 /*state.head.name_max*/)) {
            state.head.name += String.fromCharCode(len);
          }
        } while (len && copy < have);

        if (state.flags & 0x0200) {
          state.check = crc32(state.check, input, copy, next);
        }
        have -= copy;
        next += copy;
        if (len) { break inf_leave; }
      }
      else if (state.head) {
        state.head.name = null;
      }
      state.length = 0;
      state.mode = COMMENT;
      /* falls through */
    case COMMENT:
      if (state.flags & 0x1000) {
        if (have === 0) { break inf_leave; }
        copy = 0;
        do {
          len = input[next + copy++];
          /* use constant limit because in js we should not preallocate memory */
          if (state.head && len &&
              (state.length < 65536 /*state.head.comm_max*/)) {
            state.head.comment += String.fromCharCode(len);
          }
        } while (len && copy < have);
        if (state.flags & 0x0200) {
          state.check = crc32(state.check, input, copy, next);
        }
        have -= copy;
        next += copy;
        if (len) { break inf_leave; }
      }
      else if (state.head) {
        state.head.comment = null;
      }
      state.mode = HCRC;
      /* falls through */
    case HCRC:
      if (state.flags & 0x0200) {
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (hold !== (state.check & 0xffff)) {
          strm.msg = 'header crc mismatch';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
      }
      if (state.head) {
        state.head.hcrc = ((state.flags >> 9) & 1);
        state.head.done = true;
      }
      strm.adler = state.check = 0 /*crc32(0L, Z_NULL, 0)*/;
      state.mode = TYPE;
      break;
    case DICTID:
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      strm.adler = state.check = ZSWAP32(hold);
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = DICT;
      /* falls through */
    case DICT:
      if (state.havedict === 0) {
        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---
        return Z_NEED_DICT;
      }
      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
      state.mode = TYPE;
      /* falls through */
    case TYPE:
      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case TYPEDO:
      if (state.last) {
        //--- BYTEBITS() ---//
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        state.mode = CHECK;
        break;
      }
      //=== NEEDBITS(3); */
      while (bits < 3) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.last = (hold & 0x01)/*BITS(1)*/;
      //--- DROPBITS(1) ---//
      hold >>>= 1;
      bits -= 1;
      //---//

      switch ((hold & 0x03)/*BITS(2)*/) {
      case 0:                             /* stored block */
        //Tracev((stderr, "inflate:     stored block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = STORED;
        break;
      case 1:                             /* fixed block */
        fixedtables(state);
        //Tracev((stderr, "inflate:     fixed codes block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = LEN_;             /* decode codes */
        if (flush === Z_TREES) {
          //--- DROPBITS(2) ---//
          hold >>>= 2;
          bits -= 2;
          //---//
          break inf_leave;
        }
        break;
      case 2:                             /* dynamic block */
        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = TABLE;
        break;
      case 3:
        strm.msg = 'invalid block type';
        state.mode = BAD;
      }
      //--- DROPBITS(2) ---//
      hold >>>= 2;
      bits -= 2;
      //---//
      break;
    case STORED:
      //--- BYTEBITS() ---// /* go to byte boundary */
      hold >>>= bits & 7;
      bits -= bits & 7;
      //---//
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
        strm.msg = 'invalid stored block lengths';
        state.mode = BAD;
        break;
      }
      state.length = hold & 0xffff;
      //Tracev((stderr, "inflate:       stored length %u\n",
      //        state.length));
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = COPY_;
      if (flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case COPY_:
      state.mode = COPY;
      /* falls through */
    case COPY:
      copy = state.length;
      if (copy) {
        if (copy > have) { copy = have; }
        if (copy > left) { copy = left; }
        if (copy === 0) { break inf_leave; }
        //--- zmemcpy(put, next, copy); ---
        utils.arraySet(output, input, next, copy, put);
        //---//
        have -= copy;
        next += copy;
        left -= copy;
        put += copy;
        state.length -= copy;
        break;
      }
      //Tracev((stderr, "inflate:       stored end\n"));
      state.mode = TYPE;
      break;
    case TABLE:
      //=== NEEDBITS(14); */
      while (bits < 14) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
      //--- DROPBITS(5) ---//
      hold >>>= 5;
      bits -= 5;
      //---//
      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
      //--- DROPBITS(5) ---//
      hold >>>= 5;
      bits -= 5;
      //---//
      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
      //--- DROPBITS(4) ---//
      hold >>>= 4;
      bits -= 4;
      //---//
//#ifndef PKZIP_BUG_WORKAROUND
      if (state.nlen > 286 || state.ndist > 30) {
        strm.msg = 'too many length or distance symbols';
        state.mode = BAD;
        break;
      }
//#endif
      //Tracev((stderr, "inflate:       table sizes ok\n"));
      state.have = 0;
      state.mode = LENLENS;
      /* falls through */
    case LENLENS:
      while (state.have < state.ncode) {
        //=== NEEDBITS(3);
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
        //--- DROPBITS(3) ---//
        hold >>>= 3;
        bits -= 3;
        //---//
      }
      while (state.have < 19) {
        state.lens[order[state.have++]] = 0;
      }
      // We have separate tables & no pointers. 2 commented lines below not needed.
      //state.next = state.codes;
      //state.lencode = state.next;
      // Switch to use dynamic table
      state.lencode = state.lendyn;
      state.lenbits = 7;

      opts = {bits: state.lenbits};
      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
      state.lenbits = opts.bits;

      if (ret) {
        strm.msg = 'invalid code lengths set';
        state.mode = BAD;
        break;
      }
      //Tracev((stderr, "inflate:       code lengths ok\n"));
      state.have = 0;
      state.mode = CODELENS;
      /* falls through */
    case CODELENS:
      while (state.have < state.nlen + state.ndist) {
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_val < 16) {
          //--- DROPBITS(here.bits) ---//
          hold >>>= here_bits;
          bits -= here_bits;
          //---//
          state.lens[state.have++] = here_val;
        }
        else {
          if (here_val === 16) {
            //=== NEEDBITS(here.bits + 2);
            n = here_bits + 2;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            if (state.have === 0) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            len = state.lens[state.have - 1];
            copy = 3 + (hold & 0x03);//BITS(2);
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            //---//
          }
          else if (here_val === 17) {
            //=== NEEDBITS(here.bits + 3);
            n = here_bits + 3;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            len = 0;
            copy = 3 + (hold & 0x07);//BITS(3);
            //--- DROPBITS(3) ---//
            hold >>>= 3;
            bits -= 3;
            //---//
          }
          else {
            //=== NEEDBITS(here.bits + 7);
            n = here_bits + 7;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            len = 0;
            copy = 11 + (hold & 0x7f);//BITS(7);
            //--- DROPBITS(7) ---//
            hold >>>= 7;
            bits -= 7;
            //---//
          }
          if (state.have + copy > state.nlen + state.ndist) {
            strm.msg = 'invalid bit length repeat';
            state.mode = BAD;
            break;
          }
          while (copy--) {
            state.lens[state.have++] = len;
          }
        }
      }

      /* handle error breaks in while */
      if (state.mode === BAD) { break; }

      /* check for end-of-block code (better have one) */
      if (state.lens[256] === 0) {
        strm.msg = 'invalid code -- missing end-of-block';
        state.mode = BAD;
        break;
      }

      /* build code tables -- note: do not change the lenbits or distbits
         values here (9 and 6) without reading the comments in inftrees.h
         concerning the ENOUGH constants, which depend on those values */
      state.lenbits = 9;

      opts = {bits: state.lenbits};
      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
      // We have separate tables & no pointers. 2 commented lines below not needed.
      // state.next_index = opts.table_index;
      state.lenbits = opts.bits;
      // state.lencode = state.next;

      if (ret) {
        strm.msg = 'invalid literal/lengths set';
        state.mode = BAD;
        break;
      }

      state.distbits = 6;
      //state.distcode.copy(state.codes);
      // Switch to use dynamic table
      state.distcode = state.distdyn;
      opts = {bits: state.distbits};
      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
      // We have separate tables & no pointers. 2 commented lines below not needed.
      // state.next_index = opts.table_index;
      state.distbits = opts.bits;
      // state.distcode = state.next;

      if (ret) {
        strm.msg = 'invalid distances set';
        state.mode = BAD;
        break;
      }
      //Tracev((stderr, 'inflate:       codes ok\n'));
      state.mode = LEN_;
      if (flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case LEN_:
      state.mode = LEN;
      /* falls through */
    case LEN:
      if (have >= 6 && left >= 258) {
        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---
        inflate_fast(strm, _out);
        //--- LOAD() ---
        put = strm.next_out;
        output = strm.output;
        left = strm.avail_out;
        next = strm.next_in;
        input = strm.input;
        have = strm.avail_in;
        hold = state.hold;
        bits = state.bits;
        //---

        if (state.mode === TYPE) {
          state.back = -1;
        }
        break;
      }
      state.back = 0;
      for (;;) {
        here = state.lencode[hold & ((1 << state.lenbits) -1)];  /*BITS(state.lenbits)*/
        here_bits = here >>> 24;
        here_op = (here >>> 16) & 0xff;
        here_val = here & 0xffff;

        if (here_bits <= bits) { break; }
        //--- PULLBYTE() ---//
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
        //---//
      }
      if (here_op && (here_op & 0xf0) === 0) {
        last_bits = here_bits;
        last_op = here_op;
        last_val = here_val;
        for (;;) {
          here = state.lencode[last_val +
                  ((hold & ((1 << (last_bits + last_op)) -1))/*BITS(last.bits + last.op)*/ >> last_bits)];
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((last_bits + here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        //--- DROPBITS(last.bits) ---//
        hold >>>= last_bits;
        bits -= last_bits;
        //---//
        state.back += last_bits;
      }
      //--- DROPBITS(here.bits) ---//
      hold >>>= here_bits;
      bits -= here_bits;
      //---//
      state.back += here_bits;
      state.length = here_val;
      if (here_op === 0) {
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        state.mode = LIT;
        break;
      }
      if (here_op & 32) {
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.back = -1;
        state.mode = TYPE;
        break;
      }
      if (here_op & 64) {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break;
      }
      state.extra = here_op & 15;
      state.mode = LENEXT;
      /* falls through */
    case LENEXT:
      if (state.extra) {
        //=== NEEDBITS(state.extra);
        n = state.extra;
        while (bits < n) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.length += hold & ((1 << state.extra) -1)/*BITS(state.extra)*/;
        //--- DROPBITS(state.extra) ---//
        hold >>>= state.extra;
        bits -= state.extra;
        //---//
        state.back += state.extra;
      }
      //Tracevv((stderr, "inflate:         length %u\n", state.length));
      state.was = state.length;
      state.mode = DIST;
      /* falls through */
    case DIST:
      for (;;) {
        here = state.distcode[hold & ((1 << state.distbits) -1)];/*BITS(state.distbits)*/
        here_bits = here >>> 24;
        here_op = (here >>> 16) & 0xff;
        here_val = here & 0xffff;

        if ((here_bits) <= bits) { break; }
        //--- PULLBYTE() ---//
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
        //---//
      }
      if ((here_op & 0xf0) === 0) {
        last_bits = here_bits;
        last_op = here_op;
        last_val = here_val;
        for (;;) {
          here = state.distcode[last_val +
                  ((hold & ((1 << (last_bits + last_op)) -1))/*BITS(last.bits + last.op)*/ >> last_bits)];
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((last_bits + here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        //--- DROPBITS(last.bits) ---//
        hold >>>= last_bits;
        bits -= last_bits;
        //---//
        state.back += last_bits;
      }
      //--- DROPBITS(here.bits) ---//
      hold >>>= here_bits;
      bits -= here_bits;
      //---//
      state.back += here_bits;
      if (here_op & 64) {
        strm.msg = 'invalid distance code';
        state.mode = BAD;
        break;
      }
      state.offset = here_val;
      state.extra = (here_op) & 15;
      state.mode = DISTEXT;
      /* falls through */
    case DISTEXT:
      if (state.extra) {
        //=== NEEDBITS(state.extra);
        n = state.extra;
        while (bits < n) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.offset += hold & ((1 << state.extra) -1)/*BITS(state.extra)*/;
        //--- DROPBITS(state.extra) ---//
        hold >>>= state.extra;
        bits -= state.extra;
        //---//
        state.back += state.extra;
      }
//#ifdef INFLATE_STRICT
      if (state.offset > state.dmax) {
        strm.msg = 'invalid distance too far back';
        state.mode = BAD;
        break;
      }
//#endif
      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
      state.mode = MATCH;
      /* falls through */
    case MATCH:
      if (left === 0) { break inf_leave; }
      copy = _out - left;
      if (state.offset > copy) {         /* copy from window */
        copy = state.offset - copy;
        if (copy > state.whave) {
          if (state.sane) {
            strm.msg = 'invalid distance too far back';
            state.mode = BAD;
            break;
          }
// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
        }
        if (copy > state.wnext) {
          copy -= state.wnext;
          from = state.wsize - copy;
        }
        else {
          from = state.wnext - copy;
        }
        if (copy > state.length) { copy = state.length; }
        from_source = state.window;
      }
      else {                              /* copy from output */
        from_source = output;
        from = put - state.offset;
        copy = state.length;
      }
      if (copy > left) { copy = left; }
      left -= copy;
      state.length -= copy;
      do {
        output[put++] = from_source[from++];
      } while (--copy);
      if (state.length === 0) { state.mode = LEN; }
      break;
    case LIT:
      if (left === 0) { break inf_leave; }
      output[put++] = state.length;
      left--;
      state.mode = LEN;
      break;
    case CHECK:
      if (state.wrap) {
        //=== NEEDBITS(32);
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          // Use '|' insdead of '+' to make sure that result is signed
          hold |= input[next++] << bits;
          bits += 8;
        }
        //===//
        _out -= left;
        strm.total_out += _out;
        state.total += _out;
        if (_out) {
          strm.adler = state.check =
              /*UPDATE(state.check, put - _out, _out);*/
              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

        }
        _out = left;
        // NB: crc32 stored as signed 32-bit int, ZSWAP32 returns signed too
        if ((state.flags ? hold : ZSWAP32(hold)) !== state.check) {
          strm.msg = 'incorrect data check';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        //Tracev((stderr, "inflate:   check matches trailer\n"));
      }
      state.mode = LENGTH;
      /* falls through */
    case LENGTH:
      if (state.wrap && state.flags) {
        //=== NEEDBITS(32);
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (hold !== (state.total & 0xffffffff)) {
          strm.msg = 'incorrect length check';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        //Tracev((stderr, "inflate:   length matches trailer\n"));
      }
      state.mode = DONE;
      /* falls through */
    case DONE:
      ret = Z_STREAM_END;
      break inf_leave;
    case BAD:
      ret = Z_DATA_ERROR;
      break inf_leave;
    case MEM:
      return Z_MEM_ERROR;
    case SYNC:
      /* falls through */
    default:
      return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}


exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/
},{"../utils/common":27,"./adler32":29,"./crc32":31,"./inffast":34,"./inftrees":36}],36:[function(_dereq_,module,exports){
'use strict';


var utils = _dereq_('../utils/common');

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils.Buf16(MAXBITS+1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils.Buf16(MAXBITS+1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES) {
      base = extra = work;    /* dummy value--not used */
      end = 19;
  } else if (type === LENS) {
      base = lbase;
      base_index -= 257;
      extra = lext;
      extra_index -= 257;
      end = 256;
  } else {                    /* DISTS */
      base = dbase;
      extra = dext;
      end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS && used > ENOUGH_LENS) ||
    (type === DISTS && used > ENOUGH_DISTS)) {
    return 1;
  }

  var i=0;
  /* process all codes and make table entries */
  for (;;) {
    i++;
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS && used > ENOUGH_LENS) ||
        (type === DISTS && used > ENOUGH_DISTS)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};

},{"../utils/common":27}],37:[function(_dereq_,module,exports){
'use strict';

module.exports = {
  '2':    'need dictionary',     /* Z_NEED_DICT       2  */
  '1':    'stream end',          /* Z_STREAM_END      1  */
  '0':    '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};
},{}],38:[function(_dereq_,module,exports){
'use strict';


var utils = _dereq_('../utils/common');

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2*L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES+2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH-MIN_MATCH+1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


var StaticTreeDesc = function (static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
};


var static_l_desc;
var static_d_desc;
var static_bl_desc;


var TreeDesc = function(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
};



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short (s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c*2]/*.Code*/, tree[c*2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max]*2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max+1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n*2 +1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n*2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n-base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n*2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length-1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits+1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m*2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m*2 + 1]/*.Len*/)*tree[m*2]/*.Freq*/;
        tree[m*2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS+1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits-1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n*2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n*2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS+1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES-1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1<<extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length-1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0 ; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1<<extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for ( ; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1<<(extra_dbits[code]-7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n*2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n*2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n*2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n*2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES+1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n*2 + 1]/*.Len*/ = 5;
    static_dtree[n*2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS+1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc =new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n*2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n*2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n*2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK*2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n*2;
  var _m2 = m*2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j+1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx*2] << 8) | (s.pending_buf[s.d_buf + lx*2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code+LITERALS+1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n*2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node*2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n*2 + 1]/*.Dad*/ = tree[m*2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0*2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code+1)*2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n+1)*2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6*2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10*2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138*2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0*2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n+1)*2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count-3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count-3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count-11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES-1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex]*2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3*(max_blindex+1) + 5+5+4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes-257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes-1,   5);
  send_bits(s, blcodes-4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank]*2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes-1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes-1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n*2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK<<1)+(last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES<<1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len+3+7) >>> 3;
    static_lenb = (s.static_len+3+7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len+4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES<<1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES<<1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code+1, s.d_desc.max_code+1, max_blindex+1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc*2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc]+LITERALS+1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize-1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;
},{"../utils/common":27}],39:[function(_dereq_,module,exports){
'use strict';


function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;
},{}]},{},[9])
(9)
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(224).Buffer, __webpack_require__(42)))

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * The MIT License
 * 
 * Copyright © 2016-2019 3d-smile
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
!function(t,n){ true?module.exports=n():"function"==typeof define&&define.amd?define([],n):"object"==typeof exports?exports["@3d-smile/glkit"]=n():t["@3d-smile/glkit"]=n()}(window,function(){return function(t){var n={};function e(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,e),i.l=!0,i.exports}return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{enumerable:!0,get:r})},e.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},e.t=function(t,n){if(1&n&&(t=e(t)),8&n)return t;if(4&n&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(e.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&n&&"string"!=typeof t)for(var i in t)e.d(r,i,function(n){return t[n]}.bind(null,i));return r},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},e.p="",e(e.s=0)}([function(t,n,e){t.exports=e(1)},function(t,n,e){var r=e(2),i=e(29).version;t.exports={WebGL:r,version:i}},function(t,n,e){function r(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function i(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}var a=e(3),o=e(4),u=e(5),s=e(6),c=e(7),l=e(8),h=e(9),f=e(10),v=e(11),m=e(12),y=e(13),p=e(14),d=e(15),b=e(16),g=e(17),k=e(18),x=e(19),w=e(20),S=e(21),P=e(22),T=e(23),R=e(24),M=e(25),A=e(26),C=e(27),j=e(28),O=function(){function t(){var n=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r(this,t),this.class="WebGL",this.stateFlag=new Uint8Array([1]),this.$=function(){return n.stateFlag[0]=1},this.extensions={},this.contextAttributes={},this.canvas=e.canvas||document.createElement("canvas"),this.errorCallback=e.errorCallback||function(){return 0},this.contextType=e.contextType||"webgl",Object.assign(this.contextAttributes,{depth:!0,stencil:!1,alpha:!1,antialias:!0,premultipliedAlpha:!1,preserveDrawingBuffer:!1,failIfMajorPerformanceCaveat:!1,powerPreference:"default"},e.contextAttributes);try{this.WebGLRenderingContext=this.canvas.getContext(this.contextType,this.contextAttributes)||this.canvas.getContext("experimental-".concat(e.contextType),this.contextAttributes)}catch(t){this.errorCallback(t)}var i=this.WebGLRenderingContext;e.extensions&&e.extensions.forEach(function(t){return n.extensions[t]=i.getExtension(t)||i.getExtension("MOZ_".concat(t))||i.getExtension("WEBKIT_".concat(t))}),this.availableExtensions=i.getSupportedExtensions(),this.minDpr=e.minDpr||1,this.maxDpr=e.maxDpr||999,this.dpr=e.dpr||Math.min(Math.max(window.devicePixelRatio||1,this.minDpr),this.maxDpr),this.maxTextureUnits=i.getParameter(i.MAX_TEXTURE_IMAGE_UNITS),this.textureUnits=new Array(this.maxTextureUnits).fill(null).map(function(t,n){return i["TEXTURE".concat(n)]}),this.extensions.EXT_texture_filter_anisotropic&&(this.maxAnisotropy=i.getParameter(this.extensions.EXT_texture_filter_anisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)),this.MAX_PROGRAM_UNIFORM_COUNT=e.maxProgramUniformCount||16,this.Buffer=a(this),this.Renderbuffer=o(this),this.Framebuffer=u(this),this.VertexArray=s(this),this.Shader=h(this),this.Program=f(this),this.VertexAttrib=c(this),this.Texture=l(this),this.Mat2=v(this),this.Mat3=m(this),this.Mat4=y(this),this.Vec1=p(this),this.Vec2=d(this),this.Vec3=b(this),this.Vec4=g(this),this.Quat=k(this),this.VertexBuffer=x(this),this.IndexBuffer=w(this),this.Texture2D=S(this),this.Camera=P(this),this.Obj=T(this),this.Transition=R(this),this.Time=M(this),this.Orbit=A(this),this.Raycast=C(this),this.Gumball=j(this)}var n,e,O;return n=t,(e=[{key:"viewport",value:function(t,n,e,r){return this.WebGLRenderingContext.viewport(t*this.dpr,n*this.dpr,e*this.dpr,r*this.dpr),this}},{key:"setSize",value:function(t,n,e,r){return this.dpr=Math.min(Math.max(window.devicePixelRatio||1,this.minDpr),this.maxDpr),this.canvas.width=e*this.dpr,this.canvas.height=r*this.dpr,this.canvas.style.width="".concat(e,"px"),this.canvas.style.height="".concat(r,"px"),this.viewport(t,n,e,r)}}])&&i(n.prototype,e),O&&i(n,O),t}();t.exports=O},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}t.exports=function(t){var n=t.WebGLRenderingContext,i=n.STATIC_DRAW;return function(){function t(){e(this,t),this.class="Buffer",this.handle=n.createBuffer()}var a,o,u;return a=t,u=[{key:"bind",value:function(e,r){return n.bindBuffer(e,r.handle),t}},{key:"bindBase",value:function(e,r){return n.bindBufferBase(e,r.handle),t}},{key:"bindRange",value:function(e,r){return n.bindBufferRange(e,r.handle),t}},{key:"delete",value:function(e){return n.deleteBuffer(e.handle),t}},{key:"unbind",value:function(e){return n.bindBuffer(e,null),t}},{key:"data",value:function(e,r){var a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:i;return n.bufferData(e,r,a),t}},{key:"subData",value:function(e,r,i){return n.bufferSubData(e,r,i),t}}],(o=[{key:"bind",value:function(t){return n.bindBuffer(t,this.handle),this}},{key:"bindBase",value:function(t){return n.bindBufferBase(t,this.handle),this}},{key:"bindRange",value:function(t){return n.bindBufferRange(t,this.handle),this}},{key:"data",value:function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:i;return n.bufferData(t,e,r),this}},{key:"subData",value:function(t,e,r){return n.bufferSubData(t,e,r),this}},{key:"delete",value:function(){return n.deleteBuffer(this.handle),this}}])&&r(a.prototype,o),u&&r(a,u),t}()}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}t.exports=function(t){var n=t.WebGLRenderingContext,i=n.RENDERBUFFER;return function(){function t(){e(this,t),this.class="Renderbuffer",this.handle=n.createRenderbuffer()}var a,o,u;return a=t,u=[{key:"bind",value:function(e){return n.bindRenderbuffer(i,e.handle),t}},{key:"unbind",value:function(){return n.bindRenderbuffer(i,null),t}},{key:"storage",value:function(e,r,a){return n.renderbufferStorage(i,e,r,a),t}}],(o=[{key:"bind",value:function(){return n.bindRenderbuffer(i,this.handle),this}},{key:"unbind",value:function(){return n.bindRenderbuffer(i,null),this}},{key:"delete",value:function(){return n.deleteRenderbuffer(this.handle),this}},{key:"storageMultisample",value:function(t,e,r,a){return n.renderbufferStorageMultisample(i,t,e,r,a),this}}])&&r(a.prototype,o),u&&r(a,u),t}()}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}t.exports=function(t){var n=t.WebGLRenderingContext,i=n.FRAMEBUFFER,a=n.RENDERBUFFER,o=n.TEXTURE_2D;return function(){function t(){e(this,t),this.class="Framebuffer",this.handle=n.createFramebuffer()}var u,s,c;return u=t,c=[{key:"bind",value:function(e){return n.bindFramebuffer(i,e.handle),t}},{key:"unbind",value:function(){return n.bindFramebuffer(i,null),t}},{key:"texture2D",value:function(e,r){return n.framebufferTexture2D(i,e,o,r.handle,0),t}},{key:"texture2D2",value:function(e,r,a){return n.framebufferTexture2D(i,e,r,a.handle,0),t}},{key:"renderbuffer",value:function(e,r){return n.framebufferRenderbuffer(i,e,a,r.handle),t}}],(s=[{key:"bind",value:function(){return n.bindFramebuffer(i,this.handle),this}},{key:"bind2",value:function(t){return n.bindFramebuffer(t,this.handle),this}},{key:"unbind",value:function(){return n.bindFramebuffer(i,null),this}},{key:"delete",value:function(){return n.deleteFramebuffer(this.handle),this}}])&&r(u.prototype,s),c&&r(u,c),t}()}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}t.exports=function(t){var n=t.WebGLRenderingContext;return function(){function t(){e(this,t),this.class="VertexArray",this.handle=n.createVertexArray()}var i,a,o;return i=t,o=[{key:"unbind",value:function(){return n.bindVertexArray(null),t}}],(a=[{key:"bind",value:function(){return n.bindVertexArray(this.handle),this}},{key:"unbind",value:function(){return n.bindVertexArray(null),this}},{key:"delete",value:function(){return n.deleteVertexArray(this.handle),this}}])&&r(i.prototype,a),o&&r(i,o),t}()}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}t.exports=function(t){var n=t.WebGLRenderingContext,i=t.contextType,a=t.Program,o=n,u=o.FLOAT,s=o.ARRAY_BUFFER;return function(){function t(){e(this,t)}var n,c,l;return n=t,l=[{key:"enable",value:function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;return n.length?n.forEach(function(t){return o.enableVertexAttribArray(t)}):o.enableVertexAttribArray(n),t}},{key:"disable",value:function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;return n.length?n.forEach(function(t){return o.disableVertexAttribArray(t)}):o.disableVertexAttribArray(n),t}},{key:"inject",value:function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"auto",e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"vec3",r=a.currentlyBeingCreated,o="".concat(function(t){return{webgl:"attribute",webgl2:"in"}[t]}(i)," ").concat(e," ").concat(t);return"auto"===n?r.afterLinkingActions.push(function(){return r.getAttribLocation(t)}):"webgl"===i?r.beforeLinkingActions.push(function(){return r.bindAttribLocation(n,t)}):o="layout (location = ".concat(n,") ").concat(o),"".concat(o,";")}},{key:"pointer",value:function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:3,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:u,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,a=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,s=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0;return o.vertexAttribPointer(n,e,r,i,a,s),t}},{key:"pointer2",value:function(n){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:3,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:u,a=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,c=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0,l=arguments.length>6&&void 0!==arguments[6]?arguments[6]:0;return o.bindBuffer(s,n.handle),o.vertexAttribPointer(e,r,i,a,c,l),t}}],(c=null)&&r(n.prototype,c),l&&r(n,l),t}()}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}t.exports=function(t){var n=t.WebGLRenderingContext,i=t.textureUnits,a=n;return function(){function t(){e(this,t),this.class="Texture",this.handle=a.createTexture()}var n,o,u;return n=t,u=[{key:"bind",value:function(n,e){return a.bindTexture(n,e.handle),t}},{key:"unbind",value:function(n){return a.bindTexture(n,null),t}},{key:"delete",value:function(n){return a.deleteTexture(n.handle),t}},{key:"unit",value:function(n){return a.activeTexture(i[n]),t}},{key:"image2D",value:function(n,e,r,i,o,u){return a.texImage2D(n,e,r,i,o,u),t}},{key:"image2D2",value:function(n,e,r,i,o,u,s,c,l){return a.texImage2D(n,e,r,i,o,u,s,c,l),t}},{key:"mipmap",value:function(n){return a.generateMipmap(n),t}},{key:"parameteri",value:function(n,e,r){return a.texParameteri(n,e,r),t}},{key:"parameterf",value:function(n,e,r){return a.texParameterf(n,e,r),t}}],(o=[{key:"bind",value:function(t){return a.bindTexture(t,this.handle),this}},{key:"delete",value:function(){return a.deleteTexture(this.handle),this}}])&&r(n.prototype,o),u&&r(n,u),t}()}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}t.exports=function(t){var n=t.WebGLRenderingContext,i=n.VERTEX_SHADER,a=n.FRAGMENT_SHADER,o=n.COMPILE_STATUS;function u(t,e){var r=n.getShaderPrecisionFormat(t,n["MEDIUM_".concat(e.toUpperCase())]),i=n.getShaderPrecisionFormat(t,n["HIGH_".concat(e.toUpperCase())]),a="lowp";return i.precision+i.rangeMin+i.rangeMax?a="highp":r.precision+r.rangeMin+r.rangeMax&&(a="mediump"),"precision ".concat(a," ").concat(e,";")}var s=function(){function t(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:i;e(this,t),this.class="Shader",this.handle=n.createShader(r)}var a,u,s;return a=t,(u=[{key:"source",value:function(t){return n.shaderSource(this.handle,t),this}},{key:"compile",value:function(){return n.compileShader(this.handle),this}},{key:"getParam",value:function(t){return n.getShaderParameter(this.handle,t)}},{key:"checkCompileStatus",value:function(t){if(!this.getParam(o)){var n="\n".concat(t.split("\n").map(function(t,n){return"".concat(n+1,":").concat(t)}).join("\n"),"\n");throw new Error("".concat(n).concat(this.getLog()))}return this}},{key:"getLog",value:function(){return n.getShaderInfoLog(this.handle)}},{key:"delete",value:function(){return n.deleteShader(this.handle),this}}])&&r(a.prototype,u),s&&r(a,s),t}();return s.maxPrecision={vs:{int:u(i,"int"),float:u(i,"float")},fs:{int:u(a,"int"),float:u(a,"float")}},s.consts={ROTATION_MATRIX_X:"mat4 ROTATION_MATRIX_X(float a) {\n        float c = cos(a);\n        float s = sin(a);\n        return mat4(1., 0., 0., 0., 0., c, -s, 0., 0., s, c, 0., 0., 0., 0., 1.);\n      }",ROTATION_MATRIX_Y:"mat4 ROTATION_MATRIX_Y(float a) {\n        float c = cos(a);\n        float s = sin(a);\n        return mat4(c, 0., s, 0., 0., 1., 0., 0., -s, 0., c, 0., 0., 0., 0., 1.);\n      }",BEZIER_CURVE_3_POINT:"vec3 BEZIER_CURVE_3_POINT(vec3 p0, vec3 p1, vec3 p2, vec3 p3, float t) {\n        float a = 1.0 - t;\n        float b = a * a;\n        float c = t * t;\n        float d = a * b;\n        float e = 3.0 * t * b;\n        float f = 3.0 * c * a;\n        float g = c * t;\n\n        return (p0 * d) + (p1 * e) + (p2 * f) + (p3 * g);\n      }",GET_CONTROL_POINT:"vec3 GET_CONTROL_POINT(vec3 p0, vec3 p1, vec3 p2, float tension) {\n        return p1 + ((p2 - p0) * 0.5 * tension);\n      }",FLOAT_TO_RGBA:"vec4 FLOAT_TO_RGBA(float f) {\n        float Exponent = floor(log2(f));\n        float Mantissa = f / exp2(Exponent);\n        if (Mantissa < 1.0) {\n          Exponent -= 1.0;\n        }\n        Exponent += 127.0;\n        return vec4(\n          Exponent,\n          128.0 + mod(floor(Mantissa * 128.0), 128.0),\n          floor(mod(floor(Mantissa * exp2(15.0)), exp2(8.0))),\n          floor(exp2(23.0) * mod(Mantissa, exp2(-15.0)))\n        ) / 255.0;\n      }",INVERSE_MATRIX:"mat4 INVERSE_MATRIX(mat4 matrix) {\n        float a00 = matrix[0][0], a01 = matrix[0][1], a02 = matrix[0][2], a03 = matrix[0][3];\n        float a10 = matrix[1][0], a11 = matrix[1][1], a12 = matrix[1][2], a13 = matrix[1][3];\n        float a20 = matrix[2][0], a21 = matrix[2][1], a22 = matrix[2][2], a23 = matrix[2][3];\n        float a30 = matrix[3][0], a31 = matrix[3][1], a32 = matrix[3][2], a33 = matrix[3][3];\n      \n        float b00 = a00 * a11 - a01 * a10;\n        float b01 = a00 * a12 - a02 * a10;\n        float b02 = a00 * a13 - a03 * a10;\n        float b03 = a01 * a12 - a02 * a11;\n        float b04 = a01 * a13 - a03 * a11;\n        float b05 = a02 * a13 - a03 * a12;\n        float b06 = a20 * a31 - a21 * a30;\n        float b07 = a20 * a32 - a22 * a30;\n        float b08 = a20 * a33 - a23 * a30;\n        float b09 = a21 * a32 - a22 * a31;\n        float b10 = a21 * a33 - a23 * a31;\n        float b11 = a22 * a33 - a23 * a32;\n      \n        float det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;\n      \n        return mat4(\n          a11 * b11 - a12 * b10 + a13 * b09,\n          a02 * b10 - a01 * b11 - a03 * b09,\n          a31 * b05 - a32 * b04 + a33 * b03,\n          a22 * b04 - a21 * b05 - a23 * b03,\n          a12 * b08 - a10 * b11 - a13 * b07,\n          a00 * b11 - a02 * b08 + a03 * b07,\n          a32 * b02 - a30 * b05 - a33 * b01,\n          a20 * b05 - a22 * b02 + a23 * b01,\n          a10 * b10 - a11 * b08 + a13 * b06,\n          a01 * b08 - a00 * b10 - a03 * b06,\n          a30 * b04 - a31 * b02 + a33 * b00,\n          a21 * b02 - a20 * b04 - a23 * b00,\n          a11 * b07 - a10 * b09 - a12 * b06,\n          a00 * b09 - a01 * b07 + a02 * b06,\n          a31 * b01 - a30 * b03 - a32 * b00,\n          a20 * b03 - a21 * b01 + a22 * b00\n        ) / det;\n      }",EXTRACT_ROTATION:"mat4 EXTRACT_ROTATION(mat4 matrix) {\n        vec3 s = vec3(\n          length(matrix[0].xyz),\n          length(matrix[1].xyz),\n          length(matrix[2].xyz)\n        );\n\n        mat4 rotationMatrix = mat4(1.0);\n\n        rotationMatrix[0] = matrix[0] / s.x;\n        rotationMatrix[1] = matrix[1] / s.y;\n        rotationMatrix[2] = matrix[2] / s.z;\n\n        return rotationMatrix;\n      }"},s}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function i(t,n,e){return n&&r(t.prototype,n),e&&r(t,e),t}t.exports=function(t){var n=t.WebGLRenderingContext,r=t.Shader,a=t.MAX_PROGRAM_UNIFORM_COUNT,o=n,u=o.VERTEX_SHADER,s=o.FRAGMENT_SHADER,c=o.LINK_STATUS,l=[function(t,n){t.arr[t.length++]=n},function(){return 0}],h=function(){function t(){e(this,t),this.length=0,this.arr=new Uint8Array(a),this.test=new Uint8Array(a)}return i(t,[{key:"push",value:function(t){l[this.test[t]](this,t),this.test[t]=1}}]),t}(),f=function(){function t(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};e(this,t),this.class="Program",this.handle=o.createProgram(),Object.assign(this,{VS:null,FS:null},n),this.uniforms={},this.uniformUpdateFunctionsArray=[],this.uniformUpdateFunctionsObject={},this.uniformCount=0,this.uniformStack=new h,this.beforeLinkingActions=[],this.afterLinkingActions=[]}return i(t,[{key:"use",value:function(){return o.useProgram(this.handle),this}},{key:"use2",value:function(){return o.useProgram(this.handle),this.updateUniforms()}},{key:"use3",value:function(){return o.useProgram(this.handle),this.updateUniformStackUniforms()}},{key:"unuse",value:function(){return o.useProgram(null),this}},{key:"attachShader",value:function(t){return o.attachShader(this.handle,t.handle),this}},{key:"link",value:function(){return o.linkProgram(this.handle),this}},{key:"bindAttribLocation",value:function(t,n){return o.bindAttribLocation(this.handle,t,n),this}},{key:"getAttribLocation",value:function(t){return o.getAttribLocation(this.handle,t),this}},{key:"getUniformLocation",value:function(t){return o.getUniformLocation(this.handle,t)}},{key:"updateUniform",value:function(t){return this.uniformUpdateFunctionsObject[t](),this}},{key:"updateUniforms",value:function(){for(var t=this.uniformUpdateFunctionsArray.length,n=0;n<t;n++)this.uniformUpdateFunctionsArray[n]();return this}},{key:"updateUniformStackUniforms",value:function(){var t=this.uniformStack.length;this.uniformStack.length=0;for(var n=0;n<t;n++){var e=this.uniformStack.arr[n];this.uniformUpdateFunctionsArray[e](),this.uniformStack.test[e]=0}return this}},{key:"getParameter",value:function(t){return o.getProgramParameter(this.handle,t)}},{key:"getInfoLog",value:function(){return o.getProgramInfoLog(this.handle)}},{key:"checkLinkStatus",value:function(){if(!this.getParameter(c))throw new Error("".concat(c,", ").concat(this.getInfoLog()));return this}},{key:"onBeforeLinking",value:function(){return this.beforeLinkingActions.forEach(function(t){return t()}),this}},{key:"onAfterLinking",value:function(){return this.afterLinkingActions.forEach(function(t){return t()}),this}},{key:"compose",value:function(){t.currentlyBeingCreated=this;var n="function"==typeof this.VS?this.VS(this):this.VS,e="function"==typeof this.FS?this.FS(this):this.FS;return this.attachShader(t.getShader(n,u)).attachShader(t.getShader(e,s)).onBeforeLinking().link().checkLinkStatus().onAfterLinking().use().updateUniforms()}},{key:"delete",value:function(){return o.deleteProgram(this.handle),this}}],[{key:"unuse",value:function(){return o.useProgram(null),t}},{key:"getShader",value:function(t,n){return new r(n).source(t).compile().checkCompileStatus(t)}}]),t}();return f.currentlyBeingCreated=null,f}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}t.exports=function(t){var n=t.WebGLRenderingContext,i=t.Program,a=t.$,o=t.MAX_PROGRAM_UNIFORM_COUNT,u=n;return function(){function t(n){e(this,t),this.class="Mat2",this.arr=n||new Float64Array([1,0,0,1]),this.uniformPrograms=[],this.uniformProgramIndices=new Uint8Array(o),this.uniformProgramCount=0,this.uniformStateFlag=0}var n,s,c;return n=t,(s=[{key:"set",value:function(t,n,e,r){var i=this.arr;return i[0]=t,i[2]=n,i[1]=e,i[3]=r,this}},{key:"reset",value:function(){return this.set(1,0,0,1)}},{key:"copy",value:function(t){var n=t.arr;return this.set(n[0],n[2],n[1],n[3])}},{key:"clone",value:function(){return(new t).copy(this)}},{key:"zero",value:function(){return this.set(0,0,0,0)}},{key:"multiply",value:function(t,n){var e=t.arr,r=n.arr;return this.set(e[0]*r[0]+e[2]*r[1],e[0]*r[2]+e[2]*r[3],e[1]*r[0]+e[3]*r[1],e[1]*r[2]+e[3]*r[3])}},{key:"premultiply",value:function(t){return this.multiply(t,this)}},{key:"postmultiply",value:function(t){return this.multiply(this,t)}},{key:"injectUniform",value:function(t){var n=this,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"auto",r=i.currentlyBeingCreated,a=r.uniformCount++,o="uniform mat2 ".concat(t),s=null;r.uniforms[t]=this,this.uniformPrograms.push(r),this.uniformProgramIndices[this.uniformProgramCount++]=a,"auto"===e?r.afterLinkingActions.push(function(){s=r.getUniformLocation(t)}):o="layout (location = ".concat(s=e,") ").concat(o);var c=function(){u.uniformMatrix2fv(s,!1,n.arr),n.uniformStateFlag=0};return r.uniformUpdateFunctionsArray.push(c),r.uniformUpdateFunctionsObject[t]=c,"".concat(o,";")}},{key:"$",value:function(){var t=this.uniformProgramCount-this.uniformStateFlag;this.uniformStateFlag=this.uniformProgramCount;for(var n=0;n<t;n++){this.uniformPrograms[n].uniformStack.push(this.uniformProgramIndices[n])}return a(),this}}])&&r(n.prototype,s),c&&r(n,c),t}()}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}t.exports=function(t){var n=t.WebGLRenderingContext,i=t.Program,a=t.$,o=t.MAX_PROGRAM_UNIFORM_COUNT,u=n;return function(){function t(n){e(this,t),this.class="Mat3",this.arr=n||new Float64Array([1,0,0,0,1,0,0,0,1]),this.uniformPrograms=[],this.uniformProgramIndices=new Uint8Array(o),this.uniformProgramCount=0,this.uniformStateFlag=0}var n,s,c;return n=t,(s=[{key:"set",value:function(t,n,e,r,i,a,o,u,s){var c=this.arr;return c[0]=t,c[3]=n,c[6]=e,c[1]=r,c[4]=i,c[7]=a,c[2]=o,c[5]=u,c[8]=s,this}},{key:"reset",value:function(){return this.set(1,0,0,0,1,0,0,0,1)}},{key:"copy",value:function(t){var n=t.arr;return this.set(n[0],n[3],n[6],n[1],n[4],n[7],n[2],n[5],n[8])}},{key:"clone",value:function(){return(new t).copy(this)}},{key:"zero",value:function(){return this.set(0,0,0,0,0,0,0,0,0)}},{key:"multiply",value:function(t,n){var e=t.arr,r=n.arr;return this.set(e[0]*r[0]+e[3]*r[1]+e[6]*r[2],e[0]*r[3]+e[3]*r[4]+e[6]*r[5],e[0]*r[6]+e[3]*r[7]+e[6]*r[8],e[1]*r[0]+e[4]*r[1]+e[7]*r[2],e[1]*r[3]+e[4]*r[4]+e[7]*r[5],e[1]*r[6]+e[4]*r[7]+e[7]*r[8],e[2]*r[0]+e[5]*r[1]+e[8]*r[2],e[2]*r[3]+e[5]*r[4]+e[8]*r[5],e[2]*r[6]+e[5]*r[7]+e[8]*r[8])}},{key:"premultiply",value:function(t){return this.multiply(t,this)}},{key:"postmultiply",value:function(t){return this.multiply(this,t)}},{key:"injectUniform",value:function(t){var n=this,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"auto",r=i.currentlyBeingCreated,a=r.uniformCount++,o="uniform mat3 ".concat(t),s=null;r.uniforms[t]=this,this.uniformPrograms.push(r),this.uniformProgramIndices[this.uniformProgramCount++]=a,"auto"===e?r.afterLinkingActions.push(function(){s=r.getUniformLocation(t)}):o="layout (location = ".concat(s=e,") ").concat(o);var c=function(){u.uniformMatrix3fv(s,!1,n.arr),n.uniformStateFlag=0};return r.uniformUpdateFunctionsArray.push(c),r.uniformUpdateFunctionsObject[t]=c,"".concat(o,";")}},{key:"$",value:function(){var t=this.uniformProgramCount-this.uniformStateFlag;this.uniformStateFlag=this.uniformProgramCount;for(var n=0;n<t;n++){this.uniformPrograms[n].uniformStack.push(this.uniformProgramIndices[n])}return a(),this}}])&&r(n.prototype,s),c&&r(n,c),t}()}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function i(t,n,e){return n&&r(t.prototype,n),e&&r(t,e),t}t.exports=function(t){var n=t.WebGLRenderingContext,r=t.Program,a=t.$,o=t.MAX_PROGRAM_UNIFORM_COUNT,u=n,s={mat4:function(t,n){return u.uniformMatrix4fv(t,!1,n)},"ivec4[]":function(t,n){return u.uniform4iv(t,n)},"vec4[]":function(t,n){return u.uniform4fv(t,n)},"float[i]":function(t){return function(n,e){return u.uniform1i(n,e[t])}},"int[i]":function(t){return function(n,e){return u.uniform1f(n,e[t])}},"ivec2[i]":function(t){return function(n,e){return u.uniform2i(n,e[t],e[t+1])}},"vec2[i]":function(t){return function(n,e){return u.uniform2f(n,e[t],e[t+1])}},"ivec3[i]":function(t){return function(n,e){return u.uniform3i(n,e[t],e[t+1],e[t+2])}},"vec3[i]":function(t){return function(n,e){return u.uniform3f(n,e[t],e[t+1],e[t+2])}},"ivec4[i]":function(t){return function(n,e){return u.uniform4i(n,e[t],e[t+1],e[t+2],e[t+3])}},"vec4[i]":function(t){return function(n,e){return u.uniform4f(n,e[t],e[t+1],e[t+2],e[t+3])}}},c=function(){function t(){e(this,t),this.arr=new Float64Array([1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1])}return i(t,[{key:"set",value:function(t,n,e,r,i,a,o,u,s,c,l,h,f,v,m,y){var p=this.arr;return p[0]=t,p[4]=n,p[8]=e,p[12]=r,p[1]=i,p[5]=a,p[9]=o,p[13]=u,p[2]=s,p[6]=c,p[10]=l,p[14]=h,p[3]=f,p[7]=v,p[11]=m,p[15]=y,this}},{key:"makeRotation",value:function(t,n){var e=t.arr,r=Math.cos(n),i=Math.sin(n),a=e[0]*e[0],o=e[1]*e[1],u=e[2]*e[2],s=e[0]*e[1],c=e[0]*e[2],l=e[1]*e[2],h=1-r,f=e[0]*i,v=e[1]*i,m=e[2]*i;return this.set(r+a*h,s*h+m,c*h-v,0,s*h-m,r+o*h,l*h+f,0,c*h+v,l*h-f,r+u*h,0,0,0,0,1)}},{key:"makeRotationX",value:function(t){var n=Math.cos(t),e=Math.sin(t);return this.set(1,0,0,0,0,n,e,0,0,-e,n,0,0,0,0,1)}},{key:"makeRotationY",value:function(t){var n=Math.cos(t),e=Math.sin(t);return this.set(n,0,-e,0,0,1,0,0,e,0,n,0,0,0,0,1)}},{key:"makeRotationZ",value:function(t){var n=Math.cos(t),e=Math.sin(t);return this.set(n,e,0,0,-e,n,0,0,0,0,1,0,0,0,0,1)}},{key:"makeQuatRotation",value:function(t){var n=t.arr,e=2*n[0]*n[0],r=2*n[1]*n[1],i=2*n[2]*n[2],a=2*n[0]*n[1],o=2*n[0]*n[2],u=2*n[0]*n[3],s=2*n[1]*n[2],c=2*n[1]*n[3],l=2*n[2]*n[3];return this.set(1-r-i,a-l,o+c,0,a+l,1-e-i,s-u,0,o-c,s+u,1-e-r,0,0,0,0,1)}},{key:"makeTranslation",value:function(t,n){var e=t.arr;return this.set(1,0,0,e[0]*n,0,1,0,e[1]*n,0,0,1,e[2]*n,0,0,0,1)}},{key:"makeTranslationX",value:function(t){return this.set(1,0,0,t,0,1,0,0,0,0,1,0,0,0,0,1)}},{key:"makeTranslationY",value:function(t){return this.set(1,0,0,0,0,1,0,t,0,0,1,0,0,0,0,1)}},{key:"makeTranslationZ",value:function(t){return this.set(1,0,0,0,0,1,0,0,0,0,1,t,0,0,0,1)}}]),t}(),l=function(){function t(){e(this,t),this.arr=new Float64Array([0,0,0])}return i(t,[{key:"set",value:function(t,n,e){var r=this.arr;return r[0]=t,r[1]=n,r[2]=e,this}},{key:"lengthSquare",value:function(){var t=this.arr;return t[0]*t[0]+t[1]*t[1]+t[2]*t[2]}},{key:"length",value:function(){return Math.sqrt(this.lengthSquare())}},{key:"extractScale",value:function(t){var n=t.arr,e=t.vec3.set(n[0],n[1],n[2]).length(),r=t.vec3.set(n[4],n[5],n[6]).length(),i=t.vec3.set(n[8],n[9],n[10]).length();return this.set(e,r,i)}}]),t}();return function(){function t(n){e(this,t),this.class="Mat4",this.arr=n||new Float64Array([1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1]),this.uniformPrograms=[],this.uniformProgramIndices=new Uint8Array(o),this.uniformProgramCount=0,this.uniformStateFlag=0,this.mat4=new c,this.vec3=new l}return i(t,[{key:"set",value:function(t,n,e,r,i,a,o,u,s,c,l,h,f,v,m,y){var p=this.arr;return p[0]=t,p[4]=n,p[8]=e,p[12]=r,p[1]=i,p[5]=a,p[9]=o,p[13]=u,p[2]=s,p[6]=c,p[10]=l,p[14]=h,p[3]=f,p[7]=v,p[11]=m,p[15]=y,this}},{key:"reset",value:function(){return this.set(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)}},{key:"copy",value:function(t){var n=t.arr;return this.set(n[0],n[4],n[8],n[12],n[1],n[5],n[9],n[13],n[2],n[6],n[10],n[14],n[3],n[7],n[11],n[15])}},{key:"clone",value:function(){return(new t).copy(this)}},{key:"zero",value:function(){return this.set(0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0)}},{key:"multiply",value:function(t,n){var e=t.arr,r=n.arr;return this.set(e[0]*r[0]+e[4]*r[1]+e[8]*r[2]+e[12]*r[3],e[0]*r[4]+e[4]*r[5]+e[8]*r[6]+e[12]*r[7],e[0]*r[8]+e[4]*r[9]+e[8]*r[10]+e[12]*r[11],e[0]*r[12]+e[4]*r[13]+e[8]*r[14]+e[12]*r[15],e[1]*r[0]+e[5]*r[1]+e[9]*r[2]+e[13]*r[3],e[1]*r[4]+e[5]*r[5]+e[9]*r[6]+e[13]*r[7],e[1]*r[8]+e[5]*r[9]+e[9]*r[10]+e[13]*r[11],e[1]*r[12]+e[5]*r[13]+e[9]*r[14]+e[13]*r[15],e[2]*r[0]+e[6]*r[1]+e[10]*r[2]+e[14]*r[3],e[2]*r[4]+e[6]*r[5]+e[10]*r[6]+e[14]*r[7],e[2]*r[8]+e[6]*r[9]+e[10]*r[10]+e[14]*r[11],e[2]*r[12]+e[6]*r[13]+e[10]*r[14]+e[14]*r[15],e[3]*r[0]+e[7]*r[1]+e[11]*r[2]+e[15]*r[3],e[3]*r[4]+e[7]*r[5]+e[11]*r[6]+e[15]*r[7],e[3]*r[8]+e[7]*r[9]+e[11]*r[10]+e[15]*r[11],e[3]*r[12]+e[7]*r[13]+e[11]*r[14]+e[15]*r[15])}},{key:"premultiply",value:function(t){return this.multiply(t,this)}},{key:"postmultiply",value:function(t){return this.multiply(this,t)}},{key:"inverse",value:function(){var t=this.arr,n=t[9]*t[14]*t[7]-t[13]*t[10]*t[7]+t[13]*t[6]*t[11]-t[5]*t[14]*t[11]-t[9]*t[6]*t[15]+t[5]*t[10]*t[15],e=t[12]*t[10]*t[7]-t[8]*t[14]*t[7]-t[12]*t[6]*t[11]+t[4]*t[14]*t[11]+t[8]*t[6]*t[15]-t[4]*t[10]*t[15],r=t[8]*t[13]*t[7]-t[12]*t[9]*t[7]+t[12]*t[5]*t[11]-t[4]*t[13]*t[11]-t[8]*t[5]*t[15]+t[4]*t[9]*t[15],i=t[12]*t[9]*t[6]-t[8]*t[13]*t[6]-t[12]*t[5]*t[10]+t[4]*t[13]*t[10]+t[8]*t[5]*t[14]-t[4]*t[9]*t[14],a=1/(t[0]*n+t[1]*e+t[2]*r+t[3]*i);return this.set(n*a,e*a,r*a,i*a,(t[13]*t[10]*t[3]-t[9]*t[14]*t[3]-t[13]*t[2]*t[11]+t[1]*t[14]*t[11]+t[9]*t[2]*t[15]-t[1]*t[10]*t[15])*a,(t[8]*t[14]*t[3]-t[12]*t[10]*t[3]+t[12]*t[2]*t[11]-t[0]*t[14]*t[11]-t[8]*t[2]*t[15]+t[0]*t[10]*t[15])*a,(t[12]*t[9]*t[3]-t[8]*t[13]*t[3]-t[12]*t[1]*t[11]+t[0]*t[13]*t[11]+t[8]*t[1]*t[15]-t[0]*t[9]*t[15])*a,(t[8]*t[13]*t[2]-t[12]*t[9]*t[2]+t[12]*t[1]*t[10]-t[0]*t[13]*t[10]-t[8]*t[1]*t[14]+t[0]*t[9]*t[14])*a,(t[5]*t[14]*t[3]-t[13]*t[6]*t[3]+t[13]*t[2]*t[7]-t[1]*t[14]*t[7]-t[5]*t[2]*t[15]+t[1]*t[6]*t[15])*a,(t[12]*t[6]*t[3]-t[4]*t[14]*t[3]-t[12]*t[2]*t[7]+t[0]*t[14]*t[7]+t[4]*t[2]*t[15]-t[0]*t[6]*t[15])*a,(t[4]*t[13]*t[3]-t[12]*t[5]*t[3]+t[12]*t[1]*t[7]-t[0]*t[13]*t[7]-t[4]*t[1]*t[15]+t[0]*t[5]*t[15])*a,(t[12]*t[5]*t[2]-t[4]*t[13]*t[2]-t[12]*t[1]*t[6]+t[0]*t[13]*t[6]+t[4]*t[1]*t[14]-t[0]*t[5]*t[14])*a,(t[9]*t[6]*t[3]-t[5]*t[10]*t[3]-t[9]*t[2]*t[7]+t[1]*t[10]*t[7]+t[5]*t[2]*t[11]-t[1]*t[6]*t[11])*a,(t[4]*t[10]*t[3]-t[8]*t[6]*t[3]+t[8]*t[2]*t[7]-t[0]*t[10]*t[7]-t[4]*t[2]*t[11]+t[0]*t[6]*t[11])*a,(t[8]*t[5]*t[3]-t[4]*t[9]*t[3]-t[8]*t[1]*t[7]+t[0]*t[9]*t[7]+t[4]*t[1]*t[11]-t[0]*t[5]*t[11])*a,(t[4]*t[9]*t[2]-t[8]*t[5]*t[2]+t[8]*t[1]*t[6]-t[0]*t[9]*t[6]-t[4]*t[1]*t[10]+t[0]*t[5]*t[10])*a)}},{key:"inverseTransformNoScale",value:function(){var t=this.arr;return this.set(t[0],t[1],t[2],-t[0]*t[12]-t[1]*t[13]-t[2]*t[14],t[4],t[5],t[6],-t[4]*t[12]-t[5]*t[13]-t[6]*t[14],t[8],t[9],t[10],-t[8]*t[12]-t[9]*t[13]-t[10]*t[14],0,0,0,1)}},{key:"transpose",value:function(){var t=this.arr;return this.set(t[0],t[1],t[2],t[3],t[4],t[5],t[6],t[7],t[8],t[9],t[10],t[11],t[12],t[13],t[14],t[15])}},{key:"makeNormal",value:function(){return this.inverse().transpose()}},{key:"makePerspectiveProjection",value:function(t,n,e,r,i,a){return this.set(2*i/(n-t),0,(n+t)/(n-t),0,0,2*i/(e-r),(e+r)/(e-r),0,0,0,-(a+i)/(a-i),-2*a*i/(a-i),0,0,-1,0)}},{key:"makeOrthographicProjection",value:function(t,n,e,r,i,a){var o=1/(n-t),u=1/(e-r),s=1/(a-i);return this.set(2*o,0,0,-(n+t)*o,0,2*u,0,-(e+r)*u,0,0,-2*s,-(a+i)*s,0,0,0,1)}},{key:"makeScale",value:function(t,n){var e=n-1,r=e*t.x,i=e*t.y,a=r*t.y,o=r*t.z,u=i*t.z;return this.set(1+r*t.x,a,o,0,a,1+i*t.y,u,0,o,u,1+e*t.z*t.z,0,0,0,0,1)}},{key:"makeRotation",value:function(t,n){var e=t.arr,r=Math.cos(n),i=Math.sin(n),a=e[0]*e[0],o=e[1]*e[1],u=e[2]*e[2],s=e[0]*e[1],c=e[0]*e[2],l=e[1]*e[2],h=1-r,f=e[0]*i,v=e[1]*i,m=e[2]*i;return this.set(r+a*h,s*h+m,c*h-v,0,s*h-m,r+o*h,l*h+f,0,c*h+v,l*h-f,r+u*h,0,0,0,0,1)}},{key:"preRotate",value:function(t,n){return this.premultiply(this.mat4.makeRotation(t,n))}},{key:"postRotate",value:function(t,n){return this.postmultiply(this.mat4.makeRotation(t,n))}},{key:"makeRotationX",value:function(t){var n=Math.cos(t),e=Math.sin(t);return this.set(1,0,0,0,0,n,e,0,0,-e,n,0,0,0,0,1)}},{key:"preRotateX",value:function(t){return this.premultiply(this.mat4.makeRotationX(t))}},{key:"postRotateX",value:function(t){return this.postmultiply(this.mat4.makeRotationX(t))}},{key:"makeRotationY",value:function(t){var n=Math.cos(t),e=Math.sin(t);return this.set(n,0,-e,0,0,1,0,0,e,0,n,0,0,0,0,1)}},{key:"preRotateY",value:function(t){return this.premultiply(this.mat4.makeRotationY(t))}},{key:"postRotateY",value:function(t){return this.postmultiply(this.mat4.makeRotationY(t))}},{key:"makeRotationZ",value:function(t){var n=Math.cos(t),e=Math.sin(t);return this.set(n,e,0,0,-e,n,0,0,0,0,1,0,0,0,0,1)}},{key:"preRotateZ",value:function(t){return this.premultiply(this.mat4.makeRotationZ(t))}},{key:"postRotateZ",value:function(t){return this.postmultiply(this.mat4.makeRotationZ(t))}},{key:"makeQuatRotation",value:function(t){var n=t.arr,e=2*n[0]*n[0],r=2*n[1]*n[1],i=2*n[2]*n[2],a=2*n[0]*n[1],o=2*n[0]*n[2],u=2*n[0]*n[3],s=2*n[1]*n[2],c=2*n[1]*n[3],l=2*n[2]*n[3];return this.set(1-r-i,a-l,o+c,0,a+l,1-e-i,s-u,0,o-c,s+u,1-e-r,0,0,0,0,1)}},{key:"preRotateQuat",value:function(t){return this.premultiply(this.mat4.makeQuatRotation(t))}},{key:"postRotateQuat",value:function(t){return this.postmultiply(this.mat4.makeQuatRotation(t))}},{key:"makeTranslation",value:function(t,n){var e=t.arr;return this.set(1,0,0,e[0]*n,0,1,0,e[1]*n,0,0,1,e[2]*n,0,0,0,1)}},{key:"preTranslate",value:function(t,n){return this.premultiply(this.mat4.makeTranslation(t,n))}},{key:"postTranslate",value:function(t,n){return this.postmultiply(this.mat4.makeTranslation(t,n))}},{key:"makeTranslationX",value:function(t){return this.set(1,0,0,t,0,1,0,0,0,0,1,0,0,0,0,1)}},{key:"preTranslateX",value:function(t){return this.premultiply(this.mat4.makeTranslationX(t))}},{key:"postTranslateX",value:function(t){return this.postmultiply(this.mat4.makeTranslationX(t))}},{key:"makeTranslationY",value:function(t){return this.set(1,0,0,0,0,1,0,t,0,0,1,0,0,0,0,1)}},{key:"preTranslateY",value:function(t){return this.premultiply(this.mat4.makeTranslationY(t))}},{key:"postTranslateY",value:function(t){return this.postmultiply(this.mat4.makeTranslationY(t))}},{key:"makeTranslationZ",value:function(t){return this.set(1,0,0,0,0,1,0,0,0,0,1,t,0,0,0,1)}},{key:"preTranslateZ",value:function(t){return this.premultiply(this.mat4.makeTranslationZ(t))}},{key:"postTranslateZ",value:function(t){return this.postmultiply(this.mat4.makeTranslationZ(t))}},{key:"extractRotation",value:function(){var t=this.arr,n=this.vec3.extractScale(this).arr;return this.set(t[0]/n[0],t[4]/n[1],t[8]/n[2],0,t[1]/n[0],t[5]/n[1],t[9]/n[2],0,t[2]/n[0],t[6]/n[1],t[10]/n[2],0,0,0,0,1)}},{key:"injectUniform",value:function(t){var n=this,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"mat4",i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"auto",a=r.currentlyBeingCreated,o=a.uniformCount++,u="uniform ".concat(e.replace(/\[\]/,"").replace(/\[[0-9]+\]/g,"")," ").concat(t),c=null;a.uniforms[t]=this,this.uniformPrograms.push(a),this.uniformProgramIndices[this.uniformProgramCount++]=o,"auto"===i?a.afterLinkingActions.push(function(){c=a.getUniformLocation(t)}):u="layout (location = ".concat(c=i,") ").concat(u);var l=e.match(/\[[0-9]+\]/g),h=l?s["".concat(e.replace(/\[[0-9]+\]/g,""),"[i]")](parseInt(l[0].replace(/\[|\]/g,""),10)):s[e],f=function(){h(c,n.arr),n.uniformStateFlag=0};return a.uniformUpdateFunctionsArray.push(f),a.uniformUpdateFunctionsObject[t]=f,"".concat(u,";")}},{key:"$",value:function(){var t=this.uniformProgramCount-this.uniformStateFlag;this.uniformStateFlag=this.uniformProgramCount;for(var n=0;n<t;n++){this.uniformPrograms[n].uniformStack.push(this.uniformProgramIndices[n])}return a(),this}}]),t}()}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}t.exports=function(t){var n=t.WebGLRenderingContext,i=t.Program,a=t.$,o=t.MAX_PROGRAM_UNIFORM_COUNT,u=n,s={int:function(t,n){return u.uniform1i(t,n[0])},sampler2D:function(t,n){return u.uniform1i(t,n[0])},float:function(t,n){return u.uniform1f(t,n[0])},"int[]":function(t,n){return u.uniform1iv(t,n)},"sampler2D[]":function(t,n){return u.uniform1iv(t,n)},"float[]":function(t,n){return u.uniform1fv(t,n)}};return function(){function t(n){e(this,t),this.class="Vec1",this.arr=n||new Float64Array([0]),this.uniformPrograms=[],this.uniformProgramIndices=new Uint8Array(o),this.uniformProgramCount=0,this.uniformStateFlag=0}var n,u,c;return n=t,(u=[{key:"x",value:function(t){return this.arr[0]=t,this}},{key:"set",value:function(t){return this.arr[0]=t,this}},{key:"reset",value:function(){return this.arr[0]=0,this}},{key:"copy",value:function(t){return this.arr[0]=t.arr[0],this}},{key:"clone",value:function(){return(new t).copy(this)}},{key:"negate",value:function(){return this.arr[0]*=-1,this}},{key:"add",value:function(t){return this.arr[0]+=t.arr[0],this}},{key:"addS",value:function(t){return this.arr[0]+=t,this}},{key:"sub",value:function(t){return this.arr[0]-=t.arr[0],this}},{key:"subS",value:function(t){return this.arr[0]-=t,this}},{key:"mul",value:function(t){return this.arr[0]*=t.arr[0],this}},{key:"mulS",value:function(t){return this.arr[0]*=t,this}},{key:"div",value:function(t){return this.arr[0]/=t.arr[0],this}},{key:"divS",value:function(t){return this.arr[0]/=t,this}},{key:"limit",value:function(t,n){this.arr[0]=Math.max(Math.min(this.arr[0],n),t)}},{key:"injectUniform",value:function(t){var n=this,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"float",r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"auto",a=i.currentlyBeingCreated,o=a.uniformCount++,u="uniform ".concat(e.replace(/\[\]/,"")," ").concat(t),c=null;a.uniforms[t]=this,this.uniformPrograms.push(a),this.uniformProgramIndices[this.uniformProgramCount++]=o,"auto"===r?a.afterLinkingActions.push(function(){c=a.getUniformLocation(t)}):u="layout (location = ".concat(c=r,") ").concat(u);var l=s[e],h=function(){l(c,n.arr),n.uniformStateFlag=0};return a.uniformUpdateFunctionsArray.push(h),a.uniformUpdateFunctionsObject[t]=h,e.match(/\[\]/)&&(u+="[".concat(this.arr.length,"]")),"".concat(u,";")}},{key:"$",value:function(){var t=this.uniformProgramCount-this.uniformStateFlag;this.uniformStateFlag=this.uniformProgramCount;for(var n=0;n<t;n++){this.uniformPrograms[n].uniformStack.push(this.uniformProgramIndices[n])}return a(),this}}])&&r(n.prototype,u),c&&r(n,c),t}()}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function i(t,n,e){return n&&r(t.prototype,n),e&&r(t,e),t}t.exports=function(t){var n=t.WebGLRenderingContext,r=t.Program,a=t.$,o=t.MAX_PROGRAM_UNIFORM_COUNT,u=n,s={"int[]":1,"float[]":1,"ivec2[]":2,"vec2[]":2},c={ivec2:function(t,n){return u.uniform2i(t,n[0],n[1])},vec2:function(t,n){return u.uniform2f(t,n[0],n[1])},"int[]":function(t,n){return u.uniform1iv(t,n)},"float[]":function(t,n){return u.uniform1fv(t,n)},"ivec2[]":function(t,n){return u.uniform2iv(t,n)},"vec2[]":function(t,n){return u.uniform2fv(t,n)}},l=function(){function t(){e(this,t),this.arr=new Float64Array([0,0])}return i(t,[{key:"set",value:function(t,n){var e=this.arr;return e[0]=t,e[1]=n,this}},{key:"copy",value:function(t){var n=t.arr;return this.set(n[0],n[1])}},{key:"mulS",value:function(t){var n=this.arr;return n[0]*=t,n[1]*=t,this}},{key:"mulS2",value:function(t,n){var e=this.arr;return e[0]*=t,e[1]*=n,this}},{key:"makeBezierCurve3Point",value:function(t,n,e,r,i){var a=this.vec2,o=1-i,u=o*o,s=i*i,c=o*u,l=3*i*u,h=3*s*o,f=s*i;return this.reset().add(a.copy(t).mulS(c)).add(a.copy(n).mulS(l)).add(a.copy(e).mulS(h)).add(a.copy(r).mulS(f))}}]),t}();return function(){function t(n){e(this,t),this.class="Vec2",this.arr=n||new Float64Array([0,0]),this.uniformPrograms=[],this.uniformProgramIndices=new Uint8Array(o),this.uniformProgramCount=0,this.uniformStateFlag=0,this.vec2=new l}return i(t,[{key:"x",value:function(t){return this.arr[0]=t,this}},{key:"y",value:function(t){return this.arr[1]=t,this}},{key:"set",value:function(t,n){var e=this.arr;return e[0]=t,e[1]=n,this}},{key:"reset",value:function(){return this.set(0,0)}},{key:"copy",value:function(t){var n=t.arr;return this.set(n[0],n[1])}},{key:"clone",value:function(){return(new t).copy(this)}},{key:"negate",value:function(){var t=this.arr;return t[0]*=-1,t[1]*=-1,this}},{key:"add",value:function(t){var n=this.arr,e=t.arr;return n[0]+=e[0],n[1]+=e[1],this}},{key:"addX",value:function(t){return this.arr[0]+=t,this}},{key:"addY",value:function(t){return this.arr[1]+=t,this}},{key:"addS",value:function(t){var n=this.arr;return n[0]+=t,n[1]+=t,this}},{key:"addS2",value:function(t,n){var e=this.arr;return e[0]+=t,e[1]+=n,this}},{key:"sub",value:function(t){var n=this.arr,e=t.arr;return n[0]-=e[0],n[1]-=e[1],this}},{key:"subX",value:function(t){return this.arr[0]-=t,this}},{key:"subY",value:function(t){return this.arr[1]-=t,this}},{key:"subS",value:function(t){var n=this.arr;return n[0]-=t,n[1]-=t,this}},{key:"subS2",value:function(t,n){var e=this.arr;return e[0]-=t,e[1]-=n,this}},{key:"mul",value:function(t){var n=this.arr,e=t.arr;return n[0]*=e[0],n[1]*=e[1],this}},{key:"mulX",value:function(t){return this.arr[0]*=t,this}},{key:"mulY",value:function(t){return this.arr[1]*=t,this}},{key:"mulS",value:function(t){var n=this.arr;return n[0]*=t,n[1]*=t,this}},{key:"mulS2",value:function(t,n){var e=this.arr;return e[0]*=t,e[1]*=n,this}},{key:"div",value:function(t){var n=this.arr,e=t.arr;return n[0]/=e[0],n[1]/=e[1],this}},{key:"divX",value:function(t){return this.arr[0]/=t,this}},{key:"divY",value:function(t){return this.arr[1]/=t,this}},{key:"divS",value:function(t){var n=this.arr;return n[0]/=t,n[1]/=t,this}},{key:"divS2",value:function(t,n){var e=this.arr;return e[0]/=t,e[1]/=n,this}},{key:"lengthSquare",value:function(){var t=this.arr;return t[0]*t[0]+t[1]*t[1]}},{key:"dot",value:function(t){var n=this.arr,e=t.arr;return n[0]*e[0]+n[1]*e[1]}},{key:"length",value:function(){return Math.sqrt(this.lengthSquare())}},{key:"normalize",value:function(){return this.divS(this.length()||1)}},{key:"angle",value:function(t){return Math.acos(this.dot(t)/Math.sqrt(this.lengthSquare()*t.lengthSquare()))||0}},{key:"projectOnVector",value:function(t){var n=this.dot(t)/t.lengthSquare();return this.copy(t).mulS(n)}},{key:"translate",value:function(t,n){var e=t.arr,r=e[0],i=e[1];return this.addX(r*n).addY(i*n)}},{key:"makeBezierCurve2Point",value:function(t,n,e,r){var i=this.vec2,a=1-r,o=a*a,u=2*r*a,s=r*r;return this.reset().add(i.copy(t).mulS(o)).add(i.copy(n).mulS(u)).add(i.copy(e).mulS(s))}},{key:"makeBezierCurve3Point",value:function(t,n,e,r,i){var a=this.vec2,o=1-i,u=o*o,s=i*i,c=o*u,l=3*i*u,h=3*s*o,f=s*i;return this.reset().add(a.copy(t).mulS(c)).add(a.copy(n).mulS(l)).add(a.copy(e).mulS(h)).add(a.copy(r).mulS(f))}},{key:"limitX",value:function(t,n){this.arr[0]=Math.max(Math.min(this.arr[0],n),t)}},{key:"limitY",value:function(t,n){this.arr[1]=Math.max(Math.min(this.arr[1],n),t)}},{key:"injectUniform",value:function(t){var n=this,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"vec2",i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"auto",a=r.currentlyBeingCreated,o=a.uniformCount++,u="uniform ".concat(e.replace(/\[\]/,"")," ").concat(t),l=null;a.uniforms[t]=this,this.uniformPrograms.push(a),this.uniformProgramIndices[this.uniformProgramCount++]=o,"auto"===i?a.afterLinkingActions.push(function(){l=a.getUniformLocation(t)}):u="layout (location = ".concat(l=i,") ").concat(u);var h=c[e],f=function(){h(l,n.arr),n.uniformStateFlag=0};return a.uniformUpdateFunctionsArray.push(f),a.uniformUpdateFunctionsObject[t]=f,e.match(/\[\]/)&&(u+="[".concat(this.arr.length/s[e],"]")),"".concat(u,";")}},{key:"$",value:function(){var t=this.uniformProgramCount-this.uniformStateFlag;this.uniformStateFlag=this.uniformProgramCount;for(var n=0;n<t;n++){this.uniformPrograms[n].uniformStack.push(this.uniformProgramIndices[n])}return a(),this}}],[{key:"makeBezierCurve3Sequence",value:function(n,e,r,i,a,o){for(var u=new Float64Array(a),s=o||new t,c=0,l=0;l<a;l++){s.makeBezierCurve3Point(n,e,r,i,l/a);var h=1+~(-s.arr[0]*a);u[h]=s.arr[1],u.set(new Array(h-c).fill(u[h]),c+1),c=h}return u.set(new Array(a-c-1).fill(1),c+1),u}},{key:"getIntepolationFunction",value:function(t){var n=t.length;return function(e){return t[1+~(-e*n)]}}}]),t}()}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function i(t,n,e){return n&&r(t.prototype,n),e&&r(t,e),t}t.exports=function(t){var n=t.WebGLRenderingContext,r=t.Program,a=t.$,o=t.MAX_PROGRAM_UNIFORM_COUNT,u=n,s={"int[]":1,"float[]":1,"ivec3[]":3,"vec3[]":3},c={ivec3:function(t,n){return u.uniform3i(t,n[0],n[1],n[2])},vec3:function(t,n){return u.uniform3f(t,n[0],n[1],n[2])},"int[]":function(t,n){return u.uniform1iv(t,n)},"float[]":function(t,n){return u.uniform1fv(t,n)},"ivec3[]":function(t,n){return u.uniform3iv(t,n)},"vec3[]":function(t,n){return u.uniform3fv(t,n)}},l=function(){function t(){e(this,t),this.arr=new Float64Array([1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1])}return i(t,[{key:"set",value:function(t,n,e,r,i,a,o,u,s,c,l,h,f,v,m,y){var p=this.arr;return p[0]=t,p[4]=n,p[8]=e,p[12]=r,p[1]=i,p[5]=a,p[9]=o,p[13]=u,p[2]=s,p[6]=c,p[10]=l,p[14]=h,p[3]=f,p[7]=v,p[11]=m,p[15]=y,this}},{key:"copy",value:function(t){var n=t.arr;return this.set(n[0],n[4],n[8],n[12],n[1],n[5],n[9],n[13],n[2],n[6],n[10],n[14],n[3],n[7],n[11],n[15])}},{key:"inverse",value:function(){var t=this.arr,n=t[9]*t[14]*t[7]-t[13]*t[10]*t[7]+t[13]*t[6]*t[11]-t[5]*t[14]*t[11]-t[9]*t[6]*t[15]+t[5]*t[10]*t[15],e=t[12]*t[10]*t[7]-t[8]*t[14]*t[7]-t[12]*t[6]*t[11]+t[4]*t[14]*t[11]+t[8]*t[6]*t[15]-t[4]*t[10]*t[15],r=t[8]*t[13]*t[7]-t[12]*t[9]*t[7]+t[12]*t[5]*t[11]-t[4]*t[13]*t[11]-t[8]*t[5]*t[15]+t[4]*t[9]*t[15],i=t[12]*t[9]*t[6]-t[8]*t[13]*t[6]-t[12]*t[5]*t[10]+t[4]*t[13]*t[10]+t[8]*t[5]*t[14]-t[4]*t[9]*t[14],a=1/(t[0]*n+t[1]*e+t[2]*r+t[3]*i);return this.set(n*a,e*a,r*a,i*a,(t[13]*t[10]*t[3]-t[9]*t[14]*t[3]-t[13]*t[2]*t[11]+t[1]*t[14]*t[11]+t[9]*t[2]*t[15]-t[1]*t[10]*t[15])*a,(t[8]*t[14]*t[3]-t[12]*t[10]*t[3]+t[12]*t[2]*t[11]-t[0]*t[14]*t[11]-t[8]*t[2]*t[15]+t[0]*t[10]*t[15])*a,(t[12]*t[9]*t[3]-t[8]*t[13]*t[3]-t[12]*t[1]*t[11]+t[0]*t[13]*t[11]+t[8]*t[1]*t[15]-t[0]*t[9]*t[15])*a,(t[8]*t[13]*t[2]-t[12]*t[9]*t[2]+t[12]*t[1]*t[10]-t[0]*t[13]*t[10]-t[8]*t[1]*t[14]+t[0]*t[9]*t[14])*a,(t[5]*t[14]*t[3]-t[13]*t[6]*t[3]+t[13]*t[2]*t[7]-t[1]*t[14]*t[7]-t[5]*t[2]*t[15]+t[1]*t[6]*t[15])*a,(t[12]*t[6]*t[3]-t[4]*t[14]*t[3]-t[12]*t[2]*t[7]+t[0]*t[14]*t[7]+t[4]*t[2]*t[15]-t[0]*t[6]*t[15])*a,(t[4]*t[13]*t[3]-t[12]*t[5]*t[3]+t[12]*t[1]*t[7]-t[0]*t[13]*t[7]-t[4]*t[1]*t[15]+t[0]*t[5]*t[15])*a,(t[12]*t[5]*t[2]-t[4]*t[13]*t[2]-t[12]*t[1]*t[6]+t[0]*t[13]*t[6]+t[4]*t[1]*t[14]-t[0]*t[5]*t[14])*a,(t[9]*t[6]*t[3]-t[5]*t[10]*t[3]-t[9]*t[2]*t[7]+t[1]*t[10]*t[7]+t[5]*t[2]*t[11]-t[1]*t[6]*t[11])*a,(t[4]*t[10]*t[3]-t[8]*t[6]*t[3]+t[8]*t[2]*t[7]-t[0]*t[10]*t[7]-t[4]*t[2]*t[11]+t[0]*t[6]*t[11])*a,(t[8]*t[5]*t[3]-t[4]*t[9]*t[3]-t[8]*t[1]*t[7]+t[0]*t[9]*t[7]+t[4]*t[1]*t[11]-t[0]*t[5]*t[11])*a,(t[4]*t[9]*t[2]-t[8]*t[5]*t[2]+t[8]*t[1]*t[6]-t[0]*t[9]*t[6]-t[4]*t[1]*t[10]+t[0]*t[5]*t[10])*a)}}]),t}(),h=function(){function t(){e(this,t),this.arr=new Float64Array([0,0,0])}return i(t,[{key:"set",value:function(t,n,e){var r=this.arr;return r[0]=t,r[1]=n,r[2]=e,this}},{key:"copy",value:function(t){var n=t.arr;return this.set(n[0],n[1],n[2])}},{key:"sub",value:function(t){var n=this.arr,e=t.arr;return n[0]-=e[0],n[1]-=e[1],n[2]-=e[2],this}},{key:"mulS",value:function(t){var n=this.arr;return n[0]*=t,n[1]*=t,n[2]*=t,this}},{key:"mulS2",value:function(t,n,e){var r=this.arr;return r[0]*=t,r[1]*=n,r[2]*=e,this}},{key:"extractTranslation",value:function(t){var n=t.arr;return this.set(n[12],n[13],n[14])}}]),t}();return function(){function t(n){e(this,t),this.class="Vec3",this.arr=n||new Float64Array([0,0,0]),this.uniformPrograms=[],this.uniformProgramIndices=new Uint8Array(o),this.uniformProgramCount=0,this.uniformStateFlag=0,this.mat4=new l,this.vec3=new h}return i(t,[{key:"x",value:function(t){return this.arr[0]=t,this}},{key:"y",value:function(t){return this.arr[1]=t,this}},{key:"z",value:function(t){return this.arr[2]=t,this}},{key:"set",value:function(t,n,e){var r=this.arr;return r[0]=t,r[1]=n,r[2]=e,this}},{key:"reset",value:function(){return this.set(0,0,0)}},{key:"copy",value:function(t){var n=t.arr;return this.set(n[0],n[1],n[2])}},{key:"clone",value:function(){return(new t).copy(this)}},{key:"negate",value:function(){var t=this.arr;return t[0]*=-1,t[1]*=-1,t[2]*=-1,this}},{key:"add",value:function(t){var n=this.arr,e=t.arr;return n[0]+=e[0],n[1]+=e[1],n[2]+=e[2],this}},{key:"addX",value:function(t){return this.arr[0]+=t,this}},{key:"addY",value:function(t){return this.arr[1]+=t,this}},{key:"addZ",value:function(t){return this.arr[2]+=t,this}},{key:"addS",value:function(t){var n=this.arr;return n[0]+=t,n[1]+=t,n[2]+=t,this}},{key:"addS2",value:function(t,n,e){var r=this.arr;return r[0]+=t,r[1]+=n,r[2]+=e,this}},{key:"sub",value:function(t){var n=this.arr,e=t.arr;return n[0]-=e[0],n[1]-=e[1],n[2]-=e[2],this}},{key:"subX",value:function(t){return this.arr[0]-=t,this}},{key:"subY",value:function(t){return this.arr[1]-=t,this}},{key:"subZ",value:function(t){return this.arr[2]-=t,this}},{key:"subS",value:function(t){var n=this.arr;return n[0]-=t,n[1]-=t,n[2]-=t,this}},{key:"subS2",value:function(t,n,e){var r=this.arr;return r[0]-=t,r[1]-=n,r[2]-=e,this}},{key:"mul",value:function(t){var n=this.arr,e=t.arr;return n[0]*=e[0],n[1]*=e[1],n[2]*=e[2],this}},{key:"mulX",value:function(t){return this.arr[0]*=t,this}},{key:"mulY",value:function(t){return this.arr[1]*=t,this}},{key:"mulZ",value:function(t){return this.arr[2]*=t,this}},{key:"mulS",value:function(t){var n=this.arr;return n[0]*=t,n[1]*=t,n[2]*=t,this}},{key:"mulS2",value:function(t,n,e){var r=this.arr;return r[0]*=t,r[1]*=n,r[2]*=e,this}},{key:"div",value:function(t){var n=this.arr,e=t.arr;return n[0]/=e[0],n[1]/=e[1],n[2]/=e[2],this}},{key:"divX",value:function(t){return this.arr[0]/=t,this}},{key:"divY",value:function(t){return this.arr[1]/=t,this}},{key:"divZ",value:function(t){return this.arr[2]/=t,this}},{key:"divS",value:function(t){var n=this.arr;return n[0]/=t,n[1]/=t,n[2]/=t,this}},{key:"divS2",value:function(t,n,e){var r=this.arr;return r[0]/=t,r[1]/=n,r[2]/=e,this}},{key:"cross",value:function(t,n){var e=t.arr,r=n.arr;return this.set(e[1]*r[2]-e[2]*r[1],e[2]*r[0]-e[0]*r[2],e[0]*r[1]-e[1]*r[0])}},{key:"lengthSquare",value:function(){var t=this.arr;return t[0]*t[0]+t[1]*t[1]+t[2]*t[2]}},{key:"dot",value:function(t){var n=this.arr,e=t.arr;return n[0]*e[0]+n[1]*e[1]+n[2]*e[2]}},{key:"length",value:function(){return Math.sqrt(this.lengthSquare())}},{key:"normalize",value:function(){var t=this.length()||1;return this.divS(t)}},{key:"angle",value:function(t){return Math.acos(this.dot(t)/Math.sqrt(this.lengthSquare()*t.lengthSquare()))||0}},{key:"extractTranslation",value:function(t){var n=t.arr;return this.set(n[12],n[13],n[14])}},{key:"extractScale",value:function(t){var n=t.arr,e=this.vec3.set(n[0],n[1],n[2]).length(),r=this.vec3.set(n[4],n[5],n[6]).length(),i=this.vec3.set(n[8],n[9],n[10]).length();return this.set(e,r,i)}},{key:"applyMat4",value:function(t){var n=this.arr,e=t.arr,r=1/(e[3]*n[0]+e[7]*n[1]+e[11]*n[2]+e[15]);return this.set((e[0]*n[0]+e[4]*n[1]+e[8]*n[2]+e[12])*r,(e[1]*n[0]+e[5]*n[1]+e[9]*n[2]+e[13])*r,(e[2]*n[0]+e[6]*n[1]+e[10]*n[2]+e[14])*r)}},{key:"applyQuat",value:function(t){var n=this.arr,e=t.arr,r=e[0]*e[0]*2,i=e[0]*e[1]*2,a=e[0]*e[2]*2,o=e[1]*e[1]*2,u=e[1]*e[2]*2,s=e[2]*e[2]*2,c=e[3]*e[0]*2,l=e[3]*e[1]*2,h=e[3]*e[2]*2,f=n[0],v=n[1],m=n[2];return this.set((1-(o+s))*f+(i-h)*v+(a+l)*m,(i+h)*f+(1-(r+s))*v+(u-c)*m,(a-l)*f+(u+c)*v+(1-(r+o))*m)}},{key:"projectPerspective",value:function(t,n){return this.applyMat4(t).applyMat4(n)}},{key:"projectPerspective2",value:function(t){return this.applyMat4(t.viewMatrix).applyMat4(t.projectionMatrix)}},{key:"unprojectPerspective",value:function(t,n){var e=this.mat4;return this.applyMat4(e.copy(n).inverse()).applyMat4(e.copy(t).inverse())}},{key:"unprojectPerspective2",value:function(t){var n=this.mat4;return this.applyMat4(n.copy(t.projectionMatrix).inverse()).applyMat4(n.copy(t.viewMatrix).inverse())}},{key:"directToScreenCoords",value:function(t,n,e,r){return this.set(t,n,.5).unprojectPerspective(e,r).sub(this.vec3.extractTranslation(this.mat4.copy(e).inverse())).normalize()}},{key:"directToScreenCoords2",value:function(t,n,e){return this.set(t,n,.5).unprojectPerspective(e.viewMatrix,e.projectionMatrix).sub(this.vec3.extractTranslation(this.mat4.copy(e.viewMatrix).inverse())).normalize()}},{key:"getDistanceToPlane",value:function(t,n){return this.dot(t)+n}},{key:"projectOnPlane",value:function(t,n){var e=this.arr,r=e[0],i=e[1],a=e[2],o=-this.getDistanceToPlane(t,n);return this.copy(t).mulS(o).addS2(r,i,a)}},{key:"intersectPlane",value:function(t,n,e){var r=this.vec3,i=n.dot(r.copy(e).sub(t)),a=n.dot(this);return r.copy(this),this.copy(t).add(r.mulS(i/a))}},{key:"projectOnVector",value:function(t){var n=this.dot(t)/t.lengthSquare();return this.copy(t).mulS(n,n,n)}},{key:"verticalize",value:function(t){return this.cross(this,t)}},{key:"translate",value:function(t,n){var e=t.arr,r=e[0],i=e[1],a=e[2];return this.addS2(r*n,i*n,a*n)}},{key:"makeFromHex",value:function(t){return this.set(parseInt("0x".concat(t[0]).concat(t[1]),16)/255,parseInt("0x".concat(t[2]).concat(t[3]),16)/255,parseInt("0x".concat(t[4]).concat(t[5]),16)/255)}},{key:"makeBezierCurve2Point",value:function(t,n,e,r){var i=this.vec3,a=1-r,o=a*a,u=2*r*a,s=r*r;return this.reset().add(i.copy(t).mulS(o)).add(i.copy(n).mulS(u)).add(i.copy(e).mulS(s))}},{key:"makeBezierCurve3Point",value:function(t,n,e,r,i){var a=this.vec3,o=1-i,u=o*o,s=i*i,c=o*u,l=3*i*u,h=3*s*o,f=s*i;return this.reset().add(a.copy(t).mulS(c)).add(a.copy(n).mulS(l)).add(a.copy(e).mulS(h)).add(a.copy(r).mulS(f))}},{key:"makeCatmullRomSpline3ControlPoint",value:function(t,n,e,r){var i=.5*r;return this.reset().add(e).sub(t).mulS(i).add(n)}},{key:"limitX",value:function(t,n){this.arr[0]=Math.max(Math.min(this.arr[0],n),t)}},{key:"limitY",value:function(t,n){this.arr[1]=Math.max(Math.min(this.arr[1],n),t)}},{key:"limitZ",value:function(t,n){this.arr[2]=Math.max(Math.min(this.arr[2],n),t)}},{key:"injectUniform",value:function(t){var n=this,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"vec3",i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"auto",a=r.currentlyBeingCreated,o=a.uniformCount++,u="uniform ".concat(e.replace(/\[\]/,"")," ").concat(t),l=null;a.uniforms[t]=this,this.uniformPrograms.push(a),this.uniformProgramIndices[this.uniformProgramCount++]=o,"auto"===i?a.afterLinkingActions.push(function(){l=a.getUniformLocation(t)}):u="layout (location = ".concat(l=i,") ").concat(u);var h=c[e],f=function(){h(l,n.arr),n.uniformStateFlag=0};return a.uniformUpdateFunctionsArray.push(f),a.uniformUpdateFunctionsObject[t]=f,e.match(/\[\]/)&&(u+="[".concat(this.arr.length/s[e],"]")),"".concat(u,";")}},{key:"$",value:function(){var t=this.uniformProgramCount-this.uniformStateFlag;this.uniformStateFlag=this.uniformProgramCount;for(var n=0;n<t;n++){this.uniformPrograms[n].uniformStack.push(this.uniformProgramIndices[n])}return a(),this}}],[{key:"makeCatmullRomSpline3Points",value:function(n,e,r,i,a){for(var o=[],u=i||new t,s=a||new t,c=0;c<n.length-1;c++)for(var l=n[c-1]||n[c-1+n.length],h=n[c],f=n[c+1]||n[c+1-n.length],v=n[c+2]||n[c+2-n.length],m=0;m<e;m++){u.makeCatmullRomSpline3ControlPoint(l,h,f,r),s.makeCatmullRomSpline3ControlPoint(h,f,v,-r);var y=m/e,p=new t;0===c?p.makeBezierCurve2Point(h,s,f,y):c===n.length-2?p.makeBezierCurve2Point(h,u,f,y):p.makeBezierCurve3Point(h,u,s,f,y),o.push(p)}return o}},{key:"makeCatmullRomSpline3PointsClosed",value:function(n,e,r,i,a){for(var o=[],u=i||new t,s=a||new t,c=0;c<n.length;c++)for(var l=n[c-1]||n[c-1+n.length],h=n[c],f=n[c+1]||n[c+1-n.length],v=n[c+2]||n[c+2-n.length],m=0;m<e;m++){u.makeCatmullRomSpline3ControlPoint(l,h,f,r),s.makeCatmullRomSpline3ControlPoint(h,f,v,-r);var y=m/e,p=(new t).makeBezierCurve3Point(h,u,s,f,y);o.push(p)}return o}}]),t}()}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}t.exports=function(t){var n=t.WebGLRenderingContext,i=t.Program,a=t.$,o=t.MAX_PROGRAM_UNIFORM_COUNT,u=n,s={"int[]":1,"float[]":1,"ivec4[]":4,"vec4[]":4},c={ivec4:function(t,n){return u.uniform4i(t,n[0],n[1],n[2],n[3])},vec4:function(t,n){return u.uniform4f(t,n[0],n[1],n[2],n[3])},"int[]":function(t,n){return u.uniform1iv(t,n)},"float[]":function(t,n){return u.uniform1fv(t,n)},"ivec4[]":function(t,n){return u.uniform4iv(t,n)},"vec4[]":function(t,n){return u.uniform4fv(t,n)},"float[i]":function(t){return function(n,e){return u.uniform1i(n,e[t])}},"int[i]":function(t){return function(n,e){return u.uniform1f(n,e[t])}},"ivec2[i]":function(t){return function(n,e){return u.uniform2i(n,e[t],e[t+1])}},"vec2[i]":function(t){return function(n,e){return u.uniform2f(n,e[t],e[t+1])}},"ivec3[i]":function(t){return function(n,e){return u.uniform3i(n,e[t],e[t+1],e[t+2])}},"vec3[i]":function(t){return function(n,e){return u.uniform3f(n,e[t],e[t+1],e[t+2])}},"ivec4[i]":function(t){return function(n,e){return u.uniform4i(n,e[t],e[t+1],e[t+2],e[t+3])}},"vec4[i]":function(t){return function(n,e){return u.uniform4f(n,e[t],e[t+1],e[t+2],e[t+3])}}};return function(){function t(n){e(this,t),this.class="Vec4",this.arr=n||new Float64Array([0,0,0,1]),this.uniformPrograms=[],this.uniformProgramIndices=new Uint8Array(o),this.uniformProgramCount=0,this.uniformStateFlag=0}var n,u,l;return n=t,(u=[{key:"x",value:function(t){return this.arr[0]=t,this}},{key:"y",value:function(t){return this.arr[1]=t,this}},{key:"z",value:function(t){return this.arr[2]=t,this}},{key:"w",value:function(t){return this.arr[3]=t,this}},{key:"set",value:function(t,n,e,r){var i=this.arr;return i[0]=t,i[1]=n,i[2]=e,i[3]=r,this}},{key:"reset",value:function(){return this.set(0,0,0,1)}},{key:"copy",value:function(t){var n=t.arr;return this.set(n[0],n[1],n[2],n[3])}},{key:"clone",value:function(){return(new t).copy(this)}},{key:"negate",value:function(){var t=this.arr;return t[0]*=-1,t[1]*=-1,t[2]*=-1,t[3]*=-1,this}},{key:"add",value:function(t){var n=this.arr,e=t.arr;return n[0]+=e[0],n[1]+=e[1],n[2]+=e[2],n[3]+=e[3],this}},{key:"addX",value:function(t){return this.arr[0]+=t,this}},{key:"addY",value:function(t){return this.arr[1]+=t,this}},{key:"addZ",value:function(t){return this.arr[2]+=t,this}},{key:"addW",value:function(t){return this.arr[3]+=t,this}},{key:"addS",value:function(t){var n=this.arr;return n[0]+=t,n[1]+=t,n[2]+=t,n[3]+=t,this}},{key:"addS2",value:function(t,n,e,r){var i=this.arr;return i[0]+=t,i[1]+=n,i[2]+=e,i[3]+=r,this}},{key:"sub",value:function(t){var n=this.arr,e=t.arr;return n[0]-=e[0],n[1]-=e[1],n[2]-=e[2],n[3]-=e[3],this}},{key:"subX",value:function(t){return this.arr[0]-=t,this}},{key:"subY",value:function(t){return this.arr[1]-=t,this}},{key:"subZ",value:function(t){return this.arr[2]-=t,this}},{key:"subW",value:function(t){return this.arr[2]-=t,this}},{key:"subS",value:function(t){var n=this.arr;return n[0]-=t,n[1]-=t,n[2]-=t,n[3]-=t,this}},{key:"subS2",value:function(t,n,e,r){var i=this.arr;return i[0]-=t,i[1]-=n,i[2]-=e,i[3]-=r,this}},{key:"mul",value:function(t){var n=this.arr,e=t.arr;return n[0]*=e[0],n[1]*=e[1],n[2]*=e[2],n[3]*=e[3],this}},{key:"mulX",value:function(t){return this.arr[0]*=t,this}},{key:"mulY",value:function(t){return this.arr[1]*=t,this}},{key:"mulZ",value:function(t){return this.arr[2]*=t,this}},{key:"mulW",value:function(t){return this.arr[3]*=t,this}},{key:"mulS",value:function(t){var n=this.arr;return n[0]*=t,n[1]*=t,n[2]*=t,n[3]*=t,this}},{key:"mulS2",value:function(t,n,e,r){var i=this.arr;return i[0]*=t,i[1]*=n,i[2]*=e,i[3]*=r,this}},{key:"div",value:function(t){var n=this.arr,e=t.arr;return n[0]/=e[0],n[1]/=e[1],n[2]/=e[2],n[3]/=e[3],this}},{key:"divX",value:function(t){return this.arr[0]/=t,this}},{key:"divY",value:function(t){return this.arr[1]/=t,this}},{key:"divZ",value:function(t){return this.arr[2]/=t,this}},{key:"divW",value:function(t){return this.arr[3]/=t,this}},{key:"divS",value:function(t){var n=this.arr;return n[0]/=t,n[1]/=t,n[2]/=t,n[3]/=t,this}},{key:"divS2",value:function(t,n,e,r){var i=this.arr;return i[0]/=t,i[1]/=n,i[2]/=e,i[3]/=r,this}},{key:"lengthSquare",value:function(){var t=this.arr;return t[0]*t[0]+t[1]*t[1]+t[2]*t[2]+t[3]*t[3]}},{key:"dot",value:function(t){var n=this.arr,e=t.arr;return n[0]*e[0]+n[1]*e[1]+n[2]*e[2]+n[3]*e[3]}},{key:"length",value:function(){return Math.sqrt(this.lengthSquare())}},{key:"normalize",value:function(){var t=this.length()||1;return this.divS(t)}},{key:"makeFromHex",value:function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;return this.set(parseInt("0x".concat(t[0]).concat(t[1]),16)/255,parseInt("0x".concat(t[2]).concat(t[3]),16)/255,parseInt("0x".concat(t[4]).concat(t[5]),16)/255,n)}},{key:"limitX",value:function(t,n){this.arr[0]=Math.max(Math.min(this.arr[0],n),t)}},{key:"limitY",value:function(t,n){this.arr[1]=Math.max(Math.min(this.arr[1],n),t)}},{key:"limitZ",value:function(t,n){this.arr[2]=Math.max(Math.min(this.arr[2],n),t)}},{key:"limitW",value:function(t,n){this.arr[3]=Math.max(Math.min(this.arr[3],n),t)}},{key:"injectUniform",value:function(t){var n=this,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"vec4",r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"auto",a=i.currentlyBeingCreated,o=a.uniformCount++,u="uniform ".concat(e.replace(/\[\]/,"").replace(/\[[0-9]+\]/g,"")," ").concat(t),l=null;a.uniforms[t]=this,this.uniformPrograms.push(a),this.uniformProgramIndices[this.uniformProgramCount++]=o,"auto"===r?a.afterLinkingActions.push(function(){l=a.getUniformLocation(t)}):u="layout (location = ".concat(l=r,") ").concat(u);var h=e.match(/\[[0-9]+\]/g),f=h?c["".concat(e.replace(/\[[0-9]+\]/g,""),"[i]")](parseInt(h[0].replace(/\[|\]/g,""),10)):c[e],v=function(){f(l,n.arr),n.uniformStateFlag=0};return a.uniformUpdateFunctionsArray.push(v),a.uniformUpdateFunctionsObject[t]=v,e.match(/\[\]/)&&(u+="[".concat(this.arr.length/s[e],"]")),"".concat(u,";")}},{key:"$",value:function(){var t=this.uniformProgramCount-this.uniformStateFlag;this.uniformStateFlag=this.uniformProgramCount;for(var n=0;n<t;n++){this.uniformPrograms[n].uniformStack.push(this.uniformProgramIndices[n])}return a(),this}}])&&r(n.prototype,u),l&&r(n,l),t}()}},function(t,n){function e(t){return(e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function r(t,n){return!n||"object"!==e(n)&&"function"!=typeof n?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):n}function i(t){return(i=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function a(t,n){return(a=Object.setPrototypeOf||function(t,n){return t.__proto__=n,t})(t,n)}function o(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function u(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function s(t,n,e){return n&&u(t.prototype,n),e&&u(t,e),t}t.exports=function(t){var n=t.WebGLRenderingContext,e=t.Program,u=t.Vec4,c=t.$,l=n,h={ivec4:function(t,n){return l.uniform4i(t,n[0],n[1],n[2],n[3])},vec4:function(t,n){return l.uniform4f(t,n[0],n[1],n[2],n[3])},"ivec4[]":function(t,n){return l.uniform4iv(t,n)},"vec4[]":function(t,n){return l.uniform4fv(t,n)}},f=function(){function t(){o(this,t),this.arr=new Float64Array([0,0,0,1])}return s(t,[{key:"set",value:function(t,n,e,r){var i=this.arr;return i[0]=t,i[1]=n,i[2]=e,i[3]=r,this}},{key:"copy",value:function(t){var n=t.arr;return this.set(n[0],n[1],n[2],n[3])}},{key:"add",value:function(t){var n=this.arr,e=t.arr;return n[0]+=e[0],n[1]+=e[1],n[2]+=e[2],n[3]+=e[3],this}},{key:"mulS",value:function(t){var n=this.arr;return n[0]*=t,n[1]*=t,n[2]*=t,n[3]*=t,this}},{key:"mulS2",value:function(t,n,e,r){var i=this.arr;return i[0]*=t,i[1]*=n,i[2]*=e,i[3]*=r,this}},{key:"makeRotation",value:function(t,n){var e=t.arr,r=.5*n,i=Math.sin(r);return this.set(e[0]*i,e[1]*i,e[2]*i,Math.cos(r))}},{key:"makeRotationX",value:function(t){var n=.5*t;return this.set(Math.sin(n),0,0,Math.cos(n))}},{key:"makeRotationY",value:function(t){var n=.5*t;return this.set(0,Math.sin(n),0,Math.cos(n))}},{key:"makeRotationZ",value:function(t){var n=.5*t;return this.set(0,0,Math.sin(n),Math.cos(n))}}]),t}();return function(t){function n(t){var e;return o(this,n),(e=r(this,i(n).call(this,t))).class="Quat",e.quat=new f,e.quat_=new f,e}return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),n&&a(t,n)}(n,u),s(n,[{key:"multiply",value:function(t,n){var e=t.arr,r=n.arr;this.set(e[0]*r[3]+e[3]*r[0]+e[1]*r[2]-e[2]*r[1],e[1]*r[3]+e[3]*r[1]+e[2]*r[0]-e[0]*r[2],e[2]*r[3]+e[3]*r[2]+e[0]*r[1]-e[1]*r[0],e[3]*r[3]-e[0]*r[0]-e[1]*r[1]-e[2]*r[2])}},{key:"conjugate",value:function(){var t=this.arr;return t[0]=-t[0],t[1]=-t[1],t[2]=-t[2],this}},{key:"premultiply",value:function(t){return this.multiply(t,this)}},{key:"postmultiply",value:function(t){return this.multiply(this,t)}},{key:"makeRotation",value:function(t,n){var e=t.arr,r=.5*n,i=Math.sin(r);return this.set(e[0]*i,e[1]*i,e[2]*i,Math.cos(r))}},{key:"preRotate",value:function(t,n){return this.premultiply(this.quat.makeRotation(t,n))}},{key:"postRotate",value:function(t,n){return this.postmultiply(this.quat.makeRotation(t,n))}},{key:"makeRotationX",value:function(t){var n=.5*t;return this.set(Math.sin(n),0,0,Math.cos(n))}},{key:"preRotateX",value:function(t){return this.premultiply(this.quat.makeRotationX(t))}},{key:"postRotateX",value:function(t){return this.postmultiply(this.quat.makeRotationX(t))}},{key:"makeRotationY",value:function(t){var n=.5*t;return this.set(0,Math.sin(n),0,Math.cos(n))}},{key:"preRotateY",value:function(t){return this.premultiply(this.quat.makeRotationY(t))}},{key:"postRotateY",value:function(t){return this.postmultiply(this.quat.makeRotationY(t))}},{key:"makeRotationZ",value:function(t){var n=.5*t;return this.set(0,0,Math.sin(n),Math.cos(n))}},{key:"preRotateZ",value:function(t){return this.premultiply(this.quat.makeRotationZ(t))}},{key:"postRotateZ",value:function(t){return this.postmultiply(this.quat.makeRotationZ(t))}},{key:"slerp",value:function(t,n,e){var r=t.dot(n),i=Math.acos(r),a=i*e,o=Math.sin(a),u=Math.sin(i),s=Math.cos(a)-r*o/u,c=o/u;return this.copy(this.quat.copy(t).mulS(s).add(this.quat_.copy(n).mulS(c)))}},{key:"extractFromMat4",value:function(t){var n=t.arr,e=.5*Math.sqrt(1+n[0]+n[5]+n[10]),r=4*e;this.set((n[9]-n[6])/r,(n[2]-n[8])/r,(n[4]-n[1])/r,e)}},{key:"injectUniform",value:function(t){var n=this,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"vec4",i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"auto",a=e.currentlyBeingCreated,o=a.uniformCount++,u="uniform ".concat(r.replace(/\[\]/,"")," ").concat(t),s=null;a.uniforms[t]=this,this.uniformPrograms.push(a),this.uniformProgramIndices[this.uniformProgramCount++]=o,"auto"===i?a.afterLinkingActions.push(function(){s=a.getUniformLocation(t)}):u="layout (location = ".concat(s=i,") ").concat(u);var c=h[r],l=function(){c(s,n.arr),n.uniformStateFlag=0};return a.uniformUpdateFunctionsArray.push(l),a.uniformUpdateFunctionsObject[t]=l,r.match(/\[\]/)&&(u+="[".concat(this.arr.length,"]")),"".concat(u,";")}},{key:"$",value:function(){var t=this.uniformProgramCount-this.uniformStateFlag;this.uniformStateFlag=this.uniformProgramCount;for(var n=0;n<t;n++){this.uniformPrograms[n].uniformStack.push(this.uniformProgramIndices[n])}return c(),this}}]),n}()}},function(t,n){function e(t){return(e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function r(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function i(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function a(t,n){return!n||"object"!==e(n)&&"function"!=typeof n?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):n}function o(t){return(o=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function u(t,n){return(u=Object.setPrototypeOf||function(t,n){return t.__proto__=n,t})(t,n)}t.exports=function(t){var n=t.WebGLRenderingContext,e=t.Buffer,s=n,c=s.ARRAY_BUFFER,l=s.STATIC_DRAW,h=s.FLOAT;return function(t){function n(){var t;return r(this,n),(t=a(this,o(n).call(this))).class="VertexBuffer",t}var f,v,m;return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),n&&u(t,n)}(n,e),f=n,m=[{key:"bind",value:function(t){return s.bindBuffer(c,t.handle),n}},{key:"unbind",value:function(){return s.bindBuffer(c,null),n}},{key:"data",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l;return s.bufferData(c,t,e),n}},{key:"subData",value:function(t,e){return s.bufferSubData(c,t,e),n}}],(v=[{key:"bind",value:function(){return s.bindBuffer(c,this.handle),this}},{key:"data",value:function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l;return s.bufferData(c,t,n),this}},{key:"subData",value:function(t,n){return s.bufferSubData(c,t,n),this}},{key:"attrib",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:3,e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:h,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0;return s.vertexAttribPointer(t,n,e,r,i,a),this}}])&&i(f.prototype,v),m&&i(f,m),n}()}},function(t,n){function e(t){return(e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function r(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function i(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function a(t,n){return!n||"object"!==e(n)&&"function"!=typeof n?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):n}function o(t){return(o=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function u(t,n){return(u=Object.setPrototypeOf||function(t,n){return t.__proto__=n,t})(t,n)}t.exports=function(t){var n=t.WebGLRenderingContext,e=t.Buffer,s=n,c=s.ELEMENT_ARRAY_BUFFER,l=s.STATIC_DRAW;return function(t){function n(){var t;return r(this,n),(t=a(this,o(n).call(this))).class="IndexBuffer",t}var h,f,v;return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),n&&u(t,n)}(n,e),h=n,v=[{key:"bind",value:function(t){return s.bindBuffer(c,t.handle),n}},{key:"unbind",value:function(){return s.bindBuffer(c,null),n}},{key:"data",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l;return s.bufferData(c,t,e),n}},{key:"subData",value:function(t,e){return s.bufferSubData(c,t,e),n}}],(f=[{key:"bind",value:function(){return s.bindBuffer(c,this.handle),this}},{key:"data",value:function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l;return s.bufferData(c,t,n),this}},{key:"subData",value:function(t,n){return s.bufferSubData(c,t,n),this}}])&&i(h.prototype,f),v&&i(h,v),n}()}},function(t,n){function e(t){return(e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function r(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function i(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function a(t,n){return!n||"object"!==e(n)&&"function"!=typeof n?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):n}function o(t){return(o=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function u(t,n){return(u=Object.setPrototypeOf||function(t,n){return t.__proto__=n,t})(t,n)}t.exports=function(t){var n=t.WebGLRenderingContext,e=t.Texture,s=n,c=s.TEXTURE_2D;return function(t){function n(){var t;return r(this,n),(t=a(this,o(n).call(this))).class="Texture2D",t}var l,h,f;return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),n&&u(t,n)}(n,e),l=n,f=[{key:"bind",value:function(t){return e.bind(c,t),n}},{key:"unbind",value:function(){return e.unbind(c),n}},{key:"delete",value:function(t){return e.delete(t),n}},{key:"unit",value:function(t){return e.unit(t),n}},{key:"image2D",value:function(t,r,i,a,o){return e.image2D(c,t,r,i,a,o),n}},{key:"image2D2",value:function(t,r,i,a,o,u,s,l){return e.image2D2(c,t,r,i,a,o,u,s,l),n}},{key:"mipmap",value:function(){return e.mipmap(c),n}},{key:"parameteri",value:function(t,r){return e.parameteri(c,t,r),n}},{key:"parameterf",value:function(t,r){return e.parameterf(c,t,r),n}}],(h=[{key:"bind",value:function(){return s.bindTexture(c,this.handle),this}},{key:"delete",value:function(){return s.deleteTexture(this.handle),this}}])&&i(l.prototype,h),f&&i(l,f),n}()}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}t.exports=function(t){var n=t.Mat4;return function(){function t(){e(this,t),this.class="Camera",this.viewMatrix=new n,this.projectionMatrix=new n}var i,a,o;return i=t,(a=[{key:"setPerspectiveProjection",value:function(t,n,e,r,i){var a=e*Math.tan(.008726646*t)/i,o=2*a,u=n*o,s=-.5*u;return this.projectionMatrix.makePerspectiveProjection(s,s+u,a,a-o,e,r),this}},{key:"setOrthographicProjection",value:function(t,n,e,r,i,a,o){var u=(n-t)/(2*o),s=(e-r)/(2*o),c=(n+t)/2,l=(e+r)/2,h=c-u,f=c+u,v=l+s,m=l-s;return this.projectionMatrix.makeOrthographicProjection(h,f,v,m,i,a),this}},{key:"$",value:function(){return this.viewMatrix.$(),this.projectionMatrix.$(),this}}])&&r(i.prototype,a),o&&r(i,o),t}()}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}t.exports=function(t){var n=t.Vec3,i=t.Quat,a=t.Mat4,o={quat:new i,matrix:new a},u=(new n).x(1),s=(new n).y(1),c=(new n).z(1);return function(){function t(){e(this,t),this.class="Obj",this.parent=o,this.origin=new n,this.scale=new n,this.quat=new i,this.translation=new n,this.matrix=new a,this.mat=new a,this.vec=new n,this.quat_=new i}var l,h,f;return l=t,(h=[{key:"copy",value:function(t){return this.origin.copy(t.origin),this.scale.copy(t.scale),this.quat.copy(t.quat),this.translation.copy(t.translation),this.matrix.copy(t.matrix),this}},{key:"clone",value:function(){var n=new t;return n.parent=this.parent,n.origin.copy(this.origin),n.scale.copy(this.scale),n.quat.copy(this.quat),n.translation.copy(this.translation),n.matrix.copy(this.matrix),n}},{key:"attach",value:function(t){return this.parent=t,this}},{key:"unbind",value:function(){return this.parent=o,this}},{key:"setRotation",value:function(t,n){return this.quat.makeRotation(t,n),this}},{key:"setRotationX",value:function(t){return this.quat.makeRotationX(t),this}},{key:"setRotationY",value:function(t){return this.quat.makeRotationY(t),this}},{key:"setRotationZ",value:function(t){return this.quat.makeRotationZ(t),this}},{key:"preRotate",value:function(t,n){return this.quat.preRotate(t,n),this}},{key:"preRotateX",value:function(t){return this.quat.preRotateX(t),this}},{key:"preRotateY",value:function(t){return this.quat.preRotateY(t),this}},{key:"preRotateZ",value:function(t){return this.quat.preRotateZ(t),this}},{key:"postRotate",value:function(t,n){return this.quat.postRotate(t,n),this}},{key:"postRotateX",value:function(t){return this.quat.postRotateX(t),this}},{key:"postRotateY",value:function(t){return this.quat.postRotateY(t),this}},{key:"postRotateZ",value:function(t){return this.quat.postRotateZ(t),this}},{key:"getDirectionX",value:function(){return(new n).copy(u).applyQuat(this.quat)}},{key:"setDirectionX",value:function(t){return this.vec.cross(u,t).normalize(),this.setRotation(this.vec,u.angle(t))}},{key:"getDirectionY",value:function(){return(new n).copy(s).applyQuat(this.quat)}},{key:"setDirectionY",value:function(t){return this.vec.cross(s,t).normalize(),this.setRotation(this.vec,s.angle(t))}},{key:"getDirectionZ",value:function(){return(new n).copy(c).applyQuat(this.quat)}},{key:"setDirectionZ",value:function(t){return this.vec.cross(c,t).normalize(),this.setRotation(this.vec,c.angle(t))}},{key:"setBackDirectionZ",value:function(t){return this.vec.cross(c,t).normalize(),this.setRotation(this.vec,Math.PI+c.angle(t))}},{key:"setTranslation",value:function(t,n){var e=t.arr;return this.translation.set(e[0]*n,e[1]*n,e[2]*n),this}},{key:"setTranslationX",value:function(t){return this.translation.set(t,0,0),this}},{key:"setTranslationY",value:function(t){return this.translation.set(0,t,0),this}},{key:"setTranslationZ",value:function(t){return this.translation.set(0,0,t),this}},{key:"translate",value:function(t,n){return this.translation.add(this.vec.copy(t).mulS(n)),this}},{key:"translateX",value:function(t){return this.translation.addX(t),this}},{key:"translateY",value:function(t){return this.translation.addY(t),this}},{key:"translateZ",value:function(t){return this.translation.addZ(t),this}},{key:"translateGlobal",value:function(t,n){return this.quat_.copy(this.parent.quat).conjugate(),this.mat.makeQuatRotation(this.quat_),this.vec.copy(t).applyMat4(this.mat),this.translate(this.vec,n)}},{key:"setGlobalOrigin",value:function(t){return this.origin.extractTranslation(this.matrix).sub(t),this}},{key:"update",value:function(){return this.matrix.makeTranslation(this.origin,-1).preRotateQuat(this.quat).preTranslate(this.origin,1).preTranslate(this.translation,1).premultiply(this.parent.matrix),this}},{key:"$",value:function(){return this.update(),this.matrix.$(),this}}])&&r(l.prototype,h),f&&r(l,f),t}()}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}var i=function(){return 0};t.exports=function(){var t=function(){function t(n){e(this,t),this.class="Transition",this.index=t.arr.push(this)-1,this.active=0,this.stackIndex=0,this.time=0,this.interpolation=0,this.duration=0,this.onProgress=null,this.onEnd=null,this.timeObject=n,this.stack=n.stack,this.frameTime=n.frameTime.arr}var n,a,o;return n=t,(a=[{key:"set",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:i,e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:i;return this.cancel(),this.duration=t,this.onProgress=n,this.onEnd=e,this.time=0,this.active=1,this.stackIndex=this.timeObject.activeTransitionCount,this.stack[this.timeObject.activeTransitionCount++]=this.index+1,this}},{key:"update",value:function(){this.interpolation=this.time/this.duration;var n=~~this.interpolation;return t.updateTransitionSwitсh[n/n|0](this),this}},{key:"cancel",value:function(){return this.interpolation=0,this.timeObject.spliceTransitionSwitch[this.active](this),this}}])&&r(n.prototype,a),o&&r(n,o),t}();return t.arr=[],t.updateTransitionSwitсh=[function(t){t.time+=t.frameTime[0],t.onProgress(t)},function(t){return t.cancel().onEnd(t)}],t}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}var i=function(){return 0};t.exports=function(t){var n=t.stateFlag,a=t.Vec1,o=t.Transition.arr;return function(){function t(){var n=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new Uint8Array(8);e(this,t),this.class="Time",this.frameTime=new a,this.globalTime=new a,this.lastTime=(new a).set(new Date),this.animationFrame=null,this.stack=r,this.activeTransitionCount=0,this.spliceTransitionSwitch=[i,function(t){return n.spliceStack(t)}]}var u,s,c;return u=t,(s=[{key:"update",value:function(){var t=new Date,n=this.frameTime.arr,e=this.lastTime.arr;return n[0]=t-e[0],e[0]=t,this.globalTime.arr[0]+=n[0],this}},{key:"updateTransitions",value:function(){for(var t=0;t<this.activeTransitionCount;t++)o[this.stack[t]-1].update();return this}},{key:"spliceStack",value:function(t){return t.active=0,o[this.stack[--this.activeTransitionCount]-1].stackIndex=t.stackIndex,this.stack[t.stackIndex]=this.stack[this.activeTransitionCount],this.stack[this.activeTransitionCount]=0,this}},{key:"loop",value:function(t){var n=this,e=function e(){t(),n.animationFrame=requestAnimationFrame(e)};return e(),this}},{key:"loop2",value:function(t){var e=this,r=t.onStart,a=void 0===r?i:r,o=t.onStateChange,u=void 0===o?i:o,s=t.onEnd,c=void 0===s?i:s,l=[i,function(){u(),n[0]=0}];return function t(){e.update().updateTransitions(),a(),l[n[0]](),c(),e.animationFrame=requestAnimationFrame(t)}(),this}},{key:"endLoop",value:function(){return cancelAnimationFrame(this.animationFrame),this}}])&&r(u.prototype,s),c&&r(u,c),t}()}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}var i=function(){return 0};t.exports=function(t){var n=t.Camera,a=t.Obj,o=t.Vec2,u=t.Vec3,s=t.Transition;return function(){function t(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};e(this,t),this.class="Orbit",Object.assign(this,{mouseTarget:window,touchTarget:window,speedLengthLimiter:5e-7,speedResistanceFactor:.75,mouseMovementFactor:.001,touchMovementFactor:.002,translateZTouchCallback:null,minZ:0,maxZ:0,flag:1},r),this.time=r.time,this.rotationTransition=new s(this.time),this.camera=r.camera||new n,this.obj=new a,this.speed=new o,this.pan=new u,this.mousedown=null,this.mouseup=null,this.contextmenu=null,this.wheel=null,this.touchstart=null,this.touchmove=null,this.touchend=null}var c,l,h;return c=t,(l=[{key:"bindMouseEvents",value:function(t,n,e){var r=this,a=this.speed.arr,o=[function(){return r.rotationTransition.cancel()},i],u=1,s=[i,t?function(t){a[0]-=t.movementY*r.mouseMovementFactor,a[1]-=t.movementX*r.mouseMovementFactor,r.rotationTransition.set(0,function(){r.rotate().$();var t=Math.sqrt((a[0]*=r.speedResistanceFactor)*a[0]+(a[1]*=r.speedResistanceFactor)*a[1]-r.speedLengthLimiter)||0;o[t/t|0]()})}:i,n?function(t){r.obj.translate(r.pan.set(-t.movementX,t.movementY,0).mulS(.1),1),r.obj.origin.sub(r.pan),r.$()}:i],c=function(t){return s[r.flag*u](t)};this.mouseTarget.addEventListener("mousedown",this.mousedown=function(t){u=.5*(t.which-1)+1,window.addEventListener("mousemove",c)},!1),window.addEventListener("mouseup",this.mouseup=function(){return window.removeEventListener("mousemove",c,!1)},!1),this.mouseTarget.addEventListener("contextmenu",this.contextmenu=function(t){return t.preventDefault()},!1),e&&this.mouseTarget.addEventListener("wheel",this.wheel=function(t){t.preventDefault(),t.stopPropagation(),r.obj.origin.subZ(50*Math.sign(t.deltaY||t.detail||t.wheelDelta)).limitZ(r.minZ,r.maxZ),r.$()},!1)}},{key:"unbindMouseEvents",value:function(){return this.mouseTarget.removeEventListener("mousedown",this.mousedown,!1),this.mousedown=null,this.mouseTarget.removeEventListener("mouseup",this.mouseup,!1),this.mouseup=null,this.mouseTarget.removeEventListener("contextmenu",this.contextmenu,!1),this.contextmenu=null,this.mouseTarget.removeEventListener("wheel",this.wheel,!1),this.wheel=null,this}},{key:"bindTouchEvents",value:function(t,n,e){var r=this,a=this.speed.arr,o=[function(){return r.rotationTransition.cancel()},i],u=0,s=0,c=0,l=0,h=0,f=Number(Boolean(this.translateZTouchCallback)),v=[function(t){r.obj.translation.subZ(t).limitZ(r.minZ,r.maxZ),r.$()},function(t){return r.translateZTouchCallback(t)}],m=[t?function(t){t.preventDefault(),t.stopPropagation();var n=t.touches[0];u=n.clientX,s=n.clientY}:i,e?function(t){t.preventDefault(),t.stopPropagation();var n=t.touches[0],e=t.touches[1],r=e.clientX-n.clientX,i=e.clientY-n.clientY;h=Math.sqrt(r*r+i*i)}:i,n?function(t){t.preventDefault(),t.stopPropagation();var n=t.touches[0],e=t.touches[1],r=t.touches[2];c=(n.clientX+e.clientX+r.clientX)/3,l=(n.clientY+e.clientY+r.clientY)/3}:i],y=[i,function(t){return(m[t.touches.length-1]||i)(t)}];this.touchTarget.addEventListener("touchstart",this.touchstart=function(t){return y[r.flag](t)},!1);var p=[t?function(t){t.preventDefault(),t.stopPropagation();var n=t.touches[0];a[0]-=(n.clientY-s)*r.touchMovementFactor,a[1]-=(n.clientX-u)*r.touchMovementFactor,u=n.clientX,s=n.clientY,r.rotationTransition.set(0,function(){r.rotate().$();var t=Math.sqrt((a[0]*=r.speedResistanceFactor)*a[0]+(a[1]*=r.speedResistanceFactor)*a[1]-r.speedLengthLimiter)||0;o[t/t|0]()})}:i,e?function(t){t.preventDefault(),t.stopPropagation();var n=t.touches[0],e=t.touches[1],r=e.clientX-n.clientX,i=e.clientY-n.clientY,a=Math.sqrt(r*r+i*i);v[f](a-h),h=a}:i,n?function(t){t.preventDefault(),t.stopPropagation();var n=t.touches[0],e=t.touches[1],i=t.touches[2],a=(n.clientX+e.clientX+i.clientX)/3,o=(n.clientY+e.clientY+i.clientY)/3;r.obj.translate(r.pan.set(-a-c,o-l,0).mulS(.1),1),r.obj.origin.sub(r.pan),r.$(),c=a,l=o}:i],d=[i,function(t){return(p[t.touches.length-1]||i)(t)}];return this.touchTarget.addEventListener("touchmove",this.touchmove=function(t){return d[r.flag](t)},!1),this.touchTarget.addEventListener("touchend",this.touchend=function(t){return(y[r.flag]||i)(t)},!1),this}},{key:"unbindTouchEvents",value:function(){return this.touchTarget.removeEventListener("touchstart",this.touchstart,!1),this.touchstart=null,this.touchTarget.removeEventListener("touchmove",this.touchmove,!1),this.touchmove=null,this.touchTarget.removeEventListener("touchend",this.touchend,!1),this.touchend=null,this}},{key:"translateSatellite",value:function(t,n){return this.obj.translate(t,n),this}},{key:"rotate",value:function(){var t=this.speed.arr;return this.obj.postRotateX(t[0]).preRotateY(t[1]),this}},{key:"update",value:function(){return this.camera.viewMatrix.copy(this.obj.update().matrix).inverseTransformNoScale(),this}},{key:"$",value:function(){return this.update(),this.obj.$(),this.camera.$(),this}}])&&r(c.prototype,l),h&&r(c,h),t}()}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}t.exports=function(t){var n=t.WebGLRenderingContext,i=t.Mat4,a=t.Obj,o=t.Camera,u=t.Texture2D,s=t.Renderbuffer,c=t.Framebuffer,l=t.Shader,h=t.Program,f=t.VertexAttrib,v=n,m=v.RGBA,y=v.UNSIGNED_BYTE,p=v.COLOR_ATTACHMENT0,d=v.DEPTH_ATTACHMENT,b=v.DEPTH_COMPONENT16,g=v.COLOR_BUFFER_BIT,k=v.DEPTH_BUFFER_BIT;return function(){function t(){var n=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};e(this,t),this.class="Raycast",this.camera=r.camera||(new o).setOrthographicProjection(-.5,.5,.5,-.5,1,2e3,1),this.cameraObj=new a,this.modelMatrix=new i,this.pixel=new Uint8Array(4),this.texture2D=new u,u.bind(this.texture2D).image2D2(0,m,1,1,0,m,y,null).unbind(),this.renderbuffer=new s,s.bind(this.renderbuffer).storage(b,1,1).unbind(),this.framebuffer=new c,c.bind(this.framebuffer).texture2D(p,this.texture2D).renderbuffer(d,this.renderbuffer).unbind(),this.program=(r.program||new h({VS:function(){return"\n          ".concat(l.maxPrecision.vs.float,"\n          ").concat(f.inject("vertex",0),"\n          ").concat(n.camera.projectionMatrix.injectUniform("projectionMatrix"),"\n          ").concat(n.camera.viewMatrix.injectUniform("viewMatrix"),"\n          ").concat(n.modelMatrix.injectUniform("modelMatrix"),"\n          varying vec4 color;\n          ").concat(l.consts.FLOAT_TO_RGBA,"\n          void main() {\n            vec4 coords = viewMatrix * modelMatrix * vec4(vertex, 1.0);\n            color = FLOAT_TO_RGBA(-coords.z);\n            gl_Position = projectionMatrix * coords;\n          }")},FS:"\n          ".concat(l.maxPrecision.fs.float,"\n          varying vec4 color;\n          void main() {\n            gl_FragColor = color;\n          }")})).compose()}var n,x,w;return n=t,w=[{key:"rgba2float",value:function(t){return Math.pow(2,t[0]-150)*(t[1]%128*65536+256*t[2]+t[3]+8388608)}}],(x=[{key:"set",value:function(t,n){return this.cameraObj.setBackDirectionZ(n).setTranslation(t,1).update(),this.camera.viewMatrix.copy(this.cameraObj.matrix).inverse(),this.framebuffer.bind(),v.viewport(0,0,1,1),v.clearColor(0,0,0,1),this.program.use().updateUniform("viewMatrix"),this}},{key:"setModelMatrix",value:function(t){return this.modelMatrix.copy(t),this.program.updateUniform("modelMatrix"),this}},{key:"snap",value:function(t){return v.clear(g|k),t(),v.readPixels(0,0,1,1,m,y,this.pixel),this}},{key:"snap2",value:function(t,n,e,r,i){return v.clear(g|k),i(),v.readPixels(t,n,e,r,m,y,this.pixel),this}},{key:"unset",value:function(){return c.unbind(),this}},{key:"rgba2float",value:function(){return t.rgba2float(this.pixel)}}])&&r(n.prototype,x),w&&r(n,w),t}()}},function(t,n){function e(t,n){if(e=t,!(null!=(r=n)&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r))throw new TypeError("Cannot call a class as a function");var e,r}function r(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function i(t){return function(t){if(Array.isArray(t)){for(var n=0,e=new Array(t.length);n<t.length;n++)e[n]=t[n];return e}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}t.exports=function(t){var n=t.WebGLRenderingContext,a=t.Shader,o=t.Program,u=t.VertexAttrib,s=t.VertexBuffer,c=t.Vec1,l=t.Vec2,h=t.Vec3,f=t.Mat4,v=t.Obj,m=t.Camera,y=t.Raycast,p=n,d=p.LINE_STRIP,b=new f,g=new f,k=new h,x=new h,w=(new h).x(1),S=(new h).y(1),P=(new h).z(1),T=function(t,n,e){for(var r=[],a=2*Math.PI/n,o=0;o<=n;o++)g.reset().preRotateZ(a*o),k.set(0,t,0).applyMat4(g).applyMat4(e),r.push.apply(r,i(k.arr));return r};return function(){function t(n,r,i){var p=this,d=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1;e(this,t),this.class="Gumball",this.radius=n,this.translationFactor=d,this.prevX=0,this.prevY=0,this.distance=999999,this.actionIndex=0,this.obj=new v,this.raycast_=new y({camera:i||(new m).setOrthographicProjection(-2,2,2,-2,1,2e3,1)}),this.raycastDir=new h,this.prevTangentPoint=new h,this.tangentPoint=new h,this.tangentDir=new h,this.tangentDirScreen=new l,this.origin=new h,this.modelOrigin=new h,this.modelOriginProjection=new h,this.movementDir=new l,this.camera=r,this.actions=[function(t,n){return p.rotateX(t,n).setCircleTangent(t,n,w.set(1,0,0).applyMat4(b.copy(p.obj.matrix).extractRotation()))},function(t,n){return p.rotateY(t,n).setCircleTangent(t,n,S.set(0,1,0).applyMat4(b.copy(p.obj.matrix).extractRotation()))},function(t,n){return p.rotateZ(t,n).setCircleTangent(t,n,P.set(0,0,1).applyMat4(b.copy(p.obj.matrix).extractRotation()))},function(t,n){return p.translateX(t,n).setAxisTangent(w.set(1,0,0).applyMat4(b.copy(p.obj.matrix).extractRotation()))},function(t,n){return p.translateY(t,n).setAxisTangent(S.set(0,1,0).applyMat4(b.copy(p.obj.matrix).extractRotation()))},function(t,n){return p.translateZ(t,n).setAxisTangent(P.set(0,0,1).applyMat4(b.copy(p.obj.matrix).extractRotation()))}],this.program=new o({VS:function(){return"\n          ".concat(a.maxPrecision.vs.float,"\n          ").concat(u.inject("vertex",0),"\n          ").concat(p.camera.projectionMatrix.injectUniform("projectionMatrix"),"\n          ").concat(p.camera.viewMatrix.injectUniform("viewMatrix"),"\n          ").concat((new f).copy(p.obj.matrix).injectUniform("modelMatrix"),"\n          ").concat((new c).injectUniform("index","int"),"\n          ").concat(new c(new Int32Array(6)).injectUniform("colorIndex","int[]"),"\n          ").concat(new h(new Float64Array([1,.75,.75,.75,1,.75,.75,.75,1,1,.75,.75,.75,1,.75,.75,.75,1,1,0,0,0,1,0,0,0,1,1,0,0,0,1,0,0,0,1])).injectUniform("color","vec3[]"),"\n          varying vec3 vColor;\n    \n          void main() {\n            vColor = color[colorIndex[index] + index];\n            gl_Position = projectionMatrix * viewMatrix * modelMatrix * vec4(vertex, 1.0);\n          }")},FS:"\n          ".concat(a.maxPrecision.fs.float,"\n          varying vec3 vColor;\n    \n          void main() {\n            gl_FragColor = vec4(vColor, 1.0);\n          }")}).compose(),this.circleVertexBufferX=(new s).bind().data(new Float32Array(T(n,100,b.reset().preRotateY(.5*Math.PI)))),this.circleVertexBufferY=(new s).bind().data(new Float32Array(T(n,100,b.reset().preRotateX(.5*Math.PI)))),this.circleVertexBufferZ=(new s).bind().data(new Float32Array(T(n,100,b.reset()))),this.lineVertexBufferX=(new s).bind().data(new Float32Array([0,0,0,2*-n,0,0])),this.lineVertexBufferY=(new s).bind().data(new Float32Array([0,0,0,0,2*n,0])),this.lineVertexBufferZ=(new s).bind().data(new Float32Array([0,0,0,0,0,2*n]))}var n,i,g;return n=t,(i=[{key:"bindObj",value:function(t){return this.obj=t,this}},{key:"calculateRotation",value:function(t,n,e){var r=this.prevTangentPoint.angle(this.tangentPoint)*Math.sign(this.movementDir.set(this.prevX,this.prevY).subS2(t,n).dot(this.tangentDir));return 0===e?(x.copy(w).applyMat4(b.copy(this.camera.viewMatrix).inverse().extractRotation()).normalize(),1===x.arr[0]&&(r=.01*Math.sign(this.movementDir.set(this.prevX,this.prevY).subS2(t,n).dot(this.tangentDir)))):1===e?(x.copy(S).applyMat4(b.copy(this.camera.viewMatrix).inverse().extractRotation()).normalize(),1===x.arr[1]&&(r=.01*Math.sign(this.movementDir.set(this.prevX,this.prevY).subS2(t,n).dot(this.tangentDir)))):2===e&&(x.copy(P).applyMat4(b.copy(this.camera.viewMatrix).inverse().extractRotation()).normalize(),1===x.arr[2]&&(r=.01*Math.sign(this.movementDir.set(this.prevX,this.prevY).subS2(t,n).dot(this.tangentDir)))),x.reset(),this.prevX=t,this.prevY=n,this.prevTangentPoint.copy(this.tangentPoint),r}},{key:"calculateTranslation",value:function(t,n){var e=1e3*-this.movementDir.set(this.prevX,this.prevY).subS2(t,n).dot(this.tangentDir);return this.prevX=t,this.prevY=n,e*this.translationFactor}},{key:"get2DAngleY",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;return this.tangentDirScreen.copy(this.tangentDir).mulX(t),this.tangentDirScreen.angle(S.set(0,1,0))/Math.PI*180*Math.sign(this.tangentDirScreen.dot(w.set(1,0,0)))}},{key:"setCircleTangent",value:function(t,n,e){return this.tangentPoint.directToScreenCoords2(t,n,this.camera).intersectPlane(this.origin.extractTranslation(b.copy(this.camera.viewMatrix).inverse()),e,this.modelOrigin).sub(this.modelOrigin),isNaN(this.tangentPoint.arr[0]*this.tangentPoint.arr[1]*this.tangentPoint.arr[2])&&this.tangentPoint.reset(),this.tangentDir.copy(this.tangentPoint).verticalize(e).add(this.modelOrigin).projectPerspective2(this.camera).z(0).sub(this.modelOriginProjection),this}},{key:"setAxisTangent",value:function(t){return this.tangentDir.extractTranslation(this.obj.matrix).add(t).projectPerspective2(this.camera).z(0).sub(this.modelOriginProjection),this}},{key:"rotateX",value:function(t,n){return this.obj.postRotateX(this.calculateRotation(t,n,0)),this}},{key:"rotateY",value:function(t,n){return this.obj.postRotateY(this.calculateRotation(t,n,1)),this}},{key:"rotateZ",value:function(t,n){return this.obj.postRotateZ(this.calculateRotation(t,n,2)),this}},{key:"translateX",value:function(t,n){return this.obj.translateGlobal(w.set(1,0,0).applyMat4((new f).copy(this.obj.matrix).extractRotation()),this.calculateTranslation(t,n)),this.modelOrigin.extractTranslation(this.obj.matrix),this.modelOriginProjection.copy(this.modelOrigin).projectPerspective2(this.camera).z(0),this}},{key:"translateY",value:function(t,n){return this.obj.translateGlobal(S.set(0,1,0).applyMat4((new f).copy(this.obj.matrix).extractRotation()),this.calculateTranslation(t,n)),this.modelOrigin.extractTranslation(this.obj.matrix),this.modelOriginProjection.copy(this.modelOrigin).projectPerspective2(this.camera).z(0),this}},{key:"translateZ",value:function(t,n){return this.obj.translateGlobal(P.set(0,0,1).applyMat4((new f).copy(this.obj.matrix).extractRotation()),this.calculateTranslation(t,n)),this.modelOrigin.extractTranslation(this.obj.matrix),this.modelOriginProjection.copy(this.modelOrigin).projectPerspective2(this.camera).z(0),this}},{key:"drawCircleX",value:function(){return u.pointer2(this.circleVertexBufferX),p.drawArrays(d,0,101),this}},{key:"drawCircleY",value:function(){return u.pointer2(this.circleVertexBufferY),p.drawArrays(d,0,101),this}},{key:"drawCircleZ",value:function(){return u.pointer2(this.circleVertexBufferZ),p.drawArrays(d,0,101),this}},{key:"drawAxisX",value:function(){return u.pointer2(this.lineVertexBufferX),p.drawArrays(d,0,2),this}},{key:"drawAxisY",value:function(){return u.pointer2(this.lineVertexBufferY),p.drawArrays(d,0,2),this}},{key:"drawAxisZ",value:function(){return u.pointer2(this.lineVertexBufferZ),p.drawArrays(d,0,2),this}},{key:"draw",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{rotationX:!0,rotationY:!0,rotationZ:!0,translationX:!0,translationY:!0,translationZ:!0};return this.program.use3(),t.rotationX&&(this.program.uniforms.index.set(0),this.program.updateUniform("index"),this.drawCircleX()),t.rotationY&&(this.program.uniforms.index.set(1),this.program.updateUniform("index"),this.drawCircleY()),t.rotationZ&&(this.program.uniforms.index.set(2),this.program.updateUniform("index"),this.drawCircleZ()),t.translationX&&(this.program.uniforms.index.set(3),this.program.updateUniform("index"),this.drawAxisX()),t.translationY&&(this.program.uniforms.index.set(4),this.program.updateUniform("index"),this.drawAxisY()),t.translationZ&&(this.program.uniforms.index.set(5),this.program.updateUniform("index"),this.drawAxisZ()),this}},{key:"setCircleParams",value:function(t,n,e,r,i){var a=[0,0,0,0,0,0];return a[t]=6,this.program.uniforms.colorIndex.arr.set(a),this.program.uniforms.colorIndex.$(),this.distance=n,this.actionIndex=t,this.setCircleTangent(e,r,i),this}},{key:"setAxisParams",value:function(t,n,e,r,i){var a=[0,0,0,0,0,0];return a[t]=6,this.program.uniforms.colorIndex.arr.set(a),this.program.uniforms.colorIndex.$(),this.distance=n,this.actionIndex=t,this.prevX=e,this.prevY=r,this.setAxisTangent(i),this}},{key:"raycast",value:function(t,n){var e=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{rotationX:!0,rotationY:!0,rotationZ:!0,translationX:!0,translationY:!0,translationZ:!0};if(this.distance=999999,this.origin.extractTranslation(b.copy(this.camera.viewMatrix).inverse()),this.raycastDir.directToScreenCoords2(t,n,this.camera),this.raycast_.set(this.origin,this.raycastDir).setModelMatrix(this.obj.matrix).snap(function(){return e.drawCircleX()}),this.modelOrigin.extractTranslation(this.obj.matrix),this.modelOriginProjection.copy(this.modelOrigin).projectPerspective2(this.camera).z(0),r.rotationX&&this.raycast_.pixel[0]){var i=this.raycast_.rgba2float();i<this.distance&&this.setCircleParams(0,i,t,n,w.set(1,0,0).applyMat4(b.copy(this.obj.matrix).extractRotation()))}if(this.raycast_.snap(function(){return e.drawCircleY()}),r.rotationY&&this.raycast_.pixel[0]){var a=this.raycast_.rgba2float();a<this.distance&&this.setCircleParams(1,a,t,n,S.set(0,1,0).applyMat4(b.copy(this.obj.matrix).extractRotation()))}if(this.raycast_.snap(function(){return e.drawCircleZ()}),r.rotationZ&&this.raycast_.pixel[0]){var o=this.raycast_.rgba2float();o<this.distance&&this.setCircleParams(2,o,t,n,P.set(0,0,1).applyMat4(b.copy(this.obj.matrix).extractRotation()))}if(this.raycast_.snap(function(){return e.drawAxisX()}),r.translationX&&this.raycast_.pixel[0]){var u=this.raycast_.rgba2float();u<this.distance&&this.setAxisParams(3,u,t,n,w.set(1,0,0).applyMat4(b.copy(this.obj.matrix).extractRotation()))}if(this.raycast_.snap(function(){return e.drawAxisY()}),r.translationY&&this.raycast_.pixel[0]){var s=this.raycast_.rgba2float();s<this.distance&&this.setAxisParams(4,s,t,n,S.set(0,1,0).applyMat4(b.copy(this.obj.matrix).extractRotation()))}if(this.raycast_.snap(function(){return e.drawAxisZ()}),r.translationZ&&this.raycast_.pixel[0]){var c=this.raycast_.rgba2float();c<this.distance&&this.setAxisParams(5,c,t,n,P.set(0,0,1).applyMat4(b.copy(this.obj.matrix).extractRotation()))}return this}},{key:"transform",value:function(t,n){return this.actions[this.actionIndex](t,n),this}},{key:"reset",value:function(){return this.prevTangentPoint.reset(),this.tangentPoint.reset(),this.program.uniforms.colorIndex.arr.set([0,0,0,0,0,0]),this.program.uniforms.colorIndex.$(),this}},{key:"$",value:function(){return this.program.uniforms.modelMatrix.copy(this.obj.update().matrix).$(),this}}])&&r(n.prototype,i),g&&r(n,g),t}()}},function(t){t.exports={name:"@3d-smile/glkit",version:"0.0.38",description:"",main:"build/index.js",author:"Denis Belov",license:"MIT",email:"dsbelov63@gmail.com",repository:"git@github.com/denis-belov/3d-smile-glkit",devDependencies:{"@babel/core":"7.4.5","@babel/polyfill":"7.4.4","babel-plugin-transform-member-expression-literals":"6.9.4","babel-plugin-transform-property-literals":"6.9.4","@babel/plugin-transform-reserved-words":"7.2.0","@babel/plugin-transform-property-mutators":"7.2.0","@babel/plugin-transform-arrow-functions":"7.2.0","@babel/plugin-transform-block-scoped-functions":"7.2.0","@babel/plugin-transform-block-scoping":"7.4.4","@babel/plugin-transform-classes":"7.4.4","@babel/plugin-transform-computed-properties":"7.2.0","@babel/plugin-transform-destructuring":"7.4.4","@babel/plugin-transform-duplicate-keys":"7.2.0","@babel/plugin-transform-for-of":"7.4.4","@babel/plugin-transform-function-name":"7.4.4","@babel/plugin-transform-instanceof":"7.2.0","@babel/plugin-transform-literals":"7.2.0","@babel/plugin-transform-new-target":"7.4.4","@babel/plugin-transform-object-super":"7.2.0","@babel/plugin-transform-parameters":"7.4.4","@babel/plugin-transform-shorthand-properties":"7.2.0","@babel/plugin-transform-spread":"7.2.2","@babel/plugin-transform-sticky-regex":"7.2.0","@babel/plugin-transform-template-literals":"7.4.4","@babel/plugin-transform-typeof-symbol":"7.2.0","@babel/plugin-transform-unicode-regex":"7.4.4","@babel/plugin-transform-exponentiation-operator":"7.2.0","@babel/plugin-transform-async-to-generator":"7.4.4","@babel/plugin-proposal-async-generator-functions":"7.2.0","@babel/plugin-transform-dotall-regex":"7.4.4","@babel/plugin-proposal-object-rest-spread":"7.4.4","@babel/plugin-proposal-optional-catch-binding":"7.2.0","@babel/plugin-proposal-unicode-property-regex":"7.4.4","@babel/plugin-proposal-class-properties":"7.4.4","@babel/plugin-proposal-decorators":"7.4.4","@babel/plugin-proposal-do-expressions":"7.2.0","@babel/plugin-proposal-export-default-from":"7.2.0","@babel/plugin-proposal-export-namespace-from":"7.2.0","@babel/plugin-proposal-function-bind":"7.2.0","@babel/plugin-proposal-function-sent":"7.2.0","@babel/plugin-proposal-logical-assignment-operators":"7.2.0","@babel/plugin-proposal-nullish-coalescing-operator":"7.4.4","@babel/plugin-proposal-numeric-separator":"7.2.0","@babel/plugin-proposal-optional-chaining":"7.2.0","@babel/plugin-proposal-pipeline-operator":"7.3.2","@babel/plugin-proposal-throw-expressions":"7.2.0",eslint:"5.16.0","eslint-config-strict":"14.0.1",webpack:"4.32.2","webpack-cli":"3.3.2","babel-loader":"8.0.6","eslint-loader":"2.1.2","copy-webpack-plugin":"5.0.3","clean-webpack-plugin":"2.0.2","cross-env":"5.2.0"},scripts:{build:"cross-env BABEL=1 webpack --mode=production","build:clear":"webpack --mode=production",upload:"node publish"},keywords:["webgl","webgl 2.0","webgl2","3d","graphics"]}}])});

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * The MIT License
 * 
 * Copyright © 2016-2018 Denis Belov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports["@xgk/loader"]=t():e["@xgk/loader"]=t()}(window,function(){return function(e){var t={};function n(o){if(t[o])return t[o].exports;var r=t[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=e,n.c=t,n.d=function(e,t,o){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:o})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)n.d(o,r,function(t){return e[t]}.bind(null,r));return o},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=0)}([function(e,t,n){e.exports=n(1)},function(e,t){function n(e,t){if(!function(e,t){return null!=t&&"undefined"!=typeof Symbol&&t[Symbol.hasInstance]?t[Symbol.hasInstance](e):e instanceof t}(e,t))throw new TypeError("Cannot call a class as a function")}function o(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}e.exports=function(){function e(){n(this,e),this.content={},this.length=null,this.current=null,this.loaded=null,this.progress=null,this.rejectOnError=!1}return function(e,t,n){t&&o(e.prototype,t),n&&o(e,n)}(e,[{key:"getXhr",value:function(e,t,n,o,r){var s=this,u=new XMLHttpRequest;return u.lastLoaded=0,u.image=null,u.lengthComputable=!0,u.loaded=0,t.constructor===ArrayBuffer?(u.image=new Image,u.image.onload=function(){return s.onload(u,n,o)},u.image.src=window.URL.createObjectURL(new Blob([t]))):(u.open("GET",t,!0),"image"===e?(u.responseType="arraybuffer",u.image=new Image):"document"===e?(u.responseType=e,u.overrideMimeType("text/xml")):u.responseType=e,u.setRequestHeader("X-Requested-With","XMLHttpRequest"),u.setRequestHeader("Content-type","text"),u.onprogress=function(e){return s.onprogress(u,e)},u.onload=function(){200===u.status?"image"===e?(u.image.onload=function(){return s.onload(u,n,o)},u.image.src=window.URL.createObjectURL(new Blob([u.response]))):s.onload(u,n,o):s.rejectOnError?r(u):s.onloadBroken(u,n,o)},u.onerror=function(e){return r(e)},u.send()),u}},{key:"load",value:function(e){var t=this;return new Promise(function(n,o){if(e&&e.sources)for(var r in t.length=Object.keys(e.sources).length,t.current=0,t.loaded=0,t.progress=e.progress||function(){return 0},t.rejectOnError=!1,e.sources){var s=e.sources[r];t.content[r]=t.getXhr(s.type||"text",s.source||s,r,n,o)}else o(new Error("xgk::js::web::Loader: no sources."))})}},{key:"onprogress",value:function(e,t){e.lengthComputable=t.lengthComputable,e.lengthComputable&&(this.loaded+=t.loaded/t.total-e.lastLoaded,e.lastLoaded=t.loaded/t.total,e.loaded=e.lastLoaded,this.progress())}},{key:"onload",value:function(e,t,n){this.loaded+=e.lengthComputable?1-e.loaded:1,this.progress();var o=this.content[t];this.content[t]=o.image||o.response||o.responseText,++this.current===this.length&&(this.loaded=this.length,this.progress(),n(this.content))}},{key:"onloadBroken",value:function(e,t,n){this.loaded++,this.progress(),this.content[t]=null,++this.current===this.length&&(this.loaded=this.length,this.progress(),n(this.content))}}]),e}()}])});

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/*!
 * arraybuffer-loader@1.0.7 (MIT)
 *   author: Pine Mizune (https://github.com/pine)
 *   url: git+https://github.com/pine/arraybuffer-loader.git
 *
 *   Copyright (c) 2016-2018 Pine Mizune
 *
 *   Permission is hereby granted, free of charge, to any person
 *   obtaining a copy of this software and associated documentation
 *   files (the "Software"), to deal in the Software without
 *   restriction, including without limitation the rights to use,
 *   copy, modify, merge, publish, distribute, sublicense, and/or sell
 *   copies of the Software, and to permit persons to whom the
 *   Software is furnished to do so, subject to the following
 *   conditions:
 *
 *   The above copyright notice and this permission notice shall be
 *   included in all copies or substantial portions of the Software.
 *
 *   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 *   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 *   OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 *   NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 *   HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 *   WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 *   FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 *   OTHER DEALINGS IN THE SOFTWARE.
 *
 *
 *
 * buffer@4.9.1 (MIT)
 *   author: Feross Aboukhadijeh (http://feross.org)
 *   url: git://github.com/feross/buffer.git
 *   contributors:
 *     Romain Beauxis <toots@rastageeks.org>
 *     James Halliday <mail@substack.net>
 *
 *   The MIT License (MIT)
 *
 *   Copyright (c) Feross Aboukhadijeh, and other contributors.
 *
 *   Permission is hereby granted, free of charge, to any person obtaining a copy
 *   of this software and associated documentation files (the "Software"), to deal
 *   in the Software without restriction, including without limitation the rights
 *   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 *   copies of the Software, and to permit persons to whom the Software is
 *   furnished to do so, subject to the following conditions:
 *
 *   The above copyright notice and this permission notice shall be included in
 *   all copies or substantial portions of the Software.
 *
 *   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 *   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 *   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 *   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 *   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 *   THE SOFTWARE.
 *
 *
 *
 * webpack@4.32.2 (MIT)
 *   author: Tobias Koppers @sokra
 *   url: git+https://github.com/webpack/webpack.git
 *
 *   Copyright JS Foundation and other contributors
 *
 *   Permission is hereby granted, free of charge, to any person obtaining
 *   a copy of this software and associated documentation files (the
 *   'Software'), to deal in the Software without restriction, including
 *   without limitation the rights to use, copy, modify, merge, publish,
 *   distribute, sublicense, and/or sell copies of the Software, and to
 *   permit persons to whom the Software is furnished to do so, subject to
 *   the following conditions:
 *
 *   The above copyright notice and this permission notice shall be
 *   included in all copies or substantial portions of the Software.
 *
 *   THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 *   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 *   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 *   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 *   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 *   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 *   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 *
 *
 * base64-js@1.3.0 (MIT)
 *   author: T. Jameson Little
 *   url: git://github.com/beatgammit/base64-js.git
 *
 *   The MIT License (MIT)
 *
 *   Copyright (c) 2014
 *
 *   Permission is hereby granted, free of charge, to any person obtaining a copy
 *   of this software and associated documentation files (the "Software"), to deal
 *   in the Software without restriction, including without limitation the rights
 *   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 *   copies of the Software, and to permit persons to whom the Software is
 *   furnished to do so, subject to the following conditions:
 *
 *   The above copyright notice and this permission notice shall be included in
 *   all copies or substantial portions of the Software.
 *
 *   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 *   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 *   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 *   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 *   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 *   THE SOFTWARE.
 *
 *
 *
 * ieee754@1.1.13 (BSD-3-Clause)
 *   author: Feross Aboukhadijeh (http://feross.org)
 *   url: git://github.com/feross/ieee754.git
 *   contributors:
 *     Romain Beauxis <toots@rastageeks.org>
 *
 *   Copyright 2008 Fair Oaks Labs, Inc.
 *
 *   Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 *
 *   1. Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 *
 *   2. Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 *
 *   3. Neither the name of the copyright holder nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
 *
 *   THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 *
 *
 * isarray@1.0.0 (MIT)
 *   author: Julian Gruber (http://juliangruber.com)
 *   url: git://github.com/juliangruber/isarray.git
 *
 *
 */exports.runViewer=function(M){var L={};function j(A){if(L[A])return L[A].exports;var u=L[A]={i:A,l:!1,exports:{}};return M[A].call(u.exports,u,u.exports,j),u.l=!0,u.exports;}return j.m=M,j.c=L,j.d=function(M,L,A){j.o(M,L)||Object.defineProperty(M,L,{enumerable:!0,get:A});},j.r=function(M){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(M,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(M,"__esModule",{value:!0});},j.t=function(M,L){if(1&L&&(M=j(M)),8&L)return M;if(4&L&&"object"==(typeof M==="undefined"?"undefined":_typeof(M))&&M&&M.__esModule)return M;var A=Object.create(null);if(j.r(A),Object.defineProperty(A,"default",{enumerable:!0,value:M}),2&L&&"string"!=typeof M)for(var u in M){j.d(A,u,function(L){return M[L];}.bind(null,u));}return A;},j.n=function(M){var L=M&&M.__esModule?function(){return M.default;}:function(){return M;};return j.d(L,"a",L),L;},j.o=function(M,L){return Object.prototype.hasOwnProperty.call(M,L);},j.p="view/",j(j.s=2);}([function(M,L,j){"use strict";(function(L){M.exports=function(M){for(var j="undefined"!=typeof window&&"function"==typeof window.atob?window.atob(M):L.from(M,"base64").toString("binary"),A=new Uint8Array(j.length),u=0;u<j.length;++u){A[u]=j.charCodeAt(u);}return A.buffer;};}).call(this,j(22).Buffer);},function(M){M.exports={locks:"006068",lines:"02263D",spheres:"02263D",labels:"02263D",grid:"02263D",cap:"02263D",step_duration:"250",api:"https://serviziortodontici-dide.com"};},function(M,L,j){j(3),M.exports=j(4);},function(M,L,j){},function(M,L,j){function A(M){return function(M){if(Array.isArray(M)){for(var L=0,j=new Array(M.length);L<M.length;L++){j[L]=M[L];}return j;}}(M)||function(M){if(Symbol.iterator in Object(M)||"[object Arguments]"===Object.prototype.toString.call(M))return Array.from(M);}(M)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance");}();}var u,w=j(5),N=j(6),C=j(7),y=j(8),T=j(9),D=j(10),z=j(11),i=j(12),t=j(13),s=j(14),S=j(15),I=j(16),x=j(17),E=j(18),g=j(19),Q=j(20),Y={logo:{source:j(21),type:"image"}};u=j(27),Y.canvasBG={source:u,type:"image"};var c=j(1),O=null,k=null,o=null,n=null,e=null,J=null,a=function a(M,L,j){return M+(L-M)*j;};M.exports=function(){var M=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};O=M.libs.$,k=M.libs.Bowser,o=M.libs.FileSaver,n=M.libs.JsExcelTemplate,e=M.libs.Glkit,J=M.libs.Loader,O("#_3d_plan-controls-button").find("img").attr("src",w),O("#_3d_plan-controls-actions-cell-both").find("img").attr("src",N),O("#_3d_plan-controls-actions-cell-occlusion").find("img").attr("src",C),O("#_3d_plan-controls-actions-cell-upper").find("img").attr("src",y),O("#_3d_plan-controls-actions-cell-lower").find("img").attr("src",T),O("#_3d_plan-controls-actions-cell-grid").find("img").attr("src",D),O("#_3d_plan-controls-actions-cell-separations").find("img").attr("src",z),O("#_3d_plan-controls-actions-cell-locks").find("img").attr("src",i),O("#_3d_plan-controls-actions-cell-pdf").find("img").attr("src",t),O("#_3d_plan-controls-actions-cell-info").find("img").attr("src",s),O("#_3d_plan-info-occlusion-en").attr("src",S),O("#_3d_plan-info-occlusion-ru").attr("src",I),O("#_3d_plan-sequencer-button-first_step").find("img").attr("src",x),O("#_3d_plan-sequencer-button-pause").find("img").attr("src",E),O("#_3d_plan-sequencer-button-play").find("img").attr("src",g),O("#_3d_plan-sequencer-button-last_step").find("img").attr("src",Q);var L=O(window),u=O("#_3d_plan-wrapper"),U=O("#_3d_plan-nowebgl"),r=O("#_3d_plan-loader"),m=O("#_3d_plan-canvas"),P=O("#_3d_plan-controls"),G=O("#_3d_plan-info"),l=O("#_3d_plan-loader-circle"),d=O("#_3d_plan-loader-percentage");U.append("<span>".concat("No WebGL Support","</span>")),u.on("touchmove",function(M){return M.preventDefault();});var Z={INIT_PARAMS:M,errorHandler:function errorHandler(M){throw r.remove(),U.html("").append("<span>".concat(M,"</span>")).show(),new Error(M);}},B=parseInt(c.step_duration||250,10),f=function f(){Z.config=c,Z.libs={$:O,Bowser:k,FileSaver:o,JsExcelTemplate:n,Glkit:e,Loader:J},Z.info=j(28)(Z);var u=j(29)(Z),w=j(30),N=j(31),C=j(32),y=j(33),T=j(34)(Z),D=j(35)(Z),z=j(37)(Z),i=j(38)(Z),t=j(39)(Z),s=t.getDrawFunc2Attr,S=t.getDrawFunc4Attr,I=t.getDrawFunc6Attr,x=j(40),E=new(0,e.WebGL)({extensions:["OES_standard_derivatives","OES_element_index_uint","EXT_texture_filter_anisotropic"],errorCallback:function errorCallback(M){Z.errorHandler(M);}}).setSize(0,0,window.innerWidth,window.innerHeight);Z.CTX=E;var g=E.WebGLRenderingContext,Q=E.extensions,f=E.Time,W=E.Transition,v=E.Program,b=E.Vec1,h=E.Vec2,R=E.Vec3,p=E.Vec4,F=E.Shader,X=E.VertexAttrib,H=E.VertexBuffer,K=E.IndexBuffer,V=E.Texture2D,q=E.canvas;Q.OES_standard_derivatives||Z.errorHandler("No OES_standard_derivatives support");var _=new f();Z.time=_,U.hide();var $=new J();$.load({sources:{CASE:{source:M.case_json,type:"json"}}}).then(function(j){var t=j.CASE;Z.CASE=t;var c="conv-v4-3"===t.type,k="conv-v4-3"===t.type,o="conv-v4-2"===t.type||"conv-v4-3"===t.type,n="conv-v4-0"===t.type&&void 0===t.cap||t.cap,e="conv-v4-0"===t.type||"conv-v4-1"===t.type,J=!1,U="conv-v4-0"===t.type;Object.assign(Z,{SWITCH_ENABLED_ATTRIBUTE_COUNT_SIX:c,SWITCH_GET_DRAW_FUNCTION_WITH_ATTRIBUTE_COUNT_SIX:k,SWITCH_DRAW_ONLY_TEETH_OBJECTS:o,SWITCH_SET_CAP:n,SWITCH_SEPARATIONS_EXIST:e,SWITCH_SMOOTH_STEP_TRANSITION:U});var f,MM=M.case_json.split("case.json")[0];f=t.files.reduce(function(M,L){return Object.defineProperty(M,L,{value:{source:"".concat(MM,"/").concat(L),type:"arraybuffer"},enumerable:1,writable:!0});},Y),$.load({sources:f,progress:x(Z,$)}).then(function(j){var x=M.pdf;J=x,Object.assign(Z,{SWITCH_PDF_EXIST:J}),Z.assets=j,Z.pdf=x,Z.teethOcclusion=Boolean(Z.assets.upper_teeth_c_0||Z.assets.lower_teeth_c_0),Z.teethColor=Boolean(Z.assets.upper_teeth_tc_0||Z.assets.lower_teeth_tc_0);var Y=g,f=Y.STATIC_DRAW,$=Y.COLOR_BUFFER_BIT,MM=Y.DEPTH_TEST,LM=Y.CULL_FACE,jM=Y.LESS,AM=Y.TRIANGLES,uM=Y.UNSIGNED_SHORT,wM=Y.FLOAT;Y.clearColor(1,1,1,1),Y.clear($),Y.enable(MM),Y.depthFunc(jM),c?X.enable([0,1,2,3,4,5]):X.enable([0,1,2,3]);var NM=new b(),CM=new b(),yM=new p().set(1,1,1,1),TM=new Uint8Array(1),DM=new b().set(1),zM=new h().set(1,1),iM=new b().set(1),tM=new Uint8Array([1]),sM=new b();Object.assign(Z,{rotationX:CM,visibility:yM,gridMode:TM,separationMode:DM,separationVisibility:zM,separationClosed:iM,locksMode:tM,step:sM});var SM,IM=new h().set(window.innerWidth,window.innerHeight),xM=new V();Y.activeTexture(Y.TEXTURE0),V.bind(xM).image2D(0,Y.RGBA,Y.RGBA,Y.UNSIGNED_BYTE,Z.assets.canvasBG).parameteri(Y.TEXTURE_MAG_FILTER,Y.LINEAR).parameteri(Y.TEXTURE_MIN_FILTER,Y.LINEAR_MIPMAP_LINEAR).parameteri(Y.TEXTURE_WRAP_S,Y.CLAMP_TO_EDGE).parameteri(Y.TEXTURE_WRAP_T,Y.REPEAT).mipmap(),Q.EXT_texture_filter_anisotropic&&V.parameterf(Q.EXT_texture_filter_anisotropic.TEXTURE_MAX_ANISOTROPY_EXT,E.maxAnisotropy);var EM=new v({VS:function VS(){return"\n                  ".concat(F.maxPrecision.vs.float,"\n                  ").concat(X.inject("vertex",0),"\n                  ").concat(IM.injectUniform("resolution"),"\n                  varying vec2 coords;\n\n                  void main() {\n                    coords.x = vertex.x * 0.5 + 0.5;\n                    float resultHeight = 1.0 - resolution.x / ").concat(Z.assets.canvasBG.width,".0 * ").concat(Z.assets.canvasBG.height,".0;\n                    coords.y = resolution.y / resultHeight * (vertex.y * 0.5 + 0.5) + (resultHeight - resolution.y) / resultHeight * 0.5;\n                    gl_Position = vec4(vertex, 1.0);\n                  }");},FS:function FS(){return"\n                  ".concat(F.maxPrecision.fs.float,"\n                  ").concat(new b().set(0).injectUniform("BG","sampler2D"),"\n                  varying vec2 coords;\n\n                  void main() {\n                    gl_FragColor = texture2D(BG, coords);\n                  }");}}).compose(),gM=new H().bind().data(new Float32Array([-1,-1,0,-1,1,0,1,1,0,1,-1,0]).buffer,f),QM=new K().bind().data(new Uint16Array([0,1,2,2,3,0]),f);SM=function SM(){Y.disable(MM),EM.use3(),gM.bind().attrib(),QM.bind(),Y.drawElements(AM,6,uM,0),Y.enable(MM);};var YM=u();YM.bindMouseEvents(!0,!0),YM.bindTouchEvents(!0,!0,!0),YM.obj.translateZ(700),YM.obj.origin.z(-700),YM.updateProjectionMatrix[TM[0]](),YM.update(),Z.orbit=YM;var cM=new h(),OM=new p(new Float64Array(4)),kM={upper:{teeth:new D("upper_teeth"),gums:new D("upper_gums"),locks:new D("upper_locks")},lower:{teeth:new D("lower_teeth"),gums:new D("lower_gums"),locks:new D("lower_locks")}},oM=function oM(M,L,j){return M.vertexBuffer.bind().subData(0,M.arr[L].vertexOverallData).subData(M.maxVertexOverallDataLength,M.arr[j].vertexOverallData);},nM=function nM(M,L){M.indexBuffer.length=M.arr[L].indexData.length,M.indexBuffer.bind().subData(0,M.arr[L].indexData);},eM=kM.upper.teeth,JM=eM.arr,aM=null,UM=null,rM=null,mM=null,PM=function PM(M,L,j){aM=JM[M].shaderProgress,UM=JM[M].shaderEnd,rM=JM[M].bufferStart,mM=JM[M].bufferEnd,oM(eM,rM[L],rM[j]),nM(eM,rM[L]);},GM=kM.lower.teeth,lM=GM.arr,dM=null,ZM=null,BM=null,fM=null,WM=function WM(M,L,j){dM=lM[M].shaderProgress,ZM=lM[M].shaderEnd,BM=lM[M].bufferStart,fM=lM[M].bufferEnd,oM(GM,BM[L],BM[j]),nM(GM,BM[L]);},vM=kM.upper.gums,bM=vM.arr,hM=null,RM=null,pM=null,FM=null,XM=kM.lower.gums,HM=XM.arr,KM=null,VM=null,qM=null,_M=null,$M=kM.upper.locks,ML=$M.arr,LL=null,jL=null,AL=null,uL=null,wL=kM.lower.locks,NL=wL.arr,CL=null,yL=null,TL=null,DL=null,zL=function zL(){O("._3d_plan-info-upper_separation_label.-active").removeClass("-active"),O("#_3d_plan-info-upper_separation_label_".concat(-1)).addClass("-active"),O("._3d_plan-info-lower_separation_label.-active").removeClass("-active"),O("#_3d_plan-info-lower_separation_label_".concat(-1)).addClass("-active");},iL=function iL(M,L){sM.set(M).$(),O("._3d_plan-info-upper_separation_label.-active").removeClass("-active"),O("#_3d_plan-info-upper_separation_label_".concat(M)).addClass("-active"),O("._3d_plan-info-lower_separation_label.-active").removeClass("-active"),O("#_3d_plan-info-lower_separation_label_".concat(M)).addClass("-active"),oM(eM,mM[0],mM[1]),nM(eM,mM[0]),oM(GM,fM[0],fM[1]),nM(GM,fM[0]),cM.set(UM[L],ZM[L]).$();},tL=function tL(M,L){iL(M,L),oM(vM,FM[0],FM[1]),nM(vM,FM[0]),oM(XM,_M[0],_M[1]),nM(XM,_M[0]),oM($M,uL[0],uL[1]),nM($M,uL[0]),oM(wL,DL[0],DL[1]),nM(wL,DL[0]),OM.set(RM[L],VM[L],jL[L],yL[L]).$();},sL=new W(_),SL=null;SL=o?U?function(M,L,j,A){sM.set(-1).$(),zL(),PM(M,j,A),WM(M,j,A),sL.set(B,function(){return cM.set(a(aM[j],aM[A],sL.interpolation),a(dM[j],dM[A],sL.interpolation)).$();},function(){return iL(M,L);});}:function(M,L){sM.set(-1).$(),zL(),UM=JM[M].shaderEnd,mM=JM[M].bufferEnd,ZM=lM[M].shaderEnd,fM=lM[M].bufferEnd,iL(M,L);}:U?function(M,L,j,A){sM.set(-1).$(),zL(),PM(M,j,A),WM(M,j,A),function(M,L,j){hM=bM[M].shaderProgress,RM=bM[M].shaderEnd,pM=bM[M].bufferStart,FM=bM[M].bufferEnd,oM(vM,pM[L],pM[j]),nM(vM,pM[L]);}(M,j,A),function(M,L,j){KM=HM[M].shaderProgress,VM=HM[M].shaderEnd,qM=HM[M].bufferStart,_M=HM[M].bufferEnd,oM(XM,qM[L],qM[j]),nM(XM,qM[L]);}(M,j,A),function(M,L,j){LL=ML[M].shaderProgress,jL=ML[M].shaderEnd,AL=ML[M].bufferStart,uL=ML[M].bufferEnd,oM($M,AL[L],AL[j]),nM($M,AL[L]);}(M,j,A),function(M,L,j){var A=NL[M];CL=A.shaderProgress,yL=A.shaderEnd,TL=A.bufferStart,DL=A.bufferEnd,oM(wL,TL[L],TL[j]),nM(wL,TL[L]);}(M,j,A),sL.set(B,function(){cM.set(a(aM[j],aM[A],sL.interpolation),a(dM[j],dM[A],sL.interpolation)).$(),OM.set(a(hM[j],hM[A],sL.interpolation),a(KM[j],KM[A],sL.interpolation),a(LL[j],LL[A],sL.interpolation),a(CL[j],CL[A],sL.interpolation)).$();},function(){return tL(M,L);});}:function(M,L){sM.set(-1).$(),zL(),UM=JM[M].shaderEnd,mM=JM[M].bufferEnd,ZM=lM[M].shaderEnd,fM=lM[M].bufferEnd,RM=bM[M].shaderEnd,FM=bM[M].bufferEnd,VM=HM[M].shaderEnd,_M=HM[M].bufferEnd,jL=ML[M].shaderEnd,uL=ML[M].bufferEnd,yL=NL[M].shaderEnd,DL=NL[M].bufferEnd,tL(M,L);};var IL=new T({stepCount:t.stepCount,clbk:SL});Z.sequencer=IL;var xL=0,EL=0,gL=0;if(Z.assets.upper_gums_v_0||Z.assets.upper_teeth_v_0){for(var QL=new Float32Array(Z.assets.upper_gums_v_0||Z.assets.upper_teeth_v_0),YL=2;YL<QL.length;YL+=3){QL[YL]<xL&&(xL=Math.round(QL[YL]));}for(var cL=0;cL<QL.length;cL+=3){EL+=QL[cL+2],gL++;}}else if(Z.assets.lower_gums_v_0||Z.assets.lower_teeth_v_0){for(var OL=new Float32Array(Z.assets.lower_gums_v_0||Z.assets.lower_teeth_v_0),kL=2;kL<OL.length;kL+=3){OL[kL]<xL&&(xL=Math.round(OL[kL]));}for(var oL=0;oL<OL.length;oL+=3){EL+=OL[oL+2],gL++;}}EL/=gL,xL=xL.toString().split(".")[0];var nL=function nL(){return 0;};if(n&&Z.assets.upper_teeth_v_0){var eL=new V();Y.activeTexture(Y.TEXTURE0+1),V.bind(eL).image2D(0,Y.RGBA,Y.RGBA,Y.UNSIGNED_BYTE,Z.assets.logo).parameteri(Y.TEXTURE_MAG_FILTER,Y.LINEAR).parameteri(Y.TEXTURE_MIN_FILTER,Y.LINEAR_MIPMAP_LINEAR).parameteri(Y.TEXTURE_WRAP_S,Y.CLAMP_TO_EDGE).parameteri(Y.TEXTURE_WRAP_T,Y.CLAMP_TO_EDGE).mipmap(),Q.EXT_texture_filter_anisotropic&&V.parameterf(Q.EXT_texture_filter_anisotropic.TEXTURE_MAX_ANISOTROPY_EXT,E.maxAnisotropy);var JL=new v({vertexOffset:xL,varyings:"\n                  varying vec4 vPosition;\n                  varying vec3 lightDir;\n                  varying vec2 vTexCoord;",VS:function VS(M){return"\n                  ".concat(F.maxPrecision.vs.float,"\n                  ").concat(YM.camera.projectionMatrix.injectUniform("projectionMatrix"),"\n                  ").concat(YM.camera.viewMatrix.injectUniform("viewMatrix"),"\n                  ").concat(YM.obj.matrix.injectUniform("cameraPosition","vec3[12]"),"\n                  ").concat(YM.zoom.injectUniform("zoom"),"\n                  ").concat(CM.injectUniform("rotationX"),"\n                  ").concat(yM.injectUniform("visibility"),"\n                  ").concat(NM.injectUniform("index","int"),"\n                  ").concat(X.inject("vertex",0),"\n                  ").concat(X.inject("texCoord",1,"vec2"),"\n                  ").concat(M.varyings,"\n                  ").concat(F.consts.ROTATION_MATRIX_X,"\n\n                  void main() {\n                    float jawsOpened = rotationX / 1.57;\n                    vPosition = ROTATION_MATRIX_X(rotationX) * vec4(vertex, zoom * (1.0 + jawsOpened * 0.5));\n                    vPosition.y -= (").concat(M.vertexOffset,".0 - 5.0) * jawsOpened;\n                    lightDir = normalize(cameraPosition - vertex);\n                    gl_Position = projectionMatrix * viewMatrix * vPosition * visibility[index];\n                    vTexCoord = texCoord;\n                  }");},FS:function FS(M){return"\n                  #extension GL_OES_standard_derivatives: enable\n                  ".concat(F.maxPrecision.fs.float,"\n                  ").concat(new b().set(1).injectUniform("logo","sampler2D"),"\n                  ").concat(M.varyings,"\n\n                  void main() {\n                    vec3 flatNormal = normalize(cross(dFdx(vPosition.xyz), dFdy(vPosition.xyz)));\n                    float diffuse = dot(flatNormal, lightDir) + 0.125;\n                    vec4 texel = texture2D(logo, vTexCoord);\n                    gl_FragColor = texel * vec4(diffuse);\n                  }");}}).compose(),aL=new H().bind().data(new Float32Array([-10,20,-10+EL,0,0,-10,20,10+EL,0,1,10,20,10+EL,1,1,10,20,-10+EL,1,0]).buffer,f),UL=new K().bind().data(new Uint16Array([0,1,2,2,3,0]),f);Y.cullFace(Y.BACK),nL=function nL(){Y.disable(MM),Y.enable(LM),JL.use3(),aL.bind().attrib(0,3,wM,0,20).attrib(1,2,wM,0,20,12),UL.bind(),Y.drawElements(AM,6,uM,0),Y.disable(LM),Y.enable(MM);};}var rL,mL,PL=(rL=Z.teethOcclusion,mL=Z.teethColor,new v({vertexOffset:xL,varyings:"\n                varying vec4 vPosition;\n                varying vec3 lightDir;\n                varying vec4 vColor;",VS:function VS(M){return"\n                ".concat(F.maxPrecision.vs.float,"\n                ").concat(YM.camera.projectionMatrix.injectUniform("projectionMatrix"),"\n                ").concat(YM.camera.viewMatrix.injectUniform("viewMatrix"),"\n                ").concat(YM.obj.matrix.injectUniform("cameraPosition","vec3[12]"),"\n                ").concat(YM.zoom.injectUniform("zoom"),"\n                ").concat(cM.injectUniform("vertexInterpolation"),"\n                ").concat(new h().set(2,0).injectUniform("side"),"\n                ").concat(CM.injectUniform("rotationX"),"\n                ").concat(yM.injectUniform("visibility"),"\n                ").concat(NM.injectUniform("index","int"),"\n                ").concat(X.inject("vertex0",0),"\n                ").concat(X.inject("vertex1",1),"\n                ").concat(rL?"\n                  ".concat(X.inject("occlusionColor0",2),"\n                  ").concat(X.inject("occlusionColor1",3),"\n                "):"","\n                ").concat(mL?"\n                  ".concat(X.inject("teethColor0",4),"\n                  ").concat(X.inject("teethColor1",5),"\n                "):"","\n                ").concat(M.varyings,"\n                ").concat(F.consts.ROTATION_MATRIX_X,"\n  \n                void main() {\n                  vec3 resultVertex = mix(vertex0, vertex1, vertexInterpolation[index]);\n                  float jawsOpened = rotationX / 1.57;\n                  vPosition = ROTATION_MATRIX_X((side[index] - 1.0) * rotationX) * vec4(resultVertex, zoom * (1.0 + jawsOpened * 0.5));\n                  vPosition.y -= (").concat(M.vertexOffset,".0 - 5.0) * (side[index] - 1.0) * jawsOpened;\n                  lightDir = normalize(cameraPosition - resultVertex);\n                  gl_Position = projectionMatrix * viewMatrix * vPosition * visibility[index];\n                  vec4 originalColor = ").concat(mL?" vec4(mix(teethColor0, teethColor1, vertexInterpolation[index]), 1.0)":"vec4(1.0)",";\n                  vColor = ").concat(rL?" vec4(mix(originalColor.rgb, mix(occlusionColor0, occlusionColor1, vertexInterpolation[index]), jawsOpened), 1.0)":"originalColor",";\n                }");},FS:function FS(M){return"\n                #extension GL_OES_standard_derivatives: enable\n                ".concat(F.maxPrecision.fs.float,"\n                ").concat(M.varyings,"\n  \n                void main() {\n                  float diffuse = dot(normalize(cross(dFdx(vPosition.xyz), dFdy(vPosition.xyz))), lightDir) + 0.125;\n                  gl_FragColor = vColor * diffuse;\n                }");}}).compose()),GL=new v({vertexOffset:xL,gumsColor:new p().makeFromHex("ff9c8e").arr,varyings:"\n                varying vec3 vVertex;\n                varying vec4 vPosition;\n                varying vec3 lightDir;\n                varying vec4 vColor;",VS:function VS(M){return"\n                ".concat(F.maxPrecision.vs.float,"\n                ").concat(YM.camera.projectionMatrix.injectUniform("projectionMatrix"),"\n                ").concat(YM.camera.viewMatrix.injectUniform("viewMatrix"),"\n                ").concat(YM.obj.matrix.injectUniform("cameraPosition","vec3[12]"),"\n                ").concat(YM.zoom.injectUniform("zoom"),"\n                ").concat(OM.injectUniform("vertexInterpolation"),"\n                ").concat(new p().set(2,0,2,0).injectUniform("side"),"\n                ").concat(CM.injectUniform("rotationX"),"\n                ").concat(yM.injectUniform("visibility"),"\n                ").concat(NM.injectUniform("index","int"),"\n                ").concat(new p(new Float64Array([].concat(A(M.gumsColor),A(new p().makeFromHex(Z.config.locks.replace("#",""),1).arr)))).injectUniform("color","vec4[]"),"\n                ").concat(X.inject("vertex0",0),"\n                ").concat(X.inject("vertex1",1),"\n                ").concat(M.varyings,"\n                ").concat(F.consts.ROTATION_MATRIX_X,"\n  \n                void main() {\n                  vec3 resultVertex = mix(vertex0, vertex1, vertexInterpolation[index]);\n                  vVertex = resultVertex;\n                  float jawsOpened = rotationX / 1.57;\n                  vPosition = ROTATION_MATRIX_X((side[index] - 1.0) * rotationX) * vec4(resultVertex, zoom * (1.0 + jawsOpened * 0.5));\n                  vPosition.y -= (").concat(M.vertexOffset,".0 - 5.0) * (side[index] - 1.0) * jawsOpened;\n                  lightDir = normalize(cameraPosition - resultVertex);\n                  gl_Position = projectionMatrix * viewMatrix * vPosition * visibility[index];\n                  vColor = color[int(float(index) * 0.5)];\n                }");},FS:function FS(M){return"\n                #extension GL_OES_standard_derivatives: enable\n                ".concat(F.maxPrecision.fs.float,"\n                ").concat(new p().makeFromHex(Z.config.cap.replace("#","")).injectUniform("capColor"),"\n                ").concat(M.varyings,"\n  \n                void main() {\n                  vec3 flatNormal = normalize(cross(dFdx(vPosition.xyz), dFdy(vPosition.xyz)));\n                  vec3 flatNormal2 = normalize(cross(dFdx(vVertex.xyz), dFdy(vVertex.xyz)));\n                  float diffuse = dot(flatNormal, lightDir) + 0.125;\n                  ").concat(n?"\n                      float colorTop = float((vVertex.y > 19.9 && dot(flatNormal2, vec3(0.0, 1.0, 0.0)) > 0.9) || (vVertex.y < -19.9 && dot(flatNormal2, vec3(0.0, -1.0, 0.0)) > 0.9));\n                      gl_FragColor = (mix(vColor, vec4(capColor), colorTop)) * vec4(diffuse);\n                    ":"gl_FragColor = vColor * vec4(diffuse);","\n                }");}}).compose(),lL=(k?I:S)(kM.upper.teeth),dL=(k?I:S)(kM.lower.teeth),ZL=s(kM.upper.gums),BL=s(kM.lower.gums),fL=s(kM.upper.locks),WL=s(kM.lower.locks),vL=[function(){return 0;},w(Z)],bL=[[],[]];Z.separationInfo=bL;var hL=function hL(){return 0;},RL=function RL(){return 0;};if(Z.drawLabels=function(){return 0;},e){var pL=[],FL=[],XL=[],HL=[],KL=[];Z.beginSeparationPoints=pL,Z.endSeparationPoints=FL,Z.separationValues=XL,Z.separationSteps=HL,Z.separationSides=KL,[t.dict.plan.upper||{},t.dict.plan.lower||{}].forEach(function(M,L){Object.keys(M).forEach(function(j){if(M[j].separation){var A=M[j].separation,u=M[j].centroid,w=M[j].model[0].from,N="_3d_plan-info-".concat(0===L?"upper":"lower","_separation_label");bL[L].push(O('<div class="'.concat(N,'" id="').concat(N,"_").concat(M[j].model[0].from,'">&nbsp;&nbsp;&nbsp;&nbsp;').concat("Step"," ").concat(M[j].model[0].from+1,"</div>"))),bL[L][bL[L].length-1].step=M[j].model[0].from,Object.keys(A).forEach(function(M){var j=A[M],N=new R(new Float64Array(u[j.a])),C=new R(new Float64Array(u[j.b]));XL.push(2*parseFloat((j.size.match(/[0-9]+.[0-9]+/g)||[0])[0])),HL.push(w),KL.push(L),N.add(C).mulS(.5),pL.push(N),FL.push(N.clone().mulS(2).y(-18*(2*L-1)));});}});}),XL.length&&(hL=N(Z),RL=C(Z),y(Z));}var VL=[function(){return 0;},function(){hL(),RL(),Z.drawLabels();}];new z(),new i();var qL=function qL(){E.setSize(0,0,window.innerWidth,window.innerHeight),IL.trackWidth=IL.track.width(),IL.stepLength=IL.trackWidth/IL.stepCount,IL.track.toggleClass("-empty",IL.stepLength<20),IL.runner.css({"margin-left":.5*(IL.stepLength-20)+2,left:IL.currentStep*IL.stepLength}),IM.set(window.innerWidth,window.innerHeight).$(),YM.updateProjectionMatrix[TM[0]](),P.css({top:"-".concat(P[0].offsetHeight,"px")});};L.on("resize",qL),qL(),O("#_3d_plan-controls-actions-logo").remove(),qL();var _L=[function(){return 0;},function(){NM.set(2),GL.updateUniform("index"),fL(),NM.set(3),GL.updateUniform("index"),WL();}],$L=null;($L=o?e?function(){PL.use3(),NM.set(0),PL.updateUniform("index"),lL(),NM.set(1),PL.updateUniform("index"),dL(),vL[TM[0]](),VL[DM.arr[0]](),nL();}:function(){PL.use3(),NM.set(0),PL.updateUniform("index"),lL(),NM.set(1),PL.updateUniform("index"),dL(),vL[TM[0]](),nL();}:e?function(){PL.use3(),NM.set(0),PL.updateUniform("index"),lL(),NM.set(1),PL.updateUniform("index"),dL(),GL.use3(),NM.set(0),GL.updateUniform("index"),ZL(),NM.set(1),GL.updateUniform("index"),BL(),_L[tM[0]](),vL[TM[0]](),VL[DM.arr[0]](),nL();}:function(){PL.use3(),NM.set(0),PL.updateUniform("index"),lL(),NM.set(1),PL.updateUniform("index"),dL(),GL.use3(),NM.set(0),GL.updateUniform("index"),ZL(),NM.set(1),GL.updateUniform("index"),BL(),_L[tM[0]](),vL[TM[0]](),nL();})(),_.loop2({onStateChange:function onStateChange(){Y.clear($),SM(),$L();}}),m.append(q),IL.clbk(0,1,3,2),l.css({"stroke-dasharray":"280, 1000"}),d.html("100%"),setTimeout(function(){r.remove(),P.addClass("-animated"),G.addClass("-animated");},400);}).catch();}).catch();};f();};},function(M,L){M.exports="data:image/svg+xml;charset=utf-8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIwLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA2NCA2NCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNjQgNjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojMDIyNjNEO3N0cm9rZS13aWR0aDoxO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDF7ZmlsbDpub25lO3N0cm9rZTojMDIyNjNEO3N0cm9rZS13aWR0aDozO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPCEtLSA8ZyBpZD0iY2lyY2xlIj4KCTxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjMyIiBjeT0iMzIiIHI9IjMwLjQiLz4KPC9nPiAtLT4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjEzLjIiIHkxPSIyMSIgeDI9IjUwLjgiIHkyPSIyMSIvPgo8bGluZSBjbGFzcz0ic3QxIiB4MT0iMTMuMiIgeTE9IjMyIiB4Mj0iNTAuOCIgeTI9IjMyIi8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIxMy4yIiB5MT0iNDMiIHgyPSI1MC44IiB5Mj0iNDMiLz4KPC9zdmc+Cg==";},function(M,L){M.exports="data:image/svg+xml;charset=utf-8;base64,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";},function(M,L){M.exports="data:image/svg+xml;charset=utf-8;base64,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";},function(M,L){M.exports="data:image/svg+xml;charset=utf-8;base64,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";},function(M,L){M.exports="data:image/svg+xml;charset=utf-8;base64,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";},function(M,L){M.exports="data:image/svg+xml;charset=utf-8;base64,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";},function(M,L){M.exports="data:image/svg+xml;charset=utf-8;base64,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";},function(M,L){M.exports="data:image/svg+xml;charset=utf-8;base64,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";},function(M,L){M.exports="data:image/svg+xml;charset=utf-8;base64,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";},function(M,L){M.exports="data:image/svg+xml;charset=utf-8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIwLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA2NCA2NCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNjQgNjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRkZGRkZGO3N0cm9rZTojMDIyNjNEO3N0cm9rZS13aWR0aDoyO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDF7ZmlsbDojMDIyNjNEO30KPC9zdHlsZT4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDp0cmFuc3BhcmVudDtzdHJva2U6IzAyMjYzRDtzdHJva2Utd2lkdGg6MTt9Cgkuc3Qxe2ZpbGw6IzAyMjYzRDt9Cjwvc3R5bGU+CjxnIGlkPSJMYXllcl8xXzFfIj4KCTxnIGlkPSJjaXJjbGUiPgoJCTxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjMyIiBjeT0iMzIiIHI9IjMwLjQiLz4KCTwvZz4KPC9nPgo8Zz4KCTxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0yOS44LDE1LjdjMC0wLjksMC4yLTEuNSwwLjYtMS45YzAuNC0wLjQsMS0wLjYsMS42LTAuNmMwLjYsMCwxLjEsMC4yLDEuNiwwLjZjMC40LDAuNCwwLjcsMSwwLjcsMS45CgkJYzAsMC45LTAuMiwxLjUtMC43LDEuOWMtMC40LDAuNC0xLDAuNi0xLjYsMC42Yy0wLjYsMC0xLjItMC4yLTEuNi0wLjZDMzAsMTcuMiwyOS44LDE2LjYsMjkuOCwxNS43eiBNMzMuOSw0Ny43aC0zLjhWMjIuNWgzLjgKCQlWNDcuN3oiLz4KPC9nPgo8L3N2Zz4K";},function(M,L){M.exports="data:image/svg+xml;charset=utf-8;base64,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";},function(M,L){M.exports="data:image/svg+xml;charset=utf-8;base64,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";},function(M,L){M.exports="data:image/svg+xml;charset=utf-8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIwLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA3MS42IDUwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA3MS42IDUwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzAyMjYzRDtzdHJva2U6IzAyMjYzRDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cjwvc3R5bGU+CjxyZWN0IHg9IjMuMSIgeT0iMC43IiBjbGFzcz0ic3QwIiB3aWR0aD0iMTAuNyIgaGVpZ2h0PSI0OC43Ii8+Cjxwb2x5Z29uIGNsYXNzPSJzdDAiIHBvaW50cz0iNjksNDkuNCA2OSwwLjggNDEuMiwyNC44ICIvPgo8cG9seWdvbiBjbGFzcz0ic3QwIiBwb2ludHM9IjQxLjYsNDkuNCA0MS42LDAuOCAxMy44LDI0LjggIi8+Cjwvc3ZnPgo=";},function(M,L){M.exports="data:image/svg+xml;charset=utf-8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIwLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MCA1MCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTAgNTA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojMDIyNjNEO3N0cm9rZTojMDIyNjNEO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPHJlY3QgeD0iMzEuMyIgeT0iMC42IiBjbGFzcz0ic3QwIiB3aWR0aD0iMTEuNyIgaGVpZ2h0PSI0OC43Ii8+CjxyZWN0IHg9IjcuMSIgeT0iMC42IiBjbGFzcz0ic3QwIiB3aWR0aD0iMTEuNyIgaGVpZ2h0PSI0OC43Ii8+Cjwvc3ZnPgo=";},function(M,L){M.exports="data:image/svg+xml;charset=utf-8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIwLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MCA1MCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTAgNTA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojMDIyNjNEO3N0cm9rZTojMDIyNjNEO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPHBvbHlnb24gY2xhc3M9InN0MCIgcG9pbnRzPSIwLjUsMC42IDAuNSw0OS4zIDQ3LjUsMjUuMiAiLz4KPC9zdmc+Cg==";},function(M,L){M.exports="data:image/svg+xml;charset=utf-8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIwLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA3MS42IDUwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA3MS42IDUwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzAyMjYzRDtzdHJva2U6IzAyMjYzRDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cjwvc3R5bGU+CjxyZWN0IHg9IjU4LjMiIHk9IjAuNyIgY2xhc3M9InN0MCIgd2lkdGg9IjEwLjciIGhlaWdodD0iNDguNyIvPgo8cG9seWdvbiBjbGFzcz0ic3QwIiBwb2ludHM9IjMuMSwwLjcgMy4xLDQ5LjMgMzAuOSwyNS4zICIvPgo8cG9seWdvbiBjbGFzcz0ic3QwIiBwb2ludHM9IjMwLjUsMC43IDMwLjUsNDkuMyA1OC4zLDI1LjMgIi8+Cjwvc3ZnPgo=";},function(M,L,j){M.exports=j(0)("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");},function(M,L,j){"use strict";(function(M){/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */var A=j(24),u=j(25),w=j(26);function N(){return y.TYPED_ARRAY_SUPPORT?2147483647:1073741823;}function C(M,L){if(N()<L)throw new RangeError("Invalid typed array length");return y.TYPED_ARRAY_SUPPORT?(M=new Uint8Array(L)).__proto__=y.prototype:(null===M&&(M=new y(L)),M.length=L),M;}function y(M,L,j){if(!(y.TYPED_ARRAY_SUPPORT||this instanceof y))return new y(M,L,j);if("number"==typeof M){if("string"==typeof L)throw new Error("If encoding is specified then the first argument must be a string");return z(this,M);}return T(this,M,L,j);}function T(M,L,j,A){if("number"==typeof L)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&L instanceof ArrayBuffer?function(M,L,j,A){if(L.byteLength,j<0||L.byteLength<j)throw new RangeError("'offset' is out of bounds");if(L.byteLength<j+(A||0))throw new RangeError("'length' is out of bounds");L=void 0===j&&void 0===A?new Uint8Array(L):void 0===A?new Uint8Array(L,j):new Uint8Array(L,j,A);y.TYPED_ARRAY_SUPPORT?(M=L).__proto__=y.prototype:M=i(M,L);return M;}(M,L,j,A):"string"==typeof L?function(M,L,j){"string"==typeof j&&""!==j||(j="utf8");if(!y.isEncoding(j))throw new TypeError('"encoding" must be a valid string encoding');var A=0|s(L,j),u=(M=C(M,A)).write(L,j);u!==A&&(M=M.slice(0,u));return M;}(M,L,j):function(M,L){if(y.isBuffer(L)){var j=0|t(L.length);return 0===(M=C(M,j)).length?M:(L.copy(M,0,0,j),M);}if(L){if("undefined"!=typeof ArrayBuffer&&L.buffer instanceof ArrayBuffer||"length"in L)return"number"!=typeof L.length||(A=L.length)!=A?C(M,0):i(M,L);if("Buffer"===L.type&&w(L.data))return i(M,L.data);}var A;throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");}(M,L);}function D(M){if("number"!=typeof M)throw new TypeError('"size" argument must be a number');if(M<0)throw new RangeError('"size" argument must not be negative');}function z(M,L){if(D(L),M=C(M,L<0?0:0|t(L)),!y.TYPED_ARRAY_SUPPORT)for(var j=0;j<L;++j){M[j]=0;}return M;}function i(M,L){var j=L.length<0?0:0|t(L.length);M=C(M,j);for(var A=0;A<j;A+=1){M[A]=255&L[A];}return M;}function t(M){if(M>=N())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+N().toString(16)+" bytes");return 0|M;}function s(M,L){if(y.isBuffer(M))return M.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(M)||M instanceof ArrayBuffer))return M.byteLength;"string"!=typeof M&&(M=""+M);var j=M.length;if(0===j)return 0;for(var A=!1;;){switch(L){case"ascii":case"latin1":case"binary":return j;case"utf8":case"utf-8":case void 0:return W(M).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*j;case"hex":return j>>>1;case"base64":return v(M).length;default:if(A)return W(M).length;L=(""+L).toLowerCase(),A=!0;}}}function S(M,L,j){var A=!1;if((void 0===L||L<0)&&(L=0),L>this.length)return"";if((void 0===j||j>this.length)&&(j=this.length),j<=0)return"";if((j>>>=0)<=(L>>>=0))return"";for(M||(M="utf8");;){switch(M){case"hex":return a(this,L,j);case"utf8":case"utf-8":return n(this,L,j);case"ascii":return e(this,L,j);case"latin1":case"binary":return J(this,L,j);case"base64":return o(this,L,j);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return U(this,L,j);default:if(A)throw new TypeError("Unknown encoding: "+M);M=(M+"").toLowerCase(),A=!0;}}}function I(M,L,j){var A=M[L];M[L]=M[j],M[j]=A;}function x(M,L,j,A,u){if(0===M.length)return-1;if("string"==typeof j?(A=j,j=0):j>2147483647?j=2147483647:j<-2147483648&&(j=-2147483648),j=+j,isNaN(j)&&(j=u?0:M.length-1),j<0&&(j=M.length+j),j>=M.length){if(u)return-1;j=M.length-1;}else if(j<0){if(!u)return-1;j=0;}if("string"==typeof L&&(L=y.from(L,A)),y.isBuffer(L))return 0===L.length?-1:E(M,L,j,A,u);if("number"==typeof L)return L&=255,y.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?u?Uint8Array.prototype.indexOf.call(M,L,j):Uint8Array.prototype.lastIndexOf.call(M,L,j):E(M,[L],j,A,u);throw new TypeError("val must be string, number or Buffer");}function E(M,L,j,A,u){var w,N=1,C=M.length,y=L.length;if(void 0!==A&&("ucs2"===(A=String(A).toLowerCase())||"ucs-2"===A||"utf16le"===A||"utf-16le"===A)){if(M.length<2||L.length<2)return-1;N=2,C/=2,y/=2,j/=2;}function T(M,L){return 1===N?M[L]:M.readUInt16BE(L*N);}if(u){var D=-1;for(w=j;w<C;w++){if(T(M,w)===T(L,-1===D?0:w-D)){if(-1===D&&(D=w),w-D+1===y)return D*N;}else-1!==D&&(w-=w-D),D=-1;}}else for(j+y>C&&(j=C-y),w=j;w>=0;w--){for(var z=!0,i=0;i<y;i++){if(T(M,w+i)!==T(L,i)){z=!1;break;}}if(z)return w;}return-1;}function g(M,L,j,A){j=Number(j)||0;var u=M.length-j;A?(A=Number(A))>u&&(A=u):A=u;var w=L.length;if(w%2!=0)throw new TypeError("Invalid hex string");A>w/2&&(A=w/2);for(var N=0;N<A;++N){var C=parseInt(L.substr(2*N,2),16);if(isNaN(C))return N;M[j+N]=C;}return N;}function Q(M,L,j,A){return b(W(L,M.length-j),M,j,A);}function Y(M,L,j,A){return b(function(M){for(var L=[],j=0;j<M.length;++j){L.push(255&M.charCodeAt(j));}return L;}(L),M,j,A);}function c(M,L,j,A){return Y(M,L,j,A);}function O(M,L,j,A){return b(v(L),M,j,A);}function k(M,L,j,A){return b(function(M,L){for(var j,A,u,w=[],N=0;N<M.length&&!((L-=2)<0);++N){j=M.charCodeAt(N),A=j>>8,u=j%256,w.push(u),w.push(A);}return w;}(L,M.length-j),M,j,A);}function o(M,L,j){return 0===L&&j===M.length?A.fromByteArray(M):A.fromByteArray(M.slice(L,j));}function n(M,L,j){j=Math.min(M.length,j);for(var A=[],u=L;u<j;){var w,N,C,y,T=M[u],D=null,z=T>239?4:T>223?3:T>191?2:1;if(u+z<=j)switch(z){case 1:T<128&&(D=T);break;case 2:128==(192&(w=M[u+1]))&&(y=(31&T)<<6|63&w)>127&&(D=y);break;case 3:w=M[u+1],N=M[u+2],128==(192&w)&&128==(192&N)&&(y=(15&T)<<12|(63&w)<<6|63&N)>2047&&(y<55296||y>57343)&&(D=y);break;case 4:w=M[u+1],N=M[u+2],C=M[u+3],128==(192&w)&&128==(192&N)&&128==(192&C)&&(y=(15&T)<<18|(63&w)<<12|(63&N)<<6|63&C)>65535&&y<1114112&&(D=y);}null===D?(D=65533,z=1):D>65535&&(D-=65536,A.push(D>>>10&1023|55296),D=56320|1023&D),A.push(D),u+=z;}return function(M){var L=M.length;if(L<=4096)return String.fromCharCode.apply(String,M);var j="",A=0;for(;A<L;){j+=String.fromCharCode.apply(String,M.slice(A,A+=4096));}return j;}(A);}L.Buffer=y,L.SlowBuffer=function(M){+M!=M&&(M=0);return y.alloc(+M);},L.INSPECT_MAX_BYTES=50,y.TYPED_ARRAY_SUPPORT=void 0!==M.TYPED_ARRAY_SUPPORT?M.TYPED_ARRAY_SUPPORT:function(){try{var M=new Uint8Array(1);return M.__proto__={__proto__:Uint8Array.prototype,foo:function foo(){return 42;}},42===M.foo()&&"function"==typeof M.subarray&&0===M.subarray(1,1).byteLength;}catch(M){return!1;}}(),L.kMaxLength=N(),y.poolSize=8192,y._augment=function(M){return M.__proto__=y.prototype,M;},y.from=function(M,L,j){return T(null,M,L,j);},y.TYPED_ARRAY_SUPPORT&&(y.prototype.__proto__=Uint8Array.prototype,y.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&y[Symbol.species]===y&&Object.defineProperty(y,Symbol.species,{value:null,configurable:!0})),y.alloc=function(M,L,j){return function(M,L,j,A){return D(L),L<=0?C(M,L):void 0!==j?"string"==typeof A?C(M,L).fill(j,A):C(M,L).fill(j):C(M,L);}(null,M,L,j);},y.allocUnsafe=function(M){return z(null,M);},y.allocUnsafeSlow=function(M){return z(null,M);},y.isBuffer=function(M){return!(null==M||!M._isBuffer);},y.compare=function(M,L){if(!y.isBuffer(M)||!y.isBuffer(L))throw new TypeError("Arguments must be Buffers");if(M===L)return 0;for(var j=M.length,A=L.length,u=0,w=Math.min(j,A);u<w;++u){if(M[u]!==L[u]){j=M[u],A=L[u];break;}}return j<A?-1:A<j?1:0;},y.isEncoding=function(M){switch(String(M).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1;}},y.concat=function(M,L){if(!w(M))throw new TypeError('"list" argument must be an Array of Buffers');if(0===M.length)return y.alloc(0);var j;if(void 0===L)for(L=0,j=0;j<M.length;++j){L+=M[j].length;}var A=y.allocUnsafe(L),u=0;for(j=0;j<M.length;++j){var N=M[j];if(!y.isBuffer(N))throw new TypeError('"list" argument must be an Array of Buffers');N.copy(A,u),u+=N.length;}return A;},y.byteLength=s,y.prototype._isBuffer=!0,y.prototype.swap16=function(){var M=this.length;if(M%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var L=0;L<M;L+=2){I(this,L,L+1);}return this;},y.prototype.swap32=function(){var M=this.length;if(M%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var L=0;L<M;L+=4){I(this,L,L+3),I(this,L+1,L+2);}return this;},y.prototype.swap64=function(){var M=this.length;if(M%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var L=0;L<M;L+=8){I(this,L,L+7),I(this,L+1,L+6),I(this,L+2,L+5),I(this,L+3,L+4);}return this;},y.prototype.toString=function(){var M=0|this.length;return 0===M?"":0===arguments.length?n(this,0,M):S.apply(this,arguments);},y.prototype.equals=function(M){if(!y.isBuffer(M))throw new TypeError("Argument must be a Buffer");return this===M||0===y.compare(this,M);},y.prototype.inspect=function(){var M="",j=L.INSPECT_MAX_BYTES;return this.length>0&&(M=this.toString("hex",0,j).match(/.{2}/g).join(" "),this.length>j&&(M+=" ... ")),"<Buffer "+M+">";},y.prototype.compare=function(M,L,j,A,u){if(!y.isBuffer(M))throw new TypeError("Argument must be a Buffer");if(void 0===L&&(L=0),void 0===j&&(j=M?M.length:0),void 0===A&&(A=0),void 0===u&&(u=this.length),L<0||j>M.length||A<0||u>this.length)throw new RangeError("out of range index");if(A>=u&&L>=j)return 0;if(A>=u)return-1;if(L>=j)return 1;if(this===M)return 0;for(var w=(u>>>=0)-(A>>>=0),N=(j>>>=0)-(L>>>=0),C=Math.min(w,N),T=this.slice(A,u),D=M.slice(L,j),z=0;z<C;++z){if(T[z]!==D[z]){w=T[z],N=D[z];break;}}return w<N?-1:N<w?1:0;},y.prototype.includes=function(M,L,j){return-1!==this.indexOf(M,L,j);},y.prototype.indexOf=function(M,L,j){return x(this,M,L,j,!0);},y.prototype.lastIndexOf=function(M,L,j){return x(this,M,L,j,!1);},y.prototype.write=function(M,L,j,A){if(void 0===L)A="utf8",j=this.length,L=0;else if(void 0===j&&"string"==typeof L)A=L,j=this.length,L=0;else{if(!isFinite(L))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");L|=0,isFinite(j)?(j|=0,void 0===A&&(A="utf8")):(A=j,j=void 0);}var u=this.length-L;if((void 0===j||j>u)&&(j=u),M.length>0&&(j<0||L<0)||L>this.length)throw new RangeError("Attempt to write outside buffer bounds");A||(A="utf8");for(var w=!1;;){switch(A){case"hex":return g(this,M,L,j);case"utf8":case"utf-8":return Q(this,M,L,j);case"ascii":return Y(this,M,L,j);case"latin1":case"binary":return c(this,M,L,j);case"base64":return O(this,M,L,j);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return k(this,M,L,j);default:if(w)throw new TypeError("Unknown encoding: "+A);A=(""+A).toLowerCase(),w=!0;}}},y.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)};};function e(M,L,j){var A="";j=Math.min(M.length,j);for(var u=L;u<j;++u){A+=String.fromCharCode(127&M[u]);}return A;}function J(M,L,j){var A="";j=Math.min(M.length,j);for(var u=L;u<j;++u){A+=String.fromCharCode(M[u]);}return A;}function a(M,L,j){var A=M.length;(!L||L<0)&&(L=0),(!j||j<0||j>A)&&(j=A);for(var u="",w=L;w<j;++w){u+=f(M[w]);}return u;}function U(M,L,j){for(var A=M.slice(L,j),u="",w=0;w<A.length;w+=2){u+=String.fromCharCode(A[w]+256*A[w+1]);}return u;}function r(M,L,j){if(M%1!=0||M<0)throw new RangeError("offset is not uint");if(M+L>j)throw new RangeError("Trying to access beyond buffer length");}function m(M,L,j,A,u,w){if(!y.isBuffer(M))throw new TypeError('"buffer" argument must be a Buffer instance');if(L>u||L<w)throw new RangeError('"value" argument is out of bounds');if(j+A>M.length)throw new RangeError("Index out of range");}function P(M,L,j,A){L<0&&(L=65535+L+1);for(var u=0,w=Math.min(M.length-j,2);u<w;++u){M[j+u]=(L&255<<8*(A?u:1-u))>>>8*(A?u:1-u);}}function G(M,L,j,A){L<0&&(L=4294967295+L+1);for(var u=0,w=Math.min(M.length-j,4);u<w;++u){M[j+u]=L>>>8*(A?u:3-u)&255;}}function l(M,L,j,A,u,w){if(j+A>M.length)throw new RangeError("Index out of range");if(j<0)throw new RangeError("Index out of range");}function d(M,L,j,A,w){return w||l(M,0,j,4),u.write(M,L,j,A,23,4),j+4;}function Z(M,L,j,A,w){return w||l(M,0,j,8),u.write(M,L,j,A,52,8),j+8;}y.prototype.slice=function(M,L){var j,A=this.length;if((M=~~M)<0?(M+=A)<0&&(M=0):M>A&&(M=A),(L=void 0===L?A:~~L)<0?(L+=A)<0&&(L=0):L>A&&(L=A),L<M&&(L=M),y.TYPED_ARRAY_SUPPORT)(j=this.subarray(M,L)).__proto__=y.prototype;else{var u=L-M;j=new y(u,void 0);for(var w=0;w<u;++w){j[w]=this[w+M];}}return j;},y.prototype.readUIntLE=function(M,L,j){M|=0,L|=0,j||r(M,L,this.length);for(var A=this[M],u=1,w=0;++w<L&&(u*=256);){A+=this[M+w]*u;}return A;},y.prototype.readUIntBE=function(M,L,j){M|=0,L|=0,j||r(M,L,this.length);for(var A=this[M+--L],u=1;L>0&&(u*=256);){A+=this[M+--L]*u;}return A;},y.prototype.readUInt8=function(M,L){return L||r(M,1,this.length),this[M];},y.prototype.readUInt16LE=function(M,L){return L||r(M,2,this.length),this[M]|this[M+1]<<8;},y.prototype.readUInt16BE=function(M,L){return L||r(M,2,this.length),this[M]<<8|this[M+1];},y.prototype.readUInt32LE=function(M,L){return L||r(M,4,this.length),(this[M]|this[M+1]<<8|this[M+2]<<16)+16777216*this[M+3];},y.prototype.readUInt32BE=function(M,L){return L||r(M,4,this.length),16777216*this[M]+(this[M+1]<<16|this[M+2]<<8|this[M+3]);},y.prototype.readIntLE=function(M,L,j){M|=0,L|=0,j||r(M,L,this.length);for(var A=this[M],u=1,w=0;++w<L&&(u*=256);){A+=this[M+w]*u;}return A>=(u*=128)&&(A-=Math.pow(2,8*L)),A;},y.prototype.readIntBE=function(M,L,j){M|=0,L|=0,j||r(M,L,this.length);for(var A=L,u=1,w=this[M+--A];A>0&&(u*=256);){w+=this[M+--A]*u;}return w>=(u*=128)&&(w-=Math.pow(2,8*L)),w;},y.prototype.readInt8=function(M,L){return L||r(M,1,this.length),128&this[M]?-1*(255-this[M]+1):this[M];},y.prototype.readInt16LE=function(M,L){L||r(M,2,this.length);var j=this[M]|this[M+1]<<8;return 32768&j?4294901760|j:j;},y.prototype.readInt16BE=function(M,L){L||r(M,2,this.length);var j=this[M+1]|this[M]<<8;return 32768&j?4294901760|j:j;},y.prototype.readInt32LE=function(M,L){return L||r(M,4,this.length),this[M]|this[M+1]<<8|this[M+2]<<16|this[M+3]<<24;},y.prototype.readInt32BE=function(M,L){return L||r(M,4,this.length),this[M]<<24|this[M+1]<<16|this[M+2]<<8|this[M+3];},y.prototype.readFloatLE=function(M,L){return L||r(M,4,this.length),u.read(this,M,!0,23,4);},y.prototype.readFloatBE=function(M,L){return L||r(M,4,this.length),u.read(this,M,!1,23,4);},y.prototype.readDoubleLE=function(M,L){return L||r(M,8,this.length),u.read(this,M,!0,52,8);},y.prototype.readDoubleBE=function(M,L){return L||r(M,8,this.length),u.read(this,M,!1,52,8);},y.prototype.writeUIntLE=function(M,L,j,A){(M=+M,L|=0,j|=0,A)||m(this,M,L,j,Math.pow(2,8*j)-1,0);var u=1,w=0;for(this[L]=255&M;++w<j&&(u*=256);){this[L+w]=M/u&255;}return L+j;},y.prototype.writeUIntBE=function(M,L,j,A){(M=+M,L|=0,j|=0,A)||m(this,M,L,j,Math.pow(2,8*j)-1,0);var u=j-1,w=1;for(this[L+u]=255&M;--u>=0&&(w*=256);){this[L+u]=M/w&255;}return L+j;},y.prototype.writeUInt8=function(M,L,j){return M=+M,L|=0,j||m(this,M,L,1,255,0),y.TYPED_ARRAY_SUPPORT||(M=Math.floor(M)),this[L]=255&M,L+1;},y.prototype.writeUInt16LE=function(M,L,j){return M=+M,L|=0,j||m(this,M,L,2,65535,0),y.TYPED_ARRAY_SUPPORT?(this[L]=255&M,this[L+1]=M>>>8):P(this,M,L,!0),L+2;},y.prototype.writeUInt16BE=function(M,L,j){return M=+M,L|=0,j||m(this,M,L,2,65535,0),y.TYPED_ARRAY_SUPPORT?(this[L]=M>>>8,this[L+1]=255&M):P(this,M,L,!1),L+2;},y.prototype.writeUInt32LE=function(M,L,j){return M=+M,L|=0,j||m(this,M,L,4,4294967295,0),y.TYPED_ARRAY_SUPPORT?(this[L+3]=M>>>24,this[L+2]=M>>>16,this[L+1]=M>>>8,this[L]=255&M):G(this,M,L,!0),L+4;},y.prototype.writeUInt32BE=function(M,L,j){return M=+M,L|=0,j||m(this,M,L,4,4294967295,0),y.TYPED_ARRAY_SUPPORT?(this[L]=M>>>24,this[L+1]=M>>>16,this[L+2]=M>>>8,this[L+3]=255&M):G(this,M,L,!1),L+4;},y.prototype.writeIntLE=function(M,L,j,A){if(M=+M,L|=0,!A){var u=Math.pow(2,8*j-1);m(this,M,L,j,u-1,-u);}var w=0,N=1,C=0;for(this[L]=255&M;++w<j&&(N*=256);){M<0&&0===C&&0!==this[L+w-1]&&(C=1),this[L+w]=(M/N>>0)-C&255;}return L+j;},y.prototype.writeIntBE=function(M,L,j,A){if(M=+M,L|=0,!A){var u=Math.pow(2,8*j-1);m(this,M,L,j,u-1,-u);}var w=j-1,N=1,C=0;for(this[L+w]=255&M;--w>=0&&(N*=256);){M<0&&0===C&&0!==this[L+w+1]&&(C=1),this[L+w]=(M/N>>0)-C&255;}return L+j;},y.prototype.writeInt8=function(M,L,j){return M=+M,L|=0,j||m(this,M,L,1,127,-128),y.TYPED_ARRAY_SUPPORT||(M=Math.floor(M)),M<0&&(M=255+M+1),this[L]=255&M,L+1;},y.prototype.writeInt16LE=function(M,L,j){return M=+M,L|=0,j||m(this,M,L,2,32767,-32768),y.TYPED_ARRAY_SUPPORT?(this[L]=255&M,this[L+1]=M>>>8):P(this,M,L,!0),L+2;},y.prototype.writeInt16BE=function(M,L,j){return M=+M,L|=0,j||m(this,M,L,2,32767,-32768),y.TYPED_ARRAY_SUPPORT?(this[L]=M>>>8,this[L+1]=255&M):P(this,M,L,!1),L+2;},y.prototype.writeInt32LE=function(M,L,j){return M=+M,L|=0,j||m(this,M,L,4,2147483647,-2147483648),y.TYPED_ARRAY_SUPPORT?(this[L]=255&M,this[L+1]=M>>>8,this[L+2]=M>>>16,this[L+3]=M>>>24):G(this,M,L,!0),L+4;},y.prototype.writeInt32BE=function(M,L,j){return M=+M,L|=0,j||m(this,M,L,4,2147483647,-2147483648),M<0&&(M=4294967295+M+1),y.TYPED_ARRAY_SUPPORT?(this[L]=M>>>24,this[L+1]=M>>>16,this[L+2]=M>>>8,this[L+3]=255&M):G(this,M,L,!1),L+4;},y.prototype.writeFloatLE=function(M,L,j){return d(this,M,L,!0,j);},y.prototype.writeFloatBE=function(M,L,j){return d(this,M,L,!1,j);},y.prototype.writeDoubleLE=function(M,L,j){return Z(this,M,L,!0,j);},y.prototype.writeDoubleBE=function(M,L,j){return Z(this,M,L,!1,j);},y.prototype.copy=function(M,L,j,A){if(j||(j=0),A||0===A||(A=this.length),L>=M.length&&(L=M.length),L||(L=0),A>0&&A<j&&(A=j),A===j)return 0;if(0===M.length||0===this.length)return 0;if(L<0)throw new RangeError("targetStart out of bounds");if(j<0||j>=this.length)throw new RangeError("sourceStart out of bounds");if(A<0)throw new RangeError("sourceEnd out of bounds");A>this.length&&(A=this.length),M.length-L<A-j&&(A=M.length-L+j);var u,w=A-j;if(this===M&&j<L&&L<A)for(u=w-1;u>=0;--u){M[u+L]=this[u+j];}else if(w<1e3||!y.TYPED_ARRAY_SUPPORT)for(u=0;u<w;++u){M[u+L]=this[u+j];}else Uint8Array.prototype.set.call(M,this.subarray(j,j+w),L);return w;},y.prototype.fill=function(M,L,j,A){if("string"==typeof M){if("string"==typeof L?(A=L,L=0,j=this.length):"string"==typeof j&&(A=j,j=this.length),1===M.length){var u=M.charCodeAt(0);u<256&&(M=u);}if(void 0!==A&&"string"!=typeof A)throw new TypeError("encoding must be a string");if("string"==typeof A&&!y.isEncoding(A))throw new TypeError("Unknown encoding: "+A);}else"number"==typeof M&&(M&=255);if(L<0||this.length<L||this.length<j)throw new RangeError("Out of range index");if(j<=L)return this;var w;if(L>>>=0,j=void 0===j?this.length:j>>>0,M||(M=0),"number"==typeof M)for(w=L;w<j;++w){this[w]=M;}else{var N=y.isBuffer(M)?M:W(new y(M,A).toString()),C=N.length;for(w=0;w<j-L;++w){this[w+L]=N[w%C];}}return this;};var B=/[^+\/0-9A-Za-z-_]/g;function f(M){return M<16?"0"+M.toString(16):M.toString(16);}function W(M,L){var j;L=L||1/0;for(var A=M.length,u=null,w=[],N=0;N<A;++N){if((j=M.charCodeAt(N))>55295&&j<57344){if(!u){if(j>56319){(L-=3)>-1&&w.push(239,191,189);continue;}if(N+1===A){(L-=3)>-1&&w.push(239,191,189);continue;}u=j;continue;}if(j<56320){(L-=3)>-1&&w.push(239,191,189),u=j;continue;}j=65536+(u-55296<<10|j-56320);}else u&&(L-=3)>-1&&w.push(239,191,189);if(u=null,j<128){if((L-=1)<0)break;w.push(j);}else if(j<2048){if((L-=2)<0)break;w.push(j>>6|192,63&j|128);}else if(j<65536){if((L-=3)<0)break;w.push(j>>12|224,j>>6&63|128,63&j|128);}else{if(!(j<1114112))throw new Error("Invalid code point");if((L-=4)<0)break;w.push(j>>18|240,j>>12&63|128,j>>6&63|128,63&j|128);}}return w;}function v(M){return A.toByteArray(function(M){if((M=function(M){return M.trim?M.trim():M.replace(/^\s+|\s+$/g,"");}(M).replace(B,"")).length<2)return"";for(;M.length%4!=0;){M+="=";}return M;}(M));}function b(M,L,j,A){for(var u=0;u<A&&!(u+j>=L.length||u>=M.length);++u){L[u+j]=M[u];}return u;}}).call(this,j(23));},function(M,L){var j;j=function(){return this;}();try{j=j||new Function("return this")();}catch(M){"object"==(typeof window==="undefined"?"undefined":_typeof(window))&&(j=window);}M.exports=j;},function(M,L,j){"use strict";L.byteLength=function(M){var L=T(M),j=L[0],A=L[1];return 3*(j+A)/4-A;},L.toByteArray=function(M){for(var L,j=T(M),A=j[0],N=j[1],C=new w(function(M,L,j){return 3*(L+j)/4-j;}(0,A,N)),y=0,D=N>0?A-4:A,z=0;z<D;z+=4){L=u[M.charCodeAt(z)]<<18|u[M.charCodeAt(z+1)]<<12|u[M.charCodeAt(z+2)]<<6|u[M.charCodeAt(z+3)],C[y++]=L>>16&255,C[y++]=L>>8&255,C[y++]=255&L;}2===N&&(L=u[M.charCodeAt(z)]<<2|u[M.charCodeAt(z+1)]>>4,C[y++]=255&L);1===N&&(L=u[M.charCodeAt(z)]<<10|u[M.charCodeAt(z+1)]<<4|u[M.charCodeAt(z+2)]>>2,C[y++]=L>>8&255,C[y++]=255&L);return C;},L.fromByteArray=function(M){for(var L,j=M.length,u=j%3,w=[],N=0,C=j-u;N<C;N+=16383){w.push(D(M,N,N+16383>C?C:N+16383));}1===u?(L=M[j-1],w.push(A[L>>2]+A[L<<4&63]+"==")):2===u&&(L=(M[j-2]<<8)+M[j-1],w.push(A[L>>10]+A[L>>4&63]+A[L<<2&63]+"="));return w.join("");};for(var A=[],u=[],w="undefined"!=typeof Uint8Array?Uint8Array:Array,N="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",C=0,y=N.length;C<y;++C){A[C]=N[C],u[N.charCodeAt(C)]=C;}function T(M){var L=M.length;if(L%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var j=M.indexOf("=");return-1===j&&(j=L),[j,j===L?0:4-j%4];}function D(M,L,j){for(var u,w,N=[],C=L;C<j;C+=3){u=(M[C]<<16&16711680)+(M[C+1]<<8&65280)+(255&M[C+2]),N.push(A[(w=u)>>18&63]+A[w>>12&63]+A[w>>6&63]+A[63&w]);}return N.join("");}u["-".charCodeAt(0)]=62,u["_".charCodeAt(0)]=63;},function(M,L){L.read=function(M,L,j,A,u){var w,N,C=8*u-A-1,y=(1<<C)-1,T=y>>1,D=-7,z=j?u-1:0,i=j?-1:1,t=M[L+z];for(z+=i,w=t&(1<<-D)-1,t>>=-D,D+=C;D>0;w=256*w+M[L+z],z+=i,D-=8){}for(N=w&(1<<-D)-1,w>>=-D,D+=A;D>0;N=256*N+M[L+z],z+=i,D-=8){}if(0===w)w=1-T;else{if(w===y)return N?NaN:1/0*(t?-1:1);N+=Math.pow(2,A),w-=T;}return(t?-1:1)*N*Math.pow(2,w-A);},L.write=function(M,L,j,A,u,w){var N,C,y,T=8*w-u-1,D=(1<<T)-1,z=D>>1,i=23===u?Math.pow(2,-24)-Math.pow(2,-77):0,t=A?0:w-1,s=A?1:-1,S=L<0||0===L&&1/L<0?1:0;for(L=Math.abs(L),isNaN(L)||L===1/0?(C=isNaN(L)?1:0,N=D):(N=Math.floor(Math.log(L)/Math.LN2),L*(y=Math.pow(2,-N))<1&&(N--,y*=2),(L+=N+z>=1?i/y:i*Math.pow(2,1-z))*y>=2&&(N++,y/=2),N+z>=D?(C=0,N=D):N+z>=1?(C=(L*y-1)*Math.pow(2,u),N+=z):(C=L*Math.pow(2,z-1)*Math.pow(2,u),N=0));u>=8;M[j+t]=255&C,t+=s,C/=256,u-=8){}for(N=N<<u|C,T+=u;T>0;M[j+t]=255&N,t+=s,N/=256,T-=8){}M[j+t-s]|=128*S;};},function(M,L){var j={}.toString;M.exports=Array.isArray||function(M){return"[object Array]"==j.call(M);};},function(M,L,j){M.exports=j(0)("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");},function(M,L){M.exports=function(M){var L=M.libs.Bowser;return{DEBUG:window.location.search.match("DEBUG"),MOBILE:L.mobile||L.tablet};};},function(M,L){M.exports=function(M){var L=M.libs.$,j=L(window),A=L("._3d_plan-canvas"),u=L("#_3d_plan-comment-text");return function(){var L=M.CTX,w=M.time,N=L.Orbit,C=L.Vec1,y=new N({mouseDownTarget:A[0],touchStartTarget:A[0],mouseTarget:A[0],touchTarget:A[0],translateZTouchCallback:function translateZTouchCallback(M){y.zoom.set(y.zoom.arr[0]-.005*M).$(),y.zoom.arr[0]<.1?y.zoom.set(.1).$():y.zoom.arr[0]>1.9&&y.zoom.set(1.9).$();},time:w});y.updateProjectionMatrix=[function(){return y.camera.setPerspectiveProjection(10,window.innerWidth/window.innerHeight,1,2e3,1).$();},function(){return y.camera.setOrthographicProjection(window.innerWidth/-2,window.innerWidth/2,window.innerHeight/2,window.innerHeight/-2,1,2e3,6).$();}],y.zoom=new C().set(1),y.mouseDownTarget.addEventListener("wheel",function(M){y.zoom.set(y.zoom.arr[0]+.1*Math.sign(M.deltaY||M.detail||M.wheelDelta)).$(),y.zoom.arr[0]<.1?y.zoom.set(.1).$():y.zoom.arr[0]>1.9&&y.zoom.set(1.9).$();});var T=[function(){return 0;},function(){y.zoom.set(y.zoom.arr[0]-.1).$(),y.zoom.arr[0]<.1&&y.zoom.set(.1).$();},function(){return 0;},function(){y.zoom.set(y.zoom.arr[0]+.1).$(),y.zoom.arr[0]>1.9&&y.zoom.set(1.9).$();}];return j.on("keydown",function(M){M.target!==u[0]&&M.keyCode>36&&M.keyCode<41&&T[M.keyCode-37]();}),j.on("gesturechange gesturestart gestureend onselect",function(M){M.preventDefault(),M.stopPropagation();}),A.on("gesturechange gesturestart gestureend onselect",function(M){M.preventDefault(),M.stopPropagation();}),y;};};},function(M,L){M.exports=function(M){for(var L=M.CTX,j=M.orbit,A=L.WebGLRenderingContext,u=L.Program,w=L.Shader,N=L.VertexAttrib,C=L.VertexBuffer,y=new(0,L.Vec3)().makeFromHex(M.config.grid),T=A,D=T.LINES,z=T.DEPTH_TEST,i=[],t=0;t<=100;t++){t%5==0?i.push(-50,t-50,-100,1,50,t-50,-100,1,t-50,-50,-100,1,t-50,50,-100,1):i.push(-50,t-50,-100,1.2,50,t-50,-100,1.2,t-50,-50,-100,1.2,t-50,50,-100,1.2);}var s=i.length/4,S=new u({VS:function VS(){return"\n      ".concat(w.maxPrecision.vs.float,"\n      ").concat(j.camera.projectionMatrix.injectUniform("projectionMatrix"),"\n      ").concat(j.zoom.injectUniform("zoom"),"\n      ").concat(N.inject("vertex",0,"vec4"),"\n      varying float vColor;\n      void main() {\n        vColor = vertex.w;\n        gl_Position = projectionMatrix * vec4(vertex.xyz, zoom);\n      }");},FS:"\n      ".concat(w.maxPrecision.vs.float,"\n      varying float vColor;\n      void main() {\n        gl_FragColor = vec4(").concat(y.arr.map(function(M){return 0===M||1===M?"".concat(M,".0"):"".concat(M);}),", 1.0) * vColor;\n      }")}).compose(),I=new C().bind().data(new Float32Array(i).buffer);return function(){T.disable(z),S.use3(),I.bind().attrib(0,4),T.drawArrays(D,0,s),T.enable(z);};};},function(M,L){M.exports=function(M){for(var L=M.CTX,j=M.separationVisibility,A=M.separationMode,u=M.separationClosed,w=M.step,N=M.orbit,C=M.beginSeparationPoints,y=M.separationSteps,T=M.separationSides,D=L.WebGLRenderingContext,z=L.Program,i=L.Shader,t=L.VertexAttrib,s=L.VertexBuffer,S=L.IndexBuffer,I=L.Vec3,x=D,E=x.TRIANGLES,g=x.UNSIGNED_SHORT,Q=x.FLOAT,Y=[],c=[],O=0;O<C.length;O++){for(var k=[],o=0,n=0;n<=10;n++){for(var e=[],J=n/10,a=0;a<=10;a++){var U=a/10;Y.push(-3*Math.cos(U*Math.PI*2)*Math.sin(J*Math.PI*2)+C[O].arr[0],3*Math.cos(J*Math.PI*2)+C[O].arr[1],3*Math.sin(U*Math.PI*2)*Math.sin(J*Math.PI*2)+C[O].arr[2],y[O],T[O]),e.push(o++);}k.push(e);}for(var r=Y.length/5-Y.length/5/(O+1),m=0;m<10;m++){for(var P=0;P<10;P++){var G=k[m][P+1],l=k[m][P],d=k[m+1][P],Z=k[m+1][P+1];0!==m&&c.push(G+r,l+r,Z+r),9!==m&&c.push(l+r,d+r,Z+r);}}}var B=new z({VS:function VS(){return"\n      ".concat(i.maxPrecision.vs.float,"\n      ").concat(N.camera.projectionMatrix.injectUniform("projectionMatrix"),"\n      ").concat(N.camera.viewMatrix.injectUniform("viewMatrix"),"\n      ").concat(N.zoom.injectUniform("zoom"),"\n      ").concat(j.injectUniform("visibility"),"\n      ").concat(A.injectUniform("separationMode"),"\n      ").concat(u.injectUniform("separationClosed"),"\n      ").concat(w.injectUniform("step"),"\n      ").concat(t.inject("vertex",0,"vec4"),"\n      ").concat(t.inject("side",1,"float"),"\n\n      void main() {\n        gl_Position = projectionMatrix * viewMatrix * vec4(vertex.xyz, zoom) * separationMode * float(vertex.w == step) * visibility[int(side)] * separationClosed;\n      }");},FS:function FS(){return"\n      ".concat(i.maxPrecision.vs.float,"\n      ").concat(new I().makeFromHex(M.config.spheres).injectUniform("color"),"\n\n      void main() {\n        gl_FragColor = vec4(color, 1.0);\n      }");}}).compose(),f=new s().bind().data(new Float32Array(Y).buffer),W=new S().bind().data(new Uint16Array(c)),v=c.length;return function(){B.use3(),f.bind().attrib(0,4,Q,0,20).attrib(1,1,Q,0,20,16),W.bind(),x.drawElements(E,v,g,0);};};},function(M,L){function j(M){return function(M){if(Array.isArray(M)){for(var L=0,j=new Array(M.length);L<M.length;L++){j[L]=M[L];}return j;}}(M)||function(M){if(Symbol.iterator in Object(M)||"[object Arguments]"===Object.prototype.toString.call(M))return Array.from(M);}(M)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance");}();}M.exports=function(M){for(var L=M.CTX,A=M.separationVisibility,u=M.separationMode,w=M.separationClosed,N=M.step,C=M.orbit,y=M.beginSeparationPoints,T=M.endSeparationPoints,D=M.separationSteps,z=M.separationSides,i=L.WebGLRenderingContext,t=L.Program,s=L.Shader,S=L.VertexAttrib,I=L.VertexBuffer,x=L.Vec3,E=i,g=E.LINES,Q=E.FLOAT,Y=[],c=new x(),O=0;O<y.length;O++){for(var k=0;k<20;k++){Y.push.apply(Y,j(c.makeBezierCurve2Point(y[O],y[O].clone().mulS(2),T[O],k/20).arr).concat([D[O],z[O]]));}}var o=new t({VS:function VS(){return"\n      ".concat(s.maxPrecision.vs.float,"\n      ").concat(C.camera.projectionMatrix.injectUniform("projectionMatrix"),"\n      ").concat(C.camera.viewMatrix.injectUniform("viewMatrix"),"\n      ").concat(C.zoom.injectUniform("zoom"),"\n      ").concat(A.injectUniform("visibility"),"\n      ").concat(u.injectUniform("separationMode"),"\n      ").concat(w.injectUniform("separationClosed"),"\n      ").concat(N.injectUniform("step"),"\n      ").concat(S.inject("vertex",0,"vec4"),"\n      ").concat(S.inject("side",1,"float"),"\n\n      void main() {\n        gl_Position = projectionMatrix * viewMatrix * vec4(vertex.xyz, zoom) * separationMode * float(vertex.w == step) * visibility[int(side)] * separationClosed;\n      }");},FS:function FS(){return"\n      ".concat(s.maxPrecision.vs.float,"\n      ").concat(new x().makeFromHex(M.config.lines).injectUniform("color"),"\n\n      void main() {\n        gl_FragColor = vec4(color, 1.0);\n      }");}}).compose(),n=new I().bind().data(new Float32Array(Y).buffer),e=Y.length/5;return function(){o.use3(),n.bind().attrib(0,4,Q,0,20).attrib(1,1,Q,0,20,16),E.drawArrays(g,0,e);};};},function(M,L){function j(M){return function(M){if(Array.isArray(M)){for(var L=0,j=new Array(M.length);L<M.length;L++){j[L]=M[L];}return j;}}(M)||function(M){if(Symbol.iterator in Object(M)||"[object Arguments]"===Object.prototype.toString.call(M))return Array.from(M);}(M)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance");}();}M.exports=function(M){var L=M.CTX,A=M.separationVisibility,u=M.separationMode,w=M.separationClosed,N=M.step,C=M.orbit,y=M.endSeparationPoints,T=M.separationValues,D=M.separationSteps,z=M.separationSides,i=L.extensions,t=L.maxAnisotropy,s=L.WebGLRenderingContext,S=L.Program,I=L.Shader,x=L.Texture2D,E=L.VertexAttrib,g=L.VertexBuffer,Q=L.Vec1,Y=s,c=Y.TRIANGLES,O=Y.RGBA,k=Y.UNSIGNED_BYTE,o=Y.TEXTURE_MAG_FILTER,n=Y.LINEAR,e=Y.TEXTURE_MIN_FILTER,J=Y.LINEAR_MIPMAP_LINEAR,a=Y.TEXTURE_WRAP_S,U=Y.CLAMP_TO_EDGE,r=Y.TEXTURE_WRAP_T,m=Y.FLOAT,P=[],G=new Q(),l=Math.pow(2,Math.ceil(Math.log(T.length)/Math.log(2)));if(l>T.length)for(var d=T.length-1;d<l-1;d++){T.push(0);}for(var Z=0;Z<y.length;Z++){var B=y[Z].arr,f=D[Z],W=z[Z];P.push.apply(P,[-4,-2,0,Z].concat(j(B),[f,W,-4,2,0,Z],j(B),[f,W,4,2,0,Z],j(B),[f,W,4,2,0,Z],j(B),[f,W,4,-2,0,Z],j(B),[f,W,-4,-2,0,Z],j(B),[f,W]));}var v=new S({VS:function VS(){return"\n      ".concat(I.maxPrecision.vs.float,"\n      ").concat(C.camera.projectionMatrix.injectUniform("projectionMatrix"),"\n      ").concat(C.camera.viewMatrix.injectUniform("viewMatrix"),"\n      ").concat(C.zoom.injectUniform("zoom"),"\n      ").concat(A.injectUniform("visibility"),"\n      ").concat(u.injectUniform("separationMode"),"\n      ").concat(w.injectUniform("separationClosed"),"\n      ").concat(N.injectUniform("step"),"\n      ").concat(G.injectUniform("imagesLoaded"),"\n      ").concat(E.inject("vertex",0,"vec4"),"\n      ").concat(E.inject("origin",1,"vec4"),"\n      ").concat(E.inject("side",2,"float"),"\n      ").concat(I.consts.INVERSE_MATRIX,"\n      ").concat(I.consts.EXTRACT_ROTATION,"\n      varying vec2 vUv;\n\n      void main() {\n        vUv = vertex.xy / vec2(8.0, 4.0) + 0.5;\n        vUv.y = 1.0 - vUv.y;\n        vUv.y = vUv.y / ").concat(T.length,".0 + vertex.w / ").concat(T.length,".0;\n        vec4 pos = INVERSE_MATRIX(EXTRACT_ROTATION(viewMatrix)) * vec4(vertex.xyz, zoom);\n        pos.xyz += origin.xyz;\n\n        gl_Position = projectionMatrix * viewMatrix * pos * imagesLoaded * separationMode * float(origin.w == step) * visibility[int(side)] * separationClosed;\n      }");},FS:function FS(){return"\n      ".concat(I.maxPrecision.vs.float,"\n      ").concat(new Q().set(2).injectUniform("label","sampler2D"),"\n      varying vec2 vUv;\n\n      void main() {\n        gl_FragColor = texture2D(label, vUv);\n      }");}}).compose(),b=new g().bind().data(new Float32Array(P).buffer),h=P.length/9,R='<svg xmlns="http://www.w3.org/2000/svg" width="128" height="'.concat(64*T.length,'">\n      ').concat(T.map(function(L,j){return'<rect x="0" y="'.concat(64*j,'" width="128" height="64" fill="white" stroke="#').concat(M.config.labels,'" stroke-width="5"/>\n          <text fill="#').concat(M.config.labels,'"\n                text-anchor="middle"\n                x="64"\n                y="').concat(64*(j+1),'"\n                font-family="Open Sans, sans-serif"\n                font-size="50"\n                transform="translate(0,-14)">\n            ').concat(L,"\n          </text>\n          ");}).join(""),"\n    </svg>"),p=window.URL||window.webkitURL||window,F=new Blob([R],{type:"image/svg+xml"}),X=p.createObjectURL(F),H=new Image(),K=new x();H.crossOrigin="Anonymous",H.onload=function(){Y.activeTexture(Y.TEXTURE0+2),x.bind(K).image2D(0,O,O,k,H).parameteri(o,n).parameteri(e,J).parameteri(a,U).parameteri(r,U).mipmap(),i.EXT_texture_filter_anisotropic&&x.parameterf(i.EXT_texture_filter_anisotropic.TEXTURE_MAX_ANISOTROPY_EXT,t),G.set(1).$(),M.drawLabels=function(){v.use3(),b.bind().attrib(0,4,m,0,36).attrib(1,4,m,0,36,16).attrib(2,1,m,0,36,32),Y.drawArrays(c,0,h);};},H.src=X;};},function(M,L,j){function A(M,L){if(j=M,!(null!=(A=L)&&"undefined"!=typeof Symbol&&A[Symbol.hasInstance]?A[Symbol.hasInstance](j):j instanceof A))throw new TypeError("Cannot call a class as a function");var j,A;}function u(M,L){for(var j=0;j<L.length;j++){var A=L[j];A.enumerable=A.enumerable||!1,A.configurable=!0,"value"in A&&(A.writable=!0),Object.defineProperty(M,A.key,A);}}var w=j(1),N=parseInt(w.step_duration||250,10);M.exports=function(M){var L=M.libs.$,j=L(window),w=L("#_3d_plan-comment-text");return function(){function C(){var u=this,y=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};A(this,C),this.track=L("#_3d_plan-sequencer-track"),this.runner=L("#_3d_plan-sequencer-runner"),this.runnerTitle=L("#_3d_plan-sequencer-runner").find("span"),this.firstStepButton=L("#_3d_plan-sequencer-button-first_step"),this.playButton=L("#_3d_plan-sequencer-button-play"),this.pauseButton=L("#_3d_plan-sequencer-button-pause"),this.lastStepButton=L("#_3d_plan-sequencer-button-last_step"),this.upperTitle=L("#_3d_plan-sequencer-upper_title"),this.lowerTitle=L("#_3d_plan-sequencer-lower_title"),this.upperTitleSpan=L(this.upperTitle.find("span")[1]),this.lowerTitleSpan=L(this.lowerTitle.find("span")[1]),this.stepCount=y.stepCount||1,this.currentStep=0,this.trackWidth=this.track.width(),this.stepLength=this.trackWidth/this.stepCount,this.clbk=y.clbk||function(){return 0;},this.interval=0,M.CASE.keys.upper_teeth||this.upperTitle.remove(),M.CASE.keys.lower_teeth||this.lowerTitle.remove();var T=M.CASE.realSteps?M.CASE.realSteps.upper:(M.CASE.keys.upper_gums||[0]).slice().pop()+1,D=M.CASE.realSteps?M.CASE.realSteps.lower:(M.CASE.keys.lower_gums||[0]).slice().pop()+1,z=function z(M){L(u.cells[u.currentStep]).removeClass("-active");var j=Math.sign(u.currentStep-M),A=1.5*(j+1);u.currentStep=M;var w=u.currentStep*u.stepLength;u.runner.attr("title",u.currentStep+1),u.runner.css({left:w}),L(u.cells[u.currentStep]).addClass("-active"),u.runnerTitle.html(u.currentStep+1),u.clbk(u.currentStep,.5*(j+1),A,A-j),M>T-1?u.upperTitleSpan.html(T):u.upperTitleSpan.html(M+1),M>D-1?u.lowerTitleSpan.html(D):u.lowerTitleSpan.html(M+1);};M.goToStep=z,this.switcher1=[function(){return clearInterval(u.interval);},z],this.switcher0=[function(M){var L=M-u.currentStep;u.switcher1[L/L||0](M);},function(M,L){var j=(.5-.5*Math.sign(.5*window.innerWidth-L))*(u.stepCount-1),A=j-u.currentStep;u.switcher1[A/A||0](j);}];for(var i=function i(M){u.track.append(L('<div class="_3d_plan-sequencer-track-cell'.concat(0===M?" -active":"",'" draggable="false"></div>')).css({width:"".concat(100/u.stepCount,"%")}).on("click",function(){return u.switchActionBtn(M);}));},t=0;t<this.stepCount;t++){i(t);}this.cells=this.track.find("._3d_plan-sequencer-track-cell"),this.track.toggleClass("-empty",this.stepLength<20),j.on("mouseup",function(){return j.off("mousemove");}),this.runner.attr("title",0).css({"margin-left":.5*(this.stepLength-20)+2}).on("mousedown",function(){return j.on("mousemove",function(M){return u.switchActionEvt(M.clientX);});}).on("touchmove",function(M){return u.switchActionEvt(M.touches[0].clientX);}).on("touchstart",function(M){M.preventDefault(),M.stopPropagation(),u.runner.addClass("-active");}).on("touchend",function(M){M.preventDefault(),M.stopPropagation(),u.runner.removeClass("-active");}).on("gesturechange gesturestart gestureend",function(M){M.preventDefault(),M.stopPropagation();}),L(this.upperTitle.find("span")[0]).html("Aligner"),this.upperTitleSpan.html("1"),L(this.lowerTitle.find("span")[0]).html("Aligner"),this.lowerTitleSpan.html("1"),this.runnerTitle.html(1);var s=[function(){var M=u.currentStep-1,L=Math.floor(M/u.stepCount);u.switcher1[1-(L/L||0)](M);},function(){return 0;},function(){var M=u.currentStep+1,L=Math.floor(M/u.stepCount);u.switcher1[1-(L/L||0)](M);},function(){return 0;}];j.on("keydown",function(M){M.target!==w[0]&&M.keyCode>36&&M.keyCode<41&&s[M.keyCode-37]();}),this.firstStepButton.on("click",function(){return u.switchActionBtn(0);}),this.playButton.on("click",function(){s[2](),u.interval=setInterval(function(){return s[2]();},N+50);}),this.pauseButton.on("click",function(){return clearInterval(u.interval);}),this.lastStepButton.on("click",function(){return u.switchActionBtn(u.stepCount-1);});}var y,T,D;return y=C,(T=[{key:"switchActionEvt",value:function value(M){var L=Math.floor((M-.5*(window.innerWidth-this.trackWidth-2))/this.stepLength),j=Math.floor(L/this.stepCount);this.switcher0[j/j||0](L,M);}},{key:"switchActionBtn",value:function value(M){var L=M-this.currentStep;this.switcher1[L/L||0](M);}}])&&u(y.prototype,T),D&&u(y,D),C;}();};},function(M,L,j){function A(M,L){if(j=M,!(null!=(A=L)&&"undefined"!=typeof Symbol&&A[Symbol.hasInstance]?A[Symbol.hasInstance](j):j instanceof A))throw new TypeError("Cannot call a class as a function");var j,A;}var u=j(36),w=function w(M){return M>=0?M:0;},N=function M(){A(this,M),this.vertexOverallData=null,this.vertexData=null,this.vertexData_=null,this.occlusionColorData=null,this.occlusionColorData_=null,this.teethColorData=null,this.teethColorData_=null,this.indexData=null,this.bufferStart=new Float64Array(4),this.bufferEnd=new Float64Array(2),this.shaderProgress=new Float64Array(4),this.shaderEnd=new Float64Array(2),this.index=0,this.layerStart=0,this.layerEnd=0;};M.exports=function(M){var L=M.libs,j=L.$,C=L.FileSaver,y=L.JsExcelTemplate,T=j("#_3d_plan-info-debug");return function(){return function L(D){A(this,L);var z=M.CASE,i=z.keys,t=z.stepCount,s=i[D];s||(s=[0,0]);var S=s.slice().pop(),I=new Array(S+1).fill(0).map(function(){return new N();}),x=Uint16Array;this.vertexBuffer=new M.CTX.VertexBuffer(),this.indexBuffer=new M.CTX.IndexBuffer(),this.maxVertexPositionDataLength=0,this.maxOcclusionColorDataLength=0,this.maxTeethColorDataLength=0,this.maxVertexOverallDataLength=0,this.maxIndexDataLength=0;for(var E=0;E<s.length;E+=2){for(var g=s[E];g<=s[E+1];g++){var Q=I[g];Q.index=g;var Y=I[g-1],c=Q.index===(Q.layerStart=s[E]),O=Q.index===(Q.layerEnd=s[E+1]);if(Q.layerStart===Q.layerEnd)Q.shaderProgress[0]=0,Q.shaderProgress[1]=1,Q.shaderProgress[2]=0,Q.shaderProgress[3]=1,Q.shaderEnd[0]=Q.shaderProgress[1],Q.shaderEnd[1]=Q.shaderProgress[2],Q.bufferStart[0]=w(s[E-1]),Q.bufferStart[1]=w(Q.layerStart),Q.bufferStart[2]=w(s[E+2]),Q.bufferStart[3]=w(Q.layerStart),Q.forceSwitchVBO=1;else{var k=1/(Q.layerEnd-Q.layerStart||1);Q.shaderProgress[0]=k*(Q.index-Q.layerStart-1),Q.shaderProgress[1]=k*(Q.index-Q.layerStart),Q.shaderProgress[2]=k*(Q.index-Q.layerStart),Q.shaderProgress[3]=k*(Q.index-Q.layerStart+1),Q.shaderEnd[0]=Q.shaderProgress[1],Q.shaderEnd[1]=Q.shaderProgress[2],Q.bufferStart[0]=w(Q.layerStart),Q.bufferStart[1]=w(Q.layerEnd),Q.bufferStart[2]=w(Q.layerEnd),Q.bufferStart[3]=w(Q.layerStart),c&&(Q.shaderProgress[0]=0,Q.shaderProgress[1]=1,Q.shaderEnd[0]=0,Q.bufferStart[0]=Q.index-1,Q.bufferStart[1]=Q.index),O&&(Q.shaderProgress[2]=0,Q.shaderProgress[3]=1,Q.shaderEnd[1]=1,Q.bufferStart[2]=Q.index+1,Q.bufferStart[3]=Q.index);}var o=new Float32Array([0,0,0]).buffer,n=M.assets["".concat(D,"_v_").concat(Q.index)];Q.vertexData=n||(Y?Y.vertexData:o),Q.vertexData_=n?Q.index:Y?Y.vertexData_:"";var e=M.assets["".concat(D,"_c_").concat(Q.index)];Q.occlusionColorData=e||(Y?Y.occlusionColorData:o),Q.occlusionColorData_=e?Q.index:Y?Y.occlusionColorData_:"";var J=M.assets["".concat(D,"_tc_").concat(Q.index)];Q.teethColorData=J||(Y?Y.teethColorData:o),Q.teethColorData_=J?Q.index:Y?Y.teethColorData_:"",Q.vertexData.byteLength/12>65536&&(x=Uint32Array),Q.bufferEnd[0]=Q.layerStart,Q.bufferEnd[1]=Q.layerEnd,this.maxVertexPositionDataLength=Math.max(this.maxVertexPositionDataLength,Q.vertexData.byteLength),this.maxOcclusionColorDataLength=Math.max(this.maxOcclusionColorDataLength,Q.occlusionColorData.byteLength),this.maxTeethColorDataLength=Math.max(this.maxTeethColorDataLength,Q.teethColorData.byteLength);}}this.maxVertexOverallDataLength=this.maxVertexPositionDataLength+this.maxOcclusionColorDataLength+this.maxTeethColorDataLength,this.vertexBuffer.bind().data(2*this.maxVertexOverallDataLength,M.CTX.WebGLRenderingContext.DYNAMIC_DRAW);for(var a=0;a<=S;a++){var U=I[a],r=I[a-1],m=M.assets["".concat(D,"_t_").concat(U.index)];U.indexData=m?new x(m):r?r.indexData:new x([0]),U.indexData_=m?U.index:r?r.indexData_:"",this.maxIndexDataLength=Math.max(this.maxIndexDataLength,U.indexData.length);var P=.25*this.maxVertexPositionDataLength,G=P+.25*this.maxOcclusionColorDataLength;U.vertexOverallData=new Float32Array(G+.25*this.maxTeethColorDataLength),U.vertexOverallData.set(new Float32Array(U.vertexData)),U.vertexOverallData.set(new Float32Array(U.occlusionColorData),P),U.vertexOverallData.set(new Float32Array(U.teethColorData),G),m&&U.index>0&&(U.shaderProgress[0]=1,r.shaderProgress[3]=0,U.shaderEnd[0]=0,r.shaderEnd[1]=1,U.bufferStart[0]=r.layerStart,U.bufferStart[1]=r.layerEnd,r.bufferStart[2]=U.layerEnd,r.bufferStart[3]=U.index);}if(this.maxIndexDataLength*=x===Uint32Array?4:2,this.indexBuffer.bind().data(this.maxIndexDataLength,M.CTX.WebGLRenderingContext.DYNAMIC_DRAW),S<t-1)for(var l=S+1;l<t;l++){var d=new N();d.vertexData_=I[S].vertexData_,d.occlusionColorData_=I[S].occlusionColorData_,d.teethColorData_=I[S].teethColorData_,d.vertexOverallData=I[S].vertexOverallData,d.indexData=I[S].indexData,d.indexData_=I[S].indexData_,d.bufferStart=new Array(4).fill(I[S].bufferStart[1]),d.bufferEnd=new Array(2).fill(I[S].bufferEnd[1]),d.shaderProgress=new Array(4).fill(I[S].shaderProgress[1]),d.shaderEnd=new Array(2).fill(I[S].shaderEnd[0]),I.push(d);}if(M.info.DEBUG){var Z=y.fromArrayBuffer(u);Z.set("keys","".concat(s));for(var B=0;B<I.length;B++){Z.set("a".concat(B+2),B),Z.set("d".concat(B+2),I[B].shaderProgress.reduce(function(M,L){return null===L?"".concat(M,", null"):"".concat(M,", ").concat(L.toFixed(2));},"").slice(2)),Z.set("f".concat(B+2),I[B].shaderEnd.reduce(function(M,L){return null===L?"".concat(M,", null"):"".concat(M,", ").concat(L.toFixed(2));},"").slice(2)),Z.set("j".concat(B+2),I[B].bufferStart.reduce(function(M,L){return null===L?"".concat(M,", null"):"".concat(M,", ").concat(L);},"").slice(2)),Z.set("k".concat(B+2),I[B].bufferEnd.reduce(function(M,L){return null===L?"".concat(M,", null"):"".concat(M,", ").concat(L);},"").slice(2)),Z.set("l".concat(B+2),I[B].vertexData_),Z.set("o".concat(B+2),I[B].occlusionColorData_),Z.set("m".concat(B+2),I[B].indexData_);}var f=j("<a>".concat(D,".xlsx</a>"));T.show(),T.append(f),f.on("click",function(M){M.preventDefault(),C.saveAs(Z.toBlob(),"".concat(D,".xlsx"));});}Object.assign(this,{arr:I,UINT_CONSTRUCTOR:x});};}();};},function(M,L,j){M.exports=j(0)("UEsDBBQABgAIAAAAIQB0NlqmegEAAIQFAAATAAgCW0NvbnRlbnRfVHlwZXNdLnhtbCCiBAIooAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACsVM1OAjEQvpv4DpteDVvwYIxh4YB6VBLwAWo7sA3dtukMCG/vbEFiDEIIXLbZtvP9TGemP1w3rlhBQht8JXplVxTgdTDWzyvxMX3tPIoCSXmjXPBQiQ2gGA5ub/rTTQQsONpjJWqi+CQl6hoahWWI4PlkFlKjiH/TXEalF2oO8r7bfZA6eAJPHWoxxKD/DDO1dFS8rHl7q+TTelGMtvdaqkqoGJ3VilioXHnzh6QTZjOrwQS9bBi6xJhAGawBqHFlTJYZ0wSI2BgKeZAzgcPzSHeuSo7MwrC2Ee/Y+j8M7cn/rnZx7/wcyRooxirRm2rYu1w7+RXS4jOERXkc5NzU5BSVjbL+R/cR/nwZZV56VxbS+svAJ3QQ1xjI/L1cQoY5QYi0cYDXTnsGPcVcqwRmQly986sL+I19QodWTo9qLpErJ2GPe4yfW3qcQkSeGgnOF/DTom10JzIQJLKwb9JDxb5n5JFzsWNoZ5oBc4Bb5hk6+AYAAP//AwBQSwMEFAAGAAgAAAAhALVVMCP0AAAATAIAAAsACAJfcmVscy8ucmVscyCiBAIooAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACskk1PwzAMhu9I/IfI99XdkBBCS3dBSLshVH6ASdwPtY2jJBvdvyccEFQagwNHf71+/Mrb3TyN6sgh9uI0rIsSFDsjtnethpf6cXUHKiZylkZxrOHEEXbV9dX2mUdKeSh2vY8qq7iooUvJ3yNG0/FEsRDPLlcaCROlHIYWPZmBWsZNWd5i+K4B1UJT7a2GsLc3oOqTz5t/15am6Q0/iDlM7NKZFchzYmfZrnzIbCH1+RpVU2g5abBinnI6InlfZGzA80SbvxP9fC1OnMhSIjQS+DLPR8cloPV/WrQ08cudecQ3CcOryPDJgosfqN4BAAD//wMAUEsDBBQABgAIAAAAIQCSB5TsBAEAAD8DAAAaAAgBeGwvX3JlbHMvd29ya2Jvb2sueG1sLnJlbHMgogQBKKAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACskstqxDAMRfeF/oPRvnEyfVCGcWbRUphtm36AcJQ4TGIHW33k72tSOsnAkG6yMUjC9x6Ju9t/d634JB8aZxVkSQqCrHZlY2sF78XLzSOIwGhLbJ0lBQMF2OfXV7tXapHjp2CaPoioYoMCw9xvpQzaUIchcT3ZOKmc75Bj6WvZoz5iTXKTpg/SzzUgP9MUh1KBP5S3IIqhj87/a7uqajQ9O/3RkeULFjLw0MYFRIG+JlbwWyeREeRl+82a9hzPQpP7WMrxzZYYsjUZvpw/BkPEE8epFeQ4WYS5XxNGY6ufDDZ2gjm1li5yt2ooDHoq39jHzM+zMW//wciz2Oc/AAAA//8DAFBLAwQUAAYACAAAACEAMvZYNUoCAACaBAAADwAAAHhsL3dvcmtib29rLnhtbKxUS27bMBDdF+gdCO4VfSw7tmA5yMdFAxRFEKTJxhuaGlmE+VFJKnYQdNFeoxfpMZIbdSRVbdpsUrQbcvh7M/PeDOdHeyXJLVgnjM5pfBBRApqbQuhNTj9cvQmmlDjPdMGk0ZDTO3D0aPH61Xxn7HZtzJYggHY5rbyvszB0vALF3IGpQeNJaaxiHpd2E7raAitcBeCVDJMomoSKCU17hMy+BMOUpeBwZnijQPsexIJkHsN3lajdgKb4S+AUs9umDrhRNUKshRT+rgOlRPHsfKONZWuJae/j8YCM5jNoJbg1zpT+AKHCPshn+cZRGMd9yot5KSRc97QTVtfvmWq9SEokc35ZCA9FTie4NDv4bcM29UkjJJ7GaZpENFz8lOLCkgJK1kh/hSIM8HhxkkZx3N7EpI6lB6uZh1OjPXL4g/1/5avDPq0MqkMu4WMjLGBRtLQt5jgynrG1u2C+Io2VOV1mKwu1W42KwCmkojVqyXRwm6yc5SvmHHi3esI5ey7oX7DOeJt+iPn3Mfb2n1ws5m1FXwvYuV+stkuyvxG6MLucYn/cPbF33faNKHyV02Q6jfC833sLYlN5JD+eTsad8yfYXROgj24muhP/4evDt8fPj19ibLi2R85biSmxmUDDnhedgOHwkjPJUe926i5Oklk8at3A3r9zvpuRapHT+ziNjg+jWRpEy9E4SKezJJimoyQ4Tc+S5fhwebY8GX/6v9WNimfDB9FGWTHrryzjW/xWLqE8YQ6rvU8I40UxhqjD4dXiOwAAAP//AwBQSwMEFAAGAAgAAAAhACEyTo3VAAAAeAEAABQAAAB4bC9zaGFyZWRTdHJpbmdzLnhtbHSQwUoDMRCG74LvEOZus/UgIkl6EPoE+gAxmd0NbiZrZiIt4rubIl5qe/z/j49hfrM75EV9YuVUyMJ2M4BCCiUmmiy8vuzvHkGxeIp+KYQWjsiwc7c3hllUd4ktzCLrk9YcZsyeN2VF6mQsNXvpsU6a14o+8owoedH3w/Cgs08EKpRGYqEfaZQ+Gj7/ZWc4OSPu6x2P/G20OKNPzW/Ls49Y1VrLVJH5CkaK5+StjWMX+0dVrrALVt9H8KCiF38ulRCWdhrvIk0U/3m6L+d+AAAA//8DAFBLAwQUAAYACAAAACEAO20yS8EAAABCAQAAIwAAAHhsL3dvcmtzaGVldHMvX3JlbHMvc2hlZXQxLnhtbC5yZWxzhI/BisIwFEX3A/5DeHuT1oUMQ1M3IrhV5wNi+toG25eQ9xT9e7McZcDl5XDP5Tab+zypG2YOkSzUugKF5GMXaLDwe9otv0GxOOrcFAktPJBh0y6+mgNOTkqJx5BYFQuxhVEk/RjDfsTZsY4JqZA+5tlJiXkwyfmLG9Csqmpt8l8HtC9Ote8s5H1Xgzo9Uln+7I59Hzxuo7/OSPLPhEk5kGA+okg5yEXt8oBiQet39p5rfQ4Epm3My/P2CQAA//8DAFBLAwQUAAYACAAAACEAFMg8g70GAAC/GgAAEwAAAHhsL3RoZW1lL3RoZW1lMS54bWzsWd1uG0UUvkfiHVZ77/pvd21HdSp7bTfQpK0at6iXY3vsnWZ2x9odJ7WqSlV6xQ0IqSBukIAbLhAiEkVUiIpXSJ8hUisoD8GZ2bV3Jp6Q/qSooCZSsh5/58w355z95u/8hdshtXZxnBAWNe3yuZJt4WjIRiSaNO3r/V6hblsJR9EIURbhpj3HiX1h/f33zqM1HuAQW2AfJWuoaQecT9eKxWQIzSg5x6Y4gu/GLA4Rh4/xpDiK0R74DWmxUip5xRCRyLYiFILbw28Pfz787fDAujIekyG21xf+uxQ6iXgiGoY03hbe8cLomyf7hweHjw8fHh48uQfPj+H/p9J2tFMWFsk88Wls7SLatKHrEdvr49vctihKOHzRtEvyxy6uny+itcyI8hNsFbue/MnsMoPRTkX2GU8Gy04dx3W81tK/BFC+iuvWul7XW/qTADQcwshTLqpPt91od9wMq4DSR4PvTq1TLWt4xX91hXPLFb8aXoJS/84KvtfzIYoaXoJSvGuISa3iOxpeglK8t4KvlVodp6bhJSigJNpZQZdcr+ovRruEjBndMMIbrtOrVTLnOQqqYVltoosxi/iL1l6IbrG4BwbCkCJOIovPp3iMhlDoPqJkEBNrk0wCKMQpilgCzaVKqVeqwl/x68gnGSG0hpFiLXgCs2SlSfCzkmFMprxpfwhebQXy9NGjo/2HR/u/HN2/f7T/Y9a3dKXZbaBooto9/+6zv766Z/3509fPH3yedn0cn6j4Zz98/OzX3//JPYw4D8XTLw6ePTx4+uUnf3z/wOC9FaOBCu+TECfWZbxnXWMhDNDAHw/il7PoB4hoFigA3wbXXR5owMtzRE24NtZDeCMG1TEBL85uaVy3g3jGiaHnS0GoAbcYo20WGwNwSfSlRLg/iybmzuOZiruG0K6pbx9FWoK7synILzG59AOs0bxKUcTRBEeYW+I7toOxYXQ3CdHiukWGMUvYmFs3idVGxBiSPhlohZQbbZAQ8jI3EYRUa7HZumG1GTWNuoN3dSS8FogayPcx1cJ4Ec04Ck0u+yikasA3EQ9MJLfn8VDFdRMOmZ5gyqzuCCeJyeZKDONVkn4JFMac9i06D3VkzMmOyecmYkxFdtiOH6BwauRMokDFfpDsQIki6yrjJvgW098Q8RnygKIT032DYC3dpwvBdRBXlVJeIOKbWWzI5UXM9PdxTscIS5WBuUCT9JBEp+r7MWV3/x1lN2v0GWi62fHrqHkrJsZ3auOYhp+E+w8qdwfNoqsYXpbVmeudcL8Tbvt/L9wnvctnL9e5QoN452t3uZIPX3ghPyaUbvM5xZuJXMsnME+NetAoNx1yJ7rc6E0DeMy2ERpuEiNpY8WMf0R4sB2gKSz4y3KbOkky15PEmrIE9gGyWe6h8THfcjcxC7fYKN3Plsti75qKSYJ43l5yl+2w9+Ap2qvle7Sle7nrnci99YKAsH0ZEkpnOomqgURt0QhZ+ScScmRnwqJhYFEX7hepWmRxGQqgtswKLKQsWH41bddJzwlgi4UoHok8pUcGi+yK5Jxppk8KJlUrAFYViwrIM90QXE8cnhhdWmovkGmNhFJuOgmlDAM0wll1qgcrZ5nrRp5SjZ4IxeJtyGnU6m8i10JUjmkDjVSloJG117S9qgvHaUM0bdpjOAeAx3AKtZOIBTCiEzhvG/I4feFfRVmmccI7KAnSgEvRSdUgJBzHFiVh0xbDX1YDjaSGSG7lCgjCW0uuAbLytpGDpOtJxuMxHnI17UqLiHT6ERQ+1Qrjt9L81cHCks0g3dvBaM8a0Fl8DUGJubWyCOCIJHAcVE6jOSJw3rkUsrz+jk1MmeyqB46yhtJ2RKcBymYUVcxTuBTRJR35aRkD5VM2ZgjoaggHEzHBvvase/pULSKniGY+Z2qqImZNs5i+uUleYZVPohqrVLrlNiLJta6x0DooVOMsccqs+wITgkIt70yjJhivyrDQ7KxVp3aGCwIlEt4JcVvOEcZIvOrMD3bHq1ZMEIt1pix8eVei3mWwwS0Qjw6cCs8oT2Qq4WYiRrDoS8+ZU9mAV+Q2z9aI8GTNYtK075TcluNXXL9QqrvdglN1SoW626oWWq5bLXfdcqnTrtyFiYUHYdlN72l6cDBF59ltjWxfubEJF2dv54YsLDJ5EVOUxOWNTbmi3dikFzVWX9zH2BYB0bnjVXqNaqPtFRrVVq/gdNr1QsP32oWO59c6vY7v1hu9u7a1K8FOq+o7Xrde8Mq+X3C8kqBfbxRqTqXScmqtetdp3c2WMTDyVD6yWEB4Ja/1vwEAAP//AwBQSwMEFAAGAAgAAAAhAEb3UYr7AgAACQgAAA0AAAB4bC9zdHlsZXMueG1szFVLbtswEN0X6B0I7RV9Yqm2ISmI4wgI0AIFkgLd0hJlE+FHIOlUTtF1F7lD79BlF71DcqMOJdlWkKJtkqLoRuSMyMc3M4/D5KjhDF0RpakUqRMc+A4iopAlFcvUeXeRu2MHaYNFiZkUJHU2RDtH2csXiTYbRs5XhBgEEEKnzsqYeup5ulgRjvWBrImAP5VUHBsw1dLTtSK41HYTZ17o+7HHMRVOhzDlxZ+AcKwu17VbSF5jQxeUUbNpsRzEi+nZUkiFFwyoNsEIF6gJYhVuT2hdDw7htFBSy8ocAKgnq4oW5CHXiTfxcLFHAtinIQWR54dd4FlSSWE0KuRaGEg/oFvS00shP4jc/rLOblWW6Gt0hRl4AsfLkkIyqZCBZEOsrUdgTroVJ5jRhaJ2WYU5ZZvOHbb7VlhpqFoLFfoj62tr1u/lFDJonZ7l1g8agChjO6ahJQWOLIEiGKJEDgbq5xebGigJ0EsH0677zeqlwpsgjAYbvPbALFlIVYI+9znaurKEkcoAUUWXKzsaWcN3IY2BMmZJSfFSCsxsKB3IbgLhFISxc6vh99U97KZCYs1zbs7K1IHbYJOwnUIg/bTD6wyLP0TrsAewMSTr8bCoqXb4z9iNcF2zzTGjS8FJJ7IsAXl0JlpJRa8hRKurNo9tBZrq/2IMKf43KbCK+hsZeETW7x3ZCgmkM9DnPXXudIbsZU+d2y+3X+9u7j7ffr+7uf0G7aPXDFqsKTNU/EShgF02e837NlxjO2Z7G3angfRLUuE1Mxe7n6mzn78hJV1z6Kz9qrf0SpoWInX289f2agaxPYM05rWGfgIjWiuaOh9PZ68m89M8dMf+bOyODknkTqLZ3I1GJ7P5PJ/4oX/yadC6n9G422cGRBSMpppBe1d9sD35870vdQZGR78VBNAecp+EsX8cBb6bH/qBO4rx2B3Hh5GbR0E4j0ez0yiPBtyjJz4VvhcE26eiCaKpoZwwKra12lZo6IUigfmLILxtJbz9G579AAAA//8DAFBLAwQUAAYACAAAACEAM8EzsPUwAAB2+QEAGAAAAHhsL3dvcmtzaGVldHMvc2hlZXQxLnhtbJSdWXMcSZKk31dk/wMF+zIjslNE4gaF5EjcAR7F+6h6Q5NgEV0kwQVQXd07Mv99IxLJdIOp1aZ9Ly3d2almFm7K0DSPUPj9//zn1y93/nF2eXV+8e3B1uKn7a07Z98+XHw8//bbg603r/v/ONq6c3V9+u3j6ZeLb2cPtv51drX1nw//5/+4/+fF5e9Xn8/Oru9MEb5dPdj6fH39/d7du1cfPp99Pb366eL72bfp//l0cfn19Hr6n5e/3b36fnl2+nEJ+vrl7s729sHdr6fn37ZuIty7zMS4+PTp/MNZe/Hhj69n365vglyefTm9nuq/+nz+/epHtK8fMuG+nl7+/sf3//hw8fX7FOJv51/Or/+1DLp15+uHeye/fbu4PP3bl+m6/7nYO/3wI/byf0j4r+cfLi+uLj5d/zSFu3tTqF7z8d3ju1Okh/c/nk9XMC/7ncuzTw+2qsW9k3Z3d+vuw/vLFXp7fvbnlfnvd65P//bq7MvZh+uzj1Ojtu7MDfjbxcXv8xdPpo+2p5hXyy/MMU8/XJ//46w5+/LlwVZ9OPXw/yyz1IdTluM5yd11Fvvff2Tsl217fnnn49mn0z++XL+8+HM8O//t8/WUen9ahnk17n38V3t29WFqw5T8p539OeqHiy9TiOk/73w9n/k0LePpPx9s7exONPrz/OP15+m/b/90uNg+3j2c4nz44+r64uu7m/9jsSzrJsKyuPb0+vTh/cuLP+9M1JhCXX0/nYm2uLcMF9cwJZ+/Xc1ff7A1pZiKu5pW5h8Pt+/f/cd0qR9W36h/fGOueoY0/oPWf9D5D3r/weA/GP0HJ/6DR/6Dx/6DJ/6Dp/6Dn/0Hz/wHz/0HL/wHL/0Hr/wHr/0Hb/wHb/0H7/wH7/0Hv/gPfvUfVOte/uhUJb2rpHmVdK+S9lXSv0oaWEkHK2lhJT2spImVdLGSNlbSx0oaWUknK2llJb2spJmVdLOSdlbSz0oaWklHK2lpJT2tpae19LSWntbS01p6WktPa+lpLT2tpae19LSWntbS01p6WktPa+lpLT2tpae19LSWntbS01p6WktPa+lpLT2tpae19LSRnjZ6j5WeNtLTRnraSE8b6WkjPW2kp430tJGeNtLTRnraSE8b6WkjPW2kp430tJGeNtLTRnraSE8b6WkjPW2kp430tJWettLTVoVTetpKT1vpaSs9baWnrfS0lZ620tNWetpKT1vpaSs9baWnrfS0lZ620tNWetpKT1vpaSs9baWnrfS0lZ520tNOetpJTzv9NSQ97aSnnfS0k5520tNOetpJTzvpaSc97aSnnfS0k5520tNOetpJTzvpaSc97aSnnfS0k5520tNOetpLT3vpaS897aWnvf7ElZ720tNeetpLT3vpaS897aWnvfS0l5720tNeetpLT3vpaS897aWnvfS0l5720tNeetpLT3vp6SA9HaSng/R0kJ4O0tNB5xbp6SA9HaSng/R0kJ4O0tNBejpITwfp6SA9HaSng/R0kJ4O0tNBejpITwfp6SA9HaSng/R0lJ6O0tNRejpKT0fp6Sg9HXUYlZ6O0tNRejpKT0fp6Sg9HaWno/R0lJ6O0tNRejpKT0fp6Sg9HaWno/R0lJ6O0tNRenoiPT2Rnp5IT09sT+9OexzrjY4dttExf33aVFluvszbGPWPD5Y7H9eX097Hp4evu/ev/6159uTN05//7d//952t/zr9X/+99e/3736aN0b+63Tnv2/vjTRBjGW4z6eXZx+3bjasmp179c/zF8+Xe08bUuy6FO2GFDdRp4l/rm/PgTsC3nfgnoAPHHgg4EMHHgn4yIFPCPjYgR8R8GLboR8j9MKhnyC0p+JThPYsW/Jz/tdh/jFYIt9i2cLT7BnK7Xn2HKE90V4gtGfaS4T2VHuF0J5rrwl6x3PtDUJ7rr1FaM+1dwjtufYeoT3XfkFoz7VfEdpzraoQ3JOtiiTnL/+V7Xi2VZvU5tY/0h1Ptwopya7nW4W0ZNcTrkJqsusZVyE92fWUq5Ci7HrOVUhTdj3pKqQqu8I6JCu7wjqkK7vCOiQsu8I6pCx7wjokLXvCOqQte8I6JC57wjqkLnvCOiQve8I6pC97wjokMHvCOqQwe8I6JDF7wjqkMfvCOiQy+8I6pDL7nnU1Upl9z7oaqcy+Z12NVGbfs65GKrPvWVezicWzrkYqs+9ZVyOV2fesq5HKHHjW1UhlDjzraqQyB8I6pDIHwjqkMgfCOqQyB8I6pDIHwrpNKnPzSsiznXvt8p/2NMgvtjbtFRwIOTNitHy3Yx7lD4ScGTEqcCFnRozW8EMhZ0aMClzImRGjAhdyZsSowIWcGTEqcCFnRowKXMiZEaMCF3JmxKjAhXUZMSpwz7omI0YF7lnXZMRoDT/yrGsyYlTgnnVNRowKXHb3MmJU4J51TUaMCtyzrsmIUYF71jUZMSpwz7omI0YF7lnXZMSowIV1GTEqcGFdRozW8GNhXUaMClxYlxGjAhfWZUaeAhfWIZU5FtYhlTkW1iGVORbWIZU5FtYhlTkW1iGVORbWIZVZbAvtkMwstoV3SGcW20I8JDSLbWEeUprFtqdei6Rmse251yKtWWx78rVIbBbbnn0tUpvFtqdfi+RmejPYPylCerOQpxctEpzFwvOvRYqzWHj+tUhyFgt5UoY0ZyFPMVokOouF8A+pzmIh/EOys1gI/5DuLBbCPyQ8i4XwDynPQp5otEh6FjvCP6Q9ix3hHxKfxY7wD6nPYkfuf0h+FjvCP6Y/O8I/pj87wj+mP/J8o2X6Iw84bmbzDQ8x1z+cFvKEo9ukP8tdgOlb94blv/RpF2Bn4y7AQp6EdBmZWr6mMG8DLORRSJeRKYP3NO0yMmXw8k5BRqYM3tO0y8iUwXuadhmZMnhP0y4jUwbvb5NdRqYM3t8mu4xMFbw8EukyMmXw/jbZZWTK4P1tssvIlMEL/zIyZfDCv4xMGbzwLyNTBi/8y8iUwQv/MjJl8MK/jEwZvPAvI1MFLw9HuoxMGbzwLyNTBi/8y8iUwQv/MjJl8MK/jEwZvPAvMyYZvOdfnxmTDN7zr2f6Iw9JeqY/8pSkZ/ojj0l6pj/ynKRn+iMPSnqmP/KkpGf6I49KeqY/8qykZ/ojD0t6pj/yGKRn+iPPQXqmPwf+/tcz/ZEnIT3Tn0N//+uZ/hz6+1/P9OfQ3/96pj+H/v7XM/05lNdKmf4cyv2P6c+h3P+Y/hx6/e2Z/hwK/5j+yDORnunPkfCP6c+R59/A9OfI829g+nPk+Tcw/Tny/BuY/hx5/g1Mf448/wamP0eefwPTnyPPv4HpjzwdGZj+HHv+DUx/joV/TH+OhX9Mf+QJybBJf5bbBNO3pj8gMb8uOm0T7G7eJpAnKUNGppZ/BWO5TSCPUoaMTBm80DQjUwYvNM3IlMELTTMytcZPfyPFGxAyMmXwQtOMTBm80DQjUwYvNM3IlMHLbTIjUwYvt8mMTBm83CYzMmXwwr+MTBm859+YkSmD9/wbMzJV8PI0ZczIlMF7/o0ZmTJ4z78xI1MG7/k3ZmTK4D3/xoxMGbzn35iRKYP3/BszMmXwnn9jRqYMXviXkSmDF/5lZKrg5WnKmBmTDF74h/RnR56mjEh/duRpyoj0Z0eepoxIf3bkacrI9EeepoxMf+Rpysj0R56mjEx/5GnKyPRHnqaMTH/kMcnI9Ecek4xMf8QyMjL9Ec/ICdMfMY2cMP0R18gJ0x+xjdz8eN3wNK3cP6xv5JZLd5e5dOevr5Mu/xzZwv05slvfuP4L2+5Ha9v9KG+6BDHUtrs72XbnL04/4PeCH/C3U8jD4A0pbqLe2HY/yhYzAcv+CgHLrzYCFskkYK+XJwTsxfIRAattF6G9UD5BaE/FpwjtWbbk54Z/o3uz432aET+qbRfl9jx7jtCeaC8Q2jPtJUJ7qr1CaM+11wSttl2E9lx7i9Cea+8Q2nPtPUL7W9ovCO259itCe65VFYJ7slU1gnu2VQ2Ce7pVLYEHtl0E94SregT3jKsGBPeUq0YE95yrkKYEtl2UXVj3GMGFdUhXAtsuyi6sQ8oS2HZJ9sC2i+DCOiQugW0XZRfWIXkJbLsou7DuDYIL65DCBLZdlF1YhzQmsO2S7IFtF8E962qkMoFtF2UXjxpSmcC2i7J71tUdgnvW1UhlAtsuyu5ZVyOVCWy7JHtg20VwYR1SmcC2i7IL69D4Eth2UXZh3bMN8JVtd3ey7c7fnAb5/Y2DfGDbTRS5/Jvu85AV2HYRXMiZGXXW2QPbLsku76rUmWGnZBdyZsSowP3PvzojRgUu5MzMOwWutl20dELOzMRTssstMTPyFLjadlHxnnVNZuRZZw9suyS7vKHSZEaekl129zJiVOBiY8uIUYF71jWZkafA1baLls6zrsmMPCW7Z12T2UgrcLXtouKFdZmRZ509sO2S7PJeSpMZeUp2Yd0mMbqRn9VenLyV0mS200p2YV1m5Clwte2ipRPWZUaekl1Yh1QmsO2i4oV1SGUi2y5JH9l2GV6Ih4Qmsu2y/J56bWbuWTc/su2y/J58bWbyMfk9+1qkNpFtl9Xv+dcivYlsuyh/YNtleM+/FklOZNtl+YV/mQmo9D+w7bL8wr/MDGTyC/+Q7kS2XVa/8A8pT2TbRfkD2y7DC/+Q+ES2XZZf+IeGnMi2y/IL/9CYswhsuyy/2MaZ/gS2XZQ/sO1uwK9su7uTbXf+5rQLcLBxFyCy7SbKPFg/aw1suwyvtl2Gl3cKMlORqV9tuyy/p2mXmYtMfn+b7DK7dAavtl1Wv79NdpnRqOQPbLsovzwT6TLDkcnvb5NdRqYMXm27rH7hX2Y+MvnVtsvyC/8yE5LJL/zLbMQZvNp2Wf3Cv8yQVPIHtl2UX56OdJkxyeQX/mVkyuDVtsvqF/5lZMrkV9suy+/512fGJJPf86/PbMkZvNjWMmOSwXv+9ZkxqeAD2y5av8C2y/Cefz3Tn8C2y/J7/vWZMcmsn7zWx/QnsO2y+oV/TH8C2y7LL/zLjEll/QLbLsof2HYZXvjH9Cew7bL8wr/MmGTWT227LL/c/zJjkskv/GP6E9h2Wf3Cv8y7CaX+wLaL8ge2XYb3/BuY/gS2XZbf829g+hPYdll+z7+BzT+BbZflV9suw3v+DWz+CWy7KH9g22V44V9mm678+wlsuyy/8G/T/LOy7e7Op8vfbBMcbt4mCGy7iTIP19sEgW2X4f1tcsjs5pn8attl+YWmmTFpnT+y7ZL8O/JHUIfMmGTyC00zMmXwattl9QtNM2OSya+2XZZfbpOZMcnkF/5l3lsweLXtsvo9/8bMmFTyB7ZdlF+epoyZMcnk9/wbMzJl8GrbZfV7/o2ZMcnkV9suy+/5N2bGJJPf82/MjEkGr7ZdVr/wLzMmlfyBbRfll6cpY2ZMMvmFf5ltOoMX/iH9iWy77PqFf0x/Atsuyy/8Y/oT2HZZfuFfZkwq/Qtsuyh/YNtleOEf05/Atsvy+/vfSWZMMuvn+XfC9Cew7bL6Pf9ufrxusASa+s3975Ztd4/Zduev37bt7jjb7q1v/JVt95O17X6SN12CGGrb3Ztsu/MXp+d8R8EP+NspxLa7IcVN1JuXuD7JFjMBy/4KAcuvNgKWWxYBi22XgP3N6hEBq20XocW2i9Ceik8RWmy7CO1p9gyhxbaL0J5oLxDaM+0lQottF6E9114TtNp2EVpsuwjtufYOocW2i9Cea78gtNh2EdpzraoQ3JOtqhFcbbsI7ulWtQQe2HYRXG27CO4ZVw0IrrZdBPecq04Q3JOuQqoSnLaLsgvrniC4sA4JS3DaLske2HYRXFj3HMGFdUhcAtsuyi6se4XgwjqkL8Fpuyi7sO4tggvrkMQEp+2S7IFtF8GFdb8iuGddjVQmsO2i7J51dYPgnnU1UpngtF2U3bOu7hHcs65GKhOctkuyB7ZdBPesq5HKBKftouzijEQqE5y2i7IL65bz9YY9hqPVM65PwWm7G7KvbLt7k213/uY0yB9vHOQD227iGo/XRQo5M2JU4P7nX50ZddbwwLZLig9suwgut8Q3CK62XQSXW2JGjMrSCTnfo+xq20VwuSVmxKgU71nXZMSowD3rmszIs4YHtl1y7YFtF8Fld69DcLXtIrhnXZMRo7J0nnXNiLKrbRfBPeuajBiV4oV1j1F2YV1GjNbZA9suyR7YdhFcWJfZTSvFC+syI0+BC+uQygSn7aJrV9suggvrMiNPuXZhHVKZ4LRdUnxk22V4/wOwQToTnbbL8gvzkNJEp+2y/P6O1yKtiU7bZfk9+9rM6LNmX2TbZfn9Xa/NDD8lf3DaLsof2HYZ3t/42swum6lfnpQhzYlO22X1C/+Q6kSn7bL8wr/MEGTWz9/+WiQ80Wm7qP7gtF2G9/e/Fk040Wm7LL/wD6lPdNouyy/8y2y5lf4Hp+2y/MI/pj/Babssv9z/mP4Ett0N+Ve23b3Jtjt/c9oFWGxv3AaIfLuJ65wir57pR+ftwgDiXMsola1A3ivITEY2gOdql9EqG0DNu3ANPFu7zHxkK/C3yy4jVzaA52uX0SsTIDDwsjUIHLwwgJfsLvNwyF6CMDGjWTaAMDEjWjaAMDEzL9kAauOFiyhMzOiWrUCYmHlQZAMIEzPKZQIEVl62BoGXFwYQJmb26OwlCBMz6mUDCBMzbybYAMLEjH7ZAGrohYvomdhnJihbgWdin3l4ZAOIpw0qU2DqZWsQuHphAM/EPrNvZ9Yg8PXCCjwTe6hMwYG8sAJhYmb/zq6BMDEzS9kAwkSoTMGhvGwNAnsvDCDHokJlCs7lhRX4e2IPlSk4mRdWIO+gQmUKzuaFFQgTM1OVYWJg84UVyD0RKlNg9GUVBE5fGMDfE4fMUySziIHXF1YgLjaoTIHbF1agdl8YwDNxgDNTcE4vrECslHBmCiy/rILA8wsDCBOhMgWuX1iBMHGTMq1sv3uT7XdONW8zLDZvMwS+30yhi/U2Q2D8hQGEsCkBMxV4ER8yD6OmxfmxUyKPZIaUgK0DROZftAaR+xcGEMJmHkqVNdjZ9iI+pATMrIEQNjVamQBexIeUgJkAagGGiyhMTI1WpgLPxDElYCaAuoDZJQQ2YBhAj++FATwTx9SmX1mDhWfimBIwE8AzcUyNViaAZ+KYEjATQM3AcBE9E8fUpp+pQJiYEjATQP3A7BICQzAMoAf5wgDCxNSmX1mD4ChfWIEwkSlTdJgvrECYmNr0M2sgTEyNViaAMBEqU3CgL1uDwBoMAwgToTIFZ/rCCuSeCJUpONUXVuDviSepTb/Cg8AgDCvwTLz5nbvh7V3zE+cvT/bdZxbh+eu3LcK7ziJ86xt/ZRH+u7UI/11e5wpiqEV4f7IIz1+cf+zvBD/2b+eQJ88bcqzC3vxM/rtsXCO07NAgtPyyQ2i5hSG0v3+dILQ4hRFarcIMLl5hBvekfMrgnm9Lqm7697qzGsv+rqf8suyecc8ZXAzDDO4595LBPeleMbh4hhFcTcMMLq5hBvese8fgnnXvGdzf5n5hcM+6XxlcrcMM72lX1QzveVc1DK/uYYQP7MMMr/5hhvfcqwaG9+SrRoYXMydTm+DoX5Zf+PeY4YV/Txhe+MckJ/ARo/yBkZjh1UnM8MK/Fwwv/GO6syf8Y8ITHALM6hf+vWF44d9bhhf+MfEJHMUof2ApZnj1FDO8519dMbznX830Z188dEx/guOAWf3iousY3vOv7hne869m+hN4i1H+wFzM8OouZnjhH9Of4Fhgll/4x/QnOBiY5Rf+PduAX1mM9yeL8fzNeSNgd+NGQOAxzpS5+2M0C84GZnh1GSN8YDNmeKHpa4YXmqZkar1+8jfx65RMFbzQNCVTBa9eY3b9QtPUlFTyy20yNSYVvFjwUjJV8Oo3RtcfGI4ZXjx4LcPLbmFKptbXL+/JNCmZKnjPvyYlUwWvrmN2/Z5/TWpMKvk9/5pHLL/wLyVTJb86j1H+wHrM8MK/1Nbcuv5j4d8mmVoJ02orOTg0mNUv/EuNSaV+4V9qTCp44V9qTCp44R/Tn+DkYLZ+wj+mP5EJGRUQHR4MAwgFmQRFxwfDCjwJWyZC0QHCsAJPwzY1La1puNj2PGyZDkVmZHgJ6kZmAQI7MgwgftDUll1ZxIVnYsvEKDpIGF6CMJHJ0SI4ShhWIExMzU1mEYWJTJGi04ThJQgTUw+MyiUExmRWQXCgMAwgTGSyFB0pDCsQJrLBKDpUGFYgTGSjUXSsMKzA/zhsoTIFBwuzCgKL8oYAK4vy/mRRnr857yLsbdxFiCzKmUL31k94g7OFYQC1KMMA8lZDapIyl6AWZViBJ2yXmqVMBf7W2aUEzAQQY2hKwEwAtSizNQgsyjCAF/Eu9dypXMKev3V2KQEzAdSiDC9BmJiaqUwFalGGFQgTU1OVqUCYmBqrTABhYkrATAC1KLM1CCzKMIAwMTValUvYFyamBMwEUIsyvARhYkrATAVqUYYVeCb2qdHKVOCZ2KeeQ5kAYgxNjVYmgFqU2RoEFmUYQIyhqU2+cgnyt157qEyBRRlegmdiD5UpsCjDCoSJqdHKLKIwESpTcP4wvARhYmq0KpcQWJRZBcERxDCAvyf2UJmCQ4hhBcJEqEyHalGGFQgTU6OVaaMwESpTYFGGlyBMTL2bVy4hsCizCgKLMgzgmThAZQosyrACz8QBKlNgUYYVeCYOcGYKjiSGFYjjEyrTkWfiAGemwKLMLiGwKMMAwkSoTIFFGVYgTNw0M60syvuTRXlONW8z7G/eZggsyplC99fbDIFFGQbwt84htTdoKhDCpgTMBBDCpkardYDIoozWILIowwBC2JSAmUtQizKsQAibGq1MBWpRhhXIrTM1WpkKhImpNydMALHjpQTMBPBMHFOjVQkQWJTZIgZHFcMAnoljSsDMJahFGVbgmTimBMxUoBZlWIFn4pgarUwFnolj6h0KE0CYmBIwE0CYmBqtSoDAoswWMTi0GAYQJqY2/cwlCBOZMkXnFsNLECZCZQpOLoYVCBNTb1OYRRQmQmUKLMrsEgKLMgygFmUYQJgIlSk4wBhW4O+JJ1CZxPxyApUpsCjDS/BMvPmdu8nyWJj4lxblA2ZRnr9+26K85yzKt77xVxbl361F+Xd54yaIoRblg8miPH9x/rF/EPzYv51DLMobcqzC3rxX9rtsXCO07NAgtPyyQ2i5hSG0v3+dILSX0UcIrRZlBheLMoN7Uj5lcLEoM7gn3DMGF4syg3vKvWBwz7mXDO5J94rBPeteI7halBlcLMoM7ln3jsHFoszgnnW/MLhYlBncs66qGN7TrqoZXix6DcN74lUtwgcWZYZXizLDe+5VA8OrRZnhPfsqpjaBRZnlF/49Znjh3xOGF/4xyQksyih/YFFmeLUoM7zwj8lOcNwxyy/8Y8ITWJRZfuHfG4YX/r1leOEfE5/AoozyBxZlhleLMsN7/tVMf4KDj1l+z7+a6U9gUWb5Pf/qjuE9/+qe4T3/aqY/gUUZ5Q8sygyvFmWGF/4x/Qksyiy/8I/pT2BRZvmFf5uGnpVF+WCyKM+Z5o2Aw40bAYFFOVPm4eqh3++BRZnh/c/EOjUerfMHFmWUPzgKmeGFpimZKvXLX3JIyVTBC01TMlXwalFm1y80TU1JJb/cJpfk3bSVV/BiEU3JVMGLRS81Jq3xgUUZrV9wKDLDy25hSqZK/Z5/TUqmCt7zr0nJVMGrRZldv+dfkxqTSn7Pvya1LVfwwr+UTBW88C81Jq3xgUUZrV9wPDLDC/9Se3OlfuHfc5Zf+Jcak0p+tSiz/MK/1JhU8gv/Uht0BS/8Y/oTHJOMrj+yKMMAYpJ/DwMIBZkERRZlWIEnYctEKLIowwo8DdvUtLSmUWRRhhV4IrZMiBbbYgxlSrQILMrsEoIjk2EAz8SWiVFkUYYVCBOZHEUWZViBMDE1NxUmLvwdsV0+10z/IowsyvAShIlMkxaBRZlVEFiUYQBhIpOlyKIMKxAmMmGKLMqwAmEiG40iizKsQO6JUJkCizKrILAobwiwsigfTBbl+ZvzLsLRxl2EyKKcKfToxzZCdIoyDKAWZRhA3mpICZi5BLUowwo8YbvULGUq8LfOboQVeMJ2KQEzFYgxNDVOlQCBRZldQnCKMgzgb51dSsDMJahFGVYgTEzNVKYCtSjDCoSJqanKVCBMTG3rmQDCxJSAmQDCxNRgVQIEFmW2iMEpyjCAMDElYOYS1KIMKxAmpgTMVKAWZViBZ2KfGq1MBZ6JfWqDzwTwTOxTo5UJIHa81JsQJUBgUWaLGJyiDAN4JvZQmQKLMqzAM7GHyhRYlGEFwsTUaGXaKExMbfWZAMJEqEzBKcpsDQKLMgwgZvnUaFXWIDhFGVbg74k9VKbgFGVYgVqUYQBhYmq0MosoTEw9dDIBhIlQmQ7VoszWILAowwDCxNSDp7IGR/6eOEBlCizK8BL8PXGAyhRYlGEFnokDnJkCizKswDNxgMoUWJRZBYFFGQbwTBzgzCR/JnaAyhRYlOElCBM3KdPKonwwWZTnVPM2w/HmbYbAopwp9Hi9zRBYlGEAf+scUgJmKhDCpkYrE0AtyugSIosyDCCETY1W60vY2ZZbZ0rATAC1KMNLEMKmBMxUoBZlWIHcOlOjlalAmJgSMBPAM3FMCZgJoBZltgaBRRkGEDtearQqlyB/VHZMCZgJoBZleAmeiWNKwEwFalGGFXgmjqnRylTgmTimBMwEECamBMwEUIsyW4PAogwDCBNTT63KJez4e+KY2vQzAdSiDC9BmMiUKTpFGVYgTExt+pk1ECZCZdoRJkJlCizKbA0CizIMoBZlGECYCJUpsCjDCjwTT6AyBRZlWIFn4klqtCpM3PVMvPmdu+kptglgmHj38uLPh/en/7hz+WDrkFmU56/ftijvO4vyzTemQ6KvH2xd/ZVF+Yu1KH+RN26CGGpRPpwsyvMXpx/7O9vBj/3bOcSivCHHKuyNRfmLbFwjtOzQILT8skNouYUhtL9/nSC0WJQRWi3KDC4WZQb3pHzK4GJRZnBPuGcMLhZlBveUe8HgnnMvGdyT7hWDi0UZwdWizOBiUWZwz7p3DC4WZQb3rPuFwcWizOCedVXF8J52Vc3wnndVw/BqUUb4wKLM8GpRZnjPvWpgeLUoM7xnX8XUJrAos/zCv8cML/x7wvDCPyY5gUUZ5Q8sygyvFmWGF/4x2Qksyiy/8I8JT2BRZvmFf28YXvj3luGFf0x8Aosyyh9YlBleLcoM7/lXM/0JLMosv+dfzfQnsCiz/J5/dcfwnn91z/CefzXTn8CijPIHFmWGV4sywwv/mP4EFmWWX/jH9CewKLP8wr9NQ8/Konw4WZTnTPNGwGLjRkBgUc6UuVg99PsSWJQZXi3KCB9YlBleaPqa4YWmKZlar19wijLLLzRNyVTJrxZlll9ompqSSn65TS7J+2Dr1paZ3e5aEXu1FSV/z79JyVTJrxZldP2BRZnhxaDXMrzsFqZkan39wSnKLL/nX5OSqZJfLcosv+dfkxqTSn7Pv+YRy+9luknJVMmvFmWUP7AoM7zwb7mLnP73F5yizPKrRZnhhX+pMWm9/vLSS5Panit44V9qTCp44R/Tn+AUZbZ+wr/UmLSuP7IoowKiU5RhALkFMgmKLMqwAk/ClolQZFGGFXgatqlpybTR87BlOhSdogwvQS3KLEBgUYYB/L2wHWEAz8SWiVFkUYYVCBOZHEUWZViBMDE1NxUmBhZlWIGX5Db1uMhUoBZlVkFgUYYBhIlMlRbywkvLZCmyKMNLECaywSiyKMMKhIlsNIosyrACYSJUpsCizCoILMobAqwsyoeTRXn+5ryLsLNxFyGyKGcK3fmxjRBZlGEAtSjDAPJWQ2qSMpegFmVYgSdsl5qlTAVexLuUgJkAnrBdSsBMALUoszUILMowgL91dqnnTuUSglOUYQVqUYYBhIkpATOXoBZlWIEwMTVVmQqEiSkBMwGEiSkBMwHUoszWILAowwDCxNRoVS4hOEUZVqAWZRhAmJgSMHMJalGGFXgm9qnRylTgmdin3oMwATwT+9RoZQKoRZmtQWBRhgE8E/vUs6hyCcEpyrACMYZCZTrwTOyhMgUWZXgJwsTUaGUWUZgIlSk4RRlegjAxtdlXLiGwKLMKglOUYQAxy0NlCk5RhhUIE6EyBacowwqEianRyrRRmAiVKThFGV6CMPE9CxBYlGEAuSemHjyVRQwsyrAC8dlBZTryTBygMgUWZXgJnokDnJkCizKswKvzAGemwKLMKggsyjCAZ+KQegRVmBhYlGEFwkSoTMfCxE2bfiuL8uFkUZ5rnbcZdjdvMwQW5cyV7q63GQKLMgzgb53DcxhACJsSMHMJ/tY5pEardYDIoowuITpFGQZQizIMoBZlGEAIm9obNIuoFmVYgdw6U6OVqUCYmBIwE0DseKnRygQQY2hKwEqAwKLMFjE4RRkGEDteSsDMJahFGVbgmTimBMxUoBZlWIFn4pgarUwFnoljSsBMAGFiarQyAYSJKQErAQKLMlvE4BRlGEAtyjCAWpRhAGEiU6bIogwrECamRivTRmFi6m0KE0CYmBqtTABhYmq0KgECizJbxF3/c3JMjVamArUowwqEiVCZdj0TT6AyBRZleAmeiSep0cosomfize/cTe9VmQCGibcsykfMojx//bZF+cBZlG++scGifGEtyhfyxk0QQy3KR5NFef7i/GN/L/ixfzuHWJQ35FiFvXkv9EI2rhFaLMoILb/sEFpuYQjt718nCO1vXo8QWi3KDO5vXE8YXCzKDC4WZQb3hHvG4GJRZnBPuRcM7jn3ksE96V4xuGfdawRXizKDe9a9ZXCxKDO4WJQZ3LPuFwYXizKDe9ZVFcN72lU1w4tFr2F4T7yqRfjAoszwYtHrGV4tygyvFmWG9+yrmNoEFmWWX/j3mOGFf0xxdoV/T1l+4d/y59Gm34h7q93Mi8CijPLLX/OvnjO8WpQZXvjHdGdP+MeEJ7Aos/qFf28YXvjHtGdP+PeO5Rf+vUf4wKLM8GpRZni1KDO851/N9Gff869m+hNYlFn9nn91x/CefzXTn33Pv3pg+T3/6hHhA4syw6tFmeHVoszwwj+mP/JOTM30J7Aos/qFf5uGnpVF+WiyKM+Z5o2A/Y0bAYFFOVPm/g+ZDCzKDC80TcnUOn9gUUb5g1OUGV4tygwvNE3JVLl+uU2mZKrg1aLM6heapqakkl9uk0vybvqZVvD+NtmkxqSC9/xrUjK1xgcWZbR+wSnKDK8WZYb3/GtSMlWu3/OvSclUwatFmdXv+dekxqSS3/OvSW3LFbzwLzUmFbzwLyVTa3xgUUbrF5yizPDCv9TeXKlf+Jcakwpe+JfanSt44R/TH3nnpUmNSSW/8C+1QVfwwr/UmFTwwj+mP5FFGREosijDAEJBJkGRRRlW4EnYMhGKLMqwAn8bbFPT0poG0SnKsAJPxDY1L5kKPBNbpkTRKcrsEoJTlGEAz8SWiVFkUYYVCBOZHEUWZViBMDE1NxUeBBZlWIEwkUnSYiFMZJoUnaLMLiE4RRkGECYyWYosyrACYSITpsiiDCsQJrLRKLIowwqEiVCZAosyqyCwKG8IsLIoH00W5fmb8y7CwcZdhMiinCn04Mc2QmRRhgH8D8ku9bzJVCBvNaQEzARQizK8BE/YLjVLmQr8j8kutednAnjCdikBMwH8rbNLjVMlQGBRZosYnKIMA/hbZ5cSMHMJwsTUkycTQJiYEjATQC3KcA2EiampylQgTEyNVSaAMDElYCaAMDE1WJUAgUWZLWJwijIMIExMCZi5BGFi6hmUCSBMTAmYCaAWZbgGnol9arQyFXgm9qkNPhPAM7FPjVYmgGdiD5UpsCizRQxOUYYBPBN7qEzBKcqwAs/EHipTYFGGFQgTU6NV4YE8aulTW30mgDARKlNwijJbg8CiDAOIMTQ1WpU1CE5RhhX4e2IPlSk4RRlWIC/AQmU6FCamRiuziHJPTG36mQDCRKhMwSnKbBEDizIMoBZlGMDfEweoTMEpyrACf08coDIFFmVYgWfiAGemwKIMK/BMHKAyBRZlVkFgUYYB1KIMAwgToTIFpyjDCoSJm5RpZVE+mizKc6p5m+Fw8zZDYFHOFHq43mYILMowgL91DikBMxUIYVOjlQngf04OKQFbB4gsymgNIosyDCCETQmYuQQv4kNKwEwAIWxKwEwAtSjDNZBbZ2q0MhUIE1NvTpgAnoljSsBMAM/EMTValQCBRZktYmBRhgE8E8eUgJlLEDte6qmVCeCZOKYEzARQizJcA8/EMTVamQrEVZXa9DMBhIkpATMBhImp0aoECCzKbBEDizIMIExMbfqZSxAmMmXa2REmMmWKLMpwDYSJqU0/swbCxNRoZQIIE6EyBacoszUILMowgFqUYQBhIlSm4BRlWIFn4glUpsCiDCvwTDxJjVaFSMEpyrACw8RbFuVjZlGev37bonzoLMo339hgUf5qLcpf5Y2bIIZalI8ni/L8xfnH/lHwY/92Dn87azfkWIW9sSh/lY1rhJYdGoSWX3YILbcwhPb3rxOE9jL6CKHVoszgYlFmcE/Kpwzu+bak6qb3kI9Wk+XXhSfcM5ZdLMoM7in3gsE9514yuCfdKwb3rHuN4GpRZnCxKDO4Z907Bvese8/gnnW/MLhYlBncs66qGF4sejXDe95VDcOLRY9pTGBRRvnlj8lUPcN77lUDw4tFdGR4z76KqU1gUWb5hX+PGV7494ThhX9McoJTlFH+wKLM8GIRfc7wwj8mO8Epyiy/8I8JT2BRZvmFf28YXvj3luGFf0x8glOUUf7AoszwalFmeM+/mulPcIoyy+/5VzP9CSzKLL/nX90xvHjvmP4EFmWWXy3KCB9YlBleLcoML/xj+hOcoszyC/+Y/gQWZZZf+Ldp6FlZlI8ni/Kcad4ION64ERBYlDNlHv8YzQKLMsOrRRnhA4sywwtNUwPS+vrllZk6JVMFrxZlVr/QNCVTJb9alFl+oWlqSir55Ta5JO+mrYGC9zLdpGSq4NWijK4/sCgzvOdfkxqT1vXL3/JvUjJV8GpRZvV7/jWpMankV4syy+/516TGpJJfLKKpbbmCF/6lZKrg1aKMrj+wKDO88C+1NbeuPzhFmeVXizLDC/9SY1KpXy3KLL/wLzUmlfzCP6Y/wSnKrH61KCN8ZFGGAYSBqW269QoutuWBCZOgyKIML8GTsGUiFFmUYQWehm1qWjKL6HnYMh2KTlGGl6AWZRYgOEUZBvBMbFNbdmURF56JLROjyKIML0GYyOQosijDCoSJqbnJLKIwkSnSYuEluU09LjIVqEWZrUFwijIMIExMPTQqlxCcogwrkCfETJcW8sJLywajyKIML0GYyEajyKIMKxAmQmUKLMqsgsCivCHAyqJ8PFmU529Ouwi72xt3ESKLcqLQKfLqjYLIogwDqEUZBpC3GjKTlL0EtSjDCjxhu8wsZSvwt84uI2A2gCdslxEwG0AtymwNAosyDOBvnV3muZO5hOAUZViBWpRhAGFiRsDsJahFGVYgTMxMVbYCYWJGwGwAYWJmrrIB1KLM1iCwKMMAwsTMEyhzCcEpyrACtSjDAMLEjIDZS1CLMqzAM7HPjFa2As/EPvMehA3gmdhnRisbQC3KbA0CizIMIHa8zLMocwnBKcqwAjGGQmUKTlGGFchrh5mNPrsGwsTMaGUDCBOhMgWnKMM1ECZmRitzCYFFmVUQnKIMA4hZHipTcIoyrMDfE3uoTMEpyrACYWJmtLJtFCZCZQpOUYaXIEzMbPqZSwgsyqwC+duwfebBk61ALcqwAvHZQWUKTlGGFYjPLrPpZ9fAM3GAM1NgUYaX4NV5gDNTYFFmFQQWZRhALcowgFqUYQBhIlSm4BTlDRWsLMrHk0V5/ua8zbDYvM0QWJQzV7pYbzMEFmUYwN86h8xrfdO1/djokAc2Q0rATAB/6xxSo9U6QGRRRmsQWZRhALUowwBC2JSAmTXwIj5k9gZLG3e21aIML0FunanRylyCMDElYCaA2PFSo5UJ4Jk4pgSsBAgsymwRA4syDKAWZRhAjKGp0cqsgWfimBIwE0AtyvASPBPH1KafqcAzcUyNViaAMDE1WpkAwsSUgJUAgUWZLWJgUYYB1KIMAwgTmTJFFmVYgTARKtOOMDE1Wpk2ChMzT63MbX1HmJgarUwFwkSoTIFFmXUhOEUZBlCLMgwgTITKFJyiDCvwTDyByrTrmXiS2vQrPAgsyvASDBNvWZQXB8ij/Gb5/Qdby9JuB5oPlv5++m1yMB/e21ls3fnnYu/0w72P/2rPrj6cfbt+sLX903zI0f0Pdy4fbA2Lm3Ool+c8Lz8Z5ZMT+eSRfPJYPnkinzyVT36WT57JJ8/lkxfyyZvVJ7oau7tmNeZv/f9XY/n1aWiZf9ffrIZ8ciKfPJJPHssnT+STp/LJz/LJM/nkuXzywn5yw4S7V5/Pzq7b0+vTh/e/nl3+dtacfflydefDxR9z+6eBrHx6ZzmxVYtpYLtZvPL9h/e/n/529vT08rfzb1d3vpx9WlJnWsLL898+//jv1xffZ0Id7m/d+dvF9fXF1x//6/PZ6ceziWDbP00d+HRxcf3jf0wrO8d9dXb9x/c730+/n12+Ov+/Zw+2pn9HF5fnE0FPr88vvj3Y+n5xeX15en495bt3/vHB1uXJx5sK/7y4/H15gQ//nwAAAAD//wMAUEsDBBQABgAIAAAAIQC3pokwRAEAAFsCAAARAAgBZG9jUHJvcHMvY29yZS54bWwgogQBKKAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8klFPwjAUhd9N/A9L37e2IASabSRKeJLERIzGt6a9QOPaNW0V+Pd2G8wZjI+959zvnnvTfHHUVfIFzqvaFIhmBCVgRC2V2RXoZbNKZyjxgRvJq9pAgU7g0aK8vcmFZaJ28ORqCy4o8EkkGc+ELdA+BMsw9mIPmvssOkwUt7XTPMSn22HLxQffAR4RMsUaApc8cNwAU9sT0RkpRY+0n65qAVJgqECDCR7TjOIfbwCn/Z8NrTJwahVONu50jjtkS9GJvfvoVW88HA7ZYdzGiPkpfls/Prerpso0txKAylwKJhzwULtyCUb5HA8qzfUq7sM6HnqrQN6fLqZrIZLa4B0OZBKjsC74RXkdPyw3K1SOCJ2llKRksiEzNpowOn9v5v7qb6J1BX2e/j9xnpK7ljhlhLAJHRAvgDLHV9+h/AYAAP//AwBQSwMEFAAGAAgAAAAhABow2dMBDwAAJoUAABAAAAB4bC9jYWxjQ2hhaW4ueG1sbN1LjyVFeoDhvSX/B9R7D+Px3RpmFN8t4jQ0t74BuxbTHpCgGQGy7H9vLBnLisebkuqt1KmjehaZX5ysyN//8T++/+69f3/740/f/vDugyd/+5vfPnnv7buvf/jTt+/+/MGTly/mb/75yXs//fzm3Z/efPfDu7cfPPnPtz89+eMf/vqvfv/1m+++zm/efPvuvV9e4d1PHzz55uef//Kv77//09ffvP3+zU+/+eEvb9/98pN/++HH79/8/Mu3P/75/Z/+8uPbN3/66Zu3b3/+/rv3f/fb3/7j+9//8gJP/vD7r9/78YMn+cuv+vaX9/Dkve/+++v7/5Pr1/xr6DvMHfYdzh0ed3h6hw/v8NEdnt3h4zt8codP7/DZHT6/w/M7vLjDyzu8usPrO3xxhy/v8NUd1qIE5X8Jf7Va6C34Fn4LwIXggnBhuEBcKC4YF44LyIXkgnJhucBcaC44F54L0IXognRhGpgGpoFpYBqYBqaBaWAamAamgWlgGpgGpoFpYBqYBqaBaWAamAamgWlgGpgGpolpYpqYJqaJaWKamCamiWlimpgmpolpYpqYJqaJaWKamCamiWlimpgmpolpYlqYFqaFaWFamBamhWlhWpgWpoVpYVqYFqaFaWFamBamhWlhWpgWpoVpYVqYFqaNaWPamLZXQ5g2po1pY9qYNqaNaWPamDamjWlj2pg2po1pY9qYNqaNaWPamDamg+lgOpgOpuMlLqaD6WA6mA6mg+lgOpgOpoPpYDqYDqaD6WA6mA6mg+lgOpgOphvTjenGdGO6Md3OLZhuTDemG9ON6cZ0Y7ox3ZhuTDemG9ON6cZ0Y7ox3ZhuTDemG9OD6cH0YHowPZgeTI/DKKYH04PpwfRgejA9mB5MD6YH04PpwfRgejA9mB5MD6YH04PpA9MHpg9MH84y91Ab//Q/yxL/u/7wu/93nWJ+zb8et+9w7vC4w9M7fHiHj+7w7A4f3+GTO3x6h8/u8Pkdnt/hxR1e3uHVHV7f4Ys7fHmHr+6wFiUoSSlKU/BbAC4EF4QLwwXiQnHBuHBcQC4kF5QLywXmQnPBufBcgC5EF6QL08A0MA1MA9PANDANTAPTwDQwDUwD08A0MA1MA9PANDANTAPTwDQwDUwD08A0ME1ME9PENDFNTBPTxDQxTUwT08Q0MU1ME9PENDFNTBPTxDQxTUwT08Q0MU1ME9PCtDAtTAvTwrQwLUwL08K0MC1MC9PCtDAtTAvTwrQwLUwL08K0MC1MC9PCtDBtTBvTxrQxbUwb08a0MW1MG9PGtDFtTBvTxrQxbUwb08a0MW1MG9PGtDFtTBvTwXQwHUwH08F0MB1MB9PBdDAdTAfTwXQwHUwH08F0MB1MB9PBdDAdTAfTwXQw3ZhuTDemG9ON6XZuwXRjujHdmG5MN6Yb043pxnRjujHdmG5MN6Yb043pxnRjujHdmB5MD6YH04PpwfRgehxGMT2YHkwPpgfTg+nB9GB6MD2YHkwPpgfTg+nB9GB6MD2YHkwfmD4wfWD68Hz6d9eiw9xh3+Hc4XGHp3f48A4f3eHZHT6+wyd3+PQOn93h8zs8v8OLO7y8w6s7vL7DF3f48g5f3WEtSlCSUpSm4LcAXAguCBeGC8SF4oJx4biAXEguKBeWC8yF5oJz4bkAXYguSBemgWlgGpgGpoFpYBqYBqaBaWAamAamgWlgGpgGpoFpYBqYBqaBaWAamAamgWlgmpgmpolpYpqYJqaJaWKamCamiWlimpgmpolpYpqYJqaJaWKamCamiWlimpgmpoVpYVqYFqaFaWFamBamhWlhWpgWpoVpYVqYFqaFaWFamBamhWlhWpgWpoVpYdqYNqaNaWPamDamjWlj2pg2po1pY9qYNqaNaWPamDamjWlj2pg2po1pY9qYNqaD6WA6mA6mg+lgOpgOpoPpYDqYDqaD6WA6mA6mg+lgOpgOpoPpYDqYDqaD6WC6Md2Ybkw3phvT7dyC6cZ0Y7ox3ZhuTDemG9ON6cZ0Y7ox3ZhuTDemG9ON6cZ0Y7oxPZgeTA+mB9OD6cH0OIxiejA9mB5MD6YH04PpwfRgejA9mB5MD6YH04PpwfRgejA9mD4wfWD6wPTh+fTv79WFO+w7nDs87vD0Dh/e4aM7PLvDx3f45A6f3uGzO3x+h+d3eHGHl3d4dYfXd/jiDl/e4as7rEUJSlKK0pShALgQXBAuDBeIC8UF48JxAbmQXFAuLBeYC80F58JzAboQXZAuTAPTwDQwDUwD08A0MA1MA9PANDANTAPTwDQwDUwD08A0MA1MA9PANDANTAPTwDQxTUwT08Q0MU1ME9PENDFNTBPTxDQxTUwT08Q0MU1ME9PENDFNTBPTxDQxTUwL08K0MC1MC9PCtDAtTAvTwrQwLUwL08K0MC1MC9PCtDAtTAvTwrQwLUwL08K0MW1MG9PGtDFtTBvTxrQxbUwb08a0MW1MG9PGtDFtTBvTxrQxbUwb08a0MW1MB9PBdDAdTAfTwXQwHUwH08F0MB1MB9PBdDAdTAfTwXQwHUwH08F0MB1MB9PBdGO6Md2Ybkw3phvTjenGdGO6Md2Ybkw3phvTjenGdGO6Md2Ybkw3phvTjenGdGO6MT2YHkwPpgfTg+nB9DiMYnowPZgeTA+mB9OD6cH0YHowPZgeTA+mB9OD6cH0YHowPZg+MH1g+sD04fn0H+7VhTvsO5w7PO7w9A4f3uGjOzy7w8d3+OQOn97hszt8fofnd3hxh5d3eHWH13f44g5f3uGrO6xFCUpSitKUoQC4EFwQLgwXiAvFBePCcQG5kFxQLiwXmAvNBefCcwG6EF2QLkwD08A0MA1MA9PANDANTAPTwDQwDUwD08A0MA1MA9PANDANTAPTwDQwDUwD08A0MU1ME9PENDFNTBPTxDQxTUwT08Q0MU1ME9PENDFNTBPTxDQxTUwT08Q0MU1MC9PCtDAtTAvTwrQwLUwL08K0MC1MC9PCtDAtTAvTwrQwLUwL08K0MC1MC9PCtDFtTBvTxrQxbUwb08a0MW1MG9PGtDFtTBvTxrQxbUwb08a0MW1MG9PGtDFtTAfTwXQwHUwH08F0MB1MB9PBdDAdTAfTwXQwHUwH08F0MB1MB9PBdDAdTAfTwXRjujHdmG5MN6Yb043pxnRjujHdmG5MN6Yb043pxnRjujHdmG5MN6Yb043pxnRjujE9mB5MD6YH04PpwfQ4jGJ6MD2YHkwPpgfTg+nB9GB6MD2YHkwPpgfTg+nB9GB6MD2YPjB9YPrA9OH59B/v1YU77DucOzzu8PQOH97hozs8u8PHd/jkDp/e4bM7fH6H53d4cYeXd3h1h9d3+OIOX97hqzusRQlKUorSlKEAuBBcEC4MF4gLxQXjwnEBuZBcUC4sF5gLzQXnwnMBuhBdkC5MA9PANDANTAPTwDQwDUwD08A0MA1MA9PANDANTAPTwDQwDUwD08A0MA1MA9PANDFNTBPTxDQxTUwT08Q0MU1ME9PENDFNTBPTxDQxTUwT08Q0MU1ME9PENDFNTAvTwrQwLUwL08K0MC1MC9PCtDAtTAvTwrQwLUwL08K0MC1MC9PCtDAtTAvTwrQxbUwb08a0MW1MG9PGtDFtTBvTxrQxbUwb08a0MW1MG9PGtDFtTBvTxrQxbUwH08F0MB1MB9PBdDAdTAfTwXQwHUwH08F0MB1MB9PBdDAdTAfTwXQwHUwH08F0Y7ox3ZhuTDemG9ON6cZ0Y7ox3ZhuTDemG9ON6cZ0Y7ox3ZhuTDemG9ON6cZ0Y7oxPZgeTA+mB9OD6cH0OIxiejA9mB5MD6YH04PpwfRgejA9mB5MD6YH04PpwfRgejA9mD4wfWD6wPTh+fTe7HHusO9w7vC4w9M7fHiHj+7w7A4f3+GTO3x6h8/u8Pkdnt/hxR1e3uHVHV7f4Ys7fHmHr+6wFoVdN1dyTFGagt8CcCG4IFwYLhAXigvGheMCciG5oFxYLjAXmgvOhecCdCG6IF2YBqaBaWAamAamgWlgGpgGpoFpYBqYBqaBaWAamAamgWlgGpgGpoFpYBqYBqaBaWKamCamiWlimpgmpolpYpqYJqaJaWKamCamiWlimpgmpolpYpqYJqaJaWKamBamhWlhWpgWpoVpYVqYFqaFaWFamBamhWlhWpgWpoVpYVqYFqaFaWFamBamhWlj2u5ijWlj2pg2po1pY9qYNqaNaWPamDamjWlj2pg2po1pY9qYNqaNaWPamDamg+lgOpgOpoPpYDqYDqaD6WA6mA6mg+lgOpgOpoPpYDqYDqaD6WA6mA6mg+lgujHdmG5MN6Yb0+3cgunGdGO6Md2Ybkw3phvTjenGdGO6Md2Ybkw3phvTjenGdGO6MT2YHkwPpgfTg+nB9DiMYnowPZgeTA+mB9OD6cH0YHowPZgeTA+mB9OD6cH0YHowPZg+MH1g+sD04fn0X+57F+6w73Du8LjD0zt8eIeP7vDsDh/f4ZM7fHqHz+7w+R2e3+HFHV7e4dUdXt/hizt8eYev7rAWJShJKUpThgLgQnBBuDBcIC4UF4wLxwXkQnJBubBcYC40F5wLzwXoQnRBujANTAPTwDQwDUwD08A0MA1MA9PANDANTAPTwDQwDUwD08A0MA1MA9PANDANTAPTxDQxTUwT08Q0MU1ME9PENDFNTBPTxDQxTUwT08Q0MU1ME9PENDFNTBPTxDQxLUwL08K0MC1MC9PCtDAtTAvTwrQwLUwL08K0MC1MC9PCtDAtTAvTwrQwLUwL08a0MW1MG9PGtDFtTBvTxrQxbUwb08a0MW1MG9PGtDFtTBvTxrQxbUwb08a0MR1MB9PBdDAdTAfTwXQwHUwH08F0MB1MB9PBdDAdTAfTwXQwHUwH08F0MB1MB9ON6cZ0Y7ox3ZhuTDemG9ON6cZ0Y7ox3ZhuTDemG9ON6cZ0Y7ox3ZhuTDemG9ON6cb0YHowPZgeTA+mB9PjMIrpwfRgejA9mB5MD6YH04PpwfRgejA9mB5MD6YH04PpwfRg+sD0gekD04fXvfcjDX2a2v1YAndEvzcSdFezezMA/zP5vqHfu4vvj+n9hPAerJ3c7iO8d/1+p+7Md/89/u+zOt7/+s13X+c3b75994f/AgAA//8DAFBLAwQUAAYACAAAACEAEri+5N4AAADwBAAAJwAAAHhsL3ByaW50ZXJTZXR0aW5ncy9wcmludGVyU2V0dGluZ3MxLmJpbuxRwQqCQBB9K4JF1z6gLwgqDeomiucogg6CBGUEqaFCXfuNvq1/qTdCoXaJ6BTusDNvZ2aHfW89JDhjjxw9zLHFGhv6lKcZXHhFTFmP2SH5+lK60m/o6sH9Yii0ce2YrQ0UDKw0jVE8YMN8u/l9QibKkqhKuz7RwRQ+lsiKl2fELlFMNoJtHGkuGefcPtknjFHBdcezV1JmQRyy78SOlDOq1adSTlGTeQlRtecTbX0MYFEpEyOMaRaG9AGzEyLJBbTw9S75kYgc+vzBCIcfKtyMahT4TwUeAAAA//8DAFBLAwQUAAYACAAAACEApbTiPJQBAAAUAwAAEAAIAWRvY1Byb3BzL2FwcC54bWwgogQBKKAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACcksFuEzEQhu9IvMPK98abgioUeV2hFNQDiEhJex+8s4mF17bs6SrhBlcegRfhMZo3YnZXTTfAidvM/L9+fx5bXe9bV3SYsg2+EvNZKQr0JtTWbytxt3l/8UYUmcDX4ILHShwwi2v98oVapRAxkcVccITPldgRxYWU2eywhTxj2bPShNQCcZu2MjSNNXgTzEOLnuRlWV5J3BP6GuuLeAoUY+Kio/8NrYPp+fL95hAZWKu3MTprgPiW+qM1KeTQUPFub9ApORUV063RPCRLB10qOW3V2oDDJQfrBlxGJZ8H6hahX9oKbMpadbTo0FBIRbZfeW2XovgMGXucSnSQLHhirN42NkPtYqakH38+/jp+O34//lCSDeNwKKfeaW1f6/lg4OLc2AeMICycI24sOcyfmhUk+gfxfEo8MIy854zjsVPE4dZ82B/xy9BG8AcWTtUH67/ku7gJN0D4tNHzoVrvIGHNj3Da+GmgbnmZyfUhyx34LdZPnr+F/v3vx0+u51ez8lXJTzuZKfn8nfVvAAAA//8DAFBLAQItABQABgAIAAAAIQB0NlqmegEAAIQFAAATAAAAAAAAAAAAAAAAAAAAAABbQ29udGVudF9UeXBlc10ueG1sUEsBAi0AFAAGAAgAAAAhALVVMCP0AAAATAIAAAsAAAAAAAAAAAAAAAAAswMAAF9yZWxzLy5yZWxzUEsBAi0AFAAGAAgAAAAhAJIHlOwEAQAAPwMAABoAAAAAAAAAAAAAAAAA2AYAAHhsL19yZWxzL3dvcmtib29rLnhtbC5yZWxzUEsBAi0AFAAGAAgAAAAhADL2WDVKAgAAmgQAAA8AAAAAAAAAAAAAAAAAHAkAAHhsL3dvcmtib29rLnhtbFBLAQItABQABgAIAAAAIQAhMk6N1QAAAHgBAAAUAAAAAAAAAAAAAAAAAJMLAAB4bC9zaGFyZWRTdHJpbmdzLnhtbFBLAQItABQABgAIAAAAIQA7bTJLwQAAAEIBAAAjAAAAAAAAAAAAAAAAAJoMAAB4bC93b3Jrc2hlZXRzL19yZWxzL3NoZWV0MS54bWwucmVsc1BLAQItABQABgAIAAAAIQAUyDyDvQYAAL8aAAATAAAAAAAAAAAAAAAAAJwNAAB4bC90aGVtZS90aGVtZTEueG1sUEsBAi0AFAAGAAgAAAAhAEb3UYr7AgAACQgAAA0AAAAAAAAAAAAAAAAAihQAAHhsL3N0eWxlcy54bWxQSwECLQAUAAYACAAAACEAM8EzsPUwAAB2+QEAGAAAAAAAAAAAAAAAAACwFwAAeGwvd29ya3NoZWV0cy9zaGVldDEueG1sUEsBAi0AFAAGAAgAAAAhALemiTBEAQAAWwIAABEAAAAAAAAAAAAAAAAA20gAAGRvY1Byb3BzL2NvcmUueG1sUEsBAi0AFAAGAAgAAAAhABow2dMBDwAAJoUAABAAAAAAAAAAAAAAAAAAVksAAHhsL2NhbGNDaGFpbi54bWxQSwECLQAUAAYACAAAACEAEri+5N4AAADwBAAAJwAAAAAAAAAAAAAAAACFWgAAeGwvcHJpbnRlclNldHRpbmdzL3ByaW50ZXJTZXR0aW5nczEuYmluUEsBAi0AFAAGAAgAAAAhAKW04jyUAQAAFAMAABAAAAAAAAAAAAAAAAAAqFsAAGRvY1Byb3BzL2FwcC54bWxQSwUGAAAAAA0ADQBkAwAAcl4AAAAA");},function(M,L){function j(M,L){if(j=M,!(null!=(A=L)&&"undefined"!=typeof Symbol&&A[Symbol.hasInstance]?A[Symbol.hasInstance](j):j instanceof A))throw new TypeError("Cannot call a class as a function");var j,A;}var A=.5*Math.PI;M.exports=function(M){var L=M.libs.$,u=L("#_3d_plan-controls"),w=L("#_3d_plan-info"),N=L("#_3d_plan-controls-button"),C=L("#_3d_plan-controls-actions-cell-both"),y=L("#_3d_plan-controls-actions-cell-occlusion"),T=L("#_3d_plan-controls-actions-cell-upper"),D=L("#_3d_plan-controls-actions-cell-lower"),z=L("#_3d_plan-controls-actions-cell-grid"),i=L("#_3d_plan-controls-actions-cell-separations"),t=L("#_3d_plan-controls-actions-cell-locks"),s=L("#_3d_plan-controls-actions-cell-pdf"),S=L("#_3d_plan-controls-actions-cell-info"),I=L("#_3d_plan-info-occlusion");return function(){return function L(){j(this,L);var x=M.SWITCH_DRAW_ONLY_TEETH_OBJECTS,E=M.SWITCH_SEPARATIONS_EXIST,g=M.SWITCH_PDF_EXIST,Q=M.CTX,Y=M.time,c=M.rotationX,O=M.visibility,k=M.separationVisibility,o=M.orbit,n=M.gridMode,e=M.separationMode,J=M.separationClosed,a=M.locksMode,U=Q.Vec3,r=Q.Vec2,m=Q.Quat,P=Q.Transition,G=r.getIntepolationFunction,l=r.makeBezierCurve3Sequence,d=o.obj,Z=d.quat,B=d.translation,f=new U().z(700),W=new P(Y),v=new P(Y),b=new P(Y),h=G(l(new r(),new r().set(.25,0),new r().set(0,1),new r().set(1,1),1e4)),R=new m(),p=new m().normalize();N.on("click touchstart",function(M){M.preventDefault(),u.toggleClass("-opened");}),C.on("click",function(M){if(M.preventDefault(),I.removeClass("-opened"),O.arr.indexOf(0)>-1)O.set(1,1,1,1).$();else if(0!==c.arr[0]&&0===W.interpolation){var L=c.arr[0];O.set(1,1,1,1).$(),W.set(1e3,function(M){return c.set(L+h(M.interpolation)*(0-L)).$();},function(){c.set(0).$(),J.set(1).$(),o.flag=1;});}else if(0===Z.arr[0]&&0===Z.arr[1]&&0===Z.arr[2]&&1===Z.arr[3]||0!==v.interpolation){if((0!==B.arr[0]||0!==B.arr[1]||0!==B.arr[2])&&0===b.interpolation){o.flag=0;var j=new U().copy(B).sub(f);b.set(1e3,function(M){B.reset(),o.obj.translate(j,1-h(M.interpolation)).translate(f,1).$(),o.$();},function(){B.copy(f),o.obj.origin.set(0,0,-700),o.$(),o.flag=1;});}}else o.flag=0,R.copy(Z).normalize(),v.set(1e3,function(M){Z.slerp(R,p,h(M.interpolation)),o.$();},function(){Z.reset(),o.$(),o.flag=1;});}),z.on("click",function(M){M.preventDefault(),o.updateProjectionMatrix[n[0]=1-n[0]]();}),E?i.on("click",function(M){M.preventDefault(),e.set(1-e.arr[0]).$();}):i.remove(),x?t.remove():t.on("click",function(M){M.preventDefault(),a[0]=1-a[0],Q.$();}),g?s.on("click",function(L){L.preventDefault(),window.open(M.pdf);}):s.remove(),S.on("click",function(M){M.preventDefault(),w.toggleClass("-opened");}),M.assets.upper_teeth_v_0&&M.assets.lower_teeth_v_0?(y.on("click",function(M){M.preventDefault(),I.addClass("-opened");var L=c.arr[0];O.set(1,1,1,1).$(),J.set(0).$(),W.set(1e3,function(M){return c.set(L+h(M.interpolation)*(A-L)).$();},function(){c.set(A).$(),o.flag=1;});}),T.on("click",function(M){M.preventDefault(),I.removeClass("-opened"),O.set(1,0,1,0).$(),k.set(1,0).$();}),D.on("click",function(M){M.preventDefault(),I.removeClass("-opened"),O.set(0,1,0,1).$(),k.set(0,1).$();})):(y.remove(),I.remove(),T.remove(),D.remove());};}();};},function(M,L){function j(M,L){if(j=M,!(null!=(A=L)&&"undefined"!=typeof Symbol&&A[Symbol.hasInstance]?A[Symbol.hasInstance](j):j instanceof A))throw new TypeError("Cannot call a class as a function");var j,A;}M.exports=function(M){var L=M.libs.$,A=L("#_3d_plan-info"),u=L("#_3d_plan-info-close"),w=L("#_3d_plan-info-title"),N=L("#_3d_plan-info-upper"),C=L("#_3d_plan-info-lower"),y=(L("#_3d_plan-info-actions"),L("#_3d_plan-info-actions-publish")),T=L("#_3d_plan-info-actions-rework"),D=L("#_3d_plan-comment"),z=L("#_3d_plan-comment-text"),i=L("#_3d_plan-comment-actions-send"),t=L("#_3d_plan-comment-actions-cancel");return function(){return function s(){j(this,s),w.find("span").html(M.INIT_PARAMS.patient_tag),M.CASE.keys.upper_teeth?(N.find("p").html("".concat("Upper jaw")),N.append("<p>&nbsp;&nbsp;".concat("Total steps",": ").concat(M.CASE.realSteps?M.CASE.realSteps.upper:M.CASE.keys.upper_gums.slice().pop()+1,"</p>")),M.separationInfo[0].length&&(N.append("<p>&nbsp;&nbsp;".concat("IPR before step",":</p>")),M.separationInfo[0].forEach(function(L){L.on("click",function(){M.sequencer.currentStep!==L.step&&M.goToStep(L.step);}),N.append(L);}))):N.remove(),M.CASE.keys.lower_teeth?(C.find("p").html("".concat("Lower jaw")),C.append("<p>&nbsp;&nbsp;".concat("Total steps",": ").concat(M.CASE.realSteps?M.CASE.realSteps.lower:M.CASE.keys.lower_gums.slice().pop()+1,"</p>")),M.separationInfo[1].length&&(C.append("<p>&nbsp;&nbsp;IPR before step:</p>"),M.separationInfo[1].forEach(function(L){L.on("click",function(){M.sequencer.currentStep!==L.step&&M.goToStep(L.step);}),C.append(L);}))):C.remove(),L("#_3d_plan-info-occlusion-".concat("en")).show(),y.html("Publish"),T.html("Rework"),i.html("Send"),t.html("Cancel"),u.on("click",function(M){M.preventDefault(),A.toggleClass("-opened");}),y.on("click",function(L){L.preventDefault(),window.confirm("Are you sure?")&&M.INIT_PARAMS.nextStep&&M.INIT_PARAMS.nextStep();}),T.on("click",function(M){M.preventDefault(),D.css({display:"table"}),z[0].focus();}),z.on("input",function(){var M=Boolean(z.val());i.toggleClass("-disabled",!M);}),i.on("click",function(L){L.preventDefault();var j=z.val();M.INIT_PARAMS.comment(j,function(){D.hide(),z.val(""),i.toggleClass("-disabled",!0);});}),t.on("click",function(M){M.preventDefault(),D.hide(),z.val(""),i.toggleClass("-disabled",!0);});};}();};},function(M,L){M.exports=function(M){return{getDrawFunc2Attr:function getDrawFunc2Attr(L){var j=M.CTX,A=j.WebGLRenderingContext,u=A.TRIANGLES,w=A.UNSIGNED_SHORT,N=A.UNSIGNED_INT,C=A.FLOAT,y=L.vertexBuffer,T=L.indexBuffer,D=L.UINT_CONSTRUCTOR===Uint32Array?N:w;D!==N||j.extensions.OES_element_index_uint||M.errorHandler("No OES_element_index_uint support");var z=L.maxVertexOverallDataLength;return function(){y.bind().attrib().attrib(1,3,C,0,0,z),T.bind(),A.drawElements(u,T.length,D,0);};},getDrawFunc4Attr:function getDrawFunc4Attr(L){var j=M.CTX,A=j.WebGLRenderingContext,u=A.TRIANGLES,w=A.UNSIGNED_SHORT,N=A.UNSIGNED_INT,C=A.FLOAT,y=L.vertexBuffer,T=L.indexBuffer,D=L.UINT_CONSTRUCTOR===Uint32Array?N:w;D!==N||j.extensions.OES_element_index_uint||M.errorHandler("No OES_element_index_uint support");var z=L.maxVertexOverallDataLength,i=L.maxVertexPositionDataLength,t=L.maxVertexOverallDataLength+L.maxVertexPositionDataLength;return function(){y.bind().attrib().attrib(1,3,C,0,0,z).attrib(2,3,C,0,0,i).attrib(3,3,C,0,0,t),T.bind(),A.drawElements(u,T.length,D,0);};},getDrawFunc6Attr:function getDrawFunc6Attr(L){var j=M.CTX,A=j.WebGLRenderingContext,u=A.TRIANGLES,w=A.UNSIGNED_SHORT,N=A.UNSIGNED_INT,C=A.FLOAT,y=L.vertexBuffer,T=L.indexBuffer,D=L.UINT_CONSTRUCTOR===Uint32Array?N:w;D!==N||j.extensions.OES_element_index_uint||M.errorHandler("No OES_element_index_uint support");var z=L.maxVertexOverallDataLength,i=L.maxVertexPositionDataLength,t=L.maxVertexOverallDataLength+L.maxVertexPositionDataLength,s=L.maxVertexPositionDataLength+L.maxOcclusionColorDataLength,S=L.maxVertexOverallDataLength+L.maxVertexPositionDataLength+L.maxOcclusionColorDataLength;return function(){y.bind().attrib().attrib(1,3,C,0,0,z).attrib(2,3,C,0,0,i).attrib(3,3,C,0,0,t).attrib(4,3,C,0,0,s).attrib(5,3,C,0,0,S),T.bind(),A.drawElements(u,T.length,D,0);};}};};},function(M,L){M.exports=function(M,L){var j=M.libs.$,A=j("#_3d_plan-loader-circle"),u=j("#_3d_plan-loader-percentage");return function(){var M=L.loaded/L.length;A.css({"stroke-dasharray":"".concat(280*M,", 1000")}),u.html("".concat(Math.floor(100*M),"%"));};};}]);

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var n=String(e).split("."),l=!n[1],o=Number(n[0])==e,t=o&&n[0].slice(-1),r=o&&n[0].slice(-2);return a?1==t&&11!=r?"one":2==t&&12!=r?"two":3==t&&13!=r?"few":"other":1==e&&l?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}}}},{locale:"en-001",parentLocale:"en"},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001"},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001"},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001"},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ru=a())}(this,function(){"use strict";return[{locale:"ru",pluralRuleFunction:function(e,a){var t=String(e).split("."),r=t[0],o=!t[1],n=r.slice(-1),l=r.slice(-2);return a?"other":o&&1==n&&11!=l?"one":o&&n>=2&&n<=4&&(l<12||l>14)?"few":o&&0==n||o&&n>=5&&n<=9||o&&l>=11&&l<=14?"many":"other"},fields:{year:{displayName:"год",relative:{0:"в этом году",1:"в следующем году","-1":"в прошлом году"},relativeTime:{future:{one:"через {0} год",few:"через {0} года",many:"через {0} лет",other:"через {0} года"},past:{one:"{0} год назад",few:"{0} года назад",many:"{0} лет назад",other:"{0} года назад"}}},month:{displayName:"месяц",relative:{0:"в этом месяце",1:"в следующем месяце","-1":"в прошлом месяце"},relativeTime:{future:{one:"через {0} месяц",few:"через {0} месяца",many:"через {0} месяцев",other:"через {0} месяца"},past:{one:"{0} месяц назад",few:"{0} месяца назад",many:"{0} месяцев назад",other:"{0} месяца назад"}}},day:{displayName:"день",relative:{0:"сегодня",1:"завтра",2:"послезавтра","-2":"позавчера","-1":"вчера"},relativeTime:{future:{one:"через {0} день",few:"через {0} дня",many:"через {0} дней",other:"через {0} дня"},past:{one:"{0} день назад",few:"{0} дня назад",many:"{0} дней назад",other:"{0} дня назад"}}},hour:{displayName:"час",relative:{0:"в этом часе"},relativeTime:{future:{one:"через {0} час",few:"через {0} часа",many:"через {0} часов",other:"через {0} часа"},past:{one:"{0} час назад",few:"{0} часа назад",many:"{0} часов назад",other:"{0} часа назад"}}},minute:{displayName:"минута",relative:{0:"в эту минуту"},relativeTime:{future:{one:"через {0} минуту",few:"через {0} минуты",many:"через {0} минут",other:"через {0} минуты"},past:{one:"{0} минуту назад",few:"{0} минуты назад",many:"{0} минут назад",other:"{0} минуты назад"}}},second:{displayName:"секунда",relative:{0:"сейчас"},relativeTime:{future:{one:"через {0} секунду",few:"через {0} секунды",many:"через {0} секунд",other:"через {0} секунды"},past:{one:"{0} секунду назад",few:"{0} секунды назад",many:"{0} секунд назад",other:"{0} секунды назад"}}}}},{locale:"ru-BY",parentLocale:"ru"},{locale:"ru-KG",parentLocale:"ru"},{locale:"ru-KZ",parentLocale:"ru"},{locale:"ru-MD",parentLocale:"ru"},{locale:"ru-UA",parentLocale:"ru"}]});


/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var messages={};/* unused harmony default export */ var _unused_webpack_default_export = (messages);

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var messages={};/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.1bb33e74.js